(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("immer"), require("@labkey/api"), require("immutable"), require("react"), require("moment"), require("moment-timezone"), require("numeral"), require("normalizr"), require("classnames"), require("react-dom"), require("react-router-dom"), require("react-treebeard"), require("formsy-react"), require("react-select"), require("react-select/async"), require("react-select/async-creatable"), require("react-select/creatable"), require("react-datepicker"), require("react-dom/test-utils"), require("enzyme"), require("react-beautiful-dnd"), require("react-color"), require("vis-network"), require("@testing-library/react"));
	else if(typeof define === 'function' && define.amd)
		define(["immer", "@labkey/api", "immutable", "react", "moment", "moment-timezone", "numeral", "normalizr", "classnames", "react-dom", "react-router-dom", "react-treebeard", "formsy-react", "react-select", "react-select/async", "react-select/async-creatable", "react-select/creatable", "react-datepicker", "react-dom/test-utils", "enzyme", "react-beautiful-dnd", "react-color", "vis-network", "@testing-library/react"], factory);
	else if(typeof exports === 'object')
		exports["@labkey/components"] = factory(require("immer"), require("@labkey/api"), require("immutable"), require("react"), require("moment"), require("moment-timezone"), require("numeral"), require("normalizr"), require("classnames"), require("react-dom"), require("react-router-dom"), require("react-treebeard"), require("formsy-react"), require("react-select"), require("react-select/async"), require("react-select/async-creatable"), require("react-select/creatable"), require("react-datepicker"), require("react-dom/test-utils"), require("enzyme"), require("react-beautiful-dnd"), require("react-color"), require("vis-network"), require("@testing-library/react"));
	else
		root["@labkey/components"] = factory(root["immer"], root["@labkey/api"], root["immutable"], root["react"], root["moment"], root["moment-timezone"], root["numeral"], root["normalizr"], root["classnames"], root["react-dom"], root["react-router-dom"], root["react-treebeard"], root["formsy-react"], root["react-select"], root["react-select/async"], root["react-select/async-creatable"], root["react-select/creatable"], root["react-datepicker"], root["react-dom/test-utils"], root["enzyme"], root["react-beautiful-dnd"], root["react-color"], root["vis-network"], root["@testing-library/react"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__470__, __WEBPACK_EXTERNAL_MODULE__421__, __WEBPACK_EXTERNAL_MODULE__144__, __WEBPACK_EXTERNAL_MODULE__155__, __WEBPACK_EXTERNAL_MODULE__416__, __WEBPACK_EXTERNAL_MODULE__528__, __WEBPACK_EXTERNAL_MODULE__958__, __WEBPACK_EXTERNAL_MODULE__370__, __WEBPACK_EXTERNAL_MODULE__992__, __WEBPACK_EXTERNAL_MODULE__514__, __WEBPACK_EXTERNAL_MODULE__442__, __WEBPACK_EXTERNAL_MODULE__136__, __WEBPACK_EXTERNAL_MODULE__392__, __WEBPACK_EXTERNAL_MODULE__110__, __WEBPACK_EXTERNAL_MODULE__553__, __WEBPACK_EXTERNAL_MODULE__177__, __WEBPACK_EXTERNAL_MODULE__32__, __WEBPACK_EXTERNAL_MODULE__824__, __WEBPACK_EXTERNAL_MODULE__359__, __WEBPACK_EXTERNAL_MODULE__312__, __WEBPACK_EXTERNAL_MODULE__302__, __WEBPACK_EXTERNAL_MODULE__489__, __WEBPACK_EXTERNAL_MODULE__413__, __WEBPACK_EXTERNAL_MODULE__722__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 421:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__421__;

/***/ }),

/***/ 722:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__722__;

/***/ }),

/***/ 992:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__992__;

/***/ }),

/***/ 312:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__312__;

/***/ }),

/***/ 392:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__392__;

/***/ }),

/***/ 470:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__470__;

/***/ }),

/***/ 144:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__144__;

/***/ }),

/***/ 416:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__416__;

/***/ }),

/***/ 528:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__528__;

/***/ }),

/***/ 370:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__370__;

/***/ }),

/***/ 958:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__958__;

/***/ }),

/***/ 155:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__155__;

/***/ }),

/***/ 302:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__302__;

/***/ }),

/***/ 489:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__489__;

/***/ }),

/***/ 824:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__824__;

/***/ }),

/***/ 514:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__514__;

/***/ }),

/***/ 359:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__359__;

/***/ }),

/***/ 442:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__442__;

/***/ }),

/***/ 110:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__110__;

/***/ }),

/***/ 553:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__553__;

/***/ }),

/***/ 177:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__177__;

/***/ }),

/***/ 32:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__32__;

/***/ }),

/***/ 136:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__136__;

/***/ }),

/***/ 413:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__413__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ALIQUOT_CREATION: () => (/* reexport */ ALIQUOT_CREATION),
  ALIQUOT_FILTER_MODE: () => (/* reexport */ ALIQUOT_FILTER_MODE),
  ANCESTOR_LOOKUP_CONCEPT_URI: () => (/* reexport */ ANCESTOR_LOOKUP_CONCEPT_URI),
  ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE: () => (/* reexport */ ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE),
  APIKeysPanel: () => (/* reexport */ APIKeysPanel),
  ASSAY_AUDIT_QUERY: () => (/* reexport */ ASSAY_AUDIT_QUERY),
  ASSAY_DESIGNER_ROLE: () => (/* reexport */ ASSAY_DESIGNER_ROLE),
  AUDIT_EVENT_TYPE_PARAM: () => (/* reexport */ AUDIT_EVENT_TYPE_PARAM),
  ActionMapper: () => (/* reexport */ ActionMapper),
  ActiveUserLimit: () => (/* reexport */ ActiveUserLimit),
  ActiveUserLimitMessage: () => (/* reexport */ ActiveUserLimitMessage),
  AddEntityButton: () => (/* reexport */ AddEntityButton),
  AddToPicklistMenuItem: () => (/* reexport */ AddToPicklistMenuItem),
  Alert: () => (/* reexport */ Alert),
  AliasRenderer: () => (/* reexport */ AliasRenderer),
  AncestorRenderer: () => (/* reexport */ AncestorRenderer),
  AnnouncementRenderType: () => (/* reexport */ AnnouncementRenderType),
  App: () => (/* binding */ App),
  AppContextProvider: () => (/* reexport */ AppContextProvider),
  AppContextTestProvider: () => (/* reexport */ AppContextTestProvider),
  AppContexts: () => (/* reexport */ AppContexts),
  AppModel: () => (/* reexport */ AppModel),
  AppURL: () => (/* reexport */ AppURL),
  AppendUnits: () => (/* reexport */ AppendUnits),
  AssayContext: () => (/* reexport */ AssayContext),
  AssayContextConsumer: () => (/* reexport */ AssayContextConsumer),
  AssayContextProvider: () => (/* reexport */ AssayContextProvider),
  AssayDefinitionModel: () => (/* reexport */ AssayDefinitionModel),
  AssayDesignEmptyAlert: () => (/* reexport */ AssayDesignEmptyAlert),
  AssayDesignerPanels: () => (/* reexport */ AssayDesignerPanels),
  AssayDomainTypes: () => (/* reexport */ AssayDomainTypes),
  AssayImportPanels: () => (/* reexport */ AssayImportPanels),
  AssayLink: () => (/* reexport */ AssayLink),
  AssayPicker: () => (/* reexport */ AssayPicker),
  AssayPickerTabs: () => (/* reexport */ AssayPickerTabs),
  AssayProtocolModel: () => (/* reexport */ AssayProtocolModel),
  AssayResultDataType: () => (/* reexport */ AssayResultDataType),
  AssayResultsForSamplesButton: () => (/* reexport */ AssayResultsForSamplesButton),
  AssayResultsForSamplesMenuItem: () => (/* reexport */ AssayResultsForSamplesMenuItem),
  AssayRunDataType: () => (/* reexport */ AssayRunDataType),
  AssayRunOperation: () => (/* reexport */ AssayRunOperation),
  AssayStateModel: () => (/* reexport */ AssayStateModel),
  AssayUploadResultModel: () => (/* reexport */ AssayUploadResultModel),
  AssayUploadTabs: () => (/* reexport */ AssayUploadTabs),
  AttachmentCard: () => (/* reexport */ AttachmentCard),
  AuditDetails: () => (/* reexport */ AuditDetails),
  AuditDetailsModel: () => (/* reexport */ AuditDetailsModel),
  AuditSettings: () => (/* reexport */ AuditSettings),
  AutoForm: () => (/* reexport */ AutoForm),
  BACKGROUND_IMPORT_MIN_FILE_SIZE: () => (/* reexport */ BACKGROUND_IMPORT_MIN_FILE_SIZE),
  BACKGROUND_IMPORT_MIN_ROW_SIZE: () => (/* reexport */ BACKGROUND_IMPORT_MIN_ROW_SIZE),
  BOX_SAMPLES_FILTER: () => (/* reexport */ BOX_SAMPLES_FILTER),
  BarChartViewer: () => (/* reexport */ BarChartViewer),
  BarTenderConfiguration: () => (/* reexport */ BarTenderConfiguration),
  BarTenderSettingsForm: () => (/* reexport */ BarTenderSettingsForm),
  BaseBarChart: () => (/* reexport */ BaseBarChart),
  BaseDomainDesigner: () => (/* reexport */ BaseDomainDesigner),
  BaseModal: () => (/* reexport */ BaseModal),
  BasePropertiesPanel: () => (/* reexport */ BasePropertiesPanel),
  BeforeUnload: () => (/* reexport */ BeforeUnload),
  Breadcrumb: () => (/* reexport */ Breadcrumb),
  BreadcrumbCreate: () => (/* reexport */ BreadcrumbCreate),
  BulkUpdateForm: () => (/* reexport */ BulkUpdateForm),
  CHART_GROUPS: () => (/* reexport */ CHART_GROUPS),
  CHILD_SAMPLE_CREATION: () => (/* reexport */ CHILD_SAMPLE_CREATION),
  COLUMN_IN_FILTER_TYPE: () => (/* reexport */ COLUMN_IN_FILTER_TYPE),
  COLUMN_NOT_IN_FILTER_TYPE: () => (/* reexport */ COLUMN_NOT_IN_FILTER_TYPE),
  CONFIRM_MESSAGE: () => (/* reexport */ CONFIRM_MESSAGE),
  Cards: () => (/* reexport */ Cards),
  ChangePasswordModal: () => (/* reexport */ ChangePasswordModal),
  CheckboxLK: () => (/* reexport */ CheckboxLK),
  ChoicesListItem: () => (/* reexport */ ChoicesListItem),
  ColorIcon: () => (/* reexport */ ColorIcon),
  ColorPickerInput: () => (/* reexport */ ColorPickerInput),
  ColumnSelectionModal: () => (/* reexport */ ColumnSelectionModal),
  CommentTextArea: () => (/* reexport */ CommentTextArea),
  ConceptModel: () => (/* reexport */ ConceptModel),
  Container: () => (/* reexport */ Container),
  ContentGroup: () => (/* reexport */ ContentGroup),
  ContentGroupLabel: () => (/* reexport */ ContentGroupLabel),
  CreatedModified: () => (/* reexport */ CreatedModified),
  DATACLASS_DATA_UPDATE_AUDIT_QUERY: () => (/* reexport */ DATACLASS_DATA_UPDATE_AUDIT_QUERY),
  DATA_CLASS_DESIGNER_ROLE: () => (/* reexport */ DATA_CLASS_DESIGNER_ROLE),
  DATA_IMPORT_FILE_SIZE_LIMITS: () => (/* reexport */ DATA_IMPORT_FILE_SIZE_LIMITS),
  DATE_FORMATS_TOPIC: () => (/* reexport */ DATE_FORMATS_TOPIC),
  DEFAULT_ALIQUOT_NAMING_PATTERN: () => (/* reexport */ DEFAULT_ALIQUOT_NAMING_PATTERN),
  DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS: () => (/* reexport */ DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS),
  DEFAULT_FILE: () => (/* reexport */ DEFAULT_FILE),
  DEFAULT_LINEAGE_DISTANCE: () => (/* reexport */ DEFAULT_LINEAGE_DISTANCE),
  DEFAULT_SAMPLE_FIELD_CONFIG: () => (/* reexport */ DEFAULT_SAMPLE_FIELD_CONFIG),
  DERIVATION_DATA_SCOPES: () => (/* reexport */ DERIVATION_DATA_SCOPES),
  DERIVATIVE_CREATION: () => (/* reexport */ DERIVATIVE_CREATION),
  DOMAIN_FIELD_REQUIRED: () => (/* reexport */ DOMAIN_FIELD_REQUIRED),
  DOMAIN_FIELD_TYPE: () => (/* reexport */ DOMAIN_FIELD_TYPE),
  DOMAIN_RANGE_VALIDATOR: () => (/* reexport */ DOMAIN_RANGE_VALIDATOR),
  DataClassDataType: () => (/* reexport */ DataClassDataType),
  DataClassDesigner: () => (/* reexport */ DataClassDesigner),
  DataClassModel: () => (/* reexport */ DataClassModel),
  DataOperation: () => (/* reexport */ DataOperation),
  DataTypeProjectsPanel: () => (/* reexport */ DataTypeProjectsPanel),
  DataTypeSelector: () => (/* reexport */ DataTypeSelector),
  DataViewInfoTypes: () => (/* reexport */ DataViewInfoTypes),
  DatasetDesignerPanels: () => (/* reexport */ DatasetDesignerPanels),
  DatasetModel: () => (/* reexport */ DatasetModel),
  DateInput: () => (/* reexport */ DateInput),
  DatePickerInput: () => (/* reexport */ DatePickerInput),
  DefaultRenderer: () => (/* reexport */ DefaultRenderer),
  DeleteIcon: () => (/* reexport */ DeleteIcon),
  DesignerDetailTooltip: () => (/* reexport */ DesignerDetailTooltip),
  DetailPanel: () => (/* reexport */ DetailPanel),
  DetailPanelHeader: () => (/* reexport */ DetailPanelHeader),
  DetailPanelWithModel: () => (/* reexport */ DetailPanelWithModel),
  DisableableAnchor: () => (/* reexport */ DisableableAnchor),
  DisableableButton: () => (/* reexport */ DisableableButton),
  DisableableMenuItem: () => (/* reexport */ DisableableMenuItem),
  DiscardConsumedSamplesPanel: () => (/* reexport */ DiscardConsumedSamplesPanel),
  Discussions: () => (/* reexport */ Discussions),
  DomainDesign: () => (/* reexport */ DomainDesign),
  DomainDetails: () => (/* reexport */ DomainDetails),
  DomainException: () => (/* reexport */ DomainException),
  DomainField: () => (/* reexport */ DomainField),
  DomainFieldLabel: () => (/* reexport */ DomainFieldLabel),
  DomainFieldsDisplay: () => (/* reexport */ DomainFieldsDisplay),
  DomainForm: () => (/* reexport */ domainproperties_DomainForm),
  DragDropHandle: () => (/* reexport */ DragDropHandle),
  DropdownAnchor: () => (/* reexport */ DropdownAnchor),
  DropdownButton: () => (/* reexport */ DropdownButton),
  DropdownSection: () => (/* reexport */ DropdownSection),
  EXPERIMENT_AUDIT_EVENT: () => (/* reexport */ EXPERIMENT_AUDIT_EVENT),
  EXPORT_TYPES: () => (/* reexport */ EXPORT_TYPES),
  EditInlineField: () => (/* reexport */ EditInlineField),
  EditableDetailPanel: () => (/* reexport */ EditableDetailPanel),
  EditableGridEvent: () => (/* reexport */ EditableGridEvent),
  EditableGridLoaderFromSelection: () => (/* reexport */ EditableGridLoaderFromSelection),
  EditableGridPanel: () => (/* reexport */ EditableGridPanel),
  EditableGridPanelForUpdate: () => (/* reexport */ EditableGridPanelForUpdate),
  EditableGridTabs: () => (/* reexport */ EditableGridTabs),
  EditorMode: () => (/* reexport */ EditorMode),
  EditorModel: () => (/* reexport */ EditorModel),
  EntityIdCreationModel: () => (/* reexport */ EntityIdCreationModel),
  EntityMoveConfirmationModal: () => (/* reexport */ EntityMoveConfirmationModal),
  EntityMoveModal: () => (/* reexport */ EntityMoveModal),
  EntityParentType: () => (/* reexport */ EntityParentType),
  EntityTypeOption: () => (/* reexport */ EntityTypeOption),
  ExpandableContainer: () => (/* reexport */ ExpandableContainer),
  ExpandableFilterToggle: () => (/* reexport */ ExpandableFilterToggle),
  ExperimentRunResolver: () => (/* reexport */ ExperimentRunResolver),
  ExpirationDateColumnRenderer: () => (/* reexport */ ExpirationDateColumnRenderer),
  ExtendedMap: () => (/* reexport */ ExtendedMap),
  FIND_BY_IDS_QUERY_PARAM: () => (/* reexport */ FIND_BY_IDS_QUERY_PARAM),
  FieldExpansionToggle: () => (/* reexport */ FieldExpansionToggle),
  FileAttachmentArea: () => (/* reexport */ FileAttachmentArea),
  FileAttachmentEntry: () => (/* reexport */ FileAttachmentEntry),
  FileAttachmentForm: () => (/* reexport */ FileAttachmentForm),
  FileColumnRenderer: () => (/* reexport */ FileColumnRenderer),
  FileInput: () => (/* reexport */ FileInput),
  FileTree: () => (/* reexport */ FileTree),
  FilesListing: () => (/* reexport */ FilesListing),
  FilesListingForm: () => (/* reexport */ FilesListingForm),
  FindByIdsModal: () => (/* reexport */ FindByIdsModal),
  FindDerivativesButton: () => (/* reexport */ FindDerivativesButton),
  FindDerivativesMenuItem: () => (/* reexport */ FindDerivativesMenuItem),
  FormButtons: () => (/* reexport */ FormButtons),
  FormSection: () => (/* reexport */ FormSection),
  FormStep: () => (/* reexport */ FormStep),
  FormTabs: () => (/* reexport */ FormTabs),
  FormsyCheckbox: () => (/* reexport */ FormsyCheckbox),
  FormsyInput: () => (/* reexport */ FormsyInput),
  FormsySelect: () => (/* reexport */ FormsySelect),
  FormsyTextArea: () => (/* reexport */ FormsyTextArea),
  GENERAL_ASSAY_PROVIDER_NAME: () => (/* reexport */ GENERAL_ASSAY_PROVIDER_NAME),
  GRID_CHECKBOX_OPTIONS: () => (/* reexport */ GRID_CHECKBOX_OPTIONS),
  GROUP_AUDIT_QUERY: () => (/* reexport */ GROUP_AUDIT_QUERY),
  GlobalStateContextProvider: () => (/* reexport */ GlobalStateContextProvider),
  Grid: () => (/* reexport */ Grid),
  GridAliquotViewSelector: () => (/* reexport */ GridAliquotViewSelector),
  GridColumn: () => (/* reexport */ GridColumn),
  GridPanel: () => (/* reexport */ GridPanel),
  GridPanelWithModel: () => (/* reexport */ GridPanelWithModel),
  GroupDetailsPanel: () => (/* reexport */ GroupDetailsPanel),
  HELP_LINK_REFERRER: () => (/* reexport */ HELP_LINK_REFERRER),
  HOME_PATH: () => (/* reexport */ HOME_PATH),
  HOME_TITLE: () => (/* reexport */ HOME_TITLE),
  HelpIcon: () => (/* reexport */ HelpIcon),
  HelpLink: () => (/* reexport */ HelpLink),
  Hooks: () => (/* binding */ Hooks),
  HorizontalBarSection: () => (/* reexport */ HorizontalBarSection),
  IMPORT_DATA_FORM_TYPES: () => (/* reexport */ IMPORT_DATA_FORM_TYPES),
  INDEPENDENT_SAMPLE_CREATION: () => (/* reexport */ INDEPENDENT_SAMPLE_CREATION),
  INVENTORY_AUDIT_QUERY: () => (/* reexport */ INVENTORY_AUDIT_QUERY),
  IN_EXP_DESCENDANTS_OF_FILTER_TYPE: () => (/* reexport */ IN_EXP_DESCENDANTS_OF_FILTER_TYPE),
  IS_ALIQUOT_COL: () => (/* reexport */ IS_ALIQUOT_COL),
  ImportAliasRenderer: () => (/* reexport */ ImportAliasRenderer),
  InferDomainResponse: () => (/* reexport */ InferDomainResponse),
  InsertFormats: () => (/* reexport */ InsertFormats),
  InsertOptions: () => (/* reexport */ InsertOptions),
  InsufficientPermissionsAlert: () => (/* reexport */ InsufficientPermissionsAlert),
  IssuesListDefDesignerPanels: () => (/* reexport */ IssuesListDefDesignerPanels),
  IssuesListDefModel: () => (/* reexport */ IssuesListDefModel),
  ItemsLegend: () => (/* reexport */ ItemsLegend),
  JavaDocsLink: () => (/* reexport */ JavaDocsLink),
  Key: () => (/* reexport */ Key),
  LINEAGE_DIRECTIONS: () => (/* reexport */ LINEAGE_DIRECTIONS),
  LINEAGE_GROUPING_GENERATIONS: () => (/* reexport */ LINEAGE_GROUPING_GENERATIONS),
  LOCATION_SAMPLES_FILTER: () => (/* reexport */ LOCATION_SAMPLES_FILTER),
  LOOK_AND_FEEL_METRIC: () => (/* reexport */ LOOK_AND_FEEL_METRIC),
  LabelColorRenderer: () => (/* reexport */ LabelColorRenderer),
  LabelHelpTip: () => (/* reexport */ LabelHelpTip),
  LabelOverlay: () => (/* reexport */ LabelOverlay),
  LastActionStatus: () => (/* reexport */ LastActionStatus),
  LineageDepthLimitMessage: () => (/* reexport */ LineageDepthLimitMessage),
  LineageFilter: () => (/* reexport */ LineageFilter),
  LineageGraph: () => (/* reexport */ LineageGraph),
  LineageGridModel: () => (/* reexport */ LineageGridModel),
  LineageResult: () => (/* reexport */ LineageResult),
  LineageURLResolvers: () => (/* reexport */ LineageURLResolvers),
  ListDesignerPanels: () => (/* reexport */ ListDesignerPanels),
  ListModel: () => (/* reexport */ ListModel),
  ListResolver: () => (/* reexport */ ListResolver),
  LoadingSpinner: () => (/* reexport */ LoadingSpinner),
  LoadingState: () => (/* reexport */ LoadingState),
  LockIcon: () => (/* reexport */ LockIcon),
  LookupSelectInput: () => (/* reexport */ LookupSelectInput),
  MAX_EDITABLE_GRID_ROWS: () => (/* reexport */ MAX_EDITABLE_GRID_ROWS),
  MEASUREMENT_UNITS: () => (/* reexport */ MEASUREMENT_UNITS),
  ManageDropdownButton: () => (/* reexport */ ManageDropdownButton),
  ManageSampleStatusesPanel: () => (/* reexport */ ManageSampleStatusesPanel),
  MemberType: () => (/* reexport */ MemberType),
  MenuDivider: () => (/* reexport */ MenuDivider),
  MenuHeader: () => (/* reexport */ MenuHeader),
  MenuItem: () => (/* reexport */ MenuItem),
  MenuItemModel: () => (/* reexport */ MenuItemModel),
  MenuSectionModel: () => (/* reexport */ MenuSectionModel),
  MessageLevel: () => (/* reexport */ MessageLevel),
  Modal: () => (/* reexport */ Modal),
  ModalButtons: () => (/* reexport */ ModalButtons),
  ModalHeader: () => (/* reexport */ ModalHeader),
  MultiValueRenderer: () => (/* reexport */ MultiValueRenderer),
  NOT_ANY_FILTER_TYPE: () => (/* reexport */ NOT_ANY_FILTER_TYPE),
  NOT_IN_EXP_DESCENDANTS_OF_FILTER_TYPE: () => (/* reexport */ NOT_IN_EXP_DESCENDANTS_OF_FILTER_TYPE),
  NO_UPDATES_MESSAGE: () => (/* reexport */ NO_UPDATES_MESSAGE),
  NameIdSettings: () => (/* reexport */ NameIdSettings),
  NavigationBar: () => (/* reexport */ NavigationBar),
  NoLinkRenderer: () => (/* reexport */ NoLinkRenderer),
  NotificationItemModel: () => (/* reexport */ NotificationItemModel),
  Notifications: () => (/* reexport */ Notifications),
  NotificationsContextProvider: () => (/* reexport */ NotificationsContextProvider),
  OntologyBrowserFilterPanel: () => (/* reexport */ OntologyBrowserFilterPanel),
  OntologyBrowserPage: () => (/* reexport */ OntologyBrowserPage),
  OntologyConceptOverviewPanel: () => (/* reexport */ OntologyConceptOverviewPanel),
  OntologyConceptPicker: () => (/* reexport */ OntologyConceptPicker),
  OntologySearchInput: () => (/* reexport */ OntologySearchInput),
  Operation: () => (/* reexport */ Operation),
  OperationConfirmationData: () => (/* reexport */ OperationConfirmationData),
  OverlayTrigger: () => (/* reexport */ OverlayTrigger),
  PICKLIST_SAMPLES_FILTER: () => (/* reexport */ PICKLIST_SAMPLES_FILTER),
  PIPELINE_JOB_NOTIFICATION_EVENT: () => (/* reexport */ PIPELINE_JOB_NOTIFICATION_EVENT),
  PIPELINE_JOB_NOTIFICATION_EVENT_ERROR: () => (/* reexport */ PIPELINE_JOB_NOTIFICATION_EVENT_ERROR),
  PIPELINE_JOB_NOTIFICATION_EVENT_START: () => (/* reexport */ PIPELINE_JOB_NOTIFICATION_EVENT_START),
  PIPELINE_JOB_NOTIFICATION_EVENT_SUCCESS: () => (/* reexport */ PIPELINE_JOB_NOTIFICATION_EVENT_SUCCESS),
  POOLED_SAMPLE_CREATION: () => (/* reexport */ POOLED_SAMPLE_CREATION),
  PROJECT_AUDIT_QUERY: () => (/* reexport */ PROJECT_AUDIT_QUERY),
  PageDetailHeader: () => (/* reexport */ PageDetailHeader),
  PageHeader: () => (/* reexport */ PageHeader),
  Pagination: () => (/* reexport */ Pagination),
  PaginationButtons: () => (/* reexport */ PaginationButtons),
  ParentEntityLineageColumns: () => (/* reexport */ ParentEntityLineageColumns),
  ParentEntityRequiredColumns: () => (/* reexport */ ParentEntityRequiredColumns),
  Persistence: () => (/* reexport */ Persistence),
  Picklist: () => (/* reexport */ Picklist),
  PicklistButton: () => (/* reexport */ PicklistButton),
  PicklistCreationMenuItem: () => (/* reexport */ PicklistCreationMenuItem),
  PicklistEditModal: () => (/* reexport */ PicklistEditModal),
  Popover: () => (/* reexport */ Popover),
  Principal: () => (/* reexport */ Principal),
  PrintLabelsModal: () => (/* reexport */ PrintLabelsModal),
  ProductMenuModel: () => (/* reexport */ ProductMenuModel),
  ProductNavigationMenu: () => (/* reexport */ ProductNavigationMenu),
  Progress: () => (/* reexport */ Progress),
  ProjectDataTypeSelections: () => (/* reexport */ ProjectDataTypeSelections),
  ProjectNameSetting: () => (/* reexport */ ProjectNameSetting),
  ProjectSettings: () => (/* reexport */ ProjectSettings),
  PropertyValidator: () => (/* reexport */ PropertyValidator),
  ProtectedDataSettingsPanel: () => (/* reexport */ ProtectedDataSettingsPanel),
  QUERY_UPDATE_AUDIT_QUERY: () => (/* reexport */ QUERY_UPDATE_AUDIT_QUERY),
  QueryColumn: () => (/* reexport */ QueryColumn),
  QueryCommandResponse: () => (/* reexport */ QueryCommandResponse),
  QueryFilterPanel: () => (/* reexport */ QueryFilterPanel),
  QueryFormInputs: () => (/* reexport */ QueryFormInputs),
  QueryInfo: () => (/* reexport */ QueryInfo),
  QueryInfoStatus: () => (/* reexport */ QueryInfoStatus),
  QueryLookup: () => (/* reexport */ QueryLookup),
  QueryModel: () => (/* reexport */ QueryModel),
  QuerySelect: () => (/* reexport */ QuerySelect),
  QuerySort: () => (/* reexport */ QuerySort),
  RANGE_URIS: () => (/* reexport */ RANGE_URIS),
  RUN_PROPERTIES_REQUIRED_COLUMNS: () => (/* reexport */ RUN_PROPERTIES_REQUIRED_COLUMNS),
  RangeValidationOptionsModal: () => (/* reexport */ RangeValidationOptionsModal),
  ReleaseNote: () => (/* reexport */ ReleaseNote),
  RemoveEntityButton: () => (/* reexport */ RemoveEntityButton),
  ReportItemModal: () => (/* reexport */ ReportItemModal),
  ReportList: () => (/* reexport */ ReportList),
  ReportListItem: () => (/* reexport */ ReportListItem),
  RequiresPermission: () => (/* reexport */ RequiresPermission),
  ResponsiveMenuButton: () => (/* reexport */ ResponsiveMenuButton),
  ResponsiveMenuButtonGroup: () => (/* reexport */ ResponsiveMenuButtonGroup),
  SAMPLES_WITH_TYPES_FILTER: () => (/* reexport */ SAMPLES_WITH_TYPES_FILTER),
  SAMPLE_ALL_PROJECT_LOOKUP_FIELDS: () => (/* reexport */ SAMPLE_ALL_PROJECT_LOOKUP_FIELDS),
  SAMPLE_DATA_EXPORT_CONFIG: () => (/* reexport */ SAMPLE_DATA_EXPORT_CONFIG),
  SAMPLE_EXPORT_CONFIG: () => (/* reexport */ SAMPLE_EXPORT_CONFIG),
  SAMPLE_FINDER_SESSION_PREFIX: () => (/* reexport */ SAMPLE_FINDER_SESSION_PREFIX),
  SAMPLE_ID_FIND_FIELD: () => (/* reexport */ SAMPLE_ID_FIND_FIELD),
  SAMPLE_INSERT_EXTRA_COLUMNS: () => (/* reexport */ SAMPLE_INSERT_EXTRA_COLUMNS),
  SAMPLE_STATE_COLUMN_NAME: () => (/* reexport */ SAMPLE_STATE_COLUMN_NAME),
  SAMPLE_STATE_TYPE_COLUMN_NAME: () => (/* reexport */ SAMPLE_STATE_TYPE_COLUMN_NAME),
  SAMPLE_STATUS_REQUIRED_COLUMNS: () => (/* reexport */ SAMPLE_STATUS_REQUIRED_COLUMNS),
  SAMPLE_STORAGE_COLUMNS: () => (/* reexport */ SAMPLE_STORAGE_COLUMNS),
  SAMPLE_TIMELINE_AUDIT_QUERY: () => (/* reexport */ SAMPLE_TIMELINE_AUDIT_QUERY),
  SAMPLE_TYPE: () => (/* reexport */ SAMPLE_TYPE),
  SAMPLE_TYPE_AUDIT_QUERY: () => (/* reexport */ SAMPLE_TYPE_AUDIT_QUERY),
  SAMPLE_TYPE_CONCEPT_URI: () => (/* reexport */ SAMPLE_TYPE_CONCEPT_URI),
  SAMPLE_TYPE_DESIGNER_ROLE: () => (/* reexport */ SAMPLE_TYPE_DESIGNER_ROLE),
  SCHEMAS: () => (/* reexport */ SCHEMAS),
  SEARCH_PLACEHOLDER: () => (/* reexport */ SEARCH_PLACEHOLDER),
  SELECTION_KEY_TYPE: () => (/* reexport */ SELECTION_KEY_TYPE),
  SHARED_CONTAINER_PATH: () => (/* reexport */ SHARED_CONTAINER_PATH),
  SOURCE_AUDIT_QUERY: () => (/* reexport */ SOURCE_AUDIT_QUERY),
  STORAGE_UNIQUE_ID_CONCEPT_URI: () => (/* reexport */ STORAGE_UNIQUE_ID_CONCEPT_URI),
  SVGIcon: () => (/* reexport */ SVGIcon),
  SampleAliquotViewSelector: () => (/* reexport */ SampleAliquotViewSelector),
  SampleAmountEditModal: () => (/* reexport */ SampleAmountEditModal),
  SampleCreationType: () => (/* reexport */ SampleCreationType),
  SampleOperation: () => (/* reexport */ SampleOperation),
  SamplePropertyDataType: () => (/* reexport */ SamplePropertyDataType),
  SampleStateType: () => (/* reexport */ SampleStateType),
  SampleStatusLegend: () => (/* reexport */ SampleStatusLegend),
  SampleStatusRenderer: () => (/* reexport */ SampleStatusRenderer),
  SampleStatusTag: () => (/* reexport */ SampleStatusTag),
  SampleTypeDataType: () => (/* reexport */ SampleTypeDataType),
  SampleTypeDesigner: () => (/* reexport */ SampleTypeDesigner),
  SampleTypeEmptyAlert: () => (/* reexport */ SampleTypeEmptyAlert),
  SampleTypeImportAliasRenderer: () => (/* reexport */ SampleTypeImportAliasRenderer),
  SampleTypeLineageCounts: () => (/* reexport */ SampleTypeLineageCounts),
  SampleTypeModel: () => (/* reexport */ SampleTypeModel),
  SamplesEditButtonSections: () => (/* reexport */ SamplesEditButtonSections),
  SchemaDetails: () => (/* reexport */ SchemaDetails),
  SchemaQuery: () => (/* reexport */ SchemaQuery),
  SearchCategory: () => (/* reexport */ SearchCategory),
  SearchField: () => (/* reexport */ SearchField),
  SearchPanel: () => (/* reexport */ SearchPanel),
  SearchScope: () => (/* reexport */ SearchScope),
  Section: () => (/* reexport */ Section),
  SecurityAssignment: () => (/* reexport */ SecurityAssignment),
  SecurityPolicy: () => (/* reexport */ SecurityPolicy),
  SecurityRole: () => (/* reexport */ SecurityRole),
  SelectInput: () => (/* reexport */ SelectInput_SelectInput),
  SelectInputImpl: () => (/* reexport */ SelectInputImpl),
  SelectionMenuItem: () => (/* reexport */ SelectionMenuItem),
  ServerActivityData: () => (/* reexport */ ServerActivityData),
  ServerContextConsumer: () => (/* reexport */ ServerContextConsumer),
  ServerContextProvider: () => (/* reexport */ ServerContextProvider),
  ServerNotificationModel: () => (/* reexport */ ServerNotificationModel),
  Setting: () => (/* reexport */ Setting),
  SourceTypeImportAliasRenderer: () => (/* reexport */ SourceTypeImportAliasRenderer),
  SplitButton: () => (/* reexport */ SplitButton),
  StorageAmountInput: () => (/* reexport */ StorageAmountInput),
  StorageStatusRenderer: () => (/* reexport */ StorageStatusRenderer),
  StoredAmountRenderer: () => (/* reexport */ StoredAmountRenderer),
  Tab: () => (/* reexport */ Tab),
  TabbedGridPanel: () => (/* reexport */ TabbedGridPanel),
  Tabs: () => (/* reexport */ Tabs),
  TemplateDownloadButton: () => (/* reexport */ TemplateDownloadButton),
  TestLineageAPIWrapper: () => (/* reexport */ TestLineageAPIWrapper),
  TextAreaInput: () => (/* reexport */ TextAreaInput),
  TextInput: () => (/* reexport */ TextInput_TextInput),
  Theme: () => (/* reexport */ Theme),
  Thread: () => (/* reexport */ Thread),
  ThreadBlock: () => (/* reexport */ ThreadBlock),
  ThreadEditor: () => (/* reexport */ ThreadEditor),
  TimelineEventModel: () => (/* reexport */ TimelineEventModel),
  TimelineView: () => (/* reexport */ TimelineView),
  Tip: () => (/* reexport */ Tip),
  ToggleButtons: () => (/* reexport */ ToggleButtons),
  ToggleIcon: () => (/* reexport */ ToggleIcon),
  Tooltip: () => (/* reexport */ Tooltip),
  UNIQUE_ID_FIND_FIELD: () => (/* reexport */ UNIQUE_ID_FIND_FIELD),
  URLResolver: () => (/* reexport */ URLResolver),
  URLService: () => (/* reexport */ URLService),
  URL_MAPPERS: () => (/* reexport */ URL_MAPPERS),
  USER_AUDIT_QUERY: () => (/* reexport */ USER_AUDIT_QUERY),
  UnitModel: () => (/* reexport */ UnitModel),
  User: () => (/* reexport */ User),
  UserDetailHeader: () => (/* reexport */ UserDetailHeader),
  UserDetailsPanel: () => (/* reexport */ UserDetailsPanel),
  UserDetailsRenderer: () => (/* reexport */ UserDetailsRenderer),
  UserLink: () => (/* reexport */ UserLink),
  UserLinkList: () => (/* reexport */ UserLinkList),
  UserProfile: () => (/* reexport */ UserProfile),
  UserSelectInput: () => (/* reexport */ UserSelectInput),
  UsersGridPanel: () => (/* reexport */ UsersGridPanel),
  ValueList: () => (/* reexport */ ValueList),
  VerticalScrollPanel: () => (/* reexport */ VerticalScrollPanel),
  ViewInfo: () => (/* reexport */ ViewInfo),
  WHERE_FILTER_TYPE: () => (/* reexport */ WHERE_FILTER_TYPE),
  WORKFLOW_AUDIT_QUERY: () => (/* reexport */ WORKFLOW_AUDIT_QUERY),
  WORKFLOW_TASK_PROPERTIES_REQUIRED_COLUMNS: () => (/* reexport */ WORKFLOW_TASK_PROPERTIES_REQUIRED_COLUMNS),
  WebDavFile: () => (/* reexport */ WebDavFile),
  WizardNavButtons: () => (/* reexport */ WizardNavButtons),
  addColumns: () => (/* reexport */ addColumns),
  allowReimportAssayRun: () => (/* reexport */ allowReimportAssayRun),
  applyDevTools: () => (/* reexport */ applyDevTools),
  applyEditableGridChangesToModels: () => (/* reexport */ applyEditableGridChangesToModels),
  applyURL: () => (/* reexport */ applyURL),
  areUnitsCompatible: () => (/* reexport */ areUnitsCompatible),
  arrayEquals: () => (/* reexport */ arrayEquals),
  blurActiveElement: () => (/* reexport */ blurActiveElement),
  buildURL: () => (/* reexport */ buildURL),
  cancelEvent: () => (/* reexport */ cancelEvent),
  capitalizeFirstChar: () => (/* reexport */ capitalizeFirstChar),
  caseInsensitive: () => (/* reexport */ caseInsensitive),
  changeColumn: () => (/* reexport */ changeColumn),
  clearAssayDefinitionCache: () => (/* reexport */ clearAssayDefinitionCache),
  clearSelected: () => (/* reexport */ clearSelected),
  convertUnitDisplay: () => (/* reexport */ convertUnitDisplay),
  convertUnitsForInput: () => (/* reexport */ convertUnitsForInput),
  createFormInputId: () => (/* reexport */ createFormInputId),
  createGridModel: () => (/* reexport */ createGridModel),
  createGridModelId: () => (/* reexport */ createGridModelId),
  createHorizontalBarLegendData: () => (/* reexport */ createHorizontalBarLegendData),
  createMockWithRouteLeave: () => (/* reexport */ createMockWithRouteLeave),
  createPercentageBarData: () => (/* reexport */ createPercentageBarData),
  createProductUrl: () => (/* reexport */ createProductUrl),
  createProductUrlFromParts: () => (/* reexport */ createProductUrlFromParts),
  createWebDavDirectory: () => (/* reexport */ createWebDavDirectory),
  debounce: () => (/* reexport */ debounce),
  decodePart: () => (/* reexport */ decodePart),
  deleteDataClass: () => (/* reexport */ deleteDataClass),
  deleteErrorMessage: () => (/* reexport */ deleteErrorMessage),
  deletePicklists: () => (/* reexport */ deletePicklists),
  deleteRows: () => (/* reexport */ deleteRows),
  deleteSampleSet: () => (/* reexport */ deleteSampleSet),
  deleteSuccessMessage: () => (/* reexport */ deleteSuccessMessage),
  deleteWebDavResource: () => (/* reexport */ deleteWebDavResource),
  devToolsActive: () => (/* reexport */ devToolsActive),
  downloadAttachment: () => (/* reexport */ downloadAttachment),
  encodePart: () => (/* reexport */ encodePart),
  fetchContainerSecurityPolicy: () => (/* reexport */ fetchContainerSecurityPolicy),
  fetchDataClass: () => (/* reexport */ fetchDataClass),
  fetchDatasetDesign: () => (/* reexport */ fetchDatasetDesign),
  fetchDomain: () => (/* reexport */ fetchDomain),
  fetchDomainDetails: () => (/* reexport */ fetchDomainDetails),
  fetchGroupMembership: () => (/* reexport */ fetchGroupMembership),
  fetchIssuesListDefDesign: () => (/* reexport */ fetchIssuesListDefDesign),
  fetchListDesign: () => (/* reexport */ fetchListDesign),
  fetchSamples: () => (/* reexport */ fetchSamples),
  filterDate: () => (/* reexport */ filterDate),
  findMissingValues: () => (/* reexport */ findMissingValues),
  flattenBrowseDataTreeResponse: () => (/* reexport */ flattenBrowseDataTreeResponse),
  flattenValuesFromRow: () => (/* reexport */ flattenValuesFromRow),
  formatDate: () => (/* reexport */ formatDate),
  formatDateTime: () => (/* reexport */ formatDateTime),
  generateId: () => (/* reexport */ generateId),
  getActionErrorMessage: () => (/* reexport */ getActionErrorMessage),
  getAltMetricUnitOptions: () => (/* reexport */ getAltMetricUnitOptions),
  getAltUnitKeys: () => (/* reexport */ getAltUnitKeys),
  getAssayDefinitions: () => (/* reexport */ getAssayDefinitions),
  getAuditQueries: () => (/* reexport */ getAuditQueries),
  getConfirmDeleteMessage: () => (/* reexport */ getConfirmDeleteMessage),
  getContainerFilter: () => (/* reexport */ getContainerFilter),
  getContainerFilterForFolder: () => (/* reexport */ getContainerFilterForFolder),
  getContainerFilterForLookups: () => (/* reexport */ getContainerFilterForLookups),
  getContainersForPermission: () => (/* reexport */ getContainersForPermission),
  getDataDeleteConfirmationData: () => (/* reexport */ getDataDeleteConfirmationData),
  getDataOperationConfirmationData: () => (/* reexport */ getDataOperationConfirmationData),
  getDefaultAPIWrapper: () => (/* reexport */ getDefaultAPIWrapper),
  getDeleteConfirmationData: () => (/* reexport */ getDeleteConfirmationData),
  getDisambiguatedSelectInputOptions: () => (/* reexport */ getDisambiguatedSelectInputOptions),
  getEntityDescription: () => (/* reexport */ getEntityDescription),
  getEntityNoun: () => (/* reexport */ getEntityNoun),
  getEntityTypeOptions: () => (/* reexport */ getEntityTypeOptions),
  getEventDataValueDisplay: () => (/* reexport */ getEventDataValueDisplay),
  getExcludedDataTypeNames: () => (/* reexport */ getExcludedDataTypeNames),
  getFieldFiltersValidationResult: () => (/* reexport */ getFieldFiltersValidationResult),
  getFieldLookupFromSelection: () => (/* reexport */ getFieldLookupFromSelection),
  getFilterForSampleOperation: () => (/* reexport */ getFilterForSampleOperation),
  getFilterLabKeySql: () => (/* reexport */ getFilterLabKeySql),
  getFilterValuesAsArray: () => (/* reexport */ getFilterValuesAsArray),
  getGridIdsFromTransactionId: () => (/* reexport */ getGridIdsFromTransactionId),
  getGroupMembership: () => (/* reexport */ getGroupMembership),
  getGroupedSampleDisplayColumns: () => (/* reexport */ getGroupedSampleDisplayColumns),
  getGroupedSampleDomainFields: () => (/* reexport */ getGroupedSampleDomainFields),
  getHelpLink: () => (/* reexport */ getHelpLink),
  getHref: () => (/* reexport */ getHref),
  getImmediateChildLineageFilterValue: () => (/* reexport */ getImmediateChildLineageFilterValue),
  getInactiveUsers: () => (/* reexport */ getInactiveUsers),
  getInitialParentChoices: () => (/* reexport */ getInitialParentChoices),
  getJobCreationHref: () => (/* reexport */ getJobCreationHref),
  getLegalIdentifier: () => (/* reexport */ getLegalIdentifier),
  getLineageFilterValue: () => (/* reexport */ getLineageFilterValue),
  getListIdFromDomainId: () => (/* reexport */ getListIdFromDomainId),
  getListProperties: () => (/* reexport */ getListProperties),
  getMetricUnitOptions: () => (/* reexport */ getMetricUnitOptions),
  getModuleCustomLabels: () => (/* reexport */ getModuleCustomLabels),
  getMultiAltUnitKeys: () => (/* reexport */ getMultiAltUnitKeys),
  getOmittedSampleTypeColumns: () => (/* reexport */ getOmittedSampleTypeColumns),
  getOperationConfirmationData: () => (/* reexport */ getOperationConfirmationData),
  getOperationNotAllowedMessage: () => (/* reexport */ getOperationNotAllowedMessage),
  getOperationNotAllowedMessageFromCounts: () => (/* reexport */ getOperationNotAllowedMessageFromCounts),
  getOperationNotPermittedMessage: () => (/* reexport */ getOperationNotPermittedMessage),
  getOrderedSelectedMappedKeysFromQueryModel: () => (/* reexport */ getOrderedSelectedMappedKeysFromQueryModel),
  getOrderedSelectedPicklistSamples: () => (/* reexport */ getOrderedSelectedPicklistSamples),
  getPageNumberChangeURL: () => (/* reexport */ getPageNumberChangeURL),
  getParentTypeDataForLineage: () => (/* reexport */ getParentTypeDataForLineage),
  getParsedRelativeDateStr: () => (/* reexport */ getParsedRelativeDateStr),
  getPermissionRestrictionMessage: () => (/* reexport */ getPermissionRestrictionMessage),
  getPicklistFromId: () => (/* reexport */ getPicklistFromId),
  getPicklistListingContainerFilter: () => (/* reexport */ getPicklistListingContainerFilter),
  getPipelineActivityData: () => (/* reexport */ getPipelineActivityData),
  getPrincipals: () => (/* reexport */ getPrincipals),
  getPrincipalsById: () => (/* reexport */ getPrincipalsById),
  getProtocol: () => (/* reexport */ getProtocol),
  getQueryDetails: () => (/* reexport */ getQueryDetails),
  getQueryFormLabelFieldName: () => (/* reexport */ getQueryFormLabelFieldName),
  getQueryModelExportParams: () => (/* reexport */ getQueryModelExportParams),
  getQueryParams: () => (/* reexport */ getQueryParams),
  getRolesByUniqueName: () => (/* reexport */ getRolesByUniqueName),
  getSampleDomainDefaultSystemFields: () => (/* reexport */ getSampleDomainDefaultSystemFields),
  getSampleFinderLocalStorageKey: () => (/* reexport */ getSampleFinderLocalStorageKey),
  getSampleOperationConfirmationData: () => (/* reexport */ getSampleOperationConfirmationData),
  getSampleSet: () => (/* reexport */ getSampleSet),
  getSampleStatus: () => (/* reexport */ getSampleStatus),
  getSampleStatusColor: () => (/* reexport */ getSampleStatusColor),
  getSampleStatusContainerFilter: () => (/* reexport */ getSampleStatusContainerFilter),
  getSampleStatusType: () => (/* reexport */ getSampleStatusType),
  getSampleTypeDetails: () => (/* reexport */ getSampleTypeDetails),
  getSampleTypesFromTransactionIds: () => (/* reexport */ getSampleTypesFromTransactionIds),
  getSchemaQuery: () => (/* reexport */ getSchemaQuery),
  getSearchFilterObjs: () => (/* reexport */ getSearchFilterObjs),
  getSearchScopeFromContainerFilter: () => (/* reexport */ getSearchScopeFromContainerFilter),
  getSelected: () => (/* reexport */ getSelected),
  getSelectedData: () => (/* reexport */ getSelectedData),
  getSelectedPicklistSamples: () => (/* reexport */ getSelectedPicklistSamples),
  getSelectedSampleIdsFromSelectionKey: () => (/* reexport */ getSelectedSampleIdsFromSelectionKey),
  getSelectionLineageData: () => (/* reexport */ getSelectionLineageData),
  getStoredAmountDisplay: () => (/* reexport */ getStoredAmountDisplay),
  getTestAPIWrapper: () => (/* reexport */ getTestAPIWrapper),
  getTimelineEntityUrl: () => (/* reexport */ getTimelineEntityUrl),
  getURLParamsForSampleSelectionKey: () => (/* reexport */ getURLParamsForSampleSelectionKey),
  getUniqueIdColumnMetadata: () => (/* reexport */ getUniqueIdColumnMetadata),
  getUpdatedDataFromEditableGrid: () => (/* reexport */ getUpdatedDataFromEditableGrid),
  getUserProperties: () => (/* reexport */ getUserProperties),
  getUserRoleDisplay: () => (/* reexport */ getUserRoleDisplay),
  getUsersWithPermissions: () => (/* reexport */ getUsersWithPermissions),
  getValueFromRow: () => (/* reexport */ getValueFromRow),
  getVerbForInsertOption: () => (/* reexport */ getVerbForInsertOption),
  getWebDavFiles: () => (/* reexport */ getWebDavFiles),
  getWebDavUrl: () => (/* reexport */ getWebDavUrl),
  handleFileInputChange: () => (/* reexport */ handleFileInputChange),
  handleInputTab: () => (/* reexport */ handleInputTab),
  handleRequestFailure: () => (/* reexport */ handleRequestFailure),
  handleTabKeyOnTextArea: () => (/* reexport */ handleTabKeyOnTextArea),
  hasAllPermissions: () => (/* reexport */ hasAllPermissions),
  hasAnyPermissions: () => (/* reexport */ hasAnyPermissions),
  hasParameter: () => (/* reexport */ hasParameter),
  hasPermissions: () => (/* reexport */ hasPermissions),
  imageURL: () => (/* reexport */ imageURL),
  importData: () => (/* reexport */ importData),
  incrementClientSideMetricCount: () => (/* reexport */ incrementClientSideMetricCount),
  inferDomainFromFile: () => (/* reexport */ inferDomainFromFile),
  initEditableGridModel: () => (/* reexport */ initEditableGridModel),
  initEditableGridModels: () => (/* reexport */ initEditableGridModels),
  initQueryGridState: () => (/* reexport */ initQueryGridState),
  insertColumnFilter: () => (/* reexport */ insertColumnFilter),
  insertRows: () => (/* reexport */ insertRows),
  invalidateFullQueryDetailsCache: () => (/* reexport */ invalidateFullQueryDetailsCache),
  invalidateLineageResults: () => (/* reexport */ invalidateLineageResults),
  invalidateQueryDetailsCache: () => (/* reexport */ invalidateQueryDetailsCache),
  isAllSamplesSchema: () => (/* reexport */ isAllSamplesSchema),
  isDateTimeInPast: () => (/* reexport */ isDateTimeInPast),
  isImage: () => (/* reexport */ isImage),
  isInteger: () => (/* reexport */ isInteger),
  isIntegerInRange: () => (/* reexport */ isIntegerInRange),
  isLoading: () => (/* reexport */ isLoading),
  isLoginAutoRedirectEnabled: () => (/* reexport */ isLoginAutoRedirectEnabled),
  isNegativeFilterType: () => (/* reexport */ isNegativeFilterType),
  isNonNegativeFloat: () => (/* reexport */ isNonNegativeFloat),
  isNonNegativeInteger: () => (/* reexport */ isNonNegativeInteger),
  isQueryFormLabelField: () => (/* reexport */ isQueryFormLabelField),
  isRelativeDateFilterValue: () => (/* reexport */ isRelativeDateFilterValue),
  isSampleOperationPermitted: () => (/* reexport */ isSampleOperationPermitted),
  isSamplesSchema: () => (/* reexport */ isSamplesSchema),
  isValidFilterField: () => (/* reexport */ isValidFilterField),
  isValuePrecisionValid: () => (/* reexport */ isValuePrecisionValid),
  loadEditorModelData: () => (/* reexport */ loadEditorModelData),
  loadQueries: () => (/* reexport */ loadQueries),
  loadQueriesFromTable: () => (/* reexport */ loadQueriesFromTable),
  loadReports: () => (/* reexport */ loadReports),
  makeQueryInfo: () => (/* reexport */ makeQueryInfo),
  makeTestActions: () => (/* reexport */ makeTestActions),
  makeTestISelectRowsResult: () => (/* reexport */ makeTestISelectRowsResult),
  makeTestQueryModel: () => (/* reexport */ makeTestQueryModel),
  markAllNotificationsAsRead: () => (/* reexport */ markAllNotificationsAsRead),
  mountWithAppServerContext: () => (/* reexport */ mountWithAppServerContext),
  mountWithAppServerContextOptions: () => (/* reexport */ mountWithAppServerContextOptions),
  mountWithServerContext: () => (/* reexport */ mountWithServerContext),
  mountWithServerContextOptions: () => (/* reexport */ mountWithServerContextOptions),
  naturalSort: () => (/* reexport */ naturalSort),
  naturalSortByProperty: () => (/* reexport */ naturalSortByProperty),
  parseCsvString: () => (/* reexport */ parseCsvString),
  parseDate: () => (/* reexport */ parseDate),
  processChartData: () => (/* reexport */ processChartData),
  processGetRolesResponse: () => (/* reexport */ processGetRolesResponse),
  processSchemas: () => (/* reexport */ processSchemas),
  pushParameters: () => (/* reexport */ pushParameters),
  quoteValueWithDelimiters: () => (/* reexport */ quoteValueWithDelimiters),
  registerDefaultURLMappers: () => (/* reexport */ registerDefaultURLMappers),
  registerFilterType: () => (/* reexport */ registerFilterType),
  registerInputRenderer: () => (/* reexport */ registerInputRenderer),
  removeColumn: () => (/* reexport */ removeColumn),
  removeParameters: () => (/* reexport */ removeParameters),
  renderWithAppContext: () => (/* reexport */ renderWithAppContext),
  replaceParameters: () => (/* reexport */ replaceParameters),
  replaceSelected: () => (/* reexport */ replaceSelected),
  resolveDetailFieldValue: () => (/* reexport */ resolveDetailFieldValue),
  resolveDetailRenderer: () => (/* reexport */ resolveDetailRenderer),
  resolveErrorMessage: () => (/* reexport */ resolveErrorMessage),
  resolveKey: () => (/* reexport */ resolveKey),
  runDetailsColumnsForQueryModel: () => (/* reexport */ runDetailsColumnsForQueryModel),
  sampleDeleteDependencyText: () => (/* reexport */ sampleDeleteDependencyText),
  saveDomain: () => (/* reexport */ saveDomain),
  saveOrderedSnapshotSelection: () => (/* reexport */ saveOrderedSnapshotSelection),
  searchFiltersToJson: () => (/* reexport */ searchFiltersToJson),
  selectDistinctRows: () => (/* reexport */ selectDistinctRows),
  selectGridIdsFromTransactionId: () => (/* reexport */ selectGridIdsFromTransactionId),
  selectOptionByText: () => (/* reexport */ selectOptionByText),
  selectRows: () => (/* reexport */ selectRows),
  selectRowsDeprecated: () => (/* reexport */ selectRowsDeprecated),
  setDomainFields: () => (/* reexport */ setDomainFields),
  setSelected: () => (/* reexport */ setSelected),
  setSnapshotSelections: () => (/* reexport */ setSnapshotSelections),
  showPremiumFeatures: () => (/* reexport */ showPremiumFeatures),
  sleep: () => (/* reexport */ sleep),
  spliceURL: () => (/* reexport */ spliceURL),
  toggleDevTools: () => (/* reexport */ toggleDevTools),
  toggleParameter: () => (/* reexport */ toggleParameter),
  uncapitalizeFirstChar: () => (/* reexport */ uncapitalizeFirstChar),
  updateGridFromBulkForm: () => (/* reexport */ updateGridFromBulkForm),
  updatePicklist: () => (/* reexport */ updatePicklist),
  updateRowFieldValue: () => (/* reexport */ updateRowFieldValue),
  updateRows: () => (/* reexport */ updateRows),
  updateSampleStorageData: () => (/* reexport */ updateSampleStorageData),
  uploadWebDavFile: () => (/* reexport */ uploadWebDavFile),
  useAccountSubNav: () => (/* reexport */ useAccountSubNav),
  useAdminAppContext: () => (/* reexport */ useAdminAppContext),
  useAdministrationSubNav: () => (/* reexport */ useAdministrationSubNav),
  useAppContext: () => (/* reexport */ useAppContext),
  useDataChangeCommentsRequired: () => (/* reexport */ useDataChangeCommentsRequired),
  useEnterEscape: () => (/* reexport */ useEnterEscape),
  useFolderDataTypeExclusions: () => (/* reexport */ useFolderDataTypeExclusions),
  useFolderMenuContext: () => (/* reexport */ useFolderMenuContext),
  useLabelPrintingContext: () => (/* reexport */ useLabelPrintingContext),
  useNotAuthorized: () => (/* reexport */ useNotAuthorized),
  useNotFound: () => (/* reexport */ useNotFound),
  useNotificationsContext: () => (/* reexport */ useNotificationsContext),
  useOverlayTriggerState: () => (/* reexport */ useOverlayTriggerState),
  usePortalRef: () => (/* reexport */ usePortalRef),
  useRequestHandler: () => (/* reexport */ useRequestHandler),
  useRouteLeave: () => (/* reexport */ useRouteLeave),
  useServerContext: () => (/* reexport */ useServerContext),
  useServerContextDispatch: () => (/* reexport */ useServerContextDispatch),
  useSubNavTabsContext: () => (/* reexport */ useSubNavTabsContext),
  useUserProperties: () => (/* reexport */ useUserProperties),
  useUsersWithPermissions: () => (/* reexport */ useUsersWithPermissions),
  useWindowFocusCheckExpiredSession: () => (/* reexport */ useWindowFocusCheckExpiredSession),
  valueIsEmpty: () => (/* reexport */ valueIsEmpty),
  waitForLifecycle: () => (/* reexport */ enzymeTestHelpers_waitForLifecycle),
  withAppUser: () => (/* reexport */ withAppUser),
  withAssayModels: () => (/* reexport */ withAssayModels),
  withAssayModelsFromLocation: () => (/* reexport */ withAssayModelsFromLocation),
  withFormSteps: () => (/* reexport */ withFormSteps),
  withLineage: () => (/* reexport */ withLineage),
  withNotificationsContext: () => (/* reexport */ withNotificationsContext),
  withQueryModels: () => (/* reexport */ withQueryModels),
  withServerContext: () => (/* reexport */ withServerContext),
  withTransformedKeys: () => (/* reexport */ withTransformedKeys),
  wrapDraggable: () => (/* reexport */ wrapDraggable)
});

// EXTERNAL MODULE: external "immer"
var external_immer_ = __webpack_require__(470);
// EXTERNAL MODULE: external "@labkey/api"
var api_ = __webpack_require__(421);
;// CONCATENATED MODULE: ./src/internal/url/AppURL.ts
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function createProductUrlFromParts(urlProductId, currentProductId, params, ...parts) {
  const appUrl = AppURL.create(...parts).addParams(params);
  return createProductUrl(urlProductId, currentProductId, appUrl);
}
function createProductUrlFromPartsWithContainer(urlProductId, currentProductId, containerPath, params, ...parts) {
  const appUrl = AppURL.create(...parts).addParams(params);
  return createProductUrl(urlProductId, currentProductId, appUrl, containerPath);
}
function createProductUrl(urlProductId, currentProductId, appUrl, containerPath) {
  // if caller provided a containerPath, then buildURL
  // else if target productId of the URL is different then the current productId, then buildURL
  if (containerPath && urlProductId || urlProductId && (!currentProductId || urlProductId.toLowerCase() !== currentProductId.toLowerCase())) {
    const href = appUrl instanceof AppURL ? appUrl.toHref() : appUrl;

    // Stay in dev mode if we are staying in the same controller and using action appDev
    const useDevMode = api_.ActionURL.getController().toLowerCase() === urlProductId.toLowerCase() && api_.ActionURL.getAction().toLowerCase() === 'appdev';
    return buildURL(urlProductId.toLowerCase(), useDevMode ? 'appDev.view' : 'app.view', undefined, {
      returnUrl: false,
      container: containerPath
    } // if undefined, buildURL will use current container from server context
    ) + href;
  } else {
    return appUrl;
  }
}
function applyURL(prop, options) {
  if (options) {
    if (typeof options[prop] === 'string') {
      return options[prop];
    } else if (options[prop] instanceof AppURL) {
      return window.location.pathname + options[prop].toHref();
    }
  }
}
function buildURL(controller, action, params, options) {
  const constructedParams = {
    // server expects camel-case URL (e.g. Url)
    cancelUrl: undefined,
    returnUrl: undefined,
    successUrl: undefined
  };
  const applyReturnURL = !options || options && options.returnUrl !== false;
  if (applyReturnURL) {
    if (options && (typeof options.returnUrl === 'string' || options.returnUrl instanceof AppURL)) {
      constructedParams.returnUrl = applyURL('returnUrl', options);
    } else if (action.toLowerCase().indexOf('.api') === -1 && action.toLowerCase().indexOf('.post') === -1) {
      // use the current URL
      constructedParams.returnUrl = window.location.pathname + (window.location.hash ? window.location.hash : '');
    }
  }
  constructedParams.cancelUrl = applyURL('cancelUrl', options);
  constructedParams.successUrl = applyURL('successUrl', options);
  Object.keys(constructedParams).forEach(key => {
    if (!constructedParams[key]) {
      // remove any param keys that do not have values
      delete constructedParams[key];
    }
  });
  const parameters = Object.assign(params ? params : {}, constructedParams);
  return api_.ActionURL.buildURL(controller, action, options?.container, parameters);
}
class AppURL {
  constructor(partial) {
    Object.assign(this, partial);
  }
  static create(...parts) {
    let baseUrl = '';
    for (let i = 0; i < parts.length; i++) {
      if (parts[i] === undefined || parts[i] === null || parts[i] === '') {
        if ((0,api_.getServerContext)().devMode) {
          throw 'AppURL: Unable to create URL with empty parts. Parts are [' + parts.map(p => p + '').join(', ') + '].';
        } else {
          console.error('Unable to create URL with empty parts. Parts are [' + parts.map(p => p + '').join(', ') + '].');
        }
      }
      const stringPart = parts[i].toString();
      const newPart = encodeURIComponent(stringPart);
      if (i === 0) {
        if (stringPart.indexOf('/') === 0) {
          baseUrl += newPart;
        } else {
          baseUrl += '/' + newPart;
        }
      } else {
        baseUrl += '/' + newPart;
      }
    }
    return new AppURL({
      _baseUrl: baseUrl
    });
  }
  addFilters(...filters) {
    return new AppURL(_objectSpread(_objectSpread({}, this), {}, {
      _filters: this._filters ? this._filters.concat(filters) : filters
    }));
  }
  addParam(key, value, includeEmptyParams) {
    return this.addParams({
      [key]: value
    }, includeEmptyParams);
  }
  addParams(params, includeEmptyParams = false) {
    if (params) {
      const encodedParams = {};
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (includeEmptyParams || value !== undefined && value !== null) {
          encodedParams[encodeURIComponent(key)] = encodeURIComponent(value);
        }
      });
      return new AppURL(_objectSpread(_objectSpread({}, this), {}, {
        _params: this._params ? _objectSpread(_objectSpread({}, this._params), encodedParams) : encodedParams
      }));
    }
    return this;
  }
  toHref(urlPrefix) {
    return '#' + this.toString(urlPrefix);
  }
  toQuery(urlPrefix) {
    const query = _objectSpread({}, this._params);
    if (this._filters) {
      this._filters.forEach(f => {
        query[f.getURLParameterName(urlPrefix)] = f.getURLParameterValue();
      });
    }
    return query;
  }
  toString(urlPrefix) {
    const url = this._baseUrl;
    const parts = [];
    if (this._params) {
      Object.keys(this._params).forEach(key => {
        parts.push(key + '=' + this._params[key]);
      });
    }
    if (this._filters) {
      this._filters.forEach(f => {
        parts.push(f.getURLParameterName(urlPrefix) + '=' + f.getURLParameterValue());
      });
    }
    return url + (parts.length > 0 ? '?' + parts.join('&') : '');
  }
}

/**
 * Helper method to splice into the parts of an AppURL what needs to be replaced.
 * E.g. "/me/go/here/43" -> "/john/goes/43"
 * parts ["me", "go", "here" 43"]
 * newParts ["john", "goes"]
 * startIndex 0
 * numToReplace 2 (replace "me" and "go")
 *
 * @param parts - the original parts of the URL
 * @param newParts - the new (and only new) parts of the URL that are to be spliced in
 * @param startIndex - where in the "parts" to start replacement
 * @param numToReplace - how far in the "parts" to replace (default is 1)
 * @returns {AppURL}
 */
function spliceURL(parts, newParts, startIndex, numToReplace) {
  parts.splice(startIndex, numToReplace === undefined ? 1 : numToReplace, ...newParts);
  const decodedParts = parts.map(p => decodeURIComponent(p)).filter(p => !!p);
  return AppURL.create(...decodedParts);
}
;// CONCATENATED MODULE: ./src/internal/url/utils.ts
function decodeListResolverPath(resolverPath) {
  return resolverPath.replace('$CPS', '').replace('$CPE', '');
}
function encodeListResolverPath(containerPath) {
  return ['$CPS', containerPath?.toLowerCase(), '$CPE'].join('');
}
function getHref(url) {
  return typeof url === 'string' ? url : url.toHref();
}
// EXTERNAL MODULE: external "immutable"
var external_immutable_ = __webpack_require__(144);
;// CONCATENATED MODULE: ./src/internal/url/ActionURL.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



// This is similar to LABKEY.Filter.getSortFromUrl, however, it does not assume the urlPrefix.
function getSortFromUrl(queryString, urlPrefix) {
  const params = ActionURL.getParameters(queryString);
  let param = 'sort';
  if (urlPrefix) {
    param = [urlPrefix, param].join('.');
  }
  return params[param];
}
function hasParameter(parameterName) {
  return api_.ActionURL.getParameter(parameterName) !== undefined;
}
function setParameter(parameterName, value) {
  const {
    search
  } = window.location;
  const EQ = '=',
    SEP = '&';
  const keyValues = search.substr(1).split(SEP).reduce((map, part) => {
    const [key, value] = part.split(EQ).map(p => decodeURIComponent(p));
    if (!key) {
      return map;
    }
    if (map.has(key)) {
      if (!api_.Utils.isArray(map.get(key))) {
        map.set(key, [map.get(key)]);
      }
      const arrValue = map.get(key);
      arrValue.push(value);
      return map.set(key, arrValue);
    }
    return map.set(key, value);
  }, (0,external_immutable_.OrderedMap)().asMutable());
  if (value !== undefined) {
    keyValues.set(parameterName, value);
  } else {
    keyValues.remove(parameterName);
  }
  let result = '';
  if (keyValues.size) {
    let sep = '';
    result = keyValues.reduce((search, value, key) => {
      if (!api_.Utils.isArray(value)) {
        value = [value];
      }
      const eKey = encodeURIComponent(key);
      value.forEach(v => {
        search += sep + eKey + EQ + encodeURIComponent(v);
        sep = SEP;
      });
      return search;
    }, '?');
  }
  window.location.search = result;
}
function imageURL(iconDir, src) {
  return [api_.ActionURL.getContextPath(), iconDir, src].join('/');
}
function toggleParameter(parameterName, value) {
  setParameter(parameterName, hasParameter(parameterName) ? undefined : value);
}
;// CONCATENATED MODULE: ./src/internal/components/base/models/Container.ts
const defaultContainer = {
  activeModules: [],
  effectivePermissions: [],
  folderType: '',
  formats: {
    dateFormat: '',
    dateTimeFormat: '',
    numberFormat: '',
    timeFormat: ''
  },
  hasRestrictedActiveModule: false,
  iconHref: '',
  id: '',
  isContainerTab: false,
  isWorkbook: false,
  name: '',
  parentId: '',
  parentPath: '',
  path: '',
  sortOrder: 0,
  startUrl: '',
  title: '',
  type: ''
};

/**
 * Model for org.labkey.api.data.Container as returned by Container.toJSON()
 */
class Container {
  constructor(props) {
    Object.assign(this, defaultContainer, props);
  }

  /**
   * Verify if the given moduleName parameter is in the array of active modules for this container object.
   * Note that this check is case-sensitive.
   * @param moduleName
   */
  hasActiveModule(moduleName) {
    return this.activeModules?.indexOf(moduleName) > -1;
  }
  get isFolder() {
    return this.type === 'folder' && !this.isRoot;
  }
  get isProject() {
    return this.type === 'project' && !this.isRoot;
  }
  get isRoot() {
    return this.path === '/';
  }
  get isSharedProject() {
    return this.path === '/Shared';
  }
}
;// CONCATENATED MODULE: ./src/internal/components/base/models/User.ts

const defaultUser = {
  id: 0,
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  displayName: 'guest',
  email: 'guest',
  phone: null,
  avatar: api_.ActionURL.getContextPath() + '/_images/defaultavatar.png',
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: true,
  isRootAdmin: false,
  isSignedIn: false,
  isSystemAdmin: false,
  isTrusted: false,
  maxAllowedPhi: undefined,
  permissionsList: undefined
};

/**
 * Model for org.labkey.api.security.User as returned by User.getUserProps()
 */
class User {
  constructor(props) {
    Object.assign(this, defaultUser, props);
  }
  static getDefaultUser() {
    return new User(defaultUser);
  }
  hasAdminPermission() {
    return hasAllPermissions(this, [api_.PermissionTypes.Admin], false);
  }
  hasUpdatePermission() {
    return hasAllPermissions(this, [api_.PermissionTypes.Update]);
  }
  hasInsertPermission() {
    return hasAllPermissions(this, [api_.PermissionTypes.Insert]);
  }
  hasDeletePermission() {
    return hasAllPermissions(this, [api_.PermissionTypes.Delete]);
  }
  hasDesignAssaysPermission() {
    return hasAllPermissions(this, [api_.PermissionTypes.DesignAssay]);
  }
  hasDesignSampleTypesPermission() {
    return hasAllPermissions(this, [api_.PermissionTypes.DesignSampleSet]);
  }
  hasManageUsersPermission() {
    return hasAllPermissions(this, [api_.PermissionTypes.UserManagement], false);
  }
  isAppAdmin() {
    return hasAllPermissions(this, [api_.PermissionTypes.ApplicationAdmin], false);
  }
  hasAddUsersPermission() {
    return hasAllPermissions(this, [api_.PermissionTypes.AddUser], false);
  }
  hasSampleWorkflowDeletePermission() {
    return hasAllPermissions(this, [api_.PermissionTypes.SampleWorkflowDelete]);
  }
}

/**
 * Determines if a user has the permissions given.
 * @param user User in question
 * @param perms Array of permission strings (See models/constants)
 * @param checkIsAdmin Indicates if user.isAdmin should override check. Defaults to true.
 * @param permissionCheck Sets which "has permissions" check logic is used.
 *   `all` - Require user to have all of the specified permissions (default).
 *   `any` - Require user to have any of the specified permissions.
 */
function hasPermissions(user, perms, checkIsAdmin = true, permissionCheck = 'all') {
  if (checkIsAdmin && user.isAdmin) {
    return perms?.length > 0;
  } else if (perms) {
    const allPerms = user.permissionsList ?? [];
    if (permissionCheck === 'any') {
      return perms.some(p => allPerms.indexOf(p) > -1);
    } else {
      return perms.every(p => allPerms.indexOf(p) > -1);
    }
  }
  return false;
}

/**
 * Determines if a user has all the permissions given. If the user has only some of these permissions, returns false.
 * @param user User in question
 * @param perms Array of permission strings (See models/constants)
 * @param checkIsAdmin Indicates if user.isAdmin should override check
 */
function hasAllPermissions(user, perms, checkIsAdmin) {
  return hasPermissions(user, perms, checkIsAdmin, 'all');
}

/**
 * Determines if a user has any of the permissions given. If the user has any of the permissions then return true.
 * @param user User in question
 * @param perms Array of permission strings (See models/constants)
 * @param checkIsAdmin Indicates if user.isAdmin should override check
 */
function hasAnyPermissions(user, perms, checkIsAdmin) {
  return hasPermissions(user, perms, checkIsAdmin, 'any');
}
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
;// CONCATENATED MODULE: ./src/internal/components/base/models/GridColumn.tsx
function GridColumn_defineProperty(e, r, t) { return (r = GridColumn_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function GridColumn_toPropertyKey(t) { var i = GridColumn_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function GridColumn_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const defaultCell = d => {
  let display = null;
  if (d != undefined) {
    if (typeof d === 'string' || typeof d === 'number') {
      display = d;
    } else if (typeof d === 'boolean') {
      display = d ? 'true' : 'false';
    } else {
      if (d.has('formattedValue')) {
        display = d.get('formattedValue');
      } else {
        const o = d.has('displayValue') ? d.get('displayValue') : d.get('value');
        display = o !== null && o !== undefined ? o.toString() : null;
      }
      if (d.get('url')) {
        display = /*#__PURE__*/external_react_default().createElement("a", {
          href: d.get('url')
        }, display);
      }
    }
  }
  return display;
};
class GridColumn {
  constructor(config) {
    GridColumn_defineProperty(this, "align", void 0);
    GridColumn_defineProperty(this, "cell", void 0);
    GridColumn_defineProperty(this, "format", void 0);
    GridColumn_defineProperty(this, "headerCls", void 0);
    GridColumn_defineProperty(this, "helpTipRenderer", void 0);
    GridColumn_defineProperty(this, "hideTooltip", void 0);
    GridColumn_defineProperty(this, "index", void 0);
    GridColumn_defineProperty(this, "fixedWidth", void 0);
    GridColumn_defineProperty(this, "raw", void 0);
    GridColumn_defineProperty(this, "tableCell", void 0);
    GridColumn_defineProperty(this, "title", void 0);
    GridColumn_defineProperty(this, "showHeader", void 0);
    GridColumn_defineProperty(this, "width", void 0);
    this.align = config.align;
    this.cell = config.cell ?? defaultCell;
    this.format = config.format;
    this.index = config.index;
    this.fixedWidth = config.fixedWidth;
    this.raw = config.raw;
    this.headerCls = config.headerCls;
    this.helpTipRenderer = config.helpTipRenderer;
    this.width = config.width;

    // react render displays '&nbsp', see: https://facebook.github.io/react/docs/jsx-gotchas.html
    if (config.title && config.title == '&nbsp;') {
      this.title = '';
    } else {
      this.title = config.title;
    }
    this.showHeader = config.showHeader !== false; // defaults to true
    this.tableCell = config.tableCell === true; // defaults to false
    this.hideTooltip = config.hideTooltip === true; // defaults to false
  }
}
;// CONCATENATED MODULE: ./src/public/SchemaQuery.ts
function SchemaQuery_defineProperty(e, r, t) { return (r = SchemaQuery_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SchemaQuery_toPropertyKey(t) { var i = SchemaQuery_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SchemaQuery_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const APP_SELECTION_PREFIX = 'appkey';

// 36009: Case-insensitive variant of QueryKey.decodePart
function decodePart(s) {
  if (!s) return s;
  return s.replace(/\$P/gi, '.').replace(/\$C/gi, ',').replace(/\$T/gi, '~').replace(/\$B/gi, '}').replace(/\$A/gi, '&').replace(/\$S/gi, '/').replace(/\$D/gi, '$');
}

// 36009: Case-insensitive variant of QueryKey.encodePart
function encodePart(s) {
  if (!s) return s;
  return s.replace(/\$/gi, '$D').replace(/\//gi, '$S').replace(/\&/gi, '$A').replace(/\}/gi, '$B').replace(/\~/gi, '$T').replace(/\,/gi, '$C').replace(/\./gi, '$P');
}
function resolveKey(schema, query, viewName) {
  /*
     It's questionable if we really need to encodePart schema here and the suspicion is that this would result in
     double encoding. Since schema is not recognisable by api when not encoded, it would be reasonable to assume the
     passed in schema is already QueryKey encoded.  Though it won't hurt to double encode as long as resolveKey,
     resolveKeyFromJson and getSchemaQuery have the same assumption on the need to encode/decode
  */
  const parts = [encodePart(schema), encodePart(query)];
  if (viewName) parts.push(encodePart(viewName));
  return parts.join('/').toLowerCase();
}
function resolveKeyFromJson(json) {
  // if schema parts contain '.', replace with $P, to distinguish from '.' used to separate schema parts
  // similarly, encode '/' in schema parts, to distinguish from '/' used to separate schema and query parts
  // schemaName ['assay', 'general', 'a.b/c'] will be will processed to 'assay.general.a$pb$sc'
  // resolveKey will then further encode schema to assay$pgeneral$pa$dpb$sc
  return resolveKey(json.schemaName.map(schemaPart => {
    return encodePart(schemaPart);
  }).join('.'), json.queryName, json.viewName);
}
class SchemaQuery {
  constructor(schemaName, queryName, viewName) {
    SchemaQuery_defineProperty(this, "schemaName", void 0);
    SchemaQuery_defineProperty(this, "queryName", void 0);
    SchemaQuery_defineProperty(this, "viewName", void 0);
    this.schemaName = schemaName;
    this.queryName = queryName;
    this.viewName = viewName;
  }
  isEqual(sq) {
    if (!sq) return false;
    return this.toString().toLowerCase() === sq.toString().toLowerCase();
  }
  hasSchema(schemaName) {
    if (schemaName) {
      return this.schemaName?.toLowerCase() === schemaName.toLowerCase();
    }
    return false;
  }
  hasSchemaQuery(sq) {
    if (!sq) return false;
    return this.toString(false).toLowerCase() === sq.toString(false).toLowerCase();
  }
  getKey(includeViewName = true) {
    return resolveKey(this.schemaName, this.queryName, includeViewName ? this.viewName : undefined);
  }
  static parseSelectionKey(selectionKey) {
    const [appkey /* not used */, schemaQueryKey, keys] = selectionKey.split('|');
    return {
      keys,
      schemaQuery: schemaQueryKey ? getSchemaQuery(schemaQueryKey) : undefined
    };
  }
  static createAppSelectionKey(targetSQ, keys) {
    return [APP_SELECTION_PREFIX, targetSQ.getKey(), keys.join(';')].join('|');
  }
  toString(includeViewName = true) {
    const parts = [this.schemaName, this.queryName];
    if (includeViewName) {
      parts.push(this.viewName);
    }
    return parts.join('|');
  }
}
function getSchemaQuery(encodedKey) {
  const [encodedSchema, encodedQuery, encodedViewName] = encodedKey.split('/');
  return new SchemaQuery(decodePart(encodedSchema), decodePart(encodedQuery), decodePart(encodedViewName));
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/constants.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const DOMAIN_FIELD_PREFIX = 'domainpropertiesrow';
const DOMAIN_FIELD_NAME = 'name';
const DOMAIN_FIELD_TYPE = 'type';
const DOMAIN_FIELD_ADV = 'adv';
const DOMAIN_FIELD_EXPAND = 'expand';
const DOMAIN_FIELD_DELETE = 'delete';
const DOMAIN_FIELD_ROW = 'row';
const DOMAIN_FIELD_REQUIRED = 'required';
const DOMAIN_FIELD_SELECTED = 'selected';
const DOMAIN_FIELD_DETAILS = 'details';
const DOMAIN_FIELD_DESCRIPTION = 'description';
const DOMAIN_FIELD_LABEL = 'label';
const DOMAIN_FIELD_IMPORTALIASES = 'importAliases';
const DOMAIN_FIELD_URL = 'URL';
const DOMAIN_FIELD_LOOKUP_CONTAINER = 'lookupContainer';
const DOMAIN_FIELD_LOOKUP_QUERY = 'lookupQueryValue';
const DOMAIN_FIELD_LOOKUP_SCHEMA = 'lookupSchema';
const DOMAIN_FIELD_FORMAT = 'format';
const DOMAIN_FIELD_FILE_DISPLAY = 'format';
const DOMAIN_FIELD_DEFAULT_SCALE = 'defaultScale';
const DOMAIN_FIELD_EXCLUDE_FROM_SHIFTING = 'excludeFromShifting';
const DOMAIN_FIELD_MEASURE = 'measure';
const DOMAIN_FIELD_DIMENSION = 'dimension';
const DOMAIN_FIELD_HIDDEN = 'hidden';
const DOMAIN_FIELD_MVENABLED = 'mvEnabled';
const DOMAIN_FIELD_PHI = 'PHI';
const DOMAIN_FIELD_UNIQUECONSTRAINT = 'uniqueConstraint';
const DOMAIN_FIELD_RECOMMENDEDVARIABLE = 'recommendedVariable';
const DOMAIN_FIELD_SHOWNINDETAILSVIEW = 'shownInDetailsView';
const DOMAIN_FIELD_SHOWNININSERTVIEW = 'shownInInsertView';
const DOMAIN_FIELD_SHOWNINUPDATESVIEW = 'shownInUpdateView';
const DOMAIN_FIELD_CLIENT_SIDE_ERROR = 'error';
const DOMAIN_FIELD_SAMPLE_TYPE = 'sampleTypeSelect';
const DOMAIN_FIELD_DEFAULT_VALUE_TYPE = 'defaultValueType';
const DOMAIN_FIELD_DEFAULT_VALUE = 'defaultValue';
const DOMAIN_FIELD_DEFAULT_DISPLAY_VALUE = 'defaultDisplayValue';
const DOMAIN_FIELD_ONTOLOGY_SOURCE = 'sourceOntology';
const DOMAIN_FIELD_ONTOLOGY_SUBTREE_COL = 'conceptSubtree';
const DOMAIN_FIELD_ONTOLOGY_LABEL_COL = 'conceptLabelColumn';
const DOMAIN_FIELD_ONTOLOGY_IMPORT_COL = 'conceptImportColumn';
const DOMAIN_FIELD_ONTOLOGY_PRINCIPAL_CONCEPT = 'principalConceptCode';
const DOMAIN_FIELD_DERIVATION_DATA_SCOPE = 'derivationDataScope';
const DOMAIN_FIELD_VALUE_EXPRESSION = 'valueExpression';

// TextFieldOptions
const DOMAIN_FIELD_MAX_LENGTH = 'maxLength';
const DOMAIN_FIELD_CUSTOM_LENGTH = 'customLength';
const DOMAIN_FIELD_SCALE = 'scale';
const DOMAIN_FIELD_SCANNABLE_OPTION = 'scannable';
const DOMAIN_COND_FORMAT = 'conditionalFormat';
const DOMAIN_REGEX_VALIDATOR = 'regexValidator';
const DOMAIN_RANGE_VALIDATOR = 'rangeValidator';
const DOMAIN_COND_FORMATS = 'conditionalFormats';
const DOMAIN_REGEX_VALIDATORS = 'regexValidators';
const DOMAIN_RANGE_VALIDATORS = 'rangeValidators';
const DOMAIN_VALIDATOR_EXPRESSION = 'expression';
const DOMAIN_VALIDATOR_DESCRIPTION = 'description';
const DOMAIN_VALIDATOR_ERRORMESSAGE = 'errorMessage';
const DOMAIN_VALIDATOR_FAILONMATCH = 'failOnMatch';
const DOMAIN_VALIDATOR_NAME = 'name';
const DOMAIN_VALIDATOR_REMOVE = 'removeValidator';
const DOMAIN_VALIDATOR_LOOKUP = 'lookupValidator';
const DOMAIN_VALIDATOR_TEXTCHOICE = 'textChoiceValidator';
const DOMAIN_VALIDATOR_BOLD = 'bold';
const DOMAIN_VALIDATOR_ITALIC = 'italic';
const DOMAIN_VALIDATOR_STRIKETHROUGH = 'strikethrough';
const DOMAIN_CONDITIONAL_FORMAT_PREFIX = 'format.column';
const DOMAIN_CONDITION_FORMAT_TEXT_COLOR = 'textColor';
const DOMAIN_CONDITION_FORMAT_BACKGROUND_COLOR = 'backgroundColor';
const DOMAIN_FIRST_FILTER_TYPE = 'firstFilterType';
const DOMAIN_FIRST_FILTER_VALUE = 'firstFilterValue';
const DOMAIN_SECOND_FILTER_TYPE = 'secondFilterType';
const DOMAIN_SECOND_FILTER_VALUE = 'secondFilterValue';
const DOMAIN_FILTER_HASANYVALUE = 'HAS_ANY_VALUE';
const DOMAIN_FIELD_NOT_LOCKED = 'NotLocked'; // not locked, can change all properties
const DOMAIN_FIELD_PARTIALLY_LOCKED = 'PartiallyLocked'; // can't change name and type, for example, but can change other properties
const DOMAIN_FIELD_FULLY_LOCKED = 'FullyLocked'; // can't change any properties
const DOMAIN_FIELD_PRIMARY_KEY_LOCKED = 'PKLocked'; // can't change data type or required properties

const constants_SEVERITY_LEVEL_ERROR = 'Error';
const constants_SEVERITY_LEVEL_WARN = 'Warning';

// Default scale types
const DEFAULT_SCALE_LINEAR = 'LINEAR';
const DEFAULT_SCALE_LOG = 'LOG';

// Default scale types
const FILE_DISPLAY_INLINE = 'inline';
const FILE_DISPLAY_ATTACHMENT = 'attachment';

// URIs for data types
const STRING_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#string';
const MULTILINE_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#multiLine';
const BOOLEAN_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#boolean';
const INT_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#int';
const DOUBLE_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#double';
const DATETIME_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#dateTime';
const FILELINK_RANGE_URI = 'http://cpas.fhcrc.org/exp/xml#fileLink';
const ATTACHMENT_RANGE_URI = 'http://www.labkey.org/exp/xml#attachment';
const USER_RANGE_URI = 'http://www.labkey.org/exp/xml#int';
const BINARY_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#binary';
const DATE_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#date';
const DECIMAL_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#decimal';
const FLOAT_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#float';
const LONG_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#long';
const TIME_RANGE_URI = 'http://www.w3.org/2001/XMLSchema#time';
const RANGE_URIS = {
  STRING: STRING_RANGE_URI,
  MULTILINE: MULTILINE_RANGE_URI,
  BOOLEAN: BOOLEAN_RANGE_URI,
  INT: INT_RANGE_URI,
  DOUBLE: DOUBLE_RANGE_URI,
  DATETIME: DATETIME_RANGE_URI,
  FILELINK: FILELINK_RANGE_URI,
  ATTACHMENT: ATTACHMENT_RANGE_URI,
  USER: USER_RANGE_URI,
  DATE: DATE_RANGE_URI,
  TIME: TIME_RANGE_URI
};
const STRING_CONVERT_URIS = [STRING_RANGE_URI, MULTILINE_RANGE_URI];
const NUMBER_CONVERT_URIS = [DOUBLE_RANGE_URI, FLOAT_RANGE_URI, DECIMAL_RANGE_URI];
const FILE_CONVERT_URIS = [FILELINK_RANGE_URI, ATTACHMENT_RANGE_URI];
const DATETIME_CONVERT_URIS = [DATE_RANGE_URI, TIME_RANGE_URI, DATETIME_RANGE_URI];
const FLAG_CONCEPT_URI = 'http://www.labkey.org/exp/xml#flag';
const PARTICIPANTID_CONCEPT_URI = 'http://cpas.labkey.com/Study#ParticipantId';
const VISITID_CONCEPT_URI = 'http://cpas.labkey.com/Study#VisitId';
const SAMPLE_TYPE_CONCEPT_URI = 'http://www.labkey.org/exp/xml#sample';
const CONCEPT_CODE_CONCEPT_URI = 'http://www.labkey.org/types#conceptCode';
const STORAGE_UNIQUE_ID_CONCEPT_URI = 'http://www.labkey.org/types#storageUniqueId';
const TEXT_CHOICE_CONCEPT_URI = 'http://www.labkey.org/types#textChoice';
const CREATED_TIMESTAMP_CONCEPT_URI = 'http://www.labkey.org/types#createdTimestamp';
const MODIFIED_TIMESTAMP_CONCEPT_URI = 'http://www.labkey.org/types#modifiedTimestamp';
const SMILES_CONCEPT_URI = 'http://www.labkey.org/exp/xml#smiles';
const AUTO_INT_CONCEPT_URI = 'http://www.labkey.org/types#autoInt';
const CALCULATED_CONCEPT_URI = 'http://www.labkey.org/exp/xml#calculated';
const UNLIMITED_TEXT_LENGTH = 2147483647; // Integer.MAX_VALUE
const MAX_TEXT_LENGTH = 4000;
const PHILEVEL_NOT_PHI = 'NotPHI';
const PHILEVEL_LIMITED_PHI = 'Limited';
const PHILEVEL_FULL_PHI = 'PHI';
const PHILEVEL_RESTRICTED_PHI = 'Restricted';
const ALL_SAMPLES_DISPLAY_TEXT = 'All Samples';
const DOMAIN_PHI_LEVELS = (0,external_immutable_.List)([{
  label: 'Not PHI',
  value: PHILEVEL_NOT_PHI
}, {
  label: 'Limited PHI',
  value: PHILEVEL_LIMITED_PHI
}, {
  label: 'Full PHI',
  value: PHILEVEL_FULL_PHI
}, {
  label: 'Restricted PHI',
  value: PHILEVEL_RESTRICTED_PHI
}]);
const DOMAIN_EDITABLE_DEFAULT = 'FIXED_EDITABLE';
const DOMAIN_NON_EDITABLE_DEFAULT = 'FIXED_NON_EDITABLE';
const DOMAIN_LAST_ENTERED_DEFAULT = 'LAST_ENTERED';
const DOMAIN_DEFAULT_TYPES = {
  [DOMAIN_EDITABLE_DEFAULT]: 'Editable default',
  [DOMAIN_NON_EDITABLE_DEFAULT]: 'Fixed value',
  [DOMAIN_LAST_ENTERED_DEFAULT]: 'Last entered'
};
const FIELD_NAME_CHAR_WARNING_MSG = 'Field name contains special characters.';
const FIELD_NAME_CHAR_WARNING_INFO = 'SQL queries, R scripts, and other code are easiest to write when field ' + 'names contain only a combination of letters, numbers, and underscores, and start with a letter or underscore. ' + 'Exporting fields that abide by this format are also easier to work with in analysis applications such as SAS, ' + 'SPSS, and MATLAB.';
const FIELD_EMPTY_TEXT_CHOICE_WARNING_MSG = 'No text choice values defined.';
const TEXT_CHOICE_PHI_NOTE = 'Note: These text choice options are visible to all administrators, including those not granted any PHI reader role.';
const FIELD_EMPTY_TEXT_CHOICE_WARNING_INFO = 'This field is defined as a "Text Choice" field, but no values have been added. Expand the field and use the ' + '"Add Values" button to define the set of choices for this field.';
const PROPERTIES_PANEL_ERROR_MSG = 'Contains errors or is missing required values.';
const PREFIX_SUBSTITUTION_EXPRESSION = '${folderPrefix}'; // Must match FOLDER_PREFIX_EXPRESSION in platform/.../NameExpressionOptionService.java
const PROPERTIES_PANEL_NAMING_PATTERN_WARNING_MSG = `Naming Pattern does not utilize the ID/Name prefix substitution token ${PREFIX_SUBSTITUTION_EXPRESSION}. The following prefix value will not be used`;
const DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS = {
  hideRequired: false,
  hideValidators: false,
  isDragDisabled: false,
  hideTextOptions: false,
  phiLevelDisabled: false,
  hideAddFieldsButton: false,
  disableMvEnabled: false,
  hideImportData: false,
  hideFilePropertyType: false,
  hideStudyPropertyTypes: false,
  hideImportExport: false,
  hideConditionalFormatting: false
};
const DERIVATION_DATA_SCOPES = {
  CHILD_ONLY: 'ChildOnly',
  PARENT_ONLY: 'ParentOnly',
  ALL: 'All'
};
const MAX_VALID_TEXT_CHOICES = 200;
const LOOKUP_VALIDATOR_VALUES = {
  type: 'Lookup',
  name: 'Lookup Validator'
};
const DOMAIN_ERROR_ID = 'domain-error';
;// CONCATENATED MODULE: ./src/public/QuerySort.ts
class QuerySort {
  constructor(props) {
    Object.assign(this, {
      dir: ''
    }, props);
  }
  toRequestString() {
    const {
      dir,
      fieldKey
    } = this;
    return dir === '-' ? '-' + fieldKey : fieldKey;
  }
}
;// CONCATENATED MODULE: ./src/internal/ViewInfo.ts
const _excluded = ["columns", "filter", "label", "name", "sort"],
  _excluded2 = ["columns", "filters", "isDefault", "sorts"];
function ViewInfo_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ViewInfo_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ViewInfo_ownKeys(Object(t), !0).forEach(function (r) { ViewInfo_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ViewInfo_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ViewInfo_defineProperty(e, r, t) { return (r = ViewInfo_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ViewInfo_toPropertyKey(t) { var i = ViewInfo_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ViewInfo_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function getFiltersFromView(filters) {
  if (filters) {
    return filters.map(filter => api_.Filter.create(filter.fieldKey, filter.value, api_.Filter.getFilterTypeForURLSuffix(filter.op)));
  }
  return [];
}
function getSortsFromView(sorts) {
  if (sorts) {
    return sorts.map(sort => new QuerySort(sort));
  }
  return [];
}
const VIEW_INFO_DEFAULTS = {
  columns: [],
  filters: [],
  hidden: false,
  inherit: false,
  isDefault: false,
  label: undefined,
  name: undefined,
  revertable: false,
  savable: false,
  saved: false,
  session: false,
  shared: false,
  sorts: []
};

// commented out attributes are not used in app
class ViewInfo {
  constructor(partial) {
    Object.assign(this, VIEW_INFO_DEFAULTS, partial);
  }
  static fromJson(json) {
    const {
        columns,
        filter,
        label,
        name,
        sort
      } = json,
      rest = _objectWithoutProperties(json, _excluded);
    const isDefault = rest.default === true;
    delete rest.default;
    const label_ = isDefault ? 'Default' : label;
    const name_ = isDefault || name === undefined || name === '' ? ViewInfo.DEFAULT_NAME : name;
    return new ViewInfo(ViewInfo_objectSpread({
      columns: columns !== undefined ? [...columns] : [],
      filters: getFiltersFromView(filter),
      isDefault,
      label: label_,
      name: name_,
      sorts: getSortsFromView(sort)
    }, rest));
  }
  static serialize(viewInfo) {
    const {
        columns,
        filters,
        isDefault,
        sorts
      } = viewInfo,
      rest = _objectWithoutProperties(viewInfo, _excluded2);
    const json = rest;
    json.columns = [...columns];
    json.default = isDefault;
    if (json.name === this.DEFAULT_NAME) {
      json.name = '';
    }
    json.filter = filters.map(filter => ({
      fieldKey: filter.getColumnName(),
      value: filter.getURLParameterValue(),
      op: filter.getFilterType().getURLSuffix()
    }));
    json.sort = sorts.map(sort => ({
      fieldKey: sort.fieldKey,
      dir: sort.dir
    }));
    return json;
  }
  get isVisible() {
    // Issue 42628: Hide Biologics details view override in view menu
    return !this.isDefault && !this.hidden && this.name.indexOf('~~') !== 0 && this.name !== ViewInfo.BIO_DETAIL_NAME;
  }
  get isSaved() {
    return this.saved === true;
  }
  get isSystemView() {
    const lcName = this.name?.toLowerCase();
    return lcName === ViewInfo.DEFAULT_NAME.toLowerCase() || lcName === ViewInfo.DETAIL_NAME.toLowerCase() || lcName === ViewInfo.UPDATE_NAME.toLowerCase();
  }
  get modifiers() {
    const modifiers = [];
    if (this.session) {
      modifiers.push('edited');
    } else {
      if (this.inherit) modifiers.push('inherited');
      if (this.shared) modifiers.push('shared');
    }
    return modifiers;
  }
  addSystemViewColumns(queryInfo) {
    if (this.isDefault && !this.session) {
      const columns = [...this.columns];
      const columnFieldKeys = columns.map(col => col.fieldKey.toLowerCase());
      const disabledSysFields = Array.from(queryInfo.disabledSystemFields ?? []).map(field => field.toLowerCase());
      queryInfo.columns.forEach(queryCol => {
        const fieldKey = queryCol.fieldKey?.toLowerCase();
        if (fieldKey && queryCol.addToSystemView && columnFieldKeys.indexOf(fieldKey) === -1 && disabledSysFields.indexOf(fieldKey) === -1) {
          columns.push({
            fieldKey: queryCol.fieldKey,
            key: queryCol.fieldKey,
            name: queryCol.name,
            title: queryCol.caption || queryCol.name
          });
        }
      });
      return this.mutate({
        columns
      });
    }
    return this;
  }
  mutate(updates) {
    return new ViewInfo(ViewInfo_objectSpread(ViewInfo_objectSpread({}, this), updates));
  }
}
// declare aggregates: any[];
// declare analyticsProviders: any[];
// declare deletable: boolean;
// declare editable: boolean;
// 'default' is a JavaScript keyword
ViewInfo_defineProperty(ViewInfo, "DEFAULT_NAME", '~~DEFAULT~~');
ViewInfo_defineProperty(ViewInfo, "DETAIL_NAME", '~~DETAILS~~');
ViewInfo_defineProperty(ViewInfo, "UPDATE_NAME", '~~UPDATE~~');
// TODO seems like this should not be in the generic model, but we'll need a good way
//  to define the override detail name.
ViewInfo_defineProperty(ViewInfo, "BIO_DETAIL_NAME", 'BiologicsDetails');
;// CONCATENATED MODULE: ./src/internal/schemas.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




// Created By / Modified By
const CBMB = (0,external_immutable_.List)(['Created', 'CreatedBy', 'Modified', 'ModifiedBy']);

// ASSAY
const ASSAY_SCHEMA = 'assay';
const ASSAY_TABLES = {
  ASSAY_LIST: new SchemaQuery(ASSAY_SCHEMA, 'AssayList'),
  ASSAY_DETAILS_SQ: new SchemaQuery(ASSAY_SCHEMA, 'AssayList', ViewInfo.DETAIL_NAME),
  RESULTS_QUERYNAME: 'Data',
  SCHEMA: ASSAY_SCHEMA
};

// EXP
const EXP_SCHEMA = 'exp';
const EXP_TABLES = {
  ASSAY_RUNS: new SchemaQuery(EXP_SCHEMA, 'AssayRuns'),
  DATA: new SchemaQuery(EXP_SCHEMA, 'Data'),
  DATA_CLASSES: new SchemaQuery(EXP_SCHEMA, 'DataClasses'),
  DATA_CLASS_CATEGORY_TYPE: new SchemaQuery(EXP_SCHEMA, 'DataClassCategoryType'),
  MATERIALS: new SchemaQuery(EXP_SCHEMA, 'Materials'),
  PROTOCOLS: new SchemaQuery(EXP_SCHEMA, 'Protocols'),
  SCHEMA: EXP_SCHEMA,
  SAMPLE_SETS: new SchemaQuery(EXP_SCHEMA, 'SampleSets'),
  SAMPLE_SETS_DETAILS: new SchemaQuery(EXP_SCHEMA, 'SampleSets', ViewInfo.DETAIL_NAME),
  SAMPLE_STATUS: new SchemaQuery(EXP_SCHEMA, 'SampleStatus')
};

// CORE
const CORE_SCHEMA = 'core';
const CORE_TABLES = {
  SCHEMA: CORE_SCHEMA,
  DATA_STATES: new SchemaQuery(CORE_SCHEMA, 'DataStates'),
  USERS: new SchemaQuery(CORE_SCHEMA, 'Users'),
  USER_API_KEYS: new SchemaQuery(CORE_SCHEMA, 'UserApiKeys')
};

// DATA CLASSES
const DATA_CLASS_SCHEMA = 'exp.data';
const DATA_CLASSES = {
  SCHEMA: DATA_CLASS_SCHEMA,
  CELL_LINE: new SchemaQuery(DATA_CLASS_SCHEMA, 'CellLine'),
  CONSTRUCT: new SchemaQuery(DATA_CLASS_SCHEMA, 'Construct'),
  EXPRESSION_SYSTEM: new SchemaQuery(DATA_CLASS_SCHEMA, 'ExpressionSystem'),
  MOLECULE: new SchemaQuery(DATA_CLASS_SCHEMA, 'Molecule'),
  MOLECULE_SET: new SchemaQuery(DATA_CLASS_SCHEMA, 'MoleculeSet'),
  MOLECULAR_SPECIES: new SchemaQuery(DATA_CLASS_SCHEMA, 'MolecularSpecies'),
  MOLECULAR_SPECIES_SEQ: new SchemaQuery(DATA_CLASS_SCHEMA, 'MolecularSpeciesSequence'),
  NUC_SEQUENCE: new SchemaQuery(DATA_CLASS_SCHEMA, 'NucSequence'),
  PROTEIN_SEQUENCE: new SchemaQuery(DATA_CLASS_SCHEMA, 'ProtSequence'),
  VECTOR: new SchemaQuery(DATA_CLASS_SCHEMA, 'Vector'),
  INGREDIENTS: new SchemaQuery(DATA_CLASS_SCHEMA, 'Ingredients'),
  MIXTURES: new SchemaQuery(DATA_CLASS_SCHEMA, 'Mixtures')
};

// INVENTORY
const INVENTORY_SCHEMA = 'inventory';
const INVENTORY = {
  SCHEMA: INVENTORY_SCHEMA,
  ITEMS: new SchemaQuery(INVENTORY_SCHEMA, 'Item'),
  ITEM_SAMPLES: new SchemaQuery(INVENTORY_SCHEMA, 'ItemSamples'),
  SAMPLE_ITEMS: new SchemaQuery(INVENTORY_SCHEMA, 'SampleItems'),
  CHECKED_OUT_BY_FIELD: 'checkedOutBy',
  INVENTORY_COLS: ['LabelColor', 'DisplayUnit', 'StorageStatus', 'StoredAmountDisplay', 'StorageLocation', 'StorageRow', 'StorageCol', 'FreezeThawCount', 'EnteredStorage', 'CheckedOut', 'CheckedOutBy', 'StorageComment']
};

// SAMPLE SETS
const SAMPLE_SET_SCHEMA = 'samples';
const SAMPLE_SETS = {
  SCHEMA: SAMPLE_SET_SCHEMA,
  EXPRESSION_SYSTEM: new SchemaQuery(SAMPLE_SET_SCHEMA, 'ExpressionSystemSamples'),
  MIXTURE_BATCHES: new SchemaQuery(SAMPLE_SET_SCHEMA, 'MixtureBatches'),
  RAW_MATERIALS: new SchemaQuery(SAMPLE_SET_SCHEMA, 'RawMaterials'),
  SAMPLES: new SchemaQuery(SAMPLE_SET_SCHEMA, 'Samples')
};

// SAMPLE MANAGEMENT
const SAMPLE_MANAGEMENT_SCHEMA = 'samplemanagement';
const SAMPLE_MANAGEMENT = {
  SCHEMA: SAMPLE_MANAGEMENT_SCHEMA,
  SAMPLE_TYPE_INSIGHTS: new SchemaQuery(SAMPLE_MANAGEMENT_SCHEMA, 'SampleTypeInsights'),
  SAMPLE_STATUS_COUNTS: new SchemaQuery(SAMPLE_MANAGEMENT_SCHEMA, 'SampleStatusCounts'),
  SOURCE_SAMPLES: new SchemaQuery(SAMPLE_MANAGEMENT_SCHEMA, 'SourceSamples'),
  INPUT_SAMPLES_SQ: new SchemaQuery(SAMPLE_MANAGEMENT_SCHEMA, 'InputSamples'),
  JOBS: new SchemaQuery(SAMPLE_MANAGEMENT_SCHEMA, 'Jobs')
};

// STUDY
const STUDY_SCHEMA = 'study';
const STUDY_TABLES = {
  SCHEMA: STUDY_SCHEMA,
  COHORT: new SchemaQuery(STUDY_SCHEMA, 'Cohort')
};

// LIST
const LIST_METADATA_SCHEMA = 'ListManager';
const LIST_METADATA_TABLES = {
  SCHEMA: LIST_METADATA_SCHEMA,
  LIST_MANAGER: new SchemaQuery(LIST_METADATA_SCHEMA, 'ListManager'),
  PICKLISTS: new SchemaQuery(LIST_METADATA_SCHEMA, 'Picklists')
};
const PICKLIST_SCHEMA = 'lists';
const PICKLIST_TABLES = {
  SCHEMA: PICKLIST_SCHEMA
};
const AUDIT_SCHEMA = 'auditlog';
const AUDIT_TABLES = {
  SCHEMA: AUDIT_SCHEMA
};
const PLATE_SCHEMA = 'plate';
const PLATE_TABLES = {
  HIT_SELECTION_SUMMARY: new SchemaQuery(PLATE_SCHEMA, 'HitSelectionSummary'),
  PLATE: new SchemaQuery(PLATE_SCHEMA, 'Plate'),
  PLATE_SET: new SchemaQuery(PLATE_SCHEMA, 'PlateSet'),
  PLATE_SOURCE: new SchemaQuery(PLATE_SCHEMA, 'PlateSource'),
  PLATE_TYPE: new SchemaQuery(PLATE_SCHEMA, 'PlateType'),
  PRIMARY_HIT_SELECTION_SUMMARY: new SchemaQuery(PLATE_SCHEMA, 'PrimaryHitSelectionSummary'),
  SAMPLES_IN_PLATE_SETS: new SchemaQuery(PLATE_SCHEMA, 'SamplesInPlateSets'),
  SCHEMA: PLATE_SCHEMA,
  WELL: new SchemaQuery(PLATE_SCHEMA, 'Well'),
  WELL_GROUP: new SchemaQuery(PLATE_SCHEMA, 'WellGroup')
};
const SCHEMAS = {
  ASSAY_TABLES,
  AUDIT_TABLES,
  EXP_TABLES,
  CORE_TABLES,
  SAMPLE_SETS,
  DATA_CLASSES,
  CBMB,
  STUDY_TABLES,
  INVENTORY,
  LIST_METADATA_TABLES,
  PICKLIST_TABLES,
  PLATE_TABLES,
  SAMPLE_MANAGEMENT
};
;// CONCATENATED MODULE: ./src/internal/components/navigation/constants.ts
const SEARCH_PLACEHOLDER = 'Search for samples, assays, ...';
const SAMPLE_MANAGER_SEARCH_PLACEHOLDER = 'Search for samples, sources, ...';
const HOME_PATH = '/home';
const HOME_TITLE = 'Home Project';
;// CONCATENATED MODULE: ./src/internal/components/assay/constants.ts

const GENERAL_ASSAY_PROVIDER_NAME = 'General';
const PLATE_TEMPLATE_COLUMN = 'PlateTemplate';
const PLATE_SET_COLUMN = 'PlateSet';

// Columns are required for us to render the WorkflowTask in EditableDetails components
const WORKFLOW_TASK_PROPERTIES_REQUIRED_COLUMNS = ['WorkflowTask', 'WorkflowTask/Run', 'Protocol/RowId'];
const RUN_PROPERTIES_REQUIRED_COLUMNS = SCHEMAS.CBMB.concat('Name', 'RowId', 'ReplacesRun', 'ReplacedByRun', 'DataOutputs', 'DataOutputs/DataFileUrl', 'Batch', 'Folder').concat(WORKFLOW_TASK_PROPERTIES_REQUIRED_COLUMNS).toList();
;// CONCATENATED MODULE: ./src/internal/app/constants.ts
/*
 * Copyright (c) 2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */




// These ids should match what is used by the MenuProviders in the Java code so we can avoid toLowerCase comparisons.
const LKS_PRODUCT_ID = 'LabKeyServer';
const BIOLOGICS_PRODUCT_ID = 'Biologics';
const SAMPLE_MANAGER_PRODUCT_ID = 'SampleManager';
const FREEZER_MANAGER_PRODUCT_ID = 'FreezerManager';
const SAMPLE_MANAGER_PRODUCT_NAME = 'Sample Manager';
const BIOLOGICS_PRODUCT_NAME = 'Biologics';
const LABKEY_SERVER_PRODUCT_NAME = 'LabKey Server';
const FREEZER_MANAGER_PRODUCT_NAME = 'Freezer Manager';
const BIOLOGICS_CONTROLLER_NAME = 'biologics';
const SAMPLE_MANAGER_CONTROLLER_NAME = 'sampleManager';
const FREEZER_MANAGER_CONTROLLER_NAME = 'freezerManager';
const ASSAYS_KEY = 'assays';
const ASSAY_DESIGN_KEY = 'assayDesign';
const AUDIT_KEY = 'audit';
const SAMPLES_KEY = 'samples';
const SAMPLE_TYPE_KEY = 'sampleType';
const SEARCH_KEY = 'search';
const SOURCES_KEY = 'sources';
const DATA_CLASS_KEY = 'dataclass';
const SOURCE_TYPE_KEY = 'sourceType';
const WORKFLOW_KEY = 'workflow';
const FREEZERS_KEY = 'freezers';
const BOXES_KEY = 'boxes';
const HOME_KEY = 'home';
const USER_KEY = 'user';
const PLATES_KEY = 'plates';
const PICKLIST_KEY = 'picklist';
const FIND_SAMPLES_BY_ID_KEY = 'samplesById';
const FIND_SAMPLES_BY_FILTER_KEY = 'samplesByFilter';
const REQUESTS_KEY = 'requests';
const MEDIA_KEY = 'media';
const NOTEBOOKS_KEY = 'notebooks';
const REGISTRY_KEY = 'registry';
const ELN_KEY = 'notebooks';
const CROSS_TYPE_KEY = 'crossType';
const MINE_KEY = 'mine';
const TEAM_KEY = 'team';
let EntityCreationMode = /*#__PURE__*/function (EntityCreationMode) {
  EntityCreationMode["FILE_IMPORT"] = "fileimport";
  EntityCreationMode["FILE_UPDATE"] = "update";
  EntityCreationMode["GRID_INSERT"] = "gridinsert";
  return EntityCreationMode;
}({});
const FIND_SAMPLES_BY_ID_HREF = AppURL.create(SEARCH_KEY, FIND_SAMPLES_BY_ID_KEY);
const FIND_SAMPLES_BY_FILTER_HREF = AppURL.create(SEARCH_KEY, FIND_SAMPLES_BY_FILTER_KEY);
const FILE_IMPORT_SAMPLES_HREF = AppURL.create(SAMPLES_KEY, 'new').addParam('mode', EntityCreationMode.FILE_IMPORT);
const GRID_INSERT_SAMPLES_HREF = AppURL.create(SAMPLES_KEY, 'new').addParam('mode', EntityCreationMode.GRID_INSERT);
const FILE_UPDATE_SAMPLES_HREF = AppURL.create(SAMPLES_KEY, 'new').addParam('mode', EntityCreationMode.FILE_UPDATE);
const NEW_SOURCE_TYPE_HREF = AppURL.create(SOURCE_TYPE_KEY, 'new');
const NEW_SAMPLE_TYPE_HREF = AppURL.create(SAMPLE_TYPE_KEY, 'new');
const NEW_STANDARD_ASSAY_DESIGN_HREF = AppURL.create(ASSAY_DESIGN_KEY, GENERAL_ASSAY_PROVIDER_NAME);
const NEW_ASSAY_DESIGN_HREF = AppURL.create(ASSAY_DESIGN_KEY, 'new');
const WORKFLOW_HOME_HREF = AppURL.create(WORKFLOW_KEY).addParam('mine.sort', 'DueDate').addParam('active.sort', 'DueDate');
const PICKLIST_HOME_HREF = AppURL.create(PICKLIST_KEY);
const MY_PICKLISTS_HREF = AppURL.create(PICKLIST_KEY, MINE_KEY);
const TEAM_PICKLISTS_HREF = AppURL.create(PICKLIST_KEY, TEAM_KEY);
const USER_PERMISSIONS_REQUEST = '/app/USER_PERMISSIONS_REQUEST';
const USER_PERMISSIONS_SUCCESS = '/app/USER_PERMISSIONS_SUCCESS';
const UPDATE_USER = '/app/UPDATE_USER';
const UPDATE_USER_DISPLAY_NAME = '/app/UPDATE_USER_DISPLAY_NAME';
const MENU_LOADING_START = '/app/MENU_LOADING_START';
const MENU_LOADING_END = '/app/MENU_LOADING_END';
const MENU_LOADING_ERROR = '/app/MENU_LOADING_ERROR';
const MENU_INVALIDATE = '/app/MENU_INVALIDATE';
const MENU_RELOAD = '/app/MENU_RELOAD';
const SERVER_NOTIFICATIONS_LOADING_START = 'app/SERVER_NOTIFICATIONS_LOADING_START';
const SERVER_NOTIFICATIONS_LOADING_END = 'app/SERVER_NOTIFICATIONS_LOADING_END';
const SERVER_NOTIFICATIONS_LOADING_ERROR = 'app/SERVER_NOTIFICATIONS_LOADING_ERROR';
const SERVER_NOTIFICATIONS_INVALIDATE = '/app/SERVER_NOTIFICATIONS_INVALIDATE';
const NOTIFICATION_TIMEOUT = 500;
const SERVER_NOTIFICATION_MAX_ROWS = 8;
const EXPERIMENTAL_APP_PLATE_SUPPORT = 'experimental-app-plate-support';
const EXPERIMENTAL_PRODUCT_ALL_FOLDER_LOOKUPS = 'queryProductAllFolderLookups';
const EXPERIMENTAL_PRODUCT_PROJECT_DATA_LISTING_SCOPED = 'queryProductProjectDataListingScoped';
const EXPERIMENTAL_REQUESTS_MENU = 'experimental-biologics-requests-menu';
const EXPERIMENTAL_CHART_BUILDER = 'experimental-biologics-chart-builder';
const EXPERIMENTAL_SAMPLE_ALIQUOT_SELECTOR = 'experimental-sample-aliquot-selector';
const EXPERIMENTAL_CALCULATED_FIELDS = 'experimental-calculated-fields';
const PROJECT_DATA_TYPE_EXCLUSIONS = 'dataTypeExclusions';
const BASE_APP_HELP_LINK = 'https://www.labkey.org/SampleManagerHelp/wiki-page.view?name=';

// The enum values here should align with the ProductFeature.java enum values (some not currently used but included for completeness)
let ProductFeature = /*#__PURE__*/function (ProductFeature) {
  ProductFeature["ApiKeys"] = "ApiKeys";
  ProductFeature["Assay"] = "Assay";
  ProductFeature["AssayQC"] = "AssayQC";
  ProductFeature["CalculatedFields"] = "CalculatedFields";
  ProductFeature["DataChangeCommentRequirement"] = "DataChangeCommentRequirement";
  ProductFeature["ELN"] = "ELN";
  ProductFeature["FreezerManagement"] = "FreezerManagement";
  ProductFeature["Media"] = "Media";
  ProductFeature["Projects"] = "Projects";
  ProductFeature["SampleManagement"] = "SampleManagement";
  ProductFeature["Workflow"] = "Workflow";
  return ProductFeature;
}({});
const BIOLOGICS_APP_PROPERTIES = {
  productId: BIOLOGICS_PRODUCT_ID,
  name: BIOLOGICS_PRODUCT_NAME,
  logoWithTextImageUrl: imageURL('biologics/images', 'lk-bio-logo-text.svg'),
  logoBadgeImageUrl: imageURL('biologics/images', 'lk-bio-logo-badge.svg'),
  logoBadgeColorImageUrl: imageURL('biologics/images', 'lk-bio-logo-badge-color-light.svg'),
  controllerName: BIOLOGICS_CONTROLLER_NAME,
  moduleName: 'biologics',
  searchPlaceholder: SEARCH_PLACEHOLDER,
  dataClassUrlPart: REGISTRY_KEY,
  releaseNoteLink: 'bioReleaseNotes',
  baseProductHelpLinkPrefix: BASE_APP_HELP_LINK
};
const SAMPLE_MANAGER_APP_PROPERTIES = {
  productId: SAMPLE_MANAGER_PRODUCT_ID,
  name: SAMPLE_MANAGER_PRODUCT_NAME,
  logoWithTextImageUrl: imageURL('sampleManagement/images', 'LK-SampleManager-appmenu-WHITE.svg'),
  logoBadgeImageUrl: imageURL('sampleManagement/images', 'LK-SampleManager-Badge-WHITE.svg'),
  logoBadgeColorImageUrl: imageURL('sampleManagement/images', 'LK-SampleManager-Badge-COLOR-LIGHT.svg'),
  controllerName: SAMPLE_MANAGER_CONTROLLER_NAME,
  moduleName: 'sampleManagement',
  searchPlaceholder: SAMPLE_MANAGER_SEARCH_PLACEHOLDER,
  dataClassUrlPart: SOURCES_KEY,
  releaseNoteLink: 'releaseNotes'
};
const FREEZER_MANAGER_APP_PROPERTIES = {
  productId: FREEZER_MANAGER_PRODUCT_ID,
  name: FREEZER_MANAGER_PRODUCT_NAME,
  logoWithTextImageUrl: imageURL('_images', 'LK-noTAG-overcast.svg'),
  logoBadgeImageUrl: imageURL('_images', 'mobile-logo-overcast.svg'),
  logoBadgeColorImageUrl: imageURL('_images', 'mobile-logo-seattle.svg'),
  controllerName: FREEZER_MANAGER_CONTROLLER_NAME,
  moduleName: 'inventory',
  baseProductHelpLinkPrefix: BASE_APP_HELP_LINK
};
;// CONCATENATED MODULE: ./src/internal/components/navigation/model.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




class MenuSectionModel extends (0,external_immutable_.Record)({
  label: undefined,
  url: undefined,
  items: (0,external_immutable_.List)(),
  totalCount: 0,
  key: undefined,
  productId: undefined,
  sectionKey: undefined
}) {
  static create(rawData, currentProductId, containerPath) {
    if (rawData) {
      let items;
      if (rawData.items) {
        items = rawData.items.map(i => MenuItemModel.create(i, rawData.sectionKey, currentProductId, containerPath));
      }
      return new MenuSectionModel(Object.assign({}, rawData, {
        items: (0,external_immutable_.List)(items)
      }));
    }
    return new MenuSectionModel();
  }
  getVisibleItems() {
    return this.items.filter(item => !item.hidden).toArray();
  }
  hasVisibleItems() {
    return this.getVisibleItems().length > 0;
  }
}
class MenuItemModel extends (0,external_immutable_.Record)({
  id: undefined,
  key: undefined,
  label: undefined,
  url: undefined,
  hidden: false,
  orderNum: undefined,
  originalUrl: undefined,
  requiresLogin: false,
  hasActiveJob: false,
  fromSharedContainer: false
}) {
  static create(rawData, sectionKey, currentProductId, containerPath) {
    if (rawData) {
      const dataProductId = rawData.productId ? rawData.productId.toLowerCase() : undefined;
      if (rawData.key && sectionKey !== 'user') {
        // for assay names and freezer names that contain slashes, full raw key (protocol/assayname: general/a/b) is encoded using QueryKey.encodePart as general/a$Sb on server side
        // use QueryKey.decodePart to decode the name so url can be correctly called by encodeURIComponent and key be used to display decoded assay name
        const subParts = rawData.key.split('/').filter(val => val !== '').map(api_.QueryKey.decodePart);
        if (sectionKey === ASSAYS_KEY && subParts.length > 0) {
          // Issue 50640. We want to link to 'runs' since we'll get better subnav highlighting
          subParts.push('runs');
        }
        const decoded = subParts.join('/');
        const decodedKey = rawData.key.replace(rawData.key, () => decoded); // use the functional version to skip any additional pattern substitutions https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_string_as_the_replacement

        return new MenuItemModel(Object.assign({}, rawData, {
          originalUrl: rawData.url,
          url: createProductUrlFromPartsWithContainer(dataProductId, currentProductId, containerPath, undefined, sectionKey, ...subParts),
          key: decodedKey
        }));
      } else {
        return new MenuItemModel(Object.assign({}, rawData, {
          originalUrl: rawData.url,
          url: createProductUrl(dataProductId, currentProductId, rawData.url, containerPath)
        }));
      }
    }
    return new MenuItemModel();
  }
  getUrlString(useOriginalUrl) {
    if (useOriginalUrl && this.originalUrl) return this.originalUrl;
    return typeof this.url === 'string' ? this.url : this.url?.toHref();
  }
}
class ProductMenuModel extends (0,external_immutable_.Record)({
  isError: false,
  isLoaded: false,
  isLoading: false,
  sections: (0,external_immutable_.List)(),
  message: undefined,
  containerId: undefined,
  containerPath: undefined,
  currentProductId: undefined,
  productIds: undefined,
  needsReload: false
}) {
  // the current product's id
  // the list of all product ids to be included in the menu; leave undefined for all products in the container

  /**
   * Retrieve the product menu sections for this productId
   */
  getMenuSections() {
    return new Promise((resolve, reject) => {
      return api_.Ajax.request({
        url: buildURL('product', 'menuSections.api', undefined, {
          container: this.containerPath
        }),
        params: Object.assign({
          currentProductId: this.currentProductId,
          productIds: external_immutable_.List.isList(this.productIds) ? this.productIds.toArray().join(',') : this.productIds
        }),
        success: api_.Utils.getCallbackWrapper(response => {
          let sections = (0,external_immutable_.List)();
          if (response) {
            response.forEach(sectionData => {
              sections = sections.push(MenuSectionModel.create(sectionData, this.currentProductId, this.containerPath));
            });
          }
          resolve(sections);
        }),
        failure: api_.Utils.getCallbackWrapper(response => {
          console.error(response);
          reject(response);
        })
      });
    });
  }
  setLoadedSections(sections) {
    return this.merge({
      isLoaded: true,
      isLoading: false,
      needsReload: false,
      sections
    });
  }
  setError(message) {
    return this.merge({
      isLoaded: true,
      isLoading: false,
      needsReload: false,
      isError: true,
      message
    });
  }
  getSection(key) {
    return this.sections.find(section => section.key.toLowerCase() === key.toLowerCase());
  }
  hasSectionItems(key) {
    return this.isLoaded && this.getSection(key)?.totalCount > 0;
  }
  setNeedsReload() {
    return this.merge({
      needsReload: true
    });
  }
}
class MenuSectionConfig extends (0,external_immutable_.Record)({
  activeJobIconCls: 'fa-spinner fa-pulse',
  emptyText: undefined,
  filteredEmptyText: undefined,
  emptyAppURL: undefined,
  emptyURLText: 'Get started...',
  headerURLPart: undefined,
  headerText: undefined,
  iconCls: undefined,
  iconURL: undefined,
  showActiveJobIcon: true,
  staticContent: false,
  useOriginalURL: false
}) {}
;// CONCATENATED MODULE: ./src/internal/app/utils.ts
/*
 * Copyright (c) 2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */








// Type definition not provided for event codes so here we provide our own
// Source: https://www.iana.org/assignments/websocket/websocket.xml#close-code-number
let CloseEventCode = /*#__PURE__*/function (CloseEventCode) {
  CloseEventCode[CloseEventCode["NORMAL_CLOSURE"] = 1000] = "NORMAL_CLOSURE";
  CloseEventCode[CloseEventCode["GOING_AWAY"] = 1001] = "GOING_AWAY";
  CloseEventCode[CloseEventCode["PROTOCOL_ERROR"] = 1002] = "PROTOCOL_ERROR";
  CloseEventCode[CloseEventCode["UNSUPPORTED_DATA"] = 1003] = "UNSUPPORTED_DATA";
  CloseEventCode[CloseEventCode["RESERVED"] = 1004] = "RESERVED";
  CloseEventCode[CloseEventCode["NO_STATUS_RCVD"] = 1005] = "NO_STATUS_RCVD";
  CloseEventCode[CloseEventCode["ABNORMAL_CLOSURE"] = 1006] = "ABNORMAL_CLOSURE";
  CloseEventCode[CloseEventCode["INVALID_FRAME_PAYLOAD_DATA"] = 1007] = "INVALID_FRAME_PAYLOAD_DATA";
  CloseEventCode[CloseEventCode["POLICY_VIOLATION"] = 1008] = "POLICY_VIOLATION";
  CloseEventCode[CloseEventCode["MESSAGE_TOO_BIG"] = 1009] = "MESSAGE_TOO_BIG";
  CloseEventCode[CloseEventCode["MISSING_EXT"] = 1010] = "MISSING_EXT";
  CloseEventCode[CloseEventCode["INTERNAL_ERROR"] = 1011] = "INTERNAL_ERROR";
  CloseEventCode[CloseEventCode["SERVICE_RESTART"] = 1012] = "SERVICE_RESTART";
  CloseEventCode[CloseEventCode["TRY_AGAIN_LATER"] = 1013] = "TRY_AGAIN_LATER";
  CloseEventCode[CloseEventCode["BAD_GATEWAY"] = 1014] = "BAD_GATEWAY";
  CloseEventCode[CloseEventCode["TLS_HANDSHAKE"] = 1015] = "TLS_HANDSHAKE";
  return CloseEventCode;
}({});
function resolveModuleContext(moduleContext) {
  return moduleContext ?? (0,api_.getServerContext)().moduleContext;
}
function userCanReadAssays(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.ReadAssay]);
}
function userCanReadSources(user) {
  return userCanReadDataClasses(user);
}
function userCanReadRegistry(user) {
  return userCanReadDataClasses(user);
}
function userCanReadDataClasses(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.ReadDataClass]);
}
function userCanReadMedia(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.ReadMedia]);
}
function userCanReadNotebooks(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.ReadNotebooks]);
}
function userCanManagePicklists(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.ManagePicklists]);
}
function userCanDeletePublicPicklists(user) {
  return user.isAdmin;
}
function userCanManageSampleWorkflow(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.ManageSampleWorkflows], false);
}
function userCanDesignSourceTypes(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.DesignDataClass]);
}
function userCanDesignLocations(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.DesignStorage], false);
}
function userCanEditStorageData(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.EditStorageData], false);
}
function userCanReadUserDetails(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.CanSeeUserDetails], false);
}
function userCanReadGroupDetails(user) {
  return hasAllPermissions(user, [api_.PermissionTypes.CanSeeGroupDetails], false);
}
function userCanEditSharedViews(user) {
  return hasPermissions(user, [api_.PermissionTypes.EditSharedView]);
}
function isFreezerManagementEnabled(moduleContext) {
  return resolveModuleContext(moduleContext)?.inventory !== undefined;
}
function isOntologyEnabled(moduleContext) {
  return hasModule('Ontology', moduleContext);
}
function isProductNavigationEnabled(productId, moduleContext) {
  if (productId === SAMPLE_MANAGER_APP_PROPERTIES.productId) {
    return isSampleManagerEnabled(moduleContext) && !isBiologicsEnabled(moduleContext);
  } else if (productId === BIOLOGICS_APP_PROPERTIES.productId) {
    return isBiologicsEnabled(moduleContext);
  }
  return false;
}
function isProductProjectsEnabled(moduleContext) {
  return resolveModuleContext(moduleContext)?.query?.isProductProjectsEnabled === true;
}
function hasProductProjects(moduleContext) {
  return resolveModuleContext(moduleContext)?.query?.hasProductProjects === true;
}
function setProductProjects(moduleContext, hasProductProjects) {
  // side-effect set global moduleContext
  if (LABKEY?.moduleContext?.query) {
    LABKEY.moduleContext.query.hasProductProjects = hasProductProjects;
  }
  return Object.assign(moduleContext ?? {}, {
    query: Object.assign(moduleContext?.query ?? {}, {
      hasProductProjects
    })
  });
}
function isSampleManagerEnabled(moduleContext) {
  return resolveModuleContext(moduleContext)?.samplemanagement !== undefined;
}
function isBiologicsEnabled(moduleContext) {
  return resolveModuleContext(moduleContext)?.biologics !== undefined;
}
function isPremiumProductEnabled(moduleContext) {
  return isSampleManagerEnabled(moduleContext) || isBiologicsEnabled(moduleContext);
}
function isAppHomeFolder(container, moduleContext) {
  // If it's a Home project, or if it's a subfolder and products are disabled.
  const currentContainer = container ?? (0,api_.getServerContext)().container;
  const isTopFolder = currentContainer.isProject || isProjectContainer(currentContainer.path);
  const isSubFolder = currentContainer.isFolder || isSubFolderContainer(currentContainer.path);
  return isTopFolder || isSubFolder && !isProductProjectsEnabled(moduleContext);
}
function getAppHomeFolderPath(container, moduleContext) {
  const currentContainer = container ?? (0,api_.getServerContext)().container;
  return isAppHomeFolder(currentContainer, moduleContext) ? currentContainer.path : currentContainer.parentPath;
}
function getAppHomeFolderId(container, moduleContext) {
  const currentContainer = container ?? (0,api_.getServerContext)().container;
  return isAppHomeFolder(currentContainer, moduleContext) ? currentContainer.id : currentContainer.parentId;
}

// either defined in a different container or it's defined in the home container and product projects are available.
function isSharedDefinition(currentContainer, moduleContext, domainContainerPathOrId, isId) {
  if (isId && domainContainerPathOrId !== currentContainer.id || !isId && domainContainerPathOrId !== currentContainer.path) {
    return true;
  }
  if (!hasProductProjects(moduleContext)) {
    return false;
  }
  if (isId && getAppHomeFolderId(currentContainer, moduleContext) === domainContainerPathOrId) {
    return true;
  }
  return !isId && getAppHomeFolderPath(currentContainer, moduleContext) === domainContainerPathOrId;
}
function sampleManagerIsPrimaryApp(moduleContext) {
  return getPrimaryAppProperties(moduleContext)?.productId === SAMPLE_MANAGER_APP_PROPERTIES.productId;
}
function biologicsIsPrimaryApp(moduleContext) {
  return getPrimaryAppProperties(moduleContext)?.productId === BIOLOGICS_APP_PROPERTIES.productId;
}
function freezerManagerIsCurrentApp() {
  return getCurrentAppProperties()?.productId === FREEZER_MANAGER_APP_PROPERTIES.productId;
}
function isSampleStatusEnabled(moduleContext) {
  return hasModule('SampleManagement', moduleContext);
}
function getCurrentAppProperties() {
  const lcController = api_.ActionURL.getController().toLowerCase();
  if (!lcController) return undefined;
  if (lcController === SAMPLE_MANAGER_APP_PROPERTIES.controllerName.toLowerCase()) {
    return SAMPLE_MANAGER_APP_PROPERTIES;
  } else if (lcController === BIOLOGICS_APP_PROPERTIES.controllerName.toLowerCase()) {
    return BIOLOGICS_APP_PROPERTIES;
  } else if (lcController === FREEZER_MANAGER_APP_PROPERTIES.controllerName.toLowerCase()) {
    return FREEZER_MANAGER_APP_PROPERTIES;
  }
  return undefined;
}
function isApp() {
  return getCurrentAppProperties() !== undefined;
}

/**
 * In LKS we use the 'primary' bootstrap class for submit buttons, but in our apps we use 'success', this helper method
 * returns the correct class for you.
 */
function getSubmitButtonClass() {
  return isApp() ? 'success' : 'primary';
}
function getPrimaryAppProperties(moduleContext) {
  // Issue 47390: when URL is in the LKB or LKSM controller, then that should be considered the primary app
  //              it is the LKFM app case when we want to determine the primary app based on enabled modules
  const currentAppProperties = getCurrentAppProperties();
  if (currentAppProperties?.productId === BIOLOGICS_APP_PROPERTIES.productId || currentAppProperties?.productId === SAMPLE_MANAGER_APP_PROPERTIES.productId) {
    return currentAppProperties;
  }
  if (isBiologicsEnabled(moduleContext)) {
    return BIOLOGICS_APP_PROPERTIES;
  } else if (isSampleManagerEnabled(moduleContext)) {
    return SAMPLE_MANAGER_APP_PROPERTIES;
  } else if (isFreezerManagementEnabled(moduleContext)) {
    return FREEZER_MANAGER_APP_PROPERTIES;
  } else {
    return undefined;
  }
}
function isAllProductFoldersFilteringEnabled(moduleContext) {
  return resolveModuleContext(moduleContext)?.query?.[EXPERIMENTAL_PRODUCT_ALL_FOLDER_LOOKUPS] === true;
}
function isProductProjectsDataListingScopedToProject(moduleContext) {
  return resolveModuleContext(moduleContext)?.query?.[EXPERIMENTAL_PRODUCT_PROJECT_DATA_LISTING_SCOPED] === true;
}
function getProjectDataExclusion(moduleContext) {
  return resolveModuleContext(moduleContext)?.samplemanagement?.[PROJECT_DATA_TYPE_EXCLUSIONS];
}
function getProjectDashboardSampleTypeExclusion(moduleContext) {
  return getProjectDataExclusion(moduleContext)?.['DashboardSampleType'];
}
function getProjectSampleTypeExclusion(moduleContext) {
  return getProjectDataExclusion(moduleContext)?.['SampleType'];
}
function getProjectDataClassExclusion(moduleContext) {
  return getProjectDataExclusion(moduleContext)?.['DataClass'];
}
function getProjectAssayDesignExclusion(moduleContext) {
  return getProjectDataExclusion(moduleContext)?.['AssayDesign'];
}
function isAssayEnabled(moduleContext) {
  return hasModule('assay', moduleContext) && (isCommunityDistribution(moduleContext) || isFeatureEnabled(ProductFeature.Assay, moduleContext));
}
function isAssayQCEnabled(moduleContext) {
  // NK: The product tiers which include Assay QC are not fully defined.
  // For now (v22.11+), we're going to continue offering Assay QC features until
  // we can fully define all desired product tiers. Once that is done we can respect
  // the associated feature flag instead.
  // isFeatureEnabled(ProductFeature.AssayQC, moduleContext)
  return isAssayEnabled(moduleContext) && hasPremiumModule(moduleContext);
}
function isAssayRequestsEnabled(moduleContext) {
  return hasModule('assayRequest', moduleContext) && resolveModuleContext(moduleContext)?.biologics?.[EXPERIMENTAL_REQUESTS_MENU] === true;
}

// Don't enable assay design export unless there is an import capability (which we don't have for LKSM products)
function isAssayDesignExportEnabled(moduleContext) {
  return hasPremiumModule(moduleContext);
}
function isPlatesEnabled(moduleContext) {
  return biologicsIsPrimaryApp(moduleContext) && resolveModuleContext(moduleContext)?.biologics?.[EXPERIMENTAL_APP_PLATE_SUPPORT] === true;
}
function isChartBuilderEnabled(moduleContext) {
  return isLIMSEnabled(moduleContext) && resolveModuleContext(moduleContext)?.biologics?.[EXPERIMENTAL_CHART_BUILDER] === true;
}
function isRReportsEnabled(moduleContext) {
  return biologicsIsPrimaryApp(moduleContext);
}
function isLIMSEnabled(moduleContext) {
  return biologicsIsPrimaryApp(moduleContext);
}
function isELNEnabled(moduleContext) {
  return hasModule('LabBook', moduleContext) && isFeatureEnabled(ProductFeature.ELN, moduleContext);
}
function isProtectedDataEnabled(moduleContext) {
  return hasModule('compliance', moduleContext) && hasModule('complianceActivities', moduleContext);
}
function isMediaEnabled(moduleContext) {
  return isFeatureEnabled(ProductFeature.Media, moduleContext);
}
function isWorkflowEnabled(moduleContext) {
  return hasModule(SAMPLE_MANAGER_APP_PROPERTIES.moduleName, moduleContext) && isFeatureEnabled(ProductFeature.Workflow, moduleContext);
}
function isDataChangeCommentRequirementFeatureEnabled(moduleContext) {
  return isFeatureEnabled(ProductFeature.DataChangeCommentRequirement, moduleContext);
}
function isCalculatedFieldsEnabled(moduleContext) {
  if (resolveModuleContext(moduleContext)?.core?.[EXPERIMENTAL_CALCULATED_FIELDS] !== true) {
    return false;
  }
  return isApp() ? isFeatureEnabled(ProductFeature.CalculatedFields, moduleContext) : !isCommunityDistribution(moduleContext);
}
function isFeatureEnabled(flag, moduleContext) {
  return resolveModuleContext(moduleContext)?.core?.productFeatures?.indexOf(flag) >= 0;
}
function isSampleAliquotSelectorEnabled(moduleContext) {
  return resolveModuleContext(moduleContext)?.samplemanagement?.[EXPERIMENTAL_SAMPLE_ALIQUOT_SELECTOR] === true;
}
function hasModule(moduleName, moduleContext) {
  return resolveModuleContext(moduleContext).api?.moduleNames?.indexOf(moduleName.toLowerCase()) >= 0;
}
function hasPremiumModule(moduleContext) {
  return hasModule('Premium', moduleContext);
}
function isCommunityDistribution(moduleContext) {
  return !hasModule('SampleManagement', moduleContext) && !hasPremiumModule(moduleContext);
}
function isRestrictedIssueListSupported(moduleContext) {
  return resolveModuleContext(moduleContext)?.issues?.hasRestrictedIssueList === true;
}
function isProjectContainer(containerPath) {
  return getContainerDepth(containerPath) === 1;
}
function isSubFolderContainer(containerPath) {
  return getContainerDepth(containerPath) > 1;
}
function getContainerDepth(containerPath) {
  let path = containerPath ?? (0,api_.getServerContext)().container.path;
  if (!path) return 0;
  if (!path.endsWith('/')) path = path + '/';
  return path.split('/').filter(p => !!p).length;
}
function getProjectPath(containerPath) {
  const path = containerPath ?? (0,api_.getServerContext)().container.path;
  if (!path) return undefined;
  return path.split('/').filter(p => !!p)[0] + '/';
}

// exported for testing
function getStorageSectionConfig(user, currentProductId, moduleContext) {
  if (isFreezerManagementEnabled(moduleContext)) {
    let locationsMenuConfig = new MenuSectionConfig({
      emptyText: 'No storage has been defined',
      filteredEmptyText: 'No storage available',
      iconURL: imageURL('_images', 'freezer_menu.svg'),
      headerURLPart: HOME_KEY
    });
    if (user && userCanDesignLocations(user)) {
      locationsMenuConfig = locationsMenuConfig.merge({
        emptyAppURL: AppURL.create(FREEZERS_KEY, 'new'),
        emptyURLText: 'Create storage'
      });
    }
    return locationsMenuConfig;
  }
  return undefined;
}

// exported for testing
function addSourcesSectionConfig(user, sectionConfigs) {
  let sourcesMenuConfig = new MenuSectionConfig({
    emptyText: 'No source types have been defined',
    filteredEmptyText: 'No source types available',
    iconURL: imageURL('_images', 'source_type.svg')
  });
  if (user && userCanDesignSourceTypes(user)) {
    sourcesMenuConfig = sourcesMenuConfig.merge({
      emptyAppURL: NEW_SOURCE_TYPE_HREF,
      emptyURLText: 'Create a source type'
    });
  }
  return sectionConfigs.push((0,external_immutable_.Map)({
    [SOURCES_KEY]: sourcesMenuConfig
  }));
}

// exported for testing
function getSamplesSectionConfig(user) {
  let samplesMenuConfig = new MenuSectionConfig({
    emptyText: 'No sample types have been defined',
    filteredEmptyText: 'No sample types available',
    iconURL: imageURL('_images', 'samples.svg')
  });
  if (user && user.hasDesignSampleTypesPermission()) {
    samplesMenuConfig = samplesMenuConfig.merge({
      emptyAppURL: NEW_SAMPLE_TYPE_HREF,
      emptyURLText: 'Create a sample type'
    });
  }
  return samplesMenuConfig;
}

// exported for testing
function addAssaysSectionConfig(user, sectionConfigs, standardAssayOnly) {
  let assaysMenuConfig = new MenuSectionConfig({
    emptyText: 'No assays have been defined',
    filteredEmptyText: 'No assays available',
    iconURL: imageURL('_images', 'assay.svg')
  });
  if (user && user.hasDesignAssaysPermission()) {
    assaysMenuConfig = assaysMenuConfig.merge({
      emptyAppURL: standardAssayOnly ? NEW_STANDARD_ASSAY_DESIGN_HREF : NEW_ASSAY_DESIGN_HREF,
      emptyURLText: 'Create an assay design'
    });
  }
  return sectionConfigs.push((0,external_immutable_.Map)().set(ASSAYS_KEY, assaysMenuConfig));
}
function getPlatesSectionConfig() {
  return new MenuSectionConfig({
    iconURL: imageURL('_images', 'plates.svg'),
    staticContent: true
  });
}
function getWorkflowSectionConfig() {
  return new MenuSectionConfig({
    iconURL: imageURL('_images', 'workflow.svg')
  });
}
function getPicklistsSectionConfig() {
  return new MenuSectionConfig({
    iconURL: imageURL('_images', 'picklist.svg')
  });
}
function getNotebooksSectionConfig() {
  return new MenuSectionConfig({
    iconURL: imageURL('labbook/images', 'notebook_blue.svg')
  });
}
function getMediaSectionConfig() {
  return new MenuSectionConfig({
    iconURL: imageURL('_images', 'mixtures.svg')
  });
}
function getRegistrySectionConfig() {
  return new MenuSectionConfig({
    iconURL: imageURL('_images', 'molecule.svg')
  });
}
const USER_SECTION_CONFIG = new MenuSectionConfig({
  iconCls: 'fas fa-user-circle '
});
const REQUESTS_SECTION_CONFIG = new MenuSectionConfig({
  useOriginalURL: true,
  iconURL: imageURL('_images', 'default.svg'),
  staticContent: true
});
function getBioWorkflowNotebookMediaConfigs() {
  return (0,external_immutable_.Map)({
    [WORKFLOW_KEY]: getWorkflowSectionConfig(),
    [MEDIA_KEY]: getMediaSectionConfig(),
    [PICKLIST_KEY]: getPicklistsSectionConfig(),
    [NOTEBOOKS_KEY]: getNotebooksSectionConfig()
  });
}

// exported for testing
function getMenuSectionConfigs(user, currentProductId, moduleContext) {
  let sectionConfigs = (0,external_immutable_.List)();
  const currentAppProperties = getCurrentAppProperties(); // based on the controller name
  const isSMPrimary = sampleManagerIsPrimaryApp(moduleContext);
  const isBioPrimary = biologicsIsPrimaryApp(moduleContext);
  const isBioOrSM = isSMPrimary || isBioPrimary;
  const inSMApp = isSMPrimary || currentAppProperties?.productId === SAMPLE_MANAGER_APP_PROPERTIES.productId;
  if (inSMApp) {
    sectionConfigs = addSourcesSectionConfig(user, sectionConfigs);
  } else if (isBioPrimary) {
    sectionConfigs = sectionConfigs.push((0,external_immutable_.Map)({
      [REGISTRY_KEY]: getRegistrySectionConfig()
    }));
  }
  if (isBioOrSM) {
    let configs = (0,external_immutable_.Map)({
      [SAMPLES_KEY]: getSamplesSectionConfig(user)
    });
    if (isPlatesEnabled(moduleContext)) {
      configs = configs.set(PLATES_KEY, getPlatesSectionConfig());
    }
    sectionConfigs = sectionConfigs.push(configs);
    if (isAssayEnabled(moduleContext)) {
      sectionConfigs = addAssaysSectionConfig(user, sectionConfigs, isSMPrimary);
    }
  }
  const storageConfig = getStorageSectionConfig(user, currentProductId, moduleContext);
  if (inSMApp) {
    if (storageConfig) {
      sectionConfigs = sectionConfigs.push((0,external_immutable_.Map)({
        [FREEZERS_KEY]: storageConfig
      }));
    }
    let configs = (0,external_immutable_.Map)({});
    if (isWorkflowEnabled(moduleContext)) {
      configs = configs.set(WORKFLOW_KEY, getWorkflowSectionConfig());
    }
    configs = configs.set(PICKLIST_KEY, getPicklistsSectionConfig());
    if (isELNEnabled(moduleContext)) {
      configs = configs.set(NOTEBOOKS_KEY, getNotebooksSectionConfig());
    }
    sectionConfigs = sectionConfigs.push(configs);
  } else if (isBioPrimary) {
    if (isAssayRequestsEnabled(moduleContext)) {
      // When "Requests" are enabled render as two columns
      let requestsCol = (0,external_immutable_.Map)({
        [REQUESTS_KEY]: REQUESTS_SECTION_CONFIG
      });
      // ... and put the storage in this same column
      if (storageConfig) {
        requestsCol = requestsCol.set(FREEZERS_KEY, storageConfig);
      }
      sectionConfigs = sectionConfigs.push(requestsCol, getBioWorkflowNotebookMediaConfigs());
    } else {
      if (storageConfig) {
        sectionConfigs = sectionConfigs.push((0,external_immutable_.Map)({
          [FREEZERS_KEY]: storageConfig
        }));
      }
      sectionConfigs = sectionConfigs.push(getBioWorkflowNotebookMediaConfigs());
    }
  } else {
    if (storageConfig) {
      sectionConfigs = sectionConfigs.push((0,external_immutable_.Map)({
        [FREEZERS_KEY]: storageConfig
      }));
    }
    sectionConfigs = sectionConfigs.push((0,external_immutable_.Map)({
      [USER_KEY]: USER_SECTION_CONFIG
    }));
  }
  return sectionConfigs;
}
const useMenuSectionConfigs = (user, appProperties, moduleContext) => {
  return (0,external_react_.useMemo)(() => getMenuSectionConfigs(user, appProperties.productId, moduleContext), [user, moduleContext, appProperties.productId]);
};

// Returns the friendly name of the product, primarily for use in help text.
function getCurrentProductName(moduleContext) {
  const lcController = api_.ActionURL.getController().toLowerCase();
  if (!lcController) return LABKEY_SERVER_PRODUCT_NAME;
  if (isPremiumProductEnabled(moduleContext)) {
    return getPrimaryAppProperties(moduleContext).name;
  }
  return LABKEY_SERVER_PRODUCT_NAME;
}
function getAppProductIds(appProductId) {
  let productIds = external_immutable_.List.of(appProductId);
  if (appProductId === SAMPLE_MANAGER_APP_PROPERTIES.productId || appProductId === BIOLOGICS_APP_PROPERTIES.productId) {
    productIds = productIds.push(FREEZER_MANAGER_APP_PROPERTIES.productId);
  }
  return productIds;
}
;// CONCATENATED MODULE: ./src/internal/util/utils.ts
function utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? utils_ownKeys(Object(t), !0).forEach(function (r) { utils_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function utils_defineProperty(e, r, t) { return (r = utils_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function utils_toPropertyKey(t) { var i = utils_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function utils_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




const emptyList = (0,external_immutable_.List)();

// Case-insensitive Object reference. Returns undefined if either object or prop does not resolve.
// If both casings exist (e.g. 'x' and 'X' are props) then either value may be returned.
function caseInsensitive(obj, prop) {
  if (obj === undefined || obj === null) {
    return undefined;
  }
  if (api_.Utils.isString(prop)) {
    const lower = prop.toLowerCase();
    for (const p in obj) {
      if (obj.hasOwnProperty(p) && p.toLowerCase() === lower) {
        return obj[p];
      }
    }
  }
  return undefined;
}

/**
 * Returns a case-insensitive intersection of two List<string>.
 * @param a
 * @param b
 */
function intersect(a, b) {
  if (!a || !b || a.size === 0 || b.size === 0) {
    return emptyList;
  }
  const sa = a.reduce(toLowerReducer, ImmutableSet().asMutable()).asImmutable();
  const sb = b.reduce(toLowerReducer, ImmutableSet().asMutable()).asImmutable();
  return sa.intersect(sb).toList();
}

/**
 * Returns a new string in which the first character of the given string is capitalized.  If
 * the value is, empty, undefined, or not a string returns the value.
 * @param value string to convert
 */
function capitalizeFirstChar(value) {
  if (value && typeof value === 'string' && value.length > 1) {
    return [value.substr(0, 1).toUpperCase(), value.substr(1)].join('');
  }
  return value;
}

/**
 * Returns a new string in which the first character of the given string is uncapitalized.  If
 * the value is, empty, undefined, or not a string returns the value.
 * @param value string to convert
 */
function uncapitalizeFirstChar(value) {
  if (value && typeof value === 'string' && value.length > 1) {
    return [value.substr(0, 1).toLowerCase(), value.substr(1)].join('');
  }
  return value;
}

/**
 * Util to format the keys in a record
 * Example: convert {capitalizedFirstKey: value} to {CapitalizedFirstKey: value} with capitalizeFirstChar fn
 * @param obj the original object to transform
 * @param keyTransformFn the transform function for keys
 */
function withTransformedKeys(obj, keyTransformFn) {
  if (obj === undefined || obj === null) {
    return obj;
  }
  const transformedObj = {};
  for (const rawKey in obj) {
    if (obj.hasOwnProperty(rawKey)) {
      const key = keyTransformFn(rawKey);
      transformedObj[key] = obj[rawKey];
    }
  }
  return transformedObj;
}

/**
 * Returns a copy of List<string> and ensures that in copy all values are lower case strings.
 * @param a
 */
function toLowerSafe(a) {
  if (a) {
    return a.filter(v => typeof v === 'string').map(v => v.toLowerCase());
  }
  return [];
}
function toLowerReducer(s, v) {
  if (typeof v === 'string') {
    s.add(v.toLowerCase());
  }
  return s;
}
function camelCaseToTitleCase(text) {
  const camelEdges = /([A-Z](?=[A-Z][a-z])|[^A-Z](?=[A-Z])|[a-zA-Z](?=[^a-zA-Z]))/g;
  const saferText = text.replace(camelEdges, '$1 ');
  return saferText.charAt(0).toUpperCase() + saferText.slice(1);
}
function not(predicate) {
  return function () {
    return !predicate.apply(this, arguments);
  };
}
function applyDevTools() {
  if (devToolsActive() && window['devToolsExtension']) {
    return window['devToolsExtension']();
  }
  return f => f;
}
const DEV_TOOLS_URL_PARAMETER = 'devTools';
function devToolsActive() {
  return (0,api_.getServerContext)().devMode === true && hasParameter(DEV_TOOLS_URL_PARAMETER);
}
function toggleDevTools() {
  if ((0,api_.getServerContext)().devMode) {
    toggleParameter(DEV_TOOLS_URL_PARAMETER, 1);
  }
}
let DOM_COUNT = 0;
const DOM_PREFIX = 'labkey-app-';

// Only exported to use with tests. Don't use this anywhere else. This is needed so we can use it in beforeEach for jest
// snapshot tests. This way a snapshot will be identical when run as part of a test suite or run individually.
function TESTS_ONLY_RESET_DOM_COUNT() {
  DOM_COUNT = 0;
}

// Generate an id with a dom-unique integer suffix
function generateId(prefix) {
  return (prefix ? prefix : DOM_PREFIX) + DOM_COUNT++;
}

// http://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = window.setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/**
 * Performs an equality check on two arrays, returning true of the arrays are the same size
 *
 * @param array1
 * @param array2
 */
function unorderedEqual(array1, array2) {
  if (array1.length !== array2.length) return false;
  const sortedA1 = array1.sort();
  const sortedA2 = array2.sort();
  for (let i = 0; i < sortedA1.length; i++) {
    if (sortedA1[i] !== sortedA2[i]) {
      return false;
    }
  }
  return true;
}

/**
 * Returns true if value is undefined, an empty string, or an empty array.  Otherwise returns false.
 * @param value
 */
function valueIsEmpty(value) {
  if (!value) return true;
  if (typeof value === 'string' && value === '') return true;
  return Array.isArray(value) && value.length === 0;
}

/**
 * Creates a JS Object, suitable for use as a fieldValues object for QueryInfoForm,
 * mapping between field keys and values that are shared by all ids for the given data.
 *
 * It is assumed that the set of fields in each row of data is the same, though some fields
 * may be empty or null.  If the field sets are different, the results returned will
 * be as if the values were present and the same as in one of the other rows.
 *
 * @param data Map between ids and a map of data for the ids (i.e, a row of data for that id)
 */
function getCommonDataValues(data) {
  let valueMap = (0,external_immutable_.Map)(); // map from fields to the value shared by all rows
  let fieldsInConflict = (0,external_immutable_.Set)();
  let emptyFields = (0,external_immutable_.Set)(); // those fields that are empty
  data.map((rowData, id) => {
    if (rowData) {
      rowData.forEach((data, key) => {
        if (!fieldsInConflict.has(key)) {
          // skip fields that are already in conflict
          let value = data;

          // Convert from immutable to regular JS
          if (external_immutable_.Iterable.isIterable(data)) {
            if (external_immutable_.List.isList(data)) {
              value = data.toJS();
            } else {
              value = data.get('value');
            }
          }
          const currentValueEmpty = valueIsEmpty(value);
          const havePreviousValue = valueMap.has(key);
          const arrayNotEqual = Array.isArray(value) && valueMap.get(key) && (!Array.isArray(valueMap.get(key)) || !unorderedEqual(valueMap.get(key), value));
          if (!currentValueEmpty) {
            // non-empty value, so let's see if we have the same value
            if (emptyFields.contains(key)) {
              fieldsInConflict = fieldsInConflict.add(key);
            } else if (!havePreviousValue) {
              valueMap = valueMap.set(key, value);
            }
            if (arrayNotEqual) {
              fieldsInConflict = fieldsInConflict.add(key);
              valueMap = valueMap.delete(key);
            } else if (valueMap.get(key) !== value) {
              fieldsInConflict = fieldsInConflict.add(key);
              valueMap = valueMap.delete(key);
            }
          } else if (havePreviousValue) {
            // some row had a value, but this row does not
            fieldsInConflict = fieldsInConflict.add(key);
            valueMap = valueMap.delete(key);
          } else {
            emptyFields = emptyFields.add(key);
          }
        }
      });
    } else {
      console.error('Unable to find data for selection id ' + id);
    }
  });
  return valueMap.toObject();
}
function isSameWithStringCompare(value1, value2) {
  if (value1 === value2 || valueIsEmpty(value1) && valueIsEmpty(value2)) return true;
  if (value1 && value2) {
    const strVal1 = value1.toString();
    const strVal2 = value2.toString();
    return strVal1 === strVal2;
  }
  return false; // one value is empty and the other is not.
}

/**
 * Constructs an array of objects (suitable for the rows parameter of updateRows) where each object contains the
 * values that are different from the ones in originalData object as well as the primary key values for that row.
 * If updatedValues is empty or all of the originalData values are the same as the updatedValues, returns an empty array.
 *
 * @param originalData a map from an id field to a Map from fieldKeys to an object with a 'value' field
 * @param updatedValues an object mapping fieldKeys to values that are being updated
 * @param primaryKeys the list of primary fieldKey names
 * @param additionalCols additional array of fieldKeys to include
 */
function getUpdatedData(originalData, updatedValues, primaryKeys, additionalCols) {
  const updateValuesMap = (0,external_immutable_.Map)(updatedValues);
  const pkColsLc = new Set();
  primaryKeys.forEach(key => pkColsLc.add(key.toLowerCase()));
  additionalCols?.forEach(col => pkColsLc.add(col.toLowerCase()));

  // if the originalData has the container/folder values, keep those as well (i.e. treat it as a primary key)
  const folderKey = originalData.first().keySeq().find(key => key.toLowerCase() === 'folder' || key.toLowerCase() === 'container');
  if (folderKey) pkColsLc.add(folderKey.toLowerCase());
  const updatedData = originalData.map(originalRowMap => {
    return originalRowMap.reduce((m, fieldValueMap, key) => {
      // Issue 42672: The original data has keys that are names or captions for the columns.  We need to use
      // the encoded key that will match what's expected for filtering on the server side (e.g., "U g$Sl" instead of "U g/l")
      const encodedKey = encodePart(key);
      if (fieldValueMap?.has('value')) {
        if (pkColsLc.has(key.toLowerCase())) {
          return m.set(key, fieldValueMap.get('value'));
        } else if (updateValuesMap.has(encodedKey) && !isSameWithStringCompare(updateValuesMap.get(encodedKey), fieldValueMap.get('value'))) {
          return m.set(key, updateValuesMap.get(encodedKey) == undefined ? null : updateValuesMap.get(encodedKey));
        } else {
          return m;
        }
      }
      // Handle multi-value select
      else if (external_immutable_.List.isList(fieldValueMap)) {
        let updatedVal = updateValuesMap.get(encodedKey);
        if (Array.isArray(updatedVal)) {
          updatedVal = updatedVal.map(val => {
            const match = fieldValueMap.find(original => original.get('value') === val);
            if (match !== undefined) {
              return match.get('displayValue');
            }
            return val;
          });
          return m.set(key, updatedVal);
        } else if (updateValuesMap.has(encodedKey) && updatedVal === undefined) {
          return m.set(key, []);
        } else return m;
      } else return m;
    }, (0,external_immutable_.Map)());
  });
  // we want the rows that contain more than just the primaryKeys
  return updatedData.filter(rowData => rowData.size > pkColsLc.size).map(rowData => rowData.toJS()).toArray();
}

/**
 * This forces tooltips to close and menus to stop showing pressed state after you close them on Chrome. We likely will
 * not need this if/when we upgrade React Bootstrap to something beyond the pre-release version we are using.
 */
const blurActiveElement = () => {
  document.activeElement.blur();
};

/**
 * Unique names are not enforced for samples when they belong to different sample types, or data from different data classes.
 * When generating SelectInput options, we want to append sample type or source type to entries with duplicate names so user know which item they are selecting.
 * @param rows
 * @param keyField
 * @param valueField
 * @param typeField
 */
function getDisambiguatedSelectInputOptions(rows, keyField, valueField, typeField) {
  const options = [],
    rawOptions = [];
  if (external_immutable_.Iterable.isIterable(rows)) {
    rows.forEach(row => {
      rawOptions.push({
        value: row.getIn([keyField, 'value']),
        label: row.getIn([valueField, 'value']),
        type: row.getIn([typeField, 'value'])
      });
    });
  } else {
    Object.keys(rows).forEach(row => {
      const data = rows[row];
      rawOptions.push({
        value: data[keyField]?.value,
        label: data[valueField]?.value,
        type: data[typeField]?.value
      });
    });
  }
  rawOptions.sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
  const duplicateValues = [];
  for (let i = 0; i < rawOptions.length - 1; i++) {
    if (rawOptions[i + 1].label == rawOptions[i].label) {
      if (duplicateValues.indexOf(rawOptions[i].label) === -1) duplicateValues.push(rawOptions[i].label);
    }
  }
  rawOptions.forEach(option => {
    const label = duplicateValues.indexOf(option.label) > -1 ? option.label + ' (' + option.type + ')' : option.label;
    options.push({
      value: option.value,
      label
    });
  });
  return options;
}
const TRUE_STRINGS = ['true', 't', 'yes', 'y', 'on', '1'];
const FALSE_STRINGS = ['false', 'f', 'no', 'n', 'off', '0'];
function isBoolean(value, allowNull = true) {
  if (typeof value === "boolean") return true;
  if (!value) return allowNull;
  if (TRUE_STRINGS.indexOf(value.toString().toLowerCase()) > -1) return true;
  return FALSE_STRINGS.indexOf(value.toString().toLowerCase()) > -1;
}
function isFloat(value) {
  return !isNaN(Number(value)) && !isNaN(parseFloat(value + ''));
}
function isInteger(value) {
  const intValue = parseScientificInt(value);
  return !isNaN(intValue) && intValue == Number(value);
}
function isIntegerInRange(value, min, max) {
  return isInteger(value) && (!min || Number(value) >= min) && (!max || Number(value) <= max);
}
function isNonNegativeInteger(value) {
  return isInteger(value) && Number(value) >= 0;
}
function isNonNegativeFloat(value) {
  return isFloat(value) && Number(value) >= 0;
}

// works with string that might contain Scientific Notation
function parseScientificInt(value) {
  if (value == null) return undefined;
  const valueStr = String(value).trim();
  if (!valueStr) return undefined;
  if (isNaN(Number(valueStr))) return NaN;
  const valueLocaleStr = Number(valueStr).toLocaleString('fullwide', {
    useGrouping: false
  });
  return parseInt(valueLocaleStr, 10);
}
function getFileExtensionType(value) {
  const parts = value.split('.');
  return parts[parts.length - 1].toLowerCase();
}
function isImage(value) {
  // Note: don't add tif, or tiff here, most browsers will not render them (see Issue 49852)
  const validImageExtensions = ['jpg', 'jpeg', 'bmp', 'gif', 'ico', 'png', 'svg'];
  const extensionType = getFileExtensionType(value);
  return validImageExtensions.indexOf(extensionType) > -1;
}
function downloadAttachment(href, openInTab, fileName) {
  if (openInTab) {
    window.open(href, '_blank', 'noopener,noreferrer');
  } else {
    const link = document.createElement('a');
    link.href = href;
    link.download = fileName;
    link.click();
  }
}

// copied from platform/api/src/org/labkey/api/attachments/Attachment.java
const EXTENSION_FONT_CLS_MAP = {
  '7z': 'fa fa-file-archive-o',
  audio: 'fa fa-file-audio-o',
  csv: 'fa fa-file-text-o',
  dll: 'fa fa-file-code-o',
  doc: 'fa fa-file-word-o',
  docm: 'fa fa-file-word-o',
  docx: 'fa fa-file-word-o',
  dotm: 'fa fa-file-word-o',
  dotx: 'fa fa-file-word-o',
  exe: 'fa fa-file-code-o',
  folder: 'fa fa-folder-o',
  gz: 'fa fa-file-archive-o',
  html: 'fa fa-file-code-o',
  image: 'fa fa-file-image-o',
  iqy: 'fa fa-file-code-o',
  jar: 'fa fa-file-archive-o',
  json: 'fa fa-file-code-o',
  log: 'fa fa-file-text-o',
  pdf: 'fa fa-file-pdf-o',
  potm: 'fa fa-file-powerpoint-o',
  potx: 'fa fa-file-powerpoint-o',
  ppsm: 'fa fa-file-powerpoint-o',
  ppsx: 'fa fa-file-powerpoint-o',
  ppt: 'fa fa-file-powerpoint-o',
  pptm: 'fa fa-file-powerpoint-o',
  pptx: 'fa fa-file-powerpoint-o',
  prg: 'fa fa-file-code-o',
  r: 'fa fa-file-code-o',
  rtf: 'fa fa-file-word-o',
  sql: 'fa fa-file-code-o',
  tar: 'fa fa-file-archive-o',
  text: 'fa fa-file-text-o',
  tgz: 'fa fa-file-archive-o',
  tsv: 'fa fa-file-text-o',
  txt: 'fa fa-file-text-o',
  video: 'fa fa-file-video-o',
  vsd: 'fa fa-file-image-o',
  wiki: 'fa fa-file-code-o',
  xar: 'fa fa-file-archive-o',
  xls: 'fa fa-file-excel-o',
  xlsb: 'fa fa-file-excel-o',
  xlsm: 'fa fa-file-excel-o',
  xlsx: 'fa fa-file-excel-o',
  xltm: 'fa fa-file-excel-o',
  xltx: 'fa fa-file-excel-o',
  xml: 'fa fa-file-code-o',
  zip: 'fa fa-file-archive-o'
};
function getIconFontCls(value, unavailable) {
  if (!value) {
    return undefined;
  }
  if (unavailable) return 'fa fa-exclamation-triangle';
  const extensionType = getFileExtensionType(value);
  if (EXTENSION_FONT_CLS_MAP[extensionType]) {
    return EXTENSION_FONT_CLS_MAP[extensionType];
  }
  return isImage(value) ? 'fa fa-file-image-o' : 'fa fa-file-o';
}

/**
 * Formats number of bytes into a human readable string.
 * Example:
 * ```
 * formatBytes(1024);       // 1 KB
 * formatBytes('1024');     // 1 KB
 * formatBytes(1234);       // 1.21 KB
 * formatBytes(1234, 3);    // 1.205 KB
 * ```
 * https://stackoverflow.com/a/18650828
 */
function formatBytes(bytes, decimals = 2) {
  if (bytes === undefined || bytes === null) return 'Size unknown';
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Handles Ajax.request() failures. Calls the passed in "reject" handler with the error
 * from the request as determined by Utils.getCallbackWrapper(). The "reject" parameter can be a normal function
 * or a rejection handler for a Promise. If a response status code is available, then it will append that value
 * to the error object as "status".
 * Example:
 * ```
 * import { Ajax } from '@labkey/api';
 *
 * new Promise((resolve, reject) => {
 *     return Ajax.request({
 *         // ... url, success handler, etc
 *         failure: handleRequestFailure(reject, 'This optional message is logged to console.error'),
 *     });
 * });
 * ```
 */
function handleRequestFailure(reject, logMsg) {
  return api_.Utils.getCallbackWrapper((error, response) => {
    // Appends the response's status code to the error object
    const errorWithStatus = utils_objectSpread(utils_objectSpread({}, error), {}, {
      status: response?.status
    });
    if (logMsg) {
      console.error(logMsg, errorWithStatus);
    }
    reject(errorWithStatus);
  }, undefined, true);
}

/**
 * Given an array of 1-based ordinals, which may have gaps in them (e.g., [1, 3, 4, 6]) and an
 * array of ordered values, extract the ordered values that correspond to the gaps in
 * the ordinals (e.g., values[1], values[4]).
 * @param ordinals the 1-based ordinal list, possibly with gaps
 * @param orderedValues The ordered values to extract the missing values from
 */
function findMissingValues(ordinals, orderedValues) {
  let index = 0;
  let oIndex = 0;
  const missingValues = [];
  while (index < orderedValues.length) {
    if (oIndex >= ordinals.length || ordinals[oIndex] !== index + 1) {
      missingValues.push(orderedValues[index]);
    } else {
      oIndex++;
    }
    index++;
  }
  return missingValues;
}

// Helper that handles grabbing a files array from an HTMLInput ChangeEvent, use this to reduce boilerplate when
// handling events for file inputs.
const handleFileInputChange = callback => {
  return evt => {
    if (evt.currentTarget.files.length > 0) {
      callback(Array.from(evt.currentTarget.files));
    }
  };
};
function parseCsvString(value, delimiter, removeQuotes) {
  if (delimiter === '"') throw 'Unsupported delimiter: ' + delimiter;
  if (!delimiter) return undefined;
  if (value == null) return undefined;
  let start = 0;
  const parsedValues = [];
  while (start < value.length) {
    let end;
    const ch = value[start];
    if (ch === delimiter) {
      // empty string case
      end = start;
      parsedValues.push('');
    } else if (ch === '"') {
      // starting a quoted value
      end = start;
      while (true) {
        // find the end of the quoted value
        end = value.indexOf('"', end + 1);
        if (end === -1) {
          // no ending quote
          end = value.length;
          break;
        }
        if (end === value.length - 1 || value[end + 1] !== '"') {
          // end quote at end of string or without double quote
          break;
        }
        end++; // skip double ""
      }
      let parsedValue = removeQuotes ? value.substring(start + 1, end) : value.substring(start, end + 1); // start is at the quote
      if (removeQuotes && parsedValue.indexOf('""') !== -1) {
        parsedValue = parsedValue.replace(/""/g, '"');
      }
      parsedValues.push(parsedValue);
      end++; // get past the last "
    } else {
      end = value.indexOf(delimiter, start);
      if (end === -1) end = value.length;
      parsedValues.push(value.substring(start, end));
    }
    start = end + delimiter.length;
  }
  return parsedValues;
}
function quoteValueWithDelimiters(value, delimiter) {
  if (!value || !api_.Utils.isString(value)) {
    return value;
  }
  if (!delimiter) {
    throw 'Delimiter is required.';
  }
  if (value.indexOf(delimiter) === -1) return value; // nothing to do for a string that doesn't contain the delimiter
  if (value.indexOf('"') !== -1) {
    value = value.replace(/"/g, '""');
  }
  return '"' + value + '"';
}
function arrayEquals(a, b, ignoreOrder = true, caseInsensitive) {
  if (a === b) return true;
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  const aStr = ignoreOrder ? a.sort().join(';') : a.join(';');
  const bStr = ignoreOrder ? b.sort().join(';') : b.join(';');
  return caseInsensitive ? aStr.toLowerCase() === bStr.toLowerCase() : aStr === bStr;
}
function getValueFromRow(row, col) {
  if (!row) return undefined;
  const val = caseInsensitive(row, col);
  if (api_.Utils.isArray(val)) {
    return val[0]?.value;
  } else if (api_.Utils.isObject(val)) {
    return val?.value;
  }
  return val;
}
;// CONCATENATED MODULE: ./src/internal/constants.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



// We are currently accessing these vis and WebSocket namespaces off of the global context,
// but hopefully these can become their own packages or part of this package directly
const LABKEY_VIS = (0,api_.getServerContext)().vis;
const LABKEY_WEBSOCKET = (0,api_.getServerContext)().WebSocket;
const LABKEY_PASSWORD_GAUGE = (0,api_.getServerContext)().PasswordGauge;
const QUERY_GRID_PREFIX = 'labkey-querygrid-';
const FASTA_EXPORT_CONTROLLER = 'biologics';
const GENBANK_EXPORT_CONTROLLER = 'biologics';
const BARTENDER_EXPORT_CONTROLLER = 'sampleManager';
const SAMPLE_SET_DISPLAY_TEXT = 'Sample Type';
const STORAGE_MAP_EXPORT_CONTROLLER = 'inventory';
const MAX_EDITABLE_GRID_ROWS = 1000;
const LOOKUP_DEFAULT_SIZE = 25;
let AssayUploadTabs = /*#__PURE__*/function (AssayUploadTabs) {
  AssayUploadTabs[AssayUploadTabs["Grid"] = 1] = "Grid";
  AssayUploadTabs[AssayUploadTabs["Files"] = 2] = "Files";
  return AssayUploadTabs;
}({});
let EXPORT_TYPES = /*#__PURE__*/function (EXPORT_TYPES) {
  EXPORT_TYPES[EXPORT_TYPES["CSV"] = 0] = "CSV";
  EXPORT_TYPES[EXPORT_TYPES["EXCEL"] = 1] = "EXCEL";
  EXPORT_TYPES[EXPORT_TYPES["TSV"] = 2] = "TSV";
  EXPORT_TYPES[EXPORT_TYPES["FASTA"] = 3] = "FASTA";
  EXPORT_TYPES[EXPORT_TYPES["GENBANK"] = 4] = "GENBANK";
  EXPORT_TYPES[EXPORT_TYPES["LABEL"] = 5] = "LABEL";
  EXPORT_TYPES[EXPORT_TYPES["STORAGE_MAP"] = 6] = "STORAGE_MAP";
  return EXPORT_TYPES;
}({});
let KEYS = /*#__PURE__*/function (KEYS) {
  KEYS[KEYS["Backspace"] = 8] = "Backspace";
  KEYS[KEYS["Tab"] = 9] = "Tab";
  KEYS[KEYS["Enter"] = 13] = "Enter";
  KEYS[KEYS["Shift"] = 16] = "Shift";
  KEYS[KEYS["Ctrl"] = 17] = "Ctrl";
  KEYS[KEYS["Alt"] = 18] = "Alt";
  KEYS[KEYS["PauseBreak"] = 19] = "PauseBreak";
  KEYS[KEYS["CapsLock"] = 20] = "CapsLock";
  KEYS[KEYS["Escape"] = 27] = "Escape";
  KEYS[KEYS["Space"] = 32] = "Space";
  KEYS[KEYS["PageUp"] = 33] = "PageUp";
  KEYS[KEYS["PageDown"] = 34] = "PageDown";
  KEYS[KEYS["End"] = 35] = "End";
  KEYS[KEYS["Home"] = 36] = "Home";
  KEYS[KEYS["LeftArrow"] = 37] = "LeftArrow";
  KEYS[KEYS["UpArrow"] = 38] = "UpArrow";
  KEYS[KEYS["RightArrow"] = 39] = "RightArrow";
  KEYS[KEYS["DownArrow"] = 40] = "DownArrow";
  KEYS[KEYS["Insert"] = 45] = "Insert";
  KEYS[KEYS["Delete"] = 46] = "Delete";
  KEYS[KEYS["Zero"] = 48] = "Zero";
  KEYS[KEYS["ClosedParen"] = 48] = "ClosedParen";
  KEYS[KEYS["One"] = 49] = "One";
  KEYS[KEYS["ExclamationMark"] = 49] = "ExclamationMark";
  KEYS[KEYS["Two"] = 50] = "Two";
  KEYS[KEYS["AtSign"] = 50] = "AtSign";
  KEYS[KEYS["Three"] = 51] = "Three";
  KEYS[KEYS["PoundSign"] = 51] = "PoundSign";
  KEYS[KEYS["Hash"] = 51] = "Hash";
  KEYS[KEYS["Four"] = 52] = "Four";
  KEYS[KEYS["DollarSign"] = 52] = "DollarSign";
  KEYS[KEYS["Five"] = 53] = "Five";
  KEYS[KEYS["PercentSign"] = 53] = "PercentSign";
  KEYS[KEYS["Six"] = 54] = "Six";
  KEYS[KEYS["Caret"] = 54] = "Caret";
  KEYS[KEYS["Hat"] = 54] = "Hat";
  KEYS[KEYS["Seven"] = 55] = "Seven";
  KEYS[KEYS["Ampersand"] = 55] = "Ampersand";
  KEYS[KEYS["Eight"] = 56] = "Eight";
  KEYS[KEYS["Star"] = 56] = "Star";
  KEYS[KEYS["Asterik"] = 56] = "Asterik";
  KEYS[KEYS["Nine"] = 57] = "Nine";
  KEYS[KEYS["OpenParen"] = 57] = "OpenParen";
  KEYS[KEYS["A"] = 65] = "A";
  KEYS[KEYS["B"] = 66] = "B";
  KEYS[KEYS["C"] = 67] = "C";
  KEYS[KEYS["D"] = 68] = "D";
  KEYS[KEYS["E"] = 69] = "E";
  KEYS[KEYS["F"] = 70] = "F";
  KEYS[KEYS["G"] = 71] = "G";
  KEYS[KEYS["H"] = 72] = "H";
  KEYS[KEYS["I"] = 73] = "I";
  KEYS[KEYS["J"] = 74] = "J";
  KEYS[KEYS["K"] = 75] = "K";
  KEYS[KEYS["L"] = 76] = "L";
  KEYS[KEYS["M"] = 77] = "M";
  KEYS[KEYS["N"] = 78] = "N";
  KEYS[KEYS["O"] = 79] = "O";
  KEYS[KEYS["P"] = 80] = "P";
  KEYS[KEYS["Q"] = 81] = "Q";
  KEYS[KEYS["R"] = 82] = "R";
  KEYS[KEYS["S"] = 83] = "S";
  KEYS[KEYS["T"] = 84] = "T";
  KEYS[KEYS["U"] = 85] = "U";
  KEYS[KEYS["V"] = 86] = "V";
  KEYS[KEYS["W"] = 87] = "W";
  KEYS[KEYS["X"] = 88] = "X";
  KEYS[KEYS["Y"] = 89] = "Y";
  KEYS[KEYS["Z"] = 90] = "Z";
  KEYS[KEYS["LeftMetaKey"] = 91] = "LeftMetaKey";
  KEYS[KEYS["RightMetaKey"] = 92] = "RightMetaKey";
  KEYS[KEYS["SelectKey"] = 93] = "SelectKey";
  KEYS[KEYS["Numpad0"] = 96] = "Numpad0";
  KEYS[KEYS["Numpad1"] = 97] = "Numpad1";
  KEYS[KEYS["Numpad2"] = 98] = "Numpad2";
  KEYS[KEYS["Numpad3"] = 99] = "Numpad3";
  KEYS[KEYS["Numpad4"] = 100] = "Numpad4";
  KEYS[KEYS["Numpad5"] = 101] = "Numpad5";
  KEYS[KEYS["Numpad6"] = 102] = "Numpad6";
  KEYS[KEYS["Numpad7"] = 103] = "Numpad7";
  KEYS[KEYS["Numpad8"] = 104] = "Numpad8";
  KEYS[KEYS["Numpad9"] = 105] = "Numpad9";
  KEYS[KEYS["Multiply"] = 106] = "Multiply";
  KEYS[KEYS["Add"] = 107] = "Add";
  KEYS[KEYS["Subtract"] = 109] = "Subtract";
  KEYS[KEYS["DecimalPoint"] = 110] = "DecimalPoint";
  KEYS[KEYS["Divide"] = 111] = "Divide";
  KEYS[KEYS["F1"] = 112] = "F1";
  KEYS[KEYS["F2"] = 113] = "F2";
  KEYS[KEYS["F3"] = 114] = "F3";
  KEYS[KEYS["F4"] = 115] = "F4";
  KEYS[KEYS["F5"] = 116] = "F5";
  KEYS[KEYS["F6"] = 117] = "F6";
  KEYS[KEYS["F7"] = 118] = "F7";
  KEYS[KEYS["F8"] = 119] = "F8";
  KEYS[KEYS["F9"] = 120] = "F9";
  KEYS[KEYS["F10"] = 121] = "F10";
  KEYS[KEYS["F11"] = 122] = "F11";
  KEYS[KEYS["F12"] = 123] = "F12";
  KEYS[KEYS["NumLock"] = 144] = "NumLock";
  KEYS[KEYS["ScrollLock"] = 145] = "ScrollLock";
  KEYS[KEYS["SemiColon"] = 186] = "SemiColon";
  KEYS[KEYS["Equals"] = 187] = "Equals";
  KEYS[KEYS["Comma"] = 188] = "Comma";
  KEYS[KEYS["Dash"] = 189] = "Dash";
  KEYS[KEYS["Period"] = 190] = "Period";
  KEYS[KEYS["UnderScore"] = 189] = "UnderScore";
  KEYS[KEYS["PlusSign"] = 187] = "PlusSign";
  KEYS[KEYS["ForwardSlash"] = 191] = "ForwardSlash";
  KEYS[KEYS["Tilde"] = 192] = "Tilde";
  KEYS[KEYS["GraveAccent"] = 192] = "GraveAccent";
  KEYS[KEYS["OpenBracket"] = 219] = "OpenBracket";
  KEYS[KEYS["ClosedBracket"] = 221] = "ClosedBracket";
  KEYS[KEYS["Quote"] = 222] = "Quote";
  KEYS[KEYS["FFLeftMetaKey"] = 224] = "FFLeftMetaKey";
  return KEYS;
}({}); // Firefox

// This is used for filtering search results.  Since we first check for search hits containing
// a data object, which exp.data objects and materials have, the most important elements of this
// array are the types that don't have that data object.
const RELEVANT_SEARCH_RESULT_TYPES = ['data', 'experiment', 'material', 'materialSource', 'assay'];
const SAMPLE_UNIQUE_FIELD_KEY = 'Name';
const DATA_CLASS_UNIQUE_FIELD_KEY = 'Name';
const NO_UPDATES_MESSAGE = 'No changes were made because the provided values match the existing values.';
const PARENT_ALIAS_HELPER_TEXT = "Column headings used during import to set a sample's parentage. " + 'The referenced type will also be added as a parent type by default when adding samples manually.';
let DataViewInfoTypes = /*#__PURE__*/function (DataViewInfoTypes) {
  DataViewInfoTypes["AutomaticPlot"] = "Automatic Plot";
  DataViewInfoTypes["BarChart"] = "Bar Chart";
  DataViewInfoTypes["BoxAndWhiskerPlot"] = "Box and Whisker Plot";
  DataViewInfoTypes["CrosstabReport"] = "Crosstab Report";
  DataViewInfoTypes["Dataset"] = "Dataset";
  DataViewInfoTypes["ParticipantReport"] = "Participant Report";
  DataViewInfoTypes["PieChart"] = "Pie Chart";
  DataViewInfoTypes["Query"] = "Query";
  DataViewInfoTypes["RReport"] = "R Report";
  DataViewInfoTypes["SampleFinderSavedSearch"] = "Sample Finder Saved Search";
  DataViewInfoTypes["TimeChart"] = "Time Chart";
  DataViewInfoTypes["XYScatterPlot"] = "XY Scatter Plot";
  DataViewInfoTypes["XYSeriesLinePlot"] = "XY Series Line Plot";
  return DataViewInfoTypes;
}({});
const GRID_REPORTS = (0,external_immutable_.Set)([DataViewInfoTypes.Query, DataViewInfoTypes.Dataset]);
const GENERIC_CHART_REPORTS = [DataViewInfoTypes.AutomaticPlot, DataViewInfoTypes.BarChart, DataViewInfoTypes.BoxAndWhiskerPlot, DataViewInfoTypes.PieChart, DataViewInfoTypes.XYScatterPlot, DataViewInfoTypes.XYSeriesLinePlot];
const VISUALIZATION_REPORTS = (0,external_immutable_.Set)([...GENERIC_CHART_REPORTS, DataViewInfoTypes.RReport]);
let IMPORT_DATA_FORM_TYPES = /*#__PURE__*/function (IMPORT_DATA_FORM_TYPES) {
  IMPORT_DATA_FORM_TYPES[IMPORT_DATA_FORM_TYPES["GRID"] = 1] = "GRID";
  IMPORT_DATA_FORM_TYPES[IMPORT_DATA_FORM_TYPES["TEXT"] = 2] = "TEXT";
  IMPORT_DATA_FORM_TYPES[IMPORT_DATA_FORM_TYPES["FILE"] = 3] = "FILE";
  IMPORT_DATA_FORM_TYPES[IMPORT_DATA_FORM_TYPES["OTHER"] = 4] = "OTHER";
  return IMPORT_DATA_FORM_TYPES;
}({});
const GRID_EDIT_INDEX = '__editing__';
const GRID_SELECTION_INDEX = '__selection__';
const GRID_NAME_INDEX = '__name__';
const GRID_HEADER_CELL_BODY = 'grid-header-cell__body';
let GRID_CHECKBOX_OPTIONS = /*#__PURE__*/function (GRID_CHECKBOX_OPTIONS) {
  GRID_CHECKBOX_OPTIONS[GRID_CHECKBOX_OPTIONS["ALL"] = 0] = "ALL";
  GRID_CHECKBOX_OPTIONS[GRID_CHECKBOX_OPTIONS["SOME"] = 1] = "SOME";
  GRID_CHECKBOX_OPTIONS[GRID_CHECKBOX_OPTIONS["NONE"] = 2] = "NONE";
  return GRID_CHECKBOX_OPTIONS;
}({});
const PIPELINE_JOB_NOTIFICATION_EVENT = 'org.labkey.api.pipeline.AppPipelineJobNotificationProvider.ImportNotify';
const PIPELINE_JOB_NOTIFICATION_EVENT_START = PIPELINE_JOB_NOTIFICATION_EVENT + '#Start';
const PIPELINE_JOB_NOTIFICATION_EVENT_SUCCESS = PIPELINE_JOB_NOTIFICATION_EVENT + '#Success';
const PIPELINE_JOB_NOTIFICATION_EVENT_ERROR = PIPELINE_JOB_NOTIFICATION_EVENT + '#Error';
const SHARED_CONTAINER_PATH = '/Shared';
const VIEW_NOT_FOUND_EXCEPTION_CLASS = 'org.labkey.api.view.NotFoundException';
const APP_FIELD_CANNOT_BE_REMOVED_MESSAGE = 'This application field cannot be removed.';
const CELL_SELECTION_HANDLE_CLASSNAME = 'cell-selection-handle';
;// CONCATENATED MODULE: ./src/internal/util/URL.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function getQueryParamsFromSearchParams(searchParams) {
  return [...searchParams.entries()].reduce((result, tuple) => {
    const [key, value] = tuple;
    if (result.hasOwnProperty(key)) {
      if (Array.isArray(result[key])) {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
    return result;
  }, {});
}

/**
 * Takes a search string (typically from Location) or URLSearchParams (typically from useSearchParams hook) and converts
 * it to a QueryParams object. If the same key is used multiple times in a search string (e.g. ?foo=bar&foo=baz) it will
 * return an array of values for that key, if the key only appears once it will return a string for that kΩey. If you
 * know the key you are looking for will not be an array use: const myValue = getQueryParams(search).myValue as string;
 * @param search
 */
function getQueryParams(search) {
  if (!search) return {};
  if (search instanceof URLSearchParams) {
    return getQueryParamsFromSearchParams(search);
  }
  return getQueryParamsFromSearchParams(new URLSearchParams(search));
}
function setParameters(setParams, params, asReplace = false) {
  const options = asReplace ? {
    replace: true
  } : undefined;
  setParams(current => {
    const query = getQueryParams(current);
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value === undefined) {
        delete query[key];
      } else {
        query[key] = value;
      }
    });
    return query;
  }, options);
}
function removeParameters(setParams, ...params) {
  if (!params) return;
  const paramsObj = params.reduce((result, param) => {
    result[param] = undefined;
    return result;
  }, {});
  setParameters(setParams, paramsObj, true);
}
function replaceParameters(setParams, params) {
  setParameters(setParams, params, true);
}
function pushParameters(setParams, params) {
  setParameters(setParams, params);
}
;// CONCATENATED MODULE: ./src/public/LoadingState.ts
let LoadingState = /*#__PURE__*/function (LoadingState) {
  LoadingState["INITIALIZED"] = "INITIALIZED";
  LoadingState["LOADING"] = "LOADING";
  LoadingState["LOADED"] = "LOADED";
  return LoadingState;
}({});

/**
 * Returns true if any LoadingState(s) are considered to be loading. Falsy values are considered not loading.
 */
const isLoading = (...loadingStates) => {
  return !!loadingStates && loadingStates.find(ls => ls === LoadingState.INITIALIZED || ls === LoadingState.LOADING) !== undefined;
};
;// CONCATENATED MODULE: ./src/public/sort.ts
/**
 * Compares two string objects for doing alphanumeric (natural) sorting.
 * Returns a positive number if the first string comes after the second in a natural sort; 0 if they are equal
 * and a negative number if the second comes after the first.
 * For in-depth documentation and examples see components/docs/sort.md.
 * @param aso
 * @param bso
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function naturalSort(aso, bso) {
  // http://stackoverflow.com/questions/19247495/alphanumeric-sorting-an-array-in-javascript
  if (aso === bso) return 0;
  if (aso === undefined || aso === null || aso === '') return 1;
  if (bso === undefined || bso === null || bso === '') return -1;
  let a1,
    b1,
    i = 0,
    n;

  // If no matches are found in the group, then match() will return null
  const rx = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
  const a = aso.toString().toLowerCase().match(rx) ?? [];
  const b = bso.toString().toLowerCase().match(rx) ?? [];
  const L = a.length;
  while (i < L) {
    if (!b[i]) return 1;
    a1 = a[i];
    b1 = b[i++];
    if (a1 !== b1) {
      n = a1 - b1;
      if (!isNaN(n)) return n;
      return a1 > b1 ? 1 : -1;
    }
  }
  return b[i] ? -1 : 0;
}
/**
 * Creates a sort function that will natural sort an array of objects by property.
 * For in-depth documentation and examples see components/docs/sort.md.
 * Ex:`
 *  const myArray = [{ displayName: 'Nick' }, { displayName: 'Alan' }, { displayName: 'Susan' }];
 *  myArray.sort(naturalSortByProperty('displayName'));
 * @param property: string, the property you want to sort on.
 */
function naturalSortByProperty(property) {
  return (a, b) => naturalSort(a[property], b[property]);
}
;// CONCATENATED MODULE: ./src/public/QueryModel/QueryModel.ts
function QueryModel_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function QueryModel_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? QueryModel_ownKeys(Object(t), !0).forEach(function (r) { QueryModel_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : QueryModel_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function QueryModel_defineProperty(e, r, t) { return (r = QueryModel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function QueryModel_toPropertyKey(t) { var i = QueryModel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function QueryModel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










function flattenValuesFromRow(row, keys) {
  const values = {};
  if (row && keys) {
    keys.forEach(key => {
      if (row[key]) {
        values[key] = row[key].value;
      }
    });
  }
  return values;
}
function offsetFromString(rowsPerPage, pageStr) {
  if (pageStr === null) {
    return undefined;
  }
  let offset = 0;
  const page = parseInt(pageStr, 10);
  if (!isNaN(page)) {
    offset = (page - 1) * rowsPerPage;
  }
  return offset >= 0 ? offset : 0;
}
function querySortFromString(sortStr) {
  if (sortStr.startsWith('-')) {
    return new QuerySort({
      dir: '-',
      fieldKey: sortStr.slice(1)
    });
  } else {
    return new QuerySort({
      fieldKey: sortStr
    });
  }
}
function querySortsFromString(sortsStr) {
  return sortsStr?.split(',').map(querySortFromString);
}
function searchFiltersFromString(searchStr) {
  return searchStr?.split(';').map(search => api_.Filter.create('*', search, api_.Filter.Types.Q));
}

/**
 * Returns true if a given location has queryParams that would conflict with savedSettings: filters, sorts, view,
 * page offset, pageSize.
 * @param prefix: the QueryModel prefix
 * @param searchParams: The URLSearchParams returned by the react-router useSearchParams hook
 */
function locationHasQueryParamSettings(prefix, searchParams) {
  if (searchParams === undefined) return false;
  // Report
  if (searchParams.get(`${prefix}.reportId`) !== null) return true;
  // View
  if (searchParams.get(`${prefix}.view`) !== null) return true;
  // Search Filters
  if (searchParams.get(`${prefix}.q`) !== null) return true;
  // Column Filters
  if (api_.Filter.getFiltersFromParameters(getQueryParams(searchParams), prefix).length > 0) return true;
  // Sorts
  if (searchParams.get(`${prefix}.sort`) !== null) return true;
  // Page offset
  if (searchParams.get(`${prefix}.p`) !== null) return true;
  // Page size
  return searchParams.get(`${prefix}.pageSize`) !== null;
}

/**
 * Creates a QueryModel ID for a given SchemaQuery. The id is just the SchemaQuery snake-cased as
 * schemaName.queryName.
 *
 * @param schemaQuery: SchemaQuery
 */
function createQueryModelId(schemaQuery) {
  const {
    schemaName,
    queryName
  } = schemaQuery;
  return `${schemaName}.${queryName}`;
}
const sortStringMapper = s => s.toRequestString();
const DEFAULT_OFFSET = 0;
const DEFAULT_MAX_ROWS = 20;

/**
 * An object that describes the current selection pivot row for shift-select behavior. When a single row is selected
 * it becomes the "pivot" row for shift-select behavior. Subsequently, if a user selects another row while holding
 * the shift key then all rows between the pivot row and the newly selected row will be selected/deselected.
 */

/**
 * This is the base model used to store all the data for a query. At a high level the QueryModel API is a wrapper around
 * the [selectRows](https://labkey.github.io/labkey-api-js/modules/Query.html#selectRows) API.
 * If you need to retrieve data from a LabKey table or query, so you can render it in a React
 * component, then the QueryModel API is most likely what you want.
 *
 * This model stores some client-side only data as well as data retrieved from the server. You can manually instantiate a
 * QueryModel, but you will almost never do this, instead you will use the [[withQueryModels]] HOC to inject the needed
 * QueryModel(s) into your component. To create a QueryModel you will need to define a [[QueryConfig]] object. At a
 * minimum, your [[QueryConfig]] must have a valid [[SchemaQuery]], but we also support many other attributes that
 * allow you to configure the model before it is loaded, all of the attributes can be found on the [[QueryConfig]]
 * interface.
 */
class QueryModel {
  /**
   * Constructor which takes a [[QueryConfig]] definition and creates a new QueryModel, applying default values
   * to those properties not defined in the [[QueryConfig]]. Note that we default to the Details view if we have a
   * keyValue and the user hasn't specified a view.
   * @param queryConfig
   */
  constructor(queryConfig) {
    /**
     * @hidden
     */
    QueryModel_defineProperty(this, external_immer_.immerable, true);
    // Fields from QueryConfig
    // Some of the fields we have in common with QueryConfig are not optional because we give them default values.
    /**
     * An array of base [Filter.IFilter](https://labkey.github.io/labkey-api-js/interfaces/Filter.IFilter.html)
     * filters to be applied to the QueryModel data load. These base filters will be concatenated with URL filters,
     * they keyValue filter, and view filters when applicable.
     */
    QueryModel_defineProperty(this, "baseFilters", void 0);
    /**
     * Flag used to indicate whether or not filters/sorts/etc. should be persisted on the URL. Defaults to false.
     */
    QueryModel_defineProperty(this, "bindURL", void 0);
    /**
     * One of the values of [Query.ContainerFilter](https://labkey.github.io/labkey-api-js/enums/Query.ContainerFilter.html)
     * that sets the scope of this query. Defaults to ContainerFilter.current, and is interpreted relative to
     * config.containerPath.
     */
    QueryModel_defineProperty(this, "containerFilter", void 0);
    /**
     * The path to the container in which the schema and query are defined, if different than the current container.
     * If not supplied, the current container's path will be used.
     */
    QueryModel_defineProperty(this, "containerPath", void 0);
    /**
     * Id value to use for referencing a given QueryModel. If not provided, one will be generated for this QueryModel
     * instance based on the [[SchemaQuery]] and keyValue where applicable.
     */
    QueryModel_defineProperty(this, "id", void 0);
    /**
     * Include the Details link column in the set of columns (defaults to false). If included, the column will
     * have the name "\~\~Details\~\~". The underlying table/query must support details links or the column will
     * be omitted in the response.
     */
    QueryModel_defineProperty(this, "includeDetailsColumn", void 0);
    /**
     * Include the Update (or edit) link column in the set of columns (defaults to false). If included, the column
     * will have the name "\~\~Update\~\~". The underlying table/query must support update links or the column
     * will be omitted in the response.
     */
    QueryModel_defineProperty(this, "includeUpdateColumn", void 0);
    /**
     * Include the total count in the query model via a second query to the server for this value.
     * This second query will be made in parallel with the initial query to get the model data.
     */
    QueryModel_defineProperty(this, "includeTotalCount", void 0);
    /**
     * Primary key value, used when loading/rendering details pages to get a single row of data in a QueryModel.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    QueryModel_defineProperty(this, "keyValue", void 0);
    /**
     * The maximum number of rows to return from the server (defaults to 20).
     * If you want to return all possible rows, set this config property to -1.
     */
    QueryModel_defineProperty(this, "maxRows", void 0);
    /**
     * The index of the first row to return from the server (defaults to 0). Use this along with the
     * maxRows config property to request pages of data.
     */
    QueryModel_defineProperty(this, "offset", void 0);
    /**
     * Array of column names to be explicitly excluded from the column list in the QueryModel data load.
     */
    QueryModel_defineProperty(this, "omittedColumns", void 0);
    /**
     * Query parameters used as input to a parameterized query.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    QueryModel_defineProperty(this, "queryParameters", void 0);
    /**
     * Array of column names to be explicitly included from the column list in the QueryModel data load.
     */
    QueryModel_defineProperty(this, "requiredColumns", void 0);
    /**
     * Request requiredColumns as "fields" property on query-getQueryDetails.api.
     * This will ensure the required columns are available on the queryInfo. Defaults to false.
     */
    QueryModel_defineProperty(this, "requiredColumnsAsQueryInfoFields", void 0);
    /**
     * Definition of the [[SchemaQuery]] (i.e. schema, query, and optionally view name) to use for the QueryModel data load.
     */
    QueryModel_defineProperty(this, "schemaQuery", void 0);
    QueryModel_defineProperty(this, "selectionContainerPath", void 0);
    /**
     * Array of [[QuerySort]] objects to use for the QueryModel data load.
     */
    QueryModel_defineProperty(this, "sorts", void 0);
    /**
     * String value to use in grid panel header.
     */
    QueryModel_defineProperty(this, "title", void 0);
    /**
     * Prefix string value to use in url parameters when bindURL is true. Defaults to "query".
     */
    QueryModel_defineProperty(this, "urlPrefix", void 0);
    /**
     * If true we will load filters, sorts, pageSize, and viewName from localStorage when initially loading the model,
     * but only if there are no settings on the URL. Defaults to false. Important: If you are using this flag you must
     * ensure your grid id is stable and unique. It must be stable between page loads/visits, or we won't be able to
     * fetch the settings. It must be unique, or we'll override settings for other grid models.
     */
    QueryModel_defineProperty(this, "useSavedSettings", void 0);
    /**
     * An array of [Filter.IFilter](https://labkey.github.io/labkey-api-js/interfaces/Filter.IFilter.html)
     * filters to be applied to the QueryModel data load. These filters will be concatenated with base filters, URL filters,
     * they keyValue filter, and view filters when applicable.
     */
    QueryModel_defineProperty(this, "filterArray", void 0);
    // QueryModel only fields
    /**
     * Array of [[GridMessage]]. When used with a [[GridPanel]], these message will be shown above the table of data rows.
     */
    QueryModel_defineProperty(this, "messages", void 0);
    /**
     * Array of row key values in sort order from the loaded data rows object.
     */
    QueryModel_defineProperty(this, "orderedRows", void 0);
    /**
     * [[QueryInfo]] object for the given QueryModel.
     */
    QueryModel_defineProperty(this, "queryInfo", void 0);
    /**
     * Error message from API call to load the query info.
     */
    QueryModel_defineProperty(this, "queryInfoError", void 0);
    /**
     * [[LoadingState]] for the API call to load the query info.
     */
    QueryModel_defineProperty(this, "queryInfoLoadingState", void 0);
    /**
     * Object containing the data rows loaded for the given QueryModel. The object key is the primary key value for the row
     * and the object values is the row values for the given key.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    QueryModel_defineProperty(this, "rows", void 0);
    /**
     * The count of rows returned from the query for the given QueryModel. If includeTotalCount is true, this will
     * be the total count of rows for the query parameters.
     */
    QueryModel_defineProperty(this, "rowCount", void 0);
    /**
     * Error message from API call to load the data rows.
     */
    QueryModel_defineProperty(this, "rowsError", void 0);
    /**
     * [[LoadingState]] for the API call to load the data rows.
     */
    QueryModel_defineProperty(this, "rowsLoadingState", void 0);
    /**
     * ReportId, from the URL, to be used for showing a chart via the [[ChartMenu]].
     */
    QueryModel_defineProperty(this, "selectedReportId", void 0);
    /**
     * [[SelectionPivot]] object that describes the current selection pivot row for shift-select behavior.
     */
    QueryModel_defineProperty(this, "selectionPivot", void 0);
    /**
     * Array of row keys for row selections in the QueryModel.
     */
    QueryModel_defineProperty(this, "selections", void 0);
    // Note: ES6 Set is being used here, not Immutable Set.
    /**
     * Error message from API call to load the row selections.
     */
    QueryModel_defineProperty(this, "selectionsError", void 0);
    /**
     * [[LoadingState]] for the API call to load the row selections.
     */
    QueryModel_defineProperty(this, "selectionsLoadingState", void 0);
    /**
     * Error message from API call to load the total count.
     */
    QueryModel_defineProperty(this, "totalCountError", void 0);
    /**
     * [[LoadingState]] for the API call to load the total count.
     */
    QueryModel_defineProperty(this, "totalCountLoadingState", void 0);
    /**
     * Array of [[DataViewInfo]] objects that define the charts attached to the given QueryModel.
     */
    QueryModel_defineProperty(this, "charts", void 0);
    /**
     * Error message from API call to load the chart definitions.
     */
    QueryModel_defineProperty(this, "chartsError", void 0);
    /**
     * [[LoadingState]] for the API call to load the chart definitions.
     */
    QueryModel_defineProperty(this, "chartsLoadingState", void 0);
    const {
      schemaQuery,
      keyValue
    } = queryConfig;
    this.baseFilters = queryConfig.baseFilters ?? [];
    this.containerFilter = queryConfig.containerFilter;
    this.containerPath = queryConfig.containerPath;
    this.selectionContainerPath = queryConfig.selectionContainerPath ?? this.containerPath;

    // Even though this is a situation that we shouldn't be in due to the type annotations it's still possible
    // due to conversion from any, and it's best to have a specific error than an error due to undefined later
    // when we try to use the model during an API request.
    if (schemaQuery === undefined) {
      throw new Error('schemaQuery is required to instantiate a QueryModel');
    }

    // Default to the Details view if we have a keyValue and the user hasn't specified a view.
    // Note: this default may not be appropriate outside of Biologics/SM
    if (keyValue !== undefined && schemaQuery.viewName === undefined) {
      const {
        schemaName,
        queryName
      } = schemaQuery;
      this.schemaQuery = new SchemaQuery(schemaName, queryName, ViewInfo.DETAIL_NAME);
      this.bindURL = false;
    } else {
      this.schemaQuery = schemaQuery;
      this.bindURL = queryConfig.bindURL ?? false;
    }
    this.id = queryConfig.id ?? createQueryModelId(this.schemaQuery);
    this.includeDetailsColumn = queryConfig.includeDetailsColumn ?? false;
    this.includeUpdateColumn = queryConfig.includeUpdateColumn ?? false;
    this.includeTotalCount = queryConfig.includeTotalCount ?? false;
    this.keyValue = queryConfig.keyValue;
    this.maxRows = queryConfig.maxRows ?? DEFAULT_MAX_ROWS;
    this.offset = queryConfig.offset ?? DEFAULT_OFFSET;
    this.omittedColumns = queryConfig.omittedColumns ?? [];
    this.queryParameters = queryConfig.queryParameters;
    this.requiredColumns = queryConfig.requiredColumns ?? [];
    this.requiredColumnsAsQueryInfoFields = queryConfig.requiredColumnsAsQueryInfoFields ?? false;
    this.sorts = queryConfig.sorts ?? [];
    this.rowsError = undefined;
    this.filterArray = queryConfig.filterArray ?? [];
    this.messages = [];
    this.queryInfo = undefined;
    this.queryInfoError = undefined;
    this.queryInfoLoadingState = LoadingState.INITIALIZED;
    this.orderedRows = undefined;
    this.rows = undefined;
    this.rowCount = undefined;
    this.rowsLoadingState = LoadingState.INITIALIZED;
    this.selectedReportId = undefined;
    this.selectionPivot = undefined;
    this.selections = undefined;
    this.selectionsError = undefined;
    this.selectionsLoadingState = LoadingState.INITIALIZED;
    this.title = queryConfig.title;
    this.totalCountError = undefined;
    this.totalCountLoadingState = LoadingState.INITIALIZED;
    this.urlPrefix = queryConfig.urlPrefix ?? 'query'; // match Data Region defaults
    this.useSavedSettings = queryConfig.useSavedSettings ?? false;
    this.charts = undefined;
    this.chartsError = undefined;
    this.chartsLoadingState = LoadingState.INITIALIZED;
  }
  get schemaName() {
    return this.schemaQuery.schemaName;
  }
  get queryName() {
    return this.schemaQuery.queryName;
  }
  get viewName() {
    return this.schemaQuery.viewName;
  }
  get currentView() {
    return this.queryInfo?.getView(this.viewName, true);
  }

  /**
   * Array of [[QueryColumn]] objects from the [[QueryInfo]] "\~\~DETAILS\~\~" view. This will exclude those columns listed
   * in omittedColumns.
   */
  get detailColumns() {
    return this.queryInfo?.getDetailDisplayColumns(ViewInfo.DETAIL_NAME, this.omittedColumns);
  }

  /**
   * Array of [[QueryColumn]] objects from the [[QueryInfo]] view. This will exclude those columns listed
   * in omittedColumns.
   */
  get displayColumns() {
    return this.queryInfo?.getDisplayColumns(this.viewName, this.omittedColumns);
  }

  // Issue 50607: Updated field labels are not shown in the grid if the default grid view has been changed.
  getCustomViewTitleOverride(column) {
    const label = column.customViewTitle;
    const originalCol = this.queryInfo.getColumn(column.fieldKey);
    if (!originalCol || originalCol.caption !== label) return label;
    return '';
  }

  /**
   * Array of all [[QueryColumn]] objects from the [[QueryInfo]] view. This will exclude those columns listed
   * in omittedColumns.
   */
  get allColumns() {
    return this.queryInfo?.getAllColumns(this.viewName, this.omittedColumns);
  }

  /**
   * Array of [[QueryColumn]] objects from the [[QueryInfo]] "\~\~UPDATE\~\~" view. This will exclude those columns listed
   * in omittedColumns.
   */
  get updateColumns() {
    return this.queryInfo?.getUpdateDisplayColumns(ViewInfo.UPDATE_NAME, this.omittedColumns);
  }

  /**
   * Array of primary key [[QueryColumn]] objects from the [[QueryInfo]].
   */
  get keyColumns() {
    return this.queryInfo?.getPkCols();
  }
  get uniqueIdColumns() {
    return this.allColumns.filter(column => column.isUniqueIdColumn);
  }

  /**
   * @hidden
   *
   * Get an array of filters to use for the details view, which includes the base filters but explicitly excludes
   * the "replaced" column filter for the assay run case. For internal use only.
   *
   * Issue 39765: When viewing details for assays, we need to apply an "is not blank" filter on the "Replaced" column
   * in order to see replaced assay runs.  So this is the one case (we know of) where we want to apply base filters
   * when viewing details since the default view restricts the set of items found.
   *
   * Applying other base filters will be problematic (Issue 39719) in that they could possibly exclude the row you are
   * trying to get details for.
   */
  get detailFilters() {
    return this.baseFilters.filter(filter => filter.getColumnName().toLowerCase() === 'replaced');
  }
  getModelFilters(excludeViewFilters) {
    const {
      baseFilters,
      queryInfo,
      keyValue
    } = this;
    if (!queryInfo) {
      // Throw an error because this method is only used when making an API request, and if we don't have a
      // QueryInfo then we're going to make a bad request. It's better to error here before hitting the server.
      throw new Error('Cannot get filters, no QueryInfo available');
    }
    if (this.keyValue !== undefined) {
      const pkFilter = [];
      if (queryInfo.pkCols.length === 1) {
        pkFilter.push(api_.Filter.create(queryInfo.pkCols[0], keyValue));
      } else {
        // Note: This behavior of not throwing an error, and continuing despite not having a single PK column is
        // inherited from QueryGridModel, we may want to rethink this before widely adopting this API.
        const warning = 'Too many keys. Unable to filter for specific keyValue.';
        console.warn(warning, queryInfo.pkCols);
      }
      return [...pkFilter, ...this.detailFilters];
    }
    if (excludeViewFilters) {
      // Issue 49634: LKSM: Saving search filters in default grid view has odd behavior
      const searchViewFilters = this.viewFilters.filter(f => f.getColumnName() === '*');
      return [...baseFilters, ...searchViewFilters];
    }
    return [...baseFilters, ...this.viewFilters];
  }
  get modelFilters() {
    return this.getModelFilters(false);
  }
  get viewFilters() {
    const {
      queryInfo,
      viewName
    } = this;
    if (!queryInfo) {
      // Throw an error because this method is only used when making an API request, and if we don't have a
      // QueryInfo then we're going to make a bad request. It's better to error here before hitting the server.
      throw new Error('Cannot get filters, no QueryInfo available');
    }
    return [...queryInfo.getFilters(viewName)];
  }
  loadRowsFilters(excludeViewFilters) {
    const modelFilters = this.getModelFilters(excludeViewFilters);
    if (this.keyValue !== undefined) return modelFilters;
    return [...modelFilters, ...this.filterArray];
  }

  /**
   * An array of [Filter.IFilter](https://labkey.github.io/labkey-api-js/interfaces/Filter.IFilter.html) objects
   * for the QueryModel. If a keyValue is provided, this will be a filter on the primary key column concatenated with
   * the detailFilters. Otherwise, this will be a concatenation of the baseFilters, filterArray, and [[QueryInfo]] view filters.
   */
  get filters() {
    return this.loadRowsFilters(false);
  }

  /**
   * Comma-delimited string of fieldKeys for requiredColumns, keyColumns, and displayColumns. If provided, the
   * omittedColumns will be removed from this list.
   */
  get columnString() {
    const {
      queryInfo
    } = this;
    if (!queryInfo) {
      // Throw an error because this method is only used when making an API request, and if we don't have a
      // QueryInfo then we're going to make a bad request. It's better to error here before hitting the server.
      throw new Error('Cannot construct column string, no QueryInfo available');
    }
    return this.getRequestColumnsString();
  }
  getRequestColumnsString(requiredColumns, omittedColumns, isForUpdate) {
    const _requiredColumns = requiredColumns ?? this.requiredColumns;
    const _omittedColumns = omittedColumns ?? this.omittedColumns;

    // Note: ES6 Set is being used here, not Immutable Set
    const uniqueFieldKeys = new Set();
    this.keyColumns.forEach(col => uniqueFieldKeys.add(col.fieldKey));
    this.uniqueIdColumns.forEach(col => uniqueFieldKeys.add(col.fieldKey));

    // Issue 46478: Include update columns in requested columns to ensure values are available
    if (isForUpdate) {
      this.updateColumns.forEach(col => uniqueFieldKeys.add(col.fieldKey));
    } else {
      this.displayColumns.forEach(col => uniqueFieldKeys.add(col.fieldKey));
    }

    // add requiredColumns last so fieldKeys from QueryColumns are preferred, when there is a case difference
    // For example, choose Ancestors/RegistryAndSources/Participant (from displayColumns) over Ancestors/RegistryAndSources/participant (from requiredColumns)
    _requiredColumns?.forEach(col => uniqueFieldKeys.add(col));
    let fieldKeys = Array.from(uniqueFieldKeys);
    if (_omittedColumns.length) {
      const lowerOmit = new Set(_omittedColumns.map(c => c.toLowerCase()));
      fieldKeys = fieldKeys.filter(fieldKey => !lowerOmit.has(fieldKey.toLowerCase()));
    }

    // remove duplicate
    const fieldKeysLc = new Set(),
      fieldKeysCleaned = [];
    fieldKeys.forEach(fieldKey => {
      if (!fieldKeysLc.has(fieldKey.toLowerCase())) {
        fieldKeysCleaned.push(fieldKey);
        fieldKeysLc.add(fieldKey.toLowerCase());
      }
    });
    return fieldKeysCleaned.join(',');
  }

  /**
   * Comma-delimited string of fields that appear in an export. These are the same as the display columns but
   * do not exclude omitted columns.
   */
  get exportColumnString() {
    return this.displayColumns.map(column => column.fieldKey).join(',');
  }

  /**
   * An array of load-related errors on this model. This specifically targets errors related to initializing and/or
   * loading data. Subsequent errors that can occur (e.g. charting errors, selection errors, etc) are not included
   * as those are intended to be handled explicitly.
   */
  get loadErrors() {
    return [this.queryInfoError, this.rowsError].filter(e => !!e);
  }

  /**
   * Comma-delimited string of sorts from the [[QueryInfo]] sorts property. If the view has defined sorts, they
   * will be concatenated with the sorts property.
   */
  get sortString() {
    const {
      sorts,
      viewName,
      queryInfo
    } = this;
    if (!queryInfo) {
      // Throw an error because this method is only used when making an API request, and if we don't have a
      // QueryInfo then we're going to make a bad request. It's better to error here before hitting the server.
      throw new Error('Cannot construct sort string, no QueryInfo available');
    }
    let sortStrings = sorts.map(sortStringMapper);
    const viewSorts = queryInfo.getSorts(viewName).map(sortStringMapper);
    if (viewSorts.length > 0) {
      sortStrings = sortStrings.concat(viewSorts);
    }
    return sortStrings.join(',');
  }

  /**
   * Returns the data needed for a <Grid /> component to render.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get gridData() {
    const {
      selections
    } = this;
    return this.orderedRows.map(value => {
      const row = this.rows[value];
      if (selections) {
        return QueryModel_objectSpread(QueryModel_objectSpread({}, row), {}, {
          [GRID_SELECTION_INDEX]: selections.has(value)
        });
      }
      return row;
    });
  }

  /**
   * Returns an object representing the query params of the model. Used when updating the URL when bindURL is set to
   * true.
   */
  get urlQueryParams() {
    const {
      currentPage,
      urlPrefix,
      filterArray,
      maxRows,
      selectedReportId,
      sorts,
      viewName
    } = this;
    const filters = filterArray.filter(f => f.getColumnName() !== '*');
    const searches = filterArray.filter(f => f.getColumnName() === '*').map(f => f.getValue()).join(';');
    // ReactRouter location.query is typed as any.
    const modelParams = {};
    if (currentPage !== 1) {
      modelParams[`${urlPrefix}.p`] = currentPage.toString(10);
    }
    if (maxRows !== DEFAULT_MAX_ROWS) {
      modelParams[`${urlPrefix}.pageSize`] = maxRows.toString(10);
    }
    if (viewName !== undefined) {
      modelParams[`${urlPrefix}.view`] = viewName;
    }
    if (sorts.length > 0) {
      modelParams[`${urlPrefix}.sort`] = sorts.map(sortStringMapper).join(',');
    }
    if (searches.length > 0) {
      modelParams[`${urlPrefix}.q`] = searches;
    }
    if (selectedReportId) {
      modelParams[`${urlPrefix}.reportId`] = selectedReportId;
    }
    filters.forEach(filter => {
      modelParams[filter.getURLParameterName(urlPrefix)] = filter.getURLParameterValue();
    });
    return modelParams;
  }

  /**
   * Gets a column by fieldKey.
   * @param fieldKey: string
   */
  getColumnByFieldKey(fieldKey) {
    const locFieldKey = fieldKey.toLowerCase();
    return this.allColumns?.find(c => c.fieldKey?.toLowerCase() === locFieldKey);
  }

  /**
   * Gets a column by name. Implementation adapted from parseColumns in grid/utils.ts.
   * @param name: string
   */
  getColumn(name) {
    const lowered = name.toLowerCase();
    const isLookup = lowered.indexOf('/') > -1;
    const allColumns = this.allColumns;

    // First find all possible matches by name/lookup
    const columns = allColumns.filter(queryColumn => {
      if (isLookup && queryColumn.isLookup()) {
        return queryColumn.name.toLowerCase() === lowered || queryColumn.displayField?.toLowerCase() === lowered;
      }
      return queryColumn.name.toLowerCase() === lowered;
    });

    // Use exact match first, else first possible match
    let column = columns.find(c => c.name.toLowerCase() === lowered || c.displayField?.toLowerCase() === lowered);
    if (column === undefined && columns.length > 0) {
      column = columns[0];
    }
    if (column !== undefined) {
      return column;
    }

    // Fallback to finding by shortCaption
    return allColumns.find(column => {
      return column.shortCaption.toLowerCase() === lowered;
    });
  }

  /**
   * Returns the data for the specified key parameter on the QueryModel.rows object.
   * If no key parameter is provided, the first data row will be returned.
   * @param key
   * @param flattenValues True to flatten the row object to just the key: value pairs
   */
  getRow(key, flattenValues = false) {
    if (!this.hasRows) {
      return undefined;
    }
    if (key === undefined) {
      key = this.orderedRows[0];
    }
    const row = this.rows[key];
    return flattenValues ? flattenValuesFromRow(row, this.queryInfo.getColumnFieldKeys()) : row;
  }

  /**
   * Returns the value of a specific column in the first row.
   * @param columnName Case insensitive name of the column.
   */
  getRowValue(columnName) {
    return caseInsensitive(this.getRow(), columnName)?.value;
  }

  /**
   * Get the total page count for the results rows in this QueryModel-based on the total row count and the
   * max rows per page value.
   */
  get pageCount() {
    const {
      maxRows,
      rowCount
    } = this;
    return maxRows > 0 ? Math.ceil(rowCount / maxRows) : 1;
  }

  /**
   * Get the current page number based off of the results offset and max rows per page values.
   */
  get currentPage() {
    const {
      offset,
      maxRows
    } = this;
    return offset > 0 ? Math.floor(offset / maxRows) + 1 : 1;
  }

  /**
   * Get the last page offset value for the given QueryModel rows.
   */
  get lastPageOffset() {
    return (this.pageCount - 1) * this.maxRows;
  }

  /**
   * An array of [[ViewInfo]] objects for the saved views for the given QueryModel. Note that the returned array
   * will be sorted by view label.
   */
  get views() {
    return this.queryInfo?.views.valueArray.sort(naturalSortByProperty('label')) || [];
  }

  /**
   * An array of [[ViewInfo]] objects that are visible for a user to choose in the view menu. Note that the returned
   * array will be sorted by view label.
   */
  get visibleViews() {
    return this.queryInfo?.getVisibleViews();
  }

  /**
   * True if data has been loaded, even if no rows were returned.
   */
  get hasData() {
    return this.rows !== undefined;
  }

  /** True if there are any load errors. */
  get hasLoadErrors() {
    return this.loadErrors.length > 0;
  }

  /**
   * True if the model has > 0 rows.
   */
  get hasRows() {
    return this.hasData && Object.keys(this.rows).length > 0;
  }

  /**
   * True if the charts have been loaded, even if there are no saved charts returned.
   */
  get hasCharts() {
    return this.charts !== undefined;
  }

  /**
   * True if the QueryModel has row selections.
   */
  get hasSelections() {
    return this.selections?.size > 0;
  }

  /**
   * Key to attach to selections, which are specific to a view
   */
  get selectionKey() {
    return this.id + (this.viewName && this.viewName !== ViewInfo.DETAIL_NAME ? '/' + encodePart(this.viewName).toLowerCase() : '');
  }

  /**
   * Return the selection ids as an array of integers.
   */
  getSelectedIdsAsInts() {
    if (this.selections) {
      return Array.from(this.selections).map(id => parseInt(id));
    }
    return undefined;
  }

  /**
   * Return the selection ids as an optionally filtered, array.
   */
  getSelectedIds(filterIds = []) {
    if (this.selections) {
      return Array.from(this.selections).filter(s => filterIds.indexOf(parseInt(s, 10)) === -1);
    }
    return undefined;
  }

  /**
   * Get the row selection state (ALL, SOME, or NONE) for the QueryModel.
   */
  get selectedState() {
    const {
      hasData,
      isLoading,
      maxRows,
      orderedRows,
      selections,
      rowCount
    } = this;
    if (!isLoading && hasData && selections) {
      const selectedOnPage = orderedRows.filter(rowId => selections.has(rowId)).length;
      if ((selectedOnPage === rowCount || selectedOnPage === maxRows) && rowCount > 0) {
        return GRID_CHECKBOX_OPTIONS.ALL;
      } else if (selectedOnPage > 0) {
        // if model has any selected on the page show checkbox as indeterminate
        return GRID_CHECKBOX_OPTIONS.SOME;
      }
    }

    // Default to none.
    return GRID_CHECKBOX_OPTIONS.NONE;
  }

  /**
   * True if either the query info or rows of the QueryModel are still loading.
   */
  get isLoading() {
    if (this.hasLoadErrors) return false;
    return isLoading(this.queryInfoLoadingState, this.rowsLoadingState);
  }

  /**
   * True if the QueryModel is loading its chart definitions.
   */
  get isLoadingCharts() {
    return isLoading(this.chartsLoadingState);
  }

  /**
   * True if the QueryModel is loading its row selections.
   */
  get isLoadingSelections() {
    return isLoading(this.selectionsLoadingState);
  }

  /**
   * True if the QueryModel is loading its total count.
   */
  get isLoadingTotalCount() {
    return isLoading(this.totalCountLoadingState);
  }

  /**
   * True if the QueryModel is actively loading its total count, or if it's loading rows (which might include total count).
   */
  get isActivelyLoadingTotalCount() {
    return this.rowsLoadingState === LoadingState.LOADING && !this.includeTotalCount || this.totalCountLoadingState === LoadingState.LOADING;
  }

  /**
   * True if the current page is the last page for the given QueryModel rows.
   */
  get isLastPage() {
    return this.currentPage === this.pageCount;
  }

  /**
   * True if the current page is the first page for the given QueryModel rows.
   */
  get isFirstPage() {
    return this.currentPage === 1;
  }

  /**
   * Returns the data needed for pagination by the [[Pagination]] component.
   */
  get paginationData() {
    return {
      currentPage: this.currentPage,
      disabled: this.isLoading,
      isFirstPage: this.isFirstPage,
      isLastPage: this.isLastPage,
      offset: this.offset,
      pageCount: this.pageCount,
      pageSize: this.maxRows,
      rowCount: this.rowCount,
      totalCountLoadingState: this.totalCountLoadingState
    };
  }
  get showImportDataButton() {
    return !!this.queryInfo?.getShowImportDataButton();
  }
  get showInsertNewButton() {
    return !!this.queryInfo?.getShowInsertNewButton();
  }
  get isAppEditable() {
    return !!this.queryInfo?.isAppEditable();
  }
  get isFiltered() {
    return this.baseFilters?.length > 0 || this.filterArray?.length > 0 || this.queryInfo?.getFilters(this.schemaQuery.viewName)?.length > 0;
  }
  get queryConfig() {
    return {
      baseFilters: Array.from(this.baseFilters),
      bindURL: this.bindURL,
      containerFilter: this.containerFilter,
      containerPath: this.containerPath,
      filterArray: Array.from(this.filterArray),
      id: this.id,
      includeDetailsColumn: this.includeDetailsColumn,
      keyValue: this.keyValue,
      maxRows: this.maxRows,
      offset: this.offset,
      omittedColumns: Array.from(this.omittedColumns),
      queryParameters: QueryModel_objectSpread({}, this.queryParameters),
      requiredColumns: Array.from(this.requiredColumns),
      schemaQuery: this.schemaQuery,
      sorts: this.sorts,
      title: this.title,
      urlPrefix: this.urlPrefix
    };
  }
  get loadRowsConfig() {
    return {
      schemaQuery: this.schemaQuery,
      viewName: this.viewName,
      containerPath: this.containerPath,
      containerFilter: this.containerFilter,
      filterArray: this.loadRowsFilters(true),
      sort: this.sortString,
      columns: this.columnString,
      parameters: this.queryParameters,
      maxRows: this.maxRows,
      offset: this.offset,
      includeDetailsColumn: this.includeDetailsColumn,
      includeUpdateColumn: this.includeUpdateColumn
    };
  }

  /**
   * Returns the model attributes given a set of queryParams from the URL. Used for URL Binding.
   * @param searchParams: The URLSearchParams from the react-router useSearchParams hook
   * @param useExistingValues: Set to true if you want to use the values on the model as the default values.
   * Typically, this should be false, because you want to treat the URL as the single source of truth, but when we
   * initialize models we may programmatically want to set an initial value (e.g. a default sort).
   */
  attributesForURLQueryParams(searchParams, useExistingValues = false) {
    const prefix = this.urlPrefix;
    const viewName = searchParams.get(`${prefix}.view`) ?? undefined;
    const searchFilters = searchFiltersFromString(searchParams.get(`${prefix}.q`)) ?? [];
    const columnFilters = api_.Filter.getFiltersFromParameters(getQueryParams(searchParams), prefix);
    let filterArray = columnFilters.concat(searchFilters);
    let maxRows = parseInt(searchParams.get(`${prefix}.pageSize`), 10);
    if (isNaN(maxRows)) maxRows = DEFAULT_MAX_ROWS;
    let offset = offsetFromString(this.maxRows, searchParams.get(`${prefix}.p`)) ?? DEFAULT_OFFSET;
    let schemaQuery = new SchemaQuery(this.schemaName, this.queryName, viewName);
    let selectedReportId = searchParams.get(`${prefix}.reportId`) ?? undefined;
    let sorts = querySortsFromString(searchParams.get(`${prefix}.sort`)) ?? [];

    // If useExistingValues is true we'll assume any value not present on the URL can be overridden by the current
    // model value. This behavior is really only wanted when we are initializing the model.
    if (useExistingValues) {
      if (filterArray.length === 0 && this.filterArray.length > 0) {
        filterArray = this.filterArray;
      }
      if (maxRows === DEFAULT_MAX_ROWS && this.maxRows !== DEFAULT_MAX_ROWS) {
        maxRows = this.maxRows;
      }
      if (offset === 0 && this.offset !== 0) {
        offset = this.offset;
      }
      if (viewName === undefined && this.viewName !== undefined) {
        schemaQuery = this.schemaQuery;
      }
      if (selectedReportId === undefined && this.selectedReportId) {
        selectedReportId = this.selectedReportId;
      }
      if (sorts.length === 0 && this.sorts.length > 0) {
        sorts = this.sorts;
      }
    }
    return {
      filterArray,
      maxRows,
      offset,
      schemaQuery,
      selectedReportId,
      sorts
    };
  }

  /**
   * Returns a deep copy of this model with props applied iff props is not empty/null/undefined else
   * returns this.
   * @param props
   */
  mutate(props) {
    return (0,external_immer_.produce)(this, draft => {
      Object.assign(draft, props);
    });
  }
}
const LOCAL_STORAGE_PREFIX = 'QUERY_MODEL_SETTINGS';
function localStorageKey(modelId, containerPath) {
  return [LOCAL_STORAGE_PREFIX, containerPath, modelId].join(';');
}
function getSettingsFromLocalStorage(id, containerPath) {
  const savedSettings = JSON.parse(localStorage.getItem(localStorageKey(id, containerPath)));
  if (savedSettings === null) return undefined;
  const {
    maxRows,
    viewName
  } = savedSettings;
  const filterArray = savedSettings.filterArray?.map(f => api_.Filter.create(f.columnName, f.value, api_.Filter.getFilterTypeForURLSuffix(f.type)));
  const sorts = savedSettings.sorts?.map(s => querySortFromString(s));
  return {
    filterArray: filterArray ?? [],
    maxRows: maxRows ?? DEFAULT_MAX_ROWS,
    sorts: sorts ?? [],
    viewName
  };
}
const UNIQUE_ERROR = 'Model ID is not unique, cannot save settings to local storage. Use a model ID that is unique and stable.';
function saveSettingsToLocalStorage(model) {
  // Don't serialize anything to localStorage if we're not supposed to use saved settings
  if (!model.useSavedSettings) {
    return;
  }

  // We often use "model" as the default model ID, which is not sufficiently unique to store saved settings.
  if (model.id === 'model') {
    console.error(UNIQUE_ERROR);
    return;
  }
  const settings = {
    filterArray: model.filterArray.map(f => ({
      columnName: f.getColumnName(),
      value: f.getValue(),
      type: f.getFilterType().getURLSuffix()
    })),
    maxRows: model.maxRows,
    sorts: model.sorts.map(sort => sort.toRequestString()),
    viewName: model.viewName
  };
  // The settings for each model are stored in their own object, instead of storing all settings under some
  // root object, because we have to serialize to/from JSON, and it could get very expensive if we had to
  // read/write a large JSON object that stored all settings for all models every time we needed settings for
  // a single model.
  localStorage.setItem(localStorageKey(model.id, model.containerPath), JSON.stringify(settings));
}
function removeSettingsFromLocalStorage(model) {
  localStorage.removeItem(localStorageKey(model.id, model.containerPath));
}
;// CONCATENATED MODULE: ./src/internal/components/picklist/constants.ts
const PRIVATE_PICKLIST_CATEGORY = 'PrivatePicklist';
const PUBLIC_PICKLIST_CATEGORY = 'PublicPicklist';
const MAX_SELECTIONS_PER_ADD = 1000;
const MAX_SELECTIONS_MESSAGE = 'At most ' + MAX_SELECTIONS_PER_ADD.toLocaleString() + ' samples can be selected.';
;// CONCATENATED MODULE: ./src/internal/components/picklist/models.ts
function models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? models_ownKeys(Object(t), !0).forEach(function (r) { models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function models_defineProperty(e, r, t) { return (r = models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function models_toPropertyKey(t) { var i = models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




const PICKLIST_SAMPLE_ID_COLUMN = 'SampleID';
const PICKLIST_KEY_COLUMN = 'id';
class Picklist {
  static create(data) {
    return new Picklist(models_objectSpread(models_objectSpread({}, flattenValuesFromRow(data, Object.keys(data))), {}, {
      CreatedByDisplay: data.CreatedBy?.displayValue
    }));
  }
  constructor(values) {
    models_defineProperty(this, external_immer_.immerable, true);
    models_defineProperty(this, "Container", void 0);
    models_defineProperty(this, "Category", void 0);
    models_defineProperty(this, "CreatedBy", void 0);
    models_defineProperty(this, "CreatedByDisplay", void 0);
    models_defineProperty(this, "Created", void 0);
    models_defineProperty(this, "name", void 0);
    models_defineProperty(this, "listId", void 0);
    models_defineProperty(this, "Description", void 0);
    models_defineProperty(this, "ItemCount", void 0);
    models_defineProperty(this, "sampleTypes", void 0);
    models_defineProperty(this, "hasMedia", void 0);
    Object.assign(this, values);
  }
  isValid() {
    return this.name?.trim().length > 0;
  }
  isUserList(user) {
    return this.CreatedBy === user.id;
  }
  isEditable(user) {
    return this.isUserList(user) && userCanManagePicklists(user);
  }
  isPublic() {
    return this.Category === PUBLIC_PICKLIST_CATEGORY;
  }
  isDeletable(user) {
    return this.isUserList(user) || this.isPublic() && userCanDeletePublicPicklists(user);
  }
  canRemoveItems(user) {
    return this.isUserList(user) || this.isPublic() && userCanManagePicklists(user);
  }
  mutate(props) {
    return (0,external_immer_.produce)(this, draft => {
      Object.assign(draft, props);
    });
  }
}

/**
 * This implements the filter corresponding to PicklistSampleCompareType.  Updates there should also be reflected here.
 */
class PicklistSamplesFilter {
  getDisplaySymbol() {
    return null;
  }
  getDisplayText() {
    return 'Sample for picklist';
  }
  getLongDisplayText() {
    return this.getDisplayText();
  }
  getURLSuffix() {
    return 'picklistsamples';
  }
  isDataValueRequired() {
    return true;
  }
  isMultiValued() {
    return false;
  }
  isTableWise() {
    return false;
  }
  getMultiValueFilter() {
    return null;
  }
  getMultiValueMaxOccurs() {
    return 0;
  }
  getMultiValueMinOccurs() {
    return 0;
  }
  getMultiValueSeparator() {
    return null;
  }
  getOpposite() {
    return null;
  }
  getSingleValueFilter() {
    return null;
  }
  parseValue(value) {
    return value;
  }
  getURLParameterValue(value) {
    return value;
  }
  validate(value, jsonType, columnName) {}
  getLabKeySqlOperator() {
    return null;
  }
}
const PICKLIST_SAMPLES_FILTER = new PicklistSamplesFilter();
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(416);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: external "moment-timezone"
var external_moment_timezone_ = __webpack_require__(528);
var external_moment_timezone_default = /*#__PURE__*/__webpack_require__.n(external_moment_timezone_);
// EXTERNAL MODULE: external "numeral"
var external_numeral_ = __webpack_require__(958);
var external_numeral_default = /*#__PURE__*/__webpack_require__.n(external_numeral_);
;// CONCATENATED MODULE: ./src/internal/util/jDateFormatParser.ts
// This module is an internal migration of the moment-jdateformatparser package.
// Due to incompatibilities and lack of active development (last active September 2018)
// we migrated the logic and tests from the package so we could maintain it.
// Original package: https://github.com/MadMG/moment-jdateformatparser

/** The format pattern mapping from Java format to moment format. */
const javaToMomentFormatMapping = {
  d: 'DD',
  dd: 'DD',
  y: 'YYYY',
  yy: 'YY',
  yyy: 'YYYY',
  yyyy: 'YYYY',
  a: 'A',
  aa: 'A',
  A: 'A',
  M: 'M',
  MM: 'MM',
  MMM: 'MMM',
  MMMM: 'MMMM',
  h: 'h',
  hh: 'hh',
  H: 'H',
  HH: 'HH',
  k: 'H',
  kk: 'HH',
  K: 'h',
  KK: 'hh',
  m: 'm',
  mm: 'mm',
  s: 's',
  ss: 'ss',
  S: 'SSS',
  SS: 'SSS',
  SSS: 'SSS',
  E: 'ddd',
  EE: 'ddd',
  EEE: 'ddd',
  EEEE: 'dddd',
  EEEEE: 'dddd',
  EEEEEE: 'dddd',
  D: 'DDD',
  w: 'W',
  ww: 'WW',
  z: 'ZZ',
  zzzz: 'Z',
  Z: 'ZZ',
  ZZZZ: 'ZZ',
  X: 'ZZ',
  XX: 'ZZ',
  XXX: 'Z',
  u: 'E'
};

/** The format pattern mapping from moment format to Java format. */
const momentToJavaFormatMapping = {
  D: 'd',
  DD: 'dd',
  YY: 'yy',
  YYY: 'yyyy',
  YYYY: 'yyyy',
  a: 'a',
  A: 'a',
  M: 'M',
  MM: 'MM',
  MMM: 'MMM',
  MMMM: 'MMMM',
  h: 'h',
  hh: 'hh',
  H: 'H',
  HH: 'HH',
  m: 'm',
  mm: 'mm',
  s: 's',
  ss: 'ss',
  S: 'S',
  SS: 'S',
  SSS: 'S',
  ddd: 'E',
  dddd: 'EEEE',
  DDD: 'D',
  W: 'w',
  WW: 'ww',
  ZZ: 'z',
  Z: 'XXX',
  E: 'u'
};

/**
 * Checks if the substring is a mapped date format pattern and adds it to the result format String.
 * @param {String}  formatString    The unmodified format String.
 * @param {Object}  mapping         The date format mapping Object.
 * @param {Number}  startIndex      The begin index of the continuous format characters.
 * @param {Number}  currentIndex    The last index of the continuous format characters.
 * @param {String}  resultString    The result format String.
 */
function _appendMappedString(formatString, mapping, startIndex, currentIndex, resultString) {
  if (startIndex !== -1) {
    let tempString = formatString.substring(startIndex, currentIndex);

    // check if the temporary string has a known mapping
    if (mapping[tempString]) {
      tempString = mapping[tempString];
    }
    resultString += tempString;
  }
  return resultString;
}

/** Translates the format string using the supplied mappings. */
function translateFormat(formatString, mapping) {
  var len = formatString.length;
  var i = 0;
  var startIndex = -1;
  var lastChar = null;
  var currentChar = '';
  var resultString = '';
  for (; i < len; i++) {
    currentChar = formatString.charAt(i);
    if (lastChar === null || lastChar !== currentChar) {
      // change detected
      resultString = _appendMappedString(formatString, mapping, startIndex, i, resultString);
      startIndex = i;
    }
    lastChar = currentChar;
  }
  return _appendMappedString(formatString, mapping, startIndex, i, resultString);
}
const javaDateFormatCache = {};
const regexp = /[^']+|('[^']*')/g;

/** Translates a Java date format string to a moment format String. */
function jDateFormatParser_toMomentFormatString(javaDateFormatString) {
  if (!javaDateFormatCache[javaDateFormatString]) {
    let mapped = '';
    let part = '';
    while (part = regexp.exec(javaDateFormatString)) {
      part = part[0];
      if (part.match(/'(.*?)'/)) {
        mapped += '[' + part.substring(1, part.length - 1) + ']';
      } else {
        mapped += translateFormat(part, javaToMomentFormatMapping);
      }
    }
    javaDateFormatCache[javaDateFormatString] = mapped;
  }
  return javaDateFormatCache[javaDateFormatString];
}

/** Format a moment instance with the given Java date format String. */
function formatWithJDF(date, javaDateFormatString) {
  return date.format(jDateFormatParser_toMomentFormatString(javaDateFormatString));
}
const momentDateFormatsCache = {};

/** Translates the moment format string to a Java date format string */
function toJDFString(momentFormatString) {
  if (!momentDateFormatsCache[momentFormatString]) {
    momentDateFormatsCache[momentFormatString] = translateFormat(momentFormatString, momentToJavaFormatMapping);
  }
  return momentDateFormatsCache[momentFormatString];
}
;// CONCATENATED MODULE: ./src/internal/util/Date.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






function datePlaceholder(col) {
  let placeholder;
  if (col) {
    const rangeURI = col.rangeURI?.toLowerCase() ?? 'datetime';

    // attempt to use the rangeURI to figure out if we are working with a dateTime or date object
    // note Created and Modified columns do not include the rangeURI information
    if (rangeURI.indexOf('datetime') > -1) {
      placeholder = getMomentDateTimeFormat();
    } else if (rangeURI.indexOf('date') > -1) {
      placeholder = getMomentDateFormat();
    } else if (rangeURI === TIME_RANGE_URI.toLowerCase()) {
      placeholder = getMomentTimeFormat();
    } else {
      placeholder = getMomentDateTimeFormat();
    }
  }
  return placeholder;
}
function isDateTimeCol(col) {
  if (col) {
    const rangeURI = col.rangeURI?.toLowerCase();

    // attempt to use the rangeURI to figure out if we are working with a dateTime or date object
    // note Created and Modified columns do not include the rangeURI information
    if (rangeURI?.indexOf('datetime') > -1) {
      return true;
    }

    // material.materialexpdate is a non domain property datetime field that doesn't have rangeURI, but should be treated as datetime
    if (!rangeURI && col?.jsonType === 'date' && col?.name.toLowerCase() === 'materialexpdate') {
      return true;
    }
  }
  return false;
}
function dateFNSToMoment(dateFNSFormat) {
  return dateFNSFormat?.replace('yyyy', 'YYYY').replace('yy', 'YY').replace('dd', 'DD').replace('xxx', 'ZZ');
}
function momentToDateFNS(momentFormat) {
  // Issue 48608: DateFNS throws errors when formatting 'Z'
  // date-fns (or react-datepicker's usage of date-fns) throws errors when 'Z' is part of the format.
  // Even though 'z' is declared part of the date-fns format it does not work either.
  // Thus, falling back to 'xxx' as the most appropriate match.
  // https://github.com/date-fns/date-fns/issues/1857
  return momentFormat?.replace('YYYY', 'yyyy') // 0044, 0001, 1900, 2017
  .replace('YY', 'yy') // 44, 01, 00, 17
  .replace('DD', 'dd') // 01, 02, ..., 31
  .replace('A', 'a').replace(/Z+/gi, 'xxx'); // -08:00, +05:30, +00:00
}
function getPickerDateAndTimeFormat(queryColumn, hideTime) {
  const dateFormat = getColDateFormat(queryColumn, hideTime ? 'Date' : undefined, queryColumn.isDateOnlyColumn);
  const isTimeOnly = queryColumn.isTimeColumn;
  const timeFormat = hideTime ? undefined : isTimeOnly ? parseFNSTimeFormat(getColDateFormat(queryColumn, queryColumn?.format ?? 'Time')) : parseDateFNSTimeFormat(dateFormat);
  return {
    dateFormat,
    timeFormat
  };
}
function getFormattedTimeString(date, queryColumn) {
  if (!date) return null;
  const formatStr = getColDateFormat(queryColumn, queryColumn.format ?? 'Time');
  if (!formatStr) return getJsonTimeFormatString(date);
  try {
    return moment(date).format(toMomentFormatString(formatStr));
  } catch (e) {
    return getJsonTimeFormatString(date);
  }
}
function getFormattedStringFromDate(date, queryColumn, hideTime) {
  if (!date) return undefined;
  const isTimeOnly = queryColumn.isTimeColumn;
  const isDateOnly = queryColumn.isDateOnlyColumn || hideTime;
  const rawType = isTimeOnly ? 'Time' : isDateOnly ? 'Date' : 'DateTime';
  const formatStr = getColDateFormat(queryColumn, queryColumn.format ?? rawType);
  if (!formatStr) {
    return getJsonFormatString(date, rawType);
  }
  try {
    return external_moment_default()(date).format(jDateFormatParser_toMomentFormatString(formatStr));
  } catch (e) {
    return getJsonFormatString(date, rawType);
  }
}
function getColDateFormat(queryColumn, dateFormat, dateOnly) {
  let rawFormat = dateFormat || queryColumn?.format;
  if (!rawFormat) {
    if (dateOnly) rawFormat = getMomentDateFormat();else rawFormat = datePlaceholder(queryColumn);
  }

  // Issue 44011: account for the shortcut values (i.e. "Date", "DateTime", and "Time")
  if (rawFormat === 'Date') rawFormat = getMomentDateFormat();
  if (rawFormat === 'DateTime') rawFormat = getMomentDateTimeFormat();
  if (rawFormat === 'Time') rawFormat = getMomentTimeFormat();

  // Moment.js and react datepicker date format is different
  // https://github.com/Hacker0x01/react-datepicker/issues/1609
  return momentToDateFNS(rawFormat);
}
function parseFNSTimeFormat(timePart) {
  if (!timePart || timePart.indexOf(':') == -1) return undefined;
  if (timePart.indexOf('H') > -1 || timePart.indexOf('k') > -1) {
    if (timePart.indexOf('s') > 0) return 'HH:mm:ss'; // 13:30:00
    return 'HH:mm'; // 13:30
  } else if (timePart.indexOf('h') > -1 || timePart.indexOf('K') > -1) {
    if (timePart.indexOf('s') > 0) return 'hh:mm:ss a'; // 01:30:00 PM
    return 'hh:mm a'; // 01:30 PM
  }
  return undefined;
}

// Issue 48300: Respect 12-hour vs 24-hour time display format
// This method attempts to determine if the time portion of date format is in either 12-hour or 24-hour format.
// If the time format can be determined, then it will return a constant dateFNS time format.
// NK: That said, this is a far-reaching over simplification / contrived implementation which presumes the time
// format follows the date format. For a more precise implementation we would search for time-specific portions within
// the string (or use some more grand date format parsing library utility), however, there are so many different
// formats (Java, Moment, Date-FNS, JavaScript, etc) and a seemingly infinite number of ways to configure a date/time
// format that I've elected to just assume the second part of a space-split string that contains a ":" is the time
// format (e.g. it supports formats similar to "yyyy-MM-dd hh:mm" or "yyyy-MM-dd hh:mm a").
function parseDateFNSTimeFormat(dateFormat) {
  if (!dateFormat) return undefined;
  let splitIndex = dateFormat.indexOf(' ');
  let format;
  if (splitIndex > -1) {
    const remaining = dateFormat.substring(splitIndex + 1);
    format = parseFNSTimeFormat(remaining);
    if (!format && remaining.indexOf(' h') > 0) {
      // yyyy MM dd hh:mm
      splitIndex = remaining.indexOf(' h');
      format = parseFNSTimeFormat(remaining.substring(splitIndex + 1));
    }
  }
  return format;
}
function _getColFormattedDateFilterValue(column, value) {
  let valueFull = value;
  if (value && typeof value === 'string' && value.match(/^\s*(\d\d\d\d)-(\d\d)-(\d\d)\s*$/)) {
    valueFull = value + 'T00:00:00'; // Force local timezone. In ISO format, if you provide time and Z is not present in the end of string, the date will be local time zone instead of UTC time zone.
  }
  const dateFormat = getColDateFormat(column, null, true); // date or datetime fields always filter by 'date' portion only
  return formatDate(new Date(valueFull), null, dateFormat);
}
function getColFormattedDateFilterValue(column, value) {
  if (value instanceof Array) {
    const results = [];
    value.forEach(val => {
      results.push(_getColFormattedDateFilterValue(column, val));
    });
    return results;
  }
  return _getColFormattedDateFilterValue(column, value);
}
function _getColFormattedTimeFilterValue(column, value) {
  if (!value) return value;
  const timeFormat = getColDateFormat(column, column?.format ?? 'Time', false);
  if (!timeFormat) return value;
  const valueFormat = value.toLowerCase().indexOf(' am') > 0 || value.toLowerCase().indexOf(' pm') > 0 ? 'hh:mm:ss a' : 'HH:mm:ss';
  return external_moment_default()(value, valueFormat).format(jDateFormatParser_toMomentFormatString(timeFormat));
}
function getColFormattedTimeFilterValue(column, value) {
  if (value instanceof Array) {
    const results = [];
    value.forEach(val => {
      results.push(_getColFormattedTimeFilterValue(column, val));
    });
    return results;
  }
  return _getColFormattedTimeFilterValue(column, value);
}
function parseSimpleTime(rawValue) {
  if (!rawValue) return null;
  const parts = rawValue.toString().split(':').length;
  let hourMinite = 'HH:mm',
    ampm = '';
  const second = parts > 2 ? ':ss' : '';
  if (rawValue.toString().toLowerCase().indexOf('am') > -1 || rawValue.toString().toLowerCase().indexOf('pm') > -1) {
    ampm = ' a';
    hourMinite = 'hh:mm';
  }
  const format = hourMinite + second + ampm;
  return external_moment_default()(rawValue, format).toDate();
}
function getDateFormat(container) {
  return (container ?? (0,api_.getServerContext)().container).formats.dateFormat;
}
function getDateTimeFormat(container) {
  return (container ?? (0,api_.getServerContext)().container).formats.dateTimeFormat;
}
function getTimeFormat(container) {
  return (container ?? (0,api_.getServerContext)().container).formats.timeFormat;
}

// Issue 30834: get look and feel display formats
function getMomentDateFormat(container) {
  return jDateFormatParser_toMomentFormatString((container ?? (0,api_.getServerContext)().container).formats.dateFormat);
}
function getMomentDateTimeFormat(container) {
  return jDateFormatParser_toMomentFormatString((container ?? (0,api_.getServerContext)().container).formats.dateTimeFormat);
}

// hard-coded value, see docs: https://www.labkey.org/Documentation/Archive/21.7/wiki-page.view?name=studyDateNumber#short
function getMomentTimeFormat(container) {
  return jDateFormatParser_toMomentFormatString((container ?? (0,api_.getServerContext)().container).formats.timeFormat) ?? 'HH:mm:ss';
}
function parseDate(dateStr, dateFormat, minDate, timeOnly, dateOnly) {
  if (!dateStr) return null;

  // Moment.js and react datepicker date format is different
  // https://github.com/Hacker0x01/react-datepicker/issues/1609
  const _dateFormat = dateFNSToMoment(dateFormat);
  let validDate;
  if (_dateFormat) {
    const date = external_moment_default()(dateStr, _dateFormat, true);
    if (date && date.isValid()) {
      validDate = date;
    }
  }

  // Issue 45140: if a dateFormat was provided here and the date didn't parse, try the default container format and no format
  if (!validDate) {
    let date;
    if (timeOnly) {
      date = external_moment_default()(dateStr, getMomentTimeFormat(), false);
    } else {
      date = external_moment_default()(dateStr, dateOnly ? getMomentDateFormat() : getMomentDateTimeFormat(), true);
    }
    if (date && date.isValid()) {
      validDate = date;
    }
  }
  if (!validDate) {
    const date = external_moment_default()(dateStr);
    if (date && date.isValid()) {
      validDate = date;
    }
  }

  // Issue 46767: DatePicker valid dates start at year 1000 (i.e. new Date('1000-01-01'))
  if (validDate && minDate && validDate.isBefore(minDate)) {
    return null;
  }
  return validDate ? validDate.toDate() : null;
}
function _formatDate(date, dateFormat, timezone) {
  if (!date) return undefined;
  let _date;
  if (timezone) {
    _date = external_moment_timezone_default()(date).tz(timezone);
  } else {
    _date = external_moment_default()(date);
  }
  return formatWithJDF(_date, dateFormat);
}
function formatDate(date, timezone, dateFormat) {
  return _formatDate(date, dateFormat ?? getMomentDateFormat(), timezone);
}
function formatDateTime(date, timezone, dateFormat) {
  return _formatDate(date, dateFormat ?? getMomentDateTimeFormat(), timezone);
}
function getUnFormattedNumber(n) {
  return n ? external_numeral_default()(n).value() : n;
}

// Issue 44398: see DateUtil.java getJsonDateTimeFormatString(), this function is to match the format, which is
// provided by the LabKey server for the API response, from a JS Date object
function getJsonDateTimeFormatString(date) {
  return _formatDate(date, 'YYYY-MM-dd HH:mm:ss');
}
function getJsonTimeFormatString(date) {
  return _formatDate(date, 'YYYY-MM-dd HH:mm:ss')?.split(' ')[1];
}
function getJsonDateFormatString(date) {
  return _formatDate(date, 'YYYY-MM-dd');
}
function getJsonFormatString(date, rawFormat) {
  if (!date) return undefined;
  if (rawFormat === 'DateTime') return getJsonDateTimeFormatString(date);
  if (rawFormat === 'Time') return getJsonTimeFormatString(date);
  return getJsonDateFormatString(date);
}
function generateNameWithTimestamp(name) {
  const date = new Date();
  const dateStr = date.toISOString().split('T')[0];
  let timeStr = date.toTimeString().split(' ')[0];
  timeStr = timeStr.replace(/:/g, '-');
  return name + '_' + dateStr + '_' + timeStr;
}
function twoDigit(num) {
  if (num < 10) {
    return '0' + num;
  }
  return '' + num;
}

// From a current date string, get the next N date string
// example, from "2022-02-02", get next 1 day, return "2022-02-03"
// example, from "2022-02-02", get next -1 day, return "2022-02-01"
function getNextDateStr(currentDateStr, ndays) {
  const numberOfDays = ndays ?? 1;
  const seedDate = new Date(currentDateStr);
  let nextDate = new Date(seedDate.getTime() + 60 * 60 * 24 * 1000 * numberOfDays); // add N*24 hours

  const userTimezoneOffset = nextDate.getTimezoneOffset() * 60 * 1000;
  nextDate = new Date(nextDate.getTime() + userTimezoneOffset);
  const year = nextDate.getFullYear();
  const month = nextDate.getMonth() + 1;
  const day = nextDate.getDate();
  return '' + year + '-' + twoDigit(month) + '-' + twoDigit(day);
}
function getNDaysStrFromToday(ndays) {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const todayStr = '' + year + '-' + twoDigit(month) + '-' + twoDigit(day);
  return getNextDateStr(todayStr, ndays);
}

// TODO add jest
function filterDate(date, start, end) {
  const dateOnly = new Date(date.getTime());
  dateOnly.setHours(0, 0, 0, 0);
  if (start == null && end == null) return true;
  if (start != null && end == null) return dateOnly >= start;
  if (start == null && end != null) return dateOnly <= end;
  return dateOnly >= start && dateOnly <= end;
}
const RELATIVE_DAYS_REGEX = /^[+-]\d+d$/;
function isRelativeDateFilterValue(val) {
  if (!val == null) return false;
  if (typeof val !== 'string') return false;
  return RELATIVE_DAYS_REGEX.test(val);
}
function getParsedRelativeDateStr(dateVal) {
  if (!isRelativeDateFilterValue(dateVal)) return null;
  let positive = true;
  if (dateVal.indexOf('-') === 0) positive = false;
  const daysStr = dateVal.replace('-', '').replace('+', '').replace('d', '');
  const days = parseInt(daysStr);
  return {
    positive,
    days
  };
}

// return true if the dateStr has a date that's before today
function isDateInPast(dateStr) {
  if (!dateStr) return false;
  const currentDate = new Date();
  const currentDateStart = currentDate.setUTCHours(0, 0, 0, 0);
  const date = new Date(dateStr);
  return date.getTime() < currentDateStart;
}

// return true if the dateTimeStr has a timestamp that's before now
function isDateTimeInPast(dateTimeStr) {
  if (!dateTimeStr) return false;
  return new Date(dateTimeStr).getTime() <= new Date().getTime();
}
;// CONCATENATED MODULE: ./src/internal/query/filter.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



const QUERY_KEY_CHAR_DECODED = ['$', '/', '&', '}', '~', ',', '.'];
const QUERY_KEY_CHAR_ENCODED = ['$D', '$S', '$A', '$B', '$T', '$C', '$P'];
const CONCEPT_COLUMN_FILTER_TYPES = [api_.Filter.Types.HAS_ANY_VALUE, api_.Filter.Types.EQUAL, api_.Filter.Types.NEQ_OR_NULL, api_.Filter.Types.ISBLANK, api_.Filter.Types.NONBLANK, api_.Filter.Types.IN, api_.Filter.Types.NOT_IN, api_.Filter.Types.ONTOLOGY_IN_SUBTREE, api_.Filter.Types.ONTOLOGY_NOT_IN_SUBTREE];
function isEqual(first, second) {
  if (first.size !== second.size) {
    return false;
  }
  let isEqual = true;
  first.forEach((f, i) => {
    const s = second.get(i);
    if (f === undefined) {
      if (s !== undefined) {
        isEqual = false;
        return false;
      }
    }
    if (s === undefined) {
      isEqual = false;
      return false;
    }
    if (f.getURLParameterName() !== s.getURLParameterName()) {
      isEqual = false;
      return false;
    } else if (JSON.stringify(f.getURLParameterValue()) !== JSON.stringify(s.getURLParameterValue())) {
      isEqual = false;
      return false;
    }
  });
  return isEqual;
}
function getLegalIdentifier(columnName, tableAlias) {
  const columnNameParts = columnName.split('/');
  const formattedParts = [];
  columnNameParts.forEach(part => {
    if (part) {
      let decodedPart = part.replace(/"/g, '""');
      QUERY_KEY_CHAR_ENCODED.forEach((encoded, ind) => {
        const reg = new RegExp('\\' + encoded, 'g');
        decodedPart = decodedPart.replace(reg, QUERY_KEY_CHAR_DECODED[ind]);
      });
      formattedParts.push('"' + decodedPart + '"');
    }
  });
  let columnSelect = formattedParts.join('.');
  if (tableAlias) columnSelect = tableAlias + '.' + columnSelect;
  return columnSelect;
}
function getLabKeySqlValue(value, jsonType, suppressQuote) {
  if (jsonType === 'string' || jsonType === 'date' || jsonType === 'time') {
    const quote = suppressQuote ? '' : "'";
    return quote + value.toString().replace(/'/g, "''") + quote;
  }
  if (jsonType === 'boolean') return value?.toLowerCase() === 'true' || value?.toLowerCase() === 'yes' || value?.toLowerCase() === 'on' ? 'TRUE' : 'FALSE';
  return value;
}

/**
 * @returns [effectiveDate 00:00:00, effectiveDate+1 00:00:00]. end timestamp should be exclusive
 * @param dateStr the timestamp of the effective date, can be anytime in the day
 */
function getDateStrRange(dateStr) {
  let datePart;
  if (dateStr.match(/^\s*(\d\d\d\d)-(\d\d)-(\d\d)\s*$/)) {
    datePart = dateStr;
  } else if (dateStr.match(/^\s*(\d\d\d\d)-(\d\d)-(\d\d)\s*(\d\d):(\d\d)\s*$/)) {
    datePart = dateStr.split('s')[0];
  } else if (isRelativeDateFilterValue(dateStr)) {
    const {
      days,
      positive
    } = getParsedRelativeDateStr(dateStr);
    datePart = getNDaysStrFromToday(days * (positive ? 1 : -1));
  }
  if (!datePart) return [dateStr, dateStr];
  return ["'" + datePart + "'", "'" + getNextDateStr(datePart) + "'"];
}

// for date (not datetime) field, ignore the time portion and do date only comparison
function getDateFieldLabKeySql(filter, tableAlias) {
  const filterType = filter.getFilterType();
  const columnNameSelect = getLegalIdentifier(filter.getColumnName(), tableAlias);
  let startDateStart, startDateEnd, endDateStart, endDateEnd;
  const urlSuffix = filterType.getURLSuffix();
  if (filterType.isDataValueRequired()) {
    if (filterType.isMultiValued()) {
      const values = filterType.parseValue(filter.getValue());
      [startDateStart, startDateEnd] = getDateStrRange(values[0]);
      if (values.length > 1) {
        [endDateStart, endDateEnd] = getDateStrRange(values[1]);
      }
    } else {
      [startDateStart, startDateEnd] = getDateStrRange(filter.getValue());
    }
    if (urlSuffix === api_.Filter.Types.DATE_EQUAL.getURLSuffix()) {
      return '(' + columnNameSelect + ' >= ' + startDateStart + ' AND ' + columnNameSelect + ' < ' + startDateEnd + ')';
    } else if (urlSuffix === api_.Filter.Types.DATE_NOT_EQUAL.getURLSuffix()) {
      return '(' + columnNameSelect + ' < ' + startDateStart + ' OR ' + columnNameSelect + ' >= ' + startDateEnd + ')';
    } else if (urlSuffix === api_.Filter.Types.BETWEEN.getURLSuffix()) {
      return '(' + columnNameSelect + ' >= ' + startDateStart + ' AND ' + columnNameSelect + ' < ' + endDateEnd + ')';
    } else if (urlSuffix === api_.Filter.Types.NOT_BETWEEN.getURLSuffix()) {
      return '(' + columnNameSelect + ' < ' + startDateStart + ' OR ' + columnNameSelect + ' >= ' + endDateEnd + ')';
    } else if (urlSuffix === api_.Filter.Types.DATE_GREATER_THAN.getURLSuffix()) {
      return '(' + columnNameSelect + ' >= ' + startDateEnd + ')';
    } else if (urlSuffix === api_.Filter.Types.DATE_LESS_THAN.getURLSuffix()) {
      return '(' + columnNameSelect + ' < ' + startDateStart + ')';
    } else if (urlSuffix === api_.Filter.Types.DATE_GREATER_THAN_OR_EQUAL.getURLSuffix()) {
      return '(' + columnNameSelect + ' >= ' + startDateStart + ')';
    } else if (urlSuffix === api_.Filter.Types.DATE_LESS_THAN_OR_EQUAL.getURLSuffix()) {
      return '(' + columnNameSelect + ' < ' + startDateEnd + ')';
    }
  }
  if (filterType.getLabKeySqlOperator() && !filterType.isDataValueRequired()) {
    return columnNameSelect + ' ' + filterType.getLabKeySqlOperator();
  }
  return null;
}
function getInClauseLabKeySql(filter, jsonType, tableAlias, flipNegative) {
  const filterType = filter.getFilterType();
  const columnNameSelect = getLegalIdentifier(filter.getColumnName(), tableAlias);
  let operatorSql = null;
  const values = filterType.parseValue(filter.getValue());
  const sqlValues = [];
  const negate = filterType.getURLSuffix() === api_.Filter.Types.NOT_IN.getURLSuffix() && !flipNegative;
  const includeNull = values.indexOf(null) > -1 || values.indexOf('') > -1;
  values.forEach(val => {
    sqlValues.push(getLabKeySqlValue(val, jsonType));
  });
  operatorSql = '(' + columnNameSelect + ' ' + (negate ? 'NOT ' : '') + 'IN (' + sqlValues.join(', ') + ')';
  if (includeNull) {
    if (negate) {
      operatorSql = operatorSql + ' AND ' + columnNameSelect + ' IS NOT NULL)';
    } else {
      operatorSql = operatorSql + ' OR ' + columnNameSelect + ' IS NULL)';
    }
  } else {
    if (negate) {
      operatorSql = operatorSql + ' OR ' + columnNameSelect + ' IS NULL)';
    } else {
      operatorSql = operatorSql + ')';
    }
  }
  return operatorSql;
}
const LABKEY_SQL_LIKE_CLAUSE_ESCAPE = " ESCAPE '!'"; // see LikeClause.sqlEscape

function getLikeClause(sqlValue, isStart) {
  if (!sqlValue || sqlValue === '') return ' IS NULL';
  return " LIKE LOWER('" + (isStart ? '' : '%') + sqlValue + "%')" + LABKEY_SQL_LIKE_CLAUSE_ESCAPE; // lower() might not be needed, but keeping it here to be consistent with server code
}
function getContainsClause(sqlValue) {
  return getLikeClause(sqlValue, false);
}
function getNotLikeClause(sqlValue, isStart) {
  if (!sqlValue || sqlValue === '') return ' IS NOT NULL';
  return ' NOT' + getLikeClause(sqlValue, isStart);
}
function getNotContainsClause(sqlValue) {
  return getNotLikeClause(sqlValue, false);
}
function getLikeFullClause(filter, jsonType, isStart, tableAlias) {
  const columnNameSelect = getLegalIdentifier(filter.getColumnName(), tableAlias);
  const sqlValue = getLabKeySqlValue(filter.getValue(), jsonType, true);
  if (!sqlValue || sqlValue === '') return columnNameSelect + getLikeClause(sqlValue, isStart);
  return 'LOWER(' + columnNameSelect + ')' + getLikeClause(sqlValue, isStart);
}
function getContainsFullClause(filter, jsonType, tableAlias) {
  return getLikeFullClause(filter, jsonType, false, tableAlias);
}
function getStartsWithFullClause(filter, jsonType, tableAlias) {
  return getLikeFullClause(filter, jsonType, true, tableAlias);
}
function getNotLikeFullClause(filter, jsonType, isStart, tableAlias) {
  const columnNameSelect = getLegalIdentifier(filter.getColumnName(), tableAlias);
  const sqlValue = getLabKeySqlValue(filter.getValue(), jsonType, true);
  if (!sqlValue || sqlValue === '') return columnNameSelect + ' IS NOT NULL';
  return '(' + columnNameSelect + ' IS NULL) OR (LOWER(' + columnNameSelect + ')' + getNotLikeClause(sqlValue, isStart) + ')';
}
function getNotContainsFullClause(filter, jsonType, tableAlias) {
  return getNotLikeFullClause(filter, jsonType, false, tableAlias);
}
function getNotStartsWithFullClause(filter, jsonType, tableAlias) {
  return getNotLikeFullClause(filter, jsonType, true, tableAlias);
}
function getInSubTreeClause(filter, jsonType, not, tableAlias) {
  const columnNameSelect = getLegalIdentifier(filter.getColumnName(), tableAlias);
  const notFrag = not ? 'NOT ' : '';
  const pathValue = filter.getValue();
  if (!pathValue || pathValue === '') return columnNameSelect + 'IS ' + notFrag + 'NULL';

  // 'Path1/Path1-1/Path1-1-2' to 'Path1', 'Path1-1', 'Path1-1-2'
  const paths = pathValue.split('/').filter(p => !!p);
  const sqlValue = paths.map(path => {
    return getLabKeySqlValue(path, jsonType);
  }).join(', ');
  return notFrag + 'IsInSubtree(' + columnNameSelect + ', ConceptPath(' + sqlValue + '))';
}
function getInContainsClauseLabKeySql(filter, jsonType, tableAlias, flipNegative) {
  const filterType = filter.getFilterType();
  const columnNameSelect = getLegalIdentifier(filter.getColumnName(), tableAlias);
  const values = filterType.parseValue(filter.getValue());
  const negate = filterType.getURLSuffix() === api_.Filter.Types.CONTAINS_NONE_OF.getURLSuffix() && !flipNegative;
  if (values.length === 0) return '';
  if (values.length === 1) {
    return negate ? getNotContainsFullClause(filter, jsonType, tableAlias) : getContainsFullClause(filter, jsonType, tableAlias);
  }
  const includeNull = values.indexOf(null) > -1 || values.indexOf('') > -1;
  const clauses = [];
  values.forEach(val => {
    const sqlValue = getLabKeySqlValue(val, jsonType, true);
    if (sqlValue) {
      const operatorSql = negate ? getNotContainsClause(sqlValue) : getContainsClause(sqlValue);
      clauses.push('(LOWER(' + columnNameSelect + ')' + operatorSql + ')');
    }
  });
  const likeClause = '(' + clauses.join(negate ? ' AND ' : ' OR ') + ')';
  let nullClause = '';
  if (includeNull) {
    if (negate) {
      nullClause = ' AND (' + columnNameSelect + ' IS NOT NULL)';
    } else {
      nullClause = ' OR (' + columnNameSelect + ' IS NULL)';
    }
  } else {
    if (negate) {
      nullClause = ' OR (' + columnNameSelect + ' IS NULL)';
    }
  }
  return likeClause + nullClause;
}
const NEGATIVE_FILTERS = [api_.Filter.Types.NOT_IN.getURLSuffix(), api_.Filter.Types.CONTAINS_NONE_OF.getURLSuffix(), api_.Filter.Types.NOT_BETWEEN.getURLSuffix(), api_.Filter.Types.NEQ_OR_NULL.getURLSuffix(), api_.Filter.Types.DOES_NOT_CONTAIN.getURLSuffix(), api_.Filter.Types.DOES_NOT_START_WITH.getURLSuffix(), api_.Filter.Types.ONTOLOGY_NOT_IN_SUBTREE.getURLSuffix(), api_.Filter.Types.NOT_EQUAL.getURLSuffix(), api_.Filter.Types.DATE_NOT_EQUAL.getURLSuffix()];
function isNegativeFilterType(filterType) {
  return NEGATIVE_FILTERS.indexOf(filterType.getURLSuffix()) > -1;
}

/**
 * Note: this is an experimental API that may change unexpectedly in future releases.
 * From a filter and its column jsonType, return the LabKey sql operator clause
 * @param filter The Filter
 * @param jsonType The json type ("string", "int", "float", "date", or "boolean") of the field
 * @param tableAlias
 * @param flipNegative If true, use the non-negative version of the current negative filter type: not equal -> equal, not in -> in. This is used to generate a ~notinexpdescendantsof filter, when the field contains another ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE
 * @return labkey sql fragment
 */
function getFilterLabKeySql(filter, jsonType, tableAlias, flipNegative) {
  if (!filter) return null;
  const filterType = filter.getFilterType();
  let columnNameSelect = getLegalIdentifier(filter.getColumnName());
  if (tableAlias) columnNameSelect = tableAlias + '.' + columnNameSelect;
  let operatorSql = null;
  if (filterType.getURLSuffix() === api_.Filter.Types.HAS_ANY_VALUE.getURLSuffix() || filterType.getURLSuffix() === COLUMN_NOT_IN_FILTER_TYPE.getURLSuffix()) return null;
  if (jsonType === 'date' && filterType.isDataValueRequired()) {
    let dateValue;
    if (filterType.isMultiValued()) {
      const values = filterType.parseValue(filter.getValue());
      if (values.length > 1) {
        dateValue = values[0];
      }
    } else {
      dateValue = filter.getValue();
    }
    if (isRelativeDateFilterValue(dateValue) || dateValue?.match(/^\s*(\d\d\d\d)-(\d\d)-(\d\d)\s*$/)) {
      // for date (not datetime) field, ignore the time portion and do date only comparison
      return getDateFieldLabKeySql(filter, tableAlias);
    }
  }
  if (filterType.getLabKeySqlOperator()) {
    if (!filterType.isDataValueRequired()) operatorSql = filterType.getLabKeySqlOperator();else operatorSql = filterType.getLabKeySqlOperator() + ' ' + getLabKeySqlValue(filter.getValue(), jsonType);
    return columnNameSelect + ' ' + operatorSql;
  } else if (filterType.isMultiValued()) {
    if (filterType.getURLSuffix() === api_.Filter.Types.IN.getURLSuffix() || filterType.getURLSuffix() === api_.Filter.Types.NOT_IN.getURLSuffix()) {
      return getInClauseLabKeySql(filter, jsonType, tableAlias, flipNegative);
    } else if (filterType.getURLSuffix() === api_.Filter.Types.CONTAINS_ONE_OF.getURLSuffix() || filterType.getURLSuffix() === api_.Filter.Types.CONTAINS_NONE_OF.getURLSuffix()) {
      return getInContainsClauseLabKeySql(filter, jsonType, tableAlias, flipNegative);
    } else if (filterType.getURLSuffix() === api_.Filter.Types.BETWEEN.getURLSuffix() || filterType.getURLSuffix() === api_.Filter.Types.NOT_BETWEEN.getURLSuffix()) {
      const values = filterType.parseValue(filter.getValue());
      operatorSql = (filterType.getURLSuffix() === api_.Filter.Types.NOT_BETWEEN.getURLSuffix() && !flipNegative ? 'NOT ' : '') + 'BETWEEN ' + getLabKeySqlValue(values[0], jsonType) + ' AND ' + getLabKeySqlValue(values[1], jsonType);
      return columnNameSelect + ' ' + operatorSql;
    }
  } else if (filterType.getURLSuffix() === api_.Filter.Types.NEQ_OR_NULL.getURLSuffix()) {
    if (flipNegative) {
      return columnNameSelect + ' = ' + getLabKeySqlValue(filter.getValue(), jsonType);
    }
    return '(' + columnNameSelect + ' ' + api_.Filter.Types.ISBLANK.getLabKeySqlOperator() + ' OR ' + columnNameSelect + ' ' + api_.Filter.Types.NOT_EQUAL.getLabKeySqlOperator() + ' ' + getLabKeySqlValue(filter.getValue(), jsonType) + ')';
  } else if (filterType.getURLSuffix() === api_.Filter.Types.CONTAINS.getURLSuffix()) {
    return getContainsFullClause(filter, jsonType, tableAlias);
  } else if (filterType.getURLSuffix() === api_.Filter.Types.DOES_NOT_CONTAIN.getURLSuffix()) {
    if (flipNegative) return getContainsFullClause(filter, jsonType, tableAlias);
    return getNotContainsFullClause(filter, jsonType, tableAlias);
  } else if (filterType.getURLSuffix() === api_.Filter.Types.STARTS_WITH.getURLSuffix()) {
    return getStartsWithFullClause(filter, jsonType, tableAlias);
  } else if (filterType.getURLSuffix() === api_.Filter.Types.DOES_NOT_START_WITH.getURLSuffix()) {
    if (flipNegative) return getStartsWithFullClause(filter, jsonType, tableAlias);
    return getNotStartsWithFullClause(filter, jsonType, tableAlias);
  } else if (filterType.getURLSuffix() === api_.Filter.Types.ONTOLOGY_IN_SUBTREE.getURLSuffix()) {
    return getInSubTreeClause(filter, jsonType, false, tableAlias);
  } else if (filterType.getURLSuffix() === api_.Filter.Types.ONTOLOGY_NOT_IN_SUBTREE.getURLSuffix()) {
    if (flipNegative) return getInSubTreeClause(filter, jsonType, false, tableAlias);
    return getInSubTreeClause(filter, jsonType, true, tableAlias);
  }
  return null;
}

/**
 * This method is a forwarding method for the version in @labkey/api. Calling the one from @labkey/api
 * directly from another npm package registers with a different global urlMap (somehow), so essentially doesn't
 * register the filter at all, just creates a new filter type for you.
 *
 */
function registerFilterType(displayText, displaySymbol, urlSuffix, dataValueRequired, multiValueSeparator, longDisplayText, minOccurs, maxOccurs, tableWise, labkeySqlOperator) {
  return api_.Filter.registerFilterType(displayText, displaySymbol, urlSuffix, dataValueRequired, multiValueSeparator, longDisplayText, minOccurs, maxOccurs, tableWise, labkeySqlOperator);
}

/**
 * This implements the filter corresponding to QueryServiceImpl.COLUMN_IN and QueryServiceImpl.COLUMN_NOT_IN. Updates there should also be reflected here.
 */
const COLUMN_IN_FILTER_TYPE = registerFilterType('COLUMN IN', null, 'columnin', true);
const COLUMN_NOT_IN_FILTER_TYPE = registerFilterType('COLUMN NOT IN', null, 'columnnotin', true);
const ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE = registerFilterType('Equals All Of', null, 'ancestormatchesallof', true, ';');
const IN_EXP_DESCENDANTS_OF_FILTER_TYPE = registerFilterType('IN DESCENDANTS OF', null, 'inexpdescendantsof', true, undefined);
const NOT_IN_EXP_DESCENDANTS_OF_FILTER_TYPE = registerFilterType('NOT IN DESCENDANTS OF', null, 'notinexpdescendantsof', true, undefined);
const IN_EXP_ANCESTORS_OF_FILTER_TYPE = registerFilterType('IN ANCESTORS OF', null, 'inexpancestorsof', true, undefined);
/**
 * This implements the filter corresponding to SampleInBoxCompareType. Updates there should also be reflected here.
 */
const BOX_SAMPLES_FILTER = registerFilterType('Sample in box', null, 'sampleinbox', true);

/**
 * This implements the filter corresponding to SampleInLocationCompareType. Updates there should also be reflected here.
 */
const LOCATION_SAMPLES_FILTER = registerFilterType('Sample in location', null, 'sampleinlocation', true);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/PropDescType.ts


class PropDescType extends (0,external_immutable_.Record)({
  conceptURI: undefined,
  display: undefined,
  name: undefined,
  rangeURI: undefined,
  alternateRangeURI: undefined,
  shortDisplay: undefined,
  lookupSchema: undefined,
  lookupQuery: undefined
}) {
  static fromName(name) {
    return PROP_DESC_TYPES.find(type => type.name === name);
  }
  static isUser(name) {
    return name === 'users';
  }
  static isSample(conceptURI) {
    return conceptURI === SAMPLE_TYPE_CONCEPT_URI;
  }
  static isOntologyLookup(conceptURI) {
    return conceptURI === CONCEPT_CODE_CONCEPT_URI;
  }
  static isUniqueIdField(conceptURI) {
    return conceptURI === STORAGE_UNIQUE_ID_CONCEPT_URI;
  }
  static isTextChoice(name) {
    // in the case of the field editor row data type select input change, the field input name is provided
    // so check for that case here as well
    return name === TEXT_CHOICE_CONCEPT_URI || name === TEXT_CHOICE_TYPE.name;
  }
  static isLookup(name) {
    return name === 'lookup';
  }
  static isCalculation(name) {
    return name === CALCULATED_CONCEPT_URI || name === CALCULATED_TYPE.name;
  }
  static isInteger(rangeURI) {
    return rangeURI === INT_RANGE_URI || rangeURI === USER_RANGE_URI;
  }
  static isNumeric(rangeURI) {
    return this.isInteger(rangeURI) || rangeURI === DECIMAL_RANGE_URI || rangeURI === DOUBLE_RANGE_URI || rangeURI === FLOAT_RANGE_URI || rangeURI === LONG_RANGE_URI;
  }
  static isString(rangeURI) {
    return rangeURI === STRING_RANGE_URI || rangeURI === MULTILINE_RANGE_URI;
  }
  static isTime(rangeURI) {
    return rangeURI === TIME_RANGE_URI;
  }
  static isDate(rangeURI) {
    return rangeURI === DATE_RANGE_URI;
  }
  static isDateTime(rangeURI) {
    return rangeURI === DATETIME_RANGE_URI;
  }
  static isMeasure(rangeURI) {
    return rangeURI !== ATTACHMENT_RANGE_URI && rangeURI !== FILELINK_RANGE_URI;
  }
  static isDimension(rangeURI) {
    return rangeURI === BOOLEAN_RANGE_URI || rangeURI === DOUBLE_RANGE_URI || rangeURI === INT_RANGE_URI || rangeURI === STRING_RANGE_URI;
  }
  static isMvEnableable(rangeURI) {
    return rangeURI !== ATTACHMENT_RANGE_URI && rangeURI !== FILELINK_RANGE_URI && rangeURI !== MULTILINE_RANGE_URI;
  }
  static isAutoIncrement(dataType) {
    return dataType?.display === AUTOINT_TYPE.display;
  }
  getJsonType() {
    // TODO should this change to default to returning this.name and just catch the diff cases?
    switch (this.name) {
      case 'boolean':
        return 'boolean';
      case 'int':
        return 'int';
      case 'double':
        return 'float';
      case 'dateTime':
      case 'date':
        return 'date';
      default:
        return 'string';
    }
  }
  isUser() {
    return PropDescType.isUser(this.name);
  }
  isLookup() {
    return PropDescType.isLookup(this.name);
  }
  isInteger() {
    return PropDescType.isInteger(this.rangeURI);
  }
  isNumeric() {
    return PropDescType.isNumeric(this.rangeURI);
  }
  isString() {
    return PropDescType.isString(this.rangeURI);
  }
  isFileType() {
    return this === FILE_TYPE || this === ATTACHMENT_TYPE;
  }
  isSample() {
    return PropDescType.isSample(this.conceptURI);
  }
  isOntologyLookup() {
    return PropDescType.isOntologyLookup(this.conceptURI);
  }
  isUniqueId() {
    return PropDescType.isUniqueIdField(this.conceptURI);
  }
  isTextChoice() {
    return PropDescType.isTextChoice(this.conceptURI);
  }
  isTime() {
    return PropDescType.isTime(this.rangeURI);
  }
  isDate() {
    return PropDescType.isDate(this.rangeURI);
  }
  isDateTime() {
    return PropDescType.isDateTime(this.rangeURI);
  }
}
const TEXT_TYPE = new PropDescType({
  name: 'string',
  display: 'Text',
  rangeURI: STRING_RANGE_URI,
  alternateRangeURI: 'xsd:string',
  shortDisplay: 'String'
});
const LOOKUP_TYPE = new PropDescType({
  name: 'lookup',
  display: 'Lookup'
});
const MULTILINE_TYPE = new PropDescType({
  name: 'multiLine',
  display: 'Multi-Line Text',
  rangeURI: MULTILINE_RANGE_URI
});
const BOOLEAN_TYPE = new PropDescType({
  name: 'boolean',
  display: 'Boolean',
  rangeURI: BOOLEAN_RANGE_URI,
  alternateRangeURI: 'xsd:boolean'
});
const INTEGER_TYPE = new PropDescType({
  name: 'int',
  display: 'Integer',
  rangeURI: INT_RANGE_URI,
  alternateRangeURI: 'xsd:int'
});
const DOUBLE_TYPE = new PropDescType({
  name: 'double',
  display: 'Decimal (floating point)',
  rangeURI: DOUBLE_RANGE_URI,
  alternateRangeURI: 'xsd:double'
});
const DATETIME_TYPE = new PropDescType({
  name: 'dateTime',
  display: 'Date Time',
  rangeURI: DATETIME_RANGE_URI,
  alternateRangeURI: 'xsd:dateTime'
});
const FLAG_TYPE = new PropDescType({
  name: 'flag',
  display: 'Flag',
  rangeURI: STRING_RANGE_URI,
  conceptURI: FLAG_CONCEPT_URI
});
const FILE_TYPE = new PropDescType({
  name: 'fileLink',
  display: 'File',
  rangeURI: FILELINK_RANGE_URI
});
const ATTACHMENT_TYPE = new PropDescType({
  name: 'attachment',
  display: 'Attachment',
  rangeURI: ATTACHMENT_RANGE_URI
});
const USERS_TYPE = new PropDescType({
  name: 'users',
  display: 'User',
  rangeURI: INT_RANGE_URI,
  lookupSchema: 'core',
  lookupQuery: 'users'
});
const PARTICIPANT_TYPE = new PropDescType({
  name: 'ParticipantId',
  display: 'Subject/Participant',
  rangeURI: STRING_RANGE_URI,
  conceptURI: PARTICIPANTID_CONCEPT_URI
});
const SAMPLE_TYPE = new PropDescType({
  name: 'sample',
  display: 'Sample',
  rangeURI: INT_RANGE_URI,
  conceptURI: SAMPLE_TYPE_CONCEPT_URI
});
const ONTOLOGY_LOOKUP_TYPE = new PropDescType({
  name: 'ontologyLookup',
  display: 'Ontology Lookup',
  rangeURI: STRING_RANGE_URI,
  conceptURI: CONCEPT_CODE_CONCEPT_URI
});
const BINARY_TYPE = new PropDescType({
  name: 'binary',
  display: 'Byte Buffer',
  rangeURI: BINARY_RANGE_URI
});
const DATE_TYPE = new PropDescType({
  name: 'date',
  display: 'Date',
  rangeURI: DATE_RANGE_URI
});
const DECIMAL_TYPE = new PropDescType({
  name: 'decimal',
  display: 'Decimal (fixed point)',
  rangeURI: DECIMAL_RANGE_URI
});
const FLOAT_TYPE = new PropDescType({
  name: 'float',
  display: 'Float',
  rangeURI: FLOAT_RANGE_URI
});
const LONG_TYPE = new PropDescType({
  name: 'long',
  display: 'Long Integer',
  rangeURI: LONG_RANGE_URI
});
const TIME_TYPE = new PropDescType({
  name: 'time',
  display: 'Time',
  rangeURI: TIME_RANGE_URI
});
const AUTOINT_TYPE = new PropDescType({
  name: 'int',
  display: 'Auto Increment',
  rangeURI: INT_RANGE_URI,
  conceptURI: AUTO_INT_CONCEPT_URI,
  alternateRangeURI: 'xsd:int'
});
const VISIT_DATE_TYPE = new PropDescType({
  name: 'visitDate',
  display: 'Visit Date',
  rangeURI: DATETIME_RANGE_URI,
  conceptURI: VISITID_CONCEPT_URI
});
const VISIT_ID_TYPE = new PropDescType({
  name: 'visitId',
  display: 'Visit ID',
  rangeURI: DOUBLE_RANGE_URI,
  conceptURI: VISITID_CONCEPT_URI
});
const UNIQUE_ID_TYPE = new PropDescType({
  name: 'uniqueId',
  display: 'Unique ID',
  rangeURI: STRING_RANGE_URI,
  conceptURI: STORAGE_UNIQUE_ID_CONCEPT_URI
});
const TEXT_CHOICE_TYPE = new PropDescType({
  name: 'textChoice',
  display: 'Text Choice',
  rangeURI: STRING_RANGE_URI,
  conceptURI: TEXT_CHOICE_CONCEPT_URI
});
const SMILES_TYPE = new PropDescType({
  name: 'smiles',
  display: 'SMILES',
  rangeURI: STRING_RANGE_URI,
  conceptURI: SMILES_CONCEPT_URI
});
const CALCULATED_TYPE = new PropDescType({
  name: 'calculation',
  display: 'Calculation',
  conceptURI: CALCULATED_CONCEPT_URI
});
const PROP_DESC_TYPES = (0,external_immutable_.List)([TEXT_TYPE, MULTILINE_TYPE, BOOLEAN_TYPE, INTEGER_TYPE, DOUBLE_TYPE, DATE_TYPE, TIME_TYPE, DATETIME_TYPE, FLAG_TYPE, FILE_TYPE, ATTACHMENT_TYPE, USERS_TYPE, PARTICIPANT_TYPE, LOOKUP_TYPE, SAMPLE_TYPE, SMILES_TYPE, ONTOLOGY_LOOKUP_TYPE, VISIT_DATE_TYPE, VISIT_ID_TYPE, UNIQUE_ID_TYPE, TEXT_CHOICE_TYPE, CALCULATED_TYPE]);
const READONLY_DESC_TYPES = (0,external_immutable_.List)([BINARY_TYPE, DATE_TYPE, DECIMAL_TYPE, FLOAT_TYPE, LONG_TYPE, TIME_TYPE, AUTOINT_TYPE]);
const CONCEPT_URIS_NOT_USED_IN_TYPES = (0,external_immutable_.List)([CREATED_TIMESTAMP_CONCEPT_URI, MODIFIED_TIMESTAMP_CONCEPT_URI]);
const STUDY_PROPERTY_TYPES = [PARTICIPANT_TYPE, VISIT_DATE_TYPE, VISIT_ID_TYPE];
;// CONCATENATED MODULE: ./src/internal/components/samples/constants.ts
function constants_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function constants_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? constants_ownKeys(Object(t), !0).forEach(function (r) { constants_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : constants_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function constants_defineProperty(e, r, t) { return (r = constants_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function constants_toPropertyKey(t) { var i = constants_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function constants_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


let ALIQUOT_FILTER_MODE = /*#__PURE__*/function (ALIQUOT_FILTER_MODE) {
  ALIQUOT_FILTER_MODE["aliquots"] = "aliquots";
  ALIQUOT_FILTER_MODE["all"] = "all";
  ALIQUOT_FILTER_MODE["none"] = "none";
  ALIQUOT_FILTER_MODE["samples"] = "samples";
  return ALIQUOT_FILTER_MODE;
}({}); // when using grid filter with 'is blank'
let SELECTION_KEY_TYPE = /*#__PURE__*/function (SELECTION_KEY_TYPE) {
  SELECTION_KEY_TYPE["inventoryItems"] = "inventoryItems";
  SELECTION_KEY_TYPE["snapshot"] = "snapshot";
  return SELECTION_KEY_TYPE;
}({});
const FIND_BY_IDS_QUERY_PARAM = 'findByIdsKey';
const UNIQUE_ID_FIND_FIELD = {
  nounSingular: 'Barcode',
  nounPlural: 'Barcodes',
  name: 'uniqueIds',
  helpTextTitle: 'Barcode Fields',
  helpText: 'The ids provided will be matched against all Unique ID fields or any fields marked as Barcodes as defined in your sample types.',
  label: 'Barcodes',
  storageKeyPrefix: 'u:'
};
const SAMPLE_ID_FIND_FIELD = {
  nounSingular: 'Sample ID',
  nounPlural: 'Sample IDs',
  name: 'sampleIds',
  label: 'Sample IDs',
  storageKeyPrefix: 's:'
};
const IS_ALIQUOT_COL = 'IsAliquot';
const SAMPLE_STATE_COLUMN_NAME = 'SampleState';
const SAMPLE_STATE_TYPE_COLUMN_NAME = 'SampleState/StatusType';
const SAMPLE_STATE_DESCRIPTION_COLUMN_NAME = 'SampleState/Description';
const SAMPLE_STATE_COLOR_COLUMN_NAME = 'SampleState/Color';
const SAMPLE_STATUS_REQUIRED_COLUMNS = [SAMPLE_STATE_COLUMN_NAME, SAMPLE_STATE_TYPE_COLUMN_NAME, SAMPLE_STATE_DESCRIPTION_COLUMN_NAME, SAMPLE_STATE_COLOR_COLUMN_NAME];
let SampleOperation = /*#__PURE__*/function (SampleOperation) {
  SampleOperation[SampleOperation["EditMetadata"] = 0] = "EditMetadata";
  SampleOperation[SampleOperation["EditLineage"] = 1] = "EditLineage";
  SampleOperation[SampleOperation["AddToStorage"] = 2] = "AddToStorage";
  SampleOperation[SampleOperation["UpdateStorageMetadata"] = 3] = "UpdateStorageMetadata";
  SampleOperation[SampleOperation["RemoveFromStorage"] = 4] = "RemoveFromStorage";
  SampleOperation[SampleOperation["AddToPicklist"] = 5] = "AddToPicklist";
  SampleOperation[SampleOperation["Delete"] = 6] = "Delete";
  SampleOperation[SampleOperation["AddToWorkflow"] = 7] = "AddToWorkflow";
  SampleOperation[SampleOperation["RemoveFromWorkflow"] = 8] = "RemoveFromWorkflow";
  SampleOperation[SampleOperation["AddAssayData"] = 9] = "AddAssayData";
  SampleOperation[SampleOperation["LinkToStudy"] = 10] = "LinkToStudy";
  SampleOperation[SampleOperation["RecallFromStudy"] = 11] = "RecallFromStudy";
  SampleOperation[SampleOperation["Move"] = 12] = "Move";
  return SampleOperation;
}({});
let SampleStateType = /*#__PURE__*/function (SampleStateType) {
  SampleStateType["Available"] = "Available";
  SampleStateType["Consumed"] = "Consumed";
  SampleStateType["Locked"] = "Locked";
  return SampleStateType;
}({});
const permittedOps = {
  [SampleStateType.Available]: new Set(Object.keys(SampleOperation).filter(val => !isNaN(parseInt(val))).map(val => parseInt(val))),
  [SampleStateType.Consumed]: new Set([SampleOperation.EditMetadata, SampleOperation.EditLineage, SampleOperation.RemoveFromStorage, SampleOperation.AddToPicklist, SampleOperation.Delete, SampleOperation.AddToWorkflow, SampleOperation.RemoveFromWorkflow, SampleOperation.AddAssayData, SampleOperation.LinkToStudy, SampleOperation.RecallFromStudy, SampleOperation.Move]),
  [SampleStateType.Locked]: new Set([SampleOperation.AddToPicklist])
};
const STATUS_DATA_RETRIEVAL_ERROR = 'There was a problem retrieving the current sample status data.';
const operationRestrictionMessage = {
  [SampleOperation.EditMetadata]: {
    all: 'updating of their data without also changing the status',
    singular: 'updating of its data',
    plural: 'updating of their data',
    recommendation: 'Either change the status here or remove these samples from your selection'
  },
  [SampleOperation.EditLineage]: {
    all: 'updating of their lineage',
    singular: 'updating of its lineage',
    plural: 'updating of their lineage'
  },
  [SampleOperation.AddToStorage]: {
    all: 'adding them to storage',
    singular: 'adding it to storage',
    plural: 'adding them to storage'
  },
  [SampleOperation.UpdateStorageMetadata]: {
    all: 'updating their storage data',
    singular: 'updating its storage data',
    plural: 'updating their storage data'
  },
  [SampleOperation.RemoveFromStorage]: {
    all: 'removing them from storage',
    singular: 'removing it from storage',
    plural: 'removing them from storage'
  },
  [SampleOperation.AddToPicklist]: {
    all: 'adding them to a picklist',
    singular: 'adding it to a picklist',
    plural: 'adding them to a picklist'
  },
  // [SampleOperation.Delete]: {
  //    Not needed because included from the server side response
  // },
  [SampleOperation.AddToWorkflow]: {
    all: 'adding them to a job',
    singular: 'adding it to a job',
    plural: 'adding them to a job'
  },
  [SampleOperation.RemoveFromWorkflow]: {
    all: 'removing them from a job',
    singular: 'removing it from a job',
    plural: 'removing them from a job'
  },
  [SampleOperation.AddAssayData]: {
    all: 'adding associated assay data',
    singular: 'adding associated assay data',
    plural: 'adding associated assay data'
  }
  // [SampleOperation.LinkToStudy]: {
  //    Not needed because check is done on LKS page
  // },
  // [SampleOperation.RecallFromStudy]: {
  //    Not needed because only possible from LKS
  // }
};
const DEFAULT_SAMPLE_FIELD_CONFIG = {
  required: true,
  dataType: SAMPLE_TYPE,
  conceptURI: SAMPLE_TYPE.conceptURI,
  rangeURI: SAMPLE_TYPE.rangeURI,
  lookupSchema: 'exp',
  lookupQuery: 'Materials',
  lookupType: constants_objectSpread({}, SAMPLE_TYPE),
  name: 'SampleID',
  label: 'Sample ID'
};
const ALIQUOTED_FROM_COL = 'AliquotedFrom';
const STATUS_COL = 'Status';
const AMOUNT_AND_UNITS_COLUMNS = ['StoredAmount', 'Units'];
const AMOUNT_AND_UNITS_COLUMNS_LC = AMOUNT_AND_UNITS_COLUMNS.map(col => col.toLowerCase());
const SAMPLE_STORAGE_COLUMNS = ['StorageLocation', 'StorageRow', 'StorageCol', 'StorageUnit', 'RawAmount', 'RawUnits', 'FreezeThawCount', 'EnteredStorage', 'CheckedOut', 'CheckedOutBy', 'StorageComment'];
const SAMPLE_STORAGE_COLUMNS_LC = SAMPLE_STORAGE_COLUMNS.map(col => col.toLowerCase());
const SAMPLE_STORAGE_COLUMNS_WITH_SUBSELECT_EXPR = ['SourceProtocolLSID', 'StorageStatus', 'SampleTypeUnits', 'FreezeThawCount', 'CheckedOutBy', 'StorageRow', 'StorageCol', 'CheckedOut', 'StorageLocation'];
const SAMPLE_INSERT_EXTRA_COLUMNS = [...AMOUNT_AND_UNITS_COLUMNS, ...SAMPLE_STORAGE_COLUMNS, ALIQUOTED_FROM_COL];

// those lookup values are at Home project level, no need to reload on target folder change
const SAMPLE_ALL_PROJECT_LOOKUP_FIELDS = ['SampleState', 'Units'];
const SAMPLE_EXPORT_CONFIG = {
  'exportAlias.name': DEFAULT_SAMPLE_FIELD_CONFIG.label,
  'exportAlias.aliquotedFromLSID': ALIQUOTED_FROM_COL,
  'exportAlias.aliquotedFromLSID/name': ALIQUOTED_FROM_COL,
  'exportAlias.sampleState': STATUS_COL,
  'exportAlias.storedAmount': 'Amount'
};
const SAMPLE_DATA_EXPORT_CONFIG = constants_objectSpread({}, SAMPLE_EXPORT_CONFIG);

// Issue 46037: Some plate-based assays (e.g., NAB) create samples with a bogus 'Material' sample type, which should get excluded everywhere in the application
const SAMPLES_WITH_TYPES_FILTER = api_.Filter.create('SampleSet', 'Material', api_.Filter.Types.NEQ);
const SAMPLE_DOMAIN_DEFAULT_SYSTEM_FIELDS = [{
  Name: 'Name',
  Label: 'Sample ID',
  DataType: 'Text',
  Required: true,
  // For user clarity, below text differs intentionally from schema browser
  Description: 'Unique ID generated from the Naming Pattern or Aliquot Naming Pattern',
  Disableble: false
}, {
  Name: 'SampleState',
  Label: 'Status',
  DataType: 'Integer',
  Required: false,
  Description: 'Represents the status of the sample',
  Disableble: false
}, {
  Name: 'Description',
  Label: 'Description',
  DataType: 'Text',
  Required: false,
  Description: 'Contains a Description for this sample',
  Disableble: true
}, {
  Name: 'MaterialExpDate',
  Label: 'Expiration Date',
  DataType: 'DateTime',
  Required: false,
  Description: 'The date that this sample expires on',
  Disableble: true
}, {
  Name: 'StoredAmount',
  Label: 'Amount',
  DataType: 'Decimal (floating point)',
  Required: false,
  Description: 'The amount of this sample',
  Disableble: true
}, {
  Name: 'Units',
  Label: 'Units',
  DataType: 'Text',
  Required: false,
  Description: 'The units associated with the Amount value for this sample',
  Disableble: true
}, {
  Name: 'AliquotCount',
  Label: 'Aliquots Created Count',
  DataType: 'Integer',
  Required: false,
  Description: '',
  Disableble: true
}];
const SAMPLE_DOMAIN_INVENTORY_SYSTEM_FIELDS = [{
  Name: 'FreezeThawCount',
  Label: 'Freeze/Thaw Count',
  DataType: 'Integer',
  Required: false,
  Description: '',
  Disableble: true
}, {
  Name: 'StorageLocation',
  Label: 'Storage Location',
  DataType: 'Text',
  Required: false,
  Description: '',
  Disableble: true
}, {
  Name: 'StorageRow',
  Label: 'Storage Row',
  DataType: 'Text',
  Required: false,
  Description: '',
  Disableble: true
}, {
  Name: 'StorageCol',
  Label: 'Storage Col',
  DataType: 'Text',
  Required: false,
  Description: '',
  Disableble: true
}];
const AMOUNT_PRECISION_ERROR_TEXT = 'Amount used is too precise for selected units.';
const STORED_AMOUNT_FIELDS = {
  ROWID: 'RowId',
  AMOUNT: 'StoredAmount',
  UNITS: 'Units',
  RAW_AMOUNT: 'RawAmount',
  RAW_UNITS: 'RawUnits',
  FREEZE_THAW_COUNT: 'FreezeThawCount',
  AUDIT_COMMENT: 'auditUserComment'
};
const SAMPLE_TYPE_NAME_EXPRESSION_TOPIC = 'sampleIDs#patterns';
const DEFAULT_AVAILABLE_STATUS_COLOR = '#F0F8ED';
const DEFAULT_CONSUMED_STATUS_COLOR = '#FCF8E3';
const DEFAULT_LOCKED_STATUS_COLOR = '#FDE6E6';
const SAMPLE_STATUS_COLORS = {
  [DEFAULT_LOCKED_STATUS_COLOR]: {
    color: '#BF3939',
    backgroundColor: DEFAULT_LOCKED_STATUS_COLOR
  },
  '#FCEFE8': {
    color: '#B24712',
    backgroundColor: '#FCEFE8'
  },
  [DEFAULT_CONSUMED_STATUS_COLOR]: {
    color: '#8A6D3B',
    backgroundColor: DEFAULT_CONSUMED_STATUS_COLOR
  },
  [DEFAULT_AVAILABLE_STATUS_COLOR]: {
    color: '#3C763D',
    backgroundColor: DEFAULT_AVAILABLE_STATUS_COLOR
  },
  '#EBFDF8': {
    color: '#0A825E',
    backgroundColor: '#EBFDF8'
  },
  '#F1F9FC': {
    color: '#0088CC',
    backgroundColor: '#F1F9FC'
  },
  '#EBEBFD': {
    color: '#4242ED',
    backgroundColor: '#EBEBFD'
  },
  '#F7EBFD': {
    color: '#A234D9',
    backgroundColor: '#F7EBFD'
  },
  '#FDEBF7': {
    color: '#BF1F8A',
    backgroundColor: '#FDEBF7'
  },
  '#F5EEE9': {
    color: '#876444',
    backgroundColor: '#F5EEE9'
  },
  '#F7F7F7': {
    color: '#6B6B6B',
    backgroundColor: '#F7F7F7'
  },
  '#DEDEDE': {
    color: '#333333',
    backgroundColor: '#DEDEDE'
  },
  // second row
  '#F9B3B3': {
    color: '#BF3939',
    backgroundColor: '#FAEBCD'
  },
  '#FAD0BB': {
    color: '#B24712',
    backgroundColor: '#FAD0BB'
  },
  '#FAEBCC': {
    color: '#8A6D3B',
    backgroundColor: '#FAEBCC'
  },
  '#D6E9C6': {
    color: '#3C763D',
    backgroundColor: '#D6E9C6'
  },
  '#B7EDDD': {
    color: '#0A825E',
    backgroundColor: '#B7EDDD'
  },
  '#C9E6F2': {
    color: '#0088CC',
    backgroundColor: '#C9E6F2'
  },
  '#C9C9F2': {
    color: '#4242ED',
    backgroundColor: '#C9C9F2'
  },
  '#E6C0F9': {
    color: '#A234D9',
    backgroundColor: '#E6C0F9'
  },
  '#F5BCE2': {
    color: '#BF1F8A',
    backgroundColor: '#F5BCE2'
  },
  '#DED5CC': {
    color: '#876444',
    backgroundColor: '#DED5CC'
  },
  '#E0E0E0': {
    color: '#6B6B6B',
    backgroundColor: '#E0E0E0'
  },
  '#C2C2C2': {
    color: '#333333',
    backgroundColor: '#C2C2C2'
  }
};
;// CONCATENATED MODULE: ./src/internal/components/samples/utils.tsx
function samples_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function samples_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? samples_utils_ownKeys(Object(t), !0).forEach(function (r) { samples_utils_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : samples_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function samples_utils_defineProperty(e, r, t) { return (r = samples_utils_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function samples_utils_toPropertyKey(t) { var i = samples_utils_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function samples_utils_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








function getOmittedSampleTypeColumns(user, moduleContext) {
  let cols = [];
  if (user.isGuest) {
    cols.push(SCHEMAS.INVENTORY.CHECKED_OUT_BY_FIELD);
  }
  if (!isFreezerManagementEnabled(moduleContext)) {
    cols = cols.concat(SCHEMAS.INVENTORY.INVENTORY_COLS);
  }
  return cols;
}
function isSampleOperationPermitted(sampleStatusType, operation, moduleContext) {
  // everything is possible when not tracking status
  if (!isSampleStatusEnabled(moduleContext)) return true;

  // no status provided means all operations are permitted
  if (!sampleStatusType) return true;
  return permittedOps[sampleStatusType].has(operation);
}
function getSampleStatusType(row) {
  return caseInsensitive(row, SAMPLE_STATE_TYPE_COLUMN_NAME)?.value || caseInsensitive(row, 'SampleID/' + SAMPLE_STATE_TYPE_COLUMN_NAME)?.value || caseInsensitive(row, 'StatusType')?.value;
}
function getSampleStatusColor(color, stateType) {
  if (color && api_.Utils.isString(color)) return color.toUpperCase();
  const _stateType = SampleStateType[stateType];
  switch (_stateType) {
    case SampleStateType.Available:
      return DEFAULT_AVAILABLE_STATUS_COLOR;
    case SampleStateType.Consumed:
      return DEFAULT_CONSUMED_STATUS_COLOR;
    case SampleStateType.Locked:
      return DEFAULT_LOCKED_STATUS_COLOR;
    default:
      return null;
  }
}
function getSampleStatus(row) {
  let label;
  // Issue 45269. If the state columns are present, don't look at a column named 'Label'
  let field = caseInsensitive(row, SAMPLE_STATE_COLUMN_NAME);
  if (field) {
    label = field.displayValue;
  } else {
    field = caseInsensitive(row, 'SampleID/' + SAMPLE_STATE_COLUMN_NAME);
    if (field) {
      label = field.displayValue;
    } else {
      label = caseInsensitive(row, 'Label')?.value;
    }
  }
  let color;
  let col = caseInsensitive(row, SAMPLE_STATE_COLOR_COLUMN_NAME);
  if (col) {
    color = col.value;
  } else {
    col = caseInsensitive(row, 'SampleID/' + SAMPLE_STATE_COLOR_COLUMN_NAME);
    if (col) {
      color = col.value;
    } else {
      color = caseInsensitive(row, 'Color')?.value;
    }
  }
  let description;
  col = caseInsensitive(row, SAMPLE_STATE_DESCRIPTION_COLUMN_NAME);
  if (col) {
    description = col.value;
  } else {
    col = caseInsensitive(row, 'SampleID/' + SAMPLE_STATE_DESCRIPTION_COLUMN_NAME);
    if (col) {
      description = col.value;
    } else {
      description = caseInsensitive(row, 'Description')?.value;
    }
  }
  return {
    label,
    statusType: getSampleStatusType(row),
    color,
    description
  };
}
function getFilterForSampleOperation(operation, allowed = true, moduleContext) {
  if (!isSampleStatusEnabled(moduleContext)) {
    return null;
  }
  const typesNotAllowed = [];
  for (const stateType in SampleStateType) {
    if (!permittedOps[stateType].has(operation)) {
      typesNotAllowed.push(stateType);
    }
  }
  if (typesNotAllowed.length === 0) {
    return null;
  }
  const filterType = allowed ? api_.Filter.Types.NOT_IN : api_.Filter.Types.IN;
  return api_.Filter.create(SAMPLE_STATE_TYPE_COLUMN_NAME, typesNotAllowed, filterType);
}
function getOperationMessageAndRecommendation(operation, numSamples, isAll) {
  if (isAll) {
    return operationRestrictionMessage[operation].all;
  } else {
    const messageInfo = operationRestrictionMessage[operation];
    let message;
    if (numSamples === 1) {
      message = operationRestrictionMessage[operation].singular;
    } else {
      message = operationRestrictionMessage[operation].plural;
    }
    if (messageInfo.recommendation) {
      return message + '. ' + messageInfo.recommendation;
    }
    return message;
  }
}
function getOperationNotAllowedMessageFromCounts(operation, totalCount, notAllowedCount) {
  let notAllowedMsg = null;
  if (totalCount === 0) {
    return null;
  }
  if (notAllowedCount === totalCount) {
    return `All selected samples have a status that prevents ${operationRestrictionMessage[operation].all}.`;
  }
  if (notAllowedCount > 0) {
    notAllowedMsg = `The current status of ${notAllowedCount.toLocaleString()} selected sample${notAllowedCount === 1 ? '' : 's'} prevents ${getOperationMessageAndRecommendation(operation, notAllowedCount, false)}.`;
  }
  return notAllowedMsg;
}
function getOperationNotAllowedMessage(operation, statusData, aliquotIds) {
  if (statusData) {
    const noAliquots = !aliquotIds || aliquotIds.length === 0;
    let notAllowed = [];
    // no aliquots or only aliquots, we show a status message about all that are not allowed
    if (noAliquots || aliquotIds.length === statusData.totalCount) {
      notAllowed = statusData.notAllowed;
    } else {
      // some aliquots, some not, filter out the aliquots from the status message
      notAllowed = statusData.notAllowed.filter(data => aliquotIds.indexOf(caseInsensitive(data, 'rowId')) < 0);
    }
    return getOperationNotAllowedMessageFromCounts(operation, statusData.totalCount, notAllowed.length);
  }
  return null;
}
function getOperationNotPermittedMessage(statusData, nounSingular = 'sample', nounPlural = 'samples') {
  if (statusData && statusData.notPermitted?.length > 0) {
    const notPermittedCount = statusData.notPermitted.length;
    const noun = notPermittedCount === 1 ? nounSingular : nounPlural;
    return `The selection includes ${notPermittedCount.toLocaleString()} ${noun.toLowerCase()} that you do not have permission to edit. Updates will only be made to the ${nounPlural.toLowerCase()} you have edit permission for.`;
  }
  return null;
}
let SamplesEditButtonSections = /*#__PURE__*/function (SamplesEditButtonSections) {
  SamplesEditButtonSections["DELETE"] = "delete";
  SamplesEditButtonSections["EDIT"] = "edit";
  SamplesEditButtonSections["EDIT_PARENT"] = "editparent";
  SamplesEditButtonSections["FIND_DERIVATIVES"] = "findderivatives";
  SamplesEditButtonSections["IMPORT"] = "import";
  SamplesEditButtonSections["LINK_TO_STUDY"] = "linktostudy";
  SamplesEditButtonSections["MOVE_TO_PROJECT"] = "movetoproject";
  return SamplesEditButtonSections;
}({});
function isSamplesSchema(schemaQuery) {
  const lcSchemaName = schemaQuery?.schemaName?.toLowerCase();
  if (lcSchemaName === SCHEMAS.SAMPLE_SETS.SCHEMA) return true;
  return isAllSamplesSchema(schemaQuery);
}
function isAllSamplesSchema(schemaQuery) {
  const lcSchemaName = schemaQuery?.schemaName?.toLowerCase();
  const lcQueryName = schemaQuery?.queryName?.toLowerCase();
  if (lcSchemaName === SCHEMAS.EXP_TABLES.SCHEMA && lcQueryName === SCHEMAS.EXP_TABLES.MATERIALS.queryName.toLowerCase()) return true;
  if (lcSchemaName === SCHEMAS.SAMPLE_MANAGEMENT.SCHEMA) {
    return lcQueryName === SCHEMAS.SAMPLE_MANAGEMENT.SOURCE_SAMPLES.queryName.toLowerCase() || lcQueryName === SCHEMAS.SAMPLE_MANAGEMENT.INPUT_SAMPLES_SQ.queryName.toLowerCase();
  }
  return false;
}
function getURLParamsForSampleSelectionKey(model, picklistName, isAssay, sampleFieldKey, ignoreFilter) {
  const {
    keyValue,
    queryInfo,
    selectionKey
  } = model;
  let params = {};
  if (queryInfo) {
    const singleSelect = keyValue !== undefined;
    const {
      schemaQuery
    } = queryInfo;
    params['selectionKey'] = singleSelect ? SchemaQuery.createAppSelectionKey(schemaQuery, [keyValue]) : selectionKey;
    if (!ignoreFilter) {
      model.filters.forEach(filter => {
        const filterURLSuffix = filter.getFilterType().getURLSuffix();
        // We don't need the picklist IN clause here since we're dealing with the samples selected in the grid
        const isPicklistFilterType = filterURLSuffix === PICKLIST_SAMPLES_FILTER.getURLSuffix();
        // and we don't need the LSID LineageOf clause either
        const isLineageOfFilterType = filterURLSuffix === api_.Filter.Types.EXP_LINEAGE_OF.getURLSuffix();
        const isSampleInLocationFilterType = filterURLSuffix === LOCATION_SAMPLES_FILTER.getURLSuffix() || filterURLSuffix === BOX_SAMPLES_FILTER.getURLSuffix();
        if (!isPicklistFilterType && !isLineageOfFilterType && !isSampleInLocationFilterType) {
          params[filter.getURLParameterName()] = filter.getURLParameterValue();
        }
      });
    }
    if (picklistName) {
      params['picklistName'] = picklistName;
    }
    if (isAssay && sampleFieldKey) {
      params = samples_utils_objectSpread(samples_utils_objectSpread({}, params), {
        assayProtocol: schemaQuery.schemaName,
        isAssay: true,
        sampleFieldKey
      });
    }
  }
  return params;
}
function getSampleDomainDefaultSystemFields(moduleContext) {
  return isFreezerManagementEnabled(moduleContext) ? SAMPLE_DOMAIN_DEFAULT_SYSTEM_FIELDS.concat(SAMPLE_DOMAIN_INVENTORY_SYSTEM_FIELDS) : SAMPLE_DOMAIN_DEFAULT_SYSTEM_FIELDS;
}
function getSampleStatusLockedMessage(state, saving) {
  const msgs = [];
  if (state?.inUse || saving) msgs.push('cannot change status type or be deleted because it is in use');
  if (state && !state.isLocal) msgs.push('can be changed only in the ' + state.containerPath.substring(1) + ' project');
  if (msgs.length > 0) return 'This sample status ' + msgs.join(' and ') + '.';
  return undefined;
}
function getSampleStatusContainerFilter(forLegend, containerPath, moduleContext) {
  // Check to see if product projects support is enabled.
  if (!isProductProjectsEnabled(moduleContext)) {
    return undefined;
  }

  // The legend should show statuses for all the samples that can be seen in the project.
  if (forLegend && isProjectContainer(containerPath)) {
    return api_.Query.ContainerFilter.currentAndSubfoldersPlusShared;
  }

  // When requesting data from a sub-folder context the ContainerFilter filters
  // "up" the folder hierarchy for data.
  return api_.Query.ContainerFilter.currentPlusProjectAndShared;
}
;// CONCATENATED MODULE: ./src/public/QueryColumn.ts
function QueryColumn_defineProperty(e, r, t) { return (r = QueryColumn_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function QueryColumn_toPropertyKey(t) { var i = QueryColumn_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function QueryColumn_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consider having this implement Query.QueryColumn from @labkey/api
// commented out attributes are not used in app






let Operation = /*#__PURE__*/function (Operation) {
  Operation["insert"] = "insert";
  Operation["update"] = "update";
  return Operation;
}({});
class QueryLookup {
  // name of the column on the junction table that is also a lookup

  // can be "junction", "value" or undefined. Server only support "junction" at this time
  // declare public: boolean; -- NOT ALLOWING DUE TO KEYWORD -- USE isPublic

  // declare schema: string; -- NOT ALLOWING -- USE schemaName

  // declare table: string; -- NOT ALLOWING -- USE queryName

  constructor(rawLookup) {
    Object.assign(this, rawLookup, {
      schemaQuery: new SchemaQuery(rawLookup.schemaName, rawLookup.queryName, rawLookup.viewName)
    });
  }
  hasQueryFilters(operation) {
    return isAllSamplesSchema(this.schemaQuery) || QueryColumn.isUserLookup(this) || operation !== undefined && this.getFilterGroup(operation) !== undefined;
  }
  getFilterGroup(operation) {
    return this.filterGroups?.find(filterGroup => filterGroup.operation === operation);
  }
  getQueryFilters(operation) {
    // Issue 46037: Some plate-based assays (e.g., NAB) create samples with a bogus 'Material' sample type, which should get excluded here
    if (isAllSamplesSchema(this.schemaQuery)) {
      return [SAMPLES_WITH_TYPES_FILTER];
    }
    const filterGroup = this.getFilterGroup(operation);
    if (filterGroup) {
      return filterGroup.filters.map(filterGroupFilter => api_.Filter.create(filterGroupFilter.column, filterGroupFilter.value, api_.Filter.Types[filterGroupFilter.operator.toUpperCase()]));
    } else if (QueryColumn.isUserLookup(this)) {
      // Issue 49439: filter out inactive users from insert and update form query selects
      return [api_.Filter.create('Active', true)];
    }
    return undefined;
  }
  mutate(partial) {
    return new QueryLookup(Object.assign({}, this, partial));
  }
}
const defaultQueryColumn = {
  conceptURI: null,
  defaultValue: null,
  filterable: true,
  hasSortKey: false,
  multiValue: false,
  sortable: true,
  removeFromViews: false
};
class QueryColumn {
  // declare autoIncrement: boolean;
  // declare calculated: boolean;

  // declare defaultScale: string;

  // declare excludeFromShifting: boolean;
  // declare ext: any;

  // declare friendlyType: string;

  // declare isAutoIncrement: boolean; // DUPLICATE
  // declare isHidden: boolean; // DUPLICATE

  // declare isMvEnabled: boolean;
  // declare isNullable: boolean;
  // declare isReadOnly: boolean;
  // declare isSelectable: boolean; // DUPLICATE
  // declare isUserEditable: boolean; // DUPLICATE
  // declare isVersionField: boolean;

  // declare keyField: boolean;

  // declare mvEnabled: boolean;

  // declare nullable: boolean;

  // declare recommendedVariable: boolean;

  // declare versionField: boolean;

  // strips this column from all ViewInfo definitions

  constructor(rawColumn) {
    Object.assign(this, defaultQueryColumn, rawColumn);
    if (rawColumn && rawColumn.lookup !== undefined) {
      Object.assign(this, {
        lookup: new QueryLookup(rawColumn.lookup)
      });
    }
  }
  static isUserLookup(lookupInfo) {
    if (!lookupInfo) return false;
    const lcSchema = lookupInfo.schemaName?.toLowerCase();
    const lcQuery = lookupInfo.queryName?.toLowerCase();
    return lcSchema === 'core' && (lcQuery === 'users' || lcQuery === 'siteusers');
  }
  get index() {
    // See Issues 41621, 45148
    // The server provides data indices into row data from selectRows based on FieldKey. In the
    // 17.1 SelectRowsResponse format these indices are constructed based off the associated column
    // fieldKey as follows:
    // 1. If the fieldKey is made up of multiple parts (e.g: "parent/someKey"), then the data index
    //    is FieldKey encoded.
    // 2. If the fieldKey is made up of one part (e.g: "someKey"), then the data index is not FieldKey encoded.

    // return if the column does not have a fieldKey at all
    if (!this.fieldKey) return;

    // "fieldKey" is expected to be FieldKey encoded so the presence of "/" indicates
    // this is a multi-part fieldKey which means the data index will be FieldKey encoded as well.
    if (this.fieldKey.indexOf('/') > -1) {
      return this.fieldKey;
    }

    // "fieldKeyPath" is used for getQueryDetails calls when a fk is passed as a prop, to get the child fields
    // for a lookup
    if (this.fieldKeyPath?.indexOf('/') > -1) {
      return this.fieldKeyPath;
    }

    // This is a single-part fieldKey so the data index will NOT be FieldKey encoded.
    if (this.fieldKeyArray.length === 1) {
      return this.fieldKeyArray[0];
    }

    // We're in an unexpected state. The "fieldKey" is single-part but the
    // "fieldKeyArray" is non-singular (made up of zero or two or more parts).
    // Fallback to old behavior.
    return this.fieldKeyArray?.join('/');
  }
  isExpInput(checkLookup = true) {
    return this.isDataInput(checkLookup) || this.isMaterialInput(checkLookup);
  }
  isDataInput(checkLookup = true) {
    return this.name && this.name.toLowerCase().indexOf(QueryColumn.DATA_INPUTS.toLowerCase()) !== -1 && (!checkLookup || this.isLookup());
  }
  isUnitsLookup() {
    return this.isLookup() && this.lookup.queryName === QueryColumn.MEASUREMENT_UNITS_QUERY;
  }
  isAliquotParent() {
    return this.name && (this.name.toLowerCase() === QueryColumn.ALIQUOTED_FROM.toLowerCase() || this.name.toLowerCase() === QueryColumn.ALIQUOTED_FROM_LSID.toLowerCase());
  }
  isEditable() {
    return !this.readOnly && this.userEditable && this.shownInUpdateView;
  }
  isJunctionLookup() {
    return this.isLookup() && this.lookup.multiValued === 'junction';
  }
  isLookup() {
    return this.lookup !== undefined;
  }

  // Issue 39911: a public lookup indicates that it is available in the user schema (i.e. can be seen in the schema browser)
  isPublicLookup() {
    return this.isLookup() && this.lookup.isPublic;
  }
  isSampleLookup() {
    if (!this.isLookup()) {
      return false;
    }

    // Issue 44845: Support resolving sample lookup columns by Concept URI
    if (this.conceptURI === SAMPLE_TYPE_CONCEPT_URI) {
      return true;
    }

    // Issue 35881: Ensure that a column is a valid lookup to one of the following:
    // - exp.Materials
    // - samples.* (any sample set)
    const lookupSQ = this.lookup.schemaQuery;
    return SCHEMAS.EXP_TABLES.MATERIALS.isEqual(lookupSQ) || lookupSQ.hasSchema(SCHEMAS.SAMPLE_SETS.SCHEMA);
  }
  isMaterialInput(checkLookup = true) {
    return this.name && this.name.toLowerCase().indexOf(QueryColumn.MATERIAL_INPUTS.toLowerCase()) !== -1 && (!checkLookup || this.isLookup());
  }
  get isDetailColumn() {
    return !this.removeFromViews && this.shownInDetailsView === true;
  }
  get isUpdateColumn() {
    return this.removeFromViews !== true && this.isEditable() && this.fieldKeyArray.length === 1;
  }
  get isUniqueIdColumn() {
    return this.conceptURI === STORAGE_UNIQUE_ID_CONCEPT_URI;
  }
  get isConceptCodeColumn() {
    return this.conceptURI === CONCEPT_CODE_CONCEPT_URI;
  }
  get isTimeColumn() {
    return this.rangeURI === TIME_RANGE_URI;
  }
  get isDateOnlyColumn() {
    return this.rangeURI === DATE_RANGE_URI;
  }
  get isCalculatedField() {
    return this.conceptURI === CALCULATED_CONCEPT_URI;
  }
  get hasHelpTipData() {
    return !!this.description || !!this.format || !!this.phiProtected;
  }
  isImportColumn(importName) {
    if (!importName) return false;
    const lcName = importName.toLowerCase().trim();
    return this.caption?.toLowerCase() === lcName || this.caption?.replace(' ', '').toLowerCase() === lcName || this.name?.toLowerCase() === lcName || this.fieldKey?.toLowerCase() === lcName;
  }

  // TODO is this redundant with getDisplayFieldKey?
  resolveFieldKey() {
    let fieldKey;
    if (this.isPublicLookup()) {
      fieldKey = [this.fieldKey, this.lookup.displayColumn.replace(/\//g, '$S')].join('/');
    } else {
      fieldKey = this.fieldKey;
    }
    return fieldKey;
  }
  get lookupKey() {
    if (!this.lookup) return undefined;
    return [this.lookup.schemaName, this.lookup.queryName, this.fieldKey].join('|');
  }
  get isFileInput() {
    return this.inputType === 'file';
  }
  allowFaceting() {
    switch (this.facetingBehaviorType) {
      case 'ALWAYS_ON':
        return true;
      case 'ALWAYS_OFF':
        return false;
      case 'AUTOMATIC':
        // auto rules are if the column is a lookup or dimension
        // OR if it is of type : (boolean, int, date, text), multiline excluded
        if (this.lookup || this.dimension) return true;else if (this.jsonType === 'boolean' || this.jsonType === 'int' || this.jsonType === 'string' && this.inputType !== 'textarea') return true;
    }
    return false;
  }
  getDisplayFieldKey() {
    return this.isLookup() && this.displayField ? this.displayField : this.fieldKey;
  }
  getDisplayFieldJsonType() {
    return (this.displayFieldJsonType ? this.displayFieldJsonType : this.jsonType) ?? 'string';
  }
  get customViewTitle() {
    return this.caption === this.name ? '' : this.caption;
  }
  mutate(partial) {
    return new QueryColumn(Object.assign({}, this, partial));
  }
}
QueryColumn_defineProperty(QueryColumn, "DATA_INPUTS", 'DataInputs');
QueryColumn_defineProperty(QueryColumn, "MATERIAL_INPUTS", 'MaterialInputs');
QueryColumn_defineProperty(QueryColumn, "ALIQUOTED_FROM", 'AliquotedFrom');
QueryColumn_defineProperty(QueryColumn, "ALIQUOTED_FROM_CAPTION", 'Aliquoted From');
QueryColumn_defineProperty(QueryColumn, "ALIQUOTED_FROM_LSID", 'AliquotedFromLSID');
QueryColumn_defineProperty(QueryColumn, "MEASUREMENT_UNITS_QUERY", 'MeasurementUnits');
function insertColumnFilter(col, includeFileInputs = true, isIncludedColumn) {
  return col && col.removeFromViews !== true && col.shownInInsertView === true && !col.readOnly && col.userEditable && col.fieldKeyArray.length === 1 && (includeFileInputs || !col.isFileInput) && (!isIncludedColumn || isIncludedColumn(col));
}
;// CONCATENATED MODULE: ./src/internal/LastActionStatus.ts
let MessageLevel = /*#__PURE__*/function (MessageLevel) {
  MessageLevel[MessageLevel["info"] = 0] = "info";
  MessageLevel[MessageLevel["warning"] = 1] = "warning";
  MessageLevel[MessageLevel["error"] = 2] = "error";
  return MessageLevel;
}({});
class LastActionStatus {
  constructor(data) {
    Object.assign(this, {
      type: undefined,
      date: undefined,
      level: MessageLevel.info,
      message: undefined
    }, data);
  }
}
;// CONCATENATED MODULE: ./src/public/InferDomainResponse.ts


class InferDomainResponse extends (0,external_immutable_.Record)({
  data: (0,external_immutable_.List)(),
  fields: (0,external_immutable_.List)(),
  reservedFields: (0,external_immutable_.List)()
}) {
  static create(rawModel) {
    let data = (0,external_immutable_.List)();
    let fields = (0,external_immutable_.List)();
    let reservedFields = (0,external_immutable_.List)();
    if (rawModel) {
      if (rawModel.data) {
        data = (0,external_immutable_.fromJS)(rawModel.data);
      }
      if (rawModel.fields) {
        fields = (0,external_immutable_.List)(rawModel.fields.map(field => new QueryColumn(field)));
      }
      if (rawModel.reservedFields) {
        reservedFields = (0,external_immutable_.List)(rawModel.reservedFields.map(field => new QueryColumn(field)));
      }
    }
    return new InferDomainResponse({
      data,
      fields,
      reservedFields
    });
  }
}
// EXTERNAL MODULE: external "normalizr"
var external_normalizr_ = __webpack_require__(370);
;// CONCATENATED MODULE: ./src/public/ExtendedMap.ts
/**
 * ExtendedMap is an extended version of the built in Map class. It has an improved constructor (that takes Records,
 * Map, or ExtendedMap objects), as well as several convenience methods for mapping, reducing, and filtering the map or
 * values. This class is an Ordered Map, because it extends the Map class which is ordered.
 */
class ExtendedMap extends Map {
  constructor(...data) {
    super();
    for (const dataObject of data) {
      if (dataObject === null || dataObject === undefined) continue;
      if (dataObject instanceof Map) {
        for (const [key, value] of dataObject) {
          this.set(key, value);
        }
      } else {
        // Assume Record type
        for (const key of Object.keys(dataObject)) {
          this.set(key, dataObject[key]);
        }
      }
    }
  }

  /**
   * Use this when you want to map or reduce over the values of the Map, or otherwise need an array. If you just need
   * to iterate through the values you should be able to use the values() method.
   */
  get valueArray() {
    return Array.from(this.values());
  }

  /**
   * Use this when you want to map or reduce over the keys of the Map, or otherwise need an array. If you just need
   * to iterate through the keys you should be able to use the keys() method.
   */
  get keyArray() {
    return Array.from(this.keys());
  }

  /**
   * Iterates over the ExtendedMap, calling the provided Mapper function for each key/value. Allows you to transform
   * the values of the map.
   * @param mapper
   */
  map(mapper) {
    const newMap = new ExtendedMap();
    for (const [key, value] of this) {
      newMap.set(key, mapper(value, key, this));
    }
    return newMap;
  }

  /**
   * Iterates over the ExtendedMap, calling the provided Reducer function for each key/value. Allows you to completely
   * transform the ExtendedMap object into something else (e.g. a string, a filtered version of the map).
   * @param reducer
   * @param initialReduction
   */
  reduce(reducer, initialReduction) {
    let result = initialReduction === undefined ? new ExtendedMap() : initialReduction;
    for (const [key, value] of this) {
      result = reducer(result, value, key, this);
    }
    return result;
  }

  /**
   * Creates a new ExtendedMap based on the filter function a passed in. Iterates through all of the values of the map
   * and calls the filter function with the key, value, and whole map. If the filter function returns true we include
   * the key/value pair in the new map.
   * @param filterFn
   */
  filter(filterFn) {
    const newMap = new ExtendedMap();
    for (const [key, value] of this) {
      if (filterFn(value, key, this)) newMap.set(key, value);
    }
    return newMap;
  }

  /**
   * A convenience function to map over the values of the ExtendedMap. Equivalent to Array.from(myMap.values()).map().
   * @param mapper
   */
  mapValues(mapper) {
    return this.valueArray.map(mapper);
  }
  find(filterFn) {
    for (const [key, value] of this) {
      if (filterFn(value, key, this)) return value;
    }
  }

  /**
   * Creates a new ExtendedMap based on this map and the map passed in as an argument.
   * @param otherMap
   */
  merge(otherMap) {
    return new ExtendedMap(this, otherMap);
  }

  /**
   * Inserts the contents of a map at the designated index. If the given index is out of range of the existing map we
   * return a copy of the current map. If the given index is equal to the current size of the map we append the
   * incoming otherMap.
   * @param index: the index where to insert the otherMap
   * @param otherMap: the otherMap to insert
   */
  mergeAt(index, otherMap) {
    // Invalid, return a copy of this map
    if (index < 0 || index > this.size) return new ExtendedMap(this);

    // Append
    if (index === this.size) return new ExtendedMap(this, otherMap);

    // Prepend
    if (index === 0) return new ExtendedMap(otherMap, this);
    const before = new Map();
    const after = new Map();
    let curIndex = 0;
    for (const [key, value] of this) {
      if (curIndex < index) {
        before.set(key, value);
      } else {
        after.set(key, value);
      }
      curIndex++;
    }
    return new ExtendedMap(before, otherMap, after);
  }
}
;// CONCATENATED MODULE: ./src/internal/global.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


// Don't touch this directly, if you need access to it use getQueryMetadata, if you need to set the value use
// setQueryMetadata
let _queryMetadata = (0,external_immutable_.Map)();

// Don't touch this directly, if you need access to it use getQueryColumnRenderers, if you need to set the value use
// setQueryColumnRenderers
let _queryColumnRenderers = {};

/**
 * Initialize the global state object for this package.
 * @param metadata Optional Map to set the query metadata for this application
 * @param columnRenderers Optional Map to set the column renderers for this application
 */
function initQueryGridState(metadata, columnRenderers) {
  if (metadata) {
    setQueryMetadata(metadata);
  }
  if (columnRenderers) {
    setQueryColumnRenderers(columnRenderers);
  }
}

/**
 * Get the query metadata object from the global state.
 */
function getQueryMetadata() {
  return _queryMetadata;
}

/**
 * Sets the query metadata object to be used for this application in the global state.
 * @param metadata Map of query metadata to be applied to the query infos and column infos
 */
function setQueryMetadata(metadata) {
  _queryMetadata = metadata;
}

/**
 * Get the query grid column renderers from the global state.
 */
function getQueryColumnRenderers() {
  return _queryColumnRenderers;
}

/**
 * Sets the valid column renderers for this application in the global state.
 * @param columnRenderers Query grid column renderers to be bound to the queryInfo columns
 */
function setQueryColumnRenderers(columnRenderers) {
  _queryColumnRenderers = columnRenderers;
}
;// CONCATENATED MODULE: ./src/public/QueryInfo.ts
function QueryInfo_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function QueryInfo_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? QueryInfo_ownKeys(Object(t), !0).forEach(function (r) { QueryInfo_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : QueryInfo_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function QueryInfo_defineProperty(e, r, t) { return (r = QueryInfo_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function QueryInfo_toPropertyKey(t) { var i = QueryInfo_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function QueryInfo_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






let QueryInfoStatus = /*#__PURE__*/function (QueryInfoStatus) {
  QueryInfoStatus[QueryInfoStatus["ok"] = 0] = "ok";
  QueryInfoStatus[QueryInfoStatus["notFound"] = 1] = "notFound";
  QueryInfoStatus[QueryInfoStatus["unknown"] = 2] = "unknown";
  return QueryInfoStatus;
}({});
const QUERY_INFO_DEFAULTS = {
  altUpdateKeys: undefined,
  disabledSystemFields: undefined,
  // canEdit: false,
  // canEditSharedViews: false,
  columns: new ExtendedMap(),
  description: undefined,
  domainContainerPath: undefined,
  // editDefinitionUrl: undefined,
  importTemplates: [],
  // indices: {},
  // isInherited: false,

  iconURL: 'default',
  // isMetadataOverrideable: false,
  // isTemporary: false,
  // isUserDefined: false,
  lastAction: undefined,
  // lastUpdate: undefined,
  name: undefined,
  pkCols: [],
  schemaName: undefined,
  status: QueryInfoStatus.unknown,
  // targetContainers:[],
  title: undefined,
  // DEPRECATED: Use queryLabel
  titleColumn: undefined,
  // viewDataUrl: undefined,
  views: new ExtendedMap(),
  importUrlDisabled: undefined,
  importUrl: undefined,
  insertUrlDisabled: undefined,
  insertUrl: undefined,
  supportGroupConcatSubSelect: false,
  supportMerge: false,
  // our stuff
  appEditableTable: false,
  isLoading: false,
  isMedia: false,
  // opt in
  queryLabel: undefined,
  schemaLabel: undefined,
  schemaQuery: undefined,
  showInsertNewButton: true,
  // opt out
  singular: undefined,
  // defaults to value of queryLabel
  plural: undefined // defaults to value of queryLabel
};

// Commented out attributes are not used in app, but are returned by the server
class QueryInfo {
  // use isAppEditable()

  // declare canEdit: boolean;
  // declare canEditSharedViews: boolean;

  // declare editDefinitionUrl: string;

  // declare indices: Record<string, any>;
  // declare isInherited: boolean;

  // declare isMetadataOverrideable: boolean;
  // declare isTemporary: boolean;
  // declare isUserDefined: boolean;

  // declare lastUpdate: Date;

  // declare targetContainers: any[];

  // declare viewDataUrl: string;

  /**
   * This constructor merges a Partial<QueryInfo> with QUERY_INFO_DEFAULTS to create a QueryInfo object. You should
   * almost never call this constructor yourself. The vast majority of the time you should be using the
   * applyQueryMetadata method to instantiate a QueryInfo, however for some simpler test cases we can use the
   * fromJsonForTests static method to instantiate a new QueryInfo.
   * @param data the Partial<QueryInfo> object to merge with QUERY_INFO_DEFAULTS when creating a QueryInfo.
   */
  constructor(data) {
    Object.assign(this, QUERY_INFO_DEFAULTS, data);
  }
  mutate(changes) {
    return new QueryInfo(QueryInfo_objectSpread(QueryInfo_objectSpread({}, this), changes));
  }

  /**
   * Use this method for creating a basic QueryInfo object with a proper schemaQuery object and columns map from a
   * JSON object. This should only be used in tests. If you're adding more logic to this you should probably also be
   * adding that same logic to applyQueryMetadata. In the long run this method shouldn't exist and all tests should
   * use makeQueryInfo so we are testing with QueryInfos that are instantiated with the same logic as our apps are.
   *
   * @param queryInfoJson The JSON representation of the QueryInfo from LabKey Server
   * @param includeViews boolean, if true this method parses the views from the JSON object and converts them to
   * ViewInfo objects. Defaults to false.
   */
  static fromJsonForTests(queryInfoJson, includeViews = false) {
    let schemaQuery;
    if (queryInfoJson.schemaName && queryInfoJson.name) {
      schemaQuery = new SchemaQuery(queryInfoJson.schemaName, queryInfoJson.name);
    }
    const columns = new ExtendedMap();
    Object.keys(queryInfoJson.columns ?? {}).forEach(columnKey => {
      const rawColumn = queryInfoJson.columns[columnKey];
      columns.set(rawColumn.fieldKey.toLowerCase(), new QueryColumn(rawColumn));
    });
    const disabledSystemFields = new Set(queryInfoJson.disabledSystemFields ?? []);
    const altUpdateKeys = new Set(queryInfoJson.altUpdateKeys ?? []);
    const views = new ExtendedMap();
    if (includeViews) {
      queryInfoJson.views.forEach(view => {
        const viewInfo = ViewInfo.fromJson(view);
        views.set(viewInfo.name.toLowerCase(), viewInfo);
      });
    }
    return new QueryInfo(Object.assign({}, queryInfoJson, {
      altUpdateKeys,
      disabledSystemFields,
      columns,
      schemaQuery,
      views
    }));
  }
  isAppEditable() {
    return this.appEditableTable && this.getPkCols().length > 0;
  }
  getColumn(fieldKey) {
    if (fieldKey) {
      return this.columns.get(fieldKey.toLowerCase());
    }
    return undefined;
  }
  isRequiredColumn(fieldKey) {
    const column = this.getColumn(fieldKey);
    return column ? column.required : false;
  }
  getDetailDisplayColumns(view, omittedColumns) {
    return this.getDisplayColumns(view, omittedColumns).filter(col => col.isDetailColumn);
  }
  getDisplayColumns(view, omittedColumns) {
    if (!view) {
      view = ViewInfo.DEFAULT_NAME;
    }
    const lowerOmit = toLowerSafe(omittedColumns ?? []);
    const viewInfo = this.getView(view);
    if (viewInfo) {
      const displayColumns = viewInfo.columns.reduce((result, col) => {
        if (col.fieldKey && lowerOmit.includes(col.fieldKey.toLowerCase())) {
          return result;
        }
        let c = this.getColumn(col.fieldKey);
        if (c !== undefined) {
          if (col.title !== undefined) {
            c = c.mutate({
              caption: col.title,
              shortCaption: col.title
            });
          }
          result.push(c);
        } else {
          console.warn(`Unable to resolve column '${col.fieldKey}' on view '${viewInfo.name}' (${this.schemaName}.${this.name})`);
        }
        return result;
      }, []);

      // add addToSystemView columns to unsaved system view (i.e. the default-default view, details view, or update view)
      if ((viewInfo.isDefault || viewInfo.isSystemView) && !viewInfo.isSaved && !viewInfo.session) {
        const columnFieldKeysLc = viewInfo.columns.reduce((result, col) => {
          result.add(col.fieldKey.toLowerCase());
          return result;
        }, new Set());
        displayColumns.push(...this.getExtraDisplayColumns(columnFieldKeysLc, lowerOmit));
      }
      return displayColumns;
    }
    console.warn('Unable to find columns on view:', view, '(' + this.schemaName + '.' + this.name + ')');
    return [];
  }
  getExtraDisplayColumns(columnFieldKeysLc, lowerOmit) {
    const extraDisplayColumn = [];
    const disabledSysFields = [];
    this.disabledSystemFields?.forEach(field => {
      disabledSysFields.push(field.toLowerCase());
    });
    this.columns.forEach(col => {
      const fieldKey = col.fieldKey.toLowerCase();
      if (fieldKey && col.addToSystemView && !columnFieldKeysLc.has(fieldKey) && disabledSysFields.indexOf(fieldKey) === -1) {
        if (!lowerOmit || !lowerOmit.includes(col.fieldKey.toLowerCase())) extraDisplayColumn.push(col);
      }
    });
    return extraDisplayColumn;
  }
  getLookupViewColumns(omittedColumns) {
    const lcCols = omittedColumns ? omittedColumns.map(c => c.toLowerCase()) : [];
    return this.columns.filter(col => col.shownInLookupView && lcCols.indexOf(col.fieldKey.toLowerCase()) === -1).valueArray;
  }
  getAllColumns(viewName, omittedColumns) {
    // initialReduction is getDisplayColumns() because they include custom metadata from the view, like alternate
    // column display names (e.g. the Experiment grid overrides Title to "Experiment Title"). See Issue 38186 for
    // additional context.
    return this.columns.reduce((result, rawColumn) => {
      if (!result.find(displayColumn => displayColumn.name === rawColumn.name)) {
        result.push(rawColumn);
      }
      return result;
    }, this.getDisplayColumns(viewName, omittedColumns));
  }

  // @param isIncludedColumn can be used to filter out columns that should not be designate as insertColumns
  // (e.g., if creating samples that are not aliquots, the aliquot-only fields should never be included)
  getInsertColumns(isIncludedColumn, readOnlyColumns) {
    const lowerReadOnlyColumnsSet = readOnlyColumns?.reduce((result, value) => {
      result.add(value.toLowerCase());
      return result;
    }, new Set());
    // CONSIDER: use the columns in ~~INSERT~~ view to determine this set
    return this.columns.valueArray.filter(col => lowerReadOnlyColumnsSet?.has(col.fieldKey.toLowerCase()) || insertColumnFilter(col, false, isIncludedColumn));
  }
  getUpdateColumns(readOnlyColumns) {
    const lowerReadOnlyColumnsSet = readOnlyColumns?.reduce((result, value) => {
      result.add(value.toLowerCase());
      return result;
    }, new Set());
    const columns = this.columns.valueArray.filter(column => {
      return column.isUpdateColumn || lowerReadOnlyColumnsSet && lowerReadOnlyColumnsSet.has(column.fieldKey.toLowerCase());
    }).map(column => {
      if (lowerReadOnlyColumnsSet && lowerReadOnlyColumnsSet.has(column.fieldKey.toLowerCase())) {
        return column.mutate({
          readOnly: true
        });
      } else {
        return column;
      }
    });
    return columns;
  }
  getUpdateDisplayColumns(view, omittedColumns) {
    return this.getDisplayColumns(view, omittedColumns).filter(col => col.isUpdateColumn);
  }
  getFilters(view = ViewInfo.DEFAULT_NAME) {
    const viewInfo = this.getView(view);
    if (viewInfo) {
      return viewInfo.filters;
    }
    if (true) {
      console.warn('Unable to find view:', view, '(' + this.schemaName + '.' + this.name + ')');
    }
    return [];
  }
  getPkCols() {
    return this.pkCols.reduce((list, pkFieldKey) => {
      const pkCol = this.getColumn(pkFieldKey);
      if (pkCol) {
        list.push(pkCol);
      } else {
        console.warn(`Unable to resolve pkCol '${pkFieldKey}' on (${this.schemaName}.${this.name})`);
      }
      return list;
    }, []);
  }
  getUniqueIdColumns() {
    return this.columns.valueArray.filter(column => column.isUniqueIdColumn);
  }
  getSorts(view) {
    if (view) {
      const viewInfo = this.getView(view);
      if (viewInfo) {
        return viewInfo.sorts;
      }
      console.warn('Unable to find view:', view, '(' + this.schemaName + '.' + this.name + ')');
    }
    return [];
  }

  /**
   * An array of [[ViewInfo]] objects that are visible for a user to choose in the view menu. Note that the returned
   * array will be sorted by view label.
   */
  getVisibleViews() {
    return this.views.filter(view => view.isVisible).valueArray.sort(naturalSortByProperty('label'));
  }
  getView(viewName, defaultToDefault = false) {
    let _viewName = viewName?.toLowerCase();
    if (_viewName === '') _viewName = ViewInfo.DEFAULT_NAME.toLowerCase();
    if (_viewName) {
      // see if there is a specific detail view override
      if (_viewName === ViewInfo.DETAIL_NAME.toLowerCase()) {
        const details = this.views.get(ViewInfo.BIO_DETAIL_NAME.toLowerCase());
        if (details) {
          return details;
        }
      }
      const view = this.views.get(_viewName);
      if (view) return view;
    }
    return defaultToDefault ? this.views.get(ViewInfo.DEFAULT_NAME.toLowerCase()) : undefined;
  }
  getIconURL() {
    return this.iconURL;
  }

  /**
   * Get an array of fieldKeys for the column keys provided.
   * Default to getting all column fieldKeys if no parameter provided
   * @param keys The column keys to filter by
   */
  getColumnFieldKeys(keys) {
    if (this.columns) {
      return this.columns.filter((col, key) => !keys || keys.indexOf(key) > -1).valueArray.map(col => col.fieldKey);
    }
    return [];
  }
  getColumnIndex(fieldKey) {
    if (!fieldKey) return -1;
    const lcFieldKey = fieldKey.toLowerCase();
    return this.columns.keyArray.findIndex(column => column.toLowerCase() === lcFieldKey);
  }
  getShowImportDataButton() {
    return !!(this.showInsertNewButton && this.importUrl && !this.importUrlDisabled);
  }
  getShowInsertNewButton() {
    return !!(this.showInsertNewButton && this.insertUrl && !this.insertUrlDisabled);
  }

  // Note: Why does this method exist? Couldn't consumers use getInsertColumns to get the columns they want?
  getInsertQueryInfo() {
    return this.mutate({
      columns: this.columns.filter(column => column.shownInInsertView && !column.isFileInput)
    });
  }
  getFileColumnFieldKeys() {
    return this.columns.filter(col => col.isFileInput).valueArray.map(col => col.fieldKey);
  }
}
;// CONCATENATED MODULE: ./src/internal/url/URLResolver.ts
function URLResolver_defineProperty(e, r, t) { return (r = URLResolver_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function URLResolver_toPropertyKey(t) { var i = URLResolver_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function URLResolver_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







let resolvers = (0,external_immutable_.OrderedSet)();
let urlMappers = (0,external_immutable_.List)();
let URLService;
(function (_URLService) {
  function getUrlMappers() {
    return urlMappers;
  }
  _URLService.getUrlMappers = getUrlMappers;
  function registerAppRouteResolvers(...appRouteResolvers) {
    appRouteResolvers.forEach(resolver => {
      if (resolver) {
        resolvers = resolvers.add(resolver);
      }
    });
  }
  _URLService.registerAppRouteResolvers = registerAppRouteResolvers;
  async function resolveRedirect(path) {
    const resolver = resolvers.find(r => r.matches(path));
    if (resolver === undefined) return undefined;
    const parts = path.split('/');
    parts.shift(); // account for initial '/'
    const redirectPath = await resolver.fetch(parts);
    return redirectPath?.toString();
  }
  _URLService.resolveRedirect = resolveRedirect;
  function registerURLMappers(...mappers) {
    urlMappers = urlMappers.concat(mappers);
  }
  _URLService.registerURLMappers = registerURLMappers;
  function clearCache(cacheKey) {
    resolvers.forEach(resolver => {
      if (!cacheKey || resolver.cacheName === cacheKey) resolver.clearCache?.();
    });
  }
  _URLService.clearCache = clearCache;
})(URLService || (URLService = {}));
class ActionMapper {
  constructor(controller, action, resolver, productId) {
    URLResolver_defineProperty(this, "controller", void 0);
    URLResolver_defineProperty(this, "action", void 0);
    URLResolver_defineProperty(this, "resolver", void 0);
    URLResolver_defineProperty(this, "productId", void 0);
    URLResolver_defineProperty(this, "getProductUrl", url => {
      return createProductUrl(this.productId, undefined, url);
    });
    URLResolver_defineProperty(this, "resolve", (url, row, column, schemaName, queryName) => {
      if (url) {
        const parsed = api_.ActionURL.getPathFromLocation(url);
        if (parsed.action.toLowerCase() === this.action && parsed.controller.toLowerCase() === this.controller) {
          const resolvedUrl = this.resolver(row, column, schemaName, queryName);
          return resolvedUrl instanceof AppURL ? this.getProductUrl(resolvedUrl) : resolvedUrl;
        }
      }
    });
    this.controller = controller.toLowerCase();
    this.action = action.toLowerCase();
    this.resolver = resolver;
    this.productId = productId;
  }
}
// exported for jest tests
class LookupMapper {
  constructor(defaultPrefix, lookupResolvers) {
    URLResolver_defineProperty(this, "defaultPrefix", void 0);
    URLResolver_defineProperty(this, "lookupResolvers", void 0);
    URLResolver_defineProperty(this, "resolve", (url, row, column) => {
      if (column?.isLookup()) {
        const {
          lookup
        } = column;
        const {
          containerPath: lookupContainerPath,
          queryName,
          schemaName
        } = lookup;
        const queryKey = [schemaName, queryName].join('-').toLowerCase();
        const schemaKey = schemaName.toLowerCase();
        if (this.lookupResolvers) {
          if (this.lookupResolvers[queryKey]) {
            return this.lookupResolvers[queryKey](row, column, schemaName, queryName);
          }
          if (this.lookupResolvers[schemaKey]) {
            return this.lookupResolvers[schemaKey](row, column, schemaName, queryName);
          }
        }

        // Issue 46747: When the lookup goes to a different container, don't rewrite the URL
        const containerPath = (0,api_.getServerContext)().container.path;
        if (lookupContainerPath && lookupContainerPath !== containerPath) {
          return undefined;
        }
        const parts = [this.defaultPrefix, schemaName, queryName, row.get('value').toString()];
        return AppURL.create(...parts);
      }
    });
    this.defaultPrefix = defaultPrefix;
    this.lookupResolvers = lookupResolvers;
  }
}
const ASSAY_MAPPERS = [new ActionMapper('assay', 'assayDetailRedirect', row => {
  if (row.has('url')) {
    const rowURL = row.get('url');
    const params = api_.ActionURL.getParameters(rowURL);

    // expecting a parameter of runId=<runId>
    if (params.hasOwnProperty('runId')) {
      const runId = params['runId'];
      const url = ['rd', 'assayrun', runId];
      return AppURL.create(...url);
    }
  }
}), new ActionMapper('assay', 'assayRuns', (row, column, schema) => {
  if (row.has('url')) {
    const url = row.get('url');

    // expecting a filter on Batch/RowId~eq=<rowId>
    const filters = api_.Filter.getFiltersFromUrl(url, 'Runs');
    if (filters.length > 0) {
      for (let i = 0; i < filters.length; i++) {
        if (filters[i].getColumnName().toLowerCase() === 'batch/rowid') {
          const rowId = filters[i].getValue();

          // expecting a schema of assay.<provider>.<protocol>
          if (schema.indexOf('assay.') === 0) {
            const url = ['assays'].concat(schema.replace('assay.', '').split('.'));
            url.push('batches', rowId);
            return AppURL.create(...url);
          }
        }
      }
    }
  }
}), new ActionMapper('assay', 'assayBegin', row => {
  const url = row.get('url');
  if (url) {
    const params = api_.ActionURL.getParameters(url);
    if (params.rowId) {
      return AppURL.create('rd', 'assays', params.rowId);
    }
  }
}), new ActionMapper('assay', 'assayResults', row => {
  const url = row.get('url');
  if (url) {
    const params = api_.ActionURL.getParameters(url);
    const rowId = params.rowId;
    if (rowId) {
      // filter on Data.Run/RowId~eq=<rowId>
      const filters = api_.Filter.getFiltersFromUrl(url, 'Data');
      if (filters.length > 0) {
        for (let i = 0; i < filters.length; i++) {
          if (filters[i].getColumnName().toLowerCase() === 'run/rowid') {
            if (Object.keys(params).length > 2) console.warn('Params mapping skipped for: ' + url);
            const runId = filters[i].getValue();
            return AppURL.create('rd', 'assayrun', runId);
          }
        }
      }
      delete params.rowId; // strip the rowId and pass through the remaining params
      return AppURL.create('assays', rowId, 'data').addParams(params);
    }
  }
})];
const DATA_CLASS_MAPPERS = [new ActionMapper('experiment', 'showDataClass', (row, column) => {
  let identifier;

  // TODO: Deal with junction lookup
  if (row.has('data')) {
    // search link doesn't use the same url
    identifier = row.getIn(['data', 'name']);
  } else if (column?.isLookup()) {
    identifier = row.get('displayValue').toString();
  } else {
    identifier = row.get('value').toString();
  }
  if (identifier !== undefined) {
    return AppURL.create('rd', 'dataclass', identifier);
  }
}), new ActionMapper('experiment', 'showData', row => {
  const targetURL = row.get('url');
  if (targetURL) {
    const params = api_.ActionURL.getParameters(targetURL);
    if (params.rowId) {
      const url = ['rd', 'expdata', params.rowId];
      return AppURL.create(...url);
    }
  }
})];
const SAMPLE_TYPE_MAPPERS = [new ActionMapper('experiment', 'showSampleType', (row, column) => {
  let identifier;
  if (row.has('data')) {
    // search link doesn't use the same url
    identifier = row.getIn(['data', 'name']);
  } else if (column?.isLookup()) {
    identifier = row.get('displayValue').toString();
  } else {
    identifier = row.get('value').toString();
  }
  if (identifier !== undefined) {
    return AppURL.create(SAMPLES_KEY, identifier);
  }
}), new ActionMapper('experiment', 'showMaterial', row => {
  const targetURL = row.get('url');
  if (targetURL) {
    const params = api_.ActionURL.getParameters(targetURL);
    const rowId = params.rowId;
    if (rowId !== undefined) {
      const url = ['rd', 'samples', rowId];
      return AppURL.create(...url);
    } else {
      return false;
    }
  }
})];
const LIST_MAPPERS = [new ActionMapper('list', 'details', (row, column) => {
  if (!column?.isLookup()) {
    const params = api_.ActionURL.getParameters(row.get('url'));
    const urlParts = api_.ActionURL.getPathFromLocation(row.get('url'));
    if (params?.pk) {
      if (params.name) {
        const parts = ['q', 'lists', params.name, params.pk];
        return AppURL.create(...parts);
      } else if (params.listId && urlParts?.containerPath) {
        const resolverPath = encodeListResolverPath(urlParts.containerPath);
        const parts = ['q', 'lists', resolverPath, params.listId, params.pk];
        return AppURL.create(...parts);
      }
    }
  }
}), new ActionMapper('list', 'grid', (row, column) => {
  if (!column?.isLookup()) {
    const params = api_.ActionURL.getParameters(row.get('url'));
    const urlParts = api_.ActionURL.getPathFromLocation(row.get('url'));
    if (params) {
      if (params.name) {
        const parts = ['q', 'lists', params.name];
        return AppURL.create(...parts);
      } else if (params.listId && urlParts?.containerPath) {
        const resolverPath = encodeListResolverPath(urlParts.containerPath);
        const parts = ['q', 'lists', resolverPath, params.listId];
        return AppURL.create(...parts);
      }
    }
  }
})];
const DETAILS_QUERY_ROW_MAPPER = new ActionMapper('query', 'detailsQueryRow', row => {
  const url = row.get('url');
  if (url) {
    const params = api_.ActionURL.getParameters(url);
    const schemaName = params.schemaName;
    const queryName = params['query.queryName'];
    if (schemaName && queryName) {
      const key = params.keyValue ? params.keyValue : params.RowId;
      if (key !== undefined) {
        const parts = ['q', schemaName, queryName, key];
        return AppURL.create(...parts);
      }
    }
  }
});
const EXECUTE_QUERY_MAPPER = new ActionMapper('query', 'executeQuery', () => false);
const USER_DETAILS_MAPPERS = [new ActionMapper('user', 'details', row => {
  const url = row.get('url');
  if (url) {
    const params = api_.ActionURL.getParameters(url);
    return AppURL.create('q', 'core', 'siteusers', params.userId);
  }
}), new ActionMapper('user', 'attachmentDownload', () => false)];
const DOWNLOAD_FILE_LINK_MAPPER = new ActionMapper('core', 'downloadFileLink', () => false);
const AUDIT_DETAILS_MAPPER = new ActionMapper('audit', 'detailedAuditChanges', () => false);
const LOOKUP_MAPPER = new LookupMapper('q', {
  'exp-dataclasses': row => row.get('displayValue') ? AppURL.create('rd', 'dataclass', row.get('displayValue')) : undefined,
  'exp-runs': row => {
    const runId = row.get('value');
    if (!isNaN(parseInt(runId))) {
      return AppURL.create('rd', 'assayrun', runId);
    }
    return false;
  },
  issues: () => false // 33680: Prevent remapping issues lookup
});
const PIPELINE_MAPPER = new ActionMapper('pipeline-status', 'details', row => {
  const url = row.get('url');
  if (url) {
    const params = api_.ActionURL.getParameters(url);
    return AppURL.create('pipeline', params.rowId);
  }
  return false;
});
const PICKLIST_MAPPER = new ActionMapper('picklist', 'grid', row => {
  const url = row.get('url');
  if (url) {
    const params = api_.ActionURL.getParameters(url);
    if (params.listId) {
      return AppURL.create('picklist', params.listId);
    }
  }
  return false;
});
const FREEZER_ITEM_SAMPLE_MAPPER = new ActionMapper('query', 'executeQuery', row => {
  const url = row.get('url');
  if (url) {
    const materialIdKey = 'query.MaterialId~eq';
    const params = api_.ActionURL.getParameters(url);
    if (params.schemaName && params.schemaName.toLowerCase() === 'inventory' && params.queryName && params.queryName.toLowerCase() === 'item') {
      if (params[materialIdKey]) {
        return createProductUrl(FREEZER_MANAGER_APP_PROPERTIES.productId, undefined, AppURL.create('rd', 'sampleItem', params[materialIdKey]));
      } else {
        return ''; // don't try to show a link if there's no materialId Issue 49679
      }
    }
  }
  return false;
});

// This mapper overrides the URL provided for the core.ProjectManagement query.
// We're linking to #/admin/settings within a specific folder (which may be outside the current folder context).
const PROJECT_MGMT_MAPPER = new ActionMapper('project', 'begin', (row, column, schema, query) => {
  const url = row.get('url');

  // Only match against the core.ProjectManagement query
  if (url && schema?.toLowerCase() === 'core' && query?.toLowerCase() === 'projectmanagement') {
    const {
      containerPath
    } = api_.ActionURL.getPathFromLocation(url);
    const {
      controllerName
    } = getCurrentAppProperties();
    const baseURL = api_.ActionURL.buildURL(controllerName, 'app.view', containerPath);
    return baseURL + AppURL.create('admin', 'settings').toHref();
  }

  // Allow resolution of 'project-begin' to fall through to other mappers
  return undefined;
});

// query-detailsQueryRow.view?schemaName=inventory&query.queryName=Location&RowId=1811
// map to /rd/freezerLocation/1811
const STORAGE_LOCATION_MAPPER = new ActionMapper('query', 'detailsQueryRow', row => {
  const url = row.get('url');
  if (url) {
    const params = api_.ActionURL.getParameters(url);
    const schemaName = params.schemaName;
    const queryName = params['query.queryName'];
    if (schemaName && schemaName.toLowerCase() === 'inventory' && queryName && queryName.toLowerCase() === 'location') {
      const rowId = params.RowId;
      if (rowId && rowId.length) {
        return createProductUrlFromParts(FREEZER_MANAGER_APP_PROPERTIES.productId, api_.ActionURL.getController(), {}, 'rd', 'freezerLocation', rowId);
      }
      return false;
    }
  }
  return undefined;
});

// query-detailsQueryRow.view?schemaName=inventory&query.queryName=Box&RowId=2918
// map to boxes/24363?query.sort=WellPosition
const STORAGE_BOX_MAPPER = new ActionMapper('query', 'detailsQueryRow', row => {
  const url = row.get('url');
  if (url) {
    const params = api_.ActionURL.getParameters(url);
    const schemaName = params.schemaName;
    const queryName = params['query.queryName'];
    if (schemaName && schemaName.toLowerCase() === 'inventory' && queryName && queryName.toLowerCase() === 'box') {
      const rowId = params.RowId;
      if (rowId && rowId.length) {
        return createProductUrlFromParts(FREEZER_MANAGER_APP_PROPERTIES.productId, api_.ActionURL.getController(), {
          'query.sort': 'WellPosition'
        }, 'boxes', rowId);
      }
      return false;
    }
  }
  return undefined;
});
const URL_MAPPERS = {
  ASSAY_MAPPERS,
  DATA_CLASS_MAPPERS,
  SAMPLE_TYPE_MAPPERS,
  LIST_MAPPERS,
  PICKLIST_MAPPER,
  DETAILS_QUERY_ROW_MAPPER,
  EXECUTE_QUERY_MAPPER,
  USER_DETAILS_MAPPERS,
  DOWNLOAD_FILE_LINK_MAPPER,
  AUDIT_DETAILS_MAPPER,
  LOOKUP_MAPPER,
  PIPELINE_MAPPER,
  FREEZER_ITEM_SAMPLE_MAPPER,
  PROJECT_MGMT_MAPPER,
  STORAGE_LOCATION_MAPPER,
  STORAGE_BOX_MAPPER
};
class URLResolver {
  constructor() {
    URLResolver_defineProperty(this, "mapURL", mapper => {
      // Don't override URLs if the URL has a different container than the current container and is not in the folder
      // tree of the current container. This scopes the apps to their current container and container tree, and supports
      // adding FKs from other containers and preserving the URL from the server.
      if (mapper.url) {
        const urlPath = api_.ActionURL.getPathFromLocation(mapper.url).containerPath;
        if (urlPath) {
          const currentPath = (0,api_.getServerContext)().container.path;

          // not current container AND not same top-level folder
          if (urlPath !== currentPath && getProjectPath(currentPath) !== getProjectPath(urlPath)) {
            return mapper.url;
          }
        }
      }
      const _url = URLService.getUrlMappers().toSeq().map(m => m.resolve(mapper.url, mapper.row, mapper.column, mapper.schema, mapper.query)).filter(v => v !== undefined).first();
      if (_url instanceof AppURL) {
        return _url.toHref();
      }
      if (typeof _url === 'string') {
        return _url;
      }
      if (mapper.url !== undefined && _url !== false && (0,api_.getServerContext)().devMode) {
        // Don't bother logging the default server URL
        if (!mapper.url.indexOf('project-begin')) {
          console.warn('Unable to map URL:', mapper.url);
        }
      }
      return mapper.url;
    });
    URLResolver_defineProperty(this, "resolveLineageItem", (item, acceptedTypes = ['Sample', 'Data']) => {
      const metadata = {
        lineage: undefined,
        list: undefined,
        overview: item.url
      };
      if (item.type && acceptedTypes.indexOf(item.type) >= 0 && (item.queryName || item.cpasType)) {
        // Issue 48836: Resolve lineage item URL from queryName if available
        let name = item.queryName;
        if (!name) {
          // Fallback to parsing name from cpasType
          const parts = item.cpasType.split(':');
          name = parts[parts.length - 1];

          // LSID strings are 'application/x-www-form-urlencoded' encoded which replaces space with '+'
          name = name.replace(/\+/g, ' ');
        }

        // Create a URL that will be resolved/redirected in the application resolvers
        const listURLParts = item.type === 'Sample' ? [SAMPLES_KEY, name] : ['rd', 'dataclass', name];

        // listURL is the url to the grid for the data type. It will be filtered to the lineage members.
        metadata.list = AppURL.create(...listURLParts).toHref();
        const overviewURL = this.mapURL({
          url: item.url,
          row: item,
          column: undefined,
          schema: item.schemaName,
          query: item.queryName
        });
        metadata.overview = overviewURL;
        metadata.lineage = overviewURL + '/lineage';
      }
      return metadata;
    });
  }
  /**
   * Returns a Promise resolving a valid selectRowsResult with URLs replaced with those mapped by this
   * URLResolver.
   */
  resolveSelectRows(response, queryInfo) {
    let resolved = (0,external_immutable_.fromJS)(JSON.parse(JSON.stringify(response)));

    // If no url mappers defined then this is a noop. Using URLs as they are.
    if (URLService.getUrlMappers()?.size > 0) {
      if (resolved.get('rows').count()) {
        const schema = resolved.get('schemaName').toJS().join('.');
        const query = resolved.get('queryName');
        let fields = (0,external_immutable_.Map)();
        if (resolved.hasIn(['metaData', 'fields'])) {
          fields = resolved.getIn(['metaData', 'fields']).reduce((fs, col) => fs.set(col.get('fieldKey'), new QueryColumn(col.toJS())), (0,external_immutable_.Map)());
        }
        const rows = resolved.get('rows').map(row => {
          return row.map((cell, fieldKey) => {
            // single-value cells
            if (external_immutable_.Map.isMap(cell) && cell.has('url')) {
              return cell.set('url', this.mapURL({
                url: cell.get('url'),
                row: cell,
                column: fields.get(fieldKey) ?? queryInfo?.getColumn(fieldKey),
                schema,
                query
              }));
            }

            // multi-value cells
            if (external_immutable_.List.isList(cell) && cell.size > 0) {
              return cell.map(innerCell => {
                if (external_immutable_.Map.isMap(innerCell) && innerCell.has('url')) {
                  return innerCell.set('url', this.mapURL({
                    url: innerCell.get('url'),
                    row: innerCell,
                    column: fields.get(fieldKey) ?? queryInfo?.getColumn(fieldKey),
                    schema,
                    query
                  }));
                }
                return innerCell;
              }).toList();
            }
            return cell;
          });
        });
        resolved = resolved.set('rows', rows);
      }
    }
    return resolved.toJS();
  }

  // ToDo: this is rather fragile and data specific. this should be reworked with the mappers and rest of the resolvers to provide for more thorough coverage of our incoming URLs
  resolveSearchUsingIndex(result) {
    let resolved = (0,external_immutable_.fromJS)(JSON.parse(JSON.stringify(result)));
    if (resolved.get('hits').count()) {
      const rows = resolved.get('hits').map(row => {
        if (row && row.has('url')) {
          const id = row.get('id');
          let url = row.get('url');
          let query;

          // TODO: add reroute for assays/runs when pages and URLs are decided
          if (row.has('data') && row.hasIn(['data', 'dataClass'])) {
            query = row.getIn(['data', 'dataClass', 'name']);
            url = url.substring(0, url.indexOf('&')); // URL includes documentID value, this will split off at the start of the docID
            return row.set('url', this.mapURL({
              url,
              row,
              query
            }));
          } else if (id.indexOf('dataClass') >= 0) {
            query = row.getIn(['data', 'name']);
            url = url.substring(0, url.indexOf('&')); // URL includes documentID value, this will split off at the start of the docID
            return row.set('url', this.mapURL({
              url,
              row,
              query
            }));
          } else if (id.indexOf('materialSource') >= 0) {
            query = row.getIn(['data', 'name']);
            url = url.substring(0, url.indexOf('&')); // URL includes documentID value, this will split off at the start of the docID
            return row.set('url', this.mapURL({
              url,
              row,
              query
            }));
          } else if (id.indexOf('assay') >= 0) {
            query = row.getIn(['title']);
            url = url.substring(0, url.indexOf('&')); // URL includes documentID value, this will split off at the start of the docID
            return row.set('url', this.mapURL({
              url,
              row,
              query
            }));
          } else if (id.indexOf('material') !== -1 && row.hasIn(['data', 'sampleSet'])) {
            query = row.getIn(['data', 'sampleSet', 'name']);
            return row.set('url', this.mapURL({
              url,
              row,
              query
            }));
          } else if (row.has('data') && row.hasIn(['data', 'id'])) {
            query = row.getIn(['data', 'type']);
            return row.set('url', this.mapURL({
              url,
              row,
              query
            }));
          } else if (id.indexOf('workflowJob:') >= 0) {
            return row.set('url', this.mapURL({
              url,
              row
            }));
          } else if (id.indexOf('torageLocation:') >= 0) {
            let index = url.indexOf('&_docid');
            if (index > -1) {
              url = url.substring(0, index);
            }
            index = url.indexOf('?_docid');
            if (index > -1) {
              url = url.substring(0, index);
            }
            return row.set('url', this.mapURL({
              url,
              row
            }));
          } else if (url.indexOf('samplemanager-downloadAttachments') >= 0) {
            return row.set('url', this.mapURL({
              url,
              row
            }));
          } else if (url.indexOf('notebook') >= 0) {
            return row.set('url', this.mapURL({
              url,
              row
            }));
          } else if (url.indexOf('plate-designer') > -1) {
            const plateRowId = row.getIn(['data', 'rowId']);
            if (plateRowId) {
              return row.set('url', this.mapURL({
                url,
                row,
                query: plateRowId
              }));
            }
          }
        }
        return row;
      });
      resolved = resolved.set('hits', rows);
    }
    return resolved.toJS();
  }
}
;// CONCATENATED MODULE: ./src/internal/query/api.ts
const api_excluded = ["fillEmptyFields", "rows", "schemaQuery"],
  api_excluded2 = ["schemaQuery"],
  _excluded3 = ["schemaQuery"],
  _excluded4 = ["requestHandler"];
function api_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function api_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? api_ownKeys(Object(t), !0).forEach(function (r) { api_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : api_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function api_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = api_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function api_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function api_defineProperty(e, r, t) { return (r = api_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function api_toPropertyKey(t) { var i = api_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function api_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */













let queryDetailsCache = {};
function invalidateFullQueryDetailsCache() {
  queryDetailsCache = {};
}
const QUERY_CACHE_KEY_SEPARATOR = '|';
function getQueryDetailsCacheKey(schemaQuery, containerPath, fk, fields) {
  const parts = [schemaQuery.getKey(false) + QUERY_CACHE_KEY_SEPARATOR];
  if (fk) parts.push(fk);
  if (containerPath) parts.push(containerPath);
  if (fields) {
    let fields_;
    if (Array.isArray(fields)) {
      fields_ = Array.from(fields);
    } else {
      fields_ = [fields];
    }
    fields_.sort().forEach(field => {
      if (field) {
        parts.push(field);
      }
    });
  }
  return parts.join(QUERY_CACHE_KEY_SEPARATOR);
}
function invalidateQueryDetailsCache(schemaQuery, containerPath, fk, fields, exactKeyMatch = false) {
  if (exactKeyMatch) {
    const key = getQueryDetailsCacheKey(schemaQuery, containerPath, fk, fields);
    delete queryDetailsCache[key];
  } else {
    const prefix = getQueryDetailsCacheKey(schemaQuery);
    Object.keys(queryDetailsCache).forEach(cacheKey => {
      if (cacheKey.startsWith(prefix)) {
        delete queryDetailsCache[cacheKey];
      }
    });
  }
}
function getQueryDetails(options) {
  const {
    containerPath,
    fields,
    fk
  } = options;
  const schemaQuery = options.schemaQuery ?? new SchemaQuery(options.schemaName, options.queryName);
  const key = getQueryDetailsCacheKey(schemaQuery, containerPath, fk, fields);
  if (!queryDetailsCache[key]) {
    const {
      includeTriggers,
      initializeMissingView,
      lookup
    } = options;
    queryDetailsCache[key] = new Promise((resolve, reject) => {
      api_.Query.getQueryDetails({
        containerPath,
        includeTriggers,
        initializeMissingView,
        fields,
        fk,
        method: 'POST',
        queryName: schemaQuery.queryName,
        schemaName: schemaQuery.schemaName,
        viewName: fk ? undefined : '*',
        success: queryDetails => {
          // getQueryDetails will return an exception parameter in cases
          // where it is unable to resolve the tableInfo. This is deemed a 'success'
          // by the request standards but here we reject as an outright failure
          if (queryDetails.exception) {
            invalidateQueryDetailsCache(schemaQuery, containerPath, fk, fields);
            reject({
              schemaQuery,
              message: queryDetails.exception,
              exceptionClass: undefined
            });
          } else if (lookup) {
            resolve(applyQueryMetadata(queryDetails, lookup.schemaName, lookup.queryName));
          } else {
            resolve(applyQueryMetadata(queryDetails));
          }
        },
        failure: (error, request) => {
          console.error(error);
          invalidateQueryDetailsCache(schemaQuery, containerPath, fk, fields);
          reject({
            message: error.exception,
            exceptionClass: error.exceptionClass,
            schemaQuery,
            status: request.status
          });
        }
      });
    });
  }
  return queryDetailsCache[key];
}
function getDefaultVisibleColumns(options) {
  const schemaQuery = options.schemaQuery ?? new SchemaQuery(options.schemaName, options.queryName);
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('query', 'getDefaultVisibleColumns.api', options.containerPath),
      method: 'POST',
      jsonData: {
        queryName: schemaQuery.queryName,
        schemaName: schemaQuery.schemaName
      },
      success: api_.Utils.getCallbackWrapper(response => {
        const columns = [];
        const rawColumnMap = response.columns;
        Object.keys(rawColumnMap).forEach(fieldKey => {
          const rawColumn = rawColumnMap[fieldKey];
          columns.push(applyColumnMetadata(schemaQuery, rawColumn));
        });
        resolve(columns);
      }),
      failure: handleRequestFailure(reject, 'Failed to load default visible columns.')
    });
  });
}
function applyQueryMetadata(rawQueryInfo, schemaName, queryName) {
  let queryInfo;
  const metadata = getQueryMetadata();
  const _schemaName = schemaName ?? rawQueryInfo?.schemaName;
  const _queryName = queryName ?? rawQueryInfo?.name;
  if (rawQueryInfo && _schemaName && _queryName) {
    const schemaQuery = new SchemaQuery(_schemaName, _queryName);
    const columns = new ExtendedMap();
    rawQueryInfo.columns.forEach(rawColumn => {
      columns.set(rawColumn.fieldKey.toLowerCase(), applyColumnMetadata(schemaQuery, rawColumn));
    });
    let schemaMeta = metadata.getIn(['schema', _schemaName.toLowerCase(), 'queryDefaults']);
    if (schemaMeta) {
      schemaMeta = schemaMeta.toJS();
    }

    // see if metadata is defined for this query
    let queryMeta = metadata.getIn(['schema', _schemaName.toLowerCase(), 'query', _queryName.toLowerCase()]);
    if (queryMeta) {
      // remove transient properties
      queryMeta = queryMeta.delete('column');
      queryMeta = queryMeta.toJS();
    }
    const views = new ExtendedMap();
    if (rawQueryInfo.views) {
      const removedViewColumns = columns.filter(c => c.removeFromViews === true).valueArray.map(c => c.fieldKey.toLowerCase());
      rawQueryInfo.views.forEach(rawViewInfo => {
        let viewInfo = ViewInfo.fromJson(rawViewInfo);
        if (removedViewColumns.length) {
          viewInfo = viewInfo.mutate({
            columns: viewInfo.columns.filter(vc => removedViewColumns.indexOf(vc.fieldKey.toLowerCase()) === -1)
          });
        }
        applyViewColumns(columns, schemaQuery, rawViewInfo);
        views.set(viewInfo.name.toLowerCase(), viewInfo);
      });
    }
    const queryLabel = rawQueryInfo.title || _queryName;
    const disabledSystemFields = new Set(rawQueryInfo.disabledSystemFields ?? []);
    const altUpdateKeys = new Set(rawQueryInfo.altUpdateKeys ?? []);
    const defaultQueryMeta = {
      queryLabel,
      plural: queryLabel,
      schemaLabel: _schemaName,
      singular: queryLabel
    };
    queryInfo = Object.assign({}, rawQueryInfo, schemaMeta, defaultQueryMeta, queryMeta, {
      altUpdateKeys,
      disabledSystemFields,
      // derived fields
      columns,
      pkCols: columns.filter(col => col.isKeyField).valueArray.map(col => col.fieldKey),
      schemaQuery,
      status: QueryInfoStatus.ok,
      // seems a little weird to be saying we are OK here
      views
    });
  } else {
    console.warn('Invalid QueryInfo supplied for overriding metadata');
    queryInfo = rawQueryInfo;
  }
  return new QueryInfo(queryInfo);
}
const DEFAULT_PROCESS_PARAMETER_DOMAIN_KEY = 'defaultprocessparameterdomain';
function applyColumnMetadata(schemaQuery, rawColumn) {
  let columnMetadata;
  const metadata = getQueryMetadata();

  // lookup to see if metadata needs to be applied
  if (rawColumn && rawColumn.fieldKey) {
    let lcFieldKey = rawColumn.fieldKey.toLowerCase();
    // special case for vocabulary domain for process parameters. The name of the domain also contains
    // the domainId (e.g., DefaultProcessParameterDomain40).
    if (rawColumn.fieldKey.toLowerCase().startsWith(DEFAULT_PROCESS_PARAMETER_DOMAIN_KEY)) lcFieldKey = DEFAULT_PROCESS_PARAMETER_DOMAIN_KEY;
    let allMeta = metadata.getIn(['columnDefaults', lcFieldKey]);
    if (allMeta) {
      allMeta = allMeta.toJS();
    }
    let schemaMeta = metadata.getIn(['schema', schemaQuery.schemaName.toLowerCase(), 'columnDefaults', lcFieldKey]);
    if (schemaMeta) {
      schemaMeta = schemaMeta.toJS();
    }
    let columnMeta = metadata.getIn(['schema', schemaQuery.schemaName.toLowerCase(), 'query', schemaQuery.queryName.toLowerCase(), 'column', lcFieldKey]);
    if (columnMeta) {
      columnMeta = columnMeta.toJS();
    }
    // special case for assay schema to allow for metadata to be applied to all protocols base tables
    else if (schemaQuery.schemaName.toLowerCase().startsWith('assay.')) {
      columnMeta = metadata.getIn(['schema', 'assay', 'query', schemaQuery.queryName.toLowerCase(), 'column', lcFieldKey]);
      if (columnMeta) {
        columnMeta = columnMeta.toJS();
      }
    }
    if (lcFieldKey.indexOf('::') > -1) {
      const lcPivotFieldKey = lcFieldKey.split('::')[1];
      const pivotColumnMeta = metadata.getIn(['schema', schemaQuery.schemaName.toLowerCase(), 'query', schemaQuery.queryName.toLowerCase(), 'pivotColumn', lcPivotFieldKey]);
      if (pivotColumnMeta) {
        columnMeta = Object.assign({}, columnMeta ?? {}, pivotColumnMeta.toJS());
      }
    }
    columnMetadata = Object.assign({}, allMeta, schemaMeta, columnMeta);
    if (columnMetadata) {
      columnMetadata.columnRenderer = Renderers.applyColumnRenderer(columnMetadata, rawColumn, metadata);
      columnMetadata.detailRenderer = Renderers.applyDetailRenderer(columnMetadata, rawColumn, metadata);
      columnMetadata.inputRenderer = Renderers.applyInputRenderer(columnMetadata, rawColumn, metadata);
      columnMetadata.helpTipRenderer = Renderers.applyHelpTipRenderer(columnMetadata, rawColumn, metadata);
      if (columnMetadata.lookup) {
        columnMetadata.lookup = Object.assign({}, rawColumn.lookup, columnMetadata.lookup);
      }
    }
  }
  return new QueryColumn(Object.assign({}, rawColumn, columnMetadata));
}

// As of r57235 some column info's are only found on the views "fields" property that were previously
// available in the query info's "columns" property.
function applyViewColumns(columns, schemaQuery, rawViewInfo) {
  if (rawViewInfo && rawViewInfo.fields) {
    rawViewInfo.fields.forEach(rawColumn => {
      const fk = rawColumn.fieldKey.toLowerCase();
      if (!columns.has(fk)) {
        columns.set(fk, applyColumnMetadata(schemaQuery, rawColumn));
      }
    });
  }
}
class Renderers {
  static _check(columnMetadata, rawColumn, field, metadata) {
    if (columnMetadata.conceptURI || rawColumn.conceptURI) {
      const concept = metadata.getIn(['concepts', columnMetadata.conceptURI ? columnMetadata.conceptURI.toLowerCase() : rawColumn.conceptURI.toLowerCase()]);
      if (concept) {
        return concept.get(field);
      }
    }
    return undefined;
  }
  static applyColumnRenderer(columnMetadata, rawColumn, metadata) {
    let value = this._check(columnMetadata, rawColumn, 'columnRenderer', metadata);
    if (value === undefined) {
      value = this._applyDefaultRenderer(columnMetadata, rawColumn, metadata);
    }
    return value;
  }
  static applyDetailRenderer(columnMetadata, rawColumn, metadata) {
    let value = this._check(columnMetadata, rawColumn, 'detailRenderer', metadata);
    if (value === undefined) {
      value = this._applyDefaultRenderer(columnMetadata, rawColumn, metadata);
    }
    return value;
  }
  static _applyDefaultRenderer(columnMetadata, rawColumn, metadata) {
    const types = external_immutable_.Set.of(rawColumn.type.toLowerCase(), rawColumn.friendlyType.toLowerCase());
    if (rawColumn.multiValue === true) {
      return 'MultiValueDetailRenderer';
    } else if (types.contains('file')) {
      return 'FileColumnRenderer';
    } else if (QueryColumn.isUserLookup(rawColumn.lookup)) {
      return 'UserDetailsRenderer';
    }
    return undefined;
  }
  static applyInputRenderer(columnMetadata, rawColumn, metadata) {
    return this._check(columnMetadata, rawColumn, 'inputRenderer', metadata);
  }
  static applyHelpTipRenderer(columnMetadata, rawColumn, metadata) {
    return this._check(columnMetadata, rawColumn, 'helpTipRenderer', metadata);
  }
}

// Returns true if the columns parameter contains lookup columns. This columns parameter
// is intended to reflect the columns parameter accepted by Query.selectRows() which is either
// a string ('RowId, Name, Some/Lookup') or a string[] (['RowId', 'Name', 'Some/Lookup']).
function includesLookupColumns(columns) {
  if (!columns) return false;
  let columnsString;
  if (typeof columns === 'string') {
    columnsString = columns;
  } else {
    columnsString = columns.join(',');
  }
  return columnsString?.indexOf('/') > -1;
}

// Determines whether "includeMetadata" is required for a selectRows request.
function isSelectRowMetadataRequired(includeMetadata, columns) {
  return includeMetadata ?? (columns?.length > 0 ? includesLookupColumns(columns) : true);
}
/**
 * @deprecated use selectRows() instead.
 * Fetches an API response and normalizes the result JSON according to schema.
 * This makes every API response have the same shape, regardless of how nested it was.
 */
function selectRowsDeprecated(userConfig, caller) {
  return new Promise((resolve, reject) => {
    let schemaQuery, key;
    if (userConfig.queryName) {
      schemaQuery = new SchemaQuery(userConfig.schemaName, userConfig.queryName, userConfig.viewName);
      key = schemaQuery.getKey();
    }
    let hasDetails = false;
    let details;
    let hasResults = false;
    let result;
    function doResolve() {
      if (hasDetails && hasResults) {
        result = handleSelectRowsResponse(result, details);
        if (key !== result.key) {
          key = result.key; // default to model key
        }
        resolve(Object.assign({}, {
          key,
          models: result.models,
          orderedModels: result.orderedModels,
          queries: {
            [key]: details
          },
          rowCount: result.rowCount,
          messages: result.messages,
          caller
        }));
      }
    }
    if (userConfig.hasOwnProperty('sql')) {
      const saveInSession = userConfig.saveInSession === true;
      api_.Query.executeSql(Object.assign({}, userConfig, {
        method: 'POST',
        requiredVersion: 17.1,
        sql: userConfig.sql,
        saveInSession,
        containerFilter: userConfig.containerFilter ?? getContainerFilter(userConfig.containerPath),
        success: json => {
          result = json;
          hasResults = true;
          let resultSchemaQuery;
          if (saveInSession) {
            resultSchemaQuery = new SchemaQuery(userConfig.schemaName, json.queryName);
            key = resultSchemaQuery.getKey();
          } else {
            resultSchemaQuery = schemaQuery;
          }

          // We're not guaranteed to have a schemaQuery provided. When executing with SQL
          // the user only needs to supply a schemaName. If they do not saveInSession then
          // a queryName is not generated and getQueryDetails() is unable to fetch details.
          if (resultSchemaQuery) {
            getQueryDetails(resultSchemaQuery).then(d => {
              hasDetails = true;
              details = d;
              doResolve();
            }).catch(error => reject(error));
          } else {
            hasDetails = true;
            doResolve();
          }
        },
        failure: (data, request) => {
          console.error('There was a problem retrieving the data', data);
          reject({
            exceptionClass: data.exceptionClass,
            message: data.exception,
            status: request.status
          });
        }
      }));
    } else {
      const columns = userConfig.columns ? userConfig.columns : '*';
      api_.Query.selectRows(Object.assign({}, userConfig, {
        requiredVersion: 17.1,
        filterArray: userConfig.filterArray,
        method: 'POST',
        // put on this another parameter!
        columns,
        containerFilter: userConfig.containerFilter ?? getContainerFilter(userConfig.containerPath),
        includeMetadata: isSelectRowMetadataRequired(userConfig.includeMetadata, columns),
        includeTotalCount: userConfig.includeTotalCount ?? false,
        // default to false to improve performance
        success: json => {
          result = json;
          hasResults = true;
          doResolve();
        },
        failure: (data, request) => {
          console.error('There was a problem retrieving the data', data);
          reject({
            exceptionClass: data.exceptionClass,
            message: data.exception,
            schemaQuery,
            status: request.status
          });
        }
      }));
      getQueryDetails(userConfig).then(d => {
        hasDetails = true;
        details = d;
        doResolve();
      }).catch(error => {
        console.error('There was a problem retrieving the data', error);
        reject(error);
      });
    }
  });
}
function handleSelectRowsResponse(response, queryInfo) {
  const resolved = new URLResolver().resolveSelectRows(response, queryInfo);
  let count = 0,
    hasRows = false,
    models = {},
    orderedModels = {},
    qsKey = 'queries',
    rowCount = response.rowCount || 0;
  let metadataKey;
  if (resolved.metaData) {
    // If metaData is present, then use its "id" value regardless of presence of a queryInfo
    metadataKey = resolved.metaData.id;
  } else if (queryInfo) {
    // Match ApiQueryResponse logic for determining "metaData.id"
    if (queryInfo.pkCols.length === 1) {
      metadataKey = queryInfo.pkCols[0];
    }
  }
  const modelKey = resolveKeyFromJson(resolved);

  // ensure id -- unfortunately, with normalizr 3.x there doesn't seem to be a way to generate the id
  // without attaching directly to the object
  resolved.rows.forEach(row => {
    if (metadataKey) {
      if (row[metadataKey] !== undefined) {
        row._id_ = row[metadataKey].value;
        return;
      } else {
        console.error('Missing entry', metadataKey, row, resolved.schemaKey, resolved.queryName);
      }
    }
    row._id_ = count++;
  });
  const modelSchema = new external_normalizr_.schema.Entity(modelKey, {}, {
    idAttribute: '_id_'
  });
  const querySchema = new external_normalizr_.schema.Entity(qsKey, {}, {
    idAttribute: queryJson => resolveKeyFromJson(queryJson)
  });
  querySchema.define({
    rows: new external_normalizr_.schema.Array(modelSchema)
  });
  const instance = (0,external_normalizr_.normalize)(resolved, querySchema);
  Object.keys(instance.entities).forEach(key => {
    if (key !== qsKey) {
      rowCount = instance.entities[qsKey][key].rowCount;
      const rows = instance.entities[key];
      // cleanup generated ids
      Object.keys(rows).forEach(rowKey => {
        delete rows[rowKey]['_id_'];
      });
      models[key] = rows;
      orderedModels[key] = (0,external_immutable_.fromJS)(instance.entities[qsKey][key].rows).map(r => r.toString()).toList();
      hasRows = true;
    }
  });
  if (!hasRows) {
    models[modelKey] = {};
    orderedModels[modelKey] = (0,external_immutable_.List)();
  }
  const messages = resolved.messages ? (0,external_immutable_.fromJS)(resolved.messages) : (0,external_immutable_.List)();
  return {
    key: modelKey,
    messages,
    models,
    orderedModels,
    rowCount
  };
}

// exported for jest testing
function quoteValueColumnWithDelimiters(selectRowsResult, valueColumn, delimiter) {
  const rowMap = selectRowsResult.models[selectRowsResult.key];
  Object.keys(rowMap).forEach(key => {
    if (rowMap[key][valueColumn]) {
      Object.assign(rowMap[key], {
        [valueColumn]: {
          value: quoteValueWithDelimiters(rowMap[key][valueColumn].value, delimiter),
          displayValue: rowMap[key][valueColumn].displayValue ?? rowMap[key][valueColumn].value,
          url: rowMap[key][valueColumn].url
        }
      });
    }
  });
  return selectRowsResult;
}
function searchRows(selectRowsConfig, token, valueColumn, delimiter, exactColumn) {
  return new Promise((resolve, reject) => {
    let exactFilters, qFilters;
    const baseFilters = selectRowsConfig.filterArray ? selectRowsConfig.filterArray : [];
    const maxRows = selectRowsConfig.maxRows !== undefined ? selectRowsConfig.maxRows : 100000;
    if (token) {
      if (exactColumn) {
        exactFilters = [api_.Filter.create(exactColumn, token)].concat(baseFilters);
      }
      qFilters = [api_.Filter.create('*', token, api_.Filter.Types.Q)].concat(baseFilters);
    } else {
      qFilters = baseFilters;
    }
    const selects = [selectRowsDeprecated(Object.assign({}, selectRowsConfig, {
      filterArray: qFilters
    }))];
    if (exactFilters) {
      selects.push(selectRowsDeprecated(Object.assign({}, selectRowsConfig, {
        filterArray: exactFilters
      })));
    }
    return Promise.all(selects).then(allResults => {
      const [queryResults, exactResults] = allResults;
      let finalResults;
      if (exactResults && exactResults.rowCount > 0) {
        finalResults = exactResults;

        // TODO: This can cause the "rowCount" to be incorrect. Ideally, keep track of changes to give accurate count
        if (finalResults.rowCount < maxRows) {
          const {
            key
          } = finalResults;
          const finalKeySet = finalResults.orderedModels[key].toOrderedSet().asMutable();
          queryResults.orderedModels[key].forEach(key => {
            finalKeySet.add(key);
            if (finalKeySet.size >= maxRows) {
              return false;
            }
          });
          finalKeySet.forEach(rowKey => {
            if (!finalResults.models[key].hasOwnProperty(rowKey)) {
              finalResults.orderedModels[key] = finalResults.orderedModels[key].push(rowKey);
              finalResults.models[key][rowKey] = queryResults.models[key][rowKey];
            }
          });
        }
      } else {
        finalResults = queryResults;
      }
      resolve(quoteValueColumnWithDelimiters(finalResults, valueColumn, delimiter));
    }).catch(reason => {
      reject(reason);
    });
  });
}
class InsertRowsErrorResponse extends (0,external_immutable_.Record)({
  errors: undefined,
  errorCount: 0,
  exception: undefined,
  extraContext: undefined,
  success: false
}) {
  getErrorMessage() {
    return this.exception; // TODO make this more user friendly by including row number and excluding techincal details
  }
}
class QueryCommandResponse {
  constructor(values) {
    api_defineProperty(this, external_immer_.immerable, true);
    api_defineProperty(this, "rows", void 0);
    api_defineProperty(this, "schemaQuery", void 0);
    api_defineProperty(this, "error", void 0);
    api_defineProperty(this, "transactionAuditId", void 0);
    api_defineProperty(this, "reselectRowCount", void 0);
    Object.assign(this, values);
    this.rows = this.rows ?? Array();
  }
  getFilter() {
    const rowIds = [];

    // insertRows returns properties with differing case
    this.rows.map(row => caseInsensitive(row, 'rowId')).forEach(rowId => {
      if (rowId !== undefined) {
        rowIds.push(rowId);
      }
    });
    return api_.Filter.create('RowId', rowIds, api_.Filter.Types.IN);
  }
}
function insertRows(options) {
  return new Promise((resolve, reject) => {
    const {
        fillEmptyFields,
        rows,
        schemaQuery
      } = options,
      insertRowsOptions = api_objectWithoutProperties(options, api_excluded);
    const _rows = fillEmptyFields === true ? ensureAllFieldsInAllRows(rows) : rows;
    api_.Query.insertRows(api_objectSpread(api_objectSpread({
      autoFormFileData: true
    }, insertRowsOptions), {}, {
      schemaName: schemaQuery.schemaName,
      queryName: schemaQuery.queryName,
      rows: _rows.toArray(),
      skipReselectRows: options.skipReselectRows === null || options.skipReselectRows === undefined ? true : options.skipReselectRows,
      apiVersion: 13.2,
      success: (response, request) => {
        if (processRequest(response, request, reject)) return;
        resolve(new QueryCommandResponse({
          schemaQuery,
          rows: response.rows,
          transactionAuditId: response.transactionAuditId,
          reselectRowCount: response.reselectRowCount
        }));
      },
      failure: error => {
        console.error(error);
        reject(new QueryCommandResponse({
          schemaQuery,
          error
        }));
      }
    }));
  });
}

// Ensures that the List of row objects are fully (as opposed to sparsely) populated. This avoids the server
// failing to map columns on sparsely populated data sets.
// As an example:
//
// [
//     {},
//     {"columnA": "AA"},
//     {"columnD": "DD"}
// ]
//
// becomes:
//
// [
//     {"columnA": null, "columnD": null},
//     {"columnA": "AA", "columnD": null},
//     {"columnA": null, "columnD": "DD"}
// ]
function ensureAllFieldsInAllRows(rows) {
  let masterRecord = (0,external_immutable_.Map)().asMutable();
  rows.forEach(row => {
    row.keySeq().forEach(key => {
      masterRecord.set(key, null);
    });
  });
  masterRecord = masterRecord.asImmutable();
  return rows.reduce((allFieldRows, row) => allFieldRows.push(ensureNullForUndefined(masterRecord.merge(row))), (0,external_immutable_.List)());
}

// undefined is not a valid JSON value so the values must be mapped to null.
function ensureNullForUndefined(row) {
  return row.reduce((map, v, k) => map.set(k, v === undefined ? null : v), (0,external_immutable_.Map)());
}
function updateRows(options) {
  return new Promise((resolve, reject) => {
    const {
        schemaQuery
      } = options,
      updateRowOptions = api_objectWithoutProperties(options, api_excluded2);
    api_.Query.updateRows(api_objectSpread(api_objectSpread({
      autoFormFileData: true
    }, updateRowOptions), {}, {
      queryName: schemaQuery.queryName,
      schemaName: schemaQuery.schemaName,
      skipReselectRows: options.skipReselectRows === null || options.skipReselectRows === undefined ? true : options.skipReselectRows,
      success: (response, request) => {
        if (processRequest(response, request, reject)) return;
        resolve(new QueryCommandResponse({
          schemaQuery,
          rows: response.rows,
          transactionAuditId: response.transactionAuditId,
          reselectRowCount: response.reselectRowCount
        }));
      },
      failure: error => {
        console.error(error);
        reject(Object.assign({}, {
          schemaQuery
        }, error));
      }
    }));
  });
}
function updateRowsByContainer(schemaQuery, rows, containerPaths, auditUserComment, containerField = 'Folder') {
  // if all rows are in the same container, we can use updateRows (which supports file/attachments)
  if (containerPaths.length < 2) {
    return updateRows({
      containerPath: containerPaths?.[0],
      auditBehavior: api_.AuditBehaviorTypes.DETAILED,
      auditUserComment,
      rows,
      schemaQuery
    });
  } else {
    const commands = [];
    commands.push({
      command: 'update',
      schemaName: schemaQuery.schemaName,
      queryName: schemaQuery.queryName,
      rows,
      auditBehavior: api_.AuditBehaviorTypes.DETAILED,
      auditUserComment,
      skipReselectRows: true
    });
    return saveRowsByContainer({
      commands
    }, containerField);
  }
}
function deleteRows(options) {
  return new Promise((resolve, reject) => {
    const {
        schemaQuery
      } = options,
      deleteRowsOptions = api_objectWithoutProperties(options, _excluded3);
    api_.Query.deleteRows(api_objectSpread(api_objectSpread({
      apiVersion: 13.2
    }, deleteRowsOptions), {}, {
      schemaName: schemaQuery.schemaName,
      queryName: schemaQuery.queryName,
      success: response => {
        resolve(new QueryCommandResponse({
          schemaQuery: options.schemaQuery,
          rows: response.rows,
          transactionAuditId: response.transactionAuditId
        }));
      },
      failure: error => {
        reject({
          schemaQuery: options.schemaQuery,
          error
        });
      }
    }));
  });
}
function saveRows(options) {
  return new Promise((resolve, reject) => {
    api_.Query.saveRows(api_objectSpread(api_objectSpread({
      apiVersion: 13.2
    }, options), {}, {
      success: response => {
        resolve(response);
      },
      failure: error => {
        reject(error);
      }
    }));
  });
}

// exported for jest testing
function splitRowsByContainer(rows, containerField) {
  const containerRows = {};
  rows.forEach(row => {
    const container = caseInsensitive(row, containerField);
    if (!containerRows[container]) containerRows[container] = [];
    containerRows[container].push(row);
  });
  return containerRows;
}
function saveRowsByContainer(options, containerField = 'Folder') {
  const commands = []; // TODO type as Query.Command

  // for each original command, split it into multiple commands for each container in the rows
  options.commands.forEach(command => {
    const containerRows = splitRowsByContainer(command.rows, containerField);
    Object.keys(containerRows).forEach(containerPath => {
      const rows = containerRows[containerPath];
      commands.push(api_objectSpread(api_objectSpread({}, command), {}, {
        rows,
        // splitRowsByContainer will use the Record key of "undefined" if the row doesn't have a containerPath
        containerPath: !containerPath || containerPath === 'undefined' ? undefined : containerPath
      }));
    });
  });
  return saveRows(api_objectSpread(api_objectSpread({}, options), {}, {
    commands,
    apiVersion: undefined /* use default instead of 13.2 as defined in saveRows() */
  }));
}
function deleteRowsByContainer(options, containerField = 'ContainerPath') {
  const commands = [];
  const allRows = options.rows;
  if (!allRows || Object.keys(allRows[0]).map(key => key.toLowerCase()).indexOf(containerField.toLowerCase()) === -1) return deleteRows(options);
  const containerRows = splitRowsByContainer(allRows, containerField);
  if (Object.keys(containerRows).length <= 1) {
    const containerPath = Object.keys(containerRows)?.[0];
    return deleteRows(api_objectSpread(api_objectSpread({}, options), {}, {
      containerPath
    }));
  }
  Object.keys(containerRows).forEach(containerPath => {
    const rows = containerRows[containerPath];
    commands.push(api_objectSpread(api_objectSpread({}, options), {}, {
      command: 'delete',
      schemaName: options.schemaQuery.schemaName,
      queryName: options.schemaQuery.queryName,
      rows,
      containerPath
    }));
  });
  return new Promise((resolve, reject) => {
    saveRows({
      commands
    }).then(response => {
      const rows = [];
      response.result.forEach((resp, ind) => {
        rows.push(resp.rows);
      });
      resolve(new QueryCommandResponse({
        schemaQuery: options.schemaQuery,
        rows,
        transactionAuditId: response.result[0]?.['transactionAuditId']
      }));
    }).catch(error => {
      reject({
        schemaQuery: options.schemaQuery,
        error
      });
    });
  });
}
let InsertOptions = /*#__PURE__*/function (InsertOptions) {
  InsertOptions[InsertOptions["IMPORT"] = 0] = "IMPORT";
  InsertOptions[InsertOptions["MERGE"] = 1] = "MERGE";
  InsertOptions[InsertOptions["UPDATE"] = 2] = "UPDATE";
  InsertOptions[InsertOptions["CREATE"] = 3] = "CREATE";
  return InsertOptions;
}({}); // synonymous with Import for server-side; used for better messaging client-side
function getVerbForInsertOption(option, defaultVerb = 'imported') {
  if (option === InsertOptions.MERGE.toString()) {
    return defaultVerb + ' or updated';
  } else if (option === InsertOptions.UPDATE.toString()) {
    return 'updated';
  } else if (option === InsertOptions.CREATE.toString()) {
    return 'created';
  } else {
    return defaultVerb;
  }
}
let InsertFormats = /*#__PURE__*/function (InsertFormats) {
  InsertFormats["csv"] = "csv";
  InsertFormats["tsv"] = "tsv";
  return InsertFormats;
}({});
function importData(config) {
  return new Promise((resolve, reject) => {
    api_.QueryDOM.importData(Object.assign({}, config, {
      success: response => {
        if (response && response.exception) {
          reject(response);
        }
        resolve(response);
      },
      failure: error => {
        reject(error);
      }
    }));
  });
}
function processRequest(response, request, reject) {
  if (!response && request?.responseText) {
    const resp = JSON.parse(request.responseText);
    if (!resp?.success) {
      console.error(resp);
      reject(resp);
      return true;
    }
  }
  return false;
}

/**
 * Provides the default ContainerFilter to utilize when requesting data cross-folder.
 * This ContainerFilter is applied to all `executeSql` and `selectRows` requests made via the methods
 * provided by `@labkey/components`.
 * @private
 */
function getContainerFilter(containerPath, moduleContext) {
  // Check to see if product projects support is enabled.
  if (!isProductProjectsEnabled(moduleContext)) {
    return undefined;
  }

  // When all folder filtering is enabled resolve data across all folders.
  if (isAllProductFoldersFilteringEnabled(moduleContext)) {
    return api_.Query.ContainerFilter.allInProjectPlusShared;
  }

  // When requesting data from a top-level folder context the ContainerFilter filters
  // "down" the folder hierarchy for data.
  if (isProjectContainer(containerPath)) {
    return api_.Query.ContainerFilter.currentAndSubfoldersPlusShared;
  }

  // When requesting data from a sub-folder context the ContainerFilter filters
  // "up" the folder hierarchy for data.
  return api_.Query.ContainerFilter.currentPlusProjectAndShared;
}

/**
 * Provides the configured ContainerFilter to utilize when requesting data that is being read
 * within a folder context.
 * @private
 */
function getContainerFilterForFolder(containerPath, moduleContext) {
  // Check to see if product projects support is enabled.
  if (!isProductProjectsEnabled(moduleContext)) {
    return undefined;
  }
  if (isProductProjectsDataListingScopedToProject(moduleContext)) {
    // When requesting data from a top-level folder context the ContainerFilter filters
    // "down" the folder hierarchy for data.
    if (isProjectContainer(containerPath)) {
      if (isAllProductFoldersFilteringEnabled(moduleContext)) {
        return api_.Query.ContainerFilter.allInProjectPlusShared;
      }
      return api_.Query.ContainerFilter.currentAndSubfoldersPlusShared;
    }

    // When listing data in a folder scope returned data to the current
    // folder when the experimental feature is enabled.
    return api_.Query.ContainerFilter.current;
  }

  // When requesting data from a top-level folder context the ContainerFilter filters
  // "down" the folder hierarchy for data.
  if (isProjectContainer(containerPath)) {
    return api_.Query.ContainerFilter.currentAndSubfoldersPlusShared;
  }

  // When requesting data from a sub-folder context the ContainerFilter filters
  // "up" the folder hierarchy for data.
  return api_.Query.ContainerFilter.currentPlusProjectAndShared;
}

/**
 * Provides the default ContainerFilter to utilize when requesting data for insert cross-folder.
 * This ContainerFilter must be explicitly applied to be respected.
 * @private
 */
function getContainerFilterForLookups(moduleContext) {
  // Check to see if product projects support is enabled.
  if (!isProductProjectsEnabled(moduleContext)) {
    return undefined;
  }

  // When all folder filtering is enabled resolve lookups against all folders
  // within the top-level folder plus shared.
  if (isAllProductFoldersFilteringEnabled(moduleContext)) {
    return api_.Query.ContainerFilter.allInProjectPlusShared;
  }

  // When inserting data from a top-level folder or a sub-folder context
  // the ContainerFilter filters "up" the folder hierarchy for data.
  return api_.Query.ContainerFilter.currentPlusProjectAndShared;
}
function selectDistinctRows(options) {
  const {
      requestHandler
    } = options,
    queryOptions = api_objectWithoutProperties(options, _excluded4);
  return new Promise((resolve, reject) => {
    const request_ = api_.Query.selectDistinctRows(api_objectSpread(api_objectSpread({
      method: 'POST'
    }, queryOptions), {}, {
      containerFilter: queryOptions.containerFilter ?? getContainerFilter(queryOptions.containerPath),
      success: response => {
        resolve(response);
      },
      failure: (error, request) => {
        if (request.status !== 0) console.error(error);
        reject(api_objectSpread(api_objectSpread({}, error), {}, {
          status: request.status
        }));
      }
    }));
    requestHandler?.(request_);
  });
}
function loadQueries(schemaQueries) {
  return Promise.all(schemaQueries.map(schemaQuery => getQueryDetails({
    schemaQuery
  })));
}

/**
 * Loads a set of QueryInfo's sourced from a table (tableSchemaQuery)
 * where the key field (tableFieldKey) specifies the query name on the specified schema (targetSchemaName).
 *
 * Example:
 * The table "exp.SampleSets" contains a row per sample type defined in the container. The name of the sample type is
 * found on the "Name" column. The sample types themselves are on the "samples" schema. Here is what the parameters
 * would look like to load sample type QueryInfo's for each row in the "exp.SampleSets" table.
 *
 * tableSchemaQuery: exp.SampleSets
 * tableFieldKey: Name
 * targetSchemaName: samples
 *
 * @param tableSchemaQuery - The "meta" table containing a row per query found on the "targetSchemaName" schema.
 * @param tableFieldKey - The fieldKey on a given row in the "tableSchemaQuery" that contains the name of the query.
 * @param targetSchemaName - The target schemaName where the queries found on "tableFieldKey" can be found.
 * @param containerFilter - Optional Query.ContainerFilter applied to tables request.
 * @param filters - Optional Query filters applied to tables request.
 */
async function loadQueriesFromTable(tableSchemaQuery, tableFieldKey, targetSchemaName, containerFilter, filters) {
  const {
    schemaName,
    queryName,
    viewName
  } = tableSchemaQuery;
  const info = await getQueryDetails({
    queryName,
    schemaName
  });
  const queryNameField = info.getColumn(tableFieldKey);
  if (queryNameField) {
    const columns = new Set(info.getPkCols().map(col => col.fieldKey)).add(queryNameField.name);
    const {
      key,
      models
    } = await selectRowsDeprecated({
      containerFilter,
      columns: Array.from(columns).join(','),
      filterArray: filters,
      queryName,
      schemaName,
      viewName
    });
    const schemaQueries = Object.values(models[key]).map(row => caseInsensitive(row, queryNameField.name)?.value).filter(query => query !== undefined).map(query => new SchemaQuery(targetSchemaName, query));
    return loadQueries(schemaQueries);
  }
  return [];
}
;// CONCATENATED MODULE: ./src/internal/components/assay/utils.ts





// TODO: Move this out of assay/utils
function inferDomainFromFile(file,
// file or webdav url path
numLinesToInclude, domainKindName) {
  return new Promise((resolve, reject) => {
    const form = new FormData();
    form.append('file', file);
    form.append('numLinesToInclude', numLinesToInclude ? (numLinesToInclude + 1).toString() : undefined);
    if (domainKindName) {
      form.append('domainKindName', domainKindName);
    }
    api_.Ajax.request({
      url: buildURL('property', 'inferDomain'),
      method: 'POST',
      form,
      success: api_.Utils.getCallbackWrapper((response, request) => {
        if (processRequest(response, request, reject)) return;
        resolve(InferDomainResponse.create(response));
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        console.error(error);
        reject('There was a problem determining the fields in the uploaded file.  Please check the format of the file.');
      })
    });
  });
}

/**
 * This is used for retrieving preview data for a file already on the server side
 * @param file This can be a rowId for the file, or a path to the file
 * @param fileName The file name to be used to check the extension
 * @param numLinesToInclude the number of lines of data to include (excludes the header)
 */
function getServerFilePreview(file, fileName, numLinesToInclude) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL('property', 'getFilePreview.api'),
      params: {
        file,
        numLinesToInclude: numLinesToInclude ? numLinesToInclude + 1 : undefined,
        // add one to account for the header
        guessFormatAsTSV: fileName?.toLowerCase().endsWith('.tmp') // Issue 47749
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(InferDomainResponse.create(response));
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        reject('There was a problem retrieving the preview data.');
        console.error(response);
      })
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/SchemaDetails.ts

class SchemaDetails extends (0,external_immutable_.Record)({
  description: undefined,
  fullyQualifiedName: undefined,
  hidden: true,
  schemaName: undefined,
  schemas: (0,external_immutable_.List)()
}) {
  static create(schema) {
    const copy = Object.assign({}, schema);
    const schemas = (0,external_immutable_.List)().asMutable();
    if (schema.schemas) {
      for (const s in schema.schemas) {
        if (schema.schemas.hasOwnProperty(s)) {
          schemas.push(schema.schemas[s].fullyQualifiedName.toLowerCase());
        }
      }
    }
    copy.schemas = schemas.asImmutable();
    return new SchemaDetails(copy);
  }
  getLabel() {
    return this.schemaName;
  }
  getName() {
    return this.fullyQualifiedName;
  }
}
;// CONCATENATED MODULE: ./src/internal/url/WhereFilterType.ts
/**
 * This implements the filter corresponding to <code>QueryServiceImpl.WhereClause</code>
 */
class WhereFilterType {
  getDisplaySymbol() {
    return null;
  }
  getDisplayText() {
    return 'Where';
  }
  getLongDisplayText() {
    return this.getDisplayText();
  }
  getURLSuffix() {
    return 'where';
  }
  isDataValueRequired() {
    return true;
  }
  isMultiValued() {
    return false;
  }
  isTableWise() {
    return true;
  }
  getMultiValueFilter() {
    return null;
  }
  getMultiValueMaxOccurs() {
    return 0;
  }
  getMultiValueMinOccurs() {
    return 0;
  }
  getMultiValueSeparator() {
    return null;
  }
  getOpposite() {
    return null;
  }
  getSingleValueFilter() {
    return null;
  }
  parseValue(value) {
    return value;
  }
  getURLParameterValue(value) {
    return value;
  }
  validate(value, jsonType, columnName) {}
  getLabKeySqlOperator() {
    return null;
  }
}
const WHERE_FILTER_TYPE = new WhereFilterType();
;// CONCATENATED MODULE: ./src/internal/AssayDefinitionModel.ts
function AssayDefinitionModel_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AssayDefinitionModel_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AssayDefinitionModel_ownKeys(Object(t), !0).forEach(function (r) { AssayDefinitionModel_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AssayDefinitionModel_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function AssayDefinitionModel_defineProperty(e, r, t) { return (r = AssayDefinitionModel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function AssayDefinitionModel_toPropertyKey(t) { var i = AssayDefinitionModel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function AssayDefinitionModel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






let AssayDomainTypes = /*#__PURE__*/function (AssayDomainTypes) {
  AssayDomainTypes["BATCH"] = "Batch";
  AssayDomainTypes["RESULT"] = "Result";
  AssayDomainTypes["RUN"] = "Run";
  return AssayDomainTypes;
}({});
let AssayLink = /*#__PURE__*/function (AssayLink) {
  AssayLink["BATCHES"] = "batches";
  AssayLink["BEGIN"] = "begin";
  AssayLink["DESIGN_COPY"] = "designCopy";
  AssayLink["DESIGN_EDIT"] = "designEdit";
  AssayLink["IMPORT"] = "import";
  AssayLink["RESULT"] = "result";
  AssayLink["RESULTS"] = "results";
  AssayLink["RUNS"] = "runs";
  return AssayLink;
}({});
class AssayDefinitionModel extends (0,external_immutable_.Record)({
  containerPath: undefined,
  description: undefined,
  domains: (0,external_immutable_.Map)(),
  domainTypes: (0,external_immutable_.Map)(),
  id: undefined,
  importAction: undefined,
  importController: undefined,
  links: (0,external_immutable_.Map)(),
  name: undefined,
  projectLevel: undefined,
  protocolSchemaName: undefined,
  requireCommentOnQCStateChange: undefined,
  reRunSupport: undefined,
  templateLink: undefined,
  type: undefined
}) {
  static create(rawModel) {
    let domains = (0,external_immutable_.Map)();
    let domainTypes = (0,external_immutable_.Map)();
    let links = (0,external_immutable_.Map)();
    if (rawModel) {
      if (rawModel.domainTypes) {
        domainTypes = (0,external_immutable_.fromJS)(rawModel.domainTypes);
      }
      if (rawModel.domains) {
        const rawDomains = Object.keys(rawModel.domains).reduce((result, k) => {
          result[k] = (0,external_immutable_.List)(rawModel.domains[k].map(rawColumn => new QueryColumn(rawColumn)));
          return result;
        }, {});
        domains = (0,external_immutable_.Map)(rawDomains);
      }
      if (rawModel.links) {
        links = (0,external_immutable_.fromJS)(rawModel.links);
      }
    }
    return new AssayDefinitionModel(AssayDefinitionModel_objectSpread(AssayDefinitionModel_objectSpread({}, rawModel), {}, {
      domains,
      domainTypes,
      links
    }));
  }
  getDomainByType(domainType) {
    if (this.domainTypes.has(domainType)) {
      return this.domains.get(this.domainTypes.get(domainType));
    }
    return undefined;
  }
  getImportUrl(dataTab, selectionKey, filterList, isPicklist, currentProductId, targetProductId, ignoreFilter) {
    let url;
    // Note, will need to handle the re-import run case separately. Possibly introduce another URL via links
    if (this.name !== undefined && this.importAction === 'uploadWizard' && this.importController === 'assay') {
      const params = {
        rowId: this.id
      };
      if (dataTab) params.dataTab = dataTab;
      if (!ignoreFilter) {
        filterList?.forEach(filter => {
          // if the filter has a URL suffix and is not registered as one recognized for URL filters, we ignore it here
          // CONSIDER:  Applications might want to be able to register their own filter types
          const urlSuffix = filter.getFilterType().getURLSuffix();
          if (!urlSuffix || api_.Filter.getFilterTypeForURLSuffix(urlSuffix)) {
            params[filter.getURLParameterName()] = filter.getURLParameterValue();
          }
        });
      }
      if (selectionKey) params.selectionKey = selectionKey;
      if (isPicklist) params.isPicklist = true;
      url = createProductUrlFromParts(targetProductId, currentProductId, params, 'assays', this.type, this.name, 'upload');
      if (url instanceof AppURL) {
        url = url.toHref();
      }
    } else {
      url = this.links.get(AssayLink.IMPORT);
    }
    return url;
  }
  getRunsUrl() {
    return AppURL.create('assays', this.type, this.name, 'runs');
  }
  hasLookup(targetSQ, isPicklist) {
    const isSampleSet = targetSQ.hasSchema(SCHEMAS.SAMPLE_SETS.SCHEMA);

    // 44339: the SourceSamples custom query is backed by exp.materials
    const isTargetAllSamples = targetSQ.isEqual(SCHEMAS.SAMPLE_MANAGEMENT.SOURCE_SAMPLES) || targetSQ.isEqual(SCHEMAS.SAMPLE_MANAGEMENT.INPUT_SAMPLES_SQ) || isPicklist && targetSQ.hasSchema(SCHEMAS.PICKLIST_TABLES.SCHEMA);
    const findLookup = col => {
      if (col.isLookup()) {
        const lookupSQ = col.lookup.schemaQuery;
        const isMatch = targetSQ.isEqual(lookupSQ) || isTargetAllSamples && SCHEMAS.EXP_TABLES.MATERIALS.isEqual(lookupSQ);

        // 35881: If targetSQ is a Sample Set then allow targeting exp.materials table as well
        if (isSampleSet) {
          return isMatch || SCHEMAS.EXP_TABLES.MATERIALS.isEqual(lookupSQ);
        }
        return isMatch;
      }
      return false;
    };

    // Traditional for loop so we can short circuit.
    for (const k of Object.keys(AssayDomainTypes)) {
      const domainType = AssayDomainTypes[k];
      const domainColumns = this.getDomainByType(domainType);
      if (domainColumns && domainColumns.find(findLookup)) {
        return true;
      }
    }
    return false;
  }
  getSampleColumnsByDomain(domainType) {
    const ret = [];
    const columns = this.getDomainByType(domainType);
    if (columns) {
      columns.forEach(column => {
        if (column.isSampleLookup()) {
          ret.push({
            column,
            domain: domainType
          });
        }
      });
    }
    return ret;
  }

  /**
   * get all sample lookup columns found in the result, run, and batch domains, or from a specific domainType
   */
  getSampleColumns(domainType) {
    let ret = [];
    // The order matters here, we care about result, run, and batch in that order.
    const domainTypes = domainType ? [domainType] : [AssayDomainTypes.RESULT, AssayDomainTypes.RUN, AssayDomainTypes.BATCH];
    for (const domain of domainTypes) {
      const columns = this.getSampleColumnsByDomain(domain);
      if (columns && columns.length > 0) {
        ret = ret.concat(columns);
      }
    }
    return (0,external_immutable_.List)(ret);
  }

  /**
   * get the first sample lookup column found in the result, run, or batch domain.
   */
  getSampleColumn(domainType) {
    const sampleColumns = this.getSampleColumns(domainType);
    return !sampleColumns.isEmpty() ? sampleColumns.first() : null;
  }

  /**
   * returns the FieldKey string of the sample column relative from the assay Results table.
   */
  sampleColumnFieldKey(sampleCol) {
    if (sampleCol.domain === AssayDomainTypes.RESULT) {
      return sampleCol.column.fieldKey;
    } else if (sampleCol.domain === AssayDomainTypes.RUN) {
      return `Run/${sampleCol.column.fieldKey}`;
    } else if (sampleCol.domain === AssayDomainTypes.BATCH) {
      return `Run/Batch/${sampleCol.column.fieldKey}`;
    }
    throw new Error('Unexpected assay domain type: ' + sampleCol.domain);
  }

  /**
   * returns the FieldKey string of the sample columns relative from the assay Results table.
   */
  getSampleColumnFieldKeys() {
    const sampleCols = this.getSampleColumns();
    return (0,external_immutable_.List)(sampleCols.map(this.sampleColumnFieldKey));
  }
  createSampleFilter(sampleColumns, value, singleFilter) {
    const keyCol = '/RowId';
    if (sampleColumns.size === 1) {
      // generate simple equals filter
      const sampleColumn = sampleColumns.get(0);
      return api_.Filter.create(sampleColumn + keyCol, value, singleFilter);
    } else if (sampleColumns.size > 1) {
      // generate a where clause filter to include all sample columns via a UNION (issue 47346)
      const whereClause = 'RowId IN (' + sampleColumns.map(sampleCol => {
        const fieldKey = (sampleCol + keyCol).split('/').map(token => '"' + token + '"').join('.');
        return `SELECT RowId FROM Data WHERE ${fieldKey} IN (${value.join(',')})`;
      }).join(' UNION ') + ')';
      return api_.Filter.create('*', whereClause, WHERE_FILTER_TYPE);
    }
  }
  getDomainColumns(type) {
    const columns = (0,external_immutable_.OrderedMap)().asMutable();
    if (this.domains && this.domains.size) {
      const domainColumns = this.getDomainByType(type);
      if (domainColumns && domainColumns.size) {
        domainColumns.forEach(dc => {
          columns.set(dc.fieldKey.toLowerCase(), dc);
        });
      }
    }
    return columns.asImmutable();
  }
  getDomainFileColumns(type) {
    return this.getDomainColumns(type).filter(col => col.isFileInput).toArray();
  }
}
;// CONCATENATED MODULE: ./src/internal/components/ontology/models.ts
function ontology_models_defineProperty(e, r, t) { return (r = ontology_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ontology_models_toPropertyKey(t) { var i = ontology_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ontology_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


const ONTOLOGY_ROOT_CODE_PREFIX = 'labkey_ontology:';
class ConceptModel {
  // Abbreviation code for the parent ontology

  constructor(values) {
    ontology_models_defineProperty(this, external_immer_.immerable, true);
    ontology_models_defineProperty(this, "label", void 0);
    ontology_models_defineProperty(this, "code", void 0);
    ontology_models_defineProperty(this, "paths", void 0);
    ontology_models_defineProperty(this, "description", void 0);
    ontology_models_defineProperty(this, "synonyms", void 0);
    ontology_models_defineProperty(this, "ontology", void 0);
    Object.assign(this, values);
  }
  getDisplayLabel() {
    return this.label + ' (' + this.code + ')';
  }
}
class PathModel {
  // Array of Child paths, undefined if not loaded or hasChildren is false

  constructor(values) {
    ontology_models_defineProperty(this, external_immer_.immerable, true);
    ontology_models_defineProperty(this, "path", void 0);
    // Ontology coded path
    ontology_models_defineProperty(this, "code", void 0);
    // Concept code for the concept at this path
    ontology_models_defineProperty(this, "label", void 0);
    // Human readable label for this path node
    ontology_models_defineProperty(this, "hasChildren", void 0);
    // flag indicating if node path has any children
    ontology_models_defineProperty(this, "children", void 0);
    Object.assign(this, values);
  }
  getDisplayLabel() {
    return this.label + ' (' + this.code + ')';
  }
}
class OntologyModel {
  constructor(values) {
    ontology_models_defineProperty(this, external_immer_.immerable, true);
    ontology_models_defineProperty(this, "name", void 0);
    ontology_models_defineProperty(this, "description", void 0);
    ontology_models_defineProperty(this, "rowId", void 0);
    ontology_models_defineProperty(this, "abbreviation", void 0);
    ontology_models_defineProperty(this, "path", void 0);
    ontology_models_defineProperty(this, "conceptCount", void 0);
    ontology_models_defineProperty(this, "children", undefined);
    Object.assign(this, values);
  }
  static create(raw) {
    return new OntologyModel({
      rowId: caseInsensitive(raw, 'RowId')?.value,
      name: caseInsensitive(raw, 'Name')?.value,
      abbreviation: caseInsensitive(raw, 'Abbreviation')?.value
    });
  }
  getPathModel() {
    return new PathModel({
      path: this.path,
      code: this.abbreviation,
      label: this.name,
      hasChildren: !!this.children,
      children: this.children
    });
  }
  getDisplayName() {
    return this.name + (this.name !== this.abbreviation ? ' (' + this.abbreviation + ')' : '');
  }
}
;// CONCATENATED MODULE: ./src/internal/components/ontology/actions.ts


const ONTOLOGY_MODULE_NAME = 'ontology';
const ONTOLOGY_CONTROLLER = 'ontology';
const GET_CHILD_PATHS_ACTION = 'getChildPaths.api';
const GET_ONTOLOGY_ACTION = 'getOntology.api';
const GET_CONCEPT_ACTION = 'getConcept.api';
const GET_ALTERNATE_CONCEPT_PATHS_ACTION = 'getAlternateConceptPaths.api';
const GET_PARENT_PATHS_ACTION = 'getConceptParentPaths.api';
const GET_CONCEPT_PATH_FROM_CONCEPT_CODES_ACTION = 'getConceptPathFromConceptCodes.api';
const SHARED_CONTAINER = 'shared';
class Ontology {
  static getOntology(ontologyId) {
    return new Promise((resolve, reject) => {
      const {
        container
      } = (0,api_.getServerContext)();
      api_.Ajax.request({
        url: api_.ActionURL.buildURL(ONTOLOGY_CONTROLLER, GET_ONTOLOGY_ACTION, container?.path, {
          abbreviation: ontologyId
        }),
        success: api_.Utils.getCallbackWrapper(response => {
          resolve(new OntologyModel(response));
        }),
        failure: api_.Utils.getCallbackWrapper(response => {
          console.error(response);
          reject(response);
        }, null, false)
      });
    });
  }
  static getConcept(code) {
    return new Promise((resolve, reject) => {
      const {
        container
      } = (0,api_.getServerContext)();
      api_.Ajax.request({
        url: api_.ActionURL.buildURL(ONTOLOGY_CONTROLLER, GET_CONCEPT_ACTION, container?.path, {
          code
        }),
        success: api_.Utils.getCallbackWrapper(response => {
          resolve(new ConceptModel(response.concept));
        }),
        failure: api_.Utils.getCallbackWrapper(response => {
          console.error(response);
          reject(response);
        }, null, false)
      });
    });
  }
  static getConceptPath(path) {
    return new Promise((resolve, reject) => {
      const {
        container
      } = (0,api_.getServerContext)();
      api_.Ajax.request({
        url: api_.ActionURL.buildURL(ONTOLOGY_CONTROLLER, GET_CONCEPT_PATH_FROM_CONCEPT_CODES_ACTION, container?.path),
        jsonData: {
          path
        },
        success: api_.Utils.getCallbackWrapper(response => {
          resolve(new PathModel(response));
        }),
        failure: api_.Utils.getCallbackWrapper(response => {
          console.error(response);
          reject(response);
        }, null, false)
      });
    });
  }
}
function getOntologyDetails(ontologyId) {
  return Ontology.getOntology(ontologyId);
}
function getOntologyChildPathsAndConcepts(ontologyPath, container = SHARED_CONTAINER) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: api_.ActionURL.buildURL(ONTOLOGY_CONTROLLER, GET_CHILD_PATHS_ACTION, container, {
        path: ontologyPath
      }),
      success: api_.Utils.getCallbackWrapper(response => {
        const parent = response.parent;
        const {
          path,
          code,
          children
        } = parent;
        const childPaths = children?.map(child => new PathModel(child));
        resolve(new PathModel({
          path,
          code,
          children: childPaths
        }));
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(response);
      }, null, false)
    });
  });
}
function getAlternateConceptPaths(conceptCode, container = SHARED_CONTAINER) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: api_.ActionURL.buildURL(ONTOLOGY_CONTROLLER, GET_ALTERNATE_CONCEPT_PATHS_ACTION, container, {
        code: conceptCode
      }),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response.paths?.map(path => new PathModel(path)));
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(response);
      }, null, false)
    });
  });
}
function getConceptParentPaths(conceptPath, container = SHARED_CONTAINER) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: api_.ActionURL.buildURL(ONTOLOGY_CONTROLLER, GET_PARENT_PATHS_ACTION, container, {
        path: conceptPath
      }),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response.parents?.map(path => new PathModel(path)));
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        // Defensive only because it causes test failures, response should always be present
        reject(response?.errors);
      }, null, false)
    });
  });
}
function fetchChildPaths(ontologyPath) {
  return getOntologyChildPathsAndConcepts(ontologyPath);
}
function fetchAlternatePaths(conceptCode) {
  return getAlternateConceptPaths(conceptCode);
}
function fetchParentPaths(conceptPath) {
  return getConceptParentPaths(conceptPath);
}

/**
 * Concatenate the parent concept codes minus the root
 * @param parents
 */
function getParentsConceptCodePath(parents) {
  return [...parents].filter(node => !node.code.startsWith(ONTOLOGY_ROOT_CODE_PREFIX)) // Ignore the root node
  .map(node => node.code).join('/');
}
const CONCEPT_CACHE = new Map();
async function fetchConceptForCode(code) {
  if (!CONCEPT_CACHE.has(code)) {
    const concept = await Ontology.getConcept(code);
    CONCEPT_CACHE.set(code, concept);
  }
  return CONCEPT_CACHE.get(code);
}
function getConceptForCode(code) {
  if (!code) return undefined;
  fetchConceptForCode(code);
  return CONCEPT_CACHE.get(code);
}

/**
 * Gets the path model from the database for a supplied path(s)
 * @param path
 */
function fetchPathModel(path) {
  return Ontology.getConceptPath(path);
}
// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(992);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainDesignerCheckbox.tsx


// Note: This component is specifically for the Domain Designer, if you need to render a checkbox input you should
// probably be using CheckboxInput instead.
const DomainDesignerCheckbox = (0,external_react_.memo)(({
  checked,
  children,
  className,
  disabled,
  id,
  name,
  onChange
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: external_classnames_default()('checkbox', className)
}, /*#__PURE__*/external_react_default().createElement("label", null, /*#__PURE__*/external_react_default().createElement("input", {
  checked: checked,
  disabled: disabled,
  id: id,
  name: name,
  onChange: onChange,
  type: "checkbox"
}), children)));
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/propertiesUtil.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



// this is similar to what's in PropertiesEditorUtil.java that does the name validation in the old UI
function isLegalName(str) {
  for (let i = 0; i < str.length; i++) {
    if (!isLegalNameChar(str.charAt(i), i == 0)) return false;
  }
  return true;
}
function isLegalNameChar(ch, first) {
  if (ch >= 'A' && ch <= 'Z' || ch >= 'a' && ch <= 'z' || ch == '_') return true;
  if (first) return false;
  if (ch >= '0' && ch <= '9') return true;
  if (ch == ' ') return true;
  return false;
}
function isFieldPartiallyLocked(lockType) {
  // with partially locked can't change name and type, but can change other properties
  return lockType === DOMAIN_FIELD_PARTIALLY_LOCKED;
}
function isFieldFullyLocked(lockType) {
  // with fully locked, can't change any properties
  return lockType === DOMAIN_FIELD_FULLY_LOCKED;
}
function isPrimaryKeyFieldLocked(lockType) {
  // with PK locked, can't change type or required, but can change other properties
  return lockType === DOMAIN_FIELD_PRIMARY_KEY_LOCKED;
}
function generateBulkDeleteWarning(deletabilityInfo, undeletableNames) {
  const {
    deletableSelectedFields,
    undeletableFields
  } = deletabilityInfo;
  const deletableCount = deletableSelectedFields.length;
  const undeletableCount = undeletableFields.length;
  const fields = deletableCount !== 1 ? 'fields' : 'field';
  const howManyDeleted = undeletableCount > 0 ? `${deletableCount} of ${deletableCount + undeletableCount} fields` : `${deletableCount} ${fields}`;
  const itIsA = undeletableCount > 1 ? 'they are' : 'it is a';
  const field = undeletableCount > 1 ? 'fields' : 'field';
  const undeletableWarning = undeletableCount > 0 ? `${undeletableNames.join(', ')} cannot be deleted as ${itIsA} necessary ${field}.` : '';
  return {
    howManyDeleted,
    undeletableWarning
  };
}
function applySetOperation(oldSet, value, add) {
  if (add) {
    return oldSet.add(value);
  } else {
    oldSet.delete(value);
    return oldSet;
  }
}
function getVisibleSelectedFieldIndexes(fields) {
  return fields.reduce((setOfIndexes, currentField, index) => {
    return currentField.visible && currentField.selected ? setOfIndexes.add(index) : setOfIndexes;
  }, new Set());
}
function isFieldDeletable(field) {
  return !isFieldFullyLocked(field.lockType) && !isFieldPartiallyLocked(field.lockType) && !isPrimaryKeyFieldLocked(field.lockType) && !field.lockExistingField // existingField defaults to false. used for query metadata editor
  ;
}
function getVisibleFieldCount(domain) {
  return domain.fields.filter(field => field.visible).size;
}
function compareStringsAlphabetically(a, b, direction) {
  const aStr = a ? a.toUpperCase() : '';
  const bStr = b ? b.toUpperCase() : '';
  const isAsc = direction === '+';
  if (aStr < bStr) {
    return isAsc ? -1 : 1;
  }
  if (aStr > bStr) {
    return isAsc ? 1 : -1;
  }
  return 0;
}
function removeFalseyObjKeys(obj) {
  return Object.entries(obj).reduce((a, [k, v]) => v ? (a[k] = v, a) : a, {});
}

// columnOrder determines the left-to-right ordering of columns within the domain summary view
function reorderSummaryColumns(a, b) {
  const columnOrder = [
  // Collapsed field options
  'name', 'rangeURI', 'required', 'isPrimaryKey', 'lockType',
  // Lookup options
  'lookupContainer', 'lookupSchema', 'lookupQuery',
  // Integer options
  'format', 'defaultScale',
  // Ontology options
  'sourceOntology', 'conceptSubtree', 'conceptImportColumn', 'conceptLabelColumn', 'principalConceptCode',
  // Other expanded field options
  'conceptURI',
  // ParticipantId, Flag, Sample, and Ontology Lookup
  'scale', 'scannable', 'description', 'label', 'importAliases', 'url', 'conditionalFormats', 'propertyValidators', 'valueExpression',
  // Advanced Settings
  'hidden', 'shownInUpdateView', 'shownInInsertView', 'shownInDetailsView', 'defaultValueType', 'defaultValue', 'defaultDisplayValue', 'phi', 'excludeFromShifting',
  // Appears for datetime fields
  'measure', 'dimension', 'recommendedVariable', 'mvEnabled'];
  return columnOrder.indexOf(a.index) > columnOrder.indexOf(b.index) ? 1 : -1;
}
function removeUnusedProperties(obj) {
  // only applicable in the QueryMetadata field editor case
  delete obj.wrappedColumnName;
  // Not surfaced in UI, and so removed from summary view
  delete obj.propertyId;
  delete obj.propertyURI;
  // Currently only surfaced in SM Sample Types as a experimental feature.
  // To be added to Summary View columns when aliquots are no longer hidden behind experimental flag
  delete obj.derivationDataScope;
  return obj;
}
function removeUnusedOntologyProperties(obj) {
  delete obj.sourceOntology;
  delete obj.conceptSubtree;
  delete obj.conceptImportColumn;
  delete obj.conceptLabelColumn;
  delete obj.principalConceptCode;
  return obj;
}
function removeNonAppProperties(obj) {
  if (!hasPremiumModule()) {
    delete obj.lookupContainer;
    delete obj.lookupSchema;
    delete obj.lookupQuery;

    // these props are always removed for non-premium and then also conditionally removed for
    // containers that don't have the Ontology module enabled (see removeUnusedOntologyProperties)
    delete obj.sourceOntology;
    delete obj.conceptSubtree;
    delete obj.conceptImportColumn;
    delete obj.conceptLabelColumn;
  }
  delete obj.principalConceptCode;
  delete obj.conditionalFormats;
  delete obj.hidden;
  delete obj.shownInUpdateView;
  delete obj.shownInInsertView;
  delete obj.shownInDetailsView;
  delete obj.defaultValueType;
  delete obj.defaultValue;
  delete obj.defaultDisplayValue;
  delete obj.phi;
  delete obj.excludeFromShifting;
  delete obj.measure;
  delete obj.dimension;
  delete obj.recommendedVariable;
  delete obj.mvEnabled;
  return obj;
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/list/constants.ts
const VAR_LIST = 'VarList';
const INT_LIST = 'IntList';
const PICKLIST = 'Picklist';
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(514);
;// CONCATENATED MODULE: ./src/internal/hooks.ts

const useNotAuthorized = (identifier, initialState = false) => {
  const [notAuthorized, setNotAuthorized] = (0,external_react_.useState)(initialState);
  const [message, setMessage] = (0,external_react_.useState)();
  const onNotAuthorized = (0,external_react_.useCallback)(authMessage => {
    setMessage(authMessage);
    setNotAuthorized(true);
  }, [setNotAuthorized, setMessage]);
  (0,external_react_.useEffect)(() => {
    setNotAuthorized(initialState);
  }, [identifier, initialState]);
  return {
    notAuthorized,
    onNotAuthorized,
    message
  };
};
const useNotFound = identifier => {
  const [notFound, setNotFound] = (0,external_react_.useState)(false);
  const onNotFound = (0,external_react_.useCallback)(() => {
    setNotFound(true);
  }, [setNotFound]);
  (0,external_react_.useEffect)(() => {
    setNotFound(false);
  }, [identifier]);
  return {
    notFound,
    onNotFound
  };
};

// Creates a div with portalId and injects it into the DOM as the last child of the <body> tag
function createPortalContainer(portalId) {
  const popoverElement = document.createElement('div');
  popoverElement.setAttribute('id', portalId);
  document.body.appendChild(popoverElement);
  return popoverElement;
}

/**
 * usePortalRef is a method that automatically injects a DOM element for your portal into the document body, and returns
 * a ref that can be used with ReactDOM.createPortal. It will automatically remove the portal element from the DOM when
 * your component unmounts.
 * @param portalId The unique id to give the portal. The portal id can be re-used among several related components that
 * need to be rendered in a portal, each component using usePortalRef will get a unique DOM element within the shared
 * portal element. The shared portal element will be automatically removed from the DOM when no components are actively
 * using the portalId.
 */
function usePortalRef(portalId) {
  const portalElementRef = (0,external_react_.useRef)(null);
  if (portalElementRef.current === null) {
    portalElementRef.current = document.createElement('div');
  }
  (0,external_react_.useEffect)(() => {
    let portalContainer = document.querySelector(`#${portalId}`);
    if (!portalContainer) {
      portalContainer = createPortalContainer(portalId);
    }
    portalContainer.appendChild(portalElementRef.current);
    return () => {
      portalElementRef.current.remove();

      // We only remove the portalContainer if it has no children, that way if two different components share the
      // same portal id we only remove the portal container after all of them have stopped using it.
      if (!portalContainer.childElementCount) {
        portalContainer.remove();
      }
    };
  }, []);
  return portalElementRef.current;
}
;// CONCATENATED MODULE: ./src/internal/OverlayTrigger.tsx





/**
 * useOverlayTriggerState is a useful hook for when you want to render an overlay, but you can't use OverlayTrigger
 * because you can't wrap your component in an arbitrary div.
 *
 * See additional docs at components/docs/overlays.md
 *
 * @param id the id to use for the portal
 * @param hoverEventsEnabled whether onMouseEnter/Leave will trigger the show state
 * @param clickEventEnabled whether onClick with trigger the showState
 * @param delay the amount, in ms, to delay before showing the overlay
 */
function useOverlayTriggerState(id, hoverEventsEnabled, clickEventEnabled, delay = undefined) {
  const targetRef = (0,external_react_.useRef)(null);
  const portalEl = usePortalRef('overlay-trigger-portal-' + id);
  const [show, setShow] = (0,external_react_.useState)(false);
  const [_, setTimeoutId] = (0,external_react_.useState)(undefined);
  const onMouseEnter = (0,external_react_.useCallback)(() => {
    if (!hoverEventsEnabled) return;
    if (delay) {
      setTimeoutId(window.setTimeout(() => setShow(true), delay));
      return;
    }
    setShow(true);
  }, [delay, hoverEventsEnabled]);
  const onMouseOut = (0,external_react_.useCallback)(() => {
    if (!hoverEventsEnabled) return;
    setTimeoutId(currentId => {
      if (currentId) window.clearTimeout(currentId);
      return undefined;
    });
    setShow(false);
  }, [hoverEventsEnabled]);
  const onClick = (0,external_react_.useCallback)(() => {
    if (!clickEventEnabled) return;
    setShow(_show => !_show);
  }, [clickEventEnabled]);
  return {
    onClick,
    onMouseEnter,
    onMouseLeave: onMouseOut,
    portalEl,
    show,
    targetRef
  };
}
/**
 * Wraps a ReactElement with an inline-block element that has the appropriate handlers to trigger the visibility of an
 * overlay. Can be triggered by hover or click. There are a few caveats to using this component:
 *  - Your `overlay` component must have a prop called `targetRef`, which this component will inject
 *      - Your `overlay` component should probably be using the `useOverlayPositioning` hook in order to position itself
 *  - There should only be one child element to this component, we use React.Children.only to assert this
 *  - The child element to this must take a "ref" prop, and it must set that ref on the element you want to render the
 *  overlay in relation to
 *      - The easiest way to accomplish this is to make the child of this component a low level element such as div,
 *      span, button, etc.
 *      - If you need to make a proper component the direct child of this you can wrap your component with forwardRef,
 *      but you will still need to pass that injected ref to a low level tag like div, span, etc.
 *          - https://react.dev/reference/react/forwardRef
 *
 * See additional docs at components/docs/overlays.md
 */
const OverlayTrigger = ({
  children,
  className,
  delay = undefined,
  id,
  overlay,
  triggerType = 'hover',
  style
}) => {
  const id_ = (0,external_react_.useMemo)(() => id ?? generateId(), [id]);
  const {
    onMouseEnter,
    onMouseLeave,
    onClick,
    portalEl,
    show,
    targetRef
  } = useOverlayTriggerState(id_, triggerType === 'hover', triggerType === 'click', delay);
  const clonedChild = (0,external_react_.cloneElement)(external_react_.Children.only(children), {
    ref: targetRef
  });
  const className_ = external_classnames_default()('overlay-trigger', className);
  const clonedContent = (0,external_react_.cloneElement)(overlay, {
    targetRef
  });
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className_,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    style: style
  }, clonedChild, show && (0,external_react_dom_.createPortal)(clonedContent, portalEl));
};
OverlayTrigger.displayName = 'OverlayTrigger';
;// CONCATENATED MODULE: ./src/internal/useOverlayPositioning.ts

function useOverlayPositioning(placement, targetRef, isFixedPosition = false) {
  const overlayRef = (0,external_react_.useRef)(undefined);
  // Sometimes it takes a little extra time before the useEffect below can compute the style, so we default the
  // position to be (hopefully) very far off-screen, otherwise you see the overlay flash from one spot to another.
  const [style, setStyle] = (0,external_react_.useState)({
    top: -10000,
    left: -10000
  });
  if (targetRef === undefined) {
    console.warn('targetRef is undefined, did you forget to pass it to your overlay component (e.g. Tooltip/Popover)?');
  }
  (0,external_react_.useEffect)(() => {
    if (targetRef === undefined) return;
    const targetEl = targetRef.current;
    const overlayEl = overlayRef.current;

    // We have to be a little paranoid because if our refs aren't configured exactly right, or if things render in
    // an odd manner this code can cause a whole page to fall over.
    const canComputeStyle = targetEl !== undefined && targetEl.getBoundingClientRect !== undefined && overlayEl !== undefined && overlayEl.getBoundingClientRect !== undefined;
    if (canComputeStyle) {
      const overlayRect = overlayEl.getBoundingClientRect();
      const targetRect = targetEl.getBoundingClientRect();
      const updatedStyle = {
        top: targetRect.top + window.scrollY
      };

      // X positioning
      if (placement === 'top' || placement === 'bottom') {
        let left = targetRect.left + targetRect.width / 2 - overlayRect.width / 2;
        if (!isFixedPosition) left = left + window.scrollX;
        updatedStyle.left = left;
      } else if (placement === 'right') {
        let left = targetRect.left + targetRect.width;
        if (!isFixedPosition) left = left + window.scrollX;
        updatedStyle.left = left;
      } else if (placement === 'left') {
        updatedStyle.left = targetRect.left - overlayRect.width;
      }
      // make sure the overlay is within the viewport (Issue 49792)
      if (typeof updatedStyle.left === 'number' && updatedStyle.left < 0) {
        updatedStyle.left = 0;
      }

      // Y positioning
      if (placement === 'left' || placement === 'right') {
        let top = targetRect.top + targetRect.height / 2 - overlayRect.height / 2;
        if (!isFixedPosition) top = top + window.scrollY;
        updatedStyle.top = top;
      } else if (placement === 'top') {
        let top = targetRect.top - overlayRect.height;
        if (!isFixedPosition) top = top + window.scrollY;
        updatedStyle.top = top;
      } else if (placement === 'bottom') {
        let top = targetRect.top + targetRect.height;
        if (!isFixedPosition) top = top + window.scrollY;
        updatedStyle.top = top;
      }
      setStyle(updatedStyle);
    }
  }, [targetRef, placement]);
  return {
    overlayRef,
    style
  };
}
;// CONCATENATED MODULE: ./src/internal/Popover.tsx



/**
 * Popover is an unusual component, because it needs to be rendered in relation to another element on the page. If you
 * are using this component you should probably be using it in conjunction with an OverlayTrigger which will inject the
 * targetRef for you.
 *
 * See additional docs at components/docs/overlays.md
 */
const Popover = props => {
  const {
    children,
    className,
    targetRef,
    id,
    isFixedPosition,
    placement = 'right',
    title
  } = props;
  const {
    overlayRef,
    style
  } = useOverlayPositioning(placement, targetRef, isFixedPosition);
  const className_ = external_classnames_default()('lk-popover', 'popover', placement, className, {
    'lk-popover--is-fixed': isFixedPosition
  });
  return /*#__PURE__*/external_react_default().createElement("div", {
    id: id,
    className: className_,
    style: style,
    ref: overlayRef
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "arrow"
  }), title && /*#__PURE__*/external_react_default().createElement("h3", {
    className: "popover-title"
  }, title), /*#__PURE__*/external_react_default().createElement("div", {
    className: "popover-content"
  }, children));
};
Popover.displayName = 'Popover';
;// CONCATENATED MODULE: ./src/internal/components/base/LabelHelpTip.tsx




const LabelHelpTip = (0,external_react_.memo)(props => {
  const {
    children,
    title,
    placement,
    required,
    iconComponent,
    popoverClassName
  } = props;
  const id_ = (0,external_react_.useMemo)(() => generateId('label-help-tip'), []);
  const popover = (0,external_react_.useMemo)(() => /*#__PURE__*/external_react_default().createElement(Popover, {
    id: "label-help-tip-popover",
    title: title,
    className: popoverClassName,
    placement: placement
  }, children, required && /*#__PURE__*/external_react_default().createElement("div", {
    className: "label-help-required"
  }, "This field is required.")), [children, placement, popoverClassName, required, title]);
  // Need to have both icon and overlay inside mouse handlers div so overlay stays visible when moused over
  return /*#__PURE__*/external_react_default().createElement(OverlayTrigger, {
    id: id_,
    overlay: popover
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "label-help-target"
  }, iconComponent ?? /*#__PURE__*/external_react_default().createElement("span", {
    className: "label-help-icon fa fa-question-circle"
  })));
});
LabelHelpTip.displayName = 'LabelHelpTip';
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainRowWarning.tsx


const DomainRowWarning = (0,external_react_.memo)(({
  fieldError
}) => {
  const {
    extraInfo,
    message,
    severity
  } = fieldError;
  const msg = severity + ': ' + message;
  const icon = /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-exclamation-circle domain-warning-icon"
  });
  return /*#__PURE__*/external_react_default().createElement("span", {
    className: "domain-row-warning"
  }, extraInfo && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    iconComponent: icon,
    title: severity
  }, extraInfo), extraInfo && /*#__PURE__*/external_react_default().createElement("span", null, "\xA0"), msg);
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/utils.ts
function domainproperties_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function domainproperties_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? domainproperties_utils_ownKeys(Object(t), !0).forEach(function (r) { domainproperties_utils_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : domainproperties_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function domainproperties_utils_defineProperty(e, r, t) { return (r = domainproperties_utils_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function domainproperties_utils_toPropertyKey(t) { var i = domainproperties_utils_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function domainproperties_utils_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function createFormInputName(name) {
  return [DOMAIN_FIELD_PREFIX, name].join('-');
}

// TODO we should rename this to include the word "domain" in the name since it is exported from the package
function createFormInputId(name, domainIndex, rowIndex) {
  return [DOMAIN_FIELD_PREFIX, name, domainIndex, rowIndex].join('-');
}
function getNameFromId(id) {
  const parts = id.split('-');
  if (parts.length === 4) {
    return parts[1];
  }
  return undefined;
}
function getIndexFromId(id) {
  const parts = id.split('-');
  if (parts.length === 4) {
    return parseInt(parts[3]);
  }
  return -1;
}
function updateAliasValue(parentAliases, id, field, newValue) {
  return domainproperties_utils_objectSpread(domainproperties_utils_objectSpread({}, parentAliases.get(id)), {}, {
    isDupe: false,
    // Clear error because of change
    [field]: newValue
  });
}
function getParentAliasChangeResult(parentAliases, id, field, newValue) {
  const changedAlias = updateAliasValue(parentAliases, id, field, newValue);
  return parentAliases.set(id, changedAlias);
}

/**
 * returns a Set of ids corresponding to the aliases that have duplicate alias values
 */
function getDuplicateAlias(parentAliases, returnAliases = false) {
  let uniqueAliases = (0,external_immutable_.Set)();
  let dupeAliases = (0,external_immutable_.Set)();
  let dupeIds = (0,external_immutable_.Set)();
  if (parentAliases) {
    parentAliases.forEach(alias => {
      if (uniqueAliases.has(alias.alias)) {
        dupeIds = dupeIds.add(alias.id);
        dupeAliases = dupeAliases.add(alias.alias);
      } else {
        uniqueAliases = uniqueAliases.add(alias.alias);
      }
    });
  }
  return returnAliases ? dupeAliases : dupeIds;
}
function getParentAliasUpdateDupesResults(parentAliases, id) {
  if (!parentAliases) {
    return null;
  }
  const dupes = getDuplicateAlias(parentAliases);
  let newAliases = (0,external_immutable_.OrderedMap)();
  parentAliases.forEach(alias => {
    const isDupe = dupes && dupes.has(alias.id);
    let changedAlias = alias;
    if (isDupe !== alias.isDupe) {
      changedAlias = updateAliasValue(parentAliases, alias.id, 'isDupe', isDupe);
    }
    if (alias.id === id) {
      changedAlias = domainproperties_utils_objectSpread(domainproperties_utils_objectSpread({}, changedAlias), {}, {
        ignoreAliasError: false,
        ignoreSelectError: false
      });
    }
    newAliases = newAliases.set(alias.id, changedAlias);
  });
  return newAliases;
}
function parentAliasInvalid(alias) {
  if (!alias) return true;
  const aliasValueInvalid = !alias.alias || alias.alias.trim() === '';
  const parentValueInvalid = !alias.parentValue || !alias.parentValue.value;
  return !!(aliasValueInvalid || parentValueInvalid || alias.isDupe);
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/models.tsx
function domainproperties_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function domainproperties_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? domainproperties_models_ownKeys(Object(t), !0).forEach(function (r) { domainproperties_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : domainproperties_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function domainproperties_models_defineProperty(e, r, t) { return (r = domainproperties_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function domainproperties_models_toPropertyKey(t) { var i = domainproperties_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function domainproperties_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
















const SAMPLE_TYPE_OPTION_VALUE = `${SAMPLE_TYPE.rangeURI}|all`;
class DomainDesign extends (0,external_immutable_.Record)({
  name: undefined,
  container: undefined,
  description: undefined,
  domainURI: undefined,
  domainId: null,
  allowFileLinkProperties: false,
  allowAttachmentProperties: false,
  allowFlagProperties: true,
  allowSampleSubjectProperties: true,
  allowTextChoiceProperties: true,
  allowTimepointProperties: false,
  allowUniqueConstraintProperties: false,
  allowUserProperties: true,
  allowCalculatedFields: false,
  showDefaultValueSettings: false,
  defaultDefaultValueType: undefined,
  defaultValueOptions: (0,external_immutable_.List)(),
  fields: (0,external_immutable_.List)(),
  indices: (0,external_immutable_.List)(),
  domainException: undefined,
  mandatoryFieldNames: (0,external_immutable_.List)(),
  reservedFieldNames: (0,external_immutable_.List)(),
  newDesignFields: undefined,
  instructions: undefined,
  domainKindName: undefined,
  schemaName: undefined,
  queryName: undefined,
  disabledSystemFields: undefined
}) {
  // Returns a set of fields to initialize a manually created design

  static create(rawModel, exception) {
    let fields = (0,external_immutable_.List)();
    let indices = (0,external_immutable_.List)();
    let defaultValueOptions = (0,external_immutable_.List)();
    let mandatoryFieldNames = (0,external_immutable_.List)();
    let uniqueConstraintFieldNames = (0,external_immutable_.List)();
    const domainException = DomainException.create(exception, exception ? exception.severity : undefined);
    if (rawModel) {
      if (rawModel.mandatoryFieldNames) {
        mandatoryFieldNames = (0,external_immutable_.List)(rawModel.mandatoryFieldNames.map(name => name.toLowerCase()));
      }
      if (rawModel.indices) {
        indices = DomainIndex.fromJS(rawModel.indices);
        uniqueConstraintFieldNames = indices.filter(index => index.isSingleFieldUniqueConstraint()).map(index => index.columns.get(0)).toList();

        // Hack: SQL server uses a hashed field for unique constraints on text columns, see
        // BaseMicrosoftSqlServerDialect.addCreateIndexStatements (where it talks about HASHBYTES)
        indices.filter(index => index.isMSSQLHashedSingleFieldUniqueConstraint()).forEach(index => {
          uniqueConstraintFieldNames = uniqueConstraintFieldNames.push(index.columns.get(0).replace('_hashed_', ''));
        });
      }
      if (rawModel.fields) {
        fields = DomainField.fromJS(rawModel.fields, mandatoryFieldNames, uniqueConstraintFieldNames);
      }
      if (isCalculatedFieldsEnabled() && rawModel.allowCalculatedFields && rawModel.calculatedFields) {
        const calcFields = DomainField.fromJS(rawModel.calculatedFields, mandatoryFieldNames, uniqueConstraintFieldNames);
        fields = fields.push(...calcFields.toArray());
      }
      if (rawModel.defaultValueOptions) {
        for (let i = 0; i < rawModel.defaultValueOptions.length; i++) {
          defaultValueOptions = defaultValueOptions.push(rawModel.defaultValueOptions[i]);
        }
      }
    }
    return new DomainDesign(domainproperties_models_objectSpread(domainproperties_models_objectSpread({}, rawModel), {}, {
      fields,
      indices,
      defaultValueOptions,
      domainException
    }));
  }
  static serialize(dd) {
    const json = dd.toJS();

    // Issue 41677: allow for per-field unique constraints to be added via the field editor UI
    json.indices = dd.indices
    // filter out the single field unique indices, and keep the others
    .filter(index => !index.isSingleFieldUniqueConstraint() && !index.isMSSQLHashedSingleFieldUniqueConstraint()).map(index => DomainIndex.serialize(index)).toArray();
    // add in the new set of single field unique indices
    dd.fields.forEach(field => {
      if (field.uniqueConstraint) {
        json.indices.push(DomainIndex.serialize(new DomainIndex({
          columns: external_immutable_.List.of(field.name?.trim()),
          type: 'unique'
        })));
      }
    });
    json.fields = dd.fields.map(field => DomainField.serialize(field)).toArray();

    // remove non-serializable fields
    delete json.allowUserProperties;
    delete json.domainException;
    delete json.newDesignFields;
    return json;
  }
  hasErrors() {
    return this.domainException !== undefined && this.domainException.errors !== undefined && this.domainException.errors.size > 0 && this.domainException.severity === constants_SEVERITY_LEVEL_ERROR;
  }
  hasException() {
    return this.domainException !== undefined;
  }
  isNameSuffixMatch(name) {
    return this.name && this.name.endsWith(name + ' Fields');
  }

  // Issue 38399: helper for each designer model to know if there are field-level errors
  hasInvalidFields() {
    return this.getInvalidFields().size > 0;
  }
  getInvalidFields() {
    let invalid = (0,external_immutable_.Map)();
    for (let i = 0; i < this.fields.size; i++) {
      const field = this.fields.get(i);
      if (field.hasErrors()) {
        invalid = invalid.set(i, field);
      }
    }
    return invalid;
  }
  hasDefaultValueOption(value) {
    return this.defaultValueOptions.some(option => option === value);
  }
  hasInvalidNameField(defaultNameFieldConfig) {
    if (this.fields && this.fields.size > 0 && defaultNameFieldConfig && defaultNameFieldConfig.name) {
      const nameField = this.fields.find(field => {
        return field && field.name && field.name.toLowerCase() === defaultNameFieldConfig.name.toLowerCase();
      });
      return nameField !== undefined;
    }
    return false;
  }
  getFirstFieldError() {
    const invalidFields = this.getInvalidFields();
    return invalidFields.size > 0 ? invalidFields.first().getErrors() : undefined;
  }
  getDomainContainer() {
    return this.container ?? (0,api_.getServerContext)().container.id;
  }
  isSharedDomain() {
    const currentContainer = (0,api_.getServerContext)().container.id;
    return this.getDomainContainer() !== currentContainer;
  }
  findFieldIndexByName(fieldName) {
    return this.fields.findIndex(field => fieldName && field.name === fieldName);
  }
  getFieldDetails() {
    const mapping = {
      ontologyLookupIndices: [],
      detailsInfo: {}
    };
    this.fields.forEach((field, index) => {
      if (!field.hasInvalidName()) {
        if (field.conceptImportColumn) {
          mapping.detailsInfo[field.conceptImportColumn] = 'Ontology Lookup: ' + field.name;
        }
        if (field.conceptLabelColumn) {
          mapping.detailsInfo[field.conceptLabelColumn] = 'Ontology Lookup: ' + field.name;
        }
        if (field.dataType.isOntologyLookup()) {
          mapping.ontologyLookupIndices.push(index);
        }
      }
    });
    return mapping;
  }
  getGridData(appPropertiesOnly, hasOntologyModule) {
    return this.fields.map((field, i) => {
      let fieldSerial = DomainField.serialize(field);
      const dataType = field.dataType;
      fieldSerial = removeUnusedProperties(fieldSerial);
      if (!hasOntologyModule) {
        fieldSerial = removeUnusedOntologyProperties(fieldSerial);
      }
      if (appPropertiesOnly) {
        fieldSerial = removeNonAppProperties(fieldSerial);
      }
      fieldSerial.fieldIndex = i;
      // Add back subset of field properties stripped by the serialize
      fieldSerial.selected = field.selected;
      fieldSerial.visible = field.visible;
      return (0,external_immutable_.Map)(Object.keys(fieldSerial).map(key => {
        const rawVal = fieldSerial[key];
        const valueType = typeof rawVal;
        let value = valueIsEmpty(rawVal) ? '' : rawVal;

        // Since rangeURI is not set on field creation, pull rangeURI value from dataType
        if (key === 'rangeURI' && value === '') {
          value = dataType.rangeURI;
        }

        // Make bools render as strings sortable within their column
        if (key !== 'visible' && key !== 'selected' && valueType === 'boolean') {
          value = rawVal ? 'true' : 'false';
        }

        // Handle property validator and conditional format rendering
        if ((key === 'propertyValidators' || key === 'conditionalFormats') && value !== '') {
          value = JSON.stringify(value.map(cf => removeFalseyObjKeys(cf)));
        }
        if (key === 'fieldIndex' && value === '') {
          value = 0;
        }
        return [key, value];
      }));
    }).toList();
  }
  getGridColumns(onFieldsChange, scrollFunction, domainKindName, appPropertiesOnly, hasOntologyModule) {
    const selectionCol = new GridColumn({
      index: GRID_SELECTION_INDEX,
      title: GRID_SELECTION_INDEX,
      width: 20,
      cell: (data, row) => {
        const domainIndex = row.get('domainIndex');
        const fieldIndex = row.get('fieldIndex');
        const selected = row.get('selected');
        const formInputId = createFormInputId(DOMAIN_FIELD_SELECTED, domainIndex, fieldIndex);
        const changes = external_immutable_.List.of({
          id: formInputId,
          value: !selected
        });
        return /*#__PURE__*/external_react_default().createElement(DomainDesignerCheckbox, {
          className: "domain-summary-selection",
          id: formInputId,
          checked: selected,
          onChange: () => {
            onFieldsChange(changes, fieldIndex, false);
          }
        });
      }
    });
    const nameCol = new GridColumn({
      index: GRID_NAME_INDEX,
      title: GRID_NAME_INDEX,
      raw: {
        index: 'name',
        caption: 'Name',
        sortable: true
      },
      cell: (data, row) => {
        const text = row.get('name');
        const fieldIndex = row.get('fieldIndex');
        return /*#__PURE__*/external_react_default().createElement("a", {
          onClick: () => scrollFunction(fieldIndex),
          className: "clickable"
        }, text);
      }
    });
    const specialCols = (0,external_immutable_.List)([selectionCol, nameCol]);
    const firstField = this.fields.get(0);
    let columns = DomainField.serialize(firstField);
    delete columns.name;
    columns = removeUnusedProperties(columns);
    if (!hasOntologyModule) {
      columns = removeUnusedOntologyProperties(columns);
    }
    if (appPropertiesOnly) {
      columns = removeNonAppProperties(columns);
    }
    if (domainKindName !== VAR_LIST && domainKindName !== INT_LIST) {
      delete columns.isPrimaryKey;
    }
    if (!(appPropertiesOnly && domainKindName === 'SampleSet')) {
      delete columns.scannable;
    }
    const unsortedColumns = (0,external_immutable_.List)(Object.keys(columns).map(key => ({
      index: key,
      caption: camelCaseToTitleCase(key),
      sortable: true
    })));
    return specialCols.concat(unsortedColumns.sort(reorderSummaryColumns)).toList();
  }
}
class DomainIndex extends (0,external_immutable_.Record)({
  columns: (0,external_immutable_.List)(),
  type: undefined
}) {
  static fromJS(rawIndices) {
    let indices = (0,external_immutable_.List)();
    for (let i = 0; i < rawIndices.length; i++) {
      let raw = (0,external_immutable_.fromJS)(rawIndices[i]);
      if (raw.has('columnNames')) raw = raw.set('columns', raw.get('columnNames'));
      if (raw.has('unique')) raw = raw.set('type', raw.get('unique') ? 'unique' : 'nonunique');
      indices = indices.push(new DomainIndex(raw));
    }
    return indices;
  }
  static serialize(index) {
    const json = index.toJS();
    json.columnNames = [...json.columns];
    delete json.columns;
    json.unique = json.type === 'primary' || json.type === 'unique';
    delete json.type;
    return json;
  }
  isSingleFieldUniqueConstraint() {
    return this.type === 'unique' && this.columns.size === 1;
  }
  isMSSQLHashedSingleFieldUniqueConstraint() {
    return this.type === 'nonunique' && this.columns.size === 1 && this.columns.get(0).startsWith('_hashed_');
  }
}
let FieldErrors = /*#__PURE__*/function (FieldErrors) {
  FieldErrors["ALIQUOT_ONLY_REQUIRED"] = "Fields that are 'Editable for aliquots only' cannot be 'Required'.";
  FieldErrors["INVALID_LOOKUP"] = "Lookup target table does not exist.";
  FieldErrors["MISSING_DATA_TYPE"] = "Please provide a data type for each field.";
  FieldErrors["MISSING_FIELD_NAME"] = "Please provide a name for each field.";
  FieldErrors["MISSING_ONTOLOGY_PROPERTIES"] = "Missing required ontology source or label field property.";
  FieldErrors["MISSING_SCHEMA_QUERY"] = "Missing required lookup target schema or table property.";
  FieldErrors["NONE"] = "";
  return FieldErrors;
}({});
class ConditionalFormat extends (0,external_immutable_.Record)({
  formatFilter: undefined,
  bold: false,
  italic: false,
  strikethrough: false,
  textColor: undefined,
  backgroundColor: undefined
}) {
  constructor(values) {
    // filter is a reserved work on Records so change to formatFilter and update for HASANYVALUE lacking a filter symbol
    if (values && !values.get('formatFilter')) {
      values = values.set('formatFilter', values.get('filter').replace('~=', '~' + DOMAIN_FILTER_HASANYVALUE + '='));
    }
    super(values);
  }
  static fromJS(rawCondFormat) {
    let condFormats = (0,external_immutable_.List)();
    for (let i = 0; i < rawCondFormat.length; i++) {
      condFormats = condFormats.push(new ConditionalFormat((0,external_immutable_.fromJS)(rawCondFormat[i])));
    }
    return condFormats;
  }
  static serialize(cfs) {
    // Change formatFilter back to filter as that is what API is expecting
    for (let i = 0; i < cfs.length; i++) {
      cfs[i].filter = cfs[i].formatFilter.replace(DOMAIN_FILTER_HASANYVALUE, '');
      delete cfs[i].formatFilter;
    }
    return cfs;
  }
}
class PropertyValidatorProperties extends (0,external_immutable_.Record)({
  failOnMatch: false,
  validValues: undefined,
  valueUpdates: undefined
}) {
  constructor(values) {
    if (typeof values?.failOnMatch === 'string') {
      values.failOnMatch = values.failOnMatch.toLowerCase() === 'true';
    }
    // see DomainUtil.getPropertyDescriptor() for where this property is added to the JSON field validator extChoice validator info
    if (typeof values?.validValues === 'string') {
      values.validValues = values.validValues.split('|');
    }
    super(values);
  }
}
const EXPECTED_VALIDATOR_TYPES = ['Range', 'RegEx', 'TextChoice', 'Lookup'];
class PropertyValidator extends (0,external_immutable_.Record)({
  type: undefined,
  name: undefined,
  properties: new PropertyValidatorProperties(),
  extraProperties: new PropertyValidatorProperties(),
  errorMessage: undefined,
  description: undefined,
  new: true,
  shouldShowWarning: false,
  rowId: undefined,
  expression: undefined
}) {
  static fromJS(rawPropertyValidator, type, isNewField = false) {
    let propValidators = (0,external_immutable_.List)();
    if (EXPECTED_VALIDATOR_TYPES.indexOf(type) > -1) {
      for (let i = 0; i < rawPropertyValidator.length; i++) {
        if (rawPropertyValidator[i].type === type) {
          const expressionStr = rawPropertyValidator[i].expression;
          const hasExpressionStr = expressionStr !== undefined && expressionStr !== null;

          // if we are loading a textChoiceValidator from JSON, we need to set the properties.validValues
          if (type === 'TextChoice' && !rawPropertyValidator[i]?.properties?.validValues) {
            rawPropertyValidator[i].properties.validValues = expressionStr?.split('|') ?? [];
          }
          rawPropertyValidator[i]['properties'] = new PropertyValidatorProperties(rawPropertyValidator[i]['properties']);
          let newPv = new PropertyValidator(rawPropertyValidator[i]);

          // if loading validator from DB, set shouldShowWarning initially
          newPv = newPv.set('shouldShowWarning', true);

          // Special case for filters HAS ANY VALUE not having a symbol
          if (hasExpressionStr) {
            newPv = newPv.set('expression', expressionStr.replace('~=', '~' + DOMAIN_FILTER_HASANYVALUE + '='));
          }

          // for new fields, clear any validator rowIds that come in from the JSON file import
          if (isNewField) newPv = newPv.set('rowId', undefined);
          propValidators = propValidators.push(newPv);
        }
      }
    }
    return propValidators;
  }
  static serialize(pvs) {
    for (let i = 0; i < pvs.length; i++) {
      if (pvs[i].expression) {
        pvs[i].expression = pvs[i].expression.replace(DOMAIN_FILTER_HASANYVALUE, '');
      }
      if (pvs[i]?.properties?.validValues) {
        delete pvs[i].properties.validValues;
      }
      if (pvs[i]?.extraProperties && !pvs[i].extraProperties.valueUpdates) {
        delete pvs[i].extraProperties;
      }
      delete pvs[i].shouldShowWarning;
    }
    return pvs;
  }
}
const DEFAULT_TEXT_CHOICE_VALIDATOR = new PropertyValidator({
  type: 'TextChoice',
  name: 'Text Choice Validator',
  expression: '',
  properties: {
    validValues: []
  }
});
class DomainField extends (0,external_immutable_.Record)({
  conceptURI: undefined,
  conditionalFormats: (0,external_immutable_.List)(),
  defaultScale: undefined,
  defaultValueType: undefined,
  defaultValue: undefined,
  defaultDisplayValue: undefined,
  description: undefined,
  dimension: undefined,
  excludeFromShifting: false,
  format: undefined,
  hidden: false,
  importAliases: undefined,
  label: undefined,
  lookupContainer: undefined,
  lookupQuery: undefined,
  lookupSchema: undefined,
  lookupValidator: undefined,
  lookupIsValid: undefined,
  measure: undefined,
  mvEnabled: false,
  name: undefined,
  PHI: undefined,
  propertyId: undefined,
  propertyURI: undefined,
  propertyValidators: (0,external_immutable_.List)(),
  rangeValidators: (0,external_immutable_.List)(),
  rangeURI: undefined,
  regexValidators: (0,external_immutable_.List)(),
  textChoiceValidator: undefined,
  recommendedVariable: false,
  uniqueConstraint: false,
  required: false,
  scale: MAX_TEXT_LENGTH,
  URL: undefined,
  shownInDetailsView: true,
  shownInInsertView: true,
  shownInUpdateView: true,
  visible: true,
  dataType: undefined,
  lookupQueryValue: undefined,
  lookupType: undefined,
  original: undefined,
  updatedField: false,
  isPrimaryKey: false,
  lockType: DOMAIN_FIELD_NOT_LOCKED,
  wrappedColumnName: undefined,
  valueExpression: undefined,
  disablePhiLevel: false,
  lockExistingField: false,
  sourceOntology: undefined,
  conceptSubtree: undefined,
  conceptLabelColumn: undefined,
  conceptImportColumn: undefined,
  principalConceptCode: undefined,
  derivationDataScope: undefined,
  selected: false,
  scannable: false
}) {
  static create(rawField, shouldApplyDefaultValues, mandatoryFieldNames) {
    const baseField = DomainField.resolveBaseProperties(rawField, mandatoryFieldNames);
    const {
      dataType
    } = baseField;
    const lookup = DomainField.resolveLookupConfig(rawField, dataType);
    let field = new DomainField(Object.assign(rawField, baseField, domainproperties_models_objectSpread(domainproperties_models_objectSpread({}, lookup), {}, {
      original: {
        dataType,
        conceptURI: rawField.conceptURI,
        name: rawField.name,
        rangeURI: rawField.propertyId !== undefined || rawField.wrappedColumnName !== undefined ? rawField.rangeURI // Issue 40795: need rangURI for alias field (query metadata) to get other available types in the datatype dropdown
        : undefined // Issue 38366: only need to use rangeURI filtering for already saved field/property
      }
    })));
    if (rawField.conditionalFormats) {
      field = field.set('conditionalFormats', ConditionalFormat.fromJS(rawField.conditionalFormats));
    }
    if (rawField.propertyValidators) {
      field = field.set('rangeValidators', PropertyValidator.fromJS(rawField.propertyValidators, 'Range', field.isNew()));
      field = field.set('regexValidators', PropertyValidator.fromJS(rawField.propertyValidators, 'RegEx', field.isNew()));
      const lookups = PropertyValidator.fromJS(rawField.propertyValidators, 'Lookup', field.isNew());
      if (lookups && lookups.size > 0) {
        field = field.set('lookupValidator', lookups.get(0));
      }
      const textChoice = PropertyValidator.fromJS(rawField.propertyValidators, 'TextChoice', field.isNew());
      if (textChoice?.size > 0) {
        field = field.set('textChoiceValidator', textChoice.get(0));
      }
    }
    if (shouldApplyDefaultValues) {
      field = DomainField.updateDefaultValues(field);
    }
    return field;
  }
  static resolveLookupConfig(rawField, dataType) {
    const lookupType = LOOKUP_TYPE.set('rangeURI', rawField.rangeURI);
    const lookupContainer = rawField.lookupContainer === null ? undefined : rawField.lookupContainer;
    const lookupSchema = resolveLookupSchema(rawField, dataType);
    const lookupQuery = rawField.lookupQuery || (dataType === SAMPLE_TYPE ? SCHEMAS.EXP_TABLES.MATERIALS.queryName : undefined);
    const lookupQueryValue = encodeLookup(lookupQuery, lookupType);
    return {
      lookupContainer,
      lookupSchema,
      lookupQuery,
      lookupType,
      lookupQueryValue
    };
  }
  static fromJS(rawFields, mandatoryFieldNames, uniqueConstraintFieldNames) {
    let fields = (0,external_immutable_.List)();
    const lowerUniqueConstraintFieldNames = uniqueConstraintFieldNames?.map(f => f.toLowerCase()).toArray();
    for (let i = 0; i < rawFields.length; i++) {
      const rawField = rawFields[i];
      rawField.uniqueConstraint = lowerUniqueConstraintFieldNames.indexOf(rawField.name?.toLowerCase()) > -1;
      fields = fields.push(DomainField.create(rawField, undefined, mandatoryFieldNames));
    }
    return fields;
  }
  static resolveBaseProperties(raw, mandatoryFieldNames) {
    const dataType = resolveDataType(raw);

    // lockType can either come from the rawField, or be based on the domain's mandatoryFieldNames
    const isMandatoryFieldMatch = mandatoryFieldNames !== undefined && raw.name && mandatoryFieldNames.contains(raw.name.toLowerCase());
    let lockType = raw.lockType || DOMAIN_FIELD_NOT_LOCKED;
    if (lockType === DOMAIN_FIELD_NOT_LOCKED && isMandatoryFieldMatch) {
      lockType = DOMAIN_FIELD_PARTIALLY_LOCKED;
    }
    const field = {
      dataType,
      lockType
    };

    // Infer SampleId as SAMPLE_TYPE for sample manager and mark required
    if (isFieldNew(raw) && raw.name) {
      if (raw.name.localeCompare('SampleId', 'en', {
        sensitivity: 'accent'
      }) === 0) {
        field.dataType = SAMPLE_TYPE;
        field.conceptURI = SAMPLE_TYPE.conceptURI;
        field.rangeURI = SAMPLE_TYPE.rangeURI;
        field.required = true;
      }
    }

    // If calculated field, set the rangeURI to the calculated field type
    if (field.dataType === CALCULATED_TYPE) {
      field.rangeURI = raw.rangeURI;
    }
    return field;
  }
  static serialize(df, fixCaseSensitivity = true) {
    const json = df.toJS();

    // Issue 43254: trim field name leading and trailing spaces before saving
    json.name = df.name?.trim();
    if (!(df.dataType.isLookup() || df.dataType.isUser() || df.dataType.isSample())) {
      json.lookupContainer = null;
      json.lookupQuery = null;
      json.lookupSchema = null;
    }
    if (json.lookupContainer === undefined) {
      json.lookupContainer = null;
    }

    // for some reason the property binding server side cares about casing here for 'URL' and 'PHI'
    if (fixCaseSensitivity) {
      if (json.URL !== undefined) {
        json.url = json.URL;
        delete json.URL;
      }
      if (json.PHI !== undefined) {
        json.phi = json.PHI;
        delete json.PHI;
      }
    }
    if (json.conditionalFormats) {
      json.conditionalFormats = ConditionalFormat.serialize(json.conditionalFormats);
    }
    json.propertyValidators = [];
    if (json.rangeValidators) {
      json.propertyValidators = json.propertyValidators.concat(PropertyValidator.serialize(json.rangeValidators));
    }
    if (json.regexValidators) {
      json.propertyValidators = json.propertyValidators.concat(PropertyValidator.serialize(json.regexValidators));
    }
    if (json.lookupValidator) {
      json.propertyValidators = json.propertyValidators.concat(PropertyValidator.serialize([json.lookupValidator]));
    }
    if (json.textChoiceValidator) {
      json.propertyValidators = json.propertyValidators.concat(PropertyValidator.serialize([json.textChoiceValidator]));
    }

    // Special case for users, needs different URI for uniqueness in UI but actually uses int URI
    if (json.rangeURI === USER_RANGE_URI) {
      json.rangeURI = INT_RANGE_URI;
    }

    // Issue 39938: revert back to max Integer length if user input is larger then 4000
    if (df.scale && (isNaN(df.scale) || df.scale > MAX_TEXT_LENGTH)) {
      json.scale = UNLIMITED_TEXT_LENGTH;
    }

    // remove non-serializable fields
    delete json.dataType;
    delete json.lookupQueryValue;
    delete json.lookupType;
    delete json.original;
    delete json.updatedField;
    delete json.visible;
    delete json.rangeValidators;
    delete json.regexValidators;
    delete json.textChoiceValidator;
    delete json.lookupValidator;
    delete json.disablePhiLevel;
    delete json.lockExistingField;
    delete json.selected;
    delete json.lookupIsValid;
    delete json.uniqueConstraint;
    return json;
  }
  getRangeURI() {
    return this.dataType.rangeURI || this.rangeURI;
  }
  getErrors() {
    if (this.dataType.isLookup() && (!this.lookupSchema || !this.lookupQuery)) {
      return FieldErrors.MISSING_SCHEMA_QUERY;
    }
    if (this.dataType.isLookup() && !this.lookupIsValid) {
      return FieldErrors.INVALID_LOOKUP;
    }
    if ((!this.dataType || !this.getRangeURI()) && !this.isCalculatedField()) {
      return FieldErrors.MISSING_DATA_TYPE;
    }
    if (this.hasInvalidName()) {
      return FieldErrors.MISSING_FIELD_NAME;
    }

    // Issue 41829: for an ontology lookup field, only the sourceOntology is required (other ontology props are optional)
    if (this.dataType.isOntologyLookup() && !this.sourceOntology) {
      return FieldErrors.MISSING_ONTOLOGY_PROPERTIES;
    }

    // Issue 46733: Editable for aliquots only/Required Field: Adding Samples gives error
    if (this.derivationDataScope === DERIVATION_DATA_SCOPES.CHILD_ONLY && this.required) {
      return FieldErrors.ALIQUOT_ONLY_REQUIRED;
    }
    return FieldErrors.NONE;
  }
  hasInvalidName() {
    return this.name === undefined || this.name === null || this.name.trim() === '';
  }
  hasErrors() {
    return this.getErrors() !== FieldErrors.NONE;
  }
  isNew() {
    return isFieldNew(this);
  }
  isSaved() {
    return isFieldSaved(this);
  }
  isUniqueIdField() {
    return this.conceptURI === STORAGE_UNIQUE_ID_CONCEPT_URI;
  }
  isTextChoiceField() {
    return this.conceptURI === TEXT_CHOICE_CONCEPT_URI;
  }
  isCalculatedField() {
    return this.conceptURI === CALCULATED_CONCEPT_URI;
  }
  isPHI() {
    return this.PHI !== PHILEVEL_NOT_PHI;
  }
  isDeletable() {
    return isFieldDeletable(this);
  }
  static hasRangeValidation(field) {
    return field.dataType === INTEGER_TYPE || field.dataType === DOUBLE_TYPE || field.dataType === DATETIME_TYPE || field.dataType === DATE_TYPE || field.dataType === USERS_TYPE || field.dataType === LOOKUP_TYPE;
  }
  static hasRegExValidation(field) {
    return field.dataType.isString() && !field.isUniqueIdField() && !field.isTextChoiceField() && !field.isCalculatedField();
  }
  static updateDefaultValues(field) {
    const {
      dataType
    } = field;
    const config = {
      measure: DomainField.defaultValues(DOMAIN_FIELD_MEASURE, dataType),
      dimension: DomainField.defaultValues(DOMAIN_FIELD_DIMENSION, dataType)
    };
    const lookupConfig = dataType === SAMPLE_TYPE ? DomainField.resolveLookupConfig(field, dataType) : {};
    return field.merge(config, lookupConfig);
  }
  static defaultValues(prop, type) {
    switch (prop) {
      case DOMAIN_FIELD_MEASURE:
        return type === INTEGER_TYPE || type === DOUBLE_TYPE;
      case DOMAIN_FIELD_DIMENSION:
        return type === LOOKUP_TYPE || type === USERS_TYPE || type === SAMPLE_TYPE;
      default:
        return false;
    }
  }
  getPrincipalConceptDisplay() {
    const concept = getConceptForCode(this.principalConceptCode);
    return concept?.getDisplayLabel() ?? this.principalConceptCode;
  }
  getDetailsArray(index, fieldDetailsInfo) {
    const details = [];
    let period = '';
    if (this.isNew()) {
      details.push('New Field');
      period = '. ';
    } else if (this.updatedField) {
      details.push('Updated');
      period = '. ';
    }
    if (this.dataType.isSample()) {
      const detailsText = this.lookupSchema === SCHEMAS.EXP_TABLES.MATERIALS.schemaName && SCHEMAS.EXP_TABLES.MATERIALS.queryName.localeCompare(this.lookupQuery, 'en', {
        sensitivity: 'accent'
      }) === 0 ? ALL_SAMPLES_DISPLAY_TEXT : this.lookupQuery;
      details.push(period + detailsText);
      period = '. ';
    } else if (this.dataType.isLookup() && this.lookupSchema && this.lookupQuery) {
      // only show the query as a link in LKS, for now
      let link;
      if (!getCurrentAppProperties()) {
        const params = {
          schemaName: this.lookupSchema,
          'query.queryName': this.lookupQuery
        };
        const href = api_.ActionURL.buildURL('query', 'executeQuery.view', this.lookupContainer, params);
        link = /*#__PURE__*/external_react_default().createElement("a", {
          href: href
        }, " ", this.lookupQuery, " ");
      }
      details.push(period + [this.lookupContainer || 'Current Folder', this.lookupSchema].join(' > '), ' > ', link ?? this.lookupQuery);
      period = '. ';
    } else if (this.dataType.isOntologyLookup() && this.sourceOntology) {
      details.push(period + this.sourceOntology);
      period = '. ';
    } else if (this.dataType.isTextChoice()) {
      const validValuesStr = getValidValuesDetailStr(this.textChoiceValidator?.properties.validValues);
      if (this.isPHI() && this.PHI !== undefined && validValuesStr) {
        details.push(period + TEXT_CHOICE_PHI_NOTE);
      } else {
        details.push(period);
        if (validValuesStr) {
          details.push(validValuesStr);
        } else if (this.textChoiceValidator?.shouldShowWarning) {
          const fieldError = new DomainFieldError({
            extraInfo: FIELD_EMPTY_TEXT_CHOICE_WARNING_INFO,
            message: FIELD_EMPTY_TEXT_CHOICE_WARNING_MSG,
            severity: constants_SEVERITY_LEVEL_WARN
          });
          details.push( /*#__PURE__*/external_react_default().createElement(DomainRowWarning, {
            fieldError: fieldError
          }));
        }
      }
      period = '. ';
    }
    if (this.principalConceptCode) {
      details.push(period + 'Ontology Concept: ' + this.getPrincipalConceptDisplay());
      period = '. ';
    }
    if (this.wrappedColumnName) {
      details.push(period + 'Wrapped column - ' + this.wrappedColumnName);
      period = '. ';
    }
    if (this.isPrimaryKey) {
      details.push(period + 'Primary Key');
      period = '. ';
    }
    if (this.lockType === DOMAIN_FIELD_FULLY_LOCKED) {
      details.push(period + 'Locked');
      period = '. ';
    }
    if (!this.hasInvalidName() && fieldDetailsInfo?.hasOwnProperty(this.name)) {
      details.push(period + fieldDetailsInfo[this.name]);
      period = '. ';
    }
    return details;
  }
}
function isValidTextChoiceValue(v) {
  return v !== null && v !== undefined && v.trim() !== '';
}
function getValidValuesFromArray(validValues) {
  // filter out any empty string values
  const vals = validValues?.filter(isValidTextChoiceValue) ?? [];
  // remove duplicates
  return [...new Set(vals)];
}
function getValidValuesDetailStr(validValues) {
  const numToShow = 4;
  const vals = getValidValuesFromArray(validValues);
  if (vals.length > 0) {
    let validValuesStr = vals.slice(0, numToShow).join(', ');
    if (vals.length > numToShow) {
      validValuesStr += ` (and ${vals.length - numToShow} more)`;
    }
    if (validValuesStr.length > 80) {
      validValuesStr = api_.Utils.pluralize(vals.length, 'value', 'values');
    }
    return validValuesStr;
  }
  return undefined;
}
function decodeLookup(value) {
  const [rangeURI, queryName] = value ? value.split('|') : [undefined, undefined];
  return {
    queryName,
    rangeURI
  };
}
function encodeLookup(queryName, type) {
  if (queryName) {
    return [type.rangeURI, queryName].join('|');
  }
  return undefined;
}
function resolveLookupSchema(rawField, dataType) {
  if (rawField.lookupSchema) return rawField.lookupSchema;
  if (dataType === SAMPLE_TYPE) return SCHEMAS.EXP_TABLES.SCHEMA;
  return undefined;
}
function updateSampleField(field, sampleQueryValue) {
  const {
    queryName,
    rangeURI = INT_RANGE_URI
  } = decodeLookup(sampleQueryValue);
  const lookupType = field.lookupType || LOOKUP_TYPE;
  const sampleField = queryName === 'all' ? {
    // Use the exp.materials table for 'all'
    lookupSchema: SCHEMAS.EXP_TABLES.SCHEMA,
    lookupQuery: SCHEMAS.EXP_TABLES.MATERIALS.queryName,
    lookupQueryValue: sampleQueryValue,
    lookupType: field.lookupType.set('rangeURI', rangeURI),
    rangeURI
  } : {
    // use the samples.<SampleType> table for specific sample types
    lookupSchema: SCHEMAS.SAMPLE_SETS.SCHEMA,
    lookupQuery: queryName,
    lookupQueryValue: sampleQueryValue || SAMPLE_TYPE_OPTION_VALUE,
    lookupType: lookupType.set('rangeURI', rangeURI),
    rangeURI
  };
  return field.merge(sampleField);
}
function isFieldNew(field) {
  return field.propertyId === undefined;
}
function isFieldSaved(field) {
  return !isFieldNew(field) && field.propertyId !== 0;
}
function resolveAvailableTypes(field, availableTypes, appPropertiesOnly, showStudyPropertyTypes, showFilePropertyType) {
  // field has not been saved -- display all property types allowed by app
  // Issue 40795: need to check wrappedColumnName for alias field in query metadata editor and resolve the datatype fields
  if (field.isNew() && field.wrappedColumnName === undefined) {
    return availableTypes.filter(type => isPropertyTypeAllowed(appPropertiesOnly, type, showFilePropertyType, showStudyPropertyTypes)).toList();
  }

  // compare against original types as the field's values are volatile
  const {
    rangeURI,
    dataType
  } = field.original;

  // field has been saved -- display eligible propTypes
  let filteredTypes = availableTypes.filter(type => {
    // Can always return to the original type for field
    if (type.name === dataType.name) return true;

    // Issue 44511: Allow all types to be converted to string
    // Issue 44711: Don't allow Attachment or FileLink field types to be converted
    if (STRING_CONVERT_URIS.indexOf(type.rangeURI) > -1 && !type.conceptURI && FILE_CONVERT_URIS.indexOf(rangeURI) === -1) {
      return true;
    }

    // Issue 44511: Allow integer/long -> decimal/double/float
    if (NUMBER_CONVERT_URIS.indexOf(type.rangeURI) > -1 && (rangeURI === INT_RANGE_URI || rangeURI === LONG_RANGE_URI)) {
      return true;
    }
    if (!acceptablePropertyType(type, rangeURI)) return false;
    return isPropertyTypeAllowed(appPropertiesOnly, type, showFilePropertyType, showStudyPropertyTypes);
  }).toList();

  // Issue 39341: if the field type is coming from the server as a type we don't support in new field creation, add it to the list
  if (!filteredTypes.contains(dataType)) {
    filteredTypes = filteredTypes.push(dataType);
  }
  return filteredTypes;
}
function isPropertyTypeAllowed(appPropertiesOnly, type, showFilePropertyType, showStudyPropertyTypes) {
  if (type === FILE_TYPE) return showFilePropertyType;
  if (STUDY_PROPERTY_TYPES.includes(type)) return showStudyPropertyTypes;
  if (!appPropertiesOnly) return true;

  // We are excluding the field types below for the App for non-premium
  return hasPremiumModule() || ![LOOKUP_TYPE, FLAG_TYPE, ONTOLOGY_LOOKUP_TYPE].includes(type);
}

// Determines if a storage type (rangeURI) is a match for a concept type (like User or Subject)
function acceptablePropertyType(newType, originalRangeURI) {
  if (newType.isLookup()) {
    return originalRangeURI === INT_RANGE_URI || originalRangeURI === STRING_RANGE_URI;
  }
  if (newType.isSample()) {
    return originalRangeURI === INT_RANGE_URI;
  }
  if (newType.isOntologyLookup()) {
    return originalRangeURI === STRING_RANGE_URI;
  }

  // Catches Users
  if (newType.isInteger() && PropDescType.isInteger(originalRangeURI)) {
    return true;
  }

  // Original field is a string, we can't convert to a unique Id
  if (newType.isUniqueId() && PropDescType.isString(originalRangeURI)) {
    return false;
  }

  // Original field is a uniqueId, text, or multi-line text, can convert to a string type
  if (newType.isString() && PropDescType.isString(originalRangeURI)) {
    return true;
  }

  // Original field is a datetime, can convert to a date or time
  if ((newType.isTime() || newType.isDate()) && PropDescType.isDateTime(originalRangeURI)) {
    return true;
  }

  // Original field is a date, can convert to a datetime
  if (newType.isDateTime() && PropDescType.isDate(originalRangeURI)) {
    return true;
  }
  return originalRangeURI === newType.rangeURI;
}
function resolveDataType(rawField) {
  let type;
  if (!isFieldNew(rawField) || rawField.rangeURI !== undefined) {
    if (rawField.conceptURI === SAMPLE_TYPE_CONCEPT_URI) return SAMPLE_TYPE;
    if (rawField.conceptURI === SMILES_CONCEPT_URI) return SMILES_TYPE;
    if (rawField.conceptURI === CALCULATED_CONCEPT_URI) return CALCULATED_TYPE;
    if (rawField.dataType) {
      return rawField.dataType;
    }
    type = PROP_DESC_TYPES.find(type => {
      // handle matching rangeURI and conceptURI
      if (type.rangeURI === rawField.rangeURI && !type.isUser()) {
        if (!rawField.lookupQuery && (!type.conceptURI && !rawField.conceptURI || type.conceptURI === rawField.conceptURI || CONCEPT_URIS_NOT_USED_IN_TYPES.contains(rawField.conceptURI))) {
          return true;
        }
      }
      // handle alternateRangeURI which are returned from the server for inferDomain response
      else if (type.alternateRangeURI && type.alternateRangeURI === rawField.rangeURI) {
        return true;
      }
      // handle selected lookup option
      else if (type.isLookup() && rawField.lookupQuery && rawField.lookupQuery !== 'users') {
        return true;
      }
      // handle selected users option
      else if (type.isUser() && rawField.lookupQuery && rawField.lookupQuery === 'users') {
        return true;
      }
      return false;
    });

    // Issue 39341: support for a few field types that are used in certain domains but are not supported for newly created fields
    if (!type) {
      type = READONLY_DESC_TYPES.find(type => type.rangeURI === rawField.rangeURI);
    }
  }
  return type ? type : TEXT_TYPE;
}
class ColumnInfoLite extends (0,external_immutable_.Record)({
  friendlyType: undefined,
  isKeyField: false,
  jsonType: undefined,
  name: undefined
}) {
  static create(raw) {
    return new ColumnInfoLite(raw);
  }
}
class QueryInfoLite extends (0,external_immutable_.Record)({
  canEdit: false,
  canEditSharedViews: false,
  columns: (0,external_immutable_.List)(),
  description: undefined,
  hidden: false,
  inherit: false,
  isIncludedForLookups: true,
  isInherited: false,
  isMetadataOverrideable: false,
  isUserDefined: false,
  name: undefined,
  schemaName: undefined,
  snapshot: false,
  title: undefined,
  viewDataUrl: undefined
}) {
  static create(raw, schemaName) {
    return new QueryInfoLite(Object.assign({}, raw, {
      columns: raw.columns ? (0,external_immutable_.List)(raw.columns.map(c => ColumnInfoLite.create(c))) : (0,external_immutable_.List)(),
      schemaName
    }));
  }
  getLookupInfo(rangeURI) {
    const infos = [];

    // allow for queries with only 1 primary key or with 2 primary key columns when one of them is container (see Issue 39879)
    let pkCols = this.getPkColumns().size > 1 ? this.getPkColumns().filter(col => col.name.toLowerCase() !== 'container').toList() : this.getPkColumns();
    if (pkCols.size === 1) {
      // Sample Type hack (ported from DomainEditorServiceBase.java)
      if (this.schemaName.toLowerCase() === 'samples') {
        const nameCol = this.columns.find(c => c.name.toLowerCase() === 'name');
        if (nameCol) {
          pkCols = pkCols.push(nameCol);
        }
      }
      pkCols.forEach(pk => {
        const type = PROP_DESC_TYPES.find(propType => propType.name.toLowerCase() === pk.jsonType.toLowerCase());

        // if supplied, apply rangeURI matching filter
        if (type && (rangeURI === undefined || rangeURI === type.rangeURI)) {
          infos.push({
            name: this.name,
            type
          });
        }
      });
    }
    return infos;
  }
  getPkColumns() {
    return this.columns.filter(c => c.isKeyField).toList();
  }
}

// modeled after the JSON object received during server side error (except the severity).

// DomainException is used for both server side and client side errors.
// For server side, DomainException object is constructed in actions.ts (see saveDomain()) on failure while saving or creating a domain.
// For client side, DomainException object is constructed in actions.ts (see handleDomainUpdates()) while updating the domain.
class DomainException extends (0,external_immutable_.Record)({
  exception: undefined,
  success: undefined,
  severity: undefined,
  domainName: undefined,
  errors: (0,external_immutable_.List)()
}) {
  static create(rawModel, severityLevel) {
    if (rawModel && rawModel.exception) {
      let errors = (0,external_immutable_.List)();
      if (rawModel.errors) {
        errors = DomainFieldError.fromJS(rawModel.errors, severityLevel);
      }

      // warnings will only be there if there are no errors, so looking only the first one
      let severity = severityLevel;
      const hasOnlyWarnings = errors.find(error => error.severity === constants_SEVERITY_LEVEL_WARN);
      if (hasOnlyWarnings) {
        severity = constants_SEVERITY_LEVEL_WARN;
      }
      const domainName = this.getDomainNameFromException(rawModel.exception);
      if (domainName) {
        const prefix = domainName + ' -- ';
        errors = errors.map(err => {
          const parts = err.message.split(prefix);
          return err.set('message', parts.length > 1 ? parts[1] : parts[0]);
        });
      }
      const exception = errors.isEmpty() ? rawModel.exception : this.getExceptionMessage(errors);
      return new DomainException({
        exception,
        success: rawModel.success,
        severity,
        domainName,
        errors
      });
    }
    return undefined;
  }
  static clientValidationExceptions(exception, fields) {
    let fieldErrors = (0,external_immutable_.List)();
    fields.forEach((field, index) => {
      fieldErrors = fieldErrors.push(new DomainFieldError({
        message: field.getErrors(),
        fieldName: field.get('name'),
        propertyId: field.get('propertyId'),
        severity: constants_SEVERITY_LEVEL_ERROR,
        serverError: false,
        rowIndexes: (0,external_immutable_.List)([index]),
        newRowIndexes: undefined
      }));
    });
    return new DomainException({
      exception,
      success: false,
      severity: constants_SEVERITY_LEVEL_ERROR,
      errors: fieldErrors
    });
  }
  static getDomainNameFromException(message) {
    const msgParts = message.split(' -- ');
    if (msgParts.length > 1) {
      return msgParts[0];
    }
    return undefined;
  }

  // merge warnings with an incoming server side errors so that both server and pre-existing client side warning can be shown on the banner
  static mergeWarnings(domain, exception) {
    // merge pre-existing warnings on the domain
    if (domain && domain.hasException()) {
      const existingWarnings = domain.domainException.get('errors').filter(e => e.severity === constants_SEVERITY_LEVEL_WARN);
      const serverSideErrors = exception.get('errors');
      const allErrors = serverSideErrors.concat(existingWarnings);
      return exception.set('errors', allErrors);
    }
    return exception.set('errors', exception.errors);
  }
  static addRowIndexesToErrors(domain, exceptionFromServer) {
    let allFieldErrors = exceptionFromServer.get('errors');
    allFieldErrors = allFieldErrors.map(error => {
      const indices = domain.fields.reduce((indexList, field, idx, iter) => {
        if ((field.name === undefined || field.name === '') && error.get('fieldName') === undefined || field.propertyId !== 0 && field.propertyId !== undefined && error.get('propertyId') === field.propertyId || field.name !== undefined && error.get('fieldName') !== undefined && field.name.toLowerCase() === error.get('fieldName').toLowerCase()) {
          indexList = indexList.push(idx);
        }
        return indexList;
      }, (0,external_immutable_.List)());
      return error.merge({
        rowIndexes: indices
      });
    });
    return exceptionFromServer.set('errors', allFieldErrors);
  }
  static getExceptionMessage(errors) {
    let fieldErrorsCount = 0;
    let generalErrorMsg = '';
    let singleFieldError = '';
    errors.toArray().forEach(error => {
      if (error.fieldName !== undefined && error.fieldName !== '') {
        // Field error
        fieldErrorsCount++;
        singleFieldError = error.message;
      } else {
        // General error
        generalErrorMsg += error.message + ' \n';
      }
    });
    return fieldErrorsCount > 1 ? 'You have ' + fieldErrorsCount + ' field errors. ' + generalErrorMsg : singleFieldError + ' ' + generalErrorMsg;
  }
}
class DomainFieldError extends (0,external_immutable_.Record)({
  message: undefined,
  fieldName: undefined,
  propertyId: undefined,
  severity: undefined,
  serverError: undefined,
  rowIndexes: (0,external_immutable_.List)(),
  newRowIndexes: undefined,
  extraInfo: undefined
}) {
  static fromJS(errors, severityLevel) {
    let fieldErrors = (0,external_immutable_.List)();
    const hasErrors = errors.find(error => error.severity === constants_SEVERITY_LEVEL_ERROR);
    for (let i = 0; i < errors.length; i++) {
      // stripping out server side warnings when there are errors
      if (errors[i].id === 'ServerWarning' && hasErrors) continue;

      // empty field name and property id comes in as "form" string from the server, resetting it to undefined here
      const fieldName = errors[i].id === 'form' && errors[i].field === 'form' ? undefined : errors[i].field;
      const propertyId = errors[i].id === 'form' && errors[i].field === 'form' || errors[i].id < 1 ? undefined : errors[i].id;
      const severity = errors[i].severity ? errors[i].severity : severityLevel;
      const domainFieldError = new DomainFieldError({
        fieldName,
        propertyId,
        message: errors[i].message,
        extraInfo: errors[i].extraInfo,
        severity,
        serverError: true,
        rowIndexes: errors[i].rowIndexes ? errors[i].rowIndexes : (0,external_immutable_.List)()
      });
      fieldErrors = fieldErrors.push(domainFieldError);
    }
    return fieldErrors;
  }
}
/**
 * General object to describe a DomainKind as received from Domain.getDomainDetails
 *
 * @property domainDesign The fields found on all items of this domain (e.g., copy per item)
 * @property options The fields and properties shared by this type (e.g., one copy) ('options' used to match existing LKS api)
 * @property domainKindName The name of the domainkind type this represents, currently supported can be found in Domain.KINDS
 */
class DomainDetails extends (0,external_immutable_.Record)({
  domainDesign: undefined,
  options: undefined,
  domainKindName: undefined,
  nameReadOnly: false,
  namePreviews: undefined
}) {
  static create(rawDesign = (0,external_immutable_.Map)(), domainKindType = api_.Domain.KINDS.UNKNOWN) {
    let design;
    if (rawDesign) {
      const domainDesign = DomainDesign.create(rawDesign.get('domainDesign'));
      const domainKindName = rawDesign.get('domainKindName', domainKindType);
      const options = (0,external_immutable_.Map)(rawDesign.get('options'));
      const nameReadOnly = rawDesign.get('nameReadOnly');
      const namePreviews = rawDesign.get('namePreviews');
      design = new DomainDetails({
        domainDesign,
        domainKindName,
        options,
        nameReadOnly,
        namePreviews
      });
    } else {
      design = new DomainDetails({
        domainDesign: DomainDesign.create(null),
        domainKindName: domainKindType,
        options: (0,external_immutable_.Map)()
      });
    }
    return design;
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/assay/models.ts
function assay_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function assay_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? assay_models_ownKeys(Object(t), !0).forEach(function (r) { assay_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : assay_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function assay_models_defineProperty(e, r, t) { return (r = assay_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function assay_models_toPropertyKey(t) { var i = assay_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function assay_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







// See ExpProtocol.Status in 'platform' repository.
let Status = /*#__PURE__*/function (Status) {
  Status["Active"] = "Active";
  Status["Archived"] = "Archived";
  return Status;
}({});
class AssayProtocolModel extends (0,external_immutable_.Record)({
  allowBackgroundUpload: false,
  allowEditableResults: false,
  allowQCStates: false,
  allowTransformationScript: false,
  allowPlateMetadata: false,
  autoCopyTargetContainer: undefined,
  autoCopyTargetContainerId: undefined,
  autoLinkCategory: undefined,
  availableDetectionMethods: undefined,
  availableMetadataInputFormats: undefined,
  availablePlateTemplates: undefined,
  backgroundUpload: false,
  description: undefined,
  domains: undefined,
  editableResults: false,
  editableRuns: false,
  exception: undefined,
  metadataInputFormatHelp: undefined,
  moduleTransformScripts: undefined,
  name: undefined,
  plateMetadata: undefined,
  protocolId: undefined,
  protocolParameters: undefined,
  protocolTransformScripts: undefined,
  providerName: undefined,
  saveScriptFiles: false,
  selectedDetectionMethod: undefined,
  selectedMetadataInputFormat: undefined,
  selectedPlateTemplate: undefined,
  status: Status.Active,
  qcEnabled: undefined,
  excludedContainerIds: undefined
}) {
  static create(raw) {
    let domains = raw.domains || (0,external_immutable_.List)();
    if (raw.domains && api_.Utils.isArray(raw.domains)) {
      domains = (0,external_immutable_.List)(raw.domains.map(domain => {
        return DomainDesign.create(domain);
      }));
    }
    if (raw.protocolTransformScripts && api_.Utils.isArray(raw.protocolTransformScripts)) {
      raw.protocolTransformScripts = (0,external_immutable_.List)(raw.protocolTransformScripts);
    }
    if (raw.moduleTransformScripts && api_.Utils.isArray(raw.moduleTransformScripts)) {
      raw.moduleTransformScripts = (0,external_immutable_.List)(raw.moduleTransformScripts);
    }

    // if this is not an existing assay, clear the name property so the user must set it
    const name = !raw.protocolId ? undefined : raw.name;

    // Issue 38685: for new assays, pre-select some required assay properties
    const model = new AssayProtocolModel(assay_models_objectSpread(assay_models_objectSpread({}, raw), {}, {
      name,
      domains
    }));
    if (model.isNew()) {
      if (model.allowDetectionMethodSelection() && model.availableDetectionMethods.length > 0) {
        raw.selectedDetectionMethod = (0,external_immutable_.List)(model.availableDetectionMethods).get(0);
      }
      if (model.allowPlateTemplateSelection() && model.availablePlateTemplates.length > 0) {
        raw.selectedPlateTemplate = (0,external_immutable_.List)(model.availablePlateTemplates).get(0);
      }
    }
    return new AssayProtocolModel(assay_models_objectSpread(assay_models_objectSpread({}, raw), {}, {
      name,
      domains
    }));
  }
  static serialize(model) {
    // need to serialize the DomainDesign objects to remove the unrecognized fields
    const domains = model.domains.map(domain => {
      return DomainDesign.serialize(domain);
    });
    const json = model.merge({
      domains
    }).toJS();

    // only need to serialize the id and not the autoCopyTargetContainer object
    delete json.autoCopyTargetContainer;
    delete json.exception;
    return json;
  }
  isActive() {
    return this.status === Status.Active;
  }
  getDomainByNameSuffix(name) {
    if (this.domains.size > 0) {
      return this.domains.find(domain => {
        return domain.isNameSuffixMatch(name);
      });
    }
  }
  get container() {
    const container = new Container((0,api_.getServerContext)().container);
    const domainContainerId = this.domainContainerId;
    return this.isNew() ? getAppHomeFolderPath(container) : domainContainerId === container.id ? container.path : domainContainerId;
  }
  get domainContainerId() {
    return this.getIn(['domains', 0, 'container']);
  }
  isNew() {
    return !this.protocolId;
  }
  allowPlateTemplateSelection() {
    return this.availablePlateTemplates && api_.Utils.isArray(this.availablePlateTemplates);
  }
  allowDetectionMethodSelection() {
    return this.availableDetectionMethods && api_.Utils.isArray(this.availableDetectionMethods);
  }
  allowMetadataInputFormatSelection() {
    return this.availableMetadataInputFormats && api_.Utils.isObject(this.availableMetadataInputFormats) && !api_.Utils.isEmptyObj(this.availableMetadataInputFormats);
  }
  validateTransformScripts() {
    if (this.protocolTransformScripts === undefined || this.protocolTransformScripts.size === 0) {
      return undefined;
    }

    // make sure we don't have any script inputs that are empty strings
    const hasEmptyScript = this.protocolTransformScripts.some((script, i) => script === undefined || script === null || script.length === 0);
    if (hasEmptyScript) {
      return 'Missing required transform script path.';
    }
  }
  getFirstDomainFieldError() {
    const firstErrantDomain = this.domains.find(domain => domain.hasInvalidFields());
    return firstErrantDomain !== undefined ? firstErrantDomain.getInvalidFields().first().getErrors() : undefined;
  }
  isValid() {
    return this.hasValidProperties() && this.getFirstDomainFieldError() === undefined;
  }
  isGPAT() {
    return this.providerName.toLowerCase() === 'general';
  }
  hasValidProperties() {
    return this.name !== undefined && this.name !== null && this.name.trim().length > 0 && (!this.allowMetadataInputFormatSelection() || api_.Utils.isString(this.selectedMetadataInputFormat)) && (!this.allowDetectionMethodSelection() || api_.Utils.isString(this.selectedDetectionMethod)) && (!this.allowPlateTemplateSelection() || api_.Utils.isString(this.selectedPlateTemplate)) && this.validateTransformScripts() === undefined;
  }
  get hasBatchFields() {
    return this.getDomainByNameSuffix('Batch')?.fields.size > 0;
  }
  getUrl() {
    return AppURL.create('assays', this.providerName, this.name);
  }
}
;// CONCATENATED MODULE: ./src/internal/components/assay/models.ts
function components_assay_models_defineProperty(e, r, t) { return (r = components_assay_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function components_assay_models_toPropertyKey(t) { var i = components_assay_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function components_assay_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


class AssayUploadResultModel {
  constructor(values) {
    components_assay_models_defineProperty(this, external_immer_.immerable, true);
    components_assay_models_defineProperty(this, "assayId", void 0);
    components_assay_models_defineProperty(this, "batchId", void 0);
    components_assay_models_defineProperty(this, "runId", void 0);
    components_assay_models_defineProperty(this, "success", void 0);
    components_assay_models_defineProperty(this, "successurl", void 0);
    components_assay_models_defineProperty(this, "jobId", void 0);
    Object.assign(this, values);
  }
}
class AssayStateModel {
  constructor(values) {
    components_assay_models_defineProperty(this, external_immer_.immerable, true);
    components_assay_models_defineProperty(this, "definitions", void 0);
    components_assay_models_defineProperty(this, "definitionsError", void 0);
    components_assay_models_defineProperty(this, "definitionsLoadingState", void 0);
    components_assay_models_defineProperty(this, "protocolError", void 0);
    components_assay_models_defineProperty(this, "protocolLoadingState", void 0);
    Object.assign(this, values);
    this.definitions = this.definitions ?? [];
    this.definitionsLoadingState = this.definitionsLoadingState ?? LoadingState.INITIALIZED;
    this.protocolLoadingState = this.protocolLoadingState ?? LoadingState.INITIALIZED;
  }
  getById(assayRowId) {
    return this.definitions.find(def => def.id === assayRowId);
  }
  getByName(assayName) {
    const lowerName = assayName.toLowerCase();
    return this.definitions.find(def => def.name.toLowerCase() === lowerName);
  }
  getDefinitionsByTypes(included, excluded) {
    if (!included && !excluded) return this.definitions;
    const lowerIncluded = included?.join('|').toLowerCase().split('|');
    const lowerExcluded = excluded?.join('|').toLowerCase().split('|');
    return this.definitions.filter(def => {
      let include = true;
      if (included?.length > 0) {
        include = lowerIncluded.indexOf(def.type.toLowerCase()) !== -1;
      }
      if (excluded?.length > 0) {
        include = lowerExcluded.indexOf(def.type.toLowerCase()) === -1;
      }
      return include;
    });
  }
  mutate(props) {
    return (0,external_immer_.produce)(this, draft => {
      Object.assign(draft, props);
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/components/assay/actions.ts
function actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? actions_ownKeys(Object(t), !0).forEach(function (r) { actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function actions_defineProperty(e, r, t) { return (r = actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function actions_toPropertyKey(t) { var i = actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








/**
 * Only support option to re-import run if user has insert permissions in current container
 * and the current container is where the source run is located. This prevents runs from being
 * re-imported "up" or "down" the folder structure.
 */
function allowReimportAssayRun(user, runContainerId, targetContainerId) {
  return !!runContainerId && !!targetContainerId && targetContainerId === runContainerId && user.hasInsertPermission();
}
let assayDefinitionCache = {};
let protocolCache = {};
function clearAssayDefinitionCache() {
  assayDefinitionCache = {};
  protocolCache = {};
}
function getAssayDefinitions(options) {
  const key = [options.containerPath, options.id, options.name, options.plateEnabled, options.status, options.type].join('|');
  if (!assayDefinitionCache[key]) {
    assayDefinitionCache[key] = new Promise((resolve, reject) => {
      api_.Assay.getAssays(actions_objectSpread(actions_objectSpread({}, options), {}, {
        success: rawModels => {
          resolve(rawModels.map(raw => AssayDefinitionModel.create(raw)) ?? []);
        },
        failure: error => {
          reject(error);
        }
      }));
    });
  }
  return assayDefinitionCache[key];
}
function getProtocol(options) {
  const {
    copy = false,
    containerPath,
    protocolId,
    providerName
  } = options;
  const key = [copy, containerPath, protocolId, providerName].join('|').toLowerCase();

  // Issue 49922: Cache assay protocol requests
  if (!protocolCache[key]) {
    protocolCache[key] = new Promise((resolve, reject) => {
      const params = {
        copy,
        protocolId
      };

      // give precedence to the protocolId if both are provided
      if (protocolId === undefined) {
        params.providerName = providerName;
      }
      api_.Ajax.request({
        url: api_.ActionURL.buildURL('assay', 'getProtocol.api', containerPath, params),
        success: api_.Utils.getCallbackWrapper(data => {
          resolve(AssayProtocolModel.create(data.data));
        }),
        failure: handleRequestFailure(reject, 'Failed to load assay protocol')
      });
    });
  }
  return protocolCache[key];
}
function importAssayRun(config) {
  return new Promise((resolve, reject) => {
    api_.AssayDOM.importRun(actions_objectSpread(actions_objectSpread({}, config), {}, {
      success: rawModel => {
        resolve(new AssayUploadResultModel(rawModel));
      },
      failure: error => {
        console.error('Failed to import assay run', error);
        reject(error);
      }
    }));
  });
}
function uploadAssayRunFiles(data) {
  return new Promise((resolve, reject) => {
    const batchFiles = collectFiles(data.batchProperties);
    const runFiles = collectFiles(data.properties);

    // track the largest file size for the results data, used to determine if async mode should be used
    // note that we don't include the batchFiles or runFiles in this as they are processed / posted separately
    let maxFileSize = 0;
    const maxRowCount = Array.isArray(data.dataRows) ? data.dataRows.length : undefined;
    if (data.files) {
      data.files.forEach(file => {
        if (file.size > maxFileSize) {
          maxFileSize = file.size;
        }
      });
    }
    if (api_.Utils.isEmptyObj(batchFiles) && api_.Utils.isEmptyObj(runFiles)) {
      // No files in the data, so just go ahead and resolve so we run the import.
      resolve(actions_objectSpread(actions_objectSpread({}, data), {}, {
        maxRowCount,
        maxFileSize
      }));
      return;
    }

    // If we're this far along we've got files so let's process them.
    let fileCounter = 0;
    const formData = new FormData();
    const fileNameMap = {}; // Maps the file name "fileN" to the run/batch property it belongs to.

    // TODO factor this out so the code isn't duplicate below for the runFiles case
    Object.keys(batchFiles).forEach(columnName => {
      const name = fileCounter === 0 ? 'file' : `file${fileCounter}`;
      const file = batchFiles[columnName];
      fileNameMap[name] = {
        columnName,
        origin: 'batch'
      };
      formData.append(name, file);
      fileCounter++;
    });
    Object.keys(runFiles).forEach(columnName => {
      const name = fileCounter === 0 ? 'file' : `file${fileCounter}`;
      const file = runFiles[columnName];
      fileNameMap[name] = {
        columnName,
        origin: 'run'
      };
      formData.append(name, file);
      fileCounter++;
    });

    // N.B. assayFileUpload's success response is not handled well by Utils.getCallbackWrapper.
    api_.Ajax.request({
      url: buildURL('assay', 'assayFileUpload.view'),
      method: 'POST',
      form: formData,
      success: result => {
        let response = JSON.parse(result.responseText);
        const batchPaths = {};
        const runPaths = {};
        if (fileCounter === 1) {
          // Make the single file response look like the multi-file response.
          response = {
            file: response
          };
        }

        // Only process attributes that start with file so we ignore all the other stuff in the response like
        // the "success" attribute.
        Object.keys(response).filter(key => key.startsWith('file')).forEach(key => {
          const {
            columnName,
            origin
          } = fileNameMap[key];
          if (origin === 'batch') {
            batchPaths[columnName] = response[key].absolutePath;
          } else if (origin === 'run') {
            runPaths[columnName] = response[key].absolutePath;
          }
        });
        resolve(actions_objectSpread(actions_objectSpread({}, data), {}, {
          batchProperties: actions_objectSpread(actions_objectSpread({}, data.batchProperties), batchPaths),
          properties: actions_objectSpread(actions_objectSpread({}, data.properties), runPaths),
          maxRowCount,
          maxFileSize
        }));
      },
      failure: api_.Utils.getCallbackWrapper(error => {
        // As far as I can tell errors returned from assay FileUpload are only ever strings.
        const message = `Error while uploading files: ${error}`;
        reject({
          message
        });
      })
    });
  });
}
function collectFiles(source) {
  return Object.keys(source).reduce((files, key) => {
    const item = source[key];
    if (item instanceof File) {
      files[key] = item;
    }
    return files;
  }, {});
}
function checkForDuplicateAssayFiles(fileNames) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('assay', 'assayFileDuplicateCheck.api'),
      method: 'POST',
      jsonData: {
        fileNames
      },
      success: api_.Utils.getCallbackWrapper(res => {
        resolve(res);
      }),
      failure: handleRequestFailure(reject, 'Problem checking for duplicate files')
    });
  });
}
function getRunPropertiesFileName(row) {
  const dataOutputs = caseInsensitive(row, 'DataOutputs');
  return dataOutputs && dataOutputs.length === 1 ? dataOutputs[0].displayValue : undefined;
}
function flattenQueryModelRow(rowData) {
  if (rowData) {
    // TODO make the consumers of this row data able to handle the queryData instead of
    // having to create the key -> value map via reduction.
    let map = (0,external_immutable_.Map)();
    Object.keys(rowData).forEach(k => {
      const v = rowData[k];
      let valueMap = v;
      if (api_.Utils.isArray(v)) {
        if (v.length > 1) {
          console.warn("Multiple values for field '" + k + "'.  Using the last.");
        }
        valueMap = v[v.length - 1];
      }
      if (valueMap && valueMap['value'] !== undefined && valueMap['value'] !== null) {
        map = map.set(k, valueMap['value']);
      }
    });
    return map;
  }
  return (0,external_immutable_.Map)();
}
;// CONCATENATED MODULE: ./src/internal/components/assay/APIWrapper.ts
function APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function APIWrapper_defineProperty(e, r, t) { return (r = APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function APIWrapper_toPropertyKey(t) { var i = APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class AssayServerAPIWrapper {
  constructor() {
    APIWrapper_defineProperty(this, "clearAssayDefinitionCache", clearAssayDefinitionCache);
    APIWrapper_defineProperty(this, "getAssayDefinitions", getAssayDefinitions);
    APIWrapper_defineProperty(this, "getProtocol", getProtocol);
    APIWrapper_defineProperty(this, "importAssayRun", importAssayRun);
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getAssayTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return APIWrapper_objectSpread({
    clearAssayDefinitionCache: mockFn(),
    getAssayDefinitions: mockFn(),
    getProtocol: mockFn(),
    importAssayRun: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/DataViewInfo.ts
/**
 * IDataViewInfo is a client side implementation of the server-side class DataViewInfo. We currently only implement
 * a subset of the fields that are used by the client.
 */

const DataViewInfoDefaultValues = {
  name: undefined,
  description: undefined,
  detailsUrl: undefined,
  runUrl: undefined,
  type: undefined,
  visible: undefined,
  id: undefined,
  reportId: undefined,
  created: undefined,
  modified: undefined,
  createdBy: undefined,
  modifiedBy: undefined,
  thumbnail: undefined,
  icon: undefined,
  iconCls: undefined,
  schemaName: undefined,
  queryName: undefined,
  shared: false,
  // Client Side only attributes
  isLoading: false,
  isLoaded: false,
  error: undefined
};

// commented out attributes are not used in app
class DataViewInfo {
  // Client Side only attributes

  constructor(data) {
    Object.assign(this, DataViewInfoDefaultValues, data);
  }
}
;// CONCATENATED MODULE: ./src/internal/util/messaging.tsx




// TODO rename as actionErrorMessage
function getActionErrorMessage(problemStatement, noun, showRefresh = true) {
  return /*#__PURE__*/external_react_default().createElement("span", null, problemStatement, "\xA0Your session may have expired or the ", noun, " may no longer be valid.", showRefresh && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "\xA0Try ", /*#__PURE__*/external_react_default().createElement("a", {
    onClick: () => window.location.reload()
  }, "refreshing the page"), "."));
}
function deleteSuccessMessage(noun, count, additionalInfo) {
  const countStr = count === undefined ? '' : count;
  return 'Successfully deleted ' + countStr.toLocaleString() + ' ' + noun + '. ' + (additionalInfo || '');
}
function deleteErrorMessage(noun) {
  return getActionErrorMessage('There was a problem deleting the ' + noun + '. ', noun);
}
const IllegalArgumentMessage = 'java.lang.illegalargumentexception:';
const ClassCastMessage = 'cannot be cast to class';
const NullPointerExceptionMessage = 'java.lang.nullpointerexception';
const ExperimentExceptionMessage = 'org.labkey.api.exp.experimentexception:';
function trimExceptionPrefix(exceptionMessage, message) {
  const startIndex = message.toLowerCase().indexOf(exceptionMessage);
  return message.substring(startIndex + exceptionMessage.length).trim();
}
function resolveDuplicatesAsName(errorMsg, noun, nounPlural, verb) {
  // N.B. Issues 48050 and 48209: only for Postgres since the error message from SQL server doesn't provide a
  // reasonable way to parse a multi-field key in the face of names that may contain commas and spaces. Seems
  // better to show a generic message instead of an incorrectly parsed name.
  const keyMatch = errorMsg.match(/Key \(([^)]+)\)=\(([^)]+)\) already exists./);
  let name;
  if (keyMatch) {
    const numParts = keyMatch[1].split(', ').length;
    let index = 0;
    for (let i = 0; i < numParts - 1; i++) {
      index = keyMatch[2].indexOf(', ', index + 1);
    }
    if (index < keyMatch[2].length) {
      if (numParts > 1) {
        // one for comma and one for space
        name = keyMatch[2].substring(index + 2);
      } else {
        name = keyMatch[2];
      }
    }
  }
  let retMsg = `There was a problem ${verb || 'creating'} your ${nounPlural || noun || 'data'}.`;
  if (name) {
    retMsg += ` Duplicate name '${name}' found.`;
  } else {
    retMsg += ` Check the existing ${nounPlural || noun} for possible duplicates and make sure any referenced ${nounPlural || noun} are still valid.`;
  }
  return retMsg;
}
function resolveErrorMessage(error, noun = 'data', nounPlural, verb, duplicatesMessageResolver) {
  let errorMsg;
  if (!error) {
    return undefined;
  }
  if (typeof error === 'string') {
    errorMsg = error;
  } else if (error.message) {
    errorMsg = error.message;
  } else if (error.msg) {
    errorMsg = error.msg;
  } else if (error.exception) {
    errorMsg = error.exception;
  }
  if (errorMsg) {
    const lcMessage = errorMsg.toLowerCase();
    const duplicatesResolver = duplicatesMessageResolver ?? resolveDuplicatesAsName;
    if (lcMessage.indexOf('violates unique constraint') >= 0 || lcMessage.indexOf('violation of unique key constraint') >= 0 || lcMessage.indexOf('cannot insert duplicate key row') >= 0) {
      return duplicatesResolver(errorMsg, noun, nounPlural, verb);
    } else if (lcMessage.indexOf('violates foreign key constraint') >= 0 || lcMessage.indexOf('conflicted with the foreign key constraint') >= 0) {
      return `There was a problem ${verb || 'creating'} your ${noun || 'data'}. Check the data fields to make
            sure they contain or reference valid values.`;
    } else if (lcMessage.indexOf('bad sql grammar') >= 0 || lcMessage.indexOf(ClassCastMessage) >= 0) {
      return `There was a problem ${verb || 'creating'} your ${noun || 'data'}.  Check that the format of the data matches the expected type for each field.`;
    } else if (lcMessage.indexOf('existing row was not found') >= 0) {
      return `We could not find the ${noun || 'data'} ${verb ? 'to ' + verb : ''}.  Try refreshing your page to see if it has been deleted.`;
    } else if (lcMessage.indexOf('communication failure') >= 0 || lcMessage.match(/query.*in schema.*doesn't exist/) !== null || lcMessage.match(/query.*in schema.*does not exist/) !== null) {
      return `There was a problem ${verb || 'retrieving'} your ${noun || 'data'}. Your session may have expired or the ${noun || 'data'} may no longer be valid.  Try refreshing your page.`;
    } else if (lcMessage.indexOf('either rowid or lsid is required') >= 0) {
      return `There was a problem ${verb || 'retrieving or updating'} your ${noun || 'data'}.  The request did not contain the proper identifiers.  Make sure the ${noun || 'data'} are still valid.`;
    } else if (lcMessage.indexOf('unable to set genid to ') === 0) {
      // genId display value should be 1 larger than DB value
      const prefix = 'Unable to set genId to ';
      const numberEndInd = lcMessage.indexOf(' ', prefix.length + 1);
      const numberStr = lcMessage.substring(prefix.length, numberEndInd);
      return prefix + (parseInt(numberStr) + 1) + lcMessage.substring(numberEndInd);
    } else if (lcMessage.indexOf(IllegalArgumentMessage) >= 0) {
      return trimExceptionPrefix(IllegalArgumentMessage, errorMsg);
    } else if (lcMessage.indexOf('at least one of "file", "runfilepath", or "datarows" is required') >= 0) {
      return `No data provided for ${verb || 'import'}.`;
    } else if (lcMessage.indexOf(NullPointerExceptionMessage) >= 0) {
      return `There was a problem ${verb || 'processing'} your ${noun || 'data'}. This may be a problem in the application. Contact your administrator.`;
    } else if (lcMessage.indexOf(ExperimentExceptionMessage) >= 0) {
      return trimExceptionPrefix(ExperimentExceptionMessage, errorMsg);
    } else if (lcMessage.indexOf("cannot update data that don't belong to the current container.") >= 0) {
      return `There was a problem ${verb || 'importing'} your ${noun.toLowerCase() || 'data'}. One or more ${noun.toLowerCase() || 'data'} already exist in a different project.`;
    } else if (lcMessage.indexOf('inventory:item: row: ') >= 0) {
      return trimExceptionPrefix('inventory:item: row: ', errorMsg);
    } else if (lcMessage.indexOf('could not create unique index') >= 0) {
      const startIndex = lcMessage.indexOf('detail: key (');
      const fieldname = startIndex > -1 ? 'for field ' + lcMessage.substring(startIndex + 13, lcMessage.indexOf(')=(')) : '';
      return `Unable to create a unique constraint ${fieldname} because duplicate values already exists in the data.`;
    }
  }
  return errorMsg;
}
function getConfirmDeleteMessage(verbNoun = 'Deletion') {
  return /*#__PURE__*/external_react_default().createElement("p", {
    className: "top-spacing"
  }, /*#__PURE__*/external_react_default().createElement("strong", null, capitalizeFirstChar(verbNoun), " cannot be undone."), "\xA0Do you want to proceed?");
}
function getPermissionRestrictionMessage(totalCount, noPermissionCount, nounSingular, nounPlural, verb, verbSuffix) {
  if (!noPermissionCount) {
    return '';
  }
  const noun = totalCount === 1 ? nounSingular : nounPlural;
  if (noPermissionCount === totalCount) {
    return `You don't have the required permission to ${verb} the selected ${noun}${verbSuffix ?? ''}.`;
  }
  const notPermittedNoun = api_.Utils.pluralize(noPermissionCount, nounSingular, nounPlural);
  return `Selection includes ${notPermittedNoun} that you do not have permission to ${verb}${verbSuffix ?? ''}. Only the ${nounPlural} that you have permission for will be updated.`;
}
;// CONCATENATED MODULE: ./src/internal/models.ts
function createGridModelId(gridId, schemaQuery, keyValue) {
  const parts = [gridId, schemaQuery.getKey()];
  if (schemaQuery && schemaQuery.viewName) {
    parts.push(schemaQuery.viewName);
  }
  if (keyValue !== undefined) {
    parts.push(keyValue);
  }
  return parts.join('|').toLowerCase();
}
;// CONCATENATED MODULE: ./src/internal/actions.ts
function internal_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function internal_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? internal_actions_ownKeys(Object(t), !0).forEach(function (r) { internal_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : internal_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function internal_actions_defineProperty(e, r, t) { return (r = internal_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function internal_actions_toPropertyKey(t) { var i = internal_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function internal_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */














function selectAll(key, schemaQuery, filterArray, containerPath, queryParameters, containerFilter) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('query', 'selectAll.api', undefined, {
        container: containerPath
      }),
      method: 'POST',
      params: buildQueryParams(key, schemaQuery, filterArray, queryParameters, containerPath, containerFilter),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: handleRequestFailure(reject, `Problem in selecting all items in the grid ${key} ${schemaQuery.schemaName} ${schemaQuery.queryName}`)
    });
  });
}
function getGridIdsFromTransactionId(transactionAuditId, dataType) {
  if (!transactionAuditId) {
    return;
  }
  const failureMsg = 'There was a problem retrieving the ' + dataType + ' from the last action.';
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('audit', 'getTransactionRowIds.api'),
      params: {
        transactionAuditId,
        dataType
      },
      success: api_.Utils.getCallbackWrapper(response => {
        if (response.success) {
          resolve(response.rowIds);
        } else {
          console.error(failureMsg + ' (transactionAuditId = ' + transactionAuditId + ')', response);
          reject(failureMsg);
        }
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        console.error(failureMsg + ' (transactionAuditId = ' + transactionAuditId + ')', error);
        reject(failureMsg);
      })
    });
  });
}
async function selectGridIdsFromTransactionId(gridIdPrefix, schemaQuery, transactionAuditId, dataType, actions) {
  if (!transactionAuditId) return undefined;
  const modelId = createGridModelId(gridIdPrefix, schemaQuery);
  const selected = await getGridIdsFromTransactionId(transactionAuditId, dataType);
  await actions.replaceSelections(modelId, selected);
  actions.loadModel(modelId, true);
  return selected;
}
async function getSampleTypesFromTransactionIds(transactionAuditId) {
  if (!transactionAuditId) return undefined;
  const rowIds = await getGridIdsFromTransactionId(transactionAuditId, SAMPLES_KEY);
  const sampleTypes = await selectDistinctRows({
    schemaName: SCHEMAS.EXP_TABLES.MATERIALS.schemaName,
    queryName: SCHEMAS.EXP_TABLES.MATERIALS.queryName,
    column: 'SampleSet/Name',
    filterArray: [api_.Filter.create('RowId', rowIds, api_.Filter.Types.IN)]
  });
  return {
    rowIds,
    sampleTypes: sampleTypes.values
  };
}
function getExportParams(type, schemaQuery, options, advancedOptions, queryParameters) {
  let params = {
    schemaName: schemaQuery.schemaName,
    'query.queryName': schemaQuery.queryName,
    'query.showRows': options?.showRows ? [options.showRows] : ['ALL']
  };
  if (queryParameters) {
    Object.keys(queryParameters).forEach(param => {
      params['query.param.' + param] = queryParameters[param];
    });
  }
  if (advancedOptions) params = internal_actions_objectSpread(internal_actions_objectSpread({}, params), advancedOptions);
  if (schemaQuery.viewName) {
    params['query.viewName'] = schemaQuery.viewName;
  }

  // Issue 32052: Apply default headers (CRSF, etc)
  const {
    defaultHeaders
  } = (0,api_.getServerContext)();
  for (const i in defaultHeaders) {
    if (defaultHeaders.hasOwnProperty(i)) {
      params[i] = defaultHeaders[i];
    }
  }
  if (type === EXPORT_TYPES.CSV) {
    params.delim = 'COMMA';
  }
  if (options) {
    if (options.columns) {
      let columnsString = options.columns;
      if (advancedOptions?.includeColumn) columnsString = columnsString + ',' + advancedOptions.includeColumn.join(',');
      if (advancedOptions?.excludeColumn) {
        const toExclude = advancedOptions.excludeColumn;
        const columns = [];
        columnsString.split(',').forEach(col => {
          if (toExclude.indexOf(col) === -1 && toExclude.indexOf(col.toLowerCase()) === -1) {
            columns.push(col);
          }
        });
        params['query.columns'] = columns.join(',');
      } else {
        params['query.columns'] = columnsString;
      }
    }
    const containerFilter = options.containerFilter ?? getContainerFilter(options.containerPath);
    if (containerFilter) {
      params['query.containerFilterName'] = containerFilter;
    }
    options.filters?.forEach(f => {
      if (f) {
        const name = f.getURLParameterName();
        if (!params[name]) {
          params[name] = [];
        }
        params[name].push(f.getURLParameterValue());
      }
    });
    if (options.selectionKey !== undefined) {
      params['query.selectionKey'] = options.selectionKey;
    }
    if (options.sorts) {
      params['query.sort'] = options.sorts;
    }
  }
  return params;
}
function exportTabsXlsx(filename, queryForms) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('query', 'exportQueriesXLSX.api'),
      method: 'POST',
      jsonData: {
        filename,
        queryForms
      },
      downloadFile: true,
      success: () => {
        resolve();
      },
      failure: api_.Utils.getCallbackWrapper(error => {
        console.error('Failed to export tabular data', error);
        reject(resolveErrorMessage(error) ?? 'Unexpected error while exporting selected tabs.');
      })
    });
  });
}
function exportRows(type, exportParams, containerPath) {
  const form = new FormData();
  Object.keys(exportParams).forEach(key => {
    const value = exportParams[key];
    if (value instanceof Array) {
      value.forEach(arrayValue => form.append(key, arrayValue));
    } else {
      form.append(key, value);
    }
  });
  let controller, action;
  if (type === EXPORT_TYPES.CSV || type === EXPORT_TYPES.TSV) {
    controller = 'query';
    action = 'exportRowsTsv.post';
  } else if (type === EXPORT_TYPES.EXCEL) {
    controller = 'query';
    action = 'exportRowsXLSX.post';
  } else if (type === EXPORT_TYPES.FASTA) {
    controller = FASTA_EXPORT_CONTROLLER;
    action = 'export.post';
    form.append('format', 'FASTA');
  } else if (type === EXPORT_TYPES.GENBANK) {
    controller = GENBANK_EXPORT_CONTROLLER;
    action = 'export.post';
    form.append('format', 'GENEBANK');
  } else if (type === EXPORT_TYPES.LABEL) {
    controller = BARTENDER_EXPORT_CONTROLLER;
    action = 'printBarTenderLabels.post';
  } else {
    throw new Error('Unknown export type: ' + type);
  }
  api_.Ajax.request({
    url: buildURL(controller, action, undefined, {
      container: containerPath,
      returnUrl: false
    }),
    method: 'POST',
    form,
    downloadFile: true
  });
}
function getFilteredQueryParams(key, schemaQuery, filterArray, queryParameters, containerPath, containerFilter) {
  if (schemaQuery && filterArray) {
    return buildQueryParams(key, schemaQuery, filterArray, queryParameters, containerPath, containerFilter);
  }
  return {
    key
  };
}
function buildQueryParams(key, schemaQuery, filterArray, queryParameters, containerPath, containerFilter) {
  const filters = filterArray.reduce((_filters, filter) => {
    _filters[filter.getURLParameterName()] = filter.getURLParameterValue();
    return _filters;
  }, {});
  const params = {
    schemaName: schemaQuery.schemaName,
    queryName: schemaQuery.queryName,
    'query.selectionKey': key
  };
  const _containerFilter = containerFilter ?? queryParameters?.containerFilter ?? getContainerFilter(containerPath);
  if (_containerFilter) {
    params['query.containerFilterName'] = _containerFilter;
  }
  if (queryParameters) {
    for (const propName in queryParameters) {
      if (queryParameters.hasOwnProperty(propName)) {
        params['query.param.' + propName] = queryParameters[propName];
      }
    }
  }
  return internal_actions_objectSpread(internal_actions_objectSpread({}, params), filters);
}

/** Gets selected ids from a particular query view, optionally using the provided query parameters. */
function getSelected(key, useSnapshotSelection, schemaQuery, filterArray, containerPath, queryParameters, containerFilter) {
  if (useSnapshotSelection) return getSnapshotSelections(key, containerPath);
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('query', 'getSelected.api', undefined, {
        container: containerPath
      }),
      method: 'POST',
      jsonData: getFilteredQueryParams(key, schemaQuery, filterArray, queryParameters, containerPath, containerFilter),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: handleRequestFailure(reject, 'Failed to get selected.')
    });
  });
}
async function getSelectedData(schemaName, queryName, selections, columns, sorts, queryParameters, viewName, keyColumn = 'RowId') {
  const {
    models,
    orderedModels
  } = await selectRowsDeprecated({
    schemaName,
    queryName,
    viewName,
    filterArray: [api_.Filter.create(keyColumn, selections, api_.Filter.Types.IN)],
    parameters: queryParameters,
    sort: sorts,
    columns,
    offset: 0
  });
  const dataKey = resolveKey(schemaName, queryName);
  return {
    data: (0,external_immutable_.fromJS)(models[dataKey]),
    dataIds: (0,external_immutable_.List)(orderedModels[dataKey])
  };
}
function clearSelected(options) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: api_.ActionURL.buildURL('query', 'clearSelected.api', options.containerPath),
      method: 'POST',
      jsonData: getFilteredQueryParams(options.selectionKey, options.schemaQuery, options.filters, options.queryParameters, options.containerPath, options.containerFilter),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: handleRequestFailure(reject, `Problem clearing the selection ${options.selectionKey} ${options.schemaQuery?.schemaName} ${options.schemaQuery?.queryName}`)
    });
  });
}

/**
 * Selects individual ids for a particular view
 * @param key the selection key for the grid
 * @param checked whether to set selected or unselected
 * @param ids ids to change selection for
 * @param containerPath optional path to the container for this grid.  Default is the current container path
 * @param validateIds if true, check the ids are present in dataregion before setting selection in session
 * @param schemaName name of the schema for the query grid
 * @param queryName name of the query
 * @param filters array of filters to use
 * @param queryParameters the parameters to the underlying query
 */
function setSelected(key, checked, ids, containerPath, validateIds, schemaName, queryName, filters, queryParameters) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('query', 'setSelected.api', undefined, {
        container: containerPath
      }),
      method: 'POST',
      jsonData: {
        id: ids,
        key,
        checked,
        validateIds,
        schemaName,
        queryName,
        filterList: filters,
        queryParameters
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: handleRequestFailure(reject, 'Failed to set selection.')
    });
  });
}
function replaceSelected(options) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: api_.ActionURL.buildURL('query', 'replaceSelected.api', options.containerPath),
      method: 'POST',
      jsonData: {
        key: options.selectionKey,
        id: options.id
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: handleRequestFailure(reject, 'Failed to replace selection.')
    });
  });
}

/**
 * Set the snapshot selections for a grid
 * @param key the selection key for the grid
 * @param ids ids to change selection for
 * @param containerPath optional path to the container for this grid.  Default is the current container path
 */
function setSnapshotSelections(key, ids, containerPath) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('query', 'setSnapshotSelection.api', undefined, {
        container: containerPath
      }),
      method: 'POST',
      jsonData: {
        key,
        id: ids
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: handleRequestFailure(reject, 'Failed to set snapshot selection.')
    });
  });
}

/**
 * Get the snapshot selections for a grid
 * @param key the selection key for the grid
 * @param containerPath optional path to the container for this grid.  Default is the current container path
 */
function getSnapshotSelections(key, containerPath) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('query', 'getSnapshotSelection.api', undefined, {
        container: containerPath
      }),
      method: 'POST',
      jsonData: {
        key
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: handleRequestFailure(reject, 'Failed to get snapshot selection.')
    });
  });
}
async function getSelection(searchParams, schemaName, queryName) {
  const selectionKey = searchParams.get('selectionKey');
  if (selectionKey) {
    let {
      keys,
      schemaQuery
    } = SchemaQuery.parseSelectionKey(selectionKey);
    if (keys !== undefined) {
      return {
        resolved: true,
        schemaQuery,
        selected: keys.split(';')
      };
    }
    if (!schemaQuery) {
      if (schemaName && queryName) {
        schemaQuery = new SchemaQuery(schemaName, queryName);
      }
    }
    if (!schemaQuery) {
      throw new Error(`No schema found for selection with selectionKey ${selectionKey} schemaName ${schemaName} queryName ${queryName}`);
    }
    const params = getQueryParams(searchParams);
    const filters = api_.Filter.getFiltersFromParameters(params);
    const response = await getSelected(selectionKey, false, schemaQuery, filters);
    return {
      resolved: true,
      schemaQuery,
      selected: response.selected
    };
  }
  return {
    resolved: false,
    selected: []
  };
}
function fetchCharts(schemaQuery, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL('reports', 'getReportInfos.api', {
        schemaName: schemaQuery.schemaName,
        queryName: schemaQuery.queryName
      }, {
        container: containerPath
      }),
      success: api_.Utils.getCallbackWrapper(response => {
        if (response && response.success) {
          resolve(response.reports.map(report => new DataViewInfo(report)));
        } else {
          reject({
            error: 'Unable to get report info for schema/query: ' + schemaQuery.schemaName + '/' + schemaQuery.queryName
          });
        }
      }),
      failure: handleRequestFailure(reject)
    });
  });
}

/**
 * Call the core-incrementClientSideMetricCount to track a given client side action (grouped by featureArea and metricName).
 * Note that this call does not return a Promise as it is to just be a background action and not interrupt the
 * main flow of the applications. Also note, that if something goes wrong it will just log the error to the console,
 * but will intentionally not return the error response to the caller.
 * @param featureArea
 * @param metricName
 */
function incrementClientSideMetricCount(featureArea, metricName) {
  const isTestEnv = navigator.userAgent.includes('jsdom');
  if (!featureArea || !metricName || (0,api_.getServerContext)().user.isGuest || isTestEnv) {
    return;
  }
  api_.Ajax.request({
    url: buildURL('core', 'incrementClientSideMetricCount.api'),
    method: 'POST',
    jsonData: {
      featureArea,
      metricName
    },
    success: api_.Utils.getCallbackWrapper(response => {
      // success, no-op
    }),
    failure: api_.Utils.getCallbackWrapper(response => {
      // log the error but don't prevent from proceeding
      console.error(response);
    }, this, true)
  });
}
function saveAsSessionView(schemaQuery, containerPath, viewInfo) {
  // See DataRegion.js _updateSessionCustomView(), this set of hard coded booleans matches that set
  return saveGridView(schemaQuery, containerPath, viewInfo, true, true, false, false);
}
function saveGridView(schemaQuery, containerPath, viewInfo, replace, session, inherit, shared) {
  return new Promise((resolve, reject) => {
    api_.Query.saveQueryViews({
      schemaName: schemaQuery.schemaName,
      queryName: schemaQuery.queryName,
      containerPath,
      views: [internal_actions_objectSpread(internal_actions_objectSpread({}, ViewInfo.serialize(viewInfo)), {}, {
        replace,
        session,
        inherit,
        shared,
        hidden: false
      })],
      success: () => {
        invalidateQueryDetailsCache(schemaQuery, containerPath);
        resolve();
      },
      failure: response => {
        console.error(response);
        reject('There was a problem saving the view for the data grid. ' + resolveErrorMessage(response));
      }
    });
  });
}

// save the current session view as a non session view, remove session view
function saveSessionView(schemaQuery, containerPath, viewName, newName, inherit, shared, replace) {
  return new Promise((resolve, reject) => {
    api_.Query.saveSessionView({
      schemaName: schemaQuery.schemaName,
      queryName: schemaQuery.queryName,
      containerPath,
      viewName,
      newName,
      inherit,
      shared,
      hidden: false,
      replace,
      success: () => {
        invalidateQueryDetailsCache(schemaQuery, containerPath);
        resolve();
      },
      failure: response => {
        console.error(response);
        reject('There was a problem saving the view for the data grid. ' + resolveErrorMessage(response));
      }
    });
  });
}
function getGridViews(schemaQuery, sort, viewName, excludeSessionView, includeHidden) {
  return new Promise((resolve, reject) => {
    api_.Query.getQueryViews({
      schemaName: schemaQuery.schemaName,
      queryName: schemaQuery.queryName,
      viewName,
      excludeSessionView,
      success: response => {
        const views = [];
        response.views?.forEach(view => {
          if (includeHidden || view['hidden'] !== true) views.push(ViewInfo.fromJson(view));
        });
        if (sort) {
          views.sort((a, b) => {
            if (a === ViewInfo.DEFAULT_NAME) return -1;else if (b === '') return 1;
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
          });
        }
        resolve(views);
      },
      failure: response => {
        console.error(response);
        reject('There was a problem loading the views for the data grid. ' + resolveErrorMessage(response));
      }
    });
  });
}
function getGridView(schemaQuery, viewName, excludeSessionView) {
  return new Promise((resolve, reject) => {
    getGridViews(schemaQuery, false, viewName, excludeSessionView).then(views => {
      if (views?.length > 0) resolve(views[0]);else reject('Unable to load the view.');
    }).catch(error => reject(error));
  });
}
function revertViewEdit(schemaQuery, containerPath, viewName) {
  return deleteView(schemaQuery, containerPath, viewName, true);
}
function deleteView(schemaQuery, containerPath, viewName, revert) {
  return new Promise((resolve, reject) => {
    api_.Query.deleteQueryView({
      schemaName: schemaQuery.schemaName,
      queryName: schemaQuery.queryName,
      viewName,
      containerPath,
      revert,
      success: () => {
        invalidateQueryDetailsCache(schemaQuery, containerPath);
        resolve();
      },
      failure: response => {
        if (response.exceptionClass === VIEW_NOT_FOUND_EXCEPTION_CLASS) {
          invalidateQueryDetailsCache(schemaQuery, containerPath);
          resolve(); // view has already been deleted
        } else {
          console.error(response);
          reject('Unable to deleting the view for the data grid. ' + resolveErrorMessage(response));
        }
      }
    });
  });
}

/**
 * Rename a custom view from viewName to newName.
 * @param schemaQuery
 * @param containerPath
 * @param viewName The old custom view name to replace
 * @param newName The new custom view name
 */
function renameGridView(schemaQuery, containerPath, viewName, newName) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL('query', 'renameQueryView.api', undefined, {
        container: containerPath
      }),
      method: 'POST',
      jsonData: {
        schemaName: schemaQuery.schemaName,
        queryName: schemaQuery.queryName,
        viewName,
        newName
      },
      success: api_.Utils.getCallbackWrapper(response => {
        invalidateQueryDetailsCache(schemaQuery, containerPath);
        resolve();
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        console.error(error);
        reject(resolveErrorMessage(error) ?? 'Failed to rename the custom view.');
      })
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/samples/models.ts
function samples_models_defineProperty(e, r, t) { return (r = samples_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function samples_models_toPropertyKey(t) { var i = samples_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function samples_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


let SampleCreationType = /*#__PURE__*/function (SampleCreationType) {
  SampleCreationType["Aliquots"] = "Aliquots";
  SampleCreationType["Derivatives"] = "Derivatives";
  SampleCreationType["FromSources"] = "New samples from sources";
  SampleCreationType["Independents"] = "New samples";
  SampleCreationType["PooledSamples"] = "Pooled Samples";
  return SampleCreationType;
}({});
const INDEPENDENT_SAMPLE_CREATION = {
  type: SampleCreationType.Independents,
  description: 'Create samples.',
  minParentsPerSample: 0,
  quantityLabel: 'New Samples'
};
const CHILD_SAMPLE_CREATION = {
  type: SampleCreationType.FromSources,
  description: 'Create multiple output samples per source.',
  minParentsPerSample: 1,
  iconSrc: 'derivatives',
  quantityLabel: 'New Samples per Source'
};
const DERIVATIVE_CREATION = {
  type: SampleCreationType.Derivatives,
  description: 'Create multiple output samples per parent.',
  disabledDescription: 'Only one parent sample type is allowed when creating derivative samples.',
  minParentsPerSample: 1,
  iconSrc: 'derivatives',
  quantityLabel: 'Derivatives per Parent'
};
const POOLED_SAMPLE_CREATION = {
  type: SampleCreationType.PooledSamples,
  description: 'Put multiple samples into pooled outputs.',
  minParentsPerSample: 2,
  iconSrc: 'pooled',
  quantityLabel: 'New Samples per Parent Group'
};
const ALIQUOT_CREATION = {
  type: SampleCreationType.Aliquots,
  description: 'Create aliquot copies from each parent sample.',
  minParentsPerSample: 1,
  iconSrc: 'aliquots',
  quantityLabel: 'Aliquots per Parent'
};

// Note: this should stay in sync with the freezermanager/src/components/AddSamplesToStorageModal.tsx props

// Note: this should stay in sync with the freezermanager/src/components/StorageButton.tsx props

// Note: this should stay in sync with the workflow/src/Components/JobsButton.tsx props

// Note: this is meant to correspond to the JobsMenuOptions component in workflow/src/Components/JobsButton.tsx

// Note: this should stay in sync with the workflow/src/Components/WorkflowGrid.tsx props

class SampleState {
  constructor(values) {
    samples_models_defineProperty(this, external_immer_.immerable, true);
    samples_models_defineProperty(this, "rowId", void 0);
    samples_models_defineProperty(this, "label", void 0);
    samples_models_defineProperty(this, "description", void 0);
    samples_models_defineProperty(this, "stateType", void 0);
    samples_models_defineProperty(this, "publicData", void 0);
    samples_models_defineProperty(this, "inUse", void 0);
    samples_models_defineProperty(this, "isLocal", void 0);
    samples_models_defineProperty(this, "containerPath", void 0);
    samples_models_defineProperty(this, "color", void 0);
    Object.assign(this, values);
    if (this.publicData === undefined) {
      Object.assign(this, {
        publicData: false
      });
    }
  }
  set(name, value) {
    return this.mutate({
      [name]: value
    });
  }
  mutate(props) {
    return (0,external_immer_.produce)(this, draft => {
      Object.assign(draft, props);
    });
  }
  toSampleStatus() {
    return {
      description: this.description,
      label: this.label,
      color: this.color,
      statusType: SampleStateType[this.stateType]
    };
  }
}
;// CONCATENATED MODULE: ./src/internal/query/selectRows.ts
const selectRows_excluded = ["containerFilter", "columns", "includeMetadata", "includeTotalCount", "method", "schemaQuery"];
function selectRows_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function selectRows_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? selectRows_ownKeys(Object(t), !0).forEach(function (r) { selectRows_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : selectRows_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function selectRows_defineProperty(e, r, t) { return (r = selectRows_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function selectRows_toPropertyKey(t) { var i = selectRows_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function selectRows_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function selectRows_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = selectRows_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function selectRows_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }



async function selectRows(options) {
  const {
      containerFilter = getContainerFilter(options.containerPath),
      columns = '*',
      includeMetadata,
      includeTotalCount = false,
      // default to false to improve performance
      method = 'POST',
      schemaQuery
    } = options,
    selectRowsOptions = selectRows_objectWithoutProperties(options, selectRows_excluded);
  const {
    queryName,
    schemaName,
    viewName
  } = schemaQuery;
  const [queryInfo, response] = await Promise.all([getQueryDetails({
    containerPath: options.containerPath,
    schemaQuery
  }), new Promise((resolve, reject) => {
    api_.Query.selectRows(selectRows_objectSpread(selectRows_objectSpread({}, selectRowsOptions), {}, {
      columns,
      containerFilter,
      includeMetadata: isSelectRowMetadataRequired(includeMetadata, columns),
      includeTotalCount,
      method,
      queryName,
      requiredVersion: 17.1,
      schemaName,
      viewName,
      success: response_ => {
        resolve(response_);
      },
      failure: (data, request) => {
        console.error('There was a problem retrieving the data', data);
        reject({
          exceptionClass: data.exceptionClass,
          message: data.exception,
          schemaQuery,
          status: request.status
        });
      }
    }));
  })]);
  const resolved = new URLResolver().resolveSelectRows(response, queryInfo);
  return {
    messages: resolved.messages,
    queryInfo,
    rows: resolved.rows,
    rowCount: resolved.rowCount,
    schemaQuery
  };
}
;// CONCATENATED MODULE: ./src/internal/components/entities/utils.ts







function sampleDeleteDependencyText() {
  let deleteMsg = '';
  if (isWorkflowEnabled()) {
    if (isAssayEnabled()) {
      deleteMsg += 'either derived sample, job, or assay data dependencies, ';
    } else {
      deleteMsg += 'either derived sample or job dependencies, ';
    }
  } else {
    if (isAssayEnabled()) {
      deleteMsg += 'either derived sample or assay data dependencies, ';
    } else {
      deleteMsg += 'derived sample dependencies ';
    }
  }
  if (isELNEnabled()) {
    deleteMsg += 'status that prevents deletion, or references in one or more active notebooks';
  } else {
    deleteMsg += 'or status that prevents deletion';
  }
  return deleteMsg;
}
function getInitialParentChoices(parentTypeOptions, parentDataType, childData, parentIdData) {
  let parentValuesByType = (0,external_immutable_.Map)();
  if (Object.keys(childData).length > 0) {
    const inputs = childData[parentDataType.inputColumnName];
    if (inputs) {
      // group the inputs by parent type so we can show each in its own grid.
      inputs.forEach(inputRow => {
        const inputValue = inputRow.value;
        const typeValue = parentIdData[inputValue]?.parentId;
        const typeOption = parentTypeOptions.find(option => option[parentDataType.inputTypeValueField] === typeValue);
        if (!typeOption) {
          console.warn('Unable to find parent type.', typeValue);
        } else {
          if (!parentValuesByType.has(typeOption.query)) {
            parentValuesByType = parentValuesByType.set(typeOption.query, {
              type: typeOption,
              ids: [],
              value: undefined,
              gridValues: []
            });
          }
          const updatedChoice = parentValuesByType.get(typeOption.query);
          updatedChoice.ids.push(inputValue);
          // when using the data for an editable grid, we need the RowId/DisplayValue pairs
          if (parentIdData[inputValue]) {
            updatedChoice.gridValues.push({
              value: parentIdData[inputValue].rowId,
              displayValue: inputRow?.displayValue
            });
          }
          parentValuesByType = parentValuesByType.set(typeOption.query, updatedChoice);
        }
      });
    }
  }
  // having collected the values by type, create a list, sorted by the type label and return that.
  return parentValuesByType.sortBy(choice => choice.type.label, naturalSort).toList();
}
function getUniqueIdColumnMetadata(queryInfo) {
  let columnMetadata = (0,external_immutable_.Map)();
  queryInfo?.columns.filter(column => column.isUniqueIdColumn).forEach(column => {
    columnMetadata = columnMetadata.set(column.fieldKey, {
      readOnly: true,
      placeholder: '[generated value]',
      toolTip: `A unique value will be provided by ${getCurrentProductName()} for this field.`
    });
  });
  return columnMetadata;
}
function getEntityNoun(entityDataType, quantity) {
  return quantity === 1 ? entityDataType.nounSingular : entityDataType.nounPlural;
}
function getEntityDescription(entityDataType, quantity) {
  return quantity === 1 ? entityDataType.descriptionSingular : entityDataType.descriptionPlural;
}
function isSampleEntity(dataType) {
  return dataType.instanceSchemaName === SCHEMAS.SAMPLE_SETS.SCHEMA;
}
function isDataClassEntity(dataType) {
  return dataType.instanceSchemaName === SCHEMAS.DATA_CLASSES.SCHEMA;
}
function isAssayDesignEntity(dataType) {
  return dataType.instanceSchemaName === SCHEMAS.ASSAY_TABLES.SCHEMA;
}
function isAssayResultEntity(dataType) {
  return dataType.sampleFinderCardType === 'assaydata';
}
function getJobCreationHref(model, templateId, samplesIncluded, picklistName, isAssay, sampleFieldKey, currentProductId, targetProductId, ignoreFilter) {
  const params = getURLParamsForSampleSelectionKey(model, picklistName, isAssay, sampleFieldKey, ignoreFilter);
  if (templateId) params['templateId'] = templateId;
  if (!samplesIncluded) params['sampleTab'] = 'search'; // i.e. JOB_SAMPLE_SEARCH_TAB_ID

  const actionUrl = createProductUrlFromParts(targetProductId, currentProductId, params, WORKFLOW_KEY, 'new');
  return actionUrl instanceof AppURL ? actionUrl.toHref() : actionUrl;
}
;// CONCATENATED MODULE: ./src/internal/components/base/ServerContext.tsx
/*
 * Copyright (c) 2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




const Context = (0,external_react_.createContext)(undefined);
const ContextDispatch = (0,external_react_.createContext)(undefined);
const serverContextReducer = (state, payload) => {
  return Object.assign({}, state, payload);
};
const ServerContextProvider = ({
  children,
  initialContext
}) => {
  const [state, dispatch] = (0,external_react_.useReducer)(serverContextReducer, initialContext);
  return /*#__PURE__*/external_react_default().createElement(Context.Provider, {
    value: state
  }, /*#__PURE__*/external_react_default().createElement(ContextDispatch.Provider, {
    value: dispatch
  }, children));
};
const hasServerContext = () => {
  return !!(0,external_react_.useContext)(Context);
};
const useServerContext = () => {
  const context = (0,external_react_.useContext)(Context);
  if (context === undefined) {
    throw new Error('useServerContext must be used within a ServerContext.Provider');
  }
  return context;
};
const useServerContextDispatch = () => {
  const context = (0,external_react_.useContext)(ContextDispatch);
  if (context === undefined) {
    throw new Error('useServerContextDispatch must be used within a ServerContextDispatch.Provider');
  }
  return context;
};
const ServerContextConsumer = Context.Consumer;
const withAppUser = ctx => {
  return Object.assign({}, ctx, {
    container: new Container(ctx.container),
    user: new User(ctx.user)
  });
};

/**
 * Use this component wrapper for pages in LKS that need access to useServerContext.
 * @param Component the component you want to wrap
 */
function withServerContext(Component) {
  return props => {
    const initialServerContext = (0,external_react_.useMemo)(() => withAppUser((0,api_.getServerContext)()), []);
    return /*#__PURE__*/external_react_default().createElement(ServerContextProvider, {
      initialContext: initialServerContext
    }, /*#__PURE__*/external_react_default().createElement(Component, props));
  };
}
;// CONCATENATED MODULE: ./src/internal/util/helpLinks.tsx




const CHART_MEASURES_AND_DIMENSIONS_TOPIC = 'chartTrouble';
const MISSING_VALUES_TOPIC = 'manageMissing';
const PROPERTY_FIELDS_PHI_TOPIC = 'phiLevels';
const PROPERTY_FIELDS_TOPIC = 'propertyFields';
const FIELD_EDITOR_TOPIC = 'fieldEditor';
const ADVANCED_FIELD_EDITOR_TOPIC = FIELD_EDITOR_TOPIC + '#advanced';
const FIELD_EDITOR_SAMPLE_TYPES_TOPIC = PROPERTY_FIELDS_TOPIC + '#samp';
const DATE_FORMATS_TOPIC = 'dateFormats#date';
const NUMBER_FORMATS_TOPIC = 'dateFormats#number';
const ONTOLOGY_LOOKUP_TOPIC = 'ontologyLookup';
const ONTOLOGY_CONCEPT_TOPIC = 'ontologyConcept';
const LABKEY_SQL_TOPIC = 'labkeysql';
const ASSAY_EDIT_PLATE_TEMPLATE_TOPIC = 'editPlateTemplate';
const CONFIGURE_SCRIPTING_TOPIC = 'configureScripting';
const PROGRAMMATIC_QC_TOPIC = 'programmaticQC';
const RUN_PROPERTIES_TOPIC = 'runProperties';
const DEFINE_ASSAY_SCHEMA_TOPIC = 'defineAssaySchema';
const DELETE_ASSAY_RUNS_TOPIC = 'manageAssayData#deleteRun';
const DEFINE_DATA_CLASS_TOPIC = 'createDataClass';
const DATA_CLASS_NAME_EXPRESSION_TOPIC = 'dataClass#name';
const DEFINE_SAMPLE_TYPE_TOPIC = 'createSampleSet';
const DEFINE_LIST_TOPIC = 'createListOptions';
const DEFINE_ISSUES_LIST_TOPIC = 'adminIssues';
const DEFINE_DATASET_TOPIC = 'createDataset';
const DATASET_PROPERTIES_TOPIC = 'datasetProperties#advanced';
const MOVE_SAMPLES_TOPIC = 'viewSampleSets#move';
const DELETE_SAMPLES_TOPIC = 'viewSampleSets#delete';
const DERIVE_SAMPLES_TOPIC = 'deriveSamples';
const DERIVE_SAMPLES_ALIAS_TOPIC = DERIVE_SAMPLES_TOPIC + '#alias';
const DATACLASS_ALIAS_TOPIC = 'dataclassalias';
const URL_ENCODING_TOPIC = 'urlEncoding';
const SEARCH_SYNTAX_TOPIC = 'luceneSearch';
const DATA_IMPORT_TOPIC = 'dataImport';
const SAMPLE_IMPORT_TOPIC = 'importSamples';
const SAMPLE_ALIQUOT_FIELDS_TOPIC = 'createSampleType#ali';
const LKS_SAMPLE_ALIQUOT_FIELDS_TOPIC = 'generateSamples#fields';
const UNIQUE_IDS_TOPIC = 'uniqueStorageIds';
const CUSTOM_VIEW = 'customViews';
const HELP_LINK_DEFAULT_URL = 'https://www.labkey.org/Documentation/wiki-page.view?';

// See HelpTopic.java Referrer enum
let HELP_LINK_REFERRER = /*#__PURE__*/function (HELP_LINK_REFERRER) {
  HELP_LINK_REFERRER["DEV_MENU"] = "devMenu";
  HELP_LINK_REFERRER["DOC_MENU"] = "docMenu";
  HELP_LINK_REFERRER["ERROR_PAGE"] = "errorPage";
  HELP_LINK_REFERRER["IN_PAGE"] = "inPage";
  HELP_LINK_REFERRER["PRODUCT_MENU"] = "productMenu";
  return HELP_LINK_REFERRER;
}({});
function getHelpLink(topic, referrer = HELP_LINK_REFERRER.IN_PAGE, useDefaultUrl = false, helpLinkPrefix) {
  const prefix = helpLinkPrefix ?? (0,api_.getServerContext)().helpLinkPrefix;
  if (useDefaultUrl) {
    return HELP_LINK_DEFAULT_URL + 'referrer=' + referrer + '&name=' + topic;
  } else if (prefix) {
    // putting referrer= at the end causes links that go to anchors in the page not to work.
    return prefix.replace('name=', 'referrer=' + referrer + '&name=' + topic);
  }
  return undefined;
}
const HelpLink = props => {
  const {
    moduleContext
  } = useServerContext();
  const {
    useBaseAppUrl,
    className,
    topic,
    referrer,
    children,
    useDefaultUrl
  } = props;
  return /*#__PURE__*/external_react_default().createElement("a", {
    target: "_blank",
    href: getHelpLink(topic, referrer, useDefaultUrl, useBaseAppUrl ? getPrimaryAppProperties(moduleContext)?.baseProductHelpLinkPrefix : undefined),
    className: className,
    rel: "noopener noreferrer"
  }, children);
};

/**
 * @deprecated use <HelpLink>
 */
function helpLinkNode(topic, text, className) {
  return /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: topic,
    className: className
  }, text);
}
const JavaDocsLink = (0,external_react_.memo)(props => {
  const {
    urlSuffix,
    children
  } = props;
  const {
    jdkJavaDocLinkPrefix
  } = (0,api_.getServerContext)();
  return /*#__PURE__*/external_react_default().createElement("a", {
    target: "_blank",
    href: jdkJavaDocLinkPrefix + urlSuffix,
    rel: "noopener noreferrer"
  }, children);
});
;// CONCATENATED MODULE: ./src/internal/components/search/constants.ts
let SearchCategory = /*#__PURE__*/function (SearchCategory) {
  SearchCategory["Assay"] = "assay";
  SearchCategory["AssayBatch"] = "assayBatch";
  SearchCategory["AssayRun"] = "assayRun";
  SearchCategory["Concept"] = "concept";
  SearchCategory["Data"] = "data";
  SearchCategory["DataClass"] = "dataClass";
  SearchCategory["File"] = "file";
  SearchCategory["FileWorkflowJob"] = "fileWorkflowJob";
  SearchCategory["Material"] = "material";
  SearchCategory["MaterialSource"] = "materialSource";
  SearchCategory["Media"] = "media";
  SearchCategory["MediaData"] = "mediaData";
  SearchCategory["Notebook"] = "notebook";
  SearchCategory["NotebookTemplate"] = "notebookTemplate";
  SearchCategory["Plate"] = "plate";
  SearchCategory["StorageLocation"] = "storageLocation";
  SearchCategory["TerminalStorageLocation"] = "terminalStorageLocation";
  SearchCategory["WorkflowJob"] = "workflowJob";
  return SearchCategory;
}({});
let SearchField = /*#__PURE__*/function (SearchField) {
  SearchField["Body"] = "body";
  SearchField["IdentifiersHi"] = "identifiersHi";
  SearchField["IdentifiersLo"] = "identifiersLo";
  SearchField["IdentifiersMed"] = "identifiersMed";
  SearchField["KeywordsHi"] = "keywordsHi";
  SearchField["KeywordsLo"] = "keywordsLo";
  SearchField["KeywordsMed"] = "keywordsMed";
  return SearchField;
}({});
let SearchScope = /*#__PURE__*/function (SearchScope) {
  SearchScope["All"] = "All";
  SearchScope["Folder"] = "Folder";
  SearchScope["FolderAndProject"] = "FolderAndProject";
  SearchScope["FolderAndProjectAndShared"] = "FolderAndProjectAndShared";
  SearchScope["FolderAndShared"] = "FolderAndShared";
  SearchScope["FolderAndSubfolders"] = "FolderAndSubfolders";
  SearchScope["FolderAndSubfoldersAndShared"] = "FolderAndSubfoldersAndShared";
  SearchScope["Project"] = "Project";
  SearchScope["ProjectAndShared"] = "ProjectAndShared";
  return SearchScope;
}({});
const SAMPLE_PROPERTY_ALL_SAMPLE_TYPE = {
  value: '~~allsampletypes~~',
  query: '~~allsampletypes~~',
  label: 'All Sample Types'
};
const SEARCH_HELP_TOPIC = 'luceneSearch';
const SEARCH_PAGE_DEFAULT_SIZE = 20;
;// CONCATENATED MODULE: ./src/internal/components/entities/constants.ts








const DATA_OPERATION_CONFIRMATION_ACTION = 'getDataOperationConfirmationData.api';
const SAMPLE_OPERATION_CONFIRMATION_ACTION = 'getMaterialOperationConfirmationData.api';
const ASSAY_RUN_OPERATION_CONFIRMATION_ACTION = 'getAssayRunOperationConfirmationData.api';
const ASSAY_RESULTS_OPERATION_CONFIRMATION_ACTION = 'getAssayResultsOperationConfirmationData.api';
const AssayRunDataType = {
  deleteHelpLinkTopic: DELETE_ASSAY_RUNS_TOPIC,
  typeListingSchemaQuery: SCHEMAS.ASSAY_TABLES.ASSAY_LIST,
  listingSchemaQuery: SCHEMAS.EXP_TABLES.ASSAY_RUNS,
  instanceSchemaName: SCHEMAS.ASSAY_TABLES.SCHEMA,
  operationConfirmationControllerName: 'assay',
  operationConfirmationActionName: ASSAY_RUN_OPERATION_CONFIRMATION_ACTION,
  nounSingular: 'run',
  nounPlural: 'runs',
  typeNounSingular: 'Assay Design',
  typeNounAsParentSingular: 'Assay Design',
  nounAsParentPlural: 'Assay Runs',
  nounAsParentSingular: 'Assay Run',
  descriptionSingular: 'assay run',
  descriptionPlural: 'assay runs',
  uniqueFieldKey: 'RowId',
  dependencyText: undefined,
  projectConfigurableDataType: 'AssayDesign'
};
const AssayResultDataType = {
  deleteHelpLinkTopic: undefined,
  typeListingSchemaQuery: SCHEMAS.ASSAY_TABLES.ASSAY_LIST,
  listingSchemaQuery: undefined,
  instanceSchemaName: undefined,
  supportHasNoValueInQuery: true,
  getInstanceSchemaQuery: assayName => {
    return new SchemaQuery('assay.General.' + assayName, 'data');
  },
  getInstanceDataType: schemaQuery => {
    return schemaQuery.schemaName.replace('assay.General.', '');
  },
  operationConfirmationControllerName: 'assay',
  operationConfirmationActionName: ASSAY_RESULTS_OPERATION_CONFIRMATION_ACTION,
  nounSingular: 'result',
  nounPlural: 'results',
  typeNounSingular: 'Assay Design',
  typeNounAsParentSingular: 'Assay Design',
  nounAsParentPlural: 'Assays',
  // use short label for Sample Finder
  nounAsParentSingular: 'Assay',
  descriptionSingular: 'assay result',
  descriptionPlural: 'assay results',
  uniqueFieldKey: 'RowId',
  dependencyText: undefined,
  filterCardHeaderClass: 'filter-card__header-purple',
  sampleFinderCardType: 'assaydata',
  projectConfigurableDataType: 'AssayDesign'
};
let AssayRunOperation = /*#__PURE__*/function (AssayRunOperation) {
  AssayRunOperation[AssayRunOperation["Delete"] = 0] = "Delete";
  AssayRunOperation[AssayRunOperation["Edit"] = 1] = "Edit";
  AssayRunOperation[AssayRunOperation["Move"] = 2] = "Move";
  return AssayRunOperation;
}({});
const SamplePropertyDataType = {
  allowSingleParentTypeFilter: true,
  allowRelativeDateFilter: true,
  typeListingSchemaQuery: SCHEMAS.EXP_TABLES.SAMPLE_SETS,
  listingSchemaQuery: undefined,
  instanceSchemaName: undefined,
  getInstanceSchemaQuery: queryName => {
    if (queryName === SAMPLE_PROPERTY_ALL_SAMPLE_TYPE.query) return SCHEMAS.EXP_TABLES.MATERIALS;
    return new SchemaQuery('samples', queryName);
  },
  getInstanceDataType: (schemaQuery, altQueryName) => {
    return altQueryName ?? schemaQuery.queryName;
  },
  operationConfirmationControllerName: 'experiment',
  operationConfirmationActionName: undefined,
  nounSingular: 'sample',
  nounPlural: 'samples',
  nounAsParentSingular: 'Sample',
  nounAsParentPlural: 'Samples',
  typeNounSingular: 'Sample Type',
  typeNounAsParentSingular: 'Sample Type',
  descriptionSingular: 'sample type',
  descriptionPlural: 'sample types',
  uniqueFieldKey: 'Name',
  dependencyText: undefined,
  deleteHelpLinkTopic: DELETE_SAMPLES_TOPIC,
  filterCardHeaderClass: 'filter-card__header-orange',
  sampleFinderCardType: 'sampleproperty',
  projectConfigurableDataType: 'SampleType'
};
const SampleTypeDataType = {
  typeListingSchemaQuery: SCHEMAS.EXP_TABLES.SAMPLE_SETS,
  listingSchemaQuery: SCHEMAS.EXP_TABLES.MATERIALS,
  instanceKey: SAMPLES_KEY,
  instanceSchemaName: SCHEMAS.SAMPLE_SETS.SCHEMA,
  appUrlPrefixParts: ['samples'],
  operationConfirmationControllerName: 'experiment',
  operationConfirmationActionName: SAMPLE_OPERATION_CONFIRMATION_ACTION,
  moveNoun: 'samples',
  nounSingular: 'sample',
  nounPlural: 'samples',
  nounAsParentSingular: 'Parent',
  nounAsParentPlural: 'Parents',
  typeNounSingular: 'Sample Type',
  typeNounAsParentSingular: 'Parent Type',
  descriptionSingular: 'parent sample type',
  descriptionPlural: 'parent sample types',
  uniqueFieldKey: 'Name',
  dependencyText: sampleDeleteDependencyText,
  deleteHelpLinkTopic: DELETE_SAMPLES_TOPIC,
  inputColumnName: 'Inputs/Materials/First',
  ancestorColumnName: 'Ancestors/Samples',
  inputTypeValueField: 'lsid',
  insertColumnNamePrefix: 'MaterialInputs/',
  editTypeAppUrlPrefix: SAMPLE_TYPE_KEY,
  importFileAction: 'importSamples',
  filterCardHeaderClass: 'filter-card__header-success',
  exprColumnsWithSubSelect: SAMPLE_STORAGE_COLUMNS_WITH_SUBSELECT_EXPR,
  typeIcon: 'sample_set',
  sampleFinderCardType: 'sampleparent',
  supportsCrossTypeImport: true,
  projectConfigurableDataType: 'SampleType',
  labelColorCol: 'labelcolor'
};
const DataClassDataType = {
  typeListingSchemaQuery: SCHEMAS.EXP_TABLES.DATA_CLASSES,
  listingSchemaQuery: SCHEMAS.EXP_TABLES.DATA,
  instanceSchemaName: SCHEMAS.DATA_CLASSES.SCHEMA,
  operationConfirmationControllerName: 'experiment',
  operationConfirmationActionName: DATA_OPERATION_CONFIRMATION_ACTION,
  moveNoun: 'sources',
  nounSingular: 'source',
  nounPlural: 'sources',
  typeNounSingular: 'Data Type',
  typeNounAsParentSingular: 'Data Type',
  nounAsParentPlural: 'Data Types',
  nounAsParentSingular: 'Parent',
  descriptionSingular: 'parent type',
  descriptionPlural: 'parent types',
  uniqueFieldKey: 'Name',
  dependencyText: 'derived data or sample dependencies',
  deleteHelpLinkTopic: 'dataClass#prevent',
  inputColumnName: 'Inputs/Data/First',
  ancestorColumnName: 'Ancestors/OtherData',
  inputTypeValueField: 'rowId',
  insertColumnNamePrefix: 'DataInputs/',
  importFileAction: 'importData',
  filterCardHeaderClass: 'filter-card__header-primary',
  typeIcon: 'source_type',
  sampleFinderCardType: 'dataclassparent',
  projectConfigurableDataType: 'DataClass'
};
const ParentEntityLineageColumns = external_immutable_.List.of('Inputs/Materials/First', 'Inputs/Data/First');
const ParentEntityRequiredColumns = SCHEMAS.CBMB.concat('LSID', 'Name', 'Folder', 'RowId', 'Description', 'AliquotedFromLSID/Name', 'RootMaterialRowId', 'RootMaterialRowId/Name', 'RootMaterialRowId/Description').concat(ParentEntityLineageColumns);
let DataOperation = /*#__PURE__*/function (DataOperation) {
  DataOperation[DataOperation["Edit"] = 0] = "Edit";
  DataOperation[DataOperation["EditLineage"] = 1] = "EditLineage";
  DataOperation[DataOperation["Delete"] = 2] = "Delete";
  DataOperation[DataOperation["Move"] = 3] = "Move";
  return DataOperation;
}({});
const SAMPLE_SET_IMPORT_PREFIX = 'materialInputs/';
const DATA_CLASS_IMPORT_PREFIX = 'dataInputs/';
;// CONCATENATED MODULE: ./src/internal/components/entities/models.ts
function entities_models_defineProperty(e, r, t) { return (r = entities_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function entities_models_toPropertyKey(t) { var i = entities_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function entities_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











// the set of options for selecting a type (e.g., the list of sample types).
// {
//     value:   'Sample Type 1',
//     label:   'Sample Type 1',
//     schema:  'samples',
//     query:  'Sample Type 1'
// }
// capturing the schema name (e.g., samples) and query name (e.g., SampleSet1)
// that can be used to retrieve the set of fields defined for that type and/or
// the list of values (e.g., S-123, S-234) that can be chosen as actual parents.
// Needs(?) to extend SelectInputOption for use in ReactSelects, but otherwise very much
// a duplicate of EntityParentType (modulo the value being a DisplayObject vs TValue)

class EntityParentType extends (0,external_immutable_.Record)({
  index: undefined,
  key: undefined,
  query: undefined,
  schema: undefined,
  value: undefined,
  isParentTypeOnly: false,
  isAliquotParent: false
}) {
  static create(values) {
    if (!values.key) values.key = generateId('parent-type-');
    return new EntityParentType(values);
  }
  createColumnName() {
    const parentInputType = this.getInputType();
    if (parentInputType === QueryColumn.ALIQUOTED_FROM) return QueryColumn.ALIQUOTED_FROM;
    const formattedQueryName = capitalizeFirstChar(this.query);
    // Issue 33653: query name is case-sensitive for some data inputs (sample parents), so leave it
    // capitalized here and we lower it where needed
    return [parentInputType, formattedQueryName].join('/');
  }
  getInputType() {
    if (this.schema === SCHEMAS.DATA_CLASSES.SCHEMA) return QueryColumn.DATA_INPUTS;
    return this.isAliquotParent ? QueryColumn.ALIQUOTED_FROM : QueryColumn.MATERIAL_INPUTS;
  }
  generateFieldKey() {
    const parentInputType = this.getInputType();
    const formattedQueryName = capitalizeFirstChar(this.query);

    // Issue 33653: query name is case-sensitive for some data inputs (sample parents), so leave it
    // capitalized here and we lower it where needed
    return this.isAliquotParent ? QueryColumn.ALIQUOTED_FROM : [encodePart(parentInputType), encodePart(formattedQueryName)].join('/');
  }

  // TODO: We should stop generating this on the client and retrieve the actual ColumnInfo from the server
  generateColumn(displayColumn, targetSchema) {
    const parentInputType = this.getInputType();
    const formattedQueryName = capitalizeFirstChar(this.query);
    const parentColName = this.generateFieldKey();

    // Issue 40233: SM app allows for two types of parents, sources and samples, and its confusing if both use
    // the "Parents" suffix in the editable grid header.
    // To make this work with Biologics, only add Parents if target and parent are the same type (sample or data class)
    const captionSuffix = this.schema === targetSchema ? ' Parents' : '';

    // 32671: Sample import and edit grid key ingredients on scientific name
    if (this.schema && this.query && this.schema.toLowerCase() === SCHEMAS.DATA_CLASSES.INGREDIENTS.schemaName.toLowerCase() && this.query.toLowerCase() === SCHEMAS.DATA_CLASSES.INGREDIENTS.queryName.toLowerCase()) {
      displayColumn = 'scientificName';
    }
    return new QueryColumn({
      caption: this.isAliquotParent ? QueryColumn.ALIQUOTED_FROM_CAPTION : formattedQueryName + captionSuffix,
      description: this.isAliquotParent ? 'The parent sample of the aliquot' : 'Contains optional parent entity for this ' + formattedQueryName,
      fieldKeyArray: [parentColName],
      fieldKey: parentColName,
      lookup: new QueryLookup({
        displayColumn,
        isPublic: true,
        keyColumn: 'RowId',
        multiValued: this.isAliquotParent ? undefined : 'junction',
        queryName: this.query,
        schemaName: this.schema,
        viewName: ViewInfo.DETAIL_NAME // use the details view to assure we see values even if default view is filtered
      }),
      name: parentColName,
      required: this.isAliquotParent,
      shownInInsertView: true,
      shownInUpdateView: true,
      type: 'Text (String)',
      userEditable: true
    });
  }
}

// represents a chosen entity type (e.g., Sample Set 1)

class EntityTypeOption {
  constructor(props) {
    entities_models_defineProperty(this, "label", void 0);
    entities_models_defineProperty(this, "lsid", void 0);
    entities_models_defineProperty(this, "rowId", void 0);
    entities_models_defineProperty(this, "value", void 0);
    entities_models_defineProperty(this, "entityDataType", void 0);
    entities_models_defineProperty(this, "isFromSharedContainer", void 0);
    if (props) {
      for (const k in props) {
        this[k] = props[k];
      }
    }
  }
}

// represents an entity type (e.g., Sample Type 1) and the values chosen of that type (e.g., S-1, S-2)

class EntityIdCreationModel extends (0,external_immutable_.Record)({
  errors: undefined,
  initialEntityType: undefined,
  isError: false,
  isInit: false,
  originalParents: Array(),
  parentOptions: (0,external_immutable_.Map)(),
  entityParents: (0,external_immutable_.Map)(),
  entityTypeOptions: (0,external_immutable_.List)(),
  selectionKey: undefined,
  isSnapshotSelection: false,
  targetEntityType: undefined,
  entityCount: 0,
  entityDataType: undefined,
  creationType: undefined,
  numPerParent: 1
}) {
  // taken from the query string
  // map from query name to the options for the different types of parents allowed
  // map from query name to the parents already selected for that query
  // the target type options

  // the target entity Type
  // how many rows are in the grid
  // target entity data type

  static revertParentInputSchema(inputColumn) {
    if (inputColumn.isExpInput()) {
      const fieldKey = inputColumn.fieldKey.toLowerCase().split('/');
      if (fieldKey.length === 2) {
        let schemaName;
        if (fieldKey[0] === QueryColumn.DATA_INPUTS.toLowerCase()) {
          schemaName = SCHEMAS.DATA_CLASSES.SCHEMA;
        } else if (fieldKey[0] === QueryColumn.MATERIAL_INPUTS.toLowerCase()) {
          schemaName = SCHEMAS.SAMPLE_SETS.SCHEMA;
        } else {
          throw new Error('Invalid inputColumn fieldKey. "' + fieldKey[0] + '"');
        }
        return new SchemaQuery(decodePart(schemaName), decodePart(fieldKey[1]));
      }
      throw new Error('invalid inputColumn fieldKey length.');
    }
    throw new Error('Invalid inputColumn.');
  }
  static getEmptyEntityParents(queryNames) {
    let entityParents = (0,external_immutable_.Map)();
    queryNames.forEach(queryName => {
      entityParents = entityParents.set(queryName, (0,external_immutable_.List)());
    });
    return entityParents;
  }
  getClearedEntityParents() {
    return this.entityParents.reduce((clearedParents, parents, key) => {
      return clearedParents.set(key, (0,external_immutable_.List)());
    }, (0,external_immutable_.Map)());
  }
  getParentColumns(uniqueFieldKey) {
    let columns = new ExtendedMap();
    const targetSchema = this.getSchemaQuery().schemaName;
    this.entityParents.forEach(parentList => {
      parentList.forEach(parent => {
        if (parent.schema && parent.query) {
          const column = parent.generateColumn(uniqueFieldKey, targetSchema);
          // Issue 33653: query name is case-sensitive for some data inputs (parents)
          columns = columns.set(column.name.toLowerCase(), column);
        }
      });
    });
    return columns;
  }
  hasTargetEntityType() {
    return this.targetEntityType && this.targetEntityType.value !== undefined;
  }
  getTargetEntityTypeId() {
    return this.hasTargetEntityType() ? this.targetEntityType.rowId : undefined;
  }
  getTargetEntityTypeValue() {
    return this.hasTargetEntityType() ? this.targetEntityType.value : undefined;
  }
  getTargetEntityTypeLabel() {
    return this.hasTargetEntityType() ? this.targetEntityType.label : undefined;
  }
  isFromSharedContainer() {
    return this.hasTargetEntityType() ? this.targetEntityType.isFromSharedContainer : false;
  }
  getParentCount() {
    return this.entityParents.reduce((count, parentList) => {
      return count + parentList.filter(parent => parent.query !== undefined).count();
    }, 0);
  }
  getEntityInputs() {
    const dataInputs = [];
    this.entityParents.get(SCHEMAS.EXP_TABLES.DATA_CLASSES.queryName).forEach(parent => {
      const role = 'data';
      parent.value.forEach(option => {
        const rowId = parseInt(option.value);
        if (!isNaN(rowId)) {
          dataInputs.push({
            role,
            rowId
          });
        } else {
          console.warn('Unable to parse rowId from "' + option.value + '" for ' + role + '.');
        }
      });
    });
    const materialInputs = [];
    this.entityParents.get(SCHEMAS.EXP_TABLES.SAMPLE_SETS.queryName).forEach(parent => {
      const role = 'sample';
      parent.value.forEach(option => {
        const rowId = parseInt(option.value);
        if (!isNaN(rowId)) {
          materialInputs.push({
            role,
            rowId
          });
        } else {
          console.warn('Unable to parse rowId from "' + option.value + '" for ' + role + '.');
        }
      });
    });
    return {
      dataInputs,
      materialInputs
    };
  }
  getSaveValues() {
    const {
      dataInputs,
      materialInputs
    } = this.getEntityInputs();
    return {
      dataInputs,
      materialDefault: {},
      materialInputs,
      targetType: this.targetEntityType.lsid
    };
  }
  getSchemaQuery() {
    const entityTypeName = this.getTargetEntityTypeValue();
    return entityTypeName ? new SchemaQuery(this.entityDataType.instanceSchemaName, entityTypeName) : undefined;
  }
  postEntityGrid(api, dataModel, editorModel, containerPath, extraColumnsToInclude, auditUserComment) {
    const rows = editorModel.getRawDataFromModel(dataModel, false, false).valueSeq().reduce((rows_, row) => {
      let map = row.toMap();
      extraColumnsToInclude?.forEach(col => {
        map = map.set(col.name, undefined);
      });
      rows_ = rows_.push(map);
      return rows_;
    }, (0,external_immutable_.List)());
    return api.query.insertRows({
      auditBehavior: api_.AuditBehaviorTypes.DETAILED,
      auditUserComment,
      fillEmptyFields: true,
      rows,
      schemaQuery: this.getSchemaQuery(),
      containerPath
    });
  }
  getGridValues(queryInfo, separateParents) {
    let data = (0,external_immutable_.List)();
    const parentCols = [];
    let values = (0,external_immutable_.Map)();
    if (this.entityCount > 0) {
      queryInfo.getInsertColumns().forEach(col => {
        const colName = col.name;
        let selected;
        if (col.isExpInput() && this.creationType !== SampleCreationType.Aliquots) {
          // Convert parent values into appropriate column names
          const sq = EntityIdCreationModel.revertParentInputSchema(col);

          // should be only one parent with the matching schema and query name
          selected = this.entityParents.reduce((found, parentList) => {
            return found || parentList.find(parent => parent.schema === sq.schemaName && parent.query === sq.queryName);
          }, undefined);
        } else if (col.isAliquotParent() && this.creationType === SampleCreationType.Aliquots) {
          selected = this.entityParents.reduce((found, parentList) => {
            return found || parentList.find(parent => parent.isAliquotParent);
          }, undefined);
        }
        if (selected && selected.value) {
          values = values.set(colName, selected.value);
          parentCols.push(colName);
        }
      });
      if (separateParents && this.creationType && this.creationType != SampleCreationType.PooledSamples) {
        parentCols.forEach(parentCol => {
          const parents = values.get(parentCol);
          parents.forEach(parent => {
            let singleParentValues = (0,external_immutable_.Map)();
            singleParentValues = singleParentValues.set(parentCol, (0,external_immutable_.List)([parent]));
            for (let c = 0; c < this.numPerParent; c++) {
              data = data.push(singleParentValues);
            }
          });
        });
      } else {
        for (let c = 0; c < this.numPerParent; c++) {
          data = data.push(values);
        }
      }
    }
    return data.toOrderedMap();
  }
}

/**
 *  Avoid inline comment or above line comments for properties due to es-lint's limitation on moving comments:
 *  https://github.com/import-js/eslint-plugin-import/issues/1723
 *
 *     allowSingleParentTypeFilter?: boolean; // Can filter by max of one parent of this type
 *     allowRelativeDateFilter?: boolean; // if filtering by +-Xd is allowed
 *     ancestorColumnName: string; // used for extracting or querying for the ancestores of this type
 *     appUrlPrefixParts?: string[]; // the prefix used for creating links to this type in the application
 *     deleteHelpLinkTopic: string; // help topic for finding out more about dependencies and deletion
 *     dependencyText: string; // text describing the dependencies that may prevent the entity from being deleted (e.g., 'derived sample or assay data dependencies')
 *     descriptionSingular: string; // (e.g., parent sample type) used in EntityInsertPanel for a message about how many of these types are available
 *     editTypeAppUrlPrefix?: string; // the app url route prefix for the edit design page for the given data type
 *     exprColumnsWithSubSelect?: string[]; // A list of fields that are backed by ExprColumn and the ExprColumn's sql contain sub select clauses
 *     filterArray?: Filter.IFilter[]; // A list of filters to use when selecting the set of values
 *     filterCardHeaderClass?: string; // css class to use for styling the header in the display of cards for Sample Finder
 *     getInstanceDataType?: (schemaQuery: SchemaQuery, altQueryName?: string) => string; // used for data type with non-standard type name. for example, get assay design name from assay schemaQuery, or use altQueryName for special queries such as ~~allsampletypes~~
 *     getInstanceSchemaQuery?: (datatype?: string) => SchemaQuery; // used for data type with non-standard type name. for example, get assay schemaQuery from assay design name
 *     importFileAction: string; // the action in the 'experiment' controller to use for file import for the given data type
 *     importFileController?: string; // the controller to use for file import for the given data type. 'experiment' if not provided
 *     inputColumnName: string; // used for extracting or querying for the parents of this type
 *     insertColumnNamePrefix: string; // when updating this value as an input, the name of that column (e.g, MaterialInputs)
 *     instanceSchemaName: string; // (e.g., samples) Name of the schema associated with an individual instance that can be used in conjunction with a name returned from the typeListingSchemaQuery listing
 *     isFromSharedContainer?: boolean; // if the data type is defined in /Shared project
 *     listingSchemaQuery: SchemaQuery; // The schema query used to get the listing of all of the data instances (e.g., all the data class rows) available
 *     operationConfirmationActionName: string; // action in operationConfirmationControllerName used to get the confirmation data for performing operations on entities
 *     typeListingSchemaQuery: SchemaQuery; // The schema query used to get the listing of all of the data type instances (e.g., all the data classes) available
 *     projectConfigurableDataType?: string; // the DataTypeExclusion type
 */

class OperationConfirmationData {
  constructor(values, idField = 'rowId') {
    entities_models_defineProperty(this, external_immer_.immerable, void 0);
    entities_models_defineProperty(this, "allowed", void 0);
    entities_models_defineProperty(this, "containers", void 0);
    entities_models_defineProperty(this, "notAllowed", void 0);
    entities_models_defineProperty(this, "notPermitted", void 0);
    // could intersect both allowed and notAllowed
    entities_models_defineProperty(this, "idMap", void 0);
    entities_models_defineProperty(this, "totalActionable", void 0);
    entities_models_defineProperty(this, "totalNotActionable", void 0);
    Object.assign(this, values);
    const idMap = {};
    if (values?.allowed) {
      values.allowed.forEach(allowed => {
        idMap[caseInsensitive(allowed, idField)] = true;
      });
    } else {
      Object.assign(this, {
        allowed: []
      });
    }
    if (values?.notAllowed) {
      values.notAllowed.forEach(notAllowed => {
        idMap[caseInsensitive(notAllowed, idField)] = false;
      });
    } else {
      Object.assign(this, {
        notAllowed: []
      });
    }
    if (values?.notPermitted) {
      values.notPermitted.forEach(npRow => {
        idMap[caseInsensitive(npRow, idField)] = false;
      });
    } else {
      Object.assign(this, {
        notPermitted: []
      });
    }
    Object.assign(this, {
      idMap,
      totalActionable: Object.values(idMap).filter(v => v === true).length,
      totalNotActionable: Object.values(idMap).filter(v => v === false).length
    });
  }
  isIdActionable(id) {
    const idNum = typeof id === 'string' ? parseInt(id, 10) : id;
    return this.idMap[idNum];
  }
  getActionableIds(idField = 'rowId') {
    return this.allowed.map(a => {
      return caseInsensitive(a, idField);
    }).filter(id => this.isIdActionable(id));
  }
  get allActionable() {
    return this.totalNotActionable === 0;
  }

  // Note that this returns false if there are no samples represented since we generally want
  // noneActionable to mean there are some samples but none can be acted upon.
  get noneActionable() {
    return this.allowed.length === 0 && (this.notAllowed.length > 0 || this.notPermitted.length > 0);
  }
  get anyActionable() {
    return this.totalActionable > 0;
  }
  get totalCount() {
    return this.allowed.length + this.notAllowed.length;
  }
  get anyNotActionable() {
    return this.totalNotActionable > 0;
  }
  getContainerPaths(permittedOnly = true) {
    return this.containers?.filter(c => !permittedOnly || c.permitted).map(c => c.id) ?? [];
  }
}
;// CONCATENATED MODULE: ./src/internal/components/entities/actions.ts
const actions_excluded = ["entityDataType", "rowIds"];
function actions_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = actions_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function actions_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function entities_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function entities_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? entities_actions_ownKeys(Object(t), !0).forEach(function (r) { entities_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : entities_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function entities_actions_defineProperty(e, r, t) { return (r = entities_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function entities_actions_toPropertyKey(t) { var i = entities_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function entities_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





















async function getOperationConfirmationData(dataType, rowIds, selectionKey, useSnapshotSelection, extraParams, containerPath) {
  if (!selectionKey && !rowIds?.length) {
    return new OperationConfirmationData();
  }
  return new Promise((resolve, reject) => {
    let params;
    if (selectionKey) {
      params = {
        dataRegionSelectionKey: selectionKey
      };
      if (useSnapshotSelection) {
        params.useSnapshotSelection = true;
      }
    } else {
      params = {
        rowIds
      };
    }
    if (extraParams) {
      params = Object.assign(params, extraParams);
    }
    return api_.Ajax.request({
      url: api_.ActionURL.buildURL(dataType.operationConfirmationControllerName, dataType.operationConfirmationActionName, containerPath),
      method: 'POST',
      jsonData: params,
      success: api_.Utils.getCallbackWrapper(async response => {
        if (response.success) {
          resolve(new OperationConfirmationData(response.data));
        } else {
          console.error('Response failure when getting operation confirmation data', response.exception);
          reject(response.exception);
        }
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error('Error getting operation confirmation data', response);
        reject(response ? response.exception : 'Unknown error getting operation confirmation data.');
      })
    });
  });
}
function getContainersForPermission(permission) {
  return new Promise((resolve, reject) => {
    api_.Security.getContainers({
      containerPath: getAppHomeFolderPath((0,api_.getServerContext)().container),
      includeStandardProperties: false,
      includeSubfolders: true,
      success: container => {
        const results = [];
        if (container.effectivePermissions.indexOf(permission) > -1) {
          results.push(container.id);
        }
        container.children.forEach(c => {
          if (c.effectivePermissions.indexOf(permission) > -1) {
            results.push(c.id);
          }
        });
        resolve(results);
      },
      failure: error => {
        console.error('Failed to fetch containers.', error);
        reject(error);
      }
    });
  });
}
function getDeleteConfirmationData(options) {
  const {
    containerPath,
    dataType,
    rowIds,
    schemaQuery
  } = options;
  if (isAssayResultEntity(dataType)) {
    return getAssayResultOperationConfirmationData(rowIds, schemaQuery, containerPath);
  }
  const {
    selectionKey,
    useSnapshotSelection
  } = options;
  if (isSampleEntity(dataType)) {
    return getSampleOperationConfirmationData(SampleOperation.Delete, rowIds, selectionKey, useSnapshotSelection, containerPath);
  }
  let extraParams;
  if (isDataClassEntity(dataType)) {
    extraParams = {
      dataOperation: DataOperation.Delete
    };
  } else if (isAssayDesignEntity(dataType)) {
    extraParams = {
      dataOperation: AssayRunOperation.Delete
    };
  }
  return getOperationConfirmationData(dataType, rowIds, selectionKey, useSnapshotSelection, extraParams, containerPath);
}
async function getAssayResultOperationConfirmationData(rowIds, schemaQuery, containerPath) {
  const response = await selectRows({
    columns: ['RowId', 'Folder/Path'],
    containerPath,
    filterArray: [api_.Filter.create('RowId', rowIds, api_.Filter.Types.IN)],
    schemaQuery
  });
  const allowed = response.rows.reduce((agg, row) => {
    agg.push({
      rowId: caseInsensitive(row, 'RowId')?.value,
      containerPath: caseInsensitive(row, 'Folder/Path')?.value
    });
    return agg;
  }, []);
  return new OperationConfirmationData({
    allowed
  });
}
function getSampleOperationConfirmationData(operation, rowIds, selectionKey, useSnapshotSelection, containerPath) {
  return getOperationConfirmationData(SampleTypeDataType, rowIds, selectionKey, useSnapshotSelection, {
    sampleOperation: SampleOperation[operation]
  }, containerPath);
}
async function getOperationConfirmationDataForModel(model, dataType, extraParams) {
  const useSnapshotSelection = model.filterArray.length > 0;
  if (useSnapshotSelection) await setSnapshotSelections(model.selectionKey, [...model.selections]);
  return getOperationConfirmationData(dataType, undefined, model.selectionKey, useSnapshotSelection, extraParams);
}
async function getSelectedParents(schemaQuery, filterArray, isAliquotParent, orderedRowIds) {
  const isSampleParent = isSamplesSchema(schemaQuery);
  const columns = ['LSID', 'Name', 'RowId'];
  if (isSampleParent) {
    columns.push('SampleSet');
  }
  const response = await selectRows({
    columns,
    filterArray,
    schemaQuery
  });
  if (isSampleParent) {
    return resolveSampleParentTypes(response, isAliquotParent, orderedRowIds);
  }
  return resolveEntityParentTypeFromIds(schemaQuery, response, isAliquotParent, orderedRowIds);
}
async function getSelectedItemSamples(selectedItemIds) {
  const {
    queryName,
    schemaName
  } = SCHEMAS.INVENTORY.ITEMS;
  const {
    data
  } = await getSelectedData(schemaName, queryName, selectedItemIds, 'RowId, MaterialId');
  return data.map(row => row.getIn(['MaterialId', 'value'])).toArray();
}
function resolveSampleParentTypes(response, isAliquotParent, orderedRowIds) {
  const groups = {};
  const results = [];

  // The transformation done here makes the entities compatible with the editable grid
  response.rows.forEach(row => {
    const displayValue = caseInsensitive(row, 'Name')?.value;
    const sampleType = caseInsensitive(row, 'SampleSet')?.displayValue;
    const value = caseInsensitive(row, 'RowId')?.value;
    if (!groups.hasOwnProperty(sampleType)) {
      groups[sampleType] = [];
    }
    groups[sampleType].push({
      displayValue,
      value
    });
  });
  let index = 1;
  for (const [sampleType, data] of Object.entries(groups)) {
    results.push(EntityParentType.create({
      index,
      schema: 'samples',
      query: sampleType?.toLowerCase(),
      value: (0,external_immutable_.List)(data.sort(_getEntitySort(orderedRowIds))),
      isAliquotParent
    }));
    index++;
  }
  return (0,external_immutable_.List)(results);
}

/**
 * We have either an initialParents array, and determine the schemaQuery from the first id in that list
 * or a selection key and determine the schema query from parsing the selection key.  In any case, this
 * assumes parents from a single data type.
 * @param initialParents
 * @param selectionKey the key for the parent selection
 * @param isSnapshotSelection whether this selection key is a snapshot selection or not
 * @param creationType
 * @param isItemSamples
 * @param targetQueryName
 */
async function initParents(initialParents, selectionKey, isSnapshotSelection, creationType, isItemSamples, targetQueryName) {
  const isAliquotParent = creationType === SampleCreationType.Aliquots;
  if (selectionKey) {
    const {
      schemaQuery
    } = SchemaQuery.parseSelectionKey(selectionKey);
    const selectionResponse = await getSelected(selectionKey, isSnapshotSelection);
    const insertPermissionContainers = await getContainersForPermission(api_.PermissionTypes.Insert);
    const filterArray = [api_.Filter.create('RowId', selectionResponse.selected, api_.Filter.Types.IN), api_.Filter.create('Container', insertPermissionContainers, api_.Filter.Types.IN)];
    const opFilter = getFilterForSampleOperation(SampleOperation.EditLineage);
    if (opFilter) {
      filterArray.push(opFilter);
    }
    return getSelectedParents(schemaQuery, filterArray, isAliquotParent, isSnapshotSelection ? selectionResponse.selected : undefined);
  } else if (initialParents?.length > 0) {
    const [parent] = initialParents;
    const [schema, query, value] = parent.toLowerCase().split(':');

    // if the parent key doesn't have a value, we don't need to make the request to getSelectedParents
    if (value === undefined) {
      return (0,external_immutable_.List)([EntityParentType.create({
        index: 1,
        schema,
        query,
        value: (0,external_immutable_.List)(),
        isParentTypeOnly: true,
        // tell the UI to keep the parent type but not add any default rows to the editable grid
        isAliquotParent
      })]);
    }
    const filterArray = [api_.Filter.create('RowId', value)];
    const opFilter = getFilterForSampleOperation(SampleOperation.EditLineage);
    if (opFilter) {
      filterArray.push(opFilter);
    }
    return getSelectedParents(new SchemaQuery(schema, query), filterArray, isAliquotParent);
  } else if (isAliquotParent && targetQueryName) {
    return (0,external_immutable_.List)([EntityParentType.create({
      index: 1,
      schema: SCHEMAS.SAMPLE_SETS.SCHEMA,
      query: targetQueryName,
      value: (0,external_immutable_.List)(),
      isParentTypeOnly: true,
      // tell the UI to keep the parent type but not add any default rows to the editable grid
      isAliquotParent
    })]);
  }
  return (0,external_immutable_.List)();
}
function _getEntitySort(orderedIds) {
  return (a, b) => {
    return orderedIds.indexOf(a.value + '') - orderedIds.indexOf(b.value + '');
  };
}
function resolveEntityParentTypeFromIds(schemaQuery, response, isAliquotParent, orderedRowIds) {
  // The transformation done here makes the entities compatible with the editable grid
  let data = response.rows.map(row => extractEntityTypeOptionFromRow(row)).map(({
    label,
    rowId
  }) => ({
    displayValue: label,
    value: rowId
  }));
  if (orderedRowIds?.length > 1) data = data.sort(_getEntitySort(orderedRowIds));
  return (0,external_immutable_.List)([EntityParentType.create({
    index: 1,
    schema: schemaQuery.schemaName,
    query: schemaQuery.queryName,
    value: (0,external_immutable_.List)(data),
    isAliquotParent
  })]);
}
function extractEntityTypeOptionFromRow(row, lowerCaseValue = true, entityDataType) {
  const name = caseInsensitive(row, 'Name').value;
  return {
    label: name,
    lsid: caseInsensitive(row, 'LSID').value,
    rowId: caseInsensitive(row, 'RowId').value,
    value: lowerCaseValue ? name.toLowerCase() : name,
    // we match values on lower case because (at least) when parsed from an id they are lower case
    query: name,
    entityDataType,
    isFromSharedContainer: caseInsensitive(row, 'Folder/Path')?.value === SHARED_CONTAINER_PATH
  };
}

// exported for jest testing
async function getChosenParentData(model, parentEntityDataTypes, allowParents, isItemSamples, targetQueryName, combineParentTypes) {
  const entityParents = EntityIdCreationModel.getEmptyEntityParents(parentEntityDataTypes.reduce((names, entityDataType) => names.push(entityDataType.typeListingSchemaQuery.queryName), (0,external_immutable_.List)()));
  if (allowParents) {
    const parentSchemaNames = parentEntityDataTypes.keySeq();
    const {
      creationType,
      originalParents,
      selectionKey,
      isSnapshotSelection
    } = model;
    const chosenParents = await initParents(originalParents, selectionKey, isSnapshotSelection, creationType, isItemSamples, targetQueryName);

    // if we have an initial parent, we want to start with a row in the grid (entityCount = 1) otherwise we start with none
    let totalParentValueCount = 0,
      isParentTypeOnly = false,
      parentEntityDataType;
    chosenParents.forEach(chosenParent => {
      if (chosenParent.value !== undefined && parentSchemaNames.contains(chosenParent.schema)) {
        totalParentValueCount += chosenParent.value.size;
        isParentTypeOnly = chosenParent.isParentTypeOnly;

        // If combining parent types, use the first parent type for the queryName
        parentEntityDataType = (combineParentTypes ? parentEntityDataTypes.valueSeq().first() : parentEntityDataTypes.get(chosenParent.schema)).typeListingSchemaQuery.queryName;
      }
    });
    const numPerParent = model.numPerParent ?? 1;
    const validEntityCount = totalParentValueCount ? creationType === SampleCreationType.PooledSamples ? numPerParent : totalParentValueCount * numPerParent : 0;
    if (validEntityCount >= 1 || isParentTypeOnly || creationType === SampleCreationType.Aliquots) {
      return {
        entityCount: validEntityCount,
        entityParents: entityParents.set(parentEntityDataType, chosenParents)
      };
    }
  }

  // if we did not find a valid parent, we clear out the parents and selection key from the model as they aren't relevant
  return {
    originalParents: undefined,
    selectionKey: undefined,
    entityParents,
    entityCount: 0
  };
}

// get back a map from the typeListQueryName (e.g., 'SampleSet') and the list of options for that query
// where the schema field for those options is the typeSchemaName (e.g., 'samples')
async function getEntityTypeOptions(entityDataType, containerPath, containerFilter, skipProjectDataExclusion) {
  const {
    typeListingSchemaQuery,
    filterArray,
    instanceSchemaName
  } = entityDataType;
  const filters = [];
  if (!skipProjectDataExclusion) {
    const dataTypeExclusions = getProjectDataExclusion();
    const exclusions = dataTypeExclusions?.[entityDataType.projectConfigurableDataType];
    if (exclusions) filters.push(api_.Filter.create('RowId', exclusions, api_.Filter.Types.NOT_IN));
  }
  if (filterArray) filters.push(...filterArray);
  const result = await selectRows({
    columns: 'LSID,Name,RowId,Folder/Path',
    containerFilter: containerFilter ?? entityDataType.containerFilter ?? api_.Query.containerFilter.currentPlusProjectAndShared,
    containerPath,
    filterArray: filters,
    // Use of default view here is ok. Assumed that view is overridden only if there is desire to hide types.
    schemaQuery: new SchemaQuery(typeListingSchemaQuery.schemaName, typeListingSchemaQuery.queryName)
  });
  const options = result.rows.map(row => entities_actions_objectSpread(entities_actions_objectSpread({}, extractEntityTypeOptionFromRow(row, true, entityDataType)), {}, {
    schema: instanceSchemaName // e.g. "samples" or "dataclasses"
  })).sort(naturalSortByProperty('label'));
  return (0,external_immutable_.Map)({
    [typeListingSchemaQuery.queryName]: (0,external_immutable_.List)(options)
  });
}
async function getProjectConfigurableEntityTypeOptions(entityDataType, containerPath, containerFilter) {
  const {
    typeListingSchemaQuery,
    filterArray
  } = entityDataType;
  const result = await selectRows({
    columns: 'LSID,Name,RowId,Description' + (entityDataType.labelColorCol ? ',' + entityDataType.labelColorCol : ''),
    containerFilter: containerFilter ?? entityDataType.containerFilter ?? api_.Query.containerFilter.currentPlusProjectAndShared,
    containerPath,
    filterArray,
    schemaQuery: typeListingSchemaQuery
  });
  const entities = result.rows.map(row => ({
    label: caseInsensitive(row, 'Name').value,
    labelColor: entityDataType.labelColorCol ? caseInsensitive(row, entityDataType.labelColorCol).value : undefined,
    rowId: caseInsensitive(row, 'RowId').value,
    description: caseInsensitive(row, 'Description').value,
    type: entityDataType.projectConfigurableDataType,
    lsid: caseInsensitive(row, 'LSID').value
  })).sort(naturalSortByProperty('label'));
  return entities;
}

/**
 * @param model
 * @param entityDataType main data type to resolve
 * @param parentSchemaQueries map of the possible parents to the entityDataType
 * @param targetQueryName the name of the listing schema query that represents the initial target for creation.
 * @param allowParents are parents of this entity type allowed or not
 * @param isItemSamples use the selectionKey from inventory.items table to query sample parents
 * @param combineParentTypes
 */
function getEntityTypeData(model, entityDataType, parentSchemaQueries, targetQueryName, allowParents, isItemSamples, combineParentTypes) {
  return new Promise((resolve, reject) => {
    const promises = [getEntityTypeOptions(entityDataType),
    // get all the parent schemaQuery data
    getChosenParentData(model, parentSchemaQueries, allowParents, isItemSamples, targetQueryName, combineParentTypes), ...parentSchemaQueries.map(edt => getEntityTypeOptions(edt)).toArray()];
    Promise.all(promises).then(results => {
      const partial = entities_actions_objectSpread({}, results[1]); // incorporate the chosen parent data results including entityCount and entityParents
      let parentOptions = (0,external_immutable_.Map)();
      if (results.length > 2) {
        results.slice(2).forEach(typeOptionsMap => {
          parentOptions = parentOptions.merge(typeOptionsMap);
        });
      }
      // Set possible parents
      partial.parentOptions = parentOptions;

      // Set possible types
      partial.entityTypeOptions = results[0].first();

      // and populate the targetEntityType if one is provided
      if (model.initialEntityType && partial.entityTypeOptions) {
        const initialTargetTypeName = model.initialEntityType;
        const data = partial.entityTypeOptions.find(row => initialTargetTypeName.toLowerCase() === row.value);
        if (data) {
          partial.targetEntityType = new EntityTypeOption(data);
        }
      }
      resolve(entities_actions_objectSpread({
        isInit: true
      }, partial));
    }).catch(reason => {
      console.error(reason);
      reject(reason);
    });
  });
}
function deleteEntityType(deleteActionName, rowId, containerPath, auditUserComment) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('experiment', deleteActionName + '.api', undefined, {
        container: containerPath
      }),
      method: 'POST',
      params: {
        singleObjectRowId: rowId,
        forceDelete: true,
        userComment: auditUserComment
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: handleRequestFailure(reject, 'Failed to delete entity type.')
    });
  });
}
function handleEntityFileImport(importAction, queryInfo, file, insertOption, useAsync, importParameters, importFileController, saveToPipeline, containerPath, auditUserComment) {
  return new Promise((resolve, reject) => {
    return importData({
      auditUserComment,
      schemaName: queryInfo?.schemaQuery.schemaName,
      queryName: queryInfo?.schemaQuery.queryName,
      file,
      importUrl: api_.ActionURL.buildURL(importFileController ?? 'experiment', importAction, containerPath, entities_actions_objectSpread({}, importParameters)),
      importLookupByAlternateKey: true,
      useAsync,
      insertOption: InsertOptions[insertOption],
      saveToPipeline
    }).then(response => {
      if (response.success) {
        resolve(response);
      } else {
        reject({
          msg: response.errors._form
        });
      }
    }).catch(error => {
      console.error(error);
      reject({
        msg: error.exception
      });
    });
  });
}
function getDataDeleteConfirmationData(rowIds, selectionKey, useSnapshotSelection) {
  return getDataOperationConfirmationData(DataOperation.Delete, rowIds, selectionKey, useSnapshotSelection);
}
function getDataOperationConfirmationData(operation, rowIds, selectionKey, useSnapshotSelection) {
  return getOperationConfirmationData(DataClassDataType, rowIds, selectionKey, useSnapshotSelection, {
    dataOperation: DataOperation[operation]
  }, undefined);
}
function getCrossFolderSelectionResult(dataRegionSelectionKey, dataType,
// 'samples' | 'exp.data' | 'assay',
useSnapshotSelection, rowIds, picklistName) {
  if (!dataRegionSelectionKey && !rowIds?.length) {
    return Promise.resolve(undefined);
  }
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('experiment', 'getCrossFolderDataSelection.api'),
      method: 'POST',
      jsonData: {
        dataRegionSelectionKey,
        rowIds,
        dataType,
        picklistName,
        useSnapshotSelection
      },
      success: api_.Utils.getCallbackWrapper(response => {
        if (response.success) {
          resolve({
            currentFolderSelectionCount: response.data.currentFolderSelectionCount,
            crossFolderSelectionCount: response.data.crossFolderSelectionCount
          });
        } else {
          console.error('Error getting cross-project data selection result', response.exception);
          reject(response.exception);
        }
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(response ? response.exception : 'Unknown error getting cross-project data selection result.');
      })
    });
  });
}
async function getParentRowIdAndDataType(parentDataType, parentIDs, containerPath) {
  const response = await selectRows({
    containerPath,
    schemaQuery: parentDataType.listingSchemaQuery,
    viewName: ViewInfo.DETAIL_NAME,
    // use this to avoid filters on the default view
    columns: 'LSID, RowId, DataClass, SampleSet',
    // only one of DataClass or SampleSet will exist
    filterArray: [api_.Filter.create('LSID', parentIDs, api_.Filter.Types.IN)]
  });
  const filteredParentItems = {};
  response.rows.forEach(row => {
    const lsid = caseInsensitive(row, 'LSID').value;
    filteredParentItems[lsid] = {
      rowId: caseInsensitive(row, 'RowId').value,
      parentId: caseInsensitive(row, 'DataClass')?.value ?? caseInsensitive(row, 'SampleSet')?.value
    };
  });
  return filteredParentItems;
}
const getParentTypeDataForLineage = async (parentDataType, data, containerPath, containerFilter, skipProjectDataExclusion) => {
  let parentTypeOptions = (0,external_immutable_.List)();
  let parentIdData;
  if (parentDataType) {
    const options = await getEntityTypeOptions(parentDataType, containerPath, containerFilter, skipProjectDataExclusion);
    parentTypeOptions = (0,external_immutable_.List)(options.get(parentDataType.typeListingSchemaQuery.queryName));

    // get the set of parent row LSIDs so that we can query for the RowId and SampleSet/DataClass for that row
    const parentIDs = [];
    data.forEach(datum => {
      parentIDs.push(...datum[parentDataType.inputColumnName].map(row => row.value));
    });
    parentIdData = await getParentRowIdAndDataType(parentDataType, parentIDs, containerPath);
  }
  return {
    parentTypeOptions,
    parentIdData
  };
};
const getOriginalParentsFromLineage = async (lineage, parentDataTypes, containerPath) => {
  const originalParents = {};
  let parentTypeOptions = (0,external_immutable_.Map)();
  const dataClassTypeData = await getParentTypeDataForLineage(parentDataTypes.filter(dataType => dataType.typeListingSchemaQuery.queryName === SCHEMAS.EXP_TABLES.DATA_CLASSES.queryName)[0], Object.values(lineage), containerPath);
  const sampleTypeData = await getParentTypeDataForLineage(parentDataTypes.filter(dataType => dataType.typeListingSchemaQuery.queryName === SCHEMAS.EXP_TABLES.SAMPLE_SETS.queryName)[0], Object.values(lineage), containerPath);

  // iterate through both Data Classes and Sample Types for finding sample parents
  parentDataTypes.forEach(dataType => {
    const dataTypeOptions = dataType.typeListingSchemaQuery.queryName === SCHEMAS.EXP_TABLES.DATA_CLASSES.queryName ? dataClassTypeData.parentTypeOptions : sampleTypeData.parentTypeOptions;
    const parentIdData = dataType.typeListingSchemaQuery.queryName === SCHEMAS.EXP_TABLES.DATA_CLASSES.queryName ? dataClassTypeData.parentIdData : sampleTypeData.parentIdData;
    Object.keys(lineage).forEach(sampleId => {
      if (!originalParents[sampleId]) originalParents[sampleId] = (0,external_immutable_.List)();
      originalParents[sampleId] = originalParents[sampleId].concat(getInitialParentChoices(dataTypeOptions, dataType, lineage[sampleId], parentIdData));
    });

    // filter out the current parent types from the dataTypeOptions
    const originalParentTypeLsids = [];
    Object.values(originalParents).forEach(parentTypes => {
      originalParentTypeLsids.push(...parentTypes.map(parentType => parentType.type.lsid).toArray());
    });
    parentTypeOptions = parentTypeOptions.set(dataType.typeListingSchemaQuery.queryName, dataTypeOptions.filter(option => originalParentTypeLsids.indexOf(option.lsid) === -1).toList());
  });
  return {
    originalParents,
    parentTypeOptions
  };
};
function getMoveConfirmationData(dataType, rowIds, selectionKey, useSnapshotSelection) {
  if (isSampleEntity(dataType)) {
    return getSampleOperationConfirmationData(SampleOperation.Move, rowIds, selectionKey, useSnapshotSelection);
  }
  return getOperationConfirmationData(dataType, rowIds, selectionKey, useSnapshotSelection, isDataClassEntity(dataType) ? {
    dataOperation: DataOperation.Move
  } : isAssayDesignEntity(dataType) ? {
    dataOperation: AssayRunOperation.Move
  } : undefined, undefined);
}
function moveEntities(options) {
  return new Promise((resolve, reject) => {
    const {
        entityDataType,
        rowIds
      } = options,
      rest = actions_objectWithoutProperties(options, actions_excluded);
    const params = Object.assign({}, rest);
    if (rowIds) {
      params['rows'] = rowIds.reduce((prev, curr) => {
        prev.push({
          rowId: curr
        });
        return prev;
      }, []);
    }
    api_.Query.moveRows(entities_actions_objectSpread(entities_actions_objectSpread({}, params), {}, {
      success: response => {
        if (response.success) {
          resolve(response);
        } else {
          console.error('Error moving ' + entityDataType.nounPlural, response);
          reject(response?.error ?? 'Unknown error moving ' + entityDataType.nounPlural + '.');
        }
      },
      failure: reason => {
        console.error('Error moving ' + entityDataType.nounPlural, reason);
        reject(reason?.exception ?? 'Unknown error moving ' + entityDataType.nounPlural + '.');
      }
    }));
  });
}
const initParentOptionsSelects = (includeSampleTypes, includeDataClasses, containerPath, isValidParentOptionFn, newTypeOption, importAliases, idPrefix, formatLabel) => {
  const promises = [];
  const dataTypeExclusions = getProjectDataExclusion();

  // Get Sample Types
  if (includeSampleTypes) {
    const exclusions = dataTypeExclusions?.['SampleType'];
    promises.push(selectRows({
      containerPath,
      schemaQuery: SCHEMAS.EXP_TABLES.SAMPLE_SETS,
      columns: 'LSID, Name, RowId, Folder',
      containerFilter: api_.Query.containerFilter.currentPlusProjectAndShared,
      filterArray: exclusions?.length > 0 ? [api_.Filter.create('RowId', exclusions, api_.Filter.Types.NOT_IN)] : null
    }));
  }

  // Get Data Classes
  if (includeDataClasses) {
    const exclusions = dataTypeExclusions?.['DataClass'];
    promises.push(selectRows({
      containerPath,
      schemaQuery: SCHEMAS.EXP_TABLES.DATA_CLASSES,
      columns: 'LSID, Name, RowId, Folder, Category',
      containerFilter: api_.Query.containerFilter.currentPlusProjectAndShared,
      filterArray: exclusions?.length > 0 ? [api_.Filter.create('RowId', exclusions, api_.Filter.Types.NOT_IN)] : null
    }));
  }
  return new Promise((resolve, reject) => {
    Promise.all(promises).then(responses => {
      const sets = [];
      responses.forEach(result => {
        const rows = result.rows;
        const isDataClass = result.schemaQuery?.queryName?.toLowerCase() === 'dataclasses';
        const prefix = isDataClass ? DATA_CLASS_IMPORT_PREFIX : SAMPLE_SET_IMPORT_PREFIX;
        const labelPrefix = isDataClass ? 'Data Class' : 'Sample Type';
        rows.forEach(row => {
          if (isValidParentOptionFn) {
            if (!isValidParentOptionFn(row, isDataClass)) return;
          }
          const name = caseInsensitive(row, 'Name')?.value;
          const containerPath = caseInsensitive(row, 'Folder').displayValue;
          const label = formatLabel ? formatLabel(name, labelPrefix, isDataClass, containerPath) : name;
          sets.push({
            value: prefix + name,
            label,
            schema: isDataClass ? SCHEMAS.DATA_CLASSES.SCHEMA : SCHEMAS.SAMPLE_SETS.SCHEMA,
            query: name // Issue 33653: query name is case-sensitive for some data inputs (sample parents)
          });
        });
        if (newTypeOption) {
          if (!isDataClass && newTypeOption.schema === SCHEMAS.SAMPLE_SETS.SCHEMA || isDataClass && newTypeOption.schema !== SCHEMAS.SAMPLE_SETS.SCHEMA) sets.push(newTypeOption);
        }
      });
      const parentOptions = sets.sort(naturalSortByProperty('label'));
      let parentAliases = (0,external_immutable_.Map)();
      if (importAliases) {
        const initialAlias = (0,external_immutable_.Map)(importAliases);
        initialAlias.forEach((val, key) => {
          const newId = generateId(idPrefix);
          const parentValue = parentOptions.find(opt => opt.value === val);
          if (!parentValue)
            // parent option might have been filtered out by isValidParentOptionFn
            return;
          parentAliases = parentAliases.set(newId, {
            id: newId,
            alias: key,
            parentValue,
            ignoreAliasError: false,
            ignoreSelectError: false
          });
        });
      }
      resolve({
        parentOptions,
        parentAliases
      });
    }).catch(error => {
      reject(error);
    });
  });
};
const getFolderDataTypeExclusions = excludedContainer => {
  if (!hasModule(SAMPLE_MANAGER_APP_PROPERTIES.moduleName)) {
    return Promise.resolve(undefined);
  }
  let isCurrentContainer = true;
  if (excludedContainer) {
    const currentContainer = (0,api_.getServerContext)().container;
    if (!(excludedContainer === currentContainer.path || excludedContainer === currentContainer.id)) isCurrentContainer = false;
  }
  if (isCurrentContainer) {
    return new Promise(resolve => resolve(getProjectDataExclusion()));
  }
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'getDataTypeExclusion.api'),
      method: 'GET',
      params: {
        excludedContainer
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response['excludedDataTypes']);
      }),
      failure: handleRequestFailure(reject, 'Failed to get excluded data types')
    });
  });
};
const getFolderExcludedDataTypes = (dataType, excludedContainer) => {
  return new Promise((resolve, reject) => {
    getFolderDataTypeExclusions(excludedContainer).then(exclusions => {
      resolve(exclusions?.[dataType]);
    }).catch(error => reject(error));
  });
};
const getExcludedDataTypeNames = (listingSchemaQuery, dataType, excludedContainerId) => {
  return new Promise((resolve, reject) => {
    getFolderExcludedDataTypes(dataType, excludedContainerId).then(excludedRowIds => {
      if (!excludedRowIds || excludedRowIds.length === 0) {
        resolve([]);
      }
      const filterArray = [api_.Filter.create('RowId', excludedRowIds, api_.Filter.Types.IN)];
      selectRows({
        columns: 'Name',
        filterArray,
        schemaQuery: listingSchemaQuery
      }).then(response => {
        const rows = response.rows;
        const namesLc = [];
        rows.forEach(row => namesLc.push(caseInsensitive(row, 'Name')?.value?.toLowerCase()));
        resolve(namesLc);
      }).catch(reason => {
        reject(resolveErrorMessage(reason));
        console.error(reason);
      });
    }).catch(reason => {
      reject(resolveErrorMessage(reason));
      console.error(reason);
    });
  });
};
function getOrderedSelectedMappedKeys(fromColumn, toColumn, schemaName, queryName, selections, sortString, queryParameters, viewName) {
  return new Promise((resolve, reject) => {
    getSelectedData(schemaName, queryName, Array.from(selections), toColumn ? [fromColumn, toColumn].join(',') : fromColumn, sortString, queryParameters, viewName, fromColumn).then(response => {
      const {
        data,
        dataIds
      } = response;
      const values = [];
      data.forEach(row => {
        const rowData = row.toJS();
        const from = caseInsensitive(rowData, fromColumn)?.value;
        const to = toColumn ? caseInsensitive(rowData, toColumn)?.value : null;
        const orderNum = dataIds.indexOf(from + '');
        values.push({
          from,
          to,
          orderNum
        });
      });
      const mapFromValues = [];
      const mapToValues = [];
      values.sort((a, b) => a.orderNum - b.orderNum);
      values.forEach(value => {
        mapToValues.push(value.to);
        mapFromValues.push(value.from);
      });
      resolve({
        mapToValues,
        mapFromValues
      });
    }).catch(reason => {
      console.error(reason);
      reject(reason);
    });
  });
}
function saveOrderedSnapshotSelection(queryModel, fromColumn, toColumn) {
  return new Promise((resolve, reject) => {
    const {
      queryName,
      queryParameters,
      selections,
      sortString,
      viewName,
      selectionKey,
      schemaName
    } = queryModel;
    getOrderedSelectedMappedKeys(fromColumn, toColumn ?? fromColumn, schemaName, queryName, Array.from(selections), sortString, queryParameters, viewName).then(result => {
      const fromIds = result.mapFromValues;
      const toIds = result.mapToValues;
      setSnapshotSelections(selectionKey, fromIds).then(result => {
        resolve(toIds);
      }).catch(reason => {
        console.error(reason);
        reject(reason);
      });
    }).catch(reason => {
      console.error(reason);
      reject(reason);
    });
  });
}

/**
 * Get the ordered remapped key values from a QueryModel based on grid's current selection.
 * For example, picklist grid has a "ID" PK column and a "SampleId" FK column.
 * This function can be used to get the SampleIds for the currently selected IDs, in the order that respect current grid
 * filter/sort
 * @param fromColumn Key column for the current grid
 * @param toColumn Key column for the FK field, can be empty.
 * @param selectedIds
 * @param queryModel
 */
function getOrderedSelectedMappedKeysFromQueryModel(fromColumn, toColumn, queryModel, selectedIds) {
  const {
    schemaName,
    queryName,
    queryParameters,
    sortString,
    viewName,
    selections
  } = queryModel;
  return getOrderedSelectedMappedKeys(fromColumn, undefined, schemaName, queryName, selectedIds ?? Array.from(selections), sortString, queryParameters, viewName);
}
function getDataTypeDataExistSql(dataType, lsid, rowId) {
  if (!dataType) return null;
  let from = 'exp.materials ';
  // samples and assay runs reference their data type by lsid, but dataclass data reference by rowid
  let where = "WHERE SampleSet = '" + lsid + "'";
  if (dataType === 'DataClass') {
    from = 'exp.data ';
    where = 'WHERE DataClass = ' + rowId;
  } else if (dataType === 'AssayDesign') {
    from = 'exp.AssayRuns ';
    where = "WHERE protocol = '" + lsid + "'";
  }
  return `SELECT count(*) as HasData FROM (SELECT 1 FROM ${from} ${where} limit 1)`;
}
function isDataTypeEmpty(dataType, lsid, rowId, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Query.executeSql({
      containerPath,
      containerFilter: api_.Query.ContainerFilter.allInProject,
      schemaName: SCHEMAS.EXP_TABLES.SCHEMA,
      sql: getDataTypeDataExistSql(dataType, lsid, rowId),
      success: result => {
        resolve(caseInsensitive(result.rows[0], 'HasData') === 0);
      },
      failure: error => {
        console.error(error);
        reject(error);
      }
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/query/utils.ts



/**
 * Recursively processes raw schema information into a Map<string, SchemaDetails>.
 * Schemas are mapped by their "fullyQualifiedName".
 * @private
 */
function processSchemas(schemas, allSchemas) {
  let top = false;
  if (allSchemas === undefined) {
    top = true;
    allSchemas = (0,external_immutable_.Map)().asMutable();
  }
  for (const schemaName in schemas) {
    if (schemas.hasOwnProperty(schemaName)) {
      const schema = schemas[schemaName];
      allSchemas.set(schema.fullyQualifiedName.toLowerCase(), SchemaDetails.create(schema));
      if (schema.schemas !== undefined) {
        processSchemas(schema.schemas, allSchemas);
      }
    }
  }
  return top ? allSchemas.asImmutable() : allSchemas;
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/actions.ts
function domainproperties_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function domainproperties_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? domainproperties_actions_ownKeys(Object(t), !0).forEach(function (r) { domainproperties_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : domainproperties_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function domainproperties_actions_defineProperty(e, r, t) { return (r = domainproperties_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function domainproperties_actions_toPropertyKey(t) { var i = domainproperties_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function domainproperties_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



















let sharedCache = (0,external_immutable_.Map)();
function cache(prefix, key, miss) {
  const cacheKey = [prefix, key].join('|');
  let promise = sharedCache.get(cacheKey);
  if (!promise) {
    promise = miss();
    sharedCache = sharedCache.set(cacheKey, promise);
  }
  return promise;
}
function fetchContainers() {
  return cache('container-cache', 'containers', () => new Promise((resolve, reject) => {
    api_.Security.getContainers({
      containerPath: '/',
      includeSubfolders: true,
      includeEffectivePermissions: false,
      includeWorkbookChildren: false,
      includeStandardProperties: false,
      success: data => {
        resolve(processContainers(data));
      },
      failure: error => {
        console.error(error);
        reject(error);
      }
    });
  }));
}
function processContainers(payload, container) {
  let containers = (0,external_immutable_.List)();

  // Depth first
  if (container) {
    containers = containers.push(container);
  }
  payload.children.forEach(c => {
    containers = containers.concat(processContainers(c, new Container(c))).toList();
  });
  return containers;
}

/**
 * @param domainId Fetch domain by Id. Priority param over schema and query name.
 * @param schemaName Schema of domain.
 * @param queryName Query of domain.
 * @param containerPath containerPath to use for domain details query.
 * @return Promise wrapped Domain API call.
 */
function fetchDomain(domainId, schemaName, queryName, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Domain.getDomainDetails({
      containerPath,
      domainId,
      schemaName,
      queryName,
      success: data => {
        resolve(DomainDesign.create(data.domainDesign ? data.domainDesign : data, undefined));
      },
      failure: error => {
        console.error(error);
        reject(error);
      }
    });
  });
}
function fetchDomainDetails(options) {
  return new Promise((resolve, reject) => {
    api_.Domain.getDomainDetails(domainproperties_actions_objectSpread(domainproperties_actions_objectSpread({}, options), {}, {
      success: data => {
        resolve(DomainDetails.create((0,external_immutable_.Map)(domainproperties_actions_objectSpread({}, data))));
      },
      failure: error => {
        console.error(error);
        reject(error);
      }
    }));
  });
}
function fetchQueries(containerPath, schemaName) {
  const key = [containerPath, schemaName].join('|').toLowerCase();
  return cache('query-cache', key, () => new Promise(resolve => {
    if (schemaName) {
      api_.Query.getQueries({
        containerPath,
        schemaName,
        queryDetailColumns: true,
        success: data => {
          resolve(processQueries(data));
        }
      });
    } else {
      resolve(null);
    }
  }));
}

// This looks hacky, but it's actually the recommended way to download a file using raw JS
function downloadJsonFile(content, fileName) {
  const downloadLink = document.createElement('a');
  downloadLink.href = 'data:application/json;charset=utf-8,' + encodeURIComponent(content);
  downloadLink.download = fileName;
  downloadLink.style.display = 'none';
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}
function processQueries(payload) {
  if (!payload || !payload.queries) {
    return null;
  }
  return payload.queries.map(qi => QueryInfoLite.create(qi, payload.schemaName)).sort(naturalSortByProperty('name'));
}
function fetchSchemas(containerPath) {
  return cache('schema-cache', containerPath, () => new Promise(resolve => {
    api_.Query.getSchemas({
      apiVersion: 17.1,
      containerPath,
      includeHidden: false,
      success: data => {
        resolve(handleSchemas(data));
      }
    });
  }));
}
function getExcludedSchemaQueryNames(schemaName, queryContainerPath) {
  switch (schemaName) {
    case 'assay':
      return getExcludedDataTypeNames(SCHEMAS.ASSAY_TABLES.ASSAY_LIST, 'AssayDesign', queryContainerPath);
    case 'samples':
    case 'exp.materials':
      return getExcludedDataTypeNames(SCHEMAS.EXP_TABLES.SAMPLE_SETS, 'SampleType', queryContainerPath);
    case 'exp.data':
      return getExcludedDataTypeNames(SCHEMAS.EXP_TABLES.DATA_CLASSES, 'DataClass', queryContainerPath);
  }
  return new Promise(resolve => {
    resolve([]);
  });
}
function handleSchemas(payload) {
  return processSchemas(payload).valueSeq().sort(naturalSortByProperty('fullyQualifiedName')).toArray();
}
function getAvailableTypes(domain, ontologies = []) {
  return PROP_DESC_TYPES.filter(type => _isAvailablePropType(type, domain, ontologies)).toList();
}
async function getAvailableTypesForOntology(api, domain) {
  const ontologies = await api.fetchOntologies(domain.container);
  return getAvailableTypes(domain, ontologies);
}
function _isAvailablePropType(type, domain, ontologies) {
  if (type === FLAG_TYPE && !domain.allowFlagProperties) {
    return false;
  }
  if (type === FILE_TYPE && !domain.allowFileLinkProperties) {
    return false;
  }
  if (type === ATTACHMENT_TYPE && !domain.allowAttachmentProperties) {
    return false;
  }
  if ((type === VISIT_DATE_TYPE || type === VISIT_ID_TYPE) && !domain.allowTimepointProperties) {
    return false;
  }
  if (type === ONTOLOGY_LOOKUP_TYPE && ontologies.length === 0) {
    return false;
  }
  if (type === UNIQUE_ID_TYPE && (isCommunityDistribution() || domain.domainKindName !== api_.Domain.KINDS.SAMPLE_TYPE)) {
    return false;
  }
  if (type === TEXT_CHOICE_TYPE && !domain.allowTextChoiceProperties) {
    return false;
  }
  if ((type === SAMPLE_TYPE || type === PARTICIPANT_TYPE) && !domain.allowSampleSubjectProperties) {
    return false;
  }
  if (type === SMILES_TYPE) {
    return false;
  }
  if (type === USERS_TYPE && !domain.allowUserProperties) {
    return false;
  }
  if (type === CALCULATED_TYPE && (!isCalculatedFieldsEnabled() || !domain.allowCalculatedFields)) {
    return false;
  }
  return true;
}
function fetchOntologies(containerPath) {
  return cache('ontologies-cache', containerPath, async () => {
    const result = await selectRows({
      columns: ['RowId', 'Name', 'Abbreviation'],
      containerPath,
      schemaQuery: new SchemaQuery('ontology', 'ontologies'),
      sort: 'Name'
    });
    return result.rows.map(OntologyModel.create);
  });
}
function getMaxPhiLevel(containerPath) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL('security', 'getMaxPhiLevel.api', undefined, {
        container: containerPath
      }),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response.maxPhiLevel);
      }),
      failure: handleRequestFailure(reject)
    });
  });
}
function saveDomain(options) {
  return new Promise((resolve, reject) => {
    const {
      addRowIndexes,
      containerPath,
      domain,
      includeWarnings,
      kind,
      name,
      originalDomain
    } = options;
    function successHandler(response) {
      resolve(DomainDesign.create(response));
    }
    function failureHandler(response) {
      console.error(response);
      if (!response.exception) {
        response = {
          exception: response
        };
      }
      if (!response.errors) {
        reject(response);
      }
      const exception = DomainException.create(response, constants_SEVERITY_LEVEL_ERROR);
      const badDomain = setDomainException(domain, exception, addRowIndexes, originalDomain);
      reject(badDomain);
    }
    if (domain.domainId) {
      api_.Domain.save({
        containerPath: containerPath ?? domain.container,
        domainId: domain.domainId,
        domainDesign: DomainDesign.serialize(domain),
        includeWarnings,
        options: options.options,
        success: successHandler,
        failure: failureHandler
      });
    } else {
      api_.Domain.create({
        containerPath,
        domainDesign: DomainDesign.serialize(domain.set('name', name)),
        kind,
        options: options.options,
        success: successHandler,
        failure: failureHandler
      });
    }
  });
}

/**
 * @param domain DomainDesign to save
 * @param kind DomainKind if creating new Domain
 * @param options Options for creating new Domain
 * @param includeNamePreview
 * @return Promise wrapped Domain API call.
 */
function validateDomainNameExpressions(domain, kind, options, includeNamePreview) {
  return new Promise((resolve, reject) => {
    api_.Domain.validateNameExpressions({
      containerPath: domain.container,
      options,
      domainDesign: DomainDesign.serialize(domain),
      kind,
      includeNamePreview,
      success: response => {
        resolve({
          errors: response.errors,
          previews: response.previews,
          warnings: response.warnings
        });
      },
      failure: error => {
        console.error(error);
        reject(error);
      }
    });
  });
}
function createNewDomainField(domain, fieldConfig = {}) {
  // Issue 38771: if the domain has a defaultDefaultValueType and the fieldConfig doesn't include its own, use the defaultDefaultValueType
  if (domain.defaultDefaultValueType && !fieldConfig.defaultValueType) {
    fieldConfig.defaultValueType = domain.defaultDefaultValueType;
  }
  return DomainField.create(fieldConfig, true);
}
async function mergeDomainFields(domain, newFields) {
  const newFields_ = [];
  for (let i = 0; i < newFields.size; i++) {
    const field = newFields.get(i);
    if (field.lookupQuery) {
      try {
        // Issue 48240: lookupIsValid during JSON fields import if we can find the queryDetails, otherwise set to false in catch
        await getQueryDetails({
          containerPath: field.lookupContainer,
          schemaQuery: new SchemaQuery(field.lookupSchema, field.lookupQuery)
        });
        newFields_.push(field.merge({
          lookupIsValid: true
        }));
      } catch (e) {
        newFields_.push(field.merge({
          lookupIsValid: false
        }));
      }
    } else {
      newFields_.push(field);
    }
  }
  return domain.set('fields', domain.fields.concat(newFields_));
}
function processJsonImport(content, domain) {
  const domainType = domain.domainKindName;
  const emptinessError = {
    success: false,
    msg: 'No field definitions were found in the imported json file. Please check the file contents and try again.'
  };
  if (content == '') {
    return emptinessError;
  }
  const jsFields = JSON.parse(content);
  if (jsFields.length < 1 || Object.keys(jsFields).length === 0) {
    return emptinessError;
  }
  for (let i = 0; i < jsFields.length; i++) {
    const field = jsFields[i];
    if (field.defaultValueType && domain.defaultValueOptions.size > 0 && !domain.hasDefaultValueOption(field.defaultValueType)) {
      return {
        success: false,
        msg: `Error on importing field '${field.name}': Default value type '${field.defaultValueType}' is invalid.`
      };
    }
    if (!domainType?.includes('List') && field.lockType === DOMAIN_FIELD_PRIMARY_KEY_LOCKED) {
      return {
        success: false,
        msg: `Error on importing field '${field.name}': ${domainType || 'This'} domain type does not support fields with an externally defined Primary Key.`
      };
    }

    // These values are set server-side during a save
    if (field.propertyId) {
      delete field.propertyId;
    }
    if (field.propertyURI) {
      delete field.propertyURI;
    }
  }
  const tsFields = (0,external_immutable_.List)(jsFields.map(field => DomainField.create(field, false)));
  return {
    success: true,
    fields: tsFields
  };
}
function handleSystemFieldUpdates(domain, field, enable) {
  const disabledSystemFields = domain.disabledSystemFields ? [...domain.disabledSystemFields] : [];
  const disabledFieldNamesLc = disabledSystemFields.map(f => f.toLowerCase());
  const fieldInd = disabledFieldNamesLc.indexOf(field.toLowerCase());
  if (enable && fieldInd > -1) disabledSystemFields.splice(fieldInd, 1);else if (!enable && fieldInd === -1) disabledSystemFields.push(field);
  return domain.merge({
    disabledSystemFields
  });
}
function addDomainField(domain, fieldConfig = {}) {
  const newField = createNewDomainField(domain, fieldConfig);
  return domain.merge({
    fields: domain.fields.push(newField)
  });
}

// Given sequence of field indexes that have existing errors, 'rowIndex', and
// array of indexes of removed fields, 'removedFieldIndexes' we must update each
// rowIndex based on if its position has been affected by a deleted field.
// Eg, rowIndex set [1, 4, 7, 8] with removedFieldIndexes [2, 5] becomes [1, 3, 5, 6].
function updateErrorIndexes(removedFieldIndexes, domainException) {
  const errorsWithNewIndexes = domainException.errors.map(error => {
    const newRowIndexes = error.rowIndexes.map(rowIndex => {
      for (let i = 0; i < removedFieldIndexes.length; i++) {
        if (i !== removedFieldIndexes.length && removedFieldIndexes[i + 1] < rowIndex) {
          continue;
        } else if (rowIndex > removedFieldIndexes[i]) {
          return rowIndex - (i + 1);
        } else {
          return rowIndex;
        }
      }
    });
    return error.set('rowIndexes', newRowIndexes);
  });
  return domainException.set('errors', errorsWithNewIndexes);
}
function removeFields(domain, deletableSelectedFields) {
  // Removes from domain.domainException errors belonging to removed fields, and also clears domainException if
  // a removed field was the final field with any error
  deletableSelectedFields.forEach(value => {
    domain = updateDomainException(domain, value, undefined);
  });
  const newFields = domain.fields.filter((_, i) => !deletableSelectedFields.includes(i));
  const updatedDomain = domain.merge({
    fields: newFields
  });

  // "move up" the indexes of the fields with error, i.e. the fields that are below the removed fields
  if (updatedDomain.hasException()) {
    return updatedDomain.set('domainException', updateErrorIndexes(deletableSelectedFields, updatedDomain.domainException));
  } else {
    return updatedDomain;
  }
}
function handleDomainUpdates(domain, changes) {
  changes.forEach(change => {
    if (getNameFromId(change.id) === DOMAIN_FIELD_CLIENT_SIDE_ERROR) {
      domain = updateDomainException(domain, getIndexFromId(change.id), change.value);
    } else {
      domain = updateDomainField(domain, change);
    }
  });
  return domain;
}
function updateDomainField(domain, change) {
  const type = getNameFromId(change.id);
  const index = getIndexFromId(change.id);
  const field = domain.fields.get(index);
  if (field) {
    const isSelection = type === 'selected';
    let newField = isSelection ? field : field.set('updatedField', true);
    switch (type) {
      case DOMAIN_FIELD_TYPE:
        newField = updateDataType(newField, change.value);
        break;
      case DOMAIN_FIELD_LOOKUP_CONTAINER:
        newField = updateLookup(newField, change.value);
        break;
      case DOMAIN_FIELD_LOOKUP_SCHEMA:
        newField = updateLookup(newField, newField.lookupContainer, change.value);
        break;
      case DOMAIN_FIELD_SAMPLE_TYPE:
        newField = updateSampleField(newField, change.value);
        break;
      case DOMAIN_FIELD_LOOKUP_QUERY:
        const {
          queryName,
          rangeURI
        } = decodeLookup(change.value);
        newField = newField.merge({
          lookupQuery: queryName,
          lookupQueryValue: change.value,
          lookupType: newField.lookupType.set('rangeURI', rangeURI),
          rangeURI,
          lookupIsValid: true
        });
        break;
      case DOMAIN_FIELD_ONTOLOGY_PRINCIPAL_CONCEPT:
        const concept = change.value;
        newField = newField.merge({
          principalConceptCode: concept?.code
        });
        break;
      default:
        newField = newField.set(type, change.value);
        break;
    }
    domain = domain.merge({
      fields: domain.fields.set(index, newField)
    });
  }
  return domain;
}

// exported for jest testing
function updateDataType(field, value) {
  const propType = PROP_DESC_TYPES.find(pt => pt.name === value);
  if (propType) {
    const dataType = propType.isLookup() ? field.lookupType : propType;
    field = field.merge({
      dataType,
      conceptURI: dataType.conceptURI,
      rangeURI: dataType.rangeURI,
      lookupSchema: dataType.lookupSchema,
      lookupQuery: dataType.lookupQuery,
      sourceOntology: undefined,
      conceptSubtree: undefined,
      conceptLabelColumn: undefined,
      conceptImportColumn: undefined,
      scannable: undefined,
      textChoiceValidator: undefined,
      valueExpression: undefined
    });
    if (field.isNew()) {
      field = DomainField.updateDefaultValues(field);
    } else if (dataType === SAMPLE_TYPE) {
      // Issue 49005: set default lookup schema/query for change to Sample data type
      field = field.merge(DomainField.resolveLookupConfig(field, dataType));
    }
    if (field.isTextChoiceField()) {
      // when changing a field to a Text Choice, add the default textChoiceValidator and
      // remove/reset all other propertyValidators and other text option settings
      field = field.merge({
        textChoiceValidator: DEFAULT_TEXT_CHOICE_VALIDATOR,
        lookupValidator: undefined,
        rangeValidators: [],
        regexValidators: [],
        scale: MAX_TEXT_LENGTH
      });
    } else if (field.isCalculatedField()) {
      field = field.merge({
        importAliases: undefined,
        principalConceptCode: undefined,
        regexValidators: [],
        uniqueConstraint: false,
        PHI: undefined
      });
    } else {
      field = field.merge({
        lookupValidator: PropDescType.isUser(value) ? new PropertyValidator(LOOKUP_VALIDATOR_VALUES) : undefined
      });
    }
  }
  return field;
}
function updateLookup(field, lookupContainer, lookupSchema) {
  return field.merge({
    lookupContainer,
    lookupQuery: undefined,
    lookupQueryValue: undefined,
    lookupSchema,
    lookupIsValid: true
  });
}
function clearFieldDetails(domain) {
  return domain.merge({
    fields: domain.fields.map(f => f.set('updatedField', false)).toList()
  });
}
function getCheckedValue(evt) {
  if (evt.target.type === 'checkbox') {
    return evt.target.checked;
  }
  return undefined;
}
function clearAllClientValidationErrors(domain) {
  let exception;
  if (domain.domainException) {
    const updatedErrors = domain.domainException.errors.filter(error => error.serverError || error.severity === constants_SEVERITY_LEVEL_WARN);
    if (updatedErrors && updatedErrors.size > 0) {
      exception = domain.domainException.set('errors', updatedErrors);
    }
  }
  return domain.set('domainException', exception);
}
function clearAllFieldErrors(domain) {
  let exception;

  // Keep exception only errors as those are not related to the fields
  if (domain.hasException() && !domain.hasErrors()) {
    exception = domain.domainException;
  }
  return domain.set('domainException', exception);
}
function clearFieldError(domain, rowIndex) {
  const allErrors = domain.domainException.get('errors');

  // filter errors where rowIndexes size > 2
  const filteredErrors = allErrors.filter(error => {
    if (error.rowIndexes.includes(rowIndex)) {
      return error.rowIndexes.size > 2;
    }
    return true;
  });

  // find an index of an error to remove from the list of errors
  return filteredErrors.map(error => {
    return error.set('rowIndexes', error.rowIndexes.filter(idx => {
      return idx !== rowIndex;
    }));
  });
}

/**
 *
 * @param domain: DomainDesign to update with Field level error, in this case, set DomainException property which will carry field level error
 * @param index: Domain field index
 * @param domainFieldError: Field level error with message and severity
 * @return copy of domain with exception set on a field
 */
function updateDomainException(domain, index, domainFieldError) {
  let domainExceptionObj;

  // new error on a field at a given index
  if (domainFieldError) {
    // add incoming field error to a previously existing domainException object
    if (domain.hasException()) {
      const updatedErrors = clearFieldError(domain, index); // clear previously present error on a given row index
      const newErrors = updatedErrors.push(domainFieldError);
      domainExceptionObj = domain.domainException.merge({
        errors: newErrors
      });
    }
    // domainException is not defined yet/doesn't have field errors, so create a new domainException object
    else {
      const exception = domainFieldError.fieldName + ' : ' + domainFieldError.message;
      const errors = (0,external_immutable_.List)().asMutable();
      errors.push(domainFieldError);
      domainExceptionObj = new DomainException({
        exception,
        success: undefined,
        severity: domainFieldError.severity,
        errors: errors.asImmutable(),
        domainName: domain.name
      });
    }
  }
  // no error on a field at a given index
  else {
    // clear out an old error on a field, ex. if the client side error is fixed on a field then its previous error needs to be cleared out from the error set
    if (domain && domain.hasException()) {
      const updatedErrors = clearFieldError(domain, index);

      // reset domainException obj with an updated set of errors
      if (updatedErrors && updatedErrors.size > 0) {
        const exception = updatedErrors.get(0).fieldName + ' : ' + updatedErrors.get(0).message; // create exception message based on the first error, to be consistent with how server side errors are created

        domainExceptionObj = new DomainException({
          exception,
          success: undefined,
          severity: updatedErrors.get(0).severity,
          errors: updatedErrors
        });
      }
      // previous/old error on an incoming field was the last error to clear out, so no more errors
      else {
        domainExceptionObj = undefined;
      }
    }
  }
  return domain.merge({
    domainException: domainExceptionObj
  });
}
function getBannerMessages(domain) {
  if (domain && domain.hasException()) {
    let msgList = List();
    const errMsg = getErrorBannerMessage(domain);
    if (errMsg !== undefined) {
      msgList = msgList.push({
        message: errMsg,
        messageType: 'danger'
      });
    }
    const warnMsg = getWarningBannerMessage(domain);
    if (warnMsg !== undefined) {
      msgList = msgList.push({
        message: warnMsg,
        messageType: 'warning'
      });
    }
    return msgList;
  } else {
    return List();
  }
}
function getErrorBannerMessage(domain) {
  if (domain && domain.hasException()) {
    const errors = domain.domainException.get('errors').filter(e => {
      return e && e.severity === SEVERITY_LEVEL_ERROR;
    });
    if (errors && errors.size > 0) {
      if (errors.size > 1) {
        return 'Multiple fields contain issues that need to be fixed. Review the red highlighted fields above for more information.';
      } else {
        return errors.get(0).message;
      }
    }
  }
  return undefined;
}
function getWarningBannerMessage(domain) {
  if (domain && domain.hasException()) {
    const warnings = domain.domainException.get('errors').filter(e => {
      return e && e.severity === SEVERITY_LEVEL_WARN;
    });
    if (warnings && warnings.size > 0) {
      if (warnings.size > 1) {
        return 'Multiple fields may require your attention. Review the yellow highlighted fields above for more information.';
      } else {
        return warnings.get(0).fieldName + ' : ' + warnings.get(0).message;
      }
    }
  }
  return undefined;
}
function setDomainFields(domain, fields) {
  return domain.merge({
    fields: fields.map(field => {
      return DomainField.create({
        name: field.name,
        rangeURI: field.rangeURI
      });
    })
  });
}
function setDomainException(domain, exception, addRowIndexes = true, originalDomain) {
  const exceptionWithRowIndexes = addRowIndexes ? DomainException.addRowIndexesToErrors(originalDomain ?? domain, exception) : exception;
  const exceptionWithAllErrors = DomainException.mergeWarnings(domain, exceptionWithRowIndexes);
  return domain.set('domainException', exceptionWithAllErrors ? exceptionWithAllErrors : exception);
}
function getSplitSentence(label, lastWord) {
  if (!label) return undefined;
  const words = label.split(' ');
  if (lastWord) {
    if (words.length === 1) {
      return words[0];
    } else {
      return words[words.length - 1];
    }
  } else {
    if (words.length === 1) {
      return undefined;
    } else {
      return words.slice(0, words.length - 1).join(' ') + ' ';
    }
  }
}
function getDomainPanelStatus(panelIndex, currentIndex, visitedPanels, firstState) {
  if (panelIndex === 0 && firstState) {
    return 'NONE';
  } else if (currentIndex === panelIndex) {
    return 'INPROGRESS';
  } else if (visitedPanels.contains(panelIndex)) {
    return 'COMPLETE';
  }
  return 'TODO';
}
function getDomainBottomErrorMessage(exception, errorDomains, validProperties, visitedPanels) {
  if (exception) {
    return exception;
  } else if (errorDomains.size > 1 || errorDomains.size > 0 && !validProperties) {
    return 'Please correct errors above before saving.';
  } else if (visitedPanels.size > 0 && !validProperties) {
    return 'Please correct errors in the properties panel before saving.';
  } else if (errorDomains.size == 1) {
    return 'Please correct errors in ' + errorDomains.get(0) + ' before saving.';
  }
  return undefined;
}

// TODO: instead of setting a class based on isApp we should have generic collapsed/expanded classes and do all of the
//  app/LKS specific stuff in CSS, not JS. We can set a top level modifier class on BaseDomainDesigner indicate we're in
//  an app/LKS e.g. domain-designer--app, domain-designer--lks, then we can get rid of these methods and use the same
//  classNames everywhere
function getDomainPanelClass(collapsed, controlledCollapse, isApp) {
  return external_classnames_default()('panel', 'panel-default', 'domain-form-panel', {
    'lk-border-theme-light': !collapsed && controlledCollapse && !isApp,
    'domain-panel-no-theme': !collapsed && controlledCollapse && isApp
  });
}
function getDomainAlertClasses(collapsed, controlledCollapse, isApp) {
  return external_classnames_default()('domain-bottom-alert panel-default', {
    'lk-border-theme-light': !collapsed && controlledCollapse && !isApp,
    'domain-bottom-alert-expanded': !collapsed && controlledCollapse && isApp,
    'domain-bottom-alert-top': !collapsed
  });
}
function getDomainPanelHeaderId(domain, id) {
  if (domain && domain.name) {
    return createFormInputName(domain.name.replace(/\s/g, '-') + '-hdr');
  }
  return id || 'domain-header';
}
function getDomainHeaderName(name, headerTitle, headerPrefix) {
  let updatedName = headerTitle || (name ? name : 'Fields');

  // optionally trim off a headerPrefix from the name display
  if (headerPrefix && updatedName.indexOf(headerPrefix + ' ') === 0) {
    updatedName = updatedName.replace(headerPrefix + ' ', '');
  }

  // prefer "Results Fields" over "Data Fields"in assay case
  if (updatedName.endsWith('Data Fields')) {
    updatedName = updatedName.replace('Data Fields', 'Results Fields');
  }
  return updatedName;
}
function getUpdatedVisitedPanelsList(visitedPanels, index) {
  let updatedVisitedPanels = visitedPanels.merge([0]);
  if (!updatedVisitedPanels.contains(index)) {
    updatedVisitedPanels = updatedVisitedPanels.push(index);
  }
  return updatedVisitedPanels;
}
function updateOntologyDomainCols(fieldIndex, domainIndex, updatedDomain, origDomain, removedFieldIndexes, domainFieldType, domainFieldName) {
  const id = createFormInputId(domainFieldType, domainIndex, fieldIndex);
  const [changed, value] = getOntologyUpdatedFieldName(domainFieldName, updatedDomain, origDomain, removedFieldIndexes);
  if (changed) {
    updatedDomain = updateDomainField(updatedDomain, {
      id,
      value
    });
  }
  return updatedDomain;
}
function updateOntologyFieldProperties(fieldIndex, domainIndex, updatedDomain, origDomain, removedFieldIndexes) {
  // make sure it is still an ontology lookup data type field before changing anything
  const ontField = updatedDomain.fields.get(fieldIndex);
  if (ontField.dataType.isOntologyLookup()) {
    // if the concept field prop is set and the field's name or data type has changed, update it based on the updatedDomain
    if (ontField.conceptImportColumn) {
      updatedDomain = updateOntologyDomainCols(fieldIndex, domainIndex, updatedDomain, origDomain, removedFieldIndexes, DOMAIN_FIELD_ONTOLOGY_IMPORT_COL, ontField.conceptImportColumn);
    }
    if (ontField.conceptLabelColumn) {
      updatedDomain = updateOntologyDomainCols(fieldIndex, domainIndex, updatedDomain, origDomain, removedFieldIndexes, DOMAIN_FIELD_ONTOLOGY_LABEL_COL, ontField.conceptLabelColumn);
    }
  }
  return updatedDomain;
}

// get the new/updated field name for the ontology related property
// if it has been removed or changed to a non-string data type, return undefined
function getOntologyUpdatedFieldName(propFieldName, updatedDomain, origDomain, removedFieldIndexes) {
  // Check if field name and/or index have changed
  let origFieldIndex = origDomain.findFieldIndexByName(propFieldName);
  const updateFieldIndex = updatedDomain.findFieldIndexByName(propFieldName);
  const originalPropField = origDomain.fields.get(origFieldIndex);

  // check for a field removal prior to the ontology lookup field
  const propFieldRemoved = removedFieldIndexes ? removedFieldIndexes.some(removedField => removedField.originalIndex === origFieldIndex && removedField.newIndex === undefined) : !!removedFieldIndexes;
  if (removedFieldIndexes) {
    removedFieldIndexes.sort((a, b) => a.originalIndex - b.originalIndex);
    for (let i = 0; i < removedFieldIndexes.length; i++) {
      if (i + 1 < removedFieldIndexes.length && removedFieldIndexes[i + 1].originalIndex < origFieldIndex) {
        continue;
      } else if (origFieldIndex > removedFieldIndexes[i].originalIndex) {
        origFieldIndex = origFieldIndex - (i + 1);
      }
    }
  }
  const updatedPropField = updatedDomain.fields.get(origFieldIndex);
  const fieldChanged = propFieldRemoved || origFieldIndex !== updateFieldIndex || originalPropField.rangeURI !== updatedPropField?.rangeURI;
  return [fieldChanged, !propFieldRemoved && updatedPropField.dataType.isString() ? updatedPropField.name : undefined];
}
function getDomainNamePreviews(schemaQuery, domainId, containerPath) {
  return new Promise((resolve, reject) => {
    return api_.Domain.getDomainNamePreviews({
      containerPath,
      domainId,
      queryName: schemaQuery?.queryName,
      schemaName: schemaQuery?.schemaName,
      success: response => {
        resolve(response['previews']);
      },
      failure: response => {
        console.error('Failed to retrieve name expression previews', response);
        reject(response);
      }
    });
  });
}
async function getTextChoiceInUseValues(field, schemaName, queryName, lockedSqlFragment) {
  const containerFilter = api_.Query.ContainerFilter.allInProjectPlusShared; // to account for a shared domain at project or /Shared
  const fieldName = field.original?.name ?? field.name;

  // If the field is set as PHI, we need the query to include the RowId for logging, so we have to do the aggregate client side
  if (field.isPHI()) {
    const result = await selectRows({
      columns: ['RowId', 'SampleState/StatusType', fieldName],
      containerFilter,
      filterArray: [api_.Filter.create(fieldName, undefined, api_.Filter.Types.NONBLANK)],
      maxRows: -1,
      schemaQuery: new SchemaQuery(schemaName, queryName)
    });
    const values = {};
    result.rows.forEach(row => {
      const value = row[fieldName]?.value;
      if (isValidTextChoiceValue(value)) {
        if (!values[value]) {
          values[value] = {
            count: 0,
            locked: false
          };
        }
        values[value].count++;
        values[value].locked = values[value].locked || caseInsensitive(row, 'SampleState/StatusType').value === 'Locked';
      }
    });
    return values;
  }
  return new Promise((resolve, reject) => {
    api_.Query.executeSql({
      containerFilter,
      schemaName,
      sql: `SELECT "${fieldName}", ${lockedSqlFragment} AS IsLocked, COUNT(*) AS RowCount FROM "${queryName}" WHERE "${fieldName}" IS NOT NULL GROUP BY "${fieldName}"`,
      success: response => {
        const values = response.rows.filter(row => isValidTextChoiceValue(row[fieldName])).reduce((prev, current) => {
          prev[current[fieldName]] = {
            count: current['RowCount'],
            locked: current['IsLocked'] === 1
          };
          return prev;
        }, {});
        resolve(values);
      },
      failure: error => {
        console.error('Error fetching distinct values for the text field: ', error);
        reject(error);
      }
    });
  });
}
function getGenId(rowId, kindName, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Experiment.getEntitySequence({
      containerPath,
      rowId,
      kindName,
      seqType: 'genId',
      success: response => {
        if (response.success) {
          resolve(response['value']);
        } else {
          reject({
            error: 'Unable to get genId'
          });
        }
      },
      failure: error => {
        reject(error);
      }
    });
  });
}
function setGenId(rowId, kindName, genId, containerPath) {
  return new Promise((resolve, reject) => {
    return api_.Experiment.setEntitySequence({
      containerPath,
      rowId,
      kindName,
      newValue: genId,
      seqType: 'genId',
      success: response => {
        if (response.success) {
          resolve(response);
        } else {
          reject({
            error: response.error
          });
        }
      },
      failure: response => {
        reject(response);
      }
    });
  });
}
function scrollDomainErrorIntoView() {
  document.querySelector('#' + DOMAIN_ERROR_ID)?.scrollIntoView();
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/list/models.ts
function list_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function list_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? list_models_ownKeys(Object(t), !0).forEach(function (r) { list_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : list_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function list_models_defineProperty(e, r, t) { return (r = list_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function list_models_toPropertyKey(t) { var i = list_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function list_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





class ListModel extends (0,external_immutable_.Record)({
  exception: undefined,
  domain: undefined,
  entityId: undefined,
  createdBy: undefined,
  created: undefined,
  modifiedBy: undefined,
  modified: undefined,
  containerId: undefined,
  name: undefined,
  domainKindName: undefined,
  description: undefined,
  lastIndexed: undefined,
  keyName: undefined,
  titleColumn: undefined,
  domainId: undefined,
  keyType: undefined,
  discussionSetting: undefined,
  allowDelete: undefined,
  allowUpload: undefined,
  allowExport: undefined,
  entireListIndex: undefined,
  entireListIndexSetting: undefined,
  entireListTitleTemplate: undefined,
  entireListBodySetting: undefined,
  entireListBodyTemplate: undefined,
  eachItemIndex: undefined,
  eachItemTitleTemplate: undefined,
  eachItemBodySetting: undefined,
  eachItemBodyTemplate: undefined,
  fileAttachmentIndex: undefined,
  listId: undefined,
  discussionSettingEnum: undefined,
  containerPath: undefined,
  category: undefined
}) {
  static create(raw, defaultSettings = null) {
    if (defaultSettings) {
      const domain = DomainDesign.create(undefined);
      return new ListModel(list_models_objectSpread(list_models_objectSpread({}, defaultSettings), {}, {
        domain
      }));
    } else {
      let domain = DomainDesign.create(raw.domainDesign);

      // Issue39818: Set the key field of an existing list to be PKLocked.
      const fields = domain.fields;
      const pkField = fields.findIndex(i => i.isPrimaryKey);
      if (pkField > -1) {
        const pkFieldLocked = fields.get(pkField).merge({
          lockType: DOMAIN_FIELD_PRIMARY_KEY_LOCKED
        });
        const updatedFields = fields.set(pkField, pkFieldLocked);
        domain = domain.set('fields', updatedFields);
      }
      return new ListModel(list_models_objectSpread(list_models_objectSpread({}, raw.options), {}, {
        domain
      }));
    }
  }
  getDomainKind() {
    if (this.category === PUBLIC_PICKLIST_CATEGORY || this.category === PRIVATE_PICKLIST_CATEGORY) {
      return PICKLIST;
    } else if (this.keyType === 'Varchar') {
      return VAR_LIST;
    } else if (this.keyType === 'Integer' || this.keyType === 'AutoIncrementInteger') {
      return INT_LIST;
    }
    return undefined;
  }
  hasValidKeyType() {
    return this.getDomainKind() !== undefined;
  }
  isNew() {
    return !this.listId;
  }
  isValid() {
    return this.hasValidProperties() && this.hasValidKeyType() && !this.domain.hasInvalidFields();
  }
  hasValidProperties() {
    return this.name !== undefined && this.name !== null && this.name.trim().length > 0;
  }
  getOptions() {
    const options = this.toJS();

    // Note: keyName is primarily set using <SetKeyFieldNamePanel/>'s onSelectionChange()
    // Setting keyName here covers the use-case where a user sets a Key Field, and then changes its name
    const keyField = this.domain.fields.find(field => field.isPrimaryKey);
    if (keyField && this.keyName !== keyField.name) {
      options.keyName = keyField.name;
    }
    delete options.exception;
    delete options.domain;
    return options;
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/list/actions.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



function getListProperties(listId, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('list', 'getListProperties.api', containerPath),
      params: {
        listId
      },
      success: api_.Utils.getCallbackWrapper(data => {
        resolve(ListModel.create(null, data));
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        reject(error);
      })
    });
  });
}
function fetchListDesign(listId, containerPath) {
  return new Promise((resolve, reject) => {
    // first need to retrieve domainId, given a listId (or the default properties in the create case where listId is undefined)
    getListProperties(listId, containerPath).then(model => {
      // then we can use the getDomainDetails function to get the ListModel
      api_.Domain.getDomainDetails({
        containerPath,
        domainId: model.domainId,
        domainKind: listId === undefined ? INT_LIST : undefined,
        // NOTE there is also a VarList domain kind but for this purpose either will work
        success: data => {
          resolve(ListModel.create(data));
        },
        failure: error => {
          console.error(error);
          reject(error);
        }
      });
    }).catch(error => {
      console.error(error);
      reject(error);
    });
  });
}
function getListIdFromDomainId(domainId) {
  return new Promise((resolve, reject) => {
    api_.Domain.getDomainDetails({
      containerPath: (0,api_.getServerContext)().container.path,
      domainId,
      success: data => {
        const newModel = ListModel.create(data);
        resolve(newModel.listId);
      },
      failure: error => {
        console.error('Unable to retrieve list id for domainId: ' + domainId, error);
        reject(undefined);
      }
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/picklist/actions.ts
















function getPicklistsForInsert() {
  return new Promise((resolve, reject) => {
    const {
      queryName,
      schemaName
    } = SCHEMAS.LIST_METADATA_TABLES.PICKLISTS;
    selectRowsDeprecated({
      containerFilter: isProductProjectsEnabled() ? api_.Query.ContainerFilter.current : undefined,
      schemaName,
      queryName,
      sort: 'Name',
      filterArray: [api_.Filter.create('Category', null, api_.Filter.Types.NONBLANK)]
    }).then(response => {
      const {
        models,
        orderedModels
      } = response;
      const dataKey = resolveKey(schemaName, queryName);
      const data = models[dataKey];
      const picklists = [];
      orderedModels[dataKey].forEach(id => {
        picklists.push(Picklist.create(data[id]));
      });
      resolve(picklists);
    }).catch(reason => {
      console.error(reason);
      reject(reason);
    });
  });
}
function createPicklist(name, description, shared, selectionKey, useSnapshotSelection, sampleIds) {
  return new Promise((resolve, reject) => {
    api_.Domain.create({
      domainDesign: {
        name,
        fields: [{
          name: PICKLIST_SAMPLE_ID_COLUMN,
          rangeURI: 'int',
          required: true,
          lookupSchema: SCHEMAS.INVENTORY.SAMPLE_ITEMS.schemaName,
          lookupQuery: SCHEMAS.INVENTORY.SAMPLE_ITEMS.queryName
        }],
        indices: [{
          columnNames: [PICKLIST_SAMPLE_ID_COLUMN],
          unique: true
        }]
      },
      kind: PICKLIST,
      options: {
        keyName: PICKLIST_KEY_COLUMN,
        keyType: 'AutoIncrementInteger',
        description,
        category: shared ? PUBLIC_PICKLIST_CATEGORY : PRIVATE_PICKLIST_CATEGORY
      },
      success: response => {
        Promise.all([getListIdFromDomainId(response.domainId), addSamplesToPicklist(name, useSnapshotSelection, selectionKey, sampleIds)]).then(responses => {
          const [listId] = responses;
          resolve(new Picklist({
            Container: response.container,
            listId,
            name,
            Description: description,
            Category: shared ? PUBLIC_PICKLIST_CATEGORY : PRIVATE_PICKLIST_CATEGORY
          }));
        }).catch(error => {
          reject(error);
        });
      },
      failure: err => {
        reject(err);
      }
    });
  });
}
function updatePicklist(picklist) {
  return new Promise((resolve, reject) => {
    fetchListDesign(picklist.listId, picklist.Container).then(listDesign => {
      const domain = listDesign.domain;
      const options = {
        domainId: domain.domainId,
        name: picklist.name,
        keyName: 'id',
        keyType: 'AutoIncrementInteger',
        description: picklist.Description,
        category: picklist.Category
      };
      saveDomain({
        domain,
        kind: PICKLIST,
        name: picklist.name,
        options
      }).then(() => {
        resolve(picklist);
      }).catch(errorDomain => {
        console.error(errorDomain.domainException);
        reject(errorDomain.domainException);
      });
    }).catch(reason => {
      console.error(reason);
      reject(reason);
    });
  });
}
function getPicklistCountsBySampleType(listName) {
  return new Promise(async (resolve, reject) => {
    try {
      const {
        key,
        models,
        orderedModels
      } = await selectRowsDeprecated({
        schemaName: SCHEMAS.PICKLIST_TABLES.SCHEMA,
        queryName: listName,
        sql: ['SELECT COUNT(*) as ItemCount,', 'SampleId.SampleSet.Name AS SampleType,', 'SampleId.LabelColor', `FROM ${SCHEMAS.PICKLIST_TABLES.SCHEMA}."${listName}"`, 'WHERE SampleId.Name IS NOT NULL', 'GROUP BY SampleId.SampleSet.Name, SampleId.LabelColor', 'ORDER BY SampleId.SampleSet.Name'].join('\n')
      });
      const counts = orderedModels[key].map(idx => models[key][idx]).map(row => ({
        ItemCount: row.ItemCount.value,
        LabelColor: row.LabelColor.value,
        SampleType: row.SampleType.value
      })).toArray();
      resolve(counts);
    } catch (e) {
      console.error('Failed to get picklist counts by sample type', e);
      reject(e);
    }
  });
}
function getPicklistSamples(listName) {
  return new Promise((resolve, reject) => {
    const schemaName = SCHEMAS.PICKLIST_TABLES.SCHEMA;
    selectRowsDeprecated({
      schemaName,
      queryName: listName
    }).then(response => {
      const {
        models
      } = response;
      const dataKey = resolveKey(schemaName, listName);
      resolve(new Set(Object.values(models[dataKey]).map(row => row.SampleID.value.toString())));
    }).catch(reason => {
      console.error(reason);
      reject(reason);
    });
  });
}
function getOrderedSelectedPicklistSamples(queryModel, saveSnapshot) {
  const {
    queryName,
    queryParameters,
    selections,
    sortString,
    viewName,
    selectionKey
  } = queryModel;
  return getSelectedPicklistSamples(queryName, Array.from(selections), saveSnapshot, selectionKey, sortString, queryParameters, viewName);
}
function getSelectedPicklistSamples(picklistName, selectedIds, saveSnapshot, selectionKey, sorts, queryParameters, viewName) {
  return new Promise((resolve, reject) => {
    getOrderedSelectedMappedKeys(PICKLIST_KEY_COLUMN, PICKLIST_SAMPLE_ID_COLUMN, SCHEMAS.PICKLIST_TABLES.SCHEMA, picklistName, selectedIds, sorts, queryParameters, viewName).then(result => {
      const rowIds = result.mapFromValues;
      const sampleIds = result.mapToValues;
      if (saveSnapshot) {
        setSnapshotSelections(selectionKey, rowIds);
      }
      resolve(sampleIds);
    }).catch(reason => {
      console.error(reason);
      reject(reason);
    });
  });
}
async function getSamplesNotInList(listName, selectionKey, useSnapshotSelection, sampleIds) {
  const existingSamples = await getPicklistSamples(listName);
  if (sampleIds) {
    return sampleIds.filter(id => !existingSamples.has(id.toString()));
  } else if (selectionKey) {
    const response = await getSelected(selectionKey, useSnapshotSelection);
    return response.selected.filter(id => !existingSamples.has(id.toString()));
  }
  return [];
}
function addSamplesToPicklist(listName, useSnapshotSelection, selectionKey, sampleIds) {
  return new Promise((resolve, reject) => {
    return getSamplesNotInList(listName, selectionKey, useSnapshotSelection, sampleIds).then(sampleIdsToAdd => {
      let rows = (0,external_immutable_.List)();
      sampleIdsToAdd.forEach(id => {
        rows = rows.push({
          SampleID: id
        });
      });
      if (rows.size > 0) {
        insertRows({
          schemaQuery: new SchemaQuery('lists', listName),
          rows
        }).then(response => {
          resolve(response);
        }).catch(reason => reject(reason));
      } else {
        resolve(new QueryCommandResponse({
          rows: [],
          schemaQuery: new SchemaQuery('lists', listName),
          error: undefined,
          transactionAuditId: undefined
        }));
      }
    }).catch(reason => {
      reject(reason);
    });
  });
}
function getPicklistDeleteData(model, user) {
  return new Promise((resolve, reject) => {
    const columnString = 'Name,listId,category,createdBy';
    getSelectedData(model.schemaName, model.queryName, [...model.selections], columnString, undefined, undefined, undefined, 'ListId').then(response => {
      const {
        data
      } = response;
      let numNotDeletable = 0;
      let numShared = 0;
      const deletableLists = [];
      data.valueSeq().forEach(row => {
        const picklist = Picklist.create(row.toJS());
        if (picklist.isDeletable(user)) {
          if (picklist.isPublic()) {
            numShared++;
          }
          deletableLists.push(picklist);
        } else {
          numNotDeletable++;
        }
      });
      resolve({
        numDeletable: deletableLists.length,
        numNotDeletable,
        numShared,
        deletableLists
      });
    }).catch(reason => {
      console.error(reason);
      reject(reason);
    });
  });
}
function deletePicklists(picklists, selectionKey) {
  return new Promise((resolve, reject) => {
    let params;
    if (picklists.length === 1) {
      params = {
        listId: picklists[0].listId
      };
    } else if (selectionKey) {
      params = {
        dataRegionSelectionKey: selectionKey
      };
    } else {
      const listIds = [];
      picklists.forEach(picklist => {
        listIds.push(picklist.listId);
      });
      params = {
        listIds
      };
    }
    return api_.Ajax.request({
      url: buildURL('list', 'deleteListDefinition.api'),
      method: 'POST',
      params,
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(response);
      })
    });
  });
}
function getPicklistUrl(listId, picklistProductId, currentProductId) {
  let picklistUrl = AppURL.create(PICKLIST_KEY, listId).toHref();
  if (currentProductId && picklistProductId) {
    const url = createProductUrlFromParts(picklistProductId, currentProductId, {}, PICKLIST_KEY, listId);
    picklistUrl = url instanceof AppURL ? url.toHref() : url;
  }
  return picklistUrl;
}
const getPicklistFromId = async (listId, loadSampleTypes = true) => {
  const listData = await selectRowsDeprecated({
    containerFilter: getPicklistListingContainerFilter(),
    schemaName: SCHEMAS.LIST_METADATA_TABLES.PICKLISTS.schemaName,
    queryName: SCHEMAS.LIST_METADATA_TABLES.PICKLISTS.queryName,
    requiredColumns: ['Category'],
    filterArray: [api_.Filter.create('listId', listId)]
  });
  const listRow = listData.models[listData.key][listId];
  if (!listRow) return new Picklist( /* use empty picklist to signal not found */);
  let picklist = Picklist.create(listRow);
  if (loadSampleTypes) {
    const listSampleTypeData = await selectRowsDeprecated({
      schemaName: SCHEMAS.PICKLIST_TABLES.SCHEMA,
      sql: `SELECT DISTINCT SampleID.SampleSet, SampleID.SampleSet.Category FROM "${picklist.name}" WHERE SampleID.SampleSet IS NOT NULL`
    });
    picklist = picklist.mutate({
      sampleTypes: Object.values(listSampleTypeData.models[listSampleTypeData.key]).map(row => caseInsensitive(row, 'SampleSet')?.displayValue).filter(value => !!value)
    });
    picklist = picklist.mutate({
      hasMedia: !!Object.values(listSampleTypeData.models[listSampleTypeData.key]).find(row => caseInsensitive(row, 'Category')?.value === 'media')
    });
  }
  return picklist;
};
function getPicklistListingContainerFilter() {
  return isProductProjectsEnabled() ? api_.Query.ContainerFilter.current : undefined;
}
;// CONCATENATED MODULE: ./src/internal/components/auditlog/models.ts
function auditlog_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function auditlog_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? auditlog_models_ownKeys(Object(t), !0).forEach(function (r) { auditlog_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : auditlog_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function auditlog_models_defineProperty(e, r, t) { return (r = auditlog_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function auditlog_models_toPropertyKey(t) { var i = auditlog_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function auditlog_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2016-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */


class AuditDetailsModel extends (0,external_immutable_.Record)({
  rowId: undefined,
  comment: undefined,
  eventUserId: undefined,
  eventDateFormatted: undefined,
  oldData: undefined,
  newData: undefined,
  userComment: undefined
}) {
  static create(raw) {
    return new AuditDetailsModel(auditlog_models_objectSpread(auditlog_models_objectSpread({}, raw), {}, {
      oldData: raw.oldData ? (0,external_immutable_.fromJS)(raw.oldData) : undefined,
      newData: raw.newData ? (0,external_immutable_.fromJS)(raw.newData) : undefined
    }));
  }
  getActionLabel() {
    if (this.isUpdate()) return 'Updated';else if (this.isInsert()) return 'Created';else if (this.isDelete()) return 'Deleted';else return 'Updated';
  }
  isUpdate() {
    return this.oldData && this.newData && this.oldData.size > 0 && this.newData.size > 0;
  }
  isInsert() {
    return this.oldData && this.newData && this.oldData.size === 0 && this.newData.size > 0;
  }
  isDelete() {
    return this.oldData && this.newData && this.oldData.size > 0 && this.newData.size === 0;
  }
}
class TimelineEventModel extends (0,external_immutable_.Record)({
  rowId: undefined,
  eventType: undefined,
  subEventType: undefined,
  summary: undefined,
  user: undefined,
  eventUserId: undefined,
  timestamp: undefined,
  eventTimestamp: undefined,
  entity: undefined,
  entitySeparator: ' - ',
  metadata: undefined,
  oldData: undefined,
  newData: undefined,
  userComment: undefined
}) {
  // sample, assay, workflow, inventory, etc
  // for example, inventory item vs inventory storage location

  constructor(values) {
    super(values);
  }
  getRowKey() {
    return this.eventType + '|' + this.rowId;
  }

  // timezoneStr used for jest test only, to accommodate teamcity timezone difference
  static create(raw, timezoneStr) {
    const fields = {};
    fields.rowId = raw['rowId'];
    fields.eventType = raw['eventType'];
    fields.subEventType = raw['subEventType'];
    fields.summary = raw['summary'];
    fields.user = (0,external_immutable_.fromJS)(raw['user']);
    fields.eventUserId = raw['user']?.['value'];
    fields.timestamp = (0,external_immutable_.fromJS)(raw['timestamp']);
    if (raw['timestamp']['value']) fields.eventTimestamp = timezoneStr ? new Date(raw['timestamp']['value'] + ' ' + timezoneStr) : new Date(raw['timestamp']['value']);
    fields.entity = (0,external_immutable_.fromJS)(raw['entity']);
    fields.entitySeparator = raw['entitySeparator'];
    fields.userComment = raw['userComment'];
    if (raw.metadata) {
      const metaRows = [];
      for (const [key, value] of Object.entries(raw.metadata)) {
        metaRows.push({
          field: key,
          value: (0,external_immutable_.fromJS)(value)
        });
      }
      fields.metadata = (0,external_immutable_.fromJS)(metaRows);
    }
    if (raw.oldData) fields.oldData = (0,external_immutable_.fromJS)(raw.oldData);
    if (raw.newData) fields.newData = (0,external_immutable_.fromJS)(raw.newData);
    return new TimelineEventModel(fields);
  }
  getAuditDetailsModel() {
    if (!this.oldData && !this.newData) return undefined;
    return new AuditDetailsModel({
      rowId: this.rowId,
      oldData: this.oldData,
      newData: this.newData,
      userComment: this.userComment
    });
  }
  isSameEntity(event) {
    return this.entity && event.entity && this.entity.get('value') === event.entity.get('value');
  }
  getComment() {
    if (!this.metadata) return undefined;
    const commentField = this.metadata.find(metadataRow => metadataRow.get('field').toLowerCase() === 'reason');
    if (commentField) return commentField.get('value');
    return undefined;
  }
  getIcon() {
    let icon = this.eventType;
    if (ASSAYS_KEY === this.eventType) icon = 'assay';else if (this.eventType === 'inventory') {
      const summary = this.summary.toLowerCase();
      if (summary.indexOf('added to') > -1 || summary.indexOf('added location') > -1) icon = 'storage_insert';else if (summary.indexOf('discarded') > -1 || summary.indexOf('location deleted') > -1) icon = 'storage_remove';else if (summary.indexOf('checked in') > -1) icon = 'storage_checkin';else if (summary.indexOf('checked out') > -1) icon = 'storage_checkout';else if (summary.indexOf('moved') > -1) icon = 'storage_move';
      // for storage update events not associated with check in, use samples icon
      else icon = SAMPLES_KEY;
    }
    return icon;
  }
}
;// CONCATENATED MODULE: ./src/internal/components/samples/actions.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




















function getSampleSet(config) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('experiment', 'getSampleTypeApi.api'),
      params: config,
      success: api_.Utils.getCallbackWrapper(response => {
        resolve((0,external_immutable_.Map)(response));
      }),
      failure: handleRequestFailure(reject, 'Failed to fetch sample type')
    });
  });
}

// TODO: This should share implementation with api.domain.fetchDomainDetails / api.domain.getDataClassDetails
function getSampleTypeDetails(query, domainId, containerPath) {
  return new Promise((resolve, reject) => {
    return api_.Domain.getDomainDetails({
      containerPath,
      domainId,
      queryName: query ? query.queryName : undefined,
      schemaName: query ? query.schemaName : undefined,
      domainKind: query === undefined && domainId === undefined ? 'SampleSet' : undefined,
      success: response => {
        resolve(DomainDetails.create((0,external_immutable_.Map)(response)));
      },
      failure: response => {
        console.error(response);
        reject(response);
      }
    });
  });
}
function deleteSampleSet(rowId, containerPath, auditUserComment) {
  return deleteEntityType('deleteSampleTypes', rowId, containerPath, auditUserComment);
}

/**
 * Fetches an OrderedMap of Sample Type rows specified by a schemaQuery and collection of filters. This data
 * is mapped via the sampleColumn to make it compatible with editable grid data.
 * @param schemaQuery SchemaQuery which sources the request for rows
 * @param sampleColumn A QueryColumn used to map fieldKey, displayColumn, and keyColumn data
 * @param filterArray A collection of filters used when requesting rows
 * @param displayValueKey Column name containing grid display value of Sample Type
 * @param valueKey Column name containing grid value of Sample Type
 */
async function fetchSamples(schemaQuery, sampleColumn, filterArray, displayValueKey, valueKey) {
  const response = await selectRowsDeprecated({
    schemaName: schemaQuery.schemaName,
    queryName: schemaQuery.queryName,
    viewName: schemaQuery.viewName,
    columns: ['RowId', displayValueKey, valueKey],
    filterArray
  });
  const {
    key,
    models,
    orderedModels
  } = response;
  const rows = models[key];
  const data = (0,external_immutable_.OrderedMap)().asMutable();
  orderedModels[key].forEach(id => {
    data.setIn([id, sampleColumn.fieldKey], (0,external_immutable_.List)([{
      displayValue: caseInsensitive(rows[id], displayValueKey)?.value,
      value: caseInsensitive(rows[id], valueKey)?.value
    }]));
  });
  return data.asImmutable();
}

/**
 * Loads a collection of RowIds from a selectionKey found on "location". Uses [[fetchSamples]] to query and filter
 * the Sample Set data.
 * @param searchParams The URLSearchParams to search for the selectionKey on
 * @param sampleColumn A QueryColumn used to map data in [[fetchSamples]]
 */
async function loadSelectedSamples(searchParams, sampleColumn) {
  const workflowJobId = searchParams.get('workflowJobId');
  // If the "workflowJobId" URL parameter is specified, then fetch the samples associated with the workflow job.
  if (workflowJobId) {
    return fetchSamples(new SchemaQuery('sampleManagement', 'inputSamples'), sampleColumn, [api_.Filter.create('ApplicationType', 'ExperimentRun'), api_.Filter.create('ApplicationRun', workflowJobId)], 'Name', 'SampleId');
  }

  // Otherwise, load the samples from the selection.
  const selection = await getSelection(searchParams);
  if (selection.resolved && selection.schemaQuery && selection.selected.length) {
    const isPicklist = searchParams.get('isPicklist') === 'true';
    let sampleIdNums = selection.selected;
    if (isPicklist) {
      sampleIdNums = await getSelectedPicklistSamples(selection.schemaQuery.queryName, selection.selected, false);
    }
    const sampleSchemaQuery = isPicklist || selection.schemaQuery.isEqual(SCHEMAS.SAMPLE_MANAGEMENT.INPUT_SAMPLES_SQ) ? EXP_TABLES.MATERIALS : selection.schemaQuery;
    return fetchSamples(sampleSchemaQuery, sampleColumn, [api_.Filter.create('RowId', sampleIdNums, api_.Filter.Types.IN)], sampleColumn.lookup.displayColumn, sampleColumn.lookup.keyColumn);
  }
  return (0,external_immutable_.OrderedMap)();
}

/**
 * Get an array of sample RowIds from a URL selectionKey for the following scenarios:
 *  - sample grid
 *  - picklist
 *  - assay
 *  - storage items
 */
async function getSelectedSampleIdsFromSelectionKey(searchParams) {
  const key = searchParams.get('selectionKey');
  let sampleIds;
  const selectionType = searchParams.get('selectionKeyType');
  const isSnapshot = selectionType === SELECTION_KEY_TYPE.snapshot;
  if (selectionType === SELECTION_KEY_TYPE.inventoryItems) {
    const response = await getSnapshotSelections(key);
    sampleIds = await getSelectedItemSamples(response.selected);
  } else if (searchParams.get('isAssay')) {
    const schemaName = searchParams.get('assayProtocol');
    const sampleFieldKey = searchParams.get('sampleFieldKey');
    const queryName = SCHEMAS.ASSAY_TABLES.RESULTS_QUERYNAME;
    let response;
    if (isSnapshot) {
      response = await getSnapshotSelections(key);
    } else {
      response = await getSelection(searchParams, schemaName, queryName);
    }
    sampleIds = await getFieldLookupFromSelection(schemaName, queryName, response?.selected, sampleFieldKey);
  } else {
    const picklistName = searchParams.get('picklistName');
    let response;
    if (isSnapshot && key) {
      response = await getSnapshotSelections(key);
    } else {
      response = await getSelection(searchParams, SCHEMAS.PICKLIST_TABLES.SCHEMA, picklistName);
    }
    if (picklistName) {
      sampleIds = await getSelectedPicklistSamples(picklistName, response.selected, false, undefined);
    } else {
      sampleIds = response.selected.map(Number);
    }
  }
  return sampleIds;
}
async function getGroupedSampleDomainFields(sampleType) {
  const metaFields = [];
  const independentFields = [];
  const aliquotFields = [];
  const sampleTypeDomain = await getSampleTypeDetails(new SchemaQuery(SCHEMAS.SAMPLE_SETS.SCHEMA, sampleType));
  sampleTypeDomain.domainDesign.fields.forEach(field => {
    if (field.derivationDataScope === DERIVATION_DATA_SCOPES.CHILD_ONLY) {
      aliquotFields.push(field.name.toLowerCase());
    } else if (field.derivationDataScope === DERIVATION_DATA_SCOPES.ALL) {
      independentFields.push(field.name.toLowerCase());
    } else {
      metaFields.push(field.name.toLowerCase());
    }
  });
  return {
    aliquotFields,
    independentFields,
    metaFields,
    metricUnit: sampleTypeDomain.options.get('metricUnit')
  };
}
async function getSampleStorageId(sampleRowId) {
  const result = await selectRows({
    columns: 'RowId, SampleId',
    filterArray: [api_.Filter.create('SampleId', sampleRowId)],
    schemaQuery: SCHEMAS.INVENTORY.ITEM_SAMPLES
  });

  // allow rowId to be undefined, which means sample is not in storage
  if (result.rows.length === 0) {
    return undefined;
  }
  return caseInsensitive(result.rows[0], 'RowId').value;
}

// Used for samples and dataclasses
function getSelectionLineageData(selections, schema, query, viewName, columns) {
  if (selections?.size === 0) return Promise.reject('No data is selected.');
  const rowIds = Array.from(selections).map(s => parseInt(s, 10));
  return selectRowsDeprecated({
    schemaName: schema,
    queryName: query,
    viewName,
    columns: columns ?? external_immutable_.List.of('RowId', 'Name', 'LSID', 'Folder').concat(ParentEntityLineageColumns).toArray(),
    filterArray: [api_.Filter.create('RowId', rowIds, api_.Filter.Types.IN)]
  });
}
function isAliquotEditableField(colName) {
  return colName === 'name' || colName === 'description' || colName === 'materialexpdate' || isSampleStatusEnabled() && colName === 'samplestate';
}
function getGroupedSampleDisplayColumns(allDisplayColumns, allUpdateColumns, sampleTypeDomainFields, isAliquot, canBeInStorage) {
  const editColumns = [];
  const displayColumns = [];
  const aliquotHeaderDisplayColumns = [];
  allDisplayColumns.forEach(col => {
    const colName = col.name.toLowerCase();
    if (SAMPLE_STORAGE_COLUMNS_LC.indexOf(colName) > -1) {
      return;
    }
    if (AMOUNT_AND_UNITS_COLUMNS_LC.indexOf(colName) > -1 && canBeInStorage) {
      return;
    }
    if (isAliquot) {
      // barcodes belong to the individual sample or aliquot (but not both)
      if (col.conceptURI === STORAGE_UNIQUE_ID_CONCEPT_URI) {
        aliquotHeaderDisplayColumns.push(col);
      }
      // display parent meta for aliquot
      else if (sampleTypeDomainFields.aliquotFields.indexOf(colName) > -1 || sampleTypeDomainFields.independentFields.indexOf(colName) > -1) {
        aliquotHeaderDisplayColumns.push(col);
      }
    } else {
      if (sampleTypeDomainFields.aliquotFields.indexOf(colName) === -1) {
        displayColumns.push(col);
      }
    }
  });
  allUpdateColumns.forEach(col => {
    const colName = col.name.toLowerCase();
    if (SAMPLE_STORAGE_COLUMNS_LC.indexOf(colName) > -1) {
      return;
    }
    if (AMOUNT_AND_UNITS_COLUMNS_LC.indexOf(colName) > -1 && canBeInStorage) {
      return;
    }
    if (sampleTypeDomainFields.independentFields.indexOf(colName) > -1) {
      editColumns.push(col);
      return;
    }
    if (isAliquot) {
      if (sampleTypeDomainFields.aliquotFields.indexOf(colName) > -1) {
        editColumns.push(col);
      } else if (isAliquotEditableField(colName)) {
        editColumns.push(col);
      }
    } else {
      if (sampleTypeDomainFields.aliquotFields.indexOf(colName) === -1) {
        editColumns.push(col);
      }
    }
  });
  return {
    aliquotHeaderDisplayColumns,
    displayColumns,
    editColumns
  };
}
function saveIdsToFind(fieldType, ids, sessionKey) {
  // list of ids deduplicated and prefixed with the field type's storage prefix
  const prefixedIds = [];
  ids.map(id => fieldType.storageKeyPrefix + id).forEach(pid => {
    if (!prefixedIds.includes(pid)) {
      prefixedIds.push(pid);
    }
  });
  return new Promise((resolve, reject) => {
    if (prefixedIds.length > 0) {
      api_.Ajax.request({
        url: api_.ActionURL.buildURL('experiment', 'saveFindIds.api'),
        method: 'POST',
        jsonData: {
          ids: prefixedIds,
          sessionKey
        },
        success: api_.Utils.getCallbackWrapper(response => {
          if (response.success) {
            resolve(response.data);
          }
        }),
        failure: api_.Utils.getCallbackWrapper(error => {
          console.error('There was a problem saving the ids.', error);
          reject('There was a problem saving the ids. Your session may have expired.');
        })
      });
    } else {
      resolve(undefined);
    }
  });
}
function getSampleAliquotRows(sampleId) {
  return new Promise((resolve, reject) => {
    api_.Query.executeSql({
      containerFilter: getContainerFilter(),
      sql: `SELECT RowId, Name FROM materials WHERE RowId <> RootMaterialRowId AND RootMaterialRowId = ${sampleId}`,
      schemaName: SCHEMAS.EXP_TABLES.MATERIALS.schemaName,
      requiredVersion: 17.1,
      success: result => {
        resolve(result.rows);
      },
      failure: reason => {
        console.error(reason);
        reject(reason);
      }
    });
  });
}
function getSampleAssayResultViewConfigs() {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'getSampleAssayResultsViewConfigs.api'),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response.configs ?? []);
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(response);
      })
    });
  });
}
async function createSessionAssayRunSummaryQuery(sampleIds) {
  // issue with temp table re-use of queryName, invalidate cache to clear any queryDetails for old temp table
  invalidateFullQueryDetailsCache();
  let assayRunsQuery = 'AssayRunsPerSample';
  if (isProductProjectsEnabled() && !isProjectContainer()) {
    assayRunsQuery = 'AssayRunsPerSampleChildProject';
  }
  return await selectRowsDeprecated({
    saveInSession: true,
    schemaName: 'exp',
    sql: 'SELECT RowId, SampleID, SampleType, Assay, COUNT(*) AS RunCount\n' + "FROM (SELECT RowId, SampleID, SampleType, Assay || ' Run Count' AS Assay FROM " + assayRunsQuery + ') X\n' + 'WHERE RowId IN (' + sampleIds.join(',') + ')\n' + 'GROUP BY RowId, SampleID, SampleType, Assay\n' + 'PIVOT RunCount BY Assay',
    maxRows: 0 // we don't need any data back here, we just need to get the temp session schema/query
  });
}
async function getDistinctAssaysPerSample(sampleIds) {
  let assayRunsQuery = 'AssayRunsPerSample';
  if (isProductProjectsEnabled() && !isProjectContainer()) {
    assayRunsQuery = 'AssayRunsPerSampleChildProject';
  }
  try {
    const results = await selectDistinctRows({
      schemaName: SCHEMAS.EXP_TABLES.SCHEMA,
      queryName: assayRunsQuery,
      column: 'Assay',
      filterArray: [api_.Filter.create('RowId', sampleIds, api_.Filter.Types.IN)]
    });
    return results.values.filter(v => v !== null).map(v => v.toLowerCase());
  } catch (e) {
    // console.error already happens in failure case of selectDistinctRows
    return undefined;
  }
}
function getSampleStatuses(includeInUse = false, containerPath) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'getSampleStatuses.api', containerPath, {
        includeInUse
      }),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response.statuses?.map(state => new SampleState(state)) ?? []);
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(response);
      })
    });
  });
}

/**
 * The default status for a discarded sample should be Consumed. This method compensates for the
 * possibility that there may be more than one sample status with of type 'consumed'.
 * - If there is only one status of type 'consumed', this is the default, regardless of the label
 * - If there are multiple 'consumed' statuses, use the one labeled 'Consumed' as the default, if it exists.
 * - In other cases, do not choose a default.
 */
async function getDefaultDiscardStatus(containerPath) {
  try {
    const allStatuses = await getSampleStatuses(false, containerPath);
    const consumedStatuses = allStatuses.filter(state => state.stateType === SampleStateType.Consumed);
    if (consumedStatuses.length === 1) {
      return consumedStatuses[0].rowId;
    }
    const consumedLabels = consumedStatuses.filter(status => status.label.toLowerCase() === SampleStateType.Consumed.toLowerCase());
    if (consumedLabels.length === 1) {
      return consumedLabels[0].rowId;
    }
    return undefined;
  } catch (error) {
    return undefined;
  }
}

/**
 * Gets the Set of Ids from selected rowIds based on supplied fieldKey which should be a Lookup
 * @param schemaName of selected rows
 * @param queryName of selected rows
 * @param selected rowIds to pull sampleIds for
 * @param fieldKey field key for the Lookup
 */
async function getFieldLookupFromSelection(schemaName, queryName, selected, fieldKey) {
  const sampleIds = new Set();
  if (fieldKey) {
    const rowIdFieldKey = `${fieldKey}/RowId`; // Pull the rowId of the lookup
    const {
      data,
      dataIds
    } = await getSelectedData(schemaName, queryName, selected, 'RowId,' + rowIdFieldKey); // Include the RowId column to prevent warnings
    if (data) {
      const rows = data.toJS();
      dataIds.forEach(rowId => {
        const val = rows[rowId]?.[rowIdFieldKey]?.value;
        if (val) {
          sampleIds.add(val);
        }
      });
    }
  }
  return [...sampleIds];
}

// optional timezone param used for teamcity jest test only
function getTimelineEvents(sampleId, timezone) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'getTimeline.api'),
      params: {
        sampleId
      },
      success: api_.Utils.getCallbackWrapper(response => {
        if (response.success) {
          const events = [];
          if (response.events) {
            response.events.forEach(event => events.push(TimelineEventModel.create(event, timezone)));
          }
          resolve(events);
        } else {
          console.error('Sample timeline is empty. Timeline audit may have been disabled.');
          reject('There was a problem retrieving the sample timeline. Timeline audit may have been disabled.');
        }
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        console.error('Problem retrieving the sample timeline', error);
        reject('There was a problem retrieving the sample timeline.');
      })
    });
  });
}
function updateSampleStorageData(sampleStorageData, containerPath, userComment) {
  if (sampleStorageData.length === 0) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('inventory', 'updateSampleStorageData.api', undefined, {
        container: containerPath
      }),
      jsonData: {
        sampleRows: sampleStorageData,
        [STORED_AMOUNT_FIELDS.AUDIT_COMMENT]: userComment
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(resolveErrorMessage(response));
      })
    });
  });
}
function getSampleCounter(seqType, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Experiment.getEntitySequence({
      containerPath,
      seqType,
      kindName: 'SampleSet',
      success: response => {
        if (response.success) {
          resolve(response['value']);
        } else {
          reject({
            error: 'Unable to get ' + seqType
          });
        }
      },
      failure: error => {
        reject(error);
      }
    });
  });
}
function saveSampleCounter(newCount, seqType, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Experiment.setEntitySequence({
      newValue: newCount,
      containerPath,
      seqType,
      kindName: 'SampleSet',
      success: response => {
        if (response.success) {
          resolve(response);
        } else {
          console.error(response);
          reject(response.error);
        }
      },
      failure: error => {
        console.error(error);
        reject(resolveErrorMessage(error));
      }
    });
  });
}
function hasExistingSamples(isRoot, containerPath) {
  let dataCountSql = 'SELECT m.Name As SampleName ' + '\n' + 'FROM materials m WHERE EXISTS ' + '\n' + '( SELECT * FROM materials mi WHERE mi.RowId = m.RowId';
  if (isRoot) dataCountSql += ' AND mi.RootMaterialRowId = mi.RowId';
  dataCountSql += ')';
  return new Promise((resolve, reject) => {
    api_.Query.executeSql({
      containerPath,
      containerFilter: api_.Query.ContainerFilter.allInProject,
      schemaName: SCHEMAS.EXP_TABLES.SCHEMA,
      sql: dataCountSql,
      success: async data => {
        resolve(!!data.rows[0]?.SampleName);
      },
      failure: error => {
        reject(error);
      }
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/samples/APIWrapper.ts
function samples_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function samples_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? samples_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { samples_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : samples_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function samples_APIWrapper_defineProperty(e, r, t) { return (r = samples_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function samples_APIWrapper_toPropertyKey(t) { var i = samples_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function samples_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class SamplesServerAPIWrapper {
  constructor() {
    samples_APIWrapper_defineProperty(this, "createSessionAssayRunSummaryQuery", createSessionAssayRunSummaryQuery);
    samples_APIWrapper_defineProperty(this, "getGroupedSampleDomainFields", getGroupedSampleDomainFields);
    samples_APIWrapper_defineProperty(this, "getSampleAliquotRows", getSampleAliquotRows);
    samples_APIWrapper_defineProperty(this, "getSampleAssayResultViewConfigs", getSampleAssayResultViewConfigs);
    samples_APIWrapper_defineProperty(this, "getSelectionLineageData", getSelectionLineageData);
    samples_APIWrapper_defineProperty(this, "getSampleStatuses", getSampleStatuses);
    samples_APIWrapper_defineProperty(this, "getDefaultDiscardStatus", getDefaultDiscardStatus);
    samples_APIWrapper_defineProperty(this, "getSampleOperationConfirmationData", getSampleOperationConfirmationData);
    samples_APIWrapper_defineProperty(this, "getSampleStorageId", getSampleStorageId);
    samples_APIWrapper_defineProperty(this, "getFieldLookupFromSelection", getFieldLookupFromSelection);
    samples_APIWrapper_defineProperty(this, "getTimelineEvents", getTimelineEvents);
    samples_APIWrapper_defineProperty(this, "getSampleTypeDetails", getSampleTypeDetails);
    samples_APIWrapper_defineProperty(this, "getDistinctAssaysPerSample", getDistinctAssaysPerSample);
    samples_APIWrapper_defineProperty(this, "getSampleCounter", getSampleCounter);
    samples_APIWrapper_defineProperty(this, "saveSampleCounter", saveSampleCounter);
    samples_APIWrapper_defineProperty(this, "hasExistingSamples", hasExistingSamples);
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getSamplesTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return samples_APIWrapper_objectSpread({
    createSessionAssayRunSummaryQuery: mockFn(),
    getGroupedSampleDomainFields: mockFn(),
    getSampleAliquotRows: mockFn(),
    getSampleAssayResultViewConfigs: mockFn(),
    getSelectionLineageData: mockFn(),
    getSampleStatuses: mockFn(),
    getDefaultDiscardStatus: mockFn(),
    getSampleOperationConfirmationData: mockFn(),
    getSampleStorageId: mockFn(),
    getFieldLookupFromSelection: mockFn(),
    getTimelineEvents: mockFn(),
    getSampleTypeDetails: mockFn(),
    getDistinctAssaysPerSample: mockFn(),
    getSampleCounter: mockFn(),
    saveSampleCounter: mockFn(),
    hasExistingSamples: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/components/picklist/APIWrapper.ts
function picklist_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function picklist_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? picklist_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { picklist_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : picklist_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function picklist_APIWrapper_defineProperty(e, r, t) { return (r = picklist_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function picklist_APIWrapper_toPropertyKey(t) { var i = picklist_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function picklist_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class PicklistServerAPIWrapper {
  constructor() {
    picklist_APIWrapper_defineProperty(this, "getPicklistCountsBySampleType", getPicklistCountsBySampleType);
    picklist_APIWrapper_defineProperty(this, "getPicklistDeleteData", getPicklistDeleteData);
    picklist_APIWrapper_defineProperty(this, "getPicklistFromId", getPicklistFromId);
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getPicklistTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return picklist_APIWrapper_objectSpread({
    getPicklistCountsBySampleType: () => Promise.resolve([]),
    getPicklistDeleteData: mockFn(),
    getPicklistFromId: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/public/QueryModel/utils.ts
/**
 * Returns value if it is not undefined, or defaultValue.
 * @param value
 * @param defaultValue
 */



function filterToString(filter) {
  return `${filter.getColumnName()}-${filter.getFilterType().getURLSuffix()}-${filter.getValue()}`;
}
function filtersEqual(a, b) {
  return filterToString(a) === filterToString(b);
}
function filterArraysEqual(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  const aStr = a.map(filterToString).sort().join(';');
  const bStr = b.map(filterToString).sort().join(';');
  return aStr === bStr;
}
function sortsEqual(a, b) {
  return a.toRequestString() === b.toRequestString();
}
function sortArraysEqual(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  const aStr = a.map(qs => qs.toRequestString()).sort().join(';');
  const bStr = b.map(qs => qs.toRequestString()).sort().join(';');
  return aStr === bStr;
}
function actionValuesToString(actionValues) {
  return actionValues.map(actionValue => actionValue.value.toString()).sort().join(';');
}

/**
 * Returns the columns needed to render an Assay Run Details Page. Adapted from components/assay/actions.ts
 * getRunDetailsQueryColumns
 * @param model: QueryModel
 * @param reRunSupport: string
 */
function runDetailsColumnsForQueryModel(model, reRunSupport) {
  let columns = model.displayColumns;
  const includeRerunColumns = reRunSupport === 'ReRunAndReplace';
  const replacedByIndex = columns.findIndex(col => col.fieldKey === 'ReplacedByRun');
  if (replacedByIndex > -1) {
    if (includeRerunColumns) {
      // Direct manipulation by index is ok here because displayColumns returns a new array every time.
      columns[replacedByIndex] = columns[replacedByIndex].mutate({
        detailRenderer: 'assayrunreference'
      });
    } else {
      columns = columns.filter((col, index) => replacedByIndex !== index);
    }
  }
  if (includeRerunColumns) {
    const replaces = model.getColumn('ReplacesRun');
    if (replaces) {
      const column = replaces.mutate({
        detailRenderer: 'assayrunreference'
      });
      if (replacedByIndex > -1) {
        columns = [...columns.slice(0, replacedByIndex + 1), column, ...columns.slice(replacedByIndex)];
      } else {
        columns.push(column);
      }
    }
  }
  return columns;
}
function getQueryModelExportParams(model, type, advancedOptions) {
  const {
    containerFilter,
    containerPath,
    exportColumnString,
    filters,
    hasSelections,
    schemaQuery,
    sortString,
    selectionKey,
    queryParameters
  } = model;
  const exportOptions = {
    filters: (0,external_immutable_.List)(filters),
    columns: exportColumnString,
    containerFilter,
    containerPath,
    sorts: sortString,
    selectionKey,
    showRows: hasSelections ? 'SELECTED' : 'ALL'
  };
  return getExportParams(type, schemaQuery, exportOptions, advancedOptions, queryParameters);
}
function getSelectRowCountColumnsStr(rawColumns, filterArray, pkCols) {
  if (!rawColumns || rawColumns === '*') return rawColumns;
  if (filterArray?.length > 0) {
    const qFilter = filterArray.some(filter => filter.getColumnName() === '*');
    if (qFilter) return rawColumns;
  }
  if (pkCols?.length > 0) {
    return pkCols[0].fieldKey;
  }
  const columns = typeof rawColumns === 'string' ? rawColumns.split(',').map(col => col.trim()) : rawColumns;
  return columns[0];
}
;// CONCATENATED MODULE: ./src/internal/components/labelPrinting/constants.ts

const BAR_TENDER_TOPIC = 'barTender';
const LABEL_NOT_FOUND_ERROR = "The supplied label template contains an error or was not found. Please check the template, filename, and the BarTender service's configured path.";
const BARTENDER_CONFIGURATION_TITLE = 'BarTender Web Service Configuration';
const LABEL_TEMPLATES_LIST_NAME = 'LabelTemplates';
const LABEL_TEMPLATE_SQ = new SchemaQuery('lists', LABEL_TEMPLATES_LIST_NAME);
;// CONCATENATED MODULE: ./src/internal/components/labelPrinting/models.ts
function labelPrinting_models_defineProperty(e, r, t) { return (r = labelPrinting_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function labelPrinting_models_toPropertyKey(t) { var i = labelPrinting_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function labelPrinting_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class BarTenderConfiguration {
  constructor(values) {
    labelPrinting_models_defineProperty(this, external_immer_.immerable, true);
    labelPrinting_models_defineProperty(this, "serviceURL", void 0);
    labelPrinting_models_defineProperty(this, "defaultLabel", void 0);
    Object.assign(this, values);
  }
  static create(config) {
    return new BarTenderConfiguration({
      serviceURL: config.serviceURL,
      defaultLabel: parseInt(config.defaultLabel, 10)
    });
  }
  isConfigured() {
    return this.serviceURL !== undefined && this.serviceURL !== null && this.serviceURL.trim() !== '';
  }
}
var BarTenderResponseStatus = /*#__PURE__*/function (BarTenderResponseStatus) {
  BarTenderResponseStatus["Faulted"] = "Faulted";
  BarTenderResponseStatus["RanToCompletion"] = "RanToCompletion";
  return BarTenderResponseStatus;
}(BarTenderResponseStatus || {});
/*
BarTender Web Service responses settings configured as:
ContentType-Type = application/json
Source = Action Summary

Example response bodies:
Success:
    {
        "Version": "1.0",
        "Status": "RanToCompletion",
        "WaitStatus": "Completed",
        "Validated": true,
        "Messages": []
    }

Label Template not found:
    {
        "Version": "1.0",
        "Status": "Faulted",
        "WaitStatus": "Faulted",
        "Validated": true,
        "Messages": [
            {
                "ActionName": null,
                "Level": 4,
                "Text": "Failed to run action 'Print BTXML Script'. Details: BarTender document 'C:\\BarTenderDocs\\notFoundTest' does not exist or can not be accessed."
            }
        ]
    }
 */
class BarTenderResponse {
  constructor(values) {
    labelPrinting_models_defineProperty(this, external_immer_.immerable, true);
    labelPrinting_models_defineProperty(this, "Messages", void 0);
    labelPrinting_models_defineProperty(this, "Status", void 0);
    labelPrinting_models_defineProperty(this, "Version", void 0);
    labelPrinting_models_defineProperty(this, "WaitStatus", void 0);
    Object.assign(this, values);
  }
  ranToCompletion() {
    return this.Status === BarTenderResponseStatus.RanToCompletion;
  }
  faulted() {
    return this.Status === BarTenderResponseStatus.Faulted;
  }
  getFaultMessage() {
    return this.Messages.map(msg => msg.Text).join('\n');
  }
  isLabelUnavailableError() {
    // best we can do is to look in the error message as this doesn't have a specific property to indicate this error
    const message = this.getFaultMessage();
    return message.indexOf(BarTenderResponse.LABEL_NOT_FOUND_MSG) >= 0;
  }
}

// LabKey model for Label Template
labelPrinting_models_defineProperty(BarTenderResponse, "LABEL_NOT_FOUND_MSG", 'does not exist or can not be accessed');
class LabelTemplate {
  constructor(values) {
    labelPrinting_models_defineProperty(this, external_immer_.immerable, true);
    labelPrinting_models_defineProperty(this, "description", void 0);
    labelPrinting_models_defineProperty(this, "rowId", void 0);
    labelPrinting_models_defineProperty(this, "name", void 0);
    labelPrinting_models_defineProperty(this, "path", void 0);
    labelPrinting_models_defineProperty(this, "container", void 0);
    Object.assign(this, values);
  }
  set(prop, val) {
    return this.mutate({
      [prop]: val
    });
  }
  mutate(props) {
    return (0,external_immer_.produce)(this, draft => {
      Object.assign(draft, props);
    });
  }
  static create(row) {
    const fieldValues = flattenValuesFromRow(row, Object.keys(row));
    return new LabelTemplate({
      path: fieldValues.path,
      rowId: fieldValues.rowId,
      name: fieldValues.name,
      description: fieldValues.description,
      container: fieldValues.container
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/components/labelPrinting/APIWrapper.ts
function labelPrinting_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function labelPrinting_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? labelPrinting_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { labelPrinting_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : labelPrinting_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function labelPrinting_APIWrapper_defineProperty(e, r, t) { return (r = labelPrinting_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function labelPrinting_APIWrapper_toPropertyKey(t) { var i = labelPrinting_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function labelPrinting_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










function handleBarTenderConfigurationResponse(resolve) {
  return api_.Utils.getCallbackWrapper(({
    btConfiguration
  }) => resolve(BarTenderConfiguration.create(btConfiguration)));
}
class LabelPrintingServerAPIWrapper {
  constructor() {
    labelPrinting_APIWrapper_defineProperty(this, "createLabelTemplateList", containerPath => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'ensureLabelTemplateList.api', containerPath),
          method: 'POST',
          success: () => {
            resolve([]);
          },
          failure: handleRequestFailure(reject, 'Failed to ensure label template list')
        });
      });
    });
    // TODO: This endpoint handler does too much
    labelPrinting_APIWrapper_defineProperty(this, "ensureLabelTemplatesList", async (user, containerPath) => {
      try {
        return await this.getLabelTemplates(containerPath);
      } catch (reason) {
        if (reason.status !== 404) {
          return undefined;
        }
        if (!user.isAppAdmin()) {
          console.error('User has insufficient permissions to create the template list. Please contact administrator');
          return undefined;
        }
      }
      try {
        // try to create list
        return await this.createLabelTemplateList(containerPath);
      } catch (reason) {
        console.error(reason);
        return undefined;
      }
    });
    /** Retrieve the BarTender web service configuration from the server */
    labelPrinting_APIWrapper_defineProperty(this, "fetchBarTenderConfiguration", containerPath => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'getBarTenderConfiguration.api', containerPath),
          success: handleBarTenderConfigurationResponse(resolve),
          failure: handleRequestFailure(reject, 'There was a problem getting the BarTender configuration.')
        });
      });
    });
    /**
     * Makes a request to the configured BarTender Web Service to print labels.
     * @param btxml body of request
     * @param serviceURL to make request to
     */
    labelPrinting_APIWrapper_defineProperty(this, "printBarTenderLabels", (btxml, serviceURL) => {
      return new Promise((resolve, reject) => {
        // Due to CORS conflicts we can't use the normal Ajax.request utility method. BT service doesn't currently support preflight OPTIONS checks to properly support CORS request.
        // So we use a custom xhr and headers, to make "simple" request. This also prevents sharing the normal custom LabKey headers.
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = false; // If true, will cause the CORS policy to be triggered and we are not currently supporting auth

        xhr.addEventListener('readystatechange', function () {
          if (this.readyState === 4) {
            const success = xhr.status >= 200 && xhr.status < 300 || xhr.status === 304;
            // TODO: look at this for when the response is alternatively (xml vs json) configured.
            success ? resolve(new BarTenderResponse(JSON.parse(xhr.responseText))) : reject(xhr);
          }
        });
        xhr.open('POST', serviceURL);
        xhr.setRequestHeader('Content-Type', 'text/plain'); // This won't trigger the CORS requirements
        xhr.send(btxml);
      });
    });
    /**
     * Make request to get request body data for the BarTender print service
     * @param sampleModel of the samples to print
     * @param labelFormat filename to use with BarTender
     * @param numCopies to print
     * @param serverURL of the BarTender service
     */
    labelPrinting_APIWrapper_defineProperty(this, "printGridLabels", (sampleModel, labelFormat, numCopies, serverURL) => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'printBarTenderLabels.api'),
          params: getQueryModelExportParams(sampleModel, EXPORT_TYPES.LABEL, labelPrinting_APIWrapper_objectSpread(labelPrinting_APIWrapper_objectSpread({}, SAMPLE_EXPORT_CONFIG), {}, {
            labelFormat,
            numCopies,
            // We override the showRows value because of the strange default behavior for grid export that
            // exports all rows if you can have selections but have selected no items in the grid
            'query.showRows': ['SELECTED']
          })),
          success: request => {
            this.printBarTenderLabels(request.response, serverURL).then(resolve).catch(reject);
          },
          failure: handleRequestFailure(reject, 'Failed to print BarTender labels')
        });
      });
    });
    /**
     * Save the BarTender configuration to server properties
     */
    labelPrinting_APIWrapper_defineProperty(this, "saveBarTenderURLConfiguration", (btConfig, containerPath) => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'saveBarTenderURLConfiguration.api', containerPath),
          method: 'POST',
          jsonData: {
            serviceURL: btConfig.serviceURL
          },
          success: handleBarTenderConfigurationResponse(resolve),
          failure: handleRequestFailure(reject, 'Error saving BarTender service URL')
        });
      });
    });
    labelPrinting_APIWrapper_defineProperty(this, "saveDefaultLabelConfiguration", btConfig => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'saveDefaultLabelConfiguration.api'),
          method: 'POST',
          jsonData: {
            defaultLabel: btConfig.defaultLabel
          },
          success: handleBarTenderConfigurationResponse(resolve),
          failure: handleRequestFailure(reject, 'Error saving the Default Label selection')
        });
      });
    });
    labelPrinting_APIWrapper_defineProperty(this, "getLabelTemplates", async containerPath => {
      const result = await selectRows({
        containerPath,
        schemaQuery: LABEL_TEMPLATE_SQ
      });
      return result.rows.map(row => LabelTemplate.create(row));
    });
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getLabelPrintingTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return labelPrinting_APIWrapper_objectSpread({
    createLabelTemplateList: mockFn(),
    ensureLabelTemplatesList: () => Promise.resolve([]),
    fetchBarTenderConfiguration: () => Promise.resolve(new BarTenderConfiguration({
      serviceURL: ''
    })),
    getLabelTemplates: () => Promise.resolve([]),
    printBarTenderLabels: mockFn(),
    printGridLabels: mockFn(),
    saveBarTenderURLConfiguration: mockFn(),
    saveDefaultLabelConfiguration: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/components/administration/constants.ts


const SITE_SECURITY_ROLES = (0,external_immutable_.Map)([[api_.PermissionRoles.ApplicationAdmin, 'Application Administrator']]);
const APPLICATION_SECURITY_ROLES = (0,external_immutable_.Map)([[api_.PermissionRoles.ProjectAdmin, 'Project Administrator'], [api_.PermissionRoles.FolderAdmin, 'Folder Administrator'], [api_.PermissionRoles.Editor, 'Editor'], [api_.PermissionRoles.EditorWithoutDelete, 'Editor without Delete'], [api_.PermissionRoles.Reader, 'Reader']]);
const ASSAY_DESIGNER_ROLE = 'org.labkey.assay.security.AssayDesignerRole';
const DATA_CLASS_DESIGNER_ROLE = 'org.labkey.experiment.security.DataClassDesignerRole';
const SAMPLE_TYPE_DESIGNER_ROLE = 'org.labkey.experiment.security.SampleTypeDesignerRole';
const APPLICATION_ROLES_LABELS = {
  [DATA_CLASS_DESIGNER_ROLE]: 'Source Type Designer'
};
const APPLICATION_ROLES_DESCRIPTIONS = {
  [DATA_CLASS_DESIGNER_ROLE]: 'Source, Registry & Data Class designers can create and design new data classes or change existing ones.'
};
;// CONCATENATED MODULE: ./src/internal/components/administration/models.ts
let MemberType = /*#__PURE__*/function (MemberType) {
  MemberType["group"] = "g";
  MemberType["siteGroup"] = "sg";
  MemberType["user"] = "u";
  return MemberType;
}({});
;// CONCATENATED MODULE: ./src/internal/components/permissions/models.tsx
function permissions_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function permissions_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? permissions_models_ownKeys(Object(t), !0).forEach(function (r) { permissions_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : permissions_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function permissions_models_defineProperty(e, r, t) { return (r = permissions_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function permissions_models_toPropertyKey(t) { var i = permissions_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function permissions_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2015-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */



class Principal extends (0,external_immutable_.Record)({
  userId: undefined,
  name: undefined,
  displayName: undefined,
  type: undefined,
  active: true,
  isSiteGroup: false
}) {
  static create(raw) {
    return new Principal(permissions_models_objectSpread({}, raw));
  }
  static createFromSelectRow(row) {
    const userId = row.getIn(['UserId', 'value']);
    const type = row.getIn(['Type', 'value']);
    const name = row.getIn(['Name', 'value']);
    let displayName = row.getIn(['DisplayName', 'value']);
    displayName = type === MemberType.user && displayName ? name + ' (' + displayName + ')' : name;
    return new Principal({
      userId,
      name,
      type,
      displayName
    });
  }
  static filterAndSort(principals, groupMembership, excludeUserIds) {
    return principals
    // filter out any principals that are already members of this role, and built-in site groups
    .filter(principal => (excludeUserIds === undefined || !excludeUserIds.contains(principal.userId)) && principal.userId > 0)
    // Supply information on whether a principal is a site group or not
    .map(principal => groupMembership && groupMembership[principal.userId]?.type === MemberType.siteGroup ? principal.set('isSiteGroup', true) : principal)
    // finally sort by type (group or user) and then display name
    .sort((p1, p2) => naturalSort(p1.displayName, p2.displayName)).toList();
  }
}
class SecurityRole extends (0,external_immutable_.Record)({
  description: undefined,
  displayName: undefined,
  excludedPrincipals: (0,external_immutable_.List)(),
  name: undefined,
  permissions: (0,external_immutable_.List)(),
  sourceModule: undefined,
  uniqueName: undefined
}) {
  static create(raw) {
    let excludedPrincipals = (0,external_immutable_.List)();
    if (raw.excludedPrincipals) {
      excludedPrincipals = (0,external_immutable_.List)(raw.excludedPrincipals);
    }
    let permissions = (0,external_immutable_.List)();
    if (raw.permissions) {
      permissions = (0,external_immutable_.List)(raw.permissions);
    }
    return new SecurityRole(permissions_models_objectSpread(permissions_models_objectSpread({}, raw), {}, {
      excludedPrincipals,
      permissions
    }));
  }

  // use the explicit set of roles, fall back to the relevant roles for the policy
  static filter(roles, policy, rolesToShow, rolesHidden) {
    return roles.filter(role => {
      return policy.relevantRoles.contains(role.uniqueName) && (!rolesToShow || rolesToShow.contains(role.uniqueName)) && (!rolesHidden || rolesHidden.indexOf(role.uniqueName) === -1);
    }).toList();
  }
}
class SecurityAssignment extends (0,external_immutable_.Record)({
  role: undefined,
  userId: undefined,
  displayName: undefined,
  type: undefined,
  isNew: false
}) {
  static isTypeMatch(assignmentType, typeToMatch) {
    // inactive users will return type of undefined
    if (typeToMatch === MemberType.user && assignmentType === undefined) {
      return true;
    }
    return assignmentType === typeToMatch;
  }
  static getDisplayName(assignment) {
    // inactive users will return type of undefined
    if (assignment.type === undefined) {
      return 'Inactive User: ' + assignment.userId;
    }
    return assignment.displayName || assignment.userId.toString();
  }
}
class SecurityPolicy extends (0,external_immutable_.Record)({
  assignments: (0,external_immutable_.List)(),
  assignmentsByRole: (0,external_immutable_.Map)(),
  modified: undefined,
  resourceId: undefined,
  relevantRoles: (0,external_immutable_.List)(),
  containerId: undefined
}) {
  static create(raw) {
    let assignments = (0,external_immutable_.List)();
    if (raw.policy && raw.policy.assignments) {
      assignments = (0,external_immutable_.List)(raw.policy.assignments.map(assignment => new SecurityAssignment(assignment)));
    }
    let relevantRoles = (0,external_immutable_.List)();
    if (raw.relevantRoles) {
      relevantRoles = (0,external_immutable_.List)(raw.relevantRoles);
    }
    return new SecurityPolicy(permissions_models_objectSpread(permissions_models_objectSpread({}, raw.policy), {}, {
      assignments,
      assignmentsByRole: SecurityPolicy.getAssignmentsByRole(assignments),
      relevantRoles,
      containerId: raw.containerId
    }));
  }
  static getAssignmentsByRole(assignments) {
    let assignmentsByRole = (0,external_immutable_.Map)();
    assignments.map(assignment => {
      if (!assignmentsByRole.has(assignment.role)) {
        assignmentsByRole = assignmentsByRole.set(assignment.role, (0,external_immutable_.List)());
      }
      const principals = assignmentsByRole.get(assignment.role);
      assignmentsByRole = assignmentsByRole.set(assignment.role, principals.push(assignment));
    });
    return assignmentsByRole;
  }
  static removeAssignment(policy, userId, role) {
    const assignments = policy.assignments.filter(assignment => !(assignment.role === role.uniqueName && assignment.userId === userId)).toList();
    return policy.merge({
      assignments,
      assignmentsByRole: SecurityPolicy.getAssignmentsByRole(assignments)
    });
  }
  static addUserIdAssignment(policy, userId, roleUniqueName) {
    const principal = new Principal({
      userId,
      type: MemberType.user
    });
    const role = new SecurityRole({
      uniqueName: roleUniqueName
    });
    return this.addAssignment(policy, principal, role);
  }
  static addAssignment(policy, principal, role) {
    const assignments = policy.assignments.push(new SecurityAssignment(Object.assign({
      role: role.uniqueName,
      isNew: true
    }, principal.toJS())));
    return policy.merge({
      assignments,
      assignmentsByRole: SecurityPolicy.getAssignmentsByRole(assignments)
    });
  }
  static updateAssignmentsData(policy, principalsById) {
    const assignments = policy.assignments.map(assignment => {
      const principal = principalsById ? principalsById.get(assignment.userId) : undefined;
      const updatedAssignment = principal ? assignment.merge({
        displayName: (!principal.active ? 'Inactive User: ' : '') + principal.displayName,
        type: principal.type
      }) : assignment;
      return updatedAssignment;
    }).toList();
    return policy.merge({
      assignments,
      assignmentsByRole: SecurityPolicy.getAssignmentsByRole(assignments)
    });
  }
  isInheritFromParent() {
    return this.containerId && this.resourceId !== this.containerId;
  }
}
;// CONCATENATED MODULE: ./src/internal/components/permissions/actions.ts
function permissions_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function permissions_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? permissions_actions_ownKeys(Object(t), !0).forEach(function (r) { permissions_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : permissions_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function permissions_actions_defineProperty(e, r, t) { return (r = permissions_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function permissions_actions_toPropertyKey(t) { var i = permissions_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function permissions_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2015-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */






function processGetRolesResponse(rawRoles) {
  let roles = (0,external_immutable_.List)();
  rawRoles.forEach(roleRaw => {
    const role = roleRaw;
    if (APPLICATION_ROLES_LABELS[role?.uniqueName]) role.displayName = APPLICATION_ROLES_LABELS[role?.uniqueName];
    if (APPLICATION_ROLES_DESCRIPTIONS[role?.uniqueName]) role.description = APPLICATION_ROLES_DESCRIPTIONS[role?.uniqueName];
    roles = roles.push(SecurityRole.create(role));
  });
  return roles;
}
function getRolesByUniqueName(roles) {
  let rolesByUniqueName = (0,external_immutable_.Map)();
  roles.forEach(role => {
    rolesByUniqueName = rolesByUniqueName.set(role.uniqueName, role);
  });
  return rolesByUniqueName;
}
function processPrincipalsResponse(data, resolve) {
  const models = (0,external_immutable_.fromJS)(data.models[data.key]);
  let principals = (0,external_immutable_.List)();
  data.orderedModels[data.key].forEach(modelKey => {
    const row = models.get(modelKey);
    const principal = Principal.createFromSelectRow(row);
    principals = principals.push(principal);
  });
  resolve(principals);
}
function getPrincipals() {
  return new Promise((resolve, reject) => {
    selectRowsDeprecated({
      saveInSession: true,
      // needed so that we can call getQueryDetails
      schemaName: 'core',
      // issue 17704, add displayName for users
      sql: "SELECT p.*, u.DisplayName FROM Principals p LEFT JOIN Users u ON p.type='u' AND p.UserId=u.UserId"
    }).then(data => {
      processPrincipalsResponse(data, resolve);
    }).catch(response => {
      console.error(response);
      reject(response.message);
    });
  });
}
function getInactiveUsers() {
  return new Promise((resolve, reject) => {
    selectRowsDeprecated({
      schemaName: 'core',
      queryName: 'Users',
      columns: 'UserId,Email,DisplayName',
      filterArray: [api_.Filter.create('Active', false)]
    }).then(data => {
      const models = (0,external_immutable_.fromJS)(data.models[data.key]);
      let principals = (0,external_immutable_.List)();
      data.orderedModels[data.key].forEach(modelKey => {
        const row = models.get(modelKey);
        const userId = row.getIn(['UserId', 'value']);
        const name = row.getIn(['Email', 'value']);
        const displayName = row.getIn(['DisplayName', 'value']);
        const principal = new Principal({
          userId,
          name,
          type: 'u',
          displayName: displayName ? name + ' (' + displayName + ')' : name,
          active: false
        });
        principals = principals.push(principal);
      });
      resolve(principals);
    }).catch(response => {
      reject(response.message);
    });
  });
}
function getPrincipalsById(principals) {
  let principalsById = (0,external_immutable_.Map)();
  principals.forEach(principal => {
    principalsById = principalsById.set(principal.userId, principal);
  });
  return principalsById;
}
function fetchContainerSecurityPolicy(containerId, principalsById, inactiveUsersById) {
  return new Promise((resolve, reject) => {
    api_.Security.getPolicy({
      containerPath: containerId,
      resourceId: containerId,
      success: (data, relevantRoles) => {
        let policy = SecurityPolicy.create({
          policy: data,
          relevantRoles,
          containerId
        });
        policy = SecurityPolicy.updateAssignmentsData(policy, principalsById);
        if (inactiveUsersById) {
          policy = SecurityPolicy.updateAssignmentsData(policy, inactiveUsersById);
        }
        resolve(policy);
      },
      failure: error => {
        console.error('Failed to fetch security policy', error);
        reject(error);
      }
    });
  });
}
function recurseContainerHierarchy(data, container) {
  return (data.children ?? []).reduce((containers, c) => containers.concat(recurseContainerHierarchy(c, new Container(c))), [container]);
}
function actions_fetchContainers(options) {
  // NK: By default the server processes "includeSubfolders=false" as setting the
  // depth to 1. When the depth is set to 1 the results will include the first level of
  // subfolders negating the desire to not include subfolders. This endpoint wrapper
  // works around this by altering requests for "includeSubfolders=false" to be
  // "includeSubfolders=true&depth=0" so that subfolders are not included.
  if (options?.includeSubfolders === false && options.depth === undefined) {
    options.includeSubfolders = true;
    options.depth = 0;
  }
  return new Promise((resolve, reject) => {
    api_.Security.getContainers(permissions_actions_objectSpread(permissions_actions_objectSpread({}, options), {}, {
      success: data => {
        resolve(recurseContainerHierarchy(data, new Container(data)));
      },
      failure: error => {
        console.error('Failed to fetch containers', error);
        reject(error);
      }
    }));
  });
}
function getUserLimitSettings(containerPath) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('user', 'getUserLimitSettings.api', containerPath),
      success: api_.Utils.getCallbackWrapper(settings => {
        resolve(settings);
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        console.error(error);
        reject(error);
      })
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/user/actions.ts
function user_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function user_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? user_actions_ownKeys(Object(t), !0).forEach(function (r) { user_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : user_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function user_actions_defineProperty(e, r, t) { return (r = user_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function user_actions_toPropertyKey(t) { var i = user_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function user_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






function getUserProperties(userId) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('user', 'getUserProps.api', {
        userId
      }, {
        container: '/' // always use root container for this API call
      }),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        reject(response);
      })
    });
  });
}
function getUserPermissionsDisplay(user) {
  const permissions = [];
  if (user.isAdmin) {
    permissions.push('Administrator');
  } else {
    if (hasAllPermissions(user, [api_.PermissionTypes.DesignDataClass])) {
      permissions.push('Data Class Designer');
    }
    if (hasAllPermissions(user, [api_.PermissionTypes.DesignSampleSet])) {
      permissions.push('Sample Set Designer');
    }
    if (hasAllPermissions(user, [api_.PermissionTypes.DesignAssay])) {
      permissions.push('Assay Designer');
    }
    permissions.push(user.canUpdate ? 'Editor' : user.canInsert ? 'Author' : 'Reader');
  }
  return permissions;
}
function getUserRoleDisplay(user) {
  if (user.isAppAdmin()) {
    return SITE_SECURITY_ROLES.get(api_.PermissionRoles.ApplicationAdmin);
  }
  if (hasAllPermissions(user, [api_.PermissionTypes.Admin])) {
    return 'Administrator';
  }
  if (user.hasUpdatePermission()) {
    return APPLICATION_SECURITY_ROLES.get(api_.PermissionRoles.Editor);
  }
  if (hasAllPermissions(user, [api_.PermissionTypes.EditStorageData])) {
    return 'Storage Editor';
  }
  if (hasAllPermissions(user, [api_.PermissionTypes.DesignStorage])) {
    return 'Storage Designer';
  }
  if (hasAllPermissions(user, [api_.PermissionTypes.Read])) {
    if (hasAnyPermissions(user, [api_.PermissionTypes.DesignAssay, api_.PermissionTypes.DesignDataClass, api_.PermissionTypes.DesignSampleSet])) return 'Data Type Designer';
    return APPLICATION_SECURITY_ROLES.get(api_.PermissionRoles.Reader);
  }
  return 'Unknown Role';
}
function getUserLastLogin(userProperties, dateFormat) {
  const lastLogin = caseInsensitive(userProperties, 'lastlogin');
  return lastLogin ? external_moment_default()(lastLogin).format(dateFormat) : undefined;
}
function getUserDetailsRowData(user, data, avatar) {
  const formData = new FormData();
  const row = user_actions_objectSpread({
    UserId: user.id
  }, data.toJS());
  Object.keys(row).forEach(key => {
    let value = row[key];

    // need to convert booleans to string for save
    if (value !== null && api_.Utils.isBoolean(value)) {
      value = value.toString();
    }

    // need to remove email from the posted data since that is not an updatable value for this action
    if (key.toLowerCase() === 'email') {
      value = undefined;
    }
    if (value !== undefined) {
      formData.append(key, value);
    }
  });

  // add in the avatar file, if a new one was added (note that we do want to let through the value of "null" since
  // that is used to indicate to the server to delete the current avatar file)
  if (avatar !== undefined) {
    formData.append('Avatar', avatar);
  }
  return formData;
}
function changePassword(model) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL('login', 'changePasswordApi.api'),
      method: 'POST',
      params: model.toJS(),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        reject(response);
      })
    });
  });
}
function getPasswordRuleInfo() {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('login', 'getPasswordRulesInfo.api'),
      method: 'GET',
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        reject(response);
      })
    });
  });
}
function updateUsersActiveState(userIds, reactivate) {
  return updateUsersState(userIds, false, reactivate);
}
function deleteUsers(userIds) {
  return updateUsersState(userIds, true, false);
}
function updateUsersState(userIds, isDelete, isActivate) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL('user', 'updateUsersStateApi.api'),
      method: 'POST',
      params: {
        userId: userIds,
        delete: isDelete,
        activate: isActivate
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        reject(response);
      })
    });
  });
}
function resetPassword(email) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL('security', 'adminResetPassword.api'),
      method: 'POST',
      params: {
        email
      },
      success: api_.Utils.getCallbackWrapper(() => {
        resolve({
          email,
          resetPassword: true
        });
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        console.error('Failed to reset password.', error);
        reject(error);
      })
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/forms/actions.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






// "target" is not typed as an Element in base TypeScript library due to non-DOM events
// Not exactly correct typings but suffices for the usages below
// https://stackoverflow.com/q/28900077

function handleInputTab(evt) {
  if (evt.keyCode === 9) {
    // tab
    const element = evt.target;
    evt.preventDefault();
    const s = element.selectionStart;
    element.value = element.value.substring(0, s) + '\t' + element.value.substring(element.selectionEnd);
    element.selectionEnd = s + 1;
  }
}
function handleTabKeyOnTextArea(evt) {
  if (evt && evt.target && evt.target.type === 'textarea') {
    handleInputTab(evt);
  }
}

/**
 * Retrieve users in current container with a given set of permissions.  If no permission is specified, defaults to Read
 * permission
 * @param permissions the PermissionType or array of PermissionType values that all users must have.
 * @param containerPath the path of the container to request user permissions from. If not specified, then it defaults
 * to the page context's container.
 * @param includeInactive flag to optionally return inactive users
 */
function getUsersWithPermissions(permissions, containerPath, includeInactive) {
  return new Promise((resolve, reject) => {
    return api_.Security.getUsersWithPermissions({
      containerPath,
      permissions: permissions ?? api_.PermissionTypes.Read,
      includeInactive,
      requiredVersion: 23.11,
      success: ({
        users
      }) => {
        users.sort(naturalSortByProperty('displayName'));
        resolve(users);
      },
      failure: response => {
        console.error('There was a problem retrieving users with permissions ', permissions, response);
        reject('There was a problem retrieving users with the given permissions');
      }
    });
  });
}
function useUsersWithPermissions(permissions = api_.PermissionTypes.Read, containerPath, loader = getUsersWithPermissions) {
  const [users, setUsers_] = (0,external_react_.useState)();
  const [loadingState, setLoadingState] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [error, setError] = (0,external_react_.useState)();
  const load = (0,external_react_.useCallback)(async () => {
    setLoadingState(LoadingState.LOADING);
    try {
      const users_ = await loader(permissions, containerPath);
      setUsers_(users_);
    } catch (e) {
      setError(e);
    } finally {
      setLoadingState(LoadingState.LOADED);
    }
  }, [containerPath, loader, permissions]);
  (0,external_react_.useEffect)(() => {
    load();
  }, [load]);
  return {
    error,
    loadingState,
    users
  };
}
function updateRowFieldValue(model, name, value) {
  return updateRows({
    schemaQuery: model.schemaQuery,
    rows: [{
      rowId: model.getRowValue('rowId'),
      [name]: value
    }],
    containerPath: model.containerPath
  });
}
;// CONCATENATED MODULE: ./src/internal/components/security/APIWrapper.ts
function security_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function security_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? security_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { security_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : security_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function security_APIWrapper_defineProperty(e, r, t) { return (r = security_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function security_APIWrapper_toPropertyKey(t) { var i = security_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function security_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }












class ServerSecurityAPIWrapper {
  constructor() {
    security_APIWrapper_defineProperty(this, "addGroupMembers", (groupId, principalIds, projectPath) => {
      return new Promise((resolve, reject) => {
        api_.Security.addGroupMembers({
          groupId,
          principalIds,
          containerPath: projectPath,
          success: data => {
            resolve(data);
          },
          failure: error => {
            console.error('Failed to add group member(s)', error);
            reject(error);
          }
        });
      });
    });
    security_APIWrapper_defineProperty(this, "createApiKey", (type = 'apikey') => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: buildURL('security', 'createApiKey.api'),
          method: 'POST',
          jsonData: {
            type
          },
          success: api_.Utils.getCallbackWrapper(response => {
            resolve(response.apikey);
          }),
          failure: handleRequestFailure(reject, 'Problem generating the apiKey for this user.')
        });
      });
    });
    security_APIWrapper_defineProperty(this, "createGroup", (groupName, projectPath) => {
      return new Promise((resolve, reject) => {
        api_.Security.createGroup({
          groupName,
          containerPath: projectPath,
          success: data => {
            resolve(data);
          },
          failure: error => {
            console.error('Failed to create group', error);
            reject(error);
          }
        });
      });
    });
    security_APIWrapper_defineProperty(this, "deleteContainer", options => {
      return new Promise((resolve, reject) => {
        api_.Security.deleteContainer(security_APIWrapper_objectSpread(security_APIWrapper_objectSpread({}, options ?? {}), {}, {
          success: data => {
            resolve(data);
          },
          failure: error => {
            console.error('Failed to delete project', error);
            reject(error);
          }
        }));
      });
    });
    security_APIWrapper_defineProperty(this, "deleteGroup", (groupId, projectPath) => {
      return new Promise((resolve, reject) => {
        api_.Security.deleteGroup({
          groupId,
          containerPath: projectPath,
          success: data => {
            resolve(data);
          },
          failure: error => {
            console.error('Failed to delete group', error);
            reject(error);
          }
        });
      });
    });
    security_APIWrapper_defineProperty(this, "fetchContainers", actions_fetchContainers);
    security_APIWrapper_defineProperty(this, "fetchGroups", projectPath => {
      return new Promise((resolve, reject) => {
        api_.Security.getGroupPermissions({
          containerPath: projectPath,
          success: data => {
            resolve(data?.container?.groups);
          },
          failure: error => {
            console.error('Failed to fetch group permissions', error);
            reject(error);
          }
        });
      });
    });
    security_APIWrapper_defineProperty(this, "fetchPolicy", fetchContainerSecurityPolicy);
    security_APIWrapper_defineProperty(this, "fetchRoles", () => {
      return new Promise((resolve, reject) => {
        api_.Security.getRoles({
          success: rawRoles => {
            const roles = processGetRolesResponse(rawRoles);
            resolve(roles);
          },
          failure: e => {
            console.error('Failed to load security roles', e);
            reject(e);
          }
        });
      });
    });
    security_APIWrapper_defineProperty(this, "getAuditLogDate", async (filterCol, filterVal) => {
      const result = await selectRows({
        columns: ['Date'],
        containerFilter: api_.Query.ContainerFilter.allFolders,
        filterArray: [api_.Filter.create(filterCol, filterVal, api_.Filter.Types.EQUAL)],
        maxRows: 1,
        schemaQuery: new SchemaQuery(SCHEMAS.AUDIT_TABLES.SCHEMA, 'GroupAuditEvent'),
        sort: '-Date'
      });
      if (result.rows.length === 0) {
        return '';
      }
      const dateRow = caseInsensitive(result.rows[0], 'Date');
      return dateRow.formattedValue ?? dateRow.value;
    });
    security_APIWrapper_defineProperty(this, "getDeletionSummaries", () => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: buildURL('core', 'getModuleSummary.api'),
          success: api_.Utils.getCallbackWrapper(response => {
            const {
              moduleSummary
            } = response;
            moduleSummary.sort(naturalSortByProperty('noun'));
            resolve(moduleSummary);
          }),
          failure: handleRequestFailure(reject, 'Failed to retrieve deletion summary.')
        });
      });
    });
    security_APIWrapper_defineProperty(this, "getGroupMemberships", async () => {
      const result = await selectRows({
        columns: ['GroupId', 'GroupId/Name', 'UserId', 'UserId/DisplayName', 'UserId/Email'],
        schemaQuery: new SchemaQuery('core', 'Members')
      });
      return result.rows.reduce((memberships, row) => {
        memberships.push({
          groupId: caseInsensitive(row, 'GroupId').value,
          groupName: caseInsensitive(row, 'GroupId/Name').value,
          userDisplayName: caseInsensitive(row, 'UserId/DisplayName').value,
          userId: caseInsensitive(row, 'UserId').value,
          userEmail: caseInsensitive(row, 'UserId/Email').value
        });
        return memberships;
      }, []);
    });
    security_APIWrapper_defineProperty(this, "getUserLimitSettings", getUserLimitSettings);
    security_APIWrapper_defineProperty(this, "getUserPermissions", options => {
      return new Promise((resolve, reject) => {
        api_.Security.getUserPermissions(security_APIWrapper_objectSpread(security_APIWrapper_objectSpread({}, options ?? {}), {}, {
          success: response => {
            resolve(response.container.effectivePermissions);
          },
          failure: error => {
            console.error('Failed to fetch user permissions', error);
            reject(error);
          }
        }));
      });
    });
    security_APIWrapper_defineProperty(this, "getUserProperties", getUserProperties);
    security_APIWrapper_defineProperty(this, "getUserPropertiesForOther", async userId => {
      let response = await selectRows({
        filterArray: [api_.Filter.create('UserId', userId)],
        schemaQuery: SCHEMAS.CORE_TABLES.USERS
      });

      // Issue 49440: User may not be in the core.Users table (if permission was removed), so check the core.SiteUsers table as well
      if (response.rows.length === 0) {
        response = await selectRows({
          filterArray: [api_.Filter.create('UserId', userId)],
          schemaQuery: new SchemaQuery('core', 'SiteUsers')
        });
      }
      if (response.rows.length === 0) {
        return {};
      }
      const [row] = response.rows;
      const rowValues = flattenValuesFromRow(row, Object.keys(row));

      // special case for the Groups prop as it is an array
      rowValues.Groups = caseInsensitive(row, 'Groups');
      return rowValues;
    });
    security_APIWrapper_defineProperty(this, "getUsersWithPermissions", getUsersWithPermissions);
    security_APIWrapper_defineProperty(this, "removeGroupMembers", (groupId, principalIds, projectPath) => {
      return new Promise((resolve, reject) => {
        api_.Security.removeGroupMembers({
          groupId,
          principalIds,
          containerPath: projectPath,
          success: data => {
            resolve(data);
          },
          failure: error => {
            console.error('Failed to remove group member(s)', error);
            reject(error);
          }
        });
      });
    });
    security_APIWrapper_defineProperty(this, "updateUserDetails", data => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: buildURL('user', 'updateUserDetails.api'),
          method: 'POST',
          form: data,
          success: api_.Utils.getCallbackWrapper((response, request) => {
            if (processRequest(response, request, reject)) return;
            resolve(response);
          }),
          failure: handleRequestFailure(reject, 'Failed to update user details')
        });
      });
    });
    security_APIWrapper_defineProperty(this, "getInheritedProjects", container => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL('core', 'getExtSecurityContainerTree.api', container.path),
          params: {
            requiredPermission: api_.Security.PermissionTypes.Admin,
            nodeId: container.id
          },
          success: api_.Utils.getCallbackWrapper(projects => {
            const inherited = [];
            projects.forEach(proj => {
              if (proj.inherit) {
                const name = proj.text.substring(0, proj.text.length - 1); // remove trailing *
                inherited.push(name);
              }
            });
            resolve(inherited);
          }),
          failure: handleRequestFailure(reject, 'Failed to get projects')
        });
      });
    });
    security_APIWrapper_defineProperty(this, "savePolicy", (policy, containerPath) => {
      return new Promise((resolve, reject) => {
        api_.Security.savePolicy({
          policy,
          containerPath,
          success: response => {
            resolve(response);
          },
          failure: error => {
            console.error('Failed to save policy', error);
            reject(error);
          }
        });
      });
    });
    security_APIWrapper_defineProperty(this, "deletePolicy", (resourceId, containerPath) => {
      return new Promise((resolve, reject) => {
        api_.Security.deletePolicy({
          resourceId,
          containerPath,
          success: response => {
            resolve(response);
          },
          failure: error => {
            console.error('Failed to delete policy', error);
            reject(error);
          }
        });
      });
    });
  }
  deleteApiKeys(selections) {
    const rows = [];
    selections.forEach(selection => {
      rows.push({
        rowId: selection
      });
    });
    return deleteRows({
      schemaQuery: SCHEMAS.CORE_TABLES.USER_API_KEYS,
      rows
    });
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getSecurityTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return security_APIWrapper_objectSpread({
    addGroupMembers: mockFn(),
    createApiKey: mockFn(),
    deleteApiKeys: mockFn(),
    createGroup: mockFn(),
    deleteContainer: mockFn(),
    deleteGroup: mockFn(),
    fetchContainers: mockFn(),
    fetchGroups: mockFn(),
    fetchPolicy: mockFn(),
    fetchRoles: mockFn(),
    getAuditLogDate: mockFn(),
    getDeletionSummaries: mockFn(),
    getGroupMemberships: mockFn(),
    getUserLimitSettings: mockFn(),
    getUserPermissions: mockFn(),
    getUserProperties: mockFn(),
    getUserPropertiesForOther: mockFn(),
    getUsersWithPermissions: mockFn(),
    removeGroupMembers: mockFn(),
    updateUserDetails: mockFn(),
    savePolicy: mockFn(),
    deletePolicy: mockFn(),
    getInheritedProjects: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/assay/actions.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








function saveAssayDesign(model) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('assay', 'saveProtocol.api', model.container),
      jsonData: AssayProtocolModel.serialize(model),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(AssayProtocolModel.create(response.data));
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        // clear any previous exception at the model level
        let updatedModel = model.set('exception', undefined);

        // Check for validation exception
        const exception = DomainException.create(error, constants_SEVERITY_LEVEL_ERROR);
        if (exception) {
          if (exception.domainName) {
            updatedModel = setAssayDomainException(updatedModel, exception);
          } else {
            updatedModel = updatedModel.set('exception', exception.exception);
          }
        } else {
          updatedModel = updatedModel.set('exception', error.exception || error);
        }
        reject(updatedModel);
      }, this, false)
    });
  });
}
function setAssayDomainException(model, exception) {
  let updatedModel;

  // If a domain is identified in the exception, attach to that domain
  if (exception.domainName) {
    const exceptionDomains = model.domains.map(domain => {
      if (exception.domainName.endsWith(domain.get('name'))) {
        return setDomainException(domain, exception);
      }
      return domain;
    });
    updatedModel = model.set('domains', exceptionDomains);
  }
  // otherwise attach to whole assay
  else {
    updatedModel = model.set('exception', exception.exception);
  }
  return updatedModel;
}
function getValidPublishTargets(containerPath) {
  if (!isAssayEnabled()) {
    return Promise.resolve([]);
  }
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('assay', 'getValidPublishTargets.api', containerPath),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response.containers.map(c => new Container(c)));
      }),
      failure: handleRequestFailure(reject, 'Unable to load valid study targets for Auto-Link Data to Study input.')
    });
  });
}
function getScriptEngineForExtension(extension, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('core', 'getScriptEngineForExtension.api', containerPath),
      params: {
        extension
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: handleRequestFailure(reject, `Failed to get script engine for extension "${extension}".`)
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataclasses/constants.ts
const DESCRIPTION_FIELD = {
  Name: 'Description',
  Label: 'Description',
  DataType: 'Text',
  Required: false,
  Description: 'Contains a description for this data object',
  Disableble: true
};
const DATACLASS_DOMAIN_SYSTEM_FIELDS = [{
  Name: 'Name',
  Label: 'Name',
  DataType: 'Text',
  Required: true,
  Description: 'Contains a short name for this data object',
  Disableble: false
}, DESCRIPTION_FIELD];
const SOURCE_DOMAIN_SYSTEM_FIELDS = [{
  Name: 'Name',
  Label: 'Source ID',
  DataType: 'Text',
  Required: true,
  Description: 'Contains a short name for this data object',
  Disableble: false
}, DESCRIPTION_FIELD];
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataclasses/models.ts
function dataclasses_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function dataclasses_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? dataclasses_models_ownKeys(Object(t), !0).forEach(function (r) { dataclasses_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : dataclasses_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function dataclasses_models_defineProperty(e, r, t) { return (r = dataclasses_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function dataclasses_models_toPropertyKey(t) { var i = dataclasses_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function dataclasses_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





class DataClassModel {
  constructor(values) {
    dataclasses_models_defineProperty(this, external_immer_.immerable, true);
    dataclasses_models_defineProperty(this, "category", void 0);
    dataclasses_models_defineProperty(this, "description", void 0);
    dataclasses_models_defineProperty(this, "domain", void 0);
    dataclasses_models_defineProperty(this, "exception", void 0);
    dataclasses_models_defineProperty(this, "name", void 0);
    dataclasses_models_defineProperty(this, "nameExpression", void 0);
    dataclasses_models_defineProperty(this, "rowId", void 0);
    dataclasses_models_defineProperty(this, "sampleSet", void 0);
    dataclasses_models_defineProperty(this, "systemFields", void 0);
    dataclasses_models_defineProperty(this, "parentAliases", void 0);
    dataclasses_models_defineProperty(this, "importAliases", void 0);
    dataclasses_models_defineProperty(this, "excludedContainerIds", void 0);
    dataclasses_models_defineProperty(this, "isBuiltIn", void 0);
    Object.assign(this, values);
  }
  static create(raw) {
    let domain = DomainDesign.create({});
    if (raw.domainDesign) {
      domain = DomainDesign.create(raw.domainDesign);
    }
    const model = new DataClassModel(dataclasses_models_objectSpread(dataclasses_models_objectSpread({}, raw.options ? raw.options : raw), {}, {
      domain
    }));
    return (0,external_immer_.produce)(model, draft => {
      if (raw.options && model.category === null) {
        draft.category = undefined;
      }
      if (raw.options && model.sampleSet === null) {
        draft.sampleSet = undefined;
      }
      const aliases = raw.options?.importAliases || {};
      draft.importAliases = (0,external_immutable_.Map)((0,external_immutable_.fromJS)(aliases));
      draft.systemFields = model.category === 'sources' ? SOURCE_DOMAIN_SYSTEM_FIELDS : DATACLASS_DOMAIN_SYSTEM_FIELDS;
    });
  }
  get containerPath() {
    return this.domain?.container;
  }
  get isNew() {
    return !this.rowId;
  }
  isValid(defaultNameFieldConfig) {
    return this.hasValidProperties && !this.hasInvalidNameField(defaultNameFieldConfig) && getDuplicateAlias(this.parentAliases, true).size === 0 && !this.domain.hasInvalidFields();
  }
  get hasValidProperties() {
    const hasInvalidAliases = this.parentAliases && this.parentAliases.size > 0 && this.parentAliases.find(parentAliasInvalid) !== undefined;
    return this.name !== undefined && this.name !== null && this.name.trim().length > 0 && !hasInvalidAliases;
  }
  hasInvalidNameField(defaultNameFieldConfig) {
    return this.domain && defaultNameFieldConfig ? this.domain.hasInvalidNameField(defaultNameFieldConfig) : false;
  }
  get entityDataMap() {
    return (0,external_immutable_.fromJS)({
      rowId: this.rowId,
      name: this.name,
      description: this.description,
      nameExpression: this.nameExpression
    });
  }
  get options() {
    return {
      rowId: this.rowId,
      name: this.name,
      description: this.description,
      excludedContainerIds: this.excludedContainerIds,
      nameExpression: this.nameExpression,
      category: this.category,
      sampleSet: this.sampleSet,
      systemFields: this.systemFields,
      importAliases: this.importAliases
    };
  }
  mutate(props) {
    return (0,external_immer_.produce)(this, draft => {
      Object.assign(draft, props);
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataclasses/actions.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







function fetchDataClass(queryName, rowId, containerPath) {
  if (rowId) {
    return fetchDataClassProperties(rowId, containerPath).then(response => {
      return _fetchDataClass(undefined, response.domainId, containerPath);
    }).catch(error => {
      return Promise.reject(error);
    });
  } else if (queryName) {
    return _fetchDataClass(queryName, undefined, containerPath);
  } else {
    // for the create case to get the domain details based on domainKind param only
    return _fetchDataClass();
  }
}
function _fetchDataClass(queryName, domainId, containerPath) {
  return new Promise((resolve, reject) => {
    return api_.Domain.getDomainDetails({
      containerPath,
      schemaName: SCHEMAS.DATA_CLASSES.SCHEMA,
      queryName,
      domainId,
      domainKind: queryName === undefined && domainId === undefined ? 'DataClass' : undefined,
      success: data => {
        if (data.domainKindName === 'DataClass') {
          resolve(DataClassModel.create(data));
        } else {
          reject({
            exception: 'Unexpected domainKind type found: ' + data.domainKindName
          });
        }
      },
      failure: error => {
        reject(error);
      }
    });
  });
}

// TODO: This should share implementation with api.samples.getSampleTypeDetails / api.domain.fetchDomainDetails
function getDataClassDetails(query, domainId, containerPath) {
  return new Promise((resolve, reject) => {
    return api_.Domain.getDomainDetails({
      containerPath,
      domainId,
      queryName: query ? query.queryName : undefined,
      schemaName: query ? query.schemaName : undefined,
      domainKind: query === undefined && domainId === undefined ? 'DataClass' : undefined,
      success: response => {
        resolve(DomainDetails.create((0,external_immutable_.Map)(response)));
      },
      failure: response => {
        console.error(response);
        reject(response);
      }
    });
  });
}
function fetchDataClassProperties(rowId, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('experiment', 'getDataClassProperties.api', containerPath),
      params: {
        rowId
      },
      scope: this,
      success: api_.Utils.getCallbackWrapper(data => {
        resolve(data);
      }),
      failure: handleRequestFailure(reject, 'Failed to get data class properties')
    });
  });
}
function deleteDataClass(rowId, containerPath, auditUserComment) {
  return deleteEntityType('deleteDataClass', rowId, containerPath, auditUserComment);
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/APIWrapper.ts
function domainproperties_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function domainproperties_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? domainproperties_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { domainproperties_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : domainproperties_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function domainproperties_APIWrapper_defineProperty(e, r, t) { return (r = domainproperties_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function domainproperties_APIWrapper_toPropertyKey(t) { var i = domainproperties_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function domainproperties_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class DomainPropertiesAPIWrapper {
  constructor() {
    domainproperties_APIWrapper_defineProperty(this, "fetchDomainDetails", fetchDomainDetails);
    domainproperties_APIWrapper_defineProperty(this, "fetchOntologies", fetchOntologies);
    domainproperties_APIWrapper_defineProperty(this, "getDataClassDetails", getDataClassDetails);
    domainproperties_APIWrapper_defineProperty(this, "getDomainNamePreviews", getDomainNamePreviews);
    domainproperties_APIWrapper_defineProperty(this, "getGenId", getGenId);
    domainproperties_APIWrapper_defineProperty(this, "getMaxPhiLevel", getMaxPhiLevel);
    domainproperties_APIWrapper_defineProperty(this, "getValidPublishTargets", getValidPublishTargets);
    domainproperties_APIWrapper_defineProperty(this, "saveDomain", saveDomain);
    domainproperties_APIWrapper_defineProperty(this, "setGenId", setGenId);
    domainproperties_APIWrapper_defineProperty(this, "validateDomainNameExpressions", validateDomainNameExpressions);
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getDomainPropertiesTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return domainproperties_APIWrapper_objectSpread({
    fetchDomainDetails: mockFn(),
    fetchOntologies: mockFn(),
    getDataClassDetails: mockFn(),
    getDomainNamePreviews: mockFn(),
    getGenId: mockFn(),
    // Because we don't want to have an explicit dependency on jest we cannot use mockFn().mockResolvedValue here
    // like we should be able to, because the default implementation for our mockFn cannot be Jest. We should
    // probably make Jest an explicit dependency since we are actually exporting test utilities.
    getMaxPhiLevel: () => Promise.resolve(PHILEVEL_FULL_PHI),
    getValidPublishTargets: mockFn(),
    saveDomain: mockFn(),
    setGenId: mockFn(),
    validateDomainNameExpressions: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/components/project/actions.ts





function getProjectDataTypeDataCountSql(dataType) {
  if (!dataType) return null;
  let typeField = 'SampleSet';
  let from = 'exp.materials ';
  let where = '';
  if (dataType === 'DataClass') {
    typeField = 'dataclass';
    from = 'exp.data ';
    where = 'WHERE DataClass IS NOT NULL ';
  } else if (dataType === 'AssayDesign') {
    typeField = 'protocol';
    from = 'exp.AssayRuns ';
  }
  const select = 'SELECT ' + typeField + ' as Type, COUNT(*) as DataCount ';
  const groupBy = 'GROUP BY ' + typeField;
  return select + 'FROM ' + from + where + groupBy;
}
function getProjectDataTypeDataCount(dataType, containerPath, allDataTypes, isNewFolder) {
  return new Promise((resolve, reject) => {
    if (isProductProjectsDataListingScopedToProject() && isNewFolder) {
      resolve({});
      return;
    }

    // samples and assay runs reference their data type by lsid, but dataclass data reference by rowid
    const byLsid = dataType === 'SampleType' || dataType === 'AssayDesign';
    const lookup = {};
    if (byLsid && allDataTypes) {
      allDataTypes.forEach(type => {
        lookup[type.lsid] = type.rowId;
      });
    }
    let cf = getContainerFilterForFolder(containerPath);
    if (isNewFolder) {
      cf = isAllProductFoldersFilteringEnabled() ? api_.Query.ContainerFilter.allInProjectPlusShared : api_.Query.ContainerFilter.currentPlusProjectAndShared;
    }
    api_.Query.executeSql({
      containerPath,
      containerFilter: cf,
      schemaName: SCHEMAS.EXP_TABLES.SCHEMA,
      sql: getProjectDataTypeDataCountSql(dataType),
      success: result => {
        const typeCounts = {};
        result.rows?.forEach(row => {
          const type = caseInsensitive(row, 'Type');
          const count = caseInsensitive(row, 'DataCount');
          if (byLsid && allDataTypes) typeCounts[lookup[type] + ''] = count;else typeCounts[type] = count;
        });
        resolve(typeCounts);
      },
      failure: error => {
        console.error(error);
        reject(error);
      }
    });
  });
}

// exported for jest testing
function getDataTypeProjectDataCountSql(entityDataType, dataTypeRowId, dataTypeName) {
  const isAssay = entityDataType.projectConfigurableDataType === 'AssayDesign';
  const isStorage = entityDataType.projectConfigurableDataType === 'StorageLocation';
  const queryName = isAssay || isStorage ? entityDataType.listingSchemaQuery.queryName : dataTypeName;
  const whereClause = isAssay ? 'WHERE Protocol.RowId = ' + dataTypeRowId : '';
  if (!queryName) return null;
  return 'SELECT Folder AS Project, COUNT(*) as DataCount FROM "' + queryName + '" ' + whereClause + ' GROUP BY Folder';
}
function getDataTypeProjectDataCount(entityDataType, dataTypeRowId, dataTypeName) {
  return new Promise((resolve, reject) => {
    const isAssay = entityDataType.projectConfigurableDataType === 'AssayDesign';
    const isStorage = entityDataType.projectConfigurableDataType === 'StorageLocation';
    const schemaName = isAssay || isStorage ? entityDataType.listingSchemaQuery.schemaName : entityDataType.instanceSchemaName;
    const parameters = isStorage ? {
      ParentId: dataTypeRowId
    } : undefined;
    const sql = getDataTypeProjectDataCountSql(entityDataType, dataTypeRowId, dataTypeName);
    if (!sql) {
      resolve({});
      return;
    }
    api_.Query.executeSql({
      containerFilter: api_.Query.ContainerFilter.allInProject,
      // use AllInProject for all cases
      schemaName,
      sql,
      parameters,
      success: result => {
        const counts = {};
        result.rows?.forEach(row => {
          const project = caseInsensitive(row, 'Project');
          counts[project] = caseInsensitive(row, 'DataCount');
        });
        resolve(counts);
      },
      failure: error => {
        console.error(error);
        reject(error);
      }
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/query/APIWrapper.ts
function query_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function query_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? query_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { query_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : query_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function query_APIWrapper_defineProperty(e, r, t) { return (r = query_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function query_APIWrapper_toPropertyKey(t) { var i = query_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function query_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





class QueryServerAPIWrapper {
  constructor() {
    query_APIWrapper_defineProperty(this, "clearSelected", clearSelected);
    query_APIWrapper_defineProperty(this, "deleteRows", deleteRows);
    query_APIWrapper_defineProperty(this, "deleteRowsByContainer", deleteRowsByContainer);
    query_APIWrapper_defineProperty(this, "deleteView", deleteView);
    query_APIWrapper_defineProperty(this, "getDataTypeProjectDataCount", getDataTypeProjectDataCount);
    query_APIWrapper_defineProperty(this, "getEntityTypeOptions", getEntityTypeOptions);
    query_APIWrapper_defineProperty(this, "getGridViews", getGridViews);
    query_APIWrapper_defineProperty(this, "getProjectConfigurableEntityTypeOptions", getProjectConfigurableEntityTypeOptions);
    query_APIWrapper_defineProperty(this, "getProjectDataTypeDataCount", getProjectDataTypeDataCount);
    query_APIWrapper_defineProperty(this, "getQueryDetails", getQueryDetails);
    query_APIWrapper_defineProperty(this, "getSnapshotSelections", getSnapshotSelections);
    query_APIWrapper_defineProperty(this, "incrementClientSideMetricCount", incrementClientSideMetricCount);
    query_APIWrapper_defineProperty(this, "insertRows", insertRows);
    query_APIWrapper_defineProperty(this, "renameGridView", renameGridView);
    query_APIWrapper_defineProperty(this, "replaceSelected", replaceSelected);
    query_APIWrapper_defineProperty(this, "saveGridView", saveGridView);
    query_APIWrapper_defineProperty(this, "saveRowsByContainer", saveRowsByContainer);
    query_APIWrapper_defineProperty(this, "saveSessionView", saveSessionView);
    query_APIWrapper_defineProperty(this, "selectRows", selectRows);
    query_APIWrapper_defineProperty(this, "selectDistinctRows", selectDistinctRows);
    query_APIWrapper_defineProperty(this, "setSelected", setSelected);
    query_APIWrapper_defineProperty(this, "setSnapshotSelections", setSnapshotSelections);
    query_APIWrapper_defineProperty(this, "updateRows", updateRows);
    query_APIWrapper_defineProperty(this, "updateRowsByContainer", updateRowsByContainer);
    query_APIWrapper_defineProperty(this, "getDefaultVisibleColumns", getDefaultVisibleColumns);
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getQueryTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return query_APIWrapper_objectSpread({
    clearSelected: mockFn(),
    deleteRows: mockFn(),
    deleteRowsByContainer: mockFn(),
    deleteView: mockFn(),
    getDataTypeProjectDataCount: mockFn(),
    getEntityTypeOptions: mockFn(),
    getGridViews: mockFn(),
    getProjectConfigurableEntityTypeOptions: mockFn(),
    getProjectDataTypeDataCount: mockFn(),
    getQueryDetails: mockFn(),
    getSnapshotSelections: mockFn(),
    incrementClientSideMetricCount: mockFn(),
    insertRows: mockFn(),
    renameGridView: mockFn(),
    replaceSelected: mockFn(),
    saveGridView: mockFn(),
    saveRowsByContainer: mockFn(),
    saveSessionView: mockFn(),
    selectRows: mockFn(),
    selectDistinctRows: mockFn(),
    setSelected: mockFn(),
    setSnapshotSelections: mockFn(),
    updateRows: mockFn(),
    updateRowsByContainer: mockFn(),
    getDefaultVisibleColumns: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/components/settings/actions.ts




const saveNameExpressionOptions = (key, value, containerPath) => {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'setNameExpressionOptions.api', undefined, {
        container: containerPath
      }),
      jsonData: {
        [key]: value
      },
      method: 'POST',
      success: api_.Utils.getCallbackWrapper(response => resolve(response.ineligibleSampleTypes)),
      failure: handleRequestFailure(reject, 'Failed to save name expression options.')
    });
  });
};
const loadNameExpressionOptions = containerPath => {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'getNameExpressionOptions.api', undefined, {
        container: containerPath
      }),
      success: api_.Utils.getCallbackWrapper(response => resolve(response)),
      failure: handleRequestFailure(reject, 'Failed to get name expression options.')
    });
  });
};
;// CONCATENATED MODULE: ./src/internal/components/entities/APIWrapper.ts
function entities_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function entities_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? entities_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { entities_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : entities_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function entities_APIWrapper_defineProperty(e, r, t) { return (r = entities_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function entities_APIWrapper_toPropertyKey(t) { var i = entities_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function entities_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class EntityServerAPIWrapper {
  constructor() {
    entities_APIWrapper_defineProperty(this, "getCrossFolderSelectionResult", getCrossFolderSelectionResult);
    entities_APIWrapper_defineProperty(this, "getDataOperationConfirmationData", getDataOperationConfirmationData);
    entities_APIWrapper_defineProperty(this, "getDeleteConfirmationData", getDeleteConfirmationData);
    entities_APIWrapper_defineProperty(this, "getMoveConfirmationData", getMoveConfirmationData);
    entities_APIWrapper_defineProperty(this, "getEntityTypeData", getEntityTypeData);
    entities_APIWrapper_defineProperty(this, "getOperationConfirmationData", getOperationConfirmationData);
    entities_APIWrapper_defineProperty(this, "getOperationConfirmationDataForModel", getOperationConfirmationDataForModel);
    entities_APIWrapper_defineProperty(this, "getOriginalParentsFromLineage", getOriginalParentsFromLineage);
    entities_APIWrapper_defineProperty(this, "getParentTypeDataForLineage", getParentTypeDataForLineage);
    entities_APIWrapper_defineProperty(this, "handleEntityFileImport", handleEntityFileImport);
    entities_APIWrapper_defineProperty(this, "loadNameExpressionOptions", loadNameExpressionOptions);
    entities_APIWrapper_defineProperty(this, "moveEntities", moveEntities);
    entities_APIWrapper_defineProperty(this, "initParentOptionsSelects", initParentOptionsSelects);
    entities_APIWrapper_defineProperty(this, "isDataTypeEmpty", isDataTypeEmpty);
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getEntityTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return entities_APIWrapper_objectSpread({
    getCrossFolderSelectionResult: mockFn(),
    getDataOperationConfirmationData: mockFn(),
    getDeleteConfirmationData: mockFn(),
    getMoveConfirmationData: mockFn(),
    getEntityTypeData: mockFn(),
    getOperationConfirmationData: mockFn(),
    getOperationConfirmationDataForModel: mockFn(),
    getOriginalParentsFromLineage: mockFn(),
    getParentTypeDataForLineage: mockFn(),
    handleEntityFileImport: mockFn(),
    loadNameExpressionOptions: mockFn(),
    moveEntities: mockFn(),
    initParentOptionsSelects: mockFn(),
    isDataTypeEmpty: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/components/container/FolderAPIWrapper.ts
function FolderAPIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FolderAPIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FolderAPIWrapper_ownKeys(Object(t), !0).forEach(function (r) { FolderAPIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FolderAPIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FolderAPIWrapper_defineProperty(e, r, t) { return (r = FolderAPIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FolderAPIWrapper_toPropertyKey(t) { var i = FolderAPIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FolderAPIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









class ServerFolderAPIWrapper {
  constructor() {
    FolderAPIWrapper_defineProperty(this, "createProject", (options, containerPath) => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'createProject.api', containerPath),
          method: 'POST',
          jsonData: options,
          success: api_.Utils.getCallbackWrapper(({
            project
          }) => {
            resolve(new Container(project));
          }),
          failure: handleRequestFailure(reject, 'Failed to create project')
        });
      });
    });
    FolderAPIWrapper_defineProperty(this, "renameProject", (options, containerPath) => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'renameProject.api', containerPath),
          method: 'POST',
          jsonData: options,
          success: api_.Utils.getCallbackWrapper(({
            data
          }) => {
            resolve(new Container(data.project));
          }),
          failure: handleRequestFailure(reject, 'Failed to rename project')
        });
      });
    });
    FolderAPIWrapper_defineProperty(this, "getAuditSettings", containerPath => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL('audit', 'getAuditSettings', containerPath),
          method: 'POST',
          success: api_.Utils.getCallbackWrapper(response => {
            resolve(response);
          }),
          failure: handleRequestFailure(reject, 'Failed to retrieve audit settings.')
        });
      });
    });
    FolderAPIWrapper_defineProperty(this, "setAuditCommentsRequired", (requireUserComments, containerPath) => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL('audit', 'saveAuditSettings', containerPath),
          method: 'POST',
          jsonData: {
            requireUserComments
          },
          success: api_.Utils.getCallbackWrapper(() => {
            resolve();
          }),
          failure: handleRequestFailure(reject, 'Failed to save setting for audit comment requirements.')
        });
      });
    });
    FolderAPIWrapper_defineProperty(this, "updateProjectDataExclusions", (options, containerPath) => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'updateProjectDataExclusion.api', containerPath),
          method: 'POST',
          jsonData: options,
          success: api_.Utils.getCallbackWrapper(({
            data
          }) => {
            resolve();
          }),
          failure: handleRequestFailure(reject, 'Failed to update project data type')
        });
      });
    });
    FolderAPIWrapper_defineProperty(this, "updateProjectLookAndFeelSettings", (options, containerPath) => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL('admin', 'updateProjectSettings.api', containerPath),
          method: 'POST',
          jsonData: options,
          success: api_.Utils.getCallbackWrapper(({
            data
          }) => {
            resolve();
          }),
          failure: handleRequestFailure(reject, 'Failed to update project look and feel settings')
        });
      });
    });
    FolderAPIWrapper_defineProperty(this, "getDataTypeExcludedProjects", (dataType, dataTypeRowId) => {
      if (!dataType || !dataTypeRowId) {
        return Promise.resolve(undefined);
      }
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL(SAMPLE_MANAGER_APP_PROPERTIES.controllerName, 'getDataTypeExclusion.api'),
          method: 'GET',
          params: {
            dataType,
            dataTypeRowId
          },
          success: api_.Utils.getCallbackWrapper(response => {
            resolve(response['excludedProjects']);
          }),
          failure: handleRequestFailure(reject, 'Failed to get excluded projects')
        });
      });
    });
    FolderAPIWrapper_defineProperty(this, "getProjects", (container, moduleContext, includeStandardProperties, includeEffectivePermissions, includeTopFolder) => {
      return new Promise((resolve, reject) => {
        const topFolderPath = isAppHomeFolder(container, moduleContext) ? container.path : container.parentPath;
        actions_fetchContainers({
          containerPath: topFolderPath,
          includeEffectivePermissions,
          includeStandardProperties,
          includeWorkbookChildren: false,
          includeSubfolders: true,
          depth: 1
        }).then(containers => {
          const projects = containers
          // if user doesn't have permissions to the parent/project, the response will come back with an empty Container object
          .filter(c => c !== undefined && c.id !== '');
          const childProjects = projects.filter(c => c.path !== topFolderPath);
          // Issue 45805: sort folders by title as server-side sorting is insufficient
          childProjects.sort(naturalSortByProperty('title'));
          if (!includeTopFolder) {
            resolve(childProjects);
          } else {
            const top = projects.find(c => c.path === topFolderPath);
            const allProject = top ? [FolderAPIWrapper_objectSpread(FolderAPIWrapper_objectSpread({}, top), {}, {
              title: top.path === HOME_PATH ? HOME_TITLE : top.title
            })] : [];
            allProject.push(...childProjects);
            resolve(allProject);
          }
        }).catch(error => {
          reject(error);
        });
      });
    });
    FolderAPIWrapper_defineProperty(this, "getFolderDataTypeExclusions", getFolderDataTypeExclusions);
    FolderAPIWrapper_defineProperty(this, "updateProjectCustomLabels", (labelProvider, labels, containerPath) => {
      return new Promise((resolve, reject) => {
        api_.Ajax.request({
          url: api_.ActionURL.buildURL('core', 'customLabels.api', containerPath),
          method: 'POST',
          jsonData: {
            provider: labelProvider,
            labelsJson: JSON.stringify(labels)
          },
          success: api_.Utils.getCallbackWrapper(({
            data
          }) => {
            resolve();
          }),
          failure: handleRequestFailure(reject, 'Failed to update project custom labels.')
        });
      });
    });
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getFolderTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return FolderAPIWrapper_objectSpread({
    createProject: mockFn(),
    renameProject: mockFn(),
    getAuditSettings: mockFn(),
    setAuditCommentsRequired: mockFn(),
    updateProjectDataExclusions: mockFn(),
    getDataTypeExcludedProjects: mockFn(),
    getFolderDataTypeExclusions: mockFn(),
    updateProjectLookAndFeelSettings: mockFn(),
    updateProjectCustomLabels: mockFn(),
    getProjects: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/components/labels/actions.ts


const updateCustomLabels = (labelProvider, labels, containerPath) => {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('core', 'customLabels.api', containerPath),
      method: 'POST',
      jsonData: {
        provider: labelProvider,
        labelsJson: JSON.stringify(labels)
      },
      success: api_.Utils.getCallbackWrapper(() => {
        resolve();
      }),
      failure: handleRequestFailure(reject, 'Failed to update project custom labels.')
    });
  });
};
const getCustomLabels = containerPath => {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('core', 'getCustomLabels.api', containerPath),
      method: 'GET',
      success: api_.Utils.getCallbackWrapper(({
        labels
      }) => {
        resolve(labels);
      }),
      failure: handleRequestFailure(reject, 'Failed to get ELN custom labels.')
    });
  });
};
const getModuleCustomLabels = (moduleName, containerPath) => {
  return new Promise((resolve, reject) => {
    getCustomLabels(containerPath).then(results => {
      resolve(results?.[moduleName]);
    }).catch(reason => {
      console.error(reason);
      reject(reason);
    });
  });
};
;// CONCATENATED MODULE: ./src/internal/components/labels/APIWrapper.ts
function labels_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function labels_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? labels_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { labels_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : labels_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function labels_APIWrapper_defineProperty(e, r, t) { return (r = labels_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function labels_APIWrapper_toPropertyKey(t) { var i = labels_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function labels_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class ServerLabelsAPIWrapper {
  constructor() {
    labels_APIWrapper_defineProperty(this, "updateCustomLabels", updateCustomLabels);
    labels_APIWrapper_defineProperty(this, "getModuleCustomLabels", getModuleCustomLabels);
  }
}
function getLabelsTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return labels_APIWrapper_objectSpread({
    updateCustomLabels: mockFn(),
    getModuleCustomLabels: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/components/navigation/actions.ts



function signOut(navigateUrl) {
  const startUrl = buildURL('project', 'start', undefined, {
    returnUrl: false
  });

  // for the redirectUrl to work in the case of CAS logout provider redirect, this URL needs to include the host (Issue 39803)
  const returnUrl = api_.ActionURL.getBaseURL(true) + (navigateUrl || startUrl);
  api_.Ajax.request({
    url: buildURL('login', 'logoutAPI.api', undefined, {
      returnUrl
    }),
    method: 'POST',
    success: api_.Utils.getCallbackWrapper(response => {
      window.location.href = response.redirectUrl || returnUrl;
    }),
    failure: api_.Utils.getCallbackWrapper(response => {
      console.error(response);
      window.location.href = returnUrl;
    }, false)
  });
}
function signIn() {
  window.location.href = buildURL('login', 'login');
}
function getUserMenuSection(currentProductId, productId, container) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: buildURL('product', 'userMenuSection.api', undefined, {
        container
      }),
      params: Object.assign({
        productId
      }),
      success: api_.Utils.getCallbackWrapper(response => {
        if (response) {
          resolve(MenuSectionModel.create(response, currentProductId, container));
        } else {
          console.warn('No user menu section returned');
          resolve(undefined);
        }
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(response);
      })
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/navigation/NavigationAPIWrapper.ts
function NavigationAPIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NavigationAPIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NavigationAPIWrapper_ownKeys(Object(t), !0).forEach(function (r) { NavigationAPIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NavigationAPIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function NavigationAPIWrapper_defineProperty(e, r, t) { return (r = NavigationAPIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function NavigationAPIWrapper_toPropertyKey(t) { var i = NavigationAPIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function NavigationAPIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class ServerNavigationAPIWrapper {
  constructor() {
    NavigationAPIWrapper_defineProperty(this, "initMenuModel", async (appProperties, moduleContext, containerId, containerPath) => {
      const primaryProductId = getPrimaryAppProperties(moduleContext).productId;
      const menuModel = new ProductMenuModel({
        containerId,
        containerPath,
        currentProductId: appProperties?.productId ?? primaryProductId,
        productIds: getAppProductIds(primaryProductId)
      });
      try {
        const sections = await menuModel.getMenuSections();
        return menuModel.setLoadedSections(sections);
      } catch (e) {
        console.error('Problem retrieving product menu data.', e);
        return menuModel.setError('Error in retrieving product menu data. Please contact your site administrator.');
      }
    });
    NavigationAPIWrapper_defineProperty(this, "loadUserMenu", async (currentProductId, appProperties, moduleContext, containerPath) => {
      const primaryProductId = getPrimaryAppProperties(moduleContext).productId;
      try {
        return await getUserMenuSection(currentProductId, appProperties?.productId ?? primaryProductId, containerPath);
      } catch (e) {
        return undefined;
      }
    });
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getNavigationTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return NavigationAPIWrapper_objectSpread({
    initMenuModel: mockFn(),
    loadUserMenu: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/public/QueryModel/grid/actions/Filter.ts
function Filter_defineProperty(e, r, t) { return (r = Filter_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Filter_toPropertyKey(t) { var i = Filter_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Filter_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/**
 * The following section prepares the SYMBOL_MAP and SUFFIX_MAP to allow any Filter Action instances
 * to quickly resolve a IFilterType from a symbol/suffix for a filter.
 */

// construct symbol map
let SYMBOL_MAP = (0,external_immutable_.Map)().asMutable();
let SUFFIX_MAP = (0,external_immutable_.Map)().asMutable();
let TEXT_MAP = (0,external_immutable_.Map)().asMutable();
let TYPE_SET = (0,external_immutable_.Set)().asMutable();
const TYPE_MAP = (0,external_immutable_.Map)(api_.Filter.Types);
TYPE_MAP.valueSeq().forEach(type => {
  // there are duplicates of the same filter in the type map (e.g. NEQ and NOT_EQUAL)
  const suffix = getURLSuffix(type);
  const symbol = type.getDisplaySymbol();
  if (!TYPE_SET.has(suffix)) {
    TYPE_SET.add(suffix);
    SUFFIX_MAP.set(suffix, type);
    if (symbol !== null) {
      if (!SYMBOL_MAP.has(symbol)) {
        SYMBOL_MAP.set(symbol, (0,external_immutable_.Map)().asMutable());
      }
      SYMBOL_MAP.get(symbol).set(suffix, type);
    }
    const text = type.getDisplayText();
    if (text) {
      TEXT_MAP.set(text.toLowerCase(), type);
    }
  }
});
SYMBOL_MAP = SYMBOL_MAP.asImmutable();
SUFFIX_MAP = SUFFIX_MAP.asImmutable();
TEXT_MAP = TEXT_MAP.asImmutable();
TYPE_SET = undefined;

/**
 * Remaps URL suffixes for types where the suffix cannot be distinguished.
 * @private
 */
function getURLSuffix(type) {
  const suffix = type.getURLSuffix();
  if (suffix === '') return 'any';
  return suffix;
}

/**
 * Given a symbol/suffix/text and a QueryColumn this will resolve the IFilterType based on the column
 * type matched against the symbol/suffix/text.
 * @param token
 * @param column
 * @returns {IFilterType}
 */
function resolveFilterType(token, column) {
  if (SUFFIX_MAP.has(token)) {
    return SUFFIX_MAP.get(token);
  }
  if (token === ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE.getURLSuffix()) return ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE;
  if (SYMBOL_MAP.has(token)) {
    const symbolTypes = SYMBOL_MAP.get(token);
    const types = api_.Filter.getFilterTypesForType(column.getDisplayFieldJsonType());
    let value;
    let match = false;
    for (let i = 0; i < types.length; i++) {
      const suffix = getURLSuffix(types[i]);
      if (symbolTypes.has(suffix)) {
        if (match) {
          console.warn(`Column of type "${column.jsonType}" has multiple filters for symbol "${token}".`);
          match = false;
          value = undefined;
          break; // stop the loop, ambiguous
        } else {
          match = true;
          value = symbolTypes.get(suffix);
        }
      }
    }
    if (match && value) {
      return value;
    }
  }
  const text = token.toLowerCase();
  if (TEXT_MAP.has(text)) {
    return TEXT_MAP.get(text);
  }
  return undefined;
}

/**
 * Given a IFilterType resolves the symbol (string) that should be displayed
 * @param filterType
 * @returns {string}
 */
function resolveSymbol(filterType) {
  const symbol = filterType?.getDisplaySymbol();
  if (symbol) {
    return symbol;
  }
  const displayText = filterType?.getDisplayText();
  if (displayText) {
    return displayText;
  }
  return getURLSuffix(filterType);
}
class FilterAction {
  constructor(getFilterDisplayValue) {
    Filter_defineProperty(this, "iconCls", 'filter');
    Filter_defineProperty(this, "keyword", 'filter');
    Filter_defineProperty(this, "getFilterDisplayValue", void 0);
    this.getFilterDisplayValue = getFilterDisplayValue;
  }
  getDisplayValue(columnName, filterType, rawValue) {
    let value, inputValue;
    const displayParts = [decodePart(columnName), resolveSymbol(filterType)];
    const inputDisplayParts = [`"${displayParts[0]}"`, displayParts[1]]; // need to quote column name for input display

    if (!filterType.isDataValueRequired()) {
      // intentionally do not modify "display" -- this filter type does not support a value (e.g. isblank)
    } else if (filterType.isMultiValued()) {
      if (api_.Utils.isString(rawValue)) {
        // TODO: port the IFilterType.parseValue to labkey-api-js
        rawValue = rawValue.split(filterType.getMultiValueSeparator());
      }
      if (!api_.Utils.isArray(rawValue)) {
        throw new Error("Expected '" + filterType.getMultiValueSeparator() + "' string or an Array of values, got: " + rawValue);
      }

      // TODO: This is just a stopgap to prevent rendering crazy long IN clauses. Pretty much any solution besides
      // showing all the values or this would be preferred. See 28884.
      if (rawValue.length > 3) {
        value = `(${rawValue.length} values)`;
      } else {
        value = rawValue.join(', ');
      }
    } else {
      value = '' + rawValue;
      if (this.getFilterDisplayValue) {
        const displayValue = this.getFilterDisplayValue(columnName, value);
        if (displayValue) {
          value = '' + displayValue;
        }
        inputDisplayParts.push(value);
        inputValue = inputDisplayParts.join(' ');
      }
    }
    if (value) {
      displayParts.push(value);
    }
    return {
      displayValue: displayParts.join(' '),
      inputValue
    };
  }
  actionValueFromFilter(filter, column, isReadOnly) {
    const label = column?.shortCaption;
    const columnName = filter.getColumnName();
    const filterType = filter.getFilterType();
    const operator = resolveSymbol(filter.getFilterType());
    let value = filter.getValue();

    // Issue 45140: match date display format in grid filter status pill display
    if (column?.isTimeColumn) {
      value = getColFormattedTimeFilterValue(column, value);
    } else if (column?.getDisplayFieldJsonType() === 'date') {
      value = getColFormattedDateFilterValue(column, value);
    }
    const {
      displayValue,
      inputValue
    } = this.getDisplayValue(label ?? columnName, filterType, value);
    return {
      action: this,
      displayValue,
      isReadOnly,
      value: inputValue ? inputValue : `"${label ?? columnName}" ${operator} ${value}`,
      valueObject: filter
    };
  }
}
;// CONCATENATED MODULE: ./src/internal/url/NotAnyFilterType.ts
/**
 * A dummy FilterType to indicate no value is selected, not even '[blank]'. The counterpart to IFilterType.HAS_ANY_VALUE
 * Used by FilterFacetedSelector for unchecking '[All]' value(s).
 */
class NotAnyFilterType {
  getDisplaySymbol() {
    return null;
  }
  getDisplayText() {
    return 'NotAny';
  }
  getLongDisplayText() {
    return this.getDisplayText();
  }
  getURLSuffix() {
    return 'notany';
  }
  isDataValueRequired() {
    return false;
  }
  isMultiValued() {
    return false;
  }
  isTableWise() {
    return true;
  }
  getMultiValueFilter() {
    return null;
  }
  getMultiValueMaxOccurs() {
    return 0;
  }
  getMultiValueMinOccurs() {
    return 0;
  }
  getMultiValueSeparator() {
    return null;
  }
  getOpposite() {
    return null;
  }
  getSingleValueFilter() {
    return null;
  }
  parseValue(value) {
    return value;
  }
  getURLParameterValue(value) {
    return value;
  }
  validate(value, jsonType, columnName) {}
  getLabKeySqlOperator() {
    return null;
  }
}
const NOT_ANY_FILTER_TYPE = new NotAnyFilterType();
;// CONCATENATED MODULE: ./src/internal/components/search/utils.ts









const SAMPLE_FILTER_METRIC_AREA = 'sampleFinder';
const CHOOSE_VALUE_FILTERS = [api_.Filter.Types.EQUAL.getURLSuffix(), api_.Filter.Types.IN.getURLSuffix(), api_.Filter.Types.NEQ.getURLSuffix(), api_.Filter.Types.NEQ_OR_NULL.getURLSuffix(), api_.Filter.Types.NOT_IN.getURLSuffix()];
function isBetweenOperator(urlSuffix) {
  return ['between', 'notbetween'].indexOf(urlSuffix) > -1;
}
const FILTER_URL_SUFFIX_ANY_ALT = 'any';
function getFilterOptionsForType(field, isAncestor) {
  if (!field) return null;
  const jsonType = field.getDisplayFieldJsonType();
  const useConceptFilters = field.isConceptCodeColumn && isOntologyEnabled();
  let filterList = (useConceptFilters ? CONCEPT_COLUMN_FILTER_TYPES : api_.Filter.getFilterTypesForType(jsonType)).filter(function (result) {
    return api_.Filter.Types.HAS_ANY_VALUE.getURLSuffix() !== result.getURLSuffix();
  });
  if (jsonType === 'date') {
    filterList.push(api_.Filter.Types.BETWEEN);
    filterList.push(api_.Filter.Types.NOT_BETWEEN);
  }
  if (!useConceptFilters && isAncestor) {
    const equalsOneOfInd = filterList.map(type => type.getURLSuffix()).indexOf('in');
    if (equalsOneOfInd) {
      filterList = [...filterList.slice(0, equalsOneOfInd), ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE, ...filterList.slice(equalsOneOfInd)];
    } else filterList.push(ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE);
  }
  return filterList.map(filter => {
    let urlSuffix = filter.getURLSuffix();
    if (urlSuffix === '') urlSuffix = FILTER_URL_SUFFIX_ANY_ALT;
    return {
      value: urlSuffix,
      label: filter.getDisplayText(),
      valueRequired: filter.isDataValueRequired(),
      multiValue: filter.isMultiValued(),
      betweenOperator: isBetweenOperator(urlSuffix),
      isSoleFilter: urlSuffix === api_.Filter.Types.EQUAL.getURLSuffix() || urlSuffix === api_.Filter.Types.ISBLANK.getURLSuffix() || urlSuffix === api_.Filter.Types.DATE_EQUAL.getURLSuffix()
    };
  });
}
function isFilterUrlSuffixMatch(suffix, filterType) {
  if (suffix === 'any' && filterType.getURLSuffix() === '') return true;
  return suffix === filterType.getURLSuffix();
}
function getFilterTypePlaceHolder(suffix) {
  if (suffix === 'in' || suffix === 'notin' || suffix === 'containsoneof' || suffix === 'containsnoneof') {
    return 'Use new line or semicolon to separate entries';
  }
  return null;
}
function isChooseValuesFilter(filter) {
  if (!filter) return;
  return CHOOSE_VALUE_FILTERS.indexOf(filter.getFilterType().getURLSuffix()) >= 0;
}
const ALL_VALUE_DISPLAY = '[All]';
const EMPTY_VALUE_DISPLAY = '[blank]';
function getFilterValuesAsArray(filter, blankValue, checkNull = false) {
  let values = [],
    rawValues;
  const rawValue = filter.getValue();
  if (checkNull && rawValue === null) return [];
  if (Array.isArray(rawValue)) {
    rawValues = [...rawValue];
  } else if (typeof rawValue === 'string') {
    rawValues = rawValue.split(';');
  } else rawValues = [rawValue];
  rawValues.forEach(v => {
    values.push(v == '' ? blankValue ?? EMPTY_VALUE_DISPLAY : v);
  });
  return values;
}
function getFieldFiltersValidationResult(dataTypeFilters, queryLabels) {
  let missingValueFields = {},
    hasMissingError = false,
    maxMatchAllErrorField = null;
  Object.keys(dataTypeFilters).forEach(parent => {
    const filters = dataTypeFilters[parent];
    filters.forEach(fieldFilter => {
      const filter = fieldFilter.filter;
      if (filter.getFilterType().isDataValueRequired()) {
        const value = filter.getValue();
        const isBetween = isBetweenOperator(filter.getFilterType().getURLSuffix());
        const isMatchesAll = filter.getFilterType().getURLSuffix() === ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE.getURLSuffix();
        let missingValueError = false;
        if (value === undefined || value === null || api_.Utils.isString(value) && !value) {
          missingValueError = true;
        } else if (isBetween) {
          if (!Array.isArray(value) || value.length < 2) {
            missingValueError = true;
          } else {
            if (api_.Utils.isString(value[0]) && !value[0] || api_.Utils.isString(value[1]) && !value[1]) {
              missingValueError = true;
            }
          }
        }
        if (isMatchesAll) {
          if (!value || Array.isArray(value) && value.length === 0) missingValueError = true;
          if (!Array.isArray(value) || value.length > 10) {
            maxMatchAllErrorField = fieldFilter.fieldCaption;
          }
        }
        if (missingValueError == true) {
          hasMissingError = true;
          const fields = missingValueFields[parent] ?? [];
          if (fields.indexOf(fieldFilter.fieldCaption) === -1) {
            fields.push(fieldFilter.fieldCaption);
            missingValueFields[parent] = fields;
          }
        }
      }
    });
  });
  if (hasMissingError) {
    const parentMsgs = [];
    Object.keys(missingValueFields).forEach(parent => {
      const parentLabel = queryLabels?.[parent];
      parentMsgs.push((parentLabel ? parentLabel + ': ' : '') + missingValueFields[parent].join(', '));
    });
    return 'Missing filter values for: ' + parentMsgs.join('; ') + '.';
  }
  if (maxMatchAllErrorField) return "At most 10 values can be selected for 'Equals All Of' filter type for '" + maxMatchAllErrorField + "'.";
  return null;
}
function getFilterForFilterSelection(filterSelection, field) {
  return getUpdateFilterExpressionFilter(filterSelection.filterType, field, filterSelection.firstFilterValue, filterSelection.secondFilterValue, filterSelection.firstFilterValue, false, false);
}
function getUpdateFilterExpressionFilter(newFilterType, field, previousFirstFilterValue, previousSecondFilterValue, newFilterValue, isSecondValue, clearBothValues) {
  if (!newFilterType) {
    return null;
  }
  const filterType = resolveFilterType(newFilterType?.value, field);
  if (!filterType) return null;
  let filter;
  const fieldKey = field.getDisplayFieldKey();
  if (!newFilterType.valueRequired) {
    filter = api_.Filter.create(fieldKey, null, filterType);
  } else {
    let value = newFilterValue;
    if (newFilterType?.betweenOperator) {
      if (clearBothValues) {
        value = null;
      } else if (isSecondValue) {
        if (newFilterValue == null) {
          value = previousFirstFilterValue != null ? previousFirstFilterValue : '';
        } else {
          value = (previousFirstFilterValue != null ? previousFirstFilterValue + ',' : '') + newFilterValue;
        }
      } else {
        if (newFilterValue == null) {
          value = previousSecondFilterValue != null ? previousSecondFilterValue : '';
        } else {
          value = newFilterValue + (previousSecondFilterValue != null ? ',' + previousSecondFilterValue : '');
        }
      }
    } else if (!value && field.getDisplayFieldJsonType() === 'boolean') {
      value = 'false';
    }
    filter = api_.Filter.create(fieldKey, value, filterType);
  }
  return filter;
}

// this util is only for string field type
function getCheckedFilterValues(filter, allValues) {
  if (!filter && !allValues) return [];

  // if allValues is undefined, then we don't know the full set of values so filter must be an Equals/Equals one of
  if (!allValues) return getFilterValuesAsArray(filter, undefined, true);

  // if no existing filter, check all values by default
  if (!filter) return allValues;
  if (filter.getFilterType().isDataValueRequired() && filter.getValue() == null) return allValues;
  const filterUrlSuffix = filter.getFilterType().getURLSuffix();
  const filterValues = getFilterValuesAsArray(filter);
  const hasBlank = allValues.findIndex(value => value === EMPTY_VALUE_DISPLAY) !== -1;
  if (filterUrlSuffix === 'ancestormatchesallof') {
    if (filterValues?.length === allValues.length - 1 /** except [All] **/) return allValues;
    return filterValues;
  }
  switch (filterUrlSuffix) {
    case '':
    case 'any':
      return allValues;
    case 'isblank':
      return [EMPTY_VALUE_DISPLAY];
    case 'isnonblank':
      return hasBlank ? allValues.filter(value => value !== EMPTY_VALUE_DISPLAY && value !== ALL_VALUE_DISPLAY) : allValues;
    case 'neq':
    case 'neqornull':
      return allValues.filter(value => value !== filterValues[0] && value !== ALL_VALUE_DISPLAY);
    case 'eq':
    case 'in':
      return filterValues;
    case 'notin':
      return allValues.filter(value => filterValues.indexOf(value) === -1 && value !== ALL_VALUE_DISPLAY);
    default:
      return [];
  }
}
function getUpdatedCheckedValues(allValues, newValue, check, oldFilter, uncheckOthers) {
  if (uncheckOthers) return [newValue];
  const oldCheckedValues = getCheckedFilterValues(oldFilter, allValues);
  let newCheckedValues = [...oldCheckedValues];
  if (check) {
    if (newCheckedValues.indexOf(newValue) === -1) newCheckedValues.push(newValue);
    if (allValues && allValues.length - newCheckedValues.length === 1) {
      if (newCheckedValues.indexOf(ALL_VALUE_DISPLAY) === -1) newCheckedValues.push(ALL_VALUE_DISPLAY);
    }
  } else {
    newCheckedValues = newCheckedValues.filter(val => val !== newValue && val !== ALL_VALUE_DISPLAY);
  }
  return newCheckedValues;
}
// this util is only for string field type
function getUpdatedChooseValuesFilter(allValues, fieldKey, newValue, check, oldFilter, uncheckOthers) {
  const isAncestorMatchesAllFilter = oldFilter?.getFilterType().getURLSuffix() === ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE.getURLSuffix();
  const hasBlank = allValues ? allValues.findIndex(value => value === EMPTY_VALUE_DISPLAY) !== -1 : false;
  // if check all, or everything is checked, this is essentially "no filter", unless there is no blank value
  // then it's an NONBLANK filter
  if (newValue === ALL_VALUE_DISPLAY && check) {
    if (isAncestorMatchesAllFilter) return api_.Filter.create(fieldKey, allValues.filter(v => v !== ALL_VALUE_DISPLAY), ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE);
    return hasBlank ? null : api_.Filter.create(fieldKey, null, api_.Filter.Types.NONBLANK);
  }
  const newCheckedDisplayValues = getUpdatedCheckedValues(allValues, newValue, check, oldFilter, uncheckOthers);
  const newCheckedValues = [];
  newCheckedDisplayValues.forEach(v => {
    newCheckedValues.push(v === EMPTY_VALUE_DISPLAY ? '' : v);
  });

  // skip optimization for ANCESTOR_MATCHES_ALL filter type
  if (isAncestorMatchesAllFilter) {
    if (newValue === ALL_VALUE_DISPLAY && !check || newCheckedValues.length === 0) return api_.Filter.create(fieldKey, [], ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE);
    return api_.Filter.create(fieldKey, newCheckedValues, ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE);
  }

  // if everything is checked, this is the same as not filtering
  if (newValue === ALL_VALUE_DISPLAY && check || allValues && newCheckedValues.length === allValues.length) {
    return null;
  }

  // if uncheck all or if everything is unchecked, create a new NOTANY filter type
  if (newValue === ALL_VALUE_DISPLAY && !check || newCheckedValues.length === 0) return api_.Filter.create(fieldKey, null, NOT_ANY_FILTER_TYPE);

  // if only one is checked
  if (newCheckedValues.length === 1) {
    if (newCheckedValues[0] === '') return api_.Filter.create(fieldKey, null, api_.Filter.Types.ISBLANK);
    return api_.Filter.create(fieldKey, newCheckedValues[0]);
  }

  // using anything but an in clause only applies if we know all the values
  if (allValues) {
    const newUncheckedDisplayValue = allValues.filter(val => newCheckedDisplayValues.indexOf(val) === -1);
    const newUncheckedValues = [];
    newUncheckedDisplayValue.filter(v => v !== ALL_VALUE_DISPLAY).forEach(v => {
      newUncheckedValues.push(v === EMPTY_VALUE_DISPLAY ? '' : v);
    });

    // if only one is unchecked
    if (newUncheckedValues.length === 1) {
      if (newUncheckedValues[0] === '') return api_.Filter.create(fieldKey, null, api_.Filter.Types.NONBLANK);
      return api_.Filter.create(fieldKey, newUncheckedValues[0], api_.Filter.Types.NEQ_OR_NULL);
    }

    // if number of checked is greater than unchecked, use Not_In unchecked
    if (newCheckedValues.length > newUncheckedValues.length) {
      return api_.Filter.create(fieldKey, newUncheckedValues, api_.Filter.Types.NOT_IN);
    }
  }
  return api_.Filter.create(fieldKey, newCheckedValues, api_.Filter.Types.IN);
}
function isValidFilterField(field, queryInfo, exprColumnsWithSubSelect) {
  // cannot include fields that are not supported by the database
  if (!queryInfo.supportGroupConcatSubSelect && exprColumnsWithSubSelect && exprColumnsWithSubSelect.indexOf(field.fieldKey) !== -1) {
    return false;
  }

  // exclude the storage Units field for sample types since the display of this field is nonstandard and it is not
  // a useful field for filtering parent values
  if (isSamplesSchema(queryInfo.schemaQuery) && field?.fieldKey === 'Units') {
    return false;
  }
  return true;
}
function getFilterSelections(fieldFilters, filterOptions) {
  const filters = [];
  fieldFilters?.forEach(fieldFilter => {
    const filterOption = filterOptions?.find(option => {
      return isFilterUrlSuffixMatch(option.value, fieldFilter.getFilterType());
    });
    if (filterOption) {
      const filter = {
        filterType: filterOption
      };
      const values = getFilterValuesAsArray(fieldFilter, '');
      if (filterOption.betweenOperator) {
        filter.firstFilterValue = values[0];
        filter.secondFilterValue = values[1];
      } else if (values.length > 1) {
        filter.firstFilterValue = values.join(';');
      } else {
        filter.firstFilterValue = values[0];
      }
      filters.push(filter);
    }
  });
  if (filters.length === 0) {
    const filterOption = filterOptions?.find(option => {
      return isFilterUrlSuffixMatch(option.value, api_.Filter.Types.CONTAINS);
    });
    if (filterOption) {
      filters.push({
        filterType: filterOption
      });
    } else if (filterOptions?.length) {
      filters.push({
        filterType: filterOptions[0]
      });
    }
  }
  return filters;
}
function getUpdatedFilters(field, activeFilters, filterIndex, newFilterType, newFilterValue, isSecondValue, clearBothValues) {
  const newFilter = getUpdateFilterExpressionFilter(newFilterType, field, activeFilters[filterIndex]?.firstFilterValue, activeFilters[filterIndex]?.secondFilterValue, newFilterValue, isSecondValue, clearBothValues);
  let newFilters = [];
  if (!newFilter) {
    if (activeFilters.length > 1) {
      // retain the other filter
      newFilters = [getFilterForFilterSelection(activeFilters[filterIndex == 1 ? 0 : 1], field)];
    }
  } else {
    if (newFilterType.isSoleFilter) {
      newFilters = [newFilter];
    } else {
      if (filterIndex === 1) {
        newFilters = [getFilterForFilterSelection(activeFilters[0], field), newFilter];
      } else {
        newFilters = activeFilters.length <= 1 ? [newFilter] : [newFilter, getFilterForFilterSelection(activeFilters[1], field)];
      }
    }
  }
  return newFilters;
}
function getUpdatedFilterSelection(newActiveFilterType, activeFilter) {
  let firstValue = activeFilter?.firstFilterValue;
  let shouldClear = false;

  // when a value is required, we want to start with 'undefined' instead of 'null' since 'null' is seen as a valid value
  if (newActiveFilterType?.valueRequired && !activeFilter?.filterType.valueRequired || activeFilter?.filterType?.multiValue && !newActiveFilterType?.multiValue) {
    firstValue = undefined;
    shouldClear = true;
  } else if (!newActiveFilterType?.valueRequired) {
    // if value is not required, then we'll start with null
    firstValue = null;
    shouldClear = true;
  }
  return {
    shouldClear,
    filterSelection: {
      filterType: newActiveFilterType,
      firstFilterValue: firstValue,
      secondFilterValue: shouldClear ? undefined : activeFilter?.secondFilterValue
    }
  };
}
function getSearchScopeFromContainerFilter(cf) {
  switch (cf) {
    case api_.Query.ContainerFilter.allFolders:
      return SearchScope.All;
    case api_.Query.ContainerFilter.current:
      return SearchScope.Folder;
    case api_.Query.ContainerFilter.currentAndParents:
      return SearchScope.FolderAndProject;
    // TODO: I dont think this is a perfect match
    case api_.Query.ContainerFilter.currentAndSubfoldersPlusShared:
      return SearchScope.FolderAndSubfoldersAndShared;
    case api_.Query.ContainerFilter.currentPlusProject:
      return SearchScope.FolderAndProject;
    case api_.Query.ContainerFilter.currentPlusProjectAndShared:
      return SearchScope.FolderAndProjectAndShared;
    case api_.Query.ContainerFilter.currentAndFirstChildren: // TODO: I dont think this is a perfect match
    case api_.Query.ContainerFilter.currentAndSubfolders:
    default:
      return SearchScope.FolderAndSubfolders;
  }
}
function getSearchResultCardData(data, category, queryMetadata) {
  if (data) {
    const dataName = data.name;
    if (data.dataClass?.name) {
      if (data.dataClass.category === 'sources') {
        return {
          iconSrc: 'sources',
          category: 'Sources',
          title: dataName
        };
      }
    } else if (data.type) {
      const type = data.type;
      if (type === 'sampleSet') {
        return {
          iconSrc: queryMetadata?.getIn(['schema', SCHEMAS.SAMPLE_SETS.SCHEMA, 'query', data['name'].toLowerCase(), 'iconURL']) || 'sample_set',
          altText: 'sample_type-icon',
          category: 'Sample Type',
          title: dataName
        };
      } else if (type.indexOf('dataClass') === 0) {
        const parts = type.split(':');
        if (parts.length == 1 || parts.length > 1 && parts[1].toLowerCase() !== REGISTRY_KEY) {
          return {
            altText: 'source_type-icon',
            iconSrc: 'source_type',
            category: 'Source Type',
            title: dataName
          };
        } else {
          return {
            altText: 'source_type-icon',
            iconSrc: data.name.toLowerCase(),
            category: 'Registry Source Type'
          };
        }
      } else if (type === 'assay') {
        return {
          category: 'Assay'
        };
      }
    } else if (data.sampleSet?.name) {
      const sampleSetName = data.sampleSet.name.toLowerCase();
      return {
        iconSrc: queryMetadata?.getIn(['schema', SCHEMAS.SAMPLE_SETS.SCHEMA, 'query', sampleSetName, 'iconURL']) || 'samples',
        altText: 'sample_type-icon',
        category: 'Sample Type',
        title: dataName
      };
    } else if (category === SearchCategory.Material) {
      return {
        category: 'Sample',
        title: dataName
      };
    }
  }
  switch (category) {
    case SearchCategory.Assay:
      return {
        category: 'Assay'
      };
    case SearchCategory.Plate:
      return {
        iconSrc: 'plates'
      };
    case SearchCategory.WorkflowJob:
      return {
        category: 'Job'
      };
    default:
      return {};
  }
}
const decodeErrorMessage = msg => {
  if (!msg) return msg;
  let decodedMsg = msg.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#039;/g, "'");
  if (decodedMsg.charAt(decodedMsg.length - 1) != '.') decodedMsg += '.';
  return decodedMsg;
};
;// CONCATENATED MODULE: ./src/internal/components/search/models.ts
function search_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function search_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? search_models_ownKeys(Object(t), !0).forEach(function (r) { search_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : search_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function search_models_defineProperty(e, r, t) { return (r = search_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function search_models_toPropertyKey(t) { var i = search_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function search_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class SearchResultsModel extends (0,external_immutable_.Record)({
  entities: undefined,
  error: undefined,
  isLoading: false,
  isLoaded: false,
  lastUpdate: undefined
}) {
  static create(raw) {
    return new SearchResultsModel(search_models_objectSpread(search_models_objectSpread({}, raw), {}, {
      entities: raw.entities ? (0,external_immutable_.fromJS)(raw.entities) : undefined
    }));
  }
}
class SearchIdData {
  constructor() {
    search_models_defineProperty(this, "group", void 0);
    search_models_defineProperty(this, "id", void 0);
    search_models_defineProperty(this, "type", void 0);
  }
}
;// CONCATENATED MODULE: ./src/internal/components/search/actions.ts
const search_actions_excluded = ["containerPath", "requestHandler"];
function search_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function search_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? search_actions_ownKeys(Object(t), !0).forEach(function (r) { search_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : search_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function search_actions_defineProperty(e, r, t) { return (r = search_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function search_actions_toPropertyKey(t) { var i = search_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function search_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function search_actions_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = search_actions_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function search_actions_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }











const search = (options, moduleContext, applyURLResolver = true, request = api_.Ajax.request) => {
  // eslint-disable-next-line prefer-const
  let {
      containerPath,
      requestHandler
    } = options,
    params = search_actions_objectWithoutProperties(options, search_actions_excluded);
  let containerPath_;
  if (isAllProductFoldersFilteringEnabled(moduleContext)) {
    containerPath_ = getProjectPath();
    params.scope = SearchScope.FolderAndSubfoldersAndShared;
  } else if (containerPath) {
    containerPath_ = containerPath;
  }

  // Return extra info about entity types and material results
  if (params.experimentalCustomJson === undefined) {
    params.experimentalCustomJson = true;
  }

  // Remove the containerID from the returned URL
  if (params.normalizeUrls === undefined) {
    params.normalizeUrls = true;
  }
  if (!params.scope) {
    params.scope = getSearchScopeFromContainerFilter(getContainerFilter(containerPath_));
  }
  if (Array.isArray(params.category)) {
    params.category = params.category.join('+');
  }
  return new Promise((resolve, reject) => {
    const request_ = request({
      url: buildURL('search', 'json.api', undefined, {
        container: containerPath_
      }),
      method: 'POST',
      params,
      success: api_.Utils.getCallbackWrapper(json => {
        if (applyURLResolver) {
          resolve(new URLResolver().resolveSearchUsingIndex(json));
        } else {
          resolve(json);
        }
      }),
      failure: handleRequestFailure(reject, 'Failed search query')
    });
    requestHandler?.(request_);
  });
};
/** @deprecated Use search() instead */
async function searchUsingIndex(options, getCardDataFn) {
  const appProps = getPrimaryAppProperties();
  if (appProps?.productId) {
    incrementClientSideMetricCount(appProps.productId + 'Search', 'count');
  }

  // Don't apply the URL Resolver until the data objects have been resolved
  let result = await search(options, undefined, false);
  addDataObjects(result);
  result = new URLResolver().resolveSearchUsingIndex(result);
  return search_actions_objectSpread(search_actions_objectSpread({}, result), {}, {
    hits: getProcessedSearchHits(result.hits, getCardDataFn)
  });
}

// Some search results will not have a data object.  Much of the display logic
// relies on this, so for such results that we want to show the user, we add a
// data element
function addDataObjects(result) {
  result.hits.forEach(hit => {
    if (hit.data === undefined || !hit.data.id) {
      const data = parseSearchHitToData(hit);
      if (data.type && RELEVANT_SEARCH_RESULT_TYPES.indexOf(data.type) >= 0) {
        if (!hit.data) hit.data = data;else hit.data = search_actions_objectSpread(search_actions_objectSpread({}, data), hit.data);
      }
    }
  });
}

// Create a data object from the search id, which is assumed to be of the form:
//      [group:][type:]rowId
function parseSearchHitToData(hit) {
  const idData = new SearchIdData();
  if (hit.id) {
    const idParts = hit.id.split(':');
    idData.id = idParts[idParts.length - 1];
    if (idParts.length > 1) idData.type = idParts[idParts.length - 2];
    if (idParts.length > 2) idData.group = idParts[idParts.length - 3];
  }
  return idData;
}

// exported for jest testing
function resolveTypeName(data, category) {
  let typeName;
  if (data) {
    if (data.dataClass?.name) {
      typeName = data.dataClass.name;
    } else if (data.sampleSet?.name) {
      typeName = data.sampleSet.name;
    } else if (data.inventorySystemId) {
      typeName = data.typeName;
    }
  }
  if (!typeName && category) {
    if (category === SearchCategory.Notebook) {
      typeName = 'Notebook';
    } else if (category === SearchCategory.NotebookTemplate) {
      typeName = 'Notebook Template';
    } else if (category === SearchCategory.TerminalStorageLocation) {
      typeName = 'Terminal Storage Unit';
    } else if (category === SearchCategory.StorageLocation) {
      typeName = 'Storage Unit';
    }
  }
  return typeName;
}

// exported for jest testing
function resolveIconSrc(data, category) {
  let iconSrc;
  if (data) {
    if (data.dataClass?.name) {
      // Issue 44917: Resolve search icon for uncategorized data classes
      if (data.dataClass.category) {
        iconSrc = data.dataClass.name.toLowerCase();
      }
      // else fallback to default
    } else if (data.sampleSet?.name) {
      iconSrc = 'samples';
    } else if (data.type) {
      const lcType = data.type.toLowerCase();
      if (lcType === 'sampleset') {
        iconSrc = 'sample_set';
      } else if (lcType.indexOf('dataclass') !== 0) {
        iconSrc = lcType;
      } else if (lcType === 'storagelocation') {
        iconSrc = 'freezer';
      } else if (lcType === 'terminalstoragelocation') {
        iconSrc = 'terminal_unit';
      }
      // else fallback to default
    }
  }
  if (!iconSrc && category) {
    switch (category) {
      case SearchCategory.Material:
        iconSrc = 'samples';
        break;
      case SearchCategory.Notebook:
      case SearchCategory.NotebookTemplate:
        iconSrc = 'notebook_blue';
        break;
      case SearchCategory.Plate:
        iconSrc = 'plates';
        break;
      case SearchCategory.WorkflowJob:
        iconSrc = 'workflow';
        break;
      case SearchCategory.StorageLocation:
        iconSrc = 'freezer';
        break;
      case SearchCategory.TerminalStorageLocation:
        iconSrc = 'terminal_unit';
        break;
      default:
    }
  }
  return iconSrc;
}

// exported for jest testing
function resolveIconDir(category) {
  let iconDir;
  if (category === SearchCategory.Notebook || category === SearchCategory.NotebookTemplate) {
    iconDir = 'labbook/images';
  }
  return iconDir;
}
function actions_getSearchResultCardData(data, category, title) {
  return {
    iconDir: resolveIconDir(category),
    iconSrc: resolveIconSrc(data, category),
    title,
    typeName: resolveTypeName(data, category)
  };
}
function getCardData(category, data, title, getCardDataFn) {
  const cardData = actions_getSearchResultCardData(data, category, title);
  if (getCardDataFn) {
    return search_actions_objectSpread(search_actions_objectSpread({}, cardData), getCardDataFn(data, category));
  }
  return cardData;
}
function getProcessedSearchHits(hits, getCardDataFn) {
  if (!hits) return [];
  return hits.map(hit => search_actions_objectSpread(search_actions_objectSpread({}, hit), {}, {
    cardData: getCardData(hit.category, hit.data, hit.title, getCardDataFn)
  }));
}
;// CONCATENATED MODULE: ./src/internal/components/search/APIWrapper.ts
function search_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function search_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? search_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { search_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : search_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function search_APIWrapper_defineProperty(e, r, t) { return (r = search_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function search_APIWrapper_toPropertyKey(t) { var i = search_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function search_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class SearchServerAPIWrapper {
  constructor() {
    search_APIWrapper_defineProperty(this, "search", search);
  }
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getSearchTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return search_APIWrapper_objectSpread({
    search: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/APIWrapper.ts
function internal_APIWrapper_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function internal_APIWrapper_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? internal_APIWrapper_ownKeys(Object(t), !0).forEach(function (r) { internal_APIWrapper_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : internal_APIWrapper_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function internal_APIWrapper_defineProperty(e, r, t) { return (r = internal_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function internal_APIWrapper_toPropertyKey(t) { var i = internal_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function internal_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }












let DEFAULT_WRAPPER;
function getDefaultAPIWrapper() {
  if (!DEFAULT_WRAPPER) {
    DEFAULT_WRAPPER = {
      assay: new AssayServerAPIWrapper(),
      domain: new DomainPropertiesAPIWrapper(),
      entity: new EntityServerAPIWrapper(),
      folder: new ServerFolderAPIWrapper(),
      query: new QueryServerAPIWrapper(),
      labelprinting: new LabelPrintingServerAPIWrapper(),
      labels: new ServerLabelsAPIWrapper(),
      navigation: new ServerNavigationAPIWrapper(),
      picklist: new PicklistServerAPIWrapper(),
      samples: new SamplesServerAPIWrapper(),
      search: new SearchServerAPIWrapper(),
      security: new ServerSecurityAPIWrapper()
    };
  }
  return DEFAULT_WRAPPER;
}

/**
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
function getTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return internal_APIWrapper_objectSpread({
    assay: getAssayTestAPIWrapper(mockFn, overrides.assay),
    domain: getDomainPropertiesTestAPIWrapper(mockFn, overrides.domain),
    entity: getEntityTestAPIWrapper(mockFn, overrides.entity),
    folder: getFolderTestAPIWrapper(mockFn, overrides.folder),
    query: getQueryTestAPIWrapper(mockFn, overrides.query),
    labelprinting: getLabelPrintingTestAPIWrapper(mockFn, overrides.labelprinting),
    labels: getLabelsTestAPIWrapper(mockFn, overrides.labels),
    navigation: getNavigationTestAPIWrapper(mockFn, overrides.navigation),
    picklist: getPicklistTestAPIWrapper(mockFn, overrides.picklist),
    samples: getSamplesTestAPIWrapper(mockFn, overrides.samples),
    search: getSearchTestAPIWrapper(mockFn, overrides.search),
    security: getSecurityTestAPIWrapper(mockFn, overrides.security)
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/AppContext.tsx
function AppContext_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AppContext_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AppContext_ownKeys(Object(t), !0).forEach(function (r) { AppContext_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AppContext_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function AppContext_defineProperty(e, r, t) { return (r = AppContext_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function AppContext_toPropertyKey(t) { var i = AppContext_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function AppContext_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2021 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



// The "any" used here should be fine, it gets re-typed in useAppContext, so as long as you're using that and providing
// a type (e.g. useAppContext<MyAppContextType>()) you'll be fine.
const AppContext_Context = (0,external_react_.createContext)(undefined);
/**
 * AppContextProvider is a generic, where the type T is a type that extends AppContext. This allows consuming
 * applications to add their own custom attributes to the AppContext. There are a few general rules to follow when
 * adding new properties to the AppContext:
 *   - Be judicious when adding something to the AppContext, only add something when you really need it accessible all
 *     over your app, at any level in the React Component tree
 *   - AppContext is not mutable by design, this is where static app-level pieces of configuration should live, the
 *     AppContext state should never change during runtime
 *   - If it needs to be accessed by anything in ui-components, then it should live on the AppContext in above
 *   - If it is app specific, then it should live on the Type (T) that you pass to this component
 *   - If it is app specific, and it's accessed by something in ui-components, then consider changing the design of
 *       of your components so they do not depend on something app specific, or have them take an equivalent prop
 *       that you pass to the component from your context aware app (there should be a few examples of how to accomplish
 *       this, ask around if you need an example)
 *
 * Example code:
 * ```ts
 * interface MyAppSettings {
 *     specialFeatureEnabled: boolean;
 * }
 *
 * // This interface is so we can namespace all of the settings for our App, keeping them  clearly separated from other
 * // settings that may be on the context.
 * interface WithMyAppSettings {
 *     myAppSettings: MyAppSettings;
 * }
 *
 * type MyAppSpecificContext = ExtendableAppContext<WithMyAppSettings>;
 *
 * const MY_APP_CONTEXT = {
 *     myAppSettings: { specialFeatureEnabled: getSpecialFeatureFlagFromLocalStorage() };
 * };
 *
 * const MyApp: FC = () => {
 *     <AppContextProvider initialContext={MY_APP_CONTEXT}>
 *         <MyComponentThatUsesContext />
 *     </AppContextProvider>
 * };
 *
 * const MyComponentThatUsesContext: FC = () => {
 *     const { myAppSettings } = useAppContext<MyAppSpecificContext>();
 *     const message = `Special Feature is ${myAppSettings.specialFeatureEnabled ? 'Enabled' : 'Disabled'}`
 *     return <p>{message}</p>;
 * };
 * ```
 */
function AppContextProvider({
  children,
  initialContext
}) {
  const value = (0,external_react_.useMemo)(() => AppContext_objectSpread({
    // Provide a default API so that external users don't have to specify it
    api: getDefaultAPIWrapper()
  }, initialContext), [initialContext]);
  return /*#__PURE__*/external_react_default().createElement(AppContext_Context.Provider, {
    value: value
  }, children);
}

/**
 * To use the AppContext provided by a AppContextProvider, use this convenient hook. If you find yourself constantly
 * grabbing the same attribute or two from useAppContext it may be convenient to create a wrapper around this hook
 * that grabs only what you need, this is most helpful for our packages like Workflow e.g.:
 *
 * ```ts
 * const useMyAppContext = (): MyAppSettings => {
 *     const appContext = useAppContext<MyAppSpecificContext>();
 *     return appContext.myAppSettings;
 * };
 *
 * // Then, in your component:
 *
 * const { specialFeatureEnabled } = useMyAppContext();
 * ```
 */
function useAppContext() {
  const context = (0,external_react_.useContext)(AppContext_Context);
  if (context === undefined) {
    throw new Error('useAppContext must be used within a AppContext.Provider');
  }
  return context;
}
;// CONCATENATED MODULE: ./src/internal/components/container/actions.ts
function container_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function container_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? container_actions_ownKeys(Object(t), !0).forEach(function (r) { container_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : container_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function container_actions_defineProperty(e, r, t) { return (r = container_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function container_actions_toPropertyKey(t) { var i = container_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function container_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







/**
 * Applies the permissions on the container to the user. Only permission related User fields are mutated.
 */
function applyPermissions(container, user) {
  // Must set "isAdmin" and "permissionsList" prior to configuring
  // permission bits (e.g. "canDelete", "canUpdate", etc).
  const contextUser = new User(container_actions_objectSpread(container_actions_objectSpread({}, user), {}, {
    isAdmin: container.effectivePermissions.indexOf(api_.PermissionTypes.Admin) > -1,
    permissionsList: container.effectivePermissions
  }));
  return new User(container_actions_objectSpread(container_actions_objectSpread({}, contextUser), {}, {
    canDelete: contextUser.hasDeletePermission(),
    canDeleteOwn: contextUser.hasDeletePermission(),
    canInsert: contextUser.hasInsertPermission(),
    canUpdate: contextUser.hasUpdatePermission(),
    canUpdateOwn: contextUser.hasUpdatePermission()
  }));
}
/**
 * React hook that supplies the container, user, and the container-relative permissions for the user.
 * @param containerIdOrPath The container id or container path to request.
 * @param options Supply different request options for fetch containers endpoint.
 * Requests default to includeSubfolders=false and includeStandardProperties=false.
 * Example:
 * ```tsx
 * const SeeUserPermissions: React.FC = () => {
 *    // This component takes a "containerPath" as a property.
 *    const { containerPath } = props;
 *
 *    // Given the "containerPath" fetch the `container` and `user`.
 *    const { container, error, isLoaded, user } = useContainerUser(containerPath);
 *
 *    if (!isLoaded) {
 *        return <LoadingSpinner />;
 *    }
 *
 *    // Display container information and utilize user permissions in the container to control display logic.
 *    return (
 *        <div>
 *            <Alert>{error}</Alert>
 *            {!!container && (
 *                <>
 *                    <span>Folder Name: {container.name}</span>
 *                    <span>Folder Path: {container.path}</span>
 *                    {user.hasInsertPermission() && <span>{user.displayName} can insert data into {container.path}.</span>>}
 *                    {user.hasDeletePermission() && <span>{user.displayName} can delete data in {container.path}.</span>>}
 *                    {user.hasDesignSampleTypesPermission() && <span>{user.displayName} can design sample types in {container.path}.</span>>}
 *                </>
 *            )}
 *        </div>
 *    );
 * };
 * ```
 */
function useContainerUser(containerIdOrPath, options) {
  const [containerUsers, setContainerUsers] = (0,external_react_.useState)({});
  const [error, setError] = (0,external_react_.useState)();
  const [loadingState, setLoadingState] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const {
    api
  } = useAppContext();
  const {
    user
  } = useServerContext();
  (0,external_react_.useEffect)(() => {
    if (!containerIdOrPath) return;
    (async () => {
      setError(undefined);
      setLoadingState(LoadingState.LOADING);
      try {
        const containers = await api.security.fetchContainers(container_actions_objectSpread(container_actions_objectSpread({
          includeStandardProperties: false,
          includeSubfolders: false
        }, options), {}, {
          containerPath: containerIdOrPath
        }));
        const containerUsers_ = containers.reduce((cu, c, i) => {
          const u = applyPermissions(c, user);
          if (i === 0) {
            cu[containerIdOrPath] = {
              container: c,
              user: u
            };
          }
          cu[c.path] = {
            container: c,
            user: u
          };
          return cu;
        }, {});
        setContainerUsers(containerUsers_);
      } catch (e) {
        setError(resolveErrorMessage(e));
      }
      setLoadingState(LoadingState.LOADED);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ignore options
  }, [api, containerIdOrPath, user]);
  return {
    container: containerUsers[containerIdOrPath]?.container,
    containerUsers,
    error,
    isLoaded: !isLoading(loadingState),
    user: containerUsers[containerIdOrPath]?.user
  };
}
;// CONCATENATED MODULE: ./src/internal/components/HelpIcon.tsx




const HelpIcon = (0,external_react_.memo)(({
  children,
  placement = 'bottom'
}) => {
  const id = (0,external_react_.useMemo)(() => generateId(), []);
  const overlayContent = /*#__PURE__*/external_react_default().createElement(Popover, {
    id: id,
    placement: placement
  }, children);
  return /*#__PURE__*/external_react_default().createElement("span", {
    className: "help-icon"
  }, /*#__PURE__*/external_react_default().createElement(OverlayTrigger, {
    overlay: overlayContent
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-question-circle"
  })));
});
;// CONCATENATED MODULE: ./src/internal/components/AutoForm.tsx


const INPUT_CLASSES = {
  checkbox: 'form-check',
  number: 'form-control',
  radio: 'radio-inline',
  select: 'form-control',
  text: 'form-control',
  textarea: 'form-control'
};

/**
 * See Option in platform/api/org/labkey/api/formSchema
 */

/**
 * See Field in platform/api/org/labkey/api/formSchema
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * See FormSchema in platform/api/org/labkey/api/formSchema
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const Label = ({
  cls,
  field,
  id,
  wrapperCls
}) => {
  const {
    helpText,
    helpTextHref,
    label,
    required
  } = field;
  const text = `${label}${required ? '*' : ''}`;
  let helpEl;
  if (helpText) {
    let helpLink;
    if (helpTextHref) {
      helpLink = /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("a", {
        href: helpTextHref,
        target: "_blank",
        rel: "noopener noreferrer"
      }, "More info"));
    }
    helpEl = /*#__PURE__*/external_react_default().createElement(HelpIcon, null, /*#__PURE__*/external_react_default().createElement("p", null, helpText), helpLink);
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: wrapperCls
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: cls,
    htmlFor: id
  }, text, " ", helpEl));
};
const TextInput = ({
  field,
  id,
  inputClasses,
  onChange,
  value
}) => {
  const {
    name,
    placeholder
  } = field;
  const _onChange = (0,external_react_.useCallback)(event => onChange(name, event.target.value), [name]);
  const className = inputClasses.text ?? '';
  const _value = value === null || value === undefined ? '' : value;
  return /*#__PURE__*/external_react_default().createElement("input", {
    className: className,
    id: id,
    name: name,
    placeholder: placeholder,
    type: "text",
    value: _value,
    onChange: _onChange
  });
};
const NumberInput = ({
  field,
  id,
  inputClasses,
  onChange,
  value
}) => {
  const {
    name,
    placeholder
  } = field;
  const _onChange = (0,external_react_.useCallback)(event => onChange(name, event.target.value), [name]);
  const className = inputClasses.number ?? '';
  const _value = value === null || value === undefined ? '' : value;
  return /*#__PURE__*/external_react_default().createElement("input", {
    className: className,
    id: id,
    inputMode: "numeric",
    name: name,
    pattern: "[0-9]*",
    placeholder: placeholder,
    type: "text",
    value: _value,
    onChange: _onChange
  });
};
const TextareaInput = ({
  field,
  id,
  inputClasses,
  onChange,
  value
}) => {
  const _onChange = (0,external_react_.useCallback)(event => onChange(field.name, event.target.value), [field.name]);
  const className = inputClasses.textarea ?? '';
  const _value = value === null || value === undefined ? '' : value;
  return /*#__PURE__*/external_react_default().createElement("textarea", {
    className: className,
    id: id,
    name: field.name,
    value: _value,
    onChange: _onChange
  });
};
const CheckboxInput = ({
  field,
  id,
  inputClasses,
  onChange,
  value
}) => {
  const _onChange = (0,external_react_.useCallback)(event => onChange(field.name, event.target.checked === true), [field.name]);
  const className = inputClasses.checkbox ?? '';
  return /*#__PURE__*/external_react_default().createElement("input", {
    className: className,
    id: id,
    name: field.name,
    type: "checkbox",
    onChange: _onChange,
    checked: value === true
  });
};
const SelectInput = ({
  field,
  id,
  inputClasses,
  onChange,
  value
}) => {
  const {
    name,
    options,
    placeholder
  } = field;
  const _onChange = (0,external_react_.useCallback)(event => {
    const value_ = event.target.value;
    onChange(name, value_ === '' ? null : value_);
  }, [name]);
  const _value = value === null || value === undefined ? '' : value;
  const className = inputClasses.select ?? '';
  const hasPlaceholder = placeholder !== null && placeholder !== undefined;
  return /*#__PURE__*/external_react_default().createElement("select", {
    className: className,
    id: id,
    name: name,
    value: _value,
    onChange: _onChange
  }, hasPlaceholder && /*#__PURE__*/external_react_default().createElement("option", {
    value: ""
  }, placeholder), options.map(option => /*#__PURE__*/external_react_default().createElement("option", {
    key: option.value,
    value: option.value
  }, option.label)));
};
const RadioInput = ({
  field,
  inputClasses,
  onChange,
  value
}) => {
  const {
    name,
    options
  } = field;
  const _onChange = (0,external_react_.useCallback)(event => onChange(name, event.target.value), [name]);
  const className = inputClasses.radio ?? '';
  return /*#__PURE__*/external_react_default().createElement("div", null, options.map(option => /*#__PURE__*/external_react_default().createElement("label", {
    className: className,
    key: option.value
  }, /*#__PURE__*/external_react_default().createElement("input", {
    name: name,
    type: "radio",
    onChange: _onChange,
    value: option.value,
    checked: value === option.value
  }), option.label)));
};
const AutoFormField = props => {
  const {
    field,
    id,
    inputWrapperCls,
    labelCls,
    labelWrapperCls,
    fieldWrapperCls
  } = props;
  const {
    type
  } = field;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: 'auto-form-field ' + fieldWrapperCls
  }, /*#__PURE__*/external_react_default().createElement(Label, {
    cls: labelCls,
    wrapperCls: labelWrapperCls,
    field: field,
    id: id
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: inputWrapperCls
  }, type === 'text' && /*#__PURE__*/external_react_default().createElement(TextInput, props), type === 'textarea' && /*#__PURE__*/external_react_default().createElement(TextareaInput, props), type === 'number' && /*#__PURE__*/external_react_default().createElement(NumberInput, props), type === 'checkbox' && /*#__PURE__*/external_react_default().createElement(CheckboxInput, props), type === 'select' && /*#__PURE__*/external_react_default().createElement(SelectInput, props), type === 'radio' && /*#__PURE__*/external_react_default().createElement(RadioInput, props)));
};
/**
 * Generates a form given a FormSchema. FormSchemas are typically generated by LabKey Server, but can be constructed on
 * the client as well.
 * @param props
 * @constructor
 */
const AutoForm = props => {
  const {
    formSchema,
    inputClasses = INPUT_CLASSES,
    inputWrapperCls = 'col-sm-8',
    labelCls = 'control-label col-sm-4',
    labelWrapperCls,
    onChange,
    fieldWrapperCls = 'form-group',
    values,
    wrapperCls = 'form-horizontal'
  } = props;

  // Intentionally not wrapping the component in a <form> despite the name. This is because you may use multiple
  // FormSchemas to generate a single form, so it is up to the consumer to wrap in a <form> as appropriate.
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: 'auto-form ' + wrapperCls
  }, formSchema.fields.map(field => /*#__PURE__*/external_react_default().createElement(AutoFormField, {
    key: field.name,
    field: field,
    id: `auto-form-${field.name}`,
    inputClasses: inputClasses,
    inputWrapperCls: inputWrapperCls,
    labelCls: labelCls,
    labelWrapperCls: labelWrapperCls,
    onChange: onChange,
    fieldWrapperCls: fieldWrapperCls,
    value: values[field.name]
  })));
};
;// CONCATENATED MODULE: ./src/internal/util/BeforeUnload.tsx

/**
 * A HOC to be used for any LKS React page that needs to check for a dirty state on page navigation.
 *
 * This HOC  will NOT work in any of our App pages, because we use react-router in our apps. If you need similar
 * behavior in an app page use the useRouteLeave hook.
 */
class BeforeUnload extends (external_react_default()).PureComponent {
  componentDidMount() {
    window.addEventListener('beforeunload', this.props.beforeunload);
  }
  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.props.beforeunload);
  }
  render() {
    return this.props.children;
  }
}
;// CONCATENATED MODULE: ./src/internal/util/WindowFocusCheckExpiredSession.tsx


const useWindowFocusCheckExpiredSession = () => {
  const {
    WebSocket
  } = useServerContext();
  const onTabFocus = WebSocket?.checkForExpiredSession;
  const onTabFocus_ = () => {
    // Note the extra second (1s in this case) for the timeout before we query whoami, this
    // is to allow time for the server login from the other tab to take hold.
    setTimeout(() => {
      onTabFocus?.();
    }, 1000);
  };
  (0,external_react_.useEffect)(() => {
    // Issue 47024: On tab focus in the app, call the WebSocket.checkForExpiredSession
    if (!onTabFocus) return;
    window.addEventListener('focus', onTabFocus_);
    return () => {
      window.removeEventListener('focus', onTabFocus_);
    };
  }, [
    /* only on component mount */
  ]);
  return null;
};
;// CONCATENATED MODULE: ./src/internal/components/buttons/ActionButton.tsx
function ActionButton_defineProperty(e, r, t) { return (r = ActionButton_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ActionButton_toPropertyKey(t) { var i = ActionButton_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ActionButton_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



class ActionButton extends (external_react_default()).PureComponent {
  render() {
    const {
      buttonClass,
      containerClass,
      disabled,
      onClick,
      title,
      helperBody,
      helperTitle,
      children
    } = this.props;
    const buttonClasses = external_classnames_default()('container--action-button btn btn-default', {
      disabled
    });
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: containerClass,
      title: title
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: buttonClass
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: buttonClasses,
      onClick: disabled ? undefined : onClick
    }, children), helperBody && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      title: helperTitle
    }, helperBody)));
  }
}
ActionButton_defineProperty(ActionButton, "defaultProps", {
  containerClass: 'form-group',
  helperTitle: 'More Info'
});
;// CONCATENATED MODULE: ./src/internal/components/buttons/AddEntityButton.tsx
const AddEntityButton_excluded = ["entity"];
function AddEntityButton_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = AddEntityButton_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function AddEntityButton_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


const AddEntityButton = (0,external_react_.memo)(_ref => {
  let {
      entity
    } = _ref,
    actionButtonProps = AddEntityButton_objectWithoutProperties(_ref, AddEntityButton_excluded);
  return /*#__PURE__*/external_react_default().createElement(ActionButton, actionButtonProps, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-plus-circle container--addition-icon"
  }), " Add ", entity);
});
AddEntityButton.displayName = 'AddEntityButton';
;// CONCATENATED MODULE: ./src/internal/components/buttons/RemoveEntityButton.tsx
function RemoveEntityButton_defineProperty(e, r, t) { return (r = RemoveEntityButton_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function RemoveEntityButton_toPropertyKey(t) { var i = RemoveEntityButton_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function RemoveEntityButton_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class RemoveEntityButton extends (external_react_default()).Component {
  render() {
    const {
      entity,
      index,
      labelClass,
      onClick
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: labelClass
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "container--action-button",
      onClick: onClick
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-times container--removal-icon"
    }), entity ? ' Remove ' + entity + ' ' + (index || '') : ''));
  }
}
RemoveEntityButton_defineProperty(RemoveEntityButton, "defaultProps", {
  labelClass: 'col-sm-3 control-label text-left'
});
;// CONCATENATED MODULE: ./src/internal/components/base/Alert.tsx
const Alert_excluded = ["bsStyle", "children", "className", "closeLabel", "onDismiss"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Alert_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = Alert_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function Alert_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * An Alert that will only display if children are available. Defaults to bsStyle "danger".
 */
const Alert = props => {
  const {
      bsStyle,
      children,
      className,
      closeLabel,
      onDismiss
    } = props,
    divProps = Alert_objectWithoutProperties(props, Alert_excluded);
  if (!children) return null;
  const dismissible = !!onDismiss;
  return /*#__PURE__*/external_react_default().createElement("div", _extends({}, divProps, {
    className: external_classnames_default()(className, `alert alert-${bsStyle}`, {
      'alert-dismissable': dismissible
    }),
    role: "alert"
  }), dismissible && /*#__PURE__*/external_react_default().createElement("button", {
    className: "close",
    onClick: onDismiss,
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), /*#__PURE__*/external_react_default().createElement("span", {
    className: "sr-only"
  }, closeLabel)), children);
};
Alert.defaultProps = {
  bsStyle: 'danger'
};
Alert.displayName = 'Alert';
;// CONCATENATED MODULE: ./src/internal/components/base/DeleteIcon.tsx

const DeleteIcon = (0,external_react_.memo)(({
  id,
  title = 'Delete this item',
  onDelete,
  iconCls = 'field-delete'
}) => /*#__PURE__*/external_react_default().createElement("span", {
  id: id,
  title: title,
  className: "field-icon",
  onClick: onDelete
}, /*#__PURE__*/external_react_default().createElement("span", {
  className: `fa fa-times-circle ${iconCls}`
})));
;// CONCATENATED MODULE: ./src/internal/components/base/LockIcon.tsx



const LockIcon = (0,external_react_.memo)(({
  id,
  title,
  iconCls,
  body,
  className,
  unlocked = false,
  placement = 'bottom'
}) => {
  return /*#__PURE__*/external_react_default().createElement(OverlayTrigger, {
    className: className,
    overlay: /*#__PURE__*/external_react_default().createElement(Popover, {
      id: id,
      title: title,
      placement: placement
    }, body)
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: 'domain-field-lock-icon' + (iconCls ? ' ' + iconCls : '')
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: `fa fa-${unlocked ? 'unlock' : 'lock'}`
  })));
});
;// CONCATENATED MODULE: ./src/internal/components/base/ExpandableFilterToggle.tsx
function ExpandableFilterToggle_defineProperty(e, r, t) { return (r = ExpandableFilterToggle_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ExpandableFilterToggle_toPropertyKey(t) { var i = ExpandableFilterToggle_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ExpandableFilterToggle_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class ExpandableFilterToggle extends external_react_.PureComponent {
  render() {
    const {
      filterExpanded,
      hasFilter,
      toggleFilterPanel,
      resetFilter,
      panelCls
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      onClick: toggleFilterPanel,
      className: panelCls
    }, filterExpanded ? 'Hide filters ' : 'Show filters ', /*#__PURE__*/external_react_default().createElement("i", {
      className: external_classnames_default()('fa', {
        'fa-chevron-down': filterExpanded,
        'fa-chevron-right': !filterExpanded
      })
    })), hasFilter && /*#__PURE__*/external_react_default().createElement("span", {
      className: "clickable-text",
      onClick: resetFilter
    }, "Clear All"));
  }
}
ExpandableFilterToggle_defineProperty(ExpandableFilterToggle, "defaultProps", {
  panelCls: 'show-hide-filter-toggle'
});
;// CONCATENATED MODULE: ./src/internal/components/base/DragDropHandle.tsx


class DragDropHandle extends (external_react_default()).Component {
  render() {
    const {
      highlighted
    } = this.props;
    const className = external_classnames_default()('drag-drop-handle', {
      'field-highlighted': highlighted
    });
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: className
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-ellipsis-v"
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-ellipsis-v"
    }));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/base/FieldExpansionToggle.tsx


class FieldExpansionToggle extends (external_react_default()).Component {
  render() {
    const {
      expanded,
      expandedTitle,
      collapsedTitle,
      cls,
      highlighted,
      id,
      onClick
    } = this.props;
    const className = external_classnames_default()('fa fa-lg', {
      'field-highlighted': highlighted && !expanded,
      'fa-chevron-down': expanded,
      'fa-chevron-right': !expanded
    });
    return /*#__PURE__*/external_react_default().createElement("div", {
      title: expanded ? expandedTitle : collapsedTitle,
      className: 'field-icon ' + (cls ? cls : ''),
      id: id,
      onClick: onClick
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: className
    }));
  }
}
;// CONCATENATED MODULE: ./src/internal/dropdowns.tsx



/**
 * Use this when you want to prevent the document click handler from handling a click event.
 *
 * This method exists because React 16 uses an event listener on the document for almost all events:
 *      https://github.com/facebook/react/issues/4335#issuecomment-120269153
 *
 * This gives us an advantage: if an element has an onClick handler, and it calls event.stopPropagation, it won't
 * actually stop our document click handler from firing, so we are essentially guaranteed to be able to close the menu
 * when the user clicks outside of it.
 *
 * This behavior also gives us a disadvantage: by the time our document click handler executes React has already fired
 * its own click handlers and updated the DOM. This means it's impossible for us to properly determine if the user
 * clicked on a disabled element because it may be disabled now, but was not when they clicked (this is an issue for our
 * PageMenu component).
 *
 * The solution is to use event.nativeEvent.stopImmediatePropagation which prevents the root handler from ever being
 * called.
 *
 * According to Dan Abromov this was "fixed" in React 17, but he didn't specify how they fixed the issue, or what the
 * new behavior is, so this may stop working when we upgrade react:
 *      https://github.com/facebook/react/issues/4335#issuecomment-671487964
 */
function preventDocumentHandler(event) {
  // Note: nativeEvent is always available, except when running tests
  event.nativeEvent?.stopImmediatePropagation?.();
}
function useToggleState() {
  const toggleRef = (0,external_react_.useRef)();
  const [open, setOpen] = (0,external_react_.useState)(false);
  const onClick = (0,external_react_.useCallback)(event => {
    event.preventDefault(); // Needed so DropdownAnchor doesn't navigate to home page on click
    setOpen(o => !o);
  }, []);

  // onDocumentClick closes the menu if the user clicks on a MenuItem or outside the menu, we prevent closing the menu
  // when the user clicks headers, dividers, or the <ul> element by using preventDocumentHandler. See note in
  // preventDocumentHandler for more details on the nuances of our document click handler.
  const onDocumentClick = (0,external_react_.useCallback)(event => {
    // Don't take action if we're clicking the toggle, as that handles open/close on its own, and we can't use
    // preventDocumentHandler in the toggle onClick, or we'll keep the menu open if the user clicks another menu.
    if (event.target === toggleRef.current) return;
    setOpen(false);
  }, []);
  (0,external_react_.useEffect)(() => {
    // We only want to listen for clicks on the document if the menu is open
    if (open) {
      document.addEventListener('click', onDocumentClick);
    }
    return () => {
      document.removeEventListener('click', onDocumentClick);
    };
  }, [open, onDocumentClick]);
  return {
    onClick,
    open,
    setOpen,
    toggleRef
  };
}
/**
 * See docs in docs/dropdowns.md
 */
const DropdownAnchor = props => {
  const {
    children,
    label,
    pullRight,
    title
  } = props;
  const id = (0,external_react_.useMemo)(() => generateId('dropdown-anchor-'), []);
  const {
    onClick,
    open,
    toggleRef
  } = useToggleState();
  const className = external_classnames_default()('lk-dropdown', 'dropdown', props.className, {
    open
  });
  const menuClassName = external_classnames_default()('dropdown-menu', {
    'dropdown-menu-right': pullRight
  });
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className
  }, /*#__PURE__*/external_react_default().createElement("a", {
    "aria-haspopup": "true",
    "aria-expanded": open,
    className: "dropdown-toggle",
    href: "#",
    id: id,
    onClick: onClick,
    ref: toggleRef,
    role: "button",
    title: label
  }, title, /*#__PURE__*/external_react_default().createElement("span", {
    className: "caret"
  })), /*#__PURE__*/external_react_default().createElement("ul", {
    className: menuClassName
  }, children));
};
DropdownAnchor.displayName = 'DropdownAnchor';
/**
 * See docs in docs/dropdowns.md
 */
const DropdownButton = (0,external_react_.forwardRef)((props, ref) => {
  const {
    bsStyle = 'default',
    children,
    disabled = false,
    dropup = false,
    noCaret = false,
    onClick,
    onMouseEnter,
    onMouseLeave,
    pullRight = false,
    title
  } = props;
  const id = (0,external_react_.useMemo)(() => generateId('dropdown-button-'), []);
  const {
    onClick: onToggleClick,
    open,
    toggleRef
  } = useToggleState();
  const className = external_classnames_default()('lk-dropdown', 'btn-group', props.className, {
    open,
    dropdown: !dropup,
    dropup
  });
  const buttonClassName = external_classnames_default()('btn', 'btn-' + bsStyle, 'dropdown-toggle', props.buttonClassName);
  const menuClassName = external_classnames_default()('dropdown-menu', {
    'dropdown-menu-right': pullRight
  });
  const caretClassName = external_classnames_default()('caret', {
    'no-margin': !title
  });
  const onClick_ = (0,external_react_.useCallback)(event => {
    onToggleClick(event);
    onClick?.();
  }, [onToggleClick, onClick]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className,
    ref: ref,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/external_react_default().createElement("button", {
    "aria-haspopup": "true",
    "aria-expanded": open,
    className: buttonClassName,
    disabled: disabled,
    id: id,
    onClick: onClick_,
    ref: toggleRef,
    role: "button",
    type: "button"
  }, title, !noCaret && /*#__PURE__*/external_react_default().createElement("span", {
    className: caretClassName
  })), /*#__PURE__*/external_react_default().createElement("ul", {
    className: menuClassName,
    "aria-labelledby": id,
    onClick: preventDocumentHandler,
    role: "menu"
  }, children));
});
DropdownButton.displayName = 'DropdownButton';
/**
 * See docs in docs/dropdowns.md
 */
const SplitButton = (0,external_react_.memo)(props => {
  const {
    bsStyle = 'default',
    buttonDisabled = false,
    children,
    disabled = false,
    // Used to disable the main button and menu toggle at the same time
    dropup = false,
    href,
    menuDisabled = false,
    onClick,
    pullRight,
    title
  } = props;
  const {
    onClick: onToggleClick,
    open,
    toggleRef
  } = useToggleState();
  const wrapperClassName = external_classnames_default()('split-button-dropdown', 'btn-group', props.className, {
    open,
    dropdown: !dropup,
    dropup
  });
  const buttonClassName = external_classnames_default()('split-button-dropdown__button', 'btn', 'btn-' + bsStyle, props.buttonClassName);
  const toggleClassName = external_classnames_default()('btn', 'btn-' + bsStyle, 'dropdown-toggle', props.toggleClassName);
  const menuClassName = external_classnames_default()('dropdown-menu', {
    'dropdown-menu-right': pullRight
  });
  const id = (0,external_react_.useMemo)(() => generateId('dropdown-button-'), []);
  if (!href && !onClick) {
    console.warn('SplitButton is missing href and onClick, did you forget to add one of these props?');
  }
  let button;
  if (href !== undefined) {
    button = /*#__PURE__*/external_react_default().createElement("a", {
      href: href,
      className: buttonClassName
    }, title);
  } else {
    button = /*#__PURE__*/external_react_default().createElement("button", {
      className: buttonClassName,
      onClick: onClick,
      disabled: disabled || buttonDisabled,
      type: "button"
    }, title);
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: wrapperClassName
  }, button, /*#__PURE__*/external_react_default().createElement("button", {
    "aria-haspopup": "true",
    "aria-expanded": open,
    className: toggleClassName,
    disabled: disabled || menuDisabled,
    id: id,
    onClick: onToggleClick,
    ref: toggleRef,
    role: "button",
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "caret no-margin"
  })), /*#__PURE__*/external_react_default().createElement("ul", {
    className: menuClassName,
    "aria-labelledby": id,
    onClick: preventDocumentHandler,
    role: "menu"
  }, children));
});
SplitButton.displayName = 'SplitButton';
/**
 * See docs in docs/dropdowns.md
 */
const MenuHeader = ({
  className,
  text
}) => /*#__PURE__*/external_react_default().createElement("li", {
  className: external_classnames_default()('lk-dropdown-header', 'dropdown-header', className),
  role: "heading",
  onClick: preventDocumentHandler
}, text);
MenuHeader.displayName = 'MenuHeader';

/**
 * See docs in docs/dropdowns.md
 */
const MenuDivider = () => /*#__PURE__*/external_react_default().createElement("li", {
  className: "divider",
  role: "separator",
  onClick: preventDocumentHandler
});
/**
 * See docs in docs/dropdowns.md
 */
const MenuItem = (0,external_react_.forwardRef)((props, ref) => {
  const {
    active = false,
    children,
    disabled,
    href = '#',
    onClick,
    onMouseEnter,
    onMouseLeave,
    rel,
    target,
    title
  } = props;
  const className = external_classnames_default()('lk-menu-item', props.className, {
    active,
    disabled
  });
  const onClick_ = (0,external_react_.useCallback)(e => {
    // If the user didn't override the href, then we prevent default in order to prevent the browser from
    // navigating us to the home page
    if (disabled || href === '#') {
      e.preventDefault();
    }
    e.stopPropagation();

    // We have to prevent the document handler from executing in the disabled case because by the time it
    // executes React will have already updated the DOM, so it cannot tell that you clicked on a disabled item
    if (disabled) preventDocumentHandler(e);
    if (!disabled && onClick) onClick();
  }, [disabled, href, onClick]);
  return /*#__PURE__*/external_react_default().createElement("li", {
    className: className,
    role: "presentation",
    ref: ref,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/external_react_default().createElement("a", {
    onClick: onClick_,
    href: href,
    rel: rel,
    role: "menuitem",
    target: target,
    title: title
  }, children));
});
MenuItem.displayName = 'MenuItem';
;// CONCATENATED MODULE: ./src/internal/components/menus/SelectionMenuItem.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





const DisabledSelectionMenuItem = ({
  message,
  text
}) => {
  const {
    onMouseEnter,
    onMouseLeave,
    portalEl,
    show,
    targetRef
  } = useOverlayTriggerState('disabled-selection-menu-item', true, false);
  const overlay = (0,external_react_.useMemo)(() => /*#__PURE__*/external_react_default().createElement(Popover, {
    placement: "right",
    id: "disabled-selection-menu-item-popover",
    targetRef: targetRef
  }, message), [message, targetRef]);
  return /*#__PURE__*/external_react_default().createElement(MenuItem, {
    disabled: true,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: targetRef
  }, text, show && (0,external_react_dom_.createPortal)(overlay, portalEl));
};
const SelectionMenuItem = props => {
  const {
    href,
    maxSelection,
    maxSelectionDisabledMsg,
    nounPlural,
    onClick,
    queryModel,
    text
  } = props;
  const selectionSize = queryModel?.selections?.size;
  const {
    tooFewSelected,
    tooManySelected
  } = (0,external_react_.useMemo)(() => ({
    tooFewSelected: selectionSize !== undefined && selectionSize === 0,
    tooManySelected: selectionSize !== undefined && selectionSize > maxSelection
  }), [selectionSize]);
  const disabled = tooFewSelected || tooManySelected;
  if (disabled) {
    const message = tooFewSelected ? `Select one or more ${nounPlural}.` : maxSelectionDisabledMsg || `At most ${maxSelection?.toLocaleString()} ${nounPlural} can be selected.`;
    return /*#__PURE__*/external_react_default().createElement(DisabledSelectionMenuItem, {
      message: message,
      text: text
    });
  }
  return /*#__PURE__*/external_react_default().createElement(MenuItem, {
    href: href,
    onClick: onClick
  }, text);
};
SelectionMenuItem.displayName = 'SelectionMenuItem';
;// CONCATENATED MODULE: ./src/internal/components/base/LoadingSpinner.tsx
function LoadingSpinner_defineProperty(e, r, t) { return (r = LoadingSpinner_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LoadingSpinner_toPropertyKey(t) { var i = LoadingSpinner_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LoadingSpinner_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class LoadingSpinner extends (external_react_default()).PureComponent {
  render() {
    const {
      msg,
      wrapperClassName
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("span", {
      className: wrapperClassName
    }, /*#__PURE__*/external_react_default().createElement("i", {
      "aria-hidden": "true",
      className: "fa fa-spinner fa-pulse"
    }), " ", msg);
  }
}
LoadingSpinner_defineProperty(LoadingSpinner, "defaultProps", {
  msg: 'Loading...',
  wrapperClassName: ''
});
;// CONCATENATED MODULE: ./src/internal/components/permissions/InsufficientPermissionsAlert.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


const InsufficientPermissionsAlert = ({
  message = 'You do not have permissions for this action.'
}) => {
  return /*#__PURE__*/external_react_default().createElement(Alert, null, message);
};
;// CONCATENATED MODULE: ./src/internal/components/user/UserProperties.tsx

const UserProperties = (0,external_react_.memo)(props => {
  const {
    prop,
    title
  } = props;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-4 principal-detail-label"
  }, title), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-8 principal-detail-value"
  }, prop));
});
;// CONCATENATED MODULE: ./src/internal/components/permissions/EffectiveRolesList.tsx
/*
 * Copyright (c) 2018-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */




class EffectiveRolesList extends (external_react_default()).PureComponent {
  render() {
    const {
      userId,
      policy,
      rootPolicy,
      rolesByUniqueName,
      currentUser,
      showLinks = true
    } = this.props;
    const currentProductId = getCurrentAppProperties()?.productId;
    const targetProductId = getPrimaryAppProperties()?.productId;
    let assignments = policy && rolesByUniqueName ? policy.assignments.filter(assignment => assignment.userId === userId).toList() : (0,external_immutable_.List)();
    if (rootPolicy && rolesByUniqueName) {
      assignments = assignments.concat(rootPolicy.assignments.filter(assignment => assignment.userId === userId)).toList();
    }
    if (assignments.size === 0) {
      return null;
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("hr", {
      className: "principal-hr"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4 principal-detail-label"
    }, "Effective Roles"), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8 principal-detail-value"
    }, /*#__PURE__*/external_react_default().createElement("ul", {
      className: "principal-detail-ul"
    }, assignments.map(assignment => {
      const role = rolesByUniqueName.get(assignment.role);
      const roleDisplay = role ? role.displayName : assignment.role;
      const url = createProductUrlFromParts(targetProductId, currentProductId, {
        expand: roleDisplay
      }, 'admin', 'permissions');
      return /*#__PURE__*/external_react_default().createElement("li", {
        key: assignment.role,
        className: "principal-detail-li"
      }, currentUser.isAdmin && showLinks ? /*#__PURE__*/external_react_default().createElement("a", {
        href: url instanceof AppURL ? url.toHref() : url
      }, roleDisplay) : roleDisplay);
    })))));
  }
}
;// CONCATENATED MODULE: ./src/internal/FormButtons.tsx


const FormButtons = (0,external_react_.memo)(({
  children,
  sticky = true
}) => {
  const className = external_classnames_default()('form-buttons', {
    'form-buttons--sticky': sticky
  });
  let cancel;
  let secondary;
  let tertiary;
  let submit;

  // Note: we have to filter children via forEach because doing something like {canSubmit && <button>Submit</button>}
  // counts as a child, even when canSubmit is false, which results in a null child.
  const actualChildren = [];
  external_react_.Children.forEach(children, child => {
    if (child !== null) actualChildren.push(child);
  });
  const childCount = actualChildren.length;
  // Note: we split children into separate variables because if we just split the children into two arrays consumers
  // would need to remember to supply a key prop for each button, which is easy to forget, and would result in
  // warnings from React.
  if (childCount === 0) {
    return null;
  } else if (childCount === 1) {
    submit = actualChildren;
  } else if (childCount === 2) {
    cancel = actualChildren[0];
    submit = actualChildren[1];
  } else if (childCount === 3) {
    cancel = actualChildren[0];
    secondary = actualChildren[1];
    submit = actualChildren[2];
  } else if (childCount === 4) {
    cancel = actualChildren[0];
    secondary = actualChildren[1];
    tertiary = actualChildren[2];
    submit = actualChildren[3];
  } else {
    console.error(`Invalid number of children (${childCount}) passed to FormButtons, not rendering`);
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-buttons__left"
  }, cancel), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-buttons__right"
  }, secondary, tertiary, submit));
});
;// CONCATENATED MODULE: ./src/internal/components/forms/input/CommentTextArea.tsx


const COMMENT_FIELD_ID = 'actionComments';
const CommentTextArea = props => {
  const {
    actionName,
    containerClassName,
    disabled,
    inline,
    onChange,
    maxLength = 1000,
    requiresUserComment,
    rows,
    value
  } = props;
  const label = `Reason for ${actionName}${requiresUserComment ? ' *' : ''}`;
  const [showError, setShowError] = (0,external_react_.useState)(false);
  const inputRef = (0,external_react_.useRef)();

  // borrowed from https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
  const onTextAreaInput = (0,external_react_.useCallback)(() => {
    const textArea = inputRef.current;
    textArea.addEventListener('input', () => {
      textArea.style.height = 'auto';
      textArea.style.height = Math.min(92, textArea.scrollHeight) + 'px';
    });
  }, []);
  (0,external_react_.useEffect)(() => {
    const textArea = inputRef.current;
    if (inline) {
      textArea.addEventListener('input', onTextAreaInput);
    }
    return () => {
      // always remove the event listener in case "inline" prop has changed
      textArea.removeEventListener('input', onTextAreaInput);
    };
  }, [inline, onTextAreaInput]);
  const onCommentChange = (0,external_react_.useCallback)(event => {
    const _comment = event.target.value;
    // Not trimming here when checking length because it won't properly show an error if the user
    // has entered a new line as the last character, but the input will still impose the character limit.
    const tooLong = _comment.length > maxLength;
    setShowError(tooLong);
    if (!tooLong) {
      onChange(_comment);
    }
  }, [maxLength, onChange]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: containerClassName
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: inline ? 'inline-comment-label' : '',
    htmlFor: COMMENT_FIELD_ID
  }, label), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('form-group', {
      'has-error': showError
    })
  }, /*#__PURE__*/external_react_default().createElement("textarea", {
    className: "form-control",
    id: COMMENT_FIELD_ID,
    placeholder: 'Enter reason ' + (requiresUserComment ? '(required)' : '(optional)'),
    rows: rows ?? (inline ? 1 : 5),
    disabled: disabled,
    onChange: onCommentChange,
    maxLength: maxLength + 1 // allow an extra character, so we can trigger the error message
    ,
    ref: inputRef,
    value: value
  }), showError && /*#__PURE__*/external_react_default().createElement("span", {
    className: "help-block"
  }, "Please limit your reason to ", maxLength.toLocaleString(), " characters.")));
};
CommentTextArea.defaultProps = {
  containerClassName: 'top-spacing'
};
;// CONCATENATED MODULE: ./src/internal/ModalButtons.tsx




const ModalButtons = (0,external_react_.memo)(props => {
  const {
    actionName = 'Update',
    cancelText = 'Cancel',
    canConfirm = true,
    children,
    confirmClass = 'btn-success',
    confirmText = 'Save',
    confirmingText = 'Saving...',
    isConfirming,
    onCancel,
    onCommentChange,
    onConfirm,
    requiresUserComment
  } = props;
  const confirmButtonClass = external_classnames_default()('btn', confirmClass);
  if (!onCancel && !onConfirm) return null;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "modal-footer modal-buttons"
  }, /*#__PURE__*/external_react_default().createElement(FormButtons, {
    sticky: false
  }, onCancel && /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default",
    onClick: onCancel,
    type: "button"
  }, cancelText), children, onCommentChange && /*#__PURE__*/external_react_default().createElement(CommentTextArea, {
    containerClassName: "inline-comment",
    onChange: onCommentChange,
    actionName: actionName,
    requiresUserComment: requiresUserComment,
    inline: true
  }), onConfirm && /*#__PURE__*/external_react_default().createElement("button", {
    className: confirmButtonClass,
    onClick: onConfirm,
    type: "button",
    disabled: isConfirming || !canConfirm
  }, isConfirming ? confirmingText : confirmText)));
});
;// CONCATENATED MODULE: ./src/internal/Modal.tsx





/**
 * This component renders the absolute basic elements needed to render a modal. You probably shouldn't use this
 * component, instead you should probably be using Modal, which has a bunch of props to make it easier to render a
 * typical modal with save/close buttons and the appropriate logic for those buttons.
 */
const BaseModal = ({
  bsSize,
  children,
  className
}) => {
  const portalRef = usePortalRef('modal');
  const className_ = external_classnames_default()('modal-dialog', className, {
    'modal-sm': bsSize === 'sm',
    'modal-lg': bsSize === 'lg'
  });
  (0,external_react_.useEffect)(() => {
    // Prevent scrolling the body when a modal is shown
    document.body.classList.toggle('no-scroll', true);
    return () => {
      document.body.classList.toggle('no-scroll', false);
    };
  }, []);
  const modal = /*#__PURE__*/external_react_default().createElement("div", {
    className: "modal-wrapper"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "fade in modal-backdrop"
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "lk-modal modal"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: className_
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "modal-content"
  }, children))));
  return (0,external_react_dom_.createPortal)(modal, portalRef);
};
BaseModal.displayName = 'BaseModal';
const ModalHeader = ({
  title,
  onCancel
}) => {
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "modal-header"
  }, onCancel !== undefined && /*#__PURE__*/external_react_default().createElement("button", {
    className: "close",
    onClick: onCancel,
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), /*#__PURE__*/external_react_default().createElement("span", {
    className: "sr-only"
  }, "Close")), title && /*#__PURE__*/external_react_default().createElement("h4", {
    className: "modal-title"
  }, title));
};
ModalHeader.displayName = 'ModalHeader';
const Modal = (0,external_react_.memo)(props => {
  const {
    actionName,
    bsSize,
    cancelText,
    canConfirm,
    children,
    className,
    confirmClass,
    confirmText,
    confirmingText,
    footer,
    footerContent,
    isConfirming,
    onCancel,
    onCommentChange,
    onConfirm,
    requiresUserComment,
    title
  } = props;
  const showHeader = onCancel || title;
  return /*#__PURE__*/external_react_default().createElement(BaseModal, {
    bsSize: bsSize,
    className: className
  }, showHeader && /*#__PURE__*/external_react_default().createElement(ModalHeader, {
    onCancel: onCancel,
    title: title
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "modal-body"
  }, children), !footer && /*#__PURE__*/external_react_default().createElement(ModalButtons, {
    actionName: actionName,
    cancelText: cancelText,
    canConfirm: canConfirm,
    confirmClass: confirmClass,
    confirmText: confirmText,
    confirmingText: confirmingText,
    isConfirming: isConfirming,
    onConfirm: onConfirm,
    onCommentChange: onCommentChange,
    onCancel: onCancel,
    requiresUserComment: requiresUserComment
  }, footerContent), footer && /*#__PURE__*/external_react_default().createElement("div", {
    className: "modal-footer"
  }, footer));
});
Modal.displayName = 'Modal';
;// CONCATENATED MODULE: ./src/internal/components/administration/actions.ts




// groups is an array of objects, each representing a group.
// groupMemberships is an array of data rows that correlate members with groups. See core.Members, the data source.
// From this, we construct an object of the form:
// {<id of group>:
//      {
//          groupName: <group name>,
//          members: [{name: <member name>, id: <member id>, type: <member type, 'g', 'sg', or 'u'>}, ...]
//       },
//       ...
// }
// Where the members array is sorted by type, and then by name. The types stand for 'group,' 'site group,' and 'user'
const getGroupMembership = (groups, groupMemberships) => {
  const groupsWithMembers = groupMemberships.reduce((memberships, groupMembership) => {
    const {
      groupId,
      groupName,
      userDisplayName,
      userId,
      userEmail
    } = groupMembership;
    if (groupId === -1) {
      return memberships;
    }
    const memberIsGroup = !userDisplayName;
    const foundGroup = groups.find(group => group.id === userId);

    // Issue 47306: When a member is not resolvable, do not accumulate the member into any groups.
    // For example, if you are a Project Admin, a groupMembership row associating a site group with a user possessing no
    // permissions in the project will result in your inability to resolve data on the permission-less user.
    // That user will not be visible to you, and so should be excluded from the GroupMembership return value.
    if (memberIsGroup && !foundGroup) {
      return memberships;
    }
    const member = {
      name: memberIsGroup ? foundGroup.name : `${userEmail} (${userDisplayName})`,
      id: userId,
      type: memberIsGroup ? MemberType.group : MemberType.user
    };
    if (groupId in memberships) {
      memberships[groupId].members.push(member);
      memberships[groupId].members.sort(naturalSortByProperty('name'));
    } else {
      const isProjectGroup = groups.find(group => group.id === groupId)?.isProjectGroup;
      memberships[groupId] = {
        groupName,
        members: [member],
        type: isProjectGroup ? MemberType.group : MemberType.siteGroup
      };
    }
    return memberships;
  }, {});

  // If a group has no members—is in groupsData but not groupRows—add it as well, unless it is a site group
  groups.forEach(group => {
    if (!(group.id in groupsWithMembers)) {
      groupsWithMembers[group.id] = {
        groupName: group.name,
        members: [],
        type: group.isProjectGroup ? MemberType.group : MemberType.siteGroup
      };
    }
  });
  return groupsWithMembers;
};
const fetchGroupMembership = async (container, api) => {
  const groups = await api.fetchGroups(getProjectPath(container.path));
  const groupMemberships = await api.getGroupMemberships();
  return getGroupMembership(groups, groupMemberships);
};
;// CONCATENATED MODULE: ./src/internal/components/permissions/GroupsList.tsx








const GroupsList = (0,external_react_.memo)(props => {
  const {
    groups,
    asRow = true,
    showLinks = true
  } = props;
  const [groupMembership, setGroupMembership] = (0,external_react_.useState)();
  const {
    api
  } = useAppContext();
  const {
    container,
    moduleContext
  } = useServerContext();
  const homeFolderPath = getAppHomeFolderPath(container, moduleContext);
  const homeContainer = useContainerUser(homeFolderPath);
  const currentProductId = getCurrentAppProperties()?.productId;
  const targetProductId = getPrimaryAppProperties()?.productId;
  (0,external_react_.useEffect)(() => {
    (async () => {
      if (homeContainer.isLoaded && homeContainer.user.hasAdminPermission()) {
        const groupMembership_ = await fetchGroupMembership(homeContainer.container, api.security);
        setGroupMembership(groupMembership_);
      }
    })();
  }, [api.security, homeContainer.isLoaded]);
  if (!groups) return null;
  const body = /*#__PURE__*/external_react_default().createElement("ul", {
    className: "principal-detail-ul"
  }, groups.length > 0 ? groups.map(group => {
    const url = createProductUrlFromParts(targetProductId, currentProductId, {
      expand: group.value
    }, 'admin', 'groups');
    return /*#__PURE__*/external_react_default().createElement("li", {
      key: group.value,
      className: "principal-detail-li"
    }, homeContainer.user?.isAdmin && showLinks && groupMembership?.[group.value].type !== MemberType.siteGroup ? /*#__PURE__*/external_react_default().createElement("a", {
      href: url instanceof AppURL ? url.toHref() : url
    }, group.displayValue) : group.displayValue);
  }) : /*#__PURE__*/external_react_default().createElement("li", {
    className: "principal-detail-li"
  }, "None"));
  if (!asRow) return body;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("hr", {
    className: "principal-hr"
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-4 principal-detail-label"
  }, "Groups"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-8 principal-detail-value"
  }, body)));
});
;// CONCATENATED MODULE: ./src/internal/components/user/UserResetPasswordConfirmModal.tsx





const UserResetPasswordConfirmModal = (0,external_react_.memo)(props => {
  const {
    email,
    hasLogin,
    onCancel,
    onComplete,
    resetPasswordApi
  } = props;
  const [error, setError] = (0,external_react_.useState)();
  const [submitting, setSubmitting] = (0,external_react_.useState)(false);
  const onConfirm = (0,external_react_.useCallback)(async () => {
    setSubmitting(true);
    try {
      const response = await resetPasswordApi(email);
      onComplete(response);
    } catch (e) {
      setError(resolveErrorMessage(e, 'user', 'users', 'update') ?? 'Failed to reset password');
    } finally {
      setSubmitting(false);
    }
  }, [email, onComplete, resetPasswordApi]);
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    title: "Reset Password?",
    onConfirm: onConfirm,
    onCancel: onCancel,
    confirmText: "Yes, Reset Password",
    isConfirming: submitting
  }, hasLogin ? /*#__PURE__*/external_react_default().createElement("p", null, "You are about to clear the current password for ", /*#__PURE__*/external_react_default().createElement("b", null, email), ". This will send the user a reset password email and force them to pick a new password to access the site.") : /*#__PURE__*/external_react_default().createElement("p", null, "You are about to send ", /*#__PURE__*/external_react_default().createElement("b", null, email), " a reset password email. This will let them pick a password to access the site."), /*#__PURE__*/external_react_default().createElement("p", null, "Do you want to proceed?"), error && /*#__PURE__*/external_react_default().createElement(Alert, null, error));
});
UserResetPasswordConfirmModal.defaultProps = {
  resetPasswordApi: resetPassword
};
UserResetPasswordConfirmModal.displayName = 'UserResetPasswordConfirmModal';
;// CONCATENATED MODULE: ./src/internal/components/user/UserDeleteConfirmModal.tsx
function UserDeleteConfirmModal_defineProperty(e, r, t) { return (r = UserDeleteConfirmModal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function UserDeleteConfirmModal_toPropertyKey(t) { var i = UserDeleteConfirmModal_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function UserDeleteConfirmModal_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






class UserDeleteConfirmModal extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    UserDeleteConfirmModal_defineProperty(this, "onConfirm", () => {
      const {
        userIds,
        onComplete
      } = this.props;
      this.setState(() => ({
        submitting: true
      }));
      deleteUsers(userIds).then(onComplete).catch(error => {
        console.error(error);
        this.setState(() => ({
          error: resolveErrorMessage(error, 'user', 'users', 'delete'),
          submitting: false
        }));
      });
    });
    this.state = {
      submitting: false,
      error: undefined
    };
  }
  render() {
    const {
      onCancel,
      userIds
    } = this.props;
    const {
      error,
      submitting
    } = this.state;
    const userCount = userIds.length;
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: 'Delete ' + api_.Utils.pluralBasic(userCount, 'User') + '?',
      onConfirm: this.onConfirm,
      onCancel: onCancel,
      confirmClass: "btn-danger",
      confirmText: "Yes, Permanently Delete",
      isConfirming: submitting
    }, /*#__PURE__*/external_react_default().createElement("p", null, "Generally, ", /*#__PURE__*/external_react_default().createElement("b", null, "deactivation of a user is recommended"), ". Deactivated users may not login, but their information will be preserved in case they are reactivated at a later time."), /*#__PURE__*/external_react_default().createElement("p", null, "Deletion of a user is ", /*#__PURE__*/external_react_default().createElement("b", null, "permanent and cannot be undone"), ". Deleted users:", /*#__PURE__*/external_react_default().createElement("ul", null, /*#__PURE__*/external_react_default().createElement("li", null, "will no longer be displayed with actions taken or data uploaded by them"), /*#__PURE__*/external_react_default().createElement("li", null, "will be removed from groups and permissions settings"), /*#__PURE__*/external_react_default().createElement("li", null, "cannot be reactivated"))), /*#__PURE__*/external_react_default().createElement("p", null, api_.Utils.pluralBasic(userCount, 'user'), " will be deleted. Do you want to proceed?"), error && /*#__PURE__*/external_react_default().createElement(Alert, null, error));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/user/UserActivateChangeConfirmModal.tsx
function UserActivateChangeConfirmModal_defineProperty(e, r, t) { return (r = UserActivateChangeConfirmModal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function UserActivateChangeConfirmModal_toPropertyKey(t) { var i = UserActivateChangeConfirmModal_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function UserActivateChangeConfirmModal_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






class UserActivateChangeConfirmModal extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    UserActivateChangeConfirmModal_defineProperty(this, "onConfirm", () => {
      const {
        userIds,
        reactivate,
        onComplete
      } = this.props;
      this.setState(() => ({
        submitting: true
      }));
      updateUsersActiveState(userIds, reactivate).then(onComplete).catch(error => {
        console.error(error);
        this.setState(() => ({
          error: resolveErrorMessage(error, 'user', 'users', 'update'),
          submitting: false
        }));
      });
    });
    this.state = {
      submitting: false,
      error: undefined
    };
  }
  render() {
    const {
      onCancel,
      userIds,
      reactivate
    } = this.props;
    const {
      error,
      submitting
    } = this.state;
    const userCount = userIds.length;
    const action = reactivate ? 'Reactivate' : 'Deactivate';
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: action + ' ' + api_.Utils.pluralBasic(userCount, 'User') + '?',
      onConfirm: this.onConfirm,
      onCancel: onCancel,
      confirmClass: reactivate ? 'btn-success' : 'btn-danger',
      confirmText: 'Yes, ' + action,
      isConfirming: submitting
    }, !reactivate && /*#__PURE__*/external_react_default().createElement("p", null, "Deactivated users will ", /*#__PURE__*/external_react_default().createElement("b", null, "no longer be able to login"), ". However, their information will be preserved for display purposes, and their group memberships and role assignments will be preserved in case they are reactivated at a later time."), reactivate && /*#__PURE__*/external_react_default().createElement("p", null, "Reactivated users will be able to ", /*#__PURE__*/external_react_default().createElement("b", null, "login normally"), ", and all their previous group memberships and role assignments will apply."), /*#__PURE__*/external_react_default().createElement("p", null, api_.Utils.pluralBasic(userCount, 'user'), " will be updated. Do you want to proceed?"), error && /*#__PURE__*/external_react_default().createElement(Alert, null, error));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/user/UserDetailsPanel.tsx
function UserDetailsPanel_defineProperty(e, r, t) { return (r = UserDetailsPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function UserDetailsPanel_toPropertyKey(t) { var i = UserDetailsPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function UserDetailsPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2018-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */

















const UserDetailRow = ({
  label,
  value
}) => {
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-4 principal-detail-label"
  }, label), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-8 principal-detail-value"
  }, value));
};
class UserDetailsPanel extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    UserDetailsPanel_defineProperty(this, "loadPolicyAndRoles", async () => {
      const {
        policy,
        rolesByUniqueName,
        container,
        currentUser,
        api
      } = this.props;
      if (currentUser.isAdmin && !policy && !rolesByUniqueName && container) {
        try {
          const policy_ = await api.fetchPolicy(container.id);
          const roles = await api.fetchRoles();
          this.setState({
            policy: policy_,
            rolesByUniqueName: getRolesByUniqueName(roles)
          });
        } catch (e) {
          console.error(e);
        }
      }
    });
    UserDetailsPanel_defineProperty(this, "loadUserDetails", async () => {
      const {
        userId,
        isSelf,
        api,
        displayName
      } = this.props;
      if (!userId) {
        this.setState({
          userProperties: undefined
        });
        return;
      }
      this.setState({
        loading: true
      });
      try {
        if (isSelf) {
          const response = await api.getUserProperties(userId);
          this.setState({
            userProperties: response.props
          });
        } else {
          const response = await api.getUserPropertiesForOther(userId);
          if (!api_.Utils.isEmptyObj(response)) {
            this.setState({
              userProperties: response
            });
          } else {
            this.setState({
              userProperties: {
                UserId: userId,
                DisplayName: displayName
              }
            });
          }
        }
      } catch (e) {
        this.setState({
          userProperties: undefined
        });
      }
      this.setState({
        loading: false
      });
    });
    UserDetailsPanel_defineProperty(this, "toggleDialog", name => {
      this.setState({
        showDialog: name
      });
    });
    UserDetailsPanel_defineProperty(this, "onUsersStateChangeComplete", (response, isDelete) => {
      this.toggleDialog(undefined); // close dialog
      if (!isDelete) {
        this.loadUserDetails(); // reload to pickup new user state
      }
      this.props.onUsersStateChangeComplete?.(response, isDelete);
    });
    this.state = {
      loading: false,
      policy: undefined,
      rolesByUniqueName: undefined,
      showDialog: undefined,
      userProperties: undefined
    };
  }
  componentDidMount() {
    this.loadUserDetails();
    this.loadPolicyAndRoles();
  }
  componentDidUpdate(prevProps) {
    if (this.props.userId !== prevProps.userId) {
      this.loadUserDetails();
    }
  }
  renderUserProp(label, prop, formatDate = false) {
    let value = caseInsensitive(this.state.userProperties, prop);
    if (formatDate && value) {
      value = external_moment_default()(value).format(getMomentDateTimeFormat());
    } else if (value === undefined) {
      value = 'unknown';
    }
    return /*#__PURE__*/external_react_default().createElement(UserDetailRow, {
      label: label,
      value: value
    });
  }
  renderButtons() {
    const {
      allowDelete,
      allowResetPassword
    } = this.props;
    const {
      userProperties
    } = this.state;
    if (!userProperties) return null;
    const isActive = caseInsensitive(userProperties, 'active');
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("hr", {
      className: "principal-hr"
    }), allowResetPassword && isActive && /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: () => this.toggleDialog('reset'),
      type: "button"
    }, "Reset Password"), allowDelete && /*#__PURE__*/external_react_default().createElement("button", {
      className: "pull-right btn btn-default",
      style: {
        marginLeft: '10px'
      },
      onClick: () => this.toggleDialog('delete'),
      type: "button"
    }, "Delete"), /*#__PURE__*/external_react_default().createElement("button", {
      className: "pull-right btn btn-default",
      style: {
        marginLeft: '10px'
      },
      onClick: () => this.toggleDialog(isActive ? 'deactivate' : 'reactivate'),
      type: "button"
    }, isActive ? 'Deactivate' : 'Reactivate'));
  }
  renderBody() {
    const {
      showGroupListLinks,
      showPermissionListLinks,
      currentUser,
      policy,
      rolesByUniqueName,
      rootPolicy,
      userId
    } = this.props;
    const {
      loading,
      userProperties
    } = this.state;
    if (loading) {
      return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
    }
    if (userProperties) {
      const description = caseInsensitive(userProperties, 'description');
      let name = caseInsensitive(userProperties, 'firstName') ?? '';
      if (name) {
        name += ' ';
      }
      name += caseInsensitive(userProperties, 'lastName') ?? '';
      const hasPassword = caseInsensitive(userProperties, 'hasPassword');
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !!name && /*#__PURE__*/external_react_default().createElement(UserDetailRow, {
        label: "Name",
        value: name
      }), this.renderUserProp('Email', 'email'), description && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, this.renderUserProp('Description', 'description')), /*#__PURE__*/external_react_default().createElement("hr", {
        className: "principal-hr"
      }), this.renderUserProp('Last Login', 'lastLogin', true), this.renderUserProp('Created', 'created', true), /*#__PURE__*/external_react_default().createElement("hr", {
        className: "principal-hr"
      }), this.renderUserProp('User ID', 'userId'), !!hasPassword && /*#__PURE__*/external_react_default().createElement(UserDetailRow, {
        label: "Has Password",
        value: hasPassword.toString()
      }), /*#__PURE__*/external_react_default().createElement(EffectiveRolesList, {
        currentUser: currentUser,
        policy: policy ?? this.state.policy,
        rolesByUniqueName: rolesByUniqueName ?? this.state.rolesByUniqueName,
        rootPolicy: rootPolicy,
        showLinks: showPermissionListLinks,
        userId: userId
      }), /*#__PURE__*/external_react_default().createElement(GroupsList, {
        groups: caseInsensitive(userProperties, 'groups'),
        showLinks: showGroupListLinks
      }));
    }
    return /*#__PURE__*/external_react_default().createElement("div", null, "No user selected.");
  }
  renderHeader() {
    const {
      loading,
      userProperties
    } = this.state;
    if (loading || !userProperties) return 'User Details';
    const displayName = caseInsensitive(userProperties, 'displayName');
    const active = caseInsensitive(userProperties, 'active');
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("span", null, displayName), active !== undefined && /*#__PURE__*/external_react_default().createElement("span", {
      className: external_classnames_default()('margin-left status-pill', {
        active,
        inactive: !active
      })
    }, active ? 'Active' : 'Inactive'));
  }
  render() {
    const {
      userId,
      allowDelete,
      allowResetPassword,
      toggleDetailsModal,
      onUsersStateChangeComplete
    } = this.props;
    const {
      showDialog,
      userProperties
    } = this.state;
    const {
      user,
      project
    } = (0,api_.getServerContext)();
    const isSelf = userId === user.id;
    const currentProductId = getCurrentAppProperties()?.productId;
    const targetProductId = getPrimaryAppProperties()?.productId;
    // We do not currently support user management in sub folders, so we create the management URL for the project
    // container.
    const manageUrl = createProductUrlFromPartsWithContainer(targetProductId, currentProductId, project.path, {
      usersView: 'all',
      'all.UserId~eq': userId
    }, 'admin', 'users');
    if (toggleDetailsModal) {
      const footer = /*#__PURE__*/external_react_default().createElement("a", {
        className: "pull-right btn btn-default",
        href: manageUrl instanceof AppURL ? manageUrl.toHref() : manageUrl
      }, "Manage");
      return /*#__PURE__*/external_react_default().createElement(Modal, {
        onCancel: toggleDetailsModal,
        className: "user-detail-modal",
        footer: user.isAdmin ? footer : undefined,
        title: this.renderHeader()
      }, this.renderBody());
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel panel-default user-details-panel"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-heading"
    }, this.renderHeader()), /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-body"
    }, this.renderBody(), !isSelf && onUsersStateChangeComplete && this.renderButtons(), allowResetPassword && showDialog === 'reset' && /*#__PURE__*/external_react_default().createElement(UserResetPasswordConfirmModal, {
      email: caseInsensitive(userProperties, 'email'),
      hasLogin: api_.Utils.isString(caseInsensitive(userProperties, 'lastLogin')),
      onComplete: response => this.onUsersStateChangeComplete(response, false),
      onCancel: () => this.toggleDialog(undefined)
    }), (showDialog === 'reactivate' || showDialog === 'deactivate') && /*#__PURE__*/external_react_default().createElement(UserActivateChangeConfirmModal, {
      userIds: [userId],
      reactivate: showDialog === 'reactivate',
      onComplete: response => this.onUsersStateChangeComplete(response, false),
      onCancel: () => this.toggleDialog(undefined)
    }), allowDelete && showDialog === 'delete' && /*#__PURE__*/external_react_default().createElement(UserDeleteConfirmModal, {
      userIds: [userId],
      onComplete: response => this.onUsersStateChangeComplete(response, true),
      onCancel: () => this.toggleDialog(undefined)
    })));
  }
}
UserDetailsPanel_defineProperty(UserDetailsPanel, "defaultProps", {
  allowDelete: true,
  allowResetPassword: true,
  api: getDefaultAPIWrapper().security,
  showGroupListLinks: true,
  showPermissionListLinks: true
});
;// CONCATENATED MODULE: ./src/internal/components/user/UserLink.tsx






const UserLink = props => {
  const {
    userId,
    userDisplayValue,
    unknown
  } = props;
  const [showDetails, setShowDetails] = (0,external_react_.useState)(false);
  const [targetUserDisplayValue, setTargetUserDisplayValue] = (0,external_react_.useState)();
  const {
    user,
    container
  } = useServerContext();
  const {
    api
  } = useAppContext();
  const isSelf = userId === user.id;
  (0,external_react_.useEffect)(() => {
    (async () => {
      try {
        if (userId > 0 && userDisplayValue === undefined) {
          const targetUser = await api.security.getUserPropertiesForOther(userId);
          setTargetUserDisplayValue(caseInsensitive(targetUser, 'DisplayName'));
        } else {
          setTargetUserDisplayValue(userDisplayValue);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [api.security, userDisplayValue, userId]);
  const toggleDetailsModal = (0,external_react_.useCallback)(() => {
    setShowDetails(current => !current);
  }, []);
  if (targetUserDisplayValue && !userId) return /*#__PURE__*/external_react_default().createElement("span", null, targetUserDisplayValue);
  if (unknown) {
    return /*#__PURE__*/external_react_default().createElement("span", {
      className: "gray-text",
      title: "User may have been deleted from the system."
    }, "<unknown user>");
  }
  if (!userId) return null;
  if (!isSelf && (!userCanReadUserDetails(user) || !targetUserDisplayValue)) {
    if (targetUserDisplayValue) return /*#__PURE__*/external_react_default().createElement("span", null, targetUserDisplayValue);
    let title = 'User may have been deleted from the system.';
    if (!user.isSystemAdmin) {
      title = 'User may have been deleted from the system or no longer have permissions within this project.';
    }
    return /*#__PURE__*/external_react_default().createElement("span", {
      className: "gray-text",
      title: title
    }, "<", userId, ">");
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("a", {
    onClick: toggleDetailsModal,
    className: "clickable user-link"
  }, targetUserDisplayValue), showDetails && /*#__PURE__*/external_react_default().createElement(UserDetailsPanel, {
    container: container,
    currentUser: user,
    userId: userId,
    displayName: targetUserDisplayValue,
    toggleDetailsModal: toggleDetailsModal,
    isSelf: !userCanReadUserDetails(user) && isSelf
  }));
};
const UserLinkList = ({
  users
}) => {
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, users.map((u, i) => /*#__PURE__*/external_react_default().createElement(external_react_.Fragment, {
    key: u.id
  }, i > 0 && ', ', u.type === 'u' || u.type === undefined ? /*#__PURE__*/external_react_default().createElement(UserLink, {
    userId: u.id,
    userDisplayValue: u.displayName
  }) : /*#__PURE__*/external_react_default().createElement("span", null, u.displayName))));
};
;// CONCATENATED MODULE: ./src/internal/components/permissions/MembersList.tsx


const MembersList = (0,external_react_.memo)(props => {
  const {
    members
  } = props;
  return members.length === 0 ? /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null) : /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("hr", {
    className: "principal-hr"
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-4 principal-detail-label"
  }, "Members"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-8 principal-detail-value"
  }, /*#__PURE__*/external_react_default().createElement("ul", {
    className: "principal-detail-ul"
  }, members.map(member => /*#__PURE__*/external_react_default().createElement("li", {
    key: member.id,
    className: "principal-detail-li"
  }, member.type === 'u' ? /*#__PURE__*/external_react_default().createElement(UserLink, {
    userId: member.id,
    userDisplayValue: member.name
  }) : member.name))))));
});
;// CONCATENATED MODULE: ./src/internal/components/permissions/GroupDetailsPanel.tsx
function GroupDetailsPanel_extends() { return GroupDetailsPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, GroupDetailsPanel_extends.apply(null, arguments); }
/*
 * Copyright (c) 2018-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */








const GroupDetailsPanel = (0,external_react_.memo)(props => {
  const {
    principal,
    members,
    isSiteGroup,
    displayCounts = true,
    showPermissionListLinks = true
  } = props;
  const [created, setCreated] = (0,external_react_.useState)('');
  const {
    api
  } = useAppContext();
  const {
    user
  } = useServerContext();
  (0,external_react_.useEffect)(() => {
    if (!principal) return;
    (async () => {
      try {
        const createdState = await api.security.getAuditLogDate('group/UserId', principal.userId);
        setCreated(createdState);
      } catch (e) {
        console.error(resolveErrorMessage(e) ?? 'Failed to load when group created');
      }
    })();
  }, [api, principal]);
  const {
    groupsCount,
    usersCount
  } = (0,external_react_.useMemo)(() => {
    const usersCount_ = members.filter(member => member.type === MemberType.user).length;
    return {
      groupsCount: (members.length - usersCount_).toLocaleString(),
      usersCount: usersCount_.toLocaleString()
    };
  }, [members]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default group-details-panel"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, principal?.displayName ?? 'Group Details'), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, principal ? /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, displayCounts && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(UserProperties, {
    prop: usersCount.toString(),
    title: "User Count"
  }), /*#__PURE__*/external_react_default().createElement(UserProperties, {
    prop: groupsCount,
    title: "Group Count"
  }), /*#__PURE__*/external_react_default().createElement("hr", {
    className: "principal-hr"
  })), /*#__PURE__*/external_react_default().createElement(UserProperties, {
    prop: created,
    title: "Created"
  }), isSiteGroup && /*#__PURE__*/external_react_default().createElement(UserProperties, {
    prop: "true",
    title: "Site Group"
  }), /*#__PURE__*/external_react_default().createElement(EffectiveRolesList, GroupDetailsPanel_extends({}, props, {
    currentUser: user,
    userId: principal.userId,
    showLinks: showPermissionListLinks
  })), /*#__PURE__*/external_react_default().createElement(MembersList, {
    members: members
  })) : /*#__PURE__*/external_react_default().createElement("div", null, "No group selected.")));
});
;// CONCATENATED MODULE: ./src/internal/components/notifications/model.ts
function model_defineProperty(e, r, t) { return (r = model_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function model_toPropertyKey(t) { var i = model_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function model_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




let Persistence = /*#__PURE__*/function (Persistence) {
  Persistence[Persistence["PAGE_LOAD"] = 0] = "PAGE_LOAD";
  Persistence[Persistence["LOGIN_SESSION"] = 1] = "LOGIN_SESSION";
  return Persistence;
}({});

// This interface is available so you do not have .create a Model object and so the id can be optionally
// created for you.

class NotificationItemModel extends (0,external_immutable_.Record)({
  alertClass: 'success',
  data: undefined,
  id: undefined,
  isDismissible: true,
  isDismissed: false,
  message: undefined,
  onDismiss: undefined,
  persistence: Persistence.PAGE_LOAD
}) {
  static create(values) {
    return new NotificationItemModel(Object.assign({}, {
      id: nextNotificationId()
    }, values));
  }
}
function nextNotificationId() {
  return generateId('notification_');
}
class ServerActivityData {
  constructor(values) {
    model_defineProperty(this, external_immer_.immerable, true);
    model_defineProperty(this, "RowId", void 0);
    model_defineProperty(this, "Type", void 0);
    model_defineProperty(this, "Created", void 0);
    model_defineProperty(this, "CreatedBy", void 0);
    model_defineProperty(this, "UserId", void 0);
    model_defineProperty(this, "ObjectId", void 0);
    model_defineProperty(this, "ReadOn", void 0);
    model_defineProperty(this, "ActionLinkText", void 0);
    model_defineProperty(this, "ActionLinkUrl", void 0);
    model_defineProperty(this, "ContainerId", void 0);
    model_defineProperty(this, "HtmlContent", void 0);
    model_defineProperty(this, "Content", void 0);
    model_defineProperty(this, "ContentType", void 0);
    model_defineProperty(this, "IconCls", void 0);
    model_defineProperty(this, "inProgress", void 0);
    model_defineProperty(this, "hasError", void 0);
    const addedValues = {};
    if (values.Type?.indexOf('error') >= 0) {
      Object.assign(addedValues, {
        hasError: true
      });
    }
    Object.assign(this, values, addedValues);
  }
  mutate(props) {
    return (0,external_immer_.produce)(this, draft => {
      Object.assign(draft, props);
    });
  }
  isUnread() {
    return this.ReadOn == undefined;
  }
  isHTML() {
    return this.ContentType?.toLowerCase() === 'text/html';
  }
}
const DEFAULT_SERVER_NOTIFICATION_MODEL = {
  data: undefined,
  totalRows: 0,
  unreadCount: 0,
  inProgressCount: 0,
  isError: false,
  isLoaded: false,
  isLoading: false,
  errorMessage: undefined
};
class ServerNotificationModel {
  constructor(values) {
    model_defineProperty(this, external_immer_.immerable, true);
    model_defineProperty(this, "data", void 0);
    model_defineProperty(this, "totalRows", void 0);
    model_defineProperty(this, "unreadCount", void 0);
    model_defineProperty(this, "inProgressCount", void 0);
    model_defineProperty(this, "isError", void 0);
    model_defineProperty(this, "isLoaded", void 0);
    model_defineProperty(this, "isLoading", void 0);
    model_defineProperty(this, "errorMessage", void 0);
    Object.assign(this, DEFAULT_SERVER_NOTIFICATION_MODEL, values);
  }
  mutate(props) {
    return (0,external_immer_.produce)(this, draft => {
      Object.assign(draft, props);
    });
  }
  setLoadingStart() {
    return this.mutate({
      isLoading: true,
      isLoaded: false,
      isError: false,
      errorMessage: undefined
    });
  }
  setLoadingComplete(result) {
    return this.mutate({
      isLoading: false,
      isLoaded: true,
      isError: false,
      errorMessage: undefined
    }).mutate(result);
  }
  setError(errorMessage) {
    return this.mutate({
      isLoading: false,
      isLoaded: true,
      isError: true,
      errorMessage
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/components/notifications/actions.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/**
 * Used to notify the server that the trial banner has been dismissed
 */
function setTrialBannerDismissSessionKey() {
  return new Promise(() => {
    api_.Ajax.request({
      url: buildURL('core', 'dismissWarnings.api'),
      method: 'POST'
    });
  });
}
function getServerNotifications(typeLabels, maxRows) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('notification', 'getUserNotifications.api'),
      method: 'GET',
      params: {
        byContainer: true,
        // per cross-folder action improvements, we always want to default to using the allInProject
        // containerFilter for this API call so users can see all of their pipeline job details regardless of
        // which project container they are in
        containerFilter: api_.Query.ContainerFilter.allInProject,
        typeLabels,
        maxRows
      },
      success: api_.Utils.getCallbackWrapper(response => {
        if (response.success) {
          const notifications = response.notifications.map(notification => new ServerActivityData(notification));
          resolve({
            data: notifications,
            totalRows: response.totalRows,
            unreadCount: response.unreadCount,
            inProgressCount: 0
          });
        } else {
          console.error(response);
          reject('There was a problem retrieving your notification data.');
        }
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(resolveErrorMessage(response));
      })
    });
  });
}
function getRunningPipelineJobStatuses(filters) {
  const statusFilter = api_.Filter.create('Status', ['RUNNING', 'WAITING', 'SPLITWAITING'], api_.Filter.Types.IN);
  return new Promise((resolve, reject) => {
    selectRowsDeprecated({
      schemaName: 'pipeline',
      queryName: 'job',
      filterArray: [statusFilter].concat(filters ?? []),
      sort: 'Created',
      includeTotalCount: true
    }).then(response => {
      const model = response.models[response.key];
      const activities = [];
      Object.values(model).forEach(row => {
        activities.push(new ServerActivityData({
          inProgress: true,
          Content: row['Description']['value'],
          ContentType: 'text/plain',
          Created: row['Created']['formattedValue'],
          CreatedBy: row['CreatedBy']['displayValue']
        }));
      });
      resolve({
        data: activities,
        totalRows: response.rowCount,
        unreadCount: 0,
        // these are always considered to be read since they aren't actually notifications
        inProgressCount: response.rowCount
      });
    }).catch(reason => {
      console.error(reason);
      reject(resolveErrorMessage(reason));
    });
  });
}
function getPipelineActivityData(maxRows, filters) {
  return new Promise((resolve, reject) => {
    Promise.all([getServerNotifications(['Pipeline'], maxRows), getRunningPipelineJobStatuses(filters)]).then(responses => {
      const [notifications, statuses] = responses;
      resolve({
        data: statuses.data.concat(...notifications.data).slice(0, maxRows),
        totalRows: notifications.totalRows + statuses.totalRows,
        unreadCount: notifications.unreadCount,
        inProgressCount: statuses.inProgressCount
      });
    }).catch(reason => {
      console.error(reason);
      reject('There was a problem retrieving your notification data.  Try refreshing the page.');
    });
  });
}
function markNotificationsAsRead(rowIds) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('notification', 'markNotificationAsRead.api'),
      method: 'POST',
      jsonData: {
        rowIds
      },
      success: api_.Utils.getCallbackWrapper(response => {
        if (response.success) {
          resolve(true);
        } else {
          console.error(response);
          resolve(false);
        }
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(false);
      })
    });
  });
}
function markAllNotificationsAsRead(typeLabels) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('notification', 'markAllNotificationAsRead.api'),
      method: 'POST',
      jsonData: {
        byContainer: true,
        containerFilter: getContainerFilter(),
        typeLabels
      },
      success: api_.Utils.getCallbackWrapper(response => {
        if (response.success) {
          resolve(true);
        } else {
          console.error(response);
          resolve(false);
        }
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(false);
      })
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/notifications/NotificationsContext.tsx
function NotificationsContext_extends() { return NotificationsContext_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, NotificationsContext_extends.apply(null, arguments); }





const NotificationsContext = (0,external_react_.createContext)(undefined);
const useNotificationsContext = () => {
  const context = (0,external_react_.useContext)(NotificationsContext);
  if (context === undefined) {
    throw new Error('useNotificationsContext must be used within a NotificationsContext.Provider');
  }
  return context;
};
// TODO: move implementation to GlobalStateContextProvider
const NotificationsContextProvider = (0,external_react_.memo)(({
  children,
  initialContext
}) => {
  const [notifications, setNotifications] = (0,external_react_.useState)(initialContext?.notifications ?? (0,external_immutable_.Map)());

  /**
   * Dismiss the notifications identified by the given id or the given persistence level.
   * If neither parameter is provided, dismisses the notifications with Persistence.PAGE_LOAD.
   * @param id Optional string identifier for a notification
   * @param persistence Optional Persistence value used to select notifications
   */
  const dismissNotifications = (0,external_react_.useCallback)((id, persistence) => {
    persistence = persistence || Persistence.PAGE_LOAD;
    if (id) {
      setNotifications(current => {
        const currentNotification = current.get(id);
        if (currentNotification) {
          currentNotification.onDismiss?.();
          return current.set(id, currentNotification.merge({
            isDismissed: true
          }));
        }
        return current;
      });
    } else {
      setNotifications(current => {
        let updated = current;
        const dismissed = current.filter(item => item.persistence == persistence);
        dismissed.forEach(item => {
          item.onDismiss?.();
          updated = updated.set(item.id, item.merge({
            isDismissed: true
          }));
        });
        return updated;
      });
    }
  }, []);

  /**
   * Create a notification that can be displayed on pages within the application
   * @param creatable
   */
  const createNotification = (0,external_react_.useCallback)((creatable, withTimeout = false, callback) => {
    if (callback) window.setTimeout(callback, NOTIFICATION_TIMEOUT);
    if (withTimeout) {
      window.setTimeout(() => createNotification(creatable), NOTIFICATION_TIMEOUT);
      return;
    }
    let item;
    if (api_.Utils.isString(creatable)) {
      item = NotificationItemModel.create({
        message: creatable
      });
    } else if (!(creatable instanceof NotificationItemModel)) {
      item = NotificationItemModel.create(creatable);
    } else item = creatable;
    if (item) {
      setNotifications(current => {
        if (current.has(item.id)) return current;
        return current.set(item.id, item);
      });
    }
  }, []);
  const notificationsContext = (0,external_react_.useMemo)(() => ({
    notifications,
    createNotification,
    dismissNotifications
  }), [notifications, createNotification, dismissNotifications]);
  return /*#__PURE__*/external_react_default().createElement(NotificationsContext.Provider, {
    value: notificationsContext
  }, children);
});

/**
 * @deprecated use the useNotificationsContext hook instead
 * @param Component: the component to wrap and inject the NotificationsContext methods into
 */
function withNotificationsContext(Component) {
  const wrapped = props => {
    const {
      createNotification,
      dismissNotifications
    } = useNotificationsContext();
    return /*#__PURE__*/external_react_default().createElement(Component, NotificationsContext_extends({
      createNotification: createNotification,
      dismissNotifications: dismissNotifications
    }, props));
  };
  return wrapped;
}
;// CONCATENATED MODULE: ./src/internal/components/notifications/NotificationItem.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


const NotificationItem = ({
  item
}) => {
  const {
    dismissNotifications
  } = useNotificationsContext();
  const {
    data,
    id,
    message,
    isDismissible
  } = item;
  const onClick = (0,external_react_.useCallback)(() => dismissNotifications(id), [dismissNotifications, id]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "notification-item"
  }, typeof message === 'function' ? message(item, data) : message, isDismissible && /*#__PURE__*/external_react_default().createElement("i", {
    style: {
      float: 'right'
    },
    className: "fa fa-times-circle pointer",
    onClick: onClick
  }));
};
;// CONCATENATED MODULE: ./src/internal/components/notifications/Notifications.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








const NotificationList = ({
  alertClass,
  notifications
}) => {
  let body;
  if (notifications.length > 1) {
    body = /*#__PURE__*/external_react_default().createElement("ul", null, notifications.map(model => /*#__PURE__*/external_react_default().createElement("li", {
      key: model.id
    }, /*#__PURE__*/external_react_default().createElement(NotificationItem, {
      item: model
    }))));
  } else {
    body = /*#__PURE__*/external_react_default().createElement(NotificationItem, {
      item: notifications[0]
    });
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: 'notification-container alert alert-' + alertClass
  }, body);
};
const Notifications = () => {
  const {
    notifications,
    dismissNotifications,
    createNotification
  } = useNotificationsContext();
  const {
    moduleContext,
    user,
    container
  } = useServerContext();
  const renderTrialServicesNotification = (0,external_react_.useCallback)(() => {
    const {
      trialEndDate,
      upgradeLink,
      upgradeLinkText
    } = moduleContext.trialservices;
    const endDate = external_moment_default()(trialEndDate, getMomentDateFormat(container));
    const today = external_moment_default()();
    const secondsLeft = endDate.diff(today, 'seconds') % 86400;
    // seems a little silly, but if we have any time left in the current day, we count it as a day
    const dayDiff = endDate.diff(today, 'days') + (secondsLeft > 0 ? 1 : 0);
    let message = 'This LabKey trial site has expired.';
    if (dayDiff > 0) {
      message = 'This LabKey trial site will expire in ' + dayDiff + (dayDiff === 1 ? ' day.' : ' days.');
    }
    if (upgradeLink && user.isAdmin) {
      return /*#__PURE__*/external_react_default().createElement("span", null, message, "\xA0", /*#__PURE__*/external_react_default().createElement("a", {
        href: upgradeLink,
        target: "_blank",
        rel: "noopener noreferrer"
      }, upgradeLinkText));
    }
    return message;
  }, [moduleContext, user, container]);
  (0,external_react_.useEffect)(() => {
    if (moduleContext?.trialservices?.trialEndDate) {
      createNotification({
        alertClass: 'warning',
        id: 'trial_ending',
        message: renderTrialServicesNotification,
        onDismiss: setTrialBannerDismissSessionKey,
        persistence: Persistence.LOGIN_SESSION
      });
    }
    return () => {
      dismissNotifications();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const byType = (0,external_react_.useMemo)(() => {
    return notifications.filter(model => !model.isDismissed).reduce((result, model) => {
      const {
        alertClass
      } = model;
      result[alertClass] = (result[alertClass] ?? []).concat(model);
      return result;
    }, {});
  }, [notifications]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "notifications-container"
  }, Object.keys(byType).map(alertClass => /*#__PURE__*/external_react_default().createElement(NotificationList, {
    key: alertClass,
    alertClass: alertClass,
    notifications: byType[alertClass]
  })));
};
;// CONCATENATED MODULE: ./src/internal/components/base/PageHeader.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


const PageHeader = ({
  children,
  iconCls,
  showNotifications = true,
  title
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "page-header"
}, children, /*#__PURE__*/external_react_default().createElement("h2", {
  className: "no-margin-top"
}, iconCls ? /*#__PURE__*/external_react_default().createElement("span", {
  className: 'page-header-icon ' + iconCls
}, "\xA0") : null, title), showNotifications && /*#__PURE__*/external_react_default().createElement(Notifications, null));
PageHeader.displayName = 'PageHeader';
;// CONCATENATED MODULE: ./src/internal/components/base/Progress.tsx
function Progress_defineProperty(e, r, t) { return (r = Progress_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Progress_toPropertyKey(t) { var i = Progress_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Progress_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



class Progress extends (external_react_default()).Component {
  constructor(...args) {
    super(...args);
    Progress_defineProperty(this, "delayTimer", void 0);
    Progress_defineProperty(this, "timer", void 0);
    Progress_defineProperty(this, "state", {
      duration: 0,
      percent: 0,
      show: false
    });
    Progress_defineProperty(this, "cycle", fromDelay => {
      const newDuration = this.state.duration + (fromDelay ? this.props.delay : this.props.updateIncrement);
      const newPercent = Math.ceil(newDuration / this.props.estimate * 100);
      this.setState({
        duration: newDuration,
        percent: newPercent > 100 ? 100 : newPercent,
        show: true
      });
    });
    Progress_defineProperty(this, "end", fromUnmount => {
      clearTimeout(this.delayTimer);
      clearTimeout(this.timer);
      if (fromUnmount !== true) {
        this.setState({
          percent: 0,
          show: false
        });
      }
    });
    Progress_defineProperty(this, "start", () => {
      clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.cycle();
        this.start();
      }, this.props.updateIncrement);
    });
  }
  componentWillUnmount() {
    this.end(true);
  }
  componentDidUpdate(prevProps) {
    const {
      delay,
      toggle
    } = this.props;
    if (!prevProps.toggle && toggle) {
      if (delay) {
        this.delayTimer = window.setTimeout(() => {
          this.cycle(true);
          this.start();
        }, delay);
      } else {
        this.start();
      }
    } else if (prevProps.toggle && !toggle) {
      this.end();
    }
  }
  render() {
    const {
      children,
      modal,
      title
    } = this.props;
    const {
      percent,
      show
    } = this.state;
    if (!show) return null;
    const progressClassName = external_classnames_default()('progress-bar', 'progress-bar-striped', 'active', {
      'progress-bar-success': percent === 100
    });
    const progressWidth = percent + '%';
    const indicator = /*#__PURE__*/external_react_default().createElement("div", {
      className: "progress"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": percent,
      className: progressClassName,
      style: {
        width: progressWidth
      }
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "sr-only"
    }, percent, "%")));
    if (modal) {
      return /*#__PURE__*/external_react_default().createElement(Modal, {
        bsSize: "lg",
        onCancel: undefined,
        onConfirm: undefined,
        canConfirm: false,
        title: title
      }, children, indicator);
    }
    return indicator;
  }
}
Progress_defineProperty(Progress, "defaultProps", {
  delay: 350,
  estimate: 500,
  modal: false,
  updateIncrement: 50
});
;// CONCATENATED MODULE: ./src/internal/Tooltip.tsx



/**
 * Tooltip is an unusual component, because it needs to be rendered in relation to another element on the page. If you
 * are using this component you should probably be using it in conjunction with an OverlayTrigger which will inject the
 * targetRef for you.
 *
 * See additional docs at components/docs/overlays.md
 */
const Tooltip = ({
  children,
  targetRef,
  id,
  isFixedPosition,
  placement
}) => {
  const {
    overlayRef,
    style
  } = useOverlayPositioning(placement, targetRef, isFixedPosition);
  const className = external_classnames_default()('lk-tooltip', 'in', 'tooltip', placement, {
    'lk-tooltip--is-fixed': isFixedPosition
  });
  return /*#__PURE__*/external_react_default().createElement("div", {
    id: id,
    className: className,
    style: style,
    ref: overlayRef
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "tooltip-arrow"
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "tooltip-inner"
  }, children));
};
Tooltip.displayName = 'Tooltip';
;// CONCATENATED MODULE: ./src/internal/components/base/Tip.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




const Tip = ({
  caption,
  children,
  triggerType
}) => {
  const id = (0,external_react_.useMemo)(() => generateId('tip-'), []);
  return /*#__PURE__*/external_react_default().createElement(OverlayTrigger, {
    delay: 200,
    id: id,
    overlay: /*#__PURE__*/external_react_default().createElement(Tooltip, {
      id: id,
      placement: "top"
    }, caption),
    triggerType: triggerType
  }, children);
};
// EXTERNAL MODULE: external "react-router-dom"
var external_react_router_dom_ = __webpack_require__(442);
;// CONCATENATED MODULE: ./src/internal/renderers/MultiValueRenderer.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


const MultiValueRenderer = (0,external_react_.memo)(({
  data
}) => {
  if (!data || data.size === 0) {
    return null;
  }
  let i = -1;
  return /*#__PURE__*/external_react_default().createElement("div", null, data.map((item, key) => {
    let text;
    let url;
    if (external_immutable_.Map.isMap(item)) {
      if (item.has('formattedValue')) {
        text = item.get('formattedValue');
      } else {
        const o = item.has('displayValue') ? item.get('displayValue') : item.get('value');
        text = o !== null && o !== undefined ? o.toString() : null;
      }
      url = item.get('url');
    } else if (item !== undefined && item !== null) {
      text = item.toString();
    } else {
      return null;
    }
    if (text === undefined || text === null || text === '') return null;
    return (
      /*#__PURE__*/
      // IntelliJ mistakenly presumes that key is an index.
      // In fact, it is the key of the map which is unique.
      // eslint-disable-next-line react/no-array-index-key
      external_react_default().createElement("span", {
        key: key
      }, ++i > 0 ? ', ' : '', url ? /*#__PURE__*/external_react_default().createElement("a", {
        href: url
      }, text) : text)
    );
  }));
});
MultiValueRenderer.displayName = 'MultiValueRenderer';
;// CONCATENATED MODULE: ./src/internal/renderers/DefaultRenderer.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



const TARGET_BLANK = '_blank';
const URL_REL = 'noopener noreferrer';
/**
 * This is the default cell renderer for Details/Grids using a QueryGridModel.
 */
const DefaultRenderer = (0,external_react_.memo)(({
  col,
  data
}) => {
  let display = null;
  // Issue 43474: Prevent text wrapping for date columns
  const noWrap = col?.jsonType === 'date' || col?.jsonType === 'time';
  // Issue 36941: when using the default renderer, add css so that line breaks as preserved
  const className = noWrap ? 'ws-no-wrap' : 'ws-pre-wrap';
  if (data) {
    if (typeof data === 'string') {
      display = data;
    } else if (typeof data === 'boolean') {
      display = data ? 'true' : 'false';
    } else if (external_immutable_.List.isList(data)) {
      // defensively return a MultiValueRenderer, this column likely wasn't declared properly as "multiValue"
      return /*#__PURE__*/external_react_default().createElement(MultiValueRenderer, {
        data: data
      });
    } else {
      if (data.has('formattedValue')) {
        display = data.get('formattedValue');
      } else {
        const o = data.has('displayValue') ? data.get('displayValue') : data.get('value');
        display = o !== null && o !== undefined ? o.toString() : null;
      }
      if (data.get('url')) {
        const targetBlank = data.get('urlTarget') === TARGET_BLANK;
        return /*#__PURE__*/external_react_default().createElement("a", {
          className: className,
          href: data.get('url'),
          target: targetBlank ? TARGET_BLANK : undefined,
          rel: targetBlank ? URL_REL : undefined
        }, display);
      }
    }
  }
  return /*#__PURE__*/external_react_default().createElement("span", {
    className: className
  }, display);
});
DefaultRenderer.displayName = 'DefaultRenderer';
;// CONCATENATED MODULE: ./src/public/QueryModel/QueryModelLoader.ts
function QueryModelLoader_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function QueryModelLoader_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? QueryModelLoader_ownKeys(Object(t), !0).forEach(function (r) { QueryModelLoader_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : QueryModelLoader_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function QueryModelLoader_defineProperty(e, r, t) { return (r = QueryModelLoader_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function QueryModelLoader_toPropertyKey(t) { var i = QueryModelLoader_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function QueryModelLoader_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








function bindColumnRenderers(columns) {
  if (columns) {
    const columnRenderers = getQueryColumnRenderers();
    return columns.map(queryCol => {
      let node = DefaultRenderer;
      if (queryCol?.columnRenderer && columnRenderers.hasOwnProperty(queryCol.columnRenderer.toLowerCase())) {
        node = columnRenderers[queryCol.columnRenderer.toLowerCase()];
      }

      // TODO: Just generate one function per type
      return queryCol.mutate({
        cell: (data, row, col, rowIndex, columnIndex) => {
          return external_react_default().createElement(node, {
            data,
            row,
            col: queryCol,
            rowIndex,
            columnIndex
          });
        }
      });
    });
  }
  return columns;
}
const DefaultQueryModelLoader = {
  async loadQueryInfo(model) {
    const {
      containerPath,
      requiredColumns,
      requiredColumnsAsQueryInfoFields,
      schemaQuery
    } = model;
    const queryInfo = await getQueryDetails({
      containerPath,
      fields: requiredColumnsAsQueryInfoFields ? requiredColumns : undefined,
      schemaQuery
    });
    return queryInfo.mutate({
      columns: bindColumnRenderers(queryInfo.columns)
    });
  },
  async loadRows(model) {
    const result = await selectRowsDeprecated(QueryModelLoader_objectSpread(QueryModelLoader_objectSpread({}, model.loadRowsConfig), {}, {
      schemaName: model.schemaName,
      queryName: model.queryName,
      includeTotalCount: false // if requesting to includeTotalCount, it will be loaded separately via loadTotalCount
    }));
    const {
      key,
      models,
      orderedModels,
      rowCount,
      messages
    } = result;
    return {
      messages: messages.toJS(),
      rows: models[key],
      orderedRows: orderedModels[key].toArray(),
      rowCount
    };
  },
  // The selection related methods may seem like overly simple passthroughs, but by putting them on QueryModelLoader,
  // instead of in withQueryModels, it allows us to easily mock them or provide alternate implementations.
  clearSelections(model) {
    const {
      containerFilter,
      selectionKey,
      schemaQuery,
      filters,
      queryParameters,
      selectionContainerPath
    } = model;
    return clearSelected({
      selectionKey,
      schemaQuery,
      filters,
      containerPath: selectionContainerPath,
      queryParameters,
      containerFilter
    });
  },
  async loadSelections(model) {
    const {
      containerFilter,
      selectionKey,
      schemaQuery,
      filters,
      queryParameters,
      selectionContainerPath
    } = model;
    const result = await getSelected(selectionKey, false, schemaQuery, filters, selectionContainerPath, queryParameters, containerFilter);
    return new Set(result?.selected ?? []);
  },
  setSelections(model, checked, selections) {
    const {
      selectionKey,
      selectionContainerPath
    } = model;
    return setSelected(selectionKey, checked, selections, selectionContainerPath);
  },
  replaceSelections(model, selections) {
    const {
      selectionKey,
      selectionContainerPath
    } = model;
    return replaceSelected({
      selectionKey,
      id: selections,
      containerPath: selectionContainerPath
    });
  },
  async selectAllRows(model) {
    const {
      containerFilter,
      filters,
      queryParameters,
      schemaQuery,
      selectionContainerPath,
      selectionKey
    } = model;
    await selectAll(selectionKey, schemaQuery, filters, selectionContainerPath, queryParameters, containerFilter);
    return DefaultQueryModelLoader.loadSelections(model);
  },
  async loadCharts(model) {
    const {
      schemaQuery,
      containerPath
    } = model;
    const sortByName = naturalSortByProperty('name');
    let charts = await fetchCharts(schemaQuery, containerPath);
    charts = charts.sort(sortByName).filter(report => VISUALIZATION_REPORTS.contains(report.type));
    if (!isRReportsEnabled()) {
      charts = charts.filter(chart => chart.type !== DataViewInfoTypes.RReport);
    }
    return charts;
  }
};
;// CONCATENATED MODULE: ./src/public/QueryModel/withQueryModels.tsx
const withQueryModels_excluded = ["queryConfigs", "modelLoader"];
function withQueryModels_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = withQueryModels_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function withQueryModels_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function withQueryModels_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function withQueryModels_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? withQueryModels_ownKeys(Object(t), !0).forEach(function (r) { withQueryModels_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : withQueryModels_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function withQueryModels_defineProperty(e, r, t) { return (r = withQueryModels_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function withQueryModels_toPropertyKey(t) { var i = withQueryModels_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function withQueryModels_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function withQueryModels_extends() { return withQueryModels_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, withQueryModels_extends.apply(null, arguments); }

// eslint cannot find Draft for some reason, but Intellij can.
// eslint-disable-next-line import/named











const DEFAULT_SEARCH_PARAMS = new URLSearchParams();
const DEFAULT_SET_SEARCH_PARAMS = () => {};
function withSearchParams(Component) {
  const Wrapped = props => {
    let searchParams;
    let setSearchParams;
    try {
      [searchParams, setSearchParams] = (0,external_react_router_dom_.useSearchParams)();
    } catch (error) {
      // We are not in a react router context, so we revert to injecting a default set of these props
      searchParams = DEFAULT_SEARCH_PARAMS;
      setSearchParams = DEFAULT_SET_SEARCH_PARAMS;
    }
    return /*#__PURE__*/external_react_default().createElement(Component, withQueryModels_extends({
      searchParams: searchParams,
      setSearchParams: setSearchParams
    }, props));
  };
  return Wrapped;
}
/**
 * Resets queryInfo state to initialized state. Use this when you need to load/reload QueryInfo.
 * Note: This method intentionally has side effects, it is only to be used inside of an Immer produce() callback.
 * @param model The model to reset queryInfo state on.
 */
const resetQueryInfoState = model => {
  model.queryInfo = undefined;
  model.queryInfoError = undefined;
  model.queryInfoLoadingState = LoadingState.INITIALIZED;
};

/**
 * Resets totalCount state to initialized state. Use this when you need to load/reload QueryInfo.
 * Note: This method intentionally has side effects, it is only to be used inside of an Immer produce() callback.
 * @param model The model to reset queryInfo state on.
 */
const resetTotalCountState = model => {
  model.rowCount = undefined;
  model.totalCountError = undefined;
  model.totalCountLoadingState = LoadingState.INITIALIZED;
};

/**
 * Resets rows state to initialized state. Use this when you need to load/reload selections.
 * Note: This method intentionally has side effects, it is only to be used inside of an Immer produce() callback.
 * @param model The model to reset selection state on.
 */
const resetRowsState = model => {
  model.messages = undefined;
  model.offset = 0;
  model.orderedRows = undefined;
  model.rowsError = undefined;
  model.rows = undefined;
  model.rowCount = undefined;
  model.rowsLoadingState = LoadingState.INITIALIZED;
};

/**
 * Resets selection state to initialized state. Use this when you need to load/reload selections.
 * Note: This method intentionally has side effects, it is only to be used inside of an Immer produce() callback.
 * @param model The model to reset selection state on.
 */
const resetSelectionState = model => {
  model.selections = undefined;
  model.selectionsError = undefined;
  model.selectionsLoadingState = LoadingState.INITIALIZED;
};

/**
 * Compares two query params objects, returns true if they are equal, false otherwise.
 * @param oldParams
 * @param newParams
 */
const paramsEqual = (oldParams, newParams) => {
  const keys = Object.keys(oldParams);
  const oldKeyStr = keys.sort(naturalSort).join(';');
  const newKeyStr = Object.keys(newParams).sort(naturalSort).join(';');
  if (oldKeyStr === newKeyStr) {
    // If the keys are the same we need to do a deep comparison
    for (const key of Object.keys(oldParams)) {
      if (oldParams[key] !== newParams[key]) {
        return false;
      }
    }
    return true;
  }

  // If the keys have changed we can assume the params are different.
  return false;
};

/**
 * A wrapper for LabKey selectRows API. For in-depth documentation and examples see components/docs/QueryModel.md.
 * @param ComponentToWrap A component that implements generic Props and InjectedQueryModels.
 * @returns A react ComponentType that implements generic Props and MakeQueryModels.
 */
function withQueryModels(ComponentToWrap) {
  const initModels = props => {
    const {
      searchParams,
      queryConfigs
    } = props;
    return Object.keys(queryConfigs).reduce((models, id) => {
      // We expect the key value for each QueryConfig to be the id. If a user were to mistakenly set the id
      // to something different on the QueryConfig then actions would break
      // e.g. actions.loadNextPage(model.id) would not work.
      let model = new QueryModel(withQueryModels_objectSpread({
        id
      }, queryConfigs[id]));
      const hasQueryParamSettings = locationHasQueryParamSettings(model.urlPrefix, searchParams);
      if (model.bindURL && hasQueryParamSettings) {
        model = model.mutate(model.attributesForURLQueryParams(searchParams, true));
      } else if (model.useSavedSettings) {
        const settings = getSettingsFromLocalStorage(id, model.containerPath);
        if (settings !== undefined) {
          const {
            filterArray,
            maxRows,
            sorts,
            viewName
          } = settings;
          let schemaQuery = model.schemaQuery;
          if (viewName !== undefined) {
            schemaQuery = new SchemaQuery(model.schemaName, model.queryName, viewName);
          }
          model = model.mutate({
            filterArray,
            maxRows,
            schemaQuery,
            sorts
          });
        }
      }
      models[id] = model;
      return models;
    }, {});
  };
  class ComponentWithQueryModels extends external_react_.PureComponent {
    constructor(props) {
      super(props);
      withQueryModels_defineProperty(this, "actions", void 0);
      withQueryModels_defineProperty(this, "bindURL", id => {
        const {
          setSearchParams
        } = this.props;
        if (setSearchParams === DEFAULT_SET_SEARCH_PARAMS) {
          // We're rendering a component outside a react-router context, so we can't bind to the URL
          return;
        }
        const model = this.state.queryModels[id];
        const {
          urlPrefix,
          urlQueryParams
        } = model;
        setSearchParams(currentParams => {
          const queryParams = getQueryParams(currentParams);
          return Object.keys(queryParams).reduce((result, key) => {
            // Only copy params that aren't related to the current model, we initialize the result with the
            // updated params below.
            if (!key.startsWith(urlPrefix + '.')) {
              result[key] = queryParams[key];
            }
            return result;
          },
          // QueryModel.urlQueryParams returns Record<string, string> but getQueryParams and setSearchParams
          // use Record<string, string | string[]
          urlQueryParams);
        }, {
          replace: true
        });
      });
      withQueryModels_defineProperty(this, "updateModelFromURL", id => {
        const {
          searchParams
        } = this.props;
        let loadSelections = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          Object.assign(model, model.attributesForURLQueryParams(searchParams));
          // If we have selections or previously attempted to load them we'll want to reload them when the
          // model is updated from the URL because it can affect selections.
          loadSelections = !!model.selections || !!model.selectionsError;

          // since URL param changes could change the filterArray, need to reload the totalCount (issue 47660)
          model.totalCountLoadingState = LoadingState.INITIALIZED;
        }), () => {
          this.maybeLoad(id, false, true, loadSelections);
          saveSettingsToLocalStorage(this.state.queryModels[id]);
        });
      });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      withQueryModels_defineProperty(this, "setSelectionsError", (id, error, action) => {
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          let selectionsError = resolveErrorMessage(error);
          if (selectionsError === undefined) {
            const schemaQuery = model.schemaQuery.toString();
            selectionsError = `Error while ${action} selections for SchemaQuery: ${schemaQuery}`;
          }
          console.error(`Error setting selections for model ${id}:`, selectionsError);
          model.selectionsError = selectionsError;
          removeSettingsFromLocalStorage(this.state.queryModels[id]);
        }));
      });
      withQueryModels_defineProperty(this, "loadSelections", async id => {
        const {
          loadSelections
        } = this.props.modelLoader;
        this.setState((0,external_immer_.produce)(draft => {
          draft.queryModels[id].selectionsLoadingState = LoadingState.LOADING;
        }));
        try {
          const selections = await loadSelections(this.state.queryModels[id]);
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            model.selections = selections;
            model.selectionsLoadingState = LoadingState.LOADED;
            model.selectionsError = undefined;
          }));
        } catch (error) {
          this.setSelectionsError(id, error, 'loading');
        }
      });
      withQueryModels_defineProperty(this, "clearSelections", async id => {
        const {
          modelLoader
        } = this.props;
        const isLoading = this.state.queryModels[id].selectionsLoadingState === LoadingState.LOADING;
        if (!isLoading) {
          this.setState((0,external_immer_.produce)(draft => {
            draft.queryModels[id].selectionsLoadingState = LoadingState.LOADING;
          }));
        }
        try {
          await modelLoader.clearSelections(this.state.queryModels[id]);
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            model.selections = new Set();
            if (!isLoading) {
              model.selectionsLoadingState = LoadingState.LOADED;
            }
            model.selectionPivot = undefined;
            model.selectionsError = undefined;
          }));
        } catch (error) {
          this.setSelectionsError(id, error, 'clearing');
        }
      });
      withQueryModels_defineProperty(this, "setSelections", async (id, checked, selections) => {
        const {
          modelLoader
        } = this.props;
        const isLoading = this.state.queryModels[id].selectionsLoadingState === LoadingState.LOADING;
        if (!isLoading) {
          this.setState((0,external_immer_.produce)(draft => {
            draft.queryModels[id].selectionsLoadingState = LoadingState.LOADING;
          }));
        }
        try {
          await modelLoader.setSelections(this.state.queryModels[id], checked, selections);
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];

            // If there are selections made, then ensure the model.selections is initialized
            if (!model.selections && selections.length > 0) {
              model.selections = new Set();
            }
            selections.forEach(selection => {
              if (checked) {
                model.selections.add(selection);
              } else {
                model.selections.delete(selection);
              }
            });

            // Set the selection pivot row iff a single row is selected
            if (selections.length === 1) {
              model.selectionPivot = {
                checked,
                selection: selections[0]
              };
            }
            model.selectionsError = undefined;
            if (!isLoading) {
              model.selectionsLoadingState = LoadingState.LOADED;
            }
          }));
        } catch (error) {
          this.setSelectionsError(id, error, 'setting');
        }
      });
      withQueryModels_defineProperty(this, "replaceSelections", async (id, selections) => {
        const {
          modelLoader
        } = this.props;
        this.setState((0,external_immer_.produce)(draft => {
          draft.queryModels[id].selectionsLoadingState = LoadingState.LOADING;
        }));
        try {
          await modelLoader.replaceSelections(this.state.queryModels[id], selections);
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            model.selections = new Set(selections);
            model.selectionsError = undefined;
            model.selectionPivot = undefined;
            model.selectionsLoadingState = LoadingState.LOADED;
          }));
        } catch (error) {
          this.setSelectionsError(id, error, 'replace');
        }
      });
      withQueryModels_defineProperty(this, "selectAllRows", async id => {
        const {
          modelLoader
        } = this.props;
        this.setState((0,external_immer_.produce)(draft => {
          draft.queryModels[id].selectionsLoadingState = LoadingState.LOADING;
        }));
        try {
          const selections = await modelLoader.selectAllRows(this.state.queryModels[id]);
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            model.selections = selections;
            model.selectionsError = undefined;
            model.selectionPivot = undefined;
            model.selectionsLoadingState = LoadingState.LOADED;
          }));
        } catch (error) {
          this.setSelectionsError(id, error, 'setting');
        }
      });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      withQueryModels_defineProperty(this, "selectRow", (id, checked, row, useSelectionPivot) => {
        const model = this.state.queryModels[id];
        const pkCols = model.queryInfo.getPkCols();
        if (pkCols.length === 1) {
          const pkValue = row[pkCols[0].name]?.value?.toString();
          if (!pkValue) {
            console.warn(`Unable to resolve PK value for model ${id} row`, row);
            return;
          }
          if (useSelectionPivot && model.selectionPivot) {
            const pivotIdx = model.orderedRows.findIndex(key => key === model.selectionPivot.selection);
            const selectedIdx = model.orderedRows.findIndex(key => key === pkValue);

            // If we cannot make sense of the indices then just treat this as a normal selection
            if (pivotIdx === -1 || selectedIdx === -1 || pivotIdx === selectedIdx) {
              this.setSelections(id, checked, [pkValue]);
              return;
            }

            // Select all rows relative to/from the pivot row
            let selections;
            if (pivotIdx < selectedIdx) {
              selections = model.orderedRows.slice(pivotIdx + 1, selectedIdx + 1);
            } else {
              selections = model.orderedRows.slice(selectedIdx, pivotIdx);
            }
            this.setSelections(id, model.selectionPivot.checked, selections);
          } else {
            this.setSelections(id, checked, [pkValue]);
          }
        } else {
          const msg = `Cannot set row selection for model ${id}. The model has multiple PK Columns.`;
          console.warn(msg, pkCols);
        }
      });
      withQueryModels_defineProperty(this, "selectPage", (id, checked) => {
        this.setSelections(id, checked, this.state.queryModels[id].orderedRows);
      });
      withQueryModels_defineProperty(this, "selectReport", (id, reportId) => {
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          model.selectedReportId = reportId;
        }), () => {
          if (this.state.queryModels[id].bindURL) {
            this.bindURL(id);
          }
        });
      });
      withQueryModels_defineProperty(this, "loadRows", async (id, loadSelections = false) => {
        const {
          loadRows
        } = this.props.modelLoader;
        if (isLoading(this.state.queryModels[id].queryInfoLoadingState)) {
          return;
        }
        this.setState((0,external_immer_.produce)(draft => {
          draft.queryModels[id].rowsLoadingState = LoadingState.LOADING;
        }));
        try {
          const result = await loadRows(this.state.queryModels[id]);
          const {
            messages,
            rows,
            orderedRows,
            rowCount
          } = result;
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            model.messages = messages;
            model.rows = rows;
            model.orderedRows = orderedRows;
            model.rowCount = !model.includeTotalCount ? rowCount : model.rowCount; // only update the rowCount on the model if we aren't loading the totalCount
            model.rowsLoadingState = LoadingState.LOADED;
            model.rowsError = undefined;
            model.selectionPivot = undefined;
          }), () => this.maybeLoad(id, false, false, loadSelections));
        } catch (error) {
          let viewDoesNotExist = false;
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            let rowsError = resolveErrorMessage(error);
            if (rowsError === undefined) {
              rowsError = `Error while loading rows for SchemaQuery: ${model.schemaQuery.toString()}`;
            }
            console.error(`Error loading rows for model ${id}: `, rowsError);
            removeSettingsFromLocalStorage(this.state.queryModels[id]);
            if (rowsError?.indexOf('The requested view does not exist for this user') > -1) {
              // Issue 49378: if view doesn't exist, use default view
              viewDoesNotExist = true;
              model.schemaQuery = new SchemaQuery(model.schemaName, model.queryName);
              resetRowsState(model);
              resetTotalCountState(model);
              resetSelectionState(model);
            } else {
              model.rowsLoadingState = LoadingState.LOADED;
              model.rowsError = rowsError;
              model.selectionPivot = undefined;
            }
          }), () => {
            if (viewDoesNotExist) {
              this.maybeLoad(id, false, true, loadSelections);
              saveSettingsToLocalStorage(this.state.queryModels[id]);
            }
          });
        }
      });
      withQueryModels_defineProperty(this, "loadTotalCount", async (id, reloadTotalCount = false) => {
        if (isLoading(this.state.queryModels[id].queryInfoLoadingState)) {
          return;
        }

        // if we've already loaded the totalCount, no need to load it again
        if (!reloadTotalCount && this.state.queryModels[id].totalCountLoadingState === LoadingState.LOADED) {
          return;
        }

        // if usage didn't request loading the totalCount, skip it
        if (!this.state.queryModels[id].includeTotalCount) {
          this.setState((0,external_immer_.produce)(draft => {
            draft.queryModels[id].totalCountLoadingState = LoadingState.LOADED;
          }));
          return;
        }
        this.setState((0,external_immer_.produce)(draft => {
          draft.queryModels[id].totalCountLoadingState = LoadingState.LOADING;
        }));
        try {
          const loadRowsConfig = this.state.queryModels[id].loadRowsConfig;
          const queryInfo = this.state.queryModels[id].queryInfo;
          const columns = getSelectRowCountColumnsStr(loadRowsConfig.columns, loadRowsConfig.filterArray, queryInfo?.getPkCols());
          const {
            rowCount
          } = await selectRows(withQueryModels_objectSpread(withQueryModels_objectSpread({}, loadRowsConfig), {}, {
            columns,
            includeDetailsColumn: false,
            // includeMetadata: false, // TODO don't require metadata in selectRows response processing
            includeTotalCount: true,
            includeUpdateColumn: false,
            maxRows: 1,
            offset: 0,
            sort: undefined
          }));
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            model.rowCount = rowCount;
            model.totalCountLoadingState = LoadingState.LOADED;
            model.totalCountError = undefined;
          }));
        } catch (error) {
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            let rowsError = resolveErrorMessage(error);
            if (rowsError === undefined) {
              rowsError = `Error while loading total count for SchemaQuery: ${model.schemaQuery.toString()}`;
            }
            console.error(`Error loading rows for model ${id}: `, rowsError);
            removeSettingsFromLocalStorage(this.state.queryModels[id]);
            model.totalCountLoadingState = LoadingState.LOADED;
            model.totalCountError = rowsError;
          }));
        }
      });
      withQueryModels_defineProperty(this, "loadQueryInfo", async (id, loadRows = false, loadSelections = false, reloadTotalCount = false) => {
        const {
          loadQueryInfo
        } = this.props.modelLoader;
        this.setState((0,external_immer_.produce)(draft => {
          draft.queryModels[id].queryInfoLoadingState = LoadingState.LOADING;
        }));
        try {
          const queryInfo = await loadQueryInfo(this.state.queryModels[id]);
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            model.queryInfo = queryInfo;
            model.queryInfoLoadingState = LoadingState.LOADED;
            model.queryInfoError = undefined;
          }), () => this.maybeLoad(id, false, loadRows, loadSelections, reloadTotalCount));
        } catch (error) {
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            let queryInfoError = resolveErrorMessage(error);
            if (queryInfoError === undefined) {
              queryInfoError = `Error while loading QueryInfo for SchemaQuery: ${model.schemaQuery.toString()}`;
            }
            console.error(`Error loading QueryInfo for model ${id}:`, queryInfoError);
            removeSettingsFromLocalStorage(this.state.queryModels[id]);
            model.queryInfoLoadingState = LoadingState.LOADED;
            model.queryInfoError = queryInfoError;
          }));
        }
      });
      /**
       * Helper for various actions that may want to trigger loadQueryInfo, loadRows, or loadSelections.
       * @param id The id of the QueryModel you want to load
       * @param loadQueryInfo boolean, if true will load the QueryInfo before loading the model's rows.
       * @param loadRows boolean, if true will load the model's rows.
       * @param loadSelections boolean, if true will load selections after loading QueryInfo.
       * @param reloadTotalCount boolean, if true will reload totalCount after loading QueryInfo.
       */
      withQueryModels_defineProperty(this, "maybeLoad", (id, loadQueryInfo = false, loadRows = false, loadSelections = false, reloadTotalCount = false) => {
        if (loadQueryInfo) {
          // Postpone loading any rows or selections if we're loading the QueryInfo.
          this.loadQueryInfo(id, loadRows, loadSelections);
        } else {
          if (loadRows) {
            this.loadRows(id, loadSelections);
            this.loadTotalCount(id, reloadTotalCount);
          } else if (loadSelections) {
            this.loadSelections(id);
          }
        }
        if (this.state.queryModels[id].bindURL) {
          this.bindURL(id);
        }
      });
      withQueryModels_defineProperty(this, "loadModel", (id, loadSelections = false, reloadTotalCount = false) => {
        this.loadQueryInfo(id, true, loadSelections, reloadTotalCount);
      });
      withQueryModels_defineProperty(this, "loadAllModels", (loadSelections = false, reloadTotalCount = true) => {
        Object.keys(this.state.queryModels).forEach(id => this.loadModel(id, loadSelections, reloadTotalCount));
      });
      withQueryModels_defineProperty(this, "loadAllQueryInfos", () => {
        Object.keys(this.state.queryModels).forEach(id => this.loadQueryInfo(id));
      });
      withQueryModels_defineProperty(this, "loadNextPage", id => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (!model.isLastPage) {
            shouldLoad = true;
            model.offset = model.offset + model.maxRows;
          }
        }), () => this.maybeLoad(id, false, shouldLoad));
      });
      withQueryModels_defineProperty(this, "loadPreviousPage", id => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (!model.isFirstPage) {
            shouldLoad = true;
            model.offset = model.offset - model.maxRows;
          }
        }), () => this.maybeLoad(id, false, shouldLoad));
      });
      withQueryModels_defineProperty(this, "loadFirstPage", id => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (!model.isFirstPage) {
            shouldLoad = true;
            model.offset = 0;
          }
        }), () => this.maybeLoad(id, false, shouldLoad));
      });
      withQueryModels_defineProperty(this, "loadLastPage", id => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (!model.isLastPage) {
            shouldLoad = true;
            model.offset = model.lastPageOffset;
          }
        }), () => this.maybeLoad(id, false, shouldLoad));
      });
      withQueryModels_defineProperty(this, "loadCharts", async id => {
        const {
          modelLoader
        } = this.props;
        this.setState((0,external_immer_.produce)(draft => {
          draft.queryModels[id].chartsLoadingState = LoadingState.LOADING;
        }));
        try {
          const charts = await modelLoader.loadCharts(this.state.queryModels[id]);
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            model.charts = charts;
            model.chartsLoadingState = LoadingState.LOADED;
            model.chartsError = undefined;
          }));
        } catch (error) {
          this.setState((0,external_immer_.produce)(draft => {
            const model = draft.queryModels[id];
            let chartsError = resolveErrorMessage(error);
            if (chartsError === undefined) {
              const schemaQuery = model.schemaQuery.toString();
              chartsError = `Error while loading selections for SchemaQuery: ${schemaQuery}`;
            }
            console.error(`Error loading charts for model ${id}`, chartsError);
            removeSettingsFromLocalStorage(this.state.queryModels[id]);
            model.chartsLoadingState = LoadingState.LOADED;
            model.chartsError = chartsError;
          }));
        }
      });
      withQueryModels_defineProperty(this, "addModel", (queryConfig, load = true, loadSelections = false) => {
        const {
          searchParams
        } = this.props;
        let id;
        this.setState((0,external_immer_.produce)(draft => {
          // Instantiate the model first because queryConfig.id is optional and is auto-generated in the
          // QueryModel constructor if not set.
          let queryModel = new QueryModel(queryConfig);
          id = queryModel.id;
          if (queryModel.bindURL && searchParams) {
            queryModel = queryModel.mutate(queryModel.attributesForURLQueryParams(searchParams));
          }
          draft.queryModels[queryModel.id] = queryModel;
        }), () => this.maybeLoad(id, load, load, loadSelections));
      });
      withQueryModels_defineProperty(this, "setOffset", (id, offset) => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (model.offset !== offset) {
            shouldLoad = true;
            model.offset = offset;
          }
        }), () => this.maybeLoad(id, false, shouldLoad));
      });
      withQueryModels_defineProperty(this, "setMaxRows", (id, maxRows) => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (model.maxRows !== maxRows) {
            shouldLoad = true;
            model.maxRows = maxRows;
            model.offset = 0;
          }
        }), () => {
          this.maybeLoad(id, false, shouldLoad);
          saveSettingsToLocalStorage(this.state.queryModels[id]);
        });
      });
      withQueryModels_defineProperty(this, "setView", (id, viewName, loadSelections = false) => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (model.viewName !== viewName) {
            shouldLoad = true;
            model.schemaQuery = new SchemaQuery(model.schemaName, model.queryName, viewName);
            // We need to reset all data for the model because changing the view will change things such as
            // columns and rowCount. If we don't do this we'll render a grid with empty rows/columns.
            resetRowsState(model);
            resetTotalCountState(model);
            resetSelectionState(model);
          }
        }), () => {
          this.maybeLoad(id, false, shouldLoad, shouldLoad && loadSelections);
          saveSettingsToLocalStorage(this.state.queryModels[id]);
        });
      });
      /**
       * Reset the totalCount state for all models so that the next time loadModel or loadAllModels() is called,
       * it will also call the loadTotalCount().
       */
      withQueryModels_defineProperty(this, "resetTotalCountState", () => {
        this.setState((0,external_immer_.produce)(draft => {
          Object.keys(this.state.queryModels).forEach(id => {
            const model = draft.queryModels[id];
            resetTotalCountState(model);
          });
        }));
      });
      withQueryModels_defineProperty(this, "setSchemaQuery", (id, schemaQuery, loadSelections = false) => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (!model.schemaQuery.isEqual(schemaQuery)) {
            shouldLoad = true;
            // We assume that we'll need a new QueryInfo if we're changing the SchemaQuery, so we reset the
            // QueryInfo and all rows related data.
            model.schemaQuery = schemaQuery;
            resetQueryInfoState(model);
            resetRowsState(model);
            resetTotalCountState(model);
            resetSelectionState(model);
          }
        }), () => this.maybeLoad(id, shouldLoad, shouldLoad, shouldLoad && loadSelections));
      });
      withQueryModels_defineProperty(this, "setFilters", (id, filters, loadSelections = false) => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (!filterArraysEqual(model.filterArray, filters)) {
            shouldLoad = true;
            model.filterArray = filters;
            // Changing filters affects row count so we need to reset the offset or pagination can get into
            // an impossible state (e.g. page 3 on a grid with one row of data).
            model.offset = 0;
            model.totalCountLoadingState = LoadingState.INITIALIZED;
            if (shouldLoad && loadSelections) {
              model.selectionsLoadingState = LoadingState.INITIALIZED;
            }
          }
        }), () => {
          // When filters change we need to reload selections and counts.
          this.maybeLoad(id, false, shouldLoad, shouldLoad && loadSelections, true);
          saveSettingsToLocalStorage(this.state.queryModels[id]);
        });
      });
      withQueryModels_defineProperty(this, "setSorts", (id, sorts) => {
        let shouldLoad = false;
        this.setState((0,external_immer_.produce)(draft => {
          const model = draft.queryModels[id];
          if (!sortArraysEqual(model.sorts, sorts)) {
            shouldLoad = true;
            model.sorts = sorts;
          }
        }), () => {
          this.maybeLoad(id, false, shouldLoad);
          saveSettingsToLocalStorage(this.state.queryModels[id]);
        });
      });
      this.state = (0,external_immer_.produce)({}, () => ({
        queryModels: initModels(props)
      }));
      this.actions = {
        addModel: this.addModel,
        clearSelections: this.clearSelections,
        loadModel: this.loadModel,
        loadAllModels: this.loadAllModels,
        loadRows: this.loadRows,
        loadNextPage: this.loadNextPage,
        loadPreviousPage: this.loadPreviousPage,
        loadFirstPage: this.loadFirstPage,
        loadLastPage: this.loadLastPage,
        loadCharts: this.loadCharts,
        replaceSelections: this.replaceSelections,
        resetTotalCountState: this.resetTotalCountState,
        selectAllRows: this.selectAllRows,
        selectRow: this.selectRow,
        selectPage: this.selectPage,
        selectReport: this.selectReport,
        setFilters: this.setFilters,
        setOffset: this.setOffset,
        setMaxRows: this.setMaxRows,
        setSchemaQuery: this.setSchemaQuery,
        setSelections: this.setSelections,
        setSorts: this.setSorts,
        setView: this.setView
      };
    }
    componentDidMount() {
      if (this.props.autoLoad) {
        // N.B. This is currently not an ideal solution in terms of performance as it causes us to
        // (a) load selections for all models when we likely want or need it for only the "active" model and
        // (b) load selections for models that aren't associated with the grid (e.g., on details pages).
        // This change was introduced to eliminate some redundant model data querying we had been doing as a
        // result of having both autoLoad true here and loadOnMount set to true for the GridPanel (Issue 48319)
        // Getting selections is now cheaper than getting the query data itself, so we're leaving this as is
        // for now. Attempts to coordinate better between these two settings have thus far not been successful
        // (or have seemed too invasive to be attractive). See Issue 48758.
        this.loadAllModels(!!this.props.modelLoader.loadSelections);
      } else {
        // Issue 48969: For purposes of export, at least, we want to know the queryInfo data for all models
        // without having to visit each model.
        this.loadAllQueryInfos();
      }
    }

    /**
     * componentDidUpdate only checks for changes to props.searchParams so it can update models when there are
     * changes to the URL (only for models with bindURL set to true).
     *
     * Currently, we do not listen for changes to props.queryConfigs. You may be tempted to try to diff queryConfigs
     * in the future and add/update/remove models as you see changes, but this introduces a bunch of other problems
     * for child components, so don't do this. Problems include:
     *  - Child components will no longer be guaranteed that there will always be a model, so they'll have to check
     *  if model is undefined before accessing any properties on it. This is annoying and error prone.
     *  - Child components will need to listen for when models are re-instantiated, and potentially re-initialize
     *  their state. For example, GridPanel will need to call loadSelections and ChartMenu will need to call
     *  loadCharts
     *
     * If you expect changes to props.queryConfigs to create new models you can pass a key prop to your wrapped
     * component. For Example:
     *      <GridPanelWithModel key={`grid.${schemaName}.${queryName}`} queryConfigs={queryConfigs} />
     * If you pass a unique key to the component then React will unmount and remount the component when the key
     * changes.
     */
    componentDidUpdate(prevProps) {
      const prevSearch = prevProps.searchParams;
      const currSearch = this.props.searchParams;
      if (prevSearch !== undefined && currSearch !== undefined && prevSearch !== currSearch) {
        Object.values(this.state.queryModels).filter(model => model.bindURL).forEach(model => {
          const modelParamsFromURL = {};
          for (const [key, value] of currSearch.entries()) {
            if (key.startsWith(model.urlPrefix + '.')) {
              modelParamsFromURL[key] = value;
            }
          }

          // Issue 49019: Grid session filters/sorts/etc. are not applied as expected when model loads
          // queryInfo from API instead of cache the additional render cycle from the query details API
          // call causes the withQueryModels componentDidUpdate to detect a URL param change and then
          // remove the filters/sorts/etc. that were just applied from the session state. So add a check
          // for the queryInfo loading state in the if statement here.
          if (!isLoading(model.queryInfoLoadingState) && !paramsEqual(modelParamsFromURL, model.urlQueryParams)) {
            // The params for the model have changed on the URL, so update the model.
            this.updateModelFromURL(model.id);
          }
        });
      }
    }
    render() {
      // Intentionally not using queryConfigs and modelLoader, we don't want to pass them to children.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _this$props = this.props,
        {
          queryConfigs,
          modelLoader
        } = _this$props,
        props = withQueryModels_objectWithoutProperties(_this$props, withQueryModels_excluded);
      return /*#__PURE__*/external_react_default().createElement(ComponentToWrap, withQueryModels_extends({
        queryModels: this.state.queryModels,
        actions: this.actions
      }, props));
    }
  }

  // If we override default props here then it compiles. If we define it above it does not compile. TypeScript cannot
  // handle Partial<T & U> where T is a generic and U is known, even if you're only setting attributes from U. In this
  // case defaultProps is Partial<Props & MakeQueryModels>.
  // https://stackoverflow.com/questions/59279796/typescript-partial-of-a-generic-type
  withQueryModels_defineProperty(ComponentWithQueryModels, "defaultProps", void 0);
  ComponentWithQueryModels.defaultProps = {
    autoLoad: false,
    modelLoader: DefaultQueryModelLoader,
    queryConfigs: {},
    useSavedSettings: false
  };
  return withSearchParams(ComponentWithQueryModels);
}
;// CONCATENATED MODULE: ./src/internal/components/samples/SampleStatusTag.tsx
function SampleStatusTag_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SampleStatusTag_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SampleStatusTag_ownKeys(Object(t), !0).forEach(function (r) { SampleStatusTag_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SampleStatusTag_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SampleStatusTag_defineProperty(e, r, t) { return (r = SampleStatusTag_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SampleStatusTag_toPropertyKey(t) { var i = SampleStatusTag_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SampleStatusTag_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











// exported for Jest test
function hexToRGB(hex) {
  const bigInt = hex ? parseInt(hex?.replace('#', ''), 16) : 0;
  const r = bigInt >> 16 & 255;
  const g = bigInt >> 8 & 255;
  const b = bigInt & 255;
  return [r, g, b];
}

// exported for Jest test
function getStatusTagStyle(status) {
  const color = getSampleStatusColor(status.color, status.statusType);
  const style = SAMPLE_STATUS_COLORS[color];
  if (style) {
    return SampleStatusTag_objectSpread(SampleStatusTag_objectSpread({}, style), {}, {
      borderColor: 'lightgray'
    });
  }
  const rgb = hexToRGB(status.color);
  const luminance = (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255;
  return {
    borderColor: 'lightgray',
    backgroundColor: status.color,
    color: luminance <= 0.5 && luminance > 0 ? 'white' : '#555555'
  };
}
const SampleStatusTag = (0,external_react_.memo)(props => {
  const {
    api
  } = useAppContext();
  const {
    moduleContext
  } = useServerContext();
  const {
    placement,
    status,
    iconOnly,
    className,
    hideDescription
  } = props;
  const {
    label,
    statusType,
    description
  } = status;
  const [queryStatusType, setQueryStatusType] = (0,external_react_.useState)();
  const statusType_ = (0,external_react_.useMemo)(() => statusType || queryStatusType, [statusType, queryStatusType]);
  (0,external_react_.useEffect)(() => {
    (async () => {
      // if the queryModel had the status label value but not the type, query to get it from the SampleStatus table
      if (label && !statusType) {
        try {
          const response = await api.query.selectRows({
            columns: ['Label', 'StatusType'],
            filterArray: [api_.Filter.create('Label', label)],
            schemaQuery: SCHEMAS.EXP_TABLES.SAMPLE_STATUS
          });
          if (response?.rows.length > 0) {
            const statusTypeStr = caseInsensitive(response.rows[0], 'StatusType')?.value;
            if (statusTypeStr) setQueryStatusType(SampleStateType[statusTypeStr]);
          }
        } catch (e) {
          console.error(e);
        }
      }
    })();
  }, [api.query, label, statusType]);
  if (!label || !isSampleStatusEnabled(moduleContext)) return null;
  const icon = iconOnly ? /*#__PURE__*/external_react_default().createElement("i", {
    className: "status-icon fa fa-info",
    style: getStatusTagStyle(status)
  }) : /*#__PURE__*/external_react_default().createElement("span", null, label);
  const isAvailable = statusType_ === SampleStateType.Available || !statusType_;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("span", {
    className: external_classnames_default()(className, {
      'status-pill sample-status-pill': !iconOnly
    }),
    style: getStatusTagStyle(status)
  }, !hideDescription && (description || !isAvailable || iconOnly) ? /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    iconComponent: icon,
    placement: placement,
    title: "Sample Status"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "ws-pre-wrap popover-message"
  }, /*#__PURE__*/external_react_default().createElement("b", null, label), " ", description && '- ', description, !isAvailable && /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-top sample-status-warning"
  }, "Not all operations are permitted for a sample with this status."))) : label));
});
SampleStatusTag.defaultProps = {
  placement: 'bottom'
};
;// CONCATENATED MODULE: ./src/internal/components/samples/SampleStatusLegend.tsx









const SAMPLE_STATUS_LEGEND = 'SampleStatusLegend';
// export for jest testing
const SampleStatusLegendImpl = (0,external_react_.memo)(props => {
  const {
    model
  } = props.queryModels;
  if (isLoading(model.rowsLoadingState)) {
    return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  }
  if (model.rowCount === 0) {
    return /*#__PURE__*/external_react_default().createElement("table", {
      className: "sample-status-legend--table"
    }, /*#__PURE__*/external_react_default().createElement("tbody", null, /*#__PURE__*/external_react_default().createElement("tr", null, /*#__PURE__*/external_react_default().createElement("td", null, "No sample statuses are defined."))));
  }
  return /*#__PURE__*/external_react_default().createElement("table", {
    className: "sample-status-legend--table"
  }, /*#__PURE__*/external_react_default().createElement("tbody", null, model.gridData.map(row => {
    const status = getSampleStatus(row);
    return /*#__PURE__*/external_react_default().createElement("tr", {
      key: status.label
    }, /*#__PURE__*/external_react_default().createElement("td", null, /*#__PURE__*/external_react_default().createElement(SampleStatusTag, {
      status: status,
      hideDescription: true
    })), /*#__PURE__*/external_react_default().createElement("td", {
      className: "sample-status-legend--description"
    }, caseInsensitive(row, 'Description')?.value));
  })));
});
const SampleStatusLegendWithQueryModels = withQueryModels(SampleStatusLegendImpl);
const SampleStatusLegend = () => {
  const queryConfigs = {
    model: {
      id: 'sample-statuses-model',
      schemaQuery: SCHEMAS.EXP_TABLES.SAMPLE_STATUS,
      containerFilter: getSampleStatusContainerFilter(true),
      maxRows: -1,
      sorts: [new QuerySort({
        fieldKey: 'StatusType'
      }), new QuerySort({
        fieldKey: 'Label'
      })]
    }
  };
  return /*#__PURE__*/external_react_default().createElement(SampleStatusLegendWithQueryModels, {
    autoLoad: true,
    queryConfigs: queryConfigs
  });
};
;// CONCATENATED MODULE: ./src/internal/components/forms/DomainFieldHelpTipContents.tsx

const DOMAIN_FIELD = 'DomainField';
const DomainFieldHelpTipContents = props => {
  const {
    column,
    children,
    required,
    description,
    type
  } = props;
  const _description = description ?? (column ? column.description : null);
  const _type = type ?? (column ? column.type : null);
  const _required = required ?? (column ? column.required : null);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, _description && /*#__PURE__*/external_react_default().createElement("p", {
    className: "ws-pre-wrap"
  }, /*#__PURE__*/external_react_default().createElement("strong", null, "Description "), _description), _type && /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("strong", null, "Type "), _type), column && column.fieldKey !== column.caption && /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("strong", null, "Field Key "), column.fieldKey), column?.format && /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("strong", null, "Display Format "), column.format), column?.phiProtected && /*#__PURE__*/external_react_default().createElement("p", null, "PHI protected data removed."), _required && /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("small", null, /*#__PURE__*/external_react_default().createElement("i", null, "This field is required."))), children);
};
;// CONCATENATED MODULE: ./src/internal/components/forms/HelpTipRenderer.tsx



const HelpTipRenderer = (0,external_react_.memo)(props => {
  const {
    type,
    children,
    column
  } = props;
  if (type === SAMPLE_STATUS_LEGEND) {
    return /*#__PURE__*/external_react_default().createElement(SampleStatusLegend, null);
  } else if (type === DOMAIN_FIELD) {
    return /*#__PURE__*/external_react_default().createElement(DomainFieldHelpTipContents, {
      column: column
    }, children);
  }
  return null;
});
;// CONCATENATED MODULE: ./src/internal/components/base/Grid.tsx
function Grid_defineProperty(e, r, t) { return (r = Grid_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Grid_toPropertyKey(t) { var i = Grid_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Grid_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







function processColumns(columns) {
  return columns.map(c => {
    if (c instanceof GridColumn) {
      return c;
    } else if (typeof c === 'string') {
      return new GridColumn({
        index: c,
        raw: c,
        title: c
      });
    }
    return new GridColumn({
      align: c.align,
      cell: c.cell,
      format: c.jsonType === 'float' || c.jsonType === 'int' ? c.format : undefined,
      helpTipRenderer: c.helpTipRenderer,
      hideTooltip: c.helpTipRenderer !== undefined,
      index: c.index,
      fixedWidth: c.fixedWidth,
      raw: c,
      tableCell: c.tableCell,
      title: c.title || c.caption,
      width: c.width
    });
  }).toList();
}
function processData(data) {
  if (external_immutable_.List.isList(data)) {
    return data;
  }
  if (Array.isArray(data)) {
    return (0,external_immutable_.fromJS)(data);
  }
  return (0,external_immutable_.List)();
}
function resolveColumns(data) {
  const columns = (0,external_immutable_.List)().asMutable();
  if (data.count() > 0) {
    data.get(0).map((value, title) => {
      columns.push(new GridColumn({
        index: title,
        title
      }));
    });
  }
  return columns.asImmutable();
}

// export for jest testing
function getColumnHoverText(info) {
  let description = info?.description?.trim() || '';
  let sepLeft = description.length > 0 ? '(' : '';
  let sepRight = description.length > 0 ? ')' : '';

  // show field key for lookups to help determine path to field when the name is generic (i.e. "Name" is
  // from "Ancestors/Sources/Lab/Name"),  46256: use encoded fieldKeyPath, 49795: show tooltip for all columns
  description += info?.index ? ' ' + sepLeft + info.index + sepRight : '';
  sepLeft = description.length > 0 ? '(' : '';
  sepRight = description.length > 0 ? ')' : '';
  description += info?.phiProtected === true ? ' ' + sepLeft + 'PHI protected data removed' + sepRight : '';
  description = description.trim();
  return !description ? undefined : description;
}
// export for jest testing
class GridHeader extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    Grid_defineProperty(this, "state", {
      dragTarget: undefined
    });
    Grid_defineProperty(this, "handleDragStart", e => {
      const dragIndex = e.target.id;
      if (e.target?.tagName.toLowerCase() === 'th' && dragIndex !== GRID_SELECTION_INDEX) {
        e.dataTransfer.setData('dragIndex', dragIndex);
      }
    });
    Grid_defineProperty(this, "handleDragOver", e => {
      e.preventDefault();
    });
    Grid_defineProperty(this, "handleDragEnd", e => {
      this.setState({
        dragTarget: undefined
      });
    });
    Grid_defineProperty(this, "handleDragEnter", e => {
      if (e.target?.tagName.toLowerCase() === 'th' && e.target.id !== GRID_SELECTION_INDEX) {
        this.setState({
          dragTarget: e.target.id
        });
      }
    });
    Grid_defineProperty(this, "handleDrop", e => {
      var source = e.dataTransfer.getData('dragIndex');
      const target = this.state.dragTarget;
      if (source && target && source !== target) {
        this.props?.onColumnDrop(source, target);
      }
    });
    Grid_defineProperty(this, "handleHeaderClick", e => {
      // Issue 48610: app grid column header <th> element to trigger click on child <div>
      const childEl = e.target.getElementsByClassName(GRID_HEADER_CELL_BODY);
      if (childEl?.length === 1) {
        e.target.getElementsByClassName(GRID_HEADER_CELL_BODY)[0].click();
      }
    });
  }
  render() {
    const {
      calcWidths,
      columns,
      headerCell,
      showHeader,
      onColumnDrop
    } = this.props;
    const {
      dragTarget
    } = this.state;
    if (!showHeader) {
      // returning null here causes <noscript/> to render which is not expected
      return /*#__PURE__*/external_react_default().createElement("thead", {
        style: {
          display: 'none'
        }
      });
    }
    return /*#__PURE__*/external_react_default().createElement("thead", null, /*#__PURE__*/external_react_default().createElement("tr", null, columns.map((column, i) => {
      const {
        headerCls,
        index,
        fixedWidth,
        raw,
        title,
        width,
        hideTooltip
      } = column;
      const draggable = onColumnDrop !== undefined;
      let style;
      if (fixedWidth) {
        style = {
          width: `${fixedWidth}px`
        };
      }
      let colMinWidth = width;
      if (colMinWidth === undefined) {
        // the additional 45px is to account for the grid column header icons for sort/filter and the dropdown toggle
        colMinWidth = calcWidths && title ? Math.max(45 + title.length * 8, 150) : undefined;
      }
      if (!fixedWidth && colMinWidth !== undefined) {
        if (!style) style = {};
        style.minWidth = `${colMinWidth}px`;
      }
      if (column.showHeader) {
        const className = external_classnames_default()(headerCls, {
          'grid-header-cell': headerCls === undefined,
          'phi-protected': raw?.phiProtected === true,
          'grid-header-draggable': draggable && index !== GRID_SELECTION_INDEX,
          'grid-header-drag-over': dragTarget === index
        });
        const description = getColumnHoverText(raw);
        return /*#__PURE__*/external_react_default().createElement("th", {
          id: index,
          key: index,
          className: className,
          style: style,
          title: hideTooltip ? undefined : description,
          draggable: draggable,
          onDragStart: this.handleDragStart,
          onDragOver: this.handleDragOver,
          onDrop: this.handleDrop,
          onDragEnter: this.handleDragEnter,
          onDragEnd: this.handleDragEnd,
          onClick: this.handleHeaderClick
        }, headerCell ? headerCell(column, i, columns.size) : title, !headerCell && column.helpTipRenderer && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
          title: title,
          popoverClassName: "label-help-arrow-top"
        }, /*#__PURE__*/external_react_default().createElement(HelpTipRenderer, {
          type: column.helpTipRenderer
        })));
      }
      return /*#__PURE__*/external_react_default().createElement("th", {
        key: index,
        style: {
          minWidth: style?.minWidth
        }
      });
    }, this)));
  }
}
const GridMessages = (0,external_react_.memo)(({
  messages
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "grid-messages"
}, messages.map((message, i) => {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    external_react_default().createElement("div", {
      className: "grid-message",
      key: i
    }, message.get('content'))
  );
})));
const GridRow = (0,external_react_.memo)(({
  columns,
  highlight,
  row,
  rowIdx
}) => {
  // style cast to "any" type due to @types/react@16.3.14 switch to csstype package usage which does not declare
  // "textAlign" property correctly for <td> elements.
  return /*#__PURE__*/external_react_default().createElement("tr", {
    className: external_classnames_default()({
      'grid-row-highlight': highlight,
      'grid-row-alternate': rowIdx % 2 === 0,
      'grid-row': rowIdx % 2 === 1
    })
  }, columns.map((column, c) => column.tableCell ? /*#__PURE__*/external_react_default().createElement(external_react_.Fragment, {
    key: column.index
  }, column.cell(row.get(column.index), row, column, rowIdx, c)) : /*#__PURE__*/external_react_default().createElement("td", {
    key: column.index,
    style: {
      textAlign: column.align || 'left'
    }
  }, column.cell(row.get(column.index), row, column, rowIdx, c))));
});
GridRow.displayName = 'GridRow';
const EmptyGridRow = (0,external_react_.memo)(({
  colSpan,
  emptyText,
  isLoading,
  loadingText
}) => /*#__PURE__*/external_react_default().createElement("tr", {
  key: "grid-default-row",
  className: isLoading ? 'grid-loading' : 'grid-empty'
}, /*#__PURE__*/external_react_default().createElement("td", {
  colSpan: colSpan
}, isLoading ? loadingText : emptyText)));
EmptyGridRow.displayName = 'EmptyGridRow';
const GridBody = (0,external_react_.memo)(props => {
  const {
    columns,
    data,
    emptyText,
    highlightRowIndexes,
    isLoading,
    loadingText,
    rowKey
  } = props;
  return /*#__PURE__*/external_react_default().createElement("tbody", null, data.map((row, ind) => {
    const highlight = highlightRowIndexes && highlightRowIndexes.contains(ind);
    const key = rowKey ? row.get(rowKey) : ind;
    return /*#__PURE__*/external_react_default().createElement(GridRow, {
      columns: columns,
      highlight: highlight,
      key: key,
      row: row,
      rowIdx: ind
    });
  }), data.isEmpty() && /*#__PURE__*/external_react_default().createElement(EmptyGridRow, {
    colSpan: columns.count(),
    emptyText: emptyText,
    isLoading: isLoading,
    loadingText: loadingText
  }));
});
const Grid = (0,external_react_.memo)(props => {
  const {
    bordered = true,
    calcWidths = false,
    cellular = false,
    condensed = false,
    data = (0,external_immutable_.List)(),
    emptyText = 'No data available.',
    isLoading = false,
    loadingText = 'Loading...',
    messages = (0,external_immutable_.List)(),
    responsive = true,
    showHeader = true,
    striped = true,
    tableRef = undefined,
    fixedHeight = false,
    columns,
    headerCell,
    onColumnDrop,
    rowKey,
    highlightRowIndexes,
    gridId
  } = props;
  const gridData = processData(data);
  const gridColumns = columns !== undefined ? processColumns(columns) : resolveColumns(gridData);
  const headerProps = {
    calcWidths,
    columns: gridColumns,
    headerCell,
    onColumnDrop,
    showHeader
  };
  const bodyProps = {
    columns: gridColumns,
    data: gridData,
    emptyText,
    isLoading,
    loadingText,
    rowKey,
    highlightRowIndexes
  };
  const tableClasses = external_classnames_default()({
    table: !cellular,
    'table-cellular': cellular,
    'table-striped': striped,
    'table-bordered': bordered,
    'table-condensed': condensed
  });
  const wrapperClasses = external_classnames_default()({
    'table-responsive': responsive,
    // fixedHeight is a misnomer, we used to set a fixed height, but now we use a max-height set via css
    'table-responsive--max-height': fixedHeight
  });
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: wrapperClasses,
    "data-gridid": gridId
  }, /*#__PURE__*/external_react_default().createElement(GridMessages, {
    messages: messages
  }), /*#__PURE__*/external_react_default().createElement("table", {
    className: tableClasses,
    ref: tableRef
  }, /*#__PURE__*/external_react_default().createElement(GridHeader, headerProps), /*#__PURE__*/external_react_default().createElement(GridBody, bodyProps)));
});
;// CONCATENATED MODULE: ./src/internal/components/base/FormSection.tsx
function FormSection_defineProperty(e, r, t) { return (r = FormSection_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FormSection_toPropertyKey(t) { var i = FormSection_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FormSection_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



class FormSection extends (external_react_default()).Component {
  showLabel() {
    return this.props.showLabel && this.props.label !== undefined;
  }
  render() {
    const {
      label
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, this.showLabel() && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-sm-12"
    }, api_.Utils.isString(label) ? /*#__PURE__*/external_react_default().createElement("label", {
      className: "control-label text-left"
    }, /*#__PURE__*/external_react_default().createElement("strong", null, label)) : label)), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-sm-12"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('wizard-row--container', {
        'wizard-row--spacer': this.props.iconSpacer
      })
    }, this.props.children, this.props.addContent && /*#__PURE__*/external_react_default().createElement("div", {
      className: "add-row--container",
      onClick: this.props.onAddClick
    }, this.props.addContent)))));
  }
}
FormSection_defineProperty(FormSection, "defaultProps", {
  iconSpacer: true,
  showLabel: true
});
;// CONCATENATED MODULE: ./src/internal/components/base/Section.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const Section = props => {
  const {
    panelClassName,
    titleClassName,
    titleContainerClassName,
    title,
    titleSize = 'large',
    context,
    caption,
    children
  } = props;
  const showHeader = !!title || !!caption || !!context;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "g-section"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: `panel panel-content ${panelClassName ? panelClassName : ''}`
  }, showHeader && /*#__PURE__*/external_react_default().createElement("div", {
    className: `panel-heading panel-content-flex panel-content-${titleSize}`
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: `panel-content-title-container ${titleContainerClassName ?? ''}`
  }, title && /*#__PURE__*/external_react_default().createElement("div", {
    className: `panel-content-title-${titleSize} ${titleClassName ?? ''}`
  }, title), caption && /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-content-caption"
  }, caption)), context && /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-content-context"
  }, context)), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, children)));
};
Section.displayName = 'Section';
;// CONCATENATED MODULE: ./src/internal/components/base/ContentGroup.tsx


const ContentGroupLabel = ({
  withoutBottomMargin,
  children
}) => {
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('content-group-label', {
      'content-group': !withoutBottomMargin
    })
  }, children);
};
const ContentGroup = ({
  children,
  label
}) => {
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "content-group"
  }, label && /*#__PURE__*/external_react_default().createElement(ContentGroupLabel, null, label), children);
};
;// CONCATENATED MODULE: ./src/internal/components/base/VerticalScrollPanel.tsx


// We have padding at the bottom of our pages that we need to account for or we'll end up with double scrollbars on the
// page which looks bad
const PADDING = 45;
const VerticalScrollPanel = (0,external_react_.memo)(props => {
  const {
    ratio,
    offset,
    children,
    cls
  } = props;
  const [height, setHeight] = (0,external_react_.useState)(0);
  const resize = (0,external_react_.useCallback)(() => {
    if (offset) setHeight(window.innerHeight - offset - PADDING);else setHeight(window.innerHeight * ratio);
  }, [offset, ratio]);
  (0,external_react_.useEffect)(() => {
    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    style: {
      height: height + 'px'
    },
    className: 'vertical-scroll-panel ' + cls
  }, children);
});
VerticalScrollPanel.defaultProps = {
  ratio: 0.9,
  offset: 0,
  scroll: true
};
;// CONCATENATED MODULE: ./src/internal/components/files/models.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const DEFAULT_FILE = {
  canDelete: false,
  canEdit: false,
  canRead: false,
  canRename: false,
  canUpload: false,
  contentLength: 0,
  contentType: undefined,
  created: undefined,
  createdBy: undefined,
  createdById: -1,
  dataFileUrl: undefined,
  description: undefined,
  downloadUrl: undefined,
  href: undefined,
  id: undefined,
  iconFontCls: undefined,
  isCollection: false,
  isLeaf: false,
  lastModified: undefined,
  name: undefined,
  options: undefined,
  propertiesRowId: undefined
};
const ALL_FILES_LIMIT_KEY = 'all';
;// CONCATENATED MODULE: ./src/internal/components/files/actions.ts
function files_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function files_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? files_actions_ownKeys(Object(t), !0).forEach(function (r) { files_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : files_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function files_actions_defineProperty(e, r, t) { return (r = files_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function files_actions_toPropertyKey(t) { var i = files_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function files_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */




// Converts the 2D array returned by inferDomain action into a list of row maps that the grid understands
function convertRowDataIntoPreviewData(data, previewRowCount, fields) {
  let rows = (0,external_immutable_.List)();
  const headerRow = data.size > 0 ? data.get(0) : undefined;
  if (!headerRow) {
    return rows;
  }

  // numeric data is imported as Doubles for excel (see org.labkey.api.exp.PropertyType#getFromExcelCell)
  const integerFieldInds = [];
  if (fields && fields.size > 0) {
    fields.forEach((field, ind) => {
      const rangeURI = field.rangeURI;
      if (rangeURI && (rangeURI.toLowerCase() === 'xsd:int' || rangeURI.toLowerCase() === 'http://www.w3.org/2001/xmlschema#int')) {
        integerFieldInds.push(ind);
      }
    });
  }
  for (let i = 1; i < Math.min(previewRowCount + 1, data.size); i++) {
    const row = data.get(i);
    let m = (0,external_immutable_.OrderedMap)();
    headerRow.forEach((column, j) => {
      let value = row.get(j);
      // Issue 43531: We only want to do the integer conversion if the value is an integer.  If the value is a string that
      // looks like an integer (e.g., 000304), we want to retain the leading 0s at least in the preview.  The 0's will get
      // lopped off if the domain field is actually numeric.
      if (integerFieldInds.indexOf(j) > -1 && !isNaN(parseFloat(value)) && isFinite(value) && value.toString().endsWith('.0')) value = parseScientificInt(value);
      m = m.set(column, value);
    });
    rows = rows.push(m);
  }
  return rows;
}

// Finds the extension on the given file name, including the '.'. Optionally, returning the type based on the first or
// last index of '.' in the file name.
// If there is no extension returns the empty string.
// If fileName is undefined, returns undefined.
function getFileExtension(fileName, lastIndex = true) {
  if (fileName) {
    const dotIndex = lastIndex ? fileName.lastIndexOf('.') : fileName.indexOf('.');
    return dotIndex >= 0 ? fileName.slice(dotIndex) : '';
  }
  return undefined;
}
function fileMatchesAcceptedFormat(fileName, formatExtensionStr) {
  const acceptedFormatArray = formatExtensionStr.replace(/\s/g, '').split(',');
  let extension = getFileExtension(fileName);
  let isMatch = extension?.length > 0 && acceptedFormatArray.indexOf(extension) >= 0;

  // Issue 42637: some file name extensions may not be based off of the last index of '.' in the file name
  if (!isMatch) {
    extension = getFileExtension(fileName, false);
    isMatch = extension?.length > 0 && acceptedFormatArray.indexOf(extension) >= 0;
  }
  return (0,external_immutable_.fromJS)({
    extension,
    isMatch
  });
}
function fileSizeLimitCompare(file, sizeLimits) {
  if (!sizeLimits || sizeLimits.isEmpty()) return {
    isOversized: false,
    isOversizedForPreview: false,
    limits: undefined
  };
  const extension = getFileExtension(file.name);
  let limits = sizeLimits.get(ALL_FILES_LIMIT_KEY) || {};
  if (extension && sizeLimits.has(extension)) {
    limits = files_actions_objectSpread(files_actions_objectSpread({}, limits), sizeLimits.get(extension));
  }
  return {
    isOversized: limits.maxSize && file.size > limits.maxSize.value,
    isOversizedForPreview: limits.maxPreviewSize && file.size > limits.maxPreviewSize.value,
    limits
  };
}
;// CONCATENATED MODULE: ./src/internal/components/files/FileAttachmentEntry.tsx
function FileAttachmentEntry_defineProperty(e, r, t) { return (r = FileAttachmentEntry_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FileAttachmentEntry_toPropertyKey(t) { var i = FileAttachmentEntry_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FileAttachmentEntry_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class FileAttachmentEntry extends external_react_.PureComponent {
  render() {
    const {
      allowDelete,
      downloadUrl,
      onDelete,
      name,
      deleteTitleText
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      key: name,
      className: "attached-file--container"
    }, allowDelete && /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-times-circle file-upload__remove--icon",
      onClick: () => onDelete(name),
      title: deleteTitleText
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-file-text attached-file--icon attached-file--bottom-spacing"
    }), downloadUrl ? /*#__PURE__*/external_react_default().createElement("strong", null, /*#__PURE__*/external_react_default().createElement("a", {
      href: downloadUrl,
      title: name
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "file-listing-filename"
    }, name))) : name);
  }
}
FileAttachmentEntry_defineProperty(FileAttachmentEntry, "defaultProps", {
  allowDelete: true,
  deleteTitleText: 'Remove file'
});
;// CONCATENATED MODULE: ./src/internal/components/files/FileAttachmentContainer.tsx
function FileAttachmentContainer_defineProperty(e, r, t) { return (r = FileAttachmentContainer_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FileAttachmentContainer_toPropertyKey(t) { var i = FileAttachmentContainer_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FileAttachmentContainer_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








const isDirectoryEntry = entry => entry.isDirectory;
const isFileEntry = entry => entry.isFile;
class FileAttachmentContainer extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    FileAttachmentContainer_defineProperty(this, "fileInput", void 0);
    FileAttachmentContainer_defineProperty(this, "dirCbCount", void 0);
    FileAttachmentContainer_defineProperty(this, "fileCbCount", void 0);
    FileAttachmentContainer_defineProperty(this, "initFileNames", () => {
      const {
        initialFileNames,
        initialFiles
      } = this.props;

      // since we do not have the file objects themselves, we do not check if the
      // file "type" is valid.  There is presumably nothing a user could do if it were
      // invalid.
      this.setState({
        fileNames: initialFileNames || initialFiles && Object.keys(initialFiles) || []
      });
    });
    // this is copied (and extended a bit) from the LABKEY.internal.ZipLoad.getFilesFromDirectory function in ZipLoad.js
    FileAttachmentContainer_defineProperty(this, "getFilesFromDirectory", (files, entry, scope, callback) => {
      const dirReader = entry.createReader();
      const entriesReader = (scope => {
        return entries => {
          for (let i = 0; i < entries.length; i++) {
            const _entry = entries[i];
            if (isFileEntry(_entry)) {
              scope.fileCbCount++;
              _entry.file(file => {
                scope.fileCbCount--;

                // ignore hidden files
                if (file.name.substring(0, 1) !== '.') {
                  if (files[file.name]) {
                    scope.setState({
                      warningMsg: 'Duplicate files were uploaded. Only the last file provided for the duplicate name will be included in the file set.'
                    });
                  }
                  // @ts-expect-error fullPath is not a property of File in lib.dom.ts
                  file.fullPath = entry.fullPath + '/' + file.name;
                  files[file.name] = file;
                }
                if (scope.dirCbCount === 0 && scope.fileCbCount === 0) {
                  callback();
                }
              });
            } else if (isDirectoryEntry(_entry)) {
              scope.getFilesFromDirectory(files, _entry, scope, callback);
            }
          }

          // readEntries only reads 100 files in a batch for Chrome
          if (entries.length >= 100) {
            scope.dirCbCount++;
            dirReader.readEntries(entriesReader, console.error);
          }
          scope.dirCbCount--;
          if (scope.dirCbCount === 0 && scope.fileCbCount === 0) {
            callback();
          }
        };
      })(scope);
      scope.dirCbCount++;
      dirReader.readEntries(entriesReader, console.error);
    });
    FileAttachmentContainer_defineProperty(this, "validateFiles", (fileList, transferItems) => {
      const {
        acceptedFormats,
        allowDirectories,
        sizeLimits
      } = this.props;
      this.setState({
        errorMsg: undefined,
        warningMsg: undefined,
        isHover: false
      });
      if (!acceptedFormats && allowDirectories && !sizeLimits) {
        return (0,external_immutable_.Set)();
      }
      let invalidFileTypes = (0,external_immutable_.Map)(); // map from file name to extension
      let oversizedFiles = (0,external_immutable_.Map)(); // map from file name to display size limit
      const invalidDirectories = []; // list of directory names if not allowed;
      let invalidNames = (0,external_immutable_.Set)();
      Array.from(fileList).forEach((file, index) => {
        if (transferItems && transferItems[index].webkitGetAsEntry().isDirectory) {
          if (!allowDirectories) {
            invalidDirectories.push(file.name);
            invalidNames = invalidNames.add(file.name);
          }
        } else if (acceptedFormats) {
          const formatCheck = fileMatchesAcceptedFormat(file.name, acceptedFormats);
          if (!formatCheck.get('isMatch')) {
            invalidFileTypes = invalidFileTypes.set(file.name, formatCheck.get('extension'));
            invalidNames = invalidNames.add(file.name);
          }
        }
        if (sizeLimits) {
          if (!invalidFileTypes.has(file.name) && invalidDirectories.indexOf(file.name) < 0) {
            const sizeCheck = fileSizeLimitCompare(file, sizeLimits);
            if (sizeCheck.isOversized) {
              oversizedFiles = oversizedFiles.set(file.name, sizeCheck.limits.maxSize.displayValue);
              invalidNames = invalidNames.add(file.name);
            }
          }
        }
      });
      if (!invalidNames.isEmpty()) {
        const errors = [];
        if (invalidDirectories.length > 0) {
          errors.push('Folders are not supported.');
        }
        if (!invalidFileTypes.isEmpty()) {
          let errorMsg = '';
          if (invalidFileTypes.size === 1) {
            const fileName = invalidFileTypes.keySeq().first();
            errorMsg += 'Invalid file type ' + invalidFileTypes.get(fileName) + '.';
          } else {
            errorMsg += 'Invalid file types: ' + invalidFileTypes.map((extension, fileName) => extension).join(', ') + '.';
          }
          errorMsg += '  Valid types are ' + acceptedFormats + '.  ';
          errors.push(errorMsg);
        }
        if (!oversizedFiles.isEmpty()) {
          if (oversizedFiles.size === 1) {
            const fileName = oversizedFiles.keySeq().first();
            errors.push( /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "The file '", fileName, "' is larger than the maximum allowed size of", ' ', oversizedFiles.get(fileName), ". ", this.props.sizeLimitsHelpText));
          } else {
            errors.push( /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "These files are larger than their maximum allowed sizes:", /*#__PURE__*/external_react_default().createElement("ul", null, oversizedFiles.map((limit, fileName) =>
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            external_react_default().createElement("li", {
              key: fileName
            }, fileName, " (max size: ", limit, ")")).toArray()), this.props.sizeLimitsHelpText));
          }
        }
        this.setState({
          errorMsg: invalidNames.size > 1 ? /*#__PURE__*/external_react_default().createElement("ul", null, errors.map((error, index) => /*#__PURE__*/external_react_default().createElement("li", {
            key: index
          }, error))) : errors,
          isHover: false
        });
        return invalidNames;
      }
      return (0,external_immutable_.Set)();
    });
    FileAttachmentContainer_defineProperty(this, "handleChange", evt => {
      this.cancelEvent(evt);
      if (evt.currentTarget && evt.currentTarget.files) {
        this.handleFiles(evt.currentTarget.files);
      }
    });
    FileAttachmentContainer_defineProperty(this, "handleDrag", evt => {
      const {
        isHover
      } = this.state;
      this.cancelEvent(evt);
      if (!isHover) {
        this.setState({
          isHover: true
        });
      }
    });
    FileAttachmentContainer_defineProperty(this, "handleDrop", evt => {
      this.cancelEvent(evt);
      if (evt.dataTransfer && evt.dataTransfer.files) {
        this.handleFiles(evt.dataTransfer.files, evt.dataTransfer.items);
      }
    });
    FileAttachmentContainer_defineProperty(this, "_handleFiles", files => {
      const {
        handleChange,
        sizeLimits
      } = this.props;
      const totalSizeLimit = sizeLimits?.get(ALL_FILES_LIMIT_KEY)?.totalSize;
      if (totalSizeLimit) {
        const totalFileSize = Object.values(files).reduce((total, file) => {
          return total + file.size;
        }, 0);
        if (totalFileSize > totalSizeLimit.value) {
          this.setState({
            errorMsg: `The total file size of all files exceeds the maximum allowed size of ${totalSizeLimit.displayValue}.`,
            isHover: false
          });
          return;
        }
      }
      this.setState({
        files,
        fileNames: Object.keys(files),
        isHover: false,
        isDirty: true
      });
      if (api_.Utils.isFunction(handleChange)) {
        handleChange(files);
      }
    });
    FileAttachmentContainer_defineProperty(this, "handleLeave", evt => {
      const {
        isHover
      } = this.state;
      this.cancelEvent(evt);
      if (isHover) {
        this.setState({
          isHover: false
        });
      }
    });
    FileAttachmentContainer_defineProperty(this, "handleRemove", name => {
      const {
        handleRemoval
      } = this.props;
      const fileNames = this.state.fileNames.filter(fileName => name !== fileName);
      const files = {};
      for (const filename of Object.keys(this.state.files)) {
        if (fileNames.indexOf(filename) >= 0) files[filename] = this.state.files[filename];
      }

      // NOTE: This will clear the field entirely so multiple file support
      // will need to account for this and rewrite this clearing mechanism
      if (this.fileInput.current) {
        this.fileInput.current.value = '';
      }
      this.setState({
        isDirty: true,
        errorMsg: undefined,
        warningMsg: undefined,
        files,
        fileNames
      });
      if (api_.Utils.isFunction(handleRemoval)) {
        handleRemoval(name);
      }
    });
    this.fileInput = external_react_default().createRef();
    this.state = {
      files: props.initialFiles ? props.initialFiles : {},
      fileNames: props.initialFileNames || [],
      isDirty: false,
      isHover: false
    };
  }
  componentDidMount() {
    this.initFileNames();
  }
  componentDidUpdate(prevProps) {
    if (!this.state.isDirty && this.props.initialFileNames !== prevProps.initialFileNames) {
      this.initFileNames();
    }
  }
  handleFiles(fileList, transferItems) {
    const {
      allowMultiple,
      allowDirectories,
      includeDirectoryFiles
    } = this.props;
    if (!allowMultiple && fileList.length > 1) {
      this.setState({
        errorMsg: 'Only one file allowed.',
        isHover: false
      });
      return;
    }
    const invalidFiles = this.validateFiles(fileList, transferItems);

    // iterate through the file list and set the names as the object key
    const newFiles = {};
    let haveValidFiles = false;
    let hasDirectory = false;
    Array.from(fileList).forEach((file, index) => {
      if (!invalidFiles.contains(file.name)) {
        if (this.state.files?.[file.name]) {
          this.setState({
            warningMsg: 'Duplicate files were uploaded. Only the last file will be included in the file set.'
          });
        }
        newFiles[file.name] = file;
        haveValidFiles = true;
        if (transferItems && transferItems[index].webkitGetAsEntry().isDirectory) {
          hasDirectory = true;
        }
      }
    });
    if (haveValidFiles) {
      const files = Object.assign({}, newFiles, this.state.files);
      if (hasDirectory && allowDirectories && includeDirectoryFiles) {
        this.dirCbCount = 0;
        this.fileCbCount = 0;
        Array.from(fileList).forEach((file, index) => {
          const entry = transferItems[index].webkitGetAsEntry();
          if (isDirectoryEntry(entry)) {
            delete files[file.name];
            this.getFilesFromDirectory(files, entry, this, () => {
              this._handleFiles(files);
            });
          }
        });
      } else {
        this._handleFiles(files);
      }
    }
  }
  cancelEvent(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }
  getLabelLong() {
    const {
      labelLong,
      sizeLimits
    } = this.props;
    if (!sizeLimits || !sizeLimits.has(ALL_FILES_LIMIT_KEY) || sizeLimits.size > 1) {
      return labelLong;
    }
    const allMaxSize = sizeLimits.get(ALL_FILES_LIMIT_KEY).maxSize;
    return allMaxSize ? labelLong + ' The maximum file size allowed is ' + sizeLimits.get(ALL_FILES_LIMIT_KEY).maxSize.displayValue + '.' : labelLong;
  }
  render() {
    const {
      acceptedFormats,
      allowMultiple,
      index,
      compact,
      fileCountSuffix
    } = this.props;
    const {
      fileNames,
      isHover,
      errorMsg,
      warningMsg
    } = this.state;
    const hideFileUpload = !allowMultiple && fileNames.length > 0;
    const fileUploadText = 'fileUpload' + (index !== undefined ? index : '');
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('file-upload--container', hideFileUpload ? 'hidden' : 'block', {
        'file-upload--container--compact': compact
      })
    }, /*#__PURE__*/external_react_default().createElement("label", {
      className: external_classnames_default()({
        'file-upload--label': !compact,
        'file-upload--label--compact': compact,
        'file-upload__is-hover': isHover
      }),
      htmlFor: fileUploadText,
      onDragEnter: this.handleDrag,
      onDragLeave: this.handleLeave,
      onDragOver: this.handleDrag,
      onDrop: this.handleDrop
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: external_classnames_default()('fa fa-cloud-upload', {
        'fa-2x cloud-logo': !compact,
        'file-upload__label__icon': compact
      }),
      "aria-hidden": "true"
    }), this.getLabelLong()), /*#__PURE__*/external_react_default().createElement("input", {
      accept: acceptedFormats,
      className: "file-upload--input",
      id: fileUploadText,
      multiple: allowMultiple,
      name: fileUploadText,
      onChange: this.handleChange,
      ref: this.fileInput,
      type: "file"
    })), warningMsg !== '' && warningMsg !== undefined && /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "warning",
      className: this.props.compact ? 'file-upload--error-message--compact' : null
    }, warningMsg), errorMsg !== '' && errorMsg !== undefined && /*#__PURE__*/external_react_default().createElement(Alert, {
      className: this.props.compact ? 'file-upload--error-message--compact' : null
    }, errorMsg), /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('file-upload--file-entry-listing', {
        'well well-sm': allowMultiple && fileNames.length
      })
    }, fileNames.map(fileName => {
      return /*#__PURE__*/external_react_default().createElement(FileAttachmentEntry, {
        key: fileName,
        name: fileName,
        onDelete: this.handleRemove
      });
    })), fileCountSuffix && fileNames.length > 0 && /*#__PURE__*/external_react_default().createElement("div", {
      className: "file-upload--scroll-footer"
    }, api_.Utils.pluralBasic(fileNames.length, 'file'), " ", fileCountSuffix, "."));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/files/FilePreviewGrid.tsx
function FilePreviewGrid_defineProperty(e, r, t) { return (r = FilePreviewGrid_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FilePreviewGrid_toPropertyKey(t) { var i = FilePreviewGrid_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FilePreviewGrid_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class FilePreviewGrid extends (external_react_default()).Component {
  render() {
    const {
      data,
      columns,
      header,
      infoMsg,
      errorMsg,
      errorStyle,
      warningMsg
    } = this.props;
    const numRows = data ? data.size : 0;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, errorMsg ? /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: errorStyle
    }, errorMsg) : /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("strong", null, header), /*#__PURE__*/external_react_default().createElement(Alert, {
      className: "margin-top",
      bsStyle: "warning"
    }, warningMsg), /*#__PURE__*/external_react_default().createElement("p", {
      className: "margin-top"
    }, /*#__PURE__*/external_react_default().createElement("span", null, "The ", numRows === 1 ? 'one row ' : 'first ' + numRows + ' rows ', " of your data file", ' ', numRows === 1 ? 'is' : 'are', " shown below."), "\xA0", infoMsg), /*#__PURE__*/external_react_default().createElement(Grid, {
      columns: columns,
      data: data
    })));
  }
}
FilePreviewGrid_defineProperty(FilePreviewGrid, "defaultProps", {
  header: 'File preview:',
  msg: '',
  errorStyle: 'warning'
});
;// CONCATENATED MODULE: ./src/internal/components/base/Permissions.tsx
/*
 * Copyright (c) 2019-2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * This component is intended to be used to wrap other components which should only be displayed when the
 * user has specific permissions. Permissions are defined on the application user and can be specified by
 * importing PermissionTypes. The component uses "useServerContext" to access the current user so it
 * requires access to the "ServerContext".
 */
const RequiresPermission = props => {
  const {
    checkIsAdmin,
    children,
    permissionCheck,
    perms
  } = props;
  const serverContext = useServerContext();
  const user = props.user ?? serverContext.user;
  const allow = (0,external_react_.useMemo)(() => hasPermissions(user, typeof perms === 'string' ? [perms] : perms, checkIsAdmin, permissionCheck), [checkIsAdmin, permissionCheck, perms, user]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, external_react_default().Children.map(children, child => allow ? child : null));
};
RequiresPermission.displayName = 'RequiresPermission';
;// CONCATENATED MODULE: ./src/public/files/TemplateDownloadButton.tsx



const TemplateDownloadButton = (0,external_react_.memo)(props => {
  const {
    className,
    onClick,
    templateUrl,
    text,
    user
  } = props;
  if (!onClick && !templateUrl?.length) return null;
  return /*#__PURE__*/external_react_default().createElement(RequiresPermission, {
    perms: [api_.PermissionTypes.Insert, api_.PermissionTypes.Update],
    permissionCheck: "any",
    user: user
  }, /*#__PURE__*/external_react_default().createElement("a", {
    className: 'btn btn-info ' + className,
    title: "Download Template",
    onClick: onClick,
    href: templateUrl,
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-download"
  }), " ", text));
});
TemplateDownloadButton.defaultProps = {
  text: 'Template'
};
;// CONCATENATED MODULE: ./src/public/files/FileAttachmentForm.tsx
function FileAttachmentForm_extends() { return FileAttachmentForm_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, FileAttachmentForm_extends.apply(null, arguments); }
function FileAttachmentForm_defineProperty(e, r, t) { return (r = FileAttachmentForm_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FileAttachmentForm_toPropertyKey(t) { var i = FileAttachmentForm_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FileAttachmentForm_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











class FileAttachmentForm extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    FileAttachmentForm_defineProperty(this, "fileAttachmentContainerRef", void 0);
    FileAttachmentForm_defineProperty(this, "reportFileOversized", (attachedFiles, sizeStr) => {
      this.setState(() => ({
        errorMessage: 'This file is too large to be previewed. The maximum size allowed for previewing files of this type is ' + sizeStr + '.'
      }));
    });
    FileAttachmentForm_defineProperty(this, "handleFileChange", fileList => {
      const {
        onFileChange,
        sizeLimits,
        fileSpecificCallback,
        allowMultiple
      } = this.props;
      const attachedFiles = this.state.attachedFiles.merge(fileList);
      this.setState(() => ({
        attachedFiles
      }), () => {
        if (!allowMultiple) {
          // currently only supporting 1 file for processing contents
          const firstFile = attachedFiles.valueSeq().first();
          const sizeCheck = fileSizeLimitCompare(firstFile, sizeLimits);
          const fileTypeFn = fileSpecificCallback?.get(getFileExtension(firstFile.name));
          if (fileTypeFn) {
            if (!sizeCheck.isOversized) {
              fileTypeFn(firstFile).then(res => {
                this.updateErrors(res.success ? null : res.msg);
              }).catch(res => {
                this.updateErrors(res.msg);
              });
            } else {
              this.reportFileOversized(attachedFiles, sizeCheck.limits.maxSize.displayValue);
            }
          } else if (this.isShowPreviewGrid()) {
            if (!sizeCheck.isOversizedForPreview) {
              this.uploadDataFileForPreview();
            } else {
              this.reportFileOversized(attachedFiles, sizeCheck.limits.maxPreviewSize.displayValue);
            }
          }
        }
        onFileChange?.(attachedFiles);
      });
    });
    FileAttachmentForm_defineProperty(this, "handleFileRemoval", attachmentName => {
      const {
        onFileRemoval
      } = this.props;
      this.setState(state => ({
        attachedFiles: state.attachedFiles.remove(attachmentName),
        previewData: undefined,
        previewStatus: undefined,
        errorMessage: undefined
      }), () => {
        onFileRemoval?.(attachmentName, this.state.attachedFiles);
      });
    });
    FileAttachmentForm_defineProperty(this, "manuallyClearFiles", attachmentName => {
      this.fileAttachmentContainerRef.current.handleRemove(attachmentName);
    });
    FileAttachmentForm_defineProperty(this, "handleSubmit", () => {
      this.props.onSubmit?.(this.state.attachedFiles);

      // clear out attached files once they have been submitted.
      this.setState({
        attachedFiles: (0,external_immutable_.Map)()
      });
    });
    this.fileAttachmentContainerRef = external_react_default().createRef();
    if (props.allowMultiple && props.previewGridProps) {
      console.warn('Showing the file preview grid is only supported for single file upload.');
    }
    this.state = {
      attachedFiles: (0,external_immutable_.Map)(),
      errorMessage: undefined,
      previewStatus: undefined
    };
  }
  componentDidMount() {
    this.initPreviewData();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.previewGridProps !== this.props.previewGridProps) {
      this.initPreviewData();
    }
  }
  initPreviewData() {
    const {
      previewGridProps
    } = this.props;
    if (previewGridProps?.initialData) {
      this.setState({
        previewData: convertRowDataIntoPreviewData(previewGridProps.initialData.get('data'), previewGridProps.previewCount)
      });
    }
  }
  determineFileSize() {
    const {
      attachedFiles
    } = this.state;
    return attachedFiles.reduce((total, file) => total += file.size, 0);
  }
  renderButtons() {
    const {
      cancelText,
      onCancel,
      submitText,
      compact
    } = this.props;
    const button = /*#__PURE__*/external_react_default().createElement("button", {
      className: external_classnames_default()('file-form-submit-btn btn btn-success', {
        'file-form-submit-btn--compact': compact
      }),
      disabled: this.state.attachedFiles.size === 0,
      onClick: this.handleSubmit,
      title: submitText,
      type: "button"
    }, submitText);
    if (compact) {
      return button;
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row top-spacing bottom-spacing"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-6"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: onCancel,
      title: cancelText,
      type: "button"
    }, cancelText)), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-6"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "pull-right"
    }, button)));
  }
  isShowPreviewGrid() {
    return !this.props.allowMultiple && this.props.previewGridProps;
  }
  shouldShowPreviewGrid() {
    const {
      errorMessage,
      previewData,
      previewStatus
    } = this.state;
    return errorMessage || previewStatus || previewData;
  }
  renderPreviewGrid() {
    const {
      previewGridProps
    } = this.props;
    const {
      errorMessage,
      previewData,
      previewStatus
    } = this.state;
    if (!this.shouldShowPreviewGrid()) {
      return;
    }
    if (previewData || errorMessage) {
      return /*#__PURE__*/external_react_default().createElement(FilePreviewGrid, FileAttachmentForm_extends({}, previewGridProps, {
        data: previewData,
        errorMsg: errorMessage
      }));
    } else if (previewStatus) {
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "margin-top"
      }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
        msg: previewStatus
      }));
    }
  }
  updatePreviewStatus(previewStatus) {
    this.setState(() => ({
      previewStatus
    }));
  }
  updateErrors(errorMessage) {
    if (errorMessage) {
      this.props.onError?.(errorMessage);
    }
    this.setState(() => ({
      errorMessage
    }));
  }
  uploadDataFileForPreview() {
    const {
      previewGridProps
    } = this.props;
    const {
      attachedFiles
    } = this.state;

    // just take the first file, since we only support 1 file at this time
    const file = attachedFiles.first();

    // check if this usage has a set of formats which are supported for preview
    if (previewGridProps.acceptedFormats) {
      const fileCheck = fileMatchesAcceptedFormat(file.name, previewGridProps.acceptedFormats);
      // if the file extension doesn't match the accepted preview formats, return without trying to get preview data
      if (!fileCheck.get('isMatch')) {
        return;
      }
    }
    this.updatePreviewStatus('Uploading file...');
    inferDomainFromFile(file, previewGridProps.previewCount, previewGridProps.domainKindName).then(response => {
      this.updatePreviewStatus(null);
      if (!previewGridProps.skipPreviewGrid) {
        if (response.data.size > 1) {
          const previewData = convertRowDataIntoPreviewData(response.data, previewGridProps.previewCount, response.fields);
          this.setState(() => ({
            previewData
          }));
          this.updateErrors(null);
        } else {
          this.updateErrors('No data found in the attached file.');
        }
      }
      if (previewGridProps.onPreviewLoad) {
        previewGridProps.onPreviewLoad(response, file);
      }
    }).catch(reason => {
      this.updateErrors(reason ? reason?.exception || reason : 'There was a problem determining the fields in the uploaded file.  Please check the format of the file.');
    });
  }
  shouldRenderAcceptedFormats() {
    const {
      acceptedFormats,
      showAcceptedFormats
    } = this.props;
    return acceptedFormats && showAcceptedFormats && !this.shouldShowPreviewGrid();
  }
  renderAcceptedFormats() {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "file-form-formats"
    }, /*#__PURE__*/external_react_default().createElement("strong", null, "Supported formats include: "), this.props.acceptedFormats);
  }
  shouldRenderTemplateButton() {
    const {
      templateUrl
    } = this.props;
    return templateUrl?.length > 0 && !this.shouldShowPreviewGrid();
  }
  renderFooter() {
    if (!this.shouldRenderAcceptedFormats() && !this.shouldRenderTemplateButton()) {
      return;
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-9"
    }, this.shouldRenderAcceptedFormats() && this.renderAcceptedFormats()), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-3"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "pull-right"
    }, this.shouldRenderTemplateButton() && /*#__PURE__*/external_react_default().createElement(TemplateDownloadButton, {
      templateUrl: this.props.templateUrl
    }))));
  }
  render() {
    const {
      acceptedFormats,
      allowDirectories,
      includeDirectoryFiles,
      fileCountSuffix,
      allowMultiple,
      initialFileNames,
      initialFiles,
      label,
      labelLong,
      showButtons,
      showLabel,
      showProgressBar,
      sizeLimits,
      sizeLimitsHelpText,
      isSubmitting,
      compact
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("span", {
      className: "translator--toggle__wizard"
    }, /*#__PURE__*/external_react_default().createElement(FormSection, {
      iconSpacer: false,
      label: label,
      showLabel: showLabel
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()({
        'file-upload--one-row': compact
      })
    }, /*#__PURE__*/external_react_default().createElement(FileAttachmentContainer, {
      ref: this.fileAttachmentContainerRef,
      index: this.props.index,
      acceptedFormats: acceptedFormats,
      allowDirectories: allowDirectories,
      includeDirectoryFiles: includeDirectoryFiles,
      fileCountSuffix: fileCountSuffix,
      handleChange: this.handleFileChange,
      handleRemoval: this.handleFileRemoval,
      initialFileNames: initialFileNames,
      initialFiles: initialFiles,
      allowMultiple: allowMultiple,
      sizeLimits: sizeLimits,
      sizeLimitsHelpText: sizeLimitsHelpText,
      labelLong: labelLong,
      compact: compact
    }), compact && showButtons && this.renderButtons()))), this.renderPreviewGrid(), showProgressBar && /*#__PURE__*/external_react_default().createElement(Progress, {
      estimate: this.determineFileSize() * 0.1,
      modal: true,
      title: "Uploading",
      toggle: isSubmitting
    }), this.renderFooter(), !compact && showButtons && this.renderButtons());
  }
}
FileAttachmentForm_defineProperty(FileAttachmentForm, "defaultProps", {
  acceptedFormats: '',
  showAcceptedFormats: true,
  allowDirectories: true,
  includeDirectoryFiles: false,
  allowMultiple: true,
  cancelText: 'Cancel',
  label: 'Attachments',
  labelLong: 'Select file or drag and drop here.',
  onCancel: undefined,
  onSubmit: undefined,
  showButtons: false,
  showLabel: true,
  showProgressBar: false,
  submitText: 'Upload',
  compact: false,
  fileSpecificCallback: undefined
});
;// CONCATENATED MODULE: ./src/internal/components/files/FilesListing.tsx
function FilesListing_defineProperty(e, r, t) { return (r = FilesListing_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FilesListing_toPropertyKey(t) { var i = FilesListing_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FilesListing_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class FilesListing extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    FilesListing_defineProperty(this, "toggleDeleteConfirmation", fileName => {
      const {
        confirmDeletionSet
      } = this.state;
      this.setState({
        confirmDeletionSet: confirmDeletionSet.has(fileName) ? confirmDeletionSet.delete(fileName) : confirmDeletionSet.add(fileName)
      });
    });
    FilesListing_defineProperty(this, "deleteFile", fileName => {
      this.setState(state => ({
        confirmDeletionSet: state.confirmDeletionSet.delete(fileName)
      }));
      this.props.onDelete?.(fileName);
    });
    this.state = {
      confirmDeletionSet: (0,external_immutable_.Set)()
    };
  }
  render() {
    const {
      files,
      headerText,
      noFilesMessage,
      useFilePropertiesEditTrigger,
      getFilePropertiesEditTrigger,
      canDelete,
      onFileSelection,
      selectedFiles
    } = this.props;
    const {
      confirmDeletionSet
    } = this.state;
    if (!files || files.size === 0) return /*#__PURE__*/external_react_default().createElement("div", null, noFilesMessage);
    return /*#__PURE__*/external_react_default().createElement("div", null, headerText && /*#__PURE__*/external_react_default().createElement("div", {
      className: "file-listing--header bottom-spacing"
    }, headerText), files.map((file, key) => {
      const {
        description,
        downloadUrl,
        name
      } = file;
      const confirmDelete = confirmDeletionSet.has(name);
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "component file-listing-row--container",
        key: key
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "detail-component"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-4 file-listing-icon--container"
      }, /*#__PURE__*/external_react_default().createElement("input", {
        checked: selectedFiles.contains(name),
        name: name,
        onClick: onFileSelection,
        type: "checkbox"
      }), /*#__PURE__*/external_react_default().createElement("i", {
        className: file.iconFontCls + ' file-listing-icon'
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-3 file-listing-info"
      }, /*#__PURE__*/external_react_default().createElement("strong", null, /*#__PURE__*/external_react_default().createElement("a", {
        href: downloadUrl,
        title: name
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "file-listing-filename"
      }, name))), /*#__PURE__*/external_react_default().createElement("br", null), /*#__PURE__*/external_react_default().createElement("span", {
        className: "file-listing-info-light"
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "test-loc-file-created-by"
      }, file.createdBy), /*#__PURE__*/external_react_default().createElement("span", {
        className: "test-loc-file-created"
      }, file.created))), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-5"
      }, description), /*#__PURE__*/external_react_default().createElement("span", {
        className: "pull-right"
      }, useFilePropertiesEditTrigger && getFilePropertiesEditTrigger(file), canDelete && confirmDelete ? /*#__PURE__*/external_react_default().createElement("span", null, /*#__PURE__*/external_react_default().createElement("div", {
        className: "pull-right"
      }, "Permanently delete?"), /*#__PURE__*/external_react_default().createElement("br", null), /*#__PURE__*/external_react_default().createElement("span", {
        className: "file-listing-canceldel-icon"
      }, /*#__PURE__*/external_react_default().createElement("button", {
        className: "btn btn-default",
        onClick: () => this.toggleDeleteConfirmation(name),
        type: "button"
      }, "Cancel")), /*#__PURE__*/external_react_default().createElement("button", {
        className: "btn btn-danger",
        onClick: () => this.deleteFile(name),
        type: "button"
      }, "Delete File")) : canDelete && /*#__PURE__*/external_react_default().createElement("span", {
        className: "pull-right file-listing-delete",
        onClick: () => this.toggleDeleteConfirmation(name)
      }, /*#__PURE__*/external_react_default().createElement("i", {
        className: "fa fa-times-circle file-listing-delete-icon"
      }))))));
    }));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/files/FilesListingForm.tsx
function FilesListingForm_defineProperty(e, r, t) { return (r = FilesListingForm_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FilesListingForm_toPropertyKey(t) { var i = FilesListingForm_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FilesListingForm_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class FilesListingForm extends external_react_.Component {
  constructor(props) {
    super(props);
    FilesListingForm_defineProperty(this, "toggleUploadSection", () => {
      this.setState(state => ({
        showFileUploadPanel: !state.showFileUploadPanel
      }));
      this.props.handleFileChange?.(true);
    });
    FilesListingForm_defineProperty(this, "toggleFileSelection", event => {
      const {
        target
      } = event;
      const {
        name
      } = target;
      this.setState(state => ({
        selectedFiles: target.checked ? state.selectedFiles.add(name) : state.selectedFiles.delete(name)
      }));
    });
    FilesListingForm_defineProperty(this, "uploadAttachedFiles", async files => {
      const {
        handleUpload,
        onSubmit,
        onUploadFiles
      } = this.props;
      if (!handleUpload) {
        throw new Error('FilesListingForm configuration error. Must specify "handleUpload" handler if uploading files is allowed.');
      }

      // Before upload
      onSubmit?.();

      // Upload
      try {
        await handleUpload(files);
      } catch (err) {
        // handleUpload expected to handle failures
      }

      // After upload
      onUploadFiles?.();
      this.toggleUploadSection();
    });
    FilesListingForm_defineProperty(this, "downloadSelectedFiles", () => {
      this.props.handleDownload?.(this.state.selectedFiles);
    });
    FilesListingForm_defineProperty(this, "handleFileChange", () => {
      this.props.handleFileChange?.(false);
    });
    FilesListingForm_defineProperty(this, "toggleDeleteConfirmation", fileName => {
      this.setState(({
        confirmDeletionSet
      }) => ({
        confirmDeletionSet: confirmDeletionSet.has(fileName) ? confirmDeletionSet.delete(fileName) : confirmDeletionSet.add(fileName)
      }));
    });
    FilesListingForm_defineProperty(this, "deleteFile", fileName => {
      this.setState(state => ({
        selectedFiles: state.selectedFiles.delete(fileName)
      }));
      this.props.handleDelete?.(fileName);
    });
    this.state = {
      confirmDeletionSet: (0,external_immutable_.Set)(),
      selectedFiles: (0,external_immutable_.Set)(),
      showFileUploadPanel: false
    };
  }
  render() {
    const {
      addFileText,
      canDelete,
      canInsert,
      files,
      getFilePropertiesEditTrigger,
      headerText,
      noFilesMessage,
      readOnlyFiles,
      readOnlyHeaderText,
      noReadOnlyFilesMessage,
      useFilePropertiesEditTrigger
    } = this.props;
    const {
      selectedFiles,
      showFileUploadPanel
    } = this.state;
    const hasEditable = files?.size > 0;
    const hasReadOnly = readOnlyFiles?.size > 0;
    const hasFiles = hasEditable || hasReadOnly;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row bottom-spacing"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-7"
    }, canInsert && /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-primary",
      onClick: this.toggleUploadSection,
      title: addFileText,
      type: "button"
    }, addFileText)), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-5"
    }, hasFiles && /*#__PURE__*/external_react_default().createElement("div", {
      className: "pull-right"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      disabled: selectedFiles.size === 0,
      onClick: this.downloadSelectedFiles,
      title: "Download selected files",
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-download"
    }))))), showFileUploadPanel && /*#__PURE__*/external_react_default().createElement(FileAttachmentForm, {
      allowDirectories: false,
      allowMultiple: true,
      onCancel: this.toggleUploadSection,
      onSubmit: this.uploadAttachedFiles,
      onFileChange: this.handleFileChange,
      onFileRemoval: this.handleFileChange,
      showButtons: true,
      showLabel: false,
      showProgressBar: true
    }), (hasReadOnly || noReadOnlyFilesMessage) && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, hasEditable && /*#__PURE__*/external_react_default().createElement("hr", null), /*#__PURE__*/external_react_default().createElement(FilesListing, {
      files: readOnlyFiles,
      headerText: readOnlyHeaderText,
      noFilesMessage: noReadOnlyFilesMessage,
      onFileSelection: this.toggleFileSelection,
      selectedFiles: selectedFiles,
      canDelete: false
    }), hasEditable && /*#__PURE__*/external_react_default().createElement("hr", null)), (hasEditable || noFilesMessage) && /*#__PURE__*/external_react_default().createElement(FilesListing, {
      files: files,
      headerText: headerText,
      noFilesMessage: noFilesMessage,
      useFilePropertiesEditTrigger: useFilePropertiesEditTrigger,
      getFilePropertiesEditTrigger: getFilePropertiesEditTrigger,
      canDelete: canDelete,
      onDelete: this.deleteFile,
      onFileSelection: this.toggleFileSelection,
      selectedFiles: selectedFiles
    }));
  }
}
FilesListingForm_defineProperty(FilesListingForm, "defaultProps", {
  addFileText: 'Attach File'
});
;// CONCATENATED MODULE: ./src/public/files/WebDav.ts
const WebDav_excluded = ["collection", "contenttype", "creationdate", "lastmodified", "leaf", "text"];
function WebDav_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = WebDav_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function WebDav_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }



const SC_FILE_MATCH = 208;
class WebDavFile {
  constructor(props) {
    const {
        collection,
        contenttype,
        creationdate,
        lastmodified,
        leaf,
        text
      } = props,
      validProps = WebDav_objectWithoutProperties(props, WebDav_excluded);
    const {
      href
    } = validProps;
    if (collection !== undefined) validProps.isCollection = collection;
    if (contenttype !== undefined) validProps.contentType = contenttype;
    if (creationdate !== undefined) validProps.created = creationdate;
    if (href !== undefined) validProps.downloadUrl = href + '?contentDisposition=attachment';
    if (lastmodified !== undefined) validProps.lastModified = lastmodified;
    if (leaf !== undefined) validProps.isLeaf = leaf;
    if (text !== undefined) validProps.name = text;
    Object.assign(this, DEFAULT_FILE, validProps);
  }
}
function getWebDavUrl(containerPath, directory, createIntermediates, skipAtFiles, asJSON) {
  const containerPath_ = containerPath?.startsWith('/') ? containerPath : '/' + containerPath;
  let url = `${api_.ActionURL.getContextPath()}/_webdav${api_.ActionURL.encodePath(containerPath_)}`;
  if (!skipAtFiles) url += '/' + encodeURIComponent('@files');
  if (directory) url += '/' + encodeURIComponent(directory).replace(/%2F/g, '/');
  if (createIntermediates) url += '?createIntermediates=' + createIntermediates;
  if (asJSON) url += '?method=JSON';
  return url;
}
function getWebDavFiles(containerPath, directory, includeDirectories, skipAtFiles, alternateFilterCondition) {
  return new Promise((resolve, reject) => {
    return api_.Ajax.request({
      url: getWebDavUrl(containerPath, directory, false, skipAtFiles, true),
      success: api_.Utils.getCallbackWrapper(response => {
        // Filter directories and create webdav files
        const filteredFiles = response.files.reduce((filtered, file) => {
          const filterCondition = alternateFilterCondition ? alternateFilterCondition(file) : includeDirectories || !file.collection;
          if (filterCondition) {
            return filtered.set(file.text, new WebDavFile(file));
          } else {
            return filtered;
          }
        }, (0,external_immutable_.Map)());
        resolve((0,external_immutable_.Map)({
          files: filteredFiles,
          permissions: response.permissions
        }));
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error('Problem retrieving webDav files for container ' + containerPath);
        reject(response);
      }, null, false)
    });
  });
}
function uploadWebDavFile(file, containerPath, directory, createIntermediates, overwrite = true) {
  const url = getWebDavUrl(containerPath, directory, createIntermediates);
  return uploadWebDavFileToUrl(file, url, overwrite);
}
function uploadWebDavFileToUrl(file, url, overwrite = true) {
  return new Promise((resolve, reject) => {
    const form = new FormData();
    form.append('file', file);
    form.append('overwrite', overwrite ? 'T' : 'F');
    api_.Ajax.request({
      url,
      method: 'POST',
      form,
      success: api_.Utils.getCallbackWrapper((response, request) => {
        if (!overwrite && request?.status === SC_FILE_MATCH) {
          reject('File already exists: ' + file.name);
        } else {
          resolve(file.name);
        }
      }),
      failure: api_.Utils.getCallbackWrapper(() => {
        console.error('Failure uploading file: ' + file.name);
        reject('Failure uploading file: ' + file.name);
      }, null, true)
    });
  });
}
function createWebDavDirectory(containerPath, directory, createIntermediates) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: getWebDavUrl(containerPath, directory, createIntermediates),
      method: 'MKCOL',
      success: api_.Utils.getCallbackWrapper(() => {
        resolve(directory);
      }),
      failure: api_.Utils.getCallbackWrapper(() => {
        console.error('failure creating directory ' + directory);
        reject(directory);
      }, null, false)
    });
  });
}
function deleteWebDavResource(containerPath, directoryOrFilePath) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: getWebDavUrl(containerPath, directoryOrFilePath),
      method: 'DELETE',
      success: api_.Utils.getCallbackWrapper(() => {
        resolve(directoryOrFilePath);
      }),
      failure: api_.Utils.getCallbackWrapper(() => {
        console.error('failure deleting resource ' + directoryOrFilePath);
        reject(directoryOrFilePath);
      }, null, false)
    });
  });
}
// EXTERNAL MODULE: external "react-treebeard"
var external_react_treebeard_ = __webpack_require__(136);
;// CONCATENATED MODULE: ./src/internal/Checkbox.tsx


// Note: This will be renamed to Checkbox when all react-bootstrap usages of Checkbox are removed.
const CheckboxLK = (0,external_react_.memo)(props => {
  const {
    checked,
    children,
    className,
    disabled = false,
    id,
    name,
    onChange,
    onClick
  } = props;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('checkbox', className)
  }, /*#__PURE__*/external_react_default().createElement("label", null, /*#__PURE__*/external_react_default().createElement("input", {
    checked: checked,
    className: "",
    disabled: disabled,
    id: id,
    name: name,
    onChange: onChange,
    onClick: onClick,
    type: "checkbox"
  }), children));
});
CheckboxLK.displayName = 'Checkbox';
;// CONCATENATED MODULE: ./src/internal/components/files/FileTreeHeader.tsx
function FileTreeHeader_extends() { return FileTreeHeader_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, FileTreeHeader_extends.apply(null, arguments); }
function FileTreeHeader_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FileTreeHeader_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FileTreeHeader_ownKeys(Object(t), !0).forEach(function (r) { FileTreeHeader_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FileTreeHeader_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FileTreeHeader_defineProperty(e, r, t) { return (r = FileTreeHeader_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FileTreeHeader_toPropertyKey(t) { var i = FileTreeHeader_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FileTreeHeader_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




// exported for jest testing
// Not using Pure/memo as node property is mutable
const FileNodeIcon = props => {
  const {
    isDirectory,
    useFileIconCls,
    node
  } = props;
  const iconClass = external_classnames_default()('filetree-folder-icon', 'fa', {
    'fa-folder-open': isDirectory && node.toggled,
    'fa-folder': isDirectory && !node.toggled,
    'fa-file-alt': !isDirectory
  });
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !isDirectory && useFileIconCls && node.data && node.data.iconFontCls ? /*#__PURE__*/external_react_default().createElement("i", {
    className: node.data.iconFontCls + ' filetree-folder-icon'
  }) : /*#__PURE__*/external_react_default().createElement("span", {
    className: iconClass
  }));
};
// Note not using Pure/memo as the node property is mutable
const Header = props => {
  const {
    style,
    onSelect,
    node,
    customStyles,
    checked,
    handleCheckbox,
    checkboxId,
    emptyDirectoryText,
    allowMultiSelect,
    showNodeIcon = true,
    isEmpty,
    isLoading,
    NodeIcon = FileNodeIcon
  } = props;
  const isDirectory = node.children !== undefined;
  const activeColor = node.active && !allowMultiSelect ? 'lk-text-theme-dark filetree-node-active' : undefined; // $brand-primary and $gray-light

  if (isEmpty) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "filetree-empty-directory"
    }, emptyDirectoryText);
  }
  if (isLoading) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "filetree-empty-directory"
    }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null));
  }

  // Do not always want to toggle directories when clicking a check box
  const checkClick = evt => {
    evt.stopPropagation();
  };
  return /*#__PURE__*/external_react_default().createElement("span", {
    className: 'filetree-checkbox-container' + (isDirectory ? '' : ' filetree-leaf-node') + (node.active ? ' active' : '')
  }, handleCheckbox && /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
    id: checkboxId,
    checked: checked,
    name: node.id,
    onChange: handleCheckbox,
    onClick: checkClick
  }), /*#__PURE__*/external_react_default().createElement("div", {
    style: style.base,
    onClick: onSelect
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: activeColor
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "filetree-resource-row",
    style: node.selected ? FileTreeHeader_objectSpread(FileTreeHeader_objectSpread({}, style.title), customStyles.header.title) : style.title,
    title: node.name
  }, showNodeIcon && /*#__PURE__*/external_react_default().createElement(NodeIcon, FileTreeHeader_extends({}, props, {
    isDirectory: isDirectory
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()({
      'filetree-file-name': !isDirectory,
      'filetree-directory-name': isDirectory
    })
  }, node.name), props.children))));
};
;// CONCATENATED MODULE: ./src/internal/components/files/FileTree.tsx
function FileTree_extends() { return FileTree_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, FileTree_extends.apply(null, arguments); }
function FileTree_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FileTree_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FileTree_ownKeys(Object(t), !0).forEach(function (r) { FileTree_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FileTree_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FileTree_defineProperty(e, r, t) { return (r = FileTree_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FileTree_toPropertyKey(t) { var i = FileTree_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FileTree_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






const fileTree_color = '#333'; // $text-color
const customStyle = {
  tree: {
    base: {
      listStyle: 'none',
      backgroundColor: 'white',
      margin: 0,
      padding: 0,
      color: fileTree_color,
      fontFamily: 'Roboto, Helvetica Neue, Helvetica, Arial, sans-serif',
      // $font-family-sans-serif
      fontSize: '14px'
    },
    node: {
      base: {
        position: 'relative'
      },
      link: {
        cursor: 'pointer',
        position: 'relative',
        padding: '0px 5px',
        display: 'flex',
        width: 'fit-content'
      },
      activeLink: {
        borderRadius: '5px'
      },
      toggle: {
        base: {
          position: 'relative',
          display: 'inline-block',
          verticalAlign: 'top',
          marginLeft: '-5px',
          height: '24px',
          width: '24px'
        },
        wrapper: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          margin: '-10px 0 0 -5px',
          height: '10px'
        },
        height: 10,
        width: 10,
        arrow: {
          fill: fileTree_color,
          strokeWidth: 0
        }
      },
      header: {
        base: {
          display: 'inline-block',
          verticalAlign: 'top',
          color: fileTree_color
        },
        connector: {
          width: '2px',
          height: '12px',
          borderLeft: 'solid 2px black',
          borderBottom: 'solid 2px black',
          position: 'absolute',
          top: '0px',
          left: '-21px'
        },
        title: {
          lineHeight: '24px',
          verticalAlign: 'middle'
        }
      },
      subtree: {
        listStyle: 'none',
        paddingLeft: '19px'
      },
      loading: {
        color: fileTree_color
      }
    }
  }
};
const DEFAULT_ROOT_PREFIX = '|root';
const CHECK_ID_PREFIX = 'filetree-check-';

// Place holder names for empty or loading display.  Uses asterisk which will never be in a file name.
const EMPTY_FILE_NAME = '*empty';
const LOADING_FILE_NAME = '*loading';
const nodeIsLoading = id => {
  return id?.endsWith('|' + LOADING_FILE_NAME);
};
const nodeIsEmpty = id => {
  return id?.endsWith('|' + EMPTY_FILE_NAME);
};
// TODO add typings for nodes, see https://github.com/storybookjs/react-treebeard/issues/186#issuecomment-502162650
class FileTree extends external_react_.PureComponent {
  constructor(_props) {
    super(_props);
    FileTree_defineProperty(this, "loadData", (permissions = null) => {
      const {
        loadData,
        defaultRootName
      } = this.props;
      loadData().then(data => {
        let loadedData = data;

        // treebeard has bugs when there is not a single root node
        if (Array.isArray(data)) {
          if (data.length < 1) {
            data = [{
              id: DEFAULT_ROOT_PREFIX + '|' + EMPTY_FILE_NAME,
              active: false,
              name: 'empty',
              permissions
            }];
          }
          loadedData = {
            name: defaultRootName,
            id: DEFAULT_ROOT_PREFIX,
            // Special id
            children: data,
            toggled: true,
            permissions
          };
        }
        if (!loadedData.id) {
          loadedData.id = loadedData.name;
        }
        this.setState(() => ({
          data: loadedData,
          loading: false
        }));
      }).catch(reason => {
        this.setState(() => ({
          error: reason,
          loading: false
        }));
      });
    });
    FileTree_defineProperty(this, "renderHeaderDecorator", props => {
      const {
        allowMultiSelect,
        useFileIconCls,
        emptyDirectoryText,
        showNodeIcon,
        headerDecorator
      } = this.props;
      const {
        node
      } = props;
      const {
        checked
      } = this.state;
      const isLoading = nodeIsLoading(node.id);
      const isEmpty = nodeIsEmpty(node.id);
      if (headerDecorator) {
        return headerDecorator(FileTree_objectSpread(FileTree_objectSpread(FileTree_objectSpread({}, this.props), props), {}, {
          checked,
          isLoading,
          isEmpty
        }));
      } else if (allowMultiSelect) {
        return /*#__PURE__*/external_react_default().createElement(Header, FileTree_extends({}, props, {
          isLoading: isLoading,
          isEmpty: isEmpty,
          useFileIconCls: useFileIconCls,
          emptyDirectoryText: emptyDirectoryText,
          allowMultiSelect: allowMultiSelect,
          showNodeIcon: showNodeIcon,
          checked: checked.contains(node.id),
          handleCheckbox: this.handleCheckbox,
          checkboxId: CHECK_ID_PREFIX + node.id
        }));
      } else {
        return /*#__PURE__*/external_react_default().createElement(Header, FileTree_extends({}, props, {
          isLoading: isLoading,
          isEmpty: isEmpty,
          useFileIconCls: useFileIconCls,
          emptyDirectoryText: emptyDirectoryText,
          allowMultiSelect: allowMultiSelect,
          showNodeIcon: showNodeIcon
        }));
      }
    });
    FileTree_defineProperty(this, "getNodeIdFromId", id => {
      const parts = id.split(CHECK_ID_PREFIX);
      if (parts.length === 2) {
        return parts[1];
      }
      return undefined;
    });
    FileTree_defineProperty(this, "getNodeFromId", (id, name) => {
      const path = id.split('|').slice(0, -1);
      path.push(name);
      let level = this.state.data;
      for (const step in path) {
        if (level.children) {
          level = level.children.find(children => children.name === path[step]);
        }
      }
      return level;
    });
    FileTree_defineProperty(this, "getDataNode", (id, node) => {
      if (node.id === id) {
        return node;
      }
      if (node.children) {
        // First get which child is the correct descendant path
        const childPath = node.children.filter(child => {
          return id.startsWith(child.id);
        });
        if (childPath && childPath.length > 0) {
          return this.getDataNode(id, childPath[0]);
        }
      }
      return undefined;
    });
    FileTree_defineProperty(this, "getPathFromId", (id, excludeLeaf = false) => {
      let path = id;

      // strip off default root id if exists
      if (path.startsWith(DEFAULT_ROOT_PREFIX)) {
        path = path.substring(DEFAULT_ROOT_PREFIX.length);
      }
      if (excludeLeaf) {
        const finalSlash = path.lastIndexOf('|');
        path = path.slice(0, finalSlash);
      }
      return path.replace(/\|/g, '/');
    });
    FileTree_defineProperty(this, "getNameFromId", id => {
      const parts = id.split('|');
      return parts[parts.length - 1];
    });
    // Callback to parent with actual path of selected file
    // Return value determines whether file selection should proceed, or be halted
    FileTree_defineProperty(this, "onFileSelect", (id, checked, isDirectory, node) => {
      const {
        onFileSelect
      } = this.props;
      if (!nodeIsEmpty(id)) {
        return onFileSelect(this.getNameFromId(id), this.getPathFromId(id), checked, isDirectory, node);
      }
      return false;
    });
    FileTree_defineProperty(this, "setCheckedValue", (node, checked) => {
      // Recurse through children if directory
      if (node.children) {
        node.children.forEach(child => {
          this.setCheckedValue(child, checked);
        });
      }

      // If node is not a loading or empty placeholder then add or remove checked value from state
      if (!nodeIsLoading(node.id) && !nodeIsEmpty(node.id)) {
        if (checked) {
          this.setState(state => ({
            checked: state.checked.push(node.id)
          }), () => this.onFileSelect(node.id, checked, !!node.children, node));
        } else {
          this.setState(state => ({
            checked: state.checked.filter(check => {
              return check !== node.id;
            })
          }), () => this.onFileSelect(node.id, checked, !!node.children, node));
        }
      }
    });
    // recursively toggle all child files. afterCascade used to check selection box of each subfile
    FileTree_defineProperty(this, "cascadeToggle", (node, afterCascade) => {
      // TODO move this to be defined as a function of the component so it isn't redefined for each recursive call
      const afterToggle = () => {
        afterCascade(node);
        if (node.children) {
          node.children.forEach(child => {
            this.cascadeToggle(child, afterCascade);
          });
        }
      };
      this.onToggle(node, true, true, afterToggle);
    });
    FileTree_defineProperty(this, "handleCheckbox", evt => {
      const {
        data
      } = this.state;
      const {
        checked
      } = evt.target;
      const id = this.getNodeIdFromId(evt.target.id);
      const node = this.getDataNode(id, data);
      if (node.children && checked) {
        // Toggle open selected directory and check the children
        const callback = checkNode => {
          this.setCheckedValue(checkNode, checked);
        };
        this.cascadeToggle(node, callback);
      }
      this.setCheckedValue(node, checked);
    });
    FileTree_defineProperty(this, "loadDirectory", (nodeId, callback) => {
      const {
        loadData
      } = this.props;
      this.setState(() => ({
        loading: true
      }));
      loadData(this.getPathFromId(nodeId)).then(children => {
        const {
          data
        } = this.state;
        const dataNode = this.getDataNode(nodeId, data);

        // In the ModuleEditor move-folder case, if a resource is being moved into a dir that has
        // not been clicked on and lazily-loaded, we bypass below state-management
        if (undefined === dataNode) {
          return;
        }
        children = children.map(child => {
          if (!child.id) {
            child.id = dataNode.id + '|' + child.name; // generate Id from path
          }
          return child;
        });
        if (children.length < 1) {
          children = [{
            id: dataNode.id + '|' + EMPTY_FILE_NAME,
            active: false,
            name: 'empty'
          }];
        }
        dataNode.children = children; // This is not immutable so this is updating the data object
        this.setState(() => ({
          cursor: dataNode,
          data: FileTree_objectSpread({}, data),
          error: undefined,
          loading: false
        }), callback);
      }).catch(reason => {
        this.setState(() => ({
          error: reason.message ? reason.message : 'Unable to fetch data',
          loading: false
        }));
      });
    });
    // This function is called from within the treebeard package. The node that is passed back is a pointer to a specific
    // node in this.state.data. This function is updating that node which is directly updating this.state.data, then
    // we make a clone of this.state.data for setState.  Directly manipulating anything in this.state is NOT a recommended React
    // pattern.  This is done in this case to work with the treebeard package, but should not be copied elsewhere.
    FileTree_defineProperty(this, "onToggle", (node, toggled, active = true, callback) => {
      const {
        allowMultiSelect
      } = this.props;
      const {
        cursor,
        data
      } = this.state;
      if (cursor) {
        cursor.active = false;
      }
      node.active = active;
      node.toggled = toggled;
      if (!allowMultiSelect) {
        if (!this.onFileSelect(node.id, true, !!node.children, node)) {
          return;
        }
      }

      // load data in directory if not already loaded
      if (node.children?.length === 0) {
        node.children = [{
          id: node.id + '|' + LOADING_FILE_NAME
        }];
        this.setState(() => ({
          cursor: node,
          data: FileTree_objectSpread({}, data)
        }), () => {
          this.loadDirectory(node.id, callback);
        });
      } else {
        this.setState(() => ({
          cursor: node,
          data: FileTree_objectSpread({}, data),
          error: undefined
        }), callback);
      }
    });
    FileTree_defineProperty(this, "reload", (selectedNode, successCallback, failureCallback) => {
      const {
        loadData
      } = this.props;
      const parentDir = this.getPathFromId(selectedNode.id, true);
      loadData(parentDir).then(children => {
        const {
          data
        } = this.state;
        const dataNode = this.getDataNode(parentDir.replace('/', '|'), data);
        children = children.map(child => {
          child.id = dataNode.id + '|' + child.name; // generate Id from path
          return child;
        });
        dataNode.children = children; // This is not immutable so this is updating the data object
      }).catch(reason => {
        failureCallback(reason);
      });
    });
    this.state = {
      cursor: undefined,
      checked: (0,external_immutable_.List)(),
      data: [],
      error: undefined,
      loading: false
    };
  }
  componentDidMount() {
    const {
      getRootPermissions
    } = this.props;
    this.setState(() => ({
      loading: true
    }));
    if (getRootPermissions) {
      getRootPermissions().then(data => {
        this.loadData(data);
      }).catch(reason => {
        this.setState(() => ({
          error: reason,
          loading: false
        }));
      });
    } else {
      this.loadData();
    }
  }
  render() {
    const {
      showLoading,
      showAnimations
    } = this.props;
    const {
      data,
      error
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "filetree-container"
    }, showLoading ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null) : error ? /*#__PURE__*/external_react_default().createElement(Alert, null, error) : /*#__PURE__*/external_react_default().createElement(external_react_treebeard_.Treebeard, {
      animations: showAnimations ? external_react_treebeard_.animations : false,
      data: data,
      onToggle: this.onToggle,
      decorators: FileTree_objectSpread(FileTree_objectSpread({}, external_react_treebeard_.decorators), {}, {
        Header: this.renderHeaderDecorator
      }),
      style: customStyle
    }));
  }
}
FileTree_defineProperty(FileTree, "defaultProps", {
  allowMultiSelect: true,
  useFileIconCls: false,
  emptyDirectoryText: 'No Files Found',
  defaultRootName: 'root',
  showLoading: false,
  showAnimations: true,
  headerDecorator: undefined
});
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/constants.ts





// list of section keys to skip for the section rendering
const SECTION_KEYS_TO_SKIP = ['user', 'biologicsWorkflow'];
const SAMPLE_MANAGER_PRODUCT_ICON = 'LK-SampleManager-Badge-COLOR.svg';
const SAMPLE_MANAGER_ALT_PRODUCT_ICON = 'LK-SampleManager-Badge-WHITE.svg';
const SAMPLE_MANAGER_DISABLED_PRODUCT_ICON = 'LK-SampleManager-Badge-GRAY.svg';
const BIOLOGICS_PRODUCT_ICON = 'lk-bio-logo-badge-color.svg';
const BIOLOGICS_ALT_PRODUCT_ICON = 'lk-bio-logo-badge.svg';
const BIOLOGICS_DISABLED_PRODUCT_ICON = 'lk-bio-logo-badge-gray.svg';

// mapping from product ids to the image/icon src paths
const PRODUCT_ID_IMG_SRC_MAP = {
  [SAMPLE_MANAGER_APP_PROPERTIES.productId.toLowerCase()]: {
    iconUrl: imageURL('sampleManagement/images', SAMPLE_MANAGER_PRODUCT_ICON),
    iconUrlAlt: imageURL('sampleManagement/images', SAMPLE_MANAGER_ALT_PRODUCT_ICON),
    iconUrlDisabled: imageURL('sampleManagement/images', SAMPLE_MANAGER_DISABLED_PRODUCT_ICON)
  },
  [BIOLOGICS_APP_PROPERTIES.productId.toLowerCase()]: {
    iconUrl: imageURL('biologics/images', BIOLOGICS_PRODUCT_ICON),
    iconUrlAlt: imageURL('biologics/images', BIOLOGICS_ALT_PRODUCT_ICON),
    iconUrlDisabled: imageURL('biologics/images', BIOLOGICS_DISABLED_PRODUCT_ICON)
  }
};
const LK_DOC_FOLDER_TABS = getHelpLink('tabs', HELP_LINK_REFERRER.PRODUCT_MENU);
const PRODUCT_SERVICES_URL = 'https://www.labkey.com/products-services/';
const ADMIN_LOOK_AND_FEEL_URL = api_.ActionURL.buildURL('admin', 'lookAndFeelSettings.view', '/');
const APPLICATION_NAVIGATION_METRIC = 'applicationNavigation';
const TO_LKS_HOME_METRIC = 'toHomeProject';
const TO_LKS_CONTAINER_METRIC = 'toServerContainer';
const TO_LKS_TAB_METRIC = 'toServerContainerTab';
const APPLICATION_SECTION_METRIC = 'toApplicationSection';
const BIOLOGICS_SECTION_METRIC = 'toBiologicsSection';
const SAMPLE_MANAGER_SECTION_METRIC = 'toSampleManagerSection';
const LOOK_AND_FEEL_METRIC = 'lookAndFeel';
const RELEASE_NOTES_METRIC = 'releaseNotes';
;// CONCATENATED MODULE: ./src/internal/components/notifications/ReleaseNote.tsx







const DISMISSED_STORAGE_PREFIX = '__release_notes_dismissed__';
const ReleaseNote = props => {
  const [searchParams] = (0,external_react_router_dom_.useSearchParams)();
  const {
    api
  } = useAppContext();
  const {
    versionString,
    moduleContext
  } = useServerContext();
  const {
    releaseNoteLink,
    name
  } = getPrimaryAppProperties(moduleContext);
  const releaseNoteDismissKey = DISMISSED_STORAGE_PREFIX + name + versionString;
  const [releaseNoteDismissed, setReleaseNoteDismissed] = (0,external_react_.useState)((searchParams.get('showReleaseNote') ?? '').toLowerCase() !== 'true' && localStorage.getItem(releaseNoteDismissKey)?.toLowerCase() === 'true');
  (0,external_react_.useEffect)(() => {
    localStorage.setItem(releaseNoteDismissKey, JSON.stringify(releaseNoteDismissed));
  }, [releaseNoteDismissed, releaseNoteDismissKey]);
  const onDismiss = (0,external_react_.useCallback)(() => {
    setReleaseNoteDismissed(true);
  }, []);
  const onLinkClick = (0,external_react_.useCallback)(() => {
    api.query.incrementClientSideMetricCount(RELEASE_NOTES_METRIC, "FromBanner");
  }, []);
  if (releaseNoteDismissed || !releaseNoteLink) return null;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "notification-container alert alert-success release-note-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "input-group-align release-note-new"
  }, "NEW"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "notification-item input-group-align"
  }, name, " ", versionString, " is here!\xA0", /*#__PURE__*/external_react_default().createElement("span", {
    onClick: onLinkClick
  }, /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: releaseNoteLink,
    useDefaultUrl: biologicsIsPrimaryApp() /* needed for FM in Biologics*/
  }, "See what's new.")), /*#__PURE__*/external_react_default().createElement("i", {
    style: {
      float: 'right'
    },
    className: "fa fa-times-circle pointer",
    onClick: onDismiss
  })));
};
;// CONCATENATED MODULE: ./src/internal/components/base/DisableableAnchor.tsx
const DisableableAnchor_excluded = ["disabled"];
function DisableableAnchor_extends() { return DisableableAnchor_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DisableableAnchor_extends.apply(null, arguments); }
function DisableableAnchor_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DisableableAnchor_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DisableableAnchor_ownKeys(Object(t), !0).forEach(function (r) { DisableableAnchor_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DisableableAnchor_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function DisableableAnchor_defineProperty(e, r, t) { return (r = DisableableAnchor_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DisableableAnchor_toPropertyKey(t) { var i = DisableableAnchor_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DisableableAnchor_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function DisableableAnchor_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = DisableableAnchor_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function DisableableAnchor_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }


/**
 * An <a> tag which supports the "disabled" attribute.
 * The "disabled" CSS class is also applied to allow for customization of disabled anchor styling.
 */
const DisableableAnchor = props => {
  const {
      disabled
    } = props,
    anchorProps = DisableableAnchor_objectWithoutProperties(props, DisableableAnchor_excluded);
  const {
    children,
    className
  } = anchorProps;
  const onClick = (0,external_react_.useCallback)(event => {
    if (!disabled) return;
    event.preventDefault();
  }, [disabled]);
  if (disabled) {
    return /*#__PURE__*/external_react_default().createElement("a", DisableableAnchor_extends({
      tabIndex: -1
    }, anchorProps, {
      className: external_classnames_default()(className, 'disabled'),
      onClick: onClick,
      style: DisableableAnchor_objectSpread({
        pointerEvents: 'none'
      }, anchorProps.style)
    }), children);
  }
  return /*#__PURE__*/external_react_default().createElement("a", anchorProps, children);
};
DisableableAnchor.displayName = 'DisableableAnchor';
;// CONCATENATED MODULE: ./src/internal/components/base/SVGIcon.tsx
function SVGIcon_extends() { return SVGIcon_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, SVGIcon_extends.apply(null, arguments); }
function SVGIcon_defineProperty(e, r, t) { return (r = SVGIcon_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SVGIcon_toPropertyKey(t) { var i = SVGIcon_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SVGIcon_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



let Theme = /*#__PURE__*/function (Theme) {
  Theme[Theme["DEFAULT"] = 0] = "DEFAULT";
  Theme[Theme["GRAY"] = 1] = "GRAY";
  Theme[Theme["LIGHT"] = 2] = "LIGHT";
  Theme[Theme["ORANGE"] = 3] = "ORANGE";
  return Theme;
}({});
function iconURL(iconDir, prefix, theme) {
  if (!prefix || !api_.Utils.isString(prefix)) {
    prefix = 'default';
  }
  if (!(theme in Theme)) {
    theme = Theme.DEFAULT;
  }
  const suffix = theme === Theme.DEFAULT ? '' : '_' + Theme[theme].toLowerCase();
  return imageURL(iconDir, [prefix, suffix, '.svg'].join('').toLowerCase());
}
function imgProps(props) {
  const imgProps = Object.assign({}, props);
  delete imgProps.activeTheme;
  delete imgProps.iconDir;
  delete imgProps.iconSrc;
  delete imgProps.isActive;
  delete imgProps.isInverted;
  delete imgProps.theme;
  return imgProps;
}
class SVGIcon extends external_react_.PureComponent {
  getTheme() {
    let {
      activeTheme,
      isActive,
      isInverted,
      theme
    } = this.props;
    if (isInverted) {
      const temp = activeTheme;
      activeTheme = theme;
      theme = temp;
    }
    return isActive ? activeTheme : theme;
  }
  render() {
    const {
      iconSrc,
      iconDir,
      alt
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("img", SVGIcon_extends({}, imgProps(this.props), {
      alt: alt ? alt : iconSrc + '-icon',
      src: iconURL(iconDir, iconSrc, this.getTheme())
    }));
  }
}
SVGIcon_defineProperty(SVGIcon, "defaultProps", {
  activeTheme: Theme.LIGHT,
  iconDir: '_images',
  iconSrc: 'default',
  theme: Theme.DEFAULT,
  height: '100%',
  width: '100%'
});
;// CONCATENATED MODULE: ./src/internal/components/base/CreatedModified.tsx
function CreatedModified_defineProperty(e, r, t) { return (r = CreatedModified_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function CreatedModified_toPropertyKey(t) { var i = CreatedModified_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function CreatedModified_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






class CreatedModified extends external_react_.Component {
  constructor(props) {
    super(props);
    CreatedModified_defineProperty(this, "formatTitle", config => {
      const title = [];
      if (config.display) {
        if (config.hasCreated) {
          title.push('Created: ' + config.createdTS);
          if (config.createdBy) {
            title.push('Created by: ' + config.createdBy);
          }
        }
        if (!config.useCreated && config.hasModified) {
          title.push('Modified: ' + config.modifiedTS);
          if (config.modifiedBy) {
            title.push('Modified by: ' + config.modifiedBy);
          }
        }
      }
      if (title.length > 0) {
        return title.join('\n');
      }
      return '';
    });
    CreatedModified_defineProperty(this, "processRow", () => {
      const {
        row
      } = this.props;
      if (row) {
        const createdBy = caseInsensitive(row, 'createdBy')?.displayValue;
        const createdTS = caseInsensitive(row, 'created')?.value;
        const modifiedBy = caseInsensitive(row, 'modifiedBy')?.displayValue;
        const modifiedTS = caseInsensitive(row, 'modified')?.value;
        const hasCreated = createdTS !== undefined;
        const hasModified = modifiedTS !== undefined;
        return {
          createdBy,
          createdTS: hasCreated ? createdTS : undefined,
          display: hasCreated || hasModified,
          hasCreated,
          hasModified,
          modifiedBy,
          modifiedTS: hasModified ? modifiedTS : undefined,
          useCreated: !hasModified || createdTS === modifiedTS
        };
      }
      return {
        createdBy: undefined,
        createdTS: undefined,
        display: false,
        hasCreated: false,
        hasModified: false,
        modifiedBy: undefined,
        modifiedTS: undefined,
        useCreated: false
      };
    });
    this.state = {
      loading: props.useServerDate,
      serverDate: undefined
    };
  }
  componentDidMount() {
    if (this.props.useServerDate) {
      api_.Query.getServerDate({
        success: serverDate => this.setState({
          serverDate,
          loading: false
        }),
        failure: error => this.setState({
          loading: false
        })
      });
    }
  }
  render() {
    const {
      className
    } = this.props;
    const {
      serverDate,
      loading
    } = this.state;
    if (loading) {
      return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
    }
    const config = this.processRow();
    if (config.display) {
      // also supports '/'
      const timestamp = config.useCreated ? config.createdTS : config.modifiedTS;
      const displayTxt = serverDate ? external_moment_default()(timestamp).from(serverDate) : external_moment_default()(timestamp).fromNow();
      return /*#__PURE__*/external_react_default().createElement("span", {
        title: this.formatTitle(config),
        className: external_classnames_default()('createdmodified', 'gray-text', className)
      }, config.useCreated ? 'Created' : 'Modified', " ", displayTxt);
    }
    return null;
  }
}
CreatedModified_defineProperty(CreatedModified, "defaultProps", {
  className: 'cbmb-inline',
  useServerDate: true
});
;// CONCATENATED MODULE: ./src/internal/components/buttons/PaginationButtons.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const PaginationButtons = (0,external_react_.memo)(props => {
  const {
    total,
    currentPage,
    perPage,
    previousPage,
    nextPage
  } = props;
  const pageStart = currentPage * perPage + 1;
  let pageEnd = (currentPage + 1) * perPage;
  const previousDisabled = currentPage === 0;
  if (pageEnd >= total) {
    pageEnd = total;
  }
  const isValid = !isNaN(pageStart) && !isNaN(pageEnd) && !isNaN(total) && pageStart <= pageEnd;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "pagination-buttons"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "pagination-buttons__info"
  }, isValid && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("span", {
    className: "pagination-info__start"
  }, pageStart), /*#__PURE__*/external_react_default().createElement("span", null, " - "), /*#__PURE__*/external_react_default().createElement("span", {
    className: "pagination-info__end"
  }, pageEnd), /*#__PURE__*/external_react_default().createElement("span", null, " of "), /*#__PURE__*/external_react_default().createElement("span", {
    className: "pagination-info__total"
  }, total))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "pagination-buttons__buttons btn-group"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "pagination-buttons__prev btn btn-default",
    onClick: previousPage,
    disabled: previousDisabled,
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-chevron-left"
  })), /*#__PURE__*/external_react_default().createElement("button", {
    className: "pagination-buttons__next btn btn-default",
    onClick: nextPage,
    disabled: pageEnd >= total,
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-chevron-right"
  }))));
});
PaginationButtons.displayName = 'PaginationButtons';
;// CONCATENATED MODULE: ./src/internal/components/buttons/ManageDropdownButton.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


const ManageDropdownButton = props => {
  const {
    children,
    disabled,
    showIcon = true
  } = props;
  const buttonLabel = (0,external_react_.useMemo)(() => /*#__PURE__*/external_react_default().createElement("span", null, showIcon && /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-bars margin-right"
  }), "Manage"), [showIcon]);
  return /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    title: buttonLabel,
    noCaret: true,
    pullRight: true,
    disabled: disabled
  }, children);
};
ManageDropdownButton.displayName = 'ManageDropdownButton';
;// CONCATENATED MODULE: ./src/internal/components/buttons/WizardNavButtons.tsx
/*
 * Copyright (c) 2017-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */


const WizardNavButtons = (0,external_react_.memo)(props => {
  const {
    cancel,
    cancelText = 'Cancel',
    canCancel = true,
    canFinish = true,
    canNextStep = true,
    canPreviousStep = true,
    children,
    finish = false,
    finishText = 'Finish',
    isFinished,
    isFinishedText = 'Finished',
    isFinishing,
    isFinishingText = 'Finishing...',
    nextStep,
    previousStep,
    singularNoun
  } = props;
  let submitButton;
  if (finish) {
    submitButton = /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-success",
      disabled: isFinishing || !canFinish,
      onClick: nextStep,
      type: "submit"
    }, isFinished ? isFinishedText : isFinishing ? isFinishingText : finishText, singularNoun ? ' ' + singularNoun : null);
  } else {
    submitButton = /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      type: "submit",
      onClick: nextStep,
      disabled: !canNextStep
    }, "Next");
  }
  return /*#__PURE__*/external_react_default().createElement(FormButtons, null, /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default",
    disabled: !canCancel,
    onClick: cancel,
    type: "button"
  }, cancelText), previousStep !== undefined && /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default",
    onClick: previousStep,
    disabled: !canPreviousStep,
    type: "button"
  }, "Back"), children, submitButton);
});
WizardNavButtons.displayName = 'WizardNavButtons';
// EXTERNAL MODULE: external "formsy-react"
var external_formsy_react_ = __webpack_require__(392);
var external_formsy_react_default = /*#__PURE__*/__webpack_require__.n(external_formsy_react_);
;// CONCATENATED MODULE: ./src/internal/components/forms/constants.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DETAIL_TABLE_CLASSES = 'table table-responsive table-condensed detail-component--table__fixed';
const INPUT_CONTAINER_CLASS_NAME = 'form-group row';
const INPUT_LABEL_CLASS_NAME = 'control-label col-sm-3 col-xs-12 text-left';
const INPUT_WRAPPER_CLASS_NAME = 'col-sm-9 col-xs-12';
const DELIMITER = ',';

// Interface for components that support the withFormsy() component wrapper.
;// CONCATENATED MODULE: ./src/internal/components/forms/input/FormsyReactComponents.tsx
const FormsyReactComponents_excluded = ["componentRef", "elementWrapperClassName", "help", "label", "labelClassName", "layout", "onChange", "rowClassName", "validateBeforeSubmit", "validateOnSubmit", "validatePristine"],
  FormsyReactComponents_excluded2 = ["getErrorMessage", "getErrorMessages", "getValue", "hasValue", "innerRef", "isFormDisabled", "isFormSubmitted", "isPristine", "isRequired", "isValid", "isValidValue", "resetValue", "setValidations", "setValue", "showError", "step", "showRequired", "validationError", "validationErrors", "validations", "value"],
  FormsyReactComponents_excluded3 = ["valueLabel"],
  FormsyReactComponents_excluded4 = ["addonAfter", "addonBefore", "buttonAfter", "buttonBefore"],
  _excluded5 = ["multiple", "options"];
function FormsyReactComponents_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FormsyReactComponents_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FormsyReactComponents_ownKeys(Object(t), !0).forEach(function (r) { FormsyReactComponents_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FormsyReactComponents_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FormsyReactComponents_defineProperty(e, r, t) { return (r = FormsyReactComponents_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FormsyReactComponents_toPropertyKey(t) { var i = FormsyReactComponents_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FormsyReactComponents_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function FormsyReactComponents_extends() { return FormsyReactComponents_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, FormsyReactComponents_extends.apply(null, arguments); }
function FormsyReactComponents_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = FormsyReactComponents_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function FormsyReactComponents_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
// The components declared in this file are intended to be functional equivalents for components
// in the "formsy-react-components" package. That package is no longer maintained as of this writing (11/23)
// and we needed to drop it as a dependency with our move to React 18.
// Credit: https://github.com/twisty/formsy-react-components




const componentDefaultProps = {
  layout: 'horizontal',
  validateBeforeSubmit: true,
  validateOnSubmit: false,
  validatePristine: false
};

/** Determine whether to show errors, or not. */
const shouldShowErrors = (isPristine, isFormSubmitted, isValid, validatePristine, validateBeforeSubmit) => {
  if (isPristine === true) {
    if (validatePristine === false) {
      return false;
    }
  }
  if (validateBeforeSubmit === false) {
    if (isFormSubmitted === false) {
      return false;
    }
  }
  return isValid === false;
};
const ErrorMessages = (0,external_react_.memo)(props => {
  const {
    messages
  } = props;
  if (!messages) return null;
  return /*#__PURE__*/external_react_default().createElement("div", null, messages.map((message, key) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  external_react_default().createElement("span", {
    className: "help-block validation-message",
    key: key
  }, message)));
});
const Help = ({
  children
}) => {
  if (!children) return null;
  return /*#__PURE__*/external_react_default().createElement("small", {
    className: "form-text text-muted"
  }, children);
};
const RequiredSymbol = (0,external_react_.memo)(({
  required,
  symbol = ' *'
}) => {
  if (required === false) return null;
  return /*#__PURE__*/external_react_default().createElement("span", {
    className: "required-symbol"
  }, symbol);
});
const FormsyReactComponents_Label = (0,external_react_.memo)(props => {
  const {
    children,
    fakeLabel,
    htmlFor,
    labelClassName,
    layout,
    required
  } = props;
  if (layout === 'elementOnly') return null;
  const labelClassNames = external_classnames_default()(['col-form-label', layout === 'horizontal' ? 'col-sm-3' : '', labelClassName]);
  if (fakeLabel) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: labelClassNames,
      "data-required": required
    }, children, /*#__PURE__*/external_react_default().createElement(RequiredSymbol, {
      required: required
    }));
  }
  return /*#__PURE__*/external_react_default().createElement("label", {
    className: labelClassNames,
    "data-required": required,
    htmlFor: htmlFor
  }, children, /*#__PURE__*/external_react_default().createElement(RequiredSymbol, {
    required: required
  }));
});
FormsyReactComponents_Label.defaultProps = {
  fakeLabel: false,
  required: false
};
const Control = (0,external_react_.memo)(props => {
  const {
    children,
    elementWrapperClassName,
    help,
    label,
    labelClassName,
    layout,
    messages,
    required,
    rowClassName,
    showErrors
  } = props;
  const control = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, children, /*#__PURE__*/external_react_default().createElement(Help, null, help), showErrors && /*#__PURE__*/external_react_default().createElement(ErrorMessages, {
    messages: messages
  }));
  if (layout === 'elementOnly') {
    return control;
  }
  const rowClassNames = [rowClassName ?? 'form-group'];
  if (rowClassName === undefined) {
    if (showErrors) {
      rowClassNames.push('has-error');
      rowClassNames.push('has-feedback');
    }
    if (layout === 'horizontal') {
      rowClassNames.push('row');
    }
  }

  // We should render the label if there is label text defined, or if the
  // component is required (so a required symbol is displayed in the label tag)
  const renderLabel = label !== null || required;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()(rowClassNames)
  }, renderLabel && /*#__PURE__*/external_react_default().createElement(FormsyReactComponents_Label, {
    htmlFor: props.htmlFor,
    labelClassName: labelClassName,
    layout: layout,
    required: required
  }, label), layout === 'horizontal' && /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()(elementWrapperClassName, {
      'offset-sm-3': !renderLabel
    })
  }, control), layout !== 'horizontal' && control);
});
Control.defaultProps = {
  elementWrapperClassName: INPUT_WRAPPER_CLASS_NAME,
  label: null,
  showErrors: true
};
Control.displayName = 'Row';
const InputGroup = props => {
  const {
    addonAfter,
    addonBefore,
    buttonAfter,
    buttonBefore,
    children
  } = props;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "input-group"
  }, !!addonBefore && /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group-addon"
  }, addonBefore), !!buttonBefore && /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group-addon"
  }, buttonBefore), children, !!addonAfter && /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group-addon"
  }, addonAfter), !!buttonAfter && /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group-addon"
  }, buttonAfter));
};
function useControlProps(props) {
  const {
      componentRef,
      elementWrapperClassName,
      help,
      label,
      labelClassName,
      layout,
      onChange,
      rowClassName,
      validateBeforeSubmit,
      validateOnSubmit,
      validatePristine
    } = props,
    formsyAndHTMLProps = FormsyReactComponents_objectWithoutProperties(props, FormsyReactComponents_excluded);
  const {
      getErrorMessage,
      getErrorMessages,
      getValue,
      hasValue,
      innerRef,
      isFormDisabled,
      isFormSubmitted,
      isPristine,
      isRequired,
      isValid,
      isValidValue,
      resetValue,
      setValidations,
      setValue,
      showError,
      step,
      showRequired,
      validationError,
      validationErrors,
      validations,
      value
    } = formsyAndHTMLProps,
    htmlProps = FormsyReactComponents_objectWithoutProperties(formsyAndHTMLProps, FormsyReactComponents_excluded2);
  const messages = getErrorMessages();
  const required = htmlProps.required;
  return {
    baseProps: {
      componentRef,
      elementWrapperClassName,
      help,
      label,
      labelClassName,
      layout,
      markAsInvalid: showError() && (required || messages?.length > 0),
      messages,
      onChange,
      required,
      rowClassName,
      showErrors: shouldShowErrors(isPristine(), isFormSubmitted(), isValid(), validatePristine, validateBeforeSubmit),
      validateBeforeSubmit,
      validateOnSubmit,
      validatePristine
    },
    formsyProps: {
      getErrorMessage,
      getErrorMessages,
      getValue,
      hasValue,
      innerRef,
      isFormDisabled,
      isFormSubmitted,
      isPristine,
      isRequired,
      isValid,
      isValidValue,
      resetValue,
      setValidations,
      setValue,
      showError,
      showRequired,
      validationError,
      validationErrors,
      validations
    },
    htmlProps
  };
}
InputGroup.displayName = 'InputGroup';
const CheckboxImpl = props => {
  const {
      valueLabel
    } = props,
    rest = FormsyReactComponents_objectWithoutProperties(props, FormsyReactComponents_excluded3);
  const {
    baseProps,
    formsyProps,
    htmlProps
  } = useControlProps(rest);
  const {
    componentRef,
    onChange
  } = baseProps;
  const {
    getValue,
    isFormDisabled,
    setValue
  } = formsyProps;
  const {
    disabled,
    id,
    required
  } = htmlProps;
  const handleChange = (0,external_react_.useCallback)(event => {
    setValue(event.currentTarget.checked);
    onChange?.(event.currentTarget.name, event.currentTarget.checked);
  }, [onChange, setValue]);
  return /*#__PURE__*/external_react_default().createElement(Control, FormsyReactComponents_extends({}, baseProps, {
    fakeLabel: true,
    htmlFor: id,
    required: required
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "custom-control custom-checkbox"
  }, /*#__PURE__*/external_react_default().createElement("input", FormsyReactComponents_extends({}, htmlProps, {
    checked: getValue() === true,
    className: "custom-control-input",
    disabled: isFormDisabled() || disabled || false,
    id: id,
    onChange: handleChange,
    ref: componentRef,
    type: "checkbox"
  })), /*#__PURE__*/external_react_default().createElement("label", {
    className: "custom-control-label",
    htmlFor: id
  }, valueLabel)));
};
CheckboxImpl.defaultProps = FormsyReactComponents_objectSpread(FormsyReactComponents_objectSpread({}, componentDefaultProps), {}, {
  value: false,
  valueLabel: ''
});
const CheckboxWithFormsy = (0,external_formsy_react_.withFormsy)(CheckboxImpl);
const FormsyCheckbox = props => /*#__PURE__*/external_react_default().createElement(CheckboxWithFormsy, props);
FormsyCheckbox.displayName = 'FormsyCheckbox';
const InputImpl = props => {
  // Extract InputGroupProps
  const {
      addonAfter,
      addonBefore,
      buttonAfter,
      buttonBefore
    } = props,
    rest = FormsyReactComponents_objectWithoutProperties(props, FormsyReactComponents_excluded4);
  const {
    baseProps,
    formsyProps,
    htmlProps
  } = useControlProps(rest);
  const {
    componentRef,
    markAsInvalid,
    onChange
  } = baseProps;
  const {
    getValue,
    isFormDisabled,
    setValue
  } = formsyProps;
  const {
    className,
    disabled,
    id,
    required,
    type
  } = htmlProps;
  const className_ = (0,external_react_.useMemo)(() => external_classnames_default()({
    'custom-range': type === 'range',
    'form-control': type !== 'hidden' && type !== 'range',
    'is-invalid': markAsInvalid
  }, className), [className, markAsInvalid, type]);
  const handleBlur = (0,external_react_.useCallback)(event => {
    setValue(event.currentTarget.value);
  }, [setValue]);
  const handleChange = (0,external_react_.useCallback)(event => {
    setValue(event.currentTarget.value);
    onChange?.(event.currentTarget.name, event.currentTarget.value);
  }, [onChange, setValue]);
  const input = /*#__PURE__*/external_react_default().createElement("input", FormsyReactComponents_extends({}, htmlProps, {
    className: className_,
    disabled: isFormDisabled() || disabled || false,
    onBlur: handleBlur,
    onChange: handleChange,
    ref: componentRef,
    value: getValue() ?? ''
  }));
  if (type === 'hidden') {
    return input;
  }
  let control;
  if (addonAfter || addonBefore || buttonAfter || buttonBefore) {
    control = /*#__PURE__*/external_react_default().createElement(InputGroup, {
      addonAfter: addonAfter,
      addonBefore: addonBefore,
      buttonAfter: buttonAfter,
      buttonBefore: buttonBefore
    }, input);
  } else {
    control = input;
  }
  return /*#__PURE__*/external_react_default().createElement(Control, FormsyReactComponents_extends({}, baseProps, {
    htmlFor: id,
    required: required
  }), control);
};
InputImpl.defaultProps = FormsyReactComponents_objectSpread(FormsyReactComponents_objectSpread({}, componentDefaultProps), {}, {
  type: 'text'
});
const InputWithFormsy = (0,external_formsy_react_.withFormsy)(InputImpl);
const FormsyInput = props => /*#__PURE__*/external_react_default().createElement(InputWithFormsy, props);
FormsyInput.displayName = 'FormsyInput';
const SelectImpl = props => {
  const {
      multiple,
      options
    } = props,
    rest = FormsyReactComponents_objectWithoutProperties(props, _excluded5);
  const {
    baseProps,
    formsyProps,
    htmlProps
  } = useControlProps(rest);
  const {
    componentRef,
    markAsInvalid,
    onChange
  } = baseProps;
  const {
    isFormDisabled,
    setValue
  } = formsyProps;
  const {
    className,
    disabled,
    id,
    required
  } = htmlProps;
  const handleChange = (0,external_react_.useCallback)(event => {
    let value;
    if (multiple) {
      value = Array.from(event.currentTarget.options).filter(o => o.selected).map(o => o.value);
    } else {
      ({
        value
      } = event.currentTarget);
    }
    setValue(value);
    onChange?.(event.currentTarget.name, value);
  }, [multiple, onChange, setValue]);
  return /*#__PURE__*/external_react_default().createElement(Control, FormsyReactComponents_extends({}, baseProps, {
    htmlFor: id,
    required: required
  }), /*#__PURE__*/external_react_default().createElement("select", FormsyReactComponents_extends({}, htmlProps, {
    className: external_classnames_default()('form-control', {
      'is-invalid': markAsInvalid
    }, className),
    disabled: isFormDisabled() || disabled || false,
    id: id,
    onChange: handleChange,
    ref: componentRef
  }), options.map((option, i) => /*#__PURE__*/external_react_default().createElement("option", {
    key: i,
    value: option.value
  }, option.label))));
};
SelectImpl.defaultProps = FormsyReactComponents_objectSpread(FormsyReactComponents_objectSpread({}, componentDefaultProps), {}, {
  multiple: false
});
const SelectWithFormsy = (0,external_formsy_react_.withFormsy)(SelectImpl);
const FormsySelect = props => /*#__PURE__*/external_react_default().createElement(SelectWithFormsy, props);
FormsySelect.displayName = 'FormsySelect';
const TextAreaImpl = props => {
  const {
    baseProps,
    formsyProps,
    htmlProps
  } = useControlProps(props);
  const {
    componentRef,
    markAsInvalid,
    onChange
  } = baseProps;
  const {
    getValue,
    isFormDisabled,
    setValue
  } = formsyProps;
  const {
    className,
    disabled,
    id,
    required
  } = htmlProps;
  const handleBlur = (0,external_react_.useCallback)(event => {
    setValue(event.currentTarget.value);
  }, [setValue]);
  const handleChange = (0,external_react_.useCallback)(event => {
    setValue(event.currentTarget.value);
    onChange?.(event.currentTarget.name, event.currentTarget.value);
  }, [onChange, setValue]);
  return /*#__PURE__*/external_react_default().createElement(Control, FormsyReactComponents_extends({}, baseProps, {
    htmlFor: id,
    required: required
  }), /*#__PURE__*/external_react_default().createElement("textarea", FormsyReactComponents_extends({}, htmlProps, {
    className: external_classnames_default()('form-control', {
      'is-invalid': markAsInvalid
    }, className),
    disabled: isFormDisabled() || disabled || false,
    id: id,
    onBlur: handleBlur,
    onChange: handleChange,
    ref: componentRef,
    required: required,
    value: getValue()
  })));
};
TextAreaImpl.defaultProps = FormsyReactComponents_objectSpread(FormsyReactComponents_objectSpread({}, componentDefaultProps), {}, {
  cols: 0,
  rows: 3,
  value: ''
});
const TextAreaWithFormsy = (0,external_formsy_react_.withFormsy)(TextAreaImpl);
const FormsyTextArea = props => /*#__PURE__*/external_react_default().createElement(TextAreaWithFormsy, props);
FormsyTextArea.displayName = 'FormsyTextArea';
;// CONCATENATED MODULE: ./src/internal/components/buttons/ToggleButtons.tsx




const ToggleButtons = (0,external_react_.memo)(props => {
  const {
    disabled = false,
    first = 'Enabled',
    second = 'Disabled',
    onClick,
    active,
    className = 'control-toggle-btn-group',
    bsStyleFirstActive = 'primary',
    bsStyleFirstInactive = 'default',
    bsStyleSecondActive = 'primary',
    bsStyleSecondInactive = 'default',
    inputFieldName,
    id
  } = props;
  const firstActive = active === first;
  const firstCls = 'btn btn-' + (firstActive ? bsStyleFirstActive : bsStyleFirstInactive);
  const secondActive = active === second;
  const secondCls = 'btn btn-' + (secondActive ? bsStyleSecondActive : bsStyleSecondInactive);
  const firstBtnClick = (0,external_react_.useCallback)(() => {
    if (secondActive) onClick(first);
  }, [first, secondActive, onClick]);
  const secondBtnClick = (0,external_react_.useCallback)(() => {
    if (firstActive) onClick(second);
  }, [second, firstActive, onClick]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, inputFieldName && /*#__PURE__*/external_react_default().createElement(FormsyInput, {
    name: inputFieldName,
    type: "hidden",
    value: active === first ? 'true' : 'false'
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('toggle', 'btn-group', {
      'toggle-on': firstActive,
      'toggle-off': secondActive,
      [className]: !!className
    }),
    id: id
  }, /*#__PURE__*/external_react_default().createElement("button", {
    type: "button",
    className: firstCls,
    onClick: firstBtnClick,
    disabled: disabled
  }, first), /*#__PURE__*/external_react_default().createElement("button", {
    type: "button",
    className: secondCls,
    onClick: secondBtnClick,
    disabled: disabled
  }, second)));
});
const ToggleIcon = (0,external_react_.memo)(props => {
  const {
    first = 'on',
    second = 'off',
    onClick,
    active = 'off',
    className,
    inputFieldName,
    id,
    disabled = false,
    toolTip
  } = props;
  const firstActive = active === first;
  const secondActive = active === second;
  const firstBtnClick = (0,external_react_.useCallback)(() => {
    if (secondActive && !disabled) onClick(first);
  }, [first, secondActive, onClick, disabled]);
  const secondBtnClick = (0,external_react_.useCallback)(() => {
    if (firstActive && !disabled) onClick(second);
  }, [second, firstActive, onClick, disabled]);
  const body = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, firstActive && /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-toggle-on",
    onClick: secondBtnClick
  }), secondActive && /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-toggle-off",
    onClick: firstBtnClick
  }));
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, inputFieldName && /*#__PURE__*/external_react_default().createElement(FormsyInput, {
    name: inputFieldName,
    type: "hidden",
    value: active === first ? 'true' : 'false'
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('toggle', 'toggle-group-icon', 'btn-group', {
      'toggle-on': firstActive,
      'toggle-off': secondActive,
      disabled,
      [className]: !!className
    }),
    id: id
  }, toolTip && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    iconComponent: body
  }, toolTip), !toolTip && body));
});
;// CONCATENATED MODULE: ./src/internal/components/buttons/DisableableButton.tsx




const DisableableButton = (0,external_react_.memo)(props => {
  const {
    bsStyle = 'default',
    children,
    className = '',
    disabledMsg,
    onClick,
    title
  } = props;
  const {
    onMouseEnter,
    onMouseLeave,
    portalEl,
    show,
    targetRef
  } = useOverlayTriggerState('disabled-button-overlay', disabledMsg !== undefined, false);
  const popover = (0,external_react_.useMemo)(() => /*#__PURE__*/external_react_default().createElement(Popover, {
    id: "disabled-button-popover",
    title: title,
    placement: "bottom",
    targetRef: targetRef
  }, disabledMsg), [disabledMsg, targetRef, title]);

  // Note: we use onPointerEnter/Leave so events propagate when the button is disabled
  return /*#__PURE__*/external_react_default().createElement("button", {
    className: `${className} btn btn-${bsStyle}`,
    disabled: disabledMsg !== undefined,
    onClick: onClick,
    onPointerEnter: onMouseEnter,
    onPointerLeave: onMouseLeave,
    type: "button",
    ref: targetRef
  }, children, show && (0,external_react_dom_.createPortal)(popover, portalEl));
});
DisableableButton.displayName = 'DisableableButton';
;// CONCATENATED MODULE: ./src/internal/components/buttons/ResponsiveMenuButton.tsx


const ResponsiveMenuButton = (0,external_react_.memo)(({
  asSubMenu,
  className,
  items,
  text
}) => {
  if (asSubMenu) {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(MenuHeader, {
      text: text
    }), items);
  }
  return /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    className: className + ' responsive-menu',
    title: text
  }, items);
});
;// CONCATENATED MODULE: ./src/internal/components/buttons/ResponsiveMenuButtonGroup.tsx



// The known size of the More dropdown. Ideally we'd calculate this, but we need to know it before we inject it, so
// this was calculated by inspecting the DOM in FireFox.
const MORE_SIZE = 68;
const ResponsiveMenuButtonGroup = (0,external_react_.memo)(props => {
  const {
    items,
    user
  } = props;
  const filteredItems = (0,external_react_.useMemo)(() => items.filter(item => hasPermissions(user, [item.perm], false)), [items, user]);
  const [renderedItems, setRenderedItems] = (0,external_react_.useState)(filteredItems.map(item => item.button));
  const [collapsedItems, setCollapsedItems] = (0,external_react_.useState)([]);
  const [itemWidths, setItemWidths] = (0,external_react_.useState)([]);
  const elRef = (0,external_react_.useRef)(undefined);
  const computeButtonLayout = (0,external_react_.useCallback)(() => {
    if (itemWidths.length === 0 || elRef.current === undefined) {
      // If we haven't determined itemWidths then we cannot properly determine how to render the buttons
      return;
    }
    const parent = elRef.current.parentNode; // Should be responsive-btn-group, contains all the grid buttons
    let availableSpace;
    const parentClass = parent.getAttribute('class');

    // Unsupported scenario, so we just render everything.
    if (parentClass === null) return;
    if (parentClass.includes('responsive-btn-group')) {
      // This means we're in a GridPanel
      const grandParent = parent.parentNode; // Should be button-bar__section, contains buttons + filter/search
      const staticButtons = Array.from(parent.childNodes).reduce((reduction, node) => {
        if (!node.getAttribute('class')?.includes('responsive-menu-button-group')) {
          reduction += node.getBoundingClientRect().width;
        }
        return reduction;
      }, 0);
      const filterAndSearch = grandParent.querySelector('.button-bar__filter-search').getBoundingClientRect().width;
      // 24 = 12px margin on filterAndSearch wrapper, 12px margin on search box.
      const siblingSize = staticButtons + filterAndSearch + 24;
      availableSpace = grandParent.getBoundingClientRect().width - siblingSize;
    } else {
      // We're just going to assume we can look at our parent for all the information we need. This scenario is
      // needed by FM ItemDetailHeader/ItemSamplesActionMenu
      const siblingSize = Array.from(parent.childNodes).reduce((reduction, node) => {
        if (!node.getAttribute('class')?.includes('responsive-menu-button-group')) {
          const computedStyle = getComputedStyle(node);
          // We often put margin on items that we render next to ResponsiveMenuButtonGroup, so we count it
          const margin = parseInt(computedStyle.marginLeft, 10) + parseInt(computedStyle.marginRight, 10);
          reduction += node.getBoundingClientRect().width + margin;
        }
        return reduction;
      }, 0);
      availableSpace = parent.getBoundingClientRect().width - siblingSize;
    }
    const allButtonsSize = itemWidths.reduce((sum, size) => sum + size, 0);
    if (allButtonsSize > availableSpace) {
      const collapsed = [];
      const rendered = [];
      // calculate visible buttons
      let currentSize = MORE_SIZE;
      // We track if we can render more buttons via this flag and not strictly based on remaining size, in order
      // to retain the render order. Otherwise, you may see a button layout like:
      // [Derive, Assay, Picklists, Jobs, More] on a larger screen
      // [Derive, Assay, Jobs, More] on a smaller screen
      let canRenderMore = true;
      filteredItems.forEach((item, idx) => {
        const itemWidth = itemWidths[idx];

        // The button is likely being hidden due to permissions or something similar.
        if (itemWidth === undefined) return;
        if (currentSize + itemWidth > availableSpace) {
          canRenderMore = false;
        }
        if (canRenderMore) {
          rendered.push(item.button);
          currentSize = currentSize + itemWidth;
        } else {
          collapsed.push(item.button);
        }
      });
      setCollapsedItems(collapsed);
      setRenderedItems(rendered);
    } else {
      // All buttons visible
      setRenderedItems(filteredItems.map(item => item.button));
      setCollapsedItems([]);
    }
  }, [itemWidths, filteredItems]);
  (0,external_react_.useEffect)(() => {
    // Need to call computeButtonLayout here to compute the layout after first render
    computeButtonLayout();
    window.addEventListener('resize', computeButtonLayout);
    return () => window.removeEventListener('resize', computeButtonLayout);
  }, [computeButtonLayout]);

  // After the first render we need to calculate the width of each item passed to this component
  (0,external_react_.useEffect)(() => {
    // Don't attempt to compute widths when we're in tests, or we'll fall over
    if (navigator.userAgent.includes('jsdom')) return;
    const itemEls = elRef.current?.childNodes ?? [];
    // childNodes is a nodeList which does not have the map method
    const widths = Array.from(itemEls).map(element => {
      // Include margin for buttons in size
      const computedStyle = getComputedStyle(element);
      return element.getBoundingClientRect().width + parseInt(computedStyle.marginLeft, 10) + parseInt(computedStyle.marginRight, 10);
    });
    setItemWidths(widths);
  }, []);
  const buttons = filteredItems.map(item => item.button);
  if (buttons.length === 0) return null;
  return /*#__PURE__*/external_react_default().createElement("span", {
    className: "responsive-menu-button-group",
    ref: elRef
  }, renderedItems.length > 0 && renderedItems.map((button, idx) =>
  /*#__PURE__*/
  // Issue 47167
  // We wrap buttons in Fragment because otherwise we'll get an error warning about unique keys if
  // each button passed in wasn't given a key, and there's no way to warn consumers that they need to
  // put a key on the buttons they pass.
  external_react_default().createElement(external_react_.Fragment, {
    key: idx
  }, button)), collapsedItems.length > 0 && /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    className: "responsive-menu-button-group responsive-menu",
    title: "More"
  }, collapsedItems.map((item, index) => {
    return /*#__PURE__*/external_react_default().createElement(external_react_.Fragment, {
      key: index
    }, external_react_default().cloneElement(item, {
      asSubMenu: true
    }), index < collapsedItems.length - 1 && /*#__PURE__*/external_react_default().createElement(MenuDivider, null));
  })));
});
ResponsiveMenuButtonGroup.displayName = 'ResponsiveMenuButtonGroup';
;// CONCATENATED MODULE: ./src/internal/components/base/Cards.tsx
function Cards_extends() { return Cards_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, Cards_extends.apply(null, arguments); }
/*
 * Copyright (c) 2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */


const Card = props => {
  const {
    caption,
    disabled,
    href,
    iconUrl,
    iconSrc,
    index,
    onClick,
    title
  } = props;
  const onClickHandler = (0,external_react_.useCallback)(() => {
    onClick?.(index);
  }, [index, onClick]);
  return /*#__PURE__*/external_react_default().createElement("a", {
    className: "cards__card",
    href: href,
    onClick: onClickHandler
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: 'cards__block-center' + (disabled ? ' cards__block-disabled' : '')
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "cards__block-center-content"
  }, iconUrl && /*#__PURE__*/external_react_default().createElement("img", {
    src: iconUrl
  }), iconSrc && /*#__PURE__*/external_react_default().createElement(SVGIcon, {
    iconSrc: iconSrc
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "cards__card-content"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "cards__card-title"
  }, title), caption ? caption : ''));
};
const Cards = props => /*#__PURE__*/external_react_default().createElement("div", {
  className: "cards"
}, /*#__PURE__*/external_react_default().createElement("div", {
  className: "row"
}, props.cards.map((cardProps, i) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "col-xs-6 col-md-4 col-lg-3",
  key: cardProps.title
}, /*#__PURE__*/external_react_default().createElement(Card, Cards_extends({}, cardProps, {
  index: i
}))))));
;// CONCATENATED MODULE: ./src/internal/components/base/Setting.tsx
function Setting_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Setting_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Setting_ownKeys(Object(t), !0).forEach(function (r) { Setting_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Setting_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Setting_defineProperty(e, r, t) { return (r = Setting_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Setting_toPropertyKey(t) { var i = Setting_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Setting_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






const useSetting = (getUrl, setUrl, name, enabledValue, disabledValue) => {
  const [state, setState] = (0,external_react_.useState)({
    error: undefined,
    loading: true,
    saving: false,
    enabled: false
  });
  (0,external_react_.useEffect)(() => {
    api_.Ajax.request({
      url: getUrl,
      success: api_.Utils.getCallbackWrapper(response => {
        const value = response.data?.[name] ?? response[name];
        setState(currentState => Setting_objectSpread(Setting_objectSpread({}, currentState), {}, {
          enabled: value !== disabledValue,
          loading: false
        }));
      }),
      failure: api_.Utils.getCallbackWrapper(err => {
        console.error(err);
        setState(currentState => Setting_objectSpread(Setting_objectSpread({}, currentState), {}, {
          error: resolveErrorMessage(err) ?? 'Error loading setting',
          loading: false
        }));
      })
    });
  }, []);
  const save = (0,external_react_.useCallback)(() => {
    setState(currentState => Setting_objectSpread(Setting_objectSpread({}, currentState), {}, {
      saving: true
    }));
    const updatedValue = !state.enabled ? enabledValue : disabledValue;
    api_.Ajax.request({
      url: setUrl,
      jsonData: {
        [name]: updatedValue
      },
      method: 'POST',
      success: api_.Utils.getCallbackWrapper(() => {
        setState(currentState => Setting_objectSpread(Setting_objectSpread({}, currentState), {}, {
          enabled: updatedValue === enabledValue,
          saving: false
        }));
      }),
      failure: api_.Utils.getCallbackWrapper(err => {
        console.error(err);
        setState(currentState => Setting_objectSpread(Setting_objectSpread({}, currentState), {}, {
          error: resolveErrorMessage(err) ?? 'Error saving setting',
          saving: false
        }));
      })
    });
  }, [state.enabled]);
  return Setting_objectSpread(Setting_objectSpread({}, state), {}, {
    save
  });
};
const Setting = (0,external_react_.memo)(props => {
  const {
    getUrl,
    heading,
    label,
    name,
    setUrl,
    enabledValue = true,
    disabledValue = false
  } = props;
  const {
    error,
    loading,
    saving,
    save,
    enabled
  } = useSetting(getUrl, setUrl, name, enabledValue, disabledValue);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "setting-checkbox"
  }, heading !== undefined && /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__bold-text margin-bottom"
  }, heading), loading && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), error !== undefined && /*#__PURE__*/external_react_default().createElement(Alert, null, error), !loading && /*#__PURE__*/external_react_default().createElement("form", null, /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
    checked: enabled,
    name: name,
    onChange: save,
    disabled: saving
  }, label)));
});
;// CONCATENATED MODULE: ./src/internal/components/base/ValueList.tsx

const ValueList = ({
  values,
  maxCount = 5,
  vertical = false
}) => {
  if (vertical) {
    return /*#__PURE__*/external_react_default().createElement("ul", null, values.map((value, ind) => {
      if (ind > maxCount) return null;
      if (ind === maxCount) return '...';
      return /*#__PURE__*/external_react_default().createElement("li", {
        key: ind
      }, value);
    }));
  }
  let valueDisplay;
  if (values.length <= maxCount) valueDisplay = values.join(", ");else valueDisplay = values.slice(0, maxCount).join(", ") + ` and ${values.length - maxCount} more`;
  return /*#__PURE__*/external_react_default().createElement("ul", null, /*#__PURE__*/external_react_default().createElement("li", null, valueDisplay));
};
;// CONCATENATED MODULE: ./src/internal/components/base/ChoicesListItem.tsx


const ChoicesListItem = (0,external_react_.memo)(props => {
  const {
    label,
    group,
    index,
    active,
    onSelect,
    subLabel,
    componentRight,
    disabled
  } = props;
  const onClick = (0,external_react_.useCallback)(() => {
    onSelect(index, group);
  }, [onSelect, index, group]);
  return /*#__PURE__*/external_react_default().createElement("button", {
    className: external_classnames_default()('list-group-item', {
      active
    }),
    onClick: onClick,
    type: "button",
    disabled: disabled
  }, label, subLabel && /*#__PURE__*/external_react_default().createElement("span", {
    className: "choices-list__sub-label"
  }, subLabel), componentRight);
});
ChoicesListItem.displayName = 'ChoicesListItem';
;// CONCATENATED MODULE: ./src/internal/components/base/ColorIcon.tsx

class ColorIcon extends external_react_.PureComponent {
  render() {
    const {
      cls,
      value,
      asSquare,
      label,
      useSmall
    } = this.props;
    let iconCls = cls;
    if (!iconCls) {
      iconCls = asSquare ? 'color-picker__chip' : 'color-icon__circle';
      if (useSmall) iconCls += '-small';
    }
    let icon;
    if (value) {
      icon = /*#__PURE__*/external_react_default().createElement("i", {
        className: iconCls,
        style: {
          backgroundColor: value
        }
      });
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, icon, label && /*#__PURE__*/external_react_default().createElement("span", {
      className: value ? 'spacer-left' : undefined
    }, label));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/entities/DataTypeSelector.tsx






const filterDataTypeHiddenEntity = (dataType, hiddenEntities) => {
  return !hiddenEntities || hiddenEntities?.indexOf(dataType.rowId ?? dataType.lsid) === -1;
};
const getUncheckedEntityWarning = (uncheckedEntities, uncheckedEntitiesDB, dataCounts, entityDataType, rowId) => {
  if (uncheckedEntitiesDB?.indexOf(rowId) > -1) return null;
  if (uncheckedEntities?.indexOf(rowId) > -1) {
    if (!dataCounts) return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
    if (!dataCounts[rowId + '']) return null;
    const dataCount = dataCounts[rowId + ''];
    const nounPlural = entityDataType?.nounPlural?.toLowerCase() ?? 'samples';
    const nounSingular = entityDataType?.nounSingular?.toLowerCase() ?? 'sample';
    return /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "warning",
      className: "margin-left-more"
    }, dataCount, " ", dataCount > 1 ? nounPlural : nounSingular, " will no longer be visible in this project. They won't be deleted and lineage relationships won't change.", ' ');
  }
  return null;
};
const DataTypeSelector = (0,external_react_.memo)(props => {
  const {
    api,
    toggleSelectAll,
    disabled,
    entityDataType,
    allDataTypes,
    dataTypeLabel,
    hiddenEntities,
    uncheckedEntitiesDB,
    allDataCounts,
    updateUncheckedTypes,
    columns,
    noHeader,
    isNewFolder,
    project,
    showUncheckedWarning = true,
    dataTypePrefix = ''
  } = props;
  const [dataTypes, setDataTypes] = (0,external_react_.useState)();
  const [dataType, setDataType] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  const [loading, setLoading] = (0,external_react_.useState)(false);
  const [dataCounts, setDataCounts] = (0,external_react_.useState)();
  const [uncheckedEntities, setUncheckedEntities] = (0,external_react_.useState)();
  const loadDataTypes = (0,external_react_.useCallback)(async () => {
    try {
      setLoading(true);
      setError(undefined);
      const results = await api.query.getProjectConfigurableEntityTypeOptions(entityDataType, project?.path);

      // the Dashboard related data type exclusions should hide entities from the parent/related exclusion
      const results_ = results?.filter(type => filterDataTypeHiddenEntity(type, hiddenEntities));
      setDataTypes(results_);
    } catch (e) {
      console.error(e);
      setError(resolveErrorMessage(e));
    } finally {
      setLoading(false);
    }
  }, [api.query, entityDataType, hiddenEntities, project?.path]);
  (0,external_react_.useEffect)(() => {
    if (dataTypes !== undefined && allDataTypes) {
      setDataTypes(allDataTypes.filter(type => filterDataTypeHiddenEntity(type, hiddenEntities)));
    }
  }, [hiddenEntities /* only called on changes to hiddenEntities */]);
  (0,external_react_.useEffect)(() => {
    if (allDataCounts) setDataCounts(allDataCounts);
    if (allDataTypes) setDataTypes(allDataTypes.filter(type => filterDataTypeHiddenEntity(type, hiddenEntities)));else if (entityDataType) loadDataTypes(); // use entitydatatype

    setDataType(dataTypePrefix + entityDataType?.projectConfigurableDataType);
    setUncheckedEntities(uncheckedEntitiesDB ?? []);
  }, [
    /* mount only */
  ]);
  const ensureCount = (0,external_react_.useCallback)(async () => {
    if (dataCounts) return;
    const results = await api.query.getProjectDataTypeDataCount(dataType, project?.path, dataTypes, isNewFolder);
    setDataCounts(results);
  }, [api.query, dataCounts, dataType, dataTypes, isNewFolder, project?.path]);
  const onChange = (0,external_react_.useCallback)((entityId, toggle, check) => {
    if (disabled) return;
    ensureCount();
    const updated = [...uncheckedEntities];
    let checked = check;
    if (toggle) {
      checked = uncheckedEntities?.indexOf(entityId) > -1;
    }
    if (checked) {
      const ind = updated.indexOf(entityId);
      updated.splice(ind, 1);
    } else {
      updated.push(entityId);
    }
    updateUncheckedTypes(dataType, updated);
    setUncheckedEntities(updated);
  }, [disabled, ensureCount, uncheckedEntities, updateUncheckedTypes, dataType]);
  const allSelected = (0,external_react_.useMemo)(() => {
    return uncheckedEntities === null || uncheckedEntities?.length === 0;
  }, [uncheckedEntities]);
  const onSelectAll = (0,external_react_.useCallback)(() => {
    if (allSelected) {
      ensureCount();
      const ids = dataTypes.map(type => type.rowId ?? type.lsid);
      updateUncheckedTypes(dataType, ids);
      setUncheckedEntities(ids);
    } else {
      updateUncheckedTypes(dataType, []);
      setUncheckedEntities([]);
    }
  }, [allSelected, dataTypes, updateUncheckedTypes, dataType, ensureCount]);
  const _getUncheckedEntityWarning = (0,external_react_.useCallback)(id => {
    return getUncheckedEntityWarning(uncheckedEntities, uncheckedEntitiesDB, dataCounts, entityDataType, id);
  }, [uncheckedEntities, uncheckedEntitiesDB, dataCounts, entityDataType]);
  const headerLabel = (0,external_react_.useMemo)(() => {
    if (dataTypeLabel) return dataTypeLabel;
    if (entityDataType?.typeNounSingular) return entityDataType.typeNounSingular + 's';
    return null;
  }, [dataTypeLabel, entityDataType]);

  // FIXME: This should be a component, not a callback
  const getEntitiesSubList = (0,external_react_.useCallback)(dataTypeEntities => {
    return /*#__PURE__*/external_react_default().createElement("ul", {
      className: "nav nav-stacked labkey-wizard-pills"
    }, dataTypeEntities?.map((type, index) => {
      const entityId = type.rowId ?? type.lsid;
      // FIXME: This should be a component so we can use useCallback for the onChange/onClick below
      return /*#__PURE__*/external_react_default().createElement("li", {
        key: entityId,
        className: "project-faceted-data-type"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/external_react_default().createElement("input", {
        className: "form-check-input filter-faceted__checkbox",
        type: "checkbox",
        name: 'field-value-' + index,
        onChange: event => onChange(entityId, false, event.target.checked),
        checked: uncheckedEntities?.indexOf(entityId) < 0,
        disabled: disabled
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "margin-left-more project-datatype-faceted__value",
        onClick: () => onChange(entityId, true)
      }, type.labelColor && /*#__PURE__*/external_react_default().createElement(ColorIcon, {
        cls: "label_color color-icon__circle-small",
        value: type.labelColor
      }), type.label)), !!type.sublabel && /*#__PURE__*/external_react_default().createElement("div", {
        className: "help-block margin-left-more"
      }, type.sublabel), showUncheckedWarning && _getUncheckedEntityWarning(entityId));
    }));
  }, [uncheckedEntities, disabled, showUncheckedWarning, _getUncheckedEntityWarning, onChange]);

  // FIXME: this should be a component, not a callback
  const getEntitiesList = (0,external_react_.useCallback)(() => {
    if (!columns || columns === 1) {
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-12"
      }, getEntitiesSubList(dataTypes));
    }
    const lists = [];
    const colWidth = 12 / columns;
    const subSize = Math.ceil(dataTypes.length / columns);
    for (let i = 0; i < columns; i++) {
      const maxInd = Math.min(dataTypes.length, (i + 1) * subSize);
      const subList = dataTypes.slice(i * subSize, maxInd);
      lists.push( /*#__PURE__*/external_react_default().createElement("div", {
        className: `col-xs-12 col-md-${colWidth}`,
        key: i
      }, getEntitiesSubList(subList)));
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, lists);
  }, [dataTypes, columns, getEntitiesSubList]);

  // Note: because we return LoadingSpinner here when loading we can remove all the stuff below that renders based on
  // loading status
  if (!dataTypes || loading) return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("div", null, headerLabel && !noHeader && /*#__PURE__*/external_react_default().createElement("div", {
    className: "bottom-spacing content-group-label"
  }, headerLabel), toggleSelectAll && !disabled && dataTypes?.length > 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12 bottom-spacing"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "clickable-text",
    onClick: onSelectAll
  }, allSelected ? 'Deselect All' : 'Select All'))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, loading && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), !loading && getEntitiesList(), !loading && dataTypes.length === 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "help-block margin-left-more"
  }, "No ", headerLabel.toLowerCase()))));
});
DataTypeSelector.defaultProps = {
  toggleSelectAll: true,
  api: getDefaultAPIWrapper()
};
;// CONCATENATED MODULE: ./src/internal/components/editable/constants.ts
const EDITABLE_GRID_CONTAINER_CLS = 'editable-grid__container';
let SELECTION_TYPES = /*#__PURE__*/function (SELECTION_TYPES) {
  SELECTION_TYPES[SELECTION_TYPES["ALL"] = 0] = "ALL";
  SELECTION_TYPES[SELECTION_TYPES["AREA"] = 1] = "AREA";
  SELECTION_TYPES[SELECTION_TYPES["SINGLE"] = 2] = "SINGLE";
  SELECTION_TYPES[SELECTION_TYPES["AREA_CHANGE"] = 3] = "AREA_CHANGE";
  return SELECTION_TYPES;
}({});
let MODIFICATION_TYPES = /*#__PURE__*/function (MODIFICATION_TYPES) {
  MODIFICATION_TYPES[MODIFICATION_TYPES["ADD"] = 0] = "ADD";
  MODIFICATION_TYPES[MODIFICATION_TYPES["REPLACE"] = 1] = "REPLACE";
  MODIFICATION_TYPES[MODIFICATION_TYPES["REMOVE"] = 2] = "REMOVE";
  MODIFICATION_TYPES[MODIFICATION_TYPES["REMOVE_ALL"] = 3] = "REMOVE_ALL";
  return MODIFICATION_TYPES;
}({});
let EditableGridEvent = /*#__PURE__*/function (EditableGridEvent) {
  EditableGridEvent["ADD_ROWS"] = "ADD_ROWS";
  EditableGridEvent["BULK_ADD"] = "BULK_ADD";
  EditableGridEvent["BULK_UPDATE"] = "BULK_UPDATE";
  EditableGridEvent["CLEAR_SELECTION"] = "CLEAR_SELECTION";
  EditableGridEvent["DRAG_FILL"] = "DRAG_FILL";
  EditableGridEvent["FILL_TEXT"] = "FILL_TEXT";
  EditableGridEvent["FOCUS_CELL"] = "FOCUS_CELL";
  EditableGridEvent["MODIFY_CELL"] = "MODIFY_CELL";
  EditableGridEvent["PASTE"] = "PASTE";
  EditableGridEvent["REMOVE_ROWS"] = "REMOVE_ROWS";
  EditableGridEvent["SELECT_CELL"] = "SELECT_CELL";
  return EditableGridEvent;
}({});
;// CONCATENATED MODULE: ./src/internal/components/editable/utils.ts
function editable_utils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function editable_utils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? editable_utils_ownKeys(Object(t), !0).forEach(function (r) { editable_utils_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : editable_utils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function editable_utils_defineProperty(e, r, t) { return (r = editable_utils_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function editable_utils_toPropertyKey(t) { var i = editable_utils_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function editable_utils_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







const applyEditableGridChangesToModels = (dataModels, editorModels, editorModelChanges, queryInfo, dataKeys, data, tabIndex = 0) => {
  const updatedEditorModels = [...editorModels];
  let editorModel = editorModels[tabIndex].merge(editorModelChanges);

  // NK: The "selectionCells" property is of type string[]. When merge() is used it utilizes
  // Immutable.fromJS() which turns the Array into a List. We want to maintain the property
  // as an Array so here we set it explicitly.
  if (editorModelChanges?.selectionCells !== undefined) {
    const selectionCells = sortCellKeys(editorModelChanges.selectionCells);
    editorModel = editorModel.set('selectionCells', selectionCells);
    editorModel = editorModel.set('isSparseSelection', isSparseSelection(selectionCells));
  }
  updatedEditorModels.splice(tabIndex, 1, editorModel);
  const updatedDataModels = [...dataModels];
  const orderedRows = dataKeys?.toJS();
  const rows = data?.toJS();
  if (orderedRows && rows) {
    let dataModel = dataModels[tabIndex].mutate({
      orderedRows,
      rows
    });
    if (queryInfo) dataModel = dataModels[tabIndex].mutate({
      queryInfo
    });
    updatedDataModels.splice(tabIndex, 1, dataModel);
  }
  return {
    dataModels: updatedDataModels,
    editorModels: updatedEditorModels
  };
};
const getValidatedEditableGridValue = (origValue, col) => {
  const isDateTimeType = col?.jsonType === 'date';
  const isDateType = isDateTimeType && col?.isDateOnlyColumn;
  let message;
  let value = origValue;

  // Issue 44398: match JSON dateTime format provided by LK server when submitting date values back for insert/update
  // Issue 45140: use QueryColumn date format for parseDate()
  if (isDateType || isDateTimeType) {
    const dateVal = parseDate(origValue, getColDateFormat(col));
    const dateStrVal = isDateType ? getJsonDateFormatString(dateVal) : getJsonDateTimeFormatString(dateVal);
    if (origValue && !dateStrVal) message = isDateType ? 'Invalid date' : 'Invalid date time';
    value = dateStrVal ?? origValue;
  } else if (value != null && value !== '' && !col?.isPublicLookup()) {
    if (col?.validValues) {
      if (col.validValues.indexOf(origValue.toString().trim()) === -1) message = 'Invalid text choice';
    } else if (col?.jsonType === 'time') {
      const time = parseSimpleTime(value);
      if (time instanceof Date && !isNaN(time.getTime())) {
        value = getFormattedStringFromDate(time, col, false);
      } else message = 'Invalid time';
    } else if (col?.jsonType === 'boolean' && !isBoolean(value)) {
      message = 'Invalid boolean';
    } else if (col?.jsonType === 'int' && !isInteger(value)) {
      message = 'Invalid integer';
    } else if (col?.jsonType === 'float' && !isFloat(value)) {
      message = 'Invalid decimal';
    } else if (col?.jsonType === 'string' && col?.scale) {
      if (value.toString().trim().length > col.scale) message = value.toString().trim().length + '/' + col.scale + ' characters';
    }
  }
  if (col?.required && (value == null || value === '' || value.toString().trim() === '') && col?.jsonType !== 'boolean') {
    message = (message ? message + '. ' : '') + col.caption + ' is required.';
  }
  return {
    value,
    message: message ? {
      message
    } : undefined
  };
};

/**
 * Constructs an array of objects (suitable for the rows parameter of updateRows), where each object contains the
 * values in editorRows that are different from the ones in originalGridData
 *
 * @param originalGridData a map from an id field to a Map from fieldKeys to values
 * @param editorRows An array of Maps from field keys to values
 * @param idField the fieldKey in the editorRow objects that is the id field that is the key for originalGridData
 * @param queryInfo the query info behind this editable grid
 */
function getUpdatedDataFromGrid(originalGridData, editorRows, idField, queryInfo) {
  const updatedRows = [];
  const altIdFields = queryInfo.altUpdateKeys;
  editorRows.forEach(editedRow => {
    const id = editedRow.get(idField);
    const altIds = {};
    altIdFields?.forEach(altIdField => {
      altIds[altIdField] = altIdField ? editedRow.get(altIdField) : undefined;
    });
    const originalRow = originalGridData.get(id.toString());
    if (originalRow) {
      const row = editedRow.reduce((row, value, key) => {
        // We can skip the idField for the diff check, that will be added to the updated rows later
        if (key === idField) return row;
        let originalValue = originalRow.has(key) ? originalRow.get(key) : undefined;
        const col = queryInfo.getColumn(key);

        // Convert empty cell to null
        if (value === '') value = null;

        // Some column types have special handling of raw data, i.e. StoredAmount and Units (issue 49502)
        if (col?.columnRenderer) {
          const renderer = getQueryColumnRenderers()[col.columnRenderer.toLowerCase()];
          if (renderer?.getOriginalRawValue) {
            originalValue = renderer.getOriginalRawValue(originalValue);
          }
        }

        // Lookup columns store a list but grid only holds a single value
        if (external_immutable_.List.isList(originalValue) && !Array.isArray(value)) {
          originalValue = external_immutable_.Map.isMap(originalValue.get(0)) ? originalValue.get(0).get('value') : originalValue.get(0).value;
        }

        // EditableGrid passes in strings for single values. Attempt this conversion here to help check for
        // updated values. This is not the final type check.
        if (typeof originalValue === 'number' || typeof originalValue === 'boolean') {
          try {
            value = JSON.parse(value);
          } catch (e) {
            // Incorrect types are handled by API and user feedback created from that response. Don't need
            // to handle that here.
          }
        } else if (external_immutable_.Iterable.isIterable(originalValue) && !external_immutable_.List.isList(originalValue)) {
          originalValue = originalValue.get('value');
        }

        // If col is a multi-value column, compare all values for changes
        if ((external_immutable_.List.isList(originalValue) || originalValue === undefined) && Array.isArray(value)) {
          if ((originalValue?.size ?? 0) !== value.length) {
            row[key] = value;
          } else if (originalValue) {
            if (external_immutable_.Map.isMap(originalValue.get(0))) {
              // filter to those values that no longer exist in the new value array
              const filtered = originalValue.filter(o => value.indexOf(o.get('value')) === -1 && value.indexOf(o.get('displayValue')) === -1);
              if (filtered.size > 0) {
                row[key] = value;
              }
            } else if (originalValue?.findIndex(o => value.indexOf(o.value) === -1 && value.indexOf(o.displayValue) === -1) !== -1) {
              row[key] = value;
            }
          }
        } else if (!(originalValue == undefined && value == undefined) && originalValue !== value) {
          // only update if the value has changed

          // if the value is 'undefined', it will be removed from the update rows, so in order to
          // erase an existing value we set the value to null in our update data
          value = value === undefined ? null : value;
          row[key] = getValidatedEditableGridValue(value, col).value;
        }
        return row;
      }, {});
      if (!api_.Utils.isEmptyObj(row)) {
        row[idField] = id;
        Object.assign(row, altIds);
        updatedRows.push(row);
      }
    } else {
      console.error('Unable to find original row for id ' + id);
    }
  });
  return updatedRows;
}
const getUpdatedDataFromEditableGrid = (dataModels, editorModels, idField, selectionData, tabIndex = 0) => {
  const model = dataModels[tabIndex];
  const editorModel = editorModels[tabIndex];
  if (!editorModel) {
    console.error('Grid does not expose an editor. Ensure the grid is properly initialized for editing.');
    return null;
  }

  // Issue 37842: if we have data for the selection, this was the data that came from the display grid and was used
  // to populate the queryInfoForm. If we don't have this data, we came directly to the editable grid
  // using values from the display grid to initialize the editable grid model, so we use that.
  const initData = selectionData ?? (0,external_immutable_.fromJS)(model.rows);
  const editorData = editorModel.getRawDataFromModel(model, true, true, false).toArray();
  return {
    originalRows: model.rows,
    schemaQuery: model.queryInfo.schemaQuery,
    tabIndex,
    updatedRows: getUpdatedDataFromGrid(initData, editorData, idField, model.queryInfo)
  };
};
function onCellSelectChange(cellActions, colIdx, rowIdx, selectedOptions, multiple) {
  const {
    modifyCell,
    selectCell
  } = cellActions;
  if (multiple) {
    if (selectedOptions.length === 0) {
      modifyCell(colIdx, rowIdx, undefined, MODIFICATION_TYPES.REMOVE_ALL);
    } else {
      const valueDescriptors = selectedOptions.map(item => ({
        raw: item.value,
        display: item.label
      }));
      modifyCell(colIdx, rowIdx, valueDescriptors, MODIFICATION_TYPES.REPLACE);
    }
  } else {
    const selectedOption = selectedOptions;
    modifyCell(colIdx, rowIdx, [{
      raw: selectedOption?.value,
      display: selectedOption?.label
    }], MODIFICATION_TYPES.REPLACE);
    selectCell(colIdx, rowIdx);
  }
}
function genCellKey(colIdx, rowIdx) {
  return [colIdx, rowIdx].join('-');
}
function parseCellKey(cellKey) {
  const [colIdx, rowIdx] = cellKey.split('-');
  return {
    colIdx: parseInt(colIdx, 10),
    rowIdx: parseInt(rowIdx, 10)
  };
}

/**
 * Sorts cell keys left to right, top to bottom.
 */
function sortCellKeys(cellKeys) {
  return Array.from(new Set(cellKeys)).sort((a, b) => {
    const aCoords = parseCellKey(a);
    const bCoords = parseCellKey(b);
    if (aCoords.rowIdx === bCoords.rowIdx) return aCoords.colIdx - bCoords.colIdx;
    return aCoords.rowIdx - bCoords.rowIdx;
  });
}

// https://stackoverflow.com/questions/10713878/decimal-subtraction-problems-in-javascript
function decimalDifference(first, second, subtract = true) {
  const multiplier = 10000; // this will only help/work to 4 decimal places
  return (first * multiplier + (subtract ? -1 : 1) * second * multiplier) / multiplier;
}

/**
 * Returns true if the selection is sparse. A sparse selection is one where a continuous set of cells in a rectangle are
 * not selected. It may look something like this:
 *  0 1 1 0 0
 *  0 0 0 1 1
 *  0 1 1 0 0
 * @param selection An array of cell keys representing the selected cells, ordered left to right, top to bottom.
 */
function isSparseSelection(selection) {
  if (selection.length === 0) return false;
  const firstCell = parseCellKey(selection[0]);
  const lastCell = parseCellKey(selection[selection.length - 1]);
  const minCol = firstCell.colIdx;
  const maxCol = lastCell.colIdx;
  const minRow = firstCell.rowIdx;
  const maxRow = lastCell.rowIdx;
  const expectedCellCount = (maxCol - minCol + 1) * (maxRow - minRow + 1);

  // If the expected size is wrong we can short circuit and return
  if (selection.length !== expectedCellCount) return true;
  let selIdx = 0;

  // If the sizes match, then we need to generate the expected cellKeys in the order we expect them, and if they don't
  // all match we know it's a sparse selection.
  for (let rowIdx = minRow; rowIdx <= maxRow; rowIdx++) {
    for (let colIdx = minCol; colIdx <= maxCol; colIdx++) {
      const expectedCellKey = genCellKey(colIdx, rowIdx);
      const actualCellKey = selection[selIdx];
      if (expectedCellKey !== actualCellKey) return true;
      selIdx++;
    }
  }
  return false;
}
function getLookupFilters(column, lookupKeyValues, lookupValues, lookupValueFilters, forUpdate, displayColumn) {
  const {
    lookup
  } = column;
  const filters = Array.from(lookupValueFilters ?? []);
  if (lookupValues) {
    filters.push(api_.Filter.create(displayColumn ?? lookup.displayColumn, lookupValues, api_.Filter.Types.IN));
  }
  if (lookupKeyValues) {
    filters.push(api_.Filter.create(lookup.keyColumn, lookupKeyValues, api_.Filter.Types.IN));
  }
  const operation = forUpdate ? Operation.update : Operation.insert;
  if (lookup.hasQueryFilters(operation)) {
    filters.push(...lookup.getQueryFilters(operation));
  }
  return filters;
}
const EDIT_GRID_INPUT_CELL_CLASS = 'eg-input-cell';
const gridCellSelectInputProps = {
  autoFocus: true,
  containerClass: 'select-input-cell-container',
  customStyles: {
    control: provided => editable_utils_objectSpread(editable_utils_objectSpread({}, provided), {}, {
      minHeight: 24,
      borderRadius: 0
    }),
    valueContainer: provided => editable_utils_objectSpread(editable_utils_objectSpread({}, provided), {}, {
      minHeight: 24,
      padding: '0 4px'
    }),
    input: provided => editable_utils_objectSpread(editable_utils_objectSpread({}, provided), {}, {
      margin: '0px'
    }),
    indicatorsContainer: provided => editable_utils_objectSpread(editable_utils_objectSpread({}, provided), {}, {
      minHeight: 24,
      padding: '0 4px'
    })
  },
  customTheme: theme => editable_utils_objectSpread(editable_utils_objectSpread({}, theme), {}, {
    colors: editable_utils_objectSpread(editable_utils_objectSpread({}, theme.colors), {}, {
      danger: '#D9534F',
      primary: '#2980B9',
      primary75: '#009BF9',
      primary50: '#F2F9FC',
      primary25: 'rgba(41, 128, 185, 0.1)'
    }),
    spacing: editable_utils_objectSpread(editable_utils_objectSpread({}, theme.spacing), {}, {
      baseUnit: 2
    })
  }),
  inputClass: `select-input-cell ${EDIT_GRID_INPUT_CELL_CLASS}`,
  menuPosition: 'fixed',
  openMenuOnFocus: true,
  placeholder: '',
  showIndicatorSeparator: false,
  showLabel: false
};
const gridCellQuerySelectProps = editable_utils_objectSpread(editable_utils_objectSpread({}, gridCellSelectInputProps), {}, {
  showLoading: false
});

/**
 * Computes the new range for a given grid dimension when expanding or contracting in a particular direction.
 * @param selectedIdx The index of the currently selected cell
 * @param min The minimum of the current range
 * @param max The maximum of the current range
 * @param direction number in the range of -1, 1.
 *  - If -1, we are moving up or left
 *  - If 0 we are not moving
 *  - If 1 we are moving down or right
 */
function computeRangeChange(selectedIdx, min, max, direction) {
  if (direction === 0) {
    // If we haven't changed direction then we don't need to expand or contract the range at all
    return [min, max];
  }
  if (min === max) {
    // A single selected cell is a bit of a special case, because we'll be extending either before or after
    if (direction === 1) {
      // Extend forward
      max = max + 1;
    } else {
      // Extend backward
      min = min - 1;
    }
  } else if (min < selectedIdx) {
    // The selected area is above or left of the currently selected index
    if (direction === 1) {
      // We're shrinking forwards
      min = min + 1;
    } else {
      // We're extending backwards
      min = min - 1;
    }
  } else {
    if (direction === 1) {
      // We're extending forwards
      max = max + 1;
    } else {
      // We're shrinking backwards
      max = max - 1;
    }
  }
  return [Math.max(0, min), max];
}
;// CONCATENATED MODULE: ./src/internal/components/editable/models.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







function getPkData(queryInfo, row) {
  const data = {};
  const pkCols = new Set();
  queryInfo.getPkCols().forEach(col => pkCols.add(col.fieldKey));
  queryInfo.altUpdateKeys?.forEach(key => pkCols.add(key));
  pkCols.forEach(pkCol => {
    let pkVal = caseInsensitive(row.toJS(), pkCol);
    if (Array.isArray(pkVal)) pkVal = pkVal[0];
    if (external_immutable_.List.isList(pkVal)) pkVal = pkVal.get(0);
    if (pkVal !== undefined && pkVal !== null) {
      // when backing an editable grid, the data is a simple value, but when
      // backing a grid, it is a Map, which has type 'object'.
      if (external_immutable_.Map.isMap(pkVal)) pkVal = pkVal.toJS();
      data[pkCol] = typeof pkVal === 'object' ? pkVal.value : pkVal;
    } else {
      console.warn('Unable to find value for pkCol "' + pkCol + '"');
    }
  });
  return data;
}
const DATA_CHANGE_EVENTS = [EditableGridEvent.ADD_ROWS, EditableGridEvent.BULK_ADD, EditableGridEvent.BULK_UPDATE, EditableGridEvent.DRAG_FILL, EditableGridEvent.FILL_TEXT, EditableGridEvent.MODIFY_CELL, EditableGridEvent.PASTE, EditableGridEvent.REMOVE_ROWS];
const SELECTION_EVENTS = [EditableGridEvent.CLEAR_SELECTION, EditableGridEvent.FOCUS_CELL, EditableGridEvent.SELECT_CELL];
let EditorMode = /*#__PURE__*/function (EditorMode) {
  EditorMode[EditorMode["Insert"] = 0] = "Insert";
  EditorMode[EditorMode["Update"] = 1] = "Update";
  return EditorMode;
}({});
class EditorModel extends (0,external_immutable_.Record)({
  cellMessages: (0,external_immutable_.Map)(),
  cellValues: (0,external_immutable_.Map)(),
  columns: (0,external_immutable_.List)(),
  deletedIds: (0,external_immutable_.Set)(),
  focusColIdx: -1,
  focusRowIdx: -1,
  focusValue: undefined,
  id: undefined,
  isPasting: false,
  isSparseSelection: false,
  rowCount: 0,
  selectedColIdx: -1,
  selectedRowIdx: -1,
  selectionCells: []
}) {
  // NK: This is precomputed property that is updated whenever the selection is updated.
  // See applyEditableGridChangesToModels().

  // NK: This is pre-sorted array that is updated whenever the selection is updated.
  // See applyEditableGridChangesToModels().

  findNextCell(startCol, startRow, predicate, advance) {
    let colIdx = startCol,
      rowIdx = startRow;
    while (true) {
      ({
        colIdx,
        rowIdx
      } = advance(colIdx, rowIdx));
      if (!this.isInBounds(colIdx, rowIdx)) break;
      const value = this.getValue(colIdx, rowIdx);
      if (predicate(value, colIdx, rowIdx)) {
        return {
          value,
          colIdx,
          rowIdx
        };
      }
    }

    // not found
    return undefined;
  }
  getMessage(colIdx, rowIdx) {
    return this.cellMessages.get(genCellKey(colIdx, rowIdx));
  }
  getColumns(queryInfo, forUpdate, readOnlyColumns, insertColumns, updateColumns, colFilter) {
    let columns;
    if (forUpdate) {
      columns = updateColumns ?? queryInfo.getUpdateColumns(readOnlyColumns);
    } else {
      columns = insertColumns ?? queryInfo.getInsertColumns();
    }
    if (colFilter) columns = columns.filter(colFilter);
    // file input columns are not supported in the editable grid, so remove them
    return columns.filter(col => !col.isFileInput);
  }
  getColumnValues(columnName) {
    const colIdx = this.columns.findIndex(colName => colName === columnName);
    if (colIdx === -1) {
      console.warn(`Unable to resolve column "${columnName}". Cannot retrieve column values.`);
      return (0,external_immutable_.List)();
    }
    const values = (0,external_immutable_.List)().asMutable();
    for (let i = 0; i < this.rowCount; i++) {
      values.push(this.getValue(colIdx, i));
    }
    return values.asImmutable();
  }
  getRawDataFromModel(queryModel, displayValues, forUpdate, forExport) {
    return this.getRawDataFromGridData((0,external_immutable_.fromJS)(queryModel.rows), (0,external_immutable_.fromJS)(queryModel.orderedRows), queryModel.queryInfo, displayValues, forUpdate, forExport);
  }

  /** @deprecated Use getRawDataFromModel() instead. */
  getRawDataFromGridData(data, dataKeys, queryInfo, displayValues = true, forUpdate = false, forExport) {
    let rawData = (0,external_immutable_.List)();
    const columnMap = this.columns.reduce((map, fieldKey) => {
      const col = queryInfo.getColumn(fieldKey);
      // Log a warning but still retain the key in the map for column order
      if (!col) console.warn(`Unable to resolve column "${fieldKey}". Cannot retrieve raw data.`);
      return map.set(fieldKey, col);
    }, (0,external_immutable_.OrderedMap)());
    for (let rn = 0; rn < dataKeys.size; rn++) {
      let row = (0,external_immutable_.Map)();
      columnMap.valueSeq().forEach((col, cn) => {
        if (!col) return;
        const values = this.getValue(cn, rn);

        // Some column types have special handling of raw data, such as multi value columns like alias,
        // so first check renderer for how to retrieve raw data
        let renderer;
        if (col.columnRenderer) {
          renderer = getQueryColumnRenderers()[col.columnRenderer.toLowerCase()];
        }
        if (renderer?.getEditableRawValue) {
          row = row.set(col.name, renderer.getEditableRawValue(values));
        } else if (col.isLookup()) {
          if (col.isExpInput() || col.isAliquotParent()) {
            let sep = '';
            row = row.set(col.name, values.reduce((str, vd) => {
              if (vd.display !== undefined && vd.display !== null) {
                str += sep + quoteValueWithDelimiters(vd.display, ',');
                sep = ', ';
              }
              return str;
            }, ''));
          } else if (col.isJunctionLookup()) {
            row = row.set(col.name, values.reduce((arr, vd) => {
              const val = forExport ? vd.display : vd.raw;
              if (val !== undefined && val !== null) {
                arr.push(val);
              }
              return arr;
            }, []));
          } else if (col.lookup.displayColumn === col.lookup.keyColumn) {
            row = row.set(col.name, values.size === 1 ? quoteValueWithDelimiters(values.first()?.display, ',') : undefined);
          } else {
            let val;
            if (values.size === 1) val = forExport ? values.first()?.display : values.first()?.raw;
            row = row.set(col.name, val);
          }
        } else if (col.jsonType === 'time') {
          row = row.set(col.name, values.size === 1 ? values.first().raw : undefined);
        } else if (col.jsonType !== 'date' || !displayValues) {
          const val = values.size === 1 ? values.first().raw : undefined;
          row = row.set(col.name, getValidatedEditableGridValue(val, col).value);
        } else {
          row = row.set(col.name, values.size === 1 ? values.first().raw?.toString().trim() : undefined);
        }
      });
      if (forUpdate) {
        const gridRow = data.get(dataKeys.get(rn));
        row = row.merge(getPkData(queryInfo, gridRow));
      }
      rawData = rawData.push(row);
    }
    return rawData;
  }

  /**
   * Determines which rows in the grid have missing required fields, which sets of rows have combinations
   * of key fields that are duplicated, and, optionally, which sets of rows have duplicated values for a
   * given field key.
   *
   * @param queryModel the model whose data we are validating
   * @param uniqueFieldKey optional (non-key) field that should be unique.
   */
  validateData(queryModel, uniqueFieldKey, insertColumns) {
    const data = (0,external_immutable_.fromJS)(queryModel.rows);
    const columns = insertColumns ?? queryModel.queryInfo.getInsertColumns();
    let cellMessages = this.cellMessages;
    let uniqueFieldCol;
    const keyColumns = columns.filter(column => column.isKeyField);
    let keyValues = (0,external_immutable_.Map)(); // map from row number to list of key values on that row
    let uniqueKeyMap = (0,external_immutable_.Map)(); // map from value to rows with that value
    let missingRequired = (0,external_immutable_.Map)(); // map from column caption to list of rows missing a value for that column
    for (let rn = 0; rn < data.size; rn++) {
      columns.forEach((col, cn) => {
        const cellKey = genCellKey(cn, rn);
        const values = this.getValue(cn, rn);
        if (col.required && !col.isUniqueIdColumn) {
          const message = this.getMessage(cn, rn);
          const missingMsg = col.caption + ' is required.';
          let updatedMsg = message?.message;
          if (values.isEmpty() || values.find(value => this.hasRawValue(value)) == undefined) {
            if (!message || message?.message?.indexOf(missingMsg) === -1) {
              if (!message || !message.message) updatedMsg = missingMsg;else updatedMsg = message.message + '. ' + missingMsg;
            }
            if (missingRequired.has(col.caption)) {
              missingRequired = missingRequired.set(col.caption, missingRequired.get(col.caption).push(rn + 1));
            } else {
              missingRequired = missingRequired.set(col.caption, (0,external_immutable_.List)([rn + 1]));
            }
          } else {
            if (updatedMsg?.indexOf(missingMsg) > -1) {
              updatedMsg = updatedMsg.replace(missingMsg, '');
            }
          }
          if (updatedMsg == null || updatedMsg.trim() === '') cellMessages = cellMessages.remove(cellKey);else cellMessages = cellMessages.set(cellKey, {
            message: updatedMsg
          });
        }
        if (col.isKeyField) {
          // there better be only one of these
          const valueDescriptor = values.get(0);
          if (this.hasRawValue(valueDescriptor)) {
            if (keyValues.has(rn + 1)) {
              keyValues = keyValues.set(rn + 1, keyValues.get(rn + 1).push(valueDescriptor.raw.toString()));
            } else {
              keyValues = keyValues.set(rn + 1, (0,external_immutable_.List)([valueDescriptor.raw.toString()]));
            }
          }
        } else if (uniqueFieldKey && col.fieldKey === uniqueFieldKey) {
          uniqueFieldCol = col;
          // there better be only one of these
          const valueDescriptor = values.get(0);
          if (valueDescriptor && this.hasRawValue(valueDescriptor)) {
            const stringVal = valueDescriptor.raw.toString().trim().toLowerCase();
            if (uniqueKeyMap.has(stringVal)) {
              uniqueKeyMap = uniqueKeyMap.set(stringVal, uniqueKeyMap.get(stringVal).push(rn + 1));
            } else {
              uniqueKeyMap = uniqueKeyMap.set(stringVal, (0,external_immutable_.List)([rn + 1]));
            }
          }
        }
      });
    }
    let uniqueKeyViolations = (0,external_immutable_.Map)();
    const duplicates = uniqueKeyMap.filter(rowNumbers => rowNumbers.size > 1).toMap();
    if (duplicates.size > 0 && uniqueFieldCol) {
      uniqueKeyViolations = uniqueKeyViolations.set(uniqueFieldCol.caption, duplicates);
    }

    // Join all the keyValues together and put them in a map with a list of row
    // numbers with that key.  Then filter to those lists with more than one item.
    const keyViolations = keyValues.reduce((keyMap, values, rowNumber) => {
      const key = values.join(', ');
      if (keyMap.has(key)) return keyMap.set(key, keyMap.get(key).push(rowNumber));else return keyMap.set(key, (0,external_immutable_.List)([rowNumber]));
    }, (0,external_immutable_.Map)()).filter(rowNumbers => rowNumbers.size > 1).toMap();
    if (!keyViolations.isEmpty()) {
      uniqueKeyViolations = uniqueKeyViolations.set(keyColumns.map(column => column.caption).join(', '), keyViolations);
    }

    // need to return a map from the column names/captions to the rows with duplicates.
    // Message:
    //   Duplicate values (val1, val2) for <column1, column2> on rows X, Y, Z.
    return {
      uniqueKeyViolations,
      missingRequired,
      cellMessages
    };
  }
  getValidationErrors(queryModel, uniqueFieldKey, insertColumns) {
    const {
      uniqueKeyViolations,
      missingRequired,
      cellMessages
    } = this.validateData(queryModel, uniqueFieldKey, insertColumns);
    let errors = [];
    if (!uniqueKeyViolations.isEmpty()) {
      const messages = uniqueKeyViolations.reduce((keyMessages, valueMap, fieldNames) => {
        return keyMessages.concat(valueMap.reduce((messages, rowNumbers, values) => {
          messages.push('Duplicate value (' + values + ') for ' + fieldNames + ' on rows ' + rowNumbers.join(', ') + '.');
          return messages;
        }, new Array()));
      }, new Array());
      errors = errors.concat(messages);
    }
    if (!missingRequired.isEmpty()) {
      const messages = missingRequired.reduce((messages, rowNumbers, fieldName) => {
        messages.push(fieldName + ' is missing from ' + (rowNumbers.size > 1 ? 'rows ' : 'row ') + rowNumbers.join(', ') + '.');
        return messages;
      }, new Array()).join(' ');
      errors = errors.concat(messages);
    }
    return {
      errors,
      cellMessages
    };
  }
  getValue(colIdx, rowIdx) {
    return this.getValueForCellKey(genCellKey(colIdx, rowIdx));
  }
  getValueForCellKey(cellKey) {
    if (this.cellValues.has(cellKey)) {
      return this.cellValues.get(cellKey);
    }
    return (0,external_immutable_.List)();
  }
  get hasFocus() {
    return this.focusColIdx > -1 && this.focusRowIdx > -1;
  }
  get isMultiSelect() {
    return this.selectionCells.length > 1;
  }
  get isMultiColumnSelection() {
    if (!this.isMultiSelect) return false;
    const firstCellColIdx = parseCellKey(this.selectionCells[0]).colIdx;
    return this.selectionCells.some(cellKey => parseCellKey(cellKey).colIdx !== firstCellColIdx);
  }
  get hasSelection() {
    return this.selectedColIdx > -1 && this.selectedRowIdx > -1;
  }
  get selectionKey() {
    if (this.hasSelection) return genCellKey(this.selectedColIdx, this.selectedRowIdx);
    return undefined;
  }
  isInBounds(colIdx, rowIdx) {
    return colIdx >= 0 && colIdx < this.columns.size && rowIdx >= 0 && rowIdx < this.rowCount;
  }
  inSelection(colIdx, rowIdx) {
    if (colIdx < 0 || rowIdx < 0) return false;
    const cellKey = genCellKey(colIdx, rowIdx);
    return this.selectionCells.find(ck => cellKey === ck) !== undefined;
  }
  hasRawValue(descriptor) {
    return descriptor && descriptor.raw != null && descriptor.raw.toString().trim() !== '';
  }
  get hasData() {
    return this.cellValues.find(valueList => {
      return valueList?.find(value => this.hasRawValue(value)) !== undefined;
    }) !== undefined;
  }
  isFocused(colIdx, rowIdx) {
    return colIdx > -1 && rowIdx > -1 && this.focusColIdx === colIdx && this.focusRowIdx === rowIdx;
  }
  isSelected(colIdx, rowIdx) {
    return colIdx > -1 && rowIdx > -1 && this.selectedColIdx === colIdx && this.selectedRowIdx === rowIdx;
  }
  static isDataChangeEvent(event) {
    return DATA_CHANGE_EVENTS.find(e => e === event) !== undefined;
  }
  isSelectionEvent(event) {
    return SELECTION_EVENTS.find(e => e === event) !== undefined;
  }
  static getEditorDataFromQueryValueMap(valueMap) {
    // Editor expects to get either a single value or an array of an object with fields displayValue and value
    if (external_immutable_.List.isList(valueMap)) {
      return valueMap.map(val => {
        // If immutable convert to normal JS
        if (external_immutable_.Iterable.isIterable(val)) {
          return {
            displayValue: val.get('displayValue'),
            value: val.get('value')
          };
        }
        return val;
      }).toList();
    }
    if (valueMap?.has('value') && valueMap.get('value') !== null && valueMap.get('value') !== undefined) {
      if (valueMap.has('formattedValue')) {
        return external_immutable_.List.of({
          displayValue: valueMap.get('formattedValue'),
          value: valueMap.get('value')
        });
      }
      if (valueMap.has('displayValue')) {
        return external_immutable_.List.of({
          displayValue: valueMap.get('displayValue'),
          value: valueMap.get('value')
        });
      }
      return valueMap.get('value');
    }
    return undefined;
  }
  static convertQueryDataToEditorData(data, updates, idsNotToUpdate, fieldsNotToUpdate, encode = true) {
    return data.map((valueMap, id) => {
      const returnMap = valueMap.reduce((m, valueMap_, key) => {
        const editorData = EditorModel.getEditorDataFromQueryValueMap(valueMap_);
        if (editorData === undefined) {
          return m;
        }

        // data maps have keys that are display names/captions. We need to convert to the
        // encoded keys used in our filters to match up with values from the forms.
        const key_ = encode ? encodePart(key) : key;
        return m.set(key_, editorData);
      }, (0,external_immutable_.Map)());
      if (!updates) {
        return returnMap;
      }
      if (!idsNotToUpdate || idsNotToUpdate.indexOf(parseInt(id, 10)) < 0 || !fieldsNotToUpdate) {
        return returnMap.merge(updates);
      }
      let trimmedUpdates = (0,external_immutable_.Map)();
      updates.forEach((value, fieldKey) => {
        if (fieldsNotToUpdate.indexOf(fieldKey.toLowerCase()) < 0) {
          trimmedUpdates = trimmedUpdates.set(fieldKey, value);
        }
      });
      return returnMap.merge(trimmedUpdates);
    }).toMap();
  }
  static convertQueryModelDataToGridResponse(model) {
    const data = {};
    const dataIds = [];
    model.orderedRows.forEach(pk => {
      data[pk] = model.rows[pk];
      dataIds.push(pk);
    });
    return {
      data: EditorModel.convertQueryDataToEditorData((0,external_immutable_.fromJS)(data), undefined, undefined, undefined, false),
      dataIds: (0,external_immutable_.fromJS)(dataIds)
    };
  }
  lastSelection(colIdx, rowIdx) {
    const cellKeys = this.isMultiSelect ? this.selectionCells : [this.selectionKey];
    return genCellKey(colIdx, rowIdx) === cellKeys[cellKeys.length - 1];
  }
}
;// CONCATENATED MODULE: ./src/internal/events.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function cancelEvent(event) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }
}
function getPasteValue(event) {
  if (isEvent(event)) {
    return (event.clipboardData || window['clipboardData']).getData('text');
  }
}
function isEvent(event) {
  return event !== undefined && event !== null;
}
function isCtrlOrMetaKey(event) {
  return event.ctrlKey || event.metaKey;
}
function isMetaKeyEvent(event, keyCode) {
  return isEvent(event) && event.keyCode === keyCode && isCtrlOrMetaKey(event);
}
const isFillDown = event => isMetaKeyEvent(event, KEYS.D);
const isSelectAll = event => isMetaKeyEvent(event, KEYS.A);
function setCopyValue(event, value) {
  if (isEvent(event)) {
    (event.clipboardData || window['clipboardData']).setData('text/plain', value);
    return true;
  }
  return false;
}
;// CONCATENATED MODULE: ./src/internal/components/editable/actions.ts
function editable_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function editable_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? editable_actions_ownKeys(Object(t), !0).forEach(function (r) { editable_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : editable_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function editable_actions_defineProperty(e, r, t) { return (r = editable_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function editable_actions_toPropertyKey(t) { var i = editable_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function editable_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }














const EMPTY_ROW = (0,external_immutable_.Map)();
let ID_COUNTER = 0;

/**
 * @deprecated Use initEditableGridModel() or initEditableGridModels() instead.
 * This method does not make use the grid loader paradigm. Usages of this method directly
 * is susceptible to data misalignment errors with the associated view.
 */
const loadEditorModelData = async (queryModelData, editorColumns, forUpdate) => {
  const {
    orderedRows,
    rows,
    queryInfo
  } = queryModelData;
  const columns = editorColumns ?? queryInfo.getInsertColumns();
  const lookupValueDescriptors = await getLookupValueDescriptors(columns, (0,external_immutable_.fromJS)(rows), (0,external_immutable_.fromJS)(orderedRows), forUpdate);
  let cellValues = (0,external_immutable_.Map)();

  // data is initialized in column order
  columns.forEach((col, cn) => {
    orderedRows.forEach((id, rn) => {
      const row = rows[id];
      const cellKey = genCellKey(cn, rn);
      const value = row[col.fieldKey];
      if (Array.isArray(value)) {
        // assume to be list of {displayValue, value} objects
        cellValues = cellValues.set(cellKey, value.reduce((list, v) => {
          if (col.isLookup() && api_.Utils.isNumber(v)) {
            const descriptors = lookupValueDescriptors[col.lookupKey];
            if (descriptors) {
              const desc = descriptors.filter(descriptor => descriptor.raw === v);
              if (desc) {
                return list.push(...desc);
              }
            }
          }
          return list.push({
            display: v.displayValue ?? v,
            raw: v.value ?? v
          });
        }, (0,external_immutable_.List)()));
      } else {
        // assume to be a {displayValue, value} object but fall back on value not being an object
        const raw = value?.value ?? value;
        const display = value?.displayValue ?? raw;
        let cellValue = (0,external_immutable_.List)([{
          display: display !== null ? display : undefined,
          raw: raw !== null ? raw : undefined
        }]);

        // Issue 37833: try resolving the value for the lookup to get the displayValue to show in the grid cell
        if (col.isLookup() && api_.Utils.isNumber(raw)) {
          const descriptors = lookupValueDescriptors[col.lookupKey];
          if (descriptors) {
            cellValue = (0,external_immutable_.List)(descriptors.filter(descriptor => descriptor.raw === raw));
          }
        }
        cellValues = cellValues.set(cellKey, cellValue);
      }
    });
  });
  return {
    cellValues,
    columns: (0,external_immutable_.List)(columns.map(col => col.fieldKey)),
    deletedIds: (0,external_immutable_.Set)(),
    rowCount: orderedRows.length
  };
};
const initEditableGridModel = async (dataModel, editorModel, loader, queryModel, colFilter) => {
  const response = await loader.fetch(queryModel);
  const gridData = {
    rows: response.data.toJS(),
    orderedRows: response.dataIds.toArray(),
    queryInfo: loader.queryInfo
  };
  let columns;
  const forUpdate = loader.mode === EditorMode.Update;
  if (loader.columns) {
    columns = editorModel.getColumns(gridData.queryInfo, forUpdate, undefined, loader.columns, loader.columns, colFilter);
  } else {
    columns = editorModel.getColumns(gridData.queryInfo, forUpdate, undefined, undefined, undefined, colFilter);
  }
  const editorModelData = await loadEditorModelData(gridData, columns, forUpdate);
  return {
    dataModel: dataModel.mutate(editable_actions_objectSpread(editable_actions_objectSpread({}, gridData), {}, {
      rowsLoadingState: LoadingState.LOADED,
      queryInfoLoadingState: LoadingState.LOADED
    })),
    editorModel: editorModel.merge(editorModelData)
  };
};
const initEditableGridModels = async (dataModels, editorModels, loaders, queryModel) => {
  const updatedDataModels = [];
  const updatedEditorModels = [];
  const results = await Promise.all(dataModels.map((dataModel, i) => initEditableGridModel(dataModels[i], editorModels[i], loaders[i], queryModel)));
  results.forEach(result => {
    updatedDataModels.push(result.dataModel);
    updatedEditorModels.push(result.editorModel);
  });
  return {
    dataModels: updatedDataModels,
    editorModels: updatedEditorModels
  };
};
function parseIntIfNumber(val) {
  const intVal = !isNaN(val) ? parseInt(val, 10) : undefined;
  return intVal === undefined || isNaN(intVal) ? val : intVal;
}
const resolveDisplayColumn = column => {
  // Handle MVFK
  if (column.multiValue && column.isJunctionLookup()) {
    const parts = column.displayField.split('$S');
    if (parts.length > 1) return parts[1];
  }
  return column.lookup.displayColumn;
};
const findLookupValues = async (column, lookupKeyValues, lookupValues, lookupValueFilters, forUpdate, containerPath) => {
  const {
    lookup
  } = column;
  const {
    keyColumn
  } = lookup;
  const displayColumn = resolveDisplayColumn(column);
  const results = await selectRows({
    columns: [displayColumn, keyColumn],
    containerPath: lookup.containerPath ?? containerPath,
    containerFilter: lookup.containerFilter ?? getContainerFilterForLookups(),
    filterArray: getLookupFilters(column, lookupKeyValues, lookupValues, lookupValueFilters, forUpdate, displayColumn),
    includeTotalCount: false,
    maxRows: -1,
    schemaQuery: lookup.schemaQuery,
    viewName: ViewInfo.DETAIL_NAME // Use the detail view so values that may be filtered out of the default view show up.
  });
  const descriptors = results.rows.reduce((desc, row) => {
    const key = caseInsensitive(row, keyColumn)?.value;
    if (key !== undefined && key !== null) {
      const displayRow = caseInsensitive(row, displayColumn);
      desc.push({
        display: displayRow?.displayValue || displayRow?.value,
        raw: key
      });
    }
    return desc;
  }, []);
  return {
    column,
    descriptors
  };
};
async function getLookupValueDescriptors(columns, rows, ids, forUpdate) {
  const descriptorMap = {};
  // for each lookup column, find the unique values in the rows and query for those values when they look like ids
  for (let cn = 0; cn < columns.length; cn++) {
    const col = columns[cn];
    let values = (0,external_immutable_.Set)();
    if (col.isPublicLookup()) {
      ids.forEach(id => {
        const row = rows.get(id);
        const value = row?.get(col.fieldKey);
        if (api_.Utils.isNumber(value)) {
          values = values.add(value);
        } else if (external_immutable_.List.isList(value)) {
          value.forEach(val => {
            if (external_immutable_.Map.isMap(val)) {
              values = values.add(val.get('value'));
            } else {
              values = values.add(val);
            }
          });
        }
      });
      if (!values.isEmpty()) {
        const {
          descriptors
        } = await findLookupValues(col, values.toArray(), undefined, undefined, forUpdate);
        descriptorMap[col.lookupKey] = descriptors;
      }
    }
  }
  return descriptorMap;
}
async function getLookupDisplayValue(column, value, containerPath) {
  if (value === undefined || value === null) {
    return {
      valueDescriptor: {
        display: value,
        raw: value
      }
    };
  }
  let message;
  const {
    descriptors
  } = await findLookupValues(column, [value], undefined, undefined, false, containerPath);
  if (!descriptors.length) {
    message = {
      message: 'Could not find data for ' + value
    };
  }
  return {
    message,
    valueDescriptor: descriptors[0]
  };
}
async function prepareInsertRowDataFromBulkForm(insertColumns, rowData, colMin = 0, containerPath) {
  let values = (0,external_immutable_.List)();
  let messages = (0,external_immutable_.List)();
  for (let cn = 0; cn < rowData.size; cn++) {
    const data = rowData.get(cn);
    const colIdx = colMin + cn;
    const col = insertColumns.get(colIdx);
    let cv;
    if (data && col && col.isPublicLookup()) {
      cv = (0,external_immutable_.List)();
      // value had better be the rowId here, but it may be several in a comma-separated list.
      // If it's the display value, which happens to be a number, much confusion will arise.
      const values_ = data.toString().split(',');
      for (const val of values_) {
        const {
          message,
          valueDescriptor
        } = await getLookupDisplayValue(col, parseIntIfNumber(val), containerPath);
        cv = cv.push(valueDescriptor);
        if (message) {
          messages = messages.push(message);
        }
      }
    } else {
      cv = (0,external_immutable_.List)([{
        display: data,
        raw: data
      }]);
    }
    values = values.push(cv);
  }
  return {
    values,
    messages
  };
}
async function addRowsToEditorModel(rowCount, cellMessages, cellValues, insertColumns, rowData, numToAdd, rowMin = 0, containerPath) {
  const selectionCells = [];
  const preparedData = await prepareInsertRowDataFromBulkForm(insertColumns, rowData, 0, containerPath);
  const {
    values,
    messages
  } = preparedData;
  for (let rowIdx = rowMin; rowIdx < rowMin + numToAdd; rowIdx++) {
    // eslint-disable-next-line no-loop-func
    rowData.forEach((value, colIdx) => {
      const cellKey = genCellKey(colIdx, rowIdx);
      cellMessages = cellMessages.set(cellKey, messages.get(colIdx));
      selectionCells.push(cellKey);
      cellValues = cellValues.set(cellKey, values.get(colIdx));
    });
  }
  return {
    cellValues,
    cellMessages,
    selectionCells,
    rowCount: Math.max(rowMin + Number(numToAdd), rowCount)
  };
}
function addRowsToGridData(dataKeys, data, count, rowData) {
  for (let i = 0; i < count; i++) {
    // ensure we don't step on another ID
    const id = GRID_EDIT_INDEX + ID_COUNTER++;
    data = data.set(id, rowData || EMPTY_ROW);
    dataKeys = dataKeys.push(id);
  }
  return {
    data,
    dataKeys
  };
}
async function addRows(editorModel, dataKeys, data, insertColumns, numToAdd, rowData, containerPath) {
  let editorModelChanges;
  if (rowData) {
    editorModelChanges = await addRowsToEditorModel(editorModel.rowCount, editorModel.cellMessages, editorModel.cellValues, insertColumns, rowData.toList(), numToAdd, data.size, containerPath);
  } else {
    editorModelChanges = {
      rowCount: editorModel.rowCount + numToAdd
    };
  }
  const dataChanges = addRowsToGridData(dataKeys, data, numToAdd, rowData);
  data = dataChanges.data;
  dataKeys = dataChanges.dataKeys;
  return {
    editorModel: editorModelChanges,
    data,
    dataKeys
  };
}

/**
 * Adds columns to the editor model and the underlying model's data
 * @param editorModel
 * @param queryInfo
 * @param originalData
 * @param queryColumns the ordered map of columns to be added
 * @param fieldKey the fieldKey of the existing column after which the new columns should be inserted.  If undefined
 * or the column is not found, columns will be added at the beginning.
 */
function addColumns(editorModel, queryInfo, originalData, queryColumns, fieldKey) {
  if (queryColumns.size === 0) return {};

  // if fieldKey is provided, find that index and we will insert after it (or at the beginning if there is no such field)
  const leftColIndex = fieldKey ? editorModel.columns.findIndex(column => api_.Utils.caseInsensitiveEquals(column, fieldKey)) : -1;
  const editorModelIndex = leftColIndex + 1;
  const queryColIndex = queryInfo.getColumnIndex(fieldKey) + 1;
  const newCellMessages = editorModel.cellMessages.reduce((cellMessages, message, cellKey) => {
    const [oldColIdx, oldRowIdx] = cellKey.split('-').map(v => parseInt(v, 10));
    if (oldColIdx >= editorModelIndex) {
      return cellMessages.set([oldColIdx + queryColumns.size, oldRowIdx].join('-'), message);
    } else if (oldColIdx < editorModelIndex) {
      return cellMessages.set(cellKey, message);
    }
    return cellMessages;
  }, (0,external_immutable_.Map)());
  let newCellValues = editorModel.cellValues.reduce((cellValues, value, cellKey) => {
    const [oldColIdx, oldRowIdx] = cellKey.split('-').map(v => parseInt(v, 10));
    if (oldColIdx >= editorModelIndex) {
      return cellValues.set([oldColIdx + queryColumns.size, oldRowIdx].join('-'), value);
    } else if (oldColIdx < editorModelIndex) {
      return cellValues.set(cellKey, value);
    }
    return cellValues;
  }, (0,external_immutable_.Map)());
  for (let rowIdx = 0; rowIdx < editorModel.rowCount; rowIdx++) {
    for (let c = 0; c < queryColumns.size; c++) {
      newCellValues = newCellValues.set(genCellKey(editorModelIndex + c, rowIdx), (0,external_immutable_.List)());
    }
  }
  const data = originalData.map(rowData => {
    queryColumns.forEach(column => {
      rowData = rowData.set(column.fieldKey, undefined);
    });
    return rowData;
  }).toMap();
  let {
    columns
  } = editorModel;
  queryColumns.valueArray.forEach((col, i) => {
    columns = columns.insert(i + editorModelIndex, col.fieldKey);
  });
  columns = columns.toList();
  return {
    editorModelChanges: {
      columns,
      focusColIdx: -1,
      focusRowIdx: -1,
      selectedColIdx: -1,
      selectedRowIdx: -1,
      selectionCells: [],
      cellMessages: newCellMessages,
      cellValues: newCellValues
    },
    data,
    queryInfo: queryInfo.mutate({
      columns: queryInfo.columns.mergeAt(queryColIndex, queryColumns)
    })
  };
}
function changeColumn(editorModel, queryInfo, originalData, existingFieldKey, newQueryColumn) {
  const colIndex = editorModel.columns.findIndex(column => api_.Utils.caseInsensitiveEquals(column, existingFieldKey));
  // nothing to do if there is no such column
  if (colIndex === -1) return {};

  // get rid of existing messages and values at the designated index.
  const newCellMessages = editorModel.cellMessages.reduce((cellMessages, message, cellKey) => {
    const [oldColIdx] = cellKey.split('-').map(v => parseInt(v, 10));
    if (oldColIdx !== colIndex) {
      return cellMessages.set(cellKey, message);
    }
    return cellMessages;
  }, (0,external_immutable_.Map)());
  const newCellValues = editorModel.cellValues.reduce((cellValues, value, cellKey) => {
    const [oldColIdx] = cellKey.split('-').map(v => parseInt(v, 10));
    if (oldColIdx !== colIndex) {
      return cellValues.set(cellKey, value);
    }
    return cellValues;
  }, (0,external_immutable_.Map)());
  const currentCol = queryInfo.getColumn(existingFieldKey);

  // remove existing column and set new column in data
  const data = originalData.map(rowData => {
    rowData = rowData.remove(currentCol.fieldKey);
    return rowData.set(newQueryColumn.fieldKey, undefined);
  }).toMap();
  const columns = new ExtendedMap();
  queryInfo.columns.forEach((column, key) => {
    if (column.fieldKey === currentCol.fieldKey) {
      columns.set(newQueryColumn.fieldKey.toLowerCase(), newQueryColumn);
    } else {
      columns.set(key, column);
    }
  });
  let editorModelColumns = editorModel.columns;
  if (colIndex > -1) {
    editorModelColumns = editorModelColumns.set(colIndex, newQueryColumn.fieldKey);
  }
  return {
    editorModelChanges: {
      columns: editorModelColumns,
      focusColIdx: -1,
      focusRowIdx: -1,
      selectedColIdx: -1,
      selectedRowIdx: -1,
      selectionCells: [],
      cellMessages: newCellMessages,
      cellValues: newCellValues
    },
    data,
    queryInfo: queryInfo.mutate({
      columns
    })
  };
}
function removeColumn(editorModel, queryInfo, originalData, fieldKey) {
  const deleteIndex = editorModel.columns.findIndex(column => api_.Utils.caseInsensitiveEquals(column, fieldKey));
  // nothing to do if there is no such column
  if (deleteIndex === -1) return {};
  const newCellMessages = editorModel.cellMessages.reduce((cellMessages, message, cellKey) => {
    const [oldColIdx, oldRowIdx] = cellKey.split('-').map(v => parseInt(v, 10));
    if (oldColIdx > deleteIndex) {
      return cellMessages.set([oldColIdx - 1, oldRowIdx].join('-'), message);
    } else if (oldColIdx < deleteIndex) {
      return cellMessages.set(cellKey, message);
    }
    return cellMessages;
  }, (0,external_immutable_.Map)());
  const newCellValues = editorModel.cellValues.reduce((cellValues, value, cellKey) => {
    const [oldColIdx, oldRowIdx] = cellKey.split('-').map(v => parseInt(v, 10));
    if (oldColIdx > deleteIndex) {
      return cellValues.set([oldColIdx - 1, oldRowIdx].join('-'), value);
    } else if (oldColIdx < deleteIndex) {
      return cellValues.set(cellKey, value);
    }
    return cellValues;
  }, (0,external_immutable_.Map)());

  // remove column from all rows in model data
  const data = originalData.map(rowData => rowData.remove(fieldKey)).toMap();
  let columns = editorModel.columns;
  if (deleteIndex > -1) {
    columns = columns.remove(deleteIndex);
  }
  return {
    editorModelChanges: {
      columns,
      focusColIdx: -1,
      focusRowIdx: -1,
      selectedColIdx: -1,
      selectedRowIdx: -1,
      selectionCells: [],
      cellMessages: newCellMessages,
      cellValues: newCellValues
    },
    data,
    queryInfo: queryInfo.mutate({
      columns: queryInfo.columns.filter(col => col.fieldKey.toLowerCase() !== fieldKey.toLowerCase())
    })
  };
}

// altColumns is used when the columns to be updated do not correspond with the insert columns on queryInfo
async function prepareUpdateRowDataFromBulkForm(queryInfo, rowData, isIncludedColumn, containerPath, altColumns) {
  const columns = queryInfo.getInsertColumns(isIncludedColumn);
  let values = (0,external_immutable_.OrderedMap)();
  let messages = (0,external_immutable_.OrderedMap)();
  for (const colKey of rowData.keySeq().toArray()) {
    const data = rowData.get(colKey);
    let colIdx;
    let col;
    if (altColumns) {
      colIdx = altColumns.findIndex(c => c === colKey);
      col = queryInfo.getColumn(colKey);
    } else {
      colIdx = columns.findIndex(c => c.fieldKey === colKey);
      col = columns[colIdx];
    }
    let cv;
    if (data && col && col.isPublicLookup()) {
      cv = (0,external_immutable_.List)();
      // value had better be the rowId here, but it may be several in a comma-separated list.
      // If it's the display value, which happens to be a number, much confusion will arise.
      const rawValues = data.toString().split(',');
      for (const val of rawValues) {
        const {
          message,
          valueDescriptor
        } = await getLookupDisplayValue(col, parseIntIfNumber(val), containerPath);
        cv = cv.push(valueDescriptor);
        if (message) {
          messages = messages.set(colIdx, message);
        }
      }
    } else {
      cv = (0,external_immutable_.List)([{
        display: data,
        raw: data
      }]);
    }
    values = values.set(colIdx, cv);
  }
  return {
    values,
    messages
  };
}
async function updateGridFromBulkForm(editorModel, queryInfo, rowData, dataRowIndexes, lockedOrReadonlyRows, isIncludedColumn, containerPath, useEditorModelCols = false) {
  let cellMessages = editorModel.cellMessages;
  let cellValues = editorModel.cellValues;
  const preparedData = await prepareUpdateRowDataFromBulkForm(queryInfo, rowData, isIncludedColumn, containerPath, useEditorModelCols && editorModel.columns.toJS());
  const {
    values,
    messages
  } = preparedData; // {3: 'x', 4: 'z}

  dataRowIndexes.forEach(rowIdx => {
    if (lockedOrReadonlyRows && lockedOrReadonlyRows.indexOf(rowIdx) > -1) return;
    values.forEach((value, colIdx) => {
      const cellKey = genCellKey(colIdx, rowIdx);
      cellMessages = cellMessages.set(cellKey, messages.get(colIdx));
      cellValues = cellValues.set(cellKey, value);
    });
  });
  return {
    cellValues,
    cellMessages
  };
}
async function addRowsPerPivotValue(editorModel, dataKeys, data, insertColumns, numPerParent, pivotKey, pivotValues, rowData, containerPath) {
  let {
    cellMessages,
    cellValues,
    rowCount
  } = editorModel;
  if (numPerParent > 0) {
    for (const value of pivotValues) {
      rowData = rowData.set(pivotKey, value);
      const changes = await addRowsToEditorModel(rowCount, cellMessages, cellValues, insertColumns, rowData.toList(), numPerParent, dataKeys.size, containerPath);
      cellMessages = changes.cellMessages;
      cellValues = changes.cellValues;
      rowCount = changes.rowCount;
      const dataChanges = addRowsToGridData(dataKeys, data, numPerParent, rowData);
      data = dataChanges.data;
      dataKeys = dataChanges.dataKeys;
    }
  }
  return {
    editorModel: {
      cellMessages,
      cellValues,
      rowCount
    },
    data,
    dataKeys
  };
}

/**
 * This REGEX will match for any strings that are suffixed with a number, it has several capture groups to allow us to
 * easily grab the number and the prefix. The following values should match:
 *      ABC-123 captures as ['ABC-123', 'ABC-', '123', undefined]
 *      ABC123 captures as ['ABC123', 'ABC', '123', undefined]
 *      ABC-1.23 captures as ['ABC-1.23', 'ABC-', '1.23', '.23']
 *      ABC.123 captures as ['ABC.123', 'ABC.', '123', undefined]
 */
const POSTFIX_REGEX = /^(.*?)(\d+(\.\d+)?)$/;
/**
 * Given a string it returns an array in the form of [prefix, number suffix]. If the string is not suffixed with a
 * number the number suffix is undefined. If the entire string is a number the prefix will be undefined. This method
 * intentionally does not parse the numbers.
 */
function splitPrefixedNumber(text) {
  if (text === undefined || text === null || text === '') return [undefined, undefined];
  const matches = text?.toString().match(POSTFIX_REGEX);
  if (matches === null) {
    return [text, undefined];
  }
  return [matches[1] === '' ? undefined : matches[1], matches[2]];
}

/**
 * Given an array of values computed by splitPrefixedNumber returns true if they all have the same prefix
 */
function everyValueHasSamePrefix(values) {
  if (values.length === 0) return false;
  const prefix = values[0][0];
  return values.every(value => value[0] === prefix);
}
var IncrementDirection = /*#__PURE__*/function (IncrementDirection) {
  IncrementDirection[IncrementDirection["FORWARD"] = 0] = "FORWARD";
  IncrementDirection[IncrementDirection["BACKWARD"] = 1] = "BACKWARD";
  return IncrementDirection;
}(IncrementDirection || {});
var IncrementType = /*#__PURE__*/function (IncrementType) {
  IncrementType[IncrementType["DATE"] = 0] = "DATE";
  IncrementType[IncrementType["DATETIME"] = 1] = "DATETIME";
  IncrementType[IncrementType["NONE"] = 2] = "NONE";
  IncrementType[IncrementType["NUMBER"] = 3] = "NUMBER";
  return IncrementType;
}(IncrementType || {});
function inferSelectionDirection(initialCellKeys, cellKeysToFill) {
  const initialMin = parseCellKey(initialCellKeys[0]);
  const fillMin = parseCellKey(cellKeysToFill[0]);
  if (initialMin.rowIdx < fillMin.rowIdx) return IncrementDirection.FORWARD;
  return IncrementDirection.BACKWARD;
}
function inferSelectionIncrement(editorModel, initialCellKeys, cellKeysToFill) {
  const direction = inferSelectionDirection(initialCellKeys, cellKeysToFill);
  const values = initialCellKeys.map(cellKey => editorModel.getValueForCellKey(cellKey));
  // use the display values to determine sequence type to account for lookup cell values with numeric key/raw values
  let displayValues = values.map(value => value.get(0)?.display);
  let firstValue = displayValues[0];
  let lastValue = displayValues[displayValues.length - 1];
  const firstValueIsEmpty = firstValue === undefined || firstValue === '';
  const isDateSeq = values.length === 1 && !firstValueIsEmpty && formatDate(parseDate(firstValue)) === firstValue;
  const isDateTimeSeq = values.length === 1 && !firstValueIsEmpty && formatDateTime(parseDate(firstValue)) === firstValue;

  // Date sequence detection takes precedence otherwise we'd never parse dates, because we'd always consider something
  // like 2023-06-01, 6/1/2023, or 1-6-2023, to be a prefixed number string.
  if (isDateSeq || isDateTimeSeq) {
    return {
      direction,
      increment: 1,
      // Right now we only increment dates by 1 day
      incrementType: isDateSeq ? IncrementType.DATE : IncrementType.DATETIME,
      initialSelectionValues: values,
      prefix: undefined,
      startingValue: direction === IncrementDirection.FORWARD ? lastValue : firstValue
    };
  }
  let prefix;
  let incrementType = IncrementType.NONE;
  let increment;
  const splitValues = displayValues.map(splitPrefixedNumber);
  const allPrefixed = everyValueHasSamePrefix(splitValues);
  if (allPrefixed && splitValues[0][0] !== undefined) {
    prefix = splitValues[0][0];
    displayValues = splitValues.map(value => value[1]);
    firstValue = displayValues[0];
    lastValue = displayValues[displayValues.length - 1];
  }
  const isFloatSeq = values.length > 1 && displayValues.every(isFloat);
  const isIntSeq = values.length > 1 && displayValues.every(isInteger);
  if (isFloatSeq) {
    firstValue = parseFloat(firstValue);
    lastValue = parseFloat(lastValue);
  } else if (isIntSeq) {
    firstValue = parseScientificInt(firstValue);
    lastValue = parseScientificInt(lastValue);
  }
  if (isFloatSeq || isIntSeq) {
    // increment -> last value minus first value divide by the number of steps in the initial selection
    increment = decimalDifference(lastValue, firstValue);
    increment = increment / (displayValues.length - 1);
    incrementType = IncrementType.NUMBER;
  }
  return {
    direction,
    increment,
    incrementType,
    initialSelectionValues: values,
    prefix,
    startingValue: direction === IncrementDirection.FORWARD ? lastValue : firstValue
  };
}

/**
 * Gets the string representation of the primary key for a given row. It needs to be a string because it will be
 * compared against the values coming from QueryModel.orderedRows, which are string representations of PK values.
 * @param row
 * @param queryInfo
 */
function getPkValue(row, queryInfo) {
  const keyCols = queryInfo.getPkCols();
  let key;
  if (keyCols.length === 1) {
    key = caseInsensitive(row.toJS(), keyCols[0].fieldKey);
    if (Array.isArray(key)) key = key[0];
    if (typeof key === 'object') key = key.value;
  }

  // The key may be anything (often it's a number because it's RowId), so we coerce it to a string
  return key?.toString();
}
function checkCellReadStatus(row, queryInfo, columnMetadata, readonlyRows, lockedRows) {
  if (readonlyRows || columnMetadata?.isReadOnlyCell || lockedRows) {
    const keyCols = queryInfo.getPkCols();
    if (keyCols.length === 1) {
      const key = getPkValue(row, queryInfo);
      return {
        isReadonlyRow: readonlyRows && key ? readonlyRows.includes(key) : false,
        isReadonlyCell: columnMetadata?.isReadOnlyCell ? columnMetadata.isReadOnlyCell(key) : false,
        isLockedRow: lockedRows && key ? lockedRows.includes(key) : false
      };
    } else {
      console.warn('Setting readonly rows or cells for models with ' + keyCols.length + ' keys is not currently supported.');
    }
  }
  return {
    isReadonlyRow: false,
    isReadonlyCell: false,
    isLockedRow: false
  };
}

/**
 * Returns only the newly selected area given an initial selection and a final selection. These are the keys that will
 * be filled with generated data based on the initially selected data.
 * @param initialSelection The area initially selected
 * @param finalSelection The final area selected, including the initially selected area
 */
function generateFillCellKeys(initialSelection, finalSelection) {
  const firstInitial = parseCellKey(initialSelection[0]);
  const lastInitial = parseCellKey(initialSelection[initialSelection.length - 1]);
  const minCol = firstInitial.colIdx;
  const maxCol = lastInitial.colIdx;
  const initialMinRow = firstInitial.rowIdx;
  const initialMaxRow = lastInitial.rowIdx;
  const finalMinRow = parseCellKey(finalSelection[0]).rowIdx;
  const finalMaxRow = parseCellKey(finalSelection[finalSelection.length - 1]).rowIdx;
  let start;
  let end;
  if (finalMaxRow > initialMaxRow) {
    // Final selected area is below the initial selection, so we will be incrementing from the row after
    // initialMaxRow
    start = initialMaxRow + 1;
    end = finalMaxRow;
  } else {
    // Newly selected area is above the initial selection, so we will be incrementing from finalMinRow
    start = finalMinRow;
    end = initialMinRow - 1;
  }
  const fillCellKeys = [];

  // Construct arrays of columns, because we're going to generate fill sequences for columns
  for (let colIdx = minCol; colIdx <= maxCol; colIdx++) {
    const columnKeys = [];
    for (let rowIdx = start; rowIdx <= end; rowIdx++) {
      columnKeys.push(genCellKey(colIdx, rowIdx));
    }
    fillCellKeys.push(columnKeys);
  }
  return fillCellKeys;
}
function parsePastedLookup(column, descriptors, value) {
  const originalValues = (0,external_immutable_.List)([{
    display: value,
    raw: value
  }]);
  if (column.required && (value == null || value === '')) {
    return {
      values: originalValues,
      message: {
        message: column.caption + ' is required.'
      }
    };
  }
  if (value === undefined || value === null || value.toString().trim() === '' || typeof value !== 'string') {
    return {
      values: originalValues
    };
  }
  let message;
  const unmatched = [];

  // parse pasted strings to split properly around quoted values.
  // Remove the quotes for storing the actual values in the grid.
  const values = parseCsvString(value, ',', true).map(v => {
    const vt = v.trim();
    if (vt.length > 0) {
      const vl = vt.toLowerCase();
      const vd = descriptors.find(d => d.display && d.display.toString().toLowerCase() === vl);
      if (!vd) {
        unmatched.push(vt);
        return {
          display: vt,
          raw: vt
        };
      } else {
        return vd;
      }
    }
  }).filter(v => v !== undefined);
  if (unmatched.length) {
    message = {
      message: 'Could not find data for ' + unmatched.slice(0, 4).map(u => '"' + u + '"').join(', ')
    };
  }
  return {
    message,
    values: (0,external_immutable_.List)(values)
  };
}
async function getParsedLookup(column, lookupColumnContainerCache, display, value, cellKey, forUpdate, targetContainerPath, dataKeys, data) {
  const containerPath = forUpdate ? getFolderValueFromDataRow(cellKey, dataKeys, data) : targetContainerPath;
  const cacheKey = `${column.fieldKey}||${containerPath}`;
  let descriptors = lookupColumnContainerCache[cacheKey];
  if (!descriptors) {
    const response = await findLookupValues(column, undefined, display, undefined, forUpdate, containerPath);
    descriptors = response.descriptors;
    lookupColumnContainerCache[cacheKey] = descriptors;
  }
  return parsePastedLookup(column, descriptors, value);
}

/**
 * Fills a column of cells based on the initially selected values.
 * If the initialSelection is for a single cell, the fill operation will always be a copy of that value.
 * If the initialSelection includes a range of cells and all values are numeric (or numbers prefixed with the same
 * string), fill via a generated sequence where the step/diff is based on the first and last value in the initSelection.
 * if the initialSelection is a single row, and the value is a date (as determined by the date format set by the server)
 * then we will fill via a generated sequence that increments the date by one day each row.
 * If the initialSelection includes a range of cells and not all values are numeric, fill via a copy of all of the values
 * in initSelection.
 * @param editorModel An EditorModel object
 * @param column
 * @param columnMetadata
 * @param cellMessages The CellMessages object to mutate, we cannot use the one from EditorModel because we may need to
 * modify multiple columns of data in one event (see dragFillEvent).
 * @param cellValues The CellValues object to mutate, we cannot use the one from EditorModel because we may need to
 * modify multiple columns of data in one event (see dragFillEvent).
 * @param initialSelection An array of sorted cell keys, all from the same column that were initially selected
 * @param selectionToFill An array of sorted cell keys, all from the same column, to be filled with values based on the
 * content of initialSelection
 * @param forUpdate True if this is operating on update query filters.
 * @param dataKeys The orderedRows Object from a QueryModel
 * @param data The rows object from a QueryModel
 */
async function fillColumnCells(editorModel, column, columnMetadata, cellMessages, cellValues, initialSelection, selectionToFill, forUpdate, targetContainerPath, dataKeys, data) {
  const {
    direction,
    increment,
    incrementType,
    prefix,
    startingValue,
    initialSelectionValues
  } = inferSelectionIncrement(editorModel, initialSelection, selectionToFill);
  if (direction === IncrementDirection.BACKWARD) {
    selectionToFill.reverse();
  }
  selectionToFill.forEach((cellKey, i) => {
    let fillValue = initialSelectionValues[i % initialSelectionValues.length];
    if (incrementType === IncrementType.NUMBER) {
      const amount = increment * (i + 1);
      let raw;
      if (direction === IncrementDirection.FORWARD) {
        raw = decimalDifference(amount, startingValue, false);
      } else {
        raw = decimalDifference(startingValue, amount, true);
      }
      if (prefix !== undefined) raw = prefix + raw;
      const display = raw.toString();
      fillValue = (0,external_immutable_.List)([{
        raw,
        display
      }]);
    } else if (incrementType === IncrementType.DATE || incrementType === IncrementType.DATETIME) {
      const dateValue = external_moment_default()(parseDate(startingValue));
      if (direction === IncrementDirection.FORWARD) {
        dateValue.add(i + 1, 'days');
      } else {
        dateValue.subtract(i + 1, 'days');
      }
      const raw = incrementType === IncrementType.DATE ? formatDate(dateValue.toDate()) : formatDateTime(dateValue.toDate());
      fillValue = (0,external_immutable_.List)([{
        raw,
        display: raw
      }]);
    }
    cellValues = cellValues.set(cellKey, fillValue);
  });
  const filteredLookupValues = columnMetadata?.filteredLookupValues?.toArray();
  const lookupColumnContainerCache = {};
  for (const cellKey of selectionToFill) {
    // If the column is a lookup, then we need to query for the rowIds so we can set the correct raw values,
    // otherwise insert will fail. This is most common for cross-folder sample selection (Issue 50363)
    if (column.isPublicLookup()) {
      const display = cellValues.get(cellKey).map(v => v.display).toArray();
      const {
        message,
        values
      } = await getParsedLookup(column, lookupColumnContainerCache, display, filteredLookupValues ?? display.join(','), cellKey, forUpdate, targetContainerPath, dataKeys, data);
      cellValues = cellValues.set(cellKey, values);
      cellMessages = cellMessages.set(cellKey, message);
    } else {
      const {
        message
      } = getValidatedEditableGridValue(cellValues.get(cellKey)?.get(0)?.display, column);
      cellMessages = cellMessages.set(cellKey, message);
    }
  }
  return {
    cellValues,
    cellMessages
  };
}
function getFolderValueFromDataRow(cellKey, dataKeys, data) {
  const {
    rowIdx
  } = parseCellKey(cellKey);
  const dataRow = data.get(dataKeys.get(rowIdx))?.toJS();
  const value = getValueFromRow(dataRow, 'Folder') ?? getValueFromRow(dataRow, 'Container');
  return value?.toString();
}
/**
 * @param editorModel
 * @param initialSelection The initial selection before the selection was expanded
 * @param dataKeys The orderedRows Object from a QueryModel
 * @param data The rows object from a QueryModel
 * @param queryInfo A QueryInfo
 * @param columns
 * @param columnMetadata Array of column metadata, in the same order as the columns in the grid
 * @param readonlyRows A list of readonly rows
 * @param lockedRows A list of locked rows
 * @param forUpdate True if this is operating on update query filters.
 * @param targetContainerPath The container path to use when looking up lookup values in the forUpdate false case
 */
async function dragFillEvent(editorModel, initialSelection, dataKeys, data, queryInfo, columns, columnMetadata, readonlyRows, lockedRows, forUpdate, targetContainerPath) {
  const finalSelection = editorModel.selectionCells;
  let cellValues = editorModel.cellValues;
  let cellMessages = editorModel.cellMessages;

  // If the selection size hasn't changed, then the selection hasn't changed, so return the existing cellValues
  if (finalSelection.length === initialSelection.length) return {
    cellMessages,
    cellValues
  };
  const selectionToFill = generateFillCellKeys(initialSelection, finalSelection);
  for (const columnCells of selectionToFill) {
    const {
      colIdx
    } = parseCellKey(columnCells[0]);
    const initialSelectionByCol = initialSelection.filter(cellKey => parseCellKey(cellKey).colIdx === colIdx);
    const column = columns[colIdx];
    const metadata = columnMetadata[colIdx];

    // Don't manipulate any values in read only columns
    if (column.readOnly) {
      continue;
    }
    const selectionToFillByCol = columnCells.filter(cellKey => {
      const {
        rowIdx
      } = parseCellKey(cellKey);
      const row = data.get(dataKeys.get(rowIdx));
      const {
        isReadonlyCell,
        isReadonlyRow,
        isLockedRow
      } = checkCellReadStatus(row, queryInfo, metadata, readonlyRows, lockedRows);
      return !isReadonlyCell && !isReadonlyRow && !isLockedRow;
    });

    // eslint-disable-next-line no-await-in-loop
    const messagesAndValues = await fillColumnCells(editorModel, column, metadata, cellMessages, cellValues, initialSelectionByCol, selectionToFillByCol, forUpdate, targetContainerPath, dataKeys, data);
    cellValues = messagesAndValues.cellValues;
    cellMessages = messagesAndValues.cellMessages;
  }
  return {
    cellMessages,
    cellValues
  };
}

/**
 * Expands the pasted data in the X and/or Y direction if the user has selected an area that is a multiple of X or Y.
 *
 * For example:
 * If the user copied two rows and two columns to their clipboard, but selected four rows and two columns on the grid we
 * would paste the contents twice across the four selected rows. If they had selected two rows and four columns we would
 * paste the contents twice across the selected columns.
 */
function expandPaste(model, payload) {
  const selection = model.selectionCells;
  const minSelection = parseCellKey(selection[0]);
  const maxSelection = parseCellKey(selection[selection.length - 1]);
  const selectionColCount = maxSelection.colIdx - minSelection.colIdx + 1;
  const selectionRowCount = maxSelection.rowIdx - minSelection.rowIdx + 1;
  let {
    data,
    numCols,
    numRows
  } = payload;
  if (selectionColCount > payload.numCols && selectionColCount % payload.numCols === 0) {
    const colCopyMultiple = selectionColCount / payload.numCols;
    numCols = payload.numCols * colCopyMultiple;
    data = data.reduce((reduction, row) => {
      let updatedRow = row;
      for (let i = 0; i < colCopyMultiple - 1; i++) {
        updatedRow = updatedRow.concat(row).toList();
      }
      return reduction.push(updatedRow);
    }, (0,external_immutable_.List)());
  }
  if (selectionRowCount > payload.numRows && selectionRowCount % payload.numRows === 0) {
    const rowCopyMultiple = selectionRowCount / payload.numRows;
    numRows = payload.numRows * rowCopyMultiple;
    const originalRows = data;
    for (let i = 0; i < rowCopyMultiple - 1; i++) {
      data = data.concat(originalRows).toList();
    }
  }
  return {
    data,
    numCols,
    numRows
  };
}
function validatePaste(model, colMin, rowMin, value, readOnlyRowCount) {
  const maxRowPaste = 1000;
  let success = true;
  let message;
  let payload = parsePaste(value);
  if (model.isMultiSelect) {
    payload = expandPaste(model, payload);
  }
  const coordinates = {
    colMax: colMin + payload.numCols - 1,
    colMin,
    rowMax: rowMin + payload.numRows - 1,
    rowMin
  };

  // If P = 1 then target can be 1 or M
  // If P = M(x,y) then target can be 1 or exact M(x,y)
  if (coordinates.colMax >= model.columns.size) {
    success = false;
    message = 'Unable to paste. Cannot paste columns beyond the columns found in the grid.';
  } else if (coordinates.rowMax - coordinates.rowMin > maxRowPaste) {
    success = false;
    message = 'Unable to paste. Cannot paste more than ' + maxRowPaste + ' rows.';
  }
  return {
    coordinates,
    message,
    payload,
    rowsToAdd: Math.max(0, coordinates.rowMin + payload.numRows + (readOnlyRowCount ? readOnlyRowCount : 0) - model.rowCount),
    success
  };
}
function parsePaste(value) {
  let numCols = 0;
  let data = (0,external_immutable_.List)();
  if (value === undefined || value === null || typeof value !== 'string') {
    return {
      data,
      numCols,
      numRows: 0
    };
  }

  // remove trailing newline from pasted data to avoid creating an empty row of cells
  if (value.endsWith('\n')) value = value.substring(0, value.length - 1);
  value.split('\n').forEach(rv => {
    const columns = (0,external_immutable_.List)(rv.split('\t'));
    if (numCols < columns.size) {
      numCols = columns.size;
    }
    data = data.push(columns);
  });

  // Normalize the number columns in each row in case a user pasted rows with different numbers of columns in them
  data = data.map(columns => {
    if (columns.size < numCols) {
      const remainder = [];
      for (let i = columns.size; i < numCols; i++) {
        remainder.push('');
      }
      return columns.push(...remainder);
    }
    return columns;
  }).toList();
  return {
    data,
    numCols,
    numRows: data.size
  };
}
function isReadonlyRow(row, pkCols, readonlyRows) {
  if (pkCols.length === 1 && row) {
    // Coerce pkValue to string because it may actually be a number or other type, and readonlyRows is string[]
    const pkValue = caseInsensitive(row.toJS(), pkCols[0].fieldKey)?.toString();
    return readonlyRows.includes(pkValue);
  }
  return false;
}
async function insertPastedData(dataKeys, data, queryInfo, columns, editorModel, paste, columnMetadata, readonlyRows, lockedRows, lockRowCount, forUpdate, targetContainerPath, selectCells) {
  const pastedData = paste.payload.data;
  let cellMessages = editorModel.cellMessages;
  let cellValues = editorModel.cellValues;
  const selectionCells = [];
  let rowCount = editorModel.rowCount;
  let updatedDataKeys;
  let updatedData;
  if (paste.rowsToAdd > 0 && !lockRowCount) {
    rowCount += paste.rowsToAdd;
    const dataChanges = addRowsToGridData(dataKeys, data, paste.rowsToAdd);
    updatedData = dataChanges.data;
    updatedDataKeys = dataChanges.dataKeys;
  }
  const byColumnValues = getPasteValuesByColumn(paste);
  const lookupColumnContainerCache = {};
  const {
    colMin,
    rowMin
  } = paste.coordinates;
  const pkCols = queryInfo.getPkCols();
  let rowIdx = rowMin;
  let hasReachedRowLimit = false;
  let allReadOnlyRows;
  if (readonlyRows && lockedRows) {
    allReadOnlyRows = readonlyRows.concat(lockedRows);
  } else if (readonlyRows) {
    allReadOnlyRows = readonlyRows;
  } else if (lockedRows) {
    allReadOnlyRows = lockedRows;
  }
  for (let r = 0; r < pastedData.size; r++) {
    const row = pastedData.get(r);
    if (hasReachedRowLimit && lockRowCount) return;
    if (allReadOnlyRows) {
      while (rowIdx < rowCount && isReadonlyRow(data.get(dataKeys.get(rowIdx)), pkCols, allReadOnlyRows)) {
        // Skip over readonly rows
        rowIdx++;
      }
      if (rowIdx >= rowCount) {
        hasReachedRowLimit = true;
        return;
      }
    }
    let pkValue = getPkValue(row, queryInfo);
    if (!pkValue) pkValue = dataKeys.get(rowIdx);
    for (let cn = 0; cn < row.size; cn++) {
      const val = row.get(cn);
      const colIdx = colMin + cn;
      const cellKey = genCellKey(colIdx, rowIdx);
      const col = columns[colIdx];
      const metadata = columnMetadata?.get(col?.fieldKey.toLowerCase());
      const readOnlyCol = col?.readOnly || metadata?.readOnly;
      const readOnlyCell = metadata?.isReadOnlyCell(pkValue);
      if (!readOnlyCol && !readOnlyCell) {
        let cv;
        let msg;
        if (col?.isPublicLookup()) {
          // If the column is a lookup and forUpdate is true, then we need to query for the rowIds so we can set the correct raw values,
          // otherwise insert will fail. This is most common for cross-folder sample selection (Issue 50363)
          const display = byColumnValues.get(cn)?.toArray();
          const {
            message,
            values
          } = await getParsedLookup(col, lookupColumnContainerCache, display, val, cellKey, forUpdate, targetContainerPath, dataKeys, data);
          cv = values;
          msg = message;
        } else {
          const {
            message,
            value
          } = getValidatedEditableGridValue(val, col);
          cv = (0,external_immutable_.List)([{
            display: value,
            raw: value
          }]);
          msg = message;
        }
        cellMessages = cellMessages.set(cellKey, msg);
        cellValues = cellValues.set(cellKey, cv);
      }
      if (selectCells) {
        selectionCells.push(cellKey);
      }
    }
    rowIdx++;
  }
  return {
    editorModel: {
      cellMessages,
      cellValues,
      rowCount,
      selectionCells
    },
    data: updatedData,
    dataKeys: updatedDataKeys
  };
}
function getReadonlyRowCount(rowCount, dataKeys, data, queryInfo, startRowInd, readonlyRows) {
  const pkCols = queryInfo.getPkCols();

  // Rows with multiple PKs are always read-only
  if (pkCols.length !== 1) {
    return rowCount - startRowInd;
  }
  return dataKeys.slice(startRowInd, rowCount).reduce((total, index) => {
    if (isReadonlyRow(data.get(dataKeys.get(index)), pkCols, readonlyRows)) total++;
    return total;
  }, 0);
}

// Gets the non-blank values pasted for each column.  The values in the resulting lists may not align to the rows
// pasted if there were empty cells within the paste block.
function getPasteValuesByColumn(paste) {
  const {
    data
  } = paste.payload;
  const valuesByColumn = (0,external_immutable_.List)().asMutable();
  for (let i = 0; i < data.get(0).size; i++) {
    valuesByColumn.push((0,external_immutable_.List)().asMutable());
  }
  data.forEach(row => {
    row.forEach((value, index) => {
      // if values contain commas, users will need to paste the values enclosed in quotes
      // but we don't want to retain these quotes for purposes of selecting values in the grid
      parseCsvString(value, ',', true).forEach(v => {
        if (v.trim().length > 0) valuesByColumn.get(index).push(v.trim());
      });
    });
  });
  return valuesByColumn.asImmutable();
}
async function validateAndInsertPastedData(editorModel, dataKeys, data, queryInfo, columns, value, columnMetadata, readonlyRows, lockedRows, lockRowCount, forUpdate, targetContainerPath, selectCells) {
  const {
    selectedColIdx,
    selectedRowIdx
  } = editorModel;
  const readOnlyRowCount = readonlyRows && !lockRowCount ? getReadonlyRowCount(editorModel.rowCount, dataKeys, data, queryInfo, selectedRowIdx, readonlyRows) : 0;
  const paste = validatePaste(editorModel, selectedColIdx, selectedRowIdx, value, readOnlyRowCount);
  if (paste.success) {
    return insertPastedData(dataKeys, data, queryInfo, columns, editorModel, paste, columnMetadata, readonlyRows, lockedRows, lockRowCount, forUpdate, targetContainerPath, selectCells);
  } else {
    const cellKey = genCellKey(selectedColIdx, selectedRowIdx);
    return {
      data: undefined,
      dataKeys: undefined,
      editorModel: {
        cellMessages: editorModel.cellMessages.set(cellKey, {
          message: paste.message
        })
      }
    };
  }
}
async function pasteEvent(editorModel, dataKeys, data, queryInfo, columns, event, columnMetadata, readonlyRows, lockedRows, lockRowCount, forUpdate, targetContainerPath) {
  // If a cell has focus do not accept incoming paste events -- allow for normal paste to input
  if (editorModel && editorModel.hasSelection && !editorModel.hasFocus) {
    cancelEvent(event);
    const value = getPasteValue(event);
    return await validateAndInsertPastedData(editorModel, dataKeys, data, queryInfo, columns, value, columnMetadata, readonlyRows, lockedRows, lockRowCount, forUpdate, targetContainerPath, true);
  }
  return {
    data: undefined,
    dataKeys: undefined,
    editorModel: undefined
  };
}
function getCellCopyValue(valueDescriptors) {
  let value = '';
  if (valueDescriptors && valueDescriptors.size > 0) {
    let sep = '';
    value = valueDescriptors.reduce((agg, vd) => {
      agg += sep + (vd.display !== undefined ? vd.display.toString().trim() : '');
      sep = ', ';
      return agg;
    }, value);
  }
  return value;
}
function getCopyValue(model, insertColumns) {
  let copyValue = '';
  const EOL = '\n';
  const selectionCells = [...model.selectionCells];
  selectionCells.push(genCellKey(model.selectedColIdx, model.selectedRowIdx));
  for (let rn = 0; rn < model.rowCount; rn++) {
    let cellSep = '';
    let inSelection = false;
    insertColumns.forEach((col, cn) => {
      const cellKey = genCellKey(cn, rn);
      if (selectionCells.find(key => key === cellKey)) {
        inSelection = true;
        copyValue += cellSep + getCellCopyValue(model.cellValues.get(cellKey));
        cellSep = '\t';
      }
    });
    if (inSelection) {
      copyValue += EOL;
    }
  }
  if (copyValue[copyValue.length - 1] === EOL) {
    copyValue = copyValue.slice(0, copyValue.length - 1);
  }
  return copyValue;
}
function copyEvent(editorModel, insertColumns, event) {
  if (editorModel && !editorModel.hasFocus && editorModel.hasSelection && !editorModel.isSparseSelection) {
    cancelEvent(event);
    setCopyValue(event, getCopyValue(editorModel, insertColumns));
    return true;
  }
  return false;
}
;// CONCATENATED MODULE: ./src/internal/query/reports.ts


/**
 * FlattenResponse converts the response body (a nested tree structure) from browseDataTree into a flat list of
 * ReportItem objects. This method purposely ignores categories and their nested structures.
 *
 * @param response: the body from the browseDataTree API Action
 * @param urlMapper: ReportURLMapper
 */
function flattenBrowseDataTreeResponse(response, urlMapper) {
  function _flattenBrowseDataTreeResponse(all, item) {
    if (item.hasOwnProperty('children')) {
      return [...all, ...item.children.reduce(_flattenBrowseDataTreeResponse, [])];
    } else {
      if (urlMapper) {
        const appUrl = urlMapper(item);
        if (appUrl !== item.runUrl) {
          item.appUrl = appUrl;
        }
      }
      return [...all, item];
    }
  }
  return _flattenBrowseDataTreeResponse([], response);
}
function loadReports(urlMapper) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      method: 'GET',
      url: buildURL('reports', 'browseDataTree.api'),
      success: request => {
        const reports = flattenBrowseDataTreeResponse(JSON.parse(request.responseText), urlMapper);
        resolve(reports);
      },
      failure: api_.Utils.getCallbackWrapper(error => {
        reject(error);
      }, this, true)
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/url/AppURLResolver.ts
function AppURLResolver_defineProperty(e, r, t) { return (r = AppURLResolver_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function AppURLResolver_toPropertyKey(t) { var i = AppURLResolver_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function AppURLResolver_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








/**
 * Resolves list routes dynamically
 * /q/lists/$CPS<container_path>$CPE/22/14/... -> /q/lists/listByName/14/...
 */
class ListResolver {
  // Map<containerPath|listId, listName>

  constructor(lists) {
    AppURLResolver_defineProperty(this, "fetched", void 0);
    AppURLResolver_defineProperty(this, "lists", void 0);
    this.fetched = false;
    this.lists = lists !== undefined ? lists : (0,external_immutable_.Map)();
  }
  matches(route) {
    return /\/q\/lists\/(\$CPS.+\$CPE)\/(\d+$|\d+)\/*/.test(decodeURIComponent(route));
  }
  async fetch(parts) {
    // ["q", "lists", "/container/path", "44", ...]
    const containerPathIndex = 2;
    const listIdIndex = 3;
    const listIdNum = parseInt(parts[listIdIndex], 10);
    const containerPath = decodeListResolverPath(decodeURIComponent(parts[containerPathIndex]))?.toLowerCase();
    const key = [containerPath, listIdNum].join('|');
    if (isNaN(listIdNum) || !containerPath) {
      // skip it
      return;
    } else if (this.lists.has(key)) {
      // resolve it
      const newParts = [this.lists.get(key)];
      return spliceURL(parts, newParts, containerPathIndex, 2);
    } else if (this.fetched) {
      // skip it
      return undefined;
    }

    // fetch it
    try {
      const result = await selectRows({
        schemaQuery: SCHEMAS.LIST_METADATA_TABLES.LIST_MANAGER,
        columns: 'ListId,Name,Container/Path'
      });
      this.fetched = true;

      // fulfill local cache
      this.lists = result.rows.reduce((map, list) => {
        const _containerPath = caseInsensitive(list, 'Container/Path').value.toLowerCase();
        const _listId = caseInsensitive(list, 'ListId').value;
        const _name = caseInsensitive(list, 'Name').value.toLowerCase();
        const _key = [_containerPath, _listId].join('|');
        return map.set(_key, _name);
      }, (0,external_immutable_.Map)().asMutable()).asImmutable();

      // respond
      if (this.lists.has(key)) {
        // resolve it
        const newParts = [this.lists.get(key)];
        return spliceURL(parts, newParts, containerPathIndex, 2);
      }
    } catch (e) {
      // skip it
    }

    // skip it
    return undefined;
  }
}

/**
 * Resolves experiment runs to workflow jobs if appropriate
 * /rd/run/14/... -> /workflow/14/...
 * If this doesn't correspond to a job, the link won't resolve.
 *
 * Ideally we would resolve to the original URL if it's not a job, but since that's a link out to LKS
 * it's not currently supported by AppRouteResolvers.  Alternatively, and perhaps more ideally, we'd resolve
 * to the lineage page for a sample, but the URL here doesn't have any info about the related entity.
 */
class ExperimentRunResolver {
  // set of rowIds that are jobs

  static createURL(rowId) {
    return AppURL.create('rd', 'run', rowId);
  }
  constructor(jobs) {
    AppURLResolver_defineProperty(this, "jobs", void 0);
    this.jobs = jobs !== undefined ? jobs : new Set();
  }
  async fetch(parts) {
    const rowIdIndex = 2;
    const rowId = parseInt(parts[rowIdIndex], 10);
    if (isNaN(rowId)) {
      // skip it
      return undefined;
    }
    if (this.jobs.has(rowId)) {
      // resolve it
      return AppURL.create('workflow', rowId);
    }
    try {
      const result = await selectRows({
        schemaQuery: SAMPLE_MANAGEMENT.JOBS,
        filterArray: [api_.Filter.create('RowId', rowId)],
        columns: 'RowId'
      });
      if (result.rows.length > 0) {
        // resolve it
        this.jobs.add(rowId);
        return AppURL.create('workflow', rowId);
      } else {
        return AppURL.create('rd', 'assayrun', rowId);
      }
    } catch (e) {
      // skip it
    }

    // skip it
    return undefined;
  }
  matches(route) {
    return /\/rd\/run\/\d+$/.test(route);
  }
}
;// CONCATENATED MODULE: ./src/public/useEnterEscape.ts


/**
 * Enumeration of values for the KeyboardEvent.key
 * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
 */
let Key = /*#__PURE__*/function (Key) {
  Key["ARROW_DOWN"] = "ArrowDown";
  Key["ARROW_LEFT"] = "ArrowLeft";
  Key["ARROW_RIGHT"] = "ArrowRight";
  Key["ARROW_UP"] = "ArrowUp";
  Key["BACKSPACE"] = "Backspace";
  Key["END"] = "End";
  Key["ENTER"] = "Enter";
  Key["ESCAPE"] = "Escape";
  Key["HOME"] = "Home";
  Key["TAB"] = "Tab";
  return Key;
}({});
/**
 * React hook useful for when you want to intercept enter and escape keys (e.g. for a text input where enter is save
 * and escape is cancel). Pass the result of this hook to the onKeyDown prop of an <input /> element.
 * @param onEnter: function to call when the enter key is pressed.
 * @param onEscape: function to call when the escape key is pressed.
 */
const useEnterEscape = (onEnter, onEscape) => {
  return (0,external_react_.useCallback)(evt => {
    if (evt.shiftKey || evt.metaKey) return;
    switch (evt.key) {
      case Key.ENTER:
        evt.stopPropagation();
        evt.preventDefault();
        onEnter?.();
        break;
      case Key.ESCAPE:
        evt.stopPropagation();
        evt.preventDefault();
        onEscape?.();
        break;
      default:
        break;
    }
  }, [onEnter, onEscape]);
};
;// CONCATENATED MODULE: ./src/internal/components/samples/DisableableMenuItem.tsx





const SAMPLE_OPERATION_NOT_PERMITTED_MESSAGE = 'The current status of the sample does not permit this operation.';
const DisableableMenuItem = (0,external_react_.memo)(props => {
  const {
    children,
    className,
    disabledMessage = SAMPLE_OPERATION_NOT_PERMITTED_MESSAGE,
    disabled = false,
    href,
    onClick,
    placement = 'left'
  } = props;
  const {
    onMouseEnter,
    onMouseLeave,
    portalEl,
    show,
    targetRef
  } = useOverlayTriggerState('disableable-menu-item', true, false);
  if (!disabled) {
    return /*#__PURE__*/external_react_default().createElement(MenuItem, {
      className: className,
      href: href,
      onClick: onClick
    }, children);
  }
  const overlay = /*#__PURE__*/external_react_default().createElement(Popover, {
    id: "disable-operation-warning",
    className: "disabled-menu-item-popover popover-message",
    placement: placement,
    targetRef: targetRef
  }, disabledMessage);
  return /*#__PURE__*/external_react_default().createElement(MenuItem, {
    className: className,
    disabled: true,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: targetRef
  }, children, show && (0,external_react_dom_.createPortal)(overlay, portalEl));
});
DisableableMenuItem.displayName = 'DisableableMenuItem';
;// CONCATENATED MODULE: ./src/internal/components/forms/LabelOverlay.tsx
function LabelOverlay_defineProperty(e, r, t) { return (r = LabelOverlay_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LabelOverlay_toPropertyKey(t) { var i = LabelOverlay_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LabelOverlay_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







class LabelOverlay extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    LabelOverlay_defineProperty(this, "_popoverId", void 0);
    LabelOverlay_defineProperty(this, "overlayBody", () => {
      const {
        column,
        required,
        description,
        type,
        children,
        helpTipRenderer
      } = this.props;
      if (column?.helpTipRenderer || helpTipRenderer) {
        return /*#__PURE__*/external_react_default().createElement(HelpTipRenderer, {
          type: column?.helpTipRenderer || helpTipRenderer,
          column: column
        }, children);
      }
      return /*#__PURE__*/external_react_default().createElement(DomainFieldHelpTipContents, {
        column: column,
        required: required,
        description: description,
        type: type
      }, children);
    });
    this._popoverId = generateId();
  }
  overlayContent() {
    const {
      column,
      helpTipRenderer,
      placement
    } = this.props;
    const label = this.props.label ? this.props.label : column ? column.caption : null;
    const _helpTipRenderer = column?.helpTipRenderer || helpTipRenderer;
    const popoverClassName = _helpTipRenderer && _helpTipRenderer !== DOMAIN_FIELD && placement === 'right' ? 'label-help-arrow-top' : undefined;
    const body = this.overlayBody();
    return /*#__PURE__*/external_react_default().createElement(Popover, {
      id: this._popoverId,
      title: label,
      placement: placement,
      className: popoverClassName
    }, body);
  }
  getOverlay() {
    const {
      helpTipRenderer
    } = this.props;
    if (helpTipRenderer === 'NONE') return null;
    return /*#__PURE__*/external_react_default().createElement(OverlayTrigger, {
      id: this._popoverId,
      overlay: this.overlayContent()
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-question-circle"
    }));
  }
  render() {
    const {
      column,
      inputId,
      isFormsy,
      labelClass,
      required,
      addLabelAsterisk
    } = this.props;
    const label = this.props.label ? this.props.label : column ? column.caption : null;
    const overlay = this.getOverlay();
    if (isFormsy) {
      // when being used as a label for a formsy component directly this will use just a span without the
      // classes applied as well as not needing to handle 'required' display
      return /*#__PURE__*/external_react_default().createElement("span", null, label, "\xA0", required || addLabelAsterisk ? /*#__PURE__*/external_react_default().createElement("span", {
        className: "required-symbol"
      }, "* ") : null, overlay);
    }
    return /*#__PURE__*/external_react_default().createElement("label", {
      className: (labelClass ? labelClass + ' ' : '') + 'text__truncate-and-wrap',
      htmlFor: inputId
    }, /*#__PURE__*/external_react_default().createElement("span", null, label), "\xA0", required || addLabelAsterisk ? /*#__PURE__*/external_react_default().createElement("span", {
      className: "required-symbol"
    }, "* ") : null, overlay);
  }
}
LabelOverlay_defineProperty(LabelOverlay, "defaultProps", {
  isFormsy: true,
  addLabelAsterisk: false,
  labelClass: INPUT_LABEL_CLASS_NAME,
  placement: 'right'
});
;// CONCATENATED MODULE: ./src/internal/renderers.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */












function isFilterColumnNameMatch(filter, col) {
  return filter.getColumnName() === col.name || filter.getColumnName() === col.resolveFieldKey();
}
// exported for jest tests
const EditableColumnTitle = (0,external_react_.memo)(props => {
  const {
    column,
    editing,
    hideToolTip,
    onChange,
    onCancel
  } = props;
  const initialTitle = (0,external_react_.useMemo)(() => {
    return column.caption ?? column.name;
  }, [column.caption, column.name]);
  const [title, setTitle] = (0,external_react_.useState)(initialTitle);
  const showLabelOverlay = (0,external_react_.useMemo)(() => {
    return !hideToolTip && column.hasHelpTipData;
  }, [column, hideToolTip]);
  const titleInput = external_react_default().createRef();
  (0,external_react_.useEffect)(() => {
    setTitle(initialTitle);
  }, [initialTitle]);
  const onTitleChange = (0,external_react_.useCallback)(evt => {
    setTitle(evt.target.value);
  }, []);
  const onCancelEdit = (0,external_react_.useCallback)(() => {
    onCancel();
    setTitle(initialTitle);
  }, [initialTitle, onCancel]);
  const onEditFinish = (0,external_react_.useCallback)(() => {
    const trimmedTitle = title?.trim();
    if (trimmedTitle && trimmedTitle !== initialTitle) {
      onChange(trimmedTitle);
      return;
    }
    setTitle(initialTitle);
    onCancel();
  }, [initialTitle, onCancel, onChange, title]);
  const onKeyDown = useEnterEscape(onEditFinish, onCancelEdit);
  if (initialTitle === '&nbsp;') {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null);
  }
  if (editing) {
    return /*#__PURE__*/external_react_default().createElement("input", {
      autoFocus: true,
      ref: titleInput,
      defaultValue: title,
      onKeyDown: onKeyDown,
      onChange: onTitleChange,
      onBlur: onEditFinish
    });
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !showLabelOverlay && initialTitle, showLabelOverlay && /*#__PURE__*/external_react_default().createElement(LabelOverlay, {
    column: column
  }));
});
const HeaderCellDropdownMenu = (0,external_react_.memo)(props => {
  const {
    allowColFilter,
    allowColSort,
    colFilters,
    handleAddColumn,
    handleFilter,
    handleHideColumn,
    handleSort,
    isSortAsc,
    isSortDesc,
    model,
    onEditTitleClicked,
    open,
    queryColumn,
    setOpen
  } = props;
  const showGridCustomization = handleHideColumn || handleAddColumn;
  const toggleEl = (0,external_react_.useRef)();
  const menuEl = (0,external_react_.useRef)();
  const portalRef = usePortalRef('header-cell-dropdown-menu-portal');
  // Note: We need to make sure we cancel all events in our menu handlers or we also trigger the click handler in
  // HeaderCellDropdown, which will reset the open value to true, which will keep the menu open.
  const openFilterPanel = (0,external_react_.useCallback)(() => {
    setOpen(false);
    handleFilter(queryColumn, false);
  }, [setOpen, handleFilter, queryColumn]);
  const removeFilter = (0,external_react_.useCallback)(() => {
    setOpen(false);
    handleFilter(queryColumn, true);
  }, [queryColumn, handleFilter, setOpen]);
  const sort = (0,external_react_.useCallback)(dir => {
    setOpen(false);
    handleSort(queryColumn, dir);
  }, [queryColumn, handleSort, setOpen]);
  // There is something wrong with the React Bootstrap types, the only way to get these callbacks properly typed is to
  // use "as SelectCallback", even though their type signature matches perfectly.
  const sortAsc = (0,external_react_.useCallback)(() => sort('+'), [sort]);
  const sortDesc = (0,external_react_.useCallback)(() => sort('-'), [sort]);
  const clearSort = (0,external_react_.useCallback)(() => sort(), [sort]);
  const hideColumn = (0,external_react_.useCallback)(() => {
    setOpen(false);
    handleHideColumn(queryColumn);
  }, [queryColumn, handleHideColumn, setOpen]);
  const addColumn = (0,external_react_.useCallback)(() => {
    setOpen(false);
    handleAddColumn(queryColumn);
  }, [queryColumn, handleAddColumn, setOpen]);
  const editColumnTitle = (0,external_react_.useCallback)(() => {
    onEditTitleClicked();
  }, [onEditTitleClicked]);
  const [menuStyle, setMenuStyle] = (0,external_react_.useState)({});
  const updateMenuStyle = (0,external_react_.useCallback)(() => {
    let top;
    let left;
    if (toggleEl.current && menuEl.current) {
      const headerRect = toggleEl.current.parentElement.getBoundingClientRect();
      const menuRect = menuEl.current.getBoundingClientRect();
      left = headerRect.x - menuRect.width + 18 + 'px';
      top = headerRect.y + headerRect.height + 5 + 'px';

      // Issue 45553
      // Render the dropdown menu above the header if the header is too close to the bottom of the screen.
      if (headerRect.bottom + menuRect.height > window.innerHeight) {
        top = headerRect.y - menuRect.height - 10 + 'px';
      }
    }
    setMenuStyle({
      left,
      // use visibility so we can know the rendered size of the menu before making it visible
      visibility: open ? 'visible' : 'hidden',
      top
    });
  }, [open]);

  // In order to close the menu when the user clicks outside of it we have to add a click handler to the document and
  // close the menu when the user clicks on anything outside of the menu.
  const documentClickHandler = (0,external_react_.useCallback)(event => {
    if (open && !menuEl.current.contains(event.target)) {
      setOpen(false);
    }
  }, [setOpen, open]);
  (0,external_react_.useEffect)(() => {
    document.addEventListener('click', documentClickHandler);
    return () => {
      document.removeEventListener('click', documentClickHandler);
    };
  }, [documentClickHandler]);

  // TODO: investigate passing down a ref of the .table-responsive div so we can add a scroll handler to it here the
  //  same way we add one to the document, then we can update the menu positions when the table is also scrolled.
  (0,external_react_.useEffect)(() => {
    updateMenuStyle();
    window.addEventListener('scroll', updateMenuStyle);
    return () => {
      window.removeEventListener('scroll', updateMenuStyle);
    };
  }, [updateMenuStyle, open]);

  // Technically we don't need to add and remove this open class because it doesn't affect visibility, we do that
  // above via the visibility css property. We need this class so tests can look for the currently open menu.
  const className = external_classnames_default()('grid-header-cell__dropdown-menu dropdown-menu', {
    open
  });
  const body = /*#__PURE__*/external_react_default().createElement("ul", {
    className: className,
    ref: menuEl,
    style: menuStyle
  }, allowColFilter && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: openFilterPanel
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-filter grid-panel__menu-icon"
  }), "Filter..."), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    disabled: !colFilters || colFilters?.length === 0,
    onClick: removeFilter
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "grid-panel__menu-icon-spacer"
  }), "Remove filter", colFilters?.length > 1 ? 's' : ''), allowColSort && /*#__PURE__*/external_react_default().createElement(MenuDivider, null)), allowColSort && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(MenuItem, {
    disabled: isSortAsc,
    onClick: sortAsc
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-sort-amount-asc grid-panel__menu-icon"
  }), "Sort ascending"), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    disabled: isSortDesc,
    onClick: sortDesc
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-sort-amount-desc grid-panel__menu-icon"
  }), "Sort descending"), model && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    disabled: !isSortDesc && !isSortAsc,
    onClick: clearSort
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "grid-panel__menu-icon-spacer"
  }), "Clear sort")), showGridCustomization && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, (allowColSort || allowColFilter) && /*#__PURE__*/external_react_default().createElement(MenuDivider, null), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: editColumnTitle
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-pencil grid-panel__menu-icon"
  }), "Edit Label"), handleAddColumn && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: addColumn
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-plus grid-panel__menu-icon"
  }), "Insert Column"), /*#__PURE__*/external_react_default().createElement(DisableableMenuItem, {
    disabled: !(handleHideColumn && !!model),
    onClick: hideColumn,
    disabledMessage: APP_FIELD_CANNOT_BE_REMOVED_MESSAGE
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-eye-slash grid-panel__menu-icon"
  }), "Hide Column")));
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "pull-right grid-panel__menu-toggle"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-chevron-circle-down",
    ref: toggleEl
  }), (0,external_react_dom_.createPortal)(body, portalRef));
});
// exported for jest testing
const HeaderCellDropdown = (0,external_react_.memo)(props => {
  const {
    column,
    handleSort,
    handleFilter,
    handleAddColumn,
    handleHideColumn,
    model,
    onColumnTitleChange,
    onColumnTitleEdit
  } = props;
  const queryColumn = column.raw;
  const [editingTitle, setEditingTitle] = (0,external_react_.useState)(false);
  const [open, setOpen] = (0,external_react_.useState)(false);
  const click = (0,external_react_.useCallback)(() => {
    setOpen(true);
  }, []);
  const allowColSort = handleSort && queryColumn?.sortable;
  const allowColFilter = handleFilter && queryColumn?.filterable;
  const allowColumnViewChange = (handleHideColumn || handleAddColumn) && !!model;
  const includeDropdown = allowColSort || allowColFilter || allowColumnViewChange;
  const onColumnTitleUpdate = (0,external_react_.useCallback)(newTitle => {
    setEditingTitle(false);
    onColumnTitleChange(queryColumn.mutate({
      caption: newTitle
    }));
    onColumnTitleEdit?.(queryColumn);
  }, [onColumnTitleChange, queryColumn, onColumnTitleEdit]);
  const editTitle = (0,external_react_.useCallback)(() => {
    setOpen(false);
    onColumnTitleEdit?.(queryColumn);
    setEditingTitle(true);
  }, [onColumnTitleEdit, queryColumn]);
  const cancelEditTitle = (0,external_react_.useCallback)(() => {
    setEditingTitle(false);
    onColumnTitleEdit?.(queryColumn);
  }, [onColumnTitleEdit, queryColumn]);
  const view = (0,external_react_.useMemo)(() => model?.queryInfo?.getView(model?.viewName, true), [model?.queryInfo, model?.viewName]);
  if (!queryColumn) return null;

  // using filterArray to indicate user-defined filters only and concatenating with any view filters
  let colFilters = model?.filterArray.filter(filter => isFilterColumnNameMatch(filter, queryColumn));
  const viewColFilters = view?.filters.filter(filter => isFilterColumnNameMatch(filter, queryColumn));
  if (viewColFilters?.length) colFilters = colFilters.concat(viewColFilters);
  // first check the model users (user-defined) and then fall back to the view sorts
  const colQuerySortDir = model?.sorts?.find(sort => sort.fieldKey === queryColumn.resolveFieldKey())?.dir ?? view?.sorts?.find(sort => sort.fieldKey === queryColumn.resolveFieldKey())?.dir;
  const isSortAsc = queryColumn.sorts === '+' || colQuerySortDir === '+' || colQuerySortDir === '';
  const isSortDesc = queryColumn.sorts === '-' || colQuerySortDir === '-';
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: GRID_HEADER_CELL_BODY,
    onClick: click
  }, /*#__PURE__*/external_react_default().createElement("span", null, /*#__PURE__*/external_react_default().createElement(EditableColumnTitle, {
    column: queryColumn,
    onChange: onColumnTitleUpdate,
    editing: editingTitle,
    onCancel: cancelEditTitle,
    hideToolTip: !!column.helpTipRenderer
  }), !editingTitle && colFilters?.length > 0 && /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-filter grid-panel__col-header-icon",
    title: colFilters?.length + ' filter' + (colFilters?.length > 1 ? 's' : '') + ' applied'
  }), !editingTitle && isSortAsc && /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-sort-amount-asc grid-panel__col-header-icon",
    title: "Sorted ascending"
  }), !editingTitle && isSortDesc && /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-sort-amount-desc grid-panel__col-header-icon",
    title: "Sorted descending"
  }), !editingTitle && column.helpTipRenderer && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    placement: "bottom",
    title: column.title,
    popoverClassName: column.helpTipRenderer === DOMAIN_FIELD ? undefined : 'label-help-arrow-left'
  }, /*#__PURE__*/external_react_default().createElement(HelpTipRenderer, {
    type: column.helpTipRenderer,
    column: queryColumn
  }))), includeDropdown && !editingTitle && /*#__PURE__*/external_react_default().createElement(HeaderCellDropdownMenu, {
    allowColFilter: allowColFilter,
    allowColSort: allowColSort,
    colFilters: colFilters,
    handleAddColumn: handleAddColumn,
    handleFilter: handleFilter,
    handleHideColumn: handleHideColumn,
    handleSort: handleSort,
    isSortAsc: isSortAsc,
    isSortDesc: isSortDesc,
    model: model,
    open: open,
    onEditTitleClicked: editTitle,
    queryColumn: queryColumn,
    setOpen: setOpen
  }));
});
function headerCell(i, column, selectable, columnCount, handleSort, handleFilter, handleAddColumn, handleHideColumn, onColumnTitleEdit, onColumnTitleChange, model) {
  return /*#__PURE__*/external_react_default().createElement(HeaderCellDropdown, {
    i: i,
    column: column,
    selectable: selectable,
    columnCount: columnCount,
    handleSort: handleSort,
    handleFilter: handleFilter,
    handleAddColumn: handleAddColumn,
    handleHideColumn: handleHideColumn,
    model: model,
    onColumnTitleChange: onColumnTitleChange,
    onColumnTitleEdit: onColumnTitleEdit
  });
}
function headerSelectionCell(handleSelection, selectedState, disabled, className) {
  const isChecked = selectedState === GRID_CHECKBOX_OPTIONS.ALL;
  const isIndeterminate = selectedState === GRID_CHECKBOX_OPTIONS.SOME;

  // Ref below is required as indeterminate is not an actual HTML attribute
  // See: https://github.com/facebook/react/issues/1798
  return /*#__PURE__*/external_react_default().createElement("input", {
    className: className,
    checked: isChecked,
    disabled: disabled,
    onChange: handleSelection,
    ref: elem => elem && (elem.indeterminate = isIndeterminate),
    type: "checkbox"
  });
}
;// CONCATENATED MODULE: ./src/internal/components/forms/input/RadioGroupInput.tsx
function RadioGroupInput_defineProperty(e, r, t) { return (r = RadioGroupInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function RadioGroupInput_toPropertyKey(t) { var i = RadioGroupInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function RadioGroupInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





// export for jest test usage

class RadioGroupInputImpl extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    RadioGroupInput_defineProperty(this, "onValueChange", evt => {
      const {
        formsy,
        onValueChange,
        setValue
      } = this.props;
      const {
        value
      } = evt.target;
      this.setState({
        selectedValue: value
      });
      if (formsy) {
        setValue?.(value);
      }
      onValueChange?.(value);
    });
    const selected = props.options?.find(option => option.selected);
    this.state = {
      selectedValue: selected?.value
    };
    if (selected?.value && props.formsy) {
      props.setValue?.(selected.value);
    }
  }
  render() {
    const {
      options,
      name,
      showDescriptions
    } = this.props;
    const {
      selectedValue
    } = this.state;
    const inputs = [];
    if (options) {
      if (options.length === 1) {
        inputs.push( /*#__PURE__*/external_react_default().createElement("div", {
          key: options[0].value
        }, /*#__PURE__*/external_react_default().createElement("input", {
          hidden: true,
          checked: true,
          type: "radio",
          name: name,
          value: options[0].value,
          onChange: this.onValueChange
        })));
      } else {
        options.forEach(option => {
          const selected = selectedValue === option.value;
          inputs.push( /*#__PURE__*/external_react_default().createElement("div", {
            key: option.value,
            className: "radio-input-wrapper"
          }, /*#__PURE__*/external_react_default().createElement("input", {
            className: "radioinput-input",
            checked: selected && !option.disabled,
            type: "radio",
            name: name,
            value: option.value,
            onChange: this.onValueChange,
            disabled: option.disabled
          }), /*#__PURE__*/external_react_default().createElement("span", {
            className: external_classnames_default()('radioinput-label', {
              selected
            })
          }, option.label), showDescriptions && option.description && /*#__PURE__*/external_react_default().createElement("span", {
            className: "radioinput-description"
          }, " - ", option.description), !showDescriptions && option.description && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, null, option.description)));
        });
      }
    }
    return inputs;
  }
}
const RadioGroupInputFormsy = (0,external_formsy_react_.withFormsy)(RadioGroupInputImpl);
const RadioGroupInput = props => {
  if (props.formsy) {
    return /*#__PURE__*/external_react_default().createElement(RadioGroupInputFormsy, props);
  }
  return /*#__PURE__*/external_react_default().createElement(RadioGroupInputImpl, props);
};
RadioGroupInput.defaultProps = {
  formsy: true
};
RadioGroupInput.displayName = 'RadioGroupInput';
;// CONCATENATED MODULE: ./src/internal/components/forms/QueryInfoQuantity.tsx
function QueryInfoQuantity_defineProperty(e, r, t) { return (r = QueryInfoQuantity_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function QueryInfoQuantity_toPropertyKey(t) { var i = QueryInfoQuantity_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function QueryInfoQuantity_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




(0,external_formsy_react_.addValidationRule)('isPositiveLt', (vs, v, smax) => {
  if (v === '' || v === undefined || isNaN(v)) {
    return true;
  }
  const max = parseInt(smax, 10);
  const i = parseInt(v, 10);
  if (!isNaN(i) && i >= 1 && i <= max) return true;
  return max === 1 ? 'Only 1 allowed' : `Value must be between 1 and ${max.toLocaleString()}.`;
});
class QueryInfoQuantity extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    QueryInfoQuantity_defineProperty(this, "onCountChange", (field, value) => {
      this.setState(() => ({
        count: value
      }));
      this.props.onCountChange?.(value);
    });
    QueryInfoQuantity_defineProperty(this, "onOptionChange", value => {
      this.setState(() => ({
        selectedCreationType: value
      }));
    });
    const selectedOption = props.creationTypeOptions?.find(option => option.selected);
    this.state = {
      count: undefined,
      selectedCreationType: selectedOption?.type
    };
  }
  render() {
    const {
      creationTypeOptions,
      includeCountField,
      maxCount
    } = this.props;
    const {
      count,
      selectedCreationType
    } = this.state;
    let text = this.props.countText;
    const options = [];
    if (creationTypeOptions) {
      creationTypeOptions.forEach(option => {
        const selected = selectedCreationType === option.type;
        if (selected) text = option.quantityLabel;
        options.push({
          value: option.type,
          description: option.disabled && option.disabledDescription ? option.disabledDescription : option.description,
          label: option.type,
          disabled: option.disabled,
          selected: option.selected
        });
      });
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, options.length > 0 && /*#__PURE__*/external_react_default().createElement("div", {
      className: "creation-type-radioinput"
    }, /*#__PURE__*/external_react_default().createElement(RadioGroupInput, {
      name: "creationType",
      options: options,
      formsy: true,
      onValueChange: this.onOptionChange,
      showDescriptions: true
    })), (options.length > 0 || includeCountField) && /*#__PURE__*/external_react_default().createElement(FormsyInput, {
      id: "numItems",
      label: text,
      labelClassName: "control-label text-left",
      name: "numItems",
      max: maxCount,
      min: 1,
      onChange: this.onCountChange,
      required: true,
      step: "1",
      style: {
        width: '125px'
      },
      type: "number",
      validations: `isPositiveLt:${maxCount}`,
      value: count ? count.toString() : '1'
    }));
  }
}
// EXTERNAL MODULE: external "react-select"
var external_react_select_ = __webpack_require__(110);
var external_react_select_default = /*#__PURE__*/__webpack_require__.n(external_react_select_);
// EXTERNAL MODULE: external "react-select/async"
var async_ = __webpack_require__(553);
var async_default = /*#__PURE__*/__webpack_require__.n(async_);
// EXTERNAL MODULE: external "react-select/async-creatable"
var async_creatable_ = __webpack_require__(177);
var async_creatable_default = /*#__PURE__*/__webpack_require__.n(async_creatable_);
// EXTERNAL MODULE: external "react-select/creatable"
var creatable_ = __webpack_require__(32);
var creatable_default = /*#__PURE__*/__webpack_require__.n(creatable_);
;// CONCATENATED MODULE: ./src/internal/components/forms/utils.ts

const LABEL_FIELD_SUFFIX = '::label';
const getQueryFormLabelFieldName = function (name) {
  return name + LABEL_FIELD_SUFFIX;
};
const isQueryFormLabelField = function (name) {
  return name.endsWith(LABEL_FIELD_SUFFIX);
};
const getFieldEnabledFieldName = function (column, fieldName) {
  const name = fieldName ? fieldName : column ? column.fieldKey : 'unknownField';
  return name + '::enabled';
};
const isFieldList = value => external_immutable_.List.isList(value);
const isFieldArray = value => Array.isArray(value);
const isFieldMap = value => external_immutable_.Map.isMap(value);
const resolveFieldValue = (fieldValue, resolveDisplayValue, resolveFormattedValue) => {
  if (resolveFormattedValue && fieldValue.hasOwnProperty('formattedValue')) {
    return fieldValue.formattedValue;
  }
  if (resolveDisplayValue && fieldValue.hasOwnProperty('displayValue')) {
    return fieldValue.displayValue;
  }
  return fieldValue.value === null ? undefined : fieldValue.value;
};
function resolveDetailFieldValue(field, resolveDisplayValue, resolveFormattedValue) {
  if (field) {
    if (isFieldList(field) && field.size) {
      return field.toJS().map(d => resolveFieldValue(d, resolveDisplayValue, resolveFormattedValue));
    } else if (isFieldArray(field) && field.length) {
      return field.map(d => resolveFieldValue(d, resolveDisplayValue, resolveFormattedValue));
    } else if (isFieldMap(field)) {
      return resolveFieldValue(field.toJS(), resolveDisplayValue, resolveFormattedValue);
    }
    return resolveFieldValue(field, resolveDisplayValue, resolveFormattedValue);
  }
  return undefined;
}
function resolveDetailFieldLabel(field) {
  return resolveDetailFieldValue(field, true, true);
}
;// CONCATENATED MODULE: ./src/internal/components/forms/FieldLabel.tsx
function FieldLabel_extends() { return FieldLabel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, FieldLabel_extends.apply(null, arguments); }
function FieldLabel_defineProperty(e, r, t) { return (r = FieldLabel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FieldLabel_toPropertyKey(t) { var i = FieldLabel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FieldLabel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2016-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */





class FieldLabel extends external_react_.Component {
  constructor(props) {
    super(props);
    if (props.showToggle && !props.column && (!props.id || !props.fieldName)) {
      throw new Error('FieldLabel: when showing the toggle, either a column or an id and fieldName must be provided.');
    }
  }
  render() {
    const {
      label,
      column,
      fieldName,
      id,
      labelOverlayProps,
      showLabel,
      showToggle,
      isDisabled,
      toggleProps,
      withLabelOverlay,
      toggleClassName
    } = this.props;
    if (!showLabel) return null;

    // when not displaying with Formsy and we are displaying the field toggle, we adjust
    // the columns since the toggle appears outside the label.
    let toggleContainerClassName,
      toggleWrapperClassName = 'control-label-toggle-input';
    if (showToggle && labelOverlayProps && !labelOverlayProps.isFormsy && !labelOverlayProps.labelClass) {
      labelOverlayProps.labelClass = 'control-label col-sm-2 col-xs-11 text-left';
      toggleContainerClassName = 'col-xs-1';
      toggleWrapperClassName += ' control-label-toggle-input-size-fixed';
    }
    let labelBody;
    if (withLabelOverlay) {
      labelBody = /*#__PURE__*/external_react_default().createElement(LabelOverlay, FieldLabel_extends({
        column: column
      }, labelOverlayProps));
    } else {
      labelBody = label ? label : column ? column.caption : null;
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, labelBody, showToggle && /*#__PURE__*/external_react_default().createElement("span", {
      className: external_classnames_default()(toggleContainerClassName)
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()(toggleClassName, toggleWrapperClassName)
    }, /*#__PURE__*/external_react_default().createElement(ToggleIcon, {
      id: id ?? column?.fieldKey,
      inputFieldName: getFieldEnabledFieldName(column, fieldName),
      active: !isDisabled ? 'on' : 'off',
      onClick: toggleProps?.onClick,
      disabled: !toggleProps?.onClick,
      toolTip: toggleProps?.toolTip
    }))));
  }
}
FieldLabel_defineProperty(FieldLabel, "defaultProps", {
  showLabel: true,
  withLabelOverlay: true
});
;// CONCATENATED MODULE: ./src/internal/components/forms/input/SelectInput.tsx
function SelectInput_extends() { return SelectInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, SelectInput_extends.apply(null, arguments); }
function SelectInput_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SelectInput_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SelectInput_ownKeys(Object(t), !0).forEach(function (r) { SelectInput_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SelectInput_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SelectInput_defineProperty(e, r, t) { return (r = SelectInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SelectInput_toPropertyKey(t) { var i = SelectInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SelectInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










const _customStyles = {
  control: (styles, props) => {
    if (props.isDisabled) {
      return SelectInput_objectSpread(SelectInput_objectSpread({}, styles), {}, {
        backgroundColor: '#EEE',
        borderColor: '#CCC'
      });
    }
    return styles;
  },
  // ReactSelect v1 had a zIndex value of "1000" where as ReactSelect v4.3.1 has a value of "2"
  // which results in layout conflicts in our apps. This reverts to the v1 value.
  menu: provided => SelectInput_objectSpread(SelectInput_objectSpread({}, provided), {}, {
    zIndex: 1000
  }),
  menuPortal: provided => SelectInput_objectSpread(SelectInput_objectSpread({}, provided), {}, {
    zIndex: 9999
  }),
  // Issue 45958 Safari scrollbar renders over menu
  multiValue: (styles, state) => SelectInput_objectSpread(SelectInput_objectSpread({}, styles), {}, {
    backgroundColor: state.isDisabled ? '#E1E1E1' : '#F2F9FC'
  }),
  multiValueLabel: (styles, state) => SelectInput_objectSpread(SelectInput_objectSpread({}, styles), {}, {
    color: state.isDisabled ? '#555' : '#08C'
  }),
  multiValueRemove: (styles, state) => {
    // Don't display the remove symbol for each option when the select is disabled.
    if (state.isDisabled) {
      return SelectInput_objectSpread(SelectInput_objectSpread({}, styles), {}, {
        display: 'none'
      });
    }
    return SelectInput_objectSpread(SelectInput_objectSpread({}, styles), {}, {
      color: '#08C',
      ':hover': {
        backgroundColor: '#2980B9',
        color: 'white'
      }
    });
  },
  placeholder: (styles, props) => {
    if (props.isDisabled) {
      return SelectInput_objectSpread(SelectInput_objectSpread({}, styles), {}, {
        color: '#8E8E8E'
      });
    }
    return styles;
  }
};
const _customTheme = theme => SelectInput_objectSpread(SelectInput_objectSpread({}, theme), {}, {
  colors: SelectInput_objectSpread(SelectInput_objectSpread({}, theme.colors), {}, {
    danger: '#D9534F',
    primary: '#2980B9',
    primary75: '#009BF9',
    primary50: '#F2F9FC',
    primary25: 'rgba(41, 128, 185, 0.1)'
  })
});

// Allows users to declare custom option rendering components without needing to redefine the base custom component
// wrapper. This is taken from the guide at https://react-select.com/styles#cx-and-custom-components.
const CustomOption = props => {
  const {
    className,
    cx,
    children,
    getStyles,
    innerProps,
    innerRef,
    isDisabled,
    isFocused,
    isSelected
  } = props;
  return /*#__PURE__*/external_react_default().createElement("div", SelectInput_extends({
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef,
    style: getStyles('option', props)
  }, innerProps), children);
};

// Molded from @types/react-select/src/filter.d.ts

// Copied from @types/react-select/src/Select.d.ts

function initOptionFromPrimitive(value, props) {
  const {
    labelKey = 'label',
    options,
    valueKey = 'value'
  } = props;
  return options?.find(o => o[valueKey] === value) ?? {
    [labelKey]: value,
    [valueKey]: value
  };
}

// Used to initialize the selected options in `state` when `autoValue` is enabled.
// This will accept a primitive value (e.g. 5) and resolve it to an option (e.g. { label: 'Awesome', value: 5 })
// if the option is available. Supports mapping single or multiple values.
function initOptions(props) {
  const {
    value
  } = props;
  let options;
  if (value !== undefined && value !== null && value !== '') {
    if (Array.isArray(value)) {
      options = [];
      value.forEach(v => {
        if (v !== undefined && v !== null) {
          if (typeof v === 'string' || typeof v === 'number') {
            options.push(initOptionFromPrimitive(v, props));
          } else {
            options.push(v);
          }
        }
      });
    } else if (typeof value === 'string' || typeof value === 'number') {
      options = initOptionFromPrimitive(value, props);
    } else {
      options = value;
    }
  }
  return options;
}
const nullComponent = () => null;
// Implementation exported only for tests
class SelectInputImpl extends external_react_.Component {
  constructor(props) {
    super(props);
    SelectInput_defineProperty(this, "_id", void 0);
    SelectInput_defineProperty(this, "_isMounted", void 0);
    SelectInput_defineProperty(this, "CHANGE_LOCK", false);
    SelectInput_defineProperty(this, "reactSelect", void 0);
    SelectInput_defineProperty(this, "onToggleChange", () => {
      this.setState(state => ({
        isDisabled: !state.isDisabled,
        selectedOptions: state.isDisabled ? state.selectedOptions : state.originalOptions
      }), () => {
        this.props.onToggleDisable?.(this.state.isDisabled);
      });
    });
    SelectInput_defineProperty(this, "getId", () => {
      return this.props.id ?? this._id;
    });
    SelectInput_defineProperty(this, "handleBlur", event => {
      const {
        onBlur,
        saveOnBlur
      } = this.props;

      // Issue 33774: fields should be able to preserve input onBlur
      if (saveOnBlur) {
        const select = this.reactSelect.current;
        if (select?.selectOption && select.state?.focusedOption) {
          select.selectOption(select.state.focusedOption);
        }
      }
      onBlur?.(event);
    });
    SelectInput_defineProperty(this, "handleChange", (selectedOptions, context) => {
      const {
        clearCacheOnChange,
        closeMenuOnSelect,
        multiple,
        name,
        onChange,
        openMenuOnFocus
      } = this.props;
      this.CHANGE_LOCK = true;
      if (clearCacheOnChange && this.isAsync()) {
        this.setState(state => ({
          asyncKey: state.asyncKey + 1
        }));
      }
      const formValue = this._setOptionsAndValue(selectedOptions);
      onChange?.(name, formValue, selectedOptions, this.props);

      // ReactSelect does not currently support (or it is just broken) the configuration of:
      // openMenuOnFocus={true}, closeMenuOnSelect={true} and isMulti={true}
      // The menu remains open due to focus. This does not occur when isMulti={false}.
      // Here we do a deferred call to the internal onMenuClose().
      if (openMenuOnFocus && closeMenuOnSelect && multiple && context?.action === 'select-option') {
        setTimeout(() => {
          if (this._isMounted) {
            this.reactSelect.current.onMenuClose();
          }
        }, 10);
      }
    });
    SelectInput_defineProperty(this, "handleFocus", event => {
      this.props.onFocus?.(event, this.reactSelect.current);
    });
    SelectInput_defineProperty(this, "isAsync", () => {
      return !!this.props.loadOptions;
    });
    SelectInput_defineProperty(this, "isCreatable", () => {
      return this.props.allowCreate === true;
    });
    SelectInput_defineProperty(this, "loadOptions", async input => {
      // We don't support the older callback-based variant
      const options = await this.props.loadOptions(input);

      // If "autoValue" is enabled, then this will ensure the "selectedOptions" are mapped
      // from the specified "value" once the initial "loadOptions" call has been made.
      if (this.state.initialLoad) {
        if (this.props.autoValue) {
          const selectedOptions = initOptions(SelectInput_objectSpread(SelectInput_objectSpread({}, this.props), {}, {
            options
          }));
          this.setState({
            initialLoad: false,
            originalOptions: selectedOptions,
            selectedOptions
          });
        }

        // Issue 48259: ReactSelect menu positioning is currently broken when set to menuPosition="auto"
        // and the menu is asynchronously loaded. As a result the menu can end up rendering off the bottom of the
        // page upon initial load instead of "flipping" up to render above the select. This is due to the
        // underlying implementation not respecting the "isLoaded" bit when adjusting the layout via
        // useLayoutEffect() in <MenuPlacer/>.
        // This timeout operation works by flipping the "menuShouldScrollIntoView" bit, which is respected by
        // the underlying useLayoutEffect(), after a render cycle has been completed for the load out. We don't
        // currently support overriding the "menuShouldScrollIntoView" prop AND we always use "fixed" position
        // which results in ReactSelect never attempting to scroll regardless of if this prop is true or false.
        // ReactSelect Issue: https://github.com/JedWatson/react-select/issues/5733
        setTimeout(() => {
          if (this._isMounted) {
            this.setState({
              menuShouldScrollIntoView: true
            });
          }
        }, 1);
      }
      return options;
    });
    SelectInput_defineProperty(this, "renderLabel", () => {
      const {
        allowDisable,
        description,
        label,
        labelClass,
        multiple,
        name,
        required,
        showLabel,
        addLabelAsterisk,
        renderFieldLabel,
        helpTipRenderer,
        toggleDisabledTooltip
      } = this.props;
      const {
        isDisabled
      } = this.state;
      if (showLabel !== false && label !== undefined) {
        if (api_.Utils.isString(label)) {
          const description_ = description ?? `Select ${multiple ? 'one or more values for' : 'a'} ${label}`;
          if (renderFieldLabel) {
            return /*#__PURE__*/external_react_default().createElement("label", {
              className: labelClass
            }, renderFieldLabel(undefined, label, description_), required && /*#__PURE__*/external_react_default().createElement("span", {
              className: "required-symbol"
            }, " *"));
          }
          return /*#__PURE__*/external_react_default().createElement(FieldLabel, {
            id: this.getId(),
            fieldName: name,
            labelOverlayProps: {
              inputId: name,
              description: description_,
              label,
              addLabelAsterisk,
              isFormsy: false,
              required,
              labelClass: !allowDisable ? labelClass : undefined,
              helpTipRenderer
            },
            showLabel: showLabel,
            showToggle: allowDisable,
            isDisabled: isDisabled,
            toggleProps: {
              onClick: toggleDisabledTooltip ? undefined : this.onToggleChange,
              toolTip: toggleDisabledTooltip
            }
          });
        }
        return label;
      }
      return null;
    });
    SelectInput_defineProperty(this, "getOptionLabel", option => option[this.props.labelKey]);
    SelectInput_defineProperty(this, "getOptionValue", option => option[this.props.valueKey]);
    SelectInput_defineProperty(this, "Input", inputProps =>
    /*#__PURE__*/
    // Marking input as "required" is not natively supported by react-select post-v1. Here we can mark
    // the underlying input as required, however, this is not the value input but rather the user visible
    // input so we manually check if a value is set.
    external_react_default().createElement(external_react_select_.components.Input, SelectInput_extends({}, inputProps, {
      required: !!this.props.required && !inputProps.selectProps?.value
    })));
    SelectInput_defineProperty(this, "Option", optionProps => /*#__PURE__*/external_react_default().createElement(CustomOption, optionProps, this.props.optionRenderer(optionProps)));
    SelectInput_defineProperty(this, "noOptionsMessage", () => this.props.noResultsText);
    SelectInput_defineProperty(this, "renderSelect", () => {
      const {
        autoFocus,
        backspaceRemovesValue,
        cacheOptions,
        clearable,
        closeMenuOnSelect,
        customTheme,
        customStyles,
        defaultInputValue,
        defaultOptions,
        delimiter,
        disabled,
        filterOption,
        formatCreateLabel,
        formatGroupLabel,
        inputId,
        isLoading,
        isValidNewOption,
        labelKey,
        menuPlacement,
        menuPosition,
        multiple,
        name,
        onKeyDown,
        openMenuOnClick,
        openMenuOnFocus,
        optionRenderer,
        options,
        placeholder,
        showDropdownIndicator,
        showDropdownMenu,
        showIndicatorSeparator,
        tabSelectsValue,
        valueKey,
        valueRenderer
      } = this.props;
      const components = {
        Input: this.Input
      };
      if (!showDropdownIndicator) {
        components.DropdownIndicator = nullComponent;
      }
      if (!showIndicatorSeparator) {
        components.IndicatorSeparator = nullComponent;
      }
      if (!showDropdownMenu) {
        components.Menu = nullComponent;
      }
      if (optionRenderer) {
        components.Option = this.Option;
      }
      if (valueRenderer) {
        if (multiple) {
          components.MultiValue = valueRenderer;
        } else {
          components.SingleValue = valueRenderer;
        }
      }
      const selectProps = {
        autoFocus,
        backspaceRemovesValue,
        blurInputOnSelect: false,
        className: 'select-input',
        classNamePrefix: 'select-input',
        closeMenuOnSelect,
        components,
        defaultInputValue,
        delimiter,
        filterOption,
        formatCreateLabel,
        formatGroupLabel,
        getOptionLabel: labelKey && labelKey !== 'label' ? this.getOptionLabel : undefined,
        getOptionValue: valueKey && valueKey !== 'value' ? this.getOptionValue : undefined,
        id: this.getId(),
        inputId,
        isClearable: clearable,
        isDisabled: disabled || this.state.isDisabled,
        isLoading,
        isMulti: multiple,
        isValidNewOption,
        menuPlacement,
        menuPosition,
        // See comment in loadOptions() about how this is set and why it is utilized
        menuShouldScrollIntoView: this.state.menuShouldScrollIntoView,
        name,
        noOptionsMessage: this.noOptionsMessage,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown,
        openMenuOnClick,
        openMenuOnFocus,
        options,
        placeholder,
        ref: this.reactSelect,
        styles: SelectInput_objectSpread(SelectInput_objectSpread({}, _customStyles), customStyles),
        tabSelectsValue,
        theme: customTheme || _customTheme,
        // ReactSelect only supports null for clearing the value (as opposed to undefined).
        // See https://stackoverflow.com/a/50417171.
        value: (this.props.autoValue ? this.state.selectedOptions : this.props.selectedOptions) ?? null
      };
      if (Array.isArray(selectProps.value) && selectProps.value.length === 0) {
        selectProps.value = null;
      } else if (!selectProps.isMulti && Array.isArray(selectProps.value)) {
        console.warn('SelectInput: value is of type "array" but this component is NOT in "multiple" mode.' + ' Consider either putting in "multiple" mode or fix value to not be an array.');
      }
      if (this.isAsync()) {
        const asyncProps = SelectInput_objectSpread(SelectInput_objectSpread({}, selectProps), {}, {
          cacheOptions,
          defaultOptions,
          key: this.state.asyncKey,
          loadOptions: this.loadOptions
        });
        if (this.isCreatable()) {
          return /*#__PURE__*/external_react_default().createElement((async_creatable_default()), asyncProps);
        }
        return /*#__PURE__*/external_react_default().createElement((async_default()), asyncProps);
      } else if (this.isCreatable()) {
        return /*#__PURE__*/external_react_default().createElement((creatable_default()), selectProps);
      }
      return /*#__PURE__*/external_react_default().createElement((external_react_select_default()), selectProps);
    });
    this._id = generateId('selectinput-');
    const _selectedOptions = props.autoValue === true ? initOptions(props) : undefined;
    this.state = {
      asyncKey: 0,
      initialLoad: true,
      isDisabled: !!props.initiallyDisabled,
      menuShouldScrollIntoView: false,
      originalOptions: _selectedOptions,
      selectedOptions: _selectedOptions
    };
    this.reactSelect = external_react_default().createRef();
  }
  componentDidMount() {
    this._isMounted = true;
  }
  componentDidUpdate(prevProps) {
    if (!this.CHANGE_LOCK && this.props.autoValue && !this.isAsync() && prevProps.value !== this.props.value) {
      // If "autoValue" is enabled and the value has changed for a non-async configuration, then we need
      // to reinitialize "selectedOptions" from the latest props. The async case is handled in this.loadOptions().
      const selectedOptions = initOptions(this.props);
      this.setState({
        originalOptions: selectedOptions,
        selectedOptions
      });
    }
    this.CHANGE_LOCK = false;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  _setOptionsAndValue(options) {
    const {
      autoValue,
      delimiter,
      formsy,
      joinValues,
      multiple,
      setValue,
      valueKey
    } = this.props;
    let selectedOptions;
    if (options === undefined || options === null || Array.isArray(options) && options.length === 0) {
      selectedOptions = undefined;
    } else {
      selectedOptions = options;
    }
    if (autoValue) {
      this.setState({
        selectedOptions
      });
    }
    let formValue;
    if (this.props.resolveFormValue) {
      formValue = this.props.resolveFormValue(selectedOptions);
    } else if (selectedOptions !== undefined) {
      if (multiple) {
        if (Array.isArray(selectedOptions)) {
          formValue = selectedOptions.reduce((arr, option) => {
            arr.push(valueKey ? option[valueKey] : option.value);
            return arr;
          }, []);
          if (!joinValues) {
            // consider removing altogether?
            formValue = formValue.join(delimiter);
          }
        } else {
          formValue = selectedOptions;
        }
      } else {
        formValue = selectedOptions.value;
      }
    }
    if (formsy) {
      setValue?.(formValue);
    }
    return formValue;
  }
  render() {
    const {
      containerClass,
      formsy,
      getErrorMessage,
      help,
      inputClass
    } = this.props;
    const error = getErrorMessage?.();
    const hasError = formsy && !!error;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: `select-input-container ${containerClass}`
    }, this.renderLabel(), /*#__PURE__*/external_react_default().createElement("div", {
      className: inputClass
    }, this.renderSelect(), hasError && /*#__PURE__*/external_react_default().createElement("div", {
      className: "has-error"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "error-message help-block"
    }, error)), !hasError && !!help && /*#__PURE__*/external_react_default().createElement("span", {
      className: "help-block"
    }, help)));
  }
}

/**
 * This class is a wrapper around ReactSelect to be able to bind formsy-react. It uses
 * the Formsy.Decorator to bind formsy-react so the element can be validated, submitted, etc.
 */
SelectInput_defineProperty(SelectInputImpl, "defaultProps", {
  allowCreate: false,
  allowDisable: false,
  autoValue: true,
  clearable: true,
  clearCacheOnChange: true,
  closeMenuOnSelect: true,
  containerClass: INPUT_CONTAINER_CLASS_NAME,
  defaultOptions: true,
  delimiter: DELIMITER,
  initiallyDisabled: false,
  inputClass: INPUT_WRAPPER_CLASS_NAME,
  labelClass: INPUT_LABEL_CLASS_NAME,
  menuPlacement: 'auto',
  // Default to 'fixed' because 'absolute' causes issues in several scenarios (Modals, EditableGrid) but it's too
  // difficult to manually set it to fixed in all of these situations (e.g. we don't always know we're in a modal)
  menuPosition: 'fixed',
  openMenuOnFocus: false,
  saveOnBlur: false,
  showDropdownIndicator: true,
  showDropdownMenu: true,
  showIndicatorSeparator: true,
  tabSelectsValue: true,
  valueKey: 'value'
});
const SelectInputFormsy = (0,external_formsy_react_.withFormsy)(SelectInputImpl);
const SelectInput_SelectInput = props => {
  if (props.formsy) {
    return /*#__PURE__*/external_react_default().createElement(SelectInputFormsy, props);
  }
  return /*#__PURE__*/external_react_default().createElement(SelectInputImpl, props);
};
SelectInput_SelectInput.defaultProps = {
  formsy: false
};
SelectInput_SelectInput.displayName = 'SelectInput';
;// CONCATENATED MODULE: ./src/internal/components/forms/input/AliasInput.tsx
const AliasInput_excluded = ["col", "data"],
  AliasInput_excluded2 = ["data", "values"];
function AliasInput_extends() { return AliasInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, AliasInput_extends.apply(null, arguments); }
function AliasInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = AliasInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function AliasInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }




const AliasSelectInput = (0,external_react_.memo)(props => {
  const {
      col,
      data
    } = props,
    selectProps = AliasInput_objectWithoutProperties(props, AliasInput_excluded);
  const generatedId = (0,external_react_.useMemo)(() => generateId(), []);
  const isValidNewOption = (0,external_react_.useCallback)(inputValue => {
    const isEmpty = inputValue?.trim().length === 0;
    // Empty string is considered invalid. This matches default react-select behavior.
    return !!inputValue && !isEmpty;
  }, []);

  // AliasInput supplies its own formValue resolution
  // - The value is mapped from the "label"
  // - When empty the server expects an empty Array and not undefined/null
  const resolveFormValue = (0,external_react_.useCallback)(options => options?.map(o => o.label) ?? [], []);
  const value = (0,external_react_.useMemo)(() => {
    const row = external_immutable_.Map.isMap(data) ? data.toJS() : data;
    return caseInsensitive(row, col.fieldKey)?.map(a => {
      if (!a) return a;
      if (typeof a === 'string') return a;
      if (typeof a === 'object') return a.displayValue;
      return undefined;
    }).filter(a => !!a);
  }, [col, data]);
  return /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, AliasInput_extends({
    description: col.description,
    id: generatedId,
    isValidNewOption: isValidNewOption,
    label: col.caption,
    name: col.fieldKey,
    noResultsText: "Enter alias name(s)",
    required: col.required
  }, selectProps, {
    resolveFormValue: resolveFormValue,
    value: value
  }));
});
AliasSelectInput.defaultProps = {
  allowCreate: true,
  formatCreateLabel: inputValue => `Create alias "${inputValue}"`,
  formsy: true,
  joinValues: true,
  multiple: true,
  placeholder: 'Enter alias name(s)',
  saveOnBlur: true,
  showLabel: true
};
AliasSelectInput.displayName = 'AliasSelectInput';
const AliasInput = (0,external_react_.memo)(props => {
  const {
    allowFieldDisable,
    col,
    data,
    formsy,
    initiallyDisabled,
    onSelectChange,
    onToggleDisable,
    selectInputProps
  } = props;
  return /*#__PURE__*/external_react_default().createElement(AliasSelectInput, AliasInput_extends({}, selectInputProps, {
    allowDisable: allowFieldDisable,
    col: col,
    data: data,
    formsy: formsy,
    initiallyDisabled: initiallyDisabled,
    onChange: onSelectChange,
    onToggleDisable: onToggleDisable
  }));
});
AliasInput.displayName = 'AliasInput';
const AliasGridInput = (0,external_react_.memo)(props => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
      data,
      values
    } = props,
    aliasInputProps = AliasInput_objectWithoutProperties(props, AliasInput_excluded2);
  const {
    col
  } = aliasInputProps;
  const gridData = (0,external_react_.useMemo)(() => {
    if (!values) return undefined;
    return {
      [col.fieldKey]: values.map(v => v.display).toArray()
    };
  }, [col.fieldKey, values]);
  return /*#__PURE__*/external_react_default().createElement(AliasInput, AliasInput_extends({}, aliasInputProps, {
    data: gridData
  }));
});
AliasGridInput.displayName = 'AliasGridInput';
;// CONCATENATED MODULE: ./src/internal/components/forms/input/AssayTaskInput.tsx
const AssayTaskInput_excluded = ["assayId"];
function AssayTaskInput_extends() { return AssayTaskInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, AssayTaskInput_extends.apply(null, arguments); }
function AssayTaskInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = AssayTaskInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function AssayTaskInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }








async function loadInputOptions(assayId) {
  const result = await selectRows({
    columns: 'RowId, Name, AssayTypes, Run/Name',
    filterArray: [api_.Filter.create('AssayTypes', undefined, api_.Filter.Types.NONBLANK), api_.Filter.create('Status/Value', 'In Progress')],
    maxRows: -1,
    schemaQuery: new SchemaQuery('samplemanagement', 'Tasks', ViewInfo.DETAIL_NAME)
  });
  const taskOptions = [];
  result.rows.forEach(row => {
    const taskId = caseInsensitive(row, 'RowId').value;
    const jobName = caseInsensitive(row, 'Run/Name').value;
    const taskName = caseInsensitive(row, 'Name').value;
    const assays = caseInsensitive(row, 'AssayTypes').value.split(',').map(Number);
    const hasAssay = assays.find(id => assayId === id);
    if (hasAssay) {
      taskOptions.push({
        label: `${jobName} - ${taskName}`,
        value: taskId
      });
    }
  });
  return taskOptions;
}
// Note: this component is specific to Workflow, and ideally would live in the Workflow package, however we do not
// currently have a way for our Apps to override the InputRenderers (see InputRenderer.tsx).
const AssayTaskInput = (0,external_react_.memo)(props => {
  const {
      assayId
    } = props,
    selectInputProps = AssayTaskInput_objectWithoutProperties(props, AssayTaskInput_excluded);
  const [loading, setLoading] = (0,external_react_.useState)(true);
  const [taskOptions, setTaskOptions] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    (async () => {
      if (assayId === undefined) {
        // If the components rendering the QueryFormInputs or EditableDetailPanel don't properly inject the assayId
        // into the form data (via ASSAY_INDEX key defined above) then this will happen.
        setError('Assay ID not set, cannot load workflow tasks');
        setLoading(false);
        return;
      }
      try {
        const options = await loadInputOptions(assayId);
        setTaskOptions(options);
      } catch (e) {
        console.error(e.exception);
        setError('Error loading workflow tasks');
      } finally {
        setLoading(false);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, AssayTaskInput_extends({}, selectInputProps, {
    disabled: error ? true : props.disabled,
    isLoading: loading,
    options: taskOptions,
    placeholder: error ? `Error: ${error}` : props.placeholder,
    value: loading ? undefined : selectInputProps.value
  }));
});
AssayTaskInput.defaultProps = {
  clearable: true,
  description: 'The workflow task associated with this Run',
  label: 'Workflow Task'
};
AssayTaskInput.displayName = 'AssayTaskInput';
const ASSAY_ID_INDEX = 'Protocol/RowId';
function resolveAssayId(data) {
  // Used in multiple contexts so need to check various data formats
  let assayId = external_immutable_.Map.isMap(data) ? data.get(ASSAY_ID_INDEX) : data[ASSAY_ID_INDEX];
  if (!assayId) {
    assayId = external_immutable_.Map.isMap(data) ? data.get(encodePart(ASSAY_ID_INDEX)) : data[encodePart(ASSAY_ID_INDEX)];
  }
  if (external_immutable_.List.isList(assayId)) {
    assayId = assayId.get(0);
  }
  return assayId?.get?.('value') ?? assayId?.value ?? assayId;
}
const AssayTaskInputRenderer = (0,external_react_.memo)(props => {
  const {
    allowFieldDisable,
    col,
    data,
    formsy,
    initiallyDisabled,
    onSelectChange,
    onToggleDisable,
    selectInputProps,
    value
  } = props;
  return /*#__PURE__*/external_react_default().createElement(AssayTaskInput, AssayTaskInput_extends({}, selectInputProps, {
    allowDisable: allowFieldDisable,
    assayId: resolveAssayId(data),
    formsy: formsy,
    initiallyDisabled: initiallyDisabled,
    name: col.name,
    onChange: onSelectChange,
    onToggleDisable: onToggleDisable,
    value: value
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/forms/input/DisableableInput.tsx
function DisableableInput_defineProperty(e, r, t) { return (r = DisableableInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DisableableInput_toPropertyKey(t) { var i = DisableableInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DisableableInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class DisableableInput extends (external_react_default()).Component {
  constructor(...args) {
    super(...args);
    DisableableInput_defineProperty(this, "toggleDisabled", () => {
      const {
        value
      } = this.props;
      const {
        inputValue
      } = this.state;
      this.setState(state => ({
        isDisabled: !state.isDisabled,
        inputValue: state.isDisabled ? inputValue : value
      }), () => {
        this.props.onToggleDisable?.(this.state.isDisabled);
      });
    });
  }
  getInputValue() {
    if (!this.props.allowDisable || this.state.inputValue === undefined) return this.props.value;
    return this.state.inputValue;
  }
}
DisableableInput_defineProperty(DisableableInput, "defaultProps", {
  allowDisable: false,
  initiallyDisabled: false
});
;// CONCATENATED MODULE: ./src/internal/components/forms/input/TextInput.tsx
const TextInput_excluded = ["allowDisable", "initiallyDisabled", "onToggleDisable"],
  TextInput_excluded2 = ["addLabelAsterisk", "labelClassName", "renderFieldLabel", "queryColumn", "showLabel", "startFocused"];
function TextInput_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TextInput_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TextInput_ownKeys(Object(t), !0).forEach(function (r) { TextInput_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TextInput_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextInput_extends() { return TextInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, TextInput_extends.apply(null, arguments); }
function TextInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = TextInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function TextInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function TextInput_defineProperty(e, r, t) { return (r = TextInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function TextInput_toPropertyKey(t) { var i = TextInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function TextInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





class TextInput_TextInput extends DisableableInput {
  constructor(props) {
    super(props);
    TextInput_defineProperty(this, "textInput", void 0);
    TextInput_defineProperty(this, "onChange", (name, value) => {
      if (this.props.allowDisable) {
        this.setState({
          inputValue: value
        });
      }
      this.props.onChange?.(value);
    });
    this.toggleDisabled = this.toggleDisabled.bind(this);
    this.state = {
      didFocus: false,
      isDisabled: props.initiallyDisabled
    };
    this.textInput = external_react_default().createRef();
  }
  componentDidMount() {
    const {
      queryColumn,
      startFocused
    } = this.props;
    const {
      didFocus
    } = this.state;
    if (startFocused && !didFocus && queryColumn && queryColumn.name) {
      this.textInput.current?.focus();
      this.setState({
        didFocus: true
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return this.state.didFocus === nextState.didFocus;
  }
  renderLabel() {
    const {
      label,
      queryColumn,
      showLabel,
      allowDisable,
      addLabelAsterisk,
      renderFieldLabel
    } = this.props;
    const {
      isDisabled
    } = this.state;
    if (renderFieldLabel) {
      return renderFieldLabel(queryColumn);
    }
    return /*#__PURE__*/external_react_default().createElement(FieldLabel, {
      label: label,
      showLabel: showLabel,
      labelOverlayProps: {
        isFormsy: true,
        addLabelAsterisk
      },
      showToggle: allowDisable,
      column: queryColumn,
      isDisabled: isDisabled,
      toggleProps: {
        onClick: this.toggleDisabled
      }
    });
  }
  render() {
    // Extract DisableableInputProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _this$props = this.props,
      {
        allowDisable,
        initiallyDisabled,
        onToggleDisable
      } = _this$props,
      rest = TextInput_objectWithoutProperties(_this$props, TextInput_excluded);
    // Extract TextInputProps
    const {
        addLabelAsterisk,
        labelClassName,
        renderFieldLabel,
        queryColumn,
        showLabel,
        startFocused
      } = rest,
      inputProps = TextInput_objectWithoutProperties(rest, TextInput_excluded2);
    let {
      validations
    } = inputProps;
    let type = 'text';
    let step;
    if (queryColumn && !validations) {
      if (queryColumn.jsonType === 'int') {
        step = '1';
        type = 'number';
        validations = 'isInt';
      } else if (queryColumn.jsonType === 'float') {
        step = 'any';
        type = 'number';
        validations = 'isFloat';
      }
    }
    let help;
    if (queryColumn.nameExpression) {
      help = `A ${queryColumn.caption} will be generated if one is not given.`;
    }
    return /*#__PURE__*/external_react_default().createElement(FormsyInput, TextInput_extends({
      id: queryColumn.fieldKey,
      name: queryColumn.fieldKey,
      placeholder: `Enter ${queryColumn.caption.toLowerCase()}`,
      required: queryColumn.required
    }, inputProps, {
      componentRef: this.textInput,
      disabled: this.state.isDisabled,
      help: help,
      label: this.renderLabel(),
      labelClassName: showLabel ? labelClassName : 'hide-label',
      onChange: this.onChange,
      step: step,
      type: type,
      validations: validations,
      value: this.getInputValue()
    }));
  }
}
TextInput_defineProperty(TextInput_TextInput, "defaultProps", TextInput_objectSpread(TextInput_objectSpread({}, DisableableInput.defaultProps), {
  elementWrapperClassName: INPUT_WRAPPER_CLASS_NAME,
  labelClassName: INPUT_LABEL_CLASS_NAME,
  showLabel: true,
  startFocused: false
}));
;// CONCATENATED MODULE: ./src/internal/components/forms/input/AppendUnitsInput.tsx
const AppendUnitsInput_excluded = ["col", "formsy", "inputClass", "showLabel", "value"];
function AppendUnitsInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = AppendUnitsInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function AppendUnitsInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }



const isNumericWithError = (values, v) => external_formsy_react_.validationRules.isNumeric(values, v) || 'Please enter a number.';
const AppendUnitsInput = (0,external_react_.memo)(props => {
  const {
      col,
      formsy,
      inputClass,
      showLabel,
      value
    } = props,
    otherProps = AppendUnitsInput_objectWithoutProperties(props, AppendUnitsInput_excluded);
  const {
    allowFieldDisable,
    initiallyDisabled,
    onToggleDisable
  } = otherProps;

  // Issue 23462: Global Formsy validation rule for numbers
  if (!external_formsy_react_.validationRules.isNumericWithError) {
    (0,external_formsy_react_.addValidationRule)('isNumericWithError', isNumericWithError);
  }

  // If/when we migrate away from formsy we can implement this using our non-formsy input component
  if (!formsy) {
    console.warn('AppendUnitsInput is only supported in Formsy-based forms.');
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement(TextInput_TextInput, {
    allowDisable: allowFieldDisable,
    initiallyDisabled: initiallyDisabled,
    onToggleDisable: onToggleDisable,
    addonAfter: /*#__PURE__*/external_react_default().createElement("span", null, col.units),
    elementWrapperClassName: inputClass,
    queryColumn: col,
    showLabel: showLabel,
    validations: "isNumericWithError",
    value: value
  });
});
AppendUnitsInput.displayName = 'AppendUnitsInput';
;// CONCATENATED MODULE: ./src/internal/components/forms/input/useDataChangeCommentsRequired.ts




const useDataChangeCommentsRequired = () => {
  const {
    container,
    moduleContext
  } = useServerContext();
  const {
    api
  } = useAppContext();
  const [requiresUserComment, setRequiresUserComment] = (0,external_react_.useState)(false);
  (0,external_react_.useEffect)(() => {
    (async () => {
      const path = getAppHomeFolderPath(container, moduleContext);
      try {
        const response = await api.folder.getAuditSettings(path);
        setRequiresUserComment(!!response?.requireUserComments);
      } catch (error) {
        console.error('Unable to retrieve audit log settings for ' + path, error);
      }
    })();
  }, [/** on load only */]);
  return {
    requiresUserComment
  };
};
;// CONCATENATED MODULE: ./src/internal/components/samples/DiscardConsumedSamplesPanel.tsx



const DISCARD_CONSUMED_CHECKBOX_FIELD = 'discardcheckbox';
const DiscardConsumedSamplesPanel = (0,external_react_.memo)(props => {
  const {
    discardTitle,
    shouldDiscard,
    toggleShouldDiscard,
    onCommentChange,
    comment
  } = props;
  const {
    requiresUserComment
  } = useDataChangeCommentsRequired();
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    id: DISCARD_CONSUMED_CHECKBOX_FIELD,
    name: DISCARD_CONSUMED_CHECKBOX_FIELD,
    onChange: toggleShouldDiscard,
    checked: shouldDiscard
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "discard-consumed-title left-spacing"
  }, discardTitle))), onCommentChange && /*#__PURE__*/external_react_default().createElement(CommentTextArea, {
    onChange: onCommentChange,
    disabled: !shouldDiscard,
    actionName: "Discarding",
    containerClassName: "top-spacing bottom-spacing",
    requiresUserComment: requiresUserComment,
    value: comment
  }));
});
DiscardConsumedSamplesPanel.defaultProps = {
  discardTitle: 'Discard Sample(s) from Storage?'
};
;// CONCATENATED MODULE: ./src/internal/util/similaritySortFactory.ts

function indexOf(source, token, caseSensitive) {
  if (!source || !token) return -1;
  const ss = caseSensitive === true ? source.toString() : source.toString().toLowerCase();
  const tt = caseSensitive === true ? token.toString() : token.toString().toLowerCase();
  return ss.indexOf(tt);
}
function contains(s, token, caseSensitive) {
  return indexOf(s, token, caseSensitive) > -1;
}
function hasPrefix(s, prefix, caseSensitive) {
  return indexOf(s, prefix, caseSensitive) === 0;
}
function similaritySortFactory(token, caseSensitive) {
  if (!token) return naturalSort;

  // Derived from https://stackoverflow.com/a/47132167
  return (rawA, rawB) => {
    if (!rawA) return 1;
    if (!rawB) return -1;
    const a = caseSensitive === true ? rawA.toString() : rawA.toString().toLowerCase();
    const b = caseSensitive === true ? rawB.toString() : rawB.toString().toLowerCase();
    if (a === b) return 0;
    if (a === token && b !== token) return -1;
    const ahp = hasPrefix(a, token, caseSensitive);
    const bhp = hasPrefix(b, token, caseSensitive);
    if (ahp && !bhp) return -1;
    if (!ahp && bhp) return 1;
    if (ahp && bhp) return naturalSort(rawA, rawB);
    const ac = contains(a, token, caseSensitive);
    const bc = contains(b, token, caseSensitive);
    if (ac && !bc) return -1;
    if (!ac && bc) return 1;
    return naturalSort(rawA, rawB);
  };
}
;// CONCATENATED MODULE: ./src/internal/components/forms/model.ts
function model_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function model_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? model_ownKeys(Object(t), !0).forEach(function (r) { forms_model_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : model_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function forms_model_defineProperty(e, r, t) { return (r = forms_model_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function forms_model_toPropertyKey(t) { var i = forms_model_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function forms_model_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







function formatOption(model, result) {
  const {
    displayColumn,
    valueColumn
  } = model;
  return {
    label: resolveDetailFieldLabel(result.get(displayColumn)) ?? resolveDetailFieldLabel(result.get(valueColumn)),
    value: resolveDetailFieldValue(result.get(valueColumn))
  };
}
function formatResults(model, results, token) {
  const {
    displayColumn,
    groupByColumn,
    queryInfo
  } = model;
  if (!queryInfo || !results) {
    return [];
  }
  if (groupByColumn) {
    return formatGroupedResults(model, results, token);
  }
  let options = results.map(result => formatOption(model, result));

  // Issue 46618: If a sort key is applied, then skip sorting on the client to retain sort done on server.
  if (!queryInfo.getColumn(displayColumn)?.hasSortKey) {
    options = options.sortBy(item => item.label, similaritySortFactory(token));
  }
  return options.toArray();
}
const NOT_GROUPED_LABEL = 'Uncategorized';
function formatGroupedResults(model, results, token) {
  const {
    groupByColumn
  } = model;
  const groupedOptions = [];
  const optionMap = {};
  results.forEach(result => {
    let label = resolveDetailFieldLabel(result.get(groupByColumn));
    if (!label) {
      label = NOT_GROUPED_LABEL;
    }
    if (!optionMap[label]) {
      optionMap[label] = [];
    }
    optionMap[label].push(formatOption(model, result));
  });
  Object.keys(optionMap).forEach(label => {
    const options = (0,external_immutable_.List)(optionMap[label]).sortBy(o => o.label, similaritySortFactory(token)).toArray();
    groupedOptions.push({
      label,
      options
    });
  });
  return groupedOptions;
}

/**
 * Given a model this method returns "options" that are consumable by a ReactSelect.
 * @param model for which results are formatted
 * @param result select rows result
 * @param token an optional search token that will be used to sort the results
 */
function formatSavedResults(model, result, token) {
  const {
    queryInfo,
    selectedItems
  } = model;
  if (!queryInfo) {
    return [];
  }
  const {
    key,
    orderedModels
  } = result;
  const models = (0,external_immutable_.fromJS)(result.models[key]);
  const filteredResults = orderedModels[key].filter(k => !selectedItems.has(k)).reduce((ordered, k) => ordered.set(k, models.get(k)), (0,external_immutable_.OrderedMap)());
  return formatResults(model, filteredResults, token);
}
function saveSearchResults(model, result) {
  const {
    key
  } = result;
  const searchResults = (0,external_immutable_.fromJS)(result.models[key]);
  return model.merge({
    allResults: model.allResults.merge(searchResults),
    searchResults
  });
}
function getSelectedOptions(model, value) {
  // if no "value", just return currently selectedItems
  if (value === undefined || value === null || value === '') {
    return (0,external_immutable_.Map)();
  }
  const keyPath = [model.valueColumn, 'value'];
  const sources = model.allResults.merge(model.selectedItems);

  // multi-value case
  if (model.multiple === true) {
    const values = parseCsvString(value.toString(), model.delimiter);
    return sources.filter(result => {
      const resultValue = result.getIn(keyPath);
      return resultValue !== undefined && values.includes(resultValue.toString());
    }).toMap();
  }

  // single-value case
  return sources.filter(source => source.getIn(keyPath) === value).toMap();
}

// "selectedQuery" should match against displayColumn as that is what the user is typing against
function parseSelectedQuery(model, data) {
  return data.map(result => result.getIn([model.displayColumn, 'value'])).join(model.delimiter);
}
function setSelection(model, rawSelectedValue) {
  const selectedItems = getSelectedOptions(model, rawSelectedValue);
  return model.merge({
    rawSelectedValue,
    selectedItems,
    selectedQuery: parseSelectedQuery(model, selectedItems)
  });
}
function fetchSearchResults(model, input) {
  const {
    addExactFilter,
    displayColumn,
    maxRows,
    queryFilters,
    schemaQuery,
    selectedItems,
    valueColumn
  } = model;
  let allFilters = [];
  const filterVal = input.trim();

  // fetch additional options and exclude previously selected so user can see more
  if (model.multiple) {
    const excluded = selectedItems.map(row => row.getIn([valueColumn, 'value'])).toList();
    if (excluded.size) {
      if (excluded.size === 1) {
        allFilters.push(api_.Filter.create(valueColumn, excluded.first(), api_.Filter.Types.NOT_EQUAL));
      } else {
        allFilters.push(api_.Filter.create(valueColumn, excluded.toArray(), api_.Filter.Types.NOT_IN));
      }
    }
  }
  if (queryFilters) {
    allFilters = allFilters.concat(queryFilters.toArray());
  }

  // 35112: Explicitly request exact matches -- can be disabled via QuerySelectModel.addExactFilter = false
  return searchRows({
    containerFilter: model.containerFilter,
    containerPath: model.containerPath,
    schemaName: schemaQuery.schemaName,
    queryName: schemaQuery.queryName,
    viewName: schemaQuery.viewName,
    columns: model.queryColumnNames,
    filterArray: allFilters,
    sort: displayColumn,
    maxRows,
    includeTotalCount: 'f'
  }, filterVal, model.valueColumn, model.delimiter, addExactFilter ? displayColumn : undefined);
}
function initValueColumn(queryInfo, column) {
  // determine 'valueColumn'
  let valueColumn;
  if (column) {
    valueColumn = column;
    if (!queryInfo.getColumn(valueColumn)) {
      throw new Error(`Unable to initialize QuerySelect for (${queryInfo.schemaName}.${queryInfo.name}). The "valueColumn" "${valueColumn}" does not exist.`);
    }
  } else {
    const pkCols = queryInfo.getPkCols();
    if (pkCols.length === 1) {
      valueColumn = pkCols[0].fieldKey;
    } else if (pkCols.length > 0) {
      throw new Error(`Unable to initialize QuerySelect for (${queryInfo.schemaName}.${queryInfo.name}). Set "valueColumn" explicitly to any of ` + pkCols.map(col => col.fieldKey).join(', '));
    } else {
      throw new Error(`Unable to initialize QuerySelect for (${queryInfo.schemaName}.${queryInfo.name}). Set "valueColumn" explicitly as this query does not have any primary keys.`);
    }
  }
  return valueColumn;
}
function initDisplayColumn(queryInfo, valueColumn, column) {
  let displayColumn;
  if (column) {
    if (!queryInfo.getColumn(column)) {
      console.warn(`Unable to initialize QuerySelect for (${queryInfo.schemaName}.${queryInfo.name}). The display column "${column}" does not exist.`);
    } else {
      displayColumn = column;
    }
  }

  // fallback to titleColumn
  if (!displayColumn && queryInfo.titleColumn && queryInfo.getColumn(queryInfo.titleColumn)) {
    displayColumn = queryInfo.titleColumn;
  }

  // fallback to valueColumn
  if (!displayColumn) {
    displayColumn = valueColumn;
  }
  return displayColumn;
}
function initGroupByColumn(queryInfo, column) {
  let groupByColumn;
  if (column) {
    if (!queryInfo.getColumn(column)) {
      console.warn(`Unable to initialize QuerySelect for (${queryInfo.schemaName}.${queryInfo.name}). The group by column "${column}" does not exist.`);
    } else {
      groupByColumn = column;
    }
  }
  return groupByColumn;
}
async function initSelect(props) {
  const {
    containerFilter,
    containerPath,
    schemaQuery,
    queryFilters
  } = props;
  const {
    queryName,
    schemaName,
    viewName
  } = schemaQuery;
  const filters = queryFilters ? queryFilters.toArray() : [];
  const queryInfo = await getQueryDetails({
    containerPath,
    schemaQuery
  });
  const valueColumn = initValueColumn(queryInfo, props.valueColumn);
  const displayColumn = initDisplayColumn(queryInfo, valueColumn, props.displayColumn);
  const groupByColumn = initGroupByColumn(queryInfo, props.groupByColumn);
  let model = new QuerySelectModel(model_objectSpread(model_objectSpread({}, props), {}, {
    displayColumn,
    groupByColumn,
    isInit: true,
    queryInfo,
    valueColumn
  }));
  if (props.value !== undefined && props.value !== null) {
    let filter;
    if (props.multiple) {
      if (Array.isArray(props.value)) {
        filter = api_.Filter.create(valueColumn, props.value, api_.Filter.Types.IN);
      } else if (typeof props.value === 'string') {
        // Allow for setting multiValue value.
        // This requires updating the filter and the string
        filter = api_.Filter.create(valueColumn, parseCsvString(props.value, props.delimiter, true), api_.Filter.Types.IN);
      }
    }
    if (!filter) {
      filter = api_.Filter.create(valueColumn, props.value);
    }
    filters.push(filter);
    const data = await selectRowsDeprecated({
      columns: model.queryColumnNames,
      containerFilter,
      containerPath,
      filterArray: filters,
      queryName,
      schemaName,
      viewName
    });
    const selectedItems = (0,external_immutable_.fromJS)(quoteValueColumnWithDelimiters(data, props.valueColumn, props.delimiter).models[data.key]);
    model = model.merge({
      rawSelectedValue: props.value,
      selectedItems
    });
    if (selectedItems.size) {
      model = model.merge({
        allResults: model.allResults.merge(selectedItems),
        selectedQuery: parseSelectedQuery(model, selectedItems)
      });
    }
    if (props.fireQSChangeOnInit && api_.Utils.isFunction(props.onQSChange)) {
      let selectOptions = formatResults(model, model.selectedItems);

      // mimic ReactSelect in that it will return a single option if multiple is not true
      if (props.multiple === false) {
        selectOptions = selectOptions[0];
      }
      props.onQSChange(props.name, model.rawSelectedValue, selectOptions, props, model.selectedItems);
    }

    // fire listener if given an initial value and a listener function
    if (model.rawSelectedValue) {
      props.onInitValue?.(model.rawSelectedValue, model.selectedItems.toList());
    }
  }
  return model;
}
class QuerySelectModel extends (0,external_immutable_.Record)({
  addExactFilter: true,
  allResults: (0,external_immutable_.Map)(),
  containerFilter: undefined,
  containerPath: undefined,
  displayColumn: undefined,
  delimiter: DELIMITER,
  groupByColumn: undefined,
  isInit: false,
  maxRows: 20,
  multiple: false,
  queryFilters: undefined,
  queryInfo: undefined,
  rawSelectedValue: undefined,
  requiredColumns: [],
  schemaQuery: undefined,
  searchResults: (0,external_immutable_.Map)(),
  selectedQuery: '',
  selectedItems: (0,external_immutable_.Map)(),
  valueColumn: undefined
}) {
  get selectedOptions() {
    const options = formatResults(this, this.selectedItems);
    if (this.multiple) {
      return options;
    } else if (options.length === 1) {
      if (this.groupByColumn) {
        return options[0].options[0];
      }
      return options[0];
    } else if (options.length > 1) {
      console.warn('QuerySelect.getSelectedOptions: There are multiple options available, but model does not allow multiple selections.');
    }
    return undefined;
  }
  get queryColumnNames() {
    const {
      displayColumn,
      groupByColumn,
      queryInfo,
      requiredColumns,
      valueColumn
    } = this;
    const queryColumns = queryInfo.pkCols.concat([displayColumn, valueColumn].concat(requiredColumns));
    const lookupViewColumns = queryInfo.getLookupViewColumns();
    if (groupByColumn) {
      queryColumns.push(groupByColumn);
    }
    if (lookupViewColumns.length > 0) {
      return lookupViewColumns.map(c => c.fieldKey).concat(queryColumns);
    }
    return queryColumns;
  }
}
;// CONCATENATED MODULE: ./src/internal/components/forms/QuerySelect.tsx
const QuerySelect_excluded = ["autoInit", "containerFilter", "containerPath", "displayColumn", "fireQSChangeOnInit", "groupByColumn", "loadOnFocus", "maxRows", "onInitValue", "onQSChange", "preLoad", "queryFilters", "requiredColumns", "schemaQuery", "showLoading", "valueColumn"];
function QuerySelect_extends() { return QuerySelect_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, QuerySelect_extends.apply(null, arguments); }
function QuerySelect_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = QuerySelect_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function QuerySelect_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








function getValue(model, multiple) {
  const {
    rawSelectedValue
  } = model;
  if (rawSelectedValue !== undefined && !api_.Utils.isString(rawSelectedValue)) {
    if (Array.isArray(rawSelectedValue)) {
      return rawSelectedValue;
    } else if (external_immutable_.List.isList(rawSelectedValue)) {
      return rawSelectedValue.toArray();
    } else if (isNaN(rawSelectedValue)) {
      console.warn('QuerySelect: NaN is not a valid value', rawSelectedValue);
      return undefined;
    }
  }
  if (rawSelectedValue === null) {
    return undefined;
  }

  // Issue 37352
  // For reasons not entirely clear we cannot pass in an array of values to QuerySelect when we initialize it
  // while multiple is also set to true. Instead, we can only pass in one pre-populated value. We then need to
  // convert that value to an array here, or Formsy will only return a single value if the input is never touched
  // by the user. Converting it to an array right here gets us the best of both worlds: a pre-populated value that
  // is returned as an array when the user hits submit.
  if (rawSelectedValue !== undefined && rawSelectedValue !== '' && multiple && !Array.isArray(rawSelectedValue)) {
    return [rawSelectedValue];
  }
  return rawSelectedValue;
}

// Issue 33775: Provide a default no-op filter to a React Select to prevent "normal" filtering on the input
// when fetching async query results. They have already been filtered.
const noopFilterOptions = options => options;
const PreviewOption = props => {
  const {
    model,
    label,
    value
  } = props;
  const {
    allResults,
    queryInfo
  } = model;
  if (queryInfo && allResults.size) {
    const displayColumn = queryInfo.getColumn(model.displayColumn);
    const columns = [displayColumn].concat(queryInfo.getLookupViewColumns([model.displayColumn]));
    const item = allResults.find(result => value === result.getIn([model.valueColumn, 'value']));
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, columns.map((column, i) => {
      if (item !== undefined) {
        let text = resolveDetailFieldLabel(item.get(column.name));
        if (!api_.Utils.isString(text)) {
          text = text ? text.toString() : '';
        }
        return /*#__PURE__*/external_react_default().createElement("div", {
          key: i
        }, columns.length > 1 && /*#__PURE__*/external_react_default().createElement("strong", null, column.caption, ": "), /*#__PURE__*/external_react_default().createElement("span", null, text));
      }
      return /*#__PURE__*/external_react_default().createElement("div", {
        key: i
      }, /*#__PURE__*/external_react_default().createElement("span", null, label));
    }));
  }
  return null;
};

// This "extends" the SelectInputChange type by adding additional parameters. This should always extend the
// signature of SelectInputChange so onChange event handling can be coalesced.

/**
 * This is a subset of SelectInputProps that are passed through to the SelectInput. Mainly, this set should
 * represent all props of SelectInput that are not overridden by QuerySelect for its own
 * purposes (e.g. "options" are populated from the QuerySelect's model and thus are not allowed to
 * be specified by the user).
 */

const QuerySelect = (0,external_react_.memo)(props => {
  const [defaultOptions, setDefaultOptions] = (0,external_react_.useState)(() =>
  // See note in onFocus() regarding support for "loadOnFocus"
  props.preLoad !== false ? true : props.loadOnFocus ? [] : true);
  const [error, setError] = (0,external_react_.useState)();
  const [loadOnFocusLock, setLoadOnFocusLock] = (0,external_react_.useState)(false);
  const [initialLoad, setInitialLoad] = (0,external_react_.useState)(true);
  const [isLoading, setIsLoading] = (0,external_react_.useState)(undefined);
  const [model, setModel] = (0,external_react_.useState)();
  const lastRequest = (0,external_react_.useRef)(undefined);
  const querySelectTimer = (0,external_react_.useRef)(undefined);
  const {
      autoInit,
      containerFilter,
      containerPath,
      displayColumn,
      fireQSChangeOnInit,
      groupByColumn,
      loadOnFocus,
      maxRows,
      onInitValue,
      onQSChange,
      preLoad,
      queryFilters,
      requiredColumns,
      schemaQuery,
      showLoading,
      valueColumn
    } = props,
    selectInputProps = QuerySelect_objectWithoutProperties(props, QuerySelect_excluded);
  const {
    allowDisable,
    containerClass,
    customTheme,
    customStyles,
    defaultInputValue,
    description,
    formsy,
    helpTipRenderer,
    initiallyDisabled,
    inputClass,
    label,
    labelClass,
    menuPosition,
    multiple,
    name,
    onToggleDisable,
    openMenuOnFocus,
    required
  } = selectInputProps;
  const shouldLoadOnFocus = loadOnFocus && !loadOnFocusLock;
  const clear = (0,external_react_.useCallback)(() => {
    clearTimeout(querySelectTimer.current);
    querySelectTimer.current = undefined;
  }, []);
  (0,external_react_.useEffect)(() => {
    if (!autoInit) return clear;
    (async () => {
      try {
        const model_ = await initSelect(props);
        setModel(model_);
      } catch (e) {
        setError(resolveErrorMessage(e) ?? 'Failed to initialize.');
      }
    })();
    return clear;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoInit]);
  const loadOptions = (0,external_react_.useCallback)(input => {
    let input_;
    if (initialLoad) {
      // If a "defaultInputValue" is supplied and the initial load is an empty search,
      // then search with the "defaultInputValue"
      input_ = input ? input : defaultInputValue ?? '';
      setInitialLoad(false);
    } else {
      input_ = input;
    }
    const request = lastRequest.current = {};
    clear();

    // If loadOptions occurs prior to call to "onFocus" then there is no need to "loadOnFocus".
    if (shouldLoadOnFocus) {
      setLoadOnFocusLock(true);
    }
    return new Promise((resolve, reject) => {
      querySelectTimer.current = setTimeout(async () => {
        clear();
        try {
          const data = await fetchSearchResults(model, input_);

          // Issue 46816: Skip processing stale requests
          if (request !== lastRequest.current) return;
          lastRequest.current = undefined;
          resolve(formatSavedResults(model, data, input_));
          setModel(saveSearchResults(model, data));
        } catch (e) {
          const errorMsg = resolveErrorMessage(e) ?? 'Failed to retrieve search results.';
          console.error(errorMsg, e);
          reject(errorMsg);
          setError(errorMsg);
        }
      }, 250);
    });
  }, [clear, defaultInputValue, initialLoad, model, shouldLoadOnFocus]);
  const onChange = (0,external_react_.useCallback)((name_, value_, options_, props_) => {
    let selectedItems;
    setModel(model_ => {
      const updatedModel = setSelection(model_, value_);
      selectedItems = updatedModel.selectedItems;
      return updatedModel;
    });
    onQSChange?.(name_, value_, options_, props_, selectedItems);
  }, [onQSChange]);
  const onFocus = (0,external_react_.useCallback)(async () => {
    // NK: To support loading the select upon focus (a.k.a. "loadOnFocus") we have to explicitly utilize
    // the "defaultOptions" and "isLoading" properties of ReactSelect. These properties, in tandem with
    // "loadOptions", allow for an asynchronous ReactSelect to defer requesting the initial options until
    // desired. This follows the pattern outlined here:
    // https://github.com/JedWatson/react-select/issues/1525#issuecomment-744157380
    if (!shouldLoadOnFocus) return;

    // Set and forget "loadOnFocusLock" state so "loadOnFocus" only occurs on the initial focus.
    setIsLoading(true);
    setLoadOnFocusLock(true);
    try {
      const defaultOptions_ = await loadOptions('');
      setDefaultOptions(defaultOptions_);
      // ReactSelect respects "isLoading" with a value of {undefined} differently from a value of {false}.
      setIsLoading(undefined);
    } catch (e) {
      // ignore -- error already logged/configured in loadOptions()
    }
  }, [loadOptions, shouldLoadOnFocus]);
  const optionRenderer = (0,external_react_.useCallback)(p => /*#__PURE__*/external_react_default().createElement(PreviewOption, {
    label: p.label,
    model: model,
    value: p.value
  }), [model]);
  if (error) {
    return /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      allowDisable: allowDisable,
      containerClass: containerClass,
      customStyles: customStyles,
      customTheme: customTheme,
      description: description,
      disabled: true,
      formsy: formsy,
      helpTipRenderer: helpTipRenderer,
      initiallyDisabled: initiallyDisabled,
      isLoading: false,
      inputClass: inputClass,
      label: label,
      labelClass: labelClass,
      menuPosition: menuPosition,
      multiple: multiple,
      name: name,
      onToggleDisable: onToggleDisable,
      openMenuOnFocus: openMenuOnFocus,
      placeholder: `Error: ${error}`,
      required: required
    });
  }
  if (model?.isInit) {
    return /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, QuerySelect_extends({
      label: label !== undefined ? label : model.queryInfo.title,
      optionRenderer: optionRenderer
    }, selectInputProps, {
      allowCreate: false,
      autoValue: false // QuerySelect directly controls value of SelectInput via "selectedOptions"
      ,
      cacheOptions: true,
      defaultOptions: defaultOptions,
      isLoading: isLoading,
      loadOptions: loadOptions,
      onChange: onChange,
      onFocus: onFocus,
      options: undefined // prevent override
      ,
      selectedOptions: model.selectedOptions,
      value: getValue(model, multiple) // needed to initialize the Formsy "value" properly
    }));
  }
  if (showLoading) {
    return /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      allowDisable: allowDisable,
      containerClass: containerClass,
      customStyles: customStyles,
      customTheme: customTheme,
      description: description,
      disabled: true,
      formsy: formsy,
      helpTipRenderer: helpTipRenderer,
      initiallyDisabled: initiallyDisabled,
      label: label,
      labelClass: labelClass,
      menuPosition: menuPosition,
      multiple: multiple,
      name: name,
      onToggleDisable: onToggleDisable,
      openMenuOnFocus: openMenuOnFocus,
      placeholder: "Loading...",
      required: required,
      value: undefined
    });
  }
  return null;
});
QuerySelect.defaultProps = {
  // Prevent initialization in test environments in lieu of mocking APIWrapper in all test locations
  autoInit: "production" !== 'test',
  delimiter: DELIMITER,
  filterOption: noopFilterOptions,
  fireQSChangeOnInit: false,
  loadOnFocus: false,
  preLoad: true,
  showLoading: true
};
QuerySelect.displayName = 'QuerySelect';
;// CONCATENATED MODULE: ./src/internal/components/forms/input/SampleStatusInput.tsx
const SampleStatusInput_excluded = ["api", "col", "onAdditionalFormDataChange", "renderLabelField"];
function SampleStatusInput_extends() { return SampleStatusInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, SampleStatusInput_extends.apply(null, arguments); }
function SampleStatusInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = SampleStatusInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function SampleStatusInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }










const SampleStatusInput = (0,external_react_.memo)(props => {
  const {
      api,
      col,
      onAdditionalFormDataChange,
      renderLabelField
    } = props,
    querySelectProps = SampleStatusInput_objectWithoutProperties(props, SampleStatusInput_excluded);
  const {
    allowDisable,
    onQSChange,
    value
  } = querySelectProps;
  const {
    user
  } = useServerContext();
  const [consumedStatuses, setConsumedStatuses] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  const [showDiscardPanel, setShowDiscardPanel] = (0,external_react_.useState)(false);
  const [shouldDiscard, setShouldDiscard] = (0,external_react_.useState)(true);
  (0,external_react_.useEffect)(() => {
    (async () => {
      try {
        const statuses = await api.samples.getSampleStatuses();
        const consumedStatusIds = [];
        statuses.forEach(status => {
          if (status.stateType === SampleStateType.Consumed) consumedStatusIds.push(status.rowId);
        });
        setConsumedStatuses(consumedStatusIds);
      } catch (e) {
        setError('Error loading sample statuses. If you want to discard ' + (allowDisable /* bulk update */ ? 'any samples' : 'the sample') + ' being updated to a Consumed status, you will have to do that separately.');
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onChange = (0,external_react_.useCallback)((name, newValue, selectedOptions, props_, selectedItems) => {
    onQSChange?.(name, newValue, selectedOptions, props_, selectedItems);
    if (userCanEditStorageData(user)) {
      const isConsumed = consumedStatuses?.indexOf(newValue) > -1 && value !== newValue;
      const isInStorage = onAdditionalFormDataChange?.(DISCARD_CONSUMED_CHECKBOX_FIELD, shouldDiscard && isConsumed);
      setShowDiscardPanel(isInStorage && isConsumed);
    }
  }, [consumedStatuses, onAdditionalFormDataChange, onQSChange, shouldDiscard, user, value]);
  const toggleShouldDiscard = (0,external_react_.useCallback)(() => {
    const updatedShouldDiscard = !shouldDiscard;
    setShouldDiscard(updatedShouldDiscard);
    onAdditionalFormDataChange?.(DISCARD_CONSUMED_CHECKBOX_FIELD, updatedShouldDiscard && showDiscardPanel);
  }, [shouldDiscard, onAdditionalFormDataChange, showDiscardPanel]);
  const discardPanel = (0,external_react_.useMemo)(() => {
    const isBulkForm = allowDisable;
    const panel = /*#__PURE__*/external_react_default().createElement(DiscardConsumedSamplesPanel, {
      shouldDiscard: shouldDiscard,
      toggleShouldDiscard: toggleShouldDiscard,
      discardTitle: `Discard sample${isBulkForm ? '(s)' : ''} from storage?`
    });
    if (isBulkForm) {
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "row sample-bulk-update-discard-panel"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-sm-3 col-xs-12"
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-sm-9 col-xs-12"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "left-spacing right-spacing"
      }, panel)));
    }
    return panel;
  }, [shouldDiscard, toggleShouldDiscard, allowDisable]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, renderLabelField?.(col), /*#__PURE__*/external_react_default().createElement(QuerySelect, SampleStatusInput_extends({
    containerPath: col.lookup.containerPath,
    description: col.description,
    displayColumn: col.lookup.displayColumn,
    helpTipRenderer: col.helpTipRenderer,
    joinValues: col.isJunctionLookup(),
    label: col.caption,
    maxRows: LOOKUP_DEFAULT_SIZE,
    multiple: col.isJunctionLookup(),
    name: col.fieldKey,
    openMenuOnFocus: !col.isJunctionLookup(),
    required: col.required,
    showLoading: false
  }, querySelectProps, {
    containerFilter: getSampleStatusContainerFilter(),
    onQSChange: onChange,
    schemaQuery: col.lookup.schemaQuery,
    valueColumn: col.lookup.keyColumn
  })), error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), showDiscardPanel && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, discardPanel));
});
SampleStatusInput.defaultProps = {
  api: getDefaultAPIWrapper(),
  formsy: true
};
const SampleStatusInputRenderer = (0,external_react_.memo)(props => {
  const {
    allowFieldDisable,
    col,
    containerPath,
    formsy,
    initiallyDisabled,
    onAdditionalFormDataChange,
    onSelectChange,
    onToggleDisable,
    renderLabelField,
    selectInputProps,
    showAsteriskSymbol,
    value
  } = props;
  return /*#__PURE__*/external_react_default().createElement(SampleStatusInput, SampleStatusInput_extends({}, selectInputProps, {
    addLabelAsterisk: showAsteriskSymbol,
    allowDisable: allowFieldDisable,
    col: col,
    containerPath: containerPath,
    formsy: formsy,
    initiallyDisabled: initiallyDisabled,
    onAdditionalFormDataChange: onAdditionalFormDataChange,
    onQSChange: onSelectChange,
    onToggleDisable: onToggleDisable,
    renderLabelField: renderLabelField,
    value: value
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/forms/input/InputRenderFactory.ts




const inputRenderers = {};
let InputRenderContext = /*#__PURE__*/function (InputRenderContext) {
  InputRenderContext["All"] = "All";
  InputRenderContext["Form"] = "Form";
  InputRenderContext["Grid"] = "Grid";
  return InputRenderContext;
}({});
function getKey(identifier, inputRenderContext) {
  return [identifier.toLowerCase(), inputRenderContext].join('|');
}
function registerInputRenderer(identifier, renderer, inputRenderContext = InputRenderContext.All) {
  if (inputRenderContext === InputRenderContext.All) {
    inputRenderers[getKey(identifier, InputRenderContext.Form)] = renderer;
    inputRenderers[getKey(identifier, InputRenderContext.Grid)] = renderer;
  } else {
    inputRenderers[getKey(identifier, inputRenderContext)] = renderer;
  }
}
const resolveInputRenderer = (col, isGridInput = false) => {
  if (col?.inputRenderer) {
    const context = isGridInput ? InputRenderContext.Grid : InputRenderContext.Form;
    return inputRenderers[getKey(col.inputRenderer, context)];
  }
  return undefined;
};
function registerInputRenderers() {
  registerInputRenderer('AppendUnitsInput', AppendUnitsInput, InputRenderContext.Form);
  registerInputRenderer('ExperimentAlias', AliasGridInput, InputRenderContext.Grid);
  registerInputRenderer('ExperimentAlias', AliasInput, InputRenderContext.Form);
  registerInputRenderer('SampleStatusInput', SampleStatusInputRenderer);
  registerInputRenderer('WorkflowTask', AssayTaskInputRenderer);
}
;// CONCATENATED MODULE: ./src/internal/components/forms/input/CheckboxInput.tsx
function CheckboxInput_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CheckboxInput_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CheckboxInput_ownKeys(Object(t), !0).forEach(function (r) { CheckboxInput_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CheckboxInput_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CheckboxInput_extends() { return CheckboxInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, CheckboxInput_extends.apply(null, arguments); }
function CheckboxInput_defineProperty(e, r, t) { return (r = CheckboxInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function CheckboxInput_toPropertyKey(t) { var i = CheckboxInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function CheckboxInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





class CheckboxInputImpl extends DisableableInput {
  constructor(props) {
    super(props);
    CheckboxInput_defineProperty(this, "onChange", e => {
      const checked = e.target.checked;
      this.setState({
        checked
      });
      if (this.props.formsy) {
        this.props.setValue?.(checked);
      }
    });
    CheckboxInput_defineProperty(this, "toggleDisabled", () => {
      const {
        value
      } = this.props;
      this.setState(state => ({
        isDisabled: !state.isDisabled,
        checked: state.isDisabled ? state.checked : value === true || value === 'true'
      }), () => {
        this.props.onToggleDisable?.(this.state.isDisabled);
      });
    });
    this.state = {
      checked: props.value === true || props.value === 'true',
      isDisabled: props.initiallyDisabled
    };
  }
  render() {
    const {
      addLabelAsterisk,
      allowDisable,
      containerClassName,
      formsy,
      getValue,
      label,
      labelClassName,
      name,
      queryColumn,
      showLabel,
      renderFieldLabel,
      wrapperClassName
    } = this.props;
    const {
      checked,
      isDisabled
    } = this.state;

    // N.B.  We do not use the Checkbox component from Formsy because it does not support
    // React.Nodes as labels.  Using a label that is anything but a string when using Checkbox
    // produces a "Converting circular structure to JSON" error.
    // TODO: This label generation is inconsistent and does not align with other input elements.
    // This should not be responsible for rendering the "required-symbol" and should allow for component prop
    // to define label wrapper classes.
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: `${containerClassName} checkbox-input-form-row`
    }, renderFieldLabel ? /*#__PURE__*/external_react_default().createElement("label", {
      className: labelClassName
    }, renderFieldLabel(queryColumn), queryColumn?.required && /*#__PURE__*/external_react_default().createElement("span", {
      className: "required-symbol"
    }, " *")) : /*#__PURE__*/external_react_default().createElement(FieldLabel, {
      label: label,
      labelOverlayProps: {
        isFormsy: false,
        inputId: queryColumn.fieldKey,
        addLabelAsterisk
      },
      showLabel: showLabel,
      showToggle: allowDisable,
      column: queryColumn,
      isDisabled: isDisabled,
      toggleProps: {
        onClick: this.toggleDisabled
      }
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: wrapperClassName
    }, /*#__PURE__*/external_react_default().createElement("input", {
      disabled: isDisabled,
      name: name ?? queryColumn.fieldKey
      // Issue 43299: Ignore "required" property for boolean columns as this will
      // cause any false value (i.e. unchecked) to prevent submission.
      // required={queryColumn.required}
      ,
      type: "checkbox",
      value: formsy ? getValue() : checked,
      checked: checked,
      onChange: this.onChange
    })));
  }
}

/**
 * This class is a wrapper around ReactSelect to be able to bind formsy-react. It uses
 * the Formsy.Decorator to bind formsy-react so the element can be validated, submitted, etc.
 */
CheckboxInput_defineProperty(CheckboxInputImpl, "defaultProps", CheckboxInput_objectSpread(CheckboxInput_objectSpread({}, DisableableInput.defaultProps), {}, {
  containerClassName: INPUT_CONTAINER_CLASS_NAME,
  labelClassName: INPUT_LABEL_CLASS_NAME,
  showLabel: true,
  wrapperClassName: INPUT_WRAPPER_CLASS_NAME
}));
const CheckboxInputFormsy = (0,external_formsy_react_.withFormsy)(CheckboxInputImpl);
const CheckboxInput_CheckboxInput = props => {
  if (props.formsy) {
    return /*#__PURE__*/external_react_default().createElement(CheckboxInputFormsy, CheckboxInput_extends({
      name: props.name ?? props.queryColumn.name
    }, props));
  }
  return /*#__PURE__*/external_react_default().createElement(CheckboxInputImpl, props);
};
CheckboxInput_CheckboxInput.defaultProps = {
  formsy: true
};
CheckboxInput_CheckboxInput.displayName = 'CheckboxInput';
;// CONCATENATED MODULE: ./src/internal/components/forms/input/TextAreaInput.tsx
const TextAreaInput_excluded = ["allowDisable", "initiallyDisabled", "onToggleDisable"],
  TextAreaInput_excluded2 = ["addLabelAsterisk", "onChange", "queryColumn", "renderFieldLabel", "showLabel"];
function TextAreaInput_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TextAreaInput_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TextAreaInput_ownKeys(Object(t), !0).forEach(function (r) { TextAreaInput_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TextAreaInput_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextAreaInput_extends() { return TextAreaInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, TextAreaInput_extends.apply(null, arguments); }
function TextAreaInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = TextAreaInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function TextAreaInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function TextAreaInput_defineProperty(e, r, t) { return (r = TextAreaInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function TextAreaInput_toPropertyKey(t) { var i = TextAreaInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function TextAreaInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





class TextAreaInput extends DisableableInput {
  constructor(props) {
    super(props);
    TextAreaInput_defineProperty(this, "onChange", (name, value) => {
      if (this.props.allowDisable) {
        this.setState({
          inputValue: value
        });
      }
      this.props.onChange?.(value);
    });
    this.toggleDisabled = this.toggleDisabled.bind(this);
    this.state = {
      isDisabled: props.initiallyDisabled
    };
  }
  renderLabel() {
    const {
      label,
      queryColumn,
      showLabel,
      allowDisable,
      addLabelAsterisk,
      renderFieldLabel
    } = this.props;
    const {
      isDisabled
    } = this.state;
    if (renderFieldLabel) {
      return renderFieldLabel(queryColumn);
    }
    return /*#__PURE__*/external_react_default().createElement(FieldLabel, {
      label: label,
      showLabel: showLabel,
      labelOverlayProps: {
        isFormsy: true,
        addLabelAsterisk
      },
      showToggle: allowDisable,
      column: queryColumn,
      isDisabled: isDisabled,
      toggleProps: {
        onClick: this.toggleDisabled
      }
    });
  }
  render() {
    // Extract DisableableInputProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _this$props = this.props,
      {
        allowDisable,
        initiallyDisabled,
        onToggleDisable
      } = _this$props,
      rest = TextAreaInput_objectWithoutProperties(_this$props, TextAreaInput_excluded);
    // Extract TextAreaInputProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {
        addLabelAsterisk,
        onChange,
        queryColumn,
        renderFieldLabel,
        showLabel
      } = rest,
      textAreaProps = TextAreaInput_objectWithoutProperties(rest, TextAreaInput_excluded2);
    const {
      labelClassName
    } = textAreaProps;
    return /*#__PURE__*/external_react_default().createElement(FormsyTextArea, TextAreaInput_extends({
      id: queryColumn.fieldKey,
      name: queryColumn.fieldKey,
      placeholder: `Enter ${queryColumn.caption.toLowerCase()}`,
      required: queryColumn.required
    }, textAreaProps, {
      disabled: this.state.isDisabled,
      onChange: this.onChange,
      label: this.renderLabel(),
      labelClassName: showLabel ? labelClassName : 'hide-label',
      value: this.getInputValue()
    }));
  }
}
TextAreaInput_defineProperty(TextAreaInput, "defaultProps", TextAreaInput_objectSpread(TextAreaInput_objectSpread({}, DisableableInput.defaultProps), {
  cols: 50,
  elementWrapperClassName: INPUT_WRAPPER_CLASS_NAME,
  labelClassName: `${INPUT_LABEL_CLASS_NAME} textarea-control-label`,
  rows: 5,
  showLabel: true
}));
;// CONCATENATED MODULE: ./src/internal/renderers/AttachmentCard.tsx







const now = () => new Date().valueOf();
const AttachmentCard = (0,external_react_.memo)(props => {
  const {
    attachment,
    imageURL,
    imageCls,
    onCopyLink,
    onRemove,
    onDownload,
    outerCls = '',
    noun = 'attachment',
    copyNoun = 'link',
    allowRemove = true,
    allowDownload = true
  } = props;
  const [showModal, setShowModal] = (0,external_react_.useState)();
  const _showModal = (0,external_react_.useCallback)(() => {
    setShowModal(true);
  }, [setShowModal]);
  const _hideModal = (0,external_react_.useCallback)(() => {
    setShowModal(false);
  }, [setShowModal]);
  const _onCopyLink = (0,external_react_.useCallback)(() => onCopyLink(attachment), [attachment, onCopyLink]);
  const _onDownload = (0,external_react_.useCallback)(() => {
    if (allowDownload) {
      onDownload?.(attachment);
    }
  }, [allowDownload, attachment, onDownload]);
  const _onRemove = (0,external_react_.useCallback)(() => {
    if (allowRemove) {
      onRemove?.(attachment);
    }
  }, [allowRemove, attachment, onRemove]);
  const showMenu = (0,external_react_.useMemo)(() => {
    return (onCopyLink || allowDownload) && !attachment?.unavailable || allowRemove;
  }, [onCopyLink, allowDownload, attachment, allowRemove]);
  if (!attachment) {
    return null;
  }
  const {
    iconFontCls,
    loadingState,
    name,
    title,
    size,
    description,
    unavailable
  } = attachment;
  const _iconFontCls = iconFontCls ?? getIconFontCls(name);
  const isLoaded = !isLoading(loadingState);
  const recentlyCreated = attachment.created ? attachment.created > now() - 30000 : false;
  const _isImage = isImage(attachment.name);
  const modalTitle = /*#__PURE__*/external_react_default().createElement("a", {
    onClick: _onDownload,
    className: "clickable",
    title: 'Download ' + noun
  }, title ?? name);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('attachment-card ' + outerCls, {
      'attachment-unavailable': unavailable,
      'attachment-unavailable-wide': unavailable && !showMenu
    }),
    title: name + (unavailable ? ' (unavailable)' : '')
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "attachment-card__body",
    onClick: isLoaded && !unavailable ? _isImage ? _showModal : _onDownload : undefined
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "attachment-card__icon"
  }, _isImage && !isLoaded && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
    msg: ""
  }), _isImage && isLoaded && !unavailable && /*#__PURE__*/external_react_default().createElement("img", {
    className: `attachment-card__icon_img ${imageCls}`,
    src: imageURL,
    alt: name
  }), (!_isImage || unavailable) && /*#__PURE__*/external_react_default().createElement("i", {
    className: `attachment-card__icon_tile ${_iconFontCls}`
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "attachment-card__content"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "attachment-card__name"
  }, title ?? name), /*#__PURE__*/external_react_default().createElement("div", {
    className: "attachment-card__size"
  }, !isLoaded && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
    msg: "Uploading..."
  }), isLoaded && recentlyCreated && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-check-circle"
  }), " File attached"), isLoaded && !recentlyCreated && size && formatBytes(size)), description && /*#__PURE__*/external_react_default().createElement("div", {
    className: "attachment-card__description"
  }, description))), isLoaded && showMenu && /*#__PURE__*/external_react_default().createElement(DropdownAnchor, {
    className: "attachment-card__menu",
    title: /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-ellipsis-v"
    }),
    pullRight: true
  }, onCopyLink && !unavailable && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: _onCopyLink
  }, "Copy ", copyNoun), allowDownload && !unavailable && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: _onDownload
  }, "Download"), allowRemove && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: _onRemove
  }, "Remove ", noun))), showModal && /*#__PURE__*/external_react_default().createElement(Modal, {
    bsSize: "lg",
    cancelText: "Dismiss",
    onCancel: _hideModal,
    title: modalTitle
  }, /*#__PURE__*/external_react_default().createElement("img", {
    src: imageURL,
    alt: `${name} image`,
    title: name,
    className: "attachment-card__img_modal"
  })));
});
;// CONCATENATED MODULE: ./src/internal/renderers/FileColumnRenderer.tsx
function FileColumnRenderer_extends() { return FileColumnRenderer_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, FileColumnRenderer_extends.apply(null, arguments); }
function FileColumnRenderer_defineProperty(e, r, t) { return (r = FileColumnRenderer_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FileColumnRenderer_toPropertyKey(t) { var i = FileColumnRenderer_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FileColumnRenderer_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




const UNAVAILABLE_FILE_SUFFIX = ' (unavailable)';
const getFileDisplayValue = rawDisplayValue => {
  if (rawDisplayValue?.endsWith(UNAVAILABLE_FILE_SUFFIX)) {
    return {
      filename: rawDisplayValue.substring(0, rawDisplayValue.length - UNAVAILABLE_FILE_SUFFIX.length),
      fileUnavailable: true
    };
  }
  return {
    filename: rawDisplayValue,
    fileUnavailable: false
  };
};
const getAttachmentCardProp = (data, colRangeUri, onRemove) => {
  if (!data) return null;
  const url = data.get('url');
  const value = data.get('value');
  const {
    filename,
    fileUnavailable
  } = getFileDisplayValue(data.get('displayValue'));
  const name = filename || value;
  if (!name) {
    return null;
  }

  // Attachment URLs will look like images, so we check if the URL is an image.
  // FileLink URLs don't look like images, so you have to check value or displayValue.
  const _isImage = url && isImage(url) || filename && isImage(filename) || value && isImage(value);
  const attachment = {
    name,
    title: getAttachmentTitleFromName(name),
    iconFontCls: getIconFontCls(name, fileUnavailable),
    unavailable: fileUnavailable
  };
  return {
    noun: colRangeUri === FILELINK_RANGE_URI ? 'file' : 'attachment',
    attachment,
    imageURL: _isImage ? url : undefined,
    imageCls: 'attachment-card__img',
    allowRemove: onRemove !== undefined,
    onRemove
  };
};
class FileColumnRenderer extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    FileColumnRenderer_defineProperty(this, "onDownload", attachment => {
      const {
        data
      } = this.props;
      const url = data?.get('url');
      if (url) {
        downloadAttachment(url, false, attachment.name);
      }
    });
  }
  render() {
    const {
      col,
      data,
      onRemove
    } = this.props;
    const cardProps = getAttachmentCardProp(data, col?.rangeURI, onRemove);
    if (!cardProps) return null;
    return /*#__PURE__*/external_react_default().createElement(AttachmentCard, FileColumnRenderer_extends({}, cardProps, {
      onDownload: this.onDownload
    }));
  }
}

// exported for jest testing
function getAttachmentTitleFromName(name) {
  if (name.indexOf('/') > -1) {
    return name.substr(name.lastIndexOf('/') + 1);
  }
  // Issue 43725: Windows file name comes through with backslash instead
  else if (name.indexOf('\\') > -1) {
    return name.substr(name.lastIndexOf('\\') + 1);
  }
  return name;
}
;// CONCATENATED MODULE: ./src/internal/components/forms/input/FileInput.tsx
function FileInput_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FileInput_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FileInput_ownKeys(Object(t), !0).forEach(function (r) { FileInput_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FileInput_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FileInput_defineProperty(e, r, t) { return (r = FileInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FileInput_toPropertyKey(t) { var i = FileInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FileInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









class FileInputImpl extends DisableableInput {
  constructor(props) {
    super(props);
    FileInput_defineProperty(this, "fileInput", void 0);
    this.processFiles = this.processFiles.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onDrag = this.onDrag.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.setFormValue = this.setFormValue.bind(this);
    this.toggleDisabled = this.toggleDisabled.bind(this);
    this.fileInput = external_react_default().createRef();
    this.state = {
      // FileInput only accepts query-shaped row data as the initialValue
      // as that is what is accepted by FileColumnRenderer. Without this there is likely insufficient
      // metadata to render and act on the associated file value.
      data: external_immutable_.Map.isMap(props.initialValue) ? props.initialValue : undefined,
      isHover: false,
      file: null,
      error: '',
      isDisabled: props.initiallyDisabled
    };
  }
  getInputName() {
    // FIXME if there's more than one of these on the page with the same inputName
    // files will go to the wrong place when uploaded unless the names are unique
    return this.props.name ?? this.props.queryColumn.fieldKey;
  }
  processFiles(fileList, transferItems) {
    if (fileList.length > 1) {
      this.setState({
        error: 'Only one file allowed'
      });
      return;
    }
    if (transferItems && transferItems[0].webkitGetAsEntry().isDirectory) {
      this.setState({
        error: 'Folders are not supported, only one file allowed'
      });
      return;
    }
    this.setFormValue(fileList[0]);
  }
  setFormValue(file) {
    const {
      formsy,
      onChange,
      setValue
    } = this.props;
    this.setState({
      data: undefined,
      file,
      error: ''
    });
    onChange?.({
      [this.getInputName()]: file
    });
    if (formsy) {
      setValue?.(file);
    }
  }
  onChange(event) {
    cancelEvent(event);
    this.processFiles(this.fileInput.current.files);
  }
  onDrag(event) {
    cancelEvent(event);
    if (!this.state.isHover) {
      this.setState({
        isHover: true
      });
    }
  }
  onDragLeave(event) {
    cancelEvent(event);
    if (this.state.isHover) {
      this.setState({
        isHover: false
      });
    }
  }
  onDrop(event) {
    cancelEvent(event);
    if (event.dataTransfer && event.dataTransfer.files) {
      this.processFiles(event.dataTransfer.files, event.dataTransfer.items);
      this.setState({
        isHover: false
      });
    }
  }
  onRemove() {
    // A value of null is supported by server APIs to clear/remove a file field's value.
    this.setFormValue(null);
  }
  render() {
    const {
      addLabelAsterisk,
      allowDisable,
      elementWrapperClassName,
      labelClassName,
      queryColumn,
      renderFieldLabel,
      showLabel,
      toggleDisabledTooltip
    } = this.props;
    const {
      data,
      file,
      isDisabled,
      isHover
    } = this.state;
    const name = this.getInputName();
    const inputId = `${name}-fileUpload`;
    let body;
    if (file) {
      const attachedFileClass = external_classnames_default()('attached-file--inline-container', {
        'file-upload--is-hover': isHover
      });
      body = /*#__PURE__*/external_react_default().createElement("div", {
        className: attachedFileClass,
        onDrop: this.onDrop,
        onDragEnter: this.onDrag,
        onDragOver: this.onDrag,
        onDragLeave: this.onDragLeave
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "fa fa-times-circle attached-file--remove-icon",
        onClick: this.onRemove
      }), /*#__PURE__*/external_react_default().createElement("span", {
        className: "fa fa-file-text attached-file--icon"
      }), /*#__PURE__*/external_react_default().createElement("span", null, file.name), /*#__PURE__*/external_react_default().createElement("span", {
        className: "file-upload--error-message"
      }, this.state.error));
    } else if (data?.get('value')) {
      body = /*#__PURE__*/external_react_default().createElement(FileColumnRenderer, {
        col: queryColumn,
        data: data,
        onRemove: isDisabled ? undefined : this.onRemove
      });
    } else {
      body = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("input", {
        disabled: this.state.isDisabled,
        type: "file",
        className: "file-upload--input" // This class makes the file input hidden
        ,
        name: name,
        id: inputId,
        multiple: false,
        onChange: this.onChange,
        ref: this.fileInput
      }), /*#__PURE__*/external_react_default().createElement("label", {
        className: external_classnames_default()('file-upload--compact-label', {
          'file-upload--is-disabled': isDisabled,
          'file-upload--is-hover': isHover && !isDisabled
        }),
        htmlFor: inputId,
        onDrop: this.onDrop,
        onDragEnter: this.onDrag,
        onDragOver: this.onDrag,
        onDragLeave: this.onDragLeave
      }, /*#__PURE__*/external_react_default().createElement("i", {
        className: "fa fa-cloud-upload",
        "aria-hidden": "true"
      }), "\xA0", /*#__PURE__*/external_react_default().createElement("span", null, "Select file or drag and drop here."), /*#__PURE__*/external_react_default().createElement("span", {
        className: "file-upload--error-message"
      }, this.state.error)));
    }
    const labelOverlayProps = {
      addLabelAsterisk,
      inputId,
      // While this component supports binding Formsy it does not use a Formsy component
      // to render the associated label. As such, the label overlay is always configured as isFormsy={false}.
      isFormsy: false,
      labelClass: labelClassName
    };
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "form-group row"
    }, renderFieldLabel ? renderFieldLabel(queryColumn) : /*#__PURE__*/external_react_default().createElement(FieldLabel, {
      labelOverlayProps: labelOverlayProps,
      showLabel: showLabel,
      showToggle: allowDisable,
      column: queryColumn,
      isDisabled: isDisabled,
      toggleProps: {
        onClick: toggleDisabledTooltip ? undefined : this.toggleDisabled,
        toolTip: toggleDisabledTooltip
      }
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: elementWrapperClassName
    }, body));
  }
}

/**
 * This class is a wrapper around FileInputImpl to be able to bind formsy-react. It uses
 * the Formsy.Decorator to bind formsy-react so the element can be validated, submitted, etc.
 */
FileInput_defineProperty(FileInputImpl, "defaultProps", FileInput_objectSpread(FileInput_objectSpread({}, DisableableInput.defaultProps), {
  changeDebounceInterval: 0,
  elementWrapperClassName: INPUT_WRAPPER_CLASS_NAME,
  showLabel: true
}));
const FileInputFormsy = (0,external_formsy_react_.withFormsy)(FileInputImpl);
const FileInput = props => {
  if (props.formsy) {
    return /*#__PURE__*/external_react_default().createElement(FileInputFormsy, props);
  }
  return /*#__PURE__*/external_react_default().createElement(FileInputImpl, props);
};
FileInput.defaultProps = {
  formsy: false
};
FileInput.displayName = 'FileInput';
// EXTERNAL MODULE: external "react-datepicker"
var external_react_datepicker_ = __webpack_require__(824);
var external_react_datepicker_default = /*#__PURE__*/__webpack_require__.n(external_react_datepicker_);
;// CONCATENATED MODULE: ./src/internal/components/forms/input/DatePickerInput.tsx
function DatePickerInput_extends() { return DatePickerInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DatePickerInput_extends.apply(null, arguments); }
function DatePickerInput_defineProperty(e, r, t) { return (r = DatePickerInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DatePickerInput_toPropertyKey(t) { var i = DatePickerInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DatePickerInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







// export for jest testing
class DatePickerInputImpl extends DisableableInput {
  constructor(props) {
    super(props);
    DatePickerInput_defineProperty(this, "input", void 0);
    DatePickerInput_defineProperty(this, "toggleDisabled", () => {
      this.setState(state => ({
        isDisabled: !state.isDisabled,
        selectedDate: state.isDisabled ? state.selectedDate : this.getInitDate(this.props)
      }), () => {
        this.props.onToggleDisable?.(this.state.isDisabled);
      });
    });
    DatePickerInput_defineProperty(this, "onChange", (date, event) => {
      const {
        hideTime,
        queryColumn
      } = this.props;
      const isTimeOnly = queryColumn.isTimeColumn;
      const isDateOnly = queryColumn.isDateOnlyColumn;
      this.setState({
        selectedDate: date,
        invalid: false,
        invalidStart: false
      });
      if (this.state.relativeInputValue) {
        this.props.onChange?.(this.state.relativeInputValue, this.state.relativeInputValue);
      } else {
        const formatted = getFormattedStringFromDate(date, queryColumn, hideTime);
        if (isTimeOnly) {
          this.props.onChange?.(formatted, formatted);

          // Issue 44398: match JSON dateTime format provided by LK server when submitting date values back for insert/update
          if (this.props.formsy) {
            this.props.setValue?.(getJsonTimeFormatString(date));
          }
        } else {
          this.props.onChange?.(date, formatted);

          // Issue 44398: match JSON dateTime format provided by LK server when submitting date values back for insert/update
          if (this.props.formsy) {
            this.props.setValue?.(isDateOnly ? getJsonDateFormatString(date) : getJsonDateTimeFormatString(date));
          }
        }
      }

      // event is null when selecting time picker
      if (!event && this.props.inlineEdit) this.input.current.setFocus();
    });
    DatePickerInput_defineProperty(this, "onChangeRaw", event => {
      const {
        queryColumn
      } = this.props;
      const isTime = queryColumn.isTimeColumn;
      const value = event?.target?.value;
      if (isTime) {
        if (!value) {
          this.onChange(null);
        } else {
          // Issue 50010: Time picker enters the wrong time if a time field has a format set
          const time = parseSimpleTime(value);
          if (time instanceof Date && !isNaN(time.getTime())) {
            // Issue 50102: LKSM: When bulk updating a time-only field and entering a value with PM results in the AM time being selected
            this.setState({
              selectedDate: time,
              invalid: false,
              invalidStart: false
            });
            const formatted = getFormattedStringFromDate(time, queryColumn, false);
            this.props.onChange?.(formatted, formatted);

            // Issue 44398: match JSON dateTime format provided by LK server when submitting date values back for insert/update
            if (this.props.formsy) {
              this.props.setValue?.(getJsonTimeFormatString(time));
            }
          }
        }
      } else if (isRelativeDateFilterValue(value)) {
        this.setState({
          relativeInputValue: value
        });
        this.props.onChange?.(value);
      } else {
        this.setState({
          relativeInputValue: undefined
        });
      }
    });
    DatePickerInput_defineProperty(this, "onIconClick", () => {
      this.input.current?.setFocus();
    });
    DatePickerInput_defineProperty(this, "onSelect", () => {
      // focus the input so an onBlur action gets triggered after selection has been made
      this.input.current?.setFocus();
    });
    const {
      queryColumn: _queryColumn
    } = props;
    const _isTimeOnly = _queryColumn.isTimeColumn;
    this.toggleDisabled = this.toggleDisabled.bind(this);

    // Issue 45140: formsy values will hold on to the initial formatted value until onChange.
    // We instead need to make sure that the unformatted Date value is passed to setValue if there is an init value.
    const initDate = this.getInitDate(props);
    if (props.formsy && !_isTimeOnly) {
      props.setValue?.(initDate);
    }
    let invalidStart = false,
      invalid = false;
    if (props.value && !isRelativeDateFilterValue(props.value)) {
      // Issue 46767: DatePicker valid dates start at year 1000 (i.e. new Date('1000-01-01'))
      invalidStart = this.getInitDate(props, new Date('1000-01-01')) === null;
      invalid = this.getInitDate(props) === null;
    }
    this.input = external_react_default().createRef();
    this.state = {
      isDisabled: props.initiallyDisabled,
      selectedDate: initDate,
      invalid,
      invalidStart,
      relativeInputValue: undefined
    };
  }
  getInitDate(props, minDate) {
    const {
      queryColumn
    } = props;
    const isTimeOnly = queryColumn.isTimeColumn;
    const isDateOnly = queryColumn.isDateOnlyColumn;
    // Issue 45140: props.value is the original formatted date, so pass the date format
    // to parseDate when getting the initial value.
    const dateFormat = props.initValueFormatted ? this.getDateFormat() : undefined;
    if (props.allowRelativeInput && isRelativeDateFilterValue(props.value)) return undefined;
    return props.value ? parseDate(props.value, dateFormat, minDate, isTimeOnly, isDateOnly) : undefined;
  }
  getDateFormat() {
    const {
      queryColumn,
      hideTime
    } = this.props;
    return getPickerDateAndTimeFormat(queryColumn, hideTime).dateFormat;
  }
  render() {
    const {
      addLabelAsterisk,
      allowDisable,
      allowRelativeInput,
      containerClassName,
      autoFocus,
      hideTime,
      inputClassName,
      inputWrapperClassName,
      isClearable,
      isFormInput,
      label,
      labelClassName,
      name,
      onCalendarClose,
      onKeyDown,
      placeholderText,
      queryColumn,
      renderFieldLabel,
      showLabel,
      value,
      wrapperClassName,
      onBlur,
      inlineEdit
    } = this.props;
    const {
      isDisabled,
      selectedDate,
      invalid,
      invalidStart
    } = this.state;
    const {
      dateFormat,
      timeFormat
    } = getPickerDateAndTimeFormat(queryColumn, hideTime);
    const validValueInvalidStart = !invalid && invalidStart;
    const isTimeOnly = queryColumn.isTimeColumn;
    const picker = /*#__PURE__*/external_react_default().createElement((external_react_datepicker_default()), {
      ref: this.input,
      autoComplete: "off",
      autoFocus: autoFocus,
      className: inputClassName,
      dateFormat: dateFormat,
      disabled: isDisabled,
      id: queryColumn.fieldKey,
      isClearable: isClearable,
      name: name ? name : queryColumn.fieldKey,
      onCalendarClose: onCalendarClose,
      onChange: this.onChange,
      onChangeRaw: allowRelativeInput || isTimeOnly ? this.onChangeRaw : undefined,
      onKeyDown: onKeyDown,
      onMonthChange: this.onChange,
      placeholderText: placeholderText ?? `Select ${queryColumn.caption.toLowerCase()}`,
      selected: invalid ? null : selectedDate,
      showTimeSelect: !hideTime && (isDateTimeCol(queryColumn) || isTimeOnly) && !validValueInvalidStart,
      showTimeSelectOnly: !hideTime && isTimeOnly,
      timeIntervals: isTimeOnly ? 10 : 30,
      timeFormat: timeFormat,
      value: allowRelativeInput && !isTimeOnly && isRelativeDateFilterValue(value) ? value : undefined,
      wrapperClassName: inputWrapperClassName,
      onSelect: inlineEdit ? this.onSelect : undefined,
      onBlur: inlineEdit ? onBlur : undefined,
      shouldCloseOnSelect: inlineEdit ? false : undefined
    });
    if (inlineEdit) {
      return /*#__PURE__*/external_react_default().createElement("span", {
        className: "input-group date-input"
      }, picker, /*#__PURE__*/external_react_default().createElement("span", {
        className: "input-group-addon",
        onClick: this.onIconClick
      }, /*#__PURE__*/external_react_default().createElement("i", {
        className: "fa fa-calendar"
      })));
    }
    if (!isFormInput) return picker;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: containerClassName
    }, renderFieldLabel ? /*#__PURE__*/external_react_default().createElement("label", {
      className: labelClassName
    }, renderFieldLabel(queryColumn), queryColumn?.required && /*#__PURE__*/external_react_default().createElement("span", {
      className: "required-symbol"
    }, " *")) : /*#__PURE__*/external_react_default().createElement(FieldLabel, {
      label: label,
      labelOverlayProps: {
        isFormsy: false,
        inputId: queryColumn.name,
        required: queryColumn.required,
        addLabelAsterisk,
        labelClass: allowDisable ? undefined : labelClassName
      },
      showLabel: showLabel,
      showToggle: allowDisable,
      column: queryColumn,
      isDisabled: isDisabled,
      toggleProps: {
        onClick: this.toggleDisabled
      }
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: wrapperClassName
    }, picker));
  }
}

/**
 * This class is a wrapper around DatePickerInput to be able to bind formsy-react. It uses
 * the Formsy.Decorator to bind formsy-react so the element can be validated, submitted, etc.
 */
DatePickerInput_defineProperty(DatePickerInputImpl, "defaultProps", {
  addLabelAsterisk: false,
  allowDisable: false,
  containerClassName: INPUT_CONTAINER_CLASS_NAME,
  initiallyDisabled: false,
  initValueFormatted: false,
  inputClassName: 'form-control',
  inputWrapperClassName: 'block',
  isClearable: true,
  isFormInput: true,
  labelClassName: INPUT_LABEL_CLASS_NAME,
  showLabel: true,
  wrapperClassName: INPUT_WRAPPER_CLASS_NAME
});
const DatePickerInputFormsy = (0,external_formsy_react_.withFormsy)(DatePickerInputImpl);
const DatePickerInput = props => {
  if (props.formsy) {
    return /*#__PURE__*/external_react_default().createElement(DatePickerInputFormsy, DatePickerInput_extends({
      name: props.name ?? props.queryColumn.name
    }, props));
  }
  return /*#__PURE__*/external_react_default().createElement(DatePickerInputImpl, props);
};
DatePickerInput.defaultProps = {
  formsy: true
};
DatePickerInput.displayName = 'DatePickerInput';
;// CONCATENATED MODULE: ./src/internal/components/forms/input/TextChoiceInput.tsx
const TextChoiceInput_excluded = ["queryColumn"];
function TextChoiceInput_extends() { return TextChoiceInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, TextChoiceInput_extends.apply(null, arguments); }
function TextChoiceInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = TextChoiceInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function TextChoiceInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }



class TextChoiceInput extends DisableableInput {
  render() {
    const _this$props = this.props,
      {
        queryColumn
      } = _this$props,
      selectInputProps = TextChoiceInput_objectWithoutProperties(_this$props, TextChoiceInput_excluded);
    const options = queryColumn.validValues?.map(val => ({
      label: val,
      value: val
    })) ?? [];
    return /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, TextChoiceInput_extends({
      label: queryColumn.caption,
      name: queryColumn.fieldKey,
      required: queryColumn.required
    }, selectInputProps, {
      options: options
    }));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/forms/QueryFormInputs.tsx
function QueryFormInputs_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function QueryFormInputs_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? QueryFormInputs_ownKeys(Object(t), !0).forEach(function (r) { QueryFormInputs_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : QueryFormInputs_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function QueryFormInputs_defineProperty(e, r, t) { return (r = QueryFormInputs_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function QueryFormInputs_toPropertyKey(t) { var i = QueryFormInputs_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function QueryFormInputs_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
















// TODO: Merge this functionality with resolveDetailEditRenderer()
class QueryFormInputs extends (external_react_default()).Component {
  constructor(_props) {
    super(_props);
    QueryFormInputs_defineProperty(this, "_fieldEnabledCount", 0);
    QueryFormInputs_defineProperty(this, "onSelectChange", (name, value, selectedOptions, props) => {
      const {
        includeLabelField
      } = this.props;
      if (includeLabelField) {
        const allItems = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
        this.setState(prevState => ({
          labels: QueryFormInputs_objectSpread(QueryFormInputs_objectSpread({}, prevState.labels), {
            [getQueryFormLabelFieldName(name)]: allItems.map(item => item ? item.label : '(label not found)').join(', ')
          })
        }));
      }
      this.props.onSelectChange?.(name, value, selectedOptions, props);
    });
    QueryFormInputs_defineProperty(this, "onToggleDisable", disabled => {
      if (disabled) {
        this._fieldEnabledCount--;
      } else {
        this._fieldEnabledCount++;
      }
      this.props.onFieldsEnabledChange?.(this._fieldEnabledCount);
    });
    QueryFormInputs_defineProperty(this, "renderLabelField", col => {
      const {
        includeLabelField
      } = this.props;
      if (includeLabelField) {
        const fieldName = getQueryFormLabelFieldName(col.name);
        return /*#__PURE__*/external_react_default().createElement(FormsyInput, {
          name: fieldName,
          type: "hidden",
          value: this.state.labels[fieldName]
        });
      }
      return null;
    });
    const {
      queryInfo,
      queryColumns
    } = this.props;
    if (!queryInfo && !queryColumns) {
      throw new Error('QueryFormInputs: If queryInfo is not provided, queryColumns is required.');
    }
    this.state = {
      labels: {}
    };
  }
  static cleanValues(fieldValues, customValues) {
    const cleanValues = QueryFormInputs_objectSpread(QueryFormInputs_objectSpread({}, fieldValues), customValues);
    return Object.keys(cleanValues).filter(fieldKey => !isQueryFormLabelField(fieldKey)).reduce((newFieldValues, fieldKey) => {
      newFieldValues[fieldKey] = cleanValues[fieldKey];
      return newFieldValues;
    }, {});
  }
  render() {
    const {
      columnFilter,
      containerFilter,
      containerPath,
      preventCrossFolderEnable,
      pluralNoun = 'rows',
      fieldValues,
      fireQSChangeOnInit,
      checkRequiredFields,
      showLabelAsterisk,
      initiallyDisableFields,
      lookups,
      operation,
      queryColumns,
      queryInfo,
      renderFileInputs,
      allowFieldDisable,
      disabledFields,
      renderFieldLabel,
      onAdditionalFormDataChange,
      queryFilters
    } = this.props;
    const filter = columnFilter ?? insertColumnFilter;
    const columns = queryInfo ? queryInfo.columns : queryColumns;

    // CONSIDER: separately establishing the set of columns and allow
    // QueryFormInputs to be a rendering factory for the columns that are in the set.
    if (columns) {
      return columns.valueArray.filter(col => filter(col)).map((col, i) => {
        const shouldDisableField = initiallyDisableFields || disabledFields.contains(col.name.toLowerCase());
        if (!shouldDisableField) {
          this._fieldEnabledCount++;
        }
        let showAsteriskSymbol = false;
        if (!checkRequiredFields && col.required) {
          col = col.mutate({
            required: false
          });
          showAsteriskSymbol = showLabelAsterisk;
        }
        let value = caseInsensitive(fieldValues, col.name);
        if (!value && lookups) {
          value = lookups.get(col.name) || lookups.get(col.name.toLowerCase());
        }
        if (!value && col.jsonType === 'string') {
          value = '';
        }
        if (!value && col.jsonType === 'boolean') {
          value = false;
        }
        const ColumnInputRenderer = resolveInputRenderer(col);
        if (ColumnInputRenderer) {
          return /*#__PURE__*/external_react_default().createElement(ColumnInputRenderer, {
            allowFieldDisable: allowFieldDisable,
            col: col,
            data: fieldValues,
            formsy: true,
            initiallyDisabled: shouldDisableField,
            key: i,
            onAdditionalFormDataChange: onAdditionalFormDataChange,
            onSelectChange: this.onSelectChange,
            onToggleDisable: this.onToggleDisable,
            renderLabelField: this.renderLabelField,
            showAsteriskSymbol: showAsteriskSymbol,
            showLabel: true,
            value: value
          });
        }
        if (col.isPublicLookup()) {
          // undefined 'displayAsLookup' just respects the lookup.
          // Must be explicitly false to prevent drop-down.
          if (col.displayAsLookup !== false) {
            const multiple = col.isJunctionLookup();
            const joinValues = multiple;
            const queryFilter = col.lookup.hasQueryFilters(operation) ? (0,external_immutable_.List)(col.lookup.getQueryFilters(operation)) : queryFilters?.[col.fieldKey];

            // preventCrossFolderEnable will be true for bulk update of a selection from multiple containers,
            // however, lookup can be used if there is a defined col.lookup.containerPath or if isAllProductFoldersFilteringEnabled()
            const toggleDisabledTooltip = preventCrossFolderEnable && !col.lookup.containerPath && !isAllProductFoldersFilteringEnabled() ? `Lookup fields for the selected ${pluralNoun.toLowerCase()} can't be updated because the ${pluralNoun.toLowerCase()} belong to multiple projects.` : undefined;
            return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, {
              key: i
            }, this.renderLabelField(col), /*#__PURE__*/external_react_default().createElement(QuerySelect, {
              addLabelAsterisk: showAsteriskSymbol,
              allowDisable: allowFieldDisable,
              containerFilter: col.lookup.containerFilter ?? containerFilter ?? getContainerFilterForLookups(),
              containerPath: col.lookup.containerPath ?? containerPath,
              toggleDisabledTooltip: toggleDisabledTooltip,
              description: col.description,
              displayColumn: col.lookup.displayColumn,
              fireQSChangeOnInit: fireQSChangeOnInit,
              formsy: true,
              initiallyDisabled: shouldDisableField,
              joinValues: joinValues,
              label: col.caption,
              loadOnFocus: true,
              maxRows: 10,
              multiple: multiple,
              name: col.fieldKey,
              onQSChange: this.onSelectChange,
              onToggleDisable: this.onToggleDisable,
              placeholder: "Select or type to search...",
              queryFilters: queryFilter,
              renderFieldLabel: renderFieldLabel,
              required: col.required,
              schemaQuery: col.lookup.schemaQuery,
              showLabel: true,
              value: value,
              valueColumn: col.lookup.keyColumn
            }));
          }
        }
        if (col.validValues) {
          return /*#__PURE__*/external_react_default().createElement(TextChoiceInput, {
            addLabelAsterisk: showAsteriskSymbol,
            allowDisable: allowFieldDisable,
            formsy: true,
            initiallyDisabled: shouldDisableField,
            key: i,
            onChange: this.onSelectChange,
            onToggleDisable: this.onToggleDisable,
            placeholder: "Select or type to search...",
            queryColumn: col,
            renderFieldLabel: renderFieldLabel,
            description: col.description,
            value: value
          });
        }
        if (col.inputType === 'textarea') {
          return /*#__PURE__*/external_react_default().createElement(TextAreaInput, {
            key: i,
            queryColumn: col,
            value: value,
            allowDisable: allowFieldDisable,
            initiallyDisabled: shouldDisableField,
            onToggleDisable: this.onToggleDisable,
            addLabelAsterisk: showAsteriskSymbol,
            renderFieldLabel: renderFieldLabel
          });
        } else if (col.inputType === 'file' && renderFileInputs) {
          return /*#__PURE__*/external_react_default().createElement(FileInput, {
            formsy: true,
            key: i,
            queryColumn: col,
            initialValue: value,
            name: col.fieldKey,
            allowDisable: allowFieldDisable,
            initiallyDisabled: shouldDisableField,
            onToggleDisable: this.onToggleDisable,
            addLabelAsterisk: showAsteriskSymbol,
            renderFieldLabel: renderFieldLabel,
            toggleDisabledTooltip: preventCrossFolderEnable ? `File fields for the selected ${pluralNoun.toLowerCase()} can't be updated because the ${pluralNoun.toLowerCase()} belong to multiple projects.` : undefined,
            showLabel: true
          });
        }
        switch (col.jsonType) {
          case 'date':
          case 'time':
            return /*#__PURE__*/external_react_default().createElement(DatePickerInput, {
              key: i,
              queryColumn: col,
              value: value,
              allowDisable: allowFieldDisable,
              initiallyDisabled: shouldDisableField,
              onToggleDisable: this.onToggleDisable,
              addLabelAsterisk: showAsteriskSymbol,
              renderFieldLabel: renderFieldLabel
            });
          case 'boolean':
            return /*#__PURE__*/external_react_default().createElement(CheckboxInput_CheckboxInput, {
              key: i,
              queryColumn: col,
              value: value,
              allowDisable: allowFieldDisable,
              initiallyDisabled: shouldDisableField,
              onToggleDisable: this.onToggleDisable,
              addLabelAsterisk: showAsteriskSymbol,
              renderFieldLabel: renderFieldLabel
            });
          default:
            return /*#__PURE__*/external_react_default().createElement(TextInput_TextInput, {
              key: i,
              queryColumn: col,
              value: value ? String(value) : value,
              allowDisable: allowFieldDisable,
              initiallyDisabled: shouldDisableField,
              onToggleDisable: this.onToggleDisable,
              addLabelAsterisk: showAsteriskSymbol,
              renderFieldLabel: renderFieldLabel
            });
        }
      });
    }
  }
}
QueryFormInputs_defineProperty(QueryFormInputs, "defaultProps", {
  checkRequiredFields: true,
  includeLabelField: false,
  renderFileInputs: false,
  allowFieldDisable: false,
  initiallyDisableFields: false,
  disabledFields: (0,external_immutable_.List)()
});
;// CONCATENATED MODULE: ./src/internal/components/forms/QueryInfoForm.tsx
const QueryInfoForm_excluded = ["api", "asModal", "canSubmitNotDirty", "cancelText", "countText", "creationTypeOptions", "errorCallback", "footer", "header", "includeCountField", "includeCommentField", "isLoading", "isSubmittedText", "isSubmittingText", "maxCount", "onFormChange", "onHide", "onSubmit", "onSubmitForEdit", "onSuccess", "pluralNoun", "showErrorsAtBottom", "singularNoun", "submitForEditText", "submitText", "title"];
function QueryInfoForm_extends() { return QueryInfoForm_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, QueryInfoForm_extends.apply(null, arguments); }
function QueryInfoForm_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = QueryInfoForm_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function QueryInfoForm_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function QueryInfoForm_defineProperty(e, r, t) { return (r = QueryInfoForm_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function QueryInfoForm_toPropertyKey(t) { var i = QueryInfoForm_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function QueryInfoForm_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

















class QueryInfoForm extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    QueryInfoForm_defineProperty(this, "formRef", void 0);
    QueryInfoForm_defineProperty(this, "enableSubmitButton", () => {
      if (this.state.fieldEnabledCount > 0) this.setState({
        canSubmit: true
      });
    });
    QueryInfoForm_defineProperty(this, "disableSubmitButton", () => {
      this.setState({
        canSubmit: false
      });
    });
    QueryInfoForm_defineProperty(this, "handleChange", () => {
      const {
        onFormChange,
        onFormChangeWithData
      } = this.props;
      onFormChange?.();

      // for tabbed bulk edit/editable grid, needs a way to pass form data from bulk to editable grid without submit
      if (onFormChangeWithData) {
        const row = this.formRef?.['current']?.['getModel']?.();
        if (row) {
          const updatedRow = this.getUpdatedFields(row, ['numItems', 'creationType']);
          onFormChangeWithData(updatedRow);
        }
      }
      if (!this.state.isDirty) {
        this.setState({
          isDirty: true
        });
      }
    });
    QueryInfoForm_defineProperty(this, "handleSubmitError", error => {
      console.error(error);
      const errorMsg = error ? error.exception : 'Your session may have expired or the form may no longer be valid.';
      this.setState({
        errorMsg: 'There was an error submitting the data. ' + errorMsg,
        // TODO add some actionable text here
        isSubmitting: false
      });
    });
    QueryInfoForm_defineProperty(this, "getUpdatedFields", (data, additionalFields) => {
      const {
        submitForEdit
      } = this.state;
      const fieldsToUpdate = this.props.queryInfo.columns.filter(column => {
        const enabledKey = getFieldEnabledFieldName(column);
        return data[enabledKey] === undefined || data[enabledKey] === 'true';
      });
      let filteredData = (0,external_immutable_.OrderedMap)();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          if (fieldsToUpdate.has(key.toLowerCase()) || additionalFields.indexOf(key) !== -1) {
            // Date values are Dates not strings. We convert them to strings in the desired format here.
            // They are converted back to Dates when saving to the server.
            const col = this.props.queryInfo?.getColumn(key);
            if (submitForEdit && col?.jsonType === 'date') {
              if (col.isDateOnlyColumn) filteredData = filteredData.set(key, formatDate(data[key], null, col.format));else filteredData = filteredData.set(key, formatDateTime(data[key], null, col.format));
            } else if (col?.jsonType === 'string' && typeof data[key] === 'string') {
              filteredData = filteredData.set(key, data[key]?.trim());
            } else {
              filteredData = filteredData.set(key, data[key]);
            }
          }
        }
      }
      return filteredData;
    });
    QueryInfoForm_defineProperty(this, "handleValidSubmit", row => {
      const {
        errorCallback,
        onSubmit,
        onSubmitForEdit,
        onSuccess
      } = this.props;
      const {
        submitForEdit,
        comment
      } = this.state;
      this.setState({
        errorMsg: undefined,
        isSubmitting: true
      });
      const updatedRow = this.getUpdatedFields(row, ['numItems', 'creationType']);
      const submitFn = submitForEdit ? onSubmitForEdit : onSubmit;
      submitFn(updatedRow, comment).then(data => {
        this.setState({
          errorMsg: undefined,
          isSubmitted: true,
          isSubmitting: false,
          isDirty: false
        });
        if (api_.Utils.isFunction(onSuccess)) {
          return onSuccess(data, submitForEdit, comment);
        }
      }, error => {
        this.handleSubmitError(error);
        if (api_.Utils.isFunction(errorCallback)) {
          return errorCallback(error);
        }
      });
    });
    QueryInfoForm_defineProperty(this, "isValid", count => {
      const {
        maxCount
      } = this.props;
      return !maxCount || count !== undefined && count > 0 && count <= maxCount;
    });
    QueryInfoForm_defineProperty(this, "renderError", () => {
      const {
        errorMessagePrefix
      } = this.props;
      const {
        errorMsg
      } = this.state;
      if (errorMsg) {
        return /*#__PURE__*/external_react_default().createElement(Alert, null, errorMessagePrefix && /*#__PURE__*/external_react_default().createElement("strong", null, errorMessagePrefix), " ", errorMsg);
      }
      return null;
    });
    QueryInfoForm_defineProperty(this, "setSubmittingForEdit", () => {
      this.setSubmitting(true);
    });
    QueryInfoForm_defineProperty(this, "setSubmittingForSave", () => {
      this.setSubmitting(false);
    });
    QueryInfoForm_defineProperty(this, "setSubmitting", submitForEdit => {
      this.setState({
        submitForEdit
      }, () => {
        // HACK: when we're rendering as a modal we render the buttons outside the Formsy form, so we need to
        // manually trigger submit via the ref, and we have to do it after the state has been updated or the Edit in
        // Grid button will not work.
        if (this.props.asModal) {
          this.formRef.current.submit();
        }
      });
    });
    QueryInfoForm_defineProperty(this, "onHide", () => {
      this.props.onHide?.();
    });
    QueryInfoForm_defineProperty(this, "onCountChange", count => {
      this.setState({
        count
      });
    });
    QueryInfoForm_defineProperty(this, "onCommentChange", comment => {
      this.setState({
        comment
      });
    });
    QueryInfoForm_defineProperty(this, "onFieldsEnabledChange", fieldEnabledCount => {
      this.setState({
        fieldEnabledCount
      });
    });
    QueryInfoForm_defineProperty(this, "renderButtons", () => {
      const {
        asModal,
        cancelText,
        canSubmitNotDirty,
        disabled,
        includeCommentField,
        submitForEditText,
        submitText,
        isSubmittedText,
        isSubmittingText,
        onSubmit,
        onSubmitForEdit,
        pluralNoun,
        singularNoun,
        stickyButtons,
        hideButtons
      } = this.props;
      const {
        count,
        comment,
        canSubmit,
        fieldEnabledCount,
        isSubmitting,
        isSubmitted,
        submitForEdit,
        isDirty,
        requiresUserComment
      } = this.state;
      if (hideButtons) return null;
      const hasValidUserComment = comment?.trim()?.length > 0;
      const inProgressText = isSubmitted ? isSubmittedText : isSubmitting ? isSubmittingText : undefined;
      const suffix = count > 1 ? pluralNoun : singularNoun;
      const showCancel = this.props.onHide !== undefined || this.props.asModal;
      return /*#__PURE__*/external_react_default().createElement(FormButtons, {
        sticky: stickyButtons && !asModal
      }, showCancel && /*#__PURE__*/external_react_default().createElement("button", {
        className: "test-loc-cancel-button btn btn-default",
        onClick: this.onHide,
        type: "button"
      }, cancelText), includeCommentField && /*#__PURE__*/external_react_default().createElement(CommentTextArea, {
        actionName: "Update",
        containerClassName: "inline-comment",
        onChange: this.onCommentChange,
        requiresUserComment: requiresUserComment,
        inline: true
      }), onSubmitForEdit && submitForEditText && /*#__PURE__*/external_react_default().createElement("button", {
        className: `test-loc-submit-for-edit-button btn btn-${onSubmit ? 'default' : 'success'}`,
        disabled: disabled || isSubmitting || !canSubmit || count === 0,
        onClick: this.setSubmittingForEdit,
        type: "submit"
      }, submitForEdit && inProgressText ? inProgressText : submitForEditText), submitText && onSubmit && /*#__PURE__*/external_react_default().createElement("button", {
        className: "test-loc-submit-button btn btn-success",
        disabled: disabled || isSubmitting || fieldEnabledCount === 0 || !canSubmit || count === 0 || !(canSubmitNotDirty || isDirty) || includeCommentField && requiresUserComment && !hasValidUserComment,
        onClick: this.setSubmittingForSave,
        type: "submit"
      }, !submitForEdit && inProgressText ? inProgressText : submitText, suffix ? ' ' + suffix : null));
    });
    this.formRef = external_react_default().createRef();
    this.state = {
      fieldEnabledCount: !props.allowFieldDisable || !props.initiallyDisableFields ? 1 : 0,
      // initial value of 1 is really just a boolean at this point
      canSubmit: !props.includeCountField && !props.checkRequiredFields,
      isSubmitted: false,
      isSubmitting: false,
      isDirty: false,
      errorMsg: undefined,
      count: undefined,
      submitForEdit: false,
      comment: undefined,
      requiresUserComment: true
    };
  }
  componentDidMount() {
    const {
      api,
      includeCommentField
    } = this.props;
    if (includeCommentField) {
      (async () => {
        try {
          const {
            container
          } = (0,api_.getServerContext)();
          const response = await api.folder.getAuditSettings(getAppHomeFolderPath(new Container(container)));
          this.setState({
            requiresUserComment: !!response?.requireUserComments
          });
        } catch {
          this.setState({
            requiresUserComment: false
          });
        }
      })();
    }
  }
  render() {
    // Include all props to support extraction of queryFormInputProps
    const _this$props = this.props,
      {
        api,
        asModal,
        canSubmitNotDirty,
        cancelText,
        countText,
        creationTypeOptions,
        errorCallback,
        footer,
        header,
        includeCountField,
        includeCommentField,
        isLoading,
        isSubmittedText,
        isSubmittingText,
        maxCount,
        onFormChange,
        onHide,
        onSubmit,
        onSubmitForEdit,
        onSuccess,
        pluralNoun,
        showErrorsAtBottom,
        singularNoun,
        submitForEditText,
        submitText,
        title
      } = _this$props,
      queryFormInputProps = QueryInfoForm_objectWithoutProperties(_this$props, QueryInfoForm_excluded);
    const {
      queryInfo
    } = queryFormInputProps;
    if (!queryInfo || queryInfo.isLoading) {
      return null;
    }
    let content;
    const showQuantityHeader = includeCountField || creationTypeOptions.length > 0;
    if (isLoading) {
      content = /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
    } else {
      content = /*#__PURE__*/external_react_default().createElement("div", {
        className: "query-info-form"
      }, header, !showErrorsAtBottom && this.renderError(), /*#__PURE__*/external_react_default().createElement((external_formsy_react_default()), {
        className: "form-horizontal",
        onValidSubmit: this.handleValidSubmit,
        onValid: this.enableSubmitButton,
        onChange: this.handleChange,
        onInvalid: this.disableSubmitButton,
        ref: this.formRef
      }, /*#__PURE__*/external_react_default().createElement(QueryInfoQuantity, {
        creationTypeOptions: creationTypeOptions,
        includeCountField: includeCountField,
        maxCount: maxCount,
        countText: countText,
        onCountChange: this.onCountChange
      }), (header || showQuantityHeader) && /*#__PURE__*/external_react_default().createElement("hr", null), /*#__PURE__*/external_react_default().createElement(QueryFormInputs, QueryInfoForm_extends({}, queryFormInputProps, {
        onFieldsEnabledChange: this.onFieldsEnabledChange,
        pluralNoun: pluralNoun
      })), footer, showErrorsAtBottom && this.renderError(), !asModal && this.renderButtons()));
    }
    if (asModal) {
      return /*#__PURE__*/external_react_default().createElement(Modal, {
        bsSize: "lg",
        className: "form-modal",
        footer: this.renderButtons(),
        onCancel: this.onHide,
        title: title
      }, content);
    }
    return content;
  }
}
QueryInfoForm_defineProperty(QueryInfoForm, "defaultProps", {
  api: getDefaultAPIWrapper(),
  canSubmitNotDirty: true,
  includeCountField: true,
  countText: 'Quantity',
  cancelText: 'Cancel',
  stickyButtons: true,
  submitForEditText: 'Edit with Grid',
  submitText: 'Submit',
  isSubmittedText: 'Submitted',
  isSubmittingText: 'Submitting...',
  maxCount: MAX_EDITABLE_GRID_ROWS,
  creationTypeOptions: [],
  pluralNoun: 'rows'
});
;// CONCATENATED MODULE: ./src/internal/components/forms/BulkAddUpdateForm.tsx
const BulkAddUpdateForm_excluded = ["data", "dataKeys", "editorModel", "queryInfo", "selectedRowIndexes", "warning"];
function BulkAddUpdateForm_extends() { return BulkAddUpdateForm_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, BulkAddUpdateForm_extends.apply(null, arguments); }
function BulkAddUpdateForm_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = BulkAddUpdateForm_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function BulkAddUpdateForm_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }




const BulkAddUpdateForm = props => {
  const {
      data,
      dataKeys,
      editorModel,
      queryInfo,
      selectedRowIndexes,
      warning
    } = props,
    queryInfoFormProps = BulkAddUpdateForm_objectWithoutProperties(props, BulkAddUpdateForm_excluded);
  const {
    pluralNoun,
    singularNoun,
    submitForEditText = `Finish Editing ${capitalizeFirstChar(pluralNoun)}`,
    title = 'Update ' + selectedRowIndexes.size + ' ' + (selectedRowIndexes.size === 1 ? singularNoun : pluralNoun)
  } = queryInfoFormProps;
  const fieldValues = (0,external_react_.useMemo)(() => {
    const editorData = editorModel.getRawDataFromGridData(data, dataKeys, queryInfo, false).filter((val, index) => selectedRowIndexes.contains(index)).toMap();
    return getCommonDataValues(editorData);
  }, [data, dataKeys, editorModel, queryInfo, selectedRowIndexes]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning"
  }, warning), /*#__PURE__*/external_react_default().createElement(QueryInfoForm, BulkAddUpdateForm_extends({}, queryInfoFormProps, {
    fieldValues: fieldValues,
    queryInfo: queryInfo.getInsertQueryInfo(),
    submitForEditText: submitForEditText,
    title: title,
    hideButtons: !queryInfoFormProps.asModal
  })));
};
BulkAddUpdateForm.defaultProps = {
  allowFieldDisable: true,
  asModal: true,
  checkRequiredFields: false,
  includeCountField: false,
  initiallyDisableFields: true,
  pluralNoun: 'rows',
  showLabelAsterisk: true,
  singularNoun: 'row'
};
BulkAddUpdateForm.displayName = 'BulkAddUpdateForm';
;// CONCATENATED MODULE: ./src/internal/Tabs.tsx




function tabId(id, eventKey) {
  return `${id}-tab-${eventKey}`;
}
function paneId(id, eventKey) {
  return `${id}-pane-${eventKey}`;
}
const Tabs_Context = (0,external_react_.createContext)(undefined);
const Tab = ({
  children,
  className,
  eventKey
}) => {
  const {
    id,
    activeKey
  } = (0,external_react_.useContext)(Tabs_Context);
  const active = activeKey === eventKey;
  const className_ = external_classnames_default()('tab-pane', className, {
    active
  });
  return /*#__PURE__*/external_react_default().createElement("div", {
    "aria-labelledby": tabId(id, eventKey),
    "aria-hidden": !active,
    className: className_,
    id: paneId(id, eventKey),
    role: "tabpanel"
  }, children);
};
const Tabs = props => {
  const {
    children,
    onSelect
  } = props;
  const id = (0,external_react_.useMemo)(() => generateId('tabs'), []);
  const className = external_classnames_default()('lk-tabs', props.className);
  const [activeKey, setActiveKey] = (0,external_react_.useState)(() => {
    if (props.activeKey !== undefined) return props.activeKey;
    // Child is null if we do something like {canSeeSpecialTab && (<Tab eventKey="specialTab">...</Tab>}
    const firstNotNull = external_react_.Children.toArray(children).find(child => {
      return child !== null;
    });
    return firstNotNull.props.eventKey;
  });
  const tabContext = (0,external_react_.useMemo)(() => ({
    id,
    activeKey
  }), [id, activeKey]);
  const onTabClick = (0,external_react_.useCallback)(event => {
    cancelEvent(event);
    const targetEventKey = event.currentTarget.dataset.eventKey;
    if (onSelect !== undefined) onSelect(targetEventKey);else setActiveKey(targetEventKey);
  }, [onSelect]);

  // Need this useEffect to allow for controlled usages of the selected tab state
  (0,external_react_.useEffect)(() => {
    if (props.activeKey !== undefined) setActiveKey(props.activeKey);
  }, [props.activeKey]);
  const tabs = (0,external_react_.useMemo)(() => {
    return external_react_.Children.map(children, child => {
      // Child is null if we do something like {canSeeSpecialTab && (<Tab eventKey="specialTab">...</Tab>}
      if (child === null) return null;
      const eventKey = child?.props?.eventKey;
      const title = child?.props?.title;
      const disabled = child?.props?.disabled;
      const active = eventKey === activeKey;
      const tabClassName = external_classnames_default()({
        active,
        disabled
      });
      return /*#__PURE__*/external_react_default().createElement("li", {
        className: tabClassName,
        key: eventKey,
        role: "presentation"
      }, /*#__PURE__*/external_react_default().createElement("a", {
        "aria-controls": paneId(id, eventKey),
        "aria-selected": active,
        "data-event-key": eventKey,
        href: "#",
        id: tabId(id, eventKey),
        onClick: disabled ? cancelEvent : onTabClick,
        role: "tab"
      }, title));
    });
  }, [children, activeKey, id, onTabClick]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className
  }, /*#__PURE__*/external_react_default().createElement("ul", {
    className: "nav nav-tabs",
    role: "tablist"
  }, tabs), /*#__PURE__*/external_react_default().createElement("div", {
    className: "tab-content"
  }, /*#__PURE__*/external_react_default().createElement(Tabs_Context.Provider, {
    value: tabContext
  }, children)));
};
;// CONCATENATED MODULE: ./src/internal/components/editable/LookupCell.tsx
function LookupCell_extends() { return LookupCell_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, LookupCell_extends.apply(null, arguments); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











const QueryLookupCell = (0,external_react_.memo)(props => {
  const {
    col,
    containerFilter,
    disabled,
    defaultInputValue,
    filteredLookupKeys,
    filteredLookupValues,
    forUpdate,
    lookupValueFilters,
    onKeyDown,
    onSelectChange,
    rawValues,
    values,
    containerPath
  } = props;
  const {
    columnRenderer,
    lookup
  } = col;
  const isMultiple = col.isJunctionLookup();
  const queryFilters = (0,external_react_.useMemo)(() => {
    return (0,external_immutable_.List)(getLookupFilters(col, filteredLookupKeys?.toArray(), filteredLookupValues?.toArray(), lookupValueFilters, forUpdate));
  }, [col, filteredLookupKeys, filteredLookupValues, forUpdate, lookupValueFilters]);
  const schemaQuery = (0,external_react_.useMemo)(() => new SchemaQuery(lookup.schemaQuery.schemaName, lookup.schemaQuery.queryName, ViewInfo.DETAIL_NAME), [lookup]);
  let selectValue = isMultiple ? rawValues : rawValues[0];

  // Issue 49502: Some column types have special handling of raw data, i.e. StoredAmount and Units
  if (columnRenderer) {
    const renderer = getQueryColumnRenderers()[columnRenderer.toLowerCase()];
    if (renderer?.getEditableRawValue) {
      selectValue = renderer.getEditableRawValue(values);
    }
  }
  return /*#__PURE__*/external_react_default().createElement(QuerySelect, LookupCell_extends({}, gridCellQuerySelectProps, {
    containerFilter: lookup.containerFilter ?? containerFilter ?? getContainerFilterForLookups(),
    containerPath: lookup.containerPath ?? containerPath,
    defaultInputValue: defaultInputValue,
    disabled: disabled,
    maxRows: LOOKUP_DEFAULT_SIZE,
    multiple: isMultiple,
    onKeyDown: onKeyDown,
    onQSChange: onSelectChange,
    preLoad: true,
    queryFilters: queryFilters,
    schemaQuery: schemaQuery,
    value: selectValue
  }));
});
QueryLookupCell.displayName = 'QueryLookupCell';
const LookupCell = (0,external_react_.memo)(props => {
  const {
    col,
    colIdx,
    disabled,
    modifyCell,
    onKeyDown,
    row,
    rowIdx,
    select,
    values,
    containerPath
  } = props;
  const onSelectChange = (0,external_react_.useCallback)((fieldName, formValue, options, props_) => {
    onCellSelectChange({
      modifyCell,
      selectCell: select
    }, colIdx, rowIdx, options, props_.multiple);
  }, [colIdx, modifyCell, rowIdx, select]);
  const rawValues = (0,external_react_.useMemo)(() => values.filter(vd => vd.raw !== undefined).map(vd => vd.raw).toArray(), [values]);
  if (col.validValues) {
    return /*#__PURE__*/external_react_default().createElement(TextChoiceInput, LookupCell_extends({}, gridCellSelectInputProps, {
      autoFocus: true,
      disabled: disabled,
      onChange: onSelectChange,
      onKeyDown: onKeyDown,
      queryColumn: col,
      value: rawValues[0]
    }));
  }

  // if the column is a lookup, we need to pass the containerPath to the QuerySelect
  const containerPath_ = containerPath ?? getValueFromRow(row?.toJS(), 'Folder')?.toString() ?? getValueFromRow(row?.toJS(), 'Container')?.toString();
  return /*#__PURE__*/external_react_default().createElement(QueryLookupCell, LookupCell_extends({}, props, {
    onSelectChange: onSelectChange,
    rawValues: rawValues,
    containerPath: containerPath_
  }));
});
LookupCell.displayName = 'LookupCell';
;// CONCATENATED MODULE: ./src/internal/components/editable/DateInputCell.tsx





const DateInputCell = (0,external_react_.memo)(props => {
  const {
    col,
    defaultValue,
    colIdx,
    rowIdx,
    disabled,
    modifyCell,
    onKeyDown,
    select
  } = props;
  const onCalendarClose = (0,external_react_.useCallback)(() => {
    select(colIdx, rowIdx);
  }, [colIdx, rowIdx, select]);
  const onDateInputChange = (0,external_react_.useCallback)((newDate, formatted) => {
    let display = formatted;
    if (!display) {
      if (newDate && typeof newDate === 'string') display = newDate;else if (newDate && newDate instanceof Date) {
        display = isDateTimeCol(col) ? formatDateTime(newDate) : formatDate(newDate);
      }
    }
    modifyCell(colIdx, rowIdx, [{
      raw: newDate,
      display
    }], MODIFICATION_TYPES.REPLACE, col);
  }, [col, colIdx, modifyCell, rowIdx]);
  return /*#__PURE__*/external_react_default().createElement(DatePickerInput, {
    allowDisable: false,
    autoFocus: true,
    disabled: disabled,
    formsy: false,
    inputClassName: `date-input-cell ${EDIT_GRID_INPUT_CELL_CLASS}`,
    inputWrapperClassName: "",
    isClearable: false,
    isFormInput: false,
    key: genCellKey(colIdx, rowIdx),
    onCalendarClose: onCalendarClose,
    onChange: onDateInputChange,
    onKeyDown: onKeyDown,
    queryColumn: col,
    value: defaultValue,
    wrapperClassName: "date-input-cell-container"
  });
});
DateInputCell.displayName = 'DateInputCell';
;// CONCATENATED MODULE: ./src/internal/components/editable/Cell.tsx
function Cell_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Cell_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Cell_ownKeys(Object(t), !0).forEach(function (r) { Cell_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Cell_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Cell_defineProperty(e, r, t) { return (r = Cell_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Cell_toPropertyKey(t) { var i = Cell_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Cell_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */















// CSS Order: top, right, bottom, left

const DisplayCell = (0,external_react_.memo)(props => {
  const {
    alignRight,
    borderMaskBottom,
    borderMaskLeft,
    borderMaskRight,
    borderMaskTop,
    displayValue,
    isReadOnly,
    locked,
    message,
    onBlur,
    onDoubleClick,
    onKeyDown,
    onMouseDown,
    onMouseEnter: propsMouseEnter,
    placeholder,
    selected,
    selection,
    showMenu,
    targetRef
  } = props;
  const {
    onMouseEnter: overlayMouseEnter,
    onMouseLeave,
    portalEl,
    show
  } = useOverlayTriggerState('well-cell-overlay', !!message, false, 250);
  const onMouseEnter = (0,external_react_.useCallback)(event => {
    overlayMouseEnter();
    propsMouseEnter(event);
  }, [overlayMouseEnter, propsMouseEnter]);
  const className = external_classnames_default()('cellular-display', {
    'cell-align-right': alignRight,
    'cell-border-top': borderMaskTop,
    'cell-border-right': borderMaskRight,
    'cell-border-bottom': borderMaskBottom,
    'cell-border-left': borderMaskLeft,
    'cell-locked': locked,
    'cell-menu': showMenu,
    'cell-placeholder': displayValue.length === 0 && placeholder !== undefined,
    'cell-read-only': isReadOnly,
    'cell-selected': selected,
    'cell-selection': selection,
    'cell-warning': message !== undefined
  });
  const value = displayValue.length === 0 && placeholder ? placeholder : displayValue;
  let body;
  if (showMenu && !isReadOnly) {
    body = /*#__PURE__*/external_react_default().createElement("div", {
      className: "cell-content"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "cell-menu-value"
    }, value), /*#__PURE__*/external_react_default().createElement("span", {
      className: "cell-menu-selector",
      onClick: onDoubleClick
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-chevron-down"
    })));
  } else {
    body = /*#__PURE__*/external_react_default().createElement("div", {
      className: "cell-content"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "cell-content-value"
    }, value));
  }
  let popover;
  if (message) {
    popover = /*#__PURE__*/external_react_default().createElement(Popover, {
      id: "grid-cell-popover",
      placement: "top",
      targetRef: targetRef
    }, message.message);
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    autoFocus: selected,
    className: className,
    onBlur: onBlur,
    onDoubleClick: onDoubleClick,
    onKeyDown: onKeyDown,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: targetRef,
    tabIndex: -1
  }, body, show && (0,external_react_dom_.createPortal)(popover, portalEl));
});
DisplayCell.displayName = 'DisplayCell';
class Cell extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    Cell_defineProperty(this, "changeTO", void 0);
    Cell_defineProperty(this, "displayEl", void 0);
    // This is used to record the dimensions of the cell before focusing so that the
    // subsequently rendered focused textarea can fit to the same dimensions
    Cell_defineProperty(this, "preFocusDOMRect", void 0);
    Cell_defineProperty(this, "recordedKeys", void 0);
    Cell_defineProperty(this, "recordingTO", void 0);
    Cell_defineProperty(this, "focusCell", (colIdx, rowIdx, clearValue) => {
      this.preFocusDOMRect.current = this.displayEl?.current?.getBoundingClientRect();
      this.props.cellActions.focusCell(colIdx, rowIdx, clearValue);
    });
    Cell_defineProperty(this, "loadFilteredLookupKeys", async () => {
      const {
        getFilteredLookupKeys,
        linkedValues,
        readOnly
      } = this.props;
      if (!getFilteredLookupKeys || readOnly) return;
      const linkedFilteredLookupKeys = await getFilteredLookupKeys(linkedValues);
      this.setState({
        filteredLookupKeys: linkedFilteredLookupKeys
      });
    });
    Cell_defineProperty(this, "handleSelectionBlur", () => {
      const {
        cellActions,
        selected
      } = this.props;
      if (selected) {
        cellActions.clearSelection();
      }
    });
    Cell_defineProperty(this, "replaceCurrentCellValue", (display, raw) => {
      const {
        colIdx,
        rowIdx,
        cellActions,
        col
      } = this.props;
      cellActions.modifyCell(colIdx, rowIdx, [{
        display,
        raw
      }], MODIFICATION_TYPES.REPLACE, col);
    });
    Cell_defineProperty(this, "handleBlur", evt => {
      clearTimeout(this.changeTO);
      this.handleSelectionBlur();
      this.replaceCurrentCellValue(evt.target.value, evt.target.value);
    });
    Cell_defineProperty(this, "handleChange", event => {
      event.persist();
      clearTimeout(this.changeTO);
      this.changeTO = window.setTimeout(() => {
        this.replaceCurrentCellValue(event.target.value, event.target.value);
      }, 250);
    });
    Cell_defineProperty(this, "handleDblClick", () => {
      if (this.isReadOnly) return;
      const {
        colIdx,
        rowIdx
      } = this.props;
      this.focusCell(colIdx, rowIdx);
    });
    Cell_defineProperty(this, "handleKeys", event => {
      const {
        cellActions,
        colIdx,
        focused,
        rowIdx,
        selected
      } = this.props;
      const {
        modifyCell,
        selectCell,
        fillDown
      } = cellActions;
      const isRecording = this.recordingTO !== undefined;
      switch (event.keyCode) {
        case KEYS.Alt:
        case KEYS.SelectKey:
        case KEYS.Shift:
        case KEYS.Ctrl:
        case KEYS.LeftArrow:
        case KEYS.UpArrow:
        case KEYS.RightArrow:
        case KEYS.DownArrow:
        case KEYS.PageUp:
        case KEYS.PageDown:
        case KEYS.Home:
        case KEYS.End:
        case KEYS.LeftMetaKey:
        case KEYS.FFLeftMetaKey:
        case KEYS.CapsLock:
          break;
        case KEYS.Backspace:
        case KEYS.Delete:
          // "Backspace" and "Delete" are ignored on recorded input
          if (!focused && selected && !isRecording && !this.isReadOnly) {
            cancelEvent(event);
            modifyCell(colIdx, rowIdx, undefined, MODIFICATION_TYPES.REMOVE_ALL);
          }
          break;
        case KEYS.Tab:
          // "Tab" is ignored on recorded input
          if (selected && !isRecording) {
            cancelEvent(event);
            selectCell(event.shiftKey ? colIdx - 1 : colIdx + 1, rowIdx);
          }
          break;
        case KEYS.Enter:
          if (focused || this.isReadOnly) {
            // Multi-line cells support "Shift" + "Enter" to start a new line.
            if (!event.shiftKey || !this.isMultiline) {
              cancelEvent(event);
              selectCell(colIdx, rowIdx + 1);
            }
          } else if (selected) {
            // Record "Enter" key iff recording is in progress. Does not initiate recording.
            if (isRecording) {
              // Do not cancel event here, otherwise, key capture will be lost
              this.recordKeys(event);
            } else {
              cancelEvent(event);
              this.focusCell(colIdx, rowIdx);
            }
          }
          break;
        case KEYS.Escape:
          // "Escape" is ignored on recorded input
          if (focused && !isRecording) {
            cancelEvent(event);
            selectCell(colIdx, rowIdx, undefined, true);
          }
          break;
        case KEYS.D:
          if (!focused && isFillDown(event) && !this.isReadOnly) {
            cancelEvent(event);
            fillDown();
            break;
          }
        // eslint-disable-next-line no-fallthrough
        case KEYS.A:
          if (!focused && isSelectAll(event) && !this.isReadOnly) {
            cancelEvent(event);
            selectCell(colIdx, rowIdx, SELECTION_TYPES.ALL);
            break;
          }
        // eslint-disable-next-line no-fallthrough -- intentionally fallthrough for "D" and "A" characters
        default:
          // any other key
          if (!focused && !isCtrlOrMetaKey(event) && !this.isReadOnly) {
            // Do not cancel event here, otherwise, key capture will be lost
            if (this.isLookup && !this.isDateTimeField) {
              this.recordKeys(event);
            } else {
              this.focusCell(colIdx, rowIdx, true);
            }
          }
          break;
      }
    });
    // Issue 49779: Support barcode scanners "streaming" input keys
    Cell_defineProperty(this, "recordKeys", event => {
      clearTimeout(this.recordingTO);

      // record the key
      const {
        key
      } = event;
      if (key) {
        if (key === Key.ENTER) {
          this.recordedKeys += '\n';
        } else if (this.recordedKeys) {
          this.recordedKeys += key;
        } else {
          this.recordedKeys = key;
        }
      }

      // wait for more keystrokes and then fill or focus
      this.recordingTO = window.setTimeout(() => {
        this.recordingTO = undefined;
        const {
          cellActions,
          colIdx,
          rowIdx
        } = this.props;
        const {
          fillText,
          selectCell
        } = cellActions;
        if (this.recordedKeys.indexOf('\n') > -1) {
          fillText(colIdx, rowIdx, this.recordedKeys);
          selectCell(colIdx, rowIdx + 1);
        } else {
          this.focusCell(colIdx, rowIdx, !this.isReadOnly);
        }
        this.recordedKeys = undefined;
        // Wait for a very brief amount of time as automated input is
        // expected to quickly input subsequent characters
      }, 25);
    });
    /** This handles a subset of cell navigation key bindings from within a focused dropdown cell. */
    Cell_defineProperty(this, "handleFocusedDropdownKeys", event => {
      const {
        cellActions,
        colIdx,
        rowIdx
      } = this.props;
      const {
        selectCell
      } = cellActions;
      switch (event.key) {
        case Key.ESCAPE:
          cancelEvent(event);
          selectCell(colIdx, rowIdx, undefined, true);
          break;
        case Key.TAB:
          cancelEvent(event);
          selectCell(event.shiftKey ? colIdx - 1 : colIdx + 1, rowIdx);
          break;
        default:
          break;
      }
    });
    Cell_defineProperty(this, "handleMouseEnter", event => {
      const {
        cellActions,
        colIdx,
        rowIdx
      } = this.props;
      if (cellActions.inDrag()) {
        cancelEvent(event);
        cellActions.selectCell(colIdx, rowIdx, SELECTION_TYPES.AREA);
      }
    });
    Cell_defineProperty(this, "handleSelect", event => {
      // Only handle event if the left mouse button is clicked
      if (event.buttons !== 1) return;
      const {
        cellActions,
        colIdx,
        rowIdx,
        selected
      } = this.props;
      const {
        selectCell
      } = cellActions;
      if (event.ctrlKey || event.metaKey) {
        selectCell(colIdx, rowIdx, SELECTION_TYPES.SINGLE);
      } else if (event.shiftKey) {
        cancelEvent(event);
        selectCell(colIdx, rowIdx, SELECTION_TYPES.AREA);
      } else if (!selected) {
        const isDragHandle = event.target?.className?.indexOf(CELL_SELECTION_HANDLE_CLASSNAME) > -1;
        if (isDragHandle) {
          selectCell(colIdx, rowIdx, SELECTION_TYPES.AREA); // use AREA to keep initial selection in the range
        } else {
          selectCell(colIdx, rowIdx);
        }
      }
    });
    Cell_defineProperty(this, "onSelectChange", (name, value, selectedOptions, props_) => {
      const {
        cellActions,
        colIdx,
        rowIdx
      } = this.props;
      onCellSelectChange(cellActions, colIdx, rowIdx, selectedOptions, props_.multiple);
    });
    Cell_defineProperty(this, "onFocusCapture", event => {
      // Move the cursor the end of the input value upon focus
      if (event.target.value) {
        event.target.selectionStart = event.target.selectionEnd = event.target.value.length;
      }
    });
    this.state = {
      filteredLookupKeys: this.props.filteredLookupKeys
    };
    this.displayEl = external_react_default().createRef();
    this.preFocusDOMRect = external_react_default().createRef();
  }
  get isDateTimeField() {
    const {
      col
    } = this.props;
    return col.jsonType === 'date' || col.jsonType === 'time';
  }
  get isLookup() {
    const {
      col
    } = this.props;
    return col.isPublicLookup() || this.isDateTimeField || !!col.validValues;
  }
  get isMultiline() {
    return this.props.col.inputType === 'textarea';
  }
  get isReadOnly() {
    return this.props.readOnly || this.props.col.readOnly || this.props.locked;
  }
  componentDidUpdate(prevProps) {
    if (!this.props.focused && this.props.selected) {
      this.displayEl?.current?.focus();
      if (prevProps.focused) {
        this.preFocusDOMRect.current = null;
      }
      if (!prevProps.selected) {
        this.loadFilteredLookupKeys();
      }
    }
  }
  render() {
    const {
      borderMaskBottom,
      borderMaskLeft,
      borderMaskRight,
      borderMaskTop,
      cellActions,
      col,
      colIdx,
      containerFilter,
      filteredLookupValues,
      focused,
      forUpdate,
      locked,
      lookupValueFilters,
      message,
      placeholder,
      renderDragHandle,
      row,
      rowIdx,
      selected,
      selection,
      values,
      containerPath
    } = this.props;
    const {
      filteredLookupKeys
    } = this.state;
    const alignRight = col.align === 'right';
    const isDateTimeField = this.isDateTimeField;
    const showLookup = this.isLookup;
    const showMenu = showLookup || col.inputRenderer && col.inputRenderer !== 'AppendUnitsInput';
    if (!focused) {
      const displayValue = values.filter(vd => vd && vd.display !== undefined).reduce((v, vd, i) => v + (i > 0 ? ', ' : '') + vd.display, '');
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(DisplayCell, {
        alignRight: alignRight,
        borderMaskBottom: borderMaskBottom,
        borderMaskLeft: borderMaskLeft,
        borderMaskRight: borderMaskRight,
        borderMaskTop: borderMaskTop,
        displayValue: displayValue,
        isReadOnly: this.isReadOnly,
        locked: locked,
        message: message,
        onBlur: this.handleSelectionBlur,
        onDoubleClick: this.handleDblClick,
        onKeyDown: this.handleKeys,
        onMouseDown: this.handleSelect,
        onMouseEnter: this.handleMouseEnter,
        placeholder: placeholder,
        selected: selected,
        selection: selection,
        showMenu: showMenu,
        targetRef: this.displayEl
      }), renderDragHandle && !this.isReadOnly && /*#__PURE__*/external_react_default().createElement("i", {
        className: 'fa fa-square ' + CELL_SELECTION_HANDLE_CLASSNAME
      }));
    }
    const ColumnInputRenderer = resolveInputRenderer(col, true);
    if (ColumnInputRenderer) {
      return /*#__PURE__*/external_react_default().createElement(ColumnInputRenderer, {
        col: col,
        data: row,
        formsy: false,
        onSelectChange: this.onSelectChange,
        selectInputProps: Cell_objectSpread(Cell_objectSpread({}, gridCellSelectInputProps), {}, {
          onKeyDown: this.handleFocusedDropdownKeys
        }),
        showLabel: false,
        value: values?.get(0)?.raw,
        values: values
      });
    }
    if (showLookup && !isDateTimeField) {
      return /*#__PURE__*/external_react_default().createElement(LookupCell, {
        col: col,
        colIdx: colIdx,
        containerFilter: containerFilter,
        containerPath: containerPath,
        defaultInputValue: this.recordedKeys,
        disabled: this.isReadOnly,
        lookupValueFilters: lookupValueFilters,
        filteredLookupKeys: filteredLookupKeys,
        filteredLookupValues: filteredLookupValues,
        forUpdate: forUpdate,
        modifyCell: cellActions.modifyCell,
        onKeyDown: this.handleFocusedDropdownKeys,
        row: row,
        rowIdx: rowIdx,
        select: cellActions.selectCell,
        values: values
      });
    }
    if (isDateTimeField) {
      const rawDateValue = values.size === 0 ? '' : values.first().raw !== undefined ? values.first().raw : '';
      return /*#__PURE__*/external_react_default().createElement(DateInputCell, {
        col: col,
        colIdx: colIdx,
        defaultValue: rawDateValue,
        disabled: this.isReadOnly,
        modifyCell: cellActions.modifyCell,
        onKeyDown: this.handleKeys,
        rowIdx: rowIdx,
        select: cellActions.selectCell
      });
    }
    let style;
    if (this.preFocusDOMRect.current) {
      const {
        height,
        width
      } = this.preFocusDOMRect.current;
      style = {
        height: `${height}px`,
        minHeight: `${height}px`,
        minWidth: `${width}px`,
        width: `${width}px`
      };
    }
    return /*#__PURE__*/external_react_default().createElement("textarea", {
      autoFocus: true,
      className: external_classnames_default()(`${EDIT_GRID_INPUT_CELL_CLASS} cellular-input`, {
        'cellular-input-align-right': alignRight,
        'cellular-input-multiline': this.isMultiline
      }),
      defaultValue: values.size === 0 ? '' : values.first().display !== undefined ? values.first().display : '',
      disabled: this.isReadOnly,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      onFocusCapture: this.onFocusCapture,
      onKeyDown: this.handleKeys,
      placeholder: placeholder,
      style: style,
      tabIndex: -1
    });
  }
}
Cell_defineProperty(Cell, "defaultProps", {
  borderMaskBottom: false,
  borderMaskLeft: false,
  borderMaskRight: false,
  borderMaskTop: false,
  focused: false,
  renderDragHandle: false,
  message: undefined,
  selected: false,
  selection: false,
  values: (0,external_immutable_.List)()
});
;// CONCATENATED MODULE: ./src/internal/components/editable/Controls.tsx
function Controls_defineProperty(e, r, t) { return (r = Controls_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Controls_toPropertyKey(t) { var i = Controls_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Controls_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



class AddRowsControl extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    Controls_defineProperty(this, "addCount", void 0);
    this.state = {
      count: this.props.initialCount
    };
    this.getAddCount = this.getAddCount.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.addCount = external_react_default().createRef();
  }
  getAddCount() {
    if (this.addCount.current) {
      return parseInt(this.addCount.current.value);
    }
  }
  isValid(count) {
    return (!this.props.minCount || count > this.props.minCount - 1) && (!this.props.maxCount || count <= this.getMaxRowsToAdd());
  }
  onAdd() {
    if (this.isValid(this.state.count)) {
      const numToAdd = this.state.count;
      this.setState(() => ({
        count: this.props.minCount
      }), () => this.props.onAdd(numToAdd));
    }
  }
  onBlur() {
    if (!this.isValid(this.state.count)) {
      this.setState({
        count: this.props.initialCount
      });
    }
  }
  onChange(event) {
    let count = parseInt(event.target.value);
    if (isNaN(count)) {
      count = undefined;
    }
    this.setState({
      count
    });
  }
  hasError() {
    const {
      count
    } = this.state;
    return count !== undefined && !this.isValid(count);
  }
  getMaxRowsToAdd() {
    const {
      maxCount,
      maxTotalCount
    } = this.props;
    return maxCount && maxTotalCount && maxCount > maxTotalCount ? maxTotalCount : maxCount;
  }
  render() {
    const {
      addText,
      disable,
      minCount,
      maxCount,
      maxTotalCount,
      nounPlural,
      nounSingular,
      placement,
      wrapperClass,
      invalidCountMsg,
      verbPastTense
    } = this.props;
    const {
      count
    } = this.state;
    const title = addText + ' ' + (count === 1 ? nounSingular : nounPlural);
    const disabledMsg = invalidCountMsg ? invalidCountMsg : 'Maximum number of ' + nounPlural + ' reached.';
    const hasError = !disable && this.hasError();
    const wrapperClasses = external_classnames_default()('editable-grid__controls', 'text-nowrap', wrapperClass, {
      'margin-top': placement === 'bottom',
      'has-error': hasError
    });
    const maxToAdd = this.getMaxRowsToAdd();
    const errorMsg = `At most ${maxTotalCount?.toLocaleString() ?? maxCount?.toLocaleString()} ${nounPlural.toLowerCase()} can be ${verbPastTense.toLowerCase()} at once (${maxToAdd.toLocaleString()} remaining).`;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: wrapperClasses
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "input-group input-group-align"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      max: disable ? undefined : maxToAdd,
      min: disable ? undefined : minCount,
      disabled: disable,
      name: "addCount",
      onBlur: this.onBlur,
      onChange: this.onChange,
      ref: this.addCount,
      style: {
        width: '65px'
      },
      type: "number",
      value: count ? count.toString() : undefined
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: "input-group-btn"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-primary",
      disabled: disable || this.hasError(),
      onClick: this.onAdd,
      title: disable ? disabledMsg : undefined,
      type: "button"
    }, title))), hasError && count > 0 && /*#__PURE__*/external_react_default().createElement("span", {
      className: "text-danger pull-left add-control--error-message"
    }, invalidCountMsg ? invalidCountMsg : errorMsg));
  }
}
Controls_defineProperty(AddRowsControl, "defaultProps", {
  addText: 'Add',
  disable: false,
  initialCount: 1,
  maxCount: MAX_EDITABLE_GRID_ROWS,
  minCount: 1,
  nounPlural: 'rows',
  nounSingular: 'row',
  placement: 'bottom',
  verbPastTense: 'added'
});
;// CONCATENATED MODULE: ./src/internal/components/editable/EditableGrid.tsx
function EditableGrid_extends() { return EditableGrid_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, EditableGrid_extends.apply(null, arguments); }
function EditableGrid_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EditableGrid_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EditableGrid_ownKeys(Object(t), !0).forEach(function (r) { EditableGrid_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EditableGrid_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function EditableGrid_defineProperty(e, r, t) { return (r = EditableGrid_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function EditableGrid_toPropertyKey(t) { var i = EditableGrid_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function EditableGrid_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

























function isCellEmpty(values) {
  return !values || values.isEmpty() || values.some(v => v.raw === undefined || v.raw === null || v.raw === '');
}
function moveDown(colIdx, rowIdx) {
  return {
    colIdx,
    rowIdx: rowIdx + 1
  };
}
function moveLeft(colIdx, rowIdx) {
  return {
    colIdx: colIdx - 1,
    rowIdx
  };
}
function moveRight(colIdx, rowIdx) {
  return {
    colIdx: colIdx + 1,
    rowIdx
  };
}
function moveUp(colIdx, rowIdx) {
  return {
    colIdx,
    rowIdx: rowIdx - 1
  };
}
function hasCellWidthOverride(metadata) {
  return !!metadata?.minWidth || !!metadata?.width;
}
function computeSelectionCellKeys(minColIdx, minRowIdx, maxColIdx, maxRowIdx) {
  const selectionCells = [];
  for (let c = minColIdx; c <= maxColIdx; c++) {
    for (let r = minRowIdx; r <= maxRowIdx; r++) {
      selectionCells.push(genCellKey(c, r));
    }
  }
  return selectionCells;
}
function computeBorderMask(minCol, maxCol, minRow, maxRow, colIdx, rowIdx, currentMask) {
  const borderMask = [...currentMask];
  const betweenColumns = colIdx >= minCol && colIdx <= maxCol;
  const betweenRows = rowIdx >= minRow && rowIdx <= maxRow;
  if (minRow === rowIdx && betweenColumns) borderMask[0] = true;
  if (maxCol === colIdx && betweenRows) borderMask[1] = true;
  if (maxRow === rowIdx && betweenColumns) borderMask[2] = true;
  if (minCol === colIdx && betweenRows) borderMask[3] = true;
  return borderMask;
}
const COUNT_COL = new GridColumn({
  index: GRID_EDIT_INDEX,
  tableCell: true,
  title: 'Row',
  width: 45,
  // style cast to "any" type due to @types/react@16.3.14 switch to csstype package usage which does not declare
  // "textAlign" property correctly for <td> elements.
  cell: (d, r, c, rn) => /*#__PURE__*/external_react_default().createElement("td", {
    className: "cellular-count",
    key: c.index,
    style: {
      textAlign: c.align || 'left'
    }
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "cellular-count-static-content"
  }, rn + 1))
});
// the column index for cell values and cell messages does not include either the selection
// column or the row number column, so we adjust the value passed to <Cell> to accommodate.
function inputCellFactory(queryInfo, editorModel, allowSelection, hideCountCol, columnMetadata, readonlyRows, lockedRows, cellActions, containerFilter, forUpdate, initialSelection, containerPath) {
  // Note: We ignore the incoming value (_) and rowNumber (__) because they come from the underlying QueryModel that
  // backs the Grid component, but we need to reference the data that is in the EditorModel.
  return (_, row, c, __, cn) => {
    let colOffset = 0;
    if (allowSelection) colOffset += 1;
    if (!hideCountCol) colOffset += 1;
    const rn = row.get(GRID_EDIT_INDEX);
    const colIdx = cn - colOffset;
    const isReadonlyCol = columnMetadata ? columnMetadata.readOnly : false;
    const {
      isReadonlyCell,
      isReadonlyRow,
      isLockedRow
    } = checkCellReadStatus(row, queryInfo, columnMetadata, readonlyRows, lockedRows);
    let linkedValues;
    if (columnMetadata?.getFilteredLookupKeys) {
      linkedValues = editorModel.getValue(columnMetadata.linkedColInd, rn).map(vd => vd.raw).toArray();
    }
    const {
      isSparseSelection,
      selectionCells
    } = editorModel;
    const renderDragHandle = !isSparseSelection && editorModel.lastSelection(colIdx, rn);
    let inSelection = editorModel.inSelection(colIdx, rn);
    let borderMask = [false, false, false, false];
    if (!isSparseSelection && selectionCells.length) {
      const minCell = parseCellKey(selectionCells[0]);
      const maxCell = parseCellKey(selectionCells[selectionCells.length - 1]);
      borderMask = computeBorderMask(minCell.colIdx, maxCell.colIdx, minCell.rowIdx, maxCell.rowIdx, colIdx, rn, borderMask);
    }
    if (!isSparseSelection && initialSelection?.length) {
      const minCell = parseCellKey(initialSelection[0]);
      const maxCell = parseCellKey(initialSelection[initialSelection.length - 1]);
      borderMask = computeBorderMask(minCell.colIdx, maxCell.colIdx, minCell.rowIdx, maxCell.rowIdx, colIdx, rn, borderMask);
      inSelection = initialSelection.includes(genCellKey(colIdx, rn));
    }
    const focused = editorModel.isFocused(colIdx, rn);
    const className = external_classnames_default()({
      'grid-col-with-width': hasCellWidthOverride(columnMetadata)
    });
    const style = {
      textAlign: columnMetadata?.align ?? c.align ?? 'left'
    };
    return /*#__PURE__*/external_react_default().createElement("td", {
      className: className,
      key: inputCellKey(c.raw, row),
      style: style
    }, /*#__PURE__*/external_react_default().createElement(Cell, {
      borderMaskTop: borderMask[0],
      borderMaskRight: borderMask[1],
      borderMaskBottom: borderMask[2],
      borderMaskLeft: borderMask[3],
      cellActions: cellActions,
      col: c.raw,
      colIdx: colIdx,
      row: focused ? row : undefined,
      containerFilter: containerFilter,
      placeholder: columnMetadata?.placeholder,
      readOnly: isReadonlyCol || isReadonlyRow || isReadonlyCell,
      locked: isLockedRow,
      rowIdx: rn,
      focused: focused,
      forUpdate: forUpdate,
      message: editorModel.getMessage(colIdx, rn),
      selected: editorModel.isSelected(colIdx, rn),
      selection: inSelection,
      renderDragHandle: renderDragHandle,
      values: editorModel.getValue(colIdx, rn),
      lookupValueFilters: columnMetadata?.lookupValueFilters,
      filteredLookupValues: columnMetadata?.filteredLookupValues,
      filteredLookupKeys: columnMetadata?.filteredLookupKeys,
      getFilteredLookupKeys: columnMetadata?.getFilteredLookupKeys,
      linkedValues: linkedValues,
      containerPath: containerPath
    }));
  };
}
function inputCellKey(col, row) {
  const indexKey = row.get(GRID_EDIT_INDEX);
  if (indexKey === undefined || indexKey === null) {
    throw new Error(`QueryFormInputs.encodeName: Unable to encode name for field "${col.fieldKey}".`);
  }
  return [col.fieldKey, indexKey].join('_$Cell$_');
}
let EditableGridTabs = /*#__PURE__*/function (EditableGridTabs) {
  EditableGridTabs["BulkAdd"] = "BulkAdd";
  EditableGridTabs["BulkUpdate"] = "BulkUpdate";
  EditableGridTabs["Grid"] = "Grid";
  return EditableGridTabs;
}({});
class EditableGrid extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    EditableGrid_defineProperty(this, "dragDelay", void 0);
    EditableGrid_defineProperty(this, "maskDelay", void 0);
    EditableGrid_defineProperty(this, "cellActions", void 0);
    EditableGrid_defineProperty(this, "select", (row, event) => {
      const checked = event.currentTarget.checked;
      // Look through to the nativeEvent to determine if the shift key is engaged.
      const isShiftSelect = event.nativeEvent.shiftKey ?? false;
      this.setState(state => {
        const {
          dataKeys
        } = this.props;
        const {
          selectionPivot
        } = state;
        let {
          selected
        } = state;
        const key = row.get(GRID_EDIT_INDEX);
        if (isShiftSelect && selectionPivot) {
          const pivotIdx = parseInt(selectionPivot.selection, 10);
          const beginIdx = Math.min(key, pivotIdx);
          const endIdx = Math.max(key, pivotIdx);
          for (let i = beginIdx; i <= endIdx; i++) {
            if (selectionPivot.checked) {
              selected = selected.add(i);
            } else {
              selected = selected.remove(i);
            }
          }
        } else if (checked) {
          selected = selected.add(key);
        } else {
          selected = selected.remove(key);
        }
        let selectedState;
        if (selected.size === 0) {
          selectedState = GRID_CHECKBOX_OPTIONS.NONE;
        } else if (dataKeys.size === selected.size) {
          selectedState = GRID_CHECKBOX_OPTIONS.ALL;
        } else {
          selectedState = GRID_CHECKBOX_OPTIONS.SOME;
        }
        const nextState = {
          selected,
          selectedState
        };
        if (!isShiftSelect) {
          nextState.selectionPivot = {
            checked,
            selection: key.toString()
          };
        }
        return nextState;
      }, this.onAfterSelection);
    });
    EditableGrid_defineProperty(this, "onAfterSelection", () => {
      this.props.onSelectionChange?.(this.state.selected);
    });
    EditableGrid_defineProperty(this, "selectAll", evt => {
      const {
        dataKeys
      } = this.props;
      const checked = evt.currentTarget.checked === true;
      this.setState(state => {
        const selected = checked && state.selectedState !== GRID_CHECKBOX_OPTIONS.ALL;
        return {
          selected: selected ? (0,external_immutable_.Set)(dataKeys.map((v, i) => i, (0,external_immutable_.Set)())) : (0,external_immutable_.Set)(),
          selectedState: selected ? GRID_CHECKBOX_OPTIONS.ALL : GRID_CHECKBOX_OPTIONS.NONE,
          selectionPivot: undefined
        };
      }, this.onAfterSelection);
    });
    EditableGrid_defineProperty(this, "getColumns", () => {
      const {
        editorModel,
        forUpdate,
        insertColumns,
        queryInfo,
        readOnlyColumns,
        updateColumns
      } = this.props;
      return editorModel.getColumns(queryInfo, forUpdate, readOnlyColumns, insertColumns, updateColumns);
    });
    EditableGrid_defineProperty(this, "focusCell", (colIdx, rowIdx, clearValue) => {
      const {
        editorModel,
        onChange
      } = this.props;
      const cellKey = genCellKey(colIdx, rowIdx);
      const changes = {
        focusColIdx: colIdx,
        focusRowIdx: rowIdx,
        focusValue: editorModel.getIn(['cellValues', cellKey]),
        selectedColIdx: colIdx,
        selectedRowIdx: rowIdx
      };
      if (clearValue) {
        changes.cellValues = editorModel.cellValues.set(cellKey, (0,external_immutable_.List)());
      }
      onChange(EditableGridEvent.FOCUS_CELL, changes);
    });
    EditableGrid_defineProperty(this, "clearSelection", () => {
      const {
        onChange
      } = this.props;
      onChange(EditableGridEvent.CLEAR_SELECTION, {
        selectedColIdx: -1,
        selectedRowIdx: -1,
        focusColIdx: -1,
        focusRowIdx: -1
      });
    });
    EditableGrid_defineProperty(this, "applySelection", (colIdx, rowIdx, selection) => {
      const {
        initialSelection
      } = this.state;
      const {
        editorModel
      } = this.props;
      const {
        rowCount
      } = editorModel;
      let selectionCells = [];
      const hasSelection = editorModel.hasSelection;
      let selectedColIdx = colIdx;
      let selectedRowIdx = rowIdx;
      switch (selection) {
        case SELECTION_TYPES.ALL:
          {
            for (let c = 0; c < editorModel.columns.size; c++) {
              for (let r = 0; r < rowCount; r++) {
                selectionCells.push(genCellKey(c, r));
              }
            }
            break;
          }
        case SELECTION_TYPES.AREA:
          {
            selectedColIdx = editorModel.selectedColIdx;
            selectedRowIdx = editorModel.selectedRowIdx;
            if (hasSelection) {
              let minColIdx = Math.min(selectedColIdx, colIdx);
              let maxColIdx = Math.max(selectedColIdx, colIdx);
              let minRowIdx = Math.min(selectedRowIdx, rowIdx);
              let maxRowIdx = Math.max(selectedRowIdx, rowIdx);
              if (initialSelection !== undefined) {
                // If we have an initialSelection we want to prevent the user from changing the number of
                // columns, or from shrinking the initially selected state. Functionally this means a user can
                // only expand a selection upwards or downwards, just like in Excel/Sheets.
                const minInitialCell = parseCellKey(initialSelection[0]);
                const maxInitialCell = parseCellKey(initialSelection[initialSelection.length - 1]);
                minColIdx = minInitialCell.colIdx;
                maxColIdx = maxInitialCell.colIdx;
                minRowIdx = Math.min(minRowIdx, minInitialCell.rowIdx);
                maxRowIdx = Math.max(maxRowIdx, maxInitialCell.rowIdx);
              }
              selectionCells = computeSelectionCellKeys(minColIdx, minRowIdx, maxColIdx, maxRowIdx);
            }
            break;
          }
        case SELECTION_TYPES.AREA_CHANGE:
          {
            selectedColIdx = editorModel.selectedColIdx;
            selectedRowIdx = editorModel.selectedRowIdx;
            const colDir = colIdx - selectedColIdx;
            let rowDir = rowIdx - selectedRowIdx;

            // Issue 49953: Support shift-selecting down from the last row
            if (rowIdx === rowCount - 1 && rowDir === 0 && colDir === 0) {
              rowDir = 1;
            }
            let start;
            let end;
            if (editorModel.selectionCells && editorModel.selectionCells.length > 0) {
              start = parseCellKey(editorModel.selectionCells[0]);
              end = parseCellKey(editorModel.selectionCells[editorModel.selectionCells.length - 1]);
            } else {
              start = {
                colIdx: selectedColIdx,
                rowIdx: selectedRowIdx
              };
              end = start;
            }
            let [minColIdx, maxColIdx] = computeRangeChange(selectedColIdx, start.colIdx, end.colIdx, colDir);
            let [minRowIdx, maxRowIdx] = computeRangeChange(selectedRowIdx, start.rowIdx, end.rowIdx, rowDir);

            // Constrain the area selection within the editable cells dimensions
            minColIdx = Math.max(minColIdx, 0);
            maxColIdx = Math.min(maxColIdx, editorModel.columns.size - 1);
            minRowIdx = Math.max(minRowIdx, 0);
            maxRowIdx = Math.min(maxRowIdx, rowCount - 1);
            selectionCells = computeSelectionCellKeys(minColIdx, minRowIdx, maxColIdx, maxRowIdx);
            break;
          }
        case SELECTION_TYPES.SINGLE:
          {
            selectionCells = [...editorModel.selectionCells];
            selectionCells.push(genCellKey(colIdx, rowIdx));
            break;
          }
      }
      if (selectionCells.length > 0) {
        // if a cell was previously selected and there are remaining selectionCells then mark the previously
        // selected cell as in "selection"
        if (hasSelection) {
          selectionCells.push(genCellKey(editorModel.selectedColIdx, editorModel.selectedRowIdx));
        }
      }
      return {
        selectedColIdx,
        selectedRowIdx,
        selectionCells
      };
    });
    EditableGrid_defineProperty(this, "selectCell", (colIdx, rowIdx, selection, resetValue = false) => {
      const {
        editorModel,
        onChange
      } = this.props;
      const {
        cellValues,
        focusValue,
        rowCount
      } = editorModel;

      // Issue 49953: AREA_CHANGE selection is oriented around the initial selected cell, so it
      // accepts processing of negative indices.
      if (selection !== SELECTION_TYPES.AREA_CHANGE && (colIdx < 0 || rowIdx < 0 || colIdx >= editorModel.columns.size)) {
        // out of bounds, do nothing
        return;
      }

      // Issue 33855: select last row
      if (rowIdx === rowCount) {
        rowIdx = rowIdx - 1;
      }
      if (rowIdx < rowCount) {
        const changes = EditableGrid_objectSpread({
          focusColIdx: -1,
          focusRowIdx: -1
        }, this.applySelection(colIdx, rowIdx, selection));
        if (resetValue) {
          changes.focusValue = undefined;
          changes.cellValues = cellValues.set(genCellKey(colIdx, rowIdx), focusValue);
        }
        onChange(EditableGridEvent.SELECT_CELL, changes);
        if (this.state.selectionPivot) {
          this.setState({
            selectionPivot: undefined
          });
        }
      }
    });
    EditableGrid_defineProperty(this, "modifyCell", (colIdx, rowIdx, newValues, mod, column) => {
      const {
        editorModel,
        onChange
      } = this.props;
      const {
        cellMessages,
        cellValues
      } = editorModel;
      const cellKey = genCellKey(colIdx, rowIdx);
      const keyPath = ['cellValues', cellKey];
      const changes = {
        cellMessages: cellMessages.delete(cellKey)
      };
      // It's possible for a user to select a whole row or column of readonly cells, then hit cmd+x, which would not
      // result in any actual changes, so we need to track if we actually modify anything
      let changesMade = false;
      if (mod === MODIFICATION_TYPES.ADD) {
        const values = editorModel.getIn(keyPath);
        if (values !== undefined) {
          changes.cellValues = cellValues.set(cellKey, values.push(...newValues));
        } else {
          changes.cellValues = cellValues.set(cellKey, (0,external_immutable_.List)(newValues));
        }
        changesMade = true;
      } else if (mod === MODIFICATION_TYPES.REPLACE) {
        changes.cellValues = cellValues.set(cellKey, (0,external_immutable_.List)(newValues));
        changesMade = true;
        const {
          message
        } = getValidatedEditableGridValue(newValues[0].display, column);
        changes.cellMessages = cellMessages.set(cellKey, message);
      } else if (mod === MODIFICATION_TYPES.REMOVE) {
        let values = editorModel.getIn(keyPath);
        for (let v = 0; v < newValues.length; v++) {
          const idx = values.findIndex(vd => vd.display === newValues[v].display && vd.raw === newValues[v].raw);
          if (idx > -1) {
            values = values.remove(idx);
          }
        }
        changes.cellValues = cellValues.set(cellKey, values);
        changesMade = true;
      } else if (mod === MODIFICATION_TYPES.REMOVE_ALL) {
        const insertColumns = this.getColumns();
        if (editorModel.selectionCells.length > 0) {
          // Remove all values and messages for the selected cells
          changes.cellValues = editorModel.cellValues.reduce((result, value, key) => {
            // Take no action if a cell is read only. Users can select an area that includes read only rows and
            // cells
            const isReadOnly = this.isReadOnly(key);
            if (!isReadOnly && editorModel.selectionCells.includes(key)) {
              changesMade = true;
              return result.set(key, (0,external_immutable_.List)());
            }
            return result.set(key, value);
          }, (0,external_immutable_.Map)());
          let updatedCellMessages = editorModel.cellMessages;
          editorModel.selectionCells.forEach(key => {
            if (!updatedCellMessages.has(key)) updatedCellMessages = updatedCellMessages.set(key, undefined);
          });
          changes.cellMessages = updatedCellMessages.reduce((result, value, key) => {
            const isReadOnly = this.isReadOnly(key);
            if (!isReadOnly && editorModel.selectionCells.includes(key)) {
              changesMade = true;
              const {
                colIdx
              } = parseCellKey(key);
              const col = insertColumns?.[colIdx];
              const {
                message
              } = getValidatedEditableGridValue(null, col);
              if (message) return result.set(key, message);else return result.remove(key);
            }
            return result.set(key, value);
          }, (0,external_immutable_.Map)());
        } else if (!this.isReadOnly(cellKey)) {
          changes.cellValues = cellValues.set(cellKey, (0,external_immutable_.List)());
          const {
            colIdx
          } = parseCellKey(cellKey);
          const col = insertColumns?.[colIdx];
          const {
            message
          } = getValidatedEditableGridValue(null, col);
          changes.cellMessages = cellMessages.set(cellKey, message);
          changesMade = true;
        }
      }
      if (changesMade) onChange(EditableGridEvent.MODIFY_CELL, changes);
    });
    EditableGrid_defineProperty(this, "removeRows", dataIdIndexes => {
      const {
        dataKeys,
        editorModel,
        onChange
      } = this.props;
      let deletedIds = (0,external_immutable_.Set)();
      const updatedKeys = this.props.dataKeys.filter((_, i) => !dataIdIndexes.has(i)).toList();
      const updatedData = this.props.data.reduce((result, value, key) => {
        if (updatedKeys.has(key)) {
          return result.set(key, value);
        }
        deletedIds = deletedIds.add(key);
        return result;
      }, (0,external_immutable_.Map)());
      const cellReducer = (result, value, cellKey) => {
        const [colIdx, oldRowIdx] = cellKey.split('-').map(v => parseInt(v, 10));

        // If this value is part of a deleted row don't include it in the result.
        if (dataIdIndexes.has(oldRowIdx)) return result;
        const key = dataKeys.get(oldRowIdx);
        const newRowIdx = updatedKeys.indexOf(key);
        return result.set(genCellKey(colIdx, newRowIdx), value);
      };
      const cellMessages = editorModel.cellMessages.reduce(cellReducer, (0,external_immutable_.Map)());
      const cellValues = editorModel.cellValues.reduce(cellReducer, (0,external_immutable_.Map)());
      const editorModelChanges = {
        deletedIds: editorModel.deletedIds.merge(deletedIds),
        focusColIdx: -1,
        focusRowIdx: -1,
        rowCount: editorModel.rowCount - dataIdIndexes.size,
        selectedColIdx: -1,
        selectedRowIdx: -1,
        selectionCells: [],
        cellMessages,
        cellValues
      };
      onChange(EditableGridEvent.REMOVE_ROWS, editorModelChanges, updatedKeys, updatedData);
      this.setState({
        selected: (0,external_immutable_.Set)(),
        selectedState: GRID_CHECKBOX_OPTIONS.NONE,
        selectionPivot: undefined
      });
    });
    EditableGrid_defineProperty(this, "removeSelected", () => {
      const {
        metricFeatureArea
      } = this.props;
      this.removeRows(this.state.selected);
      if (metricFeatureArea) {
        incrementClientSideMetricCount(metricFeatureArea, 'removeRows');
      }
    });
    EditableGrid_defineProperty(this, "getLoweredColumnMetadata", () => this.props.columnMetadata?.reduce((result, value, key) => {
      result[key.toLowerCase()] = value;
      return result;
    }, {}));
    EditableGrid_defineProperty(this, "generateColumns", () => {
      const {
        allowRemove,
        containerFilter,
        editorModel,
        forUpdate,
        hideCountCol,
        queryInfo,
        rowNumColumn,
        readonlyRows,
        lockedRows,
        containerPath
      } = this.props;
      let gridColumns = (0,external_immutable_.List)();
      const showCheckboxes = this.showSelectionCheckboxes();
      if (showCheckboxes) {
        const selColumn = new GridColumn({
          index: GRID_SELECTION_INDEX,
          title: '&nbsp;',
          cell: (selected, row) => /*#__PURE__*/external_react_default().createElement("input", {
            className: "grid-panel__checkbox",
            checked: this.state.selected.contains(row.get(GRID_EDIT_INDEX)),
            type: "checkbox",
            onChange: this.select.bind(this, row)
          })
        });
        gridColumns = gridColumns.push(selColumn);
      }
      if (!hideCountCol) {
        gridColumns = gridColumns.push(rowNumColumn ? rowNumColumn : COUNT_COL);
      }
      const loweredColumnMetadata = this.getLoweredColumnMetadata();
      this.getColumns().forEach(qCol => {
        const metadata = loweredColumnMetadata[qCol.fieldKey.toLowerCase()];
        let width = 100;
        let fixedWidth;
        if (hasCellWidthOverride(metadata)) {
          fixedWidth = metadata.width;
          if (!fixedWidth) {
            width = metadata.minWidth;
          }
        }
        const hideTooltip = metadata?.hideTitleTooltip ?? qCol.hasHelpTipData;
        gridColumns = gridColumns.push(new GridColumn({
          align: qCol.align,
          cell: inputCellFactory(queryInfo, editorModel, showCheckboxes, hideCountCol, metadata, readonlyRows, lockedRows, this.cellActions, metadata?.containerFilter ?? containerFilter, forUpdate, this.state.initialSelection, containerPath),
          index: qCol.fieldKey,
          fixedWidth,
          raw: qCol,
          title: metadata?.caption ?? qCol.caption,
          width,
          hideTooltip,
          tableCell: true
        }));
      });
      if (allowRemove) {
        gridColumns = gridColumns.push(new GridColumn({
          index: GRID_EDIT_INDEX,
          tableCell: true,
          title: this.props.removeColumnTitle,
          width: 45,
          cell: (d, row, c, rn) => {
            const keyCols = queryInfo.getPkCols();
            const size = keyCols.length;
            let canDelete = true;
            if (size === 1) {
              const key = caseInsensitive(row.toJS(), keyCols[0].fieldKey);
              canDelete = !key || !this.props.notDeletable.contains(key);
            } else {
              console.warn(`Preventing deletion for models with ${size} keys is not currently supported.`);
            }
            return /*#__PURE__*/external_react_default().createElement("td", {
              key: 'delete' + rn
            }, canDelete && /*#__PURE__*/external_react_default().createElement(DeleteIcon, {
              onDelete: () => this.removeRows((0,external_immutable_.Set)([rn]))
            }), !canDelete && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "\xA0"));
          }
        }));
      }
      return gridColumns;
    });
    EditableGrid_defineProperty(this, "renderColumnHeader", (col, metadataKey) => {
      const label = col.title;
      const qColumn = col.raw;
      const req = !!qColumn?.required;
      const loweredColumnMetadata = this.getLoweredColumnMetadata();
      const metadata = loweredColumnMetadata?.[metadataKey.toLowerCase()];
      const showOverlayFromMetadata = !!metadata?.toolTip;
      const showLabelOverlay = !showOverlayFromMetadata && qColumn?.hasHelpTipData;
      // TODO should be able to just use LabelOverlay here since it can handle an alternate tooltip renderer
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !showLabelOverlay && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, label, req && /*#__PURE__*/external_react_default().createElement("span", {
        className: "required-symbol"
      }, " *")), showOverlayFromMetadata && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: label,
        popoverClassName: metadata?.popoverClassName,
        placement: "bottom"
      }, /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, metadata?.toolTip)), showLabelOverlay && /*#__PURE__*/external_react_default().createElement(LabelOverlay, {
        column: qColumn,
        label: metadata?.caption,
        placement: "bottom",
        required: req
      }));
    });
    EditableGrid_defineProperty(this, "headerCell", col => {
      const {
        queryInfo
      } = this.props;
      if (col.index.toLowerCase() === GRID_SELECTION_INDEX && this.showSelectionCheckboxes()) {
        return headerSelectionCell(this.selectAll, this.state.selectedState, false, 'grid-panel__checkbox');
      }
      const qColumn = queryInfo.getColumn(col.index);
      if (qColumn) {
        return this.renderColumnHeader(col, qColumn.fieldKey);
      }
      if (col.showHeader) {
        return this.renderColumnHeader(col, col.title);
      }
      return null;
    });
    EditableGrid_defineProperty(this, "hideMask", () => {
      clearTimeout(this.maskDelay);
      this.toggleMask(false);
    });
    EditableGrid_defineProperty(this, "handleDrag", event => {
      if (!this.props.editorModel.hasFocus) {
        event.preventDefault();
        return true;
      }
      return false;
    });
    EditableGrid_defineProperty(this, "beginDrag", event => {
      // Only handle event if the left mouse button is clicked
      if (event.buttons !== 1) return;
      const {
        disabled,
        editorModel
      } = this.props;
      if (this.handleDrag(event) && !disabled) {
        clearTimeout(this.dragDelay);
        const target = event.target;
        const isDragHandleAction = target.className?.indexOf(CELL_SELECTION_HANDLE_CLASSNAME) > -1;

        // NK: Here we slightly delay the drag event in case the user is just clicking on the cell
        // rather than performing a drag action. If they are simply clicking then the endDrag() will cancel
        // this update prior to the timeout.
        this.dragDelay = window.setTimeout(() => {
          this.dragDelay = undefined;
          const nextState = {
            inDrag: true
          };
          if (isDragHandleAction) {
            const initialSelection = [...editorModel.selectionCells];
            if (!initialSelection.length) initialSelection.push(editorModel.selectionKey);
            nextState.initialSelection = initialSelection;
          }
          this.setState(nextState);
          document.addEventListener('mouseup', this.onDocumentMouseUp);
        }, 150);
      }
    });
    EditableGrid_defineProperty(this, "inDrag", () => this.state.inDrag);
    EditableGrid_defineProperty(this, "endDrag", event => {
      if (this.handleDrag(event)) {
        if (this.dragDelay) {
          clearTimeout(this.dragDelay);
          this.dragDelay = undefined;
        } else {
          document.removeEventListener('mouseup', this.onDocumentMouseUp);
          this.setState({
            inDrag: false
          });
        }
      }
    });
    EditableGrid_defineProperty(this, "onCopy", event => {
      const {
        disabled,
        editorModel
      } = this.props;
      if (!disabled) {
        copyEvent(editorModel, this.getColumns(), event);
      }
    });
    EditableGrid_defineProperty(this, "onCut", event => {
      const {
        disabled,
        editorModel
      } = this.props;
      if (!disabled && copyEvent(editorModel, this.getColumns(), event)) {
        this.modifyCell(editorModel.selectedColIdx, editorModel.selectedRowIdx, undefined, MODIFICATION_TYPES.REMOVE_ALL);
      }
    });
    EditableGrid_defineProperty(this, "onKeyDown", event => {
      const {
        disabled,
        editorModel
      } = this.props;
      if (disabled || editorModel.hasFocus) {
        return;
      }
      const isMeta = isCtrlOrMetaKey(event);
      const isShift = event.shiftKey;
      const colIdx = editorModel.selectedColIdx;
      const rowIdx = editorModel.selectedRowIdx;
      let nextCol;
      let nextRow;
      switch (event.key) {
        case Key.ARROW_LEFT:
          if (isMeta) {
            const found = editorModel.findNextCell(colIdx, rowIdx, not(isCellEmpty), moveLeft);
            if (found) {
              nextCol = found.colIdx;
              nextRow = found.rowIdx;
            } else {
              nextCol = 0;
              nextRow = rowIdx;
            }
          } else {
            nextCol = colIdx - 1;
            nextRow = rowIdx;
          }
          break;
        case Key.ARROW_UP:
          if (isMeta) {
            const found = editorModel.findNextCell(colIdx, rowIdx, not(isCellEmpty), moveUp);
            if (found) {
              nextCol = found.colIdx;
              nextRow = found.rowIdx;
            } else {
              nextCol = colIdx;
              nextRow = 0;
            }
          } else {
            nextCol = colIdx;
            nextRow = rowIdx - 1;
          }
          break;
        case Key.ARROW_RIGHT:
          if (isMeta) {
            const found = editorModel.findNextCell(colIdx, rowIdx, not(isCellEmpty), moveRight);
            if (found) {
              nextCol = found.colIdx;
              nextRow = found.rowIdx;
            } else {
              nextCol = editorModel.columns.size - 1;
              nextRow = rowIdx;
            }
          } else {
            nextCol = colIdx + 1;
            nextRow = rowIdx;
          }
          break;
        case Key.ARROW_DOWN:
          if (isMeta) {
            const found = editorModel.findNextCell(colIdx, rowIdx, not(isCellEmpty), moveDown);
            if (found) {
              nextCol = found.colIdx;
              nextRow = found.rowIdx;
            } else {
              nextCol = colIdx;
              nextRow = editorModel.rowCount - 1;
            }
          } else {
            nextCol = colIdx;
            nextRow = rowIdx + 1;
          }
          break;
        case Key.HOME:
          nextCol = 0;
          nextRow = rowIdx;
          break;
        case Key.END:
          nextCol = editorModel.columns.size - 1;
          nextRow = rowIdx;
          break;
        default:
          // Ignore all other keys
          break;
      }
      if (nextCol !== undefined && nextRow !== undefined) {
        cancelEvent(event);
        this.selectCell(nextCol, nextRow, isShift ? SELECTION_TYPES.AREA_CHANGE : undefined);
      }
    });
    EditableGrid_defineProperty(this, "_dragFill", async initialSelection => {
      const {
        editorModel,
        forUpdate,
        containerPath,
        onChange,
        data,
        dataKeys,
        queryInfo,
        readonlyRows,
        lockedRows
      } = this.props;
      if (editorModel.isMultiSelect) {
        const loweredColumnMetadata = this.getLoweredColumnMetadata();
        const columns = this.getColumns();
        const columnMetadata = columns.map(col => loweredColumnMetadata[col.fieldKey.toLowerCase()]);
        const {
          cellMessages,
          cellValues
        } = await dragFillEvent(editorModel, initialSelection, dataKeys, data, queryInfo, columns, columnMetadata, readonlyRows, lockedRows, forUpdate, containerPath);
        onChange(EditableGridEvent.DRAG_FILL, {
          cellMessages,
          cellValues
        });
        this.setState({
          initialSelection: undefined
        });
      }
    });
    EditableGrid_defineProperty(this, "onMouseUp", event => {
      if (this.props.disabled) return;
      this.endDrag(event);
      const initialSelection = this.state.initialSelection;
      if (initialSelection?.length > 0) this._dragFill(initialSelection);
    });
    // Issue 49612: Handle ending drag action "mouse up" outside the editable grid
    EditableGrid_defineProperty(this, "onDocumentMouseUp", event => {
      this.onMouseUp(event);
    });
    EditableGrid_defineProperty(this, "fillDown", () => {
      const {
        disabled,
        editorModel
      } = this.props;
      const {
        isSparseSelection,
        selectionCells
      } = editorModel;
      if (disabled || isSparseSelection) return;
      const firstRowIdx = parseCellKey(selectionCells[0]).rowIdx;
      const firstRowCellKeys = selectionCells.filter(cellKey => parseCellKey(cellKey).rowIdx === firstRowIdx);
      this._dragFill(firstRowCellKeys);
    });
    EditableGrid_defineProperty(this, "fillText", async (colIdx, rowIdx, text) => {
      const {
        allowAdd,
        columnMetadata,
        data,
        dataKeys,
        disabled,
        editorModel,
        forUpdate,
        onChange,
        queryInfo,
        readonlyRows,
        lockedRows,
        containerPath
      } = this.props;
      if (disabled) return;
      this.showMask();
      const changes = await validateAndInsertPastedData(editorModel, dataKeys, data, queryInfo, this.getColumns(), text, columnMetadata, readonlyRows, lockedRows, !allowAdd, forUpdate, containerPath, false);
      this.hideMask();
      onChange(EditableGridEvent.FILL_TEXT, changes.editorModel, changes.dataKeys, changes.data);
    });
    EditableGrid_defineProperty(this, "onPaste", async event => {
      const {
        allowAdd,
        columnMetadata,
        data,
        dataKeys,
        disabled,
        editorModel,
        forUpdate,
        onChange,
        queryInfo,
        readonlyRows,
        lockedRows,
        containerPath
      } = this.props;
      if (disabled) return;
      this.showMask();
      const changes = await pasteEvent(editorModel, dataKeys, data, queryInfo, this.getColumns(), event, columnMetadata, readonlyRows, lockedRows, !allowAdd, forUpdate, containerPath);
      this.hideMask();
      onChange(EditableGridEvent.PASTE, changes.editorModel, changes.dataKeys, changes.data);
    });
    EditableGrid_defineProperty(this, "showMask", () => {
      clearTimeout(this.maskDelay);
      this.maskDelay = window.setTimeout(this.toggleMask.bind(this, true), 300);
    });
    EditableGrid_defineProperty(this, "toggleMask", showMask => {
      this.setState({
        showMask
      });
    });
    EditableGrid_defineProperty(this, "toggleBulkAdd", () => {
      this.setState(state => ({
        showBulkAdd: !state.showBulkAdd
      }),
      // Issue 38420: Without this, the BulkUpdate button always retains focus after modal is shown
      blurActiveElement);
    });
    EditableGrid_defineProperty(this, "toggleBulkUpdate", () => {
      const {
        bulkUpdateProps
      } = this.props;
      if (bulkUpdateProps?.onClickBulkUpdate) {
        bulkUpdateProps.onClickBulkUpdate(this.state.selected).then(canEdit => {
          // the selected rows might not be updatable, for examples, all selected are readonly
          if (!canEdit) return;
          this.setState(state => ({
            showBulkUpdate: !state.showBulkUpdate
          }),
          // Issue 38420: Without this, the BulkUpdate button always retains focus after modal is shown
          blurActiveElement);
        }).catch(error => {
          console.error(error);
        });
      } else {
        this.setState(state => ({
          showBulkUpdate: !state.showBulkUpdate
        }),
        // Issue 38420: Without this, the BulkUpdate button always retains focus after modal is shown
        blurActiveElement);
      }
    });
    EditableGrid_defineProperty(this, "getSelectedRowIndices", () => {
      return this.state.selected.toList();
    });
    EditableGrid_defineProperty(this, "restoreBulkInsertData", data => {
      const allInsertCols = (0,external_immutable_.OrderedMap)().asMutable();
      this.props.queryInfo.getInsertColumns(this.props.bulkAddProps.isIncludedColumn).forEach(col => allInsertCols.set(col.name, undefined));
      return allInsertCols.merge(data).asImmutable();
    });
    EditableGrid_defineProperty(this, "bulkAdd", async bulkData => {
      const {
        addControlProps,
        bulkAddProps,
        editorModel,
        data,
        dataKeys,
        metricFeatureArea,
        onChange,
        processBulkData,
        queryInfo,
        containerPath
      } = this.props;
      const nounPlural = addControlProps?.nounPlural;
      // numItems is a string because we rely on Formsy to grab the value for us (See QueryInfoForm for details). We
      // need to parseInt the value because we add this variable to other numbers, if it's a string we'll add more
      // rows than we want because 1 + "1" is "11" in JavaScript.
      const numItems = parseInt(bulkData.get('numItems'), 10);
      let pivotKey;
      let pivotValues;
      if (!numItems) {
        return Promise.reject({
          exception: 'Quantity unknown.  No ' + nounPlural + ' added.'
        });
      }
      if (processBulkData) {
        const processedData = processBulkData(bulkData);
        if (processedData.validationMsg) {
          return Promise.reject({
            exception: processedData.validationMsg
          });
        }
        pivotKey = processedData.pivotKey;
        pivotValues = processedData.pivotValues;
      }
      bulkData = bulkData.delete('numItems').delete('creationType');
      if (bulkAddProps.columnFilter) {
        bulkData = this.restoreBulkInsertData(bulkData);
      }
      if (pivotKey && pivotValues?.length > 0) {
        const changes = await addRowsPerPivotValue(editorModel, dataKeys, data, (0,external_immutable_.List)(queryInfo.getInsertColumns()), numItems, pivotKey, pivotValues, bulkData, containerPath);
        onChange(EditableGridEvent.BULK_ADD, changes.editorModel, changes.dataKeys, changes.data);
      } else {
        const changes = await addRows(editorModel, dataKeys, data, (0,external_immutable_.List)(queryInfo.getInsertColumns()), numItems, bulkData, containerPath);
        onChange(EditableGridEvent.BULK_ADD, changes.editorModel, changes.dataKeys, changes.data);
      }
      if (metricFeatureArea) {
        incrementClientSideMetricCount(metricFeatureArea, 'bulkAdd');
      }

      // Result of this promise passed to toggleBulkAdd, which doesn't expect anything to be passed
      return Promise.resolve();
    });
    EditableGrid_defineProperty(this, "bulkUpdate", async updatedData => {
      const {
        editorModel,
        queryInfo,
        onChange,
        bulkUpdateProps,
        metricFeatureArea,
        containerPath
      } = this.props;
      if (!updatedData) return Promise.resolve(undefined);
      const selectedIndices = this.getSelectedRowIndices();
      const editorModelChanges = await updateGridFromBulkForm(editorModel, queryInfo, updatedData, selectedIndices, bulkUpdateProps?.excludeRowIdx, bulkUpdateProps?.isIncludedColumn, containerPath);
      onChange(EditableGridEvent.BULK_UPDATE, editorModelChanges);
      if (metricFeatureArea) {
        incrementClientSideMetricCount(metricFeatureArea, 'bulkUpdate');
      }

      // The result of this promise is used by toggleBulkUpdate, which doesn't expect anything to be passed
      return Promise.resolve(editorModelChanges);
    });
    EditableGrid_defineProperty(this, "addRows", async count => {
      const {
        data,
        dataKeys,
        editorModel,
        onChange,
        queryInfo,
        containerPath
      } = this.props;
      const changes = await addRows(editorModel, dataKeys, data, (0,external_immutable_.List)(queryInfo.getInsertColumns()), count, undefined, containerPath);
      onChange(EditableGridEvent.ADD_ROWS, changes.editorModel, changes.dataKeys, changes.data);
    });
    EditableGrid_defineProperty(this, "renderAddRowsControl", placement => {
      const {
        addControlProps,
        editorModel,
        isSubmitting,
        maxRows
      } = this.props;
      let maxCount = addControlProps?.maxCount;
      if (maxRows && editorModel.rowCount + (addControlProps?.maxCount ?? 0) > maxRows) {
        maxCount = maxRows - editorModel.rowCount;
      }
      return /*#__PURE__*/external_react_default().createElement(AddRowsControl, EditableGrid_extends({}, addControlProps, {
        disable: isSubmitting || maxRows && editorModel.rowCount >= maxRows,
        maxCount: maxCount,
        maxTotalCount: maxRows,
        onAdd: this.addRows,
        placement: placement
      }));
    });
    EditableGrid_defineProperty(this, "renderTopControls", () => {
      const {
        addControlProps,
        allowAdd,
        allowBulkAdd,
        allowBulkRemove,
        allowBulkUpdate,
        bulkAddText,
        bulkRemoveText,
        bulkUpdateText,
        data,
        isSubmitting,
        maxRows,
        showAsTab
      } = this.props;
      const nounPlural = addControlProps?.nounPlural ?? 'rows';
      const showAddOnTop = allowAdd && this.getControlsPlacement() !== 'bottom';
      const invalidSel = this.state.selected.size === 0;
      const canAddRows = !isSubmitting && data.size < maxRows;
      const addTitle = canAddRows ? 'Add multiple ' + nounPlural + ' with the same values' : 'The grid contains the maximum number of ' + nounPlural + '.';
      const actionButtonClassNames = external_classnames_default()('editable-grid-buttons__action-buttons', {
        'col-sm-9': showAddOnTop,
        'col-sm-12': !showAddOnTop
      });
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "row editable-grid-buttons"
      }, showAddOnTop && /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-sm-3"
      }, this.renderAddRowsControl('top')), /*#__PURE__*/external_react_default().createElement("div", {
        className: actionButtonClassNames
      }, !showAsTab && allowBulkAdd && /*#__PURE__*/external_react_default().createElement("button", {
        className: "bulk-add-button btn btn-default",
        disabled: !canAddRows,
        onClick: this.toggleBulkAdd,
        title: addTitle,
        type: "button"
      }, bulkAddText), !showAsTab && allowBulkUpdate && /*#__PURE__*/external_react_default().createElement("button", {
        className: "bulk-update-button btn btn-default",
        disabled: invalidSel,
        onClick: this.toggleBulkUpdate,
        type: "button"
      }, bulkUpdateText), allowBulkRemove && /*#__PURE__*/external_react_default().createElement("button", {
        className: "bulk-remove-button btn btn-default",
        disabled: invalidSel,
        onClick: this.removeSelected,
        type: "button"
      }, bulkRemoveText)));
    });
    EditableGrid_defineProperty(this, "renderBulkAdd", () => {
      const {
        addControlProps,
        allowFieldDisable,
        bulkAddProps,
        data,
        forUpdate,
        maxRows,
        queryInfo,
        containerPath
      } = this.props;
      const maxToAdd = maxRows && maxRows - data.size < MAX_EDITABLE_GRID_ROWS ? maxRows - data.size : MAX_EDITABLE_GRID_ROWS;
      return /*#__PURE__*/external_react_default().createElement(QueryInfoForm, {
        allowFieldDisable: allowFieldDisable,
        onSubmitForEdit: this.bulkAdd,
        asModal: true,
        checkRequiredFields: false,
        showLabelAsterisk: true,
        submitForEditText: `Add ${capitalizeFirstChar(addControlProps?.nounPlural)} to Grid`,
        maxCount: maxToAdd,
        onHide: this.toggleBulkAdd,
        operation: forUpdate ? Operation.update : Operation.insert,
        onSuccess: this.toggleBulkAdd,
        queryInfo: queryInfo.getInsertQueryInfo(),
        header: !!bulkAddProps?.header && /*#__PURE__*/external_react_default().createElement("div", {
          className: "editable-grid__bulk-header"
        }, bulkAddProps.header),
        fieldValues: bulkAddProps?.fieldValues,
        columnFilter: bulkAddProps?.columnFilter,
        title: bulkAddProps?.title,
        countText: bulkAddProps?.countText,
        creationTypeOptions: bulkAddProps?.creationTypeOptions,
        containerPath: containerPath
      });
    });
    EditableGrid_defineProperty(this, "getControlsPlacement", () => {
      return this.props.addControlProps?.placement ?? 'bottom';
    });
    EditableGrid_defineProperty(this, "onBulkUpdateFormDataChange", pendingBulkFormData => {
      const {
        showAsTab,
        bulkUpdateProps
      } = this.props;
      bulkUpdateProps?.onBulkUpdateFormDataChange?.(pendingBulkFormData);
      if (showAsTab) {
        this.setState({
          pendingBulkFormData
        });
      }
    });
    EditableGrid_defineProperty(this, "applyPendingBulkFormData", () => {
      const {
        pendingBulkFormData
      } = this.state;
      this.bulkUpdate(pendingBulkFormData).then(() => {
        this.setState({
          pendingBulkFormData: undefined,
          activeEditTab: EditableGridTabs.Grid
        });
      });
    });
    EditableGrid_defineProperty(this, "onTabChange", newTabKey => {
      const {
        bulkUpdateProps
      } = this.props;
      const {
        activeEditTab
      } = this.state;
      if (newTabKey === EditableGridTabs.Grid && activeEditTab === EditableGridTabs.BulkUpdate) {
        this.applyPendingBulkFormData();
      } else if (newTabKey === EditableGridTabs.BulkUpdate && activeEditTab === EditableGridTabs.Grid) {
        if (bulkUpdateProps?.onClickBulkUpdate) {
          bulkUpdateProps.onClickBulkUpdate(this.state.selected).then(canEdit => {
            if (!canEdit) return;
            this.setState({
              activeEditTab: newTabKey
            });
          }).catch(error => {
            console.error(error);
          });
        } else {
          this.setState({
            activeEditTab: newTabKey
          });
        }
      }
    });
    EditableGrid_defineProperty(this, "onSaveClick", () => {
      const {
        primaryBtnProps,
        editorModel,
        maxRows
      } = this.props;
      const {
        pendingBulkFormData
      } = this.state;
      if (editorModel.rowCount > maxRows) {
        // only bulk edit is supported
        primaryBtnProps?.onClick?.(pendingBulkFormData);
        this.setState({
          pendingBulkFormData: undefined
        });
        return;
      }
      this.bulkUpdate(pendingBulkFormData).then(updates => {
        this.setState({
          pendingBulkFormData: undefined
        });
        primaryBtnProps?.onClick?.(undefined, updates); // send back the updates in case caller uses useState to update EditorModel, which is async without cb
      });
    });
    EditableGrid_defineProperty(this, "renderButtons", () => {
      const {
        primaryBtnProps,
        tabAdditionalBtn,
        tabBtnProps
      } = this.props;
      if (!tabBtnProps?.show) return null;
      const btnClass = primaryBtnProps.cls ?? 'btn';
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: tabBtnProps?.cls
      }, tabAdditionalBtn, /*#__PURE__*/external_react_default().createElement("button", {
        className: `${btnClass} ${btnClass}-primary`,
        disabled: primaryBtnProps.disabled,
        onClick: this.onSaveClick,
        type: "button"
      }, primaryBtnProps.caption ?? 'Save'));
    });
    EditableGrid_defineProperty(this, "renderBulkUpdate", () => {
      const {
        bulkTabHeaderComponent,
        addControlProps,
        bulkUpdateProps,
        data,
        dataKeys,
        editorModel,
        forUpdate,
        queryInfo,
        showAsTab,
        containerPath
      } = this.props;
      const {
        pendingBulkFormData
      } = this.state;
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, bulkUpdateProps?.applyBulkUpdateBtnText && /*#__PURE__*/external_react_default().createElement("button", {
        className: "btn btn-primary",
        disabled: api_.Utils.isEmptyObj(pendingBulkFormData?.toJS()),
        onClick: this.applyPendingBulkFormData,
        type: "button"
      }, bulkUpdateProps.applyBulkUpdateBtnText), bulkTabHeaderComponent, /*#__PURE__*/external_react_default().createElement(BulkAddUpdateForm, {
        asModal: !showAsTab,
        containerPath: containerPath,
        data: data,
        dataKeys: dataKeys,
        editorModel: editorModel,
        columnFilter: bulkUpdateProps?.columnFilter,
        queryFilters: bulkUpdateProps?.queryFilters,
        onFormChangeWithData: showAsTab ? this.onBulkUpdateFormDataChange : undefined,
        onHide: this.toggleBulkUpdate,
        operation: forUpdate ? Operation.update : Operation.insert,
        onSubmitForEdit: this.bulkUpdate,
        onSuccess: this.toggleBulkUpdate,
        pluralNoun: addControlProps?.nounPlural,
        queryInfo: queryInfo,
        selectedRowIndexes: this.getSelectedRowIndices(),
        singularNoun: addControlProps?.nounSingular,
        warning: bulkUpdateProps?.warning
      }));
    });
    this.cellActions = {
      clearSelection: this.clearSelection,
      focusCell: this.focusCell,
      fillDown: this.fillDown,
      fillText: this.fillText,
      inDrag: this.inDrag,
      modifyCell: this.modifyCell,
      selectCell: this.selectCell
    };
    let _selectionCells = (0,external_immutable_.Set)();
    let _selectedState = GRID_CHECKBOX_OPTIONS.NONE;
    if (props.activeEditTab === EditableGridTabs.BulkUpdate || props.hideCheckboxCol) {
      _selectionCells = (0,external_immutable_.Set)(props.dataKeys.map((v, i) => i, (0,external_immutable_.Set)()));
      _selectedState = GRID_CHECKBOX_OPTIONS.ALL;
    }
    this.state = {
      activeEditTab: props.activeEditTab ? props.activeEditTab : EditableGridTabs.Grid,
      inDrag: false,
      initialSelection: undefined,
      selected: _selectionCells,
      selectedState: _selectedState,
      selectionPivot: undefined,
      showBulkAdd: false,
      showBulkUpdate: false,
      showMask: false
    };
  }
  componentDidMount() {
    document.addEventListener('copy', this.onCopy);
    document.addEventListener('cut', this.onCut);
    document.addEventListener('paste', this.onPaste);
  }
  componentWillUnmount() {
    document.removeEventListener('copy', this.onCopy);
    document.removeEventListener('cut', this.onCut);
    document.removeEventListener('paste', this.onPaste);
  }
  componentDidUpdate(prevProps) {
    // use saveBtnClickedCount to notify EditableGrid of buttons defined outside of the component
    if (prevProps.saveBtnClickedCount !== this.props.saveBtnClickedCount) {
      this.onSaveClick();
    }
  }
  /**
   * Given a colIdx/rowIdx returns true if a cell is read only. Use this in event handlers to prevent modifying read
   * only cells (e.g. during delete).
   */
  isReadOnly(cellKey) {
    const {
      colIdx,
      rowIdx
    } = parseCellKey(cellKey);
    const {
      dataKeys,
      lockedRows,
      readonlyRows
    } = this.props;
    const cellValueDataKey = dataKeys.get(rowIdx);
    if (readonlyRows?.includes(cellValueDataKey)) return true;
    if (lockedRows?.includes(cellValueDataKey)) return true;
    const queryCol = this.getColumns()[colIdx];
    if (queryCol.readOnly) return true;
    const loweredColumnMetadata = this.getLoweredColumnMetadata();
    const metadata = loweredColumnMetadata[queryCol.fieldKey.toLowerCase()];
    return metadata && (metadata.readOnly || metadata.isReadOnlyCell?.(cellValueDataKey));
  }
  showSelectionCheckboxes() {
    const {
      allowBulkRemove,
      allowBulkUpdate,
      allowSelection,
      hideCheckboxCol
    } = this.props;
    if (allowSelection === undefined) {
      return !hideCheckboxCol && (allowBulkRemove || allowBulkUpdate);
    }
    return allowSelection && !hideCheckboxCol;
  }
  getGridData() {
    const {
      data,
      dataKeys,
      hideReadonlyRows,
      readonlyRows
    } = this.props;
    return dataKeys.map((key, index) => {
      if (hideReadonlyRows && readonlyRows && readonlyRows.includes(key)) return undefined;
      const rowIndexData = {
        [GRID_EDIT_INDEX]: index
      };
      return data.get(key)?.merge(rowIndexData) ?? (0,external_immutable_.Map)(rowIndexData);
    }).filter(r => r !== undefined).toList();
  }
  render() {
    const {
      allowAdd,
      editorModel,
      error,
      bordered,
      condensed,
      fixedHeight,
      emptyGridMsg,
      striped,
      allowBulkUpdate,
      showAsTab,
      tabBtnProps,
      maxRows,
      hideTopControls,
      tabContainerCls,
      gridTabHeaderComponent,
      hideCountCol,
      lockLeftOnScroll
    } = this.props;
    const {
      showBulkAdd,
      showBulkUpdate,
      showMask,
      activeEditTab,
      selected
    } = this.state;
    const showCheckboxes = this.showSelectionCheckboxes();
    const showCountCol = !hideCountCol;
    const gridContent = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !hideTopControls && this.renderTopControls(), gridTabHeaderComponent, /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()(EDITABLE_GRID_CONTAINER_CLS, 'grid-panel__lock-left', {
        'grid-panel__lock-left-with-checkboxes': showCheckboxes,
        'grid-panel__lock-left-with-countcol': lockLeftOnScroll && showCountCol && !showCheckboxes,
        'grid-panel__lock-left-with-checkboxes-and-countcol': lockLeftOnScroll && showCountCol && showCheckboxes,
        'loading-mask': showMask
      }),
      onKeyDown: this.onKeyDown,
      onMouseDown: this.beginDrag,
      onMouseUp: this.onMouseUp
    }, /*#__PURE__*/external_react_default().createElement(Grid, {
      bordered: bordered,
      calcWidths: true,
      cellular: true,
      columns: this.generateColumns(),
      condensed: condensed,
      data: this.getGridData(),
      emptyText: emptyGridMsg,
      fixedHeight: fixedHeight,
      headerCell: this.headerCell,
      rowKey: GRID_EDIT_INDEX,
      striped: striped
    })), allowAdd && this.getControlsPlacement() !== 'top' && this.renderAddRowsControl('bottom'));
    if (showAsTab) {
      const bulkDisabled = selected.size === 0;
      const showGrid = editorModel.rowCount <= maxRows;
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, tabBtnProps?.placement === 'top' && this.renderButtons(), /*#__PURE__*/external_react_default().createElement(Tabs, {
        activeKey: activeEditTab,
        className: tabContainerCls,
        onSelect: this.onTabChange
      }, allowBulkUpdate && /*#__PURE__*/external_react_default().createElement(Tab, {
        className: "top-spacing",
        disabled: bulkDisabled,
        eventKey: EditableGridTabs.BulkUpdate,
        title: "Edit in Bulk"
      }, /*#__PURE__*/external_react_default().createElement(Alert, null, error), this.renderBulkUpdate()), showGrid && /*#__PURE__*/external_react_default().createElement(Tab, {
        className: "top-spacing",
        eventKey: EditableGridTabs.Grid,
        title: "Edit Individually"
      }, /*#__PURE__*/external_react_default().createElement(Alert, null, error), gridContent)), tabBtnProps?.placement === 'bottom' && this.renderButtons());
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "editable-grid-wrapper"
    }, tabBtnProps?.placement === 'top' && this.renderButtons(), gridContent, error && /*#__PURE__*/external_react_default().createElement(Alert, {
      className: "margin-top"
    }, error), tabBtnProps?.placement === 'bottom' && this.renderButtons(), showBulkAdd && this.renderBulkAdd(), showBulkUpdate && this.renderBulkUpdate());
  }
}
EditableGrid_defineProperty(EditableGrid, "defaultProps", {
  allowAdd: true,
  allowBulkAdd: false,
  allowBulkRemove: false,
  allowBulkUpdate: false,
  allowRemove: false,
  removeColumnTitle: 'Delete',
  addControlProps: {
    nounPlural: 'Rows',
    nounSingular: 'Row'
  },
  bordered: false,
  bulkAddText: 'Bulk Add',
  bulkRemoveText: 'Delete Rows',
  bulkUpdateText: 'Bulk Update',
  columnMetadata: (0,external_immutable_.Map)(),
  notDeletable: (0,external_immutable_.List)(),
  fixedHeight: true,
  lockLeftOnScroll: true,
  condensed: false,
  disabled: false,
  isSubmitting: false,
  striped: false,
  maxRows: MAX_EDITABLE_GRID_ROWS,
  hideCountCol: false,
  hideTopControls: false,
  hideReadonlyRows: false,
  rowNumColumn: COUNT_COL
});
;// CONCATENATED MODULE: ./src/internal/components/editable/EditableGridPanel.tsx
const EditableGridPanel_excluded = ["editorModel", "model", "onChange", "title", "bsStyle", "className", "columnMetadata", "getColumnMetadata", "readonlyRows", "getReadOnlyRows", "updateColumns", "getUpdateColumns", "getTabHeader", "getTabTitle", "readOnlyColumns", "forUpdate", "insertColumns"];
function EditableGridPanel_extends() { return EditableGridPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, EditableGridPanel_extends.apply(null, arguments); }
function EditableGridPanel_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = EditableGridPanel_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function EditableGridPanel_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }





/**
 * Note that there are some cases which will call the onChange callback prop back to back (i.e. see LookupCell.onInputChange)
 * and pass through different sets of `editorModelChanges`. In that case, you will want to make sure that your onChange
 * handler is getting the current state object before merging in the `editorModelChanges`. See example in platform/core
 * (core/src/client/LabKeyUIComponentsPage/EditableGridPage.tsx) which uses the set state function which takes a function
 * as the first parameter instead of the new state object.
 */
const EditableGridPanel = (0,external_react_.memo)(props => {
  const {
      editorModel,
      model,
      onChange,
      title,
      bsStyle,
      className = '',
      columnMetadata,
      getColumnMetadata,
      readonlyRows,
      getReadOnlyRows,
      updateColumns,
      getUpdateColumns,
      getTabHeader,
      getTabTitle,
      readOnlyColumns,
      forUpdate,
      insertColumns
    } = props,
    gridProps = EditableGridPanel_objectWithoutProperties(props, EditableGridPanel_excluded);
  const [activeTab, setActiveTab] = (0,external_react_.useState)(props.activeTab ?? 0);
  const models = Array.isArray(model) ? model : [model];
  const activeModel = models[activeTab];
  const editorModels = Array.isArray(editorModel) ? editorModel : [editorModel];
  const activeEditorModel = editorModels[activeTab];
  const hasTabs = models.length > 1;
  const _onChange = (0,external_react_.useCallback)((event, editorModelChanges, dataKeys, data) => onChange(event, editorModelChanges, dataKeys, data, activeTab), [activeTab, onChange]);

  // TODO: When EditableGridPanelDeprecated is removed we should be able to just pass model.rows and model.orderedRows
  //  to the EditableGrid.
  const {
    orderedRows,
    queryInfo,
    rows
  } = activeModel;
  const data = (0,external_react_.useMemo)(() => (0,external_immutable_.fromJS)(rows), [rows]);
  const dataKeys = (0,external_react_.useMemo)(() => (0,external_immutable_.fromJS)(orderedRows), [orderedRows]);
  const error = activeModel.hasLoadErrors ? activeModel.loadErrors[0] ?? 'Something went wrong loading the data.' : undefined;
  let activeColumnMetadata = columnMetadata;
  if (!activeColumnMetadata && getColumnMetadata) activeColumnMetadata = getColumnMetadata(activeTab);
  if (!activeColumnMetadata) activeColumnMetadata = getUniqueIdColumnMetadata(queryInfo);
  let activeReadOnlyRows = readonlyRows;
  if (!activeReadOnlyRows && getReadOnlyRows) activeReadOnlyRows = getReadOnlyRows(activeTab);
  let activeUpdateColumns = updateColumns;
  if (!activeUpdateColumns && getUpdateColumns) activeUpdateColumns = getUpdateColumns(activeTab);
  const onTabClick = (0,external_react_.useCallback)(setActiveTab, []);
  const editableGrid = /*#__PURE__*/external_react_default().createElement(EditableGrid, EditableGridPanel_extends({}, gridProps, {
    columnMetadata: activeColumnMetadata,
    data: data,
    dataKeys: dataKeys,
    editorModel: activeEditorModel,
    error: error,
    onChange: _onChange,
    queryInfo: queryInfo,
    readonlyRows: activeReadOnlyRows,
    readOnlyColumns: readOnlyColumns,
    updateColumns: activeUpdateColumns,
    insertColumns: insertColumns,
    forUpdate: forUpdate
  }));
  if (!title) {
    return editableGrid;
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: `panel ${bsStyle === 'info' ? 'panel-info' : 'panel-default'} ${className}`
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, title), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, hasTabs && /*#__PURE__*/external_react_default().createElement("ul", {
    className: "nav nav-tabs"
  }, models.map((tabModel, index) => {
    if (tabModel) {
      let tabTitle = tabModel.title ?? tabModel.queryName;
      if (getTabTitle) tabTitle = getTabTitle(index);
      const classes = external_classnames_default()({
        active: activeModel.id === tabModel.id
      });
      return /*#__PURE__*/external_react_default().createElement("li", {
        key: tabModel.id,
        className: classes
      }, /*#__PURE__*/external_react_default().createElement("a", {
        onClick: () => onTabClick(index)
      }, tabTitle));
    }
    return null;
  })), getTabHeader?.(activeTab), editableGrid));
});
;// CONCATENATED MODULE: ./src/internal/components/editable/EditableGridPanelForUpdate.tsx
const EditableGridPanelForUpdate_excluded = ["editStatusData", "idField", "loader", "onCancel", "onComplete", "pluralNoun", "queryModel", "selectionData", "singularNoun", "updateRows", "getIsDirty", "setIsDirty"];
function EditableGridPanelForUpdate_extends() { return EditableGridPanelForUpdate_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, EditableGridPanelForUpdate_extends.apply(null, arguments); }
function EditableGridPanelForUpdate_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = EditableGridPanelForUpdate_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function EditableGridPanelForUpdate_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }















const ERROR_ALERT_ID = 'editable-grid-error';
const EditableGridPanelForUpdate = props => {
  const {
      editStatusData,
      idField,
      loader,
      onCancel,
      onComplete,
      pluralNoun,
      queryModel,
      selectionData,
      singularNoun,
      updateRows,
      getIsDirty,
      setIsDirty
    } = props,
    editableGridProps = EditableGridPanelForUpdate_objectWithoutProperties(props, EditableGridPanelForUpdate_excluded);
  const id = loader.id;
  const [models, setModels] = (0,external_react_.useState)(() => ({
    dataModel: new QueryModel({
      id,
      schemaQuery: queryModel.schemaQuery
    }),
    editorModel: new EditorModel({
      id
    })
  }));
  const [error, setError] = (0,external_react_.useState)();
  const [isSubmitting, setIsSubmitting] = (0,external_react_.useState)(false);
  const [comment, setComment] = (0,external_react_.useState)();
  const {
    requiresUserComment
  } = useDataChangeCommentsRequired();
  const hasValidUserComment = comment?.trim()?.length > 0;
  const notPermittedText = (0,external_react_.useMemo)(() => getOperationNotPermittedMessage(editStatusData, singularNoun, pluralNoun), [editStatusData, singularNoun, pluralNoun]);
  (0,external_react_.useEffect)(() => {
    (async () => {
      try {
        const models_ = await initEditableGridModel(models.dataModel, models.editorModel, loader, queryModel);
        setModels(models_);
      } catch (e) {
        console.error(e);
        setError(resolveErrorMessage(e) ?? 'Failed to initialize editable grid.');
      }
    })();
  }, []);
  const onGridChange = (0,external_react_.useCallback)((event, editorModelChanges, dataKeys, data, index = 0) => {
    setModels(_models => {
      const {
        dataModels,
        editorModels
      } = applyEditableGridChangesToModels([_models.dataModel], [_models.editorModel], editorModelChanges, undefined, dataKeys, data, index);
      const [dataModel] = dataModels;
      const [editorModel] = editorModels;
      return {
        dataModel,
        editorModel
      };
    });
    if (EditorModel.isDataChangeEvent(event)) {
      setIsDirty?.(true);
    }
  }, [setIsDirty]);
  const onSubmit = (0,external_react_.useCallback)(async () => {
    const gridData = getUpdatedDataFromEditableGrid([models.dataModel], [models.editorModel], idField, selectionData);
    if (!gridData) {
      onComplete();
      return;
    }
    setIsSubmitting(true);
    try {
      await updateRows(gridData.schemaQuery, gridData.updatedRows, comment, gridData.originalRows);
      setIsSubmitting(false);
      onComplete();
    } catch (e) {
      setError(e?.exception ?? 'There was a problem updating the ' + singularNoun + ' data.');
      setIsSubmitting(false);
      document.querySelector('#' + ERROR_ALERT_ID)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [comment, models, idField, onComplete, selectionData, singularNoun, updateRows]);
  const onCommentChange = (0,external_react_.useCallback)(_comment => {
    setComment(_comment);
  }, []);
  const columnMetadata = (0,external_react_.useMemo)(() => getUniqueIdColumnMetadata(models.dataModel.queryInfo), [models.dataModel.queryInfo]);
  if (models.dataModel.isLoading) {
    return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, notPermittedText && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning"
  }, notPermittedText), /*#__PURE__*/external_react_default().createElement(EditableGridPanel, EditableGridPanelForUpdate_extends({
    allowAdd: false,
    allowRemove: false,
    bordered: true,
    bsStyle: "info",
    striped: true,
    title: `Edit selected ${pluralNoun}`
  }, editableGridProps, {
    columnMetadata: columnMetadata,
    editorModel: models.editorModel,
    forUpdate: true,
    model: models.dataModel,
    onChange: onGridChange
  })), /*#__PURE__*/external_react_default().createElement(Alert, {
    id: ERROR_ALERT_ID
  }, error), /*#__PURE__*/external_react_default().createElement(WizardNavButtons, {
    cancel: onCancel,
    canFinish: getIsDirty?.() && (!requiresUserComment || hasValidUserComment),
    nextStep: onSubmit,
    finish: true,
    isFinishing: isSubmitting,
    isFinishingText: "Updating...",
    isFinishedText: "Finished Updating",
    finishText: 'Finish Updating ' + models.dataModel.orderedRows.length + ' ' + (models.dataModel.orderedRows.length === 1 ? capitalizeFirstChar(singularNoun) : capitalizeFirstChar(pluralNoun))
  }, /*#__PURE__*/external_react_default().createElement(CommentTextArea, {
    actionName: "Update",
    containerClassName: "inline-comment",
    onChange: onCommentChange,
    requiresUserComment: requiresUserComment,
    inline: true
  })));
};
EditableGridPanelForUpdate.defaultProps = {
  singularNoun: 'row',
  pluralNoun: 'rows'
};
;// CONCATENATED MODULE: ./src/internal/components/editable/EditableGridLoaderFromSelection.tsx
function EditableGridLoaderFromSelection_defineProperty(e, r, t) { return (r = EditableGridLoaderFromSelection_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function EditableGridLoaderFromSelection_toPropertyKey(t) { var i = EditableGridLoaderFromSelection_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function EditableGridLoaderFromSelection_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



class EditableGridLoaderFromSelection {
  constructor(id, queryInfo, updateData, requiredColumns, omittedColumns, columns, idsNotToUpdate, fieldsNotToUpdate, idsNotPermitted) {
    EditableGridLoaderFromSelection_defineProperty(this, "columns", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "id", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "idsNotPermitted", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "idsNotToUpdate", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "fieldsNotToUpdate", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "mode", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "model", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "omittedColumns", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "queryInfo", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "requiredColumns", void 0);
    EditableGridLoaderFromSelection_defineProperty(this, "updateData", void 0);
    this.columns = columns;
    this.id = id;
    this.mode = EditorMode.Update;
    this.queryInfo = queryInfo;
    this.updateData = updateData || {};
    this.requiredColumns = requiredColumns || [];
    this.omittedColumns = omittedColumns || [];
    this.idsNotToUpdate = idsNotToUpdate || [];
    this.fieldsNotToUpdate = fieldsNotToUpdate || [];
    this.idsNotPermitted = idsNotPermitted || [];
  }
  async fetch(queryModel) {
    const {
      queryName,
      queryParameters,
      schemaName,
      sortString,
      viewName
    } = queryModel;
    const selectedIds = queryModel.getSelectedIds(this.idsNotPermitted);
    const {
      data,
      dataIds
    } = await getSelectedData(schemaName, queryName, selectedIds, queryModel.getRequestColumnsString(this.requiredColumns, this.omittedColumns, true), sortString, queryParameters, viewName);
    return {
      data: EditorModel.convertQueryDataToEditorData(data, (0,external_immutable_.Map)(this.updateData), this.idsNotToUpdate, this.fieldsNotToUpdate),
      dataIds
    };
  }
}
;// CONCATENATED MODULE: ./src/internal/renderers/AliasRenderer.tsx
function AliasRenderer_defineProperty(e, r, t) { return (r = AliasRenderer_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function AliasRenderer_toPropertyKey(t) { var i = AliasRenderer_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function AliasRenderer_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const DETAIL_ALIAS_WORD_LENGTH = 5;
const GRID_ALIAS_WORD_LENGTH = 3;
class AliasRenderer extends (external_react_default()).Component {
  constructor(...args) {
    super(...args);
    AliasRenderer_defineProperty(this, "state", {
      showMore: false
    });
    AliasRenderer_defineProperty(this, "handleClick", () => {
      this.setState(state => ({
        showMore: !state.showMore
      }));
    });
  }
  render() {
    const {
      data,
      view
    } = this.props;
    const {
      showMore
    } = this.state;
    if (data?.size > 0) {
      const truncationLength = view === 'detail' ? DETAIL_ALIAS_WORD_LENGTH : GRID_ALIAS_WORD_LENGTH;
      const extraCount = data.size - truncationLength;
      const aliases = data.map(alias => alias.get('displayValue'));
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "alias-renderer",
        title: aliases.join(', ')
      }, aliases.filter((alias, i) => i < truncationLength || showMore).join(', '), extraCount > 0 && /*#__PURE__*/external_react_default().createElement("span", null, !showMore ? `... and ${extraCount} more ` : ' ', /*#__PURE__*/external_react_default().createElement("span", {
        className: "alias-renderer--more-link",
        onClick: this.handleClick
      }, !showMore ? '(see all)' : '(see less)')));
    }
    return null;
  }
}
AliasRenderer_defineProperty(AliasRenderer, "getEditableRawValue", values => {
  return values.reduce((arr, vd) => {
    if (vd.display !== undefined && vd.display !== null) {
      arr.push(vd.display);
    }
    return arr;
  }, []);
});
;// CONCATENATED MODULE: ./src/internal/renderers/AncestorRenderer.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



const ANCESTOR_LOOKUP_CONCEPT_URI = 'http://www.labkey.org/types#ancestorLookup';
const AncestorRenderer = (0,external_react_.memo)(({
  data
}) => {
  if (external_immutable_.Map.isMap(data) && data.size > 0) {
    const {
      displayValue,
      value
    } = data.toJS();
    if (value < 0 && displayValue) {
      return /*#__PURE__*/external_react_default().createElement("span", {
        className: "text-muted",
        title: `There are ${-value} ancestors of this type.`
      }, displayValue);
    }
    return /*#__PURE__*/external_react_default().createElement(DefaultRenderer, {
      data: data
    });
  }
  return null;
});
;// CONCATENATED MODULE: ./src/internal/renderers/StorageStatusRenderer.tsx

class StorageStatusRenderer extends (external_react_default()).PureComponent {
  render() {
    const {
      data
    } = this.props;
    if (!data) return null;
    const value = data.get('value');
    if (value?.toLowerCase() === 'not in storage' || value?.toLowerCase() === 'discarded') {
      return /*#__PURE__*/external_react_default().createElement("span", null, value);
    } else {
      return /*#__PURE__*/external_react_default().createElement("a", {
        href: data.get('url')
      }, value);
    }
  }
}
;// CONCATENATED MODULE: ./src/internal/renderers/StoredAmountRenderer.tsx
function StoredAmountRenderer_defineProperty(e, r, t) { return (r = StoredAmountRenderer_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function StoredAmountRenderer_toPropertyKey(t) { var i = StoredAmountRenderer_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function StoredAmountRenderer_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class StoredAmountRenderer extends (external_react_default()).PureComponent {
  render() {
    return /*#__PURE__*/external_react_default().createElement(DefaultRenderer, {
      data: this.props.data
    });
  }
}
StoredAmountRenderer_defineProperty(StoredAmountRenderer, "getEditableRawValue", values => {
  return values.size === 1 ? values.first()?.display : undefined;
});
StoredAmountRenderer_defineProperty(StoredAmountRenderer, "getOriginalRawValue", values => {
  if (!external_immutable_.List.isList(values)) return values;
  return external_immutable_.Map.isMap(values.get(0)) ? values.get(0).get('displayValue') : values.get(0).displayValue;
});
;// CONCATENATED MODULE: ./src/internal/renderers/SampleStatusRenderer.tsx



class SampleStatusRenderer extends (external_react_default()).PureComponent {
  render() {
    const {
      row
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement(SampleStatusTag, {
      status: getSampleStatus(row.toJS())
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/renderers/ExpirationDateColumnRenderer.tsx




const ExpirationDateColumnRenderer = (0,external_react_.memo)(({
  data,
  columnIndex,
  col,
  tableCell
}) => {
  let expired = false;
  let displayValue = null;
  let value = null;
  if (data) {
    if (external_immutable_.Iterable.isIterable(data)) {
      value = data.get('value');
      displayValue = data.get('formattedValue') ?? data.get('displayValue');
    } else if (data['value']) {
      value = data['value'];
      displayValue = data['formattedValue'] ?? data['displayValue'];
    }
    displayValue = displayValue ?? value;
  }
  if (value) expired = isDateTimeInPast(value);
  if (tableCell) {
    return /*#__PURE__*/external_react_default().createElement("td", {
      key: columnIndex ?? col?.name,
      className: external_classnames_default()({
        'expired-grid-cell': expired
      }),
      style: {
        textAlign: col?.align || 'left'
      }
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()({
        'expired-grid-cell-content': expired
      })
    }, displayValue));
  }
  return /*#__PURE__*/external_react_default().createElement("span", {
    className: external_classnames_default()({
      'expired-form-field': expired
    })
  }, displayValue);
});
ExpirationDateColumnRenderer.defaultProps = {
  tableCell: true
};
;// CONCATENATED MODULE: ./src/internal/renderers/AppendUnits.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class AppendUnits extends (external_react_default()).Component {
  render() {
    const {
      data,
      col
    } = this.props;
    // ToDo: adhere to formatting?

    if (data && data.get('value')) {
      return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", null, data.get('value') + ' ' + col.units));
    }
    return null;
  }
}
;// CONCATENATED MODULE: ./src/internal/renderers/LabelColorRenderer.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


class LabelColorRenderer extends external_react_.PureComponent {
  render() {
    const {
      data
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement(ColorIcon, {
      value: data?.get('value')
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/renderers/NoLinkRenderer.tsx


class NoLinkRenderer extends external_react_.PureComponent {
  render() {
    let {
      data
    } = this.props;
    if (data) data = data.delete("url");
    return /*#__PURE__*/external_react_default().createElement(DefaultRenderer, {
      data: data
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/renderers/UserDetailsRenderer.tsx


const UserDetailsRenderer = (0,external_react_.memo)(({
  data
}) => {
  if (!data) return null;
  const {
    displayValue,
    value
  } = data.toJS();
  return /*#__PURE__*/external_react_default().createElement(UserLink, {
    userId: value,
    userDisplayValue: displayValue
  });
});
;// CONCATENATED MODULE: ./src/internal/renderers/ImportAliasRenderer.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




// export for jest testing
const ImportAliasRenderer = (0,external_react_.memo)(props => {
  const {
    appRouteMap,
    data
  } = props;
  const aliasMap = data?.get('displayValue');
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, aliasMap?.keySeq().sort().map(key => {
    const splitIndex = aliasMap.get(key).indexOf('/');
    if (splitIndex === -1) return null;
    const route = appRouteMap[aliasMap.get(key).substring(0, splitIndex + 1)];
    const value = aliasMap.get(key).substring(splitIndex + 1);
    return /*#__PURE__*/external_react_default().createElement("div", {
      key: key
    }, key, " (Alias for:\xA0", /*#__PURE__*/external_react_default().createElement("a", {
      key: key,
      href: AppURL.create(route, value).toHref()
    }, value), ")");
  }));
});
const SampleTypeImportAliasRenderer = (0,external_react_.memo)(props => {
  const appRouteMap = (0,external_react_.useMemo)(() => ({
    [SAMPLE_SET_IMPORT_PREFIX]: SAMPLES_KEY
  }), []);
  return /*#__PURE__*/external_react_default().createElement(ImportAliasRenderer, {
    appRouteMap: appRouteMap,
    data: props.data
  });
});
const SourceTypeImportAliasRenderer = (0,external_react_.memo)(props => {
  const appRouteMap = (0,external_react_.useMemo)(() => ({
    [DATA_CLASS_IMPORT_PREFIX]: SOURCES_KEY
  }), []);
  return /*#__PURE__*/external_react_default().createElement(ImportAliasRenderer, {
    appRouteMap: appRouteMap,
    data: props.data
  });
});
;// CONCATENATED MODULE: ./src/internal/components/forms/BulkUpdateForm.tsx
function BulkUpdateForm_defineProperty(e, r, t) { return (r = BulkUpdateForm_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function BulkUpdateForm_toPropertyKey(t) { var i = BulkUpdateForm_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function BulkUpdateForm_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







function isUpdateModel(fn) {
  return fn.length === 1; // UpdateModel has only one parameter
}
class BulkUpdateForm extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    BulkUpdateForm_defineProperty(this, "componentDidMount", async () => {
      const {
        onCancel,
        pluralNoun,
        queryInfo,
        readOnlyColumns,
        selectedIds,
        sortString,
        viewName,
        requiredColumns
      } = this.props;
      const {
        schemaName,
        name
      } = queryInfo;
      const columns = queryInfo.getPkCols().concat(queryInfo.getUpdateColumns(readOnlyColumns)).map(c => c.fieldKey).concat(requiredColumns);
      try {
        const {
          data,
          dataIds
        } = await getSelectedData(schemaName, name, selectedIds, columns, sortString, undefined, viewName);
        const mappedData = this.mapDataForDisplayFields(data);
        this.setState({
          containerPaths: mappedData.containerPaths,
          originalDataForSelection: data,
          dataForSelection: mappedData.data,
          displayFieldUpdates: mappedData.bulkUpdates,
          dataIdsForSelection: dataIds,
          isLoadingDataForSelection: false
        });
      } catch (reason) {
        console.error(reason);
        this.props.onError?.('There was a problem loading the data for the selected ' + pluralNoun + '.');
        onCancel();
      }
    });
    BulkUpdateForm_defineProperty(this, "columnFilter", col => {
      const lcUniqueFieldKey = this.props.uniqueFieldKey?.toLowerCase();
      return col.isUpdateColumn && (!lcUniqueFieldKey || col.name.toLowerCase() !== lcUniqueFieldKey);
    });
    BulkUpdateForm_defineProperty(this, "onSubmit", (data, comment) => {
      const {
        queryInfo,
        updateRows
      } = this.props;
      const {
        displayFieldUpdates
      } = this.state;
      const updateData = displayFieldUpdates.merge(data);
      if (isUpdateModel(updateRows)) {
        return updateRows(updateData);
      }
      const rows = !api_.Utils.isEmptyObj(data) ? getUpdatedData(this.state.originalDataForSelection, updateData, queryInfo.pkCols, queryInfo.altUpdateKeys) : [];
      return updateRows(queryInfo.schemaQuery, rows, comment);
    });
    BulkUpdateForm_defineProperty(this, "onSubmitForEdit", (updateData, comment) => {
      const {
        dataForSelection,
        dataIdsForSelection
      } = this.state;
      return this.props.onSubmitForEdit(updateData, dataForSelection, dataIdsForSelection, comment);
    });
    this.state = {
      containerPaths: undefined,
      dataForSelection: undefined,
      dataIdsForSelection: undefined,
      displayFieldUpdates: {},
      isLoadingDataForSelection: true,
      originalDataForSelection: undefined
    };
  }
  mapDataForDisplayFields(data) {
    const {
      displayValueFields
    } = this.props;
    let updates = (0,external_immutable_.Map)();
    let bulkUpdates = (0,external_immutable_.OrderedMap)();
    const containerPaths = new Set();
    let conflictKeys = new Set();
    data.forEach((rowData, id) => {
      if (rowData) {
        const containerPath = caseInsensitive(rowData.toJS(), 'Folder') ?? caseInsensitive(rowData.toJS(), 'Container');
        if (containerPath?.value) containerPaths.add(containerPath.value);
        if (displayValueFields) {
          let updatedRow = (0,external_immutable_.Map)();
          rowData.forEach((field, key) => {
            if (displayValueFields.includes(key)) {
              const valuesDiffer = field.has('displayValue') && field.get('value') !== field.get('displayValue');
              let comparisonValue = field.get('displayValue') ?? field.get('value');
              if (comparisonValue) comparisonValue += ''; // force to string
              if (!conflictKeys.has(key)) {
                if (!bulkUpdates.has(key)) {
                  bulkUpdates = bulkUpdates.set(key, comparisonValue);
                } else if (bulkUpdates.get(key) !== comparisonValue) {
                  bulkUpdates = bulkUpdates.remove(key);
                  conflictKeys = conflictKeys.add(key);
                }
              }
              if (valuesDiffer) {
                field = field.set('value', comparisonValue);
              }
            }
            updatedRow = updatedRow.set(key, field);
          });
          if (!updatedRow.isEmpty()) {
            updates = updates.set(id, updatedRow);
          }
        }
      }
    });
    if (!updates.isEmpty()) {
      return {
        data: data.merge(updates),
        bulkUpdates,
        containerPaths: Array.from(containerPaths)
      };
    }
    return {
      data,
      bulkUpdates,
      containerPaths: Array.from(containerPaths)
    };
  }
  getSelectionCount() {
    return this.props.selectedIds.length;
  }
  getSelectionNoun() {
    const {
      singularNoun,
      pluralNoun
    } = this.props;
    return this.getSelectionCount() === 1 ? singularNoun.toLowerCase() : pluralNoun.toLowerCase();
  }
  getTitle() {
    const {
      itemLabel
    } = this.props;
    const prefix = 'Update ' + this.getSelectionCount() + ' ' + this.getSelectionNoun();
    return itemLabel ? prefix + " selected from '" + this.props.itemLabel + "'" : prefix;
  }
  renderBulkUpdateHeader() {
    const {
      header
    } = this.props;
    if (!header) return null;
    const noun = this.getSelectionNoun();
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, "Make changes to the selected ", noun, ". Enable a field to update or remove the value for the selected ", noun, "."), this.getSelectionCount() > 1 && /*#__PURE__*/external_react_default().createElement("p", null, "To update individual ", noun, " in this selection group, select \"Edit with Grid\".")), header);
  }
  render() {
    const {
      isLoadingDataForSelection,
      dataForSelection,
      containerPaths
    } = this.state;
    const {
      containerFilter,
      onCancel,
      onComplete,
      pluralNoun,
      queryFilters,
      queryInfo,
      onAdditionalFormDataChange,
      disabled,
      includeCommentField,
      onSubmitForEdit
    } = this.props;
    const fieldValues = isLoadingDataForSelection || !dataForSelection ? undefined : getCommonDataValues(dataForSelection);

    // if all selectedIds are from the same containerPath, use that for the lookups via QueryFormInputs > QuerySelect,
    // if selections are from multiple containerPaths, disable the lookup and file field inputs
    const containerPath = containerPaths?.length === 1 ? containerPaths[0] : undefined;
    const preventCrossFolderEnable = containerPaths?.length > 1;
    const _onSubmitForEdit = onSubmitForEdit ? this.onSubmitForEdit : undefined;
    return /*#__PURE__*/external_react_default().createElement(QueryInfoForm, {
      allowFieldDisable: true,
      asModal: true,
      checkRequiredFields: false,
      columnFilter: this.columnFilter,
      containerFilter: containerFilter,
      containerPath: containerPath,
      disabled: disabled,
      preventCrossFolderEnable: preventCrossFolderEnable,
      fieldValues: fieldValues,
      header: this.renderBulkUpdateHeader(),
      includeCommentField: includeCommentField,
      includeCountField: false,
      initiallyDisableFields: true,
      isLoading: isLoadingDataForSelection,
      onHide: onCancel,
      operation: Operation.update,
      onSubmitForEdit: _onSubmitForEdit,
      onSubmit: this.onSubmit,
      onSuccess: onComplete,
      renderFileInputs: true,
      queryInfo: queryInfo,
      queryFilters: queryFilters,
      showLabelAsterisk: true,
      submitForEditText: "Edit with Grid",
      submitText: `Update ${capitalizeFirstChar(pluralNoun)}`,
      pluralNoun: pluralNoun,
      title: this.getTitle(),
      onAdditionalFormDataChange: onAdditionalFormDataChange
    });
  }
}
BulkUpdateForm_defineProperty(BulkUpdateForm, "defaultProps", {
  pluralNoun: 'rows',
  singularNoun: 'row',
  includeCommentField: true
});
;// CONCATENATED MODULE: ./src/internal/components/forms/input/LookupSelectInput.tsx
function LookupSelectInput_extends() { return LookupSelectInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, LookupSelectInput_extends.apply(null, arguments); }
function LookupSelectInput_defineProperty(e, r, t) { return (r = LookupSelectInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LookupSelectInput_toPropertyKey(t) { var i = LookupSelectInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LookupSelectInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










function formatLookupSelectInputOptions(lookup, models, doSort = true) {
  if (!models) {
    return [];
  }
  const mappedModel = models.map(model => {
    let fieldKey = lookup.displayColumn;
    if (fieldKey.indexOf('/') > -1) {
      fieldKey = fieldKey.substr(fieldKey.indexOf('/') + 1);
    }
    return {
      label: model.getIn([fieldKey, 'formattedValue']) || model.getIn([fieldKey, 'displayValue']) || model.getIn([fieldKey, 'value']),
      value: model.getIn([lookup.keyColumn, 'value'])
    };
  });
  if (doSort) return mappedModel.sortBy(model => model.label, naturalSort).toArray();else return mappedModel.toArray();
}
class LookupSelectInput extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);

    // require our own id here so the <LabelOverlay> can be associated correctly
    LookupSelectInput_defineProperty(this, "_id", void 0);
    this._id = generateId('select-');
    this.state = {
      isLoading: false,
      options: this.getOptionsFromSelectedRows(props.selectedRows)
    };
  }
  componentDidMount() {
    if (!this.state.options && !this.state.isLoading) {
      this.loadOptions();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      selectedRows
    } = this.props;
    if (prevProps.selectedRows !== selectedRows) {
      this.setState({
        isLoading: false,
        options: this.getOptionsFromSelectedRows(selectedRows)
      });
    }
  }
  getOptionsFromSelectedRows(selectedRows) {
    if (!selectedRows) return undefined;
    const {
      queryColumn,
      sort
    } = this.props;
    const models = (0,external_immutable_.Map)((0,external_immutable_.fromJS)(selectedRows.models));
    const {
      schemaName,
      queryName
    } = queryColumn.lookup;
    return formatLookupSelectInputOptions(queryColumn.lookup, models.get(resolveKey(schemaName, queryName)), sort === undefined);
  }
  loadOptions() {
    const {
      containerFilter,
      containerPath,
      filterArray,
      queryColumn,
      sort
    } = this.props;
    if (!queryColumn || !queryColumn.isLookup()) {
      throw 'querygrid forms/input/<LookupSelectInput> only works with lookup columns.';
    } else if (queryColumn.displayAsLookup === false) {
      console.warn('querygrid forms/input/<LookupSelectInput> received lookup column that is explicitly set displayAsLookup = false');
    }
    this.setState({
      isLoading: true
    });
    const {
      schemaName,
      queryName
    } = queryColumn.lookup;
    // using Details view name to assure we get values even when the default view is filtered.
    selectRowsDeprecated({
      containerFilter,
      containerPath,
      schemaName,
      queryName,
      viewName: ViewInfo.DETAIL_NAME,
      filterArray,
      sort
    }).then(response => {
      this.setState({
        isLoading: false,
        options: this.getOptionsFromSelectedRows(response)
      });
    }).catch(() => {
      this.setState({
        isLoading: false,
        options: []
      });
    });
  }
  render() {
    const {
      queryColumn,
      value
    } = this.props;
    const {
      options
    } = this.state;
    if (!options) {
      return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
    }

    // if multiValued = 'junction', the select should support MultiSelect and the value should be joined as an array of strings
    // !Except for the faked up parent column (DataInputs/<DataClassName> in Insert.tsx) where a comma separated string is required
    const multiple = queryColumn.isJunctionLookup(),
      joinValues = multiple && !queryColumn.isDataInput(),
      id = this._id;
    const inputProps = Object.assign({
      // properties that can be overridden
      id,
      label: /*#__PURE__*/external_react_default().createElement(LabelOverlay, {
        column: queryColumn,
        inputId: id,
        isFormsy: false
      }),
      multiple,
      name: queryColumn.fieldKey,
      required: queryColumn.required
    }, this.props, {
      // properties that cannot be changed
      joinValues,
      options,
      // If joinValues is true, and a value is present ensure value is passed in as an Array<string>
      value: joinValues && value && !Array.isArray(value) ? [value] : value
    });
    return /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, LookupSelectInput_extends({}, inputProps, {
      options: options
    }));
  }
}
// EXTERNAL MODULE: external "react-dom/test-utils"
var test_utils_ = __webpack_require__(359);
// EXTERNAL MODULE: external "enzyme"
var external_enzyme_ = __webpack_require__(312);
// EXTERNAL MODULE: external "react-beautiful-dnd"
var external_react_beautiful_dnd_ = __webpack_require__(302);
;// CONCATENATED MODULE: ./src/internal/components/labelPrinting/utils.ts
function userCanPrintLabels(user) {
  return user && !user.isGuest;
}
;// CONCATENATED MODULE: ./src/internal/components/labelPrinting/LabelPrintingContextProvider.tsx






const LabelPrintingContextProvider_Context = external_react_default().createContext(undefined);
const useLabelPrintingContext = () => {
  return (0,external_react_.useContext)(LabelPrintingContextProvider_Context);
};
const LabelPrintingContextProvider = (0,external_react_.memo)(props => {
  const {
    children,
    initialContext
  } = props;
  const {
    moduleContext,
    user
  } = useServerContext();
  const {
    api
  } = useAppContext();
  const [labelContext, setLabelContext] = (0,external_react_.useState)(() => ({
    canPrintLabels: userCanPrintLabels(user),
    defaultLabel: initialContext?.defaultLabel,
    printServiceUrl: initialContext?.printServiceUrl
  }));
  (0,external_react_.useEffect)(() => {
    if (!userCanPrintLabels(user) || !isSampleManagerEnabled(moduleContext)) return;
    (async () => {
      try {
        const [btConfiguration, templates] = await Promise.all([api.labelprinting.fetchBarTenderConfiguration(), api.labelprinting.ensureLabelTemplatesList(user)]);
        setLabelContext({
          canPrintLabels: !!btConfiguration.serviceURL && templates?.length > 0,
          defaultLabel: btConfiguration.defaultLabel,
          printServiceUrl: btConfiguration.serviceURL
        });
      } catch (e) {
        setLabelContext({
          canPrintLabels: false,
          defaultLabel: undefined,
          error: `Failed to initialize label printing context: "${resolveErrorMessage(e) ?? 'Unknown error'}"`,
          printServiceUrl: undefined
        });
      }
    })();
  }, [api, moduleContext, user]);
  return /*#__PURE__*/external_react_default().createElement(LabelPrintingContextProvider_Context.Provider, {
    value: labelContext
  }, children);
});
;// CONCATENATED MODULE: ./src/internal/components/navigation/NavigationContext.ts

/**
 * Configures navigation context for the global state context.
 * NK: The reason this is declared in a separate file from hook.ts is to avoid circular dependencies.
 */
const useNavigationContextState = () => {
  // FolderMenuGlobalContext
  const [key, setKey] = (0,external_react_.useState)(0);
  const reload = (0,external_react_.useCallback)(() => {
    setKey(key_ => (key_ + 1) % 2);
  }, []);
  const folderMenuContext = (0,external_react_.useMemo)(() => ({
    key,
    reload
  }), [key, reload]);

  // SubNavGlobalContext
  const [noun, setNoun] = (0,external_react_.useState)(undefined);
  const [tabs, setTabs] = (0,external_react_.useState)([]);
  const clearNav = (0,external_react_.useCallback)(() => {
    setNoun(undefined);
    setTabs([]);
  }, []);
  const subNavContext = (0,external_react_.useMemo)(() => ({
    clearNav,
    noun,
    setNoun,
    setTabs,
    tabs
  }), [clearNav, noun, tabs]);
  return (0,external_react_.useMemo)(() => ({
    folderMenu: folderMenuContext,
    subNav: subNavContext
  }), [folderMenuContext, subNavContext]);
};
;// CONCATENATED MODULE: ./src/internal/GlobalStateContext.tsx
function GlobalStateContext_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GlobalStateContext_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GlobalStateContext_ownKeys(Object(t), !0).forEach(function (r) { GlobalStateContext_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GlobalStateContext_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function GlobalStateContext_defineProperty(e, r, t) { return (r = GlobalStateContext_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function GlobalStateContext_toPropertyKey(t) { var i = GlobalStateContext_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function GlobalStateContext_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


const GlobalStateContext_Context = (0,external_react_.createContext)(undefined);
/**
 * GlobalStateContext is a context for our apps that allows for persistence and mutations of global
 * (application-wide) context. This context is intended to be used for persisting state/actions that are useful
 * throughout the component hierarchy. This prevents the need for "prop drilling" these types of state/actions down
 * to individual components in the hierarchy through parent components that otherwise do not need this context.
 * That said, if you're looking to add to the GlobalStateContext please be sure that having your state/actions at this
 * level is useful across the application. You should NOT add your state/actions to GlobalStateContext if the
 * state/actions are only used/called within a localized component hierarchy. In that case use either component state
 * and pass it down or use a page-level context instead.
 *
 * If you're extending this context please review the context properties already in place as there may be an existing
 * namespace in this context that is most appropriate. Otherwise, another top-level property can be added.
 */
function GlobalStateContextProvider({
  children,
  initialContext
}) {
  const navigation = useNavigationContextState();
  const value = (0,external_react_.useMemo)(() => GlobalStateContext_objectSpread({
    navigation
  }, initialContext), [initialContext, navigation]);
  return /*#__PURE__*/external_react_default().createElement(GlobalStateContext_Context.Provider, {
    value: value
  }, children);
}
function useGlobalStateContext() {
  const context = (0,external_react_.useContext)(GlobalStateContext_Context);
  if (context === undefined) {
    throw new Error('useGlobalStateContext must be used within GlobalStateContext.Provider');
  }
  return context;
}
;// CONCATENATED MODULE: ./src/internal/test/testHelpers.tsx
function testHelpers_extends() { return testHelpers_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, testHelpers_extends.apply(null, arguments); }
function testHelpers_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function testHelpers_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? testHelpers_ownKeys(Object(t), !0).forEach(function (r) { testHelpers_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : testHelpers_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function testHelpers_defineProperty(e, r, t) { return (r = testHelpers_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function testHelpers_toPropertyKey(t) { var i = testHelpers_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function testHelpers_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }













const AppContextTestProvider = props => {
  const {
    appContext,
    children,
    serverContext = {},
    notificationContext,
    printLabelsContext
  } = props;
  const initialAppContext = (0,external_react_.useMemo)(() => testHelpers_objectSpread({
    api: getTestAPIWrapper()
  }, appContext), [appContext]);
  return /*#__PURE__*/external_react_default().createElement(ServerContextProvider, {
    initialContext: serverContext
  }, /*#__PURE__*/external_react_default().createElement(AppContextProvider, {
    initialContext: initialAppContext
  }, /*#__PURE__*/external_react_default().createElement(GlobalStateContextProvider, null, /*#__PURE__*/external_react_default().createElement(NotificationsContextProvider, {
    initialContext: notificationContext
  }, /*#__PURE__*/external_react_default().createElement(LabelPrintingContextProvider, {
    initialContext: printLabelsContext
  }, children)))));
};

/**
 * Instantiates a QueryInfo from a captured query details response payload. Cannot be used until you've called
 * initQueryGridState or initUnitTestMocks.
 * @param getQueryDetailsResponse: getQueryDetails response object (e.g. imported from
 * test/data/mixtures-getQueryDetails.json)
 */
const makeQueryInfo = getQueryDetailsResponse => {
  const queryInfo = applyQueryMetadata(getQueryDetailsResponse);
  return queryInfo.mutate({
    columns: bindColumnRenderers(queryInfo.columns)
  });
};
const parseQueryResponse = getQueryResponse => {
  // Hack: need to stringify and parse the query response object because Query.Response modifies the object in place,
  // which causes errors if you try to use the same response object twice.
  const response = new api_.Query.Response(JSON.parse(JSON.stringify(getQueryResponse)));
  return handleSelectRowsResponse(response, new QueryInfo({}));
};
const makeTestISelectRowsResult = (getQueryResponse, getQueryDetailsResponse) => {
  const partial = parseQueryResponse(getQueryResponse);
  return testHelpers_objectSpread(testHelpers_objectSpread({}, partial), {}, {
    queries: {
      [partial.key]: makeQueryInfo(getQueryDetailsResponse)
    }
  });
};

/**
 * Creates rows and orderedRows objects needed by the QueryModel. Returns a Promise that resolves to an object that
 * looks like: { messages: any, rows: any, orderedRows: string[], rowCount: number }
 * @param getQueryResponse: getQuery Response object (e.g. imported from test/data/mixtures-getQuery.json)
 */
const makeTestData = getQueryResponse => {
  const {
    key,
    messages,
    models,
    orderedModels,
    rowCount
  } = parseQueryResponse(getQueryResponse);
  return {
    messages: messages.toJS(),
    orderedRows: orderedModels[key].toArray(),
    rowCount,
    rows: models[key]
  };
};
function registerDefaultURLMappers() {
  URLService.registerURLMappers(...URL_MAPPERS.ASSAY_MAPPERS, ...URL_MAPPERS.DATA_CLASS_MAPPERS, ...URL_MAPPERS.SAMPLE_TYPE_MAPPERS, ...URL_MAPPERS.LIST_MAPPERS, ...URL_MAPPERS.USER_DETAILS_MAPPERS, URL_MAPPERS.LOOKUP_MAPPER);
}

/**
 * Use this to sleep in the tests. If you make your test methods async you can use "await sleep();" to put your thread
 * to sleep temporarily which will allow async actions in your component to continue.
 * @param ms: the amount of time (in ms) to sleep
 */
const sleep = (ms = 0) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
};
const wrapDraggable = element => {
  return /*#__PURE__*/external_react_default().createElement(external_react_beautiful_dnd_.DragDropContext, {
    onDragEnd: jest.fn()
  }, /*#__PURE__*/external_react_default().createElement(external_react_beautiful_dnd_.Droppable, {
    droppableId: "jest-test-droppable"
  }, provided => /*#__PURE__*/external_react_default().createElement("div", testHelpers_extends({
    ref: provided.innerRef
  }, provided.droppableProps), element, provided.placeholder)));
};
;// CONCATENATED MODULE: ./src/internal/test/enzymeTestHelpers.tsx
function enzymeTestHelpers_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function enzymeTestHelpers_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? enzymeTestHelpers_ownKeys(Object(t), !0).forEach(function (r) { enzymeTestHelpers_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : enzymeTestHelpers_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function enzymeTestHelpers_defineProperty(e, r, t) { return (r = enzymeTestHelpers_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function enzymeTestHelpers_toPropertyKey(t) { var i = enzymeTestHelpers_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function enzymeTestHelpers_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





/**
 * Use this if you're testing a component that requires a wrapping <AppContextProvider/> to provide context.
 * This utility method provides the `MountRenderProps` that can be supplied to enzyme's mount() method. The specified
 * `appContext` will be provided to the wrapped component under test. Additionally, with these options supplied
 * the returned mounted component will still be the component under test (as opposed to <AppContextProvider/>).
 * @param appContext The app context to be provided by the wrapping <AppContextProvider/>.
 * @param serverContext The server context to be provided by the wrapping <ServerContextProvider/>.
 * @param notificationContext The notification context to be provided by the wrapping <NotificationProvider/>.
 * @param options Pass through for mount's rendering options.
 * @param printLabelsContext The server context to be provided by the wrapping <PrintLabelsContext/>.
 */
const mountWithAppServerContextOptions = (appContext, serverContext, notificationContext, options, printLabelsContext) => {
  return enzymeTestHelpers_objectSpread({
    wrappingComponent: AppContextTestProvider,
    wrappingComponentProps: {
      appContext,
      serverContext,
      notificationContext,
      printLabelsContext
    }
  }, options);
};

/**
 * Use this if you're testing a component that requires a wrapping <AppContextProvider/> to provide context.
 * This test method wraps enzyme's mount() method and provides the wrapping component with "initialContext".
 * With this the returned mounted component will still be the component under test
 * (as opposed to <AppContextProvider/>).
 * @param node The React node to mount
 * @param appContext an optional app context object to mount
 * @param serverContext an optional server context object to mount
 * @param notificationContext an optional notification context object to mount
 * @param options Pass through for mount's rendering options
 * @param printLabelsContext an optional label printing context object to mount
 */
const mountWithAppServerContext = (node, appContext, serverContext, notificationContext, options, printLabelsContext) => {
  return (0,external_enzyme_.mount)(node, mountWithAppServerContextOptions(appContext, serverContext, notificationContext, options, printLabelsContext));
};

/**
 * Use this if you're testing a component that requires a wrapping <ServerContextProvider/> to provide context.
 * This utility method provides the `MountRenderProps` that can be supplied to enzyme's mount() method. The specified
 * `initialContext` will be provided to the wrapped component under test. Additionally, with these options supplied
 * the returned mounted component will still be the component under test (as opposed to <ServerContextProvider />).
 * Example:
 * ```ts
 * import { mount } from 'enzyme';
 * import { mountWithServerContextOptions } from '@labkey/components';
 *
 * describe('a test suite', () => {
 *     test('test with default context', () => {
 *         const wrapper = mount(<MyReactComponent />, mountWithServerContextOptions());
 *     });
 *     test('test with specified context, () => {
 *         const wrapper = mount(<MyReactComponent />, mountWithServerContextOptions({
 *             user: MY_TEST_USER,
 *         }));
 *     });
 * });
 * ```
 * @param initialContext The server context to be provided by the wrapping <ServerContextProvider/>
 * @param options Pass through for mount's rendering options
 */
const mountWithServerContextOptions = (initialContext = {}, options) => {
  return enzymeTestHelpers_objectSpread({
    wrappingComponent: ServerContextProvider,
    wrappingComponentProps: {
      initialContext
    }
  }, options);
};

/**
 * Use this if you're testing a component that requires a wrapping <ServerContextProvider/> to provide context.
 * This test method wraps enzyme's mount() method and provides the wrapping component with "initialContext".
 * With this the returned mounted component will still be the component under test
 * (as opposed to <ServerContextProvider />).
 * @param node The React node to mount
 * @param initialContext The server context to be provided by the wrapping <ServerContextProvider/>
 * @param options Pass through for mount's rendering options
 */
const mountWithServerContext = (node, initialContext, options) => {
  return (0,external_enzyme_.mount)(node, mountWithServerContextOptions(initialContext, options));
};

/**
 * Shallow version of mountWithServerContext.
 */
const shallowWithServerContext = (node, initialContext, options) => {
  return shallow(node, mountWithServerContextOptions(initialContext, options));
};

/**
 * If you're testing a react component that uses hooks to load data use this method to flush promises and transition
 * your component to the next part of the lifecycle. Example:
 *      const wrapper = mount(<MyComponentThatLoadsStuff />);
 *      // Loading state is expected
 *      expect(wrapper.find(LOADING_SPINNER).exists()).toEqual(true);
 *      await waitForLifecycle(wrapper);
 *      // Items have been loaded and rendered
 *      expect(wrapper.find('.item').length).toEqual(4);
 * @param wrapper: enzyme ReactWrapper or ShallowWrapper
 * @param ms: the amount of time (in ms) to sleep
 */
const enzymeTestHelpers_waitForLifecycle = (wrapper, ms) => {
  // Wrap in react-dom/utils act so we don't get errors in our test logs
  return (0,test_utils_.act)(async () => {
    await sleep(ms);
    wrapper.update();
  });
};
;// CONCATENATED MODULE: ./src/internal/components/forms/input/SelectInputTestUtils.ts

const SELECT_INPUT_CSS_PREFIX = 'select-input';
const SELECT_INPUT_CONTROL_SELECTOR = (/* unused pure expression or super */ null && (`div.${SELECT_INPUT_CSS_PREFIX}__control`));
const SELECT_INPUT_DROPDOWN_SELECTOR = `div.${SELECT_INPUT_CSS_PREFIX}__dropdown-indicator`;
const SELECT_INPUT_DISABLED_SELECTOR = (/* unused pure expression or super */ null && (`div.${SELECT_INPUT_CSS_PREFIX}--is-disabled`));
const SELECT_INPUT_OPTION_SELECTOR = `div.${SELECT_INPUT_CSS_PREFIX}__option`;
const SELECT_INPUT_PLACEHOLDER_SELECTOR = (/* unused pure expression or super */ null && (`div.${SELECT_INPUT_CSS_PREFIX}__placeholder`));
const SELECT_INPUT_SINGLE_VALUE_SELECTOR = (/* unused pure expression or super */ null && (`div.${SELECT_INPUT_CSS_PREFIX}__single-value`));
async function selectOptionByIndex(component, index) {
  toggleSelectInputMenu(component);
  const options = component.find(SELECT_INPUT_OPTION_SELECTOR);
  if (options.length <= index) {
    throw new Error(`selectOptionByIndex: Invalid index (${index}) supplied. Only ${options.length} options available.`);
  }
  options.at(index).simulate('click');
  await waitForLifecycle(component);
}
async function selectOptionByText(component, text) {
  toggleSelectInputMenu(component);
  const options = component.find(SELECT_INPUT_OPTION_SELECTOR);
  let idx = -1;
  for (let i = 0; i < options.length; i++) {
    if (options.at(i).text().indexOf(text) > -1) {
      if (idx === -1) {
        idx = i;
      } else {
        throw new Error(`selectOptionByText: Invalid text "${text}" supplied. Multiple options contain this text.`);
      }
    }
  }
  if (idx === -1) {
    throw new Error(`selectOptionByText: Unable to find option containing text "${text}".`);
  }
  options.at(idx).simulate('click');
  await enzymeTestHelpers_waitForLifecycle(component);
}
function blurSelectInputInput(component) {
  component.find('input').simulate('blur');
}
function setSelectInputText(component, value, blur = false) {
  const input = component.find('input');
  input.getDOMNode().setAttribute('value', value);
  input.simulate('change', {
    currentTarget: input
  });
  if (blur) {
    blurSelectInputInput(component);
  }
}
function toggleSelectInputMenu(component) {
  component.find(SELECT_INPUT_DROPDOWN_SELECTOR).simulate('mousedown', {
    button: 0
  });
}
// EXTERNAL MODULE: external "react-color"
var external_react_color_ = __webpack_require__(489);
;// CONCATENATED MODULE: ./src/internal/components/forms/input/ColorPickerInput.tsx
function ColorPickerInput_defineProperty(e, r, t) { return (r = ColorPickerInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ColorPickerInput_toPropertyKey(t) { var i = ColorPickerInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ColorPickerInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





class ColorPickerInput extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    ColorPickerInput_defineProperty(this, "state", {
      showPicker: false
    });
    ColorPickerInput_defineProperty(this, "onChange", color => {
      this.props.onChange(this.props.name, color?.hex);
    });
    ColorPickerInput_defineProperty(this, "togglePicker", () => {
      this.setState(state => ({
        showPicker: !state.showPicker
      }));
    });
  }
  render() {
    const {
      colors,
      disabled,
      text,
      value,
      allowRemove
    } = this.props;
    const {
      showPicker
    } = this.state;
    const iconClassName = external_classnames_default()('fa', {
      'fa-caret-up': showPicker,
      'fa-caret-down': !showPicker
    });
    const showChip = text !== undefined;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "color-picker"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      type: "button",
      className: "color-picker__button btn btn-default",
      onClick: this.togglePicker,
      disabled: disabled
    }, text ? text : value ? /*#__PURE__*/external_react_default().createElement(ColorIcon, {
      cls: "color-picker__chip-small",
      asSquare: true,
      value: value
    }) : 'None', /*#__PURE__*/external_react_default().createElement("i", {
      className: iconClassName
    })), showChip && /*#__PURE__*/external_react_default().createElement(ColorIcon, {
      cls: "color-picker__chip",
      asSquare: true,
      value: value
    }), allowRemove && value && !disabled && /*#__PURE__*/external_react_default().createElement(RemoveEntityButton, {
      onClick: () => this.onChange(),
      labelClass: "color-picker__remove"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "color-picker__picker"
    }, showPicker && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "color-picker__mask",
      onClick: this.togglePicker
    }), /*#__PURE__*/external_react_default().createElement(external_react_color_.CompactPicker, {
      onChangeComplete: this.onChange,
      color: value,
      colors: colors
    }))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/forms/PageDetailHeader.tsx
function PageDetailHeader_defineProperty(e, r, t) { return (r = PageDetailHeader_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function PageDetailHeader_toPropertyKey(t) { var i = PageDetailHeader_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function PageDetailHeader_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


class PageDetailHeader extends external_react_.PureComponent {
  render() {
    const {
      children,
      description,
      iconAltText,
      iconUrl,
      iconDir,
      iconSrc,
      leftColumns,
      subTitle,
      title
    } = this.props;
    const hasIcon = iconUrl || iconSrc;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "page-header"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: `col-xs-12 col-md-${leftColumns} detail__header--container`
    }, hasIcon && /*#__PURE__*/external_react_default().createElement("div", {
      className: "detail__header--image-container"
    }, iconUrl ? /*#__PURE__*/external_react_default().createElement("img", {
      src: iconUrl,
      className: "detail__header-icon"
    }) : /*#__PURE__*/external_react_default().createElement(SVGIcon, {
      iconDir: iconDir,
      iconSrc: iconSrc ? iconSrc : '',
      className: "detail__header-icon",
      alt: iconAltText ? iconAltText : ''
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: hasIcon ? 'detail__header-icon--body-container' : ''
    }, /*#__PURE__*/external_react_default().createElement("h2", {
      className: "no-margin-top detail__header--name"
    }, title), subTitle && /*#__PURE__*/external_react_default().createElement("h4", {
      className: "test-loc-detail-subtitle"
    }, subTitle), description && /*#__PURE__*/external_react_default().createElement("span", {
      className: "detail__header--desc"
    }, description))), children && /*#__PURE__*/external_react_default().createElement("div", {
      className: "pull-right"
    }, children), /*#__PURE__*/external_react_default().createElement("div", {
      className: "clearfix"
    }));
  }
}
PageDetailHeader_defineProperty(PageDetailHeader, "defaultProps", {
  leftColumns: 6
});
;// CONCATENATED MODULE: ./src/internal/components/forms/detail/DetailPanelHeader.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const DetailPanelHeader = (0,external_react_.memo)(props => {
  const {
    isEditable,
    editing,
    onClick,
    warning,
    title = 'Details',
    verb = 'Editing'
  } = props;
  if (editing) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-heading"
    }, verb, " ", title, /*#__PURE__*/external_react_default().createElement("span", {
      className: "detail__edit--heading"
    }, warning !== undefined && /*#__PURE__*/external_react_default().createElement("span", null, /*#__PURE__*/external_react_default().createElement("span", null, " - "), /*#__PURE__*/external_react_default().createElement("span", {
      className: "edit__warning"
    }, warning))));
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, title, /*#__PURE__*/external_react_default().createElement("span", {
    className: "detail__edit--heading"
  }, isEditable && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "detail__edit-button",
    onClick: onClick
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-pencil-square-o"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "clearfix"
  }))));
});
DetailPanelHeader.displayName = 'DetailPanelHeader';
;// CONCATENATED MODULE: ./src/internal/renderers/AssayRunReferenceRenderer.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class AssayRunReferenceRenderer extends (external_react_default()).Component {
  render() {
    const {
      data
    } = this.props;
    const displayValue = data && data.size > 0 ? data.get('displayValue') : undefined;
    const value = data && data.size > 0 ? data.get('value') : undefined;
    if (value) {
      let displayStr = 'Run ' + value;
      if (displayValue) {
        displayStr = displayValue + ' (' + displayStr + ')';
      }
      return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("a", {
        href: '#/rd/assayrun/' + value
      }, displayStr));
    }
    return null;
  }
}
;// CONCATENATED MODULE: ./src/internal/components/forms/detail/DetailDisplay.tsx
function DetailDisplay_defineProperty(e, r, t) { return (r = DetailDisplay_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DetailDisplay_toPropertyKey(t) { var i = DetailDisplay_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DetailDisplay_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






























function defaultTitleRenderer(col) {
  // If the column cannot be edited, return the label as is
  if (!col.isEditable()) {
    return /*#__PURE__*/external_react_default().createElement("span", null, col.caption);
  }
  return /*#__PURE__*/external_react_default().createElement(LabelOverlay, {
    column: col,
    required: col.required || col.nameExpression !== undefined /* Issue 43561: Support name expression fields */
  });
}
const _defaultRenderer = col => {
  return data => /*#__PURE__*/external_react_default().createElement(DefaultRenderer, {
    col: col,
    data: data
  });
};
function processFields(queryColumns, detailRenderer, titleRenderer, options, fileInputRenderer, onAdditionalFormDataChange) {
  return queryColumns.reduce((fields, c) => {
    const fieldKey = c.fieldKey.toLowerCase();
    return fields.set(fieldKey, new DetailField({
      fieldKey,
      title: c.caption,
      renderer: detailRenderer?.(c, options, fileInputRenderer, onAdditionalFormDataChange) ?? _defaultRenderer(c),
      titleRenderer: titleRenderer ? titleRenderer(c) : /*#__PURE__*/external_react_default().createElement("span", {
        title: c.fieldKey
      }, c.caption)
    }));
  }, (0,external_immutable_.OrderedMap)());
}
// TODO: export this class and make users import the set of fields or indexes
class DetailField {
  constructor(config) {
    DetailDisplay_defineProperty(this, "fieldKey", void 0);
    DetailDisplay_defineProperty(this, "index", void 0);
    DetailDisplay_defineProperty(this, "title", void 0);
    DetailDisplay_defineProperty(this, "renderer", void 0);
    DetailDisplay_defineProperty(this, "titleRenderer", void 0);
    this.fieldKey = config.fieldKey;
    this.index = config.index;
    this.title = config.title;
    this.renderer = config.renderer;
    this.titleRenderer = config.titleRenderer;
  }
}
const DetailDisplay = (0,external_react_.memo)(props => {
  const {
    asPanel,
    containerFilter,
    containerPath,
    data,
    displayColumns,
    editingMode,
    fileInputRenderer,
    fieldHelpTexts,
    onAdditionalFormDataChange,
    tableCls
  } = props;
  const detailRenderer = (0,external_react_.useMemo)(() => {
    if (editingMode) {
      return props.detailEditRenderer ?? resolveDetailEditRenderer;
    }
    return props.detailRenderer ?? resolveDetailRenderer;
  }, [props.detailRenderer, props.detailEditRenderer, editingMode]);
  const titleRenderer = (0,external_react_.useMemo)(() => {
    return props.titleRenderer ?? (editingMode ? defaultTitleRenderer : undefined);
  }, [props.titleRenderer, editingMode]);
  let body;
  if (data.size === 0) {
    body = /*#__PURE__*/external_react_default().createElement("div", null, "No data available.");
  } else {
    const options = {
      containerFilter,
      containerPath
    };
    if (editingMode) options.hideLabel = true;
    const fields = processFields(displayColumns, detailRenderer, titleRenderer, options, fileInputRenderer, onAdditionalFormDataChange);
    body = /*#__PURE__*/external_react_default().createElement("div", null, data.map((row, i) => {
      // key safety
      const newRow = row.reduce((newRow, value, key) => {
        return newRow.set(key.toLowerCase(), value);
      }, (0,external_immutable_.OrderedMap)());
      return /*#__PURE__*/external_react_default().createElement("table", {
        className: external_classnames_default()(DETAIL_TABLE_CLASSES, tableCls),
        key: i
      }, /*#__PURE__*/external_react_default().createElement("tbody", null, fields.map((field, key) => {
        const labelHelp = fieldHelpTexts?.[key];
        // 'data-caption' tag for test hooks
        return /*#__PURE__*/external_react_default().createElement("tr", {
          key: key
        }, /*#__PURE__*/external_react_default().createElement("td", null, field.titleRenderer, labelHelp && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
          popoverClassName: "detail-display-label-help-tip-popover",
          title: field.title
        }, labelHelp)), /*#__PURE__*/external_react_default().createElement("td", {
          className: "text__wrap",
          "data-caption": field.title,
          "data-fieldkey": field.fieldKey
        }, field.renderer(newRow.get(decodePart(key)) ?? newRow.get(key), row)));
      }).toArray()));
    }));
  }
  if (asPanel) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel panel-default"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-heading"
    }, "Details"), /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-body"
    }, body));
  }
  return body;
});
DetailDisplay.defaultProps = {
  asPanel: false,
  editingMode: false
};
DetailDisplay.displayName = 'DetailDisplay';
function detailNonEditableRenderer(col, data) {
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "field__un-editable"
  }, _defaultRenderer(col)(data));
}
const DETAIL_INPUT_WRAPPER_CLASS_NAME = 'col-sm-12';

// TODO: Merge this functionality with <QueryFormInputs />
function resolveDetailEditRenderer(col, options, fileInputRenderer = detailNonEditableRenderer, onAdditionalFormDataChange) {
  return (data, row) => {
    // If the column cannot be edited, return as soon as possible
    // Render the value with the defaultRenderer and a class that grays it out
    if (!col.isEditable()) {
      return detailNonEditableRenderer(col, data);
    }
    const showLabel = !options?.hideLabel ?? false;
    let value = resolveDetailFieldValue(data);
    const ColumnInputRenderer = resolveInputRenderer(col);
    if (ColumnInputRenderer) {
      return /*#__PURE__*/external_react_default().createElement(ColumnInputRenderer, {
        col: col,
        containerFilter: options?.containerFilter,
        containerPath: options?.containerPath,
        data: row,
        formsy: true,
        inputClass: DETAIL_INPUT_WRAPPER_CLASS_NAME,
        key: col.name,
        onAdditionalFormDataChange: onAdditionalFormDataChange,
        onSelectChange: options?.onSelectChange,
        selectInputProps: {
          inputClass: DETAIL_INPUT_WRAPPER_CLASS_NAME,
          showLabel
        },
        showLabel: showLabel,
        value: value
      });
    }
    if (col.isPublicLookup()) {
      // undefined 'displayAsLookup' just respects the lookup.
      // Must be explicitly false to prevent drop-down.
      if (col.displayAsLookup !== false) {
        // Issue 29232: When displaying a lookup, always use the value
        const multiple = col.isJunctionLookup();
        const joinValues = multiple && !col.isDataInput();
        const queryFilters = col.lookup.hasQueryFilters(Operation.update) ? (0,external_immutable_.List)(col.lookup.getQueryFilters(Operation.update)) : undefined;
        return /*#__PURE__*/external_react_default().createElement(QuerySelect, {
          autoFocus: options?.autoFocus,
          containerFilter: col.lookup.containerFilter ?? options?.containerFilter ?? getContainerFilterForLookups(),
          containerPath: col.lookup.containerPath ?? options?.containerPath,
          description: col.description,
          displayColumn: col.lookup.displayColumn,
          formsy: true,
          inputClass: DETAIL_INPUT_WRAPPER_CLASS_NAME,
          joinValues: joinValues,
          key: col.fieldKey,
          label: col.caption,
          maxRows: 10,
          multiple: multiple,
          name: col.name,
          onBlur: options?.onBlur,
          onQSChange: options?.onSelectChange,
          placeholder: options?.placeholder ?? 'Select or type to search...',
          queryFilters: queryFilters,
          required: col.required,
          schemaQuery: col.lookup.schemaQuery,
          showLabel: showLabel,
          value: value,
          valueColumn: col.lookup.keyColumn
        });
      }
    }
    if (col.validValues) {
      return /*#__PURE__*/external_react_default().createElement(TextChoiceInput, {
        formsy: true,
        inputClass: DETAIL_INPUT_WRAPPER_CLASS_NAME,
        queryColumn: col,
        value: value,
        autoFocus: options?.autoFocus,
        onBlur: options?.onBlur,
        onChange: options?.onSelectChange,
        placeholder: options?.placeholder ?? 'Select or type to search...',
        showLabel: showLabel
      });
    }
    if (col.inputType === 'textarea') {
      return /*#__PURE__*/external_react_default().createElement(TextAreaInput, {
        cols: 4,
        elementWrapperClassName: DETAIL_INPUT_WRAPPER_CLASS_NAME,
        queryColumn: col,
        rows: 4,
        showLabel: showLabel,
        validatePristine: true,
        value: value
      });
    }
    if (col.inputType === 'file') {
      return fileInputRenderer(col, data);
    }
    switch (col.jsonType) {
      case 'boolean':
        return /*#__PURE__*/external_react_default().createElement(CheckboxInput_CheckboxInput, {
          queryColumn: col,
          showLabel: showLabel,
          value: value && value.toString().toLowerCase() === 'true',
          wrapperClassName: DETAIL_INPUT_WRAPPER_CLASS_NAME
        });
      case 'date':
      case 'time':
        if (!value || typeof value === 'string') {
          return /*#__PURE__*/external_react_default().createElement(DatePickerInput, {
            queryColumn: col,
            showLabel: showLabel,
            value: value,
            wrapperClassName: DETAIL_INPUT_WRAPPER_CLASS_NAME,
            initValueFormatted: true
          });
        }
      default:
        let validationError;
        if (col.jsonType === 'int' || col.jsonType === 'float') {
          const unformat = getUnFormattedNumber(value);
          if (unformat !== undefined && unformat !== null) {
            value = unformat.toString();
          }
          validationError = 'Expected type: ' + col.jsonType;
        }
        return /*#__PURE__*/external_react_default().createElement(TextInput_TextInput, {
          elementWrapperClassName: DETAIL_INPUT_WRAPPER_CLASS_NAME,
          queryColumn: col
          // Issue 43561: Support name expression fields
          // NK: If a name expression is applied, then the server does not mark the field as required as
          // it will be generated. This is OK for the insert scenario, however, for update a value is
          // still required as the name expression won't be run upon update. Here we mark the input as
          // required if the nameExpression is not defined to force the form to require a value.
          ,
          required: col.required || col.nameExpression !== undefined,
          showLabel: showLabel,
          validatePristine: true,
          validationError: validationError,
          value: value
        });
    }
  };
}
function resolveDetailRenderer(column) {
  let renderer; // defaults to undefined -- leave it up to the details

  if (column?.detailRenderer) {
    switch (column.detailRenderer.toLowerCase()) {
      case 'multivaluedetailrenderer':
        renderer = d => /*#__PURE__*/external_react_default().createElement(MultiValueRenderer, {
          data: d
        });
        break;
      case 'aliasrenderer':
        renderer = d => /*#__PURE__*/external_react_default().createElement(AliasRenderer, {
          data: d,
          view: "detail"
        });
        break;
      case 'appendunits':
        renderer = d => /*#__PURE__*/external_react_default().createElement(AppendUnits, {
          data: d,
          col: column
        });
        break;
      case 'assayrunreference':
        renderer = d => /*#__PURE__*/external_react_default().createElement(AssayRunReferenceRenderer, {
          data: d
        });
        break;
      case 'labelcolorrenderer':
        renderer = d => /*#__PURE__*/external_react_default().createElement(LabelColorRenderer, {
          data: d
        });
        break;
      case 'filecolumnrenderer':
        renderer = d => /*#__PURE__*/external_react_default().createElement(FileColumnRenderer, {
          data: d,
          col: column
        });
        break;
      case 'nolinkrenderer':
        renderer = d => /*#__PURE__*/external_react_default().createElement(NoLinkRenderer, {
          data: d
        });
        break;
      case 'sampletypeimportaliasrenderer':
        renderer = d => /*#__PURE__*/external_react_default().createElement(SampleTypeImportAliasRenderer, {
          data: d
        });
        break;
      case 'sourcetypeimportaliasrenderer':
        renderer = d => /*#__PURE__*/external_react_default().createElement(SourceTypeImportAliasRenderer, {
          data: d
        });
        break;
      case 'samplestatusrenderer':
        renderer = (d, r) => /*#__PURE__*/external_react_default().createElement(SampleStatusRenderer, {
          row: r
        });
        break;
      case 'userdetailsrenderer':
        renderer = d => /*#__PURE__*/external_react_default().createElement(UserDetailsRenderer, {
          data: d
        });
        break;
      case 'expirationdatecolumnrenderer':
        renderer = d => /*#__PURE__*/external_react_default().createElement(ExpirationDateColumnRenderer, {
          data: d,
          col: column,
          tableCell: false
        });
        break;
      default:
        break;
    }
  }
  return renderer;
}
;// CONCATENATED MODULE: ./src/internal/components/forms/FormStep.tsx
function FormStep_extends() { return FormStep_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, FormStep_extends.apply(null, arguments); }
function FormStep_defineProperty(e, r, t) { return (r = FormStep_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FormStep_toPropertyKey(t) { var i = FormStep_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FormStep_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2017-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */


const FormStepContext = external_react_default().createContext(undefined);
const FormStepContextProvider = FormStepContext.Provider;
const FormStepContextConsumer = FormStepContext.Consumer;
class ActiveStep extends (external_react_default()).Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.active;
  }
  render() {
    return this.props.children;
  }
}
FormStep_defineProperty(ActiveStep, "defaultProps", {
  active: true
});
class FormStep extends (external_react_default()).Component {
  render() {
    const {
      children,
      stepIndex,
      trackActive
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement(FormStepContextConsumer, null, context => {
      if (!context) return null;
      const {
        currentStep,
        furthestStep
      } = context;
      const active = stepIndex === currentStep;
      if (furthestStep >= stepIndex) {
        return /*#__PURE__*/external_react_default().createElement("div", {
          className: external_classnames_default()('form-step', {
            active
          })
        }, trackActive ? /*#__PURE__*/external_react_default().createElement(ActiveStep, {
          active: active
        }, children) : children);
      }
      return null;
    });
  }
}
FormStep_defineProperty(FormStep, "defaultProps", {
  trackActive: true
});
class FormTabs extends (external_react_default()).Component {
  render() {
    const {
      onTabChange,
      tabs
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement(FormStepContextConsumer, null, context => {
      if (!context) return null;
      const {
        currentStep,
        furthestStep,
        hasDependentSteps,
        selectStep
      } = context;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-sm-12"
      }, /*#__PURE__*/external_react_default().createElement("ul", {
        className: "list-group clearfix",
        style: {
          listStyle: 'none'
        }
      }, tabs.map((title, i) => {
        const step = i + 1;
        const disabled = furthestStep === undefined ? true : hasDependentSteps ? step > currentStep : furthestStep < step;
        return /*#__PURE__*/external_react_default().createElement("li", {
          className: external_classnames_default()('list-group-item form-step-tab', {
            active: currentStep === step,
            disabled
          }),
          key: step,
          onClick: disabled ? undefined : () => {
            if (selectStep(step) !== false && onTabChange) {
              onTabChange(step);
            }
          }
        }, title);
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "clearfix"
      })));
    });
  }
}
// FIXME: this wrapper obliterates all type information for wrapped components, making it unsafe
const withFormSteps = (Component, defaultState) => class WithFormSteps extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    FormStep_defineProperty(this, "nextStep", () => {
      const {
        currentStep,
        furthestStep
      } = this.state;
      this.setState({
        currentStep: currentStep + 1,
        furthestStep: currentStep + 1 >= furthestStep ? currentStep + 1 : furthestStep
      });
    });
    FormStep_defineProperty(this, "previousStep", () => {
      const {
        currentStep
      } = this.state;
      this.setState({
        currentStep: currentStep - 1
      });
    });
    FormStep_defineProperty(this, "selectStep", requestedStep => {
      const {
        currentStep,
        furthestStep
      } = this.state;
      if (furthestStep >= requestedStep && currentStep !== requestedStep) {
        this.setState({
          currentStep: requestedStep
        });
        return true;
      }
      return false;
    });
    this.state = {
      currentStep: props.initialStep ? props.initialStep : defaultState && defaultState.currentStep !== undefined ? defaultState.currentStep : 1,
      furthestStep: defaultState && defaultState.furthestStep !== undefined ? defaultState.furthestStep : 1,
      hasDependentSteps: defaultState && defaultState.hasDependentSteps !== undefined ? defaultState.hasDependentSteps : true,
      selectStep: this.selectStep
    };
  }
  render() {
    return /*#__PURE__*/external_react_default().createElement(FormStepContextProvider, {
      value: this.state
    }, /*#__PURE__*/external_react_default().createElement(Component, FormStep_extends({}, this.props, this.state, {
      nextStep: this.nextStep,
      previousStep: this.previousStep,
      selectStep: this.selectStep
    })));
  }
};
;// CONCATENATED MODULE: ./src/internal/components/entities/EntityMoveConfirmationModal.tsx
const EntityMoveConfirmationModal_excluded = ["children", "excludeCurrentAsTarget", "onConfirm", "nounPlural", "currentContainer", "dataType", "dataTypeRowId"];
function EntityMoveConfirmationModal_extends() { return EntityMoveConfirmationModal_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, EntityMoveConfirmationModal_extends.apply(null, arguments); }
function EntityMoveConfirmationModal_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = EntityMoveConfirmationModal_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function EntityMoveConfirmationModal_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }













// exported for jest testing
async function getContainerOptions(api, container, moduleContext, excludeCurrentAsTarget, dataType, dataTypeRowId) {
  let folders = await api.folder.getProjects(container, moduleContext, true, true, true);
  const excludedFolders = await api.folder.getDataTypeExcludedProjects(dataType, dataTypeRowId);

  // filter to folders that the user has InsertPermissions
  folders = folders?.filter(c => c.effectivePermissions.indexOf(api_.Security.PermissionTypes.Insert) > -1);

  // filter out the current container, if requested
  if (excludeCurrentAsTarget) {
    folders = folders?.filter(c => c.id !== container.id);
  }

  // filter folder by exclusion
  if (excludedFolders) {
    folders = folders?.filter(c => excludedFolders.indexOf(c.id) === -1);
  }
  return folders?.map(f => ({
    label: f.path === HOME_PATH ? HOME_TITLE : f.title,
    value: f.path,
    data: f
  }));
}
const EntityMoveConfirmationModal = (0,external_react_.memo)(props => {
  const {
      children,
      excludeCurrentAsTarget,
      onConfirm,
      nounPlural,
      currentContainer,
      dataType,
      dataTypeRowId
    } = props,
    confirmModalProps = EntityMoveConfirmationModal_objectWithoutProperties(props, EntityMoveConfirmationModal_excluded);
  const [error, setError] = (0,external_react_.useState)();
  const [loading, setLoading] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [containerOptions, setContainerOptions] = (0,external_react_.useState)();
  const [selectedContainerOption, setSelectedContainerOption] = (0,external_react_.useState)();
  const [auditUserComment, setAuditUserComment] = (0,external_react_.useState)();
  const {
    api
  } = useAppContext();
  const {
    container,
    moduleContext
  } = useServerContext();
  const container_ = currentContainer ?? container;
  const hasValidUserComment = auditUserComment?.trim()?.length > 0;
  const {
    requiresUserComment
  } = useDataChangeCommentsRequired();
  (0,external_react_.useEffect)(() => {
    (async () => {
      setLoading(LoadingState.LOADING);
      setError(undefined);
      try {
        const options = await getContainerOptions(api, container_, moduleContext, excludeCurrentAsTarget, dataType, dataTypeRowId);
        setContainerOptions(options);
      } catch (e) {
        setError(`Error: ${resolveErrorMessage(e)}`);
      } finally {
        setLoading(LoadingState.LOADED);
      }
    })();
  }, [
    /* on mount only */
  ]);
  const onConfirmCallback = (0,external_react_.useCallback)(() => {
    if (selectedContainerOption) {
      onConfirm(selectedContainerOption.value, selectedContainerOption.label, auditUserComment);
    }
  }, [onConfirm, selectedContainerOption, auditUserComment]);
  const onContainerChange = (0,external_react_.useCallback)((fieldName, chosenType, selectedOption) => {
    setSelectedContainerOption(selectedOption);
  }, []);
  const onCommentChange = (0,external_react_.useCallback)(comment => {
    setAuditUserComment(comment);
  }, []);
  if (isLoading(loading)) {
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: confirmModalProps.title,
      onCancel: confirmModalProps.onCancel
    }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
      msg: "Loading target projects..."
    }));
  }
  if (error) {
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: confirmModalProps.title,
      onCancel: confirmModalProps.onCancel,
      cancelText: "Dismiss"
    }, /*#__PURE__*/external_react_default().createElement(Alert, null, error));
  }
  if (containerOptions?.length === 0) {
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: confirmModalProps.title,
      onCancel: confirmModalProps.onCancel,
      cancelText: "Dismiss"
    }, "You do not have permission to move ", nounPlural, " to any of the available projects.");
  }
  return /*#__PURE__*/external_react_default().createElement(Modal, EntityMoveConfirmationModal_extends({}, confirmModalProps, {
    onConfirm: onConfirmCallback,
    canConfirm: !!selectedContainerOption && (!requiresUserComment || hasValidUserComment)
  }), children, /*#__PURE__*/external_react_default().createElement("div", {
    className: "top-spacing"
  }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    helpTipRenderer: "NONE",
    label: "Move to",
    onChange: onContainerChange,
    options: containerOptions,
    required: true
  })), /*#__PURE__*/external_react_default().createElement(CommentTextArea, {
    actionName: "Moving",
    onChange: onCommentChange,
    requiresUserComment: requiresUserComment
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/entities/EntityMoveModal.tsx

















const EntityMoveModal = (0,external_react_.memo)(props => {
  const {
    api = getDefaultAPIWrapper(),
    onAfterMove,
    currentContainer,
    queryModel,
    onCancel,
    useSelected,
    entityDataType,
    maxSelected,
    targetAppURL,
    dataTypeRowId,
    hideHelp
  } = props;
  const {
    nounPlural
  } = entityDataType;
  const {
    createNotification
  } = useNotificationsContext();
  const [confirmationData, setConfirmationData] = (0,external_react_.useState)();
  const [loading, setLoading] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [error, setError] = (0,external_react_.useState)();
  const [showProgress, setShowProgress] = (0,external_react_.useState)(false);
  const [numConfirmed, setNumConfirmed] = (0,external_react_.useState)(0);
  let rowIds;
  let numSelected = 0;
  let selectionKey;
  if (useSelected) {
    selectionKey = queryModel.selectionKey;
  } else if (queryModel.hasData) {
    rowIds = [Object.keys(queryModel.rows)[0]];
    numSelected = 1;
  }
  (0,external_react_.useEffect)(() => {
    (async () => {
      setLoading(LoadingState.LOADING);
      try {
        const useSnapshotSelection = queryModel?.filterArray.length > 0;
        if (useSnapshotSelection) await setSnapshotSelections(selectionKey, [...queryModel.selections]);
        const confirmationData_ = await api.entity.getMoveConfirmationData(entityDataType, rowIds, selectionKey, useSnapshotSelection);
        setConfirmationData(confirmationData_);
      } catch (e) {
        setError('There was a problem retrieving the move confirmation data.');
      } finally {
        setLoading(LoadingState.LOADED);
      }
    })();
  }, [
    /* on mount only */
  ]);
  const onConfirm = (0,external_react_.useCallback)(async (targetContainerPath, targetName, auditUserComment) => {
    const movingAll = confirmationData.totalNotActionable === 0;
    const count = confirmationData.totalActionable;
    const noun = getEntityNoun(entityDataType, count)?.toLowerCase();
    setNumConfirmed(count);
    setShowProgress(true);
    const rowIds_ = !useSelected || !movingAll ? confirmationData.getActionableIds() : undefined;
    const useSnapshotSelection = useSelected && movingAll && queryModel.filterArray.length > 0;
    try {
      const moveResponse = await api.entity.moveEntities({
        containerPath: currentContainer?.path,
        targetContainerPath,
        entityDataType,
        schemaName: queryModel.schemaName,
        queryName: queryModel.queryName,
        rowIds: rowIds_,
        dataRegionSelectionKey: selectionKey,
        useSnapshotSelection,
        auditBehavior: api_.AuditBehaviorTypes.DETAILED,
        auditUserComment
      });
      let projectUrl = buildURL(getPrimaryAppProperties()?.productId, `${api_.ActionURL.getAction() || 'app'}.view`, undefined, {
        container: targetContainerPath,
        returnUrl: false
      });
      if (targetAppURL) {
        projectUrl = projectUrl + targetAppURL.toHref();
      }
      const movedCount = moveResponse.updateCounts[(entityDataType.moveNoun ?? entityDataType.nounPlural).toLowerCase()];
      const movedNoun = getEntityNoun(entityDataType, movedCount)?.toLowerCase();
      if (movedCount) {
        createNotification({
          message: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "Successfully moved ", movedCount, " ", movedNoun, " to ", /*#__PURE__*/external_react_default().createElement("a", {
            href: projectUrl
          }, targetName), "."),
          alertClass: 'success'
        }, true);
      } else {
        createNotification({
          message: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "All ", (entityDataType.nounPlural ?? 'data').toLowerCase(), " are already in the target project."),
          alertClass: 'warning'
        }, true);
      }
      onAfterMove();
    } catch (message) {
      setShowProgress(false);
      createNotification({
        alertClass: 'danger',
        message: 'There was a problem moving the ' + noun + '. ' + message
      }, true);
      if (useSelected) onAfterMove();
    } finally {
      onCancel();
    }
  }, [currentContainer, confirmationData, entityDataType, useSelected, queryModel.queryName, queryModel.filterArray.length, selectionKey, targetAppURL, createNotification, onAfterMove, onCancel]);
  if (useSelected && maxSelected && numSelected > maxSelected) {
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: 'Cannot Move ' + capitalizeFirstChar(nounPlural),
      onCancel: onCancel,
      cancelText: "Dismiss"
    }, "You cannot move more than ", maxSelected, " individual ", nounPlural.toLowerCase(), " at a time. Please select fewer ", nounPlural.toLowerCase(), " and try again.");
  }
  if (isLoading(loading)) {
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: "Move to Project",
      onCancel: onCancel
    }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
      msg: "Loading confirmation data..."
    }));
  }
  if (error) {
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: "Move to Project",
      onCancel: onCancel,
      cancelText: "Dismiss"
    }, /*#__PURE__*/external_react_default().createElement(Alert, null, error));
  }
  const {
    canMove,
    message,
    title
  } = getMoveConfirmationProperties(confirmationData, entityDataType.nounSingular, entityDataType.nounPlural, hideHelp);
  if (!canMove) {
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: 'Cannot Move ' + capitalizeFirstChar(nounPlural),
      onCancel: onCancel,
      cancelText: "Dismiss"
    }, message);
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !showProgress && /*#__PURE__*/external_react_default().createElement(EntityMoveConfirmationModal, {
    confirmText: "Move",
    nounPlural: nounPlural,
    onCancel: onCancel,
    onConfirm: onConfirm,
    currentContainer: currentContainer,
    title: title,
    dataType: entityDataType.projectConfigurableDataType,
    dataTypeRowId: dataTypeRowId,
    excludeCurrentAsTarget: maxSelected === 1
  }, message), /*#__PURE__*/external_react_default().createElement(Progress, {
    modal: true,
    estimate: numConfirmed * 10,
    title: `Moving ${numConfirmed} ${getEntityNoun(entityDataType, numConfirmed)}`,
    toggle: showProgress
  }));
});

// exported for jest testing
const getMoveConfirmationProperties = (confirmationData, nounSingular, nounPlural, hideHelp) => {
  if (!confirmationData) return undefined;
  const capNounSingular = capitalizeFirstChar(nounSingular);
  const capNounPlural = capitalizeFirstChar(nounPlural);
  const dependencyText = 'status that prevents moving';
  const numCanMove = confirmationData.totalActionable;
  const numCannotMove = confirmationData.totalNotActionable;
  const numNotAllowed = confirmationData.notAllowed.length;
  const numNotPermitted = confirmationData.notPermitted.length;
  const canMoveNoun = numCanMove === 1 ? capNounSingular : capNounPlural;
  const totalNum = confirmationData.totalCount;
  const totalNoun = totalNum === 1 ? nounSingular : nounPlural;
  let text;
  if (totalNum === 0) {
    text = 'Either no ' + nounPlural + ' are selected for moving or the selected ' + nounPlural + ' are no longer valid.';
  } else if (numCannotMove === 0) {
    text = totalNum === 1 ? 'The selected ' : totalNum === 2 ? 'Both ' : 'All ' + totalNum + ' ';
    text += totalNoun + ' will be moved.';
  } else if (numCanMove === 0 && numNotPermitted < numCannotMove) {
    if (totalNum === 1) {
      text = 'The ' + totalNoun + " you've selected cannot be moved because it has a " + dependencyText + ' or you lack the proper permissions. ';
    } else {
      text = numCannotMove === 2 ? 'Neither of' : 'None of';
      text += ' the ' + totalNum + ' ' + totalNoun + " you've selected can be moved";
      text += ' because they have a ' + dependencyText + ' or you lack the proper permissions.';
    }
  } else if (numCanMove > 0) {
    text = [];
    let firstText = "You've selected " + totalNum + ' ' + totalNoun + ' but only ' + numCanMove + ' can be moved. ';
    if (numNotAllowed > 0) {
      const cannotMoveNoun = numNotAllowed === 1 ? nounSingular : nounPlural;
      firstText += numNotAllowed + ' ' + cannotMoveNoun + ' cannot be moved because ';
      firstText += (numNotAllowed === 1 ? ' it has ' : ' they have ') + dependencyText + '. ';
    }
    text.push( /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, {
      key: "commonText"
    }, firstText));
  }
  let message;
  if (numCannotMove > 0) {
    message = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, text, getPermissionRestrictionMessage(totalNum, numNotPermitted, nounSingular, nounPlural, 'move'), !hideHelp && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "\xA0(", /*#__PURE__*/external_react_default().createElement(HelpLink, {
      topic: MOVE_SAMPLES_TOPIC
    }, "more info"), ")"));
  }
  if (numCanMove > 0 && numCannotMove > 0) {
    message = /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "warning"
    }, message);
  }
  return {
    message,
    title: numCanMove > 0 ? 'Move ' + numCanMove + ' ' + canMoveNoun : totalNum === 1 ? 'Cannot Move ' + capNounSingular : 'No ' + capNounPlural + ' Can Be Moved',
    canMove: numCanMove > 0
  };
};
;// CONCATENATED MODULE: ./src/internal/components/entities/AssayResultsForSamplesButton.tsx









function getAssayResultsHref(model, picklistName, isAssay, sampleFieldKey, currentProductId, targetProductId) {
  const params = getURLParamsForSampleSelectionKey(model, picklistName, isAssay, sampleFieldKey);
  const actionUrl = createProductUrlFromParts(targetProductId, currentProductId, params, ASSAYS_KEY, 'sampleresults');
  return actionUrl instanceof AppURL ? actionUrl.toHref() : actionUrl;
}
const AssayResultsForSamplesMenuItem = (0,external_react_.memo)(props => {
  const {
    model,
    metricFeatureArea,
    isAssay,
    isPicklist,
    currentProductId,
    targetProductId,
    user
  } = props;
  const picklistName = (0,external_react_.useMemo)(() => isPicklist ? model.queryName : undefined, [model, isPicklist]);
  const sampleFieldKey = (0,external_react_.useMemo)(() => isAssay ? model.displayColumns?.find(c => c.isSampleLookup())?.fieldKey : undefined, [model, isAssay]);
  const incrementMetric = (0,external_react_.useCallback)(() => {
    incrementClientSideMetricCount(metricFeatureArea, 'viewAssayResultsForSamples');
  }, [metricFeatureArea]);
  if (!userCanReadAssays(user)) return null;
  return /*#__PURE__*/external_react_default().createElement(SelectionMenuItem, {
    text: "View Assay Results for Selected",
    href: getAssayResultsHref(model, picklistName, isAssay, sampleFieldKey, currentProductId, targetProductId),
    onClick: incrementMetric,
    queryModel: model,
    nounPlural: SampleTypeDataType.nounPlural
  });
});
const AssayResultsForSamplesButton = (0,external_react_.memo)(props => {
  const {
    asSubMenu,
    user
  } = props;
  if (!userCanReadAssays(user)) return null;
  const items = /*#__PURE__*/external_react_default().createElement(AssayResultsForSamplesMenuItem, props);
  return /*#__PURE__*/external_react_default().createElement(ResponsiveMenuButton, {
    className: "sample-reports-menu",
    items: items,
    text: "Reports",
    asSubMenu: asSubMenu
  });
});
;// CONCATENATED MODULE: ./src/internal/components/entities/SampleAliquotViewSelector.tsx



const ViewMenuItem = ({
  currentFilterMode,
  filterMode,
  label,
  onClick
}) => {
  const onClick_ = (0,external_react_.useCallback)(() => onClick(filterMode), [filterMode, onClick]);
  return /*#__PURE__*/external_react_default().createElement(MenuItem, {
    active: filterMode === currentFilterMode,
    onClick: onClick_
  }, label);
};
const SampleAliquotViewSelector = props => {
  const {
    aliquotsLabel = 'Aliquots Only',
    aliquotFilterMode = ALIQUOT_FILTER_MODE.all,
    allLabel = 'Samples and Aliquots',
    headerLabel = 'Show Samples',
    samplesLabel = 'Samples Only',
    updateAliquotFilter
  } = props;
  let title = 'All Samples';
  if (aliquotFilterMode === ALIQUOT_FILTER_MODE.samples) {
    title = samplesLabel;
  } else if (aliquotFilterMode === ALIQUOT_FILTER_MODE.aliquots) {
    title = aliquotsLabel;
  } else if (aliquotFilterMode === ALIQUOT_FILTER_MODE.none) {
    title = 'None';
  }
  return /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    buttonClassName: "aliquot-view-selector",
    pullRight: true,
    title: title
  }, /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    text: headerLabel
  }), /*#__PURE__*/external_react_default().createElement(ViewMenuItem, {
    currentFilterMode: aliquotFilterMode,
    filterMode: ALIQUOT_FILTER_MODE.all,
    label: allLabel,
    onClick: updateAliquotFilter
  }), /*#__PURE__*/external_react_default().createElement(ViewMenuItem, {
    currentFilterMode: aliquotFilterMode,
    filterMode: ALIQUOT_FILTER_MODE.samples,
    label: samplesLabel,
    onClick: updateAliquotFilter
  }), /*#__PURE__*/external_react_default().createElement(ViewMenuItem, {
    currentFilterMode: aliquotFilterMode,
    filterMode: ALIQUOT_FILTER_MODE.aliquots,
    label: aliquotsLabel,
    onClick: updateAliquotFilter
  }));
};
SampleAliquotViewSelector.displayName = 'SampleAliquotViewSelector';
;// CONCATENATED MODULE: ./src/internal/components/entities/GridAliquotViewSelector.tsx
function GridAliquotViewSelector_defineProperty(e, r, t) { return (r = GridAliquotViewSelector_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function GridAliquotViewSelector_toPropertyKey(t) { var i = GridAliquotViewSelector_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function GridAliquotViewSelector_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





class GridAliquotViewSelector extends external_react_.Component {
  constructor(...args) {
    super(...args);
    GridAliquotViewSelector_defineProperty(this, "state", {
      initAliquotModeSynced: false
    });
    GridAliquotViewSelector_defineProperty(this, "componentDidUpdate", () => {
      this.syncInitMode();
    });
    GridAliquotViewSelector_defineProperty(this, "syncInitMode", () => {
      const {
        initAliquotMode,
        queryModel
      } = this.props;
      const {
        initAliquotModeSynced
      } = this.state;
      // if bindURL = true, rely on url param to set aliquot filter and ignore the initAliquotMode prop
      if (!initAliquotModeSynced && initAliquotMode && !queryModel.bindURL && !queryModel?.isLoading) {
        const currentMode = this.getAliquotFilterMode();
        if (initAliquotMode != currentMode) this.updateAliquotFilter(initAliquotMode);
        this.setState(() => ({
          initAliquotModeSynced: true
        }));
      }
    });
    GridAliquotViewSelector_defineProperty(this, "getAliquotColName", () => {
      // account for the case where the aliquot column is in the queryModel via a lookup from the sample ID
      const {
        queryModel
      } = this.props;
      let aliquotColName;
      if (!queryModel.getColumnByFieldKey(IS_ALIQUOT_COL)) {
        aliquotColName = queryModel.allColumns?.find(c => c.fieldKey.toLowerCase().indexOf('/' + IS_ALIQUOT_COL.toLowerCase()) > -1)?.fieldKey;
      }
      return aliquotColName ?? IS_ALIQUOT_COL;
    });
    GridAliquotViewSelector_defineProperty(this, "updateAliquotFilter", newMode => {
      const {
        queryModel,
        actions,
        updateFilter
      } = this.props;
      const aliquotColName = this.getAliquotColName();
      let newFilter;
      if (newMode === ALIQUOT_FILTER_MODE.all || newMode === ALIQUOT_FILTER_MODE.none) {
        newFilter = null;
      } else {
        newFilter = api_.Filter.create(aliquotColName, newMode === ALIQUOT_FILTER_MODE.aliquots);
      }
      if (updateFilter) {
        updateFilter(newFilter, aliquotColName, newMode, queryModel);
      }
      if (queryModel?.queryInfo && actions) {
        // keep any existing filters that do not match the aliquot column name
        const updatedFilters = queryModel.filterArray.filter(filter => {
          return aliquotColName.toLowerCase() !== filter.getColumnName().toLowerCase();
        });
        if (newFilter) updatedFilters.push(newFilter);
        actions.setFilters(queryModel.id, updatedFilters, true);
      }
    });
    GridAliquotViewSelector_defineProperty(this, "getAliquotFilterMode", () => {
      const {
        queryModel
      } = this.props;
      let mode = ALIQUOT_FILTER_MODE.all;
      const filterArray = queryModel?.filterArray;
      if (filterArray) {
        const aliquotColName = this.getAliquotColName();
        filterArray.forEach(filter => {
          if (filter.getColumnName().toLowerCase() === aliquotColName?.toLowerCase()) {
            const filterType = filter.getFilterType();
            const value = filter.getValue();
            if (filterType == api_.Filter.Types.ISBLANK || filterType == api_.Filter.Types.MISSING) {
              mode = ALIQUOT_FILTER_MODE.none;
            } else if (filterType == api_.Filter.Types.EQUAL || filterType.getURLSuffix() == 'eq') {
              if (value === '') return;
              mode = value === 'true' || value === true ? ALIQUOT_FILTER_MODE.aliquots : ALIQUOT_FILTER_MODE.samples;
            } else if (filterType == api_.Filter.Types.NOT_EQUAL || filterType == api_.Filter.Types.NEQ || filterType == api_.Filter.Types.NEQ_OR_NULL) {
              if (value === '') return;
              mode = value === 'true' || value === true ? ALIQUOT_FILTER_MODE.samples : ALIQUOT_FILTER_MODE.aliquots;
            }
          }
        });
      }
      return mode;
    });
  }
  componentDidMount() {
    this.syncInitMode();
  }
  render() {
    const {
      queryModel
    } = this.props;
    if (!queryModel) return null;
    if (!isSampleAliquotSelectorEnabled()) return null;
    return /*#__PURE__*/external_react_default().createElement(SampleAliquotViewSelector, {
      aliquotFilterMode: this.getAliquotFilterMode(),
      updateAliquotFilter: this.updateAliquotFilter
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/components/entities/FindDerivativesButton.tsx
function FindDerivativesButton_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FindDerivativesButton_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FindDerivativesButton_ownKeys(Object(t), !0).forEach(function (r) { FindDerivativesButton_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FindDerivativesButton_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FindDerivativesButton_defineProperty(e, r, t) { return (r = FindDerivativesButton_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FindDerivativesButton_toPropertyKey(t) { var i = FindDerivativesButton_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FindDerivativesButton_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










const SAMPLE_FINDER_SESSION_PREFIX = 'Searched ';
const DISABLED_FIND_DERIVATIVES_MSG = 'Unable to find derivative samples using search filters or filters on multi-valued lookup fields';
function getSampleFinderLocalStorageKey() {
  return getPrimaryAppProperties().productId + api_.ActionURL.getContainer() + '-SampleFinder';
}
function isValidFilterFieldSampleFinder(field, queryInfo, exprColumnsWithSubSelect) {
  if (!isValidFilterField(field, queryInfo, exprColumnsWithSubSelect)) return false;

  // also exclude multiValue lookups (MVFKs)
  return !field.multiValue;
}

// exported for unit test coverage
const getFieldFilter = (model, filter) => {
  const colName = filter.getColumnName();
  const column = model.getColumn(colName);
  return {
    fieldKey: colName,
    fieldCaption: column?.caption ?? colName,
    filter,
    jsonType: column?.isLookup() ? column.displayFieldJsonType : column?.jsonType ?? 'string'
  };
};

// exported for unit test coverage
const getSessionSearchFilterProps = (entityDataType, model, filters, baseEntityDataType, baseModel, baseFilter) => {
  let fieldFilters = [];
  // optionally include baseFilter when passed without a baseModel (i.e. apply to the same schemaQuery as the other filters)
  if (baseFilter && !baseModel) {
    fieldFilters = fieldFilters.concat(baseFilter.map(filter => getFieldFilter(model, filter)));
  }
  // always include viewFilters and user defined filters (filterArray)
  fieldFilters = fieldFilters.concat(filters.map(filter => getFieldFilter(model, filter)));
  const filterProps = [];
  if (baseModel && baseFilter) {
    filterProps.push({
      schemaQuery: baseModel.schemaQuery,
      filterArray: baseFilter.map(filter => getFieldFilter(baseModel, filter)),
      entityDataType: baseEntityDataType,
      dataTypeDisplayName: baseModel.title ?? baseModel.queryInfo.title ?? baseModel.queryName
    });
  }
  filterProps.push({
    schemaQuery: model.schemaQuery,
    filterArray: fieldFilters,
    entityDataType,
    dataTypeDisplayName: model.title ?? model.queryInfo.title ?? model.queryName
  });
  return filterProps;
};
function filterToJson(filter) {
  if (!filter) return;
  return encodeURIComponent(filter.getURLParameterName()) + '=' + encodeURIComponent(filter.getURLParameterValue());
}
function getSearchFilterObjs(filterProps) {
  const filterPropsObj = [];
  filterProps.forEach(filterProp => {
    const filterPropObj = FindDerivativesButton_objectSpread({}, filterProp);
    delete filterPropObj['entityDataType'];
    // don't persist the entire entitydatatype
    filterPropObj['sampleFinderCardType'] = filterProp.entityDataType.sampleFinderCardType;
    const filterArrayObjs = [];
    [...filterPropObj.filterArray].forEach(field => {
      filterArrayObjs.push({
        fieldKey: field.fieldKey,
        fieldCaption: field.fieldCaption,
        filter: filterToJson(field.filter),
        jsonType: field.jsonType
      });
    });
    filterPropObj.filterArray = filterArrayObjs;
    filterPropsObj.push(filterPropObj);
  });
  return filterPropsObj;
}
function searchFiltersToJson(filterProps, filterChangeCounter, time, timezone) {
  return JSON.stringify({
    filters: getSearchFilterObjs(filterProps),
    filterChangeCounter,
    filterTimestamp: SAMPLE_FINDER_SESSION_PREFIX + formatDateTime(time ?? new Date(), timezone)
  });
}
const FindDerivativesMenuItem = (0,external_react_.memo)(props => {
  const {
    baseEntityDataType,
    baseModel,
    baseFilter,
    model,
    entityDataType,
    metricFeatureArea
  } = props;
  const {
    api
  } = useAppContext();
  const viewAndUserFilters = (0,external_react_.useMemo)(() => !model.queryInfo ? [] : [].concat(model.viewFilters).concat(model.filterArray), [model]);
  const invalidFilterNames = (0,external_react_.useMemo)(() => viewAndUserFilters.map(filter => {
    const colName = filter.getColumnName();
    const column = model.getColumn(colName);
    if (!column) {
      return colName === '*' ? 'Search Filter' : 'Unknown Field';
    }
    return !isValidFilterFieldSampleFinder(column, model.queryInfo) ? column.caption : undefined;
  }).filter(caption => caption !== undefined).join(', '), [model, viewAndUserFilters]);
  const onClick = (0,external_react_.useCallback)(() => {
    const currentTimestamp = new Date();
    const sessionViewName = SAMPLE_FINDER_SESSION_PREFIX + formatDateTime(currentTimestamp);
    const filterProps = getSessionSearchFilterProps(entityDataType, model, viewAndUserFilters, baseEntityDataType, baseModel, baseFilter);
    sessionStorage.setItem(getSampleFinderLocalStorageKey(), searchFiltersToJson(filterProps, 0, currentTimestamp));
    api.query.incrementClientSideMetricCount(metricFeatureArea, 'sampleFinderFindDerivatives');
    window.location.href = AppURL.create('search', FIND_SAMPLES_BY_FILTER_KEY).addParam('view', sessionViewName).toHref();
  }, [api.query, baseFilter, baseModel, entityDataType, metricFeatureArea, model, viewAndUserFilters]);
  if (!model.queryInfo) return null;
  return /*#__PURE__*/external_react_default().createElement(DisableableMenuItem, {
    disabled: invalidFilterNames !== '',
    disabledMessage: DISABLED_FIND_DERIVATIVES_MSG + ' (' + invalidFilterNames + ').',
    onClick: onClick,
    placement: "right"
  }, "Find Derivatives in Sample Finder");
});
const FindDerivativesButton = (0,external_react_.memo)(props => {
  const items = /*#__PURE__*/external_react_default().createElement(FindDerivativesMenuItem, props);
  return /*#__PURE__*/external_react_default().createElement(ResponsiveMenuButton, {
    className: "sample-reports-menu",
    items: items,
    text: "Reports",
    asSubMenu: props.asSubMenu
  });
});
;// CONCATENATED MODULE: ./src/internal/components/search/SearchResultCard.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




const SearchResultCard = (0,external_react_.memo)(({
  cardData,
  iconUrl,
  isTopResult,
  summary,
  url
}) => {
  const {
    altText,
    category,
    iconDir,
    iconSrc,
    title,
    typeName
  } = cardData;
  const productId = getCurrentAppProperties()?.productId;
  const summaryText = summary?.length ? summary : 'No summary provided';
  const onClick = (0,external_react_.useCallback)(() => {
    if (isTopResult) incrementClientSideMetricCount(productId + 'Search', 'firstResultClicked');
    incrementClientSideMetricCount(productId + 'Search', 'resultClicked');
  }, [isTopResult, productId]);
  const textParts = [];
  if (category) textParts.push(category);
  if (typeName) textParts.push(typeName);
  return /*#__PURE__*/external_react_default().createElement("a", {
    href: url,
    onClick: onClick
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row search-result__card-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "hidden-xs search-result__card-icon__container"
  }, iconUrl && /*#__PURE__*/external_react_default().createElement("img", {
    className: "search-result__card-icon",
    src: iconUrl,
    alt: altText
  }), !iconUrl && /*#__PURE__*/external_react_default().createElement(SVGIcon, {
    iconDir: iconDir,
    iconSrc: iconSrc,
    alt: altText,
    className: "search-result__card-icon"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-12 search-result__title"
  }, /*#__PURE__*/external_react_default().createElement("h4", null, title), textParts.length > 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-left status-pill muted"
  }, textParts.join(': '))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "search-result__summary"
  }, summaryText))));
});
;// CONCATENATED MODULE: ./src/internal/components/search/SearchResultsPanel.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






const SearchResultsPanel = (0,external_react_.memo)(({
  emptyResultDisplay,
  iconUrl,
  model,
  offset = 0
}) => {
  const error = model?.error;
  const loading = model?.isLoading ?? false;
  const data = model?.getIn(['entities', 'hits']);
  const hasData = data?.size > 0;
  const empty = emptyResultDisplay ?? /*#__PURE__*/external_react_default().createElement("div", {
    className: "search-results__margin-top"
  }, "No Results Found");
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "search-results-panel"
  }, loading && /*#__PURE__*/external_react_default().createElement("div", {
    className: "top-spacing"
  }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null)), !loading && error && /*#__PURE__*/external_react_default().createElement(Alert, {
    className: "margin-top"
  }, "There was an error with your search term(s). ", decodeErrorMessage(error), /*#__PURE__*/external_react_default().createElement("br", null), /*#__PURE__*/external_react_default().createElement("br", null), "See the ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: SEARCH_SYNTAX_TOPIC
  }, "LabKey Search Documentation"), " page for more information on search terms and operators."), !loading && !error && hasData && /*#__PURE__*/external_react_default().createElement("div", {
    className: "top-spacing"
  }, data.size > 0 && data.map((item, i) => /*#__PURE__*/external_react_default().createElement("div", {
    key: i,
    className: "col-md-12 col-sm-12 search-results__margin-top"
  }, /*#__PURE__*/external_react_default().createElement(SearchResultCard, {
    summary: item.get('summary'),
    url: item.get('url'),
    iconUrl: iconUrl,
    cardData: item.get('cardData').toJS(),
    isTopResult: offset === 0 && i === 0
  })))), !loading && !error && !hasData && empty);
});
;// CONCATENATED MODULE: ./src/internal/components/search/SearchPanel.tsx
function SearchPanel_extends() { return SearchPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, SearchPanel_extends.apply(null, arguments); }












const SearchPanelImpl = (0,external_react_.memo)(props => {
  const {
    appName = 'Labkey',
    searchTerm,
    model,
    search,
    onPageChange,
    pageSize,
    offset,
    title
  } = props;
  const [searchQuery, setSearchQuery] = (0,external_react_.useState)(searchTerm);
  const totalHits = (0,external_react_.useMemo)(() => model?.getIn(['entities', 'totalHits']), [model]);
  const currentPage = offset / pageSize ? offset / pageSize : 0;
  (0,external_react_.useEffect)(() => {
    setSearchQuery(searchTerm);
  }, [searchTerm]);
  const emptyTextMessage = (0,external_react_.useMemo)(() => {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "search-panel__no-results panel-body"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "font-large"
    }, "No Results Found"), /*#__PURE__*/external_react_default().createElement("hr", null), /*#__PURE__*/external_react_default().createElement("div", null, "We suggest to check your spelling or broaden your search.", /*#__PURE__*/external_react_default().createElement("br", null), /*#__PURE__*/external_react_default().createElement("br", null), "Can\u2019t find what you\u2019re looking for? Check the", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
      topic: SEARCH_HELP_TOPIC
    }, "documentation"), " for ", appName));
  }, [appName]);
  const pageBack = (0,external_react_.useCallback)(() => {
    onPageChange(-1);
  }, [onPageChange]);
  const pageForward = (0,external_react_.useCallback)(() => {
    onPageChange(1);
  }, [onPageChange]);
  const onSearchChange = (0,external_react_.useCallback)(evt => {
    setSearchQuery(evt.target.value);
  }, [setSearchQuery]);
  const onSubmit = (0,external_react_.useCallback)(evt => {
    evt?.preventDefault();
    search({
      q: searchQuery
    });
  }, [search, searchQuery]);
  const onSearchClick = (0,external_react_.useCallback)(() => {
    onSubmit(undefined);
  }, [onSubmit]);
  const hasPages = totalHits > pageSize;
  const helpLink = /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: SEARCH_HELP_TOPIC,
    className: "search-form__help-link"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-question-circle search-form__help-icon"
  }), "Help with search");
  return /*#__PURE__*/external_react_default().createElement(Section, {
    panelClassName: "test-loc-search-panel",
    title: title,
    context: helpLink
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "search-form panel-body"
  }, /*#__PURE__*/external_react_default().createElement("form", {
    onSubmit: onSubmit
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group-addon clickable",
    onClick: onSearchClick
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-search search-icon"
  })), /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control search-input",
    onChange: onSearchChange,
    placeholder: "Search",
    size: 34,
    type: "text",
    value: searchQuery
  }))), /*#__PURE__*/external_react_default().createElement("button", {
    className: "margin-left success submit-button btn btn-default",
    onClick: onSearchClick,
    type: "submit"
  }, "Search"), hasPages && /*#__PURE__*/external_react_default().createElement("div", {
    className: "page-buttons"
  }, /*#__PURE__*/external_react_default().createElement(PaginationButtons, {
    total: totalHits,
    currentPage: currentPage,
    perPage: pageSize,
    previousPage: pageBack,
    nextPage: pageForward
  }))), searchTerm && /*#__PURE__*/external_react_default().createElement(SearchResultsPanel, {
    model: model,
    emptyResultDisplay: emptyTextMessage,
    offset: offset
  }));
});

// FIXME: This component should be moved into premium, the props should be refactored:
//      - search prop should be removed, and it should be handled internally via react router hooks (setting search
//      params via useSearchParams setter).
//      - offset, pageSize, and searchTerm (q) can be taken directly off the URL via useSearchParams
//      - searchMetadata is the only needed prop
const SearchPanel = (0,external_react_.memo)(props => {
  const {
    offset = 0,
    pageSize = SEARCH_PAGE_DEFAULT_SIZE,
    searchTerm,
    search,
    searchMetadata
  } = props;
  const [model, setModel] = (0,external_react_.useState)(() => SearchResultsModel.create({
    isLoading: true
  }));
  const {
    moduleContext
  } = useServerContext();
  const isBiologics = biologicsIsPrimaryApp(moduleContext);
  const platesEnabled = isPlatesEnabled(moduleContext);
  const category = (0,external_react_.useMemo)(() => {
    const categories = [SearchCategory.Assay, SearchCategory.AssayBatch, SearchCategory.AssayRun, SearchCategory.Data, SearchCategory.DataClass, SearchCategory.File, SearchCategory.FileWorkflowJob, SearchCategory.Material, SearchCategory.MaterialSource, SearchCategory.Notebook, SearchCategory.NotebookTemplate, SearchCategory.StorageLocation, SearchCategory.TerminalStorageLocation, SearchCategory.WorkflowJob];
    if (isBiologics) {
      categories.push(SearchCategory.Media, SearchCategory.MediaData);
    }
    if (platesEnabled) {
      categories.push(SearchCategory.Plate);
    }
    return categories;
  }, [isBiologics, platesEnabled]);
  const getCardDataFn = (0,external_react_.useCallback)((data, cat) => getSearchResultCardData(data, cat, searchMetadata), [searchMetadata]);
  (0,external_react_.useEffect)(() => {
    if (!searchTerm) return;
    (async () => {
      setModel(SearchResultsModel.create({
        isLoading: true
      }));
      try {
        const entities = await searchUsingIndex({
          category,
          q: searchTerm,
          limit: pageSize,
          offset
        }, getCardDataFn);
        setModel(SearchResultsModel.create({
          entities,
          isLoaded: true
        }));
      } catch (response) {
        setModel(SearchResultsModel.create({
          error: resolveErrorMessage(response.exception) ?? 'Unknown error getting search results.',
          isLoaded: true
        }));
      }
    })();
  }, [category, getCardDataFn, offset, pageSize, searchTerm]);
  const onPage = (0,external_react_.useCallback)(direction => {
    // FIXME: offset is a string because it comes from queryParams and we aren't properly parsing it upstream
    //  so the comment below is inaccurate. We should fix the code so it's always a number.

    // because JS is dumb and treats offset as a string...
    const newOffset = direction * pageSize + offset * 1;
    search({
      q: searchTerm,
      pageSize,
      offset: newOffset
    });
  }, [search, searchTerm, pageSize, offset]);
  return /*#__PURE__*/external_react_default().createElement(SearchPanelImpl, SearchPanel_extends({}, props, {
    search: search,
    model: model,
    onPageChange: onPage,
    offset: offset
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/project/useFolderDataTypeExclusions.ts


const useFolderDataTypeExclusions = (api, project) => {
  const [loaded, setLoaded] = (0,external_react_.useState)(false);
  const [error, setError] = (0,external_react_.useState)();
  const [disabledTypesMap, setDisabledTypesMap] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    (async () => {
      setLoaded(false);
      setError(undefined);
      try {
        if (project) {
          const disabledTypesMap_ = await api.getFolderDataTypeExclusions(project?.path);
          setDisabledTypesMap(disabledTypesMap_);
        } else {
          setDisabledTypesMap({});
        }
      } catch (e) {
        setError(`Error: ${resolveErrorMessage(e)}`);
      } finally {
        setLoaded(true);
      }
    })();
  }, [project]);
  return {
    loaded,
    error,
    disabledTypesMap
  };
};
;// CONCATENATED MODULE: ./src/internal/components/project/ProjectNameSetting.tsx

const MAX_FOLDER_NAME_LENGTH = 255;
const ProjectNameSetting = (0,external_react_.memo)(props => {
  const {
    autoFocus,
    defaultTitle,
    defaultName,
    onNameChange,
    onTitleChange,
    setIsDirty
  } = props;
  const [name, setName] = (0,external_react_.useState)(defaultName);
  const [nameIsTitle, setNameIsTitle] = (0,external_react_.useState)(defaultName ? defaultName === defaultTitle : true);
  const toggleLabel = 'Use Project Name for Project Label';
  const _onNameChange = (0,external_react_.useCallback)(evt => {
    const _name = evt.target.value;
    setName(_name);
    setIsDirty(true);
    onNameChange?.(_name);
  }, [onNameChange, setIsDirty]);
  const _onTitleChange = (0,external_react_.useCallback)(() => {
    setIsDirty(true);
    onTitleChange?.();
  }, [onTitleChange, setIsDirty]);
  const toggleNameIsTitle = (0,external_react_.useCallback)(() => {
    setNameIsTitle(_nameIsTitle => !_nameIsTitle);
    setIsDirty(true);
  }, [setIsDirty]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "project-name-properties"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: "control-label col-xs-12 col-sm-2 text-left",
    htmlFor: "name"
  }, "Project Name ", /*#__PURE__*/external_react_default().createElement("span", {
    className: "required-symbol"
  }, "*")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-10 col-md-5"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    autoComplete: "off",
    autoFocus: autoFocus,
    className: "form-control",
    defaultValue: defaultName,
    id: "name",
    name: "name",
    onChange: _onNameChange,
    required: true,
    type: "text",
    maxLength: MAX_FOLDER_NAME_LENGTH
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "help-block"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: "checkbox-inline",
    title: toggleLabel
  }, /*#__PURE__*/external_react_default().createElement("input", {
    id: "nameIsTitle",
    defaultChecked: nameIsTitle,
    style: {
      marginRight: '8px'
    },
    name: "nameAsTitle",
    onChange: toggleNameIsTitle,
    type: "checkbox"
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "checkbox-inline-label"
  }, toggleLabel))))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: "control-label col-xs-12 col-sm-2 text-left",
    htmlFor: "label"
  }, "Project Label"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-10 col-md-5"
  }, nameIsTitle && /*#__PURE__*/external_react_default().createElement("input", {
    autoComplete: "off",
    className: "form-control",
    disabled: true,
    id: "label",
    key: "controlled",
    name: "title",
    type: "text",
    value: name ?? ''
  }), !nameIsTitle && /*#__PURE__*/external_react_default().createElement("input", {
    autoComplete: "off",
    className: "form-control",
    defaultValue: defaultTitle,
    id: "label",
    key: "uncontrolled",
    name: "title",
    onChange: _onTitleChange,
    type: "text"
  }))));
});
;// CONCATENATED MODULE: ./src/internal/components/project/ProjectDataTypeSelections.tsx
function ProjectDataTypeSelections_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ProjectDataTypeSelections_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ProjectDataTypeSelections_ownKeys(Object(t), !0).forEach(function (r) { ProjectDataTypeSelections_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ProjectDataTypeSelections_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProjectDataTypeSelections_defineProperty(e, r, t) { return (r = ProjectDataTypeSelections_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ProjectDataTypeSelections_toPropertyKey(t) { var i = ProjectDataTypeSelections_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ProjectDataTypeSelections_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






const ProjectDataTypeSelections = (0,external_react_.memo)(props => {
  const {
    api,
    entityDataTypes,
    panelTitle,
    panelDescription,
    project,
    updateDataTypeExclusions,
    onSuccess,
    showUncheckedWarning,
    dataTypePrefix,
    setIsDirty,
    getIsDirty
  } = props;
  const [saveError, setSaveError] = (0,external_react_.useState)();
  const [isSaving, setIsSaving] = (0,external_react_.useState)(false);
  const [dataTypeExclusion, setDataTypeExclusion] = (0,external_react_.useState)({});
  const {
    loaded,
    error,
    disabledTypesMap
  } = useFolderDataTypeExclusions(api, project);
  const perDataTypeColumns = (0,external_react_.useMemo)(() => entityDataTypes?.length === 1 ? 2 : 1, [entityDataTypes]);
  const perEntityTypeColCls = (0,external_react_.useMemo)(() => entityDataTypes?.length === 1 ? 'col-xs-12' : 'col-xs-12 col-md-4', [entityDataTypes]);
  const updateDataTypeExclusions_ = (0,external_react_.useCallback)((dataType, exclusions) => {
    updateDataTypeExclusions?.(dataType, exclusions);
    if (project) {
      setDataTypeExclusion(prev => {
        const uncheckedUpdates = ProjectDataTypeSelections_objectSpread({}, prev);
        uncheckedUpdates[dataType] = exclusions;
        return uncheckedUpdates;
      });
    }
    setIsDirty(true);
  }, [setIsDirty, updateDataTypeExclusions, project]);
  const onSave = (0,external_react_.useCallback)(async () => {
    if (isSaving) return;
    setIsSaving(true);
    try {
      const options = {
        disabledSampleTypes: dataTypeExclusion?.['SampleType'],
        disabledDashboardSampleTypes: dataTypeExclusion?.['DashboardSampleType'],
        disabledDataClasses: dataTypeExclusion?.['DataClass'],
        disabledAssayDesigns: dataTypeExclusion?.['AssayDesign']
      };
      await api.updateProjectDataExclusions(options, project?.path);
      setIsDirty(false);
      onSuccess(true);
    } catch (e) {
      setSaveError(resolveErrorMessage(e) ?? 'Failed to update project settings');
    } finally {
      setIsSaving(false);
    }
  }, [setIsDirty, isSaving, dataTypeExclusion, api, project?.path, onSuccess]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, panelTitle), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-horizontal"
  }, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), saveError && /*#__PURE__*/external_react_default().createElement(Alert, null, saveError), /*#__PURE__*/external_react_default().createElement("div", {
    className: "bottom-spacing"
  }, panelDescription), !loaded && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, loaded && entityDataTypes?.map(entityDataType => {
    // uncheck those data types that have been configured  to be excluded, but if this
    // is a "child/related" exclusion type, then use the parent exclusions to hide options
    // (i.e. for the "Sample Type" exclusions and the "Dashboard Sample Type" exclusions)
    const uncheckedDataTypes = disabledTypesMap?.[dataTypePrefix + entityDataType.projectConfigurableDataType];
    const hiddenDataTypes = dataTypePrefix ? disabledTypesMap?.[entityDataType.projectConfigurableDataType] : undefined;
    return /*#__PURE__*/external_react_default().createElement("div", {
      key: entityDataType.nounSingular,
      className: 'bottom-spacing project-datatype-col ' + perEntityTypeColCls
    }, /*#__PURE__*/external_react_default().createElement(DataTypeSelector, {
      project: project,
      columns: perDataTypeColumns,
      dataTypePrefix: dataTypePrefix,
      entityDataType: entityDataType,
      updateUncheckedTypes: updateDataTypeExclusions_,
      uncheckedEntitiesDB: uncheckedDataTypes,
      hiddenEntities: hiddenDataTypes,
      showUncheckedWarning: showUncheckedWarning,
      isNewFolder: !project
    }));
  })), project && /*#__PURE__*/external_react_default().createElement("div", {
    className: "pull-right"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "pull-right alert-button btn btn-success",
    disabled: isSaving || !getIsDirty(),
    onClick: onSave,
    type: "button"
  }, isSaving ? 'Saving...' : 'Save')))));
});
ProjectDataTypeSelections.defaultProps = {
  dataTypePrefix: '',
  panelTitle: 'Data in Project',
  panelDescription: 'Select the types of data that will be used in this project.',
  showUncheckedWarning: true
};
ProjectDataTypeSelections.displayName = 'ProjectDataTypeSelections';
;// CONCATENATED MODULE: ./src/internal/components/administration/useAdminAppContext.ts
// If your App extends AppContext to add attributes other than Admin use this e.g.:
// type MyAppContext = ExtendableAppContext<WithMyAppContext & WithAdminAppContext>;


// If your App only extends the AppContext to add support for SampleType use this.

const useAdminAppContext = () => {
  const appContext = useAppContext();
  if (appContext.admin === undefined) {
    throw new Error('AppContext was not initialized with an admin attribute (AdminAppContext)');
  }
  return appContext.admin;
};
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainFieldLabel.tsx



const DomainFieldLabel = props => {
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, getSplitSentence(props.label, false), /*#__PURE__*/external_react_default().createElement("span", {
    className: "domain-no-wrap"
  }, getSplitSentence(props.label, true), props.helpTipBody && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    title: props.label,
    required: props.required
  }, props.helpTipBody), props.required ? ' *' : ''));
};
;// CONCATENATED MODULE: ./src/internal/components/labelPrinting/LabelsConfigurationPanel.tsx















const TITLE = 'Manage Label Templates';
const NEW_LABEL_INDEX = -1;
const SAVING_LOCKED_TIP = 'Currently saving';
const SAVING_LOCKED_TITLE = 'Saving';
const LabelTemplatesList = (0,external_react_.memo)(props => {
  const {
    onSelect,
    defaultLabel,
    selected,
    templates
  } = props;
  const isDefault = (0,external_react_.useCallback)(rowId => {
    return rowId === defaultLabel ? /*#__PURE__*/external_react_default().createElement("div", {
      className: "badge"
    }, "default") : undefined;
  }, [defaultLabel]);
  if (!templates || templates.length === 0) return /*#__PURE__*/external_react_default().createElement("div", {
    className: "choices-list__empty-message"
  }, "No label templates registered.");
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "list-group"
  }, templates.map((template, index) => /*#__PURE__*/external_react_default().createElement(ChoicesListItem, {
    active: index === selected,
    index: index,
    subLabel: template.path,
    key: template.rowId,
    label: template.name,
    onSelect: onSelect,
    componentRight: isDefault(template.rowId)
  }))));
});
const normalizeValues = template => {
  if (!template) throw Error('Unable to save, invalid template');
  return new LabelTemplate({
    name: template.name?.trim(),
    description: template.description,
    path: template.path?.trim(),
    rowId: template.rowId,
    container: template.container
  });
};
const canBeDefault = template => {
  const currentContainer = (0,api_.getServerContext)().container;
  return !template ||
  // New template
  currentContainer.parentId === template.container ||
  // Template is from the project level
  currentContainer.id === template.container // Template is from this project
  ;
};
const LabelTemplateDetails = (0,external_react_.memo)(props => {
  const {
    api,
    template,
    isNew,
    onChange,
    onActionCompleted,
    defaultLabel,
    onDefaultChanged,
    isDefaultable,
    container
  } = props;
  const [updatedTemplate, setUpdateTemplate] = (0,external_react_.useState)();
  // TODO is this needed since the Dirty state is tracked in the parent component?
  const [dirty, setDirty] = (0,external_react_.useState)();
  const [saving, setSaving] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  const [showDeleteConfirm, setShowDeleteConfirm] = (0,external_react_.useState)(false);
  const [isDefault, setIsDefault] = (0,external_react_.useState)(false);
  (0,external_react_.useEffect)(() => {
    setIsDefault(!!defaultLabel && defaultLabel === template?.rowId);
  }, [defaultLabel, template?.rowId]);

  // Clear error if Template changes
  (0,external_react_.useEffect)(() => {
    setError(undefined);
  }, [template]);
  (0,external_react_.useEffect)(() => {
    if (isNew) {
      setUpdateTemplate(new LabelTemplate({}));
      onChange();
    } else {
      setUpdateTemplate(template);
    }
    setDirty(isNew);
  }, [isNew, onChange, template]);
  const onCancel = (0,external_react_.useCallback)(() => {
    onActionCompleted(undefined, true);
  }, [onActionCompleted]);
  const defaultToggleHandler = (0,external_react_.useCallback)(event => {
    const value = event.target.checked;
    setDirty(dirty || value !== isDefault);
    setIsDefault(value);
    onChange?.();
  }, [dirty, isDefault, onChange]);
  const onToggleDeleteConfirm = (0,external_react_.useCallback)(() => setShowDeleteConfirm(!showDeleteConfirm), [showDeleteConfirm]);
  const onConfirmDelete = (0,external_react_.useCallback)(() => {
    if (updatedTemplate.rowId) {
      api.query.deleteRows({
        schemaQuery: LABEL_TEMPLATE_SQ,
        rows: [updatedTemplate],
        containerPath: updatedTemplate.container
      }).then(() => {
        onToggleDeleteConfirm();
        onActionCompleted(undefined, true);
      }).catch(reason => {
        setError(resolveErrorMessage(reason.get('error'), 'template', 'templates', 'deleting'));
        onToggleDeleteConfirm();
      });
    } else {
      onToggleDeleteConfirm();
    }
  }, [api, updatedTemplate, onActionCompleted, onToggleDeleteConfirm]);
  const onFormChange = (0,external_react_.useCallback)(evt => {
    const {
      name,
      value
    } = evt.target;
    setUpdateTemplate(updatedTemplate.set(name, value));
    setDirty(true);
    setError(undefined); // clear error if form changes
    onChange();
  }, [updatedTemplate, onChange]);
  const onSave = (0,external_react_.useCallback)(async () => {
    setError(undefined);
    setSaving(true);
    const templateToSave = normalizeValues(updatedTemplate);
    let rowId = templateToSave?.rowId;
    try {
      if (rowId) {
        await api.query.updateRows({
          schemaQuery: LABEL_TEMPLATE_SQ,
          rows: [templateToSave],
          containerPath: templateToSave.container
        });
      } else {
        const response = await api.query.insertRows({
          schemaQuery: LABEL_TEMPLATE_SQ,
          rows: (0,external_immutable_.List)([templateToSave]),
          containerPath: container.path
        });
        rowId = response?.rows[0]?.rowId;
      }
      if (isDefault && defaultLabel !== rowId || defaultLabel === rowId && !isDefault) {
        const newBtConfig = await api.labelprinting.saveDefaultLabelConfiguration({
          defaultLabel: isDefault ? rowId : undefined
        });
        if (defaultLabel !== newBtConfig.defaultLabel) {
          onDefaultChanged?.(isNaN(newBtConfig.defaultLabel) ? undefined : newBtConfig.defaultLabel);
        }
      }
      setDirty(false);
      onActionCompleted(rowId);
    } catch (reason) {
      const exception = reason?.error ?? reason;
      setError(resolveErrorMessage(exception, 'template', 'templates', 'update'));
    } finally {
      setSaving(false);
    }
  }, [api, container.path, defaultLabel, isDefault, onActionCompleted, onDefaultChanged, updatedTemplate]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !updatedTemplate && template !== null && /*#__PURE__*/external_react_default().createElement("div", {
    className: "choices-detail__empty-message"
  }, "Select template to view details."), updatedTemplate && /*#__PURE__*/external_react_default().createElement("form", {
    className: "form-horizontal content-form choices-detail__form"
  }, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Name",
    required: true
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control",
    name: "name",
    onChange: onFormChange,
    disabled: saving,
    placeholder: "Enter label template's display name",
    type: "text",
    value: updatedTemplate.name ?? ''
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Description"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/external_react_default().createElement("textarea", {
    className: "form-control",
    name: "description",
    onChange: onFormChange,
    disabled: saving,
    value: updatedTemplate.description ?? ''
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "File Path",
    required: true
  }), /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    title: "BarTender Label Template"
  }, /*#__PURE__*/external_react_default().createElement("p", null, "Provide the label template to use with BarTender. The path should be relative to the default folder configured in the BarTender web service."))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control",
    name: "path",
    onChange: onFormChange,
    disabled: saving,
    placeholder: "Enter relative path to label template",
    type: "text",
    value: updatedTemplate.path ?? ''
  }))), isDefaultable && /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Default Template"
  })), /*#__PURE__*/external_react_default().createElement("input", {
    style: {
      margin: '0 15px'
    },
    name: "isDefault",
    checked: isDefault,
    type: "checkbox",
    onChange: defaultToggleHandler
  })), /*#__PURE__*/external_react_default().createElement("div", null, !isNew && /*#__PURE__*/external_react_default().createElement(DisableableButton, {
    disabledMsg: saving ? SAVING_LOCKED_TIP : undefined,
    onClick: onToggleDeleteConfirm,
    title: SAVING_LOCKED_TITLE
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-trash"
  }), /*#__PURE__*/external_react_default().createElement("span", null, "\xA0Delete")), isNew && /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default",
    disabled: saving,
    onClick: onCancel,
    type: "button"
  }, "Cancel"), /*#__PURE__*/external_react_default().createElement("button", {
    className: "pull-right btn btn-success",
    disabled: !dirty || saving,
    onClick: onSave,
    type: "button"
  }, saving ? 'Saving...' : 'Save'))), showDeleteConfirm && /*#__PURE__*/external_react_default().createElement(Modal, {
    confirmText: "Yes, Delete",
    title: "Delete Label Template",
    onCancel: onToggleDeleteConfirm,
    onConfirm: onConfirmDelete,
    confirmClass: "btn-danger"
  }, /*#__PURE__*/external_react_default().createElement("div", null, "The ", /*#__PURE__*/external_react_default().createElement("b", null, updatedTemplate.name), " label template will be deleted.", /*#__PURE__*/external_react_default().createElement("strong", null, "This cannot be undone."), " Do you wish to proceed?")));
});
const LabelsConfigurationPanel = (0,external_react_.memo)(props => {
  const {
    api,
    setIsDirty,
    defaultLabel,
    container
  } = props;
  const {
    user
  } = useServerContext();
  const [templates, setTemplates] = (0,external_react_.useState)([]);
  const [error, setError] = (0,external_react_.useState)();
  const [selected, setSelected] = (0,external_react_.useState)();
  const [newDefaultLabel, setNewDefaultLabel] = (0,external_react_.useState)(defaultLabel);
  const addNew = (0,external_react_.useMemo)(() => selected === NEW_LABEL_INDEX, [selected]);
  const queryLabelTemplates = (0,external_react_.useCallback)(newLabelTemplate => {
    setError(undefined);
    api.labelprinting.ensureLabelTemplatesList(user, container.path).then(labelTemplates => {
      setTemplates(labelTemplates ?? []);
      if (newLabelTemplate) {
        setSelected(labelTemplates.findIndex(template => template.rowId === newLabelTemplate));
      }
    }).catch(() => {
      setError('Error: Unable to load label templates.');
    });
  }, [api, user]);

  // Load template list
  (0,external_react_.useEffect)(() => {
    queryLabelTemplates();
  }, [queryLabelTemplates]);
  const onSetSelected = (0,external_react_.useCallback)(index => {
    // Clear dirty state since we are clearing any changes on selection
    if (index !== selected) setIsDirty(false);
    setSelected(index);
  }, [selected, setIsDirty]);
  const onAddLabel = (0,external_react_.useCallback)(() => {
    setSelected(NEW_LABEL_INDEX);
  }, []);
  const onChange = (0,external_react_.useCallback)(() => {
    setIsDirty(true);
  }, [setIsDirty]);
  const onDefaultChanged = (0,external_react_.useCallback)(newDefault => {
    setNewDefaultLabel(newDefault);
  }, []);
  const onActionCompleted = (0,external_react_.useCallback)((newLabelTemplate, isDelete = false) => {
    setIsDirty(false);
    queryLabelTemplates(newLabelTemplate);
    if (isDelete) setSelected(undefined);
  }, [queryLabelTemplates, setIsDirty]);
  const template = !templates.length ? null : templates[selected];
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default label-templates-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__bold-text"
  }, TITLE), /*#__PURE__*/external_react_default().createElement("div", null, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), !templates && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), templates && !error && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row choices-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-lg-4 col-md-6 choices-container-left-panel"
  }, /*#__PURE__*/external_react_default().createElement(LabelTemplatesList, {
    templates: templates,
    selected: selected,
    onSelect: onSetSelected,
    defaultLabel: newDefaultLabel
  }), /*#__PURE__*/external_react_default().createElement(AddEntityButton, {
    onClick: onAddLabel,
    entity: "New Label Template",
    disabled: addNew
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-lg-8 col-md-6"
  }, /*#__PURE__*/external_react_default().createElement(LabelTemplateDetails
  // use null to indicate that no label templates exist to be selected, so don't show the empty message
  , {
    template: template,
    isNew: addNew,
    onActionCompleted: onActionCompleted,
    onChange: onChange,
    defaultLabel: newDefaultLabel,
    api: api,
    onDefaultChanged: onDefaultChanged,
    isDefaultable: canBeDefault(template),
    container: container
  })))));
});
;// CONCATENATED MODULE: ./src/internal/components/labelPrinting/BarTenderSettingsForm.tsx
function BarTenderSettingsForm_extends() { return BarTenderSettingsForm_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, BarTenderSettingsForm_extends.apply(null, arguments); }












const SUCCESSFUL_NOTIFICATION_MESSAGE = 'Successfully connected to BarTender web service.';
const FAILED_NOTIFICATION_MESSAGE = 'Failed to connect to BarTender web service.';
const UNKNOWN_STATUS_MESSAGE = 'Unrecognized status code returned from BarTender service';
const FAILED_TO_SAVE_MESSAGE = 'Failed to save connection configuration';
const SettingsInput = (0,external_react_.memo)(({
  children,
  description,
  label,
  name,
  onChange,
  type,
  value
}) => {
  const onChange_ = (0,external_react_.useCallback)(event => {
    onChange(name, event.target.value);
  }, [name, onChange]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", null, children, /*#__PURE__*/external_react_default().createElement("div", null, label, ' ', /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    title: label
  }, /*#__PURE__*/external_react_default().createElement("p", null, description)))), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control",
    type: type,
    id: name,
    name: name,
    value: value,
    onChange: onChange_,
    placeholder: "BarTender Web Service URL"
  })));
});
const btTestConnectionTemplate = () => {
  // This will fail script validation, but will have status "RanToCompletion" which means that the server was successfully
  // connected to. Issue #48014
  return `<XMLScript Version="2.0">
            <Command Name="Job1">
            </Command>
        </XMLScript>`;
};

// exported for jest testing
const BarTenderSettingsForm = (0,external_react_.memo)(props => {
  const {
    api,
    container,
    title = BARTENDER_CONFIGURATION_TITLE,
    onChange,
    onSuccess
  } = props;
  const [btServiceURL, setBtServiceURL] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  const [defaultLabel, setDefaultLabel] = (0,external_react_.useState)();
  const {
    moduleContext
  } = useServerContext();
  const [dirty, setDirty] = (0,external_react_.useState)(false);
  const [submitting, setSubmitting] = (0,external_react_.useState)(false);
  const [testing, setTesting] = (0,external_react_.useState)();
  const [connectionValidated, setConnectionValidated] = (0,external_react_.useState)();
  const [failureMessage, setFailureMessage] = (0,external_react_.useState)();
  const [loading, setLoading] = (0,external_react_.useState)(true);
  const containerPath = container?.path;
  (0,external_react_.useEffect)(() => {
    (async () => {
      try {
        const btConfiguration = await api.labelprinting.fetchBarTenderConfiguration(containerPath);
        setBtServiceURL(btConfiguration.serviceURL);
        setDefaultLabel(btConfiguration.defaultLabel);
        setError(undefined);
      } catch (e) {
        setError(resolveErrorMessage(e) ?? 'Failed to load BarTender configuration.');
      } finally {
        setLoading(false);
      }
    })();
  }, [api, containerPath]);
  const onChangeHandler = (0,external_react_.useCallback)((name, value) => {
    setBtServiceURL(value);
    setDirty(true);
    setConnectionValidated(undefined);
    onChange?.();
  }, [onChange]);
  const onSave = (0,external_react_.useCallback)(async () => {
    setSubmitting(true);
    setFailureMessage(undefined); // Will update with new message if still needed.
    const config = new BarTenderConfiguration({
      serviceURL: btServiceURL
    });
    try {
      const btConfig = await api.labelprinting.saveBarTenderURLConfiguration(config, containerPath);
      setBtServiceURL(btConfig.serviceURL);
      setDirty(false);
      onSuccess?.();
    } catch (e) {
      setFailureMessage(resolveErrorMessage(e) ?? FAILED_TO_SAVE_MESSAGE);
      setConnectionValidated(false);
    } finally {
      setSubmitting(false);
    }
  }, [api, btServiceURL, containerPath, onSuccess]);
  const onConnectionFailure = (0,external_react_.useCallback)(message => {
    setTesting(false);
    setConnectionValidated(false);
    setFailureMessage(message);
  }, []);
  const onVerifyBarTenderConfiguration = (0,external_react_.useCallback)(() => {
    setTesting(true);
    api.labelprinting.printBarTenderLabels(btTestConnectionTemplate(), btServiceURL).then(btResponse => {
      if (btResponse.ranToCompletion()) {
        setTesting(false);
        setConnectionValidated(true);
        setFailureMessage(undefined);
      } else if (btResponse.faulted()) {
        onConnectionFailure(btResponse.getFaultMessage());
      } else {
        onConnectionFailure(UNKNOWN_STATUS_MESSAGE);
      }
    }).catch(() => {
      onConnectionFailure(FAILED_NOTIFICATION_MESSAGE);
    });
  }, [api, btServiceURL, onConnectionFailure]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default",
    title: title
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, title), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), loading && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), !loading && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, connectionValidated && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "success"
  }, SUCCESSFUL_NOTIFICATION_MESSAGE)), connectionValidated === false && /*#__PURE__*/external_react_default().createElement(Alert, null, failureMessage), /*#__PURE__*/external_react_default().createElement(SettingsInput, {
    description: "URL of the BarTender service to use when printing labels.",
    label: "BarTender Web Service URL",
    name: "btServiceURL",
    onChange: onChangeHandler,
    type: "url",
    value: btServiceURL
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "pull-right"
  }, /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: BAR_TENDER_TOPIC,
    className: "label-printing--help-link"
  }, "Learn more about BarTender"))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "bt-service-buttons"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "pull-right alert-button btn btn-success",
    disabled: submitting || !dirty || testing,
    onClick: onSave,
    type: "button"
  }, "Save"), /*#__PURE__*/external_react_default().createElement("button", {
    className: "button-right-spacing pull-right btn btn-default",
    disabled: !btServiceURL || btServiceURL.trim() === '',
    onClick: onVerifyBarTenderConfiguration,
    type: "button"
  }, "Test Connection")), isAppHomeFolder(container, moduleContext) && /*#__PURE__*/external_react_default().createElement("div", {
    className: "label-templates-panel"
  }, /*#__PURE__*/external_react_default().createElement(LabelsConfigurationPanel, BarTenderSettingsForm_extends({}, props, {
    api: api,
    defaultLabel: defaultLabel,
    container: container
  }))))));
});
BarTenderSettingsForm.defaultProps = {
  api: getDefaultAPIWrapper()
};
BarTenderSettingsForm.displayName = 'BarTenderSettingsForm';
;// CONCATENATED MODULE: ./src/internal/components/settings/NameIdSettings.tsx
function NameIdSettings_extends() { return NameIdSettings_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, NameIdSettings_extends.apply(null, arguments); }
function NameIdSettings_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NameIdSettings_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NameIdSettings_ownKeys(Object(t), !0).forEach(function (r) { NameIdSettings_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NameIdSettings_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function NameIdSettings_defineProperty(e, r, t) { return (r = NameIdSettings_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function NameIdSettings_toPropertyKey(t) { var i = NameIdSettings_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function NameIdSettings_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }















const NameIdSettings_TITLE = 'ID/Name Settings';
const initialState = {
  error: undefined,
  loadingNamingOptions: true,
  loadingCounters: true,
  prefix: '',
  prefixIneligibleSampleTypeNames: [],
  savingPrefix: false,
  confirmModalOpen: false,
  allowUserSpecifiedNames: false,
  savingAllowUserSpecifiedNames: false,
  hasPrefixChange: false,
  hasSampleCountChange: false,
  hasRootSampleCountChange: false
};
const NameIdSettingsForm = props => {
  const {
    api,
    loadNameExpressionOptions,
    saveNameExpressionOptions,
    setIsDirty,
    isAppHome,
    container
  } = props;
  const [state, setState] = (0,external_react_.useReducer)((currentState, newState) => NameIdSettings_objectSpread(NameIdSettings_objectSpread({}, currentState), newState), initialState);
  const {
    moduleContext
  } = useServerContext();
  const {
    loadingCounters,
    loadingNamingOptions,
    savingAllowUserSpecifiedNames,
    allowUserSpecifiedNames,
    prefix,
    prefixIneligibleSampleTypeNames,
    savingPrefix,
    confirmModalOpen,
    error,
    confirmCounterModalOpen,
    isRoot,
    isReset,
    updatingCounter,
    hasRootSamples,
    hasSamples,
    rootSampleCount,
    sampleCount,
    newSampleCount,
    newRootSampleCount,
    hasPrefixChange,
    hasSampleCountChange,
    hasRootSampleCountChange
  } = state;
  const initializeNamingPattern = async () => {
    try {
      const payload = await loadNameExpressionOptions(container.path);
      setState({
        prefix: payload.prefix ?? '',
        allowUserSpecifiedNames: payload.allowUserSpecifiedNames,
        loadingNamingOptions: false
      });
    } catch (err) {
      setState({
        error: err.exception,
        loadingNamingOptions: false
      });
    }
  };
  const initialize = async () => {
    try {
      if (isAppHome) {
        const sampleCount = await api.samples.getSampleCounter('sampleCount'); // show the next value
        const rootSampleCount = await api.samples.getSampleCounter('rootSampleCount');
        let hasRootSamples = false,
          hasSamples = false;
        if (sampleCount > 0) hasSamples = await api.samples.hasExistingSamples(false);
        if (rootSampleCount > 0) hasRootSamples = await api.samples.hasExistingSamples(true);
        setState({
          loadingCounters: false,
          sampleCount,
          rootSampleCount,
          newSampleCount: sampleCount,
          newRootSampleCount: rootSampleCount,
          hasSamples,
          hasRootSamples
        });
      }
    } catch (err) {
      setState({
        error: err.exception,
        loadingCounters: false
      });
    }
  };
  (0,external_react_.useEffect)(() => {
    initializeNamingPattern();
    initialize();
  }, [isAppHome, container]);
  const displayError = err => {
    setState({
      error: err.exception ?? 'Error saving setting',
      savingAllowUserSpecifiedNames: false
    });
  };
  const saveAllowUserSpecifiedNames = (0,external_react_.useCallback)(async () => {
    setState({
      savingAllowUserSpecifiedNames: true
    });
    try {
      await saveNameExpressionOptions('allowUserSpecifiedNames', !allowUserSpecifiedNames, container.path);

      // Issue 44250: the sample type and data class queryInfo details for the name column will set the
      // setShownInInsertView based on this allowUserSpecifiedNames setting so we need to invalidate the cache
      // so that the updated information is retrieved for that table/query.
      invalidateFullQueryDetailsCache();
      setState({
        allowUserSpecifiedNames: !allowUserSpecifiedNames,
        savingAllowUserSpecifiedNames: false
      });
    } catch (err) {
      displayError(err);
    }
  }, [allowUserSpecifiedNames, saveNameExpressionOptions, container.path]);
  const savePrefix = (0,external_react_.useCallback)(async () => {
    setState({
      savingPrefix: true
    });
    let response;
    try {
      response = await saveNameExpressionOptions('prefix', prefix, container.path);
    } catch (err) {
      displayError(err);
    }
    setState({
      savingPrefix: false,
      confirmModalOpen: false,
      hasPrefixChange: false,
      prefixIneligibleSampleTypeNames: response ?? []
    });
    setIsDirty(false);
  }, [prefix, saveNameExpressionOptions, setIsDirty, container.path]);
  const prefixOnChange = (0,external_react_.useCallback)(evt => {
    const val = evt.target.value;
    setState({
      prefix: val,
      hasPrefixChange: true
    });
    setIsDirty(true);
  }, [setIsDirty]);
  const openConfirmModal = (0,external_react_.useCallback)(() => {
    setState({
      confirmModalOpen: true
    });
  }, []);
  const closeConfirmModal = (0,external_react_.useCallback)(() => {
    setState({
      confirmModalOpen: false
    });
  }, []);
  const openSetCounterConfirmModal = (0,external_react_.useCallback)((isRoot_, isReset_) => {
    setState({
      confirmCounterModalOpen: true,
      isReset: isReset_,
      isRoot: isRoot_
    });
  }, []);
  const closeCounterConfirmModal = (0,external_react_.useCallback)(() => {
    setState({
      confirmCounterModalOpen: false
    });
  }, []);
  const setNewSampleCount = (0,external_react_.useCallback)((newValue, root) => {
    if (root) {
      setState({
        hasRootSampleCountChange: true,
        newRootSampleCount: newValue
      });
    } else {
      setState({
        hasSampleCountChange: true,
        newSampleCount: newValue
      });
    }
    setIsDirty(true);
  }, [setIsDirty]);
  const saveSampleCounter = (0,external_react_.useCallback)(async () => {
    const newCount = isReset ? 0 : isRoot ? newRootSampleCount : newSampleCount;
    try {
      await api.samples.saveSampleCounter(newCount, isRoot ? 'rootSampleCount' : 'sampleCount');
      if (isRoot) setState({
        rootSampleCount: newCount,
        confirmCounterModalOpen: false,
        newRootSampleCount: newCount,
        error: undefined,
        prefixIneligibleSampleTypeNames: [],
        hasRootSampleCountChange: false
      });else setState({
        sampleCount: newCount,
        confirmCounterModalOpen: false,
        newSampleCount: newCount,
        error: undefined,
        prefixIneligibleSampleTypeNames: [],
        hasSampleCountChange: false
      });
      setIsDirty(false);
    } catch (error) {
      if (isRoot) {
        setState({
          error,
          confirmCounterModalOpen: false,
          newRootSampleCount: rootSampleCount
        });
      } else {
        setState({
          error,
          confirmCounterModalOpen: false,
          newSampleCount: sampleCount
        });
      }
    }
  }, [isRoot, isReset, newRootSampleCount, newSampleCount, setIsDirty, rootSampleCount, sampleCount]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "name-id-settings-panel panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, NameIdSettings_TITLE), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, error !== undefined && /*#__PURE__*/external_react_default().createElement(Alert, {
    className: "name-id-setting__error"
  }, error), prefixIneligibleSampleTypeNames.length > 0 && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "success",
    className: "name-id-setting__error"
  }, "Prefix updated. The following were ineligible and excluded:", /*#__PURE__*/external_react_default().createElement("ul", null, prefixIneligibleSampleTypeNames.map(name => /*#__PURE__*/external_react_default().createElement("li", {
    key: name
  }, name)))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "name-id-setting__setting-section"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__bold-text margin-bottom"
  }, "User-defined IDs/Names"), loadingNamingOptions && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), !loadingNamingOptions && /*#__PURE__*/external_react_default().createElement("form", null, /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
    name: "allowUserSpecifiedNames",
    onChange: saveAllowUserSpecifiedNames,
    disabled: savingAllowUserSpecifiedNames,
    checked: allowUserSpecifiedNames
  }, "Allow users to create/import their own IDs/Names in this folder", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    title: "User Defined ID/Names"
  }, /*#__PURE__*/external_react_default().createElement("p", null, "When users are not permitted to create their own IDs/Names, the ID/Name field will be hidden during creation and update of rows, and when accessing the design of a new or existing Sample Type or", ' ', sampleManagerIsPrimaryApp(moduleContext) ? 'Source Type' : 'Data Class', "."), /*#__PURE__*/external_react_default().createElement("p", null, "Additionally, attempting to import data and update existing rows during file import will result in an error if a new ID/Name is encountered."))))), biologicsIsPrimaryApp(moduleContext) && /*#__PURE__*/external_react_default().createElement("div", {
    className: "name-id-setting__setting-section"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__bold-text margin-bottom margin-top"
  }, "ID/Name Prefix"), /*#__PURE__*/external_react_default().createElement("div", null, "Enter a prefix to use with every Naming Pattern when new IDs/Names are created in this project. No existing IDs/Names will be changed."), loadingNamingOptions && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), !loadingNamingOptions && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "name-id-setting__prefix"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "name-id-setting__prefix-label"
  }, " Prefix: "), /*#__PURE__*/external_react_default().createElement("div", {
    className: "name-id-setting__prefix-field"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control",
    name: "prefix",
    type: "text",
    placeholder: "Enter Prefix",
    onChange: prefixOnChange,
    value: prefix
  })), /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-success",
    onClick: openConfirmModal,
    disabled: savingPrefix || !hasPrefixChange,
    type: "button"
  }, "Apply Prefix")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "name-id-setting__prefix-example"
  }, "Example: ", prefix, "Blood-$", '{', "GenId", '}'), confirmModalOpen && /*#__PURE__*/external_react_default().createElement(Modal, {
    confirmClass: "btn-danger",
    title: "Apply Prefix?",
    onCancel: closeConfirmModal,
    onConfirm: savePrefix,
    confirmText: "Yes, Save and Apply Prefix"
  }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, "This action will change the Naming Pattern for all new and existing Sample Types and", ' ', sampleManagerIsPrimaryApp(moduleContext) ? 'Source Types' : 'Data Classes', ". No existing IDs/Names will be affected but any new IDs/Names will have the prefix applied. Are you sure you want to apply the prefix?"))))), isAppHome && /*#__PURE__*/external_react_default().createElement("div", {
    className: "sample-counter__setting-section margin-top"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__bold-text margin-bottom"
  }, "Naming Pattern Elements/Tokens"), /*#__PURE__*/external_react_default().createElement("div", null, "The following tokens/counters are utilized in naming patterns for the application and all projects. To modify a counter, simply enter a number greater than the current value and click \u201CApply\u201D. Please be aware that once a counter is changed, the action cannot be reversed. For additional information regarding these tokens, you can refer to this", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: SAMPLE_TYPE_NAME_EXPRESSION_TOPIC
  }, "link"), "."), loadingCounters && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), !loadingCounters && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row margin-top"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-2"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "sample-counter__prefix-label"
  }, "sampleCount")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-2"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control update-samplecount-input",
    min: sampleCount,
    step: 1,
    name: "newSampleCount",
    onChange: event => setNewSampleCount(event?.target?.value, false),
    type: "number",
    value: newSampleCount,
    placeholder: "Enter new sampleCount..."
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-success sample-counter-btn",
    onClick: () => {
      openSetCounterConfirmModal(false, false);
    },
    disabled: updatingCounter || !hasSampleCountChange,
    type: "button"
  }, "Apply New sampleCount"), !hasSamples && sampleCount > 0 && /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-success sample-counter-btn",
    onClick: () => {
      openSetCounterConfirmModal(false, true);
    },
    disabled: updatingCounter,
    type: "button"
  }, "Reset sampleCount"))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row margin-top"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-2"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "sample-counter__prefix-label"
  }, "rootSampleCount")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-2"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control update-samplecount-input",
    min: rootSampleCount,
    step: 1,
    name: "newRootSampleCount",
    onChange: event => setNewSampleCount(event?.target?.value, true),
    type: "number",
    value: newRootSampleCount,
    placeholder: "Enter new rootSampleCount..."
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-success sample-counter-btn",
    onClick: () => {
      openSetCounterConfirmModal(true, false);
    },
    disabled: updatingCounter || !hasRootSampleCountChange,
    type: "button"
  }, "Apply New rootSampleCount"), !hasRootSamples && rootSampleCount > 0 && /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-success sample-counter-btn",
    onClick: () => {
      openSetCounterConfirmModal(true, true);
    },
    disabled: updatingCounter,
    type: "button"
  }, "Reset rootSampleCount"))), confirmCounterModalOpen && /*#__PURE__*/external_react_default().createElement(Modal, {
    confirmClass: "btn-danger",
    title: (isReset ? 'Reset ' : 'Update ') + (isRoot ? 'rootSampleCount' : 'sampleCount'),
    onCancel: closeCounterConfirmModal,
    onConfirm: saveSampleCounter,
    confirmText: 'Yes, ' + (isReset ? 'Reset' : 'Update')
  }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, "This action will change the ", isRoot ? 'rootSampleCount' : 'sampleCount', ' ', "from ", isRoot ? rootSampleCount : sampleCount, " to", ' ', isReset ? 0 : isRoot ? newRootSampleCount : newSampleCount, " for the application and all projects. Are you sure you want to proceed? This action cannot be undone.")))))));
};
const NameIdSettings = (0,external_react_.memo)(props => {
  return /*#__PURE__*/external_react_default().createElement(RequiresPermission, {
    perms: api_.PermissionTypes.Admin
  }, /*#__PURE__*/external_react_default().createElement(NameIdSettingsForm, NameIdSettings_extends({}, props, {
    saveNameExpressionOptions: saveNameExpressionOptions,
    loadNameExpressionOptions: loadNameExpressionOptions
  })));
});
NameIdSettings.defaultProps = {
  api: getDefaultAPIWrapper()
};
;// CONCATENATED MODULE: ./src/internal/components/administration/ProtectedDataSettingsPanel.tsx




const ProtectedDataSettingsPanel = (0,external_react_.memo)(props => {
  const {
    containerPath
  } = props;
  return /*#__PURE__*/external_react_default().createElement(RequiresPermission, {
    perms: api_.PermissionTypes.Admin
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Protected Data Settings"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/external_react_default().createElement(Setting, {
    getUrl: api_.ActionURL.buildURL('biologics', 'getProtectedDataSettings.api', containerPath),
    label: "Require 'Restricted PHI' permission to view nucleotide and protein sequences.",
    name: "protectedSequences",
    setUrl: api_.ActionURL.buildURL('biologics', 'setProtectedDataSettings.api', containerPath)
  }))));
});
;// CONCATENATED MODULE: ./src/internal/util/RouteLeave.tsx


const CONFIRM_MESSAGE = 'You have unsaved changes that will be lost. Are you sure you want to continue?';
/**
 * The useRouteLeave hook is useful if you want to display a confirmation dialog when the user tries to navigate away
 * from a "dirty" form or page. This hook ties into both the React Router RouteLeave event, and the browser beforeunload
 * event. This allows us to prevent navigation via back button, link clicking, or browser window/tab closing.
 * @param confirmMessage: The confirm message you want to display to the user, this message is only displayed when
 * navigating away from the page, not when closing the tab or browser window. Browsers do not let you customize the
 * message displayed when the browser/tab is closed.
 */
const useRouteLeave = (confirmMessage = CONFIRM_MESSAGE) => {
  const isDirty = (0,external_react_.useRef)(false);
  const setIsDirty = (0,external_react_.useCallback)(dirty => {
    isDirty.current = dirty;
  }, [isDirty]);
  const getIsDirty = (0,external_react_.useCallback)(() => {
    return isDirty.current;
  }, []);

  // usePrompt prevents users from going to URLs within our App
  (0,external_react_router_dom_.unstable_usePrompt)({
    when: getIsDirty,
    message: confirmMessage
  });

  // BeforeUnload is needed so we can prevent the user from going to URLs outside our App (e.g. to FM or LKS)
  const beforeUnload = (0,external_react_.useCallback)(event => {
    if (getIsDirty() === true) {
      event.returnValue = true;
    }
  }, [getIsDirty]);
  (0,external_react_.useEffect)(() => {
    window.addEventListener('beforeunload', beforeUnload);
    return () => {
      window.removeEventListener('beforeunload', beforeUnload);
    };
  }, [beforeUnload]);
  return [getIsDirty, setIsDirty];
};
;// CONCATENATED MODULE: ./src/internal/components/project/DeleteProjectModal.tsx








const DeleteProjectModal = (0,external_react_.memo)(props => {
  const {
    project,
    onCancel,
    onError,
    onDeleteSuccess
  } = props;
  const [summaries, setSummaries] = (0,external_react_.useState)([]);
  const [comment, setComment] = (0,external_react_.useState)(undefined);
  const [error, setError] = (0,external_react_.useState)(undefined);
  const [isLoading, setIsLoading] = (0,external_react_.useState)(true);
  const [isDeleting, setIsDeleting] = (0,external_react_.useState)(false);
  const {
    api
  } = useAppContext();
  const {
    container
  } = useServerContext();
  const projectName = project?.name;
  (0,external_react_.useEffect)(() => {
    (async () => {
      try {
        const allSummaries = await api.security.getDeletionSummaries();
        setSummaries(allSummaries);
        setIsLoading(false);
      } catch (e) {
        // getDeletionSummaries() handles error logging
        setError(resolveErrorMessage(e));
        setIsLoading(false);
      }
    })();
  }, [api.security]);
  const onHide = (0,external_react_.useCallback)(() => {
    if (!isDeleting) onCancel();
  }, [isDeleting, onCancel]);
  const onChangeComment = (0,external_react_.useCallback)(e => {
    setComment(e.target.value);
  }, []);
  const onDeleteProject = (0,external_react_.useCallback)(async () => {
    setIsDeleting(true);
    try {
      await api.security.deleteContainer({
        comment,
        containerPath: project.path
      });
      onDeleteSuccess();
    } catch (e) {
      onError(resolveErrorMessage(e) ?? `${projectName} could not be deleted. Please try again.`);
    }
  }, [api.security, comment, container.parentPath, onError, projectName, onDeleteSuccess]);
  const totalCountFromSummaries = (0,external_react_.useMemo)(() => summaries.reduce((prev, curr) => {
    return prev + curr.count;
  }, 0) ?? 0, [summaries]);
  const noData = !isLoading && summaries.length === 0 && !error;
  let body;
  let titleText = `Permanently delete ${projectName}?`;
  if (isDeleting) {
    body = /*#__PURE__*/external_react_default().createElement("div", {
      className: "deleting-project-modal-text"
    }, "Please don't close this page until deletion is complete.");
    titleText = 'Deleting project';
  } else if (noData) {
    body = /*#__PURE__*/external_react_default().createElement("div", {
      className: "delete-project-modal__text"
    }, /*#__PURE__*/external_react_default().createElement("p", null, "This project will be permanently deleted. It contains no data."));
  } else {
    body = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "delete-project-modal__text"
    }, /*#__PURE__*/external_react_default().createElement("p", null, "This project and all of its data will be permanently deleted."), /*#__PURE__*/external_react_default().createElement("p", null, "Before deleting this project, ensure there are no references to data (samples, sources or registry, assay data, etc.) in other projects.")), /*#__PURE__*/external_react_default().createElement("b", null, " Project Data "), error && /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "danger"
    }, error), !error && isLoading ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
      wrapperClassName: "delete-project-modal__spinner"
    }) : /*#__PURE__*/external_react_default().createElement("table", {
      className: "table table-responsive table-condensed delete-project-modal__table "
    }, /*#__PURE__*/external_react_default().createElement("tbody", null, summaries.map(s => /*#__PURE__*/external_react_default().createElement("tr", {
      key: s.count + s.noun
    }, /*#__PURE__*/external_react_default().createElement("td", null, s.noun), /*#__PURE__*/external_react_default().createElement("td", null, s.count))))));
  }
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    confirmClass: "btn-danger",
    confirmText: "Yes, Delete",
    isConfirming: isDeleting,
    onCancel: isDeleting ? undefined : onHide,
    onConfirm: isDeleting ? undefined : onDeleteProject,
    title: titleText
  }, body, !isDeleting && /*#__PURE__*/external_react_default().createElement("div", {
    className: "delete-project-modal__comment"
  }, /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("strong", null, "Deletion cannot be undone."), " Do you want to proceed?"), /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("label", {
    htmlFor: "delete-project-comment"
  }, "Reason for deleting")), /*#__PURE__*/external_react_default().createElement("textarea", {
    className: "form-control",
    id: "delete-project-comment",
    placeholder: "Enter comments (optional)",
    value: comment,
    rows: 5,
    cols: 50,
    onChange: onChangeComment
  })), /*#__PURE__*/external_react_default().createElement(Progress, {
    delay: 0,
    estimate: totalCountFromSummaries * 15,
    toggle: isDeleting
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/project/ProjectSettings.tsx
function ProjectSettings_extends() { return ProjectSettings_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ProjectSettings_extends.apply(null, arguments); }
function ProjectSettings_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ProjectSettings_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ProjectSettings_ownKeys(Object(t), !0).forEach(function (r) { ProjectSettings_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ProjectSettings_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProjectSettings_defineProperty(e, r, t) { return (r = ProjectSettings_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ProjectSettings_toPropertyKey(t) { var i = ProjectSettings_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ProjectSettings_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }















const ProjectSettings = (0,external_react_.memo)(props => {
  const {
    onChange,
    onSuccess,
    onPageError,
    project
  } = props;
  const [showModal, setShowModal] = (0,external_react_.useState)(false);
  const [nameDirty, setNameDirty] = (0,external_react_.useState)(false);
  const [hasValidName, setHasValidName] = (0,external_react_.useState)(project.name.length > 0);
  const [dataTypeDirty, setDataTypeDirty] = (0,external_react_.useState)(false);
  const [dashboardDirty, setDashboardDirty] = (0,external_react_.useState)(false);
  const [storageDirty, setStorageDirty] = (0,external_react_.useState)(false);
  const [barDirty, setBarDirty] = (0,external_react_.useState)(false);
  const [nameIdDirty, setNameIdDirty] = (0,external_react_.useState)(false);
  const [error, setError] = (0,external_react_.useState)();
  const [isSaving, setIsSaving] = (0,external_react_.useState)(false);
  const {
    api
  } = useAppContext();
  const {
    projectDataTypes,
    sampleTypeDataType,
    ProjectFreezerSelectionComponent
  } = useAdminAppContext();
  const {
    container,
    user,
    moduleContext
  } = useServerContext();
  const isAppHomeSelected = isAppHomeFolder(project, moduleContext);
  const dispatch = useServerContextDispatch();
  const [getIsDirty, setIsDirty] = useRouteLeave();
  const onNameChange = (0,external_react_.useCallback)(name => {
    setHasValidName(name?.trim().length > 0);
    setNameDirty(true);
    onChange(true);
  }, [onChange]);
  const onTitleChange = (0,external_react_.useCallback)(() => {
    onChange(true);
    setNameDirty(true);
  }, [nameDirty, project.name]);
  const onDataTypeChange_ = (0,external_react_.useCallback)(() => {
    setDataTypeDirty(true);
    onChange(true);
  }, [onChange]);
  const onDashboardChange_ = (0,external_react_.useCallback)(() => {
    setDashboardDirty(true);
    onChange(true);
  }, [onChange]);
  const onStorageChange_ = (0,external_react_.useCallback)(() => {
    setStorageDirty(true);
    onChange(true);
  }, [onChange]);
  const onBarChange_ = (0,external_react_.useCallback)(() => {
    setBarDirty(true);
    onChange(true);
  }, [onChange]);
  const onBarSuccess_ = (0,external_react_.useCallback)(() => {
    setBarDirty(false);
    onSuccess(getIsDirty() || dataTypeDirty || dashboardDirty || storageDirty || nameIdDirty, false);
  }, [onSuccess, getIsDirty, dataTypeDirty, dashboardDirty, storageDirty, nameIdDirty]);
  const onNameIdChange_ = (0,external_react_.useCallback)(dirty => {
    setNameIdDirty(dirty);
    if (dirty) onChange(true);else onSuccess(getIsDirty() || dataTypeDirty || dashboardDirty || storageDirty || barDirty, false);
  }, [onChange, onSuccess, getIsDirty, dataTypeDirty, dashboardDirty, storageDirty, barDirty]);
  const onSubmitName = (0,external_react_.useCallback)(async evt => {
    evt.preventDefault();
    evt.stopPropagation();
    if (isSaving) return;
    setIsSaving(true);
    let renamedProject;
    try {
      const formData = new FormData(evt.target);
      const options = {
        name: formData.get('name'),
        nameAsTitle: !!formData.get('nameAsTitle'),
        title: formData.get('title')
      };
      renamedProject = await api.folder.renameProject(options, project.path);
      setNameDirty(false);
      onSuccess(dataTypeDirty || dashboardDirty || storageDirty || barDirty || nameIdDirty);
    } catch (e) {
      setError(resolveErrorMessage(e) ?? 'Failed to update project settings');
    } finally {
      setIsSaving(false);
    }

    // If this change has been made to the current folder then dispatch a
    // context update of the container's name and title.
    if (renamedProject?.id === container.id) {
      dispatch({
        container: new Container(ProjectSettings_objectSpread(ProjectSettings_objectSpread({}, container), {}, {
          name: project.name,
          title: project.title
        }))
      });
    }
  }, [api.folder, container, dispatch, project, isSaving, onSuccess, dataTypeDirty, dashboardDirty, storageDirty, barDirty, nameIdDirty]);
  const closeModalHandler = (0,external_react_.useCallback)(() => {
    setShowModal(false);
  }, []);
  const openModalHandler = (0,external_react_.useCallback)(() => {
    setShowModal(true);
  }, []);
  const onDeleteError = (0,external_react_.useCallback)(e => {
    setShowModal(false);
    onPageError(e);
  }, [onPageError]);
  const onDeleteSuccess = (0,external_react_.useCallback)(() => {
    onSuccess(false, false, true);
    setShowModal(false);
  }, [onSuccess]);
  const onDataTypeSuccess = (0,external_react_.useCallback)(reload => {
    setDataTypeDirty(false);
    onSuccess(getIsDirty() || dashboardDirty || storageDirty || barDirty || nameIdDirty, reload);
  }, [onSuccess, getIsDirty, dashboardDirty, storageDirty, barDirty, nameIdDirty]);
  const onDashboardSuccess = (0,external_react_.useCallback)(reload => {
    setDashboardDirty(false);
    onSuccess(getIsDirty() || dataTypeDirty || storageDirty || barDirty || nameIdDirty, reload);
  }, [onSuccess, getIsDirty, dataTypeDirty, storageDirty, barDirty, nameIdDirty]);
  const onStorageSuccess = (0,external_react_.useCallback)(reload => {
    setStorageDirty(false);
    onSuccess(getIsDirty() || dataTypeDirty || dashboardDirty || barDirty || nameIdDirty, reload);
  }, [onSuccess, getIsDirty, dataTypeDirty, dashboardDirty, barDirty, nameIdDirty]);
  if (!project || !user.isAdmin) {
    return null;
  }
  if (isAppHomeSelected) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "project-settings-container"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "project-settings panel panel-default"
    }, /*#__PURE__*/external_react_default().createElement(ProjectDataTypeSelections, {
      api: api.folder,
      panelTitle: "Dashboard",
      panelDescription: "Select the data types to include in the Dashboard Insights graphs.",
      dataTypePrefix: "Dashboard",
      entityDataTypes: [sampleTypeDataType],
      project: project,
      showUncheckedWarning: false,
      updateDataTypeExclusions: onDashboardChange_,
      onSuccess: onDashboardSuccess,
      setIsDirty: setIsDirty,
      getIsDirty: getIsDirty
    })));
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "project-settings-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "project-settings panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Settings"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, !!error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("form", {
    className: "project-settings-form form-horizontal",
    onSubmit: onSubmitName
  }, /*#__PURE__*/external_react_default().createElement(ProjectNameSetting, {
    defaultName: project.name,
    defaultTitle: project.title,
    onNameChange: onNameChange,
    onTitleChange: onTitleChange,
    setIsDirty: setIsDirty,
    getIsDirty: getIsDirty
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "pull-right"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default delete-project-button",
    onClick: openModalHandler,
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-trash"
  }), " Delete Project"), /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-success",
    disabled: isSaving || !nameDirty || !hasValidName,
    type: "submit"
  }, isSaving ? 'Saving...' : 'Save')))), showModal && /*#__PURE__*/external_react_default().createElement(DeleteProjectModal, {
    project: project,
    onCancel: closeModalHandler,
    onError: onDeleteError,
    onDeleteSuccess: onDeleteSuccess
  })), /*#__PURE__*/external_react_default().createElement(ProjectDataTypeSelections, {
    entityDataTypes: projectDataTypes,
    project: project,
    key: project?.id,
    updateDataTypeExclusions: onDataTypeChange_,
    api: api.folder,
    onSuccess: onDataTypeSuccess,
    setIsDirty: setIsDirty,
    getIsDirty: getIsDirty
  }), sampleTypeDataType && /*#__PURE__*/external_react_default().createElement(ProjectDataTypeSelections, {
    api: api.folder,
    panelTitle: "Dashboard",
    panelDescription: "Select the data types to include in the Dashboard Insights graphs.",
    dataTypePrefix: "Dashboard",
    entityDataTypes: [sampleTypeDataType],
    project: project,
    showUncheckedWarning: false,
    updateDataTypeExclusions: onDashboardChange_,
    onSuccess: onDashboardSuccess,
    setIsDirty: setIsDirty,
    getIsDirty: getIsDirty
  }), !!ProjectFreezerSelectionComponent && /*#__PURE__*/external_react_default().createElement(ProjectFreezerSelectionComponent, {
    project: project,
    updateDataTypeExclusions: onStorageChange_,
    onSuccess: onStorageSuccess,
    setIsDirty: setIsDirty,
    getIsDirty: getIsDirty
  }), biologicsIsPrimaryApp(moduleContext) && /*#__PURE__*/external_react_default().createElement(BarTenderSettingsForm, {
    onChange: onBarChange_,
    onSuccess: onBarSuccess_,
    container: project,
    setIsDirty: null // used by templates, not needed here
    ,
    getIsDirty: null
  }), /*#__PURE__*/external_react_default().createElement(NameIdSettings, ProjectSettings_extends({}, props, {
    container: project,
    isAppHome: false,
    setIsDirty: onNameIdChange_,
    getIsDirty: null
  })), biologicsIsPrimaryApp(moduleContext) && isProtectedDataEnabled(moduleContext) && /*#__PURE__*/external_react_default().createElement(ProtectedDataSettingsPanel, {
    containerPath: project.path
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/navigation/hooks.ts

const useFolderMenuContext = () => {
  return useGlobalStateContext().navigation.folderMenu;
};
const useSubNavTabsContext = () => {
  return useGlobalStateContext().navigation.subNav;
};
;// CONCATENATED MODULE: ./src/internal/components/administration/useAdministrationSubNav.tsx
/*
 * Copyright (c) 2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */







const ADMIN_KEY = 'admin';
const PARENT_TAB = {
  text: 'Dashboard',
  url: AppURL.create('home')
};
const useAdministrationSubNav = () => {
  const {
    clearNav,
    setNoun,
    setTabs
  } = useSubNavTabsContext();
  const {
    container,
    moduleContext,
    user
  } = useServerContext();
  const isAppHome = isAppHomeFolder(container, moduleContext);
  const homeFolderPath = isAppHome ? container.path : container.parentPath;
  const homeProjectContainer = useContainerUser(homeFolderPath, {
    includeStandardProperties: true
  });
  const appHomeUser = homeProjectContainer.user ?? user;
  (0,external_react_.useEffect)(() => {
    setNoun(PARENT_TAB);
    if (homeProjectContainer.isLoaded && user.isAdmin) {
      const projectsEnabled = isProductProjectsEnabled(moduleContext);
      const inProjectContainer = isProjectContainer(container.path);
      const tabs = [];
      if (appHomeUser.isAdmin) {
        tabs.push({
          text: 'Application Settings',
          url: AppURL.create(ADMIN_KEY, 'settings')
        });
      }
      if (projectsEnabled) tabs.push({
        text: 'Projects',
        url: AppURL.create(ADMIN_KEY, 'projects')
      });
      tabs.push({
        text: 'Audit Logs',
        url: AppURL.create(AUDIT_KEY)
      });
      if (!projectsEnabled || inProjectContainer) {
        tabs.push({
          text: 'Users',
          url: AppURL.create(ADMIN_KEY, 'users')
        });
        tabs.push({
          text: 'Groups',
          url: AppURL.create(ADMIN_KEY, 'groups')
        });
      }
      tabs.push({
        text: 'Permissions',
        url: AppURL.create(ADMIN_KEY, 'permissions')
      });
      setTabs(tabs);
    }
    return clearNav;
  }, [appHomeUser.isAdmin, clearNav, container.path, homeProjectContainer.isLoaded, moduleContext, setNoun, setTabs, user.isAdmin]);
};
;// CONCATENATED MODULE: ./src/internal/components/base/EmptyAlert.tsx
const EmptyAlert_excluded = ["allowAction", "permission", "user"];
function EmptyAlert_extends() { return EmptyAlert_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, EmptyAlert_extends.apply(null, arguments); }
function EmptyAlert_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = EmptyAlert_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function EmptyAlert_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }




const EmptyAlert = (0,external_react_.memo)(({
  actionURL,
  allowAction,
  className,
  message,
  messageSuffix
}) => {
  const showActionUrl = allowAction && !!actionURL;
  return /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning",
    className: external_classnames_default()('empty-alert', className)
  }, showActionUrl && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, message, " Click ", /*#__PURE__*/external_react_default().createElement("a", {
    href: actionURL.toHref()
  }, "here"), " ", messageSuffix ?? 'to get started.'), !showActionUrl && message);
});
EmptyAlert.displayName = 'EmptyAlert';
const EmptyAlertWithPermissions = (0,external_react_.memo)(props => {
  const {
      allowAction,
      permission,
      user
    } = props,
    baseProps = EmptyAlert_objectWithoutProperties(props, EmptyAlert_excluded);
  const _allowAction = (0,external_react_.useMemo)(() => {
    return allowAction !== false && !!user && hasAllPermissions(user, [permission]);
  }, [allowAction, permission, user]);
  return /*#__PURE__*/external_react_default().createElement(EmptyAlert, EmptyAlert_extends({}, baseProps, {
    allowAction: _allowAction
  }));
});
EmptyAlertWithPermissions.displayName = 'EmptyAlertWithPermissions';
;// CONCATENATED MODULE: ./src/internal/components/samples/SampleTypeEmptyAlert.tsx
const SampleTypeEmptyAlert_excluded = ["message"];
function SampleTypeEmptyAlert_extends() { return SampleTypeEmptyAlert_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, SampleTypeEmptyAlert_extends.apply(null, arguments); }
function SampleTypeEmptyAlert_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = SampleTypeEmptyAlert_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function SampleTypeEmptyAlert_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }








const SampleTypeEmptyAlert = (0,external_react_.memo)(props => {
  const {
      message
    } = props,
    baseProps = SampleTypeEmptyAlert_objectWithoutProperties(props, SampleTypeEmptyAlert_excluded);
  const {
    container,
    moduleContext
  } = useServerContext();
  const excludedSampleTypes = getProjectSampleTypeExclusion(moduleContext);
  const excludedDashboardSampleTypes = getProjectDashboardSampleTypeExclusion(moduleContext);
  const homeFolderPath = getAppHomeFolderPath(container, moduleContext);
  const homeContainer = useContainerUser(homeFolderPath);
  if (!homeContainer.isLoaded) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement(EmptyAlert, SampleTypeEmptyAlert_extends({}, baseProps, {
    actionURL: NEW_SAMPLE_TYPE_HREF,
    message: message ?? (excludedSampleTypes?.length > 0 || excludedDashboardSampleTypes?.length > 0 ? 'No sample types available.' : 'No sample types have been created.'),
    allowAction: hasAllPermissions(homeContainer.user, [api_.PermissionTypes.DesignSampleSet])
  }));
});
;// CONCATENATED MODULE: ./src/internal/util/measurement.ts
function measurement_defineProperty(e, r, t) { return (r = measurement_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function measurement_toPropertyKey(t) { var i = measurement_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function measurement_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

let BASE_UNITS = /*#__PURE__*/function (BASE_UNITS) {
  BASE_UNITS["COUNT"] = "Count";
  BASE_UNITS["MASS"] = "Mass";
  BASE_UNITS["VOLUME"] = "Volume";
  return BASE_UNITS;
}({});
class UnitModel {
  constructor(value, unitStr) {
    measurement_defineProperty(this, external_immer_.immerable, true);
    measurement_defineProperty(this, "value", void 0);
    measurement_defineProperty(this, "unitStr", void 0);
    //Originating unit string, may not be a typical MeasurementUnit
    measurement_defineProperty(this, "unit", void 0);
    const unit = MEASUREMENT_UNITS[unitStr?.toLowerCase()] || null;
    Object.assign(this, {
      value,
      unitStr,
      unit
    });
  }
  isSupportedUnitType() {
    return this.unit != null;
  }
  canConvert(newUnitStr) {
    if (!newUnitStr) {
      return this.unit == null;
    }
    const newUnit = MEASUREMENT_UNITS[newUnitStr.toLowerCase()];
    return newUnit?.baseUnit == this.unit?.baseUnit;
  }
  as(newUnitStr) {
    if (!this.canConvert(newUnitStr)) {
      throw new Error('Cannot convert to "' + newUnitStr + '"');
    }
    const newUnit = MEASUREMENT_UNITS[newUnitStr?.toLowerCase()];
    if (!newUnit) {
      throw new Error('Unit type not supported "' + newUnitStr + '"');
    }
    if (this.value == null) {
      return new UnitModel(0, newUnit.label.toLowerCase());
    }
    const newValue = this.value * (this.unit.ratio / newUnit.ratio);
    return new UnitModel(parseFloat(newValue.toFixed(6)), newUnit.label.toLowerCase());
  }
  add(deltaValue, deltaUnitStr) {
    let deltaUnit = this.unit;
    if (deltaUnitStr) {
      if (!this.canConvert(deltaUnitStr)) {
        throw new Error('Cannot add "' + deltaUnitStr + '" to "' + this.unit?.label + '"');
      }
      deltaUnit = MEASUREMENT_UNITS[deltaUnitStr.toLowerCase()];
      if (!deltaUnit) {
        throw new Error('Unit type not supported "' + deltaUnitStr + '"');
      }
    }
    if (!this.unit) {
      return new UnitModel(this.value + deltaValue, this.unit?.label?.toLowerCase());
    }
    const newValue = this.value + deltaValue * (deltaUnit.ratio / this.unit.ratio);
    return new UnitModel(newValue, this.unit.label.toLowerCase());
  }
  compareTo(other) {
    const unitStr = this.unit?.label;
    const otherUnitStr = other.unit?.label;
    if (!areUnitsCompatible(unitStr, otherUnitStr)) {
      return undefined;
    }
    if (this.value == null && other.value != null) {
      return undefined;
    }
    if (this.value != null && other.value == null) {
      return undefined;
    }
    if (unitStr == otherUnitStr) {
      return this.value - other.value;
    }
    return this.value - other.as(unitStr).value;
  }
  toString() {
    return this.value + (this.unit ? ' ' + this.unit.label : '');
  }
  toDisplayString() {
    return (this.value ? this.value.toLocaleString() : 0) + (this.unit ? ' ' + this.unit.label : '');
  }
}
const MEASUREMENT_UNITS = {
  g: {
    label: 'g',
    longLabelSingular: 'gram',
    longLabelPlural: 'grams',
    baseUnit: BASE_UNITS.MASS,
    ratio: 1,
    displayPrecision: 3 // enable smallest precision of mg
  },
  mg: {
    label: 'mg',
    longLabelSingular: 'milligram',
    longLabelPlural: 'milligrams',
    baseUnit: BASE_UNITS.MASS,
    ratio: 0.001,
    displayPrecision: 0
  },
  kg: {
    label: 'kg',
    longLabelSingular: 'kilogram',
    longLabelPlural: 'kilograms',
    baseUnit: BASE_UNITS.MASS,
    ratio: 1000,
    displayPrecision: 6 // enable smallest precision of mg
  },
  ml: {
    label: 'mL',
    longLabelSingular: 'milliliter',
    longLabelPlural: 'milliliters',
    baseUnit: BASE_UNITS.VOLUME,
    ratio: 1,
    displayPrecision: 3
  },
  ul: {
    label: 'uL',
    longLabelSingular: 'microliter',
    longLabelPlural: 'microliters',
    baseUnit: BASE_UNITS.VOLUME,
    ratio: 0.001,
    displayPrecision: 0
  },
  l: {
    label: 'L',
    longLabelSingular: 'liter',
    longLabelPlural: 'liters',
    baseUnit: BASE_UNITS.VOLUME,
    ratio: 1000,
    displayPrecision: 6
  },
  unit: {
    label: 'unit',
    longLabelSingular: 'unit',
    longLabelPlural: 'unit',
    baseUnit: BASE_UNITS.COUNT,
    ratio: 1,
    displayPrecision: 2
  }
};

/**
 * @param unitAStr
 * @param unitBStr
 */
function areUnitsCompatible(unitAStr, unitBStr) {
  if (unitAStr == unitBStr) {
    return true;
  }
  if (!unitAStr && !unitBStr) {
    return true;
  }
  if (unitAStr && !unitBStr) {
    return false;
  }
  if (!unitAStr && unitBStr) {
    return false;
  }
  const unitA = MEASUREMENT_UNITS[unitAStr.toLowerCase()];
  const unitB = MEASUREMENT_UNITS[unitBStr.toLowerCase()];
  if (!unitA || !unitB) {
    return false;
  }
  return unitA.baseUnit == unitB.baseUnit;
}
function getMetricUnitOptions() {
  const options = [];
  for (const [key, value] of Object.entries(MEASUREMENT_UNITS)) {
    if (value.label === 'unit') {
      options.push({
        value: value.label,
        label: value.label
      });
    } else {
      options.push({
        value: value.label,
        label: value.label + ' (' + value.longLabelPlural + ')'
      });
    }
  }
  return options;
}
function getAltMetricUnitOptions(unitTypeStr, showLongLabel) {
  const unit = MEASUREMENT_UNITS[unitTypeStr?.toLowerCase()];
  if (!unit || unit.baseUnit === BASE_UNITS.COUNT) {
    return [];
  }
  const options = [];
  for (const [key, value] of Object.entries(MEASUREMENT_UNITS)) {
    if (value.baseUnit === unit.baseUnit) {
      if (!showLongLabel) {
        options.push({
          value: value.label,
          label: value.label
        });
      } else {
        options.push({
          value: value.label,
          label: value.label + ' (' + value.longLabelPlural + ')'
        });
      }
    }
  }
  return options;
}
function getAltUnitKeys(unitTypeStr) {
  const unit = MEASUREMENT_UNITS[unitTypeStr?.toLowerCase()];
  if (!unit) {
    return [];
  }
  const options = [];
  Object.values(MEASUREMENT_UNITS).forEach(value => {
    if (value.baseUnit === unit.baseUnit) {
      options.push(value.label);
    }
  });
  return options;
}
function getMultiAltUnitKeys(unitTypeStrs) {
  let compabitable = true;
  const unitTypeStr = unitTypeStrs[0];
  for (let i = 1; i < unitTypeStrs.length; i++) {
    if (!areUnitsCompatible(unitTypeStr, unitTypeStrs[i])) {
      compabitable = false;
      break;
    }
  }
  if (!compabitable) {
    return [];
  }
  if (!unitTypeStr) {
    // if no unit type, return all unit types
    const options = [];
    Object.values(MEASUREMENT_UNITS).forEach(value => {
      options.push(value.label);
    });
    return options;
  }
  return getAltUnitKeys(unitTypeStr);
}
function convertUnitsForInput(amount, unit, displayUnit) {
  if (!amount || !displayUnit || !unit) {
    return amount;
  }
  const currentUnit = MEASUREMENT_UNITS[unit.toLowerCase()];
  const targetUnit = MEASUREMENT_UNITS[displayUnit.toLowerCase()];
  if (!currentUnit || !targetUnit) {
    return amount;
  }
  // show up to 6 decimal places
  return parseFloat((amount * (currentUnit.ratio / targetUnit.ratio)).toFixed(6));
}
function convertUnitDisplay(amount, unit, displayUnit, includeUnits, emptyDisplay) {
  const convertedAmount = convertUnitsForInput(amount, unit, displayUnit);
  // Allow for 0 so can't use !amount
  if (convertedAmount == null) {
    return emptyDisplay ? emptyDisplay : '';
  }
  if (!displayUnit) {
    return convertedAmount.toLocaleString() + (includeUnits && unit ? ' ' + unit : '');
  }
  if (!unit) {
    return convertedAmount.toLocaleString() + (includeUnits && displayUnit ? ' ' + displayUnit : '');
  }
  const currentUnit = MEASUREMENT_UNITS[unit.toLowerCase()];
  const targetUnit = MEASUREMENT_UNITS[displayUnit.toLowerCase()];
  if (!currentUnit || !targetUnit) {
    return convertedAmount.toLocaleString() + (includeUnits ? ' ' + unit : '');
  }
  return (convertedAmount > 1000 ? convertedAmount.toLocaleString() : convertedAmount) + (includeUnits ? ' ' + displayUnit : '');
}

// volume unit (displayUnit): 10 mL (L)
// volume unit: 10 mL
// volume (displayUnit): 10 (L)
// volume: 10
// volume not set: null
function getStoredAmountDisplay(rawValue, includeUnits) {
  if (!rawValue || !rawValue.trim()) {
    return null;
  }
  const parts = rawValue.trim().split(/\b\s+/);
  if (parts.length === 1) {
    return rawValue.toLocaleString();
  }
  if (parts.length === 2) {
    if (includeUnits) {
      const unit = parts[1];
      if (unit.indexOf('(') === 0 && unit.indexOf(')') === unit.length - 1) {
        return parts[0].toLocaleString() + ' ' + unit.substring(1, unit.length - 1);
      } else {
        return rawValue.toLocaleString();
      }
    } else {
      return parts[0].toLocaleString();
    }
  }
  if (parts.length === 3) {
    const volume = parts[0];
    const currentUnit = parts[1];
    const targetUnit = parts[2];
    return convertUnitDisplay(parseFloat(volume), currentUnit, targetUnit.substring(1, targetUnit.length - 1), includeUnits);
  }
  return rawValue;
}
function getVolumeMinStep(sampleTypeUnit) {
  const step = 0.01;
  if (!sampleTypeUnit) {
    return step;
  }
  const unit = typeof sampleTypeUnit === 'string' ? MEASUREMENT_UNITS[sampleTypeUnit.toLowerCase()] : sampleTypeUnit;

  // If we don't know the units, or it is 'unit' then use the default
  if (!unit || unit === MEASUREMENT_UNITS.unit) {
    return step;
  }
  return Math.pow(10, -unit.displayPrecision); // Track uL and mg to a single unit
}
function isMeasurementUnitIgnoreCase(expected, val) {
  return expected.label.localeCompare(val, 'en-US', {
    sensitivity: 'base'
  }) === 0;
}
function isValuePrecisionValid(value, precision) {
  if (!value) {
    return true;
  }
  if (value < 0) {
    return false;
  }
  const valueValidator = new RegExp(`^\\d*(\\.\\d{0,${precision}})?$`);
  return valueValidator.test(value.toString());
}
;// CONCATENATED MODULE: ./src/internal/components/samples/StorageAmountInput.tsx






const deltaTooPreciseMessage = /*#__PURE__*/external_react_default().createElement(Alert, {
  bsStyle: "danger",
  className: "storage-item-precision-alert"
}, AMOUNT_PRECISION_ERROR_TEXT);
const negativeValueMessage = /*#__PURE__*/external_react_default().createElement(Alert, {
  bsStyle: "danger",
  className: "storage-item-precision-alert"
}, "Amount must be a positive value.");
const StorageAmountInput = (0,external_react_.memo)(props => {
  const {
    className,
    model,
    preferredUnit,
    inputName,
    label,
    tipText,
    amountChangedHandler,
    unitsChangedHandler
  } = props;
  const isNegativeValue = model?.value < 0;
  const isDeltaValid = isValuePrecisionValid(model?.value, model?.unit?.displayPrecision);
  const unitText = model?.unit?.label || model.unitStr;
  let preferredUnitMessage;
  let unitDisplay;
  if (!unitsChangedHandler) {
    // IF we don't have a way to change the supported value show it as static text.
    unitDisplay = /*#__PURE__*/external_react_default().createElement("span", {
      className: "storage-item-unit-text margin-left"
    }, preferredUnit || unitText);
  }
  // If preferred unit isn't set or is an unsupported value allow editing as text
  else if (preferredUnit == undefined || !MEASUREMENT_UNITS.hasOwnProperty(preferredUnit.toLowerCase())) {
    unitDisplay = /*#__PURE__*/external_react_default().createElement("input", {
      type: "text",
      className: "form-control checkin-unit-input",
      value: unitText,
      placeholder: "Enter volume units...",
      onChange: evt => unitsChangedHandler(evt.target.value)
    });
  } else {
    // IFF preferred units are supplied and are a supported type, then show possible conversions
    unitDisplay = /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      containerClass: "checkin-unit-select-container",
      inputClass: "checkin-unit-select",
      name: "unitType",
      options: getAltMetricUnitOptions(preferredUnit),
      onChange: (name, formValue, option) => {
        unitsChangedHandler(formValue === undefined && option ? option.id : formValue);
      },
      value: preferredUnit
    });
    if (model.unit !== null && !isMeasurementUnitIgnoreCase(model.unit, preferredUnit)) {
      const preferredUnitText = model.as(preferredUnit).toString();
      preferredUnitMessage = /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
        className: "storage-item-check-in-preferred-display"
      }, preferredUnitText, " equivalent (preferred)"));
    }
  }
  const onChange = (0,external_react_.useCallback)(event => amountChangedHandler(event?.target?.value), [amountChangedHandler]);
  const containerClassName = className ?? 'form-group storage-item-check-in-sampletype-row ';
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: containerClassName
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: 'checkin-amount-label ' + (isDeltaValid ? '' : 'has-error ')
  }, /*#__PURE__*/external_react_default().createElement("label", {
    htmlFor: "checkin-amount"
  }, label), tipText && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    title: "Stored Amount Delta"
  }, /*#__PURE__*/external_react_default().createElement("p", null, tipText))), /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control storage-item-check-in-text storage-amount-input ",
    id: "checkin-amount",
    min: 0,
    step: getVolumeMinStep(model.unit),
    name: inputName ?? 'amountDelta',
    onChange: onChange,
    type: "number",
    value: model.value,
    placeholder: "Enter amount..."
  }), unitDisplay, preferredUnitMessage), isNegativeValue ? negativeValueMessage : undefined, !isNegativeValue && !isDeltaValid ? deltaTooPreciseMessage : undefined);
});
;// CONCATENATED MODULE: ./src/internal/components/samples/SampleAmountEditModal.tsx













const isPrecisionValid = (amount, storageUnits) => {
  const units = MEASUREMENT_UNITS[storageUnits?.toLowerCase()];
  return isValuePrecisionValid(amount, units?.displayPrecision);
};
const isValid = (amount, units) => {
  return amount === undefined || amount >= 0 && isPrecisionValid(amount, units);
};
const SampleAmountEditModal = (0,external_react_.memo)(props => {
  const {
    schemaQuery,
    noun,
    onClose,
    updateListener,
    row
  } = props;
  const {
    api
  } = useAppContext();
  const {
    user
  } = useServerContext();
  const {
    [STORED_AMOUNT_FIELDS.ROWID]: rowId,
    [STORED_AMOUNT_FIELDS.UNITS]: Units,
    [STORED_AMOUNT_FIELDS.AMOUNT]: initStorageAmount
  } = row;
  const sampleContainer = caseInsensitive(row, 'Container/Path')?.value;
  const initStorageUnits = Units?.value;
  const [amount, setStorageAmount] = (0,external_react_.useState)(initStorageAmount?.displayValue ?? initStorageAmount?.value ?? undefined);
  const [storageUnits, setStorageUnits] = (0,external_react_.useState)(initStorageUnits ?? '');
  const [comment, setComment] = (0,external_react_.useState)('');
  const [submitting, setSubmitting] = (0,external_react_.useState)(false);
  const [error, setError] = (0,external_react_.useState)();
  const [isDirty, setIsDirty] = (0,external_react_.useState)(false);
  const {
    requiresUserComment
  } = useDataChangeCommentsRequired();
  const hasValidUserComment = comment?.trim()?.length > 0;
  const onCancel = (0,external_react_.useCallback)(() => {
    onClose();
  }, [onClose]);
  const handleUpdateSampleRow = () => {
    // Issue 41931: html input number step value only validates to a certain precision
    const precision = storageUnits ? MEASUREMENT_UNITS[storageUnits.toLowerCase()]?.displayPrecision : 2;
    if (!isValuePrecisionValid(amount, precision)) {
      return Promise.reject(AMOUNT_PRECISION_ERROR_TEXT);
    }

    // users that can update samples use regular updateRows, but users with storage editor permission use a special controller action
    if (user.canUpdate) {
      return api.query.updateRows({
        schemaQuery,
        rows: [{
          rowId: rowId?.value,
          [STORED_AMOUNT_FIELDS.AMOUNT]: amount,
          [STORED_AMOUNT_FIELDS.UNITS]: storageUnits
        }],
        [STORED_AMOUNT_FIELDS.AUDIT_COMMENT]: comment,
        containerPath: sampleContainer,
        auditBehavior: api_.AuditBehaviorTypes.DETAILED
      });
    } else {
      const sampleData = [{
        materialId: rowId?.value,
        [STORED_AMOUNT_FIELDS.AMOUNT]: amount,
        [STORED_AMOUNT_FIELDS.UNITS]: storageUnits
      }];
      return updateSampleStorageData(sampleData, sampleContainer, comment);
    }
  };
  const onSubmit = (0,external_react_.useCallback)(async () => {
    setSubmitting(true);
    if (!isValid(amount, storageUnits)) {
      return;
    }
    try {
      await handleUpdateSampleRow();
      setSubmitting(false);
      updateListener();
      onClose();
    } catch (e) {
      setSubmitting(false);
      setError(e.exception);
    }
  }, [amount, storageUnits, handleUpdateSampleRow, updateListener, onClose]);
  const amountChangeHandler = (0,external_react_.useCallback)(newAmount => {
    let newVal = parseFloat(newAmount);
    if (isNaN(newVal)) {
      newVal = null; // set to null to indicate any existing value should be cleared; undefined values are removed before submission.
    }
    setStorageAmount(newVal);
    setIsDirty(_isDirty => _isDirty || newVal !== initStorageAmount);
  }, [initStorageAmount]);
  const unitsChangeHandler = (0,external_react_.useCallback)(newUnits => {
    const units = newUnits ?? initStorageUnits;
    setStorageUnits(units);
    setIsDirty(_isDirty => _isDirty || units?.localeCompare(initStorageUnits, 'en-US', {
      sensitivity: 'base'
    }) !== 0);
  }, [initStorageUnits]);
  const commentChangeHandler = (0,external_react_.useCallback)(_comment => {
    setComment(_comment);
  }, []);
  const amountCaption = initStorageUnits === storageUnits ? `Amount (${storageUnits})` : 'Amount';
  let canConfirm = isDirty && isValid(amount, storageUnits);
  if (requiresUserComment) canConfirm = canConfirm && hasValidUserComment;
  const unitModel = new UnitModel(amount, storageUnits);
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    canConfirm: canConfirm,
    confirmText: `Update ${noun}`,
    isConfirming: submitting,
    onCancel: onCancel,
    onConfirm: onSubmit,
    title: "Edit Sample Amounts"
  }, /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "danger"
  }, error), /*#__PURE__*/external_react_default().createElement(StorageAmountInput, {
    model: unitModel,
    preferredUnit: initStorageUnits,
    amountChangedHandler: amountChangeHandler,
    unitsChangedHandler: unitsChangeHandler,
    label: amountCaption
  }), /*#__PURE__*/external_react_default().createElement(CommentTextArea, {
    containerClassName: "form-group storage-action-form-group",
    actionName: "Update",
    onChange: commentChangeHandler,
    requiresUserComment: requiresUserComment
  }));
});
SampleAmountEditModal.displayName = 'SampleAmountEditModal';
;// CONCATENATED MODULE: ./src/internal/AppContexts.tsx







/**
 * AppContexts is where you should add any additional contexts needed by our applications. At the moment all of our
 * apps share the same basic context configurations, and this component makes it easy for us to update all of our Apps
 * at once, and reduce the level of nesting needed in our Route configurations.
 */
const AppContexts = props => {
  const {
    children,
    initialAppContext
  } = props;
  const initialServerContext = (0,external_react_.useMemo)(() => withAppUser((0,api_.getServerContext)()), []);
  return /*#__PURE__*/external_react_default().createElement(ServerContextProvider, {
    initialContext: initialServerContext
  }, /*#__PURE__*/external_react_default().createElement(AppContextProvider, {
    initialContext: initialAppContext
  }, /*#__PURE__*/external_react_default().createElement(GlobalStateContextProvider, null, /*#__PURE__*/external_react_default().createElement(NotificationsContextProvider, null, /*#__PURE__*/external_react_default().createElement(LabelPrintingContextProvider, null, children)))));
};
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/BaseDomainDesigner.tsx
function BaseDomainDesigner_extends() { return BaseDomainDesigner_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, BaseDomainDesigner_extends.apply(null, arguments); }
function BaseDomainDesigner_defineProperty(e, r, t) { return (r = BaseDomainDesigner_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function BaseDomainDesigner_toPropertyKey(t) { var i = BaseDomainDesigner_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function BaseDomainDesigner_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







function withBaseDomainDesigner(ComponentToWrap) {
  class ComponentWithBaseDomainDesigner extends external_react_.PureComponent {
    constructor(...args) {
      super(...args);
      BaseDomainDesigner_defineProperty(this, "state", {
        currentPanelIndex: 0,
        firstState: true,
        submitting: false,
        visitedPanels: (0,external_immutable_.List)(),
        validatePanel: undefined
      });
      // TODO: having a child component pass a callback to a parent is a big red flag
      BaseDomainDesigner_defineProperty(this, "onTogglePanel", (index, collapsed, callback) => {
        const {
          currentPanelIndex
        } = this.state;
        if (!collapsed) {
          this.setState(state => ({
            currentPanelIndex: index,
            firstState: false,
            validatePanel: state.currentPanelIndex,
            visitedPanels: getUpdatedVisitedPanelsList(state.visitedPanels, index)
          }), callback() // TODO: This is being called immediately and we rely on that fact. Refactor this whole toggling functionality.
          );
        } else if (currentPanelIndex === index) {
          this.setState(state => ({
            currentPanelIndex: undefined,
            firstState: false,
            validatePanel: state.currentPanelIndex,
            visitedPanels: getUpdatedVisitedPanelsList(state.visitedPanels, index)
          }), callback() // TODO: This is being called immediately and we rely on that fact. Refactor this whole toggling functionality.
          );
        } else {
          callback();
        }
      });
      BaseDomainDesigner_defineProperty(this, "onFinish", (isValid, save) => {
        // This first setState forces the current expanded panel to validate its fields and display and errors
        // the callback setState then sets that to undefined so it doesn't keep validating every render
        this.setState(state => {
          const {
            currentPanelIndex,
            visitedPanels
          } = state;
          return {
            validatePanel: currentPanelIndex,
            visitedPanels: getUpdatedVisitedPanelsList(visitedPanels, currentPanelIndex)
          };
        }, () => {
          const nextState = {
            validatePanel: undefined
          };
          if (isValid) {
            nextState.submitting = true;
          }
          this.setState(nextState, isValid ? save : undefined);
        });
      });
      BaseDomainDesigner_defineProperty(this, "setSubmitting", (submitting, callback) => {
        this.setState({
          submitting
        }, callback);
      });
    }
    render() {
      return /*#__PURE__*/external_react_default().createElement(ComponentToWrap, BaseDomainDesigner_extends({}, this.state, {
        setSubmitting: this.setSubmitting,
        onTogglePanel: this.onTogglePanel,
        onFinish: this.onFinish
      }, this.props));
    }
  }
  return ComponentWithBaseDomainDesigner;
}
const BaseDomainDesigner = (0,external_react_.memo)(props => {
  const {
    children,
    domains,
    exception,
    name,
    visitedPanels,
    submitting,
    onFinish,
    onCancel,
    hasValidProperties,
    saveBtnText = 'Save'
  } = props;

  // get a list of the domain names that have errors
  const errorDomains = domains.filter(domain => domain.hasException() && domain.domainException.severity === constants_SEVERITY_LEVEL_ERROR).map(domain => getDomainHeaderName(domain.name, undefined, name)).toList();
  const bottomErrorMsg = getDomainBottomErrorMessage(exception, errorDomains, hasValidProperties, visitedPanels);
  const submitClassname = `save-button btn btn-${getSubmitButtonClass()}`;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-designer"
  }, children, bottomErrorMsg && /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-form-panel",
    id: DOMAIN_ERROR_ID
  }, /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "danger"
  }, bottomErrorMsg)), /*#__PURE__*/external_react_default().createElement(FormButtons, {
    sticky: isApp()
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "cancel-button btn btn-default",
    onClick: onCancel,
    type: "button"
  }, "Cancel"), /*#__PURE__*/external_react_default().createElement("button", {
    className: submitClassname,
    disabled: submitting,
    onClick: onFinish,
    type: "button"
  }, saveBtnText)));
});
BaseDomainDesigner.displayName = 'BaseDomainDesigner';
;// CONCATENATED MODULE: ./src/internal/components/assay/withAssayModels.tsx
const withAssayModels_excluded = ["api", "assayName"];
function withAssayModels_extends() { return withAssayModels_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, withAssayModels_extends.apply(null, arguments); }
function withAssayModels_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = withAssayModels_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function withAssayModels_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function withAssayModels_defineProperty(e, r, t) { return (r = withAssayModels_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function withAssayModels_toPropertyKey(t) { var i = withAssayModels_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function withAssayModels_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







const AssayContext = (0,external_react_.createContext)(undefined);
const AssayContextProvider = AssayContext.Provider;
const AssayContextConsumer = AssayContext.Consumer;

/**
 * Provides a wrapped component with assay definitions. These definitions are loaded into the
 * [[AssayStateModel]] which is injected into the component as the "assayModel" property.
 * Optionally, if the "assayName" property is specified it will load the associated assay
 * protocol and pass it, along with its specific assay definition, as props "assayProtocol"
 * and "assayDefinition".
 * @param ComponentToWrap The component definition (e.g. class, function) to wrap.
 * This will have [[InjectedAssayModel]] props injected into it when instantiated.
 * @param defaultProps Provide alternative "defaultProps" for this wrapped component.
 */
function withAssayModels(ComponentToWrap, defaultProps) {
  class ComponentWithAssays extends external_react_.PureComponent {
    constructor(...args) {
      super(...args);
      withAssayModels_defineProperty(this, "state", (0,external_immer_.produce)({}, () => ({
        context: {
          assayDefinition: undefined,
          assayProtocol: undefined
        },
        model: new AssayStateModel()
      })));
      withAssayModels_defineProperty(this, "_mounted", false);
      withAssayModels_defineProperty(this, "componentDidMount", () => {
        this._mounted = true;
        this.load();
      });
      withAssayModels_defineProperty(this, "componentDidUpdate", prevProps => {
        const {
          assayContainerPath,
          assayName
        } = this.props;
        if (assayName !== prevProps.assayName || assayContainerPath !== prevProps.assayContainerPath) {
          this.load();
        }
      });
      withAssayModels_defineProperty(this, "componentWillUnmount", () => {
        this._mounted = false;
      });
      withAssayModels_defineProperty(this, "load", async () => {
        if (!isAssayEnabled(this.props.moduleContext)) {
          this.updateModel({
            definitions: [],
            definitionsLoadingState: LoadingState.LOADED
          });
        } else {
          await this.loadDefinitions();
          await this.loadProtocol();
        }
      });
      withAssayModels_defineProperty(this, "loadDefinitions", async () => {
        const {
          api,
          assayContainerPath,
          excludedAssayDesigns
        } = this.props;
        const {
          model
        } = this.state;
        if (model.definitionsLoadingState === LoadingState.LOADED) {
          return;
        }
        this.updateModel({
          definitionsError: undefined,
          definitionsLoadingState: LoadingState.LOADING
        });
        try {
          let definitions = await api.assay.getAssayDefinitions({
            containerPath: assayContainerPath
          });
          if (excludedAssayDesigns?.length > 0) {
            definitions = definitions.filter(def => excludedAssayDesigns.indexOf(def.id) === -1);
          }
          this.updateModel({
            definitions,
            definitionsLoadingState: LoadingState.LOADED
          });
        } catch (definitionsError) {
          this.updateModel({
            definitions: [],
            definitionsError,
            definitionsLoadingState: LoadingState.LOADED
          });
        }
      });
      withAssayModels_defineProperty(this, "loadProtocol", async () => {
        const {
          api,
          assayContainerPath,
          assayName
        } = this.props;
        const {
          model
        } = this.state;

        // If an "assayName" is not provided and one has not ever been loaded by this instance,
        // then do not attempt to process the "assayName" as it is an optional behavior to load the protocol.
        if (!assayName && model.protocolLoadingState === LoadingState.INITIALIZED) {
          return;
        }
        const assayDefinition = model.getByName(assayName);
        let modelProps;
        if (assayDefinition) {
          modelProps = {
            protocolError: undefined,
            protocolLoadingState: LoadingState.LOADING
          };
        } else {
          modelProps = {
            protocolError: `Load protocol failed. Unable to resolve assay definition for assay name "${assayName}".`,
            protocolLoadingState: LoadingState.LOADED
          };
        }
        this.update({
          context: {
            assayDefinition,
            assayProtocol: undefined
          },
          model: model.mutate(modelProps)
        });
        if (!assayDefinition) {
          return;
        }
        try {
          const assayProtocol = await api.assay.getProtocol({
            containerPath: assayContainerPath,
            protocolId: assayDefinition.id
          });
          this.update({
            context: {
              assayDefinition,
              assayProtocol
            },
            model: model.mutate({
              protocolLoadingState: LoadingState.LOADED
            })
          });
        } catch (protocolError) {
          this.updateModel({
            protocolError,
            protocolLoadingState: LoadingState.LOADED
          });
        }
      });
      withAssayModels_defineProperty(this, "reload", async () => {
        this.props.api.assay.clearAssayDefinitionCache();
        await this.update({
          context: {
            assayDefinition: undefined,
            assayProtocol: undefined
          },
          model: new AssayStateModel()
        });
        await this.load();
      });
      withAssayModels_defineProperty(this, "update", newState => {
        return new Promise(resolve => {
          if (this._mounted) {
            this.setState((0,external_immer_.produce)(draft => {
              Object.assign(draft, newState);
            }), () => {
              resolve();
            });
          }
        });
      });
      withAssayModels_defineProperty(this, "updateModel", newModel => {
        return new Promise(resolve => {
          if (this._mounted) {
            this.setState((0,external_immer_.produce)(draft => {
              Object.assign(draft.model, newModel);
            }), () => {
              resolve();
            });
          }
        });
      });
      withAssayModels_defineProperty(this, "render", () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _this$props = this.props,
          {
            api,
            assayName
          } = _this$props,
          props = withAssayModels_objectWithoutProperties(_this$props, withAssayModels_excluded);
        const {
          context,
          model
        } = this.state;
        return /*#__PURE__*/external_react_default().createElement(AssayContextProvider, {
          value: context
        }, /*#__PURE__*/external_react_default().createElement(ComponentToWrap, withAssayModels_extends({
          assayModel: model,
          reloadAssays: this.reload
        }, context, props)));
      });
    }
  }
  withAssayModels_defineProperty(ComponentWithAssays, "defaultProps", void 0);
  ComponentWithAssays.defaultProps = {
    api: defaultProps?.api ?? getDefaultAPIWrapper()
  };
  return ComponentWithAssays;
}

/**
 * Provides a [[withAssayModels]] wrapped component that sources the "assayName" property from the URL. NOTE: This is
 * specifically configured to expect a route param called "protocol" which is expected to a be (string) name of a
 * specific assay protocol.
 * @param ComponentToWrap The component definition (e.g. class, function) to wrap.
 * This will have [[InjectedAssayModel]] props injected into it when instantiated.
 * @param defaultProps Provide alternative "defaultProps" for this wrapped component.
 */
// TODO: this component seems kind of unnecessary, it seems like every consumer should be able to just use the RR6
//  useParams hook directly, it's not particularly complicated.
function withAssayModelsFromLocation(ComponentToWrap, defaultProps) {
  const WrappedComponent = withAssayModels(ComponentToWrap, defaultProps);
  const AssayFromLocation = props => {
    const protocol = (0,external_react_router_dom_.useParams)().protocol;
    return /*#__PURE__*/external_react_default().createElement(WrappedComponent, withAssayModels_extends({}, props, {
      assayName: protocol
    }));
  };
  return AssayFromLocation;
}
;// CONCATENATED MODULE: ./src/internal/components/assay/AssayContainerLocation.tsx

const AssayContainerLocation = (0,external_react_.memo)(props => {
  const {
    locations,
    selected,
    onChange
  } = props;
  const options = (0,external_react_.useMemo)(() => {
    const options = [];
    if (locations) {
      Object.entries(locations).forEach(([key, value]) => {
        options.push( /*#__PURE__*/external_react_default().createElement("option", {
          key: key,
          value: key
        }, value));
      });
    }
    return options;
  }, [locations]);
  const onSelectChange = (0,external_react_.useCallback)(e => {
    onChange(e.target.value);
  }, [onChange]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-bottom"
  }, /*#__PURE__*/external_react_default().createElement("b", null, "Assay Location")), /*#__PURE__*/external_react_default().createElement("p", null, "Choose where the assay will be used and visible within subfolders."), /*#__PURE__*/external_react_default().createElement("select", {
    id: "assay-type-select-container",
    value: selected,
    onChange: onSelectChange,
    className: "form-control"
  }, options));
});
;// CONCATENATED MODULE: ./src/internal/components/assay/SpecialtyAssayPanel.tsx




const SpecialtyAssayPanel = (0,external_react_.memo)(props => {
  const {
    values,
    selected,
    onChange,
    children,
    hasPremium
  } = props;
  const options = (0,external_react_.useMemo)(() => {
    return values?.filter(v => v.name !== GENERAL_ASSAY_PROVIDER_NAME).map(val => {
      return /*#__PURE__*/external_react_default().createElement("option", {
        key: val.name,
        value: val.name
      }, val.name);
    });
  }, [values]);
  const warning = (0,external_react_.useMemo)(() => {
    if (!options || options.length < 1) return 'This server does not have any specialty or custom assay types.';
  }, [options]);
  const onSelectChange = (0,external_react_.useCallback)(e => {
    onChange(e.target.value);
  }, [onChange]);
  const premiumInfoClass = (0,external_react_.useMemo)(() => {
    if (children) return 'large-margin-top';
    if (warning) return '';
    return 'margin-top';
  }, [children, warning]);
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6"
  }, selected && options?.length > 0 && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-bottom"
  }, /*#__PURE__*/external_react_default().createElement("b", null, "Use Instrument-Specific Data Format")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-bottom"
  }, /*#__PURE__*/external_react_default().createElement("select", {
    id: "specialty-assay-type-select",
    value: selected.name,
    onChange: onSelectChange,
    className: "form-control"
  }, options)), /*#__PURE__*/external_react_default().createElement("div", {
    className: "small-margin-bottom"
  }, selected?.description)), warning && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-flag",
    style: {
      marginRight: '20px'
    }
  }), warning))), selected && options?.length > 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: warning ? 'margin-bottom' : 'margin-top margin-bottom'
  }, /*#__PURE__*/external_react_default().createElement("b", null, "Supported File Types")), /*#__PURE__*/external_react_default().createElement("p", null, selected?.fileTypes.join(', ')))), children, !hasPremium && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: 'col-xs-12 ' + premiumInfoClass
  }, /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "info"
  }, /*#__PURE__*/external_react_default().createElement("h1", {
    className: "fa fa-star-o"
  }, " Premium Feature"), /*#__PURE__*/external_react_default().createElement("h3", null, "More specialty assays are available with LabKey Server Premium Edition"), /*#__PURE__*/external_react_default().createElement("hr", null), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", null, "Premium users get access to more LabKey specialty assays that could be a match for your data needs."), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("a", {
    className: "alert-link",
    href: "https://www.labkey.com/platform/go-premium/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Learn more about premium editions ", /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-external-link"
  })))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-top margin-bottom"
  }, /*#__PURE__*/external_react_default().createElement("div", null, "LabKey also supports creating your own custom specialty assays. Learn more in our docs, or contact us for more information on how you can create your own."), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("a", {
    className: "alert-link",
    href: getHelpLink('moduleassay'),
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Learn more about custom specialty assays ", /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-external-link"
  }))))))));
});
;// CONCATENATED MODULE: ./src/internal/components/assay/AssayDesignUploadPanel.tsx





const AssayDesignUploadPanel = (0,external_react_.memo)(props => {
  const {
    onFileChange,
    onFileRemove,
    children
  } = props;
  const folderNoun = isPremiumProductEnabled() ? 'project' : 'folder';
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-bottom"
  }, /*#__PURE__*/external_react_default().createElement("b", null, "Import .XAR or .XAR.XML file")), /*#__PURE__*/external_react_default().createElement("p", null, "To create an assay from an existing design, import a", ' ', /*#__PURE__*/external_react_default().createElement("a", {
    href: getHelpLink('XarTutorial'),
    target: "_blank",
    rel: "noopener noreferrer"
  }, ".XAR or .XAR.XML"), ' ', "file here. You will be able to customize the design after importing."))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement(FileAttachmentForm, {
    acceptedFormats: ".XAR, .XAR.XML, .xar, .xar.xml",
    showAcceptedFormats: false,
    allowDirectories: false,
    allowMultiple: false,
    showLabel: false,
    onFileChange: onFileChange,
    onFileRemoval: onFileRemove
  }))), children, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-top margin-bottom"
  }, /*#__PURE__*/external_react_default().createElement("b", null, "Import through data pipeline")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-top margin-bottom"
  }, /*#__PURE__*/external_react_default().createElement("p", null, "If you have an existing assay .XAR file on this server, you can directly upload this assay design using this ", folderNoun, "'s data pipeline.")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-top"
  }, /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("a", {
    href: api_.ActionURL.buildURL('pipeline', 'browse')
  }, "Use data pipeline"))))));
});
;// CONCATENATED MODULE: ./src/internal/components/assay/StandardAssayPanel.tsx

const StandardAssayPanel = (0,external_react_.memo)(props => {
  const {
    provider,
    children
  } = props;
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-bottom"
  }, /*#__PURE__*/external_react_default().createElement("b", null, "Standard Assay"), /*#__PURE__*/external_react_default().createElement("span", {
    className: "gray-text"
  }, " (Recommended)")), /*#__PURE__*/external_react_default().createElement("p", null, "Standard assays are the most flexible choice for working with experimental data. Use this assay type to customize the format for mapping your experimental results."))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-bottom margin-top"
  }, /*#__PURE__*/external_react_default().createElement("b", null, "Supported File Types")), /*#__PURE__*/external_react_default().createElement("p", null, provider?.fileTypes.join(', ')))), children);
});
;// CONCATENATED MODULE: ./src/internal/components/assay/AssayPicker.tsx











let AssayPickerTabs = /*#__PURE__*/function (AssayPickerTabs) {
  AssayPickerTabs["SPECIALTY_ASSAY_TAB"] = "specialty";
  AssayPickerTabs["STANDARD_ASSAY_TAB"] = "standard";
  AssayPickerTabs["XAR_IMPORT_TAB"] = "import";
  return AssayPickerTabs;
}({});
const queryAssayProviders = () => {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('assay', 'getAssayTypeSelectOptions.api'),
      success: api_.Utils.getCallbackWrapper(data => {
        resolve(data);
      }),
      failure: handleRequestFailure(reject, 'Failed to load assay providers')
    });
  });
};
const getSelectedProvider = (providers, name) => {
  return providers?.find(p => p.name === name);
};
const AssayPicker = (0,external_react_.memo)(props => {
  const {
    defaultTab = AssayPickerTabs.STANDARD_ASSAY_TAB,
    excludedProviders,
    hasPremium,
    loadOptions = queryAssayProviders,
    onChange,
    showImport,
    showContainerSelect
  } = props;
  const [loadingState, setLoadingState] = (0,external_react_.useState)();
  const [providers, setProviders] = (0,external_react_.useState)([]);
  const [containers, setContainers] = (0,external_react_.useState)();
  const [provider, setProvider] = (0,external_react_.useState)();
  const [container, setContainer] = (0,external_react_.useState)('');
  const [file, setFile] = (0,external_react_.useState)();
  const [tab, setTab] = (0,external_react_.useState)(defaultTab);
  const isLoaded = !isLoading(loadingState);

  // useNotificationsContext will not always be available depending on if the app wraps the NotificationsContext.Provider
  let _createNotification;
  try {
    _createNotification = useNotificationsContext().createNotification;
  } catch (e) {
    // this is expected for LKS usages, so don't throw or console.error
  }
  (0,external_react_.useEffect)(() => {
    setLoadingState(LoadingState.LOADING);
    (async () => {
      try {
        const options = await loadOptions();
        let providers_ = options.providers;
        if (excludedProviders) {
          providers_ = providers_.filter(p => excludedProviders.indexOf(p.name) === -1);
        }
        setProviders(providers_);
        setContainers(options.locations);
        setContainer(options.defaultLocation);
      } catch (error) {
        _createNotification?.({
          message: error,
          alertClass: 'danger'
        });
      } finally {
        setLoadingState(LoadingState.LOADED);
      }
    })();
  }, [_createNotification, excludedProviders]);
  (0,external_react_.useEffect)(() => {
    onChange?.({
      container,
      file,
      provider,
      tab
    });
  }, [onChange, provider, container, file, tab]);
  const selectProvider = (0,external_react_.useCallback)(name => {
    setProvider(getSelectedProvider(providers, name));
  }, [providers]);
  const onSelectTab = (0,external_react_.useCallback)(tab_ => {
    setTab(tab_);
    if (tab_ === AssayPickerTabs.STANDARD_ASSAY_TAB) {
      selectProvider(GENERAL_ASSAY_PROVIDER_NAME);
    } else if (tab_ === AssayPickerTabs.SPECIALTY_ASSAY_TAB) {
      if (providers.length > 0 && (!provider || provider.name === GENERAL_ASSAY_PROVIDER_NAME)) {
        selectProvider(providers.filter(p => p.name !== GENERAL_ASSAY_PROVIDER_NAME)?.[0].name);
      }
    }
  }, [provider, providers, selectProvider]);
  (0,external_react_.useEffect)(() => {
    if (isLoaded) {
      onSelectTab(defaultTab);
    }
  }, [isLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  const onContainerChange = (0,external_react_.useCallback)(value => {
    setContainer(value);
  }, []);
  const standardProvider = (0,external_react_.useMemo)(() => {
    if (providers) {
      return getSelectedProvider(providers, 'General');
    }
    return undefined;
  }, [providers]);
  const onFileRemove = (0,external_react_.useCallback)(() => {
    setFile(undefined);
  }, []);
  const onFileSelect = (0,external_react_.useCallback)(files => {
    setFile(files.values().next().value);
  }, []);
  const containerSelect = (0,external_react_.useMemo)(() => {
    if (!showContainerSelect) {
      return null;
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-6"
    }, /*#__PURE__*/external_react_default().createElement(AssayContainerLocation, {
      locations: containers,
      selected: container,
      onChange: onContainerChange
    })));
  }, [containers, container, onContainerChange, showContainerSelect]);
  return /*#__PURE__*/external_react_default().createElement(Tabs, {
    activeKey: tab,
    onSelect: onSelectTab
  }, /*#__PURE__*/external_react_default().createElement(Tab, {
    eventKey: AssayPickerTabs.STANDARD_ASSAY_TAB,
    title: "Standard Assay",
    className: "margin-top"
  }, /*#__PURE__*/external_react_default().createElement(StandardAssayPanel, {
    provider: standardProvider
  }, showContainerSelect && /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-top"
  }, containerSelect))), /*#__PURE__*/external_react_default().createElement(Tab, {
    eventKey: AssayPickerTabs.SPECIALTY_ASSAY_TAB,
    title: "Specialty Assays",
    className: "margin-top"
  }, /*#__PURE__*/external_react_default().createElement(SpecialtyAssayPanel, {
    hasPremium: hasPremium,
    onChange: selectProvider,
    selected: provider,
    values: providers
  }, showContainerSelect && providers.length > 1 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-top"
  }, containerSelect))), showImport && /*#__PURE__*/external_react_default().createElement(Tab, {
    eventKey: AssayPickerTabs.XAR_IMPORT_TAB,
    title: "Import Assay Design",
    className: "margin-top"
  }, /*#__PURE__*/external_react_default().createElement(AssayDesignUploadPanel, {
    onFileChange: onFileSelect,
    onFileRemove: onFileRemove
  }, showContainerSelect && /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-bottom"
  }, containerSelect))));
});
;// CONCATENATED MODULE: ./src/internal/components/chart/utils.ts



function getChartRowData(row, path) {
  const first = caseInsensitive(row, path[0]);
  if (path.length > 1 && !!first) {
    return caseInsensitive(first, path[1]);
  }
  return first;
}
function processChartData(rows, options) {
  const countPath = options?.countPath ?? ['count', 'value'];
  const colorPath = options?.colorPath;
  const idPath = options?.idPath ?? ['RowId', 'value'];
  const namePath = options?.namePath ?? ['Name', 'value'];
  const groupPath = options?.groupPath;
  const data = rows.filter(row => getChartRowData(row, countPath) > 0).map(row => ({
    count: getChartRowData(row, countPath),
    id: getChartRowData(row, idPath),
    x: getChartRowData(row, namePath),
    xSub: groupPath ? getChartRowData(row, groupPath) : undefined
  }));
  data.sort((a, b) => {
    return naturalSort(a.x, b.x);
  });
  let barFillColors;
  if (colorPath) {
    barFillColors = {};
    rows.forEach(row => {
      barFillColors[getChartRowData(row, groupPath ?? namePath)] = getChartRowData(row, colorPath);
    });
  }
  return {
    barFillColors,
    data
  };
}
function createPercentageBarData(row, itemNounPlural, unusedLabel, totalCountKey, percentageBars, baseAppURL, urlFilterKey) {
  const totalCount = caseInsensitive(row, totalCountKey)?.value ?? 0;
  let unusedCount = totalCount;
  const data = [];
  let subtitle;
  if (totalCount > 0) {
    percentageBars.forEach(percentageBar => {
      const itemCount = caseInsensitive(row, percentageBar.queryKey)?.value ?? 0;
      unusedCount = unusedCount - itemCount;
      const itemPct = itemCount / totalCount * 100;
      const title = `${itemCount.toLocaleString()} of ${totalCount.toLocaleString()} ${itemNounPlural.toLowerCase()} are ${percentageBar.label.toLowerCase()}`;
      data.push({
        title,
        name: percentageBar.name,
        className: percentageBar.className,
        count: itemCount,
        totalCount,
        percent: itemPct,
        href: percentageBar.appURL?.toHref() ?? baseAppURL?.addFilters(api_.Filter.create(urlFilterKey, percentageBar.label)).toHref(),
        filled: percentageBar.filled ?? true
      });
      if (percentageBar.useForSubtitle) {
        subtitle = `${title} (${itemPct > 0 && itemPct < 1 ? '< 1' : Math.trunc(itemPct)}%)`;
      }
    });
    if (unusedLabel) {
      const unusedPct = unusedCount / totalCount * 100;
      const unusedTitle = `${unusedCount.toLocaleString()} of ${totalCount.toLocaleString()} ${itemNounPlural.toLowerCase()} are ${unusedLabel.toLowerCase()}`;
      data.push({
        title: unusedTitle,
        name: 'Available',
        count: unusedCount,
        totalCount,
        percent: unusedPct,
        filled: false
      });
      if (!subtitle) {
        subtitle = `${unusedTitle} (${unusedPct > 0 && unusedPct < 1 ? '< 1' : Math.trunc(unusedPct)}%)`;
      }
    }
  }
  return {
    data,
    subtitle
  };
}
function createHorizontalBarLegendData(data) {
  const legendMap = {};
  data.forEach(row => {
    if (row.filled && row.totalCount > 0) {
      const labels = legendMap[row.backgroundColor] || [];
      if (labels.indexOf(row.name) == -1) {
        labels.push(row.name);
        legendMap[row.backgroundColor] = labels;
      }
    }
  });
  const legendData = [];
  Object.keys(legendMap).forEach(key => {
    legendData.push({
      circleColor: key,
      backgroundColor: 'none',
      legendLabel: legendMap[key].join(', ')
    });
  });
  return legendData;
}
function getBarChartPlotConfig(props) {
  const vis = (0,api_.getServerContext)().vis;
  const {
    renderTo,
    data,
    onClick,
    height,
    width,
    defaultFillColor,
    defaultBorderColor,
    barFillColors,
    grouped
  } = props;
  let marginRight,
    legendPos = 'none',
    legendData;
  const aes = {
    x: 'x',
    y: 'count'
  };
  const scales = {
    y: {
      tickFormat: function (v) {
        if (v.toString().indexOf('.') > -1) {
          return;
        }
        return v;
      }
    }
  };
  if (barFillColors) {
    aes['color'] = 'label';
    scales['color'] = {
      scaleType: 'discrete',
      sortFn: vis.discreteSortFn,
      scale: function (key) {
        return barFillColors[key] || defaultFillColor;
      }
    };
  }
  if (grouped) {
    // in the stacked bar chart case, we actually will end up using the xSub variable for the x-axis categories
    // and the x variable for the secondary category and legend (i.e. the bar chart stacked segments)
    aes['x'] = 'xSub';
    aes['xSub'] = 'x';
    aes['color'] = 'x';
    scales['x'] = {
      scaleType: 'discrete',
      sortFn: function (a, b) {
        // reverse the sorting so that the stacked bar chart segments match the legend
        return vis.discreteSortFn(b, a);
      }
    };
    scales['xSub'] = {
      scaleType: 'discrete',
      sortFn: vis.discreteSortFn
    };
    marginRight = Math.max(...Object.keys(barFillColors).map(text => text.length)) > 10 ? undefined : 125;
    legendPos = 'right';
    legendData = Object.keys(barFillColors).sort().map(text => {
      return {
        text,
        color: barFillColors[text]
      };
    });
  }
  return {
    renderTo,
    rendererType: 'd3',
    width,
    height,
    margins: {
      top: 50,
      right: marginRight
    },
    labels: {
      yLeft: {
        value: 'Count'
      }
    },
    options: {
      color: defaultBorderColor,
      fill: defaultFillColor,
      showValues: true,
      stacked: grouped,
      clickFn: onClick,
      hoverFn: function (row) {
        return (grouped ? row.subLabel + '\n' : '') + (row.label ? row.label + '\n' : '') + 'Count: ' + row.value + '\n' + 'Click to view details';
      }
    },
    legendPos,
    legendData,
    aes,
    scales,
    data
  };
}
;// CONCATENATED MODULE: ./src/internal/components/chart/BaseBarChart.tsx
function BaseBarChart_defineProperty(e, r, t) { return (r = BaseBarChart_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function BaseBarChart_toPropertyKey(t) { var i = BaseBarChart_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function BaseBarChart_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class BaseBarChart extends external_react_.Component {
  constructor(props) {
    super(props);
    BaseBarChart_defineProperty(this, "plotId", void 0);
    BaseBarChart_defineProperty(this, "getPlotElement", () => {
      return document.getElementById(this.plotId);
    });
    BaseBarChart_defineProperty(this, "handleResize", () => {
      this.renderPlot();
    });
    BaseBarChart_defineProperty(this, "getPlotConfig", () => {
      const {
        title,
        data,
        onClick,
        chartHeight,
        defaultFillColor,
        defaultBorderColor,
        barFillColors,
        grouped
      } = this.props;
      return getBarChartPlotConfig({
        renderTo: this.plotId,
        title,
        height: chartHeight,
        width: this.getPlotElement().getBoundingClientRect().width + (grouped ? 0 : 50),
        defaultFillColor,
        defaultBorderColor,
        onClick,
        data,
        barFillColors,
        grouped
      });
    });
    BaseBarChart_defineProperty(this, "renderPlot", () => {
      this.getPlotElement().innerHTML = '';
      const plot = new LABKEY_VIS.BarPlot(this.getPlotConfig());
      plot.render();
    });
    this.plotId = generateId('base-barchart-');
    this.handleResize = debounce(this.handleResize, 75);
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.renderPlot();
  }
  componentDidUpdate() {
    this.renderPlot();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  render() {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "base-bar-chart",
      id: this.plotId
    });
  }
}
BaseBarChart_defineProperty(BaseBarChart, "defaultProps", {
  chartHeight: 350,
  defaultFillColor: '#236fa0',
  defaultBorderColor: '#236fa0',
  grouped: false
});
;// CONCATENATED MODULE: ./src/internal/components/PreviewGrid.tsx
function PreviewGrid_extends() { return PreviewGrid_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, PreviewGrid_extends.apply(null, arguments); }
function PreviewGrid_defineProperty(e, r, t) { return (r = PreviewGrid_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function PreviewGrid_toPropertyKey(t) { var i = PreviewGrid_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function PreviewGrid_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







class StatelessPreviewGrid extends external_react_.PureComponent {
  render() {
    const {
      loading,
      data,
      error,
      queryInfo,
      numCols,
      numRows,
      schemaQuery
    } = this.props;
    let body = /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
    if (loading === false && data !== null) {
      const {
        viewName
      } = schemaQuery;
      const allColumns = queryInfo.getDisplayColumns(viewName);
      const columns = allColumns.slice(0, numCols);
      const slicedData = data.slice(0, numRows).toList();
      let rowStats = '';
      if (slicedData.size === 1) {
        rowStats = ' first row and';
      } else if (slicedData.size > 1) {
        rowStats = ` first ${slicedData.size} rows and`;
      }
      const stats = `Previewing${rowStats} ${columns.length} of ${allColumns.length} columns.`;
      body = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, stats), /*#__PURE__*/external_react_default().createElement(Grid, {
        bordered: true,
        columns: (0,external_immutable_.List)(columns),
        data: slicedData
      }));
    } else if (loading === false && error !== null) {
      body = /*#__PURE__*/external_react_default().createElement(Alert, null, error);
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "preview-grid"
    }, body);
  }
}
class PreviewGrid extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    PreviewGrid_defineProperty(this, "fetchData", () => {
      this.setState(() => ({
        loading: true
      }));
      const {
        numCols,
        numRows
      } = this.props;
      const {
        schemaName,
        queryName,
        viewName
      } = this.props.schemaQuery;
      const handleFailure = resp => {
        // Do we know for sure that the error response in getQueryDetails will look the same as selectRows? We may
        // need to tweak this error handler to handle both cases, or just write one for each.
        const error = resolveErrorMessage(resp) || 'An unexpected error encountered while loading the data.';
        this.setState(() => ({
          error,
          loading: false
        }));
      };
      getQueryDetails({
        schemaName,
        queryName
      }).then(queryInfo => {
        const columns = queryInfo.getDisplayColumns(viewName).slice(0, numCols);
        const colString = queryInfo.getPkCols().concat(columns).map(c => c.fieldKey).join(',');
        selectRowsDeprecated({
          schemaName,
          queryName,
          viewName,
          columns: colString,
          maxRows: numRows,
          // No need to include total count, we only want the first three rows and it could be a perf issue.
          includeTotalCount: false
        }).then(({
          key,
          models,
          orderedModels
        }) => {
          const rows = (0,external_immutable_.fromJS)(models[key]);
          const data = (0,external_immutable_.List)(orderedModels[key]).map(id => rows.get(id)).toList();
          this.setState(() => ({
            queryInfo,
            data,
            loading: false,
            error: null
          }));
        }).catch(handleFailure);
      }).catch(handleFailure);
    });
    this.state = {
      queryInfo: null,
      data: null,
      loading: false,
      error: null
    };
  }
  componentDidMount() {
    this.fetchData();
  }
  render() {
    return /*#__PURE__*/external_react_default().createElement(StatelessPreviewGrid, PreviewGrid_extends({}, this.props, this.state));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/chart/api.ts



function fetchGenericChart(reportId) {
  return new Promise((resolve, reject) => {
    api_.Query.Visualization.get({
      reportId,
      name: undefined,
      schemaName: undefined,
      queryName: undefined,
      success: response => {
        resolve(response);
      },
      failure: reason => {
        console.error(reason);
        reject(reason);
      }
    });
  });
}
function fetchRReport(reportId, urlPrefix = 'query', container, filters) {
  return new Promise((resolve, reject) => {
    // The getWebPart API honors containerFilterName, not containerFilter.
    const containerFilterPrefix = `${urlPrefix}.containerFilterName`;
    const params = {
      reportId,
      'webpart.name': 'report',
      [containerFilterPrefix]: getContainerFilter(container)
    };
    if (filters) {
      filters.forEach(filter => params[filter.getURLParameterName(urlPrefix)] = filter.getURLParameterValue());
    }
    api_.Ajax.request({
      url: buildURL('project', 'getWebPart.view', params, {
        container
      }),
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response.html);
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        reject(response);
      })
    });
  });
}
const DEFAULT_API_WRAPPER = {
  fetchRReport,
  fetchGenericChart
};
;// CONCATENATED MODULE: ./src/internal/components/chart/actions.ts



function saveChart(reportConfig, containerPath) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL('visualization', 'saveGenericReport.api', undefined, {
        container: containerPath
      }),
      method: 'POST',
      jsonData: reportConfig,
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        console.error(error);
        reject(resolveErrorMessage(error) ?? 'Failed to save chart.');
      })
    });
  });
}
function deleteChart(id, dataType = 'reports', containerPath) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: buildURL('reports', 'deleteViews.api', undefined, {
        container: containerPath
      }),
      method: 'POST',
      jsonData: {
        views: [{
          dataType,
          id
        }]
      },
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response);
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        console.error(error);
        reject(resolveErrorMessage(error) ?? 'Failed to delete chart.');
      })
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/chart/ChartBuilderModal.tsx
function ChartBuilderModal_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ChartBuilderModal_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ChartBuilderModal_ownKeys(Object(t), !0).forEach(function (r) { ChartBuilderModal_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ChartBuilderModal_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ChartBuilderModal_defineProperty(e, r, t) { return (r = ChartBuilderModal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ChartBuilderModal_toPropertyKey(t) { var i = ChartBuilderModal_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ChartBuilderModal_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

















const HIDDEN_CHART_TYPES = ['time_chart'];
const RIGHT_COL_FIELDS = ['color', 'shape', 'series'];
const MAX_ROWS_PREVIEW = 10000;
const MAX_POINT_DISPLAY = 10000;
const BLUE_HEX_COLOR = '3366FF';
const BAR_CHART_AGGREGATE_NAME = 'aggregate-method';
const BAR_CHART_AGGREGATE_METHODS = [{
  label: 'Count (non-blank)',
  value: 'COUNT'
}, {
  label: 'Sum',
  value: 'SUM'
}, {
  label: 'Min',
  value: 'MIN'
}, {
  label: 'Max',
  value: 'MAX'
}, {
  label: 'Mean',
  value: 'MEAN'
}, {
  label: 'Median',
  value: 'MEDIAN'
}];
const BAR_CHART_AGGREGATE_METHOD_TIP = 'The aggregate method that will be used to determine the bar height for a given x-axis category / dimension. Field values that are blank are not included in calculated aggregate values.';
const ICONS = {
  bar_chart: 'bar_chart',
  box_plot: 'box_plot',
  pie_chart: 'pie_chart',
  scatter_plot: 'xy_scatter',
  line_plot: 'xy_line'
};
const getChartRenderMsg = (chartConfig, rowCount, isPreview) => {
  const msg = [];
  if (isPreview && rowCount === MAX_ROWS_PREVIEW) {
    msg.push(`The preview is being limited to ${MAX_ROWS_PREVIEW.toLocaleString()} rows.`);
  }
  if (chartConfig.renderType === 'line_plot' && rowCount > chartConfig.geomOptions.binThreshold) {
    msg.push(`The number of individual points exceeds ${MAX_POINT_DISPLAY.toLocaleString()}.`);
    msg.push('Data points will not be shown on this line plot.');
  } else if (chartConfig.renderType === 'scatter_plot' && rowCount > MAX_POINT_DISPLAY) {
    msg.push(`The number of individual points exceeds ${MAX_POINT_DISPLAY.toLocaleString()}.`);
    msg.push('The data is now grouped by density.');
  }
  return msg.length === 0 ? undefined : msg.join(' ');
};
const getSelectOptions = (model, chartType, field) => {
  const allowableTypes = LABKEY_VIS.GenericChartHelper.getAllowableTypes(field);
  return model.queryInfo.getDisplayColumns(model.viewName).filter(col => {
    const colType = col.displayFieldJsonType || col.jsonType;
    const hasMatchingType = allowableTypes.indexOf(colType) > -1;
    const isMeasureDimensionMatch = LABKEY_VIS.GenericChartHelper.isMeasureDimensionMatch(chartType.name, field, col.measure, col.dimension);
    return hasMatchingType || isMeasureDimensionMatch;
  }).sort(naturalSortByProperty('caption')).map(col => ({
    label: col.caption,
    value: col.fieldKey,
    data: col
  }));
};
const getChartBuilderQueryConfig = (model, fieldValues, chartConfig, savedConfig) => {
  const {
    schemaQuery,
    containerPath
  } = model;
  const {
    schemaName,
    queryName,
    viewName
  } = schemaQuery;
  return {
    maxRows: -1,
    // this will be saved with the queryConfig, but we will override it for the preview in the modal
    requiredVersion: '13.2',
    schemaName: savedConfig?.schemaName || schemaName,
    queryName: savedConfig?.queryName || queryName,
    viewName: savedConfig?.viewName || viewName,
    columns: Object.values(fieldValues).filter(field => field?.value).map(field => field.value),
    sort: LABKEY_VIS.GenericChartHelper.getQueryConfigSortKey(chartConfig.measures),
    filterArray: savedConfig?.filterArray ?? [],
    containerPath: savedConfig?.containerPath || containerPath
  };
};
const getChartBuilderChartConfig = (chartType, fieldValues, savedConfig) => {
  const config = {
    renderType: chartType.name,
    measures: {},
    scales: ChartBuilderModal_objectSpread({}, savedConfig?.scales),
    labels: ChartBuilderModal_objectSpread({
      main: '',
      subtitle: ''
    }, savedConfig?.labels),
    pointType: savedConfig?.pointType ?? 'all',
    geomOptions: ChartBuilderModal_objectSpread({
      binShape: 'hex',
      binSingleColor: '000000',
      binThreshold: MAX_POINT_DISPLAY,
      boxFillColor: chartType.name === 'box_plot' ? 'none' : BLUE_HEX_COLOR,
      chartLayout: 'single',
      chartSubjectSelection: 'subjects',
      colorPaletteScale: 'ColorDiscrete',
      colorRange: 'BlueWhite',
      displayIndividual: true,
      displayAggregate: false,
      errorBars: 'None',
      gradientColor: 'FFFFFF',
      gradientPercentage: 95,
      hideDataPoints: false,
      hideTrendLine: false,
      lineColor: '000000',
      lineWidth: chartType.name === 'line_plot' ? 3 : 1,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      marginTop: 20,
      // this will be saved with the chartConfig, but we will override it for the preview in the modal
      opacity: chartType.name === 'bar_chart' || chartType.name === 'line_plot' ? 1.0 : 0.5,
      pieHideWhenLessThanPercentage: 5,
      pieInnerRadius: 0,
      pieOuterRadius: 80,
      piePercentagesColor: '333333',
      pointFillColor: BLUE_HEX_COLOR,
      pointSize: chartType.name === 'box_plot' ? 3 : 5,
      position: chartType.name === 'box_plot' ? 'jitter' : null,
      showOutliers: true,
      showPiePercentages: true
    }, savedConfig?.geomOptions)
  };
  chartType.fields.forEach(field => {
    if (fieldValues[field.name]?.value) {
      config.measures[field.name] = {
        fieldKey: fieldValues[field.name].data.fieldKey,
        name: fieldValues[field.name].value,
        label: fieldValues[field.name].label,
        queryName: fieldValues[field.name].data.queryName,
        schemaName: fieldValues[field.name].data.schemaName,
        type: fieldValues[field.name].data.displayFieldJsonType || fieldValues[field.name].data.jsonType || fieldValues[field.name].data.type
      };

      // check if the field has an aggregate method (bar chart y-axis only)
      if (fieldValues[BAR_CHART_AGGREGATE_NAME] && field.name === 'y') {
        config.measures[field.name].aggregate = ChartBuilderModal_objectSpread({}, fieldValues[BAR_CHART_AGGREGATE_NAME]);
      }

      // update axis label if it is a new report or if the saved report that didn't have this measure or was using the default field label for the axis label
      if (!savedConfig || !savedConfig.measures[field.name] || savedConfig.labels[field.name] === savedConfig.measures[field.name].label) {
        config.labels[field.name] = fieldValues[field.name].label;
      }
    }
  });
  if (chartType.name === 'bar_chart' && (!savedConfig || !savedConfig.labels?.['y'] || savedConfig.labels?.['y'] === getDefaultBarChartAxisLabel(savedConfig))) {
    config.labels['y'] = getDefaultBarChartAxisLabel(config);
  }
  return config;
};
const getDefaultBarChartAxisLabel = config => {
  const aggregate = config.measures.y?.aggregate;
  const prefix = (aggregate?.name ?? aggregate?.label ?? 'Sum') + ' of ';
  return config.measures.y ? prefix + config.measures.y.label : 'Count';
};
const ChartTypeSideBar = (0,external_react_.memo)(props => {
  const {
    chartTypes,
    savedChartModel,
    selectedType,
    onChange
  } = props;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, chartTypes.map(type => {
    const selected = selectedType.name === type.name;
    const selectable = !savedChartModel && selectedType.name !== type.name;
    return /*#__PURE__*/external_react_default().createElement("div", {
      key: type.name,
      className: external_classnames_default()('chart-builder-type', {
        selected,
        selectable
      }),
      "data-name": type.name,
      onClick: onChange
    }, /*#__PURE__*/external_react_default().createElement(SVGIcon, {
      height: null,
      iconSrc: !selected ? ICONS[type.name] + '_gray' : ICONS[type.name]
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "title"
    }, type.title));
  }));
});
const ChartTypeQueryForm = (0,external_react_.memo)(props => {
  const {
    canShare,
    onNameChange,
    name,
    shared,
    onToggleShared,
    selectedType,
    fieldValues,
    model,
    onSelectFieldChange
  } = props;
  const leftColFields = (0,external_react_.useMemo)(() => {
    return selectedType.fields.filter(field => !RIGHT_COL_FIELDS.includes(field.name) && (selectedType.name !== 'bar_chart' || field.name !== 'y'));
  }, [selectedType]);
  const rightColFields = (0,external_react_.useMemo)(() => {
    return selectedType.fields.filter(field => RIGHT_COL_FIELDS.includes(field.name) || selectedType.name === 'bar_chart' && field.name === 'y');
  }, [selectedType]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "chart-builder-type-inputs"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-4"
  }, /*#__PURE__*/external_react_default().createElement("label", null, "Name *"), /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control",
    name: "name",
    placeholder: "Enter a name",
    type: "text",
    onChange: onNameChange,
    value: name
  }), canShare && /*#__PURE__*/external_react_default().createElement("div", {
    className: "checkbox-input"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    name: "shared",
    type: "checkbox",
    checked: shared,
    onChange: onToggleShared
  }), /*#__PURE__*/external_react_default().createElement("span", {
    onClick: onToggleShared
  }, "Make this chart available to all users"))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-4 fields-col"
  }, leftColFields.map(field => /*#__PURE__*/external_react_default().createElement("div", {
    key: field.name
  }, /*#__PURE__*/external_react_default().createElement("label", null, field.label, field.required && ' *'), /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    showLabel: false,
    inputClass: "col-xs-12",
    placeholder: "Select a field",
    name: field.name,
    options: getSelectOptions(model, selectedType, field),
    onChange: onSelectFieldChange,
    value: fieldValues[field.name]?.value
  })))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-4 fields-col"
  }, rightColFields.map(field => /*#__PURE__*/external_react_default().createElement(external_react_.Fragment, {
    key: field.name
  }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("label", null, field.label, field.required && ' *'), /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    showLabel: false,
    inputClass: "col-xs-12",
    placeholder: "Select a field",
    name: field.name,
    options: getSelectOptions(model, selectedType, field),
    onChange: onSelectFieldChange,
    value: fieldValues[field.name]?.value
  })), selectedType.name === 'bar_chart' && fieldValues.y?.value && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("label", null, "Y Axis Aggregate Method", ' ', /*#__PURE__*/external_react_default().createElement(LabelOverlay, {
    placement: "bottom"
  }, BAR_CHART_AGGREGATE_METHOD_TIP)), /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    showLabel: false,
    clearable: false,
    inputClass: "col-xs-12",
    placeholder: "Select aggregate method",
    name: BAR_CHART_AGGREGATE_NAME,
    options: BAR_CHART_AGGREGATE_METHODS,
    onChange: onSelectFieldChange,
    value: fieldValues[BAR_CHART_AGGREGATE_NAME]?.value ?? 'SUM'
  })))))));
});
const ChartPreview = (0,external_react_.memo)(props => {
  const {
    hasRequiredValues,
    model,
    selectedType,
    fieldValues,
    savedChartModel,
    setReportConfig
  } = props;
  const divId = (0,external_react_.useMemo)(() => generateId('chart-'), []);
  const ref = (0,external_react_.useRef)(undefined);
  const containerFilter = (0,external_react_.useMemo)(() => getContainerFilter(model.containerPath), [model.containerPath]);
  const [loadingData, setLoadingData] = (0,external_react_.useState)(false);
  const [previewMsg, setPreviewMsg] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    if (ref?.current) ref.current.innerHTML = '';
    setPreviewMsg(undefined);
    if (!hasRequiredValues) return;
    const width = ref?.current.getBoundingClientRect().width || 750;
    const chartConfig = getChartBuilderChartConfig(selectedType, fieldValues, savedChartModel?.visualizationConfig?.chartConfig);
    const queryConfig = getChartBuilderQueryConfig(model, fieldValues, chartConfig, savedChartModel?.visualizationConfig?.queryConfig);
    setReportConfig({
      schemaName: queryConfig.schemaName,
      queryName: queryConfig.queryName,
      viewName: queryConfig.viewName,
      renderType: chartConfig.renderType,
      jsonData: {
        chartConfig,
        queryConfig: ChartBuilderModal_objectSpread(ChartBuilderModal_objectSpread({}, queryConfig), {}, {
          filterArray: queryConfig.filterArray.map(f => ({
            name: f['name'] ?? f.getColumnName(),
            value: f['value'] ?? f.getValue(),
            type: f['type'] ?? f.getFilterType().getURLSuffix()
          }))
        })
      }
    });

    // add model filters, parameters, and containerFilter plus maxRows to the queryConfig for the preview, but not to save with the chart
    const queryConfig_ = ChartBuilderModal_objectSpread(ChartBuilderModal_objectSpread({}, queryConfig), {}, {
      containerFilter,
      filterArray: [...model.loadRowsFilters(true)],
      parameters: model.queryParameters,
      maxRows: MAX_ROWS_PREVIEW
    });
    setLoadingData(true);
    LABKEY_VIS.GenericChartHelper.queryChartData(divId, queryConfig_, measureStore => {
      const rowCount = LABKEY_VIS.GenericChartHelper.getMeasureStoreRecords(measureStore).length;
      const _previewMsg = getChartRenderMsg(chartConfig, rowCount, true);
      if (rowCount > MAX_POINT_DISPLAY) {
        if (chartConfig.renderType === 'box_plot') {
          chartConfig.pointType = 'outliers';
          chartConfig.geomOptions.boxFillColor = BLUE_HEX_COLOR;
        } else if (chartConfig.renderType === 'line_plot') {
          chartConfig.geomOptions.hideDataPoints = true;
        }
      }

      // adjust height, width, and marginTop for the chart config for the preview, but not to save with the chart
      var chartConfig_ = ChartBuilderModal_objectSpread(ChartBuilderModal_objectSpread({}, chartConfig), {}, {
        height: 350,
        width
      });
      if (!savedChartModel || savedChartModel.visualizationConfig.chartConfig.geomOptions.marginTop === 20) {
        chartConfig_.geomOptions.marginTop = 10;
      }
      if (ref?.current) ref.current.innerHTML = ''; // clear again, right before render
      LABKEY_VIS.GenericChartHelper.generateChartSVG(divId, chartConfig_, measureStore);
      setPreviewMsg(_previewMsg);
      setLoadingData(false);
    });
  }, [divId, model, hasRequiredValues, selectedType, fieldValues, savedChartModel, containerFilter, setReportConfig]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("label", null, "Preview"), previewMsg && /*#__PURE__*/external_react_default().createElement("span", {
    className: "chart-builder-preview-msg gray-text pull-right"
  }, previewMsg), !hasRequiredValues && /*#__PURE__*/external_react_default().createElement("div", {
    className: "gray-text"
  }, "Select required fields to preview the chart."), hasRequiredValues && /*#__PURE__*/external_react_default().createElement("div", {
    className: "chart-builder-preview-body"
  }, loadingData && /*#__PURE__*/external_react_default().createElement("div", {
    className: "chart-loading-mask"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "chart-loading-mask__background"
  }), /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
    wrapperClassName: "loading-spinner",
    msg: "Loading Preview..."
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "svg-chart__chart",
    id: divId,
    ref: ref
  })));
});
const ChartBuilderFooter = (0,external_react_.memo)(props => {
  const {
    savedChartModel,
    onSaveChart,
    onCancel,
    setError,
    afterDelete,
    saving,
    disabled
  } = props;
  const [deleting, setDeleting] = (0,external_react_.useState)(false);
  const [showConfirmDelete, setShowConfirmDelete] = (0,external_react_.useState)(false);
  const onCancel_ = (0,external_react_.useCallback)(() => {
    onCancel();
  }, [onCancel]);
  const onDeleteChart = (0,external_react_.useCallback)(() => {
    setShowConfirmDelete(true);
  }, []);
  const onCancelDelete = (0,external_react_.useCallback)(() => {
    setShowConfirmDelete(false);
    setError(undefined);
  }, [setError]);
  const onConfirmDelete = (0,external_react_.useCallback)(async () => {
    setDeleting(true);
    setError(undefined);
    try {
      await deleteChart(savedChartModel.id);
      setDeleting(false);
      afterDelete();
    } catch (e) {
      setError(e.exception ?? e);
      setDeleting(false);
    }
  }, [savedChartModel, setError, afterDelete]);
  if (showConfirmDelete) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "form-buttons"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "form-buttons__left"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "form-buttons__right"
    }, "Are you sure you want to permanently delete this chart?", /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: onCancelDelete,
      type: "button",
      disabled: deleting
    }, "Cancel"), /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-danger",
      onClick: onConfirmDelete,
      type: "button",
      disabled: deleting
    }, deleting ? 'Deleting...' : 'Delete')));
  }
  return /*#__PURE__*/external_react_default().createElement(FormButtons, {
    sticky: false
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default",
    onClick: onCancel_,
    type: "button"
  }, "Cancel"), savedChartModel?.canDelete && /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-danger",
    onClick: onDeleteChart,
    type: "button"
  }, "Delete Chart"), /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-success",
    onClick: onSaveChart,
    type: "button",
    disabled: saving || disabled
  }, saving ? savedChartModel ? 'Saving Chart...' : 'Creating Chart...' : savedChartModel ? 'Save Chart' : 'Create Chart'));
});
const ChartBuilderModal = (0,external_react_.memo)(({
  actions,
  model,
  onHide,
  savedChartModel
}) => {
  const CHART_TYPES = LABKEY_VIS?.GenericChartHelper.getRenderTypes();
  const {
    user
  } = useServerContext();
  const canShare = (0,external_react_.useMemo)(() => savedChartModel?.canShare ?? hasPermissions(user, [api_.PermissionTypes.ShareReportPermission]), [savedChartModel, user]);
  const chartTypes = (0,external_react_.useMemo)(() => CHART_TYPES.filter(type => !type.hidden && !HIDDEN_CHART_TYPES.includes(type.name)), [CHART_TYPES]);
  const [saving, setSaving] = (0,external_react_.useState)(false);
  const [error, setError] = (0,external_react_.useState)();
  const [reportConfig, setReportConfig] = (0,external_react_.useState)();
  const [selectedType, setSelectedChartType] = (0,external_react_.useState)(chartTypes[0]);
  const [name, setName] = (0,external_react_.useState)('');
  const [shared, setShared] = (0,external_react_.useState)(canShare);
  const [fieldValues, setFieldValues] = (0,external_react_.useState)({});
  (0,external_react_.useEffect)(() => {
    if (savedChartModel) {
      setSelectedChartType(chartTypes.find(c => savedChartModel?.visualizationConfig.chartConfig.renderType === c.name));
      setName(savedChartModel.name);
      setShared(savedChartModel.shared);
      const measures = savedChartModel.visualizationConfig?.chartConfig?.measures || {};
      const fieldValues_ = Object.keys(measures).reduce((result, key) => {
        let measure = measures[key];
        if (measure) {
          // Currently only supporting a single measure per axis (i.e. not supporting y-axis left/right)
          if (api_.Utils.isArray(measure)) measure = measure[0];
          result[key] = {
            label: measure.label,
            value: measure.name,
            data: measure
          };
        }
        return result;
      }, {});

      // special case for the bar chart aggregate method
      if (measures.y?.aggregate) {
        fieldValues_[BAR_CHART_AGGREGATE_NAME] = ChartBuilderModal_objectSpread({}, measures.y.aggregate);
      }
      setFieldValues(fieldValues_);
    }
  }, [
    /* on mount only */
  ]);
  const hasName = (0,external_react_.useMemo)(() => name?.trim().length > 0, [name]);
  const hasRequiredValues = (0,external_react_.useMemo)(() => {
    return selectedType.fields.find(field => field.required && !fieldValues[field.name]) === undefined;
  }, [selectedType, fieldValues]);
  const onChartTypeChange = (0,external_react_.useCallback)(e => {
    // don't allow changing chart type for a saved report
    if (savedChartModel) return;
    const selectedName = e.target.getAttribute('data-name') ?? e.target.parentElement.getAttribute('data-name');
    setSelectedChartType(chartTypes.find(type => type.name === selectedName) || chartTypes[0]);
    setFieldValues({});
  }, [chartTypes, savedChartModel]);
  const onNameChange = (0,external_react_.useCallback)(event => {
    setName(event.target.value);
  }, []);
  const onToggleShared = (0,external_react_.useCallback)(() => {
    setShared(prev => !prev);
  }, []);
  const onSelectFieldChange = (0,external_react_.useCallback)((key, _, selectedOption) => {
    setReportConfig(undefined); // clear report config state, it will be reset after the preview loads
    setFieldValues(prev => ChartBuilderModal_objectSpread(ChartBuilderModal_objectSpread({}, prev), {}, {
      [key]: selectedOption
    }));
  }, []);
  const onSaveChart = (0,external_react_.useCallback)(async () => {
    const _reportConfig = ChartBuilderModal_objectSpread(ChartBuilderModal_objectSpread({}, reportConfig), {}, {
      reportId: savedChartModel?.reportId,
      name: name?.trim(),
      public: shared
    });
    setSaving(true);
    setError(undefined);
    try {
      const response = await saveChart(_reportConfig);
      setSaving(false);
      onHide(`Successfully ${savedChartModel ? 'updated' : 'created'} chart: ${_reportConfig.name}.`);

      // clear the selected report, if we are saving/updating it, so that it will refresh in ChartPanel.tsx
      await actions.selectReport(model.id, undefined);
      await actions.loadCharts(model.id);
      actions.selectReport(model.id, response.reportId);
    } catch (e) {
      setError(e.exception ?? e);
      setSaving(false);
    }
  }, [savedChartModel, reportConfig, name, shared, actions, model.id, onHide]);
  const afterDelete = (0,external_react_.useCallback)(async () => {
    onHide('Successfully deleted chart: ' + savedChartModel.name + '.');
    await actions.selectReport(model.id, undefined);
    await actions.loadCharts(model.id);
  }, [actions, model.id, onHide, savedChartModel]);
  const onCancel = (0,external_react_.useCallback)(() => {
    onHide();
  }, [onHide]);
  const footer = /*#__PURE__*/external_react_default().createElement(ChartBuilderFooter, {
    afterDelete: afterDelete,
    disabled: !hasName || !hasRequiredValues || !reportConfig,
    onCancel: onCancel,
    onSaveChart: onSaveChart,
    savedChartModel: savedChartModel,
    saving: saving,
    setError: setError
  });
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    className: "chart-builder-modal",
    onCancel: onCancel,
    title: savedChartModel ? 'Edit Chart' : 'Create Chart',
    footer: footer
  }, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-1 col-left"
  }, /*#__PURE__*/external_react_default().createElement(ChartTypeSideBar, {
    chartTypes: chartTypes,
    onChange: onChartTypeChange,
    selectedType: selectedType,
    savedChartModel: savedChartModel
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-11 col-right"
  }, /*#__PURE__*/external_react_default().createElement(ChartTypeQueryForm, {
    canShare: canShare,
    fieldValues: fieldValues,
    model: model,
    name: name,
    onNameChange: onNameChange,
    onSelectFieldChange: onSelectFieldChange,
    onToggleShared: onToggleShared,
    savedChartModel: savedChartModel,
    shared: shared,
    selectedType: selectedType
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row margin-top"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement(ChartPreview, {
    savedChartModel: savedChartModel,
    fieldValues: fieldValues,
    model: model,
    hasRequiredValues: hasRequiredValues,
    selectedType: selectedType,
    setReportConfig: setReportConfig
  }))))));
});
;// CONCATENATED MODULE: ./src/internal/components/chart/Chart.tsx
function Chart_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Chart_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Chart_ownKeys(Object(t), !0).forEach(function (r) { Chart_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Chart_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Chart_defineProperty(e, r, t) { return (r = Chart_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Chart_toPropertyKey(t) { var i = Chart_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Chart_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









const ChartLoadingMask = (0,external_react_.memo)(({
  msg = 'Loading Chart...'
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "chart-loading-mask"
}, /*#__PURE__*/external_react_default().createElement("div", {
  className: "chart-loading-mask__background"
}), /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
  msg: msg,
  wrapperClassName: "loading-spinner"
})));

/**
 * Returns a string representation of a given filter array. Needed to properly memoize variables in functional
 * components that rely on a filter array from QueryModel, because QueryModel always returns a new filter array.
 * @param filters
 */
function computeFilterKey(filters) {
  if (!filters) return '';
  return filters.map(f => f.getURLParameterName() + '=' + f.getURLParameterValue()).sort().join('_');
}
const MAX_HEIGHT = 500;
function computeDimensions(width) {
  const dimensions = {
    width,
    height: width * 9 / 16 // 16:9 aspect ratio
  };
  if (dimensions.height > MAX_HEIGHT) dimensions.height = MAX_HEIGHT;
  return dimensions;
}
const SVGChart = (0,external_react_.memo)(({
  api,
  chart,
  container,
  filters
}) => {
  const {
    error,
    reportId
  } = chart;
  const divId = (0,external_react_.useMemo)(() => generateId('chart-'), []);
  const containerFilter = (0,external_react_.useMemo)(() => getContainerFilter(container), [container]);
  const [loadingState, setLoadingState] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [queryConfig, setQueryConfig] = (0,external_react_.useState)(undefined);
  const [chartConfig, setChartConfig] = (0,external_react_.useState)(undefined);
  const [loadingData, setLoadingData] = (0,external_react_.useState)(false);
  const [measureStore, setMeasureStore] = (0,external_react_.useState)(undefined);
  const [renderMsg, setRenderMsg] = (0,external_react_.useState)(undefined);
  const [loadError, setLoadError] = (0,external_react_.useState)(undefined);
  const filterKey = (0,external_react_.useMemo)(() => computeFilterKey(filters), [filters]);
  const ref = (0,external_react_.useRef)(undefined);
  const loadChartConfig = (0,external_react_.useCallback)(async () => {
    setLoadingState(LoadingState.LOADING);
    setRenderMsg(undefined);
    setMeasureStore(undefined);
    try {
      const savedChartModel = await api.fetchGenericChart(reportId);
      const chartConfig_ = Chart_objectSpread(Chart_objectSpread({}, savedChartModel.visualizationConfig.chartConfig), computeDimensions(ref.current.offsetWidth));
      setChartConfig(chartConfig_);
      const queryConfig_ = savedChartModel.visualizationConfig.queryConfig;
      queryConfig_.containerFilter = containerFilter;
      if (filters) {
        queryConfig_.filterArray = [...queryConfig_.filterArray, ...filters];
      }
      setQueryConfig(queryConfig_);
    } catch (e) {
      setLoadError(e.exception);
    } finally {
      setLoadingState(LoadingState.LOADED);
    }
    // We purposely don't use filters as a dep, see note in computeFilterKey
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, containerFilter, reportId, filterKey]);
  const updateChartSize = (0,external_react_.useCallback)(() => {
    setChartConfig(currentChartConfig => {
      if (currentChartConfig === undefined || ref.current === undefined) return currentChartConfig;
      const updatedChartConfig = Chart_objectSpread(Chart_objectSpread({}, currentChartConfig), computeDimensions(ref.current.offsetWidth));
      setChartConfig(updatedChartConfig);
      return updatedChartConfig;
    });
  }, []);
  (0,external_react_.useEffect)(() => {
    if (!error) {
      loadChartConfig();
    }
  }, [error, loadChartConfig]);
  (0,external_react_.useEffect)(() => {
    window.addEventListener('resize', updateChartSize);
    return () => window.removeEventListener('resize', updateChartSize);
  }, [updateChartSize]);
  (0,external_react_.useEffect)(() => {
    const render = () => {
      if (queryConfig !== undefined && chartConfig !== undefined) {
        ref.current.innerHTML = '';
        if (!measureStore) {
          setLoadingData(true);
          LABKEY_VIS.GenericChartHelper.queryChartData(divId, queryConfig, _measureStore => {
            const rowCount = LABKEY_VIS.GenericChartHelper.getMeasureStoreRecords(_measureStore).length;
            setRenderMsg(getChartRenderMsg(chartConfig, rowCount, false));
            setMeasureStore(_measureStore);
            setLoadingData(false);
          });
        } else {
          LABKEY_VIS.GenericChartHelper.generateChartSVG(divId, chartConfig, measureStore);
        }
      }
    };
    // Debounce the call to render because we may trigger many resize events back to back, which will produce many
    // new chartConfig objects
    const renderId = window.setTimeout(render, 250);
    return () => window.clearTimeout(renderId);
  }, [divId, chartConfig, queryConfig, measureStore]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "svg-chart chart-body"
  }, error !== undefined && /*#__PURE__*/external_react_default().createElement("span", {
    className: "text-danger"
  }, error), loadError !== undefined && /*#__PURE__*/external_react_default().createElement("span", {
    className: "text-danger"
  }, loadError), (isLoading(loadingState) || loadingData) && /*#__PURE__*/external_react_default().createElement(ChartLoadingMask, null), renderMsg && /*#__PURE__*/external_react_default().createElement("span", {
    className: "gray-text pull-right"
  }, renderMsg), /*#__PURE__*/external_react_default().createElement("div", {
    className: "svg-chart__chart",
    id: divId,
    ref: ref
  }));
});
SVGChart.displayName = 'SVGChart';
function parseRReportHtml(html) {
  let _fileAnchors;
  let _imageUrls;
  let error;
  if (html !== undefined) {
    // The HTML returned by our server includes a bunch of stuff we don't want. So instead of inserting it
    // directly we'll just grab the URLs for all the images named "resultImage", which are the outputs from an
    // R Report.
    const el = document.createElement('div');
    el.innerHTML = html;
    const resultAnchors = el.querySelectorAll('a[href*="reports-streamFile.view"]');
    _fileAnchors = Array.from(resultAnchors).map(anchor => ({
      href: anchor.href,
      text: anchor.innerText
    }));
    const resultImages = el.querySelectorAll('img[name="resultImage"]');
    _imageUrls = Array.from(resultImages).map(img => img.src);
    const errorEl = el.querySelector('.labkey-error');
    if (errorEl) {
      error = errorEl.parentElement.querySelector('pre')?.innerText;
    }
  }
  return {
    error,
    fileAnchors: _fileAnchors?.length > 0 ? _fileAnchors : undefined,
    imageUrls: _imageUrls?.length > 0 ? _imageUrls : undefined
  };
}
const RReport = (0,external_react_.memo)(({
  api,
  chart,
  container,
  filters
}) => {
  const {
    dataRegionName,
    error: chartError,
    reportId
  } = chart;
  const [loadingState, setLoadingState] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [reportHtml, setReportHtml] = (0,external_react_.useState)(undefined);
  const [loadError, setLoadError] = (0,external_react_.useState)(undefined);
  const filterKey = (0,external_react_.useMemo)(() => computeFilterKey(filters), [filters]);
  const loadReport = (0,external_react_.useCallback)(async () => {
    setLoadingState(LoadingState.LOADING);
    setLoadError(undefined);
    try {
      const html = await api.fetchRReport(reportId, dataRegionName, container, filters);
      setReportHtml(html);
    } catch (e) {
      setLoadError(e.exception);
    } finally {
      setLoadingState(LoadingState.LOADED);
    }
    // We purposely don't use filters as a dep, see note in computeFilterKey
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, reportId, filterKey]);
  const {
    error: outputError,
    fileAnchors,
    imageUrls
  } = (0,external_react_.useMemo)(() => parseRReportHtml(reportHtml), [reportHtml]);
  (0,external_react_.useEffect)(() => {
    if (chartError) {
      // We won't bother loading anything if the chart object has an error
      setLoadingState(LoadingState.LOADED);
    } else {
      loadReport();
    }
  }, [chartError, loadReport]);
  const isEmpty = loadingState === LoadingState.LOADED && chartError === undefined && fileAnchors === undefined && imageUrls === undefined;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "r-report chart-body"
  }, chartError !== undefined && /*#__PURE__*/external_react_default().createElement("span", {
    className: "text-danger"
  }, chartError), loadError !== undefined && /*#__PURE__*/external_react_default().createElement("span", {
    className: "text-danger"
  }, loadError), outputError !== undefined && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
    className: "text-danger"
  }, "An error occurred while executing the report:"), /*#__PURE__*/external_react_default().createElement("pre", null, outputError)), isLoading(loadingState) && /*#__PURE__*/external_react_default().createElement(ChartLoadingMask, {
    msg: "Loading Report..."
  }), isEmpty && /*#__PURE__*/external_react_default().createElement("div", {
    className: "r-report__errors text-danger"
  }, "No output detected. You may not have enough data, or there may be an issue with your R Report."), fileAnchors !== undefined && /*#__PURE__*/external_react_default().createElement("div", {
    className: "r-report__files"
  }, fileAnchors.map(({
    href,
    text
  }) => {
    return /*#__PURE__*/external_react_default().createElement("a", {
      className: "attachment-card",
      href: href,
      key: href,
      title: text
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "attachment-card__body"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "attachment-card__icon"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "attachment-card__icon_tile fa fa-file-text-o"
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "attachment-card__content"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "attachment-card__name"
    }, text))));
  })), imageUrls !== undefined && /*#__PURE__*/external_react_default().createElement("div", {
    className: "r-report__images"
  }, imageUrls.map(url => /*#__PURE__*/external_react_default().createElement("div", {
    key: url,
    className: "r-report__image"
  }, /*#__PURE__*/external_react_default().createElement("img", {
    alt: "R Report Image Output",
    src: url
  })))));
});
RReport.displayName = 'RReport';
const Chart = (0,external_react_.memo)(({
  api = DEFAULT_API_WRAPPER,
  chart,
  container,
  filters
}) => {
  if (chart.type === DataViewInfoTypes.RReport) {
    return /*#__PURE__*/external_react_default().createElement(RReport, {
      api: api,
      chart: chart,
      container: container,
      filters: filters
    });
  } else if (GENERIC_CHART_REPORTS.indexOf(chart.type) > -1) {
    return /*#__PURE__*/external_react_default().createElement(SVGChart, {
      api: api,
      chart: chart,
      container: container,
      filters: filters
    });
  }
  return null;
});
Chart.displayName = 'Chart';
;// CONCATENATED MODULE: ./src/internal/components/report-list/ReportList.tsx
function ReportList_defineProperty(e, r, t) { return (r = ReportList_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ReportList_toPropertyKey(t) { var i = ReportList_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ReportList_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









const ReportList_ICONS = {
  [DataViewInfoTypes.AutomaticPlot]: 'xy_line',
  [DataViewInfoTypes.BarChart]: 'bar_chart',
  [DataViewInfoTypes.BoxAndWhiskerPlot]: 'box_plot',
  [DataViewInfoTypes.Dataset]: 'custom_grid',
  [DataViewInfoTypes.PieChart]: 'pie_chart',
  [DataViewInfoTypes.Query]: 'custom_grid',
  [DataViewInfoTypes.TimeChart]: 'xy_line',
  [DataViewInfoTypes.XYScatterPlot]: 'xy_scatter',
  [DataViewInfoTypes.XYSeriesLinePlot]: 'xy_line'
};
class ReportLinks extends external_react_.PureComponent {
  render() {
    const {
      runUrl,
      appUrl
    } = this.props.report;
    let appLink;
    if (appUrl) {
      appLink = /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("a", {
        href: appUrl.toHref()
      }, "View in Biologics"));
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "report-item__links"
    }, /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("a", {
      href: runUrl
    }, "View in LabKey Server")), appLink);
  }
}
class ReportMetadata extends external_react_.PureComponent {
  render() {
    const {
      description,
      type,
      createdBy
    } = this.props.report;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "report-item__metadata"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "report-item__metadata-item"
    }, /*#__PURE__*/external_react_default().createElement("label", null, "Created By:"), /*#__PURE__*/external_react_default().createElement("span", null, createdBy)), /*#__PURE__*/external_react_default().createElement("div", {
      className: "report-item__metadata-item"
    }, /*#__PURE__*/external_react_default().createElement("label", null, "Type:"), /*#__PURE__*/external_react_default().createElement("span", null, type)), /*#__PURE__*/external_react_default().createElement("div", {
      className: "report-item__metadata-item"
    }, /*#__PURE__*/external_react_default().createElement("label", null, "Description:"), /*#__PURE__*/external_react_default().createElement("span", null, description)));
  }
}
class UnsupportedReportBody extends external_react_.PureComponent {
  render() {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "report-list__unsupported-preview"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "alert alert-warning unsupported-alert"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "unsupported-alert__icon"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-exclamation-circle"
    })), /*#__PURE__*/external_react_default().createElement("p", {
      className: "unsupported-alert__message"
    }, "This report is not currently supported. It is recommended that you view the report in LabKey Server."), /*#__PURE__*/external_react_default().createElement("div", {
      className: "unsupported-alert__view-link"
    }, /*#__PURE__*/external_react_default().createElement("a", {
      href: this.props.report.runUrl,
      className: "btn btn-warning"
    }, "View in LabKey Server"))), /*#__PURE__*/external_react_default().createElement(ReportMetadata, {
      report: this.props.report
    }));
  }
}
class GridReportBody extends external_react_.PureComponent {
  render() {
    const {
      schemaName,
      queryName,
      viewName
    } = this.props.report;
    const schemaQuery = new SchemaQuery(schemaName, queryName, viewName);
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "report-list__grid-preview"
    }, /*#__PURE__*/external_react_default().createElement(ReportLinks, {
      report: this.props.report
    }), /*#__PURE__*/external_react_default().createElement(PreviewGrid, {
      schemaQuery: schemaQuery,
      numCols: 4,
      numRows: 3
    }), /*#__PURE__*/external_react_default().createElement(ReportMetadata, {
      report: this.props.report
    }));
  }
}
class ChartReportBody extends external_react_.PureComponent {
  render() {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "report-list__chart-preview"
    }, /*#__PURE__*/external_react_default().createElement(ReportLinks, {
      report: this.props.report
    }), /*#__PURE__*/external_react_default().createElement(Chart, {
      chart: new DataViewInfo(this.props.report)
    }), /*#__PURE__*/external_react_default().createElement(ReportMetadata, {
      report: this.props.report
    }));
  }
}
class ReportItemModal extends external_react_.PureComponent {
  render() {
    const {
      name,
      type
    } = this.props.report;
    const onClose = this.props.onClose;
    let BodyRenderer = UnsupportedReportBody;
    if (GRID_REPORTS.contains(type)) {
      BodyRenderer = GridReportBody;
    } else if (VISUALIZATION_REPORTS.contains(type)) {
      BodyRenderer = ChartReportBody;
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "report-item-modal"
    }, /*#__PURE__*/external_react_default().createElement(Modal, {
      onCancel: onClose,
      title: name
    }, /*#__PURE__*/external_react_default().createElement(BodyRenderer, {
      report: this.props.report
    })));
  }
}
class ReportListItem extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    ReportList_defineProperty(this, "onClick", () => this.props.onClick(this.props.report));
    ReportList_defineProperty(this, "onLinkClicked", e => {
      // We need to stop event propagation when clicking on a link or it will also trigger the onClick handler
      e.stopPropagation();
      return true;
    });
  }
  render() {
    const {
      name,
      icon,
      iconCls,
      createdBy,
      type,
      runUrl,
      appUrl
    } = this.props.report;
    let nameEl = /*#__PURE__*/external_react_default().createElement("a", {
      href: runUrl,
      onClick: this.onLinkClicked
    }, name);
    if (appUrl) {
      nameEl = /*#__PURE__*/external_react_default().createElement("a", {
        href: appUrl.toHref(),
        onClick: this.onLinkClicked
      }, name);
    }
    const iconSrc = ReportList_ICONS[type];
    const iconClassName = 'report-list-item__icon';
    const hasCustomIcon = icon.indexOf('reports-thumbnail.view') > -1;
    let iconEl = /*#__PURE__*/external_react_default().createElement("img", {
      alt: icon,
      className: iconClassName,
      src: icon
    });
    if (iconSrc !== undefined && !hasCustomIcon) {
      iconEl = /*#__PURE__*/external_react_default().createElement(SVGIcon, {
        className: iconClassName,
        height: null,
        iconSrc: iconSrc
      });
    } else if (iconCls) {
      iconEl = /*#__PURE__*/external_react_default().createElement("span", {
        className: `${iconClassName} ${iconCls} fa-4x`
      });
    }
    let createdByEl;
    if (createdBy) {
      createdByEl = /*#__PURE__*/external_react_default().createElement("p", {
        className: "report-list-item__person"
      }, "Created by: ", createdBy);
    }
    return /*#__PURE__*/external_react_default().createElement("li", {
      className: "report-list-item media",
      onClick: this.onClick
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "media-left"
    }, iconEl), /*#__PURE__*/external_react_default().createElement("div", {
      className: "media-body"
    }, /*#__PURE__*/external_react_default().createElement("h4", {
      className: "report-list-item__name media-heading"
    }, nameEl), createdByEl));
  }
}
class ReportList extends external_react_.PureComponent {
  render() {
    const {
      loading,
      reports,
      onReportClicked
    } = this.props;
    let body;
    if (loading) {
      body = /*#__PURE__*/external_react_default().createElement("div", {
        className: "report-list__message"
      }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null));
    } else if (reports.length === 0) {
      body = /*#__PURE__*/external_react_default().createElement("div", {
        className: "report-list__message"
      }, "No reports.");
    } else {
      const reportEls = reports.map(report => {
        return /*#__PURE__*/external_react_default().createElement(ReportListItem, {
          key: report.runUrl,
          report: report,
          onClick: onReportClicked
        });
      });
      body = /*#__PURE__*/external_react_default().createElement("div", {
        className: "media-list report-list__list"
      }, reportEls);
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel panel-default"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-body report-list"
    }, body));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/types.ts
function types_defineProperty(e, r, t) { return (r = types_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function types_toPropertyKey(t) { var i = types_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function types_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2020 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */

let LINEAGE_DIRECTIONS = /*#__PURE__*/function (LINEAGE_DIRECTIONS) {
  LINEAGE_DIRECTIONS["Children"] = "children";
  LINEAGE_DIRECTIONS["Parent"] = "parents";
  return LINEAGE_DIRECTIONS;
}({});
let LINEAGE_GROUPING_GENERATIONS = /*#__PURE__*/function (LINEAGE_GROUPING_GENERATIONS) {
  LINEAGE_GROUPING_GENERATIONS["All"] = "all";
  LINEAGE_GROUPING_GENERATIONS["Multi"] = "multi";
  LINEAGE_GROUPING_GENERATIONS["Nearest"] = "nearest";
  LINEAGE_GROUPING_GENERATIONS["Specific"] = "specific";
  return LINEAGE_GROUPING_GENERATIONS;
}({});

/**
 * After the raw lineage result has been filtered, LineageGroupingOptions determines
 * how many generations of nodes to include in the VisGraph and the threshold at which
 * to combine multiple nodes together.
 */

class LineageFilter {
  constructor(field, value) {
    types_defineProperty(this, "field", void 0);
    types_defineProperty(this, "value", void 0);
    this.field = field;
    this.value = value;
  }
}
let LineageURLResolvers = /*#__PURE__*/function (LineageURLResolvers) {
  LineageURLResolvers["App"] = "App";
  LineageURLResolvers["Server"] = "Server";
  return LineageURLResolvers;
}({});
;// CONCATENATED MODULE: ./src/internal/components/lineage/LineageURLResolvers.ts
function LineageURLResolvers_defineProperty(e, r, t) { return (r = LineageURLResolvers_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LineageURLResolvers_toPropertyKey(t) { var i = LineageURLResolvers_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LineageURLResolvers_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class AppLineageURLResolver {
  constructor() {
    LineageURLResolvers_defineProperty(this, "resolveItem", item => {
      return AppLineageURLResolver.resolver.resolveLineageItem(item);
    });
    LineageURLResolvers_defineProperty(this, "resolveGroupedNodes", nodes => {
      let listURL;
      if (nodes && nodes.length) {
        // all nodes are expected to share the same type/configuration
        const {
          links
        } = nodes[0];
        if (links.list) {
          const filter = createQueryFilterFromNodes(nodes);
          if (filter) {
            // TODO: This is not how we should compose app URLs.
            // This should use something like AppURL.fromString() (DNE). Imagine...
            // listURL = AppURL.fromString(links.list).addFilters([filter]).toHref();
            listURL = `${links.list}?${filter.getURLParameterName()}=${filter.getURLParameterValue()}`;
          }
        }
      }
      return listURL;
    });
  }
}
LineageURLResolvers_defineProperty(AppLineageURLResolver, "resolver", new URLResolver());
class ServerLineageURLResolver {
  constructor() {
    LineageURLResolvers_defineProperty(this, "resolveItem", item => {
      return {
        // does not currently have a corollary view in LKS
        lineage: undefined,
        list: undefined,
        overview: item.url
      };
    });
    LineageURLResolvers_defineProperty(this, "resolveGroupedNodes", nodes => {
      let listURL;
      if (nodes && nodes.length) {
        // all nodes are expected to share the same type/configuration
        const {
          queryName,
          schemaName
        } = nodes[0];
        const filter = createQueryFilterFromNodes(nodes);
        if (filter) {
          listURL = api_.ActionURL.buildURL('query', 'executeQuery.view', undefined, {
            schemaName,
            'query.queryName': queryName,
            [filter.getURLParameterName()]: filter.getURLParameterValue()
          });
        }
      }
      return listURL;
    });
  }
}
const appResolver = new AppLineageURLResolver();
const serverResolver = new ServerLineageURLResolver();
function getURLResolver(options) {
  if (options && options.urlResolver === LineageURLResolvers.Server) {
    return serverResolver;
  }
  return appResolver;
}
function createQueryFilterFromNodes(nodes) {
  if (nodes && nodes.length) {
    const {
      queryName,
      schemaName
    } = nodes[0];

    // ensure query configuration is consistent in the set
    if (nodes.every(n => n.schemaName === schemaName && n.queryName === queryName && n.pkFilters.length === 1)) {
      const {
        pkFilters
      } = nodes[0];
      if (pkFilters && pkFilters.length === 1) {
        const {
          fieldKey
        } = pkFilters[0];
        let filterType;
        let value;
        if (nodes.length === 1) {
          filterType = api_.Filter.Types.EQ;
          value = pkFilters[0].value;
        } else {
          filterType = api_.Filter.Types.IN;
          value = nodes.map(n => n.pkFilters[0].value);
        }
        return api_.Filter.create(fieldKey, value, filterType);
      }
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/utils.ts
/*
 * Copyright (c) 2017-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */





const DEFAULT_ICON_URL = 'default';
const BACKUP_IMAGE_ROOT = 'https://labkey.org/_images/';

// The default vis-network icon shape to use for nodes in the lineage graph
const DEFAULT_ICON_SHAPE = 'circularImage';

// A constant set of icons that are better displayed as a normal image (since default is "circularImage")
const NON_CIRCULAR_IMAGES = ['datafile', 'file', 'expressionsystem', 'mixtures', 'rawmaterials', 'run'];
function getQueryFromSchema(schemasObject, queryName) {
  return Object.keys(schemasObject).map(k => schemasObject[k]).filter(value => !api_.Utils.isString(value)).find(schemaQuery => schemaQuery.queryName.toLowerCase() === queryName.toLowerCase());
}
function imageFromIdentifier(iconURL, isSeed, isSelected) {
  return imageURL('_images', getImageNameWithTheme(iconURL, isSeed, isSelected));
}
function getImageNameWithTheme(iconURL, isSeed, isSelected) {
  // use seed and selected status to determine color of image used
  let theme = Theme.GRAY;
  if (isSelected === true) {
    theme = Theme.ORANGE;
  } else if (isSeed === true) {
    theme = Theme.DEFAULT;
  }
  const suffix = theme === Theme.DEFAULT ? '' : '_' + Theme[theme];
  return [iconURL, suffix, '.svg'].join('').toLowerCase();
}
function getLineageDepthFirstNodeList(nodes, lsid, direction, maxDistance) {
  const nodeList = (0,external_immutable_.List)().asMutable();
  nodeList.push(nodes.get(lsid).set('distance', 0));
  const nextNodes = nodes.getIn([lsid, direction]);
  if (nextNodes) {
    nextNodes.forEach(next => {
      nodeList.push(..._getDepthFirstNodeList(nodes, next.lsid, direction, maxDistance, 1).toArray());
    });
  }
  return nodeList.asImmutable();
}
function _getDepthFirstNodeList(nodes, lsid, direction, maxDistance, distance) {
  const nodeList = (0,external_immutable_.List)().asMutable();
  const nextNodes = nodes.getIn([lsid, direction]);
  if (distance <= maxDistance) {
    nodeList.push(nodes.get(lsid).set('distance', distance));
    if (nextNodes !== undefined) {
      nextNodes.forEach(nextNode => {
        nodeList.push(..._getDepthFirstNodeList(nodes, nextNode.get('lsid'), direction, maxDistance, distance + 1).toArray());
      });
    }
  }
  return nodeList.asImmutable();
}

// TODO: The iconURL should be resolved by the server.
function resolveIconAndShapeForNode(item, queryInfoIconURL, isSeed) {
  let iconURL = DEFAULT_ICON_URL;
  let imageShape = DEFAULT_ICON_SHAPE;
  if (queryInfoIconURL && queryInfoIconURL !== DEFAULT_ICON_URL) {
    iconURL = queryInfoIconURL.toLowerCase();
  } else if (item) {
    const schemaName = item.schemaName?.toLowerCase() ?? '';
    const queryName = item.queryName?.toLowerCase() ?? '';
    if (schemaName === SCHEMAS.SAMPLE_SETS.SCHEMA.toLowerCase()) {
      // Samples
      const schemaQuery = getQueryFromSchema(SCHEMAS.SAMPLE_SETS, queryName);
      iconURL = schemaQuery ? queryName : 'samples';

      // eesh...
      if (queryName === 'mixturebatches') {
        iconURL = 'batch';
      }
    } else if (schemaName === SCHEMAS.DATA_CLASSES.SCHEMA.toLowerCase()) {
      // Data Classes
      const schemaQuery = getQueryFromSchema(SCHEMAS.DATA_CLASSES, queryName);
      if (schemaQuery) {
        iconURL = queryName;
      }
    } else if (schemaName === 'exp.materials') {
      // Materials
      iconURL = 'samples';
    } else if (item.expType === 'ExperimentRun') {
      iconURL = 'run';
    } else if (item.expType === 'Data') {
      iconURL = 'datafile';
    }
  }
  if (NON_CIRCULAR_IMAGES.indexOf(iconURL) > -1) {
    imageShape = 'image';
  }
  return {
    iconURL,
    image: imageFromIdentifier(iconURL, isSeed, false),
    imageBackup: `${BACKUP_IMAGE_ROOT}${getImageNameWithTheme(iconURL, isSeed, false)}`,
    imageSelected: imageFromIdentifier(iconURL, isSeed, true),
    imageShape
  };
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/Tag.tsx
/*
 * Copyright (c) 2016-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */

const Tag = props => /*#__PURE__*/external_react_default().createElement("span", {
  className: 'pull-right ' + (props.showOnHover === false ? 'hide-on-hover' : 'show-on-hover')
}, /*#__PURE__*/external_react_default().createElement("span", {
  className: 'label ' + (props.bsStyle ? `label-${props.bsStyle}` : '')
}, props.children));
;// CONCATENATED MODULE: ./src/internal/components/lineage/constants.tsx
/*
 * Copyright (c) 2016-2020 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */







// Default depth to fetch with the lineage API
const DEFAULT_LINEAGE_DISTANCE = 5;
const DEFAULT_LINEAGE_DIRECTION = LINEAGE_DIRECTIONS.Children;
const GROUPING_COMBINED_SIZE_MIN = 2;
const DEFAULT_GROUPING_OPTIONS = {
  childDepth: DEFAULT_LINEAGE_DISTANCE,
  combineSize: 6,
  generations: LINEAGE_GROUPING_GENERATIONS.All,
  parentDepth: DEFAULT_LINEAGE_DISTANCE + 1
};
const DEFAULT_LINEAGE_OPTIONS = {
  filterIn: true,
  filters: [],
  grouping: DEFAULT_GROUPING_OPTIONS,
  urlResolver: LineageURLResolvers.App
};
const LINEAGE_GRID_COLUMNS = (0,external_immutable_.List)([new GridColumn({
  index: 'name',
  title: 'ID',
  width: 270,
  cell: (name, node) => {
    const indent = node.get('distance') * 10;
    const dupeCount = node.get('duplicateCount');
    const isParents = node.get('membersShown') === LINEAGE_DIRECTIONS.Parent;
    const nodeDistance = node.get('distance');
    const links = node.get('links');
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "lineage-name",
      style: {
        textIndent: indent + 'px'
      },
      title: dupeCount > 0 ? dupeCount + ' duplicates' : ''
    }, links.overview ? /*#__PURE__*/external_react_default().createElement("a", {
      href: links.overview
    }, name) : name, nodeDistance === 0 && /*#__PURE__*/external_react_default().createElement(Tag, {
      bsStyle: "success"
    }, "Seed"), nodeDistance === 1 && /*#__PURE__*/external_react_default().createElement(Tag, {
      bsStyle: "info"
    }, "1st ", isParents ? 'parent' : 'child'), nodeDistance === 2 && /*#__PURE__*/external_react_default().createElement(Tag, {
      bsStyle: "primary"
    }, "2nd ", isParents ? 'parent' : 'child'), dupeCount > 0 && /*#__PURE__*/external_react_default().createElement(Tag, {
      bsStyle: "warning",
      showOnHover: false
    }, "Duplicate"));
  }
}), new GridColumn({
  index: 'distance',
  title: 'Distance',
  width: 60,
  cell: (distance, node) => {
    const gen = distance > 1 ? ' generations' : ' generation';
    return distance === 0 ? distance : node.get('membersShown') === LINEAGE_DIRECTIONS.Parent ? /*#__PURE__*/external_react_default().createElement("span", {
      title: distance + gen + ' above seed'
    }, distance) : /*#__PURE__*/external_react_default().createElement("span", {
      title: distance + gen + ' below seed'
    }, distance);
  }
}), new GridColumn({
  index: 'lsid',
  title: 'Change Seed',
  width: 70,
  cell: (lsid, node) => {
    const lineageDistance = node.get('lineageDistance');
    const baseURL = AppURL.create('lineage').addParams({
      seeds: lsid,
      distance: lineageDistance ? lineageDistance : DEFAULT_LINEAGE_DISTANCE
    });
    const parentUrl = baseURL.addParam('members', LINEAGE_DIRECTIONS.Parent);
    const childrenUrl = baseURL.addParam('members', LINEAGE_DIRECTIONS.Children);
    const children = node.get('children');
    const parents = node.get('parents');
    const membersShown = node.get('membersShown');
    const nodeDistance = node.get('distance');
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "text-nowrap"
    }, parents.size > 0 ? membersShown === LINEAGE_DIRECTIONS.Parent && nodeDistance === 0 ? /*#__PURE__*/external_react_default().createElement("button", {
      className: "lineage-btn-seed btn btn-primary btn-xs",
      disabled: true,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-arrow-up"
    })) : /*#__PURE__*/external_react_default().createElement("a", {
      className: "lineage-btn-seed btn btn-primary btn-xs",
      href: parentUrl.toHref(),
      title: 'Parents for ' + node.get('name')
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-arrow-up"
    })) : /*#__PURE__*/external_react_default().createElement("button", {
      className: "lineage-btn-seed btn btn-primary btn-xs",
      disabled: true,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-arrow-up"
    })), /*#__PURE__*/external_react_default().createElement("span", {
      style: {
        paddingRight: '5px'
      }
    }, "\xA0"), children.size > 0 ? membersShown === LINEAGE_DIRECTIONS.Children && nodeDistance === 0 ? /*#__PURE__*/external_react_default().createElement("button", {
      className: "lineage-btn-seed btn btn-primary btn-xs",
      disabled: true,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-arrow-down"
    })) : /*#__PURE__*/external_react_default().createElement("a", {
      className: "lineage-btn-seed btn btn-primary btn-xs",
      href: childrenUrl.toHref(),
      title: 'Children for ' + node.get('name')
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-arrow-down"
    })) : /*#__PURE__*/external_react_default().createElement("button", {
      className: "lineage-btn-seed btn btn-primary btn-xs",
      disabled: true,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-arrow-down"
    })));
  }
}), new GridColumn({
  index: 'displayType',
  title: 'Type'
}), new GridColumn({
  index: 'date',
  title: 'Creation Date'
}), new GridColumn({
  index: 'description',
  title: 'Description'
}), new GridColumn({
  index: 'label',
  title: 'Alias'
})]);
// EXTERNAL MODULE: external "vis-network"
var external_vis_network_ = __webpack_require__(413);
;// CONCATENATED MODULE: ./src/internal/components/lineage/models.ts
function lineage_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function lineage_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? lineage_models_ownKeys(Object(t), !0).forEach(function (r) { lineage_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : lineage_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function lineage_models_defineProperty(e, r, t) { return (r = lineage_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function lineage_models_toPropertyKey(t) { var i = lineage_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function lineage_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2016-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */








function getLineageNodeTitle(node, asHTML = false) {
  // encodeHtml if we are generating html for vis.js to use as the node's tooltip title
  const h = s => asHTML ? api_.Utils.encodeHtml(s) : s;
  let title = '';
  if (node instanceof LineageNode) {
    const {
      meta
    } = node;
    if (meta && meta.displayType) {
      title += h(meta.displayType) + ': ';
    }
    title += node.name;
    if (meta && meta.aliases && meta.aliases.size) {
      title += ' (' + meta.aliases.map(h).join(', ') + ')';
    }
    if (meta && meta.description) {
      title += (asHTML ? '<br>' : '\n') + h(meta.description);
    }
  } else {
    title = node.name;
  }
  return title;
}
function applyLineageOptions(options) {
  const _options = lineage_models_objectSpread(lineage_models_objectSpread(lineage_models_objectSpread({}, DEFAULT_LINEAGE_OPTIONS), options), {
    grouping: lineage_models_objectSpread(lineage_models_objectSpread({}, DEFAULT_GROUPING_OPTIONS), options?.grouping)
  });

  // deep copy "filters"
  _options.filters = _options.filters.map(filter => new LineageFilter(filter.field, filter.value));
  return _options;
}
class LineageNodeMetadata extends (0,external_immutable_.Record)({
  date: undefined,
  description: undefined,
  aliases: undefined,
  displayType: undefined
}) {
  static create(selectRowsMetadata, queryInfo) {
    let description;
    if (selectRowsMetadata.hasIn(['Description', 'value'])) description = selectRowsMetadata.getIn(['Description', 'value']);
    let created;
    if (selectRowsMetadata.hasIn(['Created', 'formattedValue'])) created = selectRowsMetadata.getIn(['Created', 'formattedValue']);else if (selectRowsMetadata.hasIn(['Created', 'value'])) created = selectRowsMetadata.getIn(['Created', 'value']);
    let aliases;
    if (selectRowsMetadata.has('Alias')) {
      aliases = selectRowsMetadata.get('Alias').map(alias => alias.get('displayValue'));
    }
    return new LineageNodeMetadata({
      displayType: queryInfo.queryLabel,
      description,
      date: created,
      aliases
    });
  }
}
class LineageLink extends (0,external_immutable_.Record)({
  lsid: undefined
}) {
  static createList(values) {
    const result = values ? values.map(v => new LineageLink(v)) : [];
    return (0,external_immutable_.List)(result);
  }
}
class LineageRunStep {
  constructor(values) {
    lineage_models_defineProperty(this, external_immer_.immerable, true);
    lineage_models_defineProperty(this, "applicationType", void 0);
    lineage_models_defineProperty(this, "activityDate", void 0);
    lineage_models_defineProperty(this, "activitySequence", void 0);
    lineage_models_defineProperty(this, "container", void 0);
    lineage_models_defineProperty(this, "created", void 0);
    lineage_models_defineProperty(this, "createdBy", void 0);
    lineage_models_defineProperty(this, "dataInputs", void 0);
    lineage_models_defineProperty(this, "dataOutputs", void 0);
    lineage_models_defineProperty(this, "expType", void 0);
    lineage_models_defineProperty(this, "iconProps", void 0);
    lineage_models_defineProperty(this, "id", void 0);
    lineage_models_defineProperty(this, "links", void 0);
    lineage_models_defineProperty(this, "lsid", void 0);
    lineage_models_defineProperty(this, "materialInputs", void 0);
    lineage_models_defineProperty(this, "materialOutputs", void 0);
    lineage_models_defineProperty(this, "modified", void 0);
    lineage_models_defineProperty(this, "modifiedBy", void 0);
    lineage_models_defineProperty(this, "name", void 0);
    lineage_models_defineProperty(this, "objectInputs", void 0);
    lineage_models_defineProperty(this, "objectOutputs", void 0);
    lineage_models_defineProperty(this, "pkFilters", void 0);
    lineage_models_defineProperty(this, "protocol", void 0);
    lineage_models_defineProperty(this, "queryName", void 0);
    lineage_models_defineProperty(this, "schemaName", void 0);
    Object.assign(this, values, lineage_models_objectSpread({}, LineageIO.applyConfig(values)));
  }
}
class LineageIO {
  constructor(values) {
    lineage_models_defineProperty(this, external_immer_.immerable, true);
    lineage_models_defineProperty(this, "container", void 0);
    lineage_models_defineProperty(this, "created", void 0);
    lineage_models_defineProperty(this, "createdBy", void 0);
    lineage_models_defineProperty(this, "expType", void 0);
    lineage_models_defineProperty(this, "iconProps", void 0);
    lineage_models_defineProperty(this, "id", void 0);
    lineage_models_defineProperty(this, "lsid", void 0);
    lineage_models_defineProperty(this, "links", void 0);
    lineage_models_defineProperty(this, "modified", void 0);
    lineage_models_defineProperty(this, "modifiedBy", void 0);
    lineage_models_defineProperty(this, "name", void 0);
    lineage_models_defineProperty(this, "pkFilters", void 0);
    lineage_models_defineProperty(this, "queryName", void 0);
    lineage_models_defineProperty(this, "schemaName", void 0);
    Object.assign(this, values);
  }
  static applyConfig(values) {
    return {
      dataInputs: LineageIO.fromArray(values?.dataInputs),
      dataOutputs: LineageIO.fromArray(values?.dataOutputs),
      materialInputs: LineageIO.fromArray(values?.materialInputs),
      materialOutputs: LineageIO.fromArray(values?.materialOutputs),
      // convert the provenanceMap to the inputs and outputs array, filter for just those that have a from/to lsid value
      objectInputs: LineageIO.fromArray(values?.provenanceMap?.map(prov => prov.from).filter(input => input?.lsid)),
      objectOutputs: LineageIO.fromArray(values?.provenanceMap?.map(prov => prov.to).filter(input => input?.lsid))
    };
  }
  static fromArray(values) {
    if (api_.Utils.isArray(values)) {
      return values.map(io => new LineageIO(io));
    }
    return [];
  }
}
class LineageNode extends (0,external_immutable_.Record)({
  absolutePath: undefined,
  children: undefined,
  container: undefined,
  containerPath: undefined,
  cpasType: undefined,
  created: undefined,
  createdBy: undefined,
  dataFileURL: undefined,
  dataInputs: undefined,
  dataOutputs: undefined,
  expType: undefined,
  id: undefined,
  lsid: undefined,
  materialInputs: undefined,
  materialOutputs: undefined,
  modified: undefined,
  modifiedBy: undefined,
  name: undefined,
  objectInputs: undefined,
  objectOutputs: undefined,
  parents: undefined,
  pipelinePath: undefined,
  pkFilters: undefined,
  properties: undefined,
  queryName: undefined,
  schemaName: undefined,
  steps: undefined,
  type: undefined,
  materialLineageType: undefined,
  url: undefined,
  // computed properties
  distance: undefined,
  iconProps: {},
  links: {},
  listURL: undefined,
  meta: undefined
}) {
  constructor(...args) {
    super(...args);
    // computed properties
    lineage_models_defineProperty(this, "distance", void 0);
    lineage_models_defineProperty(this, "iconProps", void 0);
    lineage_models_defineProperty(this, "links", void 0);
    lineage_models_defineProperty(this, "listURL", void 0);
    lineage_models_defineProperty(this, "meta", void 0);
  }
  static create(lsid, values) {
    let config;
    if (values && values instanceof LineageNode) {
      config = values;
    } else {
      config = lineage_models_objectSpread(lineage_models_objectSpread(lineage_models_objectSpread({}, values), LineageIO.applyConfig(values)), {
        children: LineageLink.createList(values.children),
        lsid,
        parents: LineageLink.createList(values.parents),
        steps: (0,external_immutable_.List)(values.steps?.map(stepProps => new LineageRunStep(stepProps)))
      });
    }
    return new LineageNode(config);
  }
  get isRun() {
    return this.expType === 'ExperimentRun';
  }
}
class LineageResult extends (0,external_immutable_.Record)({
  mergedIn: undefined,
  nodes: undefined,
  seed: undefined
}) {
  static create(rawLineageResult) {
    const seed = rawLineageResult.seed;
    const nodes = {};
    for (const key in rawLineageResult.nodes) {
      if (!rawLineageResult.nodes.hasOwnProperty(key)) continue;
      const rawNode = rawLineageResult.nodes[key];
      nodes[key] = LineageNode.create(key, rawNode);
    }

    // make sure that mergedIn list of all nodes that have their lineage in the model includes the original seed node
    const mergedIn = seed ? (0,external_immutable_.List)([seed]) : (0,external_immutable_.List)();
    return new LineageResult({
      seed,
      nodes: (0,external_immutable_.Map)(nodes),
      mergedIn
    });
  }
  filterIn(field, value) {
    return LineageResult._filter(this, field, value, true);
  }
  filterOut(field, value) {
    return LineageResult._filter(this, field, value, false);
  }

  /**
   * When 'filterIn' is true, keep nodes that match the filter field and value.  All other nodes are removed.
   *
   * When 'filterIn' is false, keep nodes that don't match the filter field and value.  All other nodes are removed.
   *
   * Edges to removed nodes will be copied to the source.
   */
  static _filter(result, field, value, filterIn) {
    if (field === undefined) throw new Error('field must not be undefined');
    const oldNodes = result.nodes;

    // filter out nodes that don't match the criteria
    const newNodes = oldNodes.reduce((m, node) => {
      const lsid = node.lsid;
      const matched = this._matches(node, field, value, filterIn);
      if (matched) {
        // walk the parents/children edges, adding any matching nodes
        return m.set(lsid, node.merge({
          parents: LineageResult.prune(node, oldNodes, LINEAGE_DIRECTIONS.Parent, field, value, filterIn),
          children: LineageResult.prune(node, oldNodes, LINEAGE_DIRECTIONS.Children, field, value, filterIn)
        }));
      } else {
        // don't include the current node
        return m;
      }
    }, (0,external_immutable_.Map)().asMutable());
    return result.set('nodes', newNodes);
  }

  /**
   * When 'filterIn' is true, returns true if the node[field] is equal to the value or any of the array item values.
   * When value is undefined, it is treated as a wildcard -- any value is allowed as long as the
   *
   * When 'filterIn' is false, returns true if the node[field] is not equal to the value or any of the array item values.
   * When value is undefined, the node must not have contain a value for the field.
   */
  static _matches(node, field, value, filterIn) {
    if (filterIn) {
      if (value === undefined) {
        // true if the field exists on node
        return node.has(field);
      } else if (Array.isArray(value)) {
        return value.indexOf(node[field]) > -1;
      } else {
        return node[field] === value;
      }
    } else {
      if (value === undefined) {
        // true if the field does not exist on node
        return !node.has(field);
      } else if (Array.isArray(value)) {
        return value.indexOf(node[field]) === -1;
      } else {
        return node[field] !== value;
      }
    }
  }
  static prune(node, nodes, dir, field, value, filterIn) {
    let newTree = [];
    const edges = node.get(dir);
    const walked = {};
    edges.forEach(edge => {
      newTree = newTree.concat(LineageResult.pruneEdge(edge, nodes, dir, field, value, filterIn, walked));
    });
    return (0,external_immutable_.List)(newTree);
  }
  static pruneEdge(edge, nodes, dir, field, value, filterIn, walked) {
    let heritage = [];
    const lsid = edge.lsid;
    const toNode = nodes.get(lsid);
    const edges = toNode.get(dir);
    const matched = this._matches(toNode, field, value, filterIn);
    if (!matched) {
      // don't walk the same edge set more than once
      if (walked[lsid]) {
        return heritage;
      }
      walked[lsid] = lsid;
      edges.forEach(edge => {
        const result = LineageResult.pruneEdge(edge, nodes, dir, field, value, filterIn, walked);
        if (result && result.length > 0) {
          heritage = heritage.concat(result);
        }
      });
    } else {
      heritage.push(edge);
    }
    return heritage;
  }
}
class Lineage {
  constructor(values) {
    lineage_models_defineProperty(this, external_immer_.immerable, true);
    lineage_models_defineProperty(this, "error", void 0);
    lineage_models_defineProperty(this, "result", void 0);
    lineage_models_defineProperty(this, "resultLoadingState", LoadingState.INITIALIZED);
    lineage_models_defineProperty(this, "sampleStats", void 0);
    lineage_models_defineProperty(this, "seed", void 0);
    lineage_models_defineProperty(this, "seedResult", void 0);
    lineage_models_defineProperty(this, "seedResultError", void 0);
    lineage_models_defineProperty(this, "seedResultLoadingState", LoadingState.INITIALIZED);
    Object.assign(this, values);
  }

  // Defensive check against calls made when an error is present and provides a more useful error message.
  checkError() {
    if (this.error) {
      throw new Error('Invalid call on Lineage object. Check errors prior to attempting to interact with Lineage object.');
    }
  }
  filterResult(options) {
    this.checkError();
    const {
      seed
    } = this.result;
    const _options = applyLineageOptions(options);
    let nodes;
    if (_options.filters) {
      let result = this.result;
      _options.filters.forEach(filter => {
        if (_options.filterIn === true) {
          result = result.filterIn(filter.field, filter.value);
        } else {
          result = result.filterOut(filter.field, filter.value);
        }
      });
      nodes = result.nodes;
    } else {
      nodes = this.result.nodes;
    }
    const mergedIn = this.result.mergedIn;
    return new LineageResult({
      seed,
      nodes,
      mergedIn
    });
  }

  /**
   * Generate a graph of the lineage for use with vis.js.
   *
   * @remarks
   * First, the LabKey lineage is filtered according to the {@link LineageOptions.filters}
   * then the graph is translated into vis.js nodes and edges.  During translation, nodes
   * will be combined together according to {@link LineageGroupingOptions.combineSize} and recursion
   * will be stopped when {@link LineageGroupingOptions.generations} condition is met.
   */
  generateGraph(options) {
    this.checkError();
    if (this.isLoaded()) {
      return generate(this.filterResult(options), options);
    }
    return undefined;
  }
  isLoaded() {
    return this.resultLoadingState === LoadingState.LOADED;
  }
  isSeedLoaded() {
    return !this.seedResultError && this.seedResultLoadingState === LoadingState.LOADED;
  }

  /**
   * Returns a deep copy of this model with props applied iff props is not empty/null/undefined else
   * returns this.
   * @param props
   */
  mutate(props) {
    return (0,external_immer_.produce)(this, draft => {
      Object.assign(draft, props);
    });
  }
}
class LineageGridModel {
  constructor(config) {
    lineage_models_defineProperty(this, external_immer_.immerable, true);
    lineage_models_defineProperty(this, "columns", LINEAGE_GRID_COLUMNS);
    lineage_models_defineProperty(this, "data", (0,external_immutable_.List)());
    lineage_models_defineProperty(this, "distance", DEFAULT_LINEAGE_DISTANCE);
    lineage_models_defineProperty(this, "isError", false);
    lineage_models_defineProperty(this, "isLoaded", false);
    lineage_models_defineProperty(this, "isLoading", false);
    lineage_models_defineProperty(this, "maxRows", 20);
    lineage_models_defineProperty(this, "members", DEFAULT_LINEAGE_DIRECTION);
    lineage_models_defineProperty(this, "message", void 0);
    lineage_models_defineProperty(this, "nodeCounts", (0,external_immutable_.Map)());
    lineage_models_defineProperty(this, "pageNumber", 1);
    lineage_models_defineProperty(this, "seedNode", void 0);
    lineage_models_defineProperty(this, "totalRows", 0);
    Object.assign(this, lineage_models_objectSpread({}, config));
  }
  get offset() {
    return this.pageNumber > 1 ? (this.pageNumber - 1) * this.maxRows : 0;
  }
  get maxRowIndex() {
    const max = this.pageNumber > 1 ? this.pageNumber * this.maxRows : this.maxRows;
    if (max > this.totalRows) {
      return this.totalRows;
    }
    return max;
  }
  get minRowIndex() {
    return this.offset + 1;
  }
}

// extend Node to include the LabKey lineage node and the cluster id

// vis.js doesn't expose cluster nodes directly, so this is our shim

function isBasicNode(item) {
  return item && item.kind === 'node';
}
function isCombinedNode(item) {
  return item && item.kind === 'combined';
}
function isClusterNode(item) {
  return item && item.kind === 'cluster';
}
class VisGraphOptions {
  constructor(config) {
    lineage_models_defineProperty(this, external_immer_.immerable, true);
    lineage_models_defineProperty(this, "edges", void 0);
    lineage_models_defineProperty(this, "initialSelection", void 0);
    lineage_models_defineProperty(this, "nodes", void 0);
    lineage_models_defineProperty(this, "options", void 0);
    Object.assign(this, config);
  }
  getCombinedNodes() {
    return this.nodes.get({
      filter: isCombinedNode
    });
  }
}
const EDGE_ID_SEPARATOR = '||';
function makeEdgeId(fromId, toId) {
  return fromId + EDGE_ID_SEPARATOR + toId;
}
/**
 * Create an edge between fromId -> toId when dir === Child.
 * Create an edge between fromId <- toId when dir === Parent.
 */
function addEdge(visEdges, dir, fromId, toId) {
  const edgeId = dir === LINEAGE_DIRECTIONS.Children ? makeEdgeId(fromId, toId) : makeEdgeId(toId, fromId);
  if (visEdges[edgeId] === undefined) {
    visEdges[edgeId] = {
      id: edgeId,
      from: dir === LINEAGE_DIRECTIONS.Children ? fromId : toId,
      to: dir === LINEAGE_DIRECTIONS.Children ? toId : fromId
    };
  }
}
function addEdges(lsid, targetId, visEdges, edges, nodesInCombinedNode, dir) {
  // if current node is in a combined node, use the combined node's id as the edge source
  let nodeIds = nodesInCombinedNode[lsid];
  if (nodeIds === undefined) {
    nodeIds = [lsid];
  }
  for (let i = 0; i < nodeIds.length; i++) {
    const nodeId = nodeIds[i];

    // create an edge from the current lsid (or a combined node it lives in) to the edge's target
    edges.forEach(e => {
      // Create an edge to the supplied target node or the edge target
      // or to any combined node the target belongs to.
      let edgesToMake = targetId ? [targetId] : [e.lsid];
      const existingCombinedNodes = nodesInCombinedNode[e.lsid];
      if (existingCombinedNodes !== undefined) {
        edgesToMake = existingCombinedNodes;
      }
      edgesToMake.forEach(targetId_ => {
        addEdge(visEdges, dir, nodeId, targetId_);
      });
    });
  }
}
function createVisNode(node, id, isSeed, dir, depth) {
  // show the alternate icon image color if this node is the seed or has been selected
  const {
    image,
    imageBackup,
    imageSelected,
    imageShape
  } = node.iconProps;
  return {
    kind: 'node',
    id,
    lineageNode: node,
    label: node.name,
    level: level(depth, dir, false),
    title: getLineageNodeTitle(node, true),
    image: {
      unselected: image,
      selected: imageSelected
    },
    brokenImage: imageBackup,
    shape: imageShape,
    shadow: isSeed === true,
    font: isSeed ? {
      multi: 'html',
      color: '#116596',
      // this is the color of the fill from the _v1.svg images used as seed node images
      align: 'left',
      background: 'white',
      // for the seed node the multi line label uses <b> on the second line, this seed node font object
      // override of font.bold cause the label to render the second line text bigger than first line text
      // Note: this override for <b> font only work if the options nodes object does not set the 'value'
      // property or attempt to override default scaling behaviour.
      bold: {
        size: 18
      }
    } : {
      align: 'left',
      background: 'white'
    }
  };
}

// https://stackoverflow.com/a/13403498/351483
// generate a random id like "ahl3dhtcxchvqbwyga2nhg"
function randId() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}
// group the array of nodes into collections by type
function createLineageNodeCollections(nodes, options) {
  const nodesByType = {};
  nodes.filter(n => n.meta).forEach(n => {
    const {
      displayType
    } = n.meta;
    const {
      materialLineageType
    } = n;
    const displayTypeGroup = displayType + (materialLineageType ? '-' + materialLineageType : '');
    let byTypeList = nodesByType[displayTypeGroup];
    if (!byTypeList) {
      byTypeList = {
        displayType,
        queryName: n.queryName,
        cpasType: n.cpasType,
        listURL: undefined,
        materialLineageType,
        nodes: []
      };
      nodesByType[displayTypeGroup] = byTypeList;
    }
    byTypeList.nodes.push(n);
  });
  for (const groupName of Object.keys(nodesByType)) {
    const group = nodesByType[groupName];
    group.listURL = getURLResolver(options).resolveGroupedNodes(group.nodes);
  }
  return nodesByType;
}
function createCombinedLineageNode(combinedVisNode) {
  const {
    children,
    parents
  } = combinedVisNode.containedNodes.reduce((acc, node) => {
    acc.children = acc.children.concat(node.children);
    acc.parents = acc.parents.concat(node.parents);
    return acc;
  }, {
    children: (0,external_immutable_.List)(),
    parents: (0,external_immutable_.List)()
  });
  return new LineageNode({
    children,
    lsid: combinedVisNode.id,
    name: combinedVisNode.label,
    parents
  });
}
function createCombinedVisNode(containedNodes, options, parentNodeName, dir, depth) {
  const {
    combineSize
  } = options.grouping;
  let typeLabel;
  let commonNode;
  const containedNodesByType = createLineageNodeCollections(containedNodes, options);
  const types = Object.keys(containedNodesByType).sort();
  if (types.length === 1) {
    const nodeCollection = containedNodesByType[types[0]];
    commonNode = nodeCollection.nodes[0];
    if (isAliquotNode(nodeCollection)) {
      typeLabel = 'aliquots';
    } else {
      typeLabel = nodeCollection.displayType;
    }
  } else {
    typeLabel = 'of different types';
  }

  // construct title using the node list groupings
  let title = '';
  let sep = '';
  for (let i = 0; i < types.length; i++) {
    title += sep;
    sep = '<br>';
    const displayType = types[i];
    const nodeList = containedNodesByType[displayType];
    title += displayType + ' (' + nodeList.nodes.length + '):<br>';
    for (let j = 0; j < Math.min(nodeList.nodes.length, combineSize); j++) {
      title += nodeList.nodes[j].name + '<br>';
    }
    if (nodeList.nodes.length > combineSize) {
      title += '...';
    }
  }
  const clusterOptions = {
    containedNodes,
    containedNodesByType,
    id: 'combined:' + randId(),
    kind: 'combined',
    label: containedNodes.length + ' ' + typeLabel,
    level: level(depth, dir, true),
    parentNodeName,
    shape: 'dot',
    title
  };
  if (commonNode) {
    const {
      image,
      imageBackup,
      imageSelected,
      imageShape
    } = commonNode.iconProps;
    clusterOptions.shape = imageShape;
    clusterOptions.image = {
      unselected: image,
      selected: imageSelected
    };
    clusterOptions.brokenImage = imageBackup;
  }
  return clusterOptions;
}

/**
 * Get all Edges that are connected to the id
 */
function findConnectedNodes(visEdges, id, dir) {
  return visEdges.filter(e => {
    if (dir === 'from' && e.to === id) return true;
    if (dir === 'to' && e.from === id) return true;
    if (dir === undefined && (e.to === id || e.from === id)) return true;
    return false;
  });
}

// collection of lineage node, all of the same type

function isAliquotNode(node) {
  return node.materialLineageType === 'Aliquot';
}
function processCombinedNodeEdges(lsid, edge, combinedNode, visEdges, visNodes, nodesInCombinedNode) {
  if (!combinedNode) return;

  // remove the basic node from the graph if it exists
  if (visNodes[edge.lsid]) {
    if (visNodes[edge.lsid].kind !== 'node') {
      console.error('Edge in raw graph should only connect basic nodes: ' + lsid + ' -> ' + edge.lsid);
    }
    delete visNodes[edge.lsid];
  }

  // Find existing edges in either direction to the edge target node being added to the combined node.
  // The existing edges will be deleted and re-added to the new combined node.
  const existingEdges = findConnectedNodes(Object.values(visEdges), edge.lsid);
  for (const existingEdge of existingEdges) {
    // remove existing edge
    delete visEdges[existingEdge.id];
    if (existingEdge.from === edge.lsid) {
      // create a new edge to the combined node from the existing basic node
      const edgeId = makeEdgeId(combinedNode.id, existingEdge.to);
      visEdges[edgeId] = {
        id: edgeId,
        from: combinedNode.id,
        to: existingEdge.to
      };
    } else if (existingEdge.to === edge.lsid) {
      // create a new edge from the combined node from the existing basic node
      const edgeId = makeEdgeId(existingEdge.from, combinedNode.id);
      visEdges[edgeId] = {
        id: edgeId,
        from: existingEdge.from,
        to: combinedNode.id
      };
    }
  }

  // Find existing edges in either direction to any combined nodes the target node belong to.
  // These edges won't be deleted, but new edges will be added to the existing combined nodes.
  if (nodesInCombinedNode[edge.lsid]) {
    for (const existingCombinedId of nodesInCombinedNode[edge.lsid]) {
      const existingEdgesForNodeWithinCombinedNode = findConnectedNodes(Object.values(visEdges), existingCombinedId);
      for (const existingEdge of existingEdgesForNodeWithinCombinedNode) {
        if (existingEdge.from === existingCombinedId) {
          // create a new edge to the combined node from the existing basic node
          const edgeId = makeEdgeId(combinedNode.id, existingEdge.to);
          visEdges[edgeId] = {
            id: edgeId,
            from: combinedNode.id,
            to: existingEdge.to
          };
        } else if (existingEdge.to === existingCombinedId) {
          // create a new edge from the combined node from the existing basic node
          const edgeId = makeEdgeId(existingEdge.from, combinedNode.id);
          visEdges[edgeId] = {
            id: edgeId,
            from: existingEdge.from,
            to: combinedNode.id
          };
        }
      }
    }
  }

  // create association from the node within the combined node to the combined node
  if (!nodesInCombinedNode.hasOwnProperty(edge.lsid)) {
    nodesInCombinedNode[edge.lsid] = [];
  }
  nodesInCombinedNode[edge.lsid].push(combinedNode.id);
}
function combineNodes(lsid, edges, nodes, options, dir, visEdges, visNodes, nodesInCombinedNode, depth) {
  const node = nodes[lsid];
  const edgeNodes = edges.map(e => nodes[e.lsid]);
  const combinedNode = createCombinedVisNode(edgeNodes, options, node.name, dir, depth);
  visNodes[combinedNode.id] = combinedNode;
  const combinedLineageNode = createCombinedLineageNode(combinedNode);

  // create a VisGraph Edge from the current node to the new combined node
  // as well as an edge for each of the combined nodes that one of the edge target nodes may belong to.
  addEdges(lsid, combinedNode.id, visEdges, (0,external_immutable_.List)(edges), nodesInCombinedNode, dir);
  edges.forEach(e => {
    processCombinedNodeEdges(lsid, e, combinedNode, visEdges, visNodes, nodesInCombinedNode);
  });
  return combinedLineageNode;
}

/** Applies the {@link LineageGroupingOptions#combineSize} logic to the graph. */
function applyCombineSize(lsid, edges, nodes, options, dir, visEdges, visNodes, nodesInCombinedNode, depth) {
  const combinedLineageNodes = [];
  const {
    aliquotEdges,
    nonAliquotEdges
  } = edges.reduce((acc, e) => {
    if (isAliquotNode(nodes[e.lsid])) {
      acc.aliquotEdges.push(e);
    } else {
      acc.nonAliquotEdges.push(e);
    }
    return acc;
  }, {
    aliquotEdges: [],
    nonAliquotEdges: []
  });
  if (aliquotEdges.length > 1) {
    combinedLineageNodes.push(combineNodes(lsid, aliquotEdges, nodes, options, dir, visEdges, visNodes, nodesInCombinedNode, depth));
  }
  if (nonAliquotEdges.length >= options.grouping.combineSize) {
    combinedLineageNodes.push(combineNodes(lsid, nonAliquotEdges, nodes, options, dir, visEdges, visNodes, nodesInCombinedNode, depth));
  } else if (nonAliquotEdges.length > 0) {
    // create a VisGraph Edge from the current node to the edge's target for each edge
    addEdges(lsid, null, visEdges, (0,external_immutable_.List)(nonAliquotEdges), nodesInCombinedNode, dir);
  }
  return combinedLineageNodes;
}
function groupingBoundary(grouping, depth, dir, depthSets) {
  if (grouping) {
    // Nearest only examines the first parent and child generations (depth = 1) from seed
    if (grouping.generations === LINEAGE_GROUPING_GENERATIONS.Nearest && depth + 1 > 1) {
      return true;
    }

    // Specific will examine parent and child generations to the depths specified from seed
    if (grouping.generations === LINEAGE_GROUPING_GENERATIONS.Specific && depth + 1 > (dir === LINEAGE_DIRECTIONS.Parent ? grouping.parentDepth : grouping.childDepth)) {
      return true;
    }

    // Multi will stop when we hit a depth with multiple nodes.
    // NOTE: this checks the previous depth so any basic nodes at this depth will be created but it's edges won't be traversed.
    if (grouping.generations === LINEAGE_GROUPING_GENERATIONS.Multi) {
      let currentDepthSize = 0;
      if (depth > 0 && depthSets.length >= depth) {
        currentDepthSize = Object.keys(depthSets[depth - 1]).length;
      }
      if (currentDepthSize > 1) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Determines the "level" for a node given the depth and direction.
 * Special case for our combined nodes which are given an offset level to render on their own.
 * See https://visjs.github.io/vis-network/docs/network/nodes.html
 */
function level(depth, dir, combined) {
  const combinedOffset = combined ? 1 : 0;
  if (dir === LINEAGE_DIRECTIONS.Parent) {
    return -1 * depth - combinedOffset;
  }
  return depth + combinedOffset;
}

/**
 * Recursively walks the node list in the direction indicated creating clusters as it goes.
 * The LabKey lineage in `nodes` is processed by this algorithm to populate the
 * `visEdges` collection with {@link Edge} object and the `visNodes` collections with
 * either {@link VisGraphNode} or {@link VisGraphCombinedNode} objects.
 * These collections will be fed into the vis.js {@link Network} to perform the graph layout.
 *
 * If a node has an edge count greater than {@link LineageGroupingOptions.combineSize},
 * a {@link VisGraphCombinedNode} node will be created to hold the collection of {@link LineageNode}
 * objects. We opted to create our own combined nodes rather than use vis.js's cluster node due
 * to vis.js performance issues when laying out large graph sizes with clustered nodes.
 *
 * The algorithm will stop traversing the graph when the conditions specified
 * by {@link LineageGroupingOptions.generations} have been met.
 *
 * The general approach is:
 *  starting from 'mergedIn' nodes (including the original seed)
 *  - if a node has been seen, skip
 *  - create a VisGraphNode and add it to the graph (if it hasn't already been added within a combined node)
 *  - check for stop conditions in `options.generations`:
 *      - if Immediate and depth exceeds depth 1, stop
 *      - if Specific an depth exceeds the desired depth, stop
 *      - if 'Multi' and there are >1 edges at the previous depth, stop
 *  - if there are more than {combineSize} edges, create a combined node
 *     - mark all included nodes and edges on the combined node: {containedNodes: [...]}
 *     - fixup any existing edges to the nodes that are now included in the combined node
 *     - add any additional edges needed for other combined nodes the edge target might belong to
 *     - create edge from the node to the new combined node
 *   - if there are less than {combineSize} edges, create a basic node
 *     - create edges from the node to all of edge targets
 */
function processNodes(seed, lsid, nodes, options, dir, visEdges, visNodes, nodesInCombinedNode, depth = 0, processed = {}, depthSets = []) {
  if (processed[lsid] === true) {
    return;
  }
  processed[lsid] = true;
  const node = nodes[lsid];
  if (node === undefined) {
    return;
  }

  // if node hasn't already been added to a cluster and hasn't been created as a normal node yet, add it now
  if (nodesInCombinedNode[lsid] === undefined && visNodes[lsid] === undefined) {
    visNodes[lsid] = createVisNode(node, lsid, lsid === seed, dir, depth);
  }
  const {
    grouping
  } = options;
  if (groupingBoundary(grouping, depth, dir, depthSets)) {
    return;
  }

  // examine the edges of the node in the desired direction
  const edges = dir === LINEAGE_DIRECTIONS.Parent ? node.parents : node.children;
  if (edges.size === 0) {
    return;
  }

  // depthSets contains a list of cousin nodes at each depth
  let depthSet;
  if (depth + 1 > depthSets.length) {
    depthSet = {};
    depthSets.push(depthSet);
  } else {
    depthSet = depthSets[depth];
  }
  const queue = [];
  edges.forEach(e => {
    // queue up nodes we haven't seen at this depth for recursion
    if (depthSet[e.lsid] === undefined) {
      depthSet[e.lsid] = e.lsid;
      queue.push(e.lsid);
    }
  });
  if (grouping.combineSize >= GROUPING_COMBINED_SIZE_MIN && edges.size >= grouping.combineSize) {
    const combinedLineageNodes = applyCombineSize(lsid, edges, nodes, options, dir, visEdges, visNodes, nodesInCombinedNode, depth);
    combinedLineageNodes.forEach(cln => {
      // add the combined lineage node to the nodes collection
      nodes[cln.lsid] = cln;
    });
  } else {
    // create a VisGraph Edge from the current node to the edge's target for each edge
    addEdges(lsid, null, visEdges, edges, nodesInCombinedNode, dir);
  }

  // recurse for other nodes not yet processed at this depth
  for (let i = 0; i < queue.length; i++) {
    processNodes(seed, queue[i], nodes, options, dir, visEdges, visNodes, nodesInCombinedNode, depth + 1, processed, depthSets);
  }
}
const DEFAULT_EDGE_PROPS = {
  arrows: {
    to: {
      enabled: true
    },
    from: {
      enabled: false
    }
  },
  arrowStrikethrough: false,
  chosen: false,
  dashes: false,
  color: {
    // Issue 37380: edges are missing from lineage graph
    // Without 'inherit:false', edges take their color of the 'from' node -- which is white :(
    inherit: false,
    color: '#808080'
  }
};
const DEFAULT_NODE_PROPS = {
  // ensure edge lines do not enter the image by setting useBorderImage to true and making the border
  // color be white (the same as the background) so that user does not see border box drawn around image
  color: {
    border: '#F0F0F0',
    background: '#F8F8F8'
  },
  shadow: {
    enabled: false,
    color: 'rgba(0,0,0,0.25)',
    size: 3,
    x: 3,
    y: 3
  },
  shapeProperties: {
    useBorderWithImage: true
  },
  font: {
    size: 14
  },
  chosen: {
    node: function (values, id, selected, hovering) {
      if (selected || hovering) {
        values.borderColor = '#FFA500';
        values.shadow = true;
      }
      if (hovering) {
        values.borderWidth = 1;
      }
      if (selected) {
        values.borderWidth = 1.5;
      }
    }
  }
};
function generate(result, options) {
  if (result === undefined) {
    throw new Error('raw lineage result needed to create graph');
  }
  const _options = applyLineageOptions(options);
  const nodes = result.nodes.toObject();

  // The primary output of this function: the node objects to be consumed by vis.js
  // lsid -> VisGraphNode or VisGraphCombinedNode
  const visNodes = {};

  // The primary output of this function: the edge objects to be consumed by vis.js
  // fromLsid + '||' + toLsid -> Edge
  const visEdges = {};

  // Intermediate state used by processNodes
  // lsid -> Array of combined id nodes
  const nodesInCombinedNode = {};
  result.mergedIn.forEach(startLsid => {
    // parents
    processNodes(result.seed, startLsid, nodes, _options, LINEAGE_DIRECTIONS.Parent, visEdges, visNodes, nodesInCombinedNode);

    // children
    processNodes(result.seed, startLsid, nodes, _options, LINEAGE_DIRECTIONS.Children, visEdges, visNodes, nodesInCombinedNode);
  });
  return new VisGraphOptions({
    nodes: new external_vis_network_.DataSet(Object.values(visNodes)),
    edges: new external_vis_network_.DataSet(Object.values(visEdges)),
    // visjs options described in detail here: https://visjs.github.io/vis-network/docs/network/
    options: {
      // hierarchical is needed to render linage as consistent straight up and down single branch
      // oriented in the direction implied by the direction of the edges.
      layout: {
        hierarchical: {
          enabled: true,
          direction: 'UD',
          sortMethod: 'directed'
        }
      },
      interaction: {
        dragNodes: false,
        zoomView: true,
        dragView: true,
        keyboard: false,
        hover: true
      },
      physics: {
        enabled: false
      },
      nodes: DEFAULT_NODE_PROPS,
      edges: DEFAULT_EDGE_PROPS
    },
    initialSelection: [result.seed]
  });
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/actions.ts
function lineage_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function lineage_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? lineage_actions_ownKeys(Object(t), !0).forEach(function (r) { lineage_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : lineage_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function lineage_actions_defineProperty(e, r, t) { return (r = lineage_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function lineage_actions_toPropertyKey(t) { var i = lineage_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function lineage_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2017-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */
















const LINEAGE_METADATA_COLUMNS = (0,external_immutable_.OrderedSet)(['LSID', 'Name', 'Description', 'Alias', 'RowId', 'Created']);
const NodeInteractionContext = (0,external_react_.createContext)(undefined);
const NodeInteractionProvider = NodeInteractionContext.Provider;
const NodeInteractionConsumer = NodeInteractionContext.Consumer;
function fetchLineageNodes(lsids, containerPath) {
  return new Promise((resolve, reject) => {
    return api_.Experiment.resolve({
      containerPath,
      lsids,
      success: json => {
        resolve(json.data.map(n => LineageNode.create(n.lsid, n)));
      },
      failure: error => {
        reject(error);
      }
    });
  });
}
function applyLineageMetadata(lineage, metadata, iconURLByLsid, options) {
  const urlResolver = getURLResolver(options);
  const nodes = lineage.nodes.map(node => {
    const config = lineage_actions_objectSpread(lineage_actions_objectSpread({}, applyItemMetadata(node, iconURLByLsid, urlResolver, lineage.seed === node.lsid)), {}, {
      steps: node.steps.map((0,external_immer_.produce)(draft => {
        Object.assign(draft, applyItemMetadata(draft, iconURLByLsid, urlResolver));
      })),
      meta: metadata[node.lsid]
    });

    // Unfortunately, Immutable.merge converts all types to Immutable types (e.g. {} -> Map) which
    // is not acceptable. Doing a manual merge...
    Object.keys(config).forEach(prop => {
      node = node.set(prop, config[prop]);
    });
    return node;
  });
  return lineage.set('nodes', nodes);
}
function applyItemMetadata(item, iconURLByLsid, urlResolver, isSeed = false) {
  return lineage_actions_objectSpread(lineage_actions_objectSpread({}, applyLineageIOMetadata(item, iconURLByLsid, urlResolver)), {}, {
    iconProps: resolveIconAndShapeForNode(item, iconURLByLsid[item.lsid], isSeed),
    links: urlResolver.resolveItem(item) ?? {}
  });
}
function applyLineageIOMetadata(item, iconURLByLsid, urlResolver) {
  const _applyItem = (0,external_immer_.produce)(draft => {
    draft.iconProps = resolveIconAndShapeForNode(draft, iconURLByLsid[draft.lsid]);
    draft.links = urlResolver.resolveItem(draft);
  });
  return {
    dataInputs: item.dataInputs.map(_applyItem),
    dataOutputs: item.dataOutputs.map(_applyItem),
    materialInputs: item.materialInputs.map(_applyItem),
    materialOutputs: item.materialOutputs.map(_applyItem),
    objectInputs: item.objectInputs.map(_applyItem),
    objectOutputs: item.objectOutputs.map(_applyItem)
  };
}

// TODO add jest test coverage for this function
function computeSampleCounts(lineageResult, sampleSets) {
  const {
    key,
    models
  } = sampleSets;
  const {
    nodes,
    seed
  } = lineageResult;
  const nodeIds = {};
  const seedNode = nodes.get(seed);
  nodes.forEach(({
    cpasType,
    id,
    lsid
  }) => {
    if (lsid && cpasType) {
      if (!nodeIds[cpasType]) {
        nodeIds[cpasType] = [];
      }
      nodeIds[cpasType].push(id);
    }
  });
  const rows = Object.values(models[key]).map(row => {
    const name = caseInsensitive(row, 'Name').value;
    const cpasType = caseInsensitive(row, 'LSID').value;
    const count = nodeIds[cpasType]?.length ?? 0;
    return {
      name: {
        url: AppURL.create(SAMPLES_KEY, name).toHref(),
        value: name
      },
      sampleCount: {
        url: count > 0 ? AppURL.create('rd', 'expdata', seedNode.id, 'samples').addParam('tab', name).toHref() : undefined,
        value: count
      },
      modified: count > 0 ? caseInsensitive(row, 'Modified') : undefined
    };
  });
  rows.sort((rowA, rowB) => naturalSort(rowA.name.value, rowB.name.value));
  return (0,external_immutable_.fromJS)(rows);
}
function createGridModel(lineage, members, distance, pageNumber) {
  const result = lineage.filterResult({
    filters: [new LineageFilter('type', ['Sample', 'Data'])]
  });
  distance = distance ?? DEFAULT_LINEAGE_DISTANCE;
  members = members ?? DEFAULT_LINEAGE_DIRECTION;
  pageNumber = pageNumber ?? 1;
  const data = getLineageDepthFirstNodeList(result.nodes, result.seed, members, distance);
  const nodeCounts = data.reduce((map, node) => {
    const {
      lsid
    } = node;
    if (map.has(lsid)) {
      return map.set(lsid, map.get(lsid) + 1);
    }
    return map.set(lsid, 1);
  }, (0,external_immutable_.Map)());
  return new LineageGridModel({
    data,
    distance,
    isError: false,
    isLoaded: true,
    isLoading: false,
    members,
    message: undefined,
    nodeCounts,
    pageNumber,
    seedNode: data.get(0),
    totalRows: data.size
  });
}
function getPageNumberChangeURL(queryParams, seed, pageNumber) {
  let url = AppURL.create('lineage');

  // use the seed lsid value from the param
  url = url.addParam('seeds', seed);
  Object.keys(queryParams).map(key => {
    if (key !== 'p' && key !== 'seeds') {
      url = url.addParam(key, queryParams[key]);
    }
  });
  if (pageNumber > 1) {
    url = url.addParam('p', pageNumber);
  }
  return url;
}
function getLineageFilterValue(lsid, depth) {
  const filterVals = [lsid, depth];
  return '{json:' + JSON.stringify(filterVals) + '}';
}
function getImmediateChildLineageFilterValue(lsid) {
  return getLineageFilterValue(lsid, 1);
}
let lineageResultCache = {};
let lineageSeedCache = {};
function invalidateLineageResults() {
  lineageResultCache = {};
  lineageSeedCache = {};
}
class ServerLineageAPIWrapper {
  constructor() {
    lineage_actions_defineProperty(this, "processLineageResult", async (lineage, options) => {
      const iconURLByLsid = {};
      const metadata = {};
      const results = await Promise.all(this.loadNodeMetadata(lineage));
      results.forEach(result => {
        const queryInfo = result.queries[result.key];
        const model = (0,external_immutable_.fromJS)(result.models[result.key]);
        model.forEach(data => {
          const lsid = data.getIn(['LSID', 'value']);
          iconURLByLsid[lsid] = queryInfo.iconURL;
          metadata[lsid] = LineageNodeMetadata.create(data, queryInfo);
        });
      });
      return applyLineageMetadata(lineage, metadata, iconURLByLsid, options);
    });
    lineage_actions_defineProperty(this, "loadLineage", options => {
      return new Promise((resolve, reject) => {
        const seed = options.lsid;
        api_.Experiment.lineage(lineage_actions_objectSpread(lineage_actions_objectSpread({}, options), {}, {
          success: lineage => {
            resolve(LineageResult.create(lineage));
          },
          failure: error => {
            let message = `Failed to fetch lineage for seed "${seed}".`;
            if (error) {
              if (error.exception) {
                message = error.exception;

                // When a server exception occurs
                if (error.exceptionClass) {
                  message = `${error.exceptionClass}: ` + error.exception;
                }
              }
            }
            reject({
              seed,
              message
            });
          }
        }));
      });
    });
    lineage_actions_defineProperty(this, "loadLineageResult", (seed, container, distance, options) => {
      const fetchOptions = lineage_actions_objectSpread(lineage_actions_objectSpread({}, options?.request), {}, {
        lsid: seed,
        runProtocolLsid: options?.runProtocolLsid
      });
      const currentContainerId = (0,api_.getServerContext)().container.id;
      if (!container) {
        container = currentContainerId;
      }

      // Lineage API currently responds with the container's entity ID.
      // Only apply container if it doesn't match the current container.
      if (container !== currentContainerId) {
        fetchOptions.containerPath = container;
      }
      if (!isNaN(distance)) {
        // The lineage includes a "run" object for each parent as well, so we
        // query for twice the depth requested in the URL.
        fetchOptions.depth = distance * 2;
      }
      const key = [seed, container ?? '', distance ?? -1, fetchOptions.includeInputsAndOutputs === true, fetchOptions.includeRunSteps === true, fetchOptions.includeProperties === true, options?.runProtocolLsid ?? ''].join('|');
      if (!lineageResultCache[key]) {
        lineageResultCache[key] = this.loadLineage(fetchOptions).then(r => this.processLineageResult(r, options));
      }
      return lineageResultCache[key];
    });
    lineage_actions_defineProperty(this, "loadNodeMetadata", lineage => {
      // Node metadata does not support nodes with multiple primary keys. These could be supported, however,
      // each node would require it's own request for the unique keys combination. Also, nodes without any primary
      // keys cannot be filtered upon and thus are also not supported.
      return lineage.nodes.filter(n => n.schemaName !== undefined && n.queryName !== undefined && n.pkFilters.length === 1).groupBy(n => [n.schemaName, n.queryName].join('|||').toLowerCase()).map(nodes => {
        const node = nodes.first();
        const {
          fieldKey
        } = node.pkFilters[0];
        return selectRowsDeprecated({
          containerPath: node.containerPath,
          schemaName: node.schemaName,
          queryName: node.queryName,
          viewName: ViewInfo.DETAIL_NAME,
          // use Detail view to assure we get all data, even when default view is filtered
          // TODO: Is there a better way to determine set of columns? Can we follow convention for detail views?
          // See LineageNodeMetadata (and it's usages) for why this is currently necessary
          columns: LINEAGE_METADATA_COLUMNS.add(fieldKey).join(','),
          filterArray: [api_.Filter.create(fieldKey, nodes.map(n => n.pkFilters[0].value).toArray(), api_.Filter.Types.IN)]
        });
      }).toArray();
    });
    lineage_actions_defineProperty(this, "loadSampleStats", lineageResult => {
      return selectRowsDeprecated({
        schemaName: SCHEMAS.EXP_TABLES.SAMPLE_SETS.schemaName,
        queryName: SCHEMAS.EXP_TABLES.SAMPLE_SETS.queryName,
        containerFilter: api_.Query.containerFilter.currentPlusProjectAndShared
      }).then(sampleSets => computeSampleCounts(lineageResult, sampleSets));
    });
    lineage_actions_defineProperty(this, "loadSeedResult", (seed, container, options) => {
      const key = [seed, container ?? ''].join('|');
      if (!lineageSeedCache[key]) {
        lineageSeedCache[key] = fetchLineageNodes([seed], container).then(nodes => nodes[0]).then(seedNode => LineageResult.create({
          nodes: {
            [seedNode.lsid]: seedNode
          },
          seed: seedNode.lsid
        })).then(result => this.processLineageResult(result, options));
      }
      return lineageSeedCache[key];
    });
  }
}
class TestLineageAPIWrapper extends ServerLineageAPIWrapper {
  constructor(result, metadata) {
    super();
    lineage_actions_defineProperty(this, "result", void 0);
    lineage_actions_defineProperty(this, "metadata", void 0);
    lineage_actions_defineProperty(this, "loadNodeMetadata", lineage => {
      return this.metadata.map(m => Promise.resolve(m));
    });
    lineage_actions_defineProperty(this, "loadLineage", options => {
      return Promise.resolve(this.result);
    });
    this.result = result;
    this.metadata = metadata;
  }
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/withLineage.tsx
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function withLineage_extends() { return withLineage_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, withLineage_extends.apply(null, arguments); }
function withLineage_defineProperty(e, r, t) { return (r = withLineage_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function withLineage_toPropertyKey(t) { var i = withLineage_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function withLineage_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






function withLineage(ComponentToWrap, allowSeedPrefetch = true, allowLoadSampleStats = false, applyDefaultDistance = true) {
  class ComponentWithLineage extends external_react_.PureComponent {
    constructor(...args) {
      super(...args);
      withLineage_defineProperty(this, "state", (0,external_immer_.produce)({
        lineage: undefined
      }, () => {}));
      withLineage_defineProperty(this, "_mounted", true);
      withLineage_defineProperty(this, "loadLineage", async forceReload => {
        const {
          api,
          containerPath,
          distance,
          prefetchSeed,
          lsid
        } = this.props;

        // Lineage is already processed
        if (this.state.lineage && lsid === this.state.lineage.seed && !forceReload) {
          return;
        }

        // Create the initial lineage model for this seed
        await this.setLineage(new Lineage({
          seed: lsid,
          resultLoadingState: LoadingState.LOADING
        }));
        if (allowSeedPrefetch && prefetchSeed === true) {
          // Fetch seed node asynchronously to allow for decoupled loading
          this.loadSeed();
        }
        try {
          const result = await api.loadLineageResult(lsid, containerPath, distance, this.props);
          let sampleStats;
          if (allowLoadSampleStats) {
            sampleStats = await api.loadSampleStats(result);
          }
          await this.updateLineage({
            result,
            resultLoadingState: LoadingState.LOADED,
            sampleStats
          });
        } catch (e) {
          console.error(e);
          await this.updateLineage({
            error: e.message,
            resultLoadingState: LoadingState.LOADED
          });
        }
      });
      withLineage_defineProperty(this, "loadSeed", async () => {
        const {
          api,
          containerPath,
          lsid
        } = this.props;
        await this.updateLineage({
          seedResultLoadingState: LoadingState.LOADING
        });
        try {
          const seedResult = await api.loadSeedResult(lsid, containerPath, this.props);
          await this.updateLineage({
            seedResult,
            seedResultLoadingState: LoadingState.LOADED
          });
        } catch (e) {
          console.error(e);
          await this.updateLineage({
            seedResultError: 'Error while pre-fetching the lineage seed',
            seedResultLoadingState: LoadingState.LOADED
          });
        }
      });
      /**
       * An asynchronous helper function to update properties of the state's lineage.
       * Throws an error if called prior to the state's lineage having been initialized.
       * @param lineageProps The lineage properties to update. Properties not specified will be left unchanged.
       */
      withLineage_defineProperty(this, "updateLineage", async lineageProps => {
        if (!this.state.lineage) {
          throw new Error('withLineage: Called "updateLineage" prior to setting lineage.');
        }
        return await this.setLineage(this.state.lineage.mutate(lineageProps));
      });
      /**
       * An asynchronous helper function that sets the lineage on state.
       * @param lineage The lineage object to set to
       */
      withLineage_defineProperty(this, "setLineage", lineage => {
        return new Promise(resolve => {
          if (this._mounted) {
            this.setState((0,external_immer_.produce)(draft => {
              draft.lineage = lineage;
            }), () => {
              resolve();
            });
          }
        });
      });
    }
    componentDidMount() {
      this._mounted = true;
      this.loadLineage();
    }
    componentDidUpdate(prevProps) {
      if (prevProps.lsid !== this.props.lsid || prevProps.filters !== this.props.filters || prevProps.runProtocolLsid !== this.props.runProtocolLsid) {
        this.loadLineage(prevProps.runProtocolLsid !== this.props.runProtocolLsid);
      }
    }
    componentWillUnmount() {
      this._mounted = false;
    }
    render() {
      const _this$props = this.props,
        props = withLineage_extends({}, (_objectDestructuringEmpty(_this$props), _this$props));
      const {
        lineage
      } = this.state;
      return /*#__PURE__*/external_react_default().createElement(ComponentToWrap, withLineage_extends({}, props, {
        lineage: lineage
      }));
    }
  }
  withLineage_defineProperty(ComponentWithLineage, "defaultProps", void 0);
  ComponentWithLineage.defaultProps = {
    distance: applyDefaultDistance ? DEFAULT_LINEAGE_DISTANCE : undefined,
    prefetchSeed: true,
    api: new ServerLineageAPIWrapper()
  };
  return ComponentWithLineage;
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/vis/VisGraphControls.tsx
function VisGraphControls_defineProperty(e, r, t) { return (r = VisGraphControls_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function VisGraphControls_toPropertyKey(t) { var i = VisGraphControls_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function VisGraphControls_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


const PAN_INCREMENT = 20;
const ZOOM_INCREMENT = 0.05;
class VisGraphControls extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    VisGraphControls_defineProperty(this, "panDown", () => {
      this.props.getNetwork().moveTo({
        offset: {
          x: 0,
          y: -PAN_INCREMENT
        }
      });
    });
    VisGraphControls_defineProperty(this, "panUp", () => {
      this.props.getNetwork().moveTo({
        offset: {
          x: 0,
          y: PAN_INCREMENT
        }
      });
    });
    VisGraphControls_defineProperty(this, "panLeft", () => {
      this.props.getNetwork().moveTo({
        offset: {
          x: PAN_INCREMENT,
          y: 0
        }
      });
    });
    VisGraphControls_defineProperty(this, "panRight", () => {
      this.props.getNetwork().moveTo({
        offset: {
          x: -PAN_INCREMENT,
          y: 0
        }
      });
    });
    VisGraphControls_defineProperty(this, "reset", () => {
      this.props.onReset?.(false);
    });
    VisGraphControls_defineProperty(this, "resetSelect", () => {
      this.props.onReset?.(true);
    });
    VisGraphControls_defineProperty(this, "zoomIn", () => {
      const network = this.props.getNetwork();
      network.moveTo({
        scale: network.getScale() + ZOOM_INCREMENT
      });
    });
    VisGraphControls_defineProperty(this, "zoomOut", () => {
      const network = this.props.getNetwork();
      const scale = network.getScale() - ZOOM_INCREMENT;
      if (scale > 0) {
        network.moveTo({
          scale
        });
      }
    });
  }
  render() {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "lineage-visgraph-controls"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "lineage-visgraph-control-settings"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "btn-group"
    }, !!this.props.onToggleSettings && /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: this.props.onToggleSettings,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-gear"
    })), /*#__PURE__*/external_react_default().createElement(DropdownButton, {
      title: /*#__PURE__*/external_react_default().createElement("i", {
        className: "fa fa-undo"
      }),
      pullRight: true
    }, /*#__PURE__*/external_react_default().createElement(MenuItem, {
      onClick: this.resetSelect
    }, "Reset view and select seed"), /*#__PURE__*/external_react_default().createElement(MenuItem, {
      onClick: this.reset
    }, "Reset view")))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "lineage-visgraph-control-zoom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "btn-group"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: this.zoomOut,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-search-minus"
    })), /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: this.zoomIn,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-search-plus"
    })))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "lineage-visgraph-control-pan"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "lineage-visgraph-control-pan-up btn btn-default",
      onClick: this.panUp,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-arrow-up"
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "btn-group"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: this.panLeft,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-arrow-left"
    })), /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: this.panDown,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-arrow-down"
    })), /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: this.panRight,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-arrow-right"
    })))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/vis/VisGraph.tsx
function VisGraph_defineProperty(e, r, t) { return (r = VisGraph_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function VisGraph_toPropertyKey(t) { var i = VisGraph_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function VisGraph_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2017-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */




// Directly from https://github.com/visjs/vis-network/blob/v6.5.2/lib/network/shapes.ts#L9
/**
 * Draw a circle.
 *
 * @param ctx - The context this shape will be rendered to.
 * @param x - The position of the center on the x axis.
 * @param y - The position of the center on the y axis.
 * @param r - The radius of the circle.
 */
function drawCircle(ctx, x, y, r) {
  ctx.beginPath();
  ctx.arc(x, y, r, 0, 2 * Math.PI, false);
  ctx.closePath();
}

// defined in vis/lib/network/shapes.js

// defined in vis/lib/network/modules/components/Node.js

// https://visjs.org/docs/network/#Events

class VisGraph extends external_react_.Component {
  constructor(_props) {
    super(_props);
    VisGraph_defineProperty(this, "data", void 0);
    VisGraph_defineProperty(this, "network", void 0);
    VisGraph_defineProperty(this, "visgraph", void 0);
    VisGraph_defineProperty(this, "highlightNode", (id, hover) => {
      if (id && this.data) {
        // findNode will return any cluster node ids that the node is within.
        // If the node is in a cluster, highlight it the cluster instead
        const clusterIds = this.network.findNode(id);
        if (clusterIds && clusterIds.length) {
          const topNodeId = clusterIds[0];
          if (topNodeId) {
            // reaching into the vis.js internal structure to get the graph's Node object
            const internalNode = this.getInternalNode(topNodeId);
            internalNode.hover = hover;
            this.moveNodeToTop(topNodeId);

            // force a redraw to see the hover state applied to the node
            this.network.redraw();
          }
        }
      }
    });
    // move the node to the end of the list so it is drawn on top of any of it's neighbors
    VisGraph_defineProperty(this, "moveNodeToTop", id => {
      const {
        nodeIndices
      } = this.network.body;
      const idx = nodeIndices.indexOf(id);
      nodeIndices.splice(idx, 1);
      nodeIndices.push(id);
    });
    VisGraph_defineProperty(this, "destroyGraph", () => {
      if (this.network) {
        this.network.destroy();
        this.network = undefined;
      }
      if (this.data) {
        this.data = undefined;
      }
    });
    VisGraph_defineProperty(this, "fitGraph", () => {
      // NK: This is a arbitrarily set heuristic for deciding when to focus vs when to fit to
      // the entire graph. I'm trying to delineate "small" graphs from "large" graphs.
      if (this.network.body.nodeIndices.length > 50) {
        this.focusSeed();
      } else {
        this.network.fit();
      }
    });
    VisGraph_defineProperty(this, "focusSeed", () => {
      // Focus on the seed
      this.network.fit({
        animation: false,
        nodes: [this.props.seed]
      });

      // Zoom out a bit from the default fitted zoom level
      const scale = this.network.getScale() - 0.25;
      if (scale > 0) {
        this.network.moveTo({
          scale
        });
      }
    });
    VisGraph_defineProperty(this, "getInternalNode", id => {
      return this.network.body.nodes[id];
    });
    VisGraph_defineProperty(this, "getCombinedNodes", () => {
      return this.data.nodes.get({
        filter: isCombinedNode
      });
    });
    VisGraph_defineProperty(this, "getNodes", ids => {
      return ids.map(id => this.getNode(id)).filter(n => n !== null && n !== undefined);
    });
    VisGraph_defineProperty(this, "getNode", id => {
      const node = this.data.nodes.get(id);
      if (node && this.network.isCluster(id)) {
        const nodesInCluster = this.network.getNodesInCluster(id);
        return {
          kind: 'cluster',
          id,
          nodesInCluster: this.getNodes(nodesInCluster)
        };
      }
      return node;
    });
    // set a selection on the vis.js graph and fire the select handler as if the user clicked on a node in the graph
    VisGraph_defineProperty(this, "selectNodes", ids => {
      const selectedNodes = this.getNodes(ids);
      this.doSelectNode(selectedNodes);

      // get the actual ids from the nodes -- some may not have been found
      this.network.setSelection({
        edges: [],
        nodes: selectedNodes.map(n => n.id)
      });
    });
    VisGraph_defineProperty(this, "doSelectNode", selectedNodes => {
      // change color of newly selected node
      const addToSelection = [];
      for (let i = 0; i < selectedNodes.length; i++) {
        const selectedNode = selectedNodes[i];
        if (!selectedNode) continue;
        addToSelection.push(selectedNode.id);
      }

      // add the newly selected node in the state
      this.setState(prevState => ({
        selected: this.unique(prevState.selected, addToSelection)
      }));
      this.props.onNodeSelect?.(selectedNodes);
    });
    // create a new array from the two arrays with any duplicates removed
    VisGraph_defineProperty(this, "unique", (a, b) => {
      const ret = [].concat(a);
      for (let i = 0; i < b.length; i++) {
        const item = b[i];
        if (ret.indexOf(item) == -1) ret.push(item);
      }
      return ret;
    });
    VisGraph_defineProperty(this, "onClick", visEvent => {
      if (visEvent.nodes.length !== 1) {
        return;
      }
      const id = visEvent.nodes[0];
      const clickedNode = this.getNode(id);
      if (clickedNode) {
        this.props.onNodeClick?.(clickedNode);
      } else {
        // it could happen that the graph was reset after an expanded node was selected in which case the selected node might no longer exist
        // the node specified by selected no longer exist so reset selected
        this.setState(prevState => {
          let newSelected;
          if (prevState.selected) {
            newSelected = [];
            for (let i = 0; i < prevState.selected.length; i++) {
              if (prevState.selected[i] !== id) newSelected.push(prevState.selected[i]);
            }
          }
          return {
            selected: newSelected
          };
        });
      }
    });
    VisGraph_defineProperty(this, "onDoubleClick", visEvent => {
      if (visEvent.nodes.length === 1) {
        this.props.onNodeDoubleClick?.(this.getNode(visEvent.nodes[0]));
      }
    });
    VisGraph_defineProperty(this, "onNodeBlur", () => {
      this.network.body.container.style.cursor = 'default';
      this.props.onNodeBlur?.();
    });
    VisGraph_defineProperty(this, "onNodeDeselect", visEvent => {
      if (this.props.onNodeDeselect) {
        const selectedNodes = this.getNodes(visEvent.nodes);
        const previousSelectedNodes = this.getNodes(visEvent.previousSelection.nodes);
        this.props.onNodeDeselect(selectedNodes, previousSelectedNodes);
      }
    });
    VisGraph_defineProperty(this, "onNodeHover", event => {
      this.network.body.container.style.cursor = 'pointer';
      const id = event.node;
      const node = this.getNode(id);
      if (node) {
        this.moveNodeToTop(id);
        if (this.props.onNodeHover) {
          const canvasBox = this.network.getBoundingBox(id);

          // convert the node's canvas box to DOM coordinates
          const topLeftDOM = this.network.canvasToDOM({
            x: canvasBox.left,
            y: canvasBox.top
          });
          const bottomRightDOM = this.network.canvasToDOM({
            x: canvasBox.right,
            y: canvasBox.bottom
          });
          const rect = this.visgraph.current.getBoundingClientRect();
          const coords = {
            top: rect.top + topLeftDOM.y,
            left: rect.left + topLeftDOM.x,
            bottom: rect.top + bottomRightDOM.y,
            right: rect.left + bottomRightDOM.x
          };
          this.props.onNodeHover(node, coords);
        }
      }
    });
    VisGraph_defineProperty(this, "onNodeSelect", visEvent => {
      this.doSelectNode(this.getNodes(visEvent.nodes));
    });
    VisGraph_defineProperty(this, "doAfterDrawing", ctx => {
      this.getCombinedNodes().forEach(combinedNode => {
        const internalNode = this.getInternalNode(combinedNode.id);
        if (!internalNode) {
          console.error('internal node not found for combined node: ' + combinedNode.id);
          return;
        }
        const {
          shape
        } = internalNode;
        const nodeCount = combinedNode.containedNodes.length;

        // set up circle clip area
        drawCircle(ctx, internalNode.x, internalNode.y, shape.radius);
        ctx.save();
        ctx.clip();

        // calculate the size of the font based on the shape size
        const text = '' + nodeCount;
        let fontSize = 28;
        let textMetrics;
        while (true) {
          if (fontSize < 8) break;
          ctx.font = fontSize + 'px arial';
          textMetrics = ctx.measureText(text);
          if (textMetrics.width < shape.width - 8) break;
          fontSize -= 4;
        }
        ctx.fillStyle = 'rgba(0,0,0,0.9)';
        ctx.shadowColor = 'rgba(0,0,0,0.25)';
        ctx.shadowBlur = 3;
        ctx.shadowOffsetX = 3;
        ctx.shadowOffsetY = 3;
        ctx.fillText(text, internalNode.x - textMetrics.width / 2, internalNode.y - fontSize / 2);

        // remove clip
        ctx.restore();
      });
    });
    VisGraph_defineProperty(this, "onReset", selectSeed => {
      if (selectSeed) {
        this.selectNodes(this.props.options.initialSelection);
      }
      this.fitGraph();
    });
    VisGraph_defineProperty(this, "getNetwork", () => {
      return this.network;
    });
    VisGraph_defineProperty(this, "generateGraph", props => {
      const {
        fitOnResize,
        options
      } = props;
      const {
        selected
      } = this.state;
      this.destroyGraph();
      if (!options) {
        throw new Error('VisGraph.generateGraph: options must be provided.');
      }
      this.data = {
        edges: options.edges,
        nodes: options.nodes
      };
      this.network = new external_vis_network_.Network(this.visgraph.current, this.data, options.options);
      this.network.on('afterDrawing', this.doAfterDrawing);
      this.network.on('blurNode', this.onNodeBlur);
      this.network.on('click', this.onClick);
      this.network.on('deselectNode', this.onNodeDeselect);
      this.network.on('doubleClick', this.onDoubleClick);
      this.network.on('hoverNode', this.onNodeHover);
      this.network.on('selectNode', this.onNodeSelect);
      if (fitOnResize) {
        let resize;
        this.network.on('resize', () => {
          // delay required to allow for element resizing to occur
          clearTimeout(resize);
          resize = window.setTimeout(() => {
            resize = undefined;
            this.network.redraw();
            this.fitGraph();
          }, 75);
        });
      }
      const toSelect = props.options.initialSelection || selected;
      if (toSelect && toSelect.length) {
        this.selectNodes(toSelect);
      }
      this.fitGraph();
    });
    this.state = {
      selected: undefined
    };
    this.visgraph = external_react_default().createRef();
  }
  componentDidMount() {
    this.generateGraph(this.props);
  }
  componentWillUnmount() {
    this.destroyGraph();
  }
  shouldComponentUpdate(nextProps) {
    return this.props.seed !== nextProps.seed || this.props.options?.nodes !== nextProps.options?.nodes;
  }
  componentDidUpdate() {
    this.generateGraph(this.props);
  }
  render() {
    // leave just enough room so the footer doesn't get pushed down when the visjs graph shows
    const graphHeight = window.innerHeight - 350;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "lineage-visgraph-ct"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      ref: this.visgraph,
      style: {
        height: graphHeight
      }
    }), /*#__PURE__*/external_react_default().createElement(VisGraphControls, {
      getNetwork: this.getNetwork,
      onReset: this.onReset,
      onToggleSettings: this.props.onToggleSettings
    }));
  }
}
VisGraph_defineProperty(VisGraph, "defaultProps", {
  fitOnResize: true
});
;// CONCATENATED MODULE: ./src/internal/components/lineage/LineageDataLink.tsx
function LineageDataLink_extends() { return LineageDataLink_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, LineageDataLink_extends.apply(null, arguments); }

class LineageDataLink extends external_react_.PureComponent {
  render() {
    const {
      children,
      href,
      onClick
    } = this.props;
    if (!href && !onClick) {
      return null;
    }
    return /*#__PURE__*/external_react_default().createElement("a", LineageDataLink_extends({}, this.props, {
      className: "show-on-hover lineage-data-link lineage-data-link--text"
    }), children);
  }
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/node/DetailsList.tsx
const DetailsList_excluded = ["highlightNode", "items"];
function DetailsList_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = DetailsList_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function DetailsList_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }







const DetailsList = (0,external_react_.memo)(props => {
  const {
    children,
    collapsedCount,
    headerLinks,
    open,
    showCount,
    title
  } = props;
  const [expanded, setExpanded] = (0,external_react_.useState)(false);
  const onToggle = (0,external_react_.useCallback)(() => {
    setExpanded(ex => !ex);
  }, []);
  return /*#__PURE__*/external_react_default().createElement("details", {
    open: open
  }, /*#__PURE__*/external_react_default().createElement("summary", {
    className: "lineage-name"
  }, /*#__PURE__*/external_react_default().createElement("h6", {
    className: "no-margin-bottom"
  }, title, showCount && /*#__PURE__*/external_react_default().createElement("span", {
    className: "spacer-left"
  }, "(", external_react_default().Children.count(children), ")"), headerLinks && headerLinks.map((link, i) => link && /*#__PURE__*/external_react_default().createElement("span", {
    className: "spacer-left",
    key: i
  }, link)))), /*#__PURE__*/external_react_default().createElement("ul", {
    className: "lineage-details-list"
  }, external_react_default().Children.map(children, (child, i) => {
    const showChild = expanded || i < collapsedCount;
    if (i === collapsedCount) {
      return /*#__PURE__*/external_react_default().createElement(external_react_.Fragment, {
        key: "__skip"
      }, /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement(SVGIcon, {
        className: "lineage-sm-icon"
      }), /*#__PURE__*/external_react_default().createElement("a", {
        className: "lineage-link spacer-left",
        onClick: onToggle
      }, "Show ", external_react_default().Children.count(children) - collapsedCount, ' ', expanded ? 'less' : 'more', "...")), showChild ? /*#__PURE__*/external_react_default().createElement("li", {
        key: i
      }, child) : null);
    }
    return showChild ? /*#__PURE__*/external_react_default().createElement("li", {
      key: i
    }, child) : null;
  })));
});
DetailsList.defaultProps = {
  collapsedCount: 4,
  open: true,
  showCount: true
};
DetailsList.displayName = 'DetailsList';
const DetailsListSteps = (0,external_react_.memo)(({
  node,
  onSelect
}) => {
  if (!node.isRun) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement(DetailsList, {
    title: "Run steps"
  }, node.steps.map((step, i) => /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-name",
    key: `${node.lsid}.step.${i}`
  }, /*#__PURE__*/external_react_default().createElement(SVGIcon, {
    className: "lineage-sm-icon",
    iconSrc: step.iconProps?.iconURL ?? DEFAULT_ICON_URL
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "lineage-sm-name spacer-right"
  }, step.protocol?.name || step.name), /*#__PURE__*/external_react_default().createElement(LineageDataLink, {
    onClick: () => {
      onSelect(i);
    }
  }, "Details"))));
});
DetailsListSteps.displayName = 'DetailsListSteps';
const DetailsListLineageItem = (0,external_react_.memo)(({
  highlighted,
  item
}) => {
  const style = (0,external_react_.useMemo)(() => ({
    fontWeight: highlighted ? 'bold' : 'normal'
  }), [highlighted]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-item-test lineage-name",
    style: style,
    title: getLineageNodeTitle(item)
  }, /*#__PURE__*/external_react_default().createElement(SVGIcon, {
    className: "lineage-sm-icon",
    iconSrc: item.iconProps?.iconURL ?? DEFAULT_ICON_URL
  }), /*#__PURE__*/external_react_default().createElement(NodeInteractionConsumer, null, context => {
    if (context.isNodeInGraph(item)) {
      return /*#__PURE__*/external_react_default().createElement("a", {
        className: "lineage-link spacer-horizontal",
        onClick: e => context.onNodeClick(item),
        onMouseOver: e => context.onNodeMouseOver(item),
        onMouseOut: e => context.onNodeMouseOut(item)
      }, item.name);
    }
    return /*#__PURE__*/external_react_default().createElement("span", {
      className: "spacer-horizontal"
    }, item.name);
  }), /*#__PURE__*/external_react_default().createElement(LineageDataLink, {
    href: item.links.overview
  }, "Overview"), /*#__PURE__*/external_react_default().createElement(LineageDataLink, {
    href: item.links.lineage
  }, "Lineage"));
});
DetailsListLineageItem.displayName = 'DetailsListLineageItem';
const DetailsListLineageItems = (0,external_react_.memo)(props => {
  const {
      highlightNode,
      items
    } = props,
    detailsListProps = DetailsList_objectWithoutProperties(props, DetailsList_excluded);

  // Issue 48459: Sort lineage detail list items
  const sortedItems = (0,external_react_.useMemo)(() => {
    if (!items || items.length === 0) return [];
    return items.sort(naturalSortByProperty('name'));
  }, [items]);
  if (sortedItems.length === 0) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement(DetailsList, detailsListProps, items.map(item => /*#__PURE__*/external_react_default().createElement(DetailsListLineageItem, {
    highlighted: item.lsid === highlightNode,
    item: item,
    key: item.lsid
  })));
});
DetailsListLineageItems.displayName = 'DetailsListLineageItems';
const DetailsListLineageIO = (0,external_react_.memo)(({
  item
}) => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(DetailsListLineageItems, {
  items: item.dataInputs,
  title: "Data Inputs"
}), /*#__PURE__*/external_react_default().createElement(DetailsListLineageItems, {
  items: item.materialInputs,
  title: "Material Inputs"
}), /*#__PURE__*/external_react_default().createElement(DetailsListLineageItems, {
  items: item.dataOutputs,
  title: "Data Outputs"
}), /*#__PURE__*/external_react_default().createElement(DetailsListLineageItems, {
  items: item.materialOutputs,
  title: "Material Outputs"
}), /*#__PURE__*/external_react_default().createElement(DetailsListLineageItems, {
  items: item.objectInputs,
  title: "Object Inputs"
}), /*#__PURE__*/external_react_default().createElement(DetailsListLineageItems, {
  items: item.objectOutputs,
  title: "Object Outputs"
})));
DetailsListLineageIO.displayName = 'DetailsListLineageIO';
const DetailsListNodes = (0,external_react_.memo)(({
  highlightNode,
  nodes,
  title
}) => /*#__PURE__*/external_react_default().createElement(DetailsListLineageItems, {
  headerLinks: [/*#__PURE__*/external_react_default().createElement(LineageDataLink, {
    key: "grid",
    href: nodes.listURL
  }, "View in grid")],
  highlightNode: highlightNode,
  items: nodes.nodes,
  title: title
}));
DetailsListNodes.displayName = 'DetailsListNodes';
;// CONCATENATED MODULE: ./src/internal/components/lineage/LineageSummary.tsx
function LineageSummary_defineProperty(e, r, t) { return (r = LineageSummary_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LineageSummary_toPropertyKey(t) { var i = LineageSummary_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LineageSummary_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */







class LineageSummaryImpl extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    LineageSummary_defineProperty(this, "renderNodeList", (direction, lineage, edges, nodeName) => {
      if (this.empty(edges)) {
        return null;
      }
      const {
        groupTitles,
        highlightNode
      } = this.props;
      const nodes = edges.map(edge => lineage.nodes.get(edge.lsid)).toArray();
      const nodesByType = createLineageNodeCollections(nodes, this.props);
      const groups = Object.keys(nodesByType).sort();
      const defaultTitleSuffix = direction === LINEAGE_DIRECTIONS.Parent ? 'Parents' : 'Children';
      // Issue 40008:  TBD This isn't a full fix here because of differences in treatment of the text of the queryName that identifies the groups
      const suffixes = groupTitles?.get(direction) || (0,external_immutable_.Map)();
      return groups.map(groupName => {
        const group = nodesByType[groupName];
        const title = isAliquotNode(group) && group.nodes.length > 1 ? nodeName + ' Aliquots' : group.displayType + ' ' + (suffixes.has(group.queryName) ? suffixes.get(group.queryName) : defaultTitleSuffix);
        return /*#__PURE__*/external_react_default().createElement(DetailsListNodes, {
          key: groupName,
          title: title,
          nodes: group,
          highlightNode: highlightNode
        });
      });
    });
  }
  empty(nodes) {
    return !nodes || nodes.size === 0;
  }
  render() {
    const {
      lineage
    } = this.props;
    if (!lineage || !lineage.isLoaded()) {
      return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
        msg: "Loading lineage..."
      });
    } else if (lineage.error) {
      return /*#__PURE__*/external_react_default().createElement("div", null, lineage.error);
    }
    const result = lineage.filterResult(this.props);
    const node = result.nodes.get(result.seed);
    if (!node) {
      return /*#__PURE__*/external_react_default().createElement("div", null, "Unable to resolve lineage for seed: ", result.seed);
    }
    const {
      children,
      parents
    } = node;
    const hasChildren = !this.empty(children);
    const hasParents = !this.empty(parents);
    if (!hasChildren && !hasParents) {
      return /*#__PURE__*/external_react_default().createElement("div", null, "No lineage for ", node.name);
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, this.renderNodeList(LINEAGE_DIRECTIONS.Parent, result, parents, node.name), hasChildren && hasParents && /*#__PURE__*/external_react_default().createElement("hr", null), this.renderNodeList(LINEAGE_DIRECTIONS.Children, result, children, node.name));
  }
}
const LineageSummary = withLineage(LineageSummaryImpl);
;// CONCATENATED MODULE: ./src/public/QueryModel/DetailPanel.tsx
const DetailPanel_excluded = ["editColumns", "model", "queryColumns"],
  DetailPanel_excluded2 = ["queryModels"],
  DetailPanel_excluded3 = ["queryConfig"];
function DetailPanel_extends() { return DetailPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DetailPanel_extends.apply(null, arguments); }
function DetailPanel_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = DetailPanel_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function DetailPanel_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/*
 * Copyright (c) 2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/**
 * Render a QueryModel with a single row of a data. For in-depth documentation and examples see
 * components/docs/QueryModel.md.
 */
const DetailPanel = (0,external_react_.memo)(props => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
      editColumns,
      model,
      queryColumns
    } = props,
    detailDisplayProps = DetailPanel_objectWithoutProperties(props, DetailPanel_excluded);
  const {
    editingMode
  } = detailDisplayProps;
  const error = model.queryInfoError ?? model.rowsError;
  let displayColumns;
  if (error !== undefined) {
    return /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "info"
    }, error);
  } else if (model.isLoading) {
    return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  }
  if (editingMode) {
    displayColumns = (0,external_immutable_.List)(editColumns ?? model.updateColumns);
  } else {
    displayColumns = (0,external_immutable_.List)(queryColumns ?? model.detailColumns);
  }
  return /*#__PURE__*/external_react_default().createElement(DetailDisplay, DetailPanel_extends({}, detailDisplayProps, {
    data: (0,external_immutable_.fromJS)(model.gridData),
    displayColumns: displayColumns
  }));
});
const DetailPanelWithModelBodyImpl = (0,external_react_.memo)(_ref => {
  let {
      queryModels
    } = _ref,
    rest = DetailPanel_objectWithoutProperties(_ref, DetailPanel_excluded2);
  return /*#__PURE__*/external_react_default().createElement(DetailPanel, DetailPanel_extends({}, rest, {
    model: queryModels.model
  }));
});
const DetailPanelWithModelBody = withQueryModels(DetailPanelWithModelBodyImpl);
const DetailPanelWithModel = (0,external_react_.memo)(props => {
  const {
      queryConfig
    } = props,
    detailPanelProps = DetailPanel_objectWithoutProperties(props, DetailPanel_excluded3);
  const queryConfigs = (0,external_react_.useMemo)(() => ({
    model: queryConfig
  }), [queryConfig]);
  const {
    keyValue,
    schemaQuery
  } = queryConfig;
  const {
    schemaName,
    queryName
  } = schemaQuery;
  // Key is used here to ensure we re-mount the DetailPanel when the queryConfig changes
  const key = (0,external_react_.useMemo)(() => `${schemaName}.${queryName}.${keyValue}`, [schemaQuery, keyValue]);
  return /*#__PURE__*/external_react_default().createElement(DetailPanelWithModelBody, DetailPanel_extends({}, detailPanelProps, {
    autoLoad: true,
    key: key,
    queryConfigs: queryConfigs
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/lineage/node/LineageDetail.tsx










const ADDITIONAL_DETAIL_FIELDS = ['properties'];
const LineageDetailImpl = (0,external_react_.memo)(props => {
  const {
    queryModels
  } = props;
  if (queryModels.model.isLoading) return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  if (queryModels.model.hasLoadErrors) return /*#__PURE__*/external_react_default().createElement(Alert, null, queryModels.model.loadErrors[0]);
  const additionalCols = queryModels.model.allColumns.filter(col => ADDITIONAL_DETAIL_FIELDS.indexOf(col.fieldKey?.toLowerCase()) > -1);
  const detailColumns = [...queryModels.model.detailColumns, ...additionalCols];
  return /*#__PURE__*/external_react_default().createElement(DetailPanel, {
    tableCls: "detail-component--table__auto",
    model: queryModels.model,
    queryColumns: detailColumns,
    detailRenderer: _resolveDetailRenderer
  });
});
const LineageDetailWithQueryModels = withQueryModels(LineageDetailImpl);
const LineageDetail = (0,external_react_.memo)(({
  item
}) => {
  const queryConfigs = (0,external_react_.useMemo)(() => ({
    model: {
      baseFilters: item.pkFilters.map(pkFilter => api_.Filter.create(pkFilter.fieldKey, pkFilter.value)),
      containerPath: item.container,
      // Issue 45028: Display details view columns in lineage
      schemaQuery: new SchemaQuery(item.schemaName, item.queryName, ViewInfo.DETAIL_NAME),
      // Must specify '*' columns be requested to resolve "properties" columns
      requiredColumns: ['*', SAMPLE_STATE_COLOR_COLUMN_NAME, SAMPLE_STATE_TYPE_COLUMN_NAME]
    }
  }), [item]);

  // providing "key" to allow for reload on lsid change
  return /*#__PURE__*/external_react_default().createElement(LineageDetailWithQueryModels, {
    key: item.lsid,
    autoLoad: true,
    queryConfigs: queryConfigs,
    item: item
  });
});
// exported for jest testing
const CustomPropertiesRenderer = (0,external_react_.memo)(({
  data
}) => {
  return /*#__PURE__*/external_react_default().createElement("table", {
    className: "lineage-detail-prop-table"
  }, /*#__PURE__*/external_react_default().createElement("tbody", null, data?.map(row => {
    const fieldKey = row.get('fieldKey');
    const name = fieldKey.substring(fieldKey.indexOf('#') + 1);
    return /*#__PURE__*/external_react_default().createElement("tr", {
      key: fieldKey
    }, /*#__PURE__*/external_react_default().createElement("td", {
      className: "lineage-detail-prop-cell"
    }, name), /*#__PURE__*/external_react_default().createElement("td", {
      className: "lineage-detail-prop-cell"
    }, row.get('value')));
  })));
});
function _resolveDetailRenderer(column) {
  if (column.fieldKey.toLowerCase() === 'properties') {
    return d => /*#__PURE__*/external_react_default().createElement(CustomPropertiesRenderer, {
      data: d
    });
  }
  return resolveDetailRenderer(column);
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/node/NodeDetailHeader.tsx



class DetailHeader extends external_react_.PureComponent {
  render() {
    const {
      children,
      header,
      iconSrc
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "lineage-detail-header margin-bottom"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "component-detail--child--img"
    }, /*#__PURE__*/external_react_default().createElement(SVGIcon, {
      theme: Theme.ORANGE,
      iconSrc: iconSrc,
      height: "50px",
      width: "50px"
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "text__truncate"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "lineage-name"
    }, /*#__PURE__*/external_react_default().createElement("h4", {
      className: "no-margin-top lineage-name-data"
    }, header)), /*#__PURE__*/external_react_default().createElement("div", {
      className: "small"
    }, children)));
  }
}
class NodeDetailHeader extends external_react_.PureComponent {
  render() {
    const {
      node,
      seed
    } = this.props;
    const {
      links,
      meta,
      name
    } = node;
    const lineageUrl = links.lineage;
    const isSeed = seed === node.lsid;
    const aliases = meta?.aliases;
    const description = meta?.description;
    const displayType = meta?.displayType;
    const header = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, lineageUrl && !isSeed && /*#__PURE__*/external_react_default().createElement("a", {
      href: lineageUrl
    }, name) || name, /*#__PURE__*/external_react_default().createElement("div", {
      className: "pull-right"
    }, /*#__PURE__*/external_react_default().createElement(LineageDataLink, {
      href: node.links.overview
    }, "Overview"), /*#__PURE__*/external_react_default().createElement(LineageDataLink, {
      href: lineageUrl
    }, "Lineage")));
    return /*#__PURE__*/external_react_default().createElement(DetailHeader, {
      header: header,
      iconSrc: node.iconProps.iconURL
    }, displayType && /*#__PURE__*/external_react_default().createElement("div", null, displayType), aliases && /*#__PURE__*/external_react_default().createElement("div", null, aliases.join(', ')), description && /*#__PURE__*/external_react_default().createElement("div", {
      title: description
    }, description));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/node/LineageNodeDetail.tsx
function LineageNodeDetail_extends() { return LineageNodeDetail_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, LineageNodeDetail_extends.apply(null, arguments); }
function LineageNodeDetail_defineProperty(e, r, t) { return (r = LineageNodeDetail_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LineageNodeDetail_toPropertyKey(t) { var i = LineageNodeDetail_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LineageNodeDetail_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2016-2020 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */











const LineageNodeDetail_initialState = {
  stepIdx: undefined,
  tabKey: 'details'
};
class LineageNodeDetail extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    LineageNodeDetail_defineProperty(this, "state", LineageNodeDetail_initialState);
    LineageNodeDetail_defineProperty(this, "changeTab", tabKey => {
      this.setState({
        tabKey
      });
    });
    LineageNodeDetail_defineProperty(this, "selectStep", stepIdx => {
      this.setState({
        stepIdx
      });
    });
  }
  componentDidUpdate(prevProps) {
    const prevNode = prevProps.node;
    const {
      node
    } = this.props;
    if ((prevNode.isRun || node.isRun) && prevNode.lsid !== node.lsid) {
      this.setState(LineageNodeDetail_initialState);
    }
  }
  render() {
    const {
      seed,
      node,
      highlightNode,
      lineageOptions
    } = this.props;
    const {
      stepIdx,
      tabKey
    } = this.state;
    if (node.isRun && stepIdx !== undefined) {
      return /*#__PURE__*/external_react_default().createElement(RunStepNodeDetail, {
        node: node,
        onBack: () => this.selectStep(undefined),
        stepIdx: stepIdx
      });
    }
    const nodeDetails = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(LineageDetail, {
      item: node
    }), /*#__PURE__*/external_react_default().createElement(LineageSummary, LineageNodeDetail_extends({}, lineageOptions, {
      containerPath: node.container,
      highlightNode: highlightNode,
      key: node.lsid,
      lsid: node.lsid,
      prefetchSeed: false
    })));
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "lineage-node-detail"
    }, /*#__PURE__*/external_react_default().createElement(NodeDetailHeader, {
      node: node,
      seed: seed
    }), node.isRun ? /*#__PURE__*/external_react_default().createElement(Tabs, {
      activeKey: tabKey,
      onSelect: this.changeTab
    }, /*#__PURE__*/external_react_default().createElement(Tab, {
      eventKey: "details",
      title: "Details"
    }, nodeDetails), /*#__PURE__*/external_react_default().createElement(Tab, {
      eventKey: "runProperties",
      title: "Run Properties"
    }, /*#__PURE__*/external_react_default().createElement(DetailsListSteps, {
      node: node,
      onSelect: this.selectStep
    }), /*#__PURE__*/external_react_default().createElement(DetailsListLineageIO, {
      item: node
    }))) : nodeDetails);
  }
}
class ClusterNodeDetail extends external_react_.PureComponent {
  static getGroupDisplayName(nodesByType, groupName, parentNodeName) {
    const group = nodesByType[groupName];
    const isAliquot = isAliquotNode(group);
    const aliquotDisplayName = (parentNodeName ? parentNodeName + ' ' : '') + 'Aliquots';
    return isAliquot ? aliquotDisplayName : group.displayType;
  }
  render() {
    const {
      highlightNode,
      nodes,
      options,
      parentNodeName
    } = this.props;
    const nodesByType = this.props.nodesByType ?? createLineageNodeCollections(nodes, options);
    const groups = Object.keys(nodesByType).sort();
    let iconURL;
    let title;
    if (groups.length === 1) {
      title = nodes.length + ' ' + ClusterNodeDetail.getGroupDisplayName(nodesByType, groups[0]);
      iconURL = nodes[0].iconProps.iconURL;
    } else {
      title = nodes.length + ' items of different types';
      iconURL = 'default';
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "cluster-node-detail"
    }, /*#__PURE__*/external_react_default().createElement(DetailHeader, {
      header: title,
      iconSrc: iconURL
    }), groups.map(groupName => {
      const groupDisplayName = ClusterNodeDetail.getGroupDisplayName(nodesByType, groupName, parentNodeName);
      return /*#__PURE__*/external_react_default().createElement(DetailsListNodes, {
        key: groupName,
        title: groupDisplayName,
        nodes: nodesByType[groupName],
        highlightNode: highlightNode
      });
    }));
  }
}
const RunStepNodeDetail = (0,external_react_.memo)(props => {
  const {
    node,
    onBack,
    stepIdx
  } = props;
  const [tabKey, setTabKey] = (0,external_react_.useState)('details');
  const step = node.steps.get(stepIdx);
  const stepName = step.protocol?.name || step.name;
  const hasProvenanceModule = (0,external_react_.useMemo)(() => hasModule('provenance'), []);
  const changeTab = (0,external_react_.useCallback)(newTabKey => {
    setTabKey(newTabKey);
  }, []);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "run-step-node-detail"
  }, /*#__PURE__*/external_react_default().createElement(DetailHeader, {
    header: `Run Step: ${stepName}`,
    iconSrc: "default"
  }, /*#__PURE__*/external_react_default().createElement("a", {
    className: "lineage-link",
    onClick: onBack
  }, /*#__PURE__*/external_react_default().createElement("span", null, "Back to Run Details")), /*#__PURE__*/external_react_default().createElement("span", {
    className: "spacer-left"
  }, ">"), /*#__PURE__*/external_react_default().createElement("span", {
    className: "spacer-left"
  }, stepName)), /*#__PURE__*/external_react_default().createElement(Tabs, {
    activeKey: tabKey,
    onSelect: changeTab
  }, /*#__PURE__*/external_react_default().createElement(Tab, {
    eventKey: "details",
    title: "Step Details"
  }, /*#__PURE__*/external_react_default().createElement(LineageDetail, {
    item: step
  }), /*#__PURE__*/external_react_default().createElement(DetailsListLineageIO, {
    item: step
  })), hasProvenanceModule && /*#__PURE__*/external_react_default().createElement(Tab, {
    eventKey: "provenanceMap",
    title: "Provenance Map",
    className: "lineage-run-step-provenance-map"
  }, /*#__PURE__*/external_react_default().createElement(RunStepProvenanceMap, {
    item: step
  }))));
});
const provenanceCellRenderer = (data, row) => {
  const name = data?.get('name');
  const url = data?.get('url');
  if (url) {
    return /*#__PURE__*/external_react_default().createElement("a", {
      href: url
    }, name);
  }
  return name;
};
const PROVENANCE_MAP_COLS = (0,external_immutable_.List)([new GridColumn({
  index: 'from',
  title: 'From',
  cell: provenanceCellRenderer
}), new GridColumn({
  index: 'to',
  title: 'To',
  cell: provenanceCellRenderer
})]);
const RunStepProvenanceMap = (0,external_react_.memo)(({
  item
}) => {
  return /*#__PURE__*/external_react_default().createElement(Grid, {
    columns: PROVENANCE_MAP_COLS,
    data: item?.provenanceMap ?? []
  });
});
;// CONCATENATED MODULE: ./src/internal/components/lineage/node/LineageNodeDetailFactory.tsx




class LineageNodeDetailFactory extends external_react_.PureComponent {
  render() {
    const {
      highlightNode,
      lineage,
      lineageOptions,
      selectedNodes
    } = this.props;
    if (!lineage || lineage.error) {
      return null;
    }
    if (!lineage.isLoaded()) {
      // Render selected node if seed has been pre-fetched
      if (lineage.isSeedLoaded()) {
        return /*#__PURE__*/external_react_default().createElement(LineageNodeDetail, {
          lineageOptions: lineageOptions,
          node: lineage.seedResult.nodes.get(lineage.seed),
          seed: lineage.seed
        });
      }
      return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
        msg: "Loading details..."
      });
    }
    if (!selectedNodes || selectedNodes.length === 0) {
      return /*#__PURE__*/external_react_default().createElement("em", null, "Select a node from the graph to view the details.");
    }
    if (selectedNodes.length === 1) {
      const node = selectedNodes[0];
      if (isBasicNode(node)) {
        return /*#__PURE__*/external_react_default().createElement(LineageNodeDetail, {
          highlightNode: highlightNode,
          lineageOptions: lineageOptions,
          node: node.lineageNode,
          seed: lineage.seed
        });
      } else if (isCombinedNode(node)) {
        return /*#__PURE__*/external_react_default().createElement(ClusterNodeDetail, {
          highlightNode: highlightNode,
          nodes: node.containedNodes,
          nodesByType: node.containedNodesByType,
          options: lineageOptions,
          parentNodeName: node.parentNodeName
        });
      } else if (isClusterNode(node)) {
        return /*#__PURE__*/external_react_default().createElement(ClusterNodeDetail, {
          highlightNode: highlightNode
          // LineageNodes in cluster
          ,
          nodes: node.nodesInCluster.map(n => n.kind === 'node' && n.lineageNode),
          options: lineageOptions
        });
      }
      throw new Error('unknown node kind');
    }
    return /*#__PURE__*/external_react_default().createElement("div", null, "Multiple selected nodes");
  }
}
;// CONCATENATED MODULE: ./src/internal/components/lineage/LineageSettings.tsx
const LineageSettings_excluded = ["onSettingsChange", "options"];
function LineageSettings_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function LineageSettings_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? LineageSettings_ownKeys(Object(t), !0).forEach(function (r) { LineageSettings_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : LineageSettings_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function LineageSettings_defineProperty(e, r, t) { return (r = LineageSettings_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LineageSettings_toPropertyKey(t) { var i = LineageSettings_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LineageSettings_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function LineageSettings_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = LineageSettings_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function LineageSettings_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }





const LineageSettings = (0,external_react_.memo)(props => {
  const {
    onSettingsChange
  } = props;
  const [options, setOptions] = (0,external_react_.useState)(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-shadow
    const {
        onSettingsChange,
        options
      } = props,
      optionProps = LineageSettings_objectWithoutProperties(props, LineageSettings_excluded);
    if (options) return options;
    return LineageSettings_objectSpread(LineageSettings_objectSpread({}, optionProps), {}, {
      originalFilters: optionProps.filters ? [...optionProps.filters] : []
    });
  });
  const generations = (0,external_react_.useMemo)(() => {
    const generations_ = [];
    // eslint-disable-next-line guard-for-in
    for (const value in LINEAGE_GROUPING_GENERATIONS) {
      generations_.push({
        label: value,
        value: LINEAGE_GROUPING_GENERATIONS[value]
      });
    }
    return generations_;
  }, []);
  const changeRef = (0,external_react_.useRef)(undefined);
  const applyOptions = (0,external_react_.useCallback)(cb => {
    const options_ = cb(options);
    setOptions(options_);
    if (changeRef.current !== undefined) {
      clearTimeout(changeRef.current);
      changeRef.current = undefined;
    }

    // Debounce here for user input to skip possibly costly graph renders
    changeRef.current = setTimeout(() => {
      onSettingsChange(options_);
    }, 500);
  }, [onSettingsChange, options]);
  const onDepthChange = (0,external_react_.useCallback)(evt => {
    const {
      name,
      value
    } = evt.target;
    const nValue = parseInt(value, 10);
    applyOptions(options_ => LineageSettings_objectSpread(LineageSettings_objectSpread({}, options_), {}, {
      grouping: LineageSettings_objectSpread(LineageSettings_objectSpread({}, options_.grouping), {}, {
        [name]: nValue
      })
    }));
  }, [applyOptions]);
  const onFilterChange = (0,external_react_.useCallback)(evt => {
    const {
      checked,
      name
    } = evt.target;
    applyOptions(options_ => {
      const {
        originalFilters
      } = options_;
      let {
        filters
      } = options_;
      if (checked) {
        if (!filters.find(f => f.field === name)) {
          const filter = originalFilters.find(f => f.field === name);
          if (filter) {
            filters.push(filter);
          }
        }
      } else {
        filters = filters.filter(f => f.field !== name);
      }
      return LineageSettings_objectSpread(LineageSettings_objectSpread({}, options_), {}, {
        filters
      });
    });
  }, [applyOptions]);
  const onGenerationChange = (0,external_react_.useCallback)((name, value) => {
    applyOptions(options_ => LineageSettings_objectSpread(LineageSettings_objectSpread({}, options_), {}, {
      grouping: LineageSettings_objectSpread(LineageSettings_objectSpread({}, options_.grouping), {}, {
        generations: value
      })
    }));
  }, [applyOptions]);
  const onGroupingChange = (0,external_react_.useCallback)(evt => {
    const {
      name,
      value
    } = evt.target;
    const nValue = parseInt(value, 10);
    if (GROUPING_COMBINED_SIZE_MIN < nValue) {
      applyOptions(options_ => LineageSettings_objectSpread(LineageSettings_objectSpread({}, options_), {}, {
        grouping: LineageSettings_objectSpread(LineageSettings_objectSpread({}, options_.grouping), {}, {
          [name]: nValue
        })
      }));
    }
  }, [applyOptions]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings-heading"
  }, "Graph Options"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings__section"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings__section-header"
  }, "Grouping"), /*#__PURE__*/external_react_default().createElement("label", null, "Generations", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    placement: "top",
    title: "Generations"
  }, /*#__PURE__*/external_react_default().createElement("ul", {
    className: "lineage-settings__tip-list"
  }, /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("b", null, "All"), " - Include all nodes from the seed available in the lineage response."), /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("b", null, "Multi"), " - Include all nodes from the seed until a depth is found that contains multiple nodes."), /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("b", null, "Nearest"), " - Include only the immediately connected nodes from the seed."), /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("b", null, "Specific"), " - Include all nodes from the seed up to the \"Parent Generations\" or \"Child Generations\" specified.")))), /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    clearable: false,
    name: "generations",
    onChange: onGenerationChange,
    options: generations,
    value: options.grouping?.generations ?? DEFAULT_GROUPING_OPTIONS.generations
  }), /*#__PURE__*/external_react_default().createElement("label", null, "Child Generations", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    placement: "top",
    title: "Child Generations"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings__tip-body"
  }, "The number of descendant generations to render from the seed node. Only applies when Generations is set to \"Specific\".", /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("b", null, "Note:"), " This does not affect the number of generations requested from the server.")))), /*#__PURE__*/external_react_default().createElement("input", {
    defaultValue: options.grouping?.childDepth ?? DEFAULT_GROUPING_OPTIONS.childDepth,
    className: "form-control",
    max: DEFAULT_GROUPING_OPTIONS.childDepth * 2,
    min: 0,
    name: "childDepth",
    onChange: onDepthChange,
    type: "number"
  }), /*#__PURE__*/external_react_default().createElement("label", null, "Parent Generations", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    placement: "top",
    title: "Parent Generations"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings__tip-body"
  }, "The number of ancestor generations to render from the seed node. Only applies when Generations is set to \"Specific\".", /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("b", null, "Note:"), " This does not affect the number of generations requested from the server.")))), /*#__PURE__*/external_react_default().createElement("input", {
    defaultValue: options.grouping?.parentDepth ?? DEFAULT_GROUPING_OPTIONS.parentDepth,
    className: "form-control",
    max: DEFAULT_GROUPING_OPTIONS.parentDepth * 2,
    min: 0,
    name: "parentDepth",
    onChange: onDepthChange,
    type: "number"
  }), /*#__PURE__*/external_react_default().createElement("label", null, "Combine Generation Threshold", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    placement: "top",
    title: "Combine Generation Threshold"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings__tip-body"
  }, "If the number of nodes in a generation is greater than or equal to this threshold, then all the nodes in this generation will be combined into a single node. Minimum value of", ' ', GROUPING_COMBINED_SIZE_MIN, ".", /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("b", null, "Note:"), " Aliquots are combined separately and may appear as a single combined node.")))), /*#__PURE__*/external_react_default().createElement("input", {
    defaultValue: options.grouping?.combineSize ?? DEFAULT_GROUPING_OPTIONS.combineSize,
    className: "form-control",
    min: GROUPING_COMBINED_SIZE_MIN,
    name: "combineSize",
    onChange: onGroupingChange,
    type: "number"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings__section"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings__section-header"
  }, "Filters", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    placement: "top",
    title: "Filters"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "lineage-settings__tip-body"
  }, "Some lineage views provide default filters specified by the application. Toggle filters to change which nodes are displayed in the graph."))), options.originalFilters.map(filter => /*#__PURE__*/external_react_default().createElement("div", {
    key: filter.field
  }, /*#__PURE__*/external_react_default().createElement("input", {
    defaultChecked: true,
    onChange: onFilterChange,
    name: filter.field,
    type: "checkbox"
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "lineage-settings__filter-label"
  }, filter.field, " = ", filter.value.join(' OR '))))));
});
LineageSettings.displayName = 'LineageSettings';
;// CONCATENATED MODULE: ./src/internal/components/lineage/LineageGraph.tsx
function LineageGraph_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function LineageGraph_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? LineageGraph_ownKeys(Object(t), !0).forEach(function (r) { LineageGraph_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : LineageGraph_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function LineageGraph_extends() { return LineageGraph_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, LineageGraph_extends.apply(null, arguments); }
function LineageGraph_defineProperty(e, r, t) { return (r = LineageGraph_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LineageGraph_toPropertyKey(t) { var i = LineageGraph_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LineageGraph_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2016-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */











class LineageGraphDisplay extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    LineageGraph_defineProperty(this, "visGraphRef", external_react_default().createRef());
    LineageGraph_defineProperty(this, "clearHover", () => {
      this.updateHover(undefined);
    });
    // if the node is in the graph, it is clickable in the summary panel
    LineageGraph_defineProperty(this, "isNodeInGraph", item => {
      return this.visGraphRef.current?.getNetwork().findNode(item.lsid).length > 0;
    });
    LineageGraph_defineProperty(this, "onSummaryNodeClick", item => {
      this.onSummaryNodeMouseOut(item);
      this.visGraphRef.current?.selectNodes([item.lsid]);
    });
    LineageGraph_defineProperty(this, "onSummaryNodeMouseEvent", (item, hover) => {
      // clear the hoverNode so the popover will hide
      this.clearHover();
      this.visGraphRef.current?.highlightNode(item.lsid, hover);
    });
    LineageGraph_defineProperty(this, "onSummaryNodeMouseOut", item => {
      this.onSummaryNodeMouseEvent(item, false);
    });
    LineageGraph_defineProperty(this, "onSummaryNodeMouseOver", item => {
      this.onSummaryNodeMouseEvent(item, true);
    });
    LineageGraph_defineProperty(this, "onVisGraphNodeDoubleClick", visNode => {
      this.props.navigate?.(visNode);
    });
    LineageGraph_defineProperty(this, "onNodeSelectionChange", selectedNodes => {
      this.setState({
        selectedNodes
      });
    });
    LineageGraph_defineProperty(this, "onOptionsChange", options => {
      this.props.setOptions?.(options);
    });
    LineageGraph_defineProperty(this, "onToggleSettings", () => {
      this.setState(state => ({
        showSettings: !state.showSettings
      }));
    });
    LineageGraph_defineProperty(this, "updateHover", node => {
      let hoverNode;
      if (node) {
        hoverNode = isBasicNode(node) && node.lineageNode && node.lineageNode.lsid;
      }
      this.setState({
        hoverNode
      });
    });
    this.state = {
      nodeInteractions: {
        isNodeInGraph: this.isNodeInGraph,
        onNodeMouseOver: this.onSummaryNodeMouseOver,
        onNodeMouseOut: this.onSummaryNodeMouseOut,
        onNodeClick: this.onSummaryNodeClick
      },
      showSettings: false
    };
  }
  get allowSettings() {
    return !!api_.ActionURL.getParameter('lineageSettings');
  }
  render() {
    const {
      lineage,
      lsid,
      options,
      visGraphOptions
    } = this.props;
    const {
      hoverNode,
      selectedNodes,
      showSettings
    } = this.state;
    if (lineage?.error) {
      return /*#__PURE__*/external_react_default().createElement(Alert, null, lineage.error);
    }
    return /*#__PURE__*/external_react_default().createElement(NodeInteractionProvider, {
      value: this.state.nodeInteractions
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-8"
    }, lineage?.isLoaded() ? /*#__PURE__*/external_react_default().createElement(VisGraph, {
      ref: this.visGraphRef,
      onNodeDoubleClick: this.onVisGraphNodeDoubleClick,
      onNodeSelect: this.onNodeSelectionChange,
      onNodeDeselect: this.onNodeSelectionChange,
      onNodeHover: this.updateHover,
      onNodeBlur: this.clearHover,
      onToggleSettings: this.allowSettings ? this.onToggleSettings : undefined,
      options: visGraphOptions,
      seed: lsid
    }) : /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
      msg: "Loading lineage..."
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-4 lineage-node-detail-container"
    }, !showSettings && /*#__PURE__*/external_react_default().createElement(LineageNodeDetailFactory, {
      highlightNode: hoverNode,
      lineage: lineage,
      lineageOptions: this.props,
      selectedNodes: selectedNodes
    }), showSettings && /*#__PURE__*/external_react_default().createElement(LineageSettings, LineageGraph_extends({}, this.props, {
      options: options,
      onSettingsChange: this.onOptionsChange
    })))));
  }
}
const LineageGraph = withLineage(props => {
  const [options, setOptions] = (0,external_react_.useState)();

  // Optimization: This FunctionComponent allows for "generateGraph" to only be called
  // when the lineage is updated. If it is called in the render loop of <LineageGraphDisplay/>
  // it is run each time a user interacts with the graph (e.g. hovers a node, clicks a node, etc).
  if (props.lineage?.error) {
    return /*#__PURE__*/external_react_default().createElement(Alert, null, props.lineage.error);
  }
  return /*#__PURE__*/external_react_default().createElement(LineageGraphDisplay, LineageGraph_extends({}, props, {
    options: options,
    setOptions: setOptions,
    visGraphOptions: props.lineage?.generateGraph(LineageGraph_objectSpread(LineageGraph_objectSpread({}, props), options))
  }));
});
const LineageDepthLimitMessage = (0,external_react_.memo)(props => {
  const {
    className,
    maxDistance,
    isRoot,
    nodeName
  } = props;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className
  }, "Note: Showing a maximum of ", maxDistance, " generations", isRoot ? '' : ' from ' + nodeName, ".");
});
LineageDepthLimitMessage.defaultProps = {
  className: 'lineage-graph-generation-limit-msg',
  maxDistance: DEFAULT_LINEAGE_DISTANCE,
  nodeName: 'the seed node'
};
;// CONCATENATED MODULE: ./src/internal/components/lineage/SampleTypeLineageCounts.tsx
function SampleTypeLineageCounts_defineProperty(e, r, t) { return (r = SampleTypeLineageCounts_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SampleTypeLineageCounts_toPropertyKey(t) { var i = SampleTypeLineageCounts_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SampleTypeLineageCounts_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2016-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */





class CountsWithLineageImpl extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    SampleTypeLineageCounts_defineProperty(this, "columns", (0,external_immutable_.List)([new GridColumn({
      index: 'name',
      title: 'Sample Type'
    }), new GridColumn({
      index: 'sampleCount',
      title: 'Number of Samples'
    }), new GridColumn({
      index: 'modified',
      title: 'Most Recent (Date)'
    })]));
  }
  render() {
    const {
      lineage
    } = this.props;
    const data = lineage?.sampleStats?.filter(stats => stats.getIn(['sampleCount', 'value']) > 0).toList();
    return /*#__PURE__*/external_react_default().createElement(Grid, {
      columns: this.columns,
      data: data,
      emptyText: lineage?.error ?? 'No derived samples',
      isLoading: !lineage?.isLoaded()
    });
  }
}
const CountsWithLineage = withLineage(CountsWithLineageImpl, false, true, false);

// Don't expose props from withLineage in public component
const SampleTypeLineageCounts = props => {
  return /*#__PURE__*/external_react_default().createElement(CountsWithLineage, {
    lsid: props.seed
  });
};
;// CONCATENATED MODULE: ./src/internal/useNavMenuState.ts

/**
 * Hook used to manage state and refs for our various navigation menus (ProductMenu, ProductNavigationMenu,
 * ServerNotifications)
 */
function useNavMenuState() {
  const [show, setShow] = (0,external_react_.useState)(false);
  const toggleRef = (0,external_react_.useRef)();
  const menuRef = (0,external_react_.useRef)();
  const onDocumentClick = (0,external_react_.useCallback)(event => {
    // Don't take action if we're clicking the toggle, as that handles open/close on its own, and we can't use
    // preventDocumentHandler in the toggle onClick, or we'll keep the menu open if the user clicks another menu.
    if (event.target === toggleRef.current) return;

    // Don't take action if we've clicked anything inside the menu. We have to be defensive about the existence of
    // menuRef because of how React handles events, our onClick handler above will get called before this document
    // handler, so menuRef.current may be null.
    if (!menuRef.current?.contains(event.target)) setShow(false);
  }, []);
  (0,external_react_.useEffect)(() => {
    // We only want to listen for clicks on the document if the menu is open
    if (show) {
      document.addEventListener('click', onDocumentClick);
    }

    // Prevent scrolling the body when a navigation menu is shown
    document.body.classList.toggle('no-scroll', show);
    return () => {
      document.removeEventListener('click', onDocumentClick);
    };
  }, [show, onDocumentClick]);
  return {
    show,
    setShow,
    toggleRef,
    menuRef
  };
}
;// CONCATENATED MODULE: ./src/internal/components/notifications/ServerActivityList.tsx
function ServerActivityList_defineProperty(e, r, t) { return (r = ServerActivityList_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ServerActivityList_toPropertyKey(t) { var i = ServerActivityList_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ServerActivityList_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








class ServerActivityList extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    ServerActivityList_defineProperty(this, "markRead", notificationId => {
      this.props.onRead(notificationId);
    });
    ServerActivityList_defineProperty(this, "renderNotificationContent", (content, isHtml, isError, isInProgress) => {
      const newlineIndex = content.toLowerCase().indexOf('\n');
      const brIndex = content.toLowerCase().indexOf('<br>');
      let subject, details;
      if (newlineIndex > 0 || brIndex > 0) {
        if (newlineIndex > 0) {
          subject = content.substr(0, newlineIndex);
          details = content.substring(newlineIndex + 1, content.length);
        } else {
          subject = content.substr(0, brIndex);
          details = content.substring(brIndex + 4, content.length);
        }
        const detailsDisplay = isError ? resolveErrorMessage(details) : details;
        return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, this.renderContent(subject, 'server-notifications-item-subject', isHtml), detailsDisplay && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("br", null), this.renderContent(detailsDisplay, 'server-notifications-item-details', isHtml)));
      } else if (isInProgress) {
        return this.renderContent(`A background import is processing: ${content}`, 'server-notifications-item-subject', isHtml);
      }
      return this.renderContent(content, 'server-notifications-item-subject', isHtml);
    });
    ServerActivityList_defineProperty(this, "renderContent", (content, clsName, isHtml) => {
      if (isHtml) return /*#__PURE__*/external_react_default().createElement("span", {
        className: clsName,
        dangerouslySetInnerHTML: {
          __html: content
        }
      });
      return /*#__PURE__*/external_react_default().createElement("span", {
        className: clsName
      }, content);
    });
  }
  renderData(activity, key) {
    const {
      actionLinkLabel,
      onViewClick
    } = this.props;
    const isUnread = activity.isUnread() && !activity.inProgress;
    const resolvedUrl = PIPELINE_MAPPER.resolve(activity.ActionLinkUrl, (0,external_immutable_.Map)({
      rowId: activity.RowId,
      url: activity.ActionLinkUrl
    }), undefined, undefined, undefined);
    return /*#__PURE__*/external_react_default().createElement("li", {
      key: key,
      className: isUnread ? 'is-unread' : undefined,
      onClick: isUnread ? () => this.markRead(activity.RowId) : undefined
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: external_classnames_default()('fa', {
        'fa-spinner fa-pulse': activity.inProgress,
        'fa-exclamation-circle has-error': activity.hasError,
        'fa-check-circle is-complete': !activity.inProgress && !activity.hasError
      })
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: external_classnames_default()('server-notification-message', {
        'is-unread server-notifications-item': isUnread
      })
    }, this.renderNotificationContent(activity.Content, activity.isHTML(), activity.hasError, activity.inProgress)), /*#__PURE__*/external_react_default().createElement("br", null), activity.ActionLinkUrl ? /*#__PURE__*/external_react_default().createElement("span", {
      className: "server-notifications-link"
    }, /*#__PURE__*/external_react_default().createElement("a", {
      href: resolvedUrl instanceof AppURL ? resolvedUrl.toHref() : activity.ActionLinkUrl,
      onClick: onViewClick
    }, capitalizeFirstChar(activity.ActionLinkText ? activity.ActionLinkText : actionLinkLabel))) : /*#__PURE__*/external_react_default().createElement("span", {
      className: "server-notification-data",
      title: activity.CreatedBy
    }, activity.CreatedBy), /*#__PURE__*/external_react_default().createElement("div", {
      className: "pull-right server-notification-data"
    }, formatDateTime(parseDate(activity.Created))));
  }
  render() {
    const {
      serverActivity,
      onViewAll,
      maxRows,
      noActivityMsg,
      viewAllText
    } = this.props;
    if (!serverActivity || serverActivity.totalRows === 0) {
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "server-notifications-footer"
      }, noActivityMsg);
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "server-notifications-listing-container"
    }, /*#__PURE__*/external_react_default().createElement("ul", {
      className: "server-notifications-listing"
    }, serverActivity.data.slice(0, maxRows).map((data, index) => this.renderData(data, index)))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "server-notifications-footer server-notifications-link",
      onClick: onViewAll
    }, viewAllText));
  }
}
ServerActivityList_defineProperty(ServerActivityList, "defaultProps", {
  maxRows: 8,
  viewAllText: 'View all activity',
  noActivityMsg: 'No notifications available.',
  actionLinkLabel: 'View details'
});
;// CONCATENATED MODULE: ./src/internal/components/notifications/ServerNotifications.tsx






const ServerNotifications = props => {
  const {
    markAllNotificationsRead,
    maxRows,
    onRead,
    serverActivity
  } = props;
  const {
    show,
    setShow,
    menuRef,
    toggleRef
  } = useNavMenuState();
  const toggleMenu = (0,external_react_.useCallback)(() => setShow(s => !s), []);
  const onRead_ = (0,external_react_.useCallback)(async id => {
    try {
      await markNotificationsAsRead([id]);
      onRead?.();
    } catch (e) {
      console.error('Unable to mark notification ' + id + ' as read');
    }
  }, [props.onRead]);
  const markAllRead = (0,external_react_.useCallback)(async () => {
    try {
      await markAllNotificationsRead();
      onRead?.();
    } catch (e) {
      console.error('Unable to mark all notifications as read');
    }
  }, [markAllNotificationsRead, props]);
  const unreadCount = (0,external_react_.useMemo)(() => {
    if (!serverActivity || !serverActivity.isLoaded) return 0;
    return serverActivity.unreadCount;
  }, [serverActivity]);
  const hasAnyInProgress = serverActivity?.inProgressCount > 0;
  const onViewAll = (0,external_react_.useCallback)(() => {
    toggleMenu();
    props.onViewAll();
  }, [props.onViewAll, toggleMenu]);
  let body;
  if (serverActivity?.isError) {
    body = /*#__PURE__*/external_react_default().createElement("div", {
      className: "server-notifications-footer server-notifications-error"
    }, serverActivity.errorMessage);
  } else if (!serverActivity || !serverActivity.isLoaded) {
    body = /*#__PURE__*/external_react_default().createElement("div", {
      className: "server-notifications-footer"
    }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null));
  } else {
    body = /*#__PURE__*/external_react_default().createElement(ServerActivityList, {
      maxRows: maxRows,
      serverActivity: serverActivity,
      onViewAll: onViewAll,
      onViewClick: toggleMenu,
      onRead: onRead_
    });
  }
  const iconClassName = external_classnames_default()('navbar-header-icon', 'fa', {
    'fa-spinner fa-pulse': hasAnyInProgress,
    'fa-bell': !hasAnyInProgress
  });
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-item pull-right server-notifications navbar-menu"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    "aria-haspopup": "true",
    "aria-expanded": show,
    className: "navbar-menu-button",
    onClick: toggleMenu,
    ref: toggleRef,
    role: "button",
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: iconClassName
  }), unreadCount > 0 && /*#__PURE__*/external_react_default().createElement("span", {
    className: "badge"
  }, unreadCount)), show && /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-menu__content",
    ref: menuRef
  }, /*#__PURE__*/external_react_default().createElement("h3", {
    className: "navbar-menu-header"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: 'navbar-icon-connector' + (unreadCount > 0 ? ' has-unread' : '')
  }), "Notifications", unreadCount > 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "pull-right server-notifications-link",
    onClick: markAllRead
  }, "Mark all as read")), body));
};
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/models.ts
function productnavigation_models_defineProperty(e, r, t) { return (r = productnavigation_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function productnavigation_models_toPropertyKey(t) { var i = productnavigation_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function productnavigation_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class ProductModel {
  constructor(values) {
    productnavigation_models_defineProperty(this, external_immer_.immerable, true);
    productnavigation_models_defineProperty(this, "moduleName", void 0);
    productnavigation_models_defineProperty(this, "sectionNames", void 0);
    productnavigation_models_defineProperty(this, "documentationUrl", void 0);
    productnavigation_models_defineProperty(this, "productId", void 0);
    productnavigation_models_defineProperty(this, "productName", void 0);
    productnavigation_models_defineProperty(this, "documentationLabel", void 0);
    productnavigation_models_defineProperty(this, "disabled", void 0);
    Object.assign(this, values, {
      disabled: !isProductNavigationEnabled(values?.productId)
    });
  }
  get navigationMetric() {
    if (this.productId === SAMPLE_MANAGER_APP_PROPERTIES.productId) {
      return SAMPLE_MANAGER_SECTION_METRIC;
    } else if (this.productId === BIOLOGICS_APP_PROPERTIES.productId) {
      return BIOLOGICS_SECTION_METRIC;
    } else {
      return APPLICATION_SECTION_METRIC;
    }
  }
}
class ProductSectionModel {
  constructor(values) {
    productnavigation_models_defineProperty(this, external_immer_.immerable, true);
    productnavigation_models_defineProperty(this, "key", void 0);
    productnavigation_models_defineProperty(this, "label", void 0);
    productnavigation_models_defineProperty(this, "url", void 0);
    Object.assign(this, values);
  }
}
class ContainerTabModel {
  constructor(values) {
    productnavigation_models_defineProperty(this, external_immer_.immerable, true);
    productnavigation_models_defineProperty(this, "id", void 0);
    productnavigation_models_defineProperty(this, "text", void 0);
    productnavigation_models_defineProperty(this, "href", void 0);
    productnavigation_models_defineProperty(this, "disabled", void 0);
    Object.assign(this, values);
  }
}
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/actions.ts



function getRegisteredProducts() {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('product', 'getRegisteredProducts.api'),
      method: 'POST',
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response.map(data => new ProductModel(data)));
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(resolveErrorMessage(response));
      })
    });
  });
}
function getContainerTabs() {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('admin', 'getFolderTabs.api'),
      method: 'POST',
      success: api_.Utils.getCallbackWrapper(response => {
        resolve(response.map(data => new ContainerTabModel(data)));
      }),
      failure: api_.Utils.getCallbackWrapper(response => {
        console.error(response);
        reject(resolveErrorMessage(response));
      })
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/ProductAppMenuItem.tsx


const ProductAppMenuItem = (0,external_react_.memo)(props => {
  const {
    iconUrl,
    iconUrlAlt,
    title,
    subtitle,
    onClick,
    disabled,
    productId
  } = props;
  const [hovered, setHovered] = (0,external_react_.useState)(false);
  const onEnter = (0,external_react_.useCallback)(() => setHovered(true), [setHovered]);
  const onLeave = (0,external_react_.useCallback)(() => setHovered(false), [setHovered]);
  const onClick_ = (0,external_react_.useCallback)(event => {
    // stopImmediatePropagation in order to prevent the document click handler from closing the menu
    event.nativeEvent.stopImmediatePropagation();
    onClick(productId);
  }, [onClick, productId]);
  return /*#__PURE__*/external_react_default().createElement("li", {
    className: external_classnames_default()({
      'labkey-page-nav': hovered && !disabled,
      'labkey-page-nav-disabled': disabled
    }),
    onClick: disabled ? undefined : onClick_,
    onMouseEnter: onEnter,
    onMouseLeave: onLeave
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "product-icon"
  }, /*#__PURE__*/external_react_default().createElement("img", {
    src: iconUrl,
    alt: "Product icon",
    className: "icon-primary",
    height: "40px",
    width: "40px"
  }), /*#__PURE__*/external_react_default().createElement("img", {
    src: iconUrlAlt ?? iconUrl,
    alt: "Alt Product icon",
    className: "icon-alt",
    height: "40px",
    width: "40px"
  })), !disabled && /*#__PURE__*/external_react_default().createElement("div", {
    className: "nav-icon"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-chevron-right"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('product-title', {
      'no-subtitle': subtitle === undefined
    })
  }, title), /*#__PURE__*/external_react_default().createElement("div", {
    className: "product-subtitle"
  }, subtitle));
});
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/ProductAppsDrawer.tsx






const ProductAppsDrawer_DEFAULT_ICON_URL = imageURL('_images', 'mobile-logo-seattle.svg');
const DEFAULT_ICON_ALT_URL = imageURL('_images', 'mobile-logo-overcast.svg');
const ProductAppsDrawer = (0,external_react_.memo)(props => {
  const {
    products,
    onClick
  } = props;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(ProductAppMenuItem, {
    key: LKS_PRODUCT_ID,
    iconUrl: ProductAppsDrawer_DEFAULT_ICON_URL,
    iconUrlAlt: DEFAULT_ICON_ALT_URL,
    productId: LKS_PRODUCT_ID,
    title: "LabKey Server",
    subtitle: (0,api_.getServerContext)().project?.title ?? 'Root',
    onClick: onClick
  }), products.map(product => {
    const imgSrc = PRODUCT_ID_IMG_SRC_MAP[product.productId.toLowerCase()];
    let iconUrl = imgSrc?.iconUrl ?? ProductAppsDrawer_DEFAULT_ICON_URL;
    let iconUrlAlt = imgSrc?.iconUrlAlt ?? DEFAULT_ICON_ALT_URL;
    if (product.disabled) {
      iconUrl = imgSrc?.iconUrlDisabled ?? ProductAppsDrawer_DEFAULT_ICON_URL;
      iconUrlAlt = imgSrc?.iconUrlDisabled ?? ProductAppsDrawer_DEFAULT_ICON_URL;
    }
    return /*#__PURE__*/external_react_default().createElement(ProductAppMenuItem, {
      key: product.productId,
      disabled: product.disabled,
      iconUrl: iconUrl,
      iconUrlAlt: iconUrlAlt,
      productId: product.productId,
      title: product.productName,
      subtitle: product.disabled ? 'Application not enabled in this location' : undefined,
      onClick: onClick
    });
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/ProductClickableItem.tsx

const ProductClickableItem = (0,external_react_.memo)(props => {
  const {
    id,
    onClick,
    children,
    href
  } = props;
  const [hovered, setHovered] = (0,external_react_.useState)(false);
  const onEnter = (0,external_react_.useCallback)(() => setHovered(true), [setHovered]);
  const onLeave = (0,external_react_.useCallback)(() => setHovered(false), [setHovered]);
  return /*#__PURE__*/external_react_default().createElement("a", {
    href: href,
    key: id,
    className: 'clickable-item' + (hovered ? ' labkey-page-nav' : ''),
    onClick: onClick,
    onMouseEnter: onEnter,
    onMouseLeave: onLeave
  }, children);
});
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/ProductSectionsDrawer.tsx
function ProductSectionsDrawer_extends() { return ProductSectionsDrawer_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ProductSectionsDrawer_extends.apply(null, arguments); }











const ProductSectionsDrawer = (0,external_react_.memo)(props => {
  const {
    product
  } = props;
  const currentContainer = (0,api_.getServerContext)().container;
  const [error, setError] = (0,external_react_.useState)();
  const [sections, setSections] = (0,external_react_.useState)();
  const productIds = (0,external_react_.useMemo)(() => {
    return getAppProductIds(product.productId);
  }, [product.productId]);
  (0,external_react_.useEffect)(() => {
    const model = new ProductMenuModel({
      currentProductId: product.productId,
      productIds
    });
    model.getMenuSections().then(modelSections => {
      setSections(parseProductMenuSectionResponse(modelSections, product, currentContainer.path));
    }).catch(error => {
      setError('Error: unable to load product sections.');
    });
  }, [product]);
  return /*#__PURE__*/external_react_default().createElement(ProductSectionsDrawerImpl, ProductSectionsDrawer_extends({}, props, {
    error: error,
    sections: sections
  }));
});
ProductSectionsDrawer.defaultProps = {
  api: getDefaultAPIWrapper()
};
// exported for jest testing
const ProductSectionsDrawerImpl = (0,external_react_.memo)(props => {
  const {
    api,
    sections,
    error,
    onCloseMenu,
    product
  } = props;
  const [transition, setTransition] = (0,external_react_.useState)(true);
  (0,external_react_.useEffect)(() => {
    // use setTimeout so that the "left" property will change and trigger the transition
    setTimeout(() => setTransition(false), 10);
  }, []);
  const navigate = (0,external_react_.useCallback)(section => {
    api.query.incrementClientSideMetricCount(APPLICATION_NAVIGATION_METRIC, product.navigationMetric);
    onCloseMenu?.();
  }, []);
  if (error) {
    return /*#__PURE__*/external_react_default().createElement(Alert, {
      className: "error-item"
    }, error);
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: 'menu-transition-left' + (transition ? ' transition' : '')
  }, sections?.map(section => {
    return /*#__PURE__*/external_react_default().createElement(ProductClickableItem, {
      href: section.url.toString(),
      key: section.key,
      id: section.key,
      onClick: () => navigate(section)
    }, section.label);
  }));
});

// function below are exported for jest testing

function getProductSectionUrl(productId, key, containerPath) {
  // if the section is for the same product we are already in, then keep the urls as route changes
  if (productId.toLowerCase() === api_.ActionURL.getController().toLowerCase()) {
    return AppURL.create(key).toHref();
  }
  return createProductUrl(productId, undefined, AppURL.create(key), containerPath).toString();
}
function parseProductMenuSectionResponse(modelSections, product, projectPath) {
  const menuSections = [new ProductSectionModel({
    key: 'home',
    label: 'Dashboard',
    url: getProductSectionUrl(product.productId, 'home', projectPath)
  })];
  modelSections.filter(modelSection => SECTION_KEYS_TO_SKIP.indexOf(modelSection.key) === -1).forEach(modelSection => {
    menuSections.push(new ProductSectionModel({
      key: modelSection.key,
      label: modelSection.label,
      url: getProductSectionUrl(modelSection.productId, modelSection.key, projectPath)
    }));
  });

  // special case to sort storage before workflow, media, and notebooks to match the mega menu display for LKSM and LKB
  return menuSections.sort((a, b) => {
    if (a.key === FREEZERS_KEY && (b.key === WORKFLOW_KEY || b.key === MEDIA_KEY || b.key === NOTEBOOKS_KEY)) {
      return -1;
    }
    return 0;
  });
}
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/ProductLKSDrawer.tsx







const ProductLKSDrawer = (0,external_react_.memo)(props => {
  const {
    tabs,
    disableLKSContainerLink,
    showHome,
    api
  } = props;
  const {
    container,
    homeContainer,
    user
  } = (0,api_.getServerContext)();
  const isHomeContainer = (0,external_react_.useMemo)(() => container.path === '/home', [container]);
  const [transition, setTransition] = (0,external_react_.useState)(true);
  (0,external_react_.useEffect)(() => {
    // use setTimeout so that the "left" property will change and trigger the transition
    setTimeout(() => setTransition(false), 10);
  }, []);
  const onTabClick = (0,external_react_.useCallback)(() => {
    api.query.incrementClientSideMetricCount(APPLICATION_NAVIGATION_METRIC, TO_LKS_TAB_METRIC);
  }, []);
  const visibleTabs = tabs.filter(tab => !tab.disabled);
  const onHomeClick = (0,external_react_.useCallback)(() => {
    api.query.incrementClientSideMetricCount(APPLICATION_NAVIGATION_METRIC, TO_LKS_HOME_METRIC);
  }, []);
  const onContainerClick = (0,external_react_.useCallback)(() => {
    api.query.incrementClientSideMetricCount(APPLICATION_NAVIGATION_METRIC, TO_LKS_CONTAINER_METRIC);
  }, []);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: 'menu-transition-left' + (transition ? ' transition' : '')
  }, showHome && /*#__PURE__*/external_react_default().createElement("a", {
    className: external_classnames_default()('container-item ', {
      'lk-text-theme-dark': !isHomeContainer,
      clickable: !isHomeContainer
    }),
    onClick: !isHomeContainer ? onHomeClick : undefined,
    href: getProjectBeginUrl(homeContainer)
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-home container-icon"
  }), "LabKey Home"), !isHomeContainer && /*#__PURE__*/external_react_default().createElement("a", {
    className: external_classnames_default()('container-item', {
      'lk-text-theme-dark': !disableLKSContainerLink,
      clickable: !disableLKSContainerLink
    }),
    onClick: disableLKSContainerLink ? undefined : onContainerClick,
    href: getProjectBeginUrl(container.path)
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-folder-o container-icon"
  }), container.title), /*#__PURE__*/external_react_default().createElement("div", {
    className: "container-tabs"
  }, visibleTabs.length > 1 && visibleTabs.map(tab => {
    return /*#__PURE__*/external_react_default().createElement(ProductClickableItem, {
      href: tab.href,
      key: tab.id,
      id: tab.id,
      onClick: () => onTabClick()
    }, tab.text);
  }), visibleTabs.length <= 1 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "empty"
  }, "No tabs have been added to this folder.", user.isAdmin && /*#__PURE__*/external_react_default().createElement("a", {
    className: "how-to",
    href: LK_DOC_FOLDER_TABS,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "How to use tabs in LabKey"))));
});
ProductLKSDrawer.defaultProps = {
  api: getDefaultAPIWrapper()
};

// exported for jest testing
function getProjectBeginUrl(container) {
  return buildURL('project', 'begin', undefined, {
    returnUrl: false,
    container
  });
}
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/ProductNavigationHeader.tsx



const ProductNavigationHeader = (0,external_react_.memo)(props => {
  const {
    productId,
    title
  } = props;
  const contentCls = external_classnames_default()('header-title', {
    clickable: !!productId
  });
  const onClick = (0,external_react_.useCallback)(event => {
    // stopImmediatePropagation in order to prevent the document click handler from closing the menu
    event.nativeEvent.stopImmediatePropagation();
    props.onClick();
  }, [props.onClick]);
  return /*#__PURE__*/external_react_default().createElement("h3", {
    className: "product-navigation-header navbar-menu-header"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-icon-connector"
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: contentCls,
    onClick: productId ? onClick : undefined
  }, productId && /*#__PURE__*/external_react_default().createElement("i", {
    className: "back-icon fa fa-chevron-left"
  }), title ? title : productId === LKS_PRODUCT_ID ? 'LabKey Server' : 'Applications'));
});
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/ProductNavigationMenu.tsx














const ProductNavigationMenu = (0,external_react_.memo)(props => {
  const {
    disableLKSContainerLink
  } = props;
  const {
    homeContainer
  } = (0,api_.getServerContext)();
  const [error, setError] = (0,external_react_.useState)();
  const [products, setProducts] = (0,external_react_.useState)(); // the array of products that have been registered for this LK server
  const [tabs, setTabs] = (0,external_react_.useState)(); // the array of container tabs for the current LK container
  const [selectedProductId, setSelectedProductId] = (0,external_react_.useState)();
  const [homeVisible, setHomeVisible] = (0,external_react_.useState)(false); // is home project visible to this user.

  const onSelection = (0,external_react_.useCallback)(productId => {
    setSelectedProductId(productId);
  }, [setSelectedProductId]);
  (0,external_react_.useEffect)(() => {
    getRegisteredProducts().then(setProducts).catch(setError);
    api_.Security.getContainers({
      container: homeContainer,
      includeSubfolders: false,
      includeEffectivePermissions: false,
      success: data => {
        setHomeVisible(data.userPermissions !== 0);
      },
      failure: errorInfo => {
        console.error(errorInfo);
        setError('Error: unable to get LabKey folder information.');
      }
    });
    getContainerTabs().then(setTabs).catch(setError);
  }, []);
  return /*#__PURE__*/external_react_default().createElement(ProductNavigationMenuImpl, {
    disableLKSContainerLink: disableLKSContainerLink,
    error: error,
    homeVisible: homeVisible,
    onCloseMenu: props.onCloseMenu,
    onSelection: onSelection,
    menuRef: props.menuRef,
    products: products?.sort(naturalSortByProperty('productName')),
    selectedProductId: selectedProductId,
    tabs: tabs
  });
});
// exported for jest testing
const ProductNavigationMenuImpl = (0,external_react_.memo)(props => {
  const {
    error,
    products,
    homeVisible,
    disableLKSContainerLink,
    tabs,
    onCloseMenu,
    selectedProductId,
    onSelection
  } = props;
  const selectedProduct = getSelectedProduct(products, selectedProductId);
  const showProductDrawer = selectedProductId === undefined;
  const showLKSDrawer = selectedProductId === LKS_PRODUCT_ID;
  const showSectionsDrawer = selectedProduct !== undefined;
  const {
    user
  } = (0,api_.getServerContext)();
  const showMenuSettings = (0,external_react_.useMemo)(() => {
    return hasPremiumModule() && user.isRootAdmin;
  }, [user]);
  const className = external_classnames_default()('product-navigation-container', 'navbar-menu__content', {
    wider: showProductDrawer
  });
  const onHeaderClick = (0,external_react_.useCallback)(() => onSelection(undefined), [onSelection]);
  const loading = !products || !tabs;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className,
    ref: props.menuRef
  }, /*#__PURE__*/external_react_default().createElement(ProductNavigationHeader, {
    productId: selectedProductId,
    onClick: onHeaderClick,
    title: selectedProduct?.productName
  }), loading && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
    wrapperClassName: "product-navigation-loading-item"
  }), error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), !loading && !error && /*#__PURE__*/external_react_default().createElement("ul", {
    className: "product-navigation-listing"
  }, showProductDrawer && /*#__PURE__*/external_react_default().createElement(ProductAppsDrawer, {
    products: products,
    onClick: onSelection
  }), showLKSDrawer && /*#__PURE__*/external_react_default().createElement(ProductLKSDrawer, {
    disableLKSContainerLink: disableLKSContainerLink,
    showHome: homeVisible,
    tabs: tabs
  }), showSectionsDrawer && /*#__PURE__*/external_react_default().createElement(ProductSectionsDrawer, {
    product: selectedProduct,
    onCloseMenu: onCloseMenu
  })), selectedProductId === undefined && /*#__PURE__*/external_react_default().createElement("div", {
    className: "product-navigation-footer"
  }, showMenuSettings && /*#__PURE__*/external_react_default().createElement("div", {
    className: "bottom-spacing-less"
  }, /*#__PURE__*/external_react_default().createElement("a", {
    href: ADMIN_LOOK_AND_FEEL_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Menu Settings")), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("a", {
    href: PRODUCT_SERVICES_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "More LabKey Solutions"))));
});

// exported for jest testing
function getSelectedProduct(products, productId) {
  return products?.find(product => product.productId === productId);
}
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/ProductNavigation.tsx



const ProductNavigation = (0,external_react_.memo)(() => {
  const {
    show,
    setShow,
    menuRef,
    toggleRef
  } = useNavMenuState();
  const onCloseMenu = (0,external_react_.useCallback)(() => setShow(false), []);
  const toggleMenu = (0,external_react_.useCallback)(() => setShow(s => !s), []);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-item pull-right product-navigation-menu hidden-xs navbar-menu"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    "aria-haspopup": "true",
    "aria-expanded": show,
    className: "navbar-menu-button",
    onClick: toggleMenu,
    ref: toggleRef,
    role: "button",
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-th-large navbar-header-icon"
  })), show && /*#__PURE__*/external_react_default().createElement(ProductNavigationMenu, {
    onCloseMenu: onCloseMenu,
    menuRef: menuRef
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/productnavigation/utils.ts

/**
 * Returns true for the LKB app or the LKSM app w/ premium module when the user isAdmin or the Look and Feel Setting
 * for applicationMenuDisplayMode is set to ALWAYS.
 */
function shouldShowProductNavigation(user, moduleContext) {
  return (isBiologicsEnabled(moduleContext) || hasPremiumModule(moduleContext)) && (user?.isAdmin || resolveModuleContext(moduleContext)?.api?.applicationMenuDisplayMode?.toLowerCase() === 'always');
}
;// CONCATENATED MODULE: ./src/internal/components/search/FindByIdsModal.tsx










// exported for Jest testing
const FindFieldOption = (0,external_react_.memo)(({
  field,
  checked,
  onFieldChange
}) => {
  const onChange = (0,external_react_.useCallback)(event => {
    onFieldChange(field);
  }, [onFieldChange]);
  return /*#__PURE__*/external_react_default().createElement("label", {
    key: field.name,
    className: "find-by-ids-field-label"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    name: field.name,
    type: "radio",
    onChange: onChange,
    value: field.name,
    checked: checked
  }), field.label, field.helpText && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    placement: "right",
    title: field.helpTextTitle
  }, field.helpText));
});
const MAX_IDS = 1000;
const FindByIdsModal = (0,external_react_.memo)(props => {
  const {
    onCancel,
    onFind,
    nounPlural,
    sessionKey,
    initialField,
    api
  } = props;
  const [fieldType, setFieldType] = (0,external_react_.useState)(initialField || UNIQUE_ID_FIND_FIELD);
  const [idString, setIdString] = (0,external_react_.useState)(undefined);
  const [submitting, setSubmitting] = (0,external_react_.useState)(false);
  const [error, setError] = (0,external_react_.useState)(undefined);
  const capitalNounPlural = capitalizeFirstChar(nounPlural);
  const reset = () => {
    setIdString(undefined);
    setFieldType(UNIQUE_ID_FIND_FIELD);
    setError(undefined);
  };
  const closeModal = (0,external_react_.useCallback)(() => {
    reset();
    onCancel();
  }, [onCancel]);
  const onFieldTypeChange = (0,external_react_.useCallback)(field => {
    setFieldType(field);
  }, []);
  const onIdTextChange = (0,external_react_.useCallback)(event => {
    setIdString(event.target.value);
  }, []);
  const _onFind = (0,external_react_.useCallback)(async () => {
    const ids = idString.split('\n').map(id => id.trim()).filter(id => id.length > 0);
    if (ids.length > MAX_IDS) {
      setError('The number of ' + fieldType.label + ' provided (' + ids.length.toLocaleString() + ') exceeds the maximum of ' + MAX_IDS.toLocaleString() + '.');
      return;
    }
    if (ids.length > 0) {
      setSubmitting(true);
      try {
        const _sessionKey = await saveIdsToFind(fieldType, ids, sessionKey);
        api.query.incrementClientSideMetricCount('find' + capitalNounPlural + 'ById', 'findCount');
        setSubmitting(false);
        reset();
        onFind(_sessionKey);
      } catch (e) {
        setSubmitting(false);
        setError(resolveErrorMessage(e));
      }
    }
  }, [idString, fieldType, sessionKey, api.query, capitalNounPlural, onFind]);
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    confirmText: `Find ${capitalNounPlural}`,
    confirmingText: `Finding ${capitalNounPlural}...`,
    canConfirm: idString && idString.trim().length > 0,
    isConfirming: submitting,
    onCancel: closeModal,
    onConfirm: _onFind,
    title: `Find ${capitalNounPlural}`
  }, /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("p", null, "Find ", nounPlural, " using:"), /*#__PURE__*/external_react_default().createElement(FindFieldOption, {
    field: UNIQUE_ID_FIND_FIELD,
    checked: fieldType.name === UNIQUE_ID_FIND_FIELD.name,
    onFieldChange: onFieldTypeChange
  }), /*#__PURE__*/external_react_default().createElement(FindFieldOption, {
    field: SAMPLE_ID_FIND_FIELD,
    checked: fieldType.name === SAMPLE_ID_FIND_FIELD.name,
    onFieldChange: onFieldTypeChange
  }), /*#__PURE__*/external_react_default().createElement("textarea", {
    rows: 8,
    cols: 50,
    className: "form-control textarea-fullwidth",
    placeholder: `List ${fieldType.nounPlural} here (max: ${MAX_IDS.toLocaleString()})`,
    onChange: onIdTextChange,
    value: idString
  }));
});
FindByIdsModal.defaultProps = {
  api: getDefaultAPIWrapper()
};
;// CONCATENATED MODULE: ./src/internal/components/search/FindAndSearchDropdown.tsx










const FindAndSearchDropdown = (0,external_react_.memo)(props => {
  const {
    title = '',
    findNounPlural = 'samples',
    onFindByIds,
    className,
    onSearch,
    api
  } = props;
  const [findField, setFindField] = (0,external_react_.useState)(undefined);
  const [showFindModal, setShowFindModal] = (0,external_react_.useState)(false);
  const onShowFind = (0,external_react_.useCallback)(findField => {
    setFindField(findField);
    setShowFindModal(true);
  }, [setShowFindModal]);
  const onHideFindModal = (0,external_react_.useCallback)(() => {
    setFindField(undefined);
    setShowFindModal(false);
  }, []);
  const onFind = (0,external_react_.useCallback)(sessionKey => {
    setShowFindModal(false);
    onFindByIds(sessionKey);
  }, [onFindByIds]);
  const onSampleFinder = (0,external_react_.useCallback)(() => {
    api.query.incrementClientSideMetricCount(SAMPLE_FILTER_METRIC_AREA, 'headerMenuNavigation');
  }, [api]);
  const capNoun = capitalizeFirstChar(findNounPlural);
  const findByBarcodeClicked = (0,external_react_.useCallback)(() => onShowFind(UNIQUE_ID_FIND_FIELD), []);
  const findByIdClicked = (0,external_react_.useCallback)(() => onShowFind(SAMPLE_ID_FIND_FIELD), []);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    title: title,
    buttonClassName: 'navbar__find-and-search-button ' + className
  }, !!onFindByIds && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: findByBarcodeClicked
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-barcode"
  }), " Find ", capNoun, " by Barcode"), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: findByIdClicked
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-hashtag"
  }), " Find ", capNoun, " by ID")), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: onSampleFinder,
    href: createProductUrl(getPrimaryAppProperties()?.productId, getCurrentAppProperties()?.productId, FIND_SAMPLES_BY_FILTER_HREF.toHref())
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-sitemap"
  }), " Sample Finder"), !!onSearch && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: onSearch
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-search"
  }), " Search")), !!onFindByIds && showFindModal && /*#__PURE__*/external_react_default().createElement(FindByIdsModal, {
    onCancel: onHideFindModal,
    onFind: onFind,
    nounPlural: findNounPlural,
    initialField: findField
  }));
});
FindAndSearchDropdown.defaultProps = {
  api: getDefaultAPIWrapper()
};
;// CONCATENATED MODULE: ./src/internal/components/search/SearchBox.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


const SearchBox = (0,external_react_.memo)(props => {
  const {
    onSearch,
    placeholder,
    onFindByIds,
    findNounPlural
  } = props;
  const [searchValue, setSearchValue] = (0,external_react_.useState)('');
  const showFindByIds = !!onFindByIds;
  const onChange = (0,external_react_.useCallback)(evt => {
    setSearchValue(evt.target.value);
  }, [setSearchValue]);
  const onSubmit = (0,external_react_.useCallback)(evt => {
    evt.preventDefault();
    onSearch(searchValue);

    // reset the input value after it has been submitted
    setSearchValue('');
  }, [onSearch, searchValue]);
  return /*#__PURE__*/external_react_default().createElement("form", {
    className: "navbar__search-form",
    onSubmit: onSubmit
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-search navbar__search-icon"
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: 'navbar__input-group ' + (showFindByIds ? 'input-group' : '')
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control navbar__search-input",
    onChange: onChange,
    placeholder: placeholder ?? 'Enter Search Terms',
    size: 34,
    type: "text",
    value: searchValue
  }), showFindByIds && /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group-btn"
  }, /*#__PURE__*/external_react_default().createElement(FindAndSearchDropdown, {
    title: "",
    onFindByIds: onFindByIds,
    findNounPlural: findNounPlural
  })))));
});
;// CONCATENATED MODULE: ./src/internal/components/navigation/FolderMenu.tsx







const FolderMenu = (0,external_react_.memo)(props => {
  const {
    items,
    onClick,
    activeContainerId,
    currentProductId
  } = props;
  const {
    moduleContext,
    user
  } = useServerContext();
  const primaryProductId = getPrimaryAppProperties(moduleContext).productId;

  // TODO: the "user" object here is for the current container, so all of the user.isAdmin checks below are incorrect
  // TBD if we want to includeEffectivePermissions in the getProjects() call in ProductMenu.tsx or use the
  // useContainerUser() hook here (need to consider performance implications)

  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "menu-section col-folders"
  }, /*#__PURE__*/external_react_default().createElement("ul", null, items.map(item => {
    const dashboardURL = createProductUrl(primaryProductId, currentProductId, AppURL.create('home'), item.path);
    const adminURL = createProductUrl(primaryProductId, currentProductId, AppURL.create('admin', 'projects'), item.path);
    return /*#__PURE__*/external_react_default().createElement(external_react_.Fragment, {
      key: item.id
    }, /*#__PURE__*/external_react_default().createElement("li", {
      className: external_classnames_default()({
        active: item.id === activeContainerId,
        'menu-section-header': item.isTopLevel,
        'menu-section-item': !item.isTopLevel
      })
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('col menu-folder-body', {
        'col-xs-9': user.isAdmin,
        'col-xs-10': !user.isAdmin
      })
    }, /*#__PURE__*/external_react_default().createElement("a", {
      className: "menu-folder-item",
      onClick: () => onClick(item)
    }, item.label)), /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('col menu-folder-icons', {
        'col-xs-3': user.isAdmin,
        'col-xs-2': !user.isAdmin
      })
    }, /*#__PURE__*/external_react_default().createElement("a", {
      href: getHref(dashboardURL)
    }, /*#__PURE__*/external_react_default().createElement(Tip, {
      caption: "Dashboard"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-home"
    }))), user.isAdmin && /*#__PURE__*/external_react_default().createElement("a", {
      href: getHref(adminURL)
    }, /*#__PURE__*/external_react_default().createElement(Tip, {
      caption: "Administration"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-gear"
    })))))), item.isTopLevel && /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("hr", null)));
  })));
});
FolderMenu.displayName = 'FolderMenu';
;// CONCATENATED MODULE: ./src/internal/components/navigation/ProductMenuSection.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






const MenuSectionItemLabel = (0,external_react_.memo)(({
  config,
  item
}) => {
  if (item.hasActiveJob && config.showActiveJobIcon) {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("i", {
      className: external_classnames_default()('fa', config.activeJobIconCls)
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: "spacer-left product-menu-item"
    }, item.label));
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, item.label);
});
MenuSectionItemLabel.displayName = 'MenuSectionItemLabel';
const MenuSectionLink = ({
  config,
  item
}) => {
  const isAppUrl = (item.url instanceof AppURL || item.url.indexOf('#') === 0) && !config.useOriginalURL;
  const body = /*#__PURE__*/external_react_default().createElement(MenuSectionItemLabel, {
    config: config,
    item: item
  });
  if (isAppUrl) {
    // Hack: sometimes our server returns strings that are actually proper AppURLs (workflow, eln, and more). We can
    // detect this by checking if the URL is prefixed with "#".
    const url = item.url instanceof AppURL ? item.url.toString() : item.url.replace('#', '');
    return /*#__PURE__*/external_react_default().createElement(external_react_router_dom_.Link, {
      to: url
    }, body);
  }
  return /*#__PURE__*/external_react_default().createElement("a", {
    href: item.url.toString()
  }, body);
};
const ProductMenuSection = (0,external_react_.memo)(props => {
  const {
    config,
    section,
    currentProductId,
    containerPath
  } = props;
  if (!section) return null;
  let icon;
  if (config.iconURL) {
    icon = /*#__PURE__*/external_react_default().createElement("img", {
      alt: section.label + ' icon',
      className: 'menu-section-image ' + (config.iconCls || ''),
      src: config.iconURL,
      height: "24px",
      width: "24px"
    });
  } else if (config.iconCls) {
    icon = /*#__PURE__*/external_react_default().createElement("span", {
      className: (config.iconCls || '') + ' menu-section-icon'
    });
  }
  const headerText = config.headerText ?? section.label;
  const label = icon ? /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, icon, " ", headerText) : headerText;

  // In order to make sure we don't break useRouteLeave we need to use <Link> for AppURLs and <a> for non-app URLs
  let headerEl = label;
  if (headerEl) {
    const headerURL = config.useOriginalURL ? section.url : createProductUrlFromPartsWithContainer(section.productId, currentProductId, containerPath, undefined, config.headerURLPart ?? section.key);
    if (headerURL instanceof AppURL) {
      headerEl = /*#__PURE__*/external_react_default().createElement(external_react_router_dom_.Link, {
        to: headerURL.toString()
      }, label);
    } else {
      headerEl = /*#__PURE__*/external_react_default().createElement("a", {
        href: getHref(headerURL)
      }, label);
    }
  }
  let emptyLink;
  if (config.emptyAppURL) {
    const emptyURL = createProductUrl(section.productId, currentProductId, config.emptyAppURL, containerPath);
    if (emptyURL instanceof AppURL) {
      emptyLink = /*#__PURE__*/external_react_default().createElement(external_react_router_dom_.Link, {
        to: emptyURL.toString()
      }, config.emptyURLText);
    } else {
      emptyLink = /*#__PURE__*/external_react_default().createElement("a", {
        href: emptyURL
      }, config.emptyURLText);
    }
  }
  const visibleItems = section.items.filter(item => !item.hidden).sortBy(item => item.label, naturalSort);
  const isEmpty = section.items.isEmpty() || visibleItems.isEmpty();
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "product-menu-section-header"
  }, /*#__PURE__*/external_react_default().createElement("ul", null, /*#__PURE__*/external_react_default().createElement("li", {
    className: "menu-section-header clickable-item"
  }, headerEl), /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("hr", null)))), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('product-menu-section', {
      'menu-section-static': config.staticContent
    })
  }, /*#__PURE__*/external_react_default().createElement("ul", null, isEmpty && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, (config.emptyText || config.filteredEmptyText) && /*#__PURE__*/external_react_default().createElement("li", {
    className: "empty-section"
  }, section.items.isEmpty() ? config.emptyText : config.filteredEmptyText), emptyLink && /*#__PURE__*/external_react_default().createElement("li", {
    className: "empty-section-link"
  }, emptyLink)), !isEmpty && visibleItems.map(item => {
    if (item.url) {
      return /*#__PURE__*/external_react_default().createElement("li", {
        key: item.label,
        className: "clickable-item"
      }, /*#__PURE__*/external_react_default().createElement(MenuSectionLink, {
        config: config,
        item: item
      }));
    }
    return /*#__PURE__*/external_react_default().createElement("li", {
      key: item.label
    }, /*#__PURE__*/external_react_default().createElement(MenuSectionItemLabel, {
      config: config,
      item: item
    }));
  }))));
});
ProductMenuSection.displayName = 'ProductMenuSection';
;// CONCATENATED MODULE: ./src/internal/components/navigation/ProductMenu.tsx
function ProductMenu_extends() { return ProductMenu_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ProductMenu_extends.apply(null, arguments); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


















const ProductMenu = (0,external_react_.memo)(props => {
  const {
    menuRef,
    onClick,
    error,
    folderItems,
    sectionConfigs,
    showFolderMenu,
    appProperties = getCurrentAppProperties()
  } = props;
  const {
    api
  } = useAppContext();
  const {
    container,
    moduleContext
  } = useServerContext();
  const [menuModel, setMenuModel] = (0,external_react_.useState)(() => new ProductMenuModel({
    containerId: container.id
  }));
  (0,external_react_.useEffect)(() => {
    if (!menuModel.isLoaded) return;

    // The desired behavior is that we have a min-height and then grow the menu to the max-height of 80% of the
    // browser height. The menu should grow based on the longest section column list or the project list, whichever
    // is longer.
    let height = 400; // match navbar.scss product-menu-content min-height
    const maxHeight = window.innerHeight * 0.8;
    const sections = Array.from(menuRef.current.getElementsByClassName('menu-section'));
    sections.forEach(section => height = Math.max(height, section.clientHeight));
    menuRef.current.style.height = Math.min(height, maxHeight) + 'px';

    // if the selected project is out of view, scrollIntoView
    const activeProject = menuRef.current.getElementsByClassName('active')?.[0];
    if (activeProject) {
      if (activeProject.getBoundingClientRect().bottom > menuRef.current.getBoundingClientRect().bottom) {
        menuRef.current.getElementsByClassName('active')?.[0].scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, [menuModel.isLoaded]);
  (0,external_react_.useEffect)(() => {
    (async () => {
      // no try/catch as the initMenuModel will catch errors and put them in the model isError/message
      const menuModel_ = await api.navigation.initMenuModel(appProperties, moduleContext, container.id);
      setMenuModel(menuModel_);
    })();
  }, [api.navigation, appProperties, container.id, moduleContext]);
  const onFolderItemClick = (0,external_react_.useCallback)(async folderItem => {
    // return early if folderItem is already active
    if (folderItem.id === menuModel.containerId) return;
    setMenuModel(new ProductMenuModel({
      containerId: folderItem.id
    })); // loading state, reset error

    // no try/catch as the initMenuModel will catch errors and put them in the model isError/message
    const containerPath = folderItem.id === container.id ? undefined : folderItem.path;
    const menuModel_ = await api.navigation.initMenuModel(appProperties, moduleContext, folderItem.id, containerPath);
    setMenuModel(menuModel_);
  }, [api.navigation, appProperties, container.id, menuModel.containerId, moduleContext]);
  const getSectionModel = (0,external_react_.useCallback)(key => menuModel.sections.find(section => section.key === key), [menuModel]);
  const sectionConfigKeysWithInfo = sectionConfigs.reduce((keysWithInfo, sectionConfig) => {
    // get the keys for the sections in a given column/config that have info/items
    keysWithInfo.push(Object.keys(sectionConfig.toJS()).filter(key => getSectionModel(key) !== undefined));
    return keysWithInfo;
  }, []);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "product-menu-content",
    onClick: onClick,
    ref: menuRef
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-connector"
  }), error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("div", {
    className: "product-menu-content-body"
  }, showFolderMenu && /*#__PURE__*/external_react_default().createElement(FolderMenu, {
    activeContainerId: menuModel.containerId,
    currentProductId: menuModel.currentProductId,
    items: folderItems,
    onClick: onFolderItemClick
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "sections-content"
  }, !menuModel.isLoaded && /*#__PURE__*/external_react_default().createElement("div", {
    className: "menu-section menu-loading"
  }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null)), menuModel.isError && /*#__PURE__*/external_react_default().createElement("div", {
    className: "menu-section"
  }, /*#__PURE__*/external_react_default().createElement(Alert, null, menuModel.message)), menuModel.isLoaded && sectionConfigs.map((sectionConfig, i) => {
    // this can happen if a user has different perm in different project folders
    if (sectionConfigKeysWithInfo[i].length === 0) return null;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      external_react_default().createElement("div", {
        key: i,
        className: "menu-section col-product-section"
      }, sectionConfig.entrySeq().map(([key, menuConfig]) => {
        return /*#__PURE__*/external_react_default().createElement(ProductMenuSection, {
          key: key,
          config: menuConfig,
          containerPath: menuModel.containerPath,
          currentProductId: menuModel.currentProductId,
          section: getSectionModel(key)
        });
      }))
    );
  }))));
});
const ProductMenuButtonTitle = (0,external_react_.memo)(props => {
  const {
    container,
    folderItems,
    location
  } = props;
  const title = (0,external_react_.useMemo)(() => {
    return folderItems?.length > 1 ? container.path === HOME_PATH ? HOME_TITLE : container.title : 'Menu';
  }, [container.path, container.title, folderItems?.length]);
  const subtitle = (0,external_react_.useMemo)(() => {
    return getHeaderMenuSubtitle(location?.pathname);
  }, [location]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "title"
  }, title), /*#__PURE__*/external_react_default().createElement("div", {
    className: "subtitle"
  }, subtitle));
});
const ProductMenuButton = (0,external_react_.memo)(props => {
  const {
    appProperties = getCurrentAppProperties()
  } = props;
  const location = (0,external_react_router_dom_.useLocation)();
  const {
    show,
    setShow,
    menuRef,
    toggleRef
  } = useNavMenuState();
  const [error, setError] = (0,external_react_.useState)();
  const [loading, setLoading] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [folderItems, setFolderItems] = (0,external_react_.useState)([]);
  const hasError = !!error;
  const isLoaded = !isLoading(loading);
  const {
    api
  } = useAppContext();
  const {
    container,
    moduleContext
  } = useServerContext();
  (0,external_react_.useEffect)(() => {
    setLoading(LoadingState.LOADING);
    setError(undefined);
    (async () => {
      try {
        const folders = await api.folder.getProjects(container, moduleContext, true, false, true);
        const items_ = [];
        const topLevelFolderIdx = folders.findIndex(f => f.parentPath === '/');
        if (topLevelFolderIdx > -1) {
          // Remove top-level folder from array as it is always displayed as the first menu item
          const topLevelFolder = folders.splice(topLevelFolderIdx, 1)[0];
          items_.push(createFolderItem(topLevelFolder, appProperties.controllerName, true));
        }
        setFolderItems(items_.concat(folders.map(folder => createFolderItem(folder, appProperties.controllerName, false))));
      } catch (e) {
        setError(`Error: ${resolveErrorMessage(e)}`);
      }
      setLoading(LoadingState.LOADED);
    })();
  }, [api, container, moduleContext, appProperties?.controllerName]);
  const toggleMenu = (0,external_react_.useCallback)(() => {
    setShow(!show);
    blurActiveElement();
  }, [show, setShow]);

  // Only toggle the menu closing if a menu section link has been clicked or a project icon (issue 48283).
  // Clicking anywhere else inside the menu will not toggle the menu, including side panel folder clicks.
  const onClick = (0,external_react_.useCallback)(evt => {
    const {
      nodeName,
      className
    } = evt.target;
    if (!nodeName || nodeName.toLowerCase() === 'a' && className !== 'menu-folder-item' || nodeName.toLowerCase() === 'span' && className?.indexOf('product-menu-item') > -1 || nodeName.toLowerCase() === 'i' && className?.toLowerCase().startsWith('fa')) {
      toggleMenu();
    }
  }, [toggleMenu]);
  if (!isLoaded && !hasError) return null;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "product-menu"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    "aria-haspopup": "true",
    "aria-expanded": show,
    className: "product-menu-button",
    onClick: toggleMenu,
    ref: toggleRef,
    role: "button",
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement(ProductMenuButtonTitle, {
    container: container,
    folderItems: folderItems,
    location: location
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "caret"
  })), show && /*#__PURE__*/external_react_default().createElement(ProductMenu, ProductMenu_extends({}, props, {
    error: error,
    folderItems: folderItems,
    menuRef: menuRef,
    onClick: onClick,
    showFolderMenu: folderItems?.length > 1
  })));
});

// export for jest testing
function createFolderItem(folder, controllerName, isTopLevel) {
  return {
    href: buildURL(controllerName, `${api_.ActionURL.getAction() || 'app'}.view`, undefined, {
      container: folder.path,
      returnUrl: false
    }),
    id: folder.id,
    isTopLevel,
    label: folder.path === HOME_PATH ? HOME_TITLE : folder.title,
    path: folder.path
  };
}
const HEADER_MENU_SUBTITLE_MAP = {
  account: 'Settings',
  admin: 'Administration',
  items: 'Storage',
  lineage: 'Lineage',
  home: 'Dashboard',
  pipeline: 'Imports',
  q: 'Schemas',
  reports: 'Reports',
  [ASSAY_DESIGN_KEY.toLowerCase()]: 'Assays',
  [ASSAYS_KEY]: 'Assays',
  [AUDIT_KEY]: 'Administration',
  [BOXES_KEY]: 'Storage',
  [ELN_KEY]: 'Notebooks',
  [FREEZERS_KEY]: 'Storage',
  [MEDIA_KEY]: 'Media',
  [PLATES_KEY]: 'Plates',
  [PICKLIST_KEY]: 'Picklists',
  [REGISTRY_KEY]: 'Registry',
  [SAMPLE_TYPE_KEY.toLowerCase()]: 'Sample Types',
  [SAMPLES_KEY]: 'Sample Types',
  [SOURCE_TYPE_KEY.toLowerCase()]: 'Source Types',
  [SOURCES_KEY]: 'Source Types',
  [SEARCH_KEY]: 'Search',
  [WORKFLOW_KEY]: 'Workflow'
};
function getBaseRoute(pathname) {
  // pathname is prefixed with, and split up, by /, so the first segment is always an empty string when splitting, the
  // second is the base route.
  return pathname?.toLowerCase().split('/')[1];
}

// export for jest testing
function getHeaderMenuSubtitle(pathname) {
  return HEADER_MENU_SUBTITLE_MAP[getBaseRoute(pathname)] ?? 'Dashboard';
}
function isAdminRoute(pathname) {
  return HEADER_MENU_SUBTITLE_MAP[getBaseRoute(pathname)] === 'Administration';
}
;// CONCATENATED MODULE: ./src/internal/components/navigation/NavItem.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



const NavItem = (0,external_react_.memo)(({
  children,
  onActive,
  to
}) => {
  const location = (0,external_react_router_dom_.useLocation)();
  const href = to instanceof AppURL ? to.toString() : to;
  const itemRef = (0,external_react_.useRef)();
  const [active, setActive] = (0,external_react_.useState)(false);
  (0,external_react_.useEffect)(() => {
    if (to && location) {
      const toString = to.toString();
      const paramIndex = toString.indexOf('?');
      const isActive = location.pathname.toLowerCase() === toString.substring(0, paramIndex < 0 ? toString.length : paramIndex).toLowerCase();
      setActive(isActive);
      if (isActive) {
        onActive?.(itemRef.current);
      }
    } else {
      setActive(false);
    }
  }, [location, to]);
  return /*#__PURE__*/external_react_default().createElement("li", {
    className: active ? 'active' : null,
    ref: itemRef
  }, /*#__PURE__*/external_react_default().createElement(external_react_router_dom_.Link, {
    to: href
  }, children));
});
const ParentNavItem = (0,external_react_.memo)(({
  children,
  to
}) => {
  const href = to instanceof AppURL ? to.toString() : to;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "parent-nav"
  }, /*#__PURE__*/external_react_default().createElement("ul", {
    className: "nav navbar-nav"
  }, /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement(external_react_router_dom_.Link, {
    to: href
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-chevron-left"
  }), "\xA0", children))));
});
;// CONCATENATED MODULE: ./src/internal/components/navigation/SubNav.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








const SubNavImpl = ({
  noun,
  tabs
}) => {
  const location = (0,external_react_router_dom_.useLocation)();
  const isAdminPage = (0,external_react_.useMemo)(() => isAdminRoute(location.pathname), [location.pathname]);
  const scrollable = (0,external_react_.useRef)();
  const {
    container,
    moduleContext
  } = useServerContext();
  const {
    versionString
  } = (0,api_.getServerContext)();
  const showCurrentContainer = hasPremiumModule(moduleContext) && !hasProductProjects(moduleContext);
  const [isScrollable, setIsScrollable] = (0,external_react_.useState)(false);
  const scroll = (0,external_react_.useCallback)(offset => {
    scrollable.current.scrollLeft = scrollable.current.scrollLeft + offset;
  }, []);
  const scrollLeft = (0,external_react_.useCallback)(() => scroll(-300), [scroll]);
  const scrollRight = (0,external_react_.useCallback)(() => scroll(300), [scroll]);
  const onItemActivate = (0,external_react_.useCallback)(el => {
    const scrollPos = scrollable.current.getBoundingClientRect();
    const itemPos = el.getBoundingClientRect();
    const leftEdge = scrollPos.left;
    const rightEdge = scrollPos.left + scrollPos.width;
    const itemLeft = itemPos.left;
    const itemRight = itemPos.left + itemPos.width;
    if (itemLeft < leftEdge) {
      scroll(itemLeft - leftEdge);
    } else if (itemRight > rightEdge) {
      scroll(itemRight - rightEdge);
    }
  }, [scroll]);
  const calculateIsScrollable = (0,external_react_.useCallback)(() => {
    const el = scrollable.current;
    const hasOverflow = el.offsetWidth < el.scrollWidth;
    if (hasOverflow) {
      setIsScrollable(true);
    } else {
      setIsScrollable(false);
    }
  }, []);
  (0,external_react_.useEffect)(() => {
    window.addEventListener('resize', calculateIsScrollable);
    return () => {
      window.removeEventListener('resize', calculateIsScrollable);
    };
  }, [calculateIsScrollable]);
  (0,external_react_.useEffect)(() => {
    // Tabs can be loaded asynchronously, isScrollable is calculated based on the window size and size of the tabs,
    // so we want to recalculate every time the tabs change
    calculateIsScrollable();
  }, [calculateIsScrollable, tabs]);
  return /*#__PURE__*/external_react_default().createElement("nav", {
    className: "navbar navbar-inverse sub-nav"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "sub-nav-container"
  }, noun && /*#__PURE__*/external_react_default().createElement(ParentNavItem, {
    to: noun.url
  }, noun.text), /*#__PURE__*/external_react_default().createElement("div", {
    className: "tab-scroll-ct",
    ref: scrollable
  }, /*#__PURE__*/external_react_default().createElement("ul", {
    className: "nav navbar-nav"
  }, tabs.filter(tab => !!tab.text).map(({
    text,
    url
  }, i) =>
  /*#__PURE__*/
  // neither "text" nor "url" are consistently unique
  // eslint-disable-next-line react/no-array-index-key
  external_react_default().createElement(NavItem, {
    key: i,
    to: url,
    onActive: onItemActivate
  }, text)))), isScrollable && /*#__PURE__*/external_react_default().createElement("div", {
    className: "btn-group scroll-btn-group"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default",
    onClick: scrollLeft,
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-chevron-left"
  })), /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default",
    onClick: scrollRight,
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-chevron-right"
  }))), showCurrentContainer && /*#__PURE__*/external_react_default().createElement("div", {
    className: "container-nav"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-folder-open"
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "container-nav__name",
    title: container.name
  }, container.name)), isAdminPage && /*#__PURE__*/external_react_default().createElement("div", {
    className: "lk-version-nav"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "lk-version-nav__label",
    title: versionString
  }, "Version: ", versionString))));
};
const SubNav = (0,external_react_.memo)(() => {
  const {
    noun,
    tabs
  } = useSubNavTabsContext();
  if (tabs.length === 0 && noun === undefined) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement(SubNavImpl, {
    noun: noun,
    tabs: tabs
  });
});
;// CONCATENATED MODULE: ./src/internal/components/navigation/UserMenuGroup.tsx
function UserMenuGroup_extends() { return UserMenuGroup_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, UserMenuGroup_extends.apply(null, arguments); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











// exported for jest testing
const UserMenuGroupImpl = props => {
  const {
    model,
    extraDevItems,
    extraUserItems,
    onSignIn,
    onSignOut,
    user,
    signOutUrl
  } = props;
  const {
    api
  } = useAppContext();
  const releaseNoteLink = getPrimaryAppProperties()?.releaseNoteLink;
  const releaseNoteHref = releaseNoteLink ? getHelpLink(getPrimaryAppProperties()?.releaseNoteLink, null, biologicsIsPrimaryApp() /* needed for FM in Biologics*/) : undefined;
  const {
    helpHref,
    userMenuItems,
    adminMenuItems
  } = (0,external_react_.useMemo)(() => {
    let helpHref;
    const userMenuItems = [];
    const adminMenuItems = [];
    model?.items.filter(item => !item.requiresLogin || item.requiresLogin && user?.isSignedIn).forEach(item => {
      if (item.key === 'docs') {
        helpHref = item.getUrlString();
      } else {
        const menuItem = /*#__PURE__*/external_react_default().createElement(MenuItem, {
          key: item.key,
          href: item.getUrlString(),
          target: "_self"
        }, item.label);
        if (item.key.indexOf('admin') === 0) {
          adminMenuItems.push(menuItem);
        } else {
          userMenuItems.push(menuItem);
        }
      }
    });
    return {
      helpHref,
      userMenuItems,
      adminMenuItems
    };
  }, [model?.items, user?.isSignedIn]);
  const handleSignOut = (0,external_react_.useCallback)(() => {
    onSignOut(signOutUrl);
  }, [onSignOut, signOutUrl]);
  const onReleaseNotesClick = (0,external_react_.useCallback)(() => {
    api.query.incrementClientSideMetricCount(RELEASE_NOTES_METRIC, 'FromHelpMenu');
  }, []);
  if (!model || !user) {
    return null;
  }
  const userToggle = user.avatar ? /*#__PURE__*/external_react_default().createElement("img", {
    className: "img-rounded",
    src: user.avatar,
    alt: "User Avatar",
    height: 32,
    width: 32
  }) : /*#__PURE__*/external_react_default().createElement("span", {
    className: "navbar-item"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "user-name"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fas fa-user-circle"
  }), " ", user.displayName, ' '));
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-item pull-right"
  }, /*#__PURE__*/external_react_default().createElement(DropdownAnchor, {
    className: "user-dropdown",
    title: userToggle,
    pullRight: true
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-connector"
  }), userMenuItems, extraUserItems, (userMenuItems?.length > 0 || extraUserItems) && /*#__PURE__*/external_react_default().createElement(MenuDivider, null), user.isSignedIn ? /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: handleSignOut
  }, "Sign Out") : /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: onSignIn
  }, "Sign In"))), (adminMenuItems?.length > 0 || (0,api_.getServerContext)().devMode) && /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-item pull-right navbar-item__dropdown"
  }, /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    className: "admin-dropdown",
    buttonClassName: "navbar-menu-button",
    title: /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-cog navbar-header-icon"
    }),
    noCaret: true,
    pullRight: true
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-icon-connector"
  }), adminMenuItems, adminMenuItems?.length > 0 && (0,api_.getServerContext)().devMode && /*#__PURE__*/external_react_default().createElement(MenuDivider, null), (0,api_.getServerContext)().devMode && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    text: "Dev Tools"
  }), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: toggleDevTools
  }, devToolsActive() ? 'Disable' : 'Enable', " Redux Tools"), extraDevItems))), (!!helpHref || !!releaseNoteHref) && /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-item pull-right navbar-item__dropdown"
  }, /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    className: "help-dropdown",
    buttonClassName: "navbar-menu-button",
    title: /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-question-circle navbar-header-icon"
    }),
    noCaret: true,
    pullRight: true
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-icon-connector"
  }), helpHref && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    href: helpHref,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Help"), releaseNoteHref && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    href: releaseNoteHref,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onReleaseNotesClick
  }, "Release Notes"))));
};
const UserMenuGroup = props => {
  const {
    api
  } = useAppContext();
  const {
    container,
    moduleContext
  } = useServerContext();
  const {
    appProperties = getPrimaryAppProperties(moduleContext)
  } = props;
  const productId = getCurrentAppProperties()?.productId ?? appProperties.productId;
  const [model, setModel] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    (async () => {
      // no try/catch as the loadUserMenu will catch errors and return undefined
      const sectionModel = await api.navigation.loadUserMenu(productId, appProperties, moduleContext);
      setModel(sectionModel);
    })();
  }, [api.navigation, appProperties, container.path, moduleContext, productId]);
  return /*#__PURE__*/external_react_default().createElement(UserMenuGroupImpl, UserMenuGroup_extends({}, props, {
    model: model
  }));
};
UserMenuGroup.defaultProps = {
  onSignIn: signIn,
  onSignOut: signOut
};
;// CONCATENATED MODULE: ./src/internal/components/navigation/NavigationBar.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */















const NavigationBar = (0,external_react_.memo)(props => {
  const {
    brand,
    extraDevItems,
    extraUserItems,
    menuSectionConfigs,
    notificationsConfig,
    onSearch,
    onFindByIds,
    onSignIn,
    onSignOut,
    searchPlaceholder,
    showNavMenu,
    showNotifications,
    showFolderMenu,
    showProductNav,
    showSearchBox,
    signOutUrl,
    user
  } = props;
  const {
    moduleContext
  } = useServerContext();
  const folderMenuContext = useFolderMenuContext();
  const location = (0,external_react_router_dom_.useLocation)();
  const isAdminPage = (0,external_react_.useMemo)(() => isAdminRoute(location.pathname), [location.pathname]);
  const onSearchIconClick = (0,external_react_.useCallback)(() => {
    onSearch('');
  }, [onSearch]);
  const _searchPlaceholder = searchPlaceholder ?? getPrimaryAppProperties(moduleContext)?.searchPlaceholder ?? SEARCH_PLACEHOLDER;
  const _showNotifications = showNotifications !== false && !!notificationsConfig && !!user && !user.isGuest;
  const _showProductNav = showProductNav !== false && shouldShowProductNavigation(user, moduleContext);
  const {
    noun,
    tabs
  } = useSubNavTabsContext();
  const hasSubNav = noun !== undefined || tabs.length > 0;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('app-navigation', {
      'with-sub-nav': hasSubNav
    })
  }, /*#__PURE__*/external_react_default().createElement("nav", {
    className: external_classnames_default()('main-nav navbar test-loc-nav-header', {
      'navbar-container': !isAdminPage,
      'admin-navbar-container': isAdminPage
    })
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-left col-xs-6 col-md-6"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "navbar-item navbar-left-icon pull-left"
  }, brand), showNavMenu && !isAdminPage && /*#__PURE__*/external_react_default().createElement("span", {
    className: "navbar-item navbar-left-menu"
  }, /*#__PURE__*/external_react_default().createElement(ProductMenuButton, {
    key: folderMenuContext.key // re-render and reload folderItems when project added
    ,
    sectionConfigs: menuSectionConfigs,
    showFolderMenu: showFolderMenu
  })), isAdminPage && /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-left-sub"
  }, "Administration")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-right col-xs-6 col-md-6"
  }, !!user && /*#__PURE__*/external_react_default().createElement(UserMenuGroup, {
    extraDevItems: extraDevItems,
    extraUserItems: extraUserItems,
    onSignIn: onSignIn,
    onSignOut: onSignOut,
    signOutUrl: signOutUrl,
    user: user
  }), _showNotifications && !isAdminPage && /*#__PURE__*/external_react_default().createElement(ServerNotifications, notificationsConfig), _showProductNav && /*#__PURE__*/external_react_default().createElement(ProductNavigation, null), showSearchBox && !isAdminPage && /*#__PURE__*/external_react_default().createElement("div", {
    className: "navbar-item pull-right"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "hidden-md hidden-sm hidden-xs"
  }, /*#__PURE__*/external_react_default().createElement(SearchBox, {
    onSearch: onSearch,
    placeholder: _searchPlaceholder,
    onFindByIds: onFindByIds,
    findNounPlural: "samples"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "visible-md visible-sm visible-xs"
  }, onFindByIds ? /*#__PURE__*/external_react_default().createElement(FindAndSearchDropdown, {
    className: "navbar__xs-find-dropdown",
    title: /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-search navbar__xs-search-icon"
    }),
    findNounPlural: "samples",
    onSearch: onSearchIconClick,
    onFindByIds: onFindByIds
  }) : /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-search navbar__xs-search-icon",
    onClick: onSearchIconClick
  }))))))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "sub-nav-wrapper"
  }, /*#__PURE__*/external_react_default().createElement(SubNav, null)));
});

// FIXME: re-evaluate these defaults. Some are always passed, so no default is needed. Some are never passed, so no prop
//  is needed.
NavigationBar.defaultProps = {
  showFolderMenu: false,
  showNavMenu: true,
  showNotifications: true,
  showProductNav: true,
  showSearchBox: false
};
NavigationBar.displayName = 'NavigationBar';
;// CONCATENATED MODULE: ./src/internal/util/RequestHandler.tsx

/**
 * React hook that encapsulates handling for aborting stale XMLHttpRequests.
 * NK: In general, I'd like to make it easier to handle aborting requests within our applications.
 * This is a first crack at it but could certainly be improved/extended before being made available more broadly.
 */
function useRequestHandler() {
  const requestRef = (0,external_react_.useRef)(undefined);

  // This requestHandler aborts prior search requests in the event that another search request is made
  const requestHandler = (0,external_react_.useCallback)(request => {
    requestRef.current?.abort();
    requestRef.current = request;
  }, []);
  const resetRequestHandler = (0,external_react_.useCallback)(() => {
    requestRef.current = undefined;
  }, []);
  return {
    requestHandler,
    resetRequestHandler
  };
}
;// CONCATENATED MODULE: ./src/internal/components/search/FilterFacetedSelector.tsx
function FilterFacetedSelector_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FilterFacetedSelector_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FilterFacetedSelector_ownKeys(Object(t), !0).forEach(function (r) { FilterFacetedSelector_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FilterFacetedSelector_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FilterFacetedSelector_defineProperty(e, r, t) { return (r = FilterFacetedSelector_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FilterFacetedSelector_toPropertyKey(t) { var i = FilterFacetedSelector_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FilterFacetedSelector_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









const MAX_DISTINCT_FILTER_OPTIONS = 250;
const FilterFacetedSelector = (0,external_react_.memo)(props => {
  const {
    api,
    canBeBlank,
    disabled,
    selectDistinctOptions,
    fieldKey,
    fieldFilters,
    onFieldFilterUpdate,
    showSearchLength
  } = props;
  const timerRef = (0,external_react_.useRef)(undefined);
  const [fieldDistinctValues, setFieldDistinctValues] = (0,external_react_.useState)(undefined);
  const [searchDistinctValues, setSearchDistinctValues] = (0,external_react_.useState)(undefined);
  const [error, setError] = (0,external_react_.useState)(undefined);
  const [searchStr, setSearchStr] = (0,external_react_.useState)(undefined);
  const [allShown, setAllShown] = (0,external_react_.useState)(undefined);
  const [loading, setLoading] = (0,external_react_.useState)(true);
  const {
    requestHandler,
    resetRequestHandler
  } = useRequestHandler();
  const resetTimeout = (0,external_react_.useCallback)(() => {
    clearTimeout(timerRef.current);
    timerRef.current = undefined;
  }, []);
  (0,external_react_.useEffect)(() => {
    setDistinctValues(true);
  }, [fieldKey]); // on fieldKey change, reload selection values

  const setDistinctValues = (0,external_react_.useCallback)(async (checkForAll, searchStr) => {
    let aborted = false;
    try {
      setLoading(true);
      setError(undefined);
      resetTimeout();
      const filterArray = searchStr ? [api_.Filter.create(fieldKey, searchStr, api_.Filter.Types.CONTAINS)].concat(selectDistinctOptions?.filterArray) : selectDistinctOptions?.filterArray;
      const result = await api.query.selectDistinctRows(FilterFacetedSelector_objectSpread(FilterFacetedSelector_objectSpread({}, selectDistinctOptions), {}, {
        filterArray,
        maxRows: MAX_DISTINCT_FILTER_OPTIONS + 1,
        requestHandler
      }));
      resetRequestHandler();
      const toShow = result.values.slice(0, MAX_DISTINCT_FILTER_OPTIONS);
      const distinctValues = toShow.sort(naturalSort).map(val => {
        if (val === '' || val === null || val === undefined) return EMPTY_VALUE_DISPLAY;
        return val;
      });
      let hasBlank = false;
      // move [blank] to first
      if (distinctValues.indexOf(EMPTY_VALUE_DISPLAY) >= 0) {
        hasBlank = true;
        distinctValues.splice(distinctValues.indexOf(EMPTY_VALUE_DISPLAY), 1);
      }
      // Issue 47544: don't show 'blank' if we have all the values and none are blank
      if (toShow.length > 0 && (hasBlank || canBeBlank && result.values.length > MAX_DISTINCT_FILTER_OPTIONS)) {
        distinctValues.unshift(EMPTY_VALUE_DISPLAY);
      }

      // add [All] to first if the total distinct values is < 250
      const hasAllValues = !searchStr && result.values.length <= MAX_DISTINCT_FILTER_OPTIONS;
      if (hasAllValues) distinctValues.unshift(ALL_VALUE_DISPLAY);
      if (checkForAll) {
        setAllShown(hasAllValues);
      }
      if (searchStr) {
        setSearchDistinctValues(distinctValues);
      } else {
        setFieldDistinctValues(distinctValues);
      }
    } catch (e) {
      aborted = !e.status;
      if (!aborted) {
        console.error(e);
        setAllShown(true);
        if (searchStr) {
          setSearchDistinctValues([]);
        } else {
          setFieldDistinctValues([]);
        }
        setError(resolveErrorMessage(e));
      }
    } finally {
      if (!aborted) {
        resetTimeout();
        setLoading(false);
      }
    }
  }, [api.query, canBeBlank, fieldKey, requestHandler, resetRequestHandler, resetTimeout, selectDistinctOptions]);
  const setDistinctValuesForSearch = (0,external_react_.useCallback)(async searchStr => {
    if (timerRef.current !== undefined) {
      resetTimeout();
    }
    timerRef.current = setTimeout(async () => {
      setDistinctValues(false, searchStr);
    }, 500);
  }, [resetTimeout, setDistinctValues]);
  const checkedValues = (0,external_react_.useMemo)(() => {
    return getCheckedFilterValues(fieldFilters?.[0], allShown ? fieldDistinctValues : undefined);
  }, [fieldFilters?.[0], fieldKey, fieldDistinctValues, allShown]); // need to add fieldKey

  const taggedValues = (0,external_react_.useMemo)(() => {
    if (checkedValues?.indexOf(ALL_VALUE_DISPLAY) > -1) return [];
    return checkedValues;
  }, [checkedValues]);
  const onSearchStrChange = (0,external_react_.useCallback)(e => {
    setSearchStr(e.target.value);
    setDistinctValuesForSearch(e.target.value);
  }, [setDistinctValuesForSearch]);
  const onChange = (0,external_react_.useCallback)((value, checked, uncheckOthers) => {
    if (disabled) return;
    const newFilter = getUpdatedChooseValuesFilter(allShown ? fieldDistinctValues : undefined, fieldKey, value, checked, fieldFilters?.[0],
    // choose values applies only to the first filter
    uncheckOthers);
    onFieldFilterUpdate([newFilter], 0);
  }, [disabled, allShown, fieldDistinctValues, fieldKey, fieldFilters, onFieldFilterUpdate]);
  const filteredFieldDistinctValues = (0,external_react_.useMemo)(() => {
    if (!searchStr) return fieldDistinctValues;
    return searchDistinctValues?.filter(val => {
      return val !== ALL_VALUE_DISPLAY && val !== EMPTY_VALUE_DISPLAY;
    });
  }, [fieldDistinctValues, searchDistinctValues, searchStr]);
  if (!fieldDistinctValues || allShown === undefined) return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("div", {
    className: "filter-faceted__panel"
  }, (fieldDistinctValues?.length > showSearchLength || searchStr) && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("input", {
    id: "filter-faceted__typeahead-input",
    className: "form-control filter-faceted__typeahead-input",
    value: searchStr ?? '',
    onChange: onSearchStrChange,
    type: "text",
    placeholder: "Type to filter",
    disabled: disabled
  })), !allShown && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12 bottom-spacing"
  }, /*#__PURE__*/external_react_default().createElement("div", null, "There are more than ", MAX_DISTINCT_FILTER_OPTIONS, " distinct values. Use the filter box above to find additional values."))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: `col-xs-${taggedValues?.length > 0 ? 6 : 12}`
  }, loading && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), !loading && /*#__PURE__*/external_react_default().createElement("ul", {
    className: "nav nav-stacked labkey-wizard-pills"
  }, filteredFieldDistinctValues?.map((value, index) => {
    let displayValue = value;
    if (value === null || value === undefined) displayValue = '[blank]';
    return /*#__PURE__*/external_react_default().createElement("li", {
      key: index,
      className: "filter-faceted__li"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "form-check"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-check-input filter-faceted__checkbox",
      type: "checkbox",
      name: 'field-value-' + index,
      onChange: event => onChange(value, event.target.checked),
      checked: checkedValues.indexOf(value) > -1,
      disabled: disabled
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "filter-faceted__value",
      onClick: () => onChange(value, true, true)
    }, displayValue)));
  }), searchStr && filteredFieldDistinctValues?.length === 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__empty-msg"
  }, "No value matches '", searchStr, "'."))), taggedValues?.length > 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "filter-faceted__tags-title"
  }, "Selected"), /*#__PURE__*/external_react_default().createElement("ul", {
    className: "nav nav-stacked labkey-wizard-pills filter-faceted__tags-div"
  }, taggedValues?.map((value, index) => {
    let displayValue = value;
    if (value === null || value === undefined) displayValue = '[blank]';
    return /*#__PURE__*/external_react_default().createElement("li", {
      key: index,
      className: "filter-status__faceted"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "filter-status-value"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "symbol fa fa-close",
      onClick: () => onChange(value, false)
    }), /*#__PURE__*/external_react_default().createElement("span", null, displayValue)));
  }))))));
});
FilterFacetedSelector.defaultProps = {
  showSearchLength: 20,
  api: getDefaultAPIWrapper()
};
;// CONCATENATED MODULE: ./src/internal/components/ontology/ConceptPathDisplay.tsx
function ConceptPathDisplay_extends() { return ConceptPathDisplay_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ConceptPathDisplay_extends.apply(null, arguments); }
/* eslint-disable import/no-cycle */





const ConceptPathDisplay = (0,external_react_.memo)(props => {
  const {
    path
  } = props;
  const [parentPaths, setParentPaths] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    if (path) {
      setParentPaths(undefined);
      // FIXME: this should be in an APIWrapper, it's causing console errors in our tests, and was causing
      //  intermittent test failures in ConceptOverviewPanel.spec.tsx
      fetchParentPaths(path.path).then(response => {
        setParentPaths(response);
      }).catch(reason => {
        setError('Unable to load parent paths: ' + reason?.exception);
        setParentPaths([]);
      });
    }
  }, [path, setParentPaths, setError]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), path && /*#__PURE__*/external_react_default().createElement(ConceptPathDisplayImpl, ConceptPathDisplay_extends({
    key: path.path
  }, props, {
    parentPaths: parentPaths
  })));
});
const ConceptPathDisplayImpl = (0,external_react_.memo)(props => {
  const {
    isSelected = false,
    onClick = undefined,
    parentPaths,
    path,
    title
  } = props;
  const updatePath = (0,external_react_.useCallback)(() => {
    onClick?.(path, true);
  }, [path, onClick]);
  if (!path) return undefined;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('concept-path-container', {
      selected: isSelected
    }),
    onClick: updatePath
  }, title && /*#__PURE__*/external_react_default().createElement("div", {
    className: "title"
  }, title), /*#__PURE__*/external_react_default().createElement("div", {
    className: "concept-path"
  }, !parentPaths && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), parentPaths?.map((parent, idx) => {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("span", {
      className: "concept-path-label"
    }, parent.label), idx !== parentPaths.length - 1 && /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-chevron-right concept-path-spacer"
    }));
  })));
});
;// CONCATENATED MODULE: ./src/internal/components/ontology/ConceptOverviewPanel.tsx







const CURRENT_PATH_TITLE = 'Current Path';
/**
 * An ontology concept overview panel that takes in a concept code as a prop and will load the concept details
 * to show in the ConceptOverviewPanelImpl.
 */
const OntologyConceptOverviewPanel = (0,external_react_.memo)(props => {
  const {
    code
  } = props;
  const [error, setError] = (0,external_react_.useState)();
  const [concept, setConcept] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    if (code) {
      fetchConceptForCode(code).then(setConcept).catch(() => {
        setError('Error: unable to get concept information for ' + code + '. ');
      });
    }
  }, [code, setConcept, setError]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), concept && /*#__PURE__*/external_react_default().createElement(ConceptOverviewPanelImpl, {
    concept: concept
  }));
});
// exported for jest testing
const ConceptSynonyms = (0,external_react_.memo)(props => {
  const {
    synonyms
  } = props;
  if (!synonyms || synonyms.length === 0) return undefined;
  const synonymList = synonyms.sort(naturalSort).map(synonym => {
    return /*#__PURE__*/external_react_default().createElement("li", {
      key: synonym
    }, synonym);
  });
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "synonyms-title"
  }, "Synonyms"), /*#__PURE__*/external_react_default().createElement("ul", {
    className: "synonyms-text"
  }, synonymList));
});

/**
 * The ontology concept overview display panel that takes in the concept prop (i.e. ConceptModel) and displays
 * the information about the concept label, code, description, etc.
 */
const ConceptOverviewPanelImpl = (0,external_react_.memo)(props => {
  const {
    concept,
    selectedPath = undefined,
    conceptNotFoundText = 'No concept selected'
  } = props;
  const [showPath, setShowPath] = (0,external_react_.useState)();
  const handleShowPath = (0,external_react_.useCallback)(() => {
    setShowPath(!showPath);
  }, [showPath, setShowPath]);
  if (!concept) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "none-selected"
    }, conceptNotFoundText);
  }
  const {
    code,
    label,
    description,
    synonyms
  } = concept;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, selectedPath && /*#__PURE__*/external_react_default().createElement("div", {
    className: "path-button-container"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: external_classnames_default()('btn btn-default', {
      'show-path': showPath
    }),
    onClick: handleShowPath,
    type: "button"
  }, showPath ? 'Hide' : 'Show', " Path")), label && /*#__PURE__*/external_react_default().createElement("div", {
    className: "title small-margin-bottom"
  }, label), code && /*#__PURE__*/external_react_default().createElement("span", {
    className: "code margin-bottom"
  }, code), selectedPath && showPath && /*#__PURE__*/external_react_default().createElement("div", {
    className: "concept-overview-selected-path"
  }, /*#__PURE__*/external_react_default().createElement(ConceptPathDisplay, {
    title: CURRENT_PATH_TITLE,
    path: selectedPath,
    isSelected: true
  })), description && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "description-title"
  }, "Description"), /*#__PURE__*/external_react_default().createElement("p", {
    className: "description-text"
  }, description)), /*#__PURE__*/external_react_default().createElement(ConceptSynonyms, {
    synonyms: synonyms
  }));
});
/**
 * A modal dialog version that will display the same concept overview display panel from ConceptOverviewPanelImpl
 * but in a modal dialog. This component takes in the concept (i.e. ConceptModel) as a prop.
 */
const ConceptOverviewTooltip = (0,external_react_.memo)(props => {
  const {
    concept,
    path,
    error
  } = props;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), !error && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    title: "Concept Overview",
    placement: "bottom",
    iconComponent: !!concept && /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-info-circle"
    }),
    popoverClassName: "concept-overview"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "ontology-concept-overview-container"
  }, /*#__PURE__*/external_react_default().createElement(ConceptOverviewPanelImpl, {
    conceptNotFoundText: "No information available.",
    concept: concept,
    selectedPath: path
  }))));
});
;// CONCATENATED MODULE: ./src/internal/components/ontology/ConceptPathInfo.tsx
function ConceptPathInfo_extends() { return ConceptPathInfo_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ConceptPathInfo_extends.apply(null, arguments); }





const ConceptPathInfo = (0,external_react_.memo)(props => {
  const {
    selectedCode
  } = props;
  const [error, setError] = (0,external_react_.useState)();
  const [alternatePaths, setAlternatePaths] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    if (selectedCode) {
      setAlternatePaths(undefined);
      fetchAlternatePaths(selectedCode).then(response => {
        setAlternatePaths(response);
      }).catch(reason => {
        setError('Unable to load alternate concept paths: ' + reason?.exception ?? 'error unknown');
        setAlternatePaths([]);
      });
    }
  }, [selectedCode, setAlternatePaths]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement(ConceptPathInfoImpl, ConceptPathInfo_extends({
    alternatePaths: alternatePaths
  }, props)));
});
// export for jest testing
const ConceptPathInfoImpl = (0,external_react_.memo)(props => {
  const {
    selectedCode,
    selectedPath,
    alternatePaths
  } = props;
  if (!selectedCode) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "none-selected"
    }, "No concept selected");
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "concept-pathinfo-container"
  }, selectedPath && /*#__PURE__*/external_react_default().createElement("div", {
    className: "title"
  }, selectedPath.label), !alternatePaths && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
    msg: "Loading path information for concept..."
  }), alternatePaths?.length === 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "no-path-info"
  }, "No path information available"), alternatePaths?.length > 0 && /*#__PURE__*/external_react_default().createElement(AlternatePathPanel, props));
});

// export for jest testing
const AlternatePathPanel = (0,external_react_.memo)(props => {
  const {
    selectedPath,
    alternatePaths,
    alternatePathClickHandler
  } = props;
  const altPaths = alternatePaths.filter(path => path.path !== selectedPath?.path);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, selectedPath && /*#__PURE__*/external_react_default().createElement("div", {
    className: "current-path-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "title"
  }, "Current Path"), /*#__PURE__*/external_react_default().createElement(ConceptPathDisplay, {
    key: selectedPath.path,
    path: selectedPath,
    isSelected: true
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "alternate-paths-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "title"
  }, "Alternate Path(s)"), altPaths?.length === 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "no-path-info"
  }, "No alternate paths"), altPaths?.map(path => /*#__PURE__*/external_react_default().createElement(ConceptPathDisplay, {
    key: path.path,
    path: path,
    onClick: alternatePathClickHandler
  }))));
});
;// CONCATENATED MODULE: ./src/internal/components/ontology/ConceptInformationTabs.tsx




let ConceptInfoTabs = /*#__PURE__*/function (ConceptInfoTabs) {
  ConceptInfoTabs["CONCEPT_OVERVIEW_TAB"] = "overview";
  ConceptInfoTabs["PATH_INFO_TAB"] = "pathinfo";
  return ConceptInfoTabs;
}({});
const ConceptInformationTabs = (0,external_react_.memo)(props => {
  const {
    concept,
    selectedPath,
    alternatePathClickHandler
  } = props;
  return /*#__PURE__*/external_react_default().createElement(Tabs, {
    className: "concept-information-tabs"
  }, /*#__PURE__*/external_react_default().createElement(Tab, {
    className: "ontology-concept-overview-container",
    eventKey: ConceptInfoTabs.CONCEPT_OVERVIEW_TAB,
    title: "Overview"
  }, /*#__PURE__*/external_react_default().createElement(ConceptOverviewPanelImpl, {
    concept: concept,
    selectedPath: selectedPath
  })), /*#__PURE__*/external_react_default().createElement(Tab, {
    className: "ontology-concept-pathinfo-container",
    eventKey: ConceptInfoTabs.PATH_INFO_TAB,
    title: "Path Information"
  }, /*#__PURE__*/external_react_default().createElement(ConceptPathInfo, {
    selectedCode: concept?.code,
    selectedPath: selectedPath,
    alternatePathClickHandler: alternatePathClickHandler
  })));
});
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologyTreePanel.tsx
function OntologyTreePanel_extends() { return OntologyTreePanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, OntologyTreePanel_extends.apply(null, arguments); }
function OntologyTreePanel_defineProperty(e, r, t) { return (r = OntologyTreePanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function OntologyTreePanel_toPropertyKey(t) { var i = OntologyTreePanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function OntologyTreePanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






class OntologyPath {
  constructor() {
    OntologyTreePanel_defineProperty(this, "id", void 0);
    OntologyTreePanel_defineProperty(this, "name", void 0);
    OntologyTreePanel_defineProperty(this, "children", void 0);
    OntologyTreePanel_defineProperty(this, "conceptCode", void 0);
    OntologyTreePanel_defineProperty(this, "data", void 0);
  }
}
// exported for jest testing
const FilterIcon = props => {
  const {
    node,
    onClick,
    filters = new Map()
  } = props;
  const nodeSelected = filters.has(node?.data?.code);
  const clickHandler = (0,external_react_.useCallback)(evt => {
    evt.stopPropagation();
    onClick?.(node.data);
  }, [node, onClick]);
  return /*#__PURE__*/external_react_default().createElement("i", {
    className: external_classnames_default()('fa fa-filter', {
      selected: nodeSelected
    }),
    onClick: clickHandler,
    title: nodeSelected ? 'Remove filter' : 'Add filter'
  });
};
const OntologyTreePanel = props => {
  const {
    root,
    onNodeSelection,
    alternatePath,
    showFilterIcon = false,
    filters = new Map(),
    onFilterChange
  } = props;
  const [showLoading, setShowLoading] = (0,external_react_.useState)(false);
  const fileTreeRef = (0,external_react_.useRef)();

  // watch for changes to alternatePath so that we can make sure the tree data down to that node is loaded
  (0,external_react_.useEffect)(() => {
    if (alternatePath?.path) {
      // Get the predecessors for the path, this provides the depth and nodes to potentially load
      fetchParentPaths(alternatePath.path).then(parentPaths => {
        // if this is a deeply nested path, let's mask the tree with a loading message while we toggle parents
        if (parentPaths.length > 5) setShowLoading(true);

        // Create callback in the event tree hasn't fully loaded
        const toggleParents = () => {
          toggleParentPaths(fileTreeRef.current, alternatePath, parentPaths, true, () => {
            scrollToActive(toggleParents);
          });
        };
        toggleParentPaths(fileTreeRef.current, alternatePath, parentPaths, true, () => {
          setShowLoading(false);
          scrollToActive(toggleParents);
        });
      });
    }
  }, [alternatePath, setShowLoading]);
  const loadData = (0,external_react_.useCallback)(async (ontologyPath = root.path) => {
    const ontPath = await fetchChildPaths(ontologyPath);
    return ontPath?.children?.sort(naturalSortByProperty('label')).map(child => {
      return {
        id: child.path,
        name: child.label,
        children: child.hasChildren ? [] : undefined,
        conceptCode: child.code,
        toggled: child.path === alternatePath?.path,
        data: child
      };
    });
  },
  // Needs to trigger for filters to ensure PathModels are loaded and update the FilterDialog values.
  [root, filters]);
  const onSelect = (name, path, checked, isDirectory, node) => {
    if (node.active) onNodeSelection(node?.data);
    return true;
  };
  const renderNodeHeader = props => {
    return /*#__PURE__*/external_react_default().createElement(Header, props, showFilterIcon && /*#__PURE__*/external_react_default().createElement(FilterIcon, OntologyTreePanel_extends({}, props, {
      filters: filters,
      onClick: onFilterChange
    })));
  };
  return /*#__PURE__*/external_react_default().createElement(FileTree, {
    loadData: loadData,
    onFileSelect: onSelect,
    allowMultiSelect: false,
    showNodeIcon: false,
    defaultRootName: root.label,
    showLoading: showLoading,
    showAnimations: false,
    ref: fileTreeRef,
    headerDecorator: renderNodeHeader
  });
};
const getTreeNodeForPath = function (fileTree, path) {
  return fileTree?.getDataNode(path, fileTree.state.data);
};
const toggleParentPaths = function (fileTree, alternatePath, parentPaths, isRoot, callback) {
  const clone = [...parentPaths];
  const parentPath = isRoot ? DEFAULT_ROOT_PREFIX : clone[0].path;
  clone.shift();
  const node = getTreeNodeForPath(fileTree, parentPath);
  if (node) {
    fileTree.onToggle(node, true, alternatePath.path === node.id, () => {
      if (clone.length > 0) {
        toggleParentPaths(fileTree, alternatePath, clone, false, callback);
      } else {
        callback();
      }
    });
  } else if (clone.length > 0) {
    toggleParentPaths(fileTree, alternatePath, clone, false, callback);
  } else {
    callback();
  }
};
const scrollToActive = function (notReadyCallback) {
  const activeEl = document.getElementsByClassName('filetree-node-active');
  if (activeEl.length > 0) {
    activeEl[0].scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  } else {
    setTimeout(notReadyCallback, 500);
  }
};
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologySelectionPanel.tsx
function OntologySelectionPanel_extends() { return OntologySelectionPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, OntologySelectionPanel_extends.apply(null, arguments); }







const OntologySelectionPanel = (0,external_react_.memo)(props => {
  const {
    onOntologySelection
  } = props;
  const [error, setError] = (0,external_react_.useState)();
  const [ontologies, setOntologies] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    fetchChildPaths('/').then(response => {
      // if only one ontology present, just select it
      if (response.children.length === 1) {
        onOntologySelection('ontology-select', undefined, response.children[0]);
      } else {
        setOntologies(response.children);
      }
    }).catch(reason => {
      setError('Error: unable to load ontology information for selection. ' + reason?.exception);
      setOntologies([]);
    });
  }, [setOntologies, setError, onOntologySelection]);
  return /*#__PURE__*/external_react_default().createElement(OntologySelectionPanelImpl, OntologySelectionPanel_extends({}, props, {
    error: error,
    ontologies: ontologies
  }));
});
// exported for jest testing
const OntologySelectionPanelImpl = (0,external_react_.memo)(props => {
  const {
    onOntologySelection,
    asPanel,
    error,
    ontologies
  } = props;
  const body = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), !ontologies && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
    msg: "Loading ontologies..."
  }), ontologies?.length === 0 && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning"
  }, "No ontologies have been loaded for this server.", (0,api_.getServerContext)().user.isRootAdmin && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "\xA0Click ", /*#__PURE__*/external_react_default().createElement("a", {
    href: buildURL(ONTOLOGY_CONTROLLER, 'begin')
  }, "here"), " to get started.")), ontologies && /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    key: "ontology-select",
    name: "ontology-select",
    id: "ontology-select",
    label: "Select Ontology",
    description: "Select an ontology to load and browse concepts.",
    inputClass: "col-sm-6 col-xs-12",
    labelClass: "control-label col-sm-3 text-left col-xs-12",
    valueKey: "code",
    onChange: onOntologySelection,
    options: ontologies
  }));
  if (!asPanel) {
    return body;
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default ontology-browser-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Browse Ontology Concepts"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, body)));
});
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologyTreeSearchContainer.tsx
const OntologyTreeSearchContainer_excluded = ["ontologyId", "searchPathChangeHandler"];
function OntologyTreeSearchContainer_extends() { return OntologyTreeSearchContainer_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, OntologyTreeSearchContainer_extends.apply(null, arguments); }
function OntologyTreeSearchContainer_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = OntologyTreeSearchContainer_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function OntologyTreeSearchContainer_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }






const SEARCH_LIMIT = 20;
const OntologyTreeSearchContainer = (0,external_react_.memo)(props => {
  const {
    ontology,
    searchPathClickHandler,
    inputName = 'concept-search',
    className = 'form-control',
    initCode = '',
    onChangeListener
  } = props;
  const [isFocused, setIsFocused] = (0,external_react_.useState)();
  const [searchTerm, setSearchTerm] = (0,external_react_.useState)(initCode);
  const [searchHits, setSearchHits] = (0,external_react_.useState)();
  const [totalHits, setTotalHits] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  const [showResults, setShowResults] = (0,external_react_.useState)(false);
  (0,external_react_.useEffect)(() => {
    if (searchTerm !== initCode) {
      setSearchTerm(initCode);
    }
  }, [initCode]); // Only trigger when the initCode value is changed, this can happen when the user selects a value via the picker

  const onSearchChange = (0,external_react_.useCallback)(evt => {
    const {
      value
    } = evt.currentTarget;
    setSearchTerm(value?.length > 2 ? value : undefined);
    onChangeListener?.(value);
  }, [onChangeListener]);
  const onSearchFocus = (0,external_react_.useCallback)(() => {
    setIsFocused(true);
  }, []);
  const onSearchBlur = (0,external_react_.useCallback)(() => {
    setIsFocused(false);
  }, []);
  (0,external_react_.useEffect)(() => {
    setError(undefined);
    setTotalHits(undefined);
    setSearchHits(undefined);
    if (searchTerm) {
      const timeOutId = setTimeout(() => {
        search({
          q: getOntologySearchTerm(ontology, searchTerm),
          category: SearchCategory.Concept,
          limit: SEARCH_LIMIT,
          scope: SearchScope.FolderAndSubfoldersAndShared
        }).then(response => {
          setSearchHits(response.hits.map(hit => {
            return new ConceptModel({
              code: hit.id.substring(hit.id.indexOf(':') + 1),
              // Trim off category code from doc id
              label: hit.title,
              description: hit.summary.split('\n')[1] // format is "<code> <label>\n<description>" see ConceptDocumentProvider
            });
          }));
          setTotalHits(response.totalHits);
        }).catch(reason => {
          console.error(reason);
          setError('Error: unable to get search results. Check for syntax errors in your search term.');
        });
      }, 500);
      return () => clearTimeout(timeOutId);
    }
  }, [ontology, searchTerm]);
  const onItemClick = (0,external_react_.useCallback)(async (evt, code) => {
    // for now, we will just send the user to the first path for this concept, in the future we'll add in UI
    // that lets the user select if more than one path exists for the concept
    const codePaths = await fetchAlternatePaths(code);
    if (codePaths?.length > 0) {
      searchPathClickHandler(codePaths[0], true);
    }
    setSearchTerm(code);
  }, [searchPathClickHandler]);
  const keyHandler = (0,external_react_.useCallback)(evt => {
    switch (evt.key) {
      case 'Escape':
        setShowResults(false);
        evt.stopPropagation();
        evt.preventDefault();
        return true;
      default:
        setShowResults(true);
        return false;
    }
  }, []);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "concept-search-container"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "text",
    className: className,
    name: inputName,
    placeholder: 'Search ' + ontology.abbreviation,
    onChange: onSearchChange,
    onFocus: onSearchFocus,
    onBlur: onSearchBlur,
    onKeyUp: keyHandler,
    value: searchTerm
  }), showResults && /*#__PURE__*/external_react_default().createElement(OntologySearchResultsMenu, {
    searchHits: searchHits,
    totalHits: totalHits,
    isFocused: isFocused,
    error: error,
    onItemClick: onItemClick
  }));
});
// exported for jest testing
const OntologySearchResultsMenu = (0,external_react_.memo)(props => {
  const {
    searchHits,
    isFocused,
    totalHits,
    error,
    onItemClick
  } = props;
  const showMenu = (0,external_react_.useMemo)(() => isFocused && (searchHits !== undefined || error !== undefined), [isFocused, searchHits, error]);
  const hitsHaveDescriptions = (0,external_react_.useMemo)(() => searchHits?.findIndex(hit => hit.description !== undefined) > -1, [searchHits]);
  if (!showMenu) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("ul", {
    className: "result-menu container"
  }, /*#__PURE__*/external_react_default().createElement(Alert, null, error), searchHits?.length === 0 && /*#__PURE__*/external_react_default().createElement("li", {
    key: "none"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col col-xs-12"
  }, "No search results found."))), searchHits?.map(hit => /*#__PURE__*/external_react_default().createElement("li", {
    key: hit.code,
    className: "selectable-item",
    role: "option",
    onMouseDown: evt => onItemClick(evt, hit.code)
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: 'col bold ' + (hitsHaveDescriptions ? 'col-xs-5' : 'col-xs-10')
  }, hit.label), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col col-xs-2"
  }, hit.code), hitsHaveDescriptions && /*#__PURE__*/external_react_default().createElement("div", {
    className: "col col-xs-5"
  }, hit.description)))), searchHits?.length < totalHits && /*#__PURE__*/external_react_default().createElement("div", {
    className: "result-footer"
  }, Number(totalHits).toLocaleString(), " results found. Update your search term to further refine your results.")));
});
const OntologySearchInput = (0,external_react_.memo)(props => {
  const {
      ontologyId,
      searchPathChangeHandler
    } = props,
    rest = OntologyTreeSearchContainer_objectWithoutProperties(props, OntologyTreeSearchContainer_excluded);
  const [ontologyModel, setOntologyModel] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    if (ontologyId) {
      getOntologyDetails(ontologyId).then(ontology => {
        setOntologyModel(ontology);
      }).catch(() => {
        setError('Error: unable to load ontology concept information for ' + ontologyId + '.');
      });
    }
  }, [ontologyId]);
  const onSearchClickHandler = (0,external_react_.useCallback)(path => {
    searchPathChangeHandler(path.code);
  }, [searchPathChangeHandler]);
  const onChangeHandler = (0,external_react_.useCallback)(val => {
    searchPathChangeHandler(val);
  }, [searchPathChangeHandler]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), ontologyModel && /*#__PURE__*/external_react_default().createElement(OntologyTreeSearchContainer, OntologyTreeSearchContainer_extends({}, rest, {
    ontology: ontologyModel,
    searchPathClickHandler: onSearchClickHandler,
    onChangeListener: onChangeHandler
  })));
});

// exported for jest testing
function getOntologySearchTerm(ontology, searchTerm) {
  // Quotes are needed to escape the ':' and the open term allows more flexible search of multi-token terms, e.g. ABC T
  return `+ontology:${ontology.abbreviation} AND ("${searchTerm}" OR ${searchTerm})`;
}
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologyBrowserPanel.tsx
const OntologyBrowserPanel_excluded = ["initConceptCode"];
function OntologyBrowserPanel_extends() { return OntologyBrowserPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, OntologyBrowserPanel_extends.apply(null, arguments); }
function OntologyBrowserPanel_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = OntologyBrowserPanel_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function OntologyBrowserPanel_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }










const OntologyBrowserPage = (0,external_react_.memo)(props => {
  const {
      initConceptCode
    } = props,
    rest = OntologyBrowserPanel_objectWithoutProperties(props, OntologyBrowserPanel_excluded);
  const [concept, setConcept] = (0,external_react_.useState)();
  const [loading, setLoading] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    if (initConceptCode && !concept) {
      setLoading(true);
      (async () => {
        try {
          const loadingConcept = await fetchConceptForCode(initConceptCode);
          setConcept(loadingConcept);
          setLoading(false);
        } catch (e) {
          setError('Error: unable to load ontology concept information for ' + initConceptCode + ', code not found.');
          setConcept(null);
          setLoading(false);
        }
      })();
    }
  }, [initConceptCode]);
  if (loading) {
    return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement(OntologyBrowserPanel, OntologyBrowserPanel_extends({}, rest, {
    initConcept: concept
  })));
});
const OntologyBrowserPanel = (0,external_react_.memo)(props => {
  const {
    asPanel,
    initOntologyId,
    initConcept,
    initPath,
    onPathSelect,
    hideConceptInfo = false,
    filters,
    filterChangeHandler
  } = props;
  const [error, setError] = (0,external_react_.useState)();
  const [selectedOntologyId, setSelectedOntologyId] = (0,external_react_.useState)();
  const [ontology, setOntologyModel] = (0,external_react_.useState)();
  const [selectedConcept, setSelectedConcept] = (0,external_react_.useState)(initConcept);
  const [selectedPath, setSelectedPath] = (0,external_react_.useState)();
  const [alternatePath, setAlternatePath] = (0,external_react_.useState)(initPath);
  const ontologyId = selectedOntologyId ?? (!error ? initOntologyId : undefined);
  const onSelectedPathChange = (0,external_react_.useCallback)((path, isAlternatePath = false) => {
    if (path === undefined) {
      return;
    }
    if (isAlternatePath) {
      setAlternatePath(path);
    } else {
      setSelectedPath(path);
    }
  }, [setSelectedPath, setAlternatePath]);
  const onOntologySelection = (0,external_react_.useCallback)((name, value, model) => {
    setSelectedOntologyId(model?.path.replace(/\//g, ''));
  }, [setSelectedOntologyId]);
  (0,external_react_.useEffect)(() => {
    if (ontologyId) {
      getOntologyDetails(ontologyId).then(ontology => {
        setOntologyModel(ontology);
      }).catch(() => {
        setError('Error: unable to load ontology concept information for ' + ontologyId + '.');
        setSelectedOntologyId(undefined);
      });
    } else {
      setOntologyModel(undefined);
    }
  }, [ontologyId, setOntologyModel, setSelectedOntologyId, setError]);
  (0,external_react_.useEffect)(() => {
    if (initConcept) {
      fetchAlternatePaths(initConcept.code).then(paths => {
        onSelectedPathChange(paths?.[0], true);
      });
    }
  }, [initConcept]);
  (0,external_react_.useEffect)(() => {
    if (selectedPath?.code) {
      fetchConceptForCode(selectedPath.code).then(concept => {
        setSelectedConcept(concept);
        onPathSelect?.(selectedPath, concept);
      });
    }
  }, [selectedPath, setSelectedConcept, onPathSelect]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), !ontologyId && /*#__PURE__*/external_react_default().createElement(OntologySelectionPanel, {
    onOntologySelection: onOntologySelection,
    asPanel: asPanel
  }), ontologyId && /*#__PURE__*/external_react_default().createElement(OntologyBrowserPanelImpl, {
    ontology: ontology,
    selectedConcept: selectedConcept,
    alternatePath: alternatePath,
    selectedPath: selectedPath,
    setSelectedPath: onSelectedPathChange,
    asPanel: asPanel,
    hideConceptInfo: hideConceptInfo,
    filters: filters,
    onFilterChange: filterChangeHandler
  }));
});
OntologyBrowserPanel.defaultProps = {
  asPanel: true
};
// exported for jest testing
const OntologyBrowserPanelImpl = (0,external_react_.memo)(props => {
  const {
    ontology,
    selectedConcept,
    alternatePath,
    selectedPath,
    setSelectedPath,
    asPanel,
    hideConceptInfo,
    filters,
    onFilterChange
  } = props;
  if (!ontology) {
    return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  }
  const {
    conceptCount,
    description
  } = ontology;
  const root = ontology.getPathModel();
  const leftColClassName = external_classnames_default()({
    'col-xs-12': hideConceptInfo,
    'col-xs-6': !hideConceptInfo,
    'left-panel': !hideConceptInfo
  });
  const body = /*#__PURE__*/external_react_default().createElement("div", {
    className: hideConceptInfo ? 'row filter-panel-row' : 'row'
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: leftColClassName
  }, /*#__PURE__*/external_react_default().createElement(OntologyTreeSearchContainer, {
    ontology: ontology,
    searchPathClickHandler: setSelectedPath
  }), /*#__PURE__*/external_react_default().createElement(OntologyTreePanel, {
    root: root,
    onNodeSelection: setSelectedPath,
    alternatePath: alternatePath,
    showFilterIcon: hideConceptInfo,
    filters: filters,
    onFilterChange: onFilterChange
  })), !hideConceptInfo && /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6 right-panel"
  }, /*#__PURE__*/external_react_default().createElement(ConceptInformationTabs, {
    concept: selectedConcept,
    selectedPath: selectedPath,
    alternatePathClickHandler: setSelectedPath
  })));
  if (!asPanel) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "ontology-browser-container"
    }, body);
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default ontology-browser-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Browse ", ontology.getDisplayName(), "\xA0", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    title: "Ontology Details",
    placement: "bottom",
    iconComponent: /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-info-circle"
    })
  }, description && /*#__PURE__*/external_react_default().createElement("p", {
    className: "ontology-description"
  }, description), /*#__PURE__*/external_react_default().createElement("p", {
    className: "ontology-concept-count"
  }, Number(conceptCount).toLocaleString(), " total concepts"))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, body));
});
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologyBrowserFilterPanel.tsx







function isPathFilter(filterType) {
  if (!filterType) return false;
  return filterType.getURLSuffix() === api_.Filter.Types.ONTOLOGY_IN_SUBTREE.getURLSuffix() || filterType.getURLSuffix() === api_.Filter.Types.ONTOLOGY_NOT_IN_SUBTREE.getURLSuffix();
}
const OntologyBrowserFilterPanel = (0,external_react_.memo)(props => {
  const {
    ontologyId,
    conceptSubtree,
    filterType,
    filterValue,
    onFilterChange
  } = props;
  const [subtreePath, setSubtreePath] = (0,external_react_.useState)();
  const [filteredConcepts, setFilteredConcepts] = (0,external_react_.useState)(new Map());
  const [error, setError] = (0,external_react_.useState)();
  const updateFilterValues = (0,external_react_.useCallback)(async filterString => {
    setError(null); // clear any existing errors
    const filterArray = filterString?.split(';') ?? [];

    // Look up path model for the path based filters, otherwise parse the code filter
    let paths;
    const isPathFilterType = isPathFilter(filterType);
    if (isPathFilterType) {
      try {
        paths = filterString ? [await fetchPathModel(filterString)] : [];
      } catch (e) {
        if (e?.exceptionClass === 'org.labkey.api.view.NotFoundException') {
          const article = isPathFilterType ? 'Path ' : 'Code ';
          setError(article + ' not found');
        } else {
          setError(e?.exception);
        }
      }
    } else {
      paths = filterArray.filter(code => !!code).map(code => new PathModel({
        code
      }));
    }
    const filterModels = new Map(paths?.map(model => [model.code, model]));
    setFilteredConcepts(filterModels);
  }, [setError, filterType, setFilteredConcepts]);
  const filterChangeHandler = (0,external_react_.useCallback)(async model => {
    setError(null);
    const newFilter = new Map([...filteredConcepts]);
    if (!newFilter.delete(model.code)) {
      if (!filterType?.isMultiValued()) {
        newFilter.clear();
      }
      newFilter.set(model.code, model);
    }
    setFilteredConcepts(newFilter);
    let newFilterString;
    if (isPathFilter(filterType)) {
      const filterStrings = [];
      for await (const filterNode of newFilter.values()) {
        // Get parent nodes for the selected node's path
        const parents = await fetchParentPaths(filterNode.path);
        filterStrings.push(getParentsConceptCodePath(parents));
      }
      newFilterString = filterStrings.join(';');
    } else {
      newFilterString = [...newFilter.keys()].join(';');
    }
    onFilterChange(newFilterString);
  }, [filterValue, filterType, filteredConcepts, setFilteredConcepts, onFilterChange, setError]);
  (0,external_react_.useEffect)(() => {
    updateFilterValues(filterValue);
  },
  // Trigger effect if the filterType value changes. This will facilitate switching between Concept code based filters and Path based filters
  [filterType, filterValue]);
  (0,external_react_.useEffect)(() => {
    if (conceptSubtree) {
      fetchPathModel(conceptSubtree).then(setSubtreePath).catch(() => {
        // set to null to complete rendering of OntologyBrowserPanel (note: fetchPathModel will console.error)
        setSubtreePath(null);
      });
    }
  }, [conceptSubtree]);
  if (conceptSubtree && subtreePath === undefined) {
    return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement(OntologyBrowserPanel, {
    asPanel: false,
    hideConceptInfo: true,
    initOntologyId: ontologyId,
    initPath: subtreePath,
    filters: filteredConcepts,
    filterChangeHandler: filterChangeHandler
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/search/FilterExpressionView.tsx
function FilterExpressionView_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FilterExpressionView_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FilterExpressionView_ownKeys(Object(t), !0).forEach(function (r) { FilterExpressionView_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FilterExpressionView_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FilterExpressionView_defineProperty(e, r, t) { return (r = FilterExpressionView_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function FilterExpressionView_toPropertyKey(t) { var i = FilterExpressionView_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function FilterExpressionView_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








const FilterExpressionView = (0,external_react_.memo)(props => {
  const {
    allowRelativeDateFilter,
    field,
    fieldFilters,
    onFieldFilterUpdate,
    disabled,
    includeAllAncestorFilter
  } = props;
  const [fieldFilterOptions, setFieldFilterOptions] = (0,external_react_.useState)(undefined);
  const [activeFilters, setActiveFilters] = (0,external_react_.useState)([]);
  const [removeFilterCount, setRemoveFilterCount] = (0,external_react_.useState)(0);
  const [expandedOntologyKey, setExpandedOntologyKey] = (0,external_react_.useState)(undefined);
  (0,external_react_.useEffect)(() => {
    const filterOptions = getFilterOptionsForType(field, includeAllAncestorFilter);
    setFieldFilterOptions(filterOptions);
    setActiveFilters(getFilterSelections(fieldFilters, filterOptions));
  }, [field]); // leave fieldFilters out of deps list, fieldFilters is used to init once

  const unusedFilterOptions = (0,external_react_.useCallback)(thisIndex => {
    const otherIndex = thisIndex === 1 ? 0 : 1;
    return fieldFilterOptions?.filter(option => (thisIndex === 0 || !option.isSoleFilter) && activeFilters[otherIndex]?.filterType.value !== option.value);
  }, [fieldFilterOptions, activeFilters]);
  const updateFilter = (0,external_react_.useCallback)((filterIndex, newFilterType, newFilterValue, isSecondValue, clearBothValues) => {
    onFieldFilterUpdate(getUpdatedFilters(field, activeFilters, filterIndex, newFilterType, newFilterValue, isSecondValue, clearBothValues), filterIndex);
  }, [field, activeFilters]);
  const updateActiveFilters = (0,external_react_.useCallback)((filterIndex, newFilterSelection) => {
    const filterSelection = FilterExpressionView_objectSpread(FilterExpressionView_objectSpread({}, activeFilters[filterIndex]), newFilterSelection);
    if (filterSelection.filterType) {
      if (filterSelection.filterType.isSoleFilter) {
        setActiveFilters([filterSelection]);
      } else {
        setActiveFilters(currentFilters => {
          return [...currentFilters.slice(0, filterIndex), filterSelection, ...currentFilters.slice(filterIndex + 1)];
        });
      }
    } else {
      setActiveFilters(currentFilters => {
        return [...currentFilters.slice(0, filterIndex), ...currentFilters.slice(filterIndex + 1)];
      });
      // When a filter is removed, we need to recreate the selectInputs so they pick up the value from the
      // filter that got shifted into the place that was removed. This doesn't happen through normal channels
      // because this is part of the onChange callback for the selectInput, and it has protections against
      // infinitely updating as a result of the onChange action.
      setRemoveFilterCount(count => count + 1);
    }
  }, [activeFilters]);
  const onFieldFilterTypeChange = (0,external_react_.useCallback)((fieldname, filterUrlSuffix, filterIndex) => {
    const newActiveFilterType = fieldFilterOptions?.find(option => option.value === filterUrlSuffix);
    const {
      shouldClear,
      filterSelection
    } = getUpdatedFilterSelection(newActiveFilterType, activeFilters[filterIndex]);
    updateFilter(filterIndex, newActiveFilterType, filterSelection.firstFilterValue, false, shouldClear);
    updateActiveFilters(filterIndex, filterSelection);
    setExpandedOntologyKey(undefined);
  }, [fieldFilterOptions, activeFilters]);
  const updateBooleanFilterFieldValue = (0,external_react_.useCallback)((filterIndex, event) => {
    const newValue = event.target.value;
    updateFilter(filterIndex, activeFilters[filterIndex]?.filterType, newValue, false);
    updateActiveFilters(filterIndex, {
      firstFilterValue: newValue
    }); // boolean columns don't support between operators
  }, [activeFilters]);
  const updateTextFilterFieldValue = (0,external_react_.useCallback)((filterIndex, event, isNumberInput) => {
    if (disabled) return;
    let newValue = isNumberInput ? event.target.valueAsNumber : event.target.value;
    if (isNumberInput && isNaN(newValue)) newValue = null;
    const isSecondInput = event.target.name.endsWith('-second');
    const update = {};
    if (isSecondInput) {
      update.secondFilterValue = newValue;
    } else {
      update.firstFilterValue = newValue;
    }
    updateFilter(filterIndex, activeFilters[filterIndex]?.filterType, newValue, isSecondInput);
    updateActiveFilters(filterIndex, update);
  }, [activeFilters, disabled]);
  const updateDateFilterFieldValue = (0,external_react_.useCallback)((filterIndex, newValue, isSecondInput) => {
    const update = {};
    if (isSecondInput) {
      update.secondFilterValue = newValue;
    } else {
      update.firstFilterValue = newValue;
    }
    updateFilter(filterIndex, activeFilters[filterIndex]?.filterType, newValue, isSecondInput);
    updateActiveFilters(filterIndex, update);
  }, [activeFilters]);
  const updateOntologyFieldValue = (0,external_react_.useCallback)((filterIndex, newValue, isSecondInput) => {
    const update = {};
    if (isSecondInput) {
      update.secondFilterValue = newValue;
    } else {
      update.firstFilterValue = newValue;
    }
    updateFilter(filterIndex, activeFilters[filterIndex]?.filterType, newValue, isSecondInput);
    updateActiveFilters(filterIndex, update);
  }, [activeFilters]);
  const onOntologyFilterExpand = (0,external_react_.useCallback)((ontologyBrowserKey, expand) => {
    if (!expand) setExpandedOntologyKey(undefined);else setExpandedOntologyKey(ontologyBrowserKey);
  }, []);

  // FIXME: this is a component, it should be converted to a proper FC
  const renderFilterInput = (0,external_react_.useCallback)((placeholder, filterIndex, isMultiValueInput, isSecondInput, expandedOntologyKey) => {
    const {
      filterType,
      firstFilterValue,
      secondFilterValue
    } = activeFilters[filterIndex];
    if (!filterType || !filterType.valueRequired) return null;
    const suffix = '-' + filterIndex + (isSecondInput ? '-second' : '');
    const valueRaw = isSecondInput ? secondFilterValue : firstFilterValue;
    const jsonType = field.getDisplayFieldJsonType();
    const isConceptColumn = field.isConceptCodeColumn && isOntologyEnabled();
    const isTimeOnly = field.isTimeColumn;
    if (jsonType === 'date' || jsonType === 'time') {
      return /*#__PURE__*/external_react_default().createElement(DatePickerInput, {
        allowRelativeInput: allowRelativeDateFilter,
        formsy: false,
        inputClassName: "form-control filter-expression__input",
        wrapperClassName: "form-group col-sm-12 filter-expression__input-wrapper",
        queryColumn: field,
        name: 'field-value-date' + suffix,
        value: valueRaw,
        showLabel: false,
        isClearable: true,
        hideTime: !isTimeOnly // filter date and datetime by date only, without timepicker
        ,
        disabled: disabled,
        onChange: newDate => {
          let dateStr = newDate;
          if (typeof newDate !== 'string') dateStr = isTimeOnly ? getJsonTimeFormatString(newDate) : getJsonDateFormatString(newDate);
          updateDateFilterFieldValue(filterIndex, dateStr, isSecondInput);
        }
      });
    } else if (jsonType === 'boolean') {
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
        key: "field-value-bool-true"
      }, /*#__PURE__*/external_react_default().createElement("label", {
        className: "field-value-bool-label clickable"
      }, /*#__PURE__*/external_react_default().createElement("input", {
        checked: valueRaw == 'true',
        className: "",
        type: "radio",
        name: 'field-value-bool' + suffix,
        value: "true",
        disabled: disabled,
        onChange: event => updateBooleanFilterFieldValue(filterIndex, event)
      }), ' ', "TRUE")), /*#__PURE__*/external_react_default().createElement("div", {
        key: "field-value-bool-false"
      }, /*#__PURE__*/external_react_default().createElement("label", {
        className: "field-value-bool-label clickable"
      }, /*#__PURE__*/external_react_default().createElement("input", {
        checked: valueRaw && valueRaw != 'true',
        className: "",
        type: "radio",
        name: 'field-value-bool' + suffix,
        value: "false",
        disabled: disabled,
        onChange: event => updateBooleanFilterFieldValue(filterIndex, event)
      }), ' ', "FALSE")));
    }
    if (filterType.multiValue && !filterType.betweenOperator) {
      return /*#__PURE__*/external_react_default().createElement("textarea", {
        className: "form-control filter-expression__textarea",
        name: 'field-value-text' + suffix,
        onChange: event => updateTextFilterFieldValue(filterIndex, event),
        defaultValue: (valueRaw && valueRaw.replaceAll(';', '\n')) ?? '',
        rows: 3,
        required: true,
        placeholder: placeholder
      });
    }
    if (!isMultiValueInput && (jsonType === 'int' || jsonType === 'float')) {
      return /*#__PURE__*/external_react_default().createElement("input", {
        className: "form-control filter-expression__input",
        step: jsonType === 'int' ? 1 : undefined,
        name: 'field-value-text' + suffix,
        onChange: event => updateTextFilterFieldValue(filterIndex, event, true),
        pattern: jsonType === 'int' ? '-?[0-9]*' : undefined,
        type: "number",
        value: valueRaw ?? '',
        placeholder: placeholder,
        required: true,
        disabled: disabled
      });
    }
    const textInput = /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control filter-expression__input",
      name: 'field-value-text' + suffix,
      type: "text",
      value: valueRaw ?? '',
      onChange: event => updateTextFilterFieldValue(filterIndex, event),
      placeholder: placeholder,
      required: true,
      disabled: disabled
    });
    if (isConceptColumn) {
      const ontologyBrowserKey = filterIndex + '-' + (isSecondInput ? '2' : '1');
      const expanded = expandedOntologyKey === ontologyBrowserKey;
      const onBrowserToggle = event => {
        event.preventDefault();
        if (disabled) return;
        onOntologyFilterExpand(ontologyBrowserKey, !expanded);
      };
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "ontology-input"
      }, textInput, /*#__PURE__*/external_react_default().createElement("div", {
        className: "ontology-browser__menu"
      }, /*#__PURE__*/external_react_default().createElement("a", {
        href: "#",
        onClick: onBrowserToggle
      }, expanded ? 'Close Browser' : `Find ${field.caption} By Tree`, /*#__PURE__*/external_react_default().createElement("span", {
        className: "caret"
      })), expanded && /*#__PURE__*/external_react_default().createElement(OntologyBrowserFilterPanel, {
        ontologyId: field.sourceOntology,
        conceptSubtree: field.conceptSubtree,
        filterValue: valueRaw,
        filterType: api_.Filter.getFilterTypeForURLSuffix(filterType.value),
        onFilterChange: filterValue => updateOntologyFieldValue(filterIndex, filterValue, isSecondInput)
      })));
    }
    return textInput;
  }, [field, activeFilters, disabled]);

  // FIXME: this is a component, it should be converted to a proper FC
  const renderFilterTypeInputs = (0,external_react_.useCallback)(filterIndex => {
    if (filterIndex >= activeFilters.length) return null;
    const {
      filterType
    } = activeFilters[filterIndex];
    if (!filterType || !filterType.valueRequired) return null;
    const isBetweenOperator = filterType.betweenOperator;
    const isMultiValueInput = filterType.value === 'in' || filterType.value === 'notin';
    const placeholder = getFilterTypePlaceHolder(filterType.value);
    if (!isBetweenOperator) return renderFilterInput(placeholder, filterIndex, isMultiValueInput, false, expandedOntologyKey);
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, renderFilterInput(placeholder, filterIndex, isMultiValueInput, false, expandedOntologyKey), /*#__PURE__*/external_react_default().createElement("div", {
      className: "filter-expression__and-op"
    }, "and"), renderFilterInput(placeholder, filterIndex, isMultiValueInput, true, expandedOntologyKey));
  }, [field, activeFilters, expandedOntologyKey, disabled]);
  const shouldShowSecondFilter = (0,external_react_.useMemo)(() => {
    if (!activeFilters?.length) return false;
    if (activeFilters[0].filterType.isSoleFilter) return false;
    if (!activeFilters[0].filterType.valueRequired) return true;
    if (activeFilters[0].firstFilterValue === undefined) return false;
    return !activeFilters[0].filterType.betweenOperator || activeFilters[0].secondFilterValue !== undefined;
  }, [activeFilters]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "filter-expression__panel"
  }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    key: 'filter-expression-field-filter-type-' + removeFilterCount // we need to recreate this component when a filter is removed
    ,
    name: "filter-expression-field-filter-type",
    containerClass: "form-group filter-expression__input-wrapper",
    inputClass: "filter-expression__input-select",
    placeholder: "Select a filter type...",
    value: activeFilters[0]?.filterType?.value,
    onChange: (fieldname, filterUrlSuffix) => onFieldFilterTypeChange(fieldname, filterUrlSuffix, 0),
    options: unusedFilterOptions(0),
    disabled: disabled
  }), renderFilterTypeInputs(0), shouldShowSecondFilter && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__col-sub-title"
  }, "and"), /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    key: "filter-expression-field-filter-type",
    name: "filter-expression-field-filter-type",
    containerClass: "form-group filter-expression__input-wrapper",
    inputClass: "filter-expression__input-select",
    placeholder: "Select a filter type...",
    value: activeFilters[1]?.filterType?.value,
    onChange: (fieldname, filterUrlSuffix) => onFieldFilterTypeChange(fieldname, filterUrlSuffix, 1),
    options: unusedFilterOptions(1),
    menuPosition: "fixed",
    disabled: disabled
  }), renderFilterTypeInputs(1)));
});
;// CONCATENATED MODULE: ./src/internal/components/search/QueryFilterPanel.tsx
function QueryFilterPanel_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function QueryFilterPanel_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? QueryFilterPanel_ownKeys(Object(t), !0).forEach(function (r) { QueryFilterPanel_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : QueryFilterPanel_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function QueryFilterPanel_defineProperty(e, r, t) { return (r = QueryFilterPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function QueryFilterPanel_toPropertyKey(t) { var i = QueryFilterPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function QueryFilterPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }












var FieldFilterTabs = /*#__PURE__*/function (FieldFilterTabs) {
  FieldFilterTabs["ChooseValues"] = "ChooseValues";
  FieldFilterTabs["Filter"] = "Filter";
  return FieldFilterTabs;
}(FieldFilterTabs || {});
const DEFAULT_VIEW_NAME = ''; // always use default view for selection, if none provided

const QueryFilterPanel = (0,external_react_.memo)(props => {
  const {
    allowRelativeDateFilter,
    hasNotInQueryFilter,
    asRow,
    api,
    queryInfo,
    emptyMsg,
    skipDefaultViewCheck,
    validFilterField,
    entityDataType,
    fieldKey,
    filters,
    onFilterUpdate,
    metricFeatureArea,
    fullWidth,
    selectDistinctOptions,
    onHasNoValueInQueryChange,
    hasNotInQueryFilterLabel,
    altQueryName,
    fields,
    isAncestor
  } = props;
  const [queryFields, setQueryFields] = (0,external_react_.useState)(undefined);
  const [activeField, setActiveField] = (0,external_react_.useState)(undefined);
  const [activeTab, setActiveTab] = (0,external_react_.useState)(undefined);
  const queryName = (0,external_react_.useMemo)(() => queryInfo?.name.toLowerCase(), [queryInfo]);

  // for sample finder, assay data filters uses assay design name (part of schema key) instead of "data" (the query name) as query key
  const filterQueryKey = (0,external_react_.useMemo)(() => {
    if (entityDataType && entityDataType.getInstanceDataType && queryInfo?.schemaQuery) return entityDataType.getInstanceDataType(queryInfo.schemaQuery, altQueryName)?.toLowerCase();
    return queryName;
  }, [queryInfo, entityDataType, queryName, altQueryName]);
  const viewName = (0,external_react_.useMemo)(() => props.viewName ?? DEFAULT_VIEW_NAME, [props.viewName]);
  const allowFaceting = col => {
    return col?.allowFaceting() && col?.getDisplayFieldJsonType() === 'string'; // current plan is to only support facet for string fields, to reduce scope
  };
  const filterStatus = (0,external_react_.useMemo)(() => {
    const status = {};
    if (!filters) return {};
    Object.keys(filters).forEach(parent => {
      const filterFields = filters[parent];
      filterFields.forEach(fieldFilter => {
        if (fieldFilter.filter.getFilterType() !== NOT_ANY_FILTER_TYPE) {
          const key = parent.toLowerCase() + '-' + fieldFilter.fieldKey;
          status[key] = true;
        }
      });
    });
    return status;
  }, [filters]);
  const hasFilters = (0,external_react_.useCallback)(field => {
    return filterStatus?.[filterQueryKey.toLowerCase() + '-' + field.resolveFieldKey()];
  }, [filterStatus, filterQueryKey]);
  const getDefaultActiveTab = (0,external_react_.useCallback)(field => {
    if (!allowFaceting(field)) {
      return FieldFilterTabs.Filter;
    }
    if (!hasFilters(field)) {
      return FieldFilterTabs.ChooseValues;
    }
    const currentFieldFilters = filters[filterQueryKey].filter(filterField => filterField.fieldKey === field.resolveFieldKey());
    if (currentFieldFilters.length > 1) {
      return FieldFilterTabs.Filter;
    }
    return isChooseValuesFilter(currentFieldFilters[0].filter) ? FieldFilterTabs.ChooseValues : FieldFilterTabs.Filter;
  }, [hasFilters, filters, filterQueryKey]);
  (0,external_react_.useEffect)(() => {
    setQueryFields(undefined);
    setActiveField(undefined);
    if (!queryInfo) return;
    let validFields;
    if (fields) validFields = fields;else {
      const qFields = skipDefaultViewCheck ? queryInfo.getAllColumns(viewName) : queryInfo.getDisplayColumns(viewName);
      validFields = qFields.filter(field => field.filterable && (!validFilterField || validFilterField(field, queryInfo, entityDataType?.exprColumnsWithSubSelect)));
    }
    setQueryFields(validFields);
    if (fieldKey) {
      const field = validFields.find(f => f.getDisplayFieldKey() === fieldKey);
      setActiveField(field);
    }
  }, [queryInfo, skipDefaultViewCheck, validFilterField, entityDataType?.exprColumnsWithSubSelect, fieldKey, viewName, fields]);
  (0,external_react_.useEffect)(() => {
    if (activeField) setActiveTab(getDefaultActiveTab(activeField));
  }, [activeField]); // don't include getDefaultActiveTab as we only want this to be triggered when the field selection changes

  const activeFieldKey = (0,external_react_.useMemo)(() => {
    return activeField?.getDisplayFieldKey();
  }, [activeField]);
  const currentFieldFilters = (0,external_react_.useMemo)(() => {
    if (!filters || !activeField) return null;
    const activeQueryFilters = filters[filterQueryKey];
    return activeQueryFilters?.filter(filter => filter.fieldKey === activeFieldKey);
  }, [activeField, filterQueryKey, filters, activeFieldKey]);
  const fieldDistinctValueFilters = (0,external_react_.useMemo)(() => {
    if (!filters || !filterQueryKey || !activeField) return null;

    // Issue 45135: include any model filters (baseFilters or queryInfo filters)
    const valueFilters = selectDistinctOptions ? [...selectDistinctOptions.filterArray] : [];

    // use active filters to filter distinct values, but exclude filters on current field
    filters?.[filterQueryKey]?.forEach(field => {
      if (field.fieldKey !== activeFieldKey) {
        let filter = field.filter;
        // convert ancestor matches all to IN filter type for distinct value selection
        if (filter.getFilterType().getURLSuffix() === ANCESTOR_MATCHES_ALL_OF_FILTER_TYPE.getURLSuffix()) filter = api_.Filter.create(filter.getColumnName(), filter.getValue(), api_.Filter.Types.IN);
        valueFilters.push(filter);
      }
    });
    return valueFilters;
  }, [filters, filterQueryKey, activeField, activeFieldKey, selectDistinctOptions]);
  const onFieldClick = (0,external_react_.useCallback)(queryColumn => {
    setActiveField(queryColumn);
  }, []);
  const onTabChange = (0,external_react_.useCallback)(tabKey => {
    setActiveTab(tabKey);
    if (tabKey === FieldFilterTabs.ChooseValues) {
      api.query.incrementClientSideMetricCount(metricFeatureArea, 'goToChooseValuesTab');
    }
  }, [api, metricFeatureArea]);
  const fieldsClassName = `col-xs-${fullWidth ? 12 : 6} col-sm-${fullWidth ? 4 : 3} field-modal__col filter-modal__col_fields`;
  const valuesClassName = `col-xs-12 col-sm-${fullWidth ? 8 : 6} field-modal__col filter-modal__col_filter_exp`;
  const body = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: fieldsClassName
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__col-title"
  }, "Fields"), !queryName && emptyMsg && /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__empty-msg"
  }, emptyMsg), queryName && /*#__PURE__*/external_react_default().createElement("div", {
    className: "list-group field-modal__col-content filter-modal__fields-col-content"
  }, !queryFields && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
    wrapperClassName: "loading-spinner"
  }), entityDataType?.supportHasNoValueInQuery && /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-check list-group-item"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-check-input filter-faceted__checkbox",
    type: "checkbox",
    name: "field-value-nodata-check",
    onChange: event => onHasNoValueInQueryChange(event.target.checked),
    checked: hasNotInQueryFilter
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "filter-modal__fields-col-nodata-msg"
  }, hasNotInQueryFilterLabel ?? 'Without data from this type')), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()({
      'field-modal__col-content-disabled': hasNotInQueryFilter
    })
  }, queryFields?.map((field, index) => {
    const {
      caption
    } = field;
    const currFieldKey = field.getDisplayFieldKey();
    return /*#__PURE__*/external_react_default().createElement(ChoicesListItem, {
      active: currFieldKey === activeFieldKey,
      index: index,
      key: currFieldKey,
      label: caption,
      onSelect: () => onFieldClick(field),
      componentRight: hasFilters(field) && /*#__PURE__*/external_react_default().createElement("span", {
        className: "pull-right field-modal__field_dot"
      }),
      disabled: hasNotInQueryFilter
    });
  })))), /*#__PURE__*/external_react_default().createElement("div", {
    className: valuesClassName
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__col-title"
  }, "Values"), queryName && !activeField && /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__empty-msg"
  }, "Select a field."), queryName && activeField && /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('field-modal__col-content field-modal__values', {
      'field-modal__col-content-disabled': hasNotInQueryFilter
    })
  }, /*#__PURE__*/external_react_default().createElement(Tabs, {
    activeKey: activeTab,
    className: "field-modal__tabs content-tabs",
    onSelect: onTabChange
  }, /*#__PURE__*/external_react_default().createElement(Tab, {
    eventKey: FieldFilterTabs.Filter,
    title: "Filter"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__col-sub-title"
  }, "Find values for ", activeField.caption), activeTab === FieldFilterTabs.Filter && /*#__PURE__*/external_react_default().createElement(FilterExpressionView, {
    allowRelativeDateFilter: allowRelativeDateFilter,
    key: activeFieldKey,
    field: activeField,
    fieldFilters: currentFieldFilters?.map(filter => filter.filter),
    onFieldFilterUpdate: (newFilters, index) => onFilterUpdate(activeField, newFilters, index),
    disabled: hasNotInQueryFilter,
    includeAllAncestorFilter: isAncestor && activeField?.fieldKey.toLowerCase() === 'name'
  })), allowFaceting(activeField) && /*#__PURE__*/external_react_default().createElement(Tab, {
    eventKey: FieldFilterTabs.ChooseValues,
    title: "Choose values"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__col-sub-title"
  }, "Find values for ", activeField.caption), /*#__PURE__*/external_react_default().createElement(FilterFacetedSelector, {
    selectDistinctOptions: QueryFilterPanel_objectSpread(QueryFilterPanel_objectSpread({}, selectDistinctOptions), {}, {
      column: activeFieldKey,
      schemaName: queryInfo.schemaName,
      queryName,
      viewName,
      filterArray: fieldDistinctValueFilters
    }),
    fieldFilters: currentFieldFilters?.map(filter => filter.filter),
    fieldKey: activeFieldKey,
    canBeBlank: !activeField?.required && !activeField.nameExpression,
    key: activeFieldKey,
    onFieldFilterUpdate: (newFilters, index) => onFilterUpdate(activeField, newFilters, index),
    disabled: hasNotInQueryFilter
  }))))));
  if (asRow) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row field-modal__container"
    }, body);
  } else {
    return body;
  }
});
QueryFilterPanel.defaultProps = {
  api: getDefaultAPIWrapper()
};
;// CONCATENATED MODULE: ./src/internal/components/navigation/Breadcrumb.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


const Breadcrumb = props => {
  const children = [];
  external_react_default().Children.forEach(props.children, c => {
    if (c !== null) {
      children.push(c);
    }
  });
  if (children.length === 0) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement("ol", {
    className: external_classnames_default()('breadcrumb', props.className)
  }, external_react_default().Children.map(children, (child, i) => {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, i > 0 && /*#__PURE__*/external_react_default().createElement("li", {
      className: "separator"
    }, "\xA0/\xA0"), /*#__PURE__*/external_react_default().createElement("li", null, child));
  }));
};
Breadcrumb.displayName = 'Breadcrumb';
;// CONCATENATED MODULE: ./src/internal/components/navigation/BreadcrumbCreate.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



const BreadcrumbCreate = (0,external_react_.memo)(props => /*#__PURE__*/external_react_default().createElement("div", {
  className: "row component-crumbcreate--container"
}, /*#__PURE__*/external_react_default().createElement(Breadcrumb, {
  className: "col-xs-8 col-sm-8 col-md-8"
}, props.children), /*#__PURE__*/external_react_default().createElement(CreatedModified, {
  row: props.row,
  useServerDate: props.useServerDate,
  className: "col-xs-4 col-sm-4 col-md-4"
})));
;// CONCATENATED MODULE: ./src/internal/components/forms/input/UserSelectInput.tsx
const UserSelectInput_excluded = ["containerPath", "includeInactive", "notifyList", "permissions", "useEmail"];
function UserSelectInput_extends() { return UserSelectInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, UserSelectInput_extends.apply(null, arguments); }
function UserSelectInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = UserSelectInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function UserSelectInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/*
 * Copyright (c) 2017-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */





function generateKey(permissions, containerPath) {
  let key = 'allPermissions';
  if (permissions) {
    if (Array.isArray(permissions)) {
      key = permissions.sort(naturalSort).join(';');
    } else {
      key = permissions;
    }
  }
  if (containerPath) {
    key = [containerPath, key].join('|');
  }
  return key;
}
const UserSelectInput = (0,external_react_.memo)(props => {
  const {
      containerPath,
      includeInactive,
      notifyList,
      permissions,
      useEmail
    } = props,
    selectInputProps = UserSelectInput_objectWithoutProperties(props, UserSelectInput_excluded);
  const key = (0,external_react_.useMemo)(() => generateKey(permissions, containerPath), [containerPath, permissions]);
  const [error, setError] = (0,external_react_.useState)();
  const {
    api
  } = useAppContext();
  const loadOptions = (0,external_react_.useCallback)(async input => {
    let options;
    const sanitizedInput = input?.trim().toLowerCase();
    try {
      const users = await api.security.getUsersWithPermissions(permissions, containerPath, includeInactive);
      options = users?.filter(v => {
        if (sanitizedInput) {
          return v.displayName?.toLowerCase().indexOf(sanitizedInput) > -1;
        }
        return true;
      }).map(v => ({
        label: v.displayName,
        value: notifyList ? v.displayName : useEmail ? v.email : v.userId
      }));
    } catch (e) {
      setError(resolveErrorMessage(e) ?? 'Failed to load users');
    }
    return options;
  }, [api, containerPath, includeInactive, notifyList, permissions, useEmail]);
  return /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, UserSelectInput_extends({}, selectInputProps, {
    disabled: error ? true : selectInputProps.disabled,
    delimiter: notifyList ? ';' : ',',
    key: key,
    loadOptions: loadOptions,
    placeholder: error ?? selectInputProps.placeholder
  }));
});
UserSelectInput.defaultProps = {
  clearCacheOnChange: false,
  notifyList: false,
  useEmail: false
};
UserSelectInput.displayName = 'UserSelectInput';
;// CONCATENATED MODULE: ./src/internal/components/user/UserDetailHeader.tsx



const UserDetailHeader = props => {
  const {
    container,
    dateFormat,
    description,
    renderButtons,
    showFolderTitle,
    title,
    user,
    userProperties
  } = props;
  const lastLogin = (0,external_react_.useMemo)(() => getUserLastLogin(userProperties, dateFormat), [dateFormat, userProperties]);
  const userDescription = (0,external_react_.useMemo)(() => {
    return description || getUserPermissionsDisplay(user).join(', ');
  }, [description, user]);
  return /*#__PURE__*/external_react_default().createElement(PageDetailHeader, {
    iconUrl: user.avatar,
    title: title,
    description: userDescription,
    leftColumns: 9
  }, showFolderTitle && !!container?.title && /*#__PURE__*/external_react_default().createElement("div", {
    className: "detail__header--desc"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-folder-open"
  }), "\xA0", container.title), lastLogin && /*#__PURE__*/external_react_default().createElement("div", {
    className: "detail__header--desc pull-right"
  }, "Last Login: ", lastLogin), renderButtons && /*#__PURE__*/external_react_default().createElement("div", {
    className: lastLogin ? 'detail__header--buttons' : ''
  }, renderButtons));
};
UserDetailHeader.displayName = 'UserDetailHeader';
UserDetailHeader.defaultProps = {
  showFolderTitle: true
};
;// CONCATENATED MODULE: ./src/internal/components/user/UserProfile.tsx
function UserProfile_defineProperty(e, r, t) { return (r = UserProfile_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function UserProfile_toPropertyKey(t) { var i = UserProfile_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function UserProfile_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */
















const FIELDS_TO_EXCLUDE = (0,external_immutable_.List)(['userid', 'owner', 'groups', 'lastlogin', 'lastactivity', 'haspassword', 'phone', 'mobile', 'pager', 'im', 'avatar']);
const DISABLED_FIELDS = (0,external_immutable_.List)(['email']);
const USER_AVATAR_FILE = 'user_avatar_file';
const DEFAULT_AVATAR_PATH = '/_images/defaultavatar.png';
class UserProfile extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    UserProfile_defineProperty(this, "componentDidMount", async () => {
      const {
        user,
        api
      } = this.props;
      try {
        const queryInfo = await api.query.getQueryDetails(SCHEMAS.CORE_TABLES.USERS);
        this.setState(() => ({
          queryInfo
        }));
      } catch (e) {
        console.error(e.message);
        this.setState(() => ({
          hasError: true
        }));
      }
      if (hasPermissions(user, [api_.PermissionTypes.CanSeeUserDetails])) {
        try {
          const response = await api.security.getUserPropertiesForOther(user.id);
          const groups = caseInsensitive(response, 'Groups');
          this.setState(() => ({
            groups
          }));
        } catch (e) {
          console.error(resolveErrorMessage(e) ?? 'Failed to load group data');
          this.setState(() => ({
            hasError: true
          }));
        }
      }
    });
    UserProfile_defineProperty(this, "columnFilter", col => {
      // make sure all columns are set as shownInInsertView and those that are marked as editable are not also readOnly.
      // Issue 47532 We want users to be able to update the fields on their own profile page, even if only readers
      const _col = col.mutate({
        shownInInsertView: true,
        readOnly: !col.userEditable
      });
      return insertColumnFilter(_col) && !FIELDS_TO_EXCLUDE.contains(_col.fieldKey.toLowerCase());
    });
    UserProfile_defineProperty(this, "onAvatarFileChange", files => {
      this.onFormChange();
      this.setState(() => ({
        avatar: files[USER_AVATAR_FILE]
      }));
    });
    UserProfile_defineProperty(this, "removeCurrentAvatar", () => {
      this.onFormChange();
      this.setState({
        removeCurrentAvatar: true
      });
    });
    UserProfile_defineProperty(this, "onFormChange", () => {
      this.props.setIsDirty(true);
    });
    UserProfile_defineProperty(this, "submitUserDetails", data => {
      const {
        api,
        user
      } = this.props;
      const avatar = this.state.avatar || (this.state.removeCurrentAvatar ? null : undefined);

      // Issue 39225: don't submit empty string for required DisplayName
      const displayName = data.get('DisplayName');
      if (displayName.trim() === '') {
        return Promise.reject({
          exception: 'Missing required value for Display Name.'
        });
      }

      // need to reload the page if the avatar changes or is removed since that is coming from LABKEY.user on page load
      if (avatar !== undefined) {
        this.setState(() => ({
          reloadRequired: true
        }));
      }
      return api.security.updateUserDetails(getUserDetailsRowData(user, data, avatar));
    });
    UserProfile_defineProperty(this, "onSuccess", result => {
      this.props.onSuccess(result, this.state.reloadRequired);
    });
    this.state = {
      queryInfo: undefined,
      avatar: undefined,
      removeCurrentAvatar: false,
      reloadRequired: false,
      hasError: false,
      groups: undefined
    };
  }
  footer() {
    const {
      groups
    } = this.state;
    if (!groups) return null;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "form-group row"
    }, /*#__PURE__*/external_react_default().createElement("label", {
      className: INPUT_LABEL_CLASS_NAME
    }, "Groups"), /*#__PURE__*/external_react_default().createElement("div", {
      className: INPUT_WRAPPER_CLASS_NAME
    }, /*#__PURE__*/external_react_default().createElement(GroupsList, {
      groups: groups,
      asRow: false
    })));
  }
  render() {
    const {
      user,
      userProperties
    } = this.props;
    const {
      hasError,
      queryInfo,
      removeCurrentAvatar
    } = this.state;
    const isDefaultAvatar = !user.avatar || user.avatar.indexOf(DEFAULT_AVATAR_PATH) > -1;
    const isLoading = !queryInfo || !userProperties;
    const avatarSrc = removeCurrentAvatar ? api_.ActionURL.getContextPath() + DEFAULT_AVATAR_PATH : user.avatar;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, hasError && /*#__PURE__*/external_react_default().createElement(Alert, null, getActionErrorMessage('There was a problem loading your user profile', 'profile')), isLoading && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), !isLoading && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-sm-3 col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("p", {
      className: "user-section-header"
    }, "Avatar")), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-sm-2 col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("img", {
      src: avatarSrc,
      className: "detail__header-icon"
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-sm-7 col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(FileInput, {
      key: USER_AVATAR_FILE,
      showLabel: false,
      name: USER_AVATAR_FILE,
      onChange: this.onAvatarFileChange
    }), !isDefaultAvatar && !removeCurrentAvatar && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("a", {
      className: "user-text-link",
      onClick: this.removeCurrentAvatar
    }, "Delete Current Avatar")))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("hr", null))), /*#__PURE__*/external_react_default().createElement("p", {
      className: "user-section-header"
    }, "User Details"), /*#__PURE__*/external_react_default().createElement(QueryInfoForm, {
      columnFilter: this.columnFilter,
      queryInfo: queryInfo,
      fieldValues: userProperties,
      includeCountField: false,
      submitText: "Save",
      isSubmittedText: "Save",
      isSubmittingText: "Saving...",
      onFormChange: this.onFormChange,
      onSubmit: this.submitUserDetails,
      onSuccess: this.onSuccess,
      disabledFields: DISABLED_FIELDS,
      footer: this.footer(),
      stickyButtons: false,
      showErrorsAtBottom: true
    })));
  }
}
UserProfile_defineProperty(UserProfile, "defaultProps", {
  api: getDefaultAPIWrapper()
});
;// CONCATENATED MODULE: ./src/internal/components/user/models.ts

class ChangePasswordModel extends (0,external_immutable_.Record)({
  email: undefined,
  oldPassword: '',
  password: '',
  password2: ''
}) {}
;// CONCATENATED MODULE: ./src/internal/components/user/ChangePasswordModal.tsx
function ChangePasswordModal_defineProperty(e, r, t) { return (r = ChangePasswordModal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ChangePasswordModal_toPropertyKey(t) { var i = ChangePasswordModal_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ChangePasswordModal_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








const PasswordInput = ({
  helpTip,
  label,
  name,
  onChange,
  value
}) => {
  const onChange_ = (0,external_react_.useCallback)(event => onChange(event.target.name, event.target.value), [onChange]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-4"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: "control-label",
    htmlFor: name
  }, label, helpTip && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    title: label
  }, /*#__PURE__*/external_react_default().createElement("div", {
    dangerouslySetInnerHTML: {
      __html: helpTip
    }
  })))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-8"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control",
    type: "password",
    id: name,
    name: name,
    value: value,
    onChange: onChange_
  })));
};
class ChangePasswordModal extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    ChangePasswordModal_defineProperty(this, "onChange", (name, value) => {
      this.setState(state => ({
        model: state.model.set(name, value)
      }));
    });
    ChangePasswordModal_defineProperty(this, "submitChangePassword", () => {
      this.setState({
        submitting: true
      });
      changePassword(this.state.model).then(() => {
        this.props.onHide();
        this.props.onSuccess();
        this.setState({
          submitting: false
        });
      }).catch(response => {
        this.setState({
          error: resolveErrorMessage(response),
          submitting: false
        });
      });
    });
    this.state = {
      model: new ChangePasswordModel({
        email: props.user.email
      }),
      passwordRule: undefined,
      submitting: false,
      error: undefined
    };
  }
  componentDidMount() {
    getPasswordRuleInfo().then(response => {
      this.setState(() => ({
        passwordRule: response
      }), () => {
        if (response?.shouldShowPasswordGuidance) {
          LABKEY_PASSWORD_GAUGE.createComponent('strengthGuidance', 'password', 'email', this.props.user.email);
          document.getElementById('strengthGuidance').style.width = '100%';
        }
      });
    }).catch(response => {
      this.setState({
        error: resolveErrorMessage(response)
      });
    });
  }
  render() {
    const {
      onHide
    } = this.props;
    const {
      model,
      submitting,
      error,
      passwordRule
    } = this.state;
    const helpTip = passwordRule?.shouldShowPasswordGuidance ? passwordRule?.summary.replace('display:none;', '').replace('<a ', '<a style="display:none;" ') : passwordRule?.full;
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      isConfirming: submitting,
      onCancel: onHide,
      onConfirm: this.submitChangePassword,
      title: "Change Password"
    }, /*#__PURE__*/external_react_default().createElement("form", null, /*#__PURE__*/external_react_default().createElement(PasswordInput, {
      label: "Old Password",
      name: "oldPassword",
      onChange: this.onChange,
      value: model.oldPassword
    }), /*#__PURE__*/external_react_default().createElement(PasswordInput, {
      label: "New Password",
      name: "password",
      onChange: this.onChange,
      value: model.password,
      helpTip: helpTip
    }), passwordRule?.shouldShowPasswordGuidance && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8"
    }, /*#__PURE__*/external_react_default().createElement("canvas", {
      id: "strengthGuidance",
      width: "350",
      height: "30"
    }, "Your browser does not support the HTML5 canvas element."))), /*#__PURE__*/external_react_default().createElement(PasswordInput, {
      label: "Retype New Password",
      name: "password2",
      onChange: this.onChange,
      value: model.password2
    })), error && /*#__PURE__*/external_react_default().createElement(Alert, null, error));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/user/hooks.ts
/*
 * Copyright (c) 2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */


function useUserProperties(user, api = getDefaultAPIWrapper()) {
  const {
    id,
    isGuest
  } = user;
  const [userProperties, setUserProperties] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    if (isGuest) {
      setUserProperties({});
    } else {
      (async () => {
        try {
          const response = await api.security.getUserProperties(id);
          setUserProperties(response.props);
        } catch (e) {
          console.error('Failed to load user properties', e);
        }
      })();
    }
  }, [api, isGuest, id]);
  return userProperties;
}
;// CONCATENATED MODULE: ./src/internal/components/administration/utils.ts



function isLoginAutoRedirectEnabled(moduleContext) {
  return moduleContext?.api?.AutoRedirectSSOAuthConfiguration !== undefined;
}
function isApiKeyGenerationEnabled(moduleContext) {
  return !!moduleContext?.api?.allowApiKeys;
}
function isSessionKeyGenerationEnabled(moduleContext) {
  return !!moduleContext?.api?.allowSessionKeys;
}
function getApiExpirationMessage(moduleContext) {
  const expSeconds = moduleContext?.api?.apiKeyExpirationSeconds;
  if (!expSeconds || expSeconds === -1) {
    return 'never expire';
  }
  return 'expire after ' + external_moment_default().duration(expSeconds, 'seconds').humanize();
}
function showPremiumFeatures(moduleContext) {
  return hasPremiumModule(moduleContext) && !api_.ActionURL.getParameter('excludePremium');
}
;// CONCATENATED MODULE: ./src/internal/components/pagination/PaginationButton.tsx






const PaginationButton = ({
  className,
  disabled,
  iconClass,
  onClick,
  tooltip
}) => {
  const clsName = external_classnames_default()(className, 'pagination-button btn btn-default', {
    'disabled-button-with-tooltip': disabled
  });
  const {
    onMouseEnter,
    onMouseLeave,
    portalEl,
    show,
    targetRef
  } = useOverlayTriggerState('pagination-button-overlay', true, false, 200);
  const onClick_ = (0,external_react_.useCallback)(() => {
    onClick();
    blurActiveElement();
  }, [onClick]);
  const tooltip_ = (0,external_react_.useMemo)(() => /*#__PURE__*/external_react_default().createElement(Tooltip, {
    id: "pagination-button-tooltip",
    placement: "top",
    targetRef: targetRef
  }, tooltip), [targetRef, tooltip]);
  return /*#__PURE__*/external_react_default().createElement("button", {
    disabled: disabled,
    className: clsName,
    onClick: onClick_,
    onPointerEnter: onMouseEnter,
    onPointerLeave: onMouseLeave,
    ref: targetRef,
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: `fa ${iconClass}`
  }), show && (0,external_react_dom_.createPortal)(tooltip_, portalEl));
};
;// CONCATENATED MODULE: ./src/internal/components/pagination/PageMenu.tsx





const PageMenu = props => {
  const {
    currentPage,
    disabled,
    isFirstPage,
    isLastPage,
    loadFirstPage,
    loadLastPage,
    pageCount,
    pageSize,
    pageSizes,
    setPageSize
  } = props;
  const totalPagesText = disabled ? '...' : `${pageCount} Total Pages`;
  // We have to manually wire up a Tooltip here because we're rendering PageMenu within a btn-group so any extra
  // wrapping elements cause it to render incorrectly.
  const {
    onMouseEnter,
    onMouseLeave,
    portalEl,
    show,
    targetRef
  } = useOverlayTriggerState('page-menu-overlay', true, false, 200);
  const tooltip = /*#__PURE__*/external_react_default().createElement(Tooltip, {
    id: "view-menu-tooltip",
    placement: "top",
    targetRef: targetRef
  }, "Current Page");
  return /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    buttonClassName: "current-page-dropdown",
    disabled: disabled,
    pullRight: true,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    title: currentPage,
    ref: targetRef
  }, /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    text: "Jump To"
  }), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    disabled: disabled || isFirstPage,
    onClick: loadFirstPage
  }, "First Page"), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    disabled: disabled || isLastPage,
    onClick: loadLastPage
  }, "Last Page"), /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    className: "submenu-footer",
    text: totalPagesText
  }), /*#__PURE__*/external_react_default().createElement(MenuDivider, null), /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    text: "Page Size"
  }), pageSizes?.map(size => /*#__PURE__*/external_react_default().createElement(MenuItem, {
    key: size,
    active: size === pageSize,
    onClick: () => setPageSize(size)
  }, size)), show && (0,external_react_dom_.createPortal)(tooltip, portalEl));
};
;// CONCATENATED MODULE: ./src/internal/components/pagination/PaginationInfo.tsx



const PaginationInfo = (0,external_react_.memo)(props => {
  const {
    offset,
    pageSize,
    rowCount,
    totalCountLoadingState
  } = props;
  const loading = isLoading(totalCountLoadingState);
  const min = offset !== rowCount ? offset + 1 : offset;
  const max = offset + pageSize;
  const text = `${min.toLocaleString()} - `;
  return /*#__PURE__*/external_react_default().createElement("span", {
    className: "pagination-info",
    "data-min": min,
    "data-max": max,
    "data-total": rowCount
  }, text, loading && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
    msg: ""
  }), !loading && /*#__PURE__*/external_react_default().createElement("span", null, max > rowCount ? rowCount.toLocaleString() : max.toLocaleString()), !loading && rowCount > max && /*#__PURE__*/external_react_default().createElement("span", null, ` of ${rowCount.toLocaleString()}`));
});
;// CONCATENATED MODULE: ./src/internal/components/pagination/Pagination.tsx
function Pagination_defineProperty(e, r, t) { return (r = Pagination_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Pagination_toPropertyKey(t) { var i = Pagination_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Pagination_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





const PAGINATION_METRIC_AREA = 'pagination';
class Pagination extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    Pagination_defineProperty(this, "onLoadFirstPage", () => {
      incrementClientSideMetricCount(PAGINATION_METRIC_AREA, 'loadFirstPage');
      this.props.loadFirstPage();
    });
    Pagination_defineProperty(this, "onLoadLastPage", () => {
      incrementClientSideMetricCount(PAGINATION_METRIC_AREA, 'loadLastPage');
      this.props.loadLastPage();
    });
    Pagination_defineProperty(this, "onLoadPreviousPage", () => {
      incrementClientSideMetricCount(PAGINATION_METRIC_AREA, 'loadPreviousPage');
      this.props.loadPreviousPage();
    });
    Pagination_defineProperty(this, "onLoadNextPage", () => {
      incrementClientSideMetricCount(PAGINATION_METRIC_AREA, 'loadNextPage');
      this.props.loadNextPage();
    });
    Pagination_defineProperty(this, "onSetPageSize", pageSize => {
      incrementClientSideMetricCount(PAGINATION_METRIC_AREA, 'setPageSize' + pageSize);
      this.props.setPageSize(pageSize);
    });
  }
  render() {
    const {
      currentPage,
      disabled,
      isFirstPage,
      isLastPage,
      offset,
      pageSize,
      pageCount,
      pageSizes,
      rowCount,
      totalCountLoadingState
    } = this.props;
    const showPaginationButtons = rowCount > pageSizes[0];

    // Use lk-pagination so we don't conflict with bootstrap pagination class.
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "lk-pagination"
    }, /*#__PURE__*/external_react_default().createElement(PaginationInfo, {
      offset: offset,
      pageSize: pageSize,
      rowCount: rowCount,
      totalCountLoadingState: totalCountLoadingState
    }), showPaginationButtons && /*#__PURE__*/external_react_default().createElement("div", {
      className: "pagination-button-group btn-group"
    }, /*#__PURE__*/external_react_default().createElement(PaginationButton, {
      className: "pagination-button--previous",
      disabled: disabled || isFirstPage,
      iconClass: "fa-chevron-left",
      tooltip: "Previous Page",
      onClick: this.onLoadPreviousPage
    }), /*#__PURE__*/external_react_default().createElement(PageMenu, {
      currentPage: currentPage,
      disabled: disabled,
      isFirstPage: isFirstPage,
      isLastPage: isLastPage,
      pageCount: pageCount,
      loadFirstPage: this.onLoadFirstPage,
      loadLastPage: this.onLoadLastPage,
      pageSize: pageSize,
      pageSizes: pageSizes,
      setPageSize: this.onSetPageSize
    }), /*#__PURE__*/external_react_default().createElement(PaginationButton, {
      className: "pagination-button--next",
      disabled: disabled || isLastPage,
      iconClass: "fa-chevron-right",
      tooltip: "Next Page",
      onClick: this.onLoadNextPage
    })));
  }
}
Pagination_defineProperty(Pagination, "defaultProps", {
  pageSizes: [20, 40, 100, 250, 400]
});
;// CONCATENATED MODULE: ./src/public/QueryModel/grid/actions/Search.ts
function Search_defineProperty(e, r, t) { return (r = Search_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Search_toPropertyKey(t) { var i = Search_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Search_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class SearchAction {
  constructor() {
    Search_defineProperty(this, "isDefaultAction", true);
    Search_defineProperty(this, "iconCls", 'search');
    Search_defineProperty(this, "param", 'q');
    Search_defineProperty(this, "keyword", 'search');
  }
  actionValueFromFilter(filter, isReadOnly) {
    return {
      value: filter.getValue(),
      valueObject: filter,
      action: this,
      isReadOnly,
      isRemovable: true
    };
  }
}
;// CONCATENATED MODULE: ./src/public/QueryModel/grid/actions/Sort.ts
function Sort_defineProperty(e, r, t) { return (r = Sort_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Sort_toPropertyKey(t) { var i = Sort_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Sort_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class SortAction {
  constructor() {
    Sort_defineProperty(this, "iconCls", 'sort');
    Sort_defineProperty(this, "keyword", 'sort');
    Sort_defineProperty(this, "separator", ',');
  }
  actionValueFromSort(sort, label) {
    const {
      dir,
      fieldKey
    } = sort;
    return {
      value: `${fieldKey} ${dir === '-' ? 'DESC' : 'ASC'}`,
      displayValue: label ?? decodePart(fieldKey),
      valueObject: sort,
      action: this
    };
  }
}
;// CONCATENATED MODULE: ./src/public/QueryModel/grid/actions/View.ts
function View_defineProperty(e, r, t) { return (r = View_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function View_toPropertyKey(t) { var i = View_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function View_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class ViewAction {
  constructor() {
    View_defineProperty(this, "iconCls", 'table');
    View_defineProperty(this, "param", ViewAction.NAME);
    View_defineProperty(this, "keyword", ViewAction.NAME);
  }
}
View_defineProperty(ViewAction, "NAME", 'view');
;// CONCATENATED MODULE: ./src/public/QueryModel/grid/model.ts
let ChangeType = /*#__PURE__*/function (ChangeType) {
  ChangeType["add"] = "add";
  ChangeType["remove"] = "remove";
  ChangeType["modify"] = "modify";
  ChangeType["none"] = "none";
  return ChangeType;
}({});
;// CONCATENATED MODULE: ./src/public/QueryModel/grid/utils.ts


/**
 * From the supplied columnName this method will determine which columns in the "columns" list
 * match based on name. If none match, then the columnName will attempt to resolve against each
 * column's shortCaption (see QueryColumn).
 * @param columns
 * @param columnName
 * @returns {List<QueryColumn>}
 */
function parseColumns(columns, columnName) {
  const _columnName = columnName ? columnName.toLowerCase() : '';

  // First, attempt to match by column name/lookup
  const nameMatches = columns.filter(c => {
    if (_columnName.indexOf('/') > -1) {
      if (c.isLookup()) {
        const name = _columnName.split('/')[0];
        return c.name.toLowerCase() === name;
      }
      return false;
    }
    return c.name.toLowerCase() === _columnName;
  });

  // Second, if there are no matches by column name/lookup, attempt to match by column shortCaption
  if (nameMatches.length === 0) {
    return columns.filter(c => c.shortCaption.toLowerCase() === _columnName);
  }
  return nameMatches;
}

/**
 * Determines what the field key should be from a supplied columnName.
 * If a column (QueryColumn) is supplied it will override the columnName for either
 * the column's lookup column or the column's name.
 * @param columnName
 * @param column
 * @returns {any}
 */
function resolveFieldKey(columnName, column) {
  return column?.resolveFieldKey() ?? columnName;
}
function getSearchValueAction(actionValues, value) {
  const hasNewSearch = value?.length > 0;
  const existingSearchIndex = actionValues.findIndex(actionValue => actionValue.action.keyword === 'search');
  let change = hasNewSearch ? {
    type: ChangeType.add
  } : undefined;
  if (existingSearchIndex > -1) {
    if (hasNewSearch) {
      change = {
        type: ChangeType.modify,
        index: existingSearchIndex
      };
    } else {
      change = {
        type: ChangeType.remove,
        index: existingSearchIndex
      };
    }
  }
  return change;
}
function filterActionValuesByType(actionValues, keyword) {
  return actionValues.filter(actionValue => actionValue.action.keyword === keyword);
}
;// CONCATENATED MODULE: ./src/public/QueryModel/ViewMenu.tsx





const ViewMenu_ViewMenuItem = ({
  activeViewName,
  onViewSelect,
  viewInfo
}) => {
  const {
    name,
    isDefault,
    saved,
    shared
  } = viewInfo;
  const label = isDefault && saved && !shared ? 'Your Default' : viewInfo.label;
  const view = isDefault ? undefined : name;
  const onClick = (0,external_react_.useCallback)(() => {
    onViewSelect(view);
  }, [onViewSelect, view]);
  return /*#__PURE__*/external_react_default().createElement(MenuItem, {
    active: name === activeViewName,
    key: name,
    onClick: onClick
  }, label);
};
class ViewMenu extends external_react_.PureComponent {
  render() {
    const {
      allowViewCustomization,
      model,
      hideEmptyViewMenu,
      onCustomizeView,
      onManageViews,
      onViewSelect,
      onSaveView
    } = this.props;
    const {
      isLoading,
      views,
      viewName,
      visibleViews
    } = model;
    const {
      user
    } = (0,api_.getServerContext)();
    const activeViewName = viewName ?? ViewInfo.DEFAULT_NAME;
    const defaultView = views.find(view => view.isDefault);
    const hasViewsToManage = defaultView?.isSaved || views.filter(view => !view.hidden && !view.isSystemView).length > 0;
    const publicViews = visibleViews.filter(view => view.shared);
    const privateViews = visibleViews.filter(view => !view.shared);
    const noViews = publicViews.length === 0 && privateViews.length === 0;
    const _hideEmptyViewMenu = getQueryMetadata().get('hideEmptyViewMenu', hideEmptyViewMenu);
    const hidden = _hideEmptyViewMenu && noViews && !allowViewCustomization;
    const disabled = isLoading || noViews && !allowViewCustomization;
    const viewMapper = viewInfo => /*#__PURE__*/external_react_default().createElement(ViewMenu_ViewMenuItem, {
      key: viewInfo.name,
      activeViewName: activeViewName,
      onViewSelect: onViewSelect,
      viewInfo: viewInfo
    });
    if (hidden) return null;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "view-menu"
    }, /*#__PURE__*/external_react_default().createElement(DropdownButton, {
      disabled: disabled,
      pullRight: true,
      title: /*#__PURE__*/external_react_default().createElement("span", null, /*#__PURE__*/external_react_default().createElement("i", {
        className: "fa fa-table"
      }), /*#__PURE__*/external_react_default().createElement("span", null, " Views"))
    }, defaultView && viewMapper(defaultView), privateViews.length > 0 && /*#__PURE__*/external_react_default().createElement(MenuDivider, null), privateViews.length > 0 && /*#__PURE__*/external_react_default().createElement(MenuHeader, {
      text: "Your Saved Views"
    }), privateViews.length > 0 && privateViews.map(viewMapper), publicViews.length > 0 && /*#__PURE__*/external_react_default().createElement(MenuDivider, null), publicViews.length > 0 && /*#__PURE__*/external_react_default().createElement(MenuHeader, {
      text: "Shared Saved Views"
    }), publicViews.length > 0 && publicViews.map(viewMapper), allowViewCustomization && !user.isGuest && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(MenuDivider, null), /*#__PURE__*/external_react_default().createElement(MenuItem, {
      onClick: onCustomizeView
    }, "Customize Grid View"), /*#__PURE__*/external_react_default().createElement(MenuItem, {
      onClick: onManageViews,
      disabled: !hasViewsToManage
    }, "Manage Saved Views"), /*#__PURE__*/external_react_default().createElement(MenuItem, {
      onClick: onSaveView
    }, "Save Grid View"))));
  }
}
;// CONCATENATED MODULE: ./src/public/QueryModel/ExportMenu.tsx
const ExportMenu_excluded = ["model"];
function ExportMenu_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = ExportMenu_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function ExportMenu_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ExportMenu_defineProperty(e, r, t) { return (r = ExportMenu_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ExportMenu_toPropertyKey(t) { var i = ExportMenu_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ExportMenu_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ExportMenu_extends() { return ExportMenu_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ExportMenu_extends.apply(null, arguments); }






const exportOptions = [{
  type: EXPORT_TYPES.CSV,
  icon: 'fa-file-o',
  label: 'CSV'
}, {
  type: EXPORT_TYPES.EXCEL,
  icon: 'fa-file-excel-o',
  label: 'Excel'
}, {
  type: EXPORT_TYPES.TSV,
  icon: 'fa-file-text-o',
  label: 'TSV'
}, {
  type: EXPORT_TYPES.LABEL,
  icon: 'fa-tag',
  label: 'Label',
  hidden: true
}, {
  type: EXPORT_TYPES.STORAGE_MAP,
  icon: 'fa-file-excel-o',
  label: 'Storage Map (Excel)',
  hidden: true
}
// Note: EXPORT_TYPES and exportRows (used in export function below) also include support for FASTA and GENBANK,
// but they were never used in the QueryGridPanel version of export. We're explicitly not supporting them in
// this implementation until we need them.
];
const ExportMenuItem = ({
  hasSelections,
  onExport,
  option,
  supportedTypes
}) => {
  const onClick = (0,external_react_.useCallback)(() => {
    onExport(option);
  }, [onExport, option]);
  if (option.hidden && !supportedTypes?.includes(option.type)) return null;
  if (option.type === EXPORT_TYPES.LABEL) {
    const exportAndPrintHeader = 'Export and Print' + (hasSelections ? ' Selected Data' : ' Data');
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, {
      key: option.type
    }, /*#__PURE__*/external_react_default().createElement(MenuDivider, null), /*#__PURE__*/external_react_default().createElement(MenuHeader, {
      text: exportAndPrintHeader
    }), /*#__PURE__*/external_react_default().createElement(MenuItem, {
      onClick: onClick
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: `fa ${option.icon} export-menu-icon`
    }), "\xA0 ", option.label));
  }
  if (option.type === EXPORT_TYPES.STORAGE_MAP) {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, {
      key: option.type
    }, /*#__PURE__*/external_react_default().createElement(MenuDivider, null), /*#__PURE__*/external_react_default().createElement(MenuHeader, {
      text: "Export Map"
    }), /*#__PURE__*/external_react_default().createElement(MenuItem, {
      onClick: onClick
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: `fa ${option.icon} export-menu-icon`
    }), "\xA0 ", option.label));
  }
  return /*#__PURE__*/external_react_default().createElement(MenuItem, {
    key: option.type,
    onClick: onClick
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "export-menu__item"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: `fa ${option.icon} export-menu-icon`
  }), /*#__PURE__*/external_react_default().createElement("span", null, option.label)));
};
const ExportMenuImpl = (0,external_react_.memo)(props => {
  const {
    id,
    hasData,
    supportedTypes,
    hasSelections,
    exportHandler,
    onExport,
    extraExportMenuOptions
  } = props;
  const exportCallback = (0,external_react_.useCallback)(option => {
    const {
      type
    } = option;
    if (onExport?.[type]) {
      onExport[type]?.(id);
    } else {
      exportHandler(option);
    }
  }, [exportHandler, id, onExport]);
  const exportHeader = 'Export' + (hasSelections ? ' Selected' : '') + ' Data';
  return hasData && /*#__PURE__*/external_react_default().createElement("div", {
    className: "export-menu"
  }, /*#__PURE__*/external_react_default().createElement(Tip, {
    caption: "Export"
  }, /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    noCaret: true,
    pullRight: true,
    title: /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-download"
    })
  }, /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    text: exportHeader
  }), exportOptions.map(option => /*#__PURE__*/external_react_default().createElement(ExportMenuItem, {
    key: option.label,
    hasSelections: hasSelections,
    onExport: exportCallback,
    option: option,
    supportedTypes: supportedTypes
  })), extraExportMenuOptions?.map(obj => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, {
    key: obj.label
  }, /*#__PURE__*/external_react_default().createElement(MenuDivider, null), /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    text: obj.label
  }), obj.extraOptions.map(option => /*#__PURE__*/external_react_default().createElement(ExportMenuItem, ExportMenu_extends({
    key: option.option.label,
    hasSelections: hasSelections,
    supportedTypes: supportedTypes
  }, option))))))));
});
class ExportMenu extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    ExportMenu_defineProperty(this, "export", option => {
      const {
        model,
        advancedOptions,
        onExport
      } = this.props;
      const {
        type
      } = option;
      if (onExport?.[type]) {
        onExport[type](model.id);
      } else {
        exportRows(type, getQueryModelExportParams(model, type, advancedOptions), model.containerPath);
      }
    });
  }
  render() {
    const _this$props = this.props,
      {
        model
      } = _this$props,
      rest = ExportMenu_objectWithoutProperties(_this$props, ExportMenu_excluded);
    const {
      id,
      hasData,
      hasSelections
    } = model;
    return /*#__PURE__*/external_react_default().createElement(ExportMenuImpl, ExportMenu_extends({}, rest, {
      id: id,
      hasData: hasData,
      hasSelections: hasSelections,
      exportHandler: this.export
    }));
  }
}
;// CONCATENATED MODULE: ./src/public/QueryModel/SelectionStatus.tsx
function SelectionStatus_defineProperty(e, r, t) { return (r = SelectionStatus_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SelectionStatus_toPropertyKey(t) { var i = SelectionStatus_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SelectionStatus_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class SelectionStatus extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    SelectionStatus_defineProperty(this, "clearSelections", () => {
      this.props.actions.clearSelections(this.props.model.id);
    });
    SelectionStatus_defineProperty(this, "selectAll", () => {
      this.props.actions.selectAllRows(this.props.model.id);
    });
    SelectionStatus_defineProperty(this, "clearText", () => {
      const {
        selections
      } = this.props.model;
      let clearText = 'Clear';
      if (selections.size === 2) {
        clearText = clearText + ' both';
      } else if (selections.size > 2) {
        clearText = clearText + ' all';
      }
      return clearText;
    });
  }
  render() {
    const {
      model
    } = this.props;
    const {
      isLoading,
      isLoadingSelections,
      isLoadingTotalCount,
      maxRows,
      rowCount,
      selections
    } = model;
    if (isLoading || isLoadingSelections || !selections) {
      return null;
    }
    const selectionSize = selections.size;
    let selectionCount;
    let clearAllButton;
    let selectAllButton;
    if (selectionSize > 0) {
      selectionCount = /*#__PURE__*/external_react_default().createElement("span", {
        className: "selection-status__count"
      }, selectionSize.toLocaleString(), " of", ' ', isLoadingTotalCount ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
        msg: ""
      }) : rowCount.toLocaleString(), " selected");
      clearAllButton = /*#__PURE__*/external_react_default().createElement("span", {
        className: "selection-status__clear-all"
      }, /*#__PURE__*/external_react_default().createElement("button", {
        className: "btn btn-default btn-xs",
        onClick: this.clearSelections,
        type: "button"
      }, this.clearText()));
    }
    if (rowCount > maxRows && selectionSize !== rowCount && rowCount > 0) {
      selectAllButton = /*#__PURE__*/external_react_default().createElement("span", {
        className: "selection-status__select-all"
      }, /*#__PURE__*/external_react_default().createElement("button", {
        className: "btn btn-default btn-xs",
        onClick: this.selectAll,
        type: "button"
      }, "Select all ", !isLoadingTotalCount ? rowCount.toLocaleString() : ''));
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "selection-status"
    }, selectionCount, selectAllButton, clearAllButton);
  }
}
;// CONCATENATED MODULE: ./src/internal/components/chart/ChartBuilderMenuItem.tsx




const ChartBuilderMenuItem = (0,external_react_.memo)(({
  actions,
  model
}) => {
  const [showModal, setShowModal] = (0,external_react_.useState)(false);
  const {
    createNotification
  } = useNotificationsContext();
  const onShowModal = (0,external_react_.useCallback)(() => {
    setShowModal(true);
  }, []);
  const onHideModal = (0,external_react_.useCallback)(successMsg => {
    setShowModal(false);
    if (successMsg) {
      createNotification({
        message: successMsg,
        alertClass: 'success'
      });
    }
  }, [createNotification]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: onShowModal
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-plus-circle"
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "chart-menu-label"
  }, "Create Chart")), showModal && /*#__PURE__*/external_react_default().createElement(ChartBuilderModal, {
    actions: actions,
    model: model,
    onHide: onHideModal
  }));
});
;// CONCATENATED MODULE: ./src/public/QueryModel/ChartMenu.tsx








const ChartMenuItem = ({
  chart,
  showChart
}) => {
  const onClick = (0,external_react_.useCallback)(() => showChart(chart), [showChart, chart]);
  const useSVG = chart.icon?.indexOf('.svg') > -1;
  return /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: onClick
  }, useSVG && /*#__PURE__*/external_react_default().createElement("img", {
    src: chart.icon,
    width: 16,
    alt: chart.icon
  }), !useSVG && /*#__PURE__*/external_react_default().createElement("i", {
    className: `chart-menu-icon ${chart.iconCls ?? ''}`
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "chart-menu-label"
  }, chart.name));
};
const ChartMenu = props => {
  const {
    model,
    actions
  } = props;
  const {
    moduleContext,
    user
  } = useServerContext();
  const {
    charts,
    chartsError,
    hasCharts,
    isLoading,
    isLoadingCharts,
    rowsError,
    queryInfoError
  } = model;
  const viewCharts = charts?.filter(chart => chart.viewName === model.schemaQuery.viewName) ?? []; // filter chart menu based on selected view
  const privateCharts = hasCharts ? viewCharts.filter(chart => !chart.shared) : [];
  const publicCharts = hasCharts ? viewCharts.filter(chart => chart.shared) : [];
  const showCreateChart = isChartBuilderEnabled(moduleContext) && hasPermissions(user, [api_.PermissionTypes.Read]) && !user.isGuest;
  const noCharts = hasCharts && viewCharts.length === 0;
  const showCreateChartDivider = showCreateChart && !noCharts;
  const hasError = queryInfoError !== undefined || rowsError !== undefined;
  const disabled = isLoading || isLoadingCharts || hasError || noCharts && !showCreateChart;
  (0,external_react_.useEffect)(() => {
    actions.loadCharts(model.id);
  }, [
    /* on mount */
  ]);
  const chartClicked = (0,external_react_.useCallback)(chart => {
    blurActiveElement();
    actions.selectReport(model.id, chart.reportId);
  }, [actions, model]);
  if (noCharts && !showCreateChart) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "chart-menu"
  }, /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    buttonClassName: "chart-menu-button",
    disabled: disabled,
    pullRight: true,
    title: isLoadingCharts ? /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-spinner fa-pulse"
    }) : /*#__PURE__*/external_react_default().createElement("span", null, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-area-chart"
    }), /*#__PURE__*/external_react_default().createElement("span", null, " Charts"))
  }, chartsError !== undefined && /*#__PURE__*/external_react_default().createElement(MenuItem, null, chartsError), showCreateChart && /*#__PURE__*/external_react_default().createElement(ChartBuilderMenuItem, {
    actions: actions,
    model: model
  }), showCreateChartDivider && /*#__PURE__*/external_react_default().createElement(MenuDivider, null), privateCharts.length > 0 && /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    text: "Your Charts"
  }), privateCharts.length > 0 && privateCharts.map(chart => /*#__PURE__*/external_react_default().createElement(ChartMenuItem, {
    key: chart.reportId,
    chart: chart,
    showChart: chartClicked
  })), privateCharts.length > 0 && publicCharts.length > 0 && /*#__PURE__*/external_react_default().createElement(MenuDivider, null), publicCharts.length > 0 && /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    text: "Shared Charts"
  }), publicCharts.length > 0 && publicCharts.map(chart => /*#__PURE__*/external_react_default().createElement(ChartMenuItem, {
    key: chart.reportId,
    chart: chart,
    showChart: chartClicked
  }))));
};
;// CONCATENATED MODULE: ./src/public/QueryModel/SearchBox.tsx

const SearchBox_SearchBox = (0,external_react_.memo)(props => {
  const {
    actionValues,
    onSearch
  } = props;
  const [searchValue, setSearchValue] = (0,external_react_.useState)('');
  const appliedSearch = (0,external_react_.useMemo)(() => actionValues?.[0]?.value, [actionValues]);
  (0,external_react_.useEffect)(() => {
    if (appliedSearch) {
      setSearchValue(appliedSearch);
    } else {
      setSearchValue('');
    }
  }, [appliedSearch]);
  const onChange = (0,external_react_.useCallback)(evt => {
    setSearchValue(evt.target.value);
  }, [setSearchValue]);
  const onSubmit = (0,external_react_.useCallback)(evt => {
    evt.preventDefault();
    onSearch(searchValue);
  }, [onSearch, searchValue]);
  const onIconClick = (0,external_react_.useCallback)(() => {
    onSearch(searchValue);
  }, [onSearch, searchValue]);
  const removeSearch = (0,external_react_.useCallback)(() => {
    onSearch('');
    setSearchValue('');
  }, [onSearch]);
  return /*#__PURE__*/external_react_default().createElement("form", {
    className: "grid-panel__search-form",
    onSubmit: onSubmit
  }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
    className: "grid-panel__input-group input-group"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group-addon",
    onClick: onIconClick
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-search"
  })), /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control grid-panel__search-input",
    onChange: onChange,
    placeholder: "Search...",
    size: 25,
    type: "text",
    value: searchValue
  }), appliedSearch?.length > 0 && /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group-btn"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    type: "button",
    className: "btn btn-default",
    onClick: removeSearch
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-remove"
  }))))));
});
;// CONCATENATED MODULE: ./src/public/QueryModel/GridFilterModal.tsx







const GridFilterModal = (0,external_react_.memo)(props => {
  const {
    api,
    onCancel,
    initFilters,
    model,
    onApply,
    fieldKey,
    selectDistinctOptions,
    skipDefaultViewCheck
  } = props;
  const {
    queryInfo
  } = model;
  const [filterError, setFilterError] = (0,external_react_.useState)(undefined);
  const [filters, setFilters] = (0,external_react_.useState)(initFilters.map(filter => {
    return {
      fieldKey: filter.getColumnName(),
      filter
    };
  }));
  const closeModal = (0,external_react_.useCallback)(() => {
    onCancel();
  }, [onCancel]);
  const validFieldFilters = (0,external_react_.useMemo)(() => {
    if (!filters) return null;
    return filters.filter(fieldFilter => {
      const urlSuffix = fieldFilter?.filter?.getFilterType()?.getURLSuffix();
      return urlSuffix !== NOT_ANY_FILTER_TYPE.getURLSuffix() && urlSuffix !== '';
    });
  }, [filters]);
  const _onApply = (0,external_react_.useCallback)(() => {
    const filterErrors = getFieldFiltersValidationResult({
      [queryInfo.name.toLowerCase()]: filters
    });
    if (!filterErrors) {
      onApply(validFieldFilters.map(fieldFilter => fieldFilter.filter));
    } else {
      setFilterError(filterErrors);
    }
  }, [filters, onApply, queryInfo, validFieldFilters]);
  const onFilterUpdate = (0,external_react_.useCallback)((field, newFilters, index) => {
    setFilterError(undefined);
    const activeFieldKey = field.getDisplayFieldKey();
    const updatedFilters = filters?.filter(fieldFilter => fieldFilter.fieldKey !== activeFieldKey) ?? [];
    if (newFilters) {
      newFilters?.filter(newFilter => newFilter !== null).forEach(newFilter => {
        updatedFilters.push({
          fieldKey: activeFieldKey,
          fieldCaption: field.caption,
          filter: newFilter,
          jsonType: field.getDisplayFieldJsonType()
        });
      });
    }
    setFilters(updatedFilters);
  }, [filters]);
  const canConfirm = validFieldFilters && Object.keys(validFieldFilters).length > 0;
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    bsSize: "lg",
    canConfirm: canConfirm,
    confirmText: "Apply",
    onCancel: closeModal,
    onConfirm: _onApply,
    title: `Filter ${queryInfo.title}`
  }, /*#__PURE__*/external_react_default().createElement(Alert, null, filterError), /*#__PURE__*/external_react_default().createElement(QueryFilterPanel, {
    asRow: true,
    api: api,
    fieldKey: fieldKey,
    filters: {
      [queryInfo.name.toLowerCase()]: filters
    },
    fullWidth: true,
    onFilterUpdate: onFilterUpdate,
    queryInfo: queryInfo,
    selectDistinctOptions: selectDistinctOptions,
    skipDefaultViewCheck: skipDefaultViewCheck,
    validFilterField: isValidFilterField,
    viewName: model.viewName
  }));
});
GridFilterModal.defaultProps = {
  api: getDefaultAPIWrapper()
};
;// CONCATENATED MODULE: ./src/public/QueryModel/FiltersButton.tsx


const FiltersButton = (0,external_react_.memo)(props => {
  const {
    onFilter,
    iconOnly
  } = props;
  if (iconOnly) {
    return /*#__PURE__*/external_react_default().createElement(Tip, {
      caption: "Filters"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "grid-panel__button btn btn-default",
      onClick: onFilter,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-filter"
    })));
  }
  return /*#__PURE__*/external_react_default().createElement("button", {
    className: "grid-panel__button btn btn-default",
    onClick: onFilter,
    type: "button"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-filter"
  }), " Filters");
});
;// CONCATENATED MODULE: ./src/public/QueryModel/grid/Value.tsx
function Value_defineProperty(e, r, t) { return (r = Value_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Value_toPropertyKey(t) { var i = Value_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Value_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2018 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


const valueClassName = 'filter-status-value';
class Value extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    Value_defineProperty(this, "onClick", event => {
      event.stopPropagation();
      event.preventDefault();
      if (this.props.onClick && this.props.actionValue.isReadOnly === undefined) {
        this.props.onClick(this.props.actionValue, event);
      }
    });
    Value_defineProperty(this, "onIconClick", event => {
      event.stopPropagation();
      event.preventDefault();
      if (this.props.onRemove && this.props.actionValue.isRemovable !== false) {
        this.props.onRemove(this.props.index, event);
      }
    });
    Value_defineProperty(this, "onMouseEnter", () => {
      this.setState({
        isActive: true
      });
    });
    Value_defineProperty(this, "onMouseLeave", () => {
      this.setState({
        isActive: false
      });
    });
    this.state = {
      isActive: false,
      isDisabled: false
    };
  }
  render() {
    const {
      actionValue
    } = this.props;
    const {
      action,
      value,
      displayValue,
      isReadOnly,
      isRemovable
    } = actionValue;
    const showRemoveIcon = this.state.isActive && isRemovable !== false && actionValue.action.keyword !== 'view';
    const className = external_classnames_default()(valueClassName, {
      'is-active': this.state.isActive,
      'is-disabled': this.state.isDisabled,
      'is-readonly': isReadOnly !== undefined
    });
    const iconClassNames = external_classnames_default()('symbol', 'fa', showRemoveIcon ? 'fa-close' : action.iconCls ? 'fa-' + action.iconCls : '');
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: className,
      onClick: this.onClick,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: iconClassNames,
      onClick: this.onIconClick
    }), isReadOnly ? /*#__PURE__*/external_react_default().createElement("i", {
      className: "read-lock fa fa-lock",
      title: isReadOnly
    }) : null, /*#__PURE__*/external_react_default().createElement("span", null, displayValue ?? value));
  }
}
;// CONCATENATED MODULE: ./src/public/QueryModel/FilterStatus.tsx



const FilterStatus = (0,external_react_.memo)(props => {
  const {
    actionValues,
    onClick,
    onRemove,
    onRemoveAll
  } = props;
  const showRemoveAll = filterActionValuesByType(actionValues, 'filter').length > 1;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "grid-panel__filter-status"
  }, actionValues.sort((a, b) => {
    // sort the view actions to the front
    if (a.action.keyword !== b.action.keyword) {
      return a.action.keyword === 'view' ? -1 : b.action.keyword === 'view' ? 1 : 0;
    }

    // then sort by filter display value
    const aDisplayValue = a.displayValue ?? a.value;
    const bDisplayValue = b.displayValue ?? b.value;
    return aDisplayValue > bDisplayValue ? 1 : aDisplayValue < bDisplayValue ? -1 : 0;
  }).map((actionValue, index) => {
    // loop over all actionValues so that the index remains consistent, but don't show sort actions
    if (actionValue.action.keyword === 'sort') {
      return null;
    }

    // only FilterActions can be edited via click
    const _onClick = actionValue.action.keyword === 'filter' ? onClick : undefined;
    // search and filter actions can be removed via click
    const _onRemove = actionValue.action.keyword === 'filter' || actionValue.action.keyword === 'search' ? onRemove : undefined;
    return /*#__PURE__*/external_react_default().createElement(Value, {
      key: index,
      index: index,
      actionValue: actionValue,
      onClick: _onClick,
      onRemove: _onRemove
    });
  }), onRemoveAll && showRemoveAll && /*#__PURE__*/external_react_default().createElement("a", {
    className: "remove-all-filters",
    onClick: onRemoveAll
  }, "Remove all"));
});
;// CONCATENATED MODULE: ./src/public/QueryModel/SaveViewModal.tsx










const MAX_VIEW_NAME_LENGTH = 200;
const RESERVED_VIEW_NAMES = ['default', 'my default', 'your default', '~~details~~', '~~insert~~', '~~update~~', '~~samplefinder~~'];
const ViewNameInput = (0,external_react_.memo)(props => {
  const {
    autoFocus,
    defaultValue,
    placeholder,
    view,
    isDefaultView,
    onBlur,
    onChange,
    maxLength = MAX_VIEW_NAME_LENGTH
  } = props;
  const [nameError, setNameError] = (0,external_react_.useState)(undefined);
  const [viewName, setViewName] = (0,external_react_.useState)(view?.isDefault || view?.hidden ? '' : view?.name);
  const setNameErrorMessage = (0,external_react_.useCallback)(() => {
    const trimmed = viewName.trim();
    if (trimmed.length > maxLength) {
      setNameError(`Current length: ${trimmed.length}; maximum length: ${maxLength}`);
    } else if (RESERVED_VIEW_NAMES.indexOf(trimmed.toLowerCase()) >= 0) setNameError(`View name '${trimmed}' is reserved.`);else setNameError(undefined);
  }, [maxLength, viewName]);
  (0,external_react_.useEffect)(() => {
    if (!isDefaultView) {
      setNameErrorMessage();
    }
  }, [isDefaultView, setNameErrorMessage, viewName]);
  const clearError = (0,external_react_.useCallback)(() => {
    setNameError(undefined);
  }, []);
  const onViewNameChange = (0,external_react_.useCallback)(evt => {
    setViewName(evt.target.value);
    const trimmed = evt.target.value.trim();
    const hasError = trimmed.length > maxLength || RESERVED_VIEW_NAMES.indexOf(trimmed) >= 0;
    setNameErrorMessage();
    onChange?.(evt.target.value, hasError);
  }, [maxLength, onChange, setNameErrorMessage]);
  const _onBlur = (0,external_react_.useCallback)(() => {
    if (viewName.length > maxLength) {
      setNameErrorMessage();
      onBlur(viewName, true);
    } else {
      onBlur(viewName, false);
    }
  }, [maxLength, onBlur, setNameErrorMessage, viewName]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("input", {
    autoFocus: autoFocus,
    name: "gridViewName",
    defaultValue: defaultValue,
    placeholder: placeholder ?? 'Grid View Name',
    className: 'form-control' + (nameError ? ' grid-view-name-error' : ''),
    value: viewName,
    onChange: onViewNameChange,
    onFocus: clearError,
    onBlur: _onBlur,
    disabled: isDefaultView,
    type: "text"
  }), nameError && /*#__PURE__*/external_react_default().createElement("span", {
    className: "text-danger"
  }, nameError));
});
const SaveViewModal = (0,external_react_.memo)(props => {
  const {
    onConfirmSave,
    currentView,
    onCancel,
    gridLabel
  } = props;
  const {
    container,
    moduleContext,
    user
  } = useServerContext();
  const [viewName, setViewName] = (0,external_react_.useState)(currentView?.isDefault || currentView?.hidden ? '' : currentView?.name);
  const [nameError, setNameError] = (0,external_react_.useState)(false);
  const [isDefaultView, setIsDefaultView] = (0,external_react_.useState)(() => user.hasAdminPermission() && currentView?.isDefault);
  const [canInherit, setCanInherit] = (0,external_react_.useState)(currentView?.inherit);
  const [isShared, setIsShared] = (0,external_react_.useState)(currentView?.shared);
  const [errorMessage, setErrorMessage] = (0,external_react_.useState)();
  const [isSubmitting, setIsSubmitting] = (0,external_react_.useState)();
  const canEditShared = userCanEditSharedViews(user);
  const saveView = (0,external_react_.useCallback)(async () => {
    if (!viewName && !isDefaultView) return;
    setErrorMessage(undefined);
    setIsSubmitting(true);
    try {
      const name = isDefaultView ? '' : viewName.trim();
      const isCurrentView = name?.toLowerCase() === currentView?.name?.toLowerCase();
      await onConfirmSave(name, canInherit, isCurrentView, isDefaultView || isShared);
    } catch (error) {
      setErrorMessage(resolveErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  }, [viewName, isDefaultView, currentView?.name, onConfirmSave, canInherit, isShared]);
  const onViewNameChange = (0,external_react_.useCallback)((name, hasError) => {
    setViewName(name);
    setNameError(hasError);
  }, []);
  const toggleDefaultView = (0,external_react_.useCallback)(evt => {
    setIsDefaultView(evt.target.id === 'defaultView');
    setNameError(false);
  }, []);
  const toggleInherit = (0,external_react_.useCallback)(evt => setCanInherit(evt.target.checked), []);
  const toggleShared = (0,external_react_.useCallback)(evt => setIsShared(evt.target.checked), []);
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    canConfirm: !!viewName && !nameError || isDefaultView,
    isConfirming: isSubmitting,
    onCancel: onCancel,
    onConfirm: saveView,
    title: "Save Grid View"
  }, /*#__PURE__*/external_react_default().createElement(Alert, null, errorMessage), /*#__PURE__*/external_react_default().createElement("form", {
    onSubmit: saveView
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "bottom-spacing"
  }, "Columns, sort order, and filters will be saved. Once saved, this view will be available for all", ' ', gridLabel, " grids throughout the application."), /*#__PURE__*/external_react_default().createElement(RequiresPermission, {
    perms: api_.PermissionTypes.Admin
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "content-form"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: "clickable"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-check-input",
    type: "radio",
    name: "setSaveType",
    id: "defaultView",
    onChange: toggleDefaultView,
    checked: isDefaultView
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "margin-left"
  }, "Save as default view for all users"))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "content-form"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: "clickable"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    checked: !isDefaultView,
    name: "setSaveType",
    id: "customView",
    onChange: toggleDefaultView,
    type: "radio"
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "margin-left"
  }, "Save as a custom view")))), !isDefaultView && /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('bottom-spacing', {
      'margin-left-more': user.hasAdminPermission()
    })
  }, /*#__PURE__*/external_react_default().createElement(ViewNameInput, {
    onChange: onViewNameChange,
    onBlur: onViewNameChange,
    view: currentView,
    isDefaultView: isDefaultView
  })), !isDefaultView && canEditShared && /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    name: "setShared",
    onChange: toggleShared,
    checked: isShared
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "margin-left"
  }, "Make this grid view available to all users")), isProductProjectsEnabled(moduleContext) && isAppHomeFolder(container, moduleContext) && canEditShared && /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    name: "setInherit",
    onChange: toggleInherit,
    checked: canInherit
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "margin-left"
  }, "Make this grid view available in all Projects")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "top-spacing"
  }, "Learn more about ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: CUSTOM_VIEW
  }, "custom grid views"), " in LabKey."))));
});
;// CONCATENATED MODULE: ./src/internal/components/ColumnSelectionModal.tsx
const ColumnSelectionModal_excluded = ["allowEditLabel", "allowEmptySelection", "allowShowAll", "error", "expandedColumnFilter", "initialSelectedColumn", "initialSelectedColumns", "isLoaded", "leftColumnTitle", "onExpand", "onSubmit", "queryInfo", "rightColumnTitle"];
function ColumnSelectionModal_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ColumnSelectionModal_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ColumnSelectionModal_ownKeys(Object(t), !0).forEach(function (r) { ColumnSelectionModal_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ColumnSelectionModal_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ColumnSelectionModal_defineProperty(e, r, t) { return (r = ColumnSelectionModal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ColumnSelectionModal_toPropertyKey(t) { var i = ColumnSelectionModal_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ColumnSelectionModal_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ColumnSelectionModal_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = ColumnSelectionModal_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function ColumnSelectionModal_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ColumnSelectionModal_extends() { return ColumnSelectionModal_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ColumnSelectionModal_extends.apply(null, arguments); }









const FieldLabelDisplay = (0,external_react_.memo)(props => {
  const {
    column,
    editing,
    includeFieldKey,
    onEditComplete
  } = props;
  const initialTitle = (0,external_react_.useMemo)(() => column.caption ?? column.name, [column.caption, column.name]);
  const [title, setTitle] = (0,external_react_.useState)(initialTitle);
  (0,external_react_.useEffect)(() => {
    setTitle(initialTitle);
  }, [initialTitle]);
  const onBlur = (0,external_react_.useCallback)(() => {
    if (title !== initialTitle) {
      onEditComplete(column, title);
    } else {
      onEditComplete();
    }
  }, [column, initialTitle, title, onEditComplete]);
  const onChange = (0,external_react_.useCallback)(evt => {
    setTitle(evt.target.value);
  }, []);
  const id = column.index + '-fieldlabel-popover';
  const popover = (0,external_react_.useMemo)(() => /*#__PURE__*/external_react_default().createElement(Popover, {
    id: id,
    placement: "left"
  }, column.index), [column.index, id]);
  if (editing) {
    return /*#__PURE__*/external_react_default().createElement("input", {
      autoFocus: true,
      placeholder: undefined,
      className: "form-control",
      defaultValue: title,
      onBlur: onBlur,
      onChange: onChange,
      type: "text"
    });
  }
  // Issue 46256: use encoded fieldKeyPath, Issue 49795: show tooltip more often to account for renamed fields, etc.
  if (!includeFieldKey) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "field-name"
    }, initialTitle);
  }
  return /*#__PURE__*/external_react_default().createElement(OverlayTrigger, {
    className: "field-name",
    overlay: popover
  }, /*#__PURE__*/external_react_default().createElement("span", null, initialTitle));
});
// exported for jest tests
const ColumnChoice = (0,external_react_.memo)(props => {
  const {
    column,
    isExpanded,
    isInView,
    onAddColumn,
    onExpandColumn,
    onCollapseColumn
  } = props;
  const supportsExpand = !!onExpandColumn;
  const colFieldKey = column.index;

  // 46256: use encoded fieldKeyPath
  const hasParentFieldKeys = column.fieldKeyPath.indexOf('/') > -1;
  const parentFieldKeys = hasParentFieldKeys ? column.fieldKeyPath.substring(0, column.fieldKeyPath.lastIndexOf('/')).split('/') : [];
  const _onAddColumn = (0,external_react_.useCallback)(() => {
    onAddColumn(column);
  }, [column, onAddColumn]);
  const _onExpandColumn = (0,external_react_.useCallback)(() => {
    onExpandColumn(column);
  }, [column, onExpandColumn]);
  const _onCollapseColumn = (0,external_react_.useCallback)(() => {
    onCollapseColumn(column);
  }, [column, onCollapseColumn]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "list-group-item flex",
    key: colFieldKey,
    "data-fieldkey": colFieldKey
  }, supportsExpand && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, parentFieldKeys.map((parent, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  external_react_default().createElement("div", {
    className: "field-expand-icon",
    key: `${colFieldKey}|${index}`
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-expand-icon"
  }, column.isLookup() && !isExpanded && /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-chevron-right",
    onClick: _onExpandColumn
  }), column.isLookup() && isExpanded && /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-chevron-down",
    onClick: _onCollapseColumn
  }))), /*#__PURE__*/external_react_default().createElement(FieldLabelDisplay, {
    column: column
  }), isInView && /*#__PURE__*/external_react_default().createElement("div", {
    className: "pull-right view-field__action disabled",
    title: "This field is included in the view."
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-check"
  })), !isInView && column.selectable && /*#__PURE__*/external_react_default().createElement("div", {
    className: "pull-right view-field__action",
    title: "Add this field to the view.",
    onClick: _onAddColumn
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-plus"
  })));
});
const ColumnChoiceGroup = (0,external_react_.memo)(props => {
  const {
    expandedColumnFilter,
    expandedColumns,
    column,
    onAddColumn,
    onExpandColumn,
    onCollapseColumn,
    columnsInView,
    showAllColumns
  } = props;
  const isLookupExpanded = !!expandedColumns?.[column.index];
  const isColumnInView = (0,external_react_.useCallback)(col => columnsInView.findIndex(c => c.index === col.index) !== -1, [columnsInView]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(ColumnChoice, {
    column: column,
    isExpanded: isLookupExpanded,
    isInView: isColumnInView(column),
    key: column.index,
    onAddColumn: onAddColumn,
    onCollapseColumn: onCollapseColumn,
    onExpandColumn: onExpandColumn
  }), isLookupExpanded && expandedColumns[column.index].columns.valueArray.filter(fkCol => expandedColumnFilter?.(fkCol, showAllColumns) ?? true).map(fkCol => /*#__PURE__*/external_react_default().createElement(ColumnChoiceGroup, {
    column: fkCol,
    key: fkCol.index,
    isInView: isColumnInView(fkCol),
    onAddColumn: onAddColumn,
    isExpanded: !!expandedColumns[fkCol.index],
    onExpandColumn: onExpandColumn,
    expandedColumnFilter: expandedColumnFilter,
    onCollapseColumn: onCollapseColumn,
    expandedColumns: expandedColumns,
    columnsInView: columnsInView,
    showAllColumns: showAllColumns
  })));
});
const ColumnInView = (0,external_react_.memo)(props => {
  const {
    allowEditLabel,
    column,
    isDragDisabled,
    onRemoveColumn,
    onClick,
    onEditTitle,
    onUpdateTitle,
    selected,
    index
  } = props;
  const key = column.index;
  const [editing, setEditing] = (0,external_react_.useState)(false);
  const _onRemoveColumn = (0,external_react_.useCallback)(() => {
    onRemoveColumn(column);
  }, [column, onRemoveColumn]);
  const _onClick = (0,external_react_.useCallback)(() => {
    onClick(index);
  }, [onClick, index]);
  const _onUpdateTitle = (0,external_react_.useCallback)((col, title) => {
    setEditing(false);
    if (col && title) {
      onUpdateTitle(col, title);
    }
  }, [onUpdateTitle]);
  const _onEditTitle = (0,external_react_.useCallback)(() => {
    setEditing(true);
    onEditTitle();
  }, [onEditTitle]);
  return /*#__PURE__*/external_react_default().createElement(external_react_beautiful_dnd_.Draggable, {
    key: key,
    draggableId: key,
    index: index,
    isDragDisabled: isDragDisabled
  }, (dragProvided, snapshot) => /*#__PURE__*/external_react_default().createElement("div", ColumnSelectionModal_extends({
    className: external_classnames_default()('list-group-item flex draggable', {
      active: selected && !editing
    }),
    onClick: _onClick,
    ref: dragProvided.innerRef
  }, dragProvided.draggableProps), /*#__PURE__*/external_react_default().createElement("div", ColumnSelectionModal_extends({
    className: "right-spacing"
  }, dragProvided.dragHandleProps), /*#__PURE__*/external_react_default().createElement(DragDropHandle, ColumnSelectionModal_extends({
    highlighted: snapshot.isDragging
  }, dragProvided.dragHandleProps))), /*#__PURE__*/external_react_default().createElement(FieldLabelDisplay, {
    column: column,
    includeFieldKey: true,
    editing: editing,
    onEditComplete: _onUpdateTitle
  }), !editing && /*#__PURE__*/external_react_default().createElement("span", {
    className: "pull-right"
  }, allowEditLabel && /*#__PURE__*/external_react_default().createElement("span", {
    className: "edit-inline-field__toggle",
    title: "Edit the field's label for this view.",
    onClick: _onEditTitle
  }, /*#__PURE__*/external_react_default().createElement("i", {
    id: 'select-' + index,
    className: "fa fa-pencil"
  })), /*#__PURE__*/external_react_default().createElement("span", {
    className: "view-field__action clickable",
    title: "Remove this field from the view.",
    onClick: _onRemoveColumn
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-times"
  })))));
});
const ColumnSelectionModal = (0,external_react_.memo)(props => {
  const {
      allowEditLabel,
      allowEmptySelection,
      allowShowAll,
      error,
      expandedColumnFilter,
      initialSelectedColumn,
      initialSelectedColumns,
      isLoaded,
      leftColumnTitle,
      onExpand,
      onSubmit,
      queryInfo,
      rightColumnTitle
    } = props,
    confirmModalProps = ColumnSelectionModal_objectWithoutProperties(props, ColumnSelectionModal_excluded);
  const [editingColumnTitle, setEditingColumnTitle] = (0,external_react_.useState)(false);
  const [expandedColumns, setExpandedColumns] = (0,external_react_.useState)({});
  const [isDirty, setIsDirty] = (0,external_react_.useState)(false);
  const [queryError, setQueryError] = (0,external_react_.useState)();
  const [selectedColumns, setSelectedColumns] = (0,external_react_.useState)([]);
  const [selectedIndex, setSelectedIndex] = (0,external_react_.useState)();
  const [showAllColumns, setShowAllColumns] = (0,external_react_.useState)(false);
  (0,external_react_.useEffect)(() => {
    if (isLoaded) {
      const selectedColumns_ = initialSelectedColumns ?? [];
      setSelectedColumns(selectedColumns_);
      if (initialSelectedColumn) {
        setSelectedIndex(selectedColumns_.findIndex(col => initialSelectedColumn.index === col.index));
      }
    }
  }, [initialSelectedColumn, initialSelectedColumns, isLoaded]);
  const onAddColumn = (0,external_react_.useCallback)(column => {
    if (selectedIndex !== undefined) {
      setSelectedColumns(columns => [...columns.slice(0, selectedIndex + 1), column, ...columns.slice(selectedIndex + 1)]);
    } else {
      setSelectedColumns(columns => [...columns, column]);
    }
    setIsDirty(true);
  }, [selectedIndex, setIsDirty]);
  const onCollapseColumn = (0,external_react_.useCallback)(column => {
    setQueryError(undefined);
    setExpandedColumns(expanded => ColumnSelectionModal_objectSpread(ColumnSelectionModal_objectSpread({}, expanded), {}, {
      [column.index]: undefined
    }));
  }, []);
  const onConfirm = (0,external_react_.useCallback)(() => {
    onSubmit(selectedColumns);
  }, [selectedColumns, onSubmit]);
  const onDragEnd = (0,external_react_.useCallback)(dropResult => {
    const {
      destination,
      draggableId,
      source
    } = dropResult;
    if (destination === null || source.index === destination.index) {
      return;
    }
    const {
      index
    } = destination;
    const colInMotion = selectedColumns[source.index];
    let updatedColumns = selectedColumns.filter(col => col.index != draggableId);
    updatedColumns = [...updatedColumns.slice(0, index), colInMotion, ...updatedColumns.slice(index)];
    setSelectedColumns(updatedColumns);
    if (source.index === selectedIndex) {
      setSelectedIndex(index);
    } else if (selectedIndex !== undefined) {
      if (source.index > selectedIndex && index <= selectedIndex) {
        setSelectedIndex(selectedIndex + 1);
      } else if (source.index < selectedIndex && index >= selectedIndex) {
        setSelectedIndex(selectedIndex - 1);
      }
    }
    setIsDirty(true);
  }, [selectedColumns, selectedIndex]);
  const onEditTitle = (0,external_react_.useCallback)(() => {
    setEditingColumnTitle(true);
  }, []);
  const onExpandColumn = (0,external_react_.useCallback)(async column => {
    try {
      setQueryError(undefined);
      const queryInfo_ = await onExpand(column);
      setExpandedColumns(expanded => ColumnSelectionModal_objectSpread(ColumnSelectionModal_objectSpread({}, expanded), {}, {
        [column.index]: queryInfo_
      }));
    } catch (e) {
      setQueryError(e.message);
    }
  }, [onExpand]);
  const onRemoveColumn = (0,external_react_.useCallback)(removedColumn => {
    setSelectedColumns(columns => columns.filter(c => c.index !== removedColumn.index));
    setIsDirty(true);
  }, []);
  const onRevertEdits = (0,external_react_.useCallback)(() => {
    setSelectedColumns(initialSelectedColumns ?? []);
    setIsDirty(false);
    setSelectedIndex(undefined);
  }, [initialSelectedColumns]);
  const onSelectField = (0,external_react_.useCallback)(index => {
    setSelectedIndex(selectedIndex_ => selectedIndex_ === index ? undefined : index);
  }, []);
  const onUpdateTitle = (0,external_react_.useCallback)((updatedColumn, caption) => {
    const relabeledColumn = updatedColumn.mutate({
      caption
    });
    const index = selectedColumns.findIndex(column => column.index === updatedColumn.index);
    setSelectedColumns([...selectedColumns.slice(0, index), relabeledColumn, ...selectedColumns.slice(index + 1)]);
    setIsDirty(true);
    setEditingColumnTitle(false);
  }, [selectedColumns]);
  const onToggleShowAll = (0,external_react_.useCallback)(() => {
    setShowAllColumns(s => !s);
  }, []);
  const availableColumns = (0,external_react_.useMemo)(() => {
    if (!isLoaded || !queryInfo) return [];
    return queryInfo.columns.valueArray.filter(c => expandedColumnFilter?.(c, showAllColumns) ?? true).filter(c => c.fieldKeyArray.length === 1); // at the top level don't include lookup fields
  }, [expandedColumnFilter, isLoaded, queryInfo, showAllColumns]);
  return /*#__PURE__*/external_react_default().createElement(Modal, ColumnSelectionModal_extends({}, confirmModalProps, {
    bsSize: "lg",
    canConfirm: isDirty && (allowEmptySelection || selectedColumns.length > 0),
    onConfirm: onConfirm
  }), /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement(Alert, null, queryError), !isLoaded && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), isLoaded && /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__container row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12 col-sm-6 field-modal__col-2"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    key: "title",
    className: "field-modal__col-title"
  }, leftColumnTitle), /*#__PURE__*/external_react_default().createElement("div", {
    key: "field-list",
    className: "list-group field-modal__col-content"
  }, availableColumns.map(column => /*#__PURE__*/external_react_default().createElement(ColumnChoiceGroup, {
    column: column,
    key: column.index,
    onAddColumn: onAddColumn,
    onExpandColumn: onExpand ? onExpandColumn : undefined,
    onCollapseColumn: onCollapseColumn,
    expandedColumnFilter: expandedColumnFilter,
    expandedColumns: expandedColumns,
    columnsInView: selectedColumns,
    showAllColumns: showAllColumns
  }))), allowShowAll && /*#__PURE__*/external_react_default().createElement("div", {
    key: "toggleAll",
    className: "field-modal__footer"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "checkbox",
    checked: showAllColumns,
    onChange: onToggleShowAll
  }), "\xA0Show all system and user-defined fields")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12 col-sm-6 field-modal__col-2"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "field-modal__col-title"
  }, rightColumnTitle, /*#__PURE__*/external_react_default().createElement("span", {
    className: 'pull-right ' + (isDirty ? 'action-text' : 'disabled-action-text'),
    onClick: isDirty ? onRevertEdits : undefined
  }, "Undo edits")), /*#__PURE__*/external_react_default().createElement(external_react_beautiful_dnd_.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/external_react_default().createElement(external_react_beautiful_dnd_.Droppable, {
    droppableId: "field-droppable"
  }, dropProvided => /*#__PURE__*/external_react_default().createElement("div", ColumnSelectionModal_extends({
    className: "list-group field-modal__col-content"
  }, dropProvided.droppableProps, {
    ref: dropProvided.innerRef
  }), selectedColumns.map((column, index) => /*#__PURE__*/external_react_default().createElement(ColumnInView, {
    allowEditLabel: allowEditLabel,
    key: column.index,
    column: column,
    index: index,
    isDragDisabled: editingColumnTitle,
    onRemoveColumn: onRemoveColumn,
    selected: selectedIndex === index,
    onClick: onSelectField,
    onEditTitle: onEditTitle,
    onUpdateTitle: onUpdateTitle
  })), dropProvided.placeholder))))));
});
ColumnSelectionModal.defaultProps = {
  allowEditLabel: false,
  allowEmptySelection: false,
  allowShowAll: false,
  isLoaded: true,
  leftColumnTitle: 'Available Fields',
  rightColumnTitle: 'Selected Fields'
};
ColumnSelectionModal.displayName = 'ColumnSelectionModal';
;// CONCATENATED MODULE: ./src/public/QueryModel/CustomizeGridViewModal.tsx






// exported for jest testing
const includedColumnsForCustomizationFilter = (column, showAllColumns) => {
  const isAncestor = column.fieldKeyPath?.indexOf('/Ancestors') >= 0;
  const isAncestorChild = column.fieldKeyPath?.indexOf('Ancestors/') >= 0;
  const isRunSampleAncestor = isAncestor && column.fieldKeyPath?.indexOf('Run/') >= 0;
  // don't allow multiple levels of ancestors since the ancestor value may not be a valid rowId to join through
  const isNestedAncestor = column.fieldKeyPath?.indexOf('Ancestors/') !== column.fieldKeyPath?.lastIndexOf('/Ancestors') + 1;
  return (showAllColumns || !column.hidden) && !column.removeFromViews && (showPremiumFeatures() || !column.removeFromViewCustomization) && !isRunSampleAncestor && (
  // Issue 46870: Don't allow selection/inclusion of multi-valued lookup fields from Ancestors
  !isAncestorChild || !isNestedAncestor && !column.isJunctionLookup());
};
const CustomizeGridViewModal = (0,external_react_.memo)(props => {
  const {
    model,
    onCancel,
    onUpdate,
    selectedColumn
  } = props;
  const {
    title,
    queryInfo
  } = model;
  const [saveError, setSaveError] = (0,external_react_.useState)();
  const gridName = title ?? model.schemaQuery.queryName;
  const initialSelectedColumns = (0,external_react_.useMemo)(() => model.displayColumns, [model]);
  const onExpand = (0,external_react_.useCallback)(async column => {
    const fkQueryInfo = await getQueryDetails({
      fk: column.index,
      lookup: column.lookup,
      schemaQuery: queryInfo.schemaQuery
    });
    // For data classes, we want to limit the Ancestor filters to exclude 'Samples'
    if (column.index === 'Ancestors' && queryInfo.schemaQuery.schemaName === SCHEMAS.DATA_CLASSES.SCHEMA) {
      fkQueryInfo.columns = fkQueryInfo.columns.filter(col => col.fieldKey !== 'Samples' && col.fieldKey !== 'MediaSamples');
    }
    return fkQueryInfo;
  }, [queryInfo]);
  const onSubmit = (0,external_react_.useCallback)(async selectedColumns => {
    try {
      setSaveError(undefined);
      const viewInfo = model.currentView.mutate({
        columns: selectedColumns.map(col => ({
          fieldKey: col.fieldKeyPath /* Issue 46256: use encoded fieldKeyPath */,
          title: model.getCustomViewTitleOverride(col)
        }))
      });
      await saveAsSessionView(model.schemaQuery, model.containerPath, viewInfo);
      onCancel();
      onUpdate();
    } catch (error) {
      setSaveError(error);
    }
  }, [onCancel, onUpdate, model]);
  const titleNode = (0,external_react_.useMemo)(() => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "Customize ", gridName, " Grid", model.viewName && ' - ' + model.viewName, model.currentView.session && /*#__PURE__*/external_react_default().createElement("span", {
    className: "alert-info view-edit-alert view-edit-title-alert"
  }, "Edited")), [gridName, model.viewName, model.currentView.session]);
  return /*#__PURE__*/external_react_default().createElement(ColumnSelectionModal, {
    allowEditLabel: true,
    allowShowAll: true,
    confirmText: "Update Grid",
    expandedColumnFilter: includedColumnsForCustomizationFilter,
    initialSelectedColumn: selectedColumn,
    initialSelectedColumns: initialSelectedColumns,
    onCancel: onCancel,
    onExpand: onExpand,
    onSubmit: onSubmit,
    queryInfo: model.queryInfo,
    rightColumnTitle: "Shown in Grid",
    saveError: saveError,
    title: titleNode
  });
});
;// CONCATENATED MODULE: ./src/public/QueryModel/ManageViewsModal.tsx














// exported for jest tests
const ViewLabel = (0,external_react_.memo)(props => {
  const {
    view
  } = props;
  const viewLabel = view.isDefault ? view.saved && !view.shared ? 'My Default View' : 'Default View' : view.label;
  const modifiers = view.modifiers;
  if (modifiers.length > 0) {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, viewLabel, " ", /*#__PURE__*/external_react_default().createElement("span", {
      className: "text-muted"
    }, "(", modifiers.join(', '), ")"));
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, viewLabel);
});
const ManageViewsModal = (0,external_react_.memo)(props => {
  const {
    onDone,
    schemaQuery,
    currentView,
    containerPath
  } = props;
  const [views, setViews] = (0,external_react_.useState)();
  const [selectedView, setSelectedView] = (0,external_react_.useState)();
  const [errorMessage, setErrorMessage] = (0,external_react_.useState)();
  const [isSubmitting, setIsSubmitting] = (0,external_react_.useState)();
  const [hasChange, setHasChange] = (0,external_react_.useState)();
  const [reselectViewName, setReselectViewName] = (0,external_react_.useState)();
  const [deleting, setDeleting] = (0,external_react_.useState)();
  const {
    api
  } = useAppContext();
  const {
    user
  } = useServerContext();
  const userCanEditShared = userCanEditSharedViews(user);
  (0,external_react_.useEffect)(() => {
    (async () => {
      try {
        setViews(await api.query.getGridViews(schemaQuery, true));
      } catch (error) {
        setErrorMessage(resolveErrorMessage(error));
      }
    })();
  }, []);
  const onClose = (0,external_react_.useCallback)(() => {
    onDone(hasChange, reselectViewName);
  }, [hasChange, reselectViewName, onDone]);
  const handleAction = (0,external_react_.useCallback)(async _handle => {
    setErrorMessage(undefined);
    setDeleting(undefined);
    setIsSubmitting(true);
    setHasChange(true);
    try {
      await _handle();
      setViews(await api.query.getGridViews(schemaQuery, true));
    } catch (error) {
      setErrorMessage(resolveErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  }, [api, schemaQuery]);
  const getActionView = (0,external_react_.useCallback)(event => {
    const targetId = event.target.id;
    const viewInd = parseInt(targetId.split('-')[1]);
    return views[viewInd];
  }, [views]);
  const onSelectView = (0,external_react_.useCallback)(event => {
    const view = getActionView(event);
    setSelectedView(view);
  }, [getActionView]);
  const revertDefaultView = (0,external_react_.useCallback)(() => {
    handleAction(async () => {
      await api.query.deleteView(schemaQuery, containerPath, '', true);
    });
  }, [api, handleAction, schemaQuery, containerPath]);
  const setDefaultView = (0,external_react_.useCallback)(event => {
    const view = getActionView(event);
    handleAction(async () => {
      const finalViewInfo = view.mutate({
        name: ''
      });
      if (view.session) {
        await api.query.saveSessionView(schemaQuery, containerPath, view.name, '', view.inherit, true, true);
      } else {
        await api.query.saveGridView(schemaQuery, containerPath, finalViewInfo, true, false, view.inherit, true);
      }
      if (currentView.name === view.name) setReselectViewName('');
    });
  }, [api, getActionView, handleAction, currentView, schemaQuery, containerPath]);
  const deleteSavedView = (0,external_react_.useCallback)(() => {
    handleAction(async () => {
      const viewName = deleting.name;
      await api.query.deleteView(schemaQuery, containerPath, viewName, true);
      if (currentView.name === viewName || reselectViewName === viewName) setReselectViewName('');
    });
  }, [api, handleAction, deleting, schemaQuery, containerPath, currentView, reselectViewName]);
  const onDeleteView = (0,external_react_.useCallback)(event => {
    setDeleting(getActionView(event));
  }, [getActionView]);
  const cancelDeleteView = (0,external_react_.useCallback)(() => {
    setDeleting(undefined);
  }, []);
  const renameView = (0,external_react_.useCallback)(async (newName, hasError) => {
    if (!selectedView || !newName || !newName.trim() || hasError) {
      setSelectedView(undefined);
      return;
    }
    if (selectedView.name.toLowerCase() === newName.toLowerCase()) {
      setSelectedView(undefined);
      return;
    }
    await handleAction(async () => {
      await api.query.renameGridView(schemaQuery, containerPath, selectedView.name, newName);
      setSelectedView(undefined);
      if (selectedView.name === currentView.name) setReselectViewName(newName);
    });
  }, [api, selectedView, handleAction, schemaQuery, containerPath, currentView]);
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    cancelText: "Done",
    onCancel: onClose,
    title: "Manage Saved Views"
  }, /*#__PURE__*/external_react_default().createElement(Alert, null, errorMessage), !views && !errorMessage && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), views && views.map((view, ind) => {
    const {
      isDefault,
      isSystemView,
      shared
    } = view;

    // other than the default view, don't show system views
    if (!isDefault && isSystemView) {
      return null;
    }
    const unsavedView = view.session;
    const isRenaming = !!selectedView;
    let canEdit = !isDefault && !isRenaming && !unsavedView && !deleting;
    if (shared) {
      canEdit = canEdit && userCanEditShared;
    }
    return /*#__PURE__*/external_react_default().createElement(external_react_.Fragment, {
      key: view.name
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row small-margin-bottom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8"
    }, selectedView && selectedView?.name === view.name ? /*#__PURE__*/external_react_default().createElement(ViewNameInput, {
      autoFocus: true,
      view: selectedView,
      onBlur: renameView,
      placeholder: selectedView?.name,
      defaultValue: selectedView?.name
    }) : /*#__PURE__*/external_react_default().createElement(ViewLabel, {
      view: view
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement(RequiresPermission, {
      perms: api_.PermissionTypes.Admin
    }, isDefault && !isRenaming && /*#__PURE__*/external_react_default().createElement(OverlayTrigger, {
      overlay: /*#__PURE__*/external_react_default().createElement(Popover, {
        id: "disabled-button-popover",
        placement: "top"
      }, "Revert back to the system default view.")
    }, view.isSaved ? /*#__PURE__*/external_react_default().createElement("span", {
      onClick: revertDefaultView,
      className: "clickable-text"
    }, "Revert") : /*#__PURE__*/external_react_default().createElement("span", {
      className: "gray-text"
    }, "Revert")), !isDefault && !isRenaming && /*#__PURE__*/external_react_default().createElement("span", {
      onClick: setDefaultView,
      id: 'setDefault-' + ind,
      className: "clickable-text"
    }, "Make default")), canEdit && /*#__PURE__*/external_react_default().createElement("span", {
      className: "pull-right"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "edit-inline-field__toggle small-right-spacing",
      onClick: onSelectView
    }, /*#__PURE__*/external_react_default().createElement("i", {
      id: 'select-' + ind,
      className: "fa fa-pencil"
    })), /*#__PURE__*/external_react_default().createElement("span", {
      className: "edit-inline-field__toggle",
      onClick: onDeleteView
    }, /*#__PURE__*/external_react_default().createElement("i", {
      id: 'delete-' + ind,
      className: "fa fa-trash-o"
    }))))), deleting === view && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row bottom-spacing"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "inline-confirmation"
    }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
      className: "inline-confirmation__label"
    }, "Permanently remove this view?"), /*#__PURE__*/external_react_default().createElement("button", {
      className: "button-left-spacing alert-button btn btn-danger",
      id: 'confirm-delete-' + ind,
      onClick: deleteSavedView,
      type: "button"
    }, "Yes"), /*#__PURE__*/external_react_default().createElement("button", {
      className: "button-left-spacing alert-button btn btn-default",
      id: 'cancel-delete-' + ind,
      onClick: cancelDeleteView,
      type: "button"
    }, "No"))))));
  }));
});
;// CONCATENATED MODULE: ./src/public/QueryModel/ChartPanel.tsx









const ChartPanel = (0,external_react_.memo)(({
  actions,
  model,
  api = DEFAULT_API_WRAPPER
}) => {
  const {
    charts,
    containerPath,
    id,
    queryInfo,
    selectedReportId
  } = model;
  const [savedChartModel, setSavedChartModel] = (0,external_react_.useState)(undefined);
  const [showEditModal, setShowEditModal] = (0,external_react_.useState)(false);
  const {
    moduleContext
  } = useServerContext();

  // useNotificationsContext will not always be available depending on if the app wraps the NotificationsContext.Provider
  let _createNotification;
  try {
    _createNotification = useNotificationsContext().createNotification;
  } catch (e) {
    // this is expected for LKS usages, so don't throw or console.error
  }
  const selectedChart = (0,external_react_.useMemo)(() => charts?.find(chart => chart.reportId === selectedReportId), [selectedReportId, charts]);
  (0,external_react_.useEffect)(() => {
    (async () => {
      setSavedChartModel(undefined);
      // only allowing edit of generic charts in the apps at this time
      if (selectedChart && GENERIC_CHART_REPORTS.indexOf(selectedChart.type) > -1) {
        try {
          const savedChartModel_ = await api.fetchGenericChart(selectedChart.reportId);
          setSavedChartModel(savedChartModel_);
        } catch (e) {
          // no-op as we are only using this to determine if we can edit the chart
        }
      }
    })();
  }, [api, selectedChart]);
  const clearChart = (0,external_react_.useCallback)(() => actions.selectReport(id, undefined), [actions, id]);
  const onShowEditChart = (0,external_react_.useCallback)(() => {
    setShowEditModal(true);
  }, []);
  const onExportChart = (0,external_react_.useCallback)(type => {
    const svg = document.querySelector('.chart-panel svg');
    if (svg) {
      LABKEY_VIS.SVGConverter.convert(svg, type, selectedChart.name);
    }
  }, [selectedChart]);
  const onExportChartPDF = (0,external_react_.useCallback)(() => {
    onExportChart(LABKEY_VIS.SVGConverter.FORMAT_PDF);
  }, [onExportChart]);
  const onExportChartPNG = (0,external_react_.useCallback)(() => {
    onExportChart(LABKEY_VIS.SVGConverter.FORMAT_PNG);
  }, [onExportChart]);
  const onHideEditChart = (0,external_react_.useCallback)(successMsg => {
    setShowEditModal(false);
    if (successMsg) {
      _createNotification?.({
        message: successMsg,
        alertClass: 'success'
      });
    }
  }, [_createNotification]);

  // If we don't have a queryInfo we can't get filters off the model, so we can't render the chart
  const showChart = queryInfo !== undefined && selectedChart !== undefined;
  if (!showChart) return null;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "chart-panel"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "chart-panel__heading"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "chart-panel__heading-title"
  }, selectedChart.name, savedChartModel?.canEdit && isChartBuilderEnabled(moduleContext) && /*#__PURE__*/external_react_default().createElement("span", {
    className: "margin-left"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    type: "button",
    title: "Edit chart",
    className: "btn btn-default",
    onClick: onShowEditChart
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-pencil"
  }))), /*#__PURE__*/external_react_default().createElement("span", {
    className: "margin-left"
  }, /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    buttonClassName: "chart-panel-export-btn",
    title: /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-download"
    }),
    noCaret: true
  }, /*#__PURE__*/external_react_default().createElement(MenuHeader, {
    text: "Export Chart"
  }), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: onExportChartPDF
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-file-pdf-o"
  }), "\xA0 PDF"), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: onExportChartPNG
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-file-image-o"
  }), "\xA0 PNG")))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "chart-panel__hide-icon"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    type: "button",
    title: "Hide chart",
    className: "btn btn-default",
    onClick: clearChart
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-close"
  }), " Close"))), /*#__PURE__*/external_react_default().createElement(Chart, {
    api: api,
    chart: selectedChart,
    container: containerPath,
    filters: model.filters
  }), showEditModal && /*#__PURE__*/external_react_default().createElement(ChartBuilderModal, {
    actions: actions,
    model: model,
    onHide: onHideEditChart,
    savedChartModel: savedChartModel
  }));
});
;// CONCATENATED MODULE: ./src/public/QueryModel/GridPanel.tsx
const GridPanel_excluded = ["actions", "id", "queryModels"],
  GridPanel_excluded2 = ["queryConfig"];
function GridPanel_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GridPanel_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GridPanel_ownKeys(Object(t), !0).forEach(function (r) { GridPanel_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GridPanel_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function GridPanel_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = GridPanel_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function GridPanel_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function GridPanel_extends() { return GridPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, GridPanel_extends.apply(null, arguments); }
function GridPanel_defineProperty(e, r, t) { return (r = GridPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function GridPanel_toPropertyKey(t) { var i = GridPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function GridPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







































class ButtonBar extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    GridPanel_defineProperty(this, "loadFirstPage", () => {
      const {
        model,
        actions
      } = this.props;
      actions.loadFirstPage(model.id);
    });
    GridPanel_defineProperty(this, "loadLastPage", () => {
      const {
        model,
        actions
      } = this.props;
      actions.loadLastPage(model.id);
    });
    GridPanel_defineProperty(this, "loadNextPage", () => {
      const {
        model,
        actions
      } = this.props;
      actions.loadNextPage(model.id);
    });
    GridPanel_defineProperty(this, "loadPreviousPage", () => {
      const {
        model,
        actions
      } = this.props;
      actions.loadPreviousPage(model.id);
    });
    GridPanel_defineProperty(this, "setPageSize", pageSize => {
      const {
        model,
        actions
      } = this.props;
      actions.setMaxRows(model.id, pageSize);
    });
  }
  render() {
    const {
      searchActionValues,
      allowViewCustomization,
      model,
      actions,
      advancedExportOptions,
      ButtonsComponent,
      ButtonsComponentRight,
      hideEmptyViewMenu,
      onCustomizeView,
      onExport,
      onFilter,
      onManageViews,
      onSearch,
      onSaveView,
      onViewSelect,
      pageSizes,
      showChartMenu,
      showExport,
      showFiltersButton,
      showPagination,
      showSearchInput,
      showViewMenu,
      supportedExportTypes,
      extraExportMenuOptions
    } = this.props;
    const {
      hasData,
      hasRows,
      queryInfo,
      queryInfoError,
      rowsError,
      selectionsError
    } = model;
    const hasError = queryInfoError !== undefined || rowsError !== undefined || selectionsError !== undefined;
    const paginate = showPagination && hasRows && !hasError;
    const canExport = showExport && !hasError;
    // Don't disable view selection when there is an error because it's possible the error may be caused by the view
    const canSelectView = showViewMenu && queryInfo !== undefined;
    const buttonsComponentProps = this.props.buttonsComponentProps ?? {};
    const hasLeftButtonsComp = ButtonsComponent !== undefined;
    // We do not want to render the buttons component until after we've loaded the query model at least once,
    // otherwise the ResponsiveMenuButtonGroup will not be able to collapse buttons correctly.
    const showButtonsComponent = hasLeftButtonsComp && (hasData || rowsError);
    const hiddenWithLeftButtonsCls = external_classnames_default()({
      'hidden-md hidden-sm hidden-xs': hasLeftButtonsComp
    });
    const paginationComp = /*#__PURE__*/external_react_default().createElement(Pagination, GridPanel_extends({}, model.paginationData, {
      loadNextPage: this.loadNextPage,
      loadFirstPage: this.loadFirstPage,
      loadPreviousPage: this.loadPreviousPage,
      loadLastPage: this.loadLastPage,
      pageSizes: pageSizes,
      setPageSize: this.setPageSize
    }));
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "grid-panel__button-bar"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "grid-panel__button-bar-left"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "button-bar__section"
    }, showButtonsComponent && /*#__PURE__*/external_react_default().createElement(ButtonsComponent, GridPanel_extends({}, buttonsComponentProps, {
      model: model,
      actions: actions
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: 'button-bar__filter-search ' + hiddenWithLeftButtonsCls
    }, showFiltersButton && /*#__PURE__*/external_react_default().createElement(FiltersButton, {
      onFilter: onFilter
    }), showSearchInput && /*#__PURE__*/external_react_default().createElement(SearchBox_SearchBox, {
      actionValues: searchActionValues,
      onSearch: onSearch
    })))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "grid-panel__button-bar-right"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "button-bar__section"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: hiddenWithLeftButtonsCls
    }, paginate && paginationComp), canExport && /*#__PURE__*/external_react_default().createElement(ExportMenu, {
      model: model,
      advancedOptions: advancedExportOptions,
      supportedTypes: supportedExportTypes?.toJS(),
      onExport: onExport,
      extraExportMenuOptions: extraExportMenuOptions
    }), showChartMenu && /*#__PURE__*/external_react_default().createElement(ChartMenu, {
      actions: actions,
      model: model
    }), canSelectView && /*#__PURE__*/external_react_default().createElement(ViewMenu, {
      allowViewCustomization: allowViewCustomization,
      model: model,
      onViewSelect: onViewSelect,
      onSaveView: onSaveView,
      onCustomizeView: onCustomizeView,
      onManageViews: onManageViews,
      hideEmptyViewMenu: hideEmptyViewMenu
    }), ButtonsComponentRight !== undefined && /*#__PURE__*/external_react_default().createElement(ButtonsComponentRight, GridPanel_extends({}, buttonsComponentProps, {
      model: model,
      actions: actions
    }))))), /*#__PURE__*/external_react_default().createElement("span", {
      className: external_classnames_default()({
        'visible-md visible-sm visible-xs': hasLeftButtonsComp,
        hidden: !hasLeftButtonsComp
      })
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "grid-panel__button-bar margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "grid-panel__button-bar-left"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "button-bar__section"
    }, showFiltersButton && /*#__PURE__*/external_react_default().createElement(FiltersButton, {
      onFilter: onFilter,
      iconOnly: true
    }), showSearchInput && /*#__PURE__*/external_react_default().createElement(SearchBox_SearchBox, {
      actionValues: searchActionValues,
      onSearch: onSearch
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "grid-panel__button-bar-right"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "button-bar__section"
    }, paginate && paginationComp)))));
  }
}
const GridTitle = (0,external_react_.memo)(props => {
  const {
    title,
    view,
    model,
    onRevertView,
    onSaveView,
    onSaveNewView,
    actions,
    allowSelections,
    allowViewCustomization,
    isUpdated
  } = props;
  const {
    viewName
  } = model;
  const [errorMsg, setErrorMsg] = (0,external_react_.useState)();

  // TODO: unable to get jest to pass with useServerContext() due to GridPanel being Component instead of FC
  // const { user } = useServerContext();
  const user = hasServerContext() ? useServerContext().user : (0,api_.getServerContext)().user;
  const currentView = view ?? model.currentView;
  let displayTitle = title;
  if (viewName && !currentView?.hidden && !currentView?.isSystemView) {
    const label = currentView?.label ?? viewName;
    displayTitle = displayTitle ? displayTitle + ' - ' + label : label;
  }
  const isEdited = currentView?.session;
  const showSave = allowViewCustomization && isEdited && currentView?.savable;
  const showRevert = allowViewCustomization && isEdited && currentView?.revertable;
  let canSaveCurrent = false;
  if (viewName) {
    canSaveCurrent = !user?.isGuest && !currentView?.hidden;
  }
  const _revertViewEdit = (0,external_react_.useCallback)(async () => {
    try {
      await revertViewEdit(model.schemaQuery, model.containerPath, model.viewName);
    } catch (error) {
      setErrorMsg(error);
    }
    await actions.loadModel(model.id, allowSelections, true);
    onRevertView?.();
  }, [model, onRevertView, actions, allowSelections]);
  const _onSaveCurrentView = (0,external_react_.useCallback)(() => {
    onSaveView(userCanEditSharedViews(user));
  }, [onSaveView, user]);
  if (!displayTitle && (!allowViewCustomization || !isEdited && !isUpdated)) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading view-header"
  }, isEdited && allowViewCustomization && /*#__PURE__*/external_react_default().createElement("span", {
    className: "alert-info view-edit-alert"
  }, "Edited"), isUpdated && allowViewCustomization && /*#__PURE__*/external_react_default().createElement("span", {
    className: "alert-success view-edit-alert"
  }, "Updated"), displayTitle ?? 'Default View', showRevert && /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default button-left-spacing button-right-spacing",
    onClick: _revertViewEdit,
    type: "button"
  }, "Undo"), showSave && !canSaveCurrent && /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-success",
    onClick: onSaveNewView,
    type: "button"
  }, "Save"), showSave && canSaveCurrent && /*#__PURE__*/external_react_default().createElement(SplitButton, {
    bsStyle: "success",
    onClick: _onSaveCurrentView,
    title: "Save"
  }, /*#__PURE__*/external_react_default().createElement(MenuItem, {
    title: "Save as new view",
    onClick: onSaveNewView,
    key: "saveNewGridView"
  }, "Save as...")), errorMsg && /*#__PURE__*/external_react_default().createElement("span", {
    className: "view-edit-error"
  }, errorMsg));
});
/**
 * Render a QueryModel as an interactive grid. For in-depth documentation and examples see components/docs/QueryModel.md.
 */
class GridPanel extends external_react_.PureComponent {
  constructor(props) {
    super(props);

    // TODO: gridActions is a vestigal structure left behind from the days of Omnibox, which we have since removed.
    //  We should remove gridActions and the related classes.
    GridPanel_defineProperty(this, "gridActions", void 0);
    GridPanel_defineProperty(this, "createGridActionValues", () => {
      const {
        model
      } = this.props;
      const {
        filterArray,
        sorts
      } = model;
      const view = model.currentView;
      const actionValues = [];
      const searchActionValues = [];
      const _sorts = view ? sorts.concat(view.sorts) : sorts;
      _sorts.forEach(sort => {
        const column = model.getColumn(sort.fieldKey);
        if (column) {
          actionValues.push(this.gridActions.sort.actionValueFromSort(sort, column?.shortCaption));
        }
      });

      // handle the view's saved filters (which will be shown as read only)
      if (view && view.filters.length) {
        view.filters.forEach(filter => {
          const column = model.getColumn(filter.getColumnName());
          if (column) {
            actionValues.push(this.gridActions.filter.actionValueFromFilter(filter, column, 'Locked (saved with view)'));
          } else if (filter.getColumnName() === '*') {
            actionValues.push(this.gridActions.search.actionValueFromFilter(filter, 'Locked (saved with view)'));
          }
        });
      }

      // handle the model.filterArray (user-defined filters)
      filterArray.forEach(filter => {
        if (filter.getColumnName() === '*') {
          const searchAction = this.gridActions.search.actionValueFromFilter(filter);
          searchActionValues.push(searchAction);
        } else {
          const column = model.getColumn(filter.getColumnName());
          if (column) {
            actionValues.push(this.gridActions.filter.actionValueFromFilter(filter, column));
          } else if (filter.getColumnName().indexOf('/') > -1) {
            const lookupCol = model.getColumn(filter.getColumnName().split('/')[0]);
            if (lookupCol) actionValues.push(this.gridActions.filter.actionValueFromFilter(filter, column));
          }
        }
      });
      return {
        actionValues,
        searchActionValues
      };
    });
    /**
     * Populates the grid with ActionValues based on the current model state. Requires that the model has a QueryInfo
     * so we can properly render Column and View labels.
     */
    GridPanel_defineProperty(this, "populateGridActions", () => {
      const {
        actionValues,
        searchActionValues
      } = this.createGridActionValues();
      const modelActionValuesStr = actionValuesToString(actionValues);
      const currentActionValuesStr = actionValuesToString(this.state.actionValues);
      const searchActionsValuesStr = actionValuesToString(searchActionValues);
      const currentSearchActionValuesStr = actionValuesToString(this.state.searchActionValues);
      if (modelActionValuesStr !== currentActionValuesStr || searchActionsValuesStr !== currentSearchActionValuesStr) {
        // The action values have changed due to external model changes (likely URL changes), so we need to
        // update the actionValues state with the newest values.
        this.setState({
          actionValues,
          searchActionValues,
          errorMsg: undefined
        });
      }
    });
    GridPanel_defineProperty(this, "selectRow", (row, event) => {
      const {
        model,
        actions
      } = this.props;
      const checked = event.target.checked === true;
      // Look through to the nativeEvent to determine if the shift key is engaged.
      const useSelectionPivot = event.nativeEvent.shiftKey ?? false;
      actions.selectRow(model.id, checked, row.toJS(), useSelectionPivot);
      if (useSelectionPivot) {
        incrementClientSideMetricCount('grid', 'shiftSelect');
      }
    });
    GridPanel_defineProperty(this, "selectPage", event => {
      const {
        model,
        actions
      } = this.props;
      const checked = event.target.checked === true && model.selectedState !== GRID_CHECKBOX_OPTIONS.SOME;
      actions.selectPage(model.id, checked);
    });
    GridPanel_defineProperty(this, "getSelectDistinctOptions", () => {
      const {
        model
      } = this.props;
      return {
        column: undefined,
        containerFilter: model.containerFilter,
        containerPath: model.containerPath,
        schemaName: model.schemaName,
        queryName: model.queryName,
        filterArray: model.modelFilters,
        parameters: model.queryParameters
      };
    });
    GridPanel_defineProperty(this, "handleFilterRemove", (change, column) => {
      const {
        model,
        actions,
        allowSelections
      } = this.props;
      const {
        actionValues
      } = this.state;
      const view = model.currentView;
      if (change.type === ChangeType.remove) {
        let newFilters = model.filterArray;
        let viewUpdates;

        // If a column is provided instead of a change.index, then we will remove all filters for that column.
        if (change.index !== undefined) {
          const value = actionValues[change.index].valueObject;

          // first check if we are removing a filter from the saved view
          const viewFilterIndex = view?.filters.findIndex(filter => filtersEqual(filter, value)) ?? -1;
          if (viewFilterIndex > -1) {
            this.saveAsSessionView({
              filters: view.filters.filter((f, i) => viewFilterIndex !== i)
            });
            return;
          }
          newFilters = newFilters.filter(filter => !filtersEqual(filter, value));
        } else if (column) {
          newFilters = newFilters.filter(filter => !isFilterColumnNameMatch(filter, column));
          if (view?.filters.length) {
            viewUpdates = {
              filters: view.filters.filter(filter => !isFilterColumnNameMatch(filter, column))
            };
          }
        } else {
          // remove all filters, but keep the search that's not part of the view
          newFilters = newFilters.filter(filter => filter.getFilterType() === api_.Filter.Types.Q);
          if (view?.filters.length) {
            viewUpdates = {
              filters: []
            };
          }
        }
        actions.setFilters(model.id, newFilters, allowSelections);
        if (viewUpdates) this.saveAsSessionView(viewUpdates);
      }
    });
    GridPanel_defineProperty(this, "handleApplyFilters", newFilters => {
      const {
        model,
        actions,
        allowSelections
      } = this.props;
      this.setState({
        showFilterModalFieldKey: undefined,
        showSaveViewModal: false,
        showManageViewsModal: false
      }, () => actions.setFilters(model.id, newFilters, allowSelections));
    });
    GridPanel_defineProperty(this, "handleSortChange", (change, newQuerySort) => {
      const {
        model,
        actions
      } = this.props;
      const {
        actionValues
      } = this.state;
      const view = model.currentView;
      let newSorts;
      if (change.type === ChangeType.remove) {
        const value = actionValues[change.index].valueObject;

        // first check if we are removing a sort from the saved view
        const viewSortIndex = view?.sorts.findIndex(sort => sortsEqual(sort, value)) ?? -1;
        if (viewSortIndex > -1) {
          this.saveAsSessionView({
            sorts: view.sorts.filter((s, i) => viewSortIndex !== i)
          });
          return;
        }
        newSorts = model.sorts.filter(sort => !sortsEqual(sort, value));
      } else if (newQuerySort) {
        // first check if we are changing a sort from the saved view
        const viewSortIndex = view?.sorts.findIndex(sort => sort.fieldKey === newQuerySort.fieldKey) ?? -1;
        if (viewSortIndex > -1) {
          const newViewSorts = view.sorts.filter((s, i) => viewSortIndex !== i);
          newViewSorts.push(newQuerySort);
          this.saveAsSessionView({
            sorts: newViewSorts
          });
          return;
        }

        // remove any existing sorts on the given column (doesn't make sense to keep multiple)
        // before adding the new sort value
        newSorts = model.sorts.filter(sort => sort.fieldKey !== newQuerySort.fieldKey);
        newSorts.push(newQuerySort);
      }
      actions.setSorts(model.id, newSorts);
    });
    GridPanel_defineProperty(this, "onSearch", value => {
      const {
        model,
        actions,
        allowSelections
      } = this.props;
      const {
        searchActionValues
      } = this.state;
      const change = getSearchValueAction(searchActionValues, value);
      if (!change) return;
      let newFilters = model.filterArray;
      if (change.type === ChangeType.modify || change.type === ChangeType.remove) {
        // Remove the filter with the value of oldValue
        const oldValue = searchActionValues[change.index].valueObject;
        newFilters = newFilters.filter(filter => !filtersEqual(filter, oldValue));
      }
      if (change.type === ChangeType.add || change.type === ChangeType.modify) {
        newFilters = newFilters.concat(api_.Filter.create('*', value, api_.Filter.Types.Q));
      }
      actions.setFilters(model.id, newFilters, allowSelections);
    });
    GridPanel_defineProperty(this, "onRevertView", () => {
      this.setState({
        errorMsg: undefined
      });
    });
    GridPanel_defineProperty(this, "filterColumn", (column, remove = false) => {
      if (remove) {
        this.handleFilterRemove({
          type: ChangeType.remove
        }, column);
      } else {
        const fieldKey = column.resolveFieldKey(); // resolveFieldKey because of Issue 34627
        this.setState({
          showFilterModalFieldKey: fieldKey
        });
      }
    });
    GridPanel_defineProperty(this, "removeAllFilters", () => {
      this.handleFilterRemove({
        type: ChangeType.remove
      });
    });
    GridPanel_defineProperty(this, "removeFilter", index => {
      this.handleFilterRemove({
        type: ChangeType.remove,
        index
      });
    });
    GridPanel_defineProperty(this, "showFilterModal", actionValue => {
      const {
        model
      } = this.props;
      const displayColumns = model.displayColumns;

      // if the user clicked to edit an existing filter, use that filter's column name when opening the modal
      // else open modal with the first field selected
      const columnName = actionValue?.valueObject?.getColumnName();
      const colIndex = columnName ? Math.max(displayColumns.findIndex(col => col.resolveFieldKey() === columnName), 0 // fall back to the first field if no match
      ) : 0;
      const fieldKey = displayColumns[colIndex]?.resolveFieldKey();
      this.setState({
        showFilterModalFieldKey: fieldKey
      });
    });
    GridPanel_defineProperty(this, "closeFilterModal", () => {
      this.setState({
        showFilterModalFieldKey: undefined
      });
    });
    GridPanel_defineProperty(this, "sortColumn", (column, direction) => {
      const fieldKey = column.resolveFieldKey(); // resolveFieldKey because of Issue 34627

      if (direction) {
        const dir = direction === '+' ? '' : '-'; // Sort Action only uses '-' and ''
        const sort = new QuerySort({
          fieldKey,
          dir
        });
        this.handleSortChange({
          type: ChangeType.add
        }, sort);
      } else {
        const actionIndex = this.state.actionValues.findIndex(actionValue => actionValue.action === this.gridActions.sort && actionValue.valueObject.fieldKey === fieldKey);
        if (actionIndex > -1) {
          this.handleSortChange({
            type: ChangeType.remove,
            index: actionIndex
          });
        }
      }
    });
    GridPanel_defineProperty(this, "hideColumn", columnToHide => {
      const {
        model
      } = this.props;
      this.saveAsSessionView({
        columns: model.displayColumns.filter(column => column.index !== columnToHide.index).map(col => ({
          fieldKey: col.fieldKeyPath /* 46256: use encoded fieldKeyPath */,
          title: model.getCustomViewTitleOverride(col)
        }))
      });
    });
    GridPanel_defineProperty(this, "addColumn", selectedColumn => {
      this.setState({
        selectedColumn,
        showCustomizeViewModal: true
      });
    });
    GridPanel_defineProperty(this, "onColumnTitleEdit", () => {
      this.setState(state => ({
        disableColumnDrag: !state.disableColumnDrag
      }));
    });
    GridPanel_defineProperty(this, "updateColumnTitle", updatedCol => {
      const {
        model
      } = this.props;
      this.saveAsSessionView({}, updatedCol);
      this.setState({
        disableColumnDrag: false
      });
    });
    GridPanel_defineProperty(this, "saveAsSessionView", (updates, updatedCol) => {
      const {
        model
      } = this.props;
      const {
        schemaQuery,
        containerPath
      } = model;
      const changedFilters = updates.filters && !filterArraysEqual(updates.filters, model.currentView.filters);
      if (!updates.columns) {
        updates.columns = model.displayColumns.map(col => {
          if (updatedCol && col.index === updatedCol.index) {
            return {
              fieldKey: updatedCol.fieldKeyPath /* 46256: use encoded fieldKeyPath */,
              title: model.getCustomViewTitleOverride(updatedCol)
            };
          } else {
            return {
              fieldKey: col.fieldKeyPath /* 46256: use encoded fieldKeyPath */,
              title: model.getCustomViewTitleOverride(col)
            };
          }
        });
      }
      const viewInfo = model.currentView.mutate(updates);
      saveAsSessionView(schemaQuery, containerPath, viewInfo).then(() => this.afterViewChange(changedFilters)).catch(errorMsg => {
        this.setState({
          errorMsg
        });
      });
    });
    GridPanel_defineProperty(this, "afterViewChange", reloadTotalCount => {
      const {
        actions,
        model,
        allowSelections
      } = this.props;
      actions.loadModel(model.id, allowSelections, reloadTotalCount);
      this.setState({
        errorMsg: undefined
      });
    });
    GridPanel_defineProperty(this, "onSaveCurrentView", async canSaveShared => {
      const {
        model
      } = this.props;
      const {
        queryInfo,
        viewName
      } = model;
      const view = queryInfo?.getView(viewName, true);
      let currentView = view;
      try {
        if (view.session) currentView = await getGridView(queryInfo.schemaQuery, viewName, true);
        await this.onSaveView(viewName, currentView?.inherit, true, currentView.shared && canSaveShared);
      } catch (errorMsg) {
        this.setState({
          errorMsg
        });
      }
    });
    GridPanel_defineProperty(this, "onManageViews", () => {
      this.setState({
        showManageViewsModal: true
      });
    });
    GridPanel_defineProperty(this, "closeManageViewsModal", (hasChange, reselectViewName) => {
      const {
        model,
        actions,
        allowSelections
      } = this.props;
      if (hasChange) {
        actions.loadModel(model.id, allowSelections, true);
        if (reselectViewName !== undefined) {
          // don't reselect if reselectViewName is undefined
          this.onViewSelect(reselectViewName);
        }
      }
      this.setState({
        showManageViewsModal: false
      });
    });
    GridPanel_defineProperty(this, "onSaveNewView", () => {
      this.setState({
        showSaveViewModal: true
      });
    });
    GridPanel_defineProperty(this, "toggleCustomizeView", () => {
      this.setState(state => ({
        showCustomizeViewModal: !state.showCustomizeViewModal
      }));
    });
    GridPanel_defineProperty(this, "onSessionViewUpdate", () => {
      const {
        actions,
        model,
        allowSelections
      } = this.props;
      actions.loadModel(model.id, allowSelections);
    });
    GridPanel_defineProperty(this, "onSaveView", (newName, inherit, replace, shared) => {
      const {
        model
      } = this.props;
      const {
        viewName,
        queryInfo
      } = model;
      return new Promise((resolve, reject) => {
        const view = queryInfo?.getView(viewName, true);
        let updatedViewInfo = view.addSystemViewColumns(queryInfo);
        updatedViewInfo = updatedViewInfo.mutate({
          // update/set sorts and filters to combine view and user-defined items
          filters: model.filterArray.concat(view.filters),
          sorts: model.sorts.concat(view.sorts),
          columns: model.displayColumns.map(col => {
            return {
              fieldKey: col.fieldKeyPath /* 46256: use encoded fieldKeyPath */,
              title: model.getCustomViewTitleOverride(col)
            };
          })
        });
        if (view.session) {
          // first save an updated session view with the concatenated sorts/filters (without name update),
          // then convert the session view to a non session view (with name update)
          saveAsSessionView(model.schemaQuery, model.containerPath, updatedViewInfo).then(() => {
            saveSessionView(model.schemaQuery, model.containerPath, viewName, newName, inherit, shared, replace).then(response => {
              this.afterSaveViewComplete(newName);
              resolve(response);
            }).catch(errorMsg => {
              reject(errorMsg);
            });
          }).catch(errorMsg => {
            this.setState({
              errorMsg
            });
          });
        } else {
          const isCustomView = !!newName && newName !== ViewInfo.DEFAULT_NAME;
          const finalViewInfo = updatedViewInfo.mutate({
            name: newName,
            isDefault: isCustomView ? false : updatedViewInfo.isDefault
          });
          saveGridView(model.schemaQuery, model.containerPath, finalViewInfo, replace, false, inherit, shared).then(response => {
            this.afterSaveViewComplete(newName);
            resolve(response);
          }).catch(errorMsg => {
            reject(errorMsg);
          });
        }
      });
    });
    GridPanel_defineProperty(this, "afterSaveViewComplete", newName => {
      const {
        model,
        actions
      } = this.props;
      const {
        showSaveViewModal
      } = this.state;

      // if the model had any user defined sorts/filters, clear those since they are now saved with the view
      if (model.filterArray.length > 0) actions.setFilters(model.id, [], false);
      if (model.sorts.length > 0) actions.setSorts(model.id, []);
      this.afterViewChange();
      if (showSaveViewModal) {
        this.closeSaveViewModal();
        this.onViewSelect(newName);
      }
      this.showViewSavedIndicator();
    });
    GridPanel_defineProperty(this, "showViewSavedIndicator", () => {
      this.setState({
        isViewSaved: true
      });
      setTimeout(() => {
        this.setState({
          isViewSaved: false
        });
      }, 5000);
    });
    GridPanel_defineProperty(this, "closeSaveViewModal", () => {
      this.setState({
        showSaveViewModal: false
      });
    });
    GridPanel_defineProperty(this, "onViewSelect", viewName => {
      const {
        actions,
        model,
        allowSelections
      } = this.props;
      if (viewName !== undefined && viewName !== null && viewName !== '') {
        if (viewName !== model.viewName) {
          // Only trigger view change if the viewName has changed
          actions.setView(model.id, viewName, allowSelections);
        }
      } else {
        actions.setView(model.id, undefined, allowSelections);
      }

      // since the grid ChartMenu filters to charts for a given view, when the view changes clear the selectedReportId
      if (model.selectedReportId) {
        actions.selectReport(model.id, undefined);
      }
    });
    GridPanel_defineProperty(this, "getGridColumns", () => {
      const {
        allowSelections,
        model
      } = this.props;
      const {
        isLoading,
        isLoadingSelections
      } = model;
      let columns = model?.displayColumns ? (0,external_immutable_.List)(model.displayColumns) : (0,external_immutable_.List)();
      columns.forEach(col => {
        if (!(col instanceof GridColumn)) {
          if (!col.helpTipRenderer && col.hasHelpTipData) {
            col.helpTipRenderer = DOMAIN_FIELD;
          }
        }
      });
      if (allowSelections) {
        const selectColumn = new GridColumn({
          index: GRID_SELECTION_INDEX,
          title: '',
          showHeader: true,
          cell: (selected, row) => {
            return /*#__PURE__*/external_react_default().createElement("input", {
              checked: selected === true,
              className: "grid-panel__row-checkbox",
              disabled: isLoading || isLoadingSelections,
              onChange: this.selectRow.bind(this, row) // eslint-disable-line
              ,
              type: "checkbox"
            });
          }
        });
        columns = columns.insert(0, selectColumn);
      }
      return columns;
    });
    GridPanel_defineProperty(this, "onColumnDrop", (source, target) => {
      const {
        model
      } = this.props;
      const {
        displayColumns
      } = model;
      const sourceIndex = displayColumns.findIndex(col => col.index === source);
      const colInMotion = displayColumns.find(col => col.index === source);
      if (colInMotion) {
        let updatedColumns = displayColumns.filter(col => col.index !== source);
        const targetIndex = updatedColumns.findIndex(col => col.index === target);
        if (targetIndex > -1 && targetIndex !== sourceIndex) {
          updatedColumns = [...updatedColumns.slice(0, targetIndex), colInMotion, ...updatedColumns.slice(targetIndex)];
          this.saveAsSessionView({
            columns: updatedColumns.map(col => ({
              fieldKey: col.fieldKeyPath /* 46256: use encoded fieldKeyPath */,
              title: model.getCustomViewTitleOverride(col)
            }))
          });
          incrementClientSideMetricCount('customViews', 'columnReorderDragNDrop');
        }
      }
    });
    GridPanel_defineProperty(this, "headerCell", (column, index, columnCount) => {
      const {
        allowSelections,
        allowSorting,
        allowFiltering,
        allowViewCustomization,
        model
      } = this.props;
      const {
        isLoading,
        isLoadingSelections,
        hasRows,
        rowCount
      } = model;
      const disabled = isLoadingSelections || isLoading || hasRows && rowCount === 0;
      const nonSelectableColumnCount = allowSelections ? columnCount - 1 : columnCount;
      if (column.index === GRID_SELECTION_INDEX) {
        return headerSelectionCell(this.selectPage, model.selectedState, disabled, 'grid-panel__page-checkbox');
      }
      return headerCell(index, column, allowSelections, columnCount, allowSorting ? this.sortColumn : undefined, allowFiltering ? this.filterColumn : undefined, allowViewCustomization ? this.addColumn : undefined, allowViewCustomization && nonSelectableColumnCount > 1 ? this.hideColumn : undefined, allowViewCustomization ? this.onColumnTitleEdit : undefined, allowViewCustomization ? this.updateColumnTitle : undefined, model);
    });
    this.gridActions = {
      filter: new FilterAction(props.getFilterDisplayValue),
      search: new SearchAction(),
      sort: new SortAction(),
      view: new ViewAction()
    };
    this.state = {
      actionValues: [],
      searchActionValues: [],
      disableColumnDrag: false,
      showFilterModalFieldKey: undefined,
      showSaveViewModal: false,
      showCustomizeViewModal: false,
      showManageViewsModal: false,
      errorMsg: undefined,
      isViewSaved: false,
      selectedColumn: undefined
    };
  }
  componentDidMount() {
    const {
      model,
      actions,
      allowSelections,
      loadOnMount
    } = this.props;
    if (loadOnMount) {
      actions.loadModel(model.id, allowSelections);
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.model.queryInfo !== undefined && this.props.model !== prevProps.model) {
      this.populateGridActions();
    }
  }
  getHighlightRowIndexes() {
    const {
      highlightLastSelectedRow,
      model
    } = this.props;
    if (!highlightLastSelectedRow || !model.hasSelections) return undefined;
    const lastSelectedId = Array.from(model.selections).pop();
    return (0,external_immutable_.List)([model.orderedRows.indexOf(lastSelectedId)]);
  }
  render() {
    const {
      actions,
      allowSelections,
      allowFiltering,
      allowSorting,
      allowViewCustomization,
      hasHeader,
      asPanel,
      emptyText,
      getEmptyText,
      model,
      onExport,
      showButtonBar,
      showFilterStatus,
      showHeader,
      title
    } = this.props;
    const {
      selectedColumn,
      showCustomizeViewModal,
      showFilterModalFieldKey,
      showManageViewsModal,
      showSaveViewModal,
      actionValues,
      searchActionValues,
      errorMsg,
      isViewSaved,
      disableColumnDrag
    } = this.state;
    const {
      hasData,
      id,
      isLoading,
      isLoadingSelections,
      rowsError,
      selectionsError,
      messages,
      queryInfoError,
      queryInfo,
      viewName
    } = model;
    const hasGridError = queryInfoError !== undefined || rowsError !== undefined;
    const hasError = hasGridError || selectionsError !== undefined || errorMsg;
    let loadingMessage;
    const gridIsLoading = !hasGridError && isLoading;
    const selectionsAreLoading = !hasError && allowSelections && isLoadingSelections;
    if (gridIsLoading) {
      loadingMessage = 'Loading data...';
    } else if (selectionsAreLoading) {
      loadingMessage = 'Loading selections...';
    }
    const gridEmptyText = getEmptyText?.(model) ?? emptyText;
    const view = queryInfo?.getView(viewName, true);
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('grid-panel', {
        panel: asPanel,
        'panel-default': asPanel
      })
    }, /*#__PURE__*/external_react_default().createElement(GridTitle, {
      model: model,
      view: view,
      title: title,
      actions: actions,
      allowSelections: allowSelections,
      allowViewCustomization: allowViewCustomization,
      onRevertView: this.onRevertView,
      onSaveView: this.onSaveCurrentView,
      onSaveNewView: this.onSaveNewView,
      isUpdated: isViewSaved
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('grid-panel__body', {
        'panel-body': asPanel,
        'top-spacing': !hasHeader
      })
    }, !gridIsLoading && /*#__PURE__*/external_react_default().createElement(ChartPanel, {
      actions: actions,
      model: model
    }), showButtonBar && /*#__PURE__*/external_react_default().createElement(ButtonBar, GridPanel_extends({}, this.props, {
      actionValues: actionValues,
      searchActionValues: searchActionValues,
      onExport: onExport,
      onFilter: this.showFilterModal,
      onSearch: this.onSearch,
      onViewSelect: this.onViewSelect,
      onSaveView: this.onSaveNewView,
      onCustomizeView: this.toggleCustomizeView,
      onManageViews: this.onManageViews
    })), (loadingMessage || allowSelections) && /*#__PURE__*/external_react_default().createElement("div", {
      className: "grid-panel__info"
    }, loadingMessage && /*#__PURE__*/external_react_default().createElement("div", {
      className: "grid-panel__loading"
    }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
      msg: loadingMessage
    })), allowSelections && /*#__PURE__*/external_react_default().createElement(SelectionStatus, {
      model: model,
      actions: actions
    }), showFilterStatus && /*#__PURE__*/external_react_default().createElement(FilterStatus, {
      actionValues: actionValues,
      onClick: this.showFilterModal,
      onRemove: this.removeFilter,
      onRemoveAll: this.removeAllFilters
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('grid-panel__grid ', 'grid-panel__lock-left', {
        'grid-panel__lock-left-with-checkboxes': allowSelections
      })
    }, hasError && /*#__PURE__*/external_react_default().createElement(Alert, null, errorMsg || queryInfoError || rowsError || selectionsError), !hasGridError && hasData && /*#__PURE__*/external_react_default().createElement(Grid, {
      headerCell: this.headerCell,
      onColumnDrop: allowViewCustomization && !disableColumnDrag ? this.onColumnDrop : undefined,
      showHeader: showHeader,
      calcWidths: allowSorting || allowFiltering,
      condensed: true,
      emptyText: gridEmptyText,
      fixedHeight: true,
      gridId: id,
      messages: (0,external_immutable_.fromJS)(messages),
      columns: this.getGridColumns(),
      data: model.gridData,
      highlightRowIndexes: this.getHighlightRowIndexes()
    })))), showFilterModalFieldKey && /*#__PURE__*/external_react_default().createElement(GridFilterModal, {
      fieldKey: showFilterModalFieldKey,
      selectDistinctOptions: this.getSelectDistinctOptions(),
      initFilters: model.filterArray // using filterArray to indicate user-defined filters only
      ,
      model: model,
      onApply: this.handleApplyFilters,
      onCancel: this.closeFilterModal
    }), showSaveViewModal && /*#__PURE__*/external_react_default().createElement(SaveViewModal, {
      gridLabel: queryInfo?.schemaQuery?.queryName,
      currentView: view,
      onCancel: this.closeSaveViewModal,
      onConfirmSave: this.onSaveView
    }), showCustomizeViewModal && /*#__PURE__*/external_react_default().createElement(CustomizeGridViewModal, {
      model: model,
      onCancel: this.toggleCustomizeView,
      onUpdate: this.onSessionViewUpdate,
      selectedColumn: selectedColumn
    }), showManageViewsModal && /*#__PURE__*/external_react_default().createElement(ManageViewsModal, {
      schemaQuery: model.schemaQuery,
      containerPath: model.containerPath,
      currentView: view,
      onDone: this.closeManageViewsModal
    }));
  }
}
GridPanel_defineProperty(GridPanel, "defaultProps", {
  allowSelections: true,
  allowSorting: true,
  allowFiltering: true,
  allowViewCustomization: true,
  asPanel: true,
  hideEmptyViewMenu: true,
  highlightLastSelectedRow: false,
  loadOnMount: true,
  showPagination: true,
  showButtonBar: true,
  showChartMenu: true,
  showExport: true,
  showFiltersButton: true,
  showFilterStatus: true,
  showSearchInput: true,
  showViewMenu: true,
  showHeader: true
});
const GridPanelWithModelBodyImpl = (0,external_react_.memo)(_ref => {
  let {
      actions,
      id,
      queryModels
    } = _ref,
    props = GridPanel_objectWithoutProperties(_ref, GridPanel_excluded);
  return /*#__PURE__*/external_react_default().createElement(GridPanel, GridPanel_extends({
    actions: actions,
    model: queryModels[id]
  }, props));
});
const GridPanelWithModelBody = withQueryModels(GridPanelWithModelBodyImpl);
/**
 * GridPanelWithModel is the same as a GridPanel component, but it takes a single QueryConfig and loads the model.
 */
const GridPanelWithModel = (0,external_react_.memo)(_ref2 => {
  let {
      queryConfig
    } = _ref2,
    props = GridPanel_objectWithoutProperties(_ref2, GridPanel_excluded2);
  const id = (0,external_react_.useMemo)(() => queryConfig.id ?? createQueryModelId(queryConfig.schemaQuery), [queryConfig]);
  const queryConfigs = (0,external_react_.useMemo)(() => ({
    [id]: GridPanel_objectSpread({}, queryConfig)
  }), [id, queryConfig]);
  return /*#__PURE__*/external_react_default().createElement(GridPanelWithModelBody, GridPanel_extends({}, props, {
    id: id,
    key: id,
    queryConfigs: queryConfigs
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/user/APIKeysPanel.tsx
function APIKeysPanel_extends() { return APIKeysPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, APIKeysPanel_extends.apply(null, arguments); }
/*
 * Copyright (c) 2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */














const APIKeysButtonsComponent = props => {
  const {
    model,
    actions,
    onDelete
  } = props;
  const {
    api
  } = useAppContext();
  const [showConfirmDelete, setShowConfirmDelete] = (0,external_react_.useState)(false);
  const onDeleteClicked = (0,external_react_.useCallback)(() => setShowConfirmDelete(true), []);
  const closeDeleteModal = (0,external_react_.useCallback)(() => setShowConfirmDelete(false), []);
  const onConfirmDelete = (0,external_react_.useCallback)(async () => {
    try {
      await api.security.deleteApiKeys(model.selections);
      actions.clearSelections(model.id);
      actions.loadModel(model.id, true, true);
      actions.loadFirstPage(model.id);
      closeDeleteModal();
      onDelete();
    } catch (e) {
      console.error('Unable to delete selected api keys', e);
      onDelete('Unable to delete the selected keys. If the problem persists, please contact your system administrator.');
    }
  }, [model, actions, model.id]);
  const noun = model?.selections?.size > 1 ? 'Keys' : 'Key';
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    type: "button",
    className: "btn btn-default",
    disabled: !model.hasSelections,
    onClick: onDeleteClicked
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-trash"
  }), " Delete"), showConfirmDelete && /*#__PURE__*/external_react_default().createElement(Modal, {
    confirmClass: "btn-danger",
    onCancel: closeDeleteModal,
    onConfirm: onConfirmDelete,
    confirmText: "Yes, Delete",
    title: `Delete ${model?.selections?.size} API ${noun}`
  }, /*#__PURE__*/external_react_default().createElement("strong", null, "Deletion cannot be undone."), " Do you want to proceed?"));
};
// exported for jest testing
const KeyGenerator = props => {
  const {
    afterCreate,
    type,
    keyValue,
    noun
  } = props;
  const {
    api
  } = useAppContext();
  const [error, setError] = (0,external_react_.useState)(false);
  const onGenerateKey = (0,external_react_.useCallback)(async () => {
    try {
      const key = await api.security.createApiKey(type);
      afterCreate(key);
    } catch (e) {
      setError(true);
    }
  }, [type, api]);
  const onCopyKey = (0,external_react_.useCallback)(() => {
    const handleCopy = event => {
      setCopyValue(event, keyValue);
      event.preventDefault();
      document.removeEventListener('copy', handleCopy, true);
    };
    document.addEventListener('copy', handleCopy, true);
    document.execCommand('copy');
  }, [keyValue]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "top-spacing form-group"
  }, /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-success api-key__button",
    onClick: onGenerateKey,
    disabled: !!keyValue
  }, "Generate ", noun), /*#__PURE__*/external_react_default().createElement("input", {
    disabled: true,
    type: "text",
    className: "form-control api-key__input",
    name: type + '_token',
    value: keyValue
  }), /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default api-key__button",
    title: "Copy to clipboard",
    name: 'copy_' + type + '_token',
    onClick: onCopyKey,
    disabled: !keyValue
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-clipboard"
  }))), !!keyValue && /*#__PURE__*/external_react_default().createElement("div", {
    id: "copy_advice"
  }, "Copy this key value and save it for use in authenticating to the server. This key value will not be shown again."), error && /*#__PURE__*/external_react_default().createElement(Alert, {
    className: "margin-top"
  }, "There was a problem generating your API key. If the problem persists, please contact your system administrator."));
};
const APIKeysPanelBody = props => {
  const {
    includeSessionKeys,
    actions,
    queryModels
  } = props;
  const {
    model
  } = queryModels;
  const {
    user,
    moduleContext,
    impersonatingUser
  } = useServerContext();
  const [apiKey, setApiKey] = (0,external_react_.useState)(''); // start with empty string not undefined to avoid warnings about controlled vs. uncontrolled inputs
  const [sessionKey, setSessionKey] = (0,external_react_.useState)('');
  const [error, setError] = (0,external_react_.useState)();
  const apiEnabled = isApiKeyGenerationEnabled(moduleContext);
  const sessionEnabled = isSessionKeyGenerationEnabled(moduleContext);
  const onDelete = (0,external_react_.useCallback)(deleteError => {
    if (deleteError) {
      setError(deleteError);
    } else {
      setError(undefined);
      setApiKey(''); // undefined and null here will not have the desired effect
    }
  }, []);
  const onApiKeyCreate = (0,external_react_.useCallback)(key => {
    setApiKey(key);
    actions?.loadModel(model?.id, true, true);
  }, [actions, model?.id]);
  const adminMsg = (0,external_react_.useMemo)(() => user.isSystemAdmin ? /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "info",
    id: "admin-msg"
  }, "As a site administrator, you can configure API keys on the", ' ', /*#__PURE__*/external_react_default().createElement("a", {
    href: api_.ActionURL.buildURL('admin', 'customizeSite.view', '/')
  }, "Site Settings page"), ". You can manage API keys generated on the server via", ' ', /*#__PURE__*/external_react_default().createElement("a", {
    href: api_.ActionURL.buildURL('query', 'executeQuery.view', '/', {
      schemaName: 'core',
      queryName: 'APIKeys'
    })
  }, "this query"), ".") : null, [user]);
  const configMsg = (0,external_react_.useMemo)(() => apiEnabled ? /*#__PURE__*/external_react_default().createElement("p", {
    id: "config-msg"
  }, "API keys are currently configured to", ' ', /*#__PURE__*/external_react_default().createElement("span", {
    className: "api-key__expiration-config"
  }, getApiExpirationMessage(moduleContext)), ".", ' ', /*#__PURE__*/external_react_default().createElement("span", null, getCurrentAppProperties() ? /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: "myAccount#apikey",
    useDefaultUrl: biologicsIsPrimaryApp(moduleContext)
  }, "More info") : /*#__PURE__*/external_react_default().createElement("a", {
    href: "https://www.labkey.org/Documentation/wiki-page.view?name=apiKey#usage"
  }, "More info"))) : null, [moduleContext, apiEnabled]);

  // We are meant to not show this panel for LKSM Starter, but show it in LKS and LKSM Prof+
  if (isApp() && !isFeatureEnabled(ProductFeature.ApiKeys, moduleContext)) return null;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-content panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "API Keys"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/external_react_default().createElement("p", null, "API keys are used to authorize client code using one of the", ' ', /*#__PURE__*/external_react_default().createElement("a", {
    href: "https://www.labkey.org/Documentation/wiki-page.view?referrer=inPage&name=viewApis"
  }, "LabKey Client APIs"), ". API keys are appropriate for authenticating ad hoc interactions within statistical tools (e.g., R, RStudio, SAS) or programming languages (e.g., Java, Python), as well as authenticating API use from automated scripts. A valid API key provides complete access to your data and actions, so it should be kept secret."), configMsg, adminMsg, !impersonatingUser && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(GridPanel, {
    actions: actions,
    model: model,
    asPanel: false,
    showSearchInput: false,
    showFiltersButton: false,
    showPagination: true,
    showExport: false,
    showChartMenu: false,
    showViewMenu: false,
    allowViewCustomization: false,
    buttonsComponentProps: {
      model,
      actions,
      onDelete
    },
    ButtonsComponent: APIKeysButtonsComponent,
    emptyText: "You currently do not have any API keys."
  }), /*#__PURE__*/external_react_default().createElement(Alert, null, error)), apiEnabled && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, impersonatingUser !== undefined && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning",
    id: "impersonating-msg"
  }, "API key generation is not available while impersonating."), !impersonatingUser && /*#__PURE__*/external_react_default().createElement(KeyGenerator, {
    type: "apikey",
    keyValue: apiKey,
    afterCreate: onApiKeyCreate,
    noun: "API Key"
  })), !apiEnabled && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning",
    id: "config-msg"
  }, "API key generation is currently not enabled on this server."), sessionEnabled && includeSessionKeys && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "user-section-header top-spacing bottom-spacing"
  }, "Session Keys"), impersonatingUser !== undefined && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning",
    id: "session-impersonating-msg"
  }, "Session key generation is not available while impersonating."), !impersonatingUser && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "A session key is tied to your current browser session, which means all API calls execute in your current context (e.g., your user, your authorizations, etc.). It also means the key will no longer represent a logged in user when the session expires, e.g., when you sign out via the browser or the server automatically times out your session. Since they expire quickly, session keys are most appropriate for deployments with regulatory compliance requirements."), /*#__PURE__*/external_react_default().createElement(KeyGenerator, {
    type: "session",
    keyValue: sessionKey,
    afterCreate: setSessionKey,
    noun: "Session Key"
  })))));
};
const APIKeysPanelWithQueryModels = withQueryModels(APIKeysPanelBody);
const APIKeysPanel = props => {
  const {
    homeContainer,
    impersonatingUser
  } = useServerContext();
  const configs = {};
  if (!impersonatingUser) {
    configs.model = {
      id: 'model',
      title: 'Current API Keys',
      schemaQuery: SCHEMAS.CORE_TABLES.USER_API_KEYS,
      includeTotalCount: true,
      containerPath: homeContainer
    };
  }
  return /*#__PURE__*/external_react_default().createElement(APIKeysPanelWithQueryModels, APIKeysPanel_extends({
    autoLoad: true,
    queryConfigs: configs
  }, props));
};
;// CONCATENATED MODULE: ./src/internal/components/user/AccountSubNav.tsx



const AccountSubNav_PARENT_TAB = {
  text: 'Dashboard',
  url: AppURL.create('home')
};
const useAccountSubNav = () => {
  const {
    clearNav,
    setNoun,
    setTabs
  } = useSubNavTabsContext();
  (0,external_react_.useEffect)(() => {
    setNoun(AccountSubNav_PARENT_TAB);
    setTabs([{
      text: 'Profile',
      url: AppURL.create('account', 'profile')
    }, {
      text: 'Settings',
      url: AppURL.create('account', 'settings')
    }]);
    return clearNav;
  }, [clearNav, setNoun, setTabs]);
};
;// CONCATENATED MODULE: ./src/internal/components/user/CreateUsersModal.tsx
function CreateUsersModal_defineProperty(e, r, t) { return (r = CreateUsersModal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function CreateUsersModal_toPropertyKey(t) { var i = CreateUsersModal_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function CreateUsersModal_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





const DEFAULT_STATE = {
  emailText: '',
  optionalMessage: '',
  roles: undefined,
  isSubmitting: false,
  error: undefined
};
class CreateUsersModal extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    CreateUsersModal_defineProperty(this, "handleEmail", evt => {
      const emailText = evt.target.value;
      this.setState(() => ({
        emailText
      }));
    });
    CreateUsersModal_defineProperty(this, "handleOptionalMessage", evt => {
      const optionalMessage = evt.target.value;
      this.setState(() => ({
        optionalMessage
      }));
    });
    CreateUsersModal_defineProperty(this, "handleRoles", (name, formValue, selectedOptions) => {
      const roles = selectedOptions ? selectedOptions.map(option => option.id) : undefined;
      this.setState({
        roles
      });
    });
    CreateUsersModal_defineProperty(this, "createUsers", () => {
      const {
        emailText,
        optionalMessage
      } = this.state;
      this.setState(() => ({
        isSubmitting: true,
        error: undefined
      }));

      // convert the email addresses from newline separated to semicolon separated
      const email = emailText.replace(/\n/g, ';');
      api_.Security.createNewUser({
        email,
        sendEmail: true,
        optionalMessage: optionalMessage && optionalMessage.length > 0 ? optionalMessage : undefined,
        success: response => {
          this.props.onComplete(response, this.getSelectedRoles());
          this.setState(() => DEFAULT_STATE);
        },
        failure: error => {
          console.error(error);
          this.setState(() => ({
            isSubmitting: false,
            error: error.exception
          }));
        }
      });
    });
    this.state = DEFAULT_STATE;
  }
  hasRoleOptions() {
    return this.props.roleOptions && this.props.roleOptions.length > 0;
  }
  getSelectedRoles() {
    return this.hasRoleOptions() ? this.state.roles || [this.props.roleOptions[0].id] : undefined;
  }
  renderForm() {
    const {
      userLimitSettings
    } = this.props;
    const {
      emailText,
      optionalMessage
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("label", {
      className: "create-users-label-bottom",
      htmlFor: "create-users-email-input"
    }, "Enter one or more email addresses, each on its own line:"), /*#__PURE__*/external_react_default().createElement("textarea", {
      className: "form-control",
      id: "create-users-email-input",
      rows: 5,
      value: emailText || '',
      onChange: this.handleEmail
    }), userLimitSettings?.userLimit && /*#__PURE__*/external_react_default().createElement("div", {
      className: "create-users-limit-message"
    }, "Number of users that can be added: ", userLimitSettings.remainingUsers), this.hasRoleOptions() && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("label", {
      className: "create-users-label-top create-users-label-bottom",
      htmlFor: "create-users-role"
    }, "Roles:"), /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      containerClass: "form-group row",
      inputClass: "col-sm-12",
      inputId: "create-users-role",
      name: "create-users-role",
      key: "create-users-role-selection",
      placeholder: "Select role...",
      value: this.getSelectedRoles(),
      options: this.props.roleOptions,
      valueKey: "id",
      onChange: this.handleRoles,
      clearable: false,
      required: true,
      multiple: true
    })), /*#__PURE__*/external_react_default().createElement("label", {
      className: "create-users-label-bottom",
      htmlFor: "create-users-optionalMessage-input"
    }, "Optional message to send to new users:"), /*#__PURE__*/external_react_default().createElement("textarea", {
      className: "form-control",
      id: "create-users-optionalMessage-input",
      rows: 5,
      value: optionalMessage || '',
      placeholder: "Add your message to be included in the invite email...",
      onChange: this.handleOptionalMessage
    }));
  }
  render() {
    const {
      onCancel
    } = this.props;
    const {
      error,
      emailText
    } = this.state;
    const valid = emailText?.length > 0 && this.getSelectedRoles()?.length > 0; // Issue 46841

    return /*#__PURE__*/external_react_default().createElement(Modal, {
      canConfirm: valid,
      confirmText: "Create Users",
      confirmingText: "Creating Users...",
      isConfirming: this.state.isSubmitting,
      onCancel: onCancel,
      onConfirm: this.createUsers,
      title: "Create New Users"
    }, this.renderForm(), error && /*#__PURE__*/external_react_default().createElement(Alert, {
      style: {
        marginTop: '10px'
      }
    }, error));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/user/UsersGridPanel.tsx
function UsersGridPanel_extends() { return UsersGridPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, UsersGridPanel_extends.apply(null, arguments); }
function UsersGridPanel_defineProperty(e, r, t) { return (r = UsersGridPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function UsersGridPanel_toPropertyKey(t) { var i = UsersGridPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function UsersGridPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */




















const OMITTED_COLUMNS = ['phone', 'im', 'mobile', 'pager', 'groups', 'firstName', 'lastName', 'description', 'expirationDate'];
class UsersGridPanelImpl extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    UsersGridPanel_defineProperty(this, "initQueryModel", usersView => {
      const {
        actions
      } = this.props;
      const baseFilters = usersView === 'all' ? [] : [api_.Filter.create('active', usersView === 'active')];
      actions.addModel({
        id: this.getUsersModelId(),
        schemaQuery: SCHEMAS.CORE_TABLES.USERS,
        baseFilters,
        omittedColumns: OMITTED_COLUMNS,
        bindURL: true,
        urlPrefix: usersView,
        // each model needs to have its own urlPrefix for paging to work across models
        includeTotalCount: true,
        useSavedSettings: true
      }, true, true);
    });
    UsersGridPanel_defineProperty(this, "toggleViewActive", viewName => {
      this.setState({
        usersView: viewName
      });
    });
    UsersGridPanel_defineProperty(this, "closeDialog", () => {
      this.toggleDialog(undefined);
    });
    UsersGridPanel_defineProperty(this, "toggleDialog", (name, requiresSelection = false) => {
      if (requiresSelection && !this.getUsersModel().hasSelections) {
        this.setState({
          showDialog: undefined
        });
      } else {
        this.setState({
          showDialog: name
        });
      }
    });
    UsersGridPanel_defineProperty(this, "onCreateComplete", (response, roles) => {
      this.closeDialog();
      this.onRowSelectionChange(this.getUsersModel(), undefined, false); // clear selected user details
      this.props.onCreateComplete(response, roles);
      this.reloadUsersModel();
    });
    UsersGridPanel_defineProperty(this, "onUsersStateChangeComplete", (response, resetSelection = true) => {
      this.closeDialog();
      if (resetSelection) {
        this.onRowSelectionChange(this.getUsersModel(), undefined, false); // clear selected user details
      }
      this.props.onUsersStateChangeComplete(response);
      this.reloadUsersModel();
    });
    UsersGridPanel_defineProperty(this, "onRowSelectionChange", (model, row, checked) => {
      let selectedUserId;
      if (checked) {
        // if a specific row has been selected, use that rows UserId value
        // else use the last userId in the selected array
        if (row) {
          selectedUserId = row.getIn(['UserId', 'value']);
        } else if (model.hasSelections) {
          selectedUserId = this.getLastSelectedId();
        }
      }
      this.updateSelectedUserId(selectedUserId);
    });
    UsersGridPanel_defineProperty(this, "renderButtons", () => {
      const {
        user
      } = this.props;
      const {
        usersView
      } = this.state;
      const model = this.getUsersModel();
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "btn-group"
      }, user.hasAddUsersPermission() && /*#__PURE__*/external_react_default().createElement(DisableableButton, {
        bsStyle: "success",
        onClick: () => this.toggleDialog('create'),
        disabledMsg: this.getUserLimitRemainingUsers() === 0 ? 'User limit has been reached' : undefined
      }, "Create"), /*#__PURE__*/external_react_default().createElement(ManageDropdownButton, {
        showIcon: false
      }, user.hasManageUsersPermission() && usersView === 'active' && /*#__PURE__*/external_react_default().createElement(SelectionMenuItem, {
        text: "Deactivate Users",
        onClick: () => this.toggleDialog('deactivate', true),
        queryModel: model,
        nounPlural: "users"
      }), user.hasManageUsersPermission() && /*#__PURE__*/external_react_default().createElement(SelectionMenuItem, {
        text: "Delete Users",
        onClick: () => this.toggleDialog('delete', true),
        queryModel: model,
        nounPlural: "users"
      }), user.hasManageUsersPermission() && usersView === 'inactive' && /*#__PURE__*/external_react_default().createElement(SelectionMenuItem, {
        text: "Reactivate Users",
        maxSelection: this.getUserLimitRemainingUsers(),
        maxSelectionDisabledMsg: this.getUserLimitRemainingUsers() === 0 ? 'User limit has been reached' : undefined,
        onClick: () => this.toggleDialog('reactivate', true),
        queryModel: model,
        nounPlural: "users"
      }), usersView !== 'active' && /*#__PURE__*/external_react_default().createElement(MenuItem, {
        onClick: () => this.toggleViewActive('active')
      }, "View Active Users"), usersView !== 'all' && /*#__PURE__*/external_react_default().createElement(MenuItem, {
        onClick: () => this.toggleViewActive('all')
      }, "View All Users"), usersView !== 'inactive' && /*#__PURE__*/external_react_default().createElement(MenuItem, {
        onClick: () => this.toggleViewActive('inactive')
      }, "View Inactive Users")));
    });
    this.state = {
      // location is really only undefined when running in jest tests because the react-router context isn't
      // properly setup.
      usersView: this.getUsersView(this.props.searchParams.get('usersView')),
      showDialog: undefined,
      selectedUserId: undefined
    };
  }
  componentDidMount() {
    this.setLastSelectedId();
    this.initQueryModel(this.state.usersView);
  }
  componentDidUpdate(prevProps, prevState) {
    this.setLastSelectedId();
    if (this.state.usersView !== prevState.usersView) {
      this.initQueryModel(this.state.usersView);
    } else if (prevProps.policy !== undefined && this.props.policy !== prevProps.policy) {
      // if we had a policy and it changed (ex. user was deactivated or deleted from detail panel), then load model
      this.reloadUsersModel();
    }
    const curUsersView = this.props.searchParams.get('usersView');
    if (curUsersView !== null) {
      this.setState({
        usersView: this.getUsersView(curUsersView)
      });
      removeParameters(this.props.setSearchParams, 'usersView');
    }
  }
  getUsersView(paramVal) {
    return paramVal === 'inactive' || paramVal === 'all' ? paramVal : 'active'; // default to view active users
  }
  getUsersModelId() {
    return 'user-management-users-' + this.state.usersView;
  }
  getUsersModel() {
    return this.props.queryModels[this.getUsersModelId()];
  }
  reloadUsersModel() {
    this.props.actions.loadModel(this.getUsersModelId(), true, true);
  }
  updateSelectedUserId(selectedUserId) {
    if (this.state.selectedUserId !== selectedUserId) {
      this.setState(() => ({
        selectedUserId
      }));
    }
  }
  getLastSelectedId() {
    const selectedIds = this.getUsersModel().selections;
    return selectedIds.size > 0 ? parseInt(Array.from(selectedIds).pop()) : undefined;
  }
  setLastSelectedId() {
    const model = this.getUsersModel();
    if (!model || isLoading(model.selectionsLoadingState)) return;

    // if the model has already loaded selections, we can use that to reselect the last user
    // otherwise, query the server for the selection key for this model and use that response (issue 39374)
    if (model.selectionsLoadingState === LoadingState.LOADED) {
      this.updateSelectedUserId(this.getLastSelectedId());
    } else {
      // TODO: This seems wrong, we should just do nothing, eventually the selections will load and we'll be able
      //  to set the user id. If we don't automatically load selections we can manually call loadSelections via
      //  model actions.
      getSelected(model.id, false, model.schemaQuery, model.filters, model.containerPath, model.queryParameters, model.containerFilter).then(response => {
        const selectedUserId = response.selected.length > 0 ? parseInt(external_immutable_.List.of(...response.selected).last()) : undefined;
        this.updateSelectedUserId(selectedUserId);
      });
    }
  }
  getUserLimitRemainingUsers() {
    const {
      userLimitSettings
    } = this.props;
    return userLimitSettings?.userLimit ? userLimitSettings.remainingUsers : undefined;
  }
  render() {
    const {
      newUserRoleOptions,
      user,
      showDetailsPanel,
      actions,
      userLimitSettings
    } = this.props;
    const {
      selectedUserId,
      showDialog,
      usersView
    } = this.state;
    const model = this.getUsersModel();
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: `col-xs-12 col-md-${showDetailsPanel ? 8 : 12}`
    }, !model && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), model && /*#__PURE__*/external_react_default().createElement(GridPanel, {
      actions: actions,
      model: model,
      loadOnMount: false,
      title: capitalizeFirstChar(usersView) + ' Users',
      ButtonsComponent: () => this.renderButtons(),
      highlightLastSelectedRow: true,
      showChartMenu: false
    })), showDetailsPanel && /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12 col-md-4"
    }, /*#__PURE__*/external_react_default().createElement(UserDetailsPanel, UsersGridPanel_extends({}, this.props, {
      currentUser: user,
      userId: selectedUserId,
      onUsersStateChangeComplete: this.onUsersStateChangeComplete
    })))), user.hasAddUsersPermission() && showDialog === 'create' && /*#__PURE__*/external_react_default().createElement(CreateUsersModal, {
      userLimitSettings: userLimitSettings,
      roleOptions: newUserRoleOptions,
      onComplete: this.onCreateComplete,
      onCancel: this.closeDialog
    }), user.hasManageUsersPermission() && (showDialog === 'reactivate' || showDialog === 'deactivate') && /*#__PURE__*/external_react_default().createElement(UserActivateChangeConfirmModal, {
      userIds: model.getSelectedIdsAsInts(),
      reactivate: showDialog === 'reactivate',
      onComplete: this.onUsersStateChangeComplete,
      onCancel: this.closeDialog
    }), user.hasManageUsersPermission() && showDialog === 'delete' && /*#__PURE__*/external_react_default().createElement(UserDeleteConfirmModal, {
      userIds: model.getSelectedIdsAsInts(),
      onComplete: this.onUsersStateChangeComplete,
      onCancel: this.closeDialog
    }));
  }
}
UsersGridPanel_defineProperty(UsersGridPanelImpl, "defaultProps", {
  showDetailsPanel: true,
  allowResetPassword: true
});
const UsersGridPanelWithModels = withQueryModels(UsersGridPanelImpl);
const UsersGridPanel = (0,external_react_.memo)(props => {
  const [searchParams, setSearchParams] = (0,external_react_router_dom_.useSearchParams)();
  return /*#__PURE__*/external_react_default().createElement(UsersGridPanelWithModels, UsersGridPanel_extends({}, props, {
    searchParams: searchParams,
    setSearchParams: setSearchParams
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/ExpandableContainer.tsx
function ExpandableContainer_defineProperty(e, r, t) { return (r = ExpandableContainer_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ExpandableContainer_toPropertyKey(t) { var i = ExpandableContainer_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ExpandableContainer_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2016-2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */



class ExpandableContainer extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    ExpandableContainer_defineProperty(this, "handleClick", () => {
      if (!this.props.isExpandable) {
        this.props.onClick?.(false);
        return;
      }
      this.setState(state => ({
        visible: !state.visible
      }), () => {
        this.props.onClick?.(this.state.visible);
      });
    });
    ExpandableContainer_defineProperty(this, "handleMouseEnter", () => {
      this.setState(() => ({
        isHover: true
      }));
    });
    ExpandableContainer_defineProperty(this, "handleMouseLeave", () => {
      this.setState(() => ({
        isHover: false
      }));
    });
    this.state = {
      visible: props.initExpanded || false,
      isHover: false
    };
  }
  render() {
    const {
      children,
      iconSrc,
      iconFaCls,
      isExpandable,
      clause,
      links,
      containerCls,
      useGreyTheme
    } = this.props;
    const {
      visible,
      isHover
    } = this.state;
    const hasOnClick = this.props.onClick !== undefined;
    const containerDivCls = useGreyTheme ? 'container-expandable-grey' : 'container-expandable-blue';
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('row', 'container-expandable', {
        disabled: !isExpandable
      })
    }, /*#__PURE__*/external_react_default().createElement("div", {
      onClick: hasOnClick || isExpandable ? this.handleClick : undefined,
      onMouseEnter: isExpandable ? this.handleMouseEnter : undefined,
      onMouseLeave: isExpandable ? this.handleMouseLeave : undefined,
      className: external_classnames_default()(containerCls, containerDivCls, {
        'container-expandable-child__inactive': visible
      }, {
        'container-expandable__active': isHover || visible
      }, {
        'container-expandable__inactive': !isHover && !visible
      })
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "container-expandable-child__img"
    }, iconFaCls ? /*#__PURE__*/external_react_default().createElement("i", {
      style: {
        padding: '5px'
      },
      className: 'fa fa-' + iconFaCls
    }) : /*#__PURE__*/external_react_default().createElement(SVGIcon, {
      iconSrc: iconSrc,
      isActive: isHover,
      height: "50px",
      width: "50px"
    })), /*#__PURE__*/external_react_default().createElement("div", {
      onClick: hasOnClick || isExpandable ? this.handleClick : undefined,
      className: external_classnames_default()('pull-right', 'container-expandable-child__chevron', {
        'text-muted': !isExpandable
      })
    }, /*#__PURE__*/external_react_default().createElement("i", {
      onClick: hasOnClick || isExpandable ? this.handleClick : undefined,
      className: external_classnames_default()('fa', {
        'fa-chevron-down': visible,
        'fa-chevron-right': !visible
      })
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "container-expandable-heading"
    }, clause, links)), visible && children);
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/samples/models.ts
function samples_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function samples_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? samples_models_ownKeys(Object(t), !0).forEach(function (r) { domainproperties_samples_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : samples_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function domainproperties_samples_models_defineProperty(e, r, t) { return (r = domainproperties_samples_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function domainproperties_samples_models_toPropertyKey(t) { var i = domainproperties_samples_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function domainproperties_samples_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




// eslint-disable-next-line no-template-curly-in-string
const DEFAULT_ALIQUOT_NAMING_PATTERN = '${${AliquotedFrom}-:withCounter}';
class SampleTypeModel extends (0,external_immutable_.Record)({
  rowId: undefined,
  name: undefined,
  nameReadOnly: false,
  nameExpression: undefined,
  aliquotNameExpression: undefined,
  description: undefined,
  labelColor: undefined,
  metricUnit: undefined,
  parentAliases: undefined,
  importAliases: undefined,
  domainId: undefined,
  domain: undefined,
  autoLinkTargetContainerId: undefined,
  autoLinkCategory: undefined,
  excludedContainerIds: undefined,
  excludedDashboardContainerIds: undefined,
  exception: undefined
}) {
  static create(raw, name) {
    const options = raw?.options;
    let importAliases = (0,external_immutable_.Map)();
    if (options) {
      const aliases = options.get('importAliases') || {};
      importAliases = (0,external_immutable_.Map)((0,external_immutable_.fromJS)(aliases));
    }
    return new SampleTypeModel(samples_models_objectSpread(samples_models_objectSpread({}, options?.toJS()), {}, {
      aliquotNameExpression: options?.get('aliquotNameExpression') || DEFAULT_ALIQUOT_NAMING_PATTERN,
      name,
      nameReadOnly: raw?.nameReadOnly,
      importAliases,
      labelColor: options?.get('labelColor') || undefined,
      // helps to convert null to undefined
      metricUnit: options?.get('metricUnit') || undefined,
      domain: raw?.domainDesign ?? DomainDesign.create({})
    }));
  }
  static serialize(model) {
    const domain = DomainDesign.serialize(model.domain);
    return model.merge({
      domain
    }).toJS();
  }
  isNew() {
    return !this.rowId;
  }
  isValid(defaultNameFieldConfig, metricUnitRequired) {
    return this.hasValidProperties() && !this.hasInvalidNameField(defaultNameFieldConfig) && getDuplicateAlias(this.parentAliases, true).size === 0 && !this.domain.hasInvalidFields() && this.isMetricUnitValid(metricUnitRequired);
  }
  isMetricUnitValid(metricUnitRequired) {
    return !metricUnitRequired || this.metricUnit != null;
  }
  hasValidProperties() {
    const {
      parentAliases
    } = this;
    const hasInvalidAliases = parentAliases && parentAliases.size > 0 && parentAliases.find(parentAliasInvalid) !== undefined;
    return this.name !== undefined && this.name !== null && this.name.trim().length > 0 && !hasInvalidAliases;
  }
  hasInvalidNameField(defaultNameFieldConfig) {
    return this.domain && defaultNameFieldConfig ? this.domain.hasInvalidNameField(defaultNameFieldConfig) : false;
  }
  get containerPath() {
    return this.domain.container;
  }
}
;// CONCATENATED MODULE: ./src/internal/components/forms/detail/utils.ts


function arrayListIsEqual(valueArr, nestedModelList) {
  let matched = 0;
  // Loop through the submitted array and the existing list and compare values.
  // If values match, add tally. If submitted values length is same as existing list, consider them equal.
  // Note: caller should have checked against empty array and list before function.
  nestedModelList.forEach(nestedField => {
    return valueArr.forEach(nestedVal => {
      if (nestedField.get('value') === nestedVal || nestedField.get('displayValue') === nestedVal) {
        matched++;
      }
    });
  });
  return matched === valueArr.length;
}
function extractChanges(queryInfo, currentData, formValues) {
  const changedValues = {};
  // Loop through submitted formValues and check against existing currentData from server
  Object.keys(formValues).forEach(field => {
    let existingValue = currentData.get(field);
    const changedValue = formValues[field];

    // If nested value, will need to do deeper check
    if (external_immutable_.List.isList(existingValue)) {
      // If the submitted value and existing value are empty, do not update field
      if (!changedValue && existingValue.size === 0) {
        return false;
      }
      // If the submitted value is empty and there is an existing value, should update field
      else if (!changedValue && existingValue.size > 0) {
        // Issue 46102
        // Do not set the field to changedValue, it may be undefined, which causes us to treat the value as if
        // it has not changed, making it impossible to clear the value.
        changedValues[field] = [];
      } else {
        // If submitted value array and existing value array are different size, should update field
        if (changedValue.length !== existingValue.size) {
          changedValues[field] = changedValue;
        }
        // If submitted value array and existing array are the same size, need to compare full contents
        else if (changedValue.length === existingValue.size) {
          if (!arrayListIsEqual(changedValue, existingValue)) {
            changedValues[field] = changedValue;
          }
        }
      }
    } else if (changedValue != currentData.getIn([field, 'value'])) {
      existingValue = currentData.getIn([field, 'value']);
      const column = queryInfo.getColumn(field);
      let newValue = changedValue;
      // A date field needs to be checked specially
      if (column?.jsonType === 'date') {
        // Ensure dates have same formatting
        const newDate = new Date(newValue);
        const origDate = new Date(existingValue);
        // If submitted value is same as existing date down to the minute (issue 40139), do not update
        let newDateValue = newDate.setUTCSeconds(0, 0);
        let origDateValue = origDate.setUTCSeconds(0, 0);
        // If original date doesn't have timestamp, then only check date to hour
        if (api_.Utils.isString(newValue) && newValue.indexOf(':') === -1) {
          newDateValue = newDate.setUTCHours(0, 0, 0, 0);
          origDateValue = origDate.setUTCHours(0, 0, 0, 0);
        }
        if (newDateValue === origDateValue) {
          return false;
        }
      } else if (column?.inputType === 'file') {
        // for file inputs, newValue of undefined means that it wasn't changed
        if (newValue === undefined || existingValue === newValue) {
          return false;
        }
      } else if (column?.jsonType === 'string') {
        if (api_.Utils.isString(newValue)) {
          newValue = newValue.trim();
        }
        if (existingValue === newValue) {
          return false;
        }
      }
      changedValues[field] = newValue === undefined ? null : newValue;
    }
  });
  return changedValues;
}
;// CONCATENATED MODULE: ./src/public/QueryModel/EditableDetailPanel.tsx
function EditableDetailPanel_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EditableDetailPanel_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EditableDetailPanel_ownKeys(Object(t), !0).forEach(function (r) { EditableDetailPanel_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EditableDetailPanel_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function EditableDetailPanel_defineProperty(e, r, t) { return (r = EditableDetailPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function EditableDetailPanel_toPropertyKey(t) { var i = EditableDetailPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function EditableDetailPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }














const EditableDetailPanel = props => {
  const {
    containerPath,
    model,
    onBeforeUpdate,
    onCommentChange,
    onEditToggle,
    onUpdate,
    appEditable,
    containerFilter,
    disabled,
    detailEditRenderer,
    detailHeader,
    detailRenderer,
    asSubPanel,
    canUpdate,
    editColumns,
    queryColumns,
    submitText,
    title,
    onAdditionalFormDataChange
  } = props;
  const {
    api
  } = useAppContext();
  const [canSubmit, setCanSubmit] = (0,external_react_.useState)(false);
  const [editing, setEditing] = (0,external_react_.useState)(false);
  const [error, setError] = (0,external_react_.useState)(undefined);
  const [warning, setWarning] = (0,external_react_.useState)(undefined);
  const [comment, setComment] = (0,external_react_.useState)();
  const {
    requiresUserComment
  } = useDataChangeCommentsRequired();
  const _onCommentChange = (0,external_react_.useCallback)(_comment => {
    setComment(_comment);
    onCommentChange?.(_comment);
  }, [onCommentChange]);
  const hasValidUserComment = comment?.trim()?.length > 0;
  const toggleEditing = (0,external_react_.useCallback)(() => {
    const updated = !editing;
    setEditing(updated);
    setWarning(undefined);
    setError(undefined);
    onEditToggle?.(updated);
  }, [editing, onEditToggle]);
  const disableSubmitButton = (0,external_react_.useCallback)(() => {
    setCanSubmit(false);
  }, []);
  const enableSubmitButton = (0,external_react_.useCallback)(() => {
    setCanSubmit(true);
  }, []);
  const handleFormChange = (0,external_react_.useCallback)(() => {
    setWarning(undefined);
  }, []);
  const fileInputRenderer = (0,external_react_.useCallback)((col, data) => {
    return /*#__PURE__*/external_react_default().createElement(FileInput, {
      formsy: true,
      initialValue: data,
      name: col.fieldKey,
      queryColumn: col,
      showLabel: false
    });
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = (0,external_react_.useCallback)(async values => {
    const {
      queryInfo
    } = model;
    const row = model.getRow();
    const updatedValues = extractChanges(queryInfo, (0,external_immutable_.fromJS)(model.getRow()), values);
    if (Object.keys(updatedValues).length === 0) {
      setCanSubmit(false);
      setError(undefined);
      setWarning('No changes detected. Please update the form and click save.');
      return;
    }

    // iterate the set of pkCols for this QueryInfo -- include value from queryData
    queryInfo.getPkCols().forEach(pkCol => {
      const pkVal = row[pkCol.fieldKey]?.value;
      if (pkVal !== undefined && pkVal !== null) {
        updatedValues[pkCol.fieldKey] = pkVal;
      } else {
        console.warn('Unable to find value for pkCol "' + pkCol.fieldKey + '"');
      }
    });
    try {
      onBeforeUpdate?.(updatedValues);
      await api.query.updateRows({
        auditBehavior: api_.AuditBehaviorTypes.DETAILED,
        containerPath,
        rows: [updatedValues],
        schemaQuery: queryInfo.schemaQuery,
        auditUserComment: comment
      });
      setEditing(false);
      onUpdate?.(); // eslint-disable-line no-unused-expressions
      onEditToggle?.(false); // eslint-disable-line no-unused-expressions
    } catch (e) {
      setError(resolveErrorMessage(e, 'data', undefined, 'update'));
      setWarning(undefined);
    }
  }, [model, onBeforeUpdate, api.query, containerPath, comment, onUpdate, onEditToggle]);
  const isEditable = !model.isLoading && model.hasRows && (model.queryInfo?.isAppEditable() || appEditable);
  const panel = /*#__PURE__*/external_react_default().createElement("div", {
    className: `panel ${editing ? 'panel-info' : 'panel-default'}`
  }, /*#__PURE__*/external_react_default().createElement(DetailPanelHeader, {
    isEditable: isEditable && canUpdate,
    editing: editing,
    title: title,
    onClick: toggleEditing,
    warning: warning
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "detail__editing"
  }, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), !editing && (detailHeader ?? null), !editing && /*#__PURE__*/external_react_default().createElement(DetailPanel, {
    containerFilter: containerFilter,
    containerPath: containerPath,
    detailRenderer: detailRenderer,
    editingMode: false,
    model: model,
    queryColumns: queryColumns
  }), editing && /*#__PURE__*/external_react_default().createElement(DetailPanelWithModel, {
    containerFilter: containerFilter,
    containerPath: containerPath,
    detailEditRenderer: detailEditRenderer,
    detailRenderer: detailRenderer,
    editColumns: editColumns,
    editingMode: true,
    fileInputRenderer: fileInputRenderer,
    onAdditionalFormDataChange: onAdditionalFormDataChange,
    queryConfig: EditableDetailPanel_objectSpread(EditableDetailPanel_objectSpread({}, model.queryConfig), {}, {
      // Issue 46478: Include update columns in request columns to ensure values are available
      requiredColumns: model.requiredColumns.concat(model.updateColumns.map(col => col.fieldKey))
    })
  }))));
  if (editing) {
    return /*#__PURE__*/external_react_default().createElement((external_formsy_react_default()), {
      onChange: handleFormChange,
      onValidSubmit: handleSubmit,
      onValid: enableSubmitButton,
      onInvalid: disableSubmitButton
    }, panel, /*#__PURE__*/external_react_default().createElement(FormButtons, null, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      type: "button",
      onClick: toggleEditing
    }, "Cancel"), /*#__PURE__*/external_react_default().createElement(CommentTextArea, {
      actionName: "Update",
      containerClassName: "inline-comment",
      onChange: _onCommentChange,
      requiresUserComment: requiresUserComment,
      inline: true
    }), /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-success",
      type: "submit",
      disabled: !canSubmit || requiresUserComment && !hasValidUserComment || disabled
    }, submitText)), asSubPanel && /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-divider-spacing"
    }));
  }
  return panel;
};
EditableDetailPanel.defaultProps = {
  submitText: 'Save'
};
;// CONCATENATED MODULE: ./src/internal/components/assay/AssayDesignEmptyAlert.tsx
const AssayDesignEmptyAlert_excluded = ["message", "actionURL"];
function AssayDesignEmptyAlert_extends() { return AssayDesignEmptyAlert_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, AssayDesignEmptyAlert_extends.apply(null, arguments); }
function AssayDesignEmptyAlert_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = AssayDesignEmptyAlert_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function AssayDesignEmptyAlert_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }








const AssayDesignEmptyAlert = (0,external_react_.memo)(props => {
  const {
      message,
      actionURL
    } = props,
    baseProps = AssayDesignEmptyAlert_objectWithoutProperties(props, AssayDesignEmptyAlert_excluded);
  const {
    container,
    moduleContext
  } = useServerContext();
  const homeFolderPath = getAppHomeFolderPath(container, moduleContext);
  const homeContainer = useContainerUser(homeFolderPath);
  if (!homeContainer.isLoaded) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement(EmptyAlert, AssayDesignEmptyAlert_extends({}, baseProps, {
    actionURL: actionURL ?? NEW_ASSAY_DESIGN_HREF,
    message: message ?? 'No assays are currently active.',
    allowAction: hasAllPermissions(homeContainer.user, [api_.PermissionTypes.DesignAssay])
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/chart/BarChartViewer.tsx
function BarChartViewer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BarChartViewer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BarChartViewer_ownKeys(Object(t), !0).forEach(function (r) { BarChartViewer_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BarChartViewer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function BarChartViewer_defineProperty(e, r, t) { return (r = BarChartViewer_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function BarChartViewer_toPropertyKey(t) { var i = BarChartViewer_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function BarChartViewer_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






















async function fetchItemCount(schemaQuery, filterArray = []) {
  try {
    const response = await selectRows({
      filterArray,
      maxRows: 1,
      schemaQuery,
      containerFilter: api_.Query.ContainerFilter.currentPlusProjectAndShared // Issue 46098
    });
    return response.rows.length;
  } catch (error) {
    console.error('Failed to fetch item count for charts', error);
  }
  return 0;
}
class BarChartViewer extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    BarChartViewer_defineProperty(this, "loadChartData", async () => {
      const {
        containerFilter,
        dataTypeExclusions
      } = this.props;
      const {
        resultRows,
        currentGroup
      } = this.state;
      if (!resultRows.hasOwnProperty(currentGroup)) {
        try {
          const currentConfig = this.getSelectedChartGroup();
          const {
            itemCountFilters,
            itemCountSQ,
            getProjectExclusionFilter
          } = currentConfig;
          const projectExclusionFilter = getProjectExclusionFilter(dataTypeExclusions);
          const filters = [];
          if (itemCountFilters) filters.push(...itemCountFilters);
          if (projectExclusionFilter) filters.push(projectExclusionFilter);
          const itemCount = await fetchItemCount(itemCountSQ, filters);
          const {
            queryName,
            schemaName,
            sort
          } = currentConfig;
          // default view is fine here; using custom query that is assumed not to be customized or customized
          // to specifically affect this view.
          const response = await selectRows({
            schemaQuery: new SchemaQuery(schemaName, queryName),
            containerFilter,
            sort,
            filterArray: filters
          });
          this.setState(state => ({
            itemCounts: BarChartViewer_objectSpread(BarChartViewer_objectSpread({}, state.itemCounts), {}, {
              [currentGroup]: itemCount
            }),
            resultRows: BarChartViewer_objectSpread(BarChartViewer_objectSpread({}, state.resultRows), {}, {
              [currentGroup]: response.rows
            })
          }));
        } catch (reason) {
          console.error(reason);
          this.setState({
            hasError: true
          });
        }
      }
    });
    BarChartViewer_defineProperty(this, "getSelectedChartGroup", () => {
      return this.props.chartConfigs[this.state.currentGroup];
    });
    BarChartViewer_defineProperty(this, "getSelectedChartGroupCharts", () => {
      return this.getSelectedChartGroup().charts;
    });
    BarChartViewer_defineProperty(this, "onBarClick", (evt, row) => {
      const {
        getAppURL,
        filterDataRegionName = 'query'
      } = this.getSelectedChartGroup();
      if (getAppURL) {
        const chart = this.getSelectedChartGroupCharts()[this.state.currentChart];

        // apply the created date filter if the chart definition has one
        let url = getAppURL(row, evt);
        if (chart.filter !== undefined) {
          const dt = external_moment_default()().add(chart.filter, 'days').format(getDateFormat().toUpperCase());
          url = url.addParam(filterDataRegionName + '.Created~dategte', dt);
        }
        this.props.navigate(url);
      }
    });
    BarChartViewer_defineProperty(this, "prevChart", () => {
      this.selectChart(this.state.currentChart - 1);
    });
    BarChartViewer_defineProperty(this, "nextChart", () => {
      this.selectChart(this.state.currentChart + 1);
    });
    BarChartViewer_defineProperty(this, "selectChart", index => {
      if (index < 0 || index > this.getSelectedChartGroupCharts().length - 1) {
        return;
      }
      this.setState({
        currentChart: index
      });
    });
    BarChartViewer_defineProperty(this, "selectChartGroup", index => {
      this.setState(() => ({
        currentGroup: index,
        currentChart: 0
      }), () => {
        this.loadChartData();
      });
    });
    this.state = {
      currentChart: 0,
      currentGroup: 0,
      hasError: false,
      itemCounts: {},
      resultRows: {}
    };
  }
  componentDidMount() {
    this.loadChartData();
  }
  render() {
    const {
      chartConfigs,
      user
    } = this.props;
    const {
      resultRows,
      currentGroup,
      currentChart,
      hasError,
      itemCounts
    } = this.state;
    const selectedGroup = this.getSelectedChartGroup();
    const selectedCharts = this.getSelectedChartGroupCharts();
    const currentChartOptions = selectedCharts[currentChart];
    const hasSectionItems = itemCounts[currentGroup] > 0;
    const rows = resultRows[currentGroup];
    const isLoading = !rows;
    const hasData = rows?.length > 0;
    let body;
    if (hasError) {
      body = /*#__PURE__*/external_react_default().createElement(Alert, null, getActionErrorMessage('There was a problem loading the chart configurations.', 'chart'));
    } else if (isLoading) {
      body = /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
    } else if (!hasSectionItems) {
      if (selectedGroup.key === SAMPLES_KEY) {
        body = /*#__PURE__*/external_react_default().createElement(SampleTypeEmptyAlert, {
          user: user
        });
      } else if (selectedGroup.key === ASSAYS_KEY) {
        body = /*#__PURE__*/external_react_default().createElement(AssayDesignEmptyAlert, null); // don't pass user, prevents creating assay design from alert message
      }
    } else if (!hasData) {
      if (selectedGroup.key === SAMPLES_KEY) {
        body = /*#__PURE__*/external_react_default().createElement(Alert, {
          bsStyle: "warning"
        }, "No samples have been created.", ' ', user.hasInsertPermission() ? "Use the 'Add Samples' menu above to create samples." : '');
      } else if (selectedGroup.key === ASSAYS_KEY) {
        body = /*#__PURE__*/external_react_default().createElement(Alert, {
          bsStyle: "warning"
        }, "No assay runs have been imported.");
      }
    } else {
      const {
        barFillColors,
        data
      } = processChartData(rows, {
        colorPath: selectedGroup.colorPath,
        groupPath: selectedGroup.groupPath,
        countPath: [currentChartOptions.name, 'value']
      });
      body = /*#__PURE__*/external_react_default().createElement(BaseBarChart, {
        barFillColors: barFillColors,
        data: data,
        defaultBorderColor: "#555",
        grouped: selectedGroup.groupPath !== undefined,
        onClick: selectedGroup.getAppURL ? this.onBarClick : undefined,
        title: `${selectedGroup.label} (${currentChartOptions.label})`
      });
    }
    return /*#__PURE__*/external_react_default().createElement(Section, {
      panelClassName: isLoading || !hasData ? 'bar-chart-viewer-empty' : 'bar-chart-viewer-panel',
      title: "Dashboard Insights",
      titleSize: "medium"
    }, !hasError && /*#__PURE__*/external_react_default().createElement("div", {
      className: "btn-group"
    }, /*#__PURE__*/external_react_default().createElement(DropdownButton, {
      buttonClassName: "insight-type-menu",
      title: selectedGroup.label
    }, chartConfigs.map(({
      label
    }, i) => /*#__PURE__*/external_react_default().createElement(MenuItem, {
      active: selectedGroup.label === label,
      key: label,
      onClick: () => this.selectChartGroup(i)
    }, label))), selectedCharts?.length > 1 && /*#__PURE__*/external_react_default().createElement(DropdownButton, {
      buttonClassName: "insight-chart-menu",
      title: currentChartOptions.label
    }, selectedCharts.map((chart, i) => /*#__PURE__*/external_react_default().createElement(MenuItem, {
      active: currentChart === i,
      key: chart.label,
      onClick: () => this.selectChart(i)
    }, chart.label)))), !hasError && selectedCharts?.length > 1 && /*#__PURE__*/external_react_default().createElement("div", {
      className: "btn-group button-left-spacing pull-right"
    }, /*#__PURE__*/external_react_default().createElement(Tip, {
      caption: "Previous"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      disabled: currentChart === 0,
      onClick: this.prevChart,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-chevron-left"
    }))), /*#__PURE__*/external_react_default().createElement(Tip, {
      caption: "Next"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: this.nextChart,
      disabled: currentChart === selectedCharts.length - 1,
      type: "button"
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-chevron-right"
    })))), !hasError && hasSectionItems && selectedGroup.showSampleButtons && /*#__PURE__*/external_react_default().createElement(SampleButtons, null), /*#__PURE__*/external_react_default().createElement("div", {
      className: "margin-top"
    }, body));
  }
}

// export for jest testing
const SampleButtons = (0,external_react_.memo)(() => {
  const {
    api
  } = useAppContext();
  const {
    user
  } = useServerContext();
  const onSampleFinder = (0,external_react_.useCallback)(() => {
    api.query.incrementClientSideMetricCount(SAMPLE_FILTER_METRIC_AREA, 'dashboardButtonNavigation');
  }, [api]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "pull-right bar-chart-viewer-sample-buttons"
  }, /*#__PURE__*/external_react_default().createElement("a", {
    className: external_classnames_default()('btn btn-primary', {
      'button-right-spacing': user.canInsert
    }),
    href: FIND_SAMPLES_BY_FILTER_HREF.toHref(),
    onClick: onSampleFinder
  }, "Go to Sample Finder"), /*#__PURE__*/external_react_default().createElement(RequiresPermission, {
    perms: api_.PermissionTypes.Insert
  }, /*#__PURE__*/external_react_default().createElement(DropdownButton, {
    title: "Add Samples",
    bsStyle: "success"
  }, /*#__PURE__*/external_react_default().createElement(MenuItem, {
    href: GRID_INSERT_SAMPLES_HREF.toHref()
  }, "Add Manually"), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    href: FILE_IMPORT_SAMPLES_HREF.toHref()
  }, "Import from File"))));
});
;// CONCATENATED MODULE: ./src/internal/components/chart/HorizontalBarSection.tsx




const DEFAULT_EMPTY_TEXT = 'No data available.';
const HorizontalBarSection = (0,external_react_.memo)(props => {
  const {
    subtitle,
    title,
    data,
    emptyText
  } = props;
  let horizontalBars = /*#__PURE__*/external_react_default().createElement("div", {
    className: "horizontal-bar--empty-text"
  }, emptyText ?? DEFAULT_EMPTY_TEXT);
  if (data?.length) {
    horizontalBars = data.filter(row => row.percent > 0).map((row, index) => {
      const style = {
        width: row.percent + '%',
        background: row.backgroundColor
      };
      const overlay = /*#__PURE__*/external_react_default().createElement(Popover, {
        id: "grid-cell-popover",
        placement: "top"
      }, row.title);
      return /*#__PURE__*/external_react_default().createElement(OverlayTrigger, {
        key: index,
        id: index.toString(),
        overlay: overlay,
        style: style
      }, /*#__PURE__*/external_react_default().createElement("div", {
        "data-title": row.title,
        className: external_classnames_default()('horizontal-bar-part', row.className, {
          'horizontal-bar--linked': !!row.href,
          'horizontal-bar--open': !row.filled || !row.backgroundColor
        })
      }, row.href && /*#__PURE__*/external_react_default().createElement("a", {
        href: row.href,
        className: "horizontal-bar--link"
      }, "\xA0")));
    });
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "horizontal-bar-section"
  }, title && /*#__PURE__*/external_react_default().createElement("div", {
    className: "horizontal-bar--title"
  }, title), /*#__PURE__*/external_react_default().createElement("div", {
    className: "horizontal-bars"
  }, horizontalBars), subtitle && /*#__PURE__*/external_react_default().createElement("div", {
    className: "horizontal-bar--subtitle"
  }, subtitle));
});
;// CONCATENATED MODULE: ./src/internal/components/chart/ItemsLegend.tsx
function ItemsLegend_defineProperty(e, r, t) { return (r = ItemsLegend_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ItemsLegend_toPropertyKey(t) { var i = ItemsLegend_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ItemsLegend_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


const CELL_EMPTY_COLOR = 'FFFFFF';
class ItemsLegend extends (external_react_default()).PureComponent {
  render() {
    const {
      legendData,
      emptyColor
    } = this.props;
    const legendsDisplay = [];
    legendData.forEach((legend, index) => {
      let icon;
      if (legend.circleColor && legend.circleColor !== 'none') {
        icon = /*#__PURE__*/external_react_default().createElement("i", {
          className: "color-icon__circle cell-legend-circle",
          style: {
            backgroundColor: legend.circleColor
          }
        });
      } else if (legend.locked) {
        icon = /*#__PURE__*/external_react_default().createElement("span", {
          className: "cell-lock"
        }, /*#__PURE__*/external_react_default().createElement("span", {
          className: "fa fa-lock"
        }));
      }
      const key = 'cell-legend-' + index;
      const hasBackground = legend.backgroundColor !== 'none';
      const style = {
        backgroundColor: hasBackground ? legend.backgroundColor : emptyColor
      };
      if (legend.borderColor) {
        style['border'] = '3px solid ' + legend.borderColor;
      }
      const legendDisplay = /*#__PURE__*/external_react_default().createElement("tr", {
        key: key,
        className: "cell-legend-row"
      }, /*#__PURE__*/external_react_default().createElement("td", null, /*#__PURE__*/external_react_default().createElement("span", {
        className: external_classnames_default()('cell-legend-icon', {
          'cell-legend-icon-spacing': legend.locked,
          'cell-legend-icon-border': hasBackground,
          'expired-form-field': legend.expired
        }),
        style: style
      }, icon)), /*#__PURE__*/external_react_default().createElement("td", null, /*#__PURE__*/external_react_default().createElement("span", {
        className: "cell-legend-label"
      }, legend.legendLabel)));
      legendsDisplay.push(legendDisplay);
    });
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "box-viewer-legend"
    }, /*#__PURE__*/external_react_default().createElement("table", null, /*#__PURE__*/external_react_default().createElement("tbody", null, legendsDisplay)));
  }
}
ItemsLegend_defineProperty(ItemsLegend, "defaultProps", {
  title: 'Container legend',
  emptyColor: CELL_EMPTY_COLOR,
  asModal: true
});
;// CONCATENATED MODULE: ./src/internal/components/chart/configs.ts




const CHART_SELECTORS = {
  All: {
    name: 'TotalCount',
    label: 'All'
  },
  Month: {
    name: 'Last30DaysCount',
    label: 'In the Last Month',
    filter: -29
  },
  Today: {
    name: 'TodayCount',
    label: 'Today',
    filter: 0
  },
  Week: {
    name: 'Last7DaysCount',
    label: 'In the Last Week',
    filter: -6
  },
  Year: {
    name: 'Last365DaysCount',
    label: 'In the Last Year',
    filter: -364
  }
};
const getExclusionFilter = dataTypes => {
  return projectExclusions => {
    const exclusions = dataTypes.reduce((acc, dataType) => {
      const dataTypeExclusions = projectExclusions?.[dataType];
      if (dataTypeExclusions?.length > 0) {
        acc.push(...dataTypeExclusions);
      }
      return acc;
    }, []);
    if (exclusions?.length > 0) return api_.Filter.create('RowId', exclusions, api_.Filter.Types.NOT_IN);
    return null;
  };
};
const CHART_GROUPS = {
  Assays: {
    charts: [CHART_SELECTORS.All, CHART_SELECTORS.Year, CHART_SELECTORS.Month, CHART_SELECTORS.Week, CHART_SELECTORS.Today],
    // TODO: Use redirect AppURL.create('assays', row.id, 'runs')
    getAppURL: row => AppURL.create(ASSAYS_KEY, 'general', row.x || row['label'], 'runs'),
    filterDataRegionName: 'Runs',
    itemCountSQ: SCHEMAS.ASSAY_TABLES.ASSAY_LIST,
    key: ASSAYS_KEY,
    label: 'Assay Run Count by Assay',
    queryName: 'AssayRunCounts',
    schemaName: SCHEMAS.EXP_TABLES.SCHEMA,
    getProjectExclusionFilter: getExclusionFilter(['AssayDesign'])
  },
  Samples: {
    charts: [CHART_SELECTORS.All, CHART_SELECTORS.Year, CHART_SELECTORS.Month, CHART_SELECTORS.Week, CHART_SELECTORS.Today],
    colorPath: ['Color', 'value'],
    showSampleButtons: true,
    getAppURL: row => AppURL.create(SAMPLES_KEY, row.x || row['label']),
    itemCountSQ: SCHEMAS.EXP_TABLES.SAMPLE_SETS,
    key: SAMPLES_KEY,
    label: 'Sample Count by Sample Type',
    queryName: 'SampleSetCounts',
    schemaName: SCHEMAS.EXP_TABLES.SCHEMA,
    getProjectExclusionFilter: getExclusionFilter(['SampleType', 'DashboardSampleType'])
  },
  SampleStatuses: {
    charts: [{
      name: 'TotalCount',
      label: 'All Statuses'
    }, {
      name: 'WithStatusCount',
      label: 'With a Status'
    }, {
      name: 'NoStatusCount',
      label: 'No Status'
    }],
    colorPath: ['Color', 'value'],
    groupPath: ['Status', 'value'],
    showSampleButtons: true,
    getAppURL: (row, evt) => {
      let url = AppURL.create(SAMPLES_KEY, row.xSub || row['subLabel']);
      if (evt.target.tagName === 'rect') {
        const val = row.x || row['label'];
        if (val !== 'No Status') {
          url = url.addFilters(api_.Filter.create('SampleState/Label', val));
        } else {
          url = url.addFilters(api_.Filter.create('SampleState/Label', null, api_.Filter.Types.ISBLANK));
        }
      }
      return url;
    },
    itemCountSQ: SCHEMAS.EXP_TABLES.SAMPLE_SETS,
    key: SAMPLES_KEY,
    label: 'Sample Count by Status',
    queryName: SCHEMAS.SAMPLE_MANAGEMENT.SAMPLE_STATUS_COUNTS.queryName,
    schemaName: SCHEMAS.SAMPLE_MANAGEMENT.SAMPLE_STATUS_COUNTS.schemaName,
    getProjectExclusionFilter: getExclusionFilter(['SampleType', 'DashboardSampleType'])
  }
};
;// CONCATENATED MODULE: ./src/internal/components/auditlog/constants.ts

const ATTACHMENT_AUDIT_QUERY = {
  label: 'Attachment Events',
  value: 'attachmentauditevent'
};
const DOMAIN_AUDIT_QUERY = {
  label: 'Domain Events',
  value: 'domainauditevent'
};
const DOMAIN_PROPERTY_AUDIT_QUERY = {
  label: 'Domain Property Events',
  value: 'domainpropertyauditevent'
};
const QUERY_UPDATE_AUDIT_QUERY = {
  hasDetail: true,
  label: 'Query Update Events',
  value: 'queryupdateauditevent'
};
const DATACLASS_DATA_UPDATE_AUDIT_QUERY = {
  hasDetail: true,
  label: 'Data Update Events',
  value: 'dataclassdataauditevent'
};
const INVENTORY_AUDIT_QUERY = {
  hasDetail: true,
  label: 'Storage Management Events',
  value: 'inventoryauditevent'
};
const LIST_AUDIT_QUERY = {
  label: 'List Events',
  value: 'listauditevent'
};
const GROUP_AUDIT_QUERY = {
  containerFilter: api_.Query.ContainerFilter.allFolders,
  label: 'Roles and Assignment Events',
  value: 'groupauditevent'
};
const PROJECT_AUDIT_QUERY = {
  containerFilter: api_.Query.ContainerFilter.allFolders,
  label: 'Project Events',
  value: 'containerauditevent'
};
const SAMPLE_TYPE_AUDIT_QUERY = {
  label: 'Sample Type Events',
  value: 'samplesetauditevent'
};
const SAMPLE_TIMELINE_AUDIT_QUERY = {
  hasDetail: true,
  label: 'Sample Timeline Events',
  value: 'sampletimelineevent'
};
const USER_AUDIT_QUERY = {
  containerFilter: api_.Query.ContainerFilter.allFolders,
  label: 'User Events',
  value: 'userauditevent'
};
const ASSAY_AUDIT_QUERY = {
  value: 'assayauditevent',
  label: 'Assay Events'
};
const WORKFLOW_AUDIT_QUERY = {
  hasDetail: true,
  label: 'Sample Workflow Events',
  value: 'samplesworkflowauditevent'
};
const SOURCE_AUDIT_QUERY = {
  hasDetail: true,
  label: 'Sources Events',
  value: 'sourcesauditevent'
};
const NOTEBOOK_AUDIT_QUERY = {
  label: 'Notebook Events',
  value: 'LabBookEvent'
};
const NOTEBOOK_REVIEW_AUDIT_QUERY = {
  label: 'Notebook Review Events',
  value: 'NotebookEvent'
};
const REGISTRY_AUDIT_QUERY = {
  label: 'Registry Events',
  value: 'RegistryEvent'
};
const AUDIT_EVENT_TYPE_PARAM = 'eventType';
const COMMON_AUDIT_QUERIES = [ATTACHMENT_AUDIT_QUERY, DOMAIN_AUDIT_QUERY, DOMAIN_PROPERTY_AUDIT_QUERY, QUERY_UPDATE_AUDIT_QUERY, INVENTORY_AUDIT_QUERY, LIST_AUDIT_QUERY, GROUP_AUDIT_QUERY, SAMPLE_TYPE_AUDIT_QUERY, SAMPLE_TIMELINE_AUDIT_QUERY, USER_AUDIT_QUERY];
const EXPERIMENT_AUDIT_EVENT = 'experimentauditevent';
;// CONCATENATED MODULE: ./src/internal/components/auditlog/utils.ts
/*
 * Copyright (c) 2016-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */







function getAuditQueries(ctx) {
  const queries = [...COMMON_AUDIT_QUERIES];
  if (isProductProjectsEnabled(ctx)) queries.push(PROJECT_AUDIT_QUERY);
  if (isWorkflowEnabled(ctx)) queries.push(WORKFLOW_AUDIT_QUERY);
  if (isAssayEnabled(ctx)) queries.push(ASSAY_AUDIT_QUERY);
  if (isSampleManagerEnabled(ctx) && sampleManagerIsPrimaryApp(ctx)) queries.push(SOURCE_AUDIT_QUERY);
  if (isBiologicsEnabled(ctx) && biologicsIsPrimaryApp(ctx)) {
    queries.push(DATACLASS_DATA_UPDATE_AUDIT_QUERY);
    queries.push(REGISTRY_AUDIT_QUERY);
  }
  if (isELNEnabled(ctx)) {
    queries.push(NOTEBOOK_AUDIT_QUERY);
    queries.push(NOTEBOOK_REVIEW_AUDIT_QUERY);
  }
  return queries.sort(naturalSortByProperty('label'));
}
function getEventDataValueDisplay(d, showLink = true) {
  let display = null;
  if (d) {
    if (typeof d === 'string' || typeof d === 'number') {
      display = d;
    } else if (typeof d === 'boolean') {
      display = d ? 'true' : 'false';
    } else if (external_immutable_.Map.isMap(d)) {
      if (d.has('formattedValue')) {
        display = d.get('formattedValue');
      } else {
        const o = d.has('displayValue') ? d.get('displayValue') : d.get('value');
        display = o?.toString() ?? null;
      }
      if (showLink) {
        if (!d.get('hideLink')) {
          if (d.get('url')) {
            display = external_react_default().createElement('a', {
              href: d.get('url')
            }, display);
          } else {
            const url = getTimelineEntityUrl(d.toJS());
            if (url) {
              display = external_react_default().createElement('a', {
                href: url.toHref()
              }, display);
            }
          }
        }
      }
    } else {
      if (d.formattedValue) {
        display = d.formattedValue;
      } else {
        display = (d.displayValue ?? d.value)?.toString() ?? null;
      }
      if (showLink && !d.hideLink) {
        const href = d.url ?? getTimelineEntityUrl(d)?.toHref();
        if (href) {
          display = external_react_default().createElement('a', {
            href
          }, display);
        }
      }
    }
  }
  return display;
}
function getTimelineEntityUrl(d) {
  let url;
  if (d) {
    const {
      urlType,
      value
    } = d;
    switch (urlType) {
      case SAMPLES_KEY:
        url = AppURL.create('rd', SAMPLES_KEY, value);
        break;
      case WORKFLOW_KEY:
        url = AppURL.create(WORKFLOW_KEY, value);
        break;
      case ASSAYS_KEY:
        url = AppURL.create(ASSAYS_KEY, 'general', value);
        break;
      case 'workflowTemplate':
        url = AppURL.create(WORKFLOW_KEY, 'template', value);
        break;
      case USER_KEY:
        url = undefined; // handle display render via UserLink
        break;
      case 'assayRun':
        if (Array.isArray(value) && value.length > 1) {
          url = AppURL.create(ASSAYS_KEY, 'general', value[0], 'runs', value[1]);
        }
        break;
      case 'inventoryLocation':
        if (Array.isArray(value) && value.length > 1) {
          url = AppURL.create('rd', 'freezerLocation', value[1]);
        }
        break;
      case 'inventoryBox':
        url = AppURL.create(BOXES_KEY, value);
        break;
      default:
        break;
    }
  }
  return url;
}
;// CONCATENATED MODULE: ./src/internal/components/auditlog/AuditDetails.tsx
function AuditDetails_defineProperty(e, r, t) { return (r = AuditDetails_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function AuditDetails_toPropertyKey(t) { var i = AuditDetails_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function AuditDetails_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2016-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */







class AuditDetails extends external_react_.Component {
  constructor(...args) {
    super(...args);
    AuditDetails_defineProperty(this, "getValueDisplay", (field, value) => {
      const {
        fieldValueRenderer
      } = this.props;
      let displayVal = value;
      if (value == null || value === '') displayVal = 'NA';
      if (AuditDetails.isUserFieldLabel(field) && value !== undefined) {
        displayVal = /*#__PURE__*/external_react_default().createElement(UserLink, {
          userId: parseInt(value, 10)
        });
      }
      if (fieldValueRenderer) displayVal = fieldValueRenderer(field, value, displayVal);
      return displayVal;
    });
    AuditDetails_defineProperty(this, "getGridColumns", () => {
      const {
        user,
        gridColumnRenderer
      } = this.props;
      return (0,external_immutable_.List)([new GridColumn({
        index: 'field',
        title: 'Field',
        showHeader: false
      }), new GridColumn({
        index: 'value',
        title: 'Value',
        showHeader: false,
        cell: (data, row) => {
          let display;
          if (row.get('isUser')) {
            display = /*#__PURE__*/external_react_default().createElement(UserLink, {
              userId: row.get('value')
            });
          } else if (external_immutable_.Map.isMap(data) && data.get('urlType') === 'user') {
            display = /*#__PURE__*/external_react_default().createElement(UserLink, {
              userId: data.get('value'),
              userDisplayValue: data.get('displayValue')
            });
          } else {
            display = getEventDataValueDisplay(data, user.isAdmin);
          }
          if (gridColumnRenderer) display = gridColumnRenderer(data, row, display);
          return display;
        }
      })]);
    });
  }
  static isUserFieldLabel(field) {
    return ['created by', 'createdby', 'modified by', 'modifiedby'].indexOf(field.toLowerCase()) > -1;
  }
  renderRow(field, oldVal, newVal, isUpdate, isInsert) {
    const {
      user
    } = this.props;
    if (!user.isSignedIn && AuditDetails.isUserFieldLabel(field)) return null;
    const oldValue = this.getValueDisplay(field, oldVal);
    const newValue = this.getValueDisplay(field, newVal);
    const changed = oldValue !== newValue;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom",
      key: field
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "left-spacing right-spacing"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "audit-detail-row-label right-spacing"
    }, capitalizeFirstChar(field))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "left-spacing right-spacing"
    }, isInsert && /*#__PURE__*/external_react_default().createElement("span", {
      className: "new-audit-value"
    }, newValue), isUpdate && changed && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("span", {
      className: "display-light old-audit-value right-spacing"
    }, oldValue), /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-long-arrow-right right-spacing"
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: "new-audit-value"
    }, newValue)), isUpdate && !changed && /*#__PURE__*/external_react_default().createElement("span", {
      className: "display-light old-audit-value right-spacing"
    }, oldValue), !isInsert && !isUpdate && /*#__PURE__*/external_react_default().createElement("span", {
      className: "display-light old-audit-value"
    }, oldValue)));
  }
  renderChanges() {
    const {
      changeDetails
    } = this.props;
    const isUpdate = changeDetails.isUpdate();
    const isInsert = changeDetails.isInsert();
    const usedFields = [];
    let oldFields, newFields;
    if (changeDetails.oldData) {
      oldFields = changeDetails.oldData.entrySeq().map(([field, value]) => {
        let newValue;
        if (changeDetails.newData) {
          newValue = changeDetails.newData.get(field);
          usedFields.push(field);
        }
        return this.renderRow(field, value, newValue, isUpdate, isInsert);
      });
    }
    if (changeDetails.newData) {
      newFields = changeDetails.newData.entrySeq().map(([field, value]) => {
        if (usedFields.indexOf(field) >= 0) return null;
        return this.renderRow(field, undefined, value, isUpdate, isInsert);
      });
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, oldFields, newFields);
  }
  render() {
    const {
      changeDetails,
      children,
      emptyMsg,
      gridData,
      rowId,
      summary,
      title
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel panel-default"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-heading"
    }, title), /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-body"
    }, children, !rowId && /*#__PURE__*/external_react_default().createElement("div", null, emptyMsg), !!rowId && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, summary && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom display-light"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, summary)), gridData && /*#__PURE__*/external_react_default().createElement(Grid, {
      data: gridData,
      columns: this.getGridColumns(),
      showHeader: false
    }), changeDetails && this.renderChanges())));
  }
}
AuditDetails_defineProperty(AuditDetails, "defaultProps", {
  title: 'Audit Event Details',
  emptyMsg: 'No audit event selected.'
});
;// CONCATENATED MODULE: ./src/internal/components/auditlog/TimelineView.tsx
function TimelineView_defineProperty(e, r, t) { return (r = TimelineView_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function TimelineView_toPropertyKey(t) { var i = TimelineView_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function TimelineView_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






class TimelineView extends (external_react_default()).Component {
  constructor(...args) {
    super(...args);
    TimelineView_defineProperty(this, "selectEvent", selectedEvent => {
      const {
        onEventSelection,
        selectionDisabled
      } = this.props;
      if (onEventSelection && !selectionDisabled) this.props.onEventSelection(selectedEvent);
    });
  }
  renderRow(event) {
    const {
      selectedEvent,
      selectedEntityConnectionInfo
    } = this.props;
    let eventSelected = false;
    let isFirstEvent = false;
    let isLastEvent = false;
    let isEventCompleted = false;
    let isConnection = false;
    if (selectedEvent && selectedEvent.getRowKey() === event.getRowKey()) {
      eventSelected = true;
    }
    if (selectedEntityConnectionInfo && selectedEntityConnectionInfo.length > 0) {
      selectedEntityConnectionInfo.forEach(info => {
        const inRange = info.firstEvent && info.lastEvent && event.eventTimestamp >= info.firstEvent.eventTimestamp && event.eventTimestamp <= info.lastEvent.eventTimestamp;
        if (inRange) {
          isEventCompleted = info.isCompleted;
          isConnection = true;
          if (info.firstEvent && event.getRowKey() === info.firstEvent.getRowKey()) {
            isFirstEvent = true;
          } else if (info.lastEvent && event.getRowKey() === info.lastEvent.getRowKey()) {
            isLastEvent = true;
          }
        } else if (info.firstEvent && event.getRowKey() === info.firstEvent.getRowKey()) isFirstEvent = true;
      });
    }
    return /*#__PURE__*/external_react_default().createElement("tr", {
      key: event.getRowKey(),
      onClick: () => {
        if (event.rowId) this.selectEvent(event);
      },
      className: external_classnames_default()({
        'timeline-event-row': event.rowId !== 0,
        'timeline-row-selected': eventSelected
      })
    }, this.renderTimestampCol(event.timestamp), this.renderIconCol(event.getIcon(), eventSelected, isFirstEvent, isLastEvent, isEventCompleted, isConnection), this.renderDetailCol(event));
  }
  renderTimestampCol(timestamp) {
    return /*#__PURE__*/external_react_default().createElement("td", {
      key: "tl-timestamp-col",
      className: "display-light timeline-timestamp-col"
    }, getEventDataValueDisplay(timestamp));
  }
  renderIconCol(iconSrc, isSelected, isFirstEvent, isLastEvent, isClosedEvent, isConnection) {
    const {
      showRecentFirst
    } = this.props;
    const icon = /*#__PURE__*/external_react_default().createElement(SVGIcon, {
      iconSrc: isSelected ? iconSrc + '_orange' : iconSrc,
      className: "timeline-event-icon",
      alt: iconSrc ? iconSrc : ''
    });
    const isStart = showRecentFirst ? !isFirstEvent : isFirstEvent;
    const isEnd = showRecentFirst ? !isLastEvent : isLastEvent;
    const circle = /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
      className: external_classnames_default()('timeline-circle', {
        'timeline-circle-open': !isClosedEvent
      })
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: "timeline-hline hline-short"
    }));
    const shortVLineStart = /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('timeline-vline vline-short', {
        'line-highlight': isConnection && !isStart
      })
    });
    const shortVLineEnd = /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('timeline-vline vline-short', {
        'line-highlight': isConnection && !isEnd
      })
    });
    const longVLine = /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
      className: external_classnames_default()('timeline-vline vline-long', {
        'line-highlight': isConnection
      })
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: "timeline-hline hline-long"
    }));
    let line;
    if (isFirstEvent || isLastEvent) {
      line = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, shortVLineStart, circle, shortVLineEnd);
    } else {
      line = longVLine;
    }
    return /*#__PURE__*/external_react_default().createElement("td", {
      key: "tl-icon-col",
      className: "icon-col"
    }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "timeline-line"
    }, line), icon));
  }
  renderComment(comment) {
    if (!comment) return null;
    return /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      iconComponent: /*#__PURE__*/external_react_default().createElement("i", {
        className: "timeline-comments-icon fa fa-comments"
      }),
      placement: "bottom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "ws-pre-wrap"
    }, comment));
  }
  renderInfoBubble(event) {
    const {
      getInfoBubbleContent
    } = this.props;
    if (getInfoBubbleContent) {
      const info = getInfoBubbleContent(event);
      if (info != null) {
        return /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
          iconComponent: /*#__PURE__*/external_react_default().createElement("i", {
            className: "timeline-info-icon fa fa-info-circle"
          }),
          placement: "bottom",
          title: info.title
        }, /*#__PURE__*/external_react_default().createElement("div", {
          className: "ws-pre-wrap"
        }, info.content));
      }
    }
    return null;
  }
  renderDetailCol(event) {
    const {
      summary,
      user,
      entity,
      entitySeparator
    } = event;
    const comment = event.getComment();
    return /*#__PURE__*/external_react_default().createElement("td", {
      key: "tl-detail-col",
      className: "detail-col"
    }, /*#__PURE__*/external_react_default().createElement("div", null, getEventDataValueDisplay(summary), entity != null && /*#__PURE__*/external_react_default().createElement("span", null, entitySeparator ? entitySeparator : ' - '), entity != null && getEventDataValueDisplay(entity)), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "field-text-nowrap"
    }, /*#__PURE__*/external_react_default().createElement(UserLink, {
      userId: user?.get('value'),
      userDisplayValue: user?.get('displayValue'),
      unknown: !user
    })), ' ', this.renderComment(comment), this.renderInfoBubble(event)));
  }
  render() {
    const {
      events,
      selectionDisabled
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("table", {
      className: external_classnames_default()('timeline-grid', {
        'timeline-grid-no-selection': selectionDisabled
      })
    }, /*#__PURE__*/external_react_default().createElement("tbody", null, events.map(event => {
      if (event.rowId > 0) return this.renderRow(event);
    })));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/Lookup/Context.tsx




const LookupContext = external_react_default().createContext(undefined);
const LookupContextProvider = LookupContext.Provider;
const LookupContextConsumer = LookupContext.Consumer;

// default provider
class LookupProvider extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    this.state = {
      activeContainer: new Container(api_.Security.currentContainer),
      fetchContainers: fetchContainers,
      fetchQueries: fetchQueries,
      fetchSchemas: fetchSchemas,
      getExcludedSchemaQueryNames: getExcludedSchemaQueryNames
    };
  }
  render() {
    return /*#__PURE__*/external_react_default().createElement(LookupContextProvider, {
      value: this.state
    }, this.props.children);
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/SectionHeading.tsx


const SectionHeading = (0,external_react_.memo)(props => /*#__PURE__*/external_react_default().createElement("div", {
  className: 'domain-field-section-heading' + (props.cls ? ' ' + props.cls : '')
}, props.title, props.helpTipBody && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
  title: props.title
}, props.helpTipBody)));
SectionHeading.displayName = 'SectionHeading';
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologyBrowserModal.tsx




const OntologyBrowserModal = (0,external_react_.memo)(props => {
  const {
    title,
    initOntologyId,
    onCancel,
    onApply,
    initConcept,
    initPath
  } = props;
  const [selectedPath, setSelectedPath] = (0,external_react_.useState)();
  const [selectedConcept, setSelectedConcept] = (0,external_react_.useState)();
  const onConfirm = (0,external_react_.useCallback)(() => {
    onApply(selectedPath, selectedConcept);
  }, [onApply, selectedPath, selectedConcept]);
  const onPathSelect = (0,external_react_.useCallback)((path, concept) => {
    setSelectedPath(path);
    setSelectedConcept(concept);
  }, [setSelectedConcept, setSelectedPath]);
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    bsSize: "lg",
    canConfirm: selectedConcept !== undefined,
    confirmClass: `btn-${getSubmitButtonClass()}`,
    confirmText: "Apply",
    onCancel: onCancel,
    onConfirm: onConfirm,
    title: title
  }, /*#__PURE__*/external_react_default().createElement(OntologyBrowserPanel, {
    asPanel: false,
    initOntologyId: initOntologyId,
    initConcept: initConcept,
    initPath: initPath,
    onPathSelect: onPathSelect
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologyConceptSelectButton.tsx








const OntologyConceptSelectButton = (0,external_react_.memo)(props => {
  const {
    id,
    field,
    title,
    onChange,
    error,
    useFieldSourceOntology,
    valueProp,
    valueIsPath
  } = props;
  const isFieldLocked = (0,external_react_.useMemo)(() => isFieldFullyLocked(field.lockType), [field.lockType]);
  const [showSelectModal, setShowSelectModal] = (0,external_react_.useState)();
  const [concept, setConcept] = (0,external_react_.useState)();
  const [path, setPath] = (0,external_react_.useState)();
  const fieldValue = (0,external_react_.useMemo)(() => field[valueProp], [field]);
  (0,external_react_.useEffect)(() => {
    if (valueIsPath) {
      if (fieldValue) {
        fetchPathModel(fieldValue).then(setPath).catch(err => {
          console.error('Failed to fetch path model', err);
        });
      } else {
        setPath(undefined);
      }
    }
  }, [fieldValue]);
  (0,external_react_.useEffect)(() => {
    if (!valueIsPath && fieldValue) {
      fetchConceptForCode(fieldValue).then(setConcept).catch(err => {
        console.error('Failed to fetch concept for code', err);
      });
    } else if (path?.code) {
      fetchConceptForCode(path.code).then(setConcept).catch(err => {
        console.error('Failed to fetch concept for code', err);
      });
    } else {
      setConcept(undefined);
    }
  }, [fieldValue, path]);
  const toggleSelectModal = (0,external_react_.useCallback)(() => {
    setShowSelectModal(s => !s);
  }, []);
  const onApply = (0,external_react_.useCallback)((selectedPath, selectedConcept) => {
    onChange(id, selectedPath, selectedConcept);
    setShowSelectModal(false);
  }, [onChange, id]);
  const onRemove = (0,external_react_.useCallback)(() => {
    onApply(undefined, undefined);
  }, [onApply]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("table", {
    className: "domain-annotation-table"
  }, /*#__PURE__*/external_react_default().createElement("tbody", null, /*#__PURE__*/external_react_default().createElement("tr", null, /*#__PURE__*/external_react_default().createElement("td", null, /*#__PURE__*/external_react_default().createElement("button", {
    className: "domain-validation-button btn btn-default",
    disabled: isFieldLocked,
    id: id,
    name: createFormInputName(DOMAIN_FIELD_ONTOLOGY_PRINCIPAL_CONCEPT),
    onClick: toggleSelectModal,
    type: "button"
  }, title)), !fieldValue && /*#__PURE__*/external_react_default().createElement("td", {
    className: "content"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "domain-text-label"
  }, "None Set")), fieldValue && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !isFieldLocked && /*#__PURE__*/external_react_default().createElement("td", {
    className: "content"
  }, /*#__PURE__*/external_react_default().createElement("a", {
    className: "domain-validator-link",
    onClick: onRemove
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-remove"
  }))), /*#__PURE__*/external_react_default().createElement("td", {
    className: "content"
  }, /*#__PURE__*/external_react_default().createElement("a", {
    className: external_classnames_default()('domain-annotation-item', isFieldLocked ? 'domain-text-label' : 'domain-validator-link'),
    onClick: isFieldLocked ? undefined : toggleSelectModal
  }, concept ? concept.getDisplayLabel() : path?.getDisplayLabel() ?? fieldValue))), /*#__PURE__*/external_react_default().createElement("td", {
    className: "content"
  }, /*#__PURE__*/external_react_default().createElement(ConceptOverviewTooltip, {
    concept: concept,
    path: path,
    error: error
  }))))), showSelectModal && /*#__PURE__*/external_react_default().createElement(OntologyBrowserModal, {
    title: title,
    initOntologyId: concept?.ontology ?? (useFieldSourceOntology ? field.sourceOntology : undefined),
    initConcept: path ? undefined : concept // if we have a path, we want the modal to use that instead of the first path from the concept
    ,
    initPath: path,
    onCancel: toggleSelectModal,
    onApply: onApply
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologyLookupOptions.tsx
function OntologyLookupOptions_defineProperty(e, r, t) { return (r = OntologyLookupOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function OntologyLookupOptions_toPropertyKey(t) { var i = OntologyLookupOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function OntologyLookupOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }












const LEARN_MORE = /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
  topic: sampleManagerIsPrimaryApp() ? ADVANCED_FIELD_EDITOR_TOPIC : ONTOLOGY_LOOKUP_TOPIC
}, "ontology integration"), ' ', "in LabKey.");
class OntologyLookupOptions extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    OntologyLookupOptions_defineProperty(this, "state", {
      loading: true,
      ontologies: []
    });
    OntologyLookupOptions_defineProperty(this, "componentDidMount", async () => {
      const {
        domainContainerPath,
        api
      } = this.props;
      try {
        const newOntologies = await api.fetchOntologies(domainContainerPath);
        this.setState(() => ({
          loading: false,
          ontologies: newOntologies
        }), () => {
          const {
            field
          } = this.props;
          const {
            ontologies
          } = this.state;

          // default to selecting the first ontology in the list, if > 0 exist and one is not already selected
          if (ontologies?.length > 0 && !field.sourceOntology) {
            this.onChange(this.getSourceInputId(), ontologies[0].abbreviation);
          }
        });
      } catch (error) {
        console.error('Failed to retrieve available types for Ontology.', error);
        this.setState(() => ({
          loading: false
        }));
      }
    });
    OntologyLookupOptions_defineProperty(this, "onSelectChange", (id, formValue, selected) => {
      this.onChange(id, selected?.name);
    });
    OntologyLookupOptions_defineProperty(this, "onOntologyFieldChange", evt => {
      const {
        domainIndex,
        onMultiChange
      } = this.props;
      const {
        id,
        value
      } = evt.target;
      let changes = (0,external_immutable_.List)([{
        id,
        value
      }]);
      changes = changes.push({
        id: createFormInputId(DOMAIN_FIELD_ONTOLOGY_SUBTREE_COL, domainIndex, getIndexFromId(id)),
        value: undefined
      });
      onMultiChange(changes);
    });
    OntologyLookupOptions_defineProperty(this, "onOntologySubtreeChange", async (id, path) => {
      let subtreePath;
      if (path?.path) {
        const parents = await fetchParentPaths(path.path);
        subtreePath = getParentsConceptCodePath(parents);
      }
      this.onChange(id, subtreePath);
    });
    OntologyLookupOptions_defineProperty(this, "onFieldChange", evt => {
      const val = evt.target.value;
      let changes = (0,external_immutable_.List)([{
        id: evt.target.id,
        value: val
      }]);
      const valFieldIdx = this.props.domainFields.findIndex(df => df.name === val);
      if (valFieldIdx > 0) {
        const valFieldInsertId = createFormInputId(DOMAIN_FIELD_SHOWNININSERTVIEW, this.props.domainIndex, valFieldIdx);
        const valFieldUpdateId = createFormInputId(DOMAIN_FIELD_SHOWNINUPDATESVIEW, this.props.domainIndex, valFieldIdx);
        changes = changes.push({
          id: valFieldInsertId,
          value: false
        }, {
          id: valFieldUpdateId,
          value: false
        });
      }
      this.props.onMultiChange(changes);
    });
  }
  onChange(id, value) {
    this.props.onChange?.(id, value);
  }
  getSourceInputId() {
    const {
      index,
      domainIndex
    } = this.props;
    return createFormInputId(DOMAIN_FIELD_ONTOLOGY_SOURCE, domainIndex, index);
  }
  render() {
    const {
      index,
      label,
      lockType,
      domainIndex,
      field,
      domainFields
    } = this.props;
    const {
      loading,
      ontologies
    } = this.state;
    const sourceId = this.getSourceInputId();
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: label
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Choose an Ontology", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      title: "Choose an Ontology"
    }, /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Choose which ontology to use to lookup concept codes and preferred names."), /*#__PURE__*/external_react_default().createElement("p", null, "Optionally, you may use the \"Expected Vocabulary\" option to select a concept hierarchy which will be used to guide users to a concept hierarchy subtree of interest during data entry for this field."), LEARN_MORE)))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Choose an Import Field", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      title: "Choose an Import Field"
    }, /*#__PURE__*/external_react_default().createElement("p", null, "Choose which text field to use when looking up a code against the selected ontology."), LEARN_MORE))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Choose a Label Field", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      title: "Choose a Label Field"
    }, /*#__PURE__*/external_react_default().createElement("p", null, "Choose which text field to store the preferred name of the concept."), LEARN_MORE)))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/external_react_default().createElement("select", {
      className: "form-control",
      id: sourceId,
      key: sourceId,
      disabled: isFieldFullyLocked(lockType),
      onChange: this.onOntologyFieldChange,
      value: field.sourceOntology
    }, loading && /*#__PURE__*/external_react_default().createElement("option", {
      disabled: true,
      key: "_loading"
    }, "Loading..."), !loading && ontologies.length === 0 && /*#__PURE__*/external_react_default().createElement("option", {
      key: "_currentValue",
      value: field.sourceOntology
    }, field.sourceOntology), !loading && ontologies.length > 0 && ontologies.map(ontology => {
      return /*#__PURE__*/external_react_default().createElement("option", {
        key: ontology.abbreviation,
        value: ontology.abbreviation
      }, ontology.getDisplayName());
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, /*#__PURE__*/external_react_default().createElement(OntologyConceptSelectButton, {
      id: createFormInputId(DOMAIN_FIELD_ONTOLOGY_SUBTREE_COL, domainIndex, index),
      title: "Expected Vocabulary",
      field: field,
      valueProp: "conceptSubtree",
      valueIsPath: true,
      onChange: this.onOntologySubtreeChange,
      useFieldSourceOntology: true
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement(OntologyTextDomainFieldSelect, {
      field: field,
      domainFields: domainFields,
      lockType: lockType,
      id: createFormInputId(DOMAIN_FIELD_ONTOLOGY_IMPORT_COL, domainIndex, index),
      value: field.conceptImportColumn,
      filterValue: field.conceptLabelColumn,
      onFieldChange: this.onFieldChange
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement(OntologyTextDomainFieldSelect, {
      field: field,
      domainFields: domainFields,
      lockType: lockType,
      id: createFormInputId(DOMAIN_FIELD_ONTOLOGY_LABEL_COL, domainIndex, index),
      value: field.conceptLabelColumn,
      filterValue: field.conceptImportColumn,
      onFieldChange: this.onFieldChange
    }))));
  }
}
OntologyLookupOptions_defineProperty(OntologyLookupOptions, "defaultProps", {
  api: getDefaultAPIWrapper().domain
});
const OntologyTextDomainFieldSelect = (0,external_react_.memo)(props => {
  const {
    domainFields,
    lockType,
    field,
    id,
    value,
    filterValue,
    onFieldChange
  } = props;
  return /*#__PURE__*/external_react_default().createElement("select", {
    className: "form-control",
    id: id,
    key: id,
    disabled: isFieldFullyLocked(lockType),
    onChange: onFieldChange,
    value: value
  }, /*#__PURE__*/external_react_default().createElement("option", {
    value: null
  }), domainFields.map((df, index) => {
    // Need to preserve index so don't filter, but return null for those fields we don't want as options
    // (i.e. don't show self, fields with no name, fields not of type string, or field selected as the other lookup option)
    if (df === field || df.hasInvalidName() || !df.dataType.isString() || df.name === filterValue) {
      return null;
    }
    return /*#__PURE__*/external_react_default().createElement("option", {
      key: index,
      value: df.name
    }, df.name);
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologyConceptAnnotation.tsx
function OntologyConceptAnnotation_extends() { return OntologyConceptAnnotation_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, OntologyConceptAnnotation_extends.apply(null, arguments); }





const OntologyConceptAnnotation = (0,external_react_.memo)(props => {
  const {
    onChange
  } = props;
  const onApply = (0,external_react_.useCallback)((id, path, concept) => {
    onChange(id, concept);
  }, [onChange]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-label"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Ontology Concept",
    helpTipBody: getOntologyConceptAnnotationHelpTipBody()
  })), /*#__PURE__*/external_react_default().createElement(OntologyConceptSelectButton, OntologyConceptAnnotation_extends({}, props, {
    title: "Select Concept",
    valueProp: "principalConceptCode",
    valueIsPath: false,
    onChange: onApply
  })));
});
function getOntologyConceptAnnotationHelpTipBody() {
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Select an ontology concept to use as an annotation for this field."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: sampleManagerIsPrimaryApp() ? ADVANCED_FIELD_EDITOR_TOPIC : ONTOLOGY_LOOKUP_TOPIC
  }, "ontology integration"), ' ', "in LabKey."));
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/NameAndLinkingOptions.tsx
function NameAndLinkingOptions_defineProperty(e, r, t) { return (r = NameAndLinkingOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function NameAndLinkingOptions_toPropertyKey(t) { var i = NameAndLinkingOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function NameAndLinkingOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










class NameAndLinkingOptions extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    NameAndLinkingOptions_defineProperty(this, "handleChange", evt => {
      this.onChange(evt.target.id, evt.target.value);
    });
    NameAndLinkingOptions_defineProperty(this, "onChange", (id, value) => {
      this.props?.onChange(id, value);
    });
    NameAndLinkingOptions_defineProperty(this, "getImportAliasHelpText", () => {
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "Define alternate field names to be used when importing from a file.", /*#__PURE__*/external_react_default().createElement("br", null), /*#__PURE__*/external_react_default().createElement("br", null), "Multiple aliases may be separated by spaces or commas. To define an alias that contains spaces, use double-quotes (\") around it.");
    });
    NameAndLinkingOptions_defineProperty(this, "getURLHelpText", () => {
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "Use this to change the display of the field value within a data grid into a link. Multiple formats are supported, which allows ways to easily substitute and link to other locations in LabKey.", /*#__PURE__*/external_react_default().createElement("br", null), /*#__PURE__*/external_react_default().createElement("br", null), "Learn more about using ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: URL_ENCODING_TOPIC
      }, "URL Formatting Options"), ".");
    });
  }
  render() {
    const {
      index,
      field,
      domainIndex,
      appPropertiesOnly,
      domainFormDisplayOptions
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "Name and Linking Options",
      cls: "domain-field-section-hdr"
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Description"), /*#__PURE__*/external_react_default().createElement("textarea", {
      className: "form-control",
      rows: 4,
      value: field.description || '',
      id: createFormInputId(DOMAIN_FIELD_DESCRIPTION, domainIndex, index),
      name: createFormInputName(DOMAIN_FIELD_DESCRIPTION),
      onChange: this.handleChange,
      disabled: isFieldFullyLocked(field.lockType)
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Label"), /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: "text",
      value: field.label || '',
      id: createFormInputId(DOMAIN_FIELD_LABEL, domainIndex, index),
      name: createFormInputName(DOMAIN_FIELD_LABEL),
      onChange: this.handleChange,
      disabled: isFieldFullyLocked(field.lockType)
    }), !field.isUniqueIdField() && !field.isCalculatedField() && !domainFormDisplayOptions?.hideImportAliases && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Import Aliases",
      helpTipBody: this.getImportAliasHelpText()
    })), /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: "text",
      value: field.importAliases || '',
      id: createFormInputId(DOMAIN_FIELD_IMPORTALIASES, domainIndex, index),
      name: createFormInputName(DOMAIN_FIELD_IMPORTALIASES),
      onChange: this.handleChange,
      disabled: isFieldFullyLocked(field.lockType)
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "URL",
      helpTipBody: this.getURLHelpText()
    })), /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: "text",
      value: field.URL || '',
      id: createFormInputId(DOMAIN_FIELD_URL, domainIndex, index),
      name: createFormInputName(DOMAIN_FIELD_URL),
      onChange: this.handleChange,
      disabled: isFieldFullyLocked(field.lockType)
    }), !appPropertiesOnly && hasModule(ONTOLOGY_MODULE_NAME) && !field.isUniqueIdField() && !field.isCalculatedField() && /*#__PURE__*/external_react_default().createElement(OntologyConceptAnnotation, {
      id: createFormInputId(DOMAIN_FIELD_ONTOLOGY_PRINCIPAL_CONCEPT, domainIndex, index),
      field: field,
      onChange: this.onChange
    }))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/ScannableOption.tsx





const ScannableOption = (0,external_react_.memo)(props => {
  const {
    domainIndex,
    index,
    lockType,
    scannable = false,
    appPropertiesOnly,
    showScannableOption,
    onChange
  } = props;
  if (!appPropertiesOnly || !showScannableOption) return null;
  const handleOptionToggle = (0,external_react_.useCallback)(event => {
    const {
      id,
      checked
    } = event.target;
    onChange?.(id, checked);
  }, [onChange]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-label"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Barcode Field",
    helpTipBody: 'When using the Find Samples dialog from the search bar and choosing the "Barcodes" option, fields that are designated as Barcode fields will be queried along with any UniqueId fields for this sample type.'
  })))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12 domain-text-options-col"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "checkbox",
    id: createFormInputId(DOMAIN_FIELD_SCANNABLE_OPTION, domainIndex, index),
    name: createFormInputName(DOMAIN_FIELD_SCANNABLE_OPTION),
    className: "form-control domain-text-option-scannable",
    onChange: handleOptionToggle,
    disabled: isFieldFullyLocked(lockType),
    checked: scannable
  }), /*#__PURE__*/external_react_default().createElement("span", null, "Search this field when scanning samples"))));
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/TextFieldOptions.tsx
function TextFieldOptions_defineProperty(e, r, t) { return (r = TextFieldOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function TextFieldOptions_toPropertyKey(t) { var i = TextFieldOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function TextFieldOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







class TextFieldOptions extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    TextFieldOptions_defineProperty(this, "handleChange", event => {
      const {
        onChange,
        scale,
        domainIndex,
        index
      } = this.props;
      const target = event.target;

      // Initially set to handle custom character count
      let scaleId = target.id;
      let value = event.target.value;
      const fieldName = getNameFromId(target.id);

      // If handling radio button
      if (fieldName !== DOMAIN_FIELD_SCALE) {
        this.setState({
          radio: value
        }); // set local state
        scaleId = createFormInputId(DOMAIN_FIELD_SCALE, domainIndex, index); // updating scale
        value = value === DOMAIN_FIELD_MAX_LENGTH ? UNLIMITED_TEXT_LENGTH : MAX_TEXT_LENGTH;
      } else {
        value = parseInt(value);
      }
      if (onChange && value !== scale) {
        onChange(scaleId, value);
      }
    });
    TextFieldOptions_defineProperty(this, "getMaxCountHelpText", () => {
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Sets the maximum character count for a text field."), /*#__PURE__*/external_react_default().createElement("p", null, "Anything over 4,000 characters will use the 'Unlimited' designation."));
    });
    this.state = {
      radio: DOMAIN_FIELD_MAX_LENGTH
    };
  }
  componentDidMount() {
    this.setState({
      radio: !this.props.scale || this.props.scale > MAX_TEXT_LENGTH ? DOMAIN_FIELD_MAX_LENGTH : DOMAIN_FIELD_CUSTOM_LENGTH
    });
  }
  render() {
    const {
      index,
      label,
      scale,
      lockType,
      domainIndex
    } = this.props;
    const {
      radio
    } = this.state;
    const textOptionsFormControl = /*#__PURE__*/external_react_default().createElement("input", {
      type: "number",
      id: createFormInputId(DOMAIN_FIELD_SCALE, domainIndex, index),
      name: createFormInputName(DOMAIN_FIELD_SCALE),
      className: "form-control domain-text-length-field",
      value: typeof scale !== 'undefined' && radio === DOMAIN_FIELD_CUSTOM_LENGTH ? scale : MAX_TEXT_LENGTH,
      onChange: this.handleChange,
      disabled: isFieldFullyLocked(lockType) || radio === DOMAIN_FIELD_MAX_LENGTH
    });
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: label
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Maximum Text Length",
      helpTipBody: this.getMaxCountHelpText()
    })))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12 domain-text-options-col"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      type: "radio",
      className: "form-control domain-text-options-radio1 domain-field-float-left",
      value: DOMAIN_FIELD_MAX_LENGTH,
      checked: radio === DOMAIN_FIELD_MAX_LENGTH,
      onChange: this.handleChange,
      id: createFormInputId(DOMAIN_FIELD_MAX_LENGTH, domainIndex, index),
      disabled: isFieldFullyLocked(lockType)
    }), /*#__PURE__*/external_react_default().createElement("div", null, "Unlimited"))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      type: "radio",
      className: "form-control domain-text-options-radio2 domain-field-float-left",
      value: DOMAIN_FIELD_CUSTOM_LENGTH,
      checked: radio === DOMAIN_FIELD_CUSTOM_LENGTH,
      onChange: this.handleChange,
      id: createFormInputId(DOMAIN_FIELD_CUSTOM_LENGTH, domainIndex, index)
    }), /*#__PURE__*/external_react_default().createElement("span", {
      className: "domain-text-options-length domain-field-float-left"
    }, "No longer than ", textOptionsFormControl, " characters"))), /*#__PURE__*/external_react_default().createElement(ScannableOption, this.props));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/BooleanFieldOptions.tsx
function BooleanFieldOptions_defineProperty(e, r, t) { return (r = BooleanFieldOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function BooleanFieldOptions_toPropertyKey(t) { var i = BooleanFieldOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function BooleanFieldOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






class BooleanFieldOptions extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    BooleanFieldOptions_defineProperty(this, "onFieldChange", evt => {
      this.props.onChange?.(evt.target.id, evt.target.value);
    });
    BooleanFieldOptions_defineProperty(this, "getFormatHelpText", () => {
      return /*#__PURE__*/external_react_default().createElement("div", null, "Use boolean formatting to specify the text to show when a value is true and false. Text can optionally be shown for null values.", /*#__PURE__*/external_react_default().createElement("br", null), /*#__PURE__*/external_react_default().createElement("br", null), "For example, \"Yes;No;Blank\" would output \"Yes\" if the value is true, \"No\" if false, and \"Blank\" for a null value.");
    });
  }
  render() {
    const {
      index,
      label,
      format,
      lockType,
      domainIndex
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: label
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Format for Boolean Values",
      helpTipBody: this.getFormatHelpText()
    })))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: "text",
      value: format || '',
      onChange: this.onFieldChange,
      id: createFormInputId(DOMAIN_FIELD_FORMAT, domainIndex, index),
      disabled: isFieldFullyLocked(lockType),
      name: createFormInputName(DOMAIN_FIELD_SCALE)
    }))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/NumericFieldOptions.tsx
function NumericFieldOptions_defineProperty(e, r, t) { return (r = NumericFieldOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function NumericFieldOptions_toPropertyKey(t) { var i = NumericFieldOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function NumericFieldOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








class NumericFieldOptions extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    NumericFieldOptions_defineProperty(this, "onFieldChange", evt => {
      const {
        onChange
      } = this.props;
      const value = evt.target.value;
      if (onChange) {
        onChange(evt.target.id, value);
      }
    });
    NumericFieldOptions_defineProperty(this, "getFormatHelpText", () => {
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "To control how a number value is displayed, provide a string format compatible with the Java", ' ', /*#__PURE__*/external_react_default().createElement(JavaDocsLink, {
        urlSuffix: "java/text/DecimalFormat.html"
      }, "DecimalFormat"), " class."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: NUMBER_FORMATS_TOPIC
      }, "Number formats"), " in LabKey."));
    });
  }
  render() {
    const {
      index,
      label,
      format,
      defaultScale,
      lockType,
      domainIndex
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: label
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Format for Numbers",
      helpTipBody: this.getFormatHelpText()
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Default Scale Type"))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: "text",
      value: format || '',
      onChange: this.onFieldChange,
      id: createFormInputId(DOMAIN_FIELD_FORMAT, domainIndex, index),
      name: createFormInputName(DOMAIN_FIELD_FORMAT),
      disabled: isFieldFullyLocked(lockType)
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement("select", {
      className: "form-control",
      id: createFormInputId(DOMAIN_FIELD_DEFAULT_SCALE, domainIndex, index),
      disabled: isFieldFullyLocked(lockType),
      name: createFormInputName(DOMAIN_FIELD_DEFAULT_SCALE),
      onChange: this.onFieldChange,
      value: defaultScale
    }, /*#__PURE__*/external_react_default().createElement("option", {
      key: createFormInputId(DOMAIN_FIELD_DEFAULT_SCALE + 'option-' + DEFAULT_SCALE_LINEAR, domainIndex, index),
      value: DEFAULT_SCALE_LINEAR
    }, "Linear"), /*#__PURE__*/external_react_default().createElement("option", {
      key: createFormInputId(DOMAIN_FIELD_DEFAULT_SCALE + 'option-' + DEFAULT_SCALE_LOG, domainIndex, index),
      value: DEFAULT_SCALE_LOG
    }, "Log")))), /*#__PURE__*/external_react_default().createElement(ScannableOption, this.props));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DateTimeFieldOptions.tsx
function DateTimeFieldOptions_defineProperty(e, r, t) { return (r = DateTimeFieldOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DateTimeFieldOptions_toPropertyKey(t) { var i = DateTimeFieldOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DateTimeFieldOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







class DateTimeFieldOptions extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    DateTimeFieldOptions_defineProperty(this, "onFieldChange", evt => {
      const {
        onChange
      } = this.props;
      let value = evt.target.value;
      if (getNameFromId(evt.target.id) === DOMAIN_FIELD_EXCLUDE_FROM_SHIFTING) {
        value = evt.target.checked;
      }
      if (onChange) {
        onChange(evt.target.id, value);
      }
    });
    DateTimeFieldOptions_defineProperty(this, "getFormatHelpText", () => {
      const {
        type
      } = this.props;
      const noun = type === 'dateTime' ? 'date or time' : type;
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "To control how a ", noun, " value is displayed, provide a string format compatible with the Java", ' ', /*#__PURE__*/external_react_default().createElement(JavaDocsLink, {
        urlSuffix: "java/text/SimpleDateFormat.html"
      }, "SimpleDateFormat"), " class."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: DATE_FORMATS_TOPIC
      }, "Date and Time formats"), " in LabKey."));
    });
  }
  render() {
    const {
      index,
      label,
      format,
      lockType,
      domainIndex,
      type
    } = this.props;
    const noun = type === 'time' ? 'Times' : 'Dates';
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: label
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: 'Format for ' + noun,
      helpTipBody: this.getFormatHelpText()
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9"
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: "text",
      value: format || '',
      onChange: this.onFieldChange,
      disabled: isFieldFullyLocked(lockType),
      id: createFormInputId(DOMAIN_FIELD_FORMAT, domainIndex, index),
      name: createFormInputName(DOMAIN_FIELD_FORMAT)
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9"
    })));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/Lookup/Fields.tsx
function Fields_defineProperty(e, r, t) { return (r = Fields_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Fields_toPropertyKey(t) { var i = Fields_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Fields_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Fields_extends() { return Fields_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, Fields_extends.apply(null, arguments); }







class FolderSelect extends (external_react_default()).PureComponent {
  render() {
    return /*#__PURE__*/external_react_default().createElement(LookupContextConsumer, null, context => /*#__PURE__*/external_react_default().createElement(FolderSelectImpl, Fields_extends({}, this.props, {
      context: context,
      name: createFormInputName(DOMAIN_FIELD_LOOKUP_CONTAINER)
    })));
  }
}
class FolderSelectImpl extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    this.state = {
      containers: (0,external_immutable_.List)(),
      loading: false
    };
  }
  componentDidMount() {
    const {
      context
    } = this.props;
    this.setState({
      loading: true
    });
    context.fetchContainers().then(containers => {
      this.setState({
        containers,
        loading: false
      });
    });
  }
  render() {
    const {
      context
    } = this.props;
    const {
      containers
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement("select", Fields_extends({}, this.props, {
      className: "form-control"
    }), context.activeContainer && /*#__PURE__*/external_react_default().createElement("option", {
      key: "_current",
      value: ""
    }, "Current ", context.activeContainer.type.toLowerCase() === 'project' ? 'Project' : 'Folder'), containers.map(c => /*#__PURE__*/external_react_default().createElement("option", {
      key: c.id,
      value: c.path
    }, c.path)).toArray());
  }
}
class TargetTableSelect extends (external_react_default()).PureComponent {
  render() {
    return /*#__PURE__*/external_react_default().createElement(LookupContextConsumer, null, context => /*#__PURE__*/external_react_default().createElement(TargetTableSelectImpl, Fields_extends({}, this.props, {
      context: context,
      name: createFormInputName(DOMAIN_FIELD_LOOKUP_QUERY)
    })));
  }
}
class TargetTableSelectImpl extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    this.state = {
      containerPath: null,
      // explicitly use "null" instead of "undefined" due to container API
      loading: false,
      prevPath: null,
      prevSchemaName: undefined,
      queries: undefined
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (TargetTableSelectImpl.isChanged(nextProps, prevState)) {
      return {
        prevPath: nextProps.containerPath,
        prevSchemaName: nextProps.schemaName
      };
    }

    // no state update
    return null;
  }
  static isChanged(props, state) {
    return props.containerPath !== state.prevPath || props.schemaName !== state.prevSchemaName;
  }
  componentDidMount() {
    this.loadData();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (TargetTableSelectImpl.isChanged(prevProps, this.state)) {
      this.loadData();
    }
  }
  loadData() {
    const {
      containerPath,
      context,
      schemaName,
      value,
      lookupIsValid
    } = this.props;
    this.setState({
      loading: true,
      prevPath: containerPath,
      prevSchemaName: schemaName
    });

    // special case for Current Project/Folder which uses a value of '' (empty string)
    const queryContainerPath = containerPath === '' ? null : containerPath;
    context.fetchQueries(queryContainerPath, schemaName).then(queries => {
      const infos = [];
      context.getExcludedSchemaQueryNames(schemaName?.toLowerCase(), queryContainerPath).then(excludedQueries => {
        queries?.forEach(q => {
          if (excludedQueries && excludedQueries?.indexOf(q.name.toLowerCase()) > -1) return;
          if (q.isIncludedForLookups) infos.push(...q.getLookupInfo(this.props.lookupURI));
        });
        const initialQueryName = value ? decodeLookup(value).queryName : undefined;
        if (!lookupIsValid) infos.unshift({
          name: initialQueryName,
          type: LOOKUP_TYPE
        });
        this.setState({
          loading: false,
          queries: infos,
          initialQueryName,
          initialQueryInvalid: !lookupIsValid
        });
      }).catch(error => {
        console.error(error);
      });
    }).catch(e => {
      console.error(e);
    });
  }
  render() {
    const {
      id,
      onChange,
      value,
      name,
      disabled,
      lookupIsValid,
      shouldDisableNonExists
    } = this.props;
    const {
      loading,
      queries,
      initialQueryName,
      initialQueryInvalid
    } = this.state;
    const isEmpty = queries?.length === 0;
    const hasValue = !!value;
    const blankOption = !hasValue && !isEmpty;
    const queryNameOptionExists = initialQueryName && !isEmpty ? queries.find(query => query.name === initialQueryName) !== undefined : true; // default to true without a selected queryName

    // Certain cases disable the lookup field for a valid query that is not in the list of queries
    const disabledField = disabled || shouldDisableNonExists && !queryNameOptionExists && lookupIsValid;
    return /*#__PURE__*/external_react_default().createElement("select", {
      className: "form-control",
      disabled: loading || disabledField,
      value: value,
      id: id,
      name: name,
      onChange: onChange
    }, value && disabledField && /*#__PURE__*/external_react_default().createElement("option", {
      key: "_disabled",
      value: value
    }, decodeLookup(value).queryName), loading && /*#__PURE__*/external_react_default().createElement("option", {
      disabled: true,
      key: "_loading",
      value: value
    }, "Loading..."), blankOption && /*#__PURE__*/external_react_default().createElement("option", {
      key: "_default",
      value: undefined
    }), queries?.map(q => {
      const encoded = encodeLookup(q.name, q.type);
      return /*#__PURE__*/external_react_default().createElement("option", {
        key: encoded,
        value: encoded,
        disabled:
        // Disable if it is the initial query and it is an invalid lookup
        initialQueryInvalid && q.name === initialQueryName && decodeLookup(value).queryName !== q.name
      }, q.name, " (", !lookupIsValid && q.name === initialQueryName ? 'Unknown' : q.type.shortDisplay || q.type.display, ")");
    }), !loading && isEmpty && /*#__PURE__*/external_react_default().createElement("option", {
      disabled: true,
      key: "_empty",
      value: undefined
    }, "(No tables)"));
  }
}
Fields_defineProperty(TargetTableSelectImpl, "defaultProps", {
  shouldDisableNonExists: true
});
class SchemaSelect extends (external_react_default()).PureComponent {
  render() {
    return /*#__PURE__*/external_react_default().createElement(LookupContextConsumer, null, context => /*#__PURE__*/external_react_default().createElement(SchemaSelectImpl, Fields_extends({}, this.props, {
      context: context,
      name: createFormInputName(DOMAIN_FIELD_LOOKUP_SCHEMA)
    })));
  }
}
class SchemaSelectImpl extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      prevPath: null,
      schemas: undefined
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.containerPath !== prevState.containerPath) {
      return {
        prevPath: nextProps.containerPath
      };
    }

    // no state update
    return null;
  }
  componentDidMount() {
    this.loadData();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.containerPath !== this.state.prevPath) {
      this.loadData();
    }
  }
  loadData() {
    const {
      containerPath,
      context
    } = this.props;
    this.setState({
      loading: true,
      prevPath: containerPath
    });
    context.fetchSchemas(containerPath).then(allSchemas => {
      const schemas = [];
      context.getExcludedSchemaQueryNames('assay', containerPath).then(excludedAssayNames => {
        if (!excludedAssayNames || excludedAssayNames.length === 0) schemas.push(...allSchemas);else {
          allSchemas.forEach(schema => {
            if (!(schema.fullyQualifiedName.indexOf('assay.') === 0 && excludedAssayNames.indexOf(schema.schemaName.toLowerCase()) > -1)) schemas.push(schema);
          });
        }
        this.setState({
          loading: false,
          schemas
        });
      });
    });
  }
  render() {
    const {
      id,
      onChange,
      value,
      name,
      disabled
    } = this.props;
    const {
      schemas,
      loading
    } = this.state;
    const isEmpty = schemas?.length === 0;
    const hasValue = !!value;
    const blankOption = !hasValue && !isEmpty;
    return /*#__PURE__*/external_react_default().createElement("select", {
      className: "form-control",
      disabled: disabled,
      value: value,
      id: id,
      name: name,
      onChange: onChange,
      placeholder: "Select Schema"
    }, disabled && value && /*#__PURE__*/external_react_default().createElement("option", {
      key: "_disabled",
      value: value
    }, value), loading && /*#__PURE__*/external_react_default().createElement("option", {
      disabled: true,
      key: "_loading",
      value: value
    }, "Loading..."), blankOption && /*#__PURE__*/external_react_default().createElement("option", {
      key: "_default",
      value: undefined
    }), schemas?.map(s => /*#__PURE__*/external_react_default().createElement("option", {
      key: s.fullyQualifiedName,
      value: s.fullyQualifiedName
    }, s.fullyQualifiedName)), !loading && isEmpty && /*#__PURE__*/external_react_default().createElement("option", {
      disabled: true,
      key: "_empty",
      value: undefined
    }, "(No schemas)"));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/LookupFieldOptions.tsx
function LookupFieldOptions_defineProperty(e, r, t) { return (r = LookupFieldOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function LookupFieldOptions_toPropertyKey(t) { var i = LookupFieldOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function LookupFieldOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








class LookupFieldOptions extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    LookupFieldOptions_defineProperty(this, "onFieldChange", evt => {
      const {
        onMultiChange,
        domainIndex
      } = this.props;
      const index = getIndexFromId(evt.target.id);
      const name = getNameFromId(evt.target.id);
      let changes = (0,external_immutable_.List)();
      changes = changes.push({
        id: evt.target.id,
        value: evt.target.value
      });
      if (name === DOMAIN_FIELD_LOOKUP_CONTAINER) {
        changes = changes.push({
          id: createFormInputId(DOMAIN_FIELD_LOOKUP_SCHEMA, domainIndex, index),
          value: ''
        });
        changes = changes.push({
          id: createFormInputId(DOMAIN_FIELD_LOOKUP_QUERY, domainIndex, index),
          value: ''
        });
      }
      if (name === DOMAIN_FIELD_LOOKUP_SCHEMA) {
        changes = changes.push({
          id: createFormInputId(DOMAIN_FIELD_LOOKUP_QUERY, domainIndex, index),
          value: ''
        });
      }
      if (onMultiChange) {
        onMultiChange(changes);
      }
    });
    LookupFieldOptions_defineProperty(this, "addLookupValidator", evt => {
      const {
        onMultiChange
      } = this.props;
      let newLookupValidator;
      if (evt.target.checked) {
        newLookupValidator = new PropertyValidator(LOOKUP_VALIDATOR_VALUES);
      }
      let changes = (0,external_immutable_.List)();
      changes = changes.push({
        id: evt.target.id,
        value: newLookupValidator
      });
      if (onMultiChange) {
        onMultiChange(changes);
      }
    });
  }
  render() {
    const {
      index,
      label,
      lookupContainer,
      lockType,
      domainIndex,
      field
    } = this.props;
    const {
      lookupSchema,
      lookupQueryValue,
      lookupValidator,
      original,
      lookupIsValid,
      wrappedColumnName,
      dataType
    } = field;
    const disabled = lockType === DOMAIN_FIELD_PARTIALLY_LOCKED || lockType === DOMAIN_FIELD_FULLY_LOCKED;
    const isUserLookup = dataType.isUser();
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-section-heading"
    }, label))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, !isUserLookup && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Target Folder"), /*#__PURE__*/external_react_default().createElement(FolderSelect, {
      id: createFormInputId(DOMAIN_FIELD_LOOKUP_CONTAINER, domainIndex, index),
      key: createFormInputId(DOMAIN_FIELD_LOOKUP_CONTAINER, domainIndex, index),
      disabled: disabled,
      onChange: this.onFieldChange,
      value: lookupContainer
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Target Schema"), /*#__PURE__*/external_react_default().createElement(SchemaSelect, {
      containerPath: lookupContainer,
      id: createFormInputId(DOMAIN_FIELD_LOOKUP_SCHEMA, domainIndex, index),
      key: createFormInputId(DOMAIN_FIELD_LOOKUP_SCHEMA, domainIndex, index),
      disabled: disabled,
      onChange: this.onFieldChange,
      value: lookupSchema
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Target Table"), /*#__PURE__*/external_react_default().createElement(TargetTableSelect, {
      containerPath: lookupContainer,
      id: createFormInputId(DOMAIN_FIELD_LOOKUP_QUERY, domainIndex, index),
      key: createFormInputId(DOMAIN_FIELD_LOOKUP_QUERY, domainIndex, index),
      disabled: disabled,
      lookupURI: original.rangeURI,
      onChange: this.onFieldChange,
      schemaName: lookupSchema,
      value: lookupQueryValue,
      lookupIsValid: lookupIsValid,
      shouldDisableNonExists: !wrappedColumnName && lookupIsValid // Only disable non-wrapped fields with valid lookup value if the value is not in the query list
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-6"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Lookup Validator"), /*#__PURE__*/external_react_default().createElement(DomainDesignerCheckbox, {
      className: "domain-field-checkbox-margin",
      id: createFormInputId(DOMAIN_VALIDATOR_LOOKUP, domainIndex, index),
      name: createFormInputName(DOMAIN_VALIDATOR_LOOKUP),
      checked: !!lookupValidator,
      onChange: this.addLookupValidator
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "domain-lookup-validator-text"
    }, "Ensure Value Exists in Lookup Target"), /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      title: "Lookup Validator"
    }, /*#__PURE__*/external_react_default().createElement("div", null, "Lookup validators allow you to require that any value is present in the lookup's target table or query"))))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/validation/ValidatorModal.tsx
function ValidatorModal_defineProperty(e, r, t) { return (r = ValidatorModal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ValidatorModal_toPropertyKey(t) { var i = ValidatorModal_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ValidatorModal_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






function ValidatorModal(WrappedComponent) {
  return class extends (external_react_default()).PureComponent {
    constructor(props) {
      super(props);
      ValidatorModal_defineProperty(this, "initValidators", validators => {
        if (validators.size < 1) {
          return this.addEmpty(validators);
        }
        return validators;
      });
      ValidatorModal_defineProperty(this, "handleApply", () => {
        const {
          onApply,
          onHide,
          type
        } = this.props;
        const {
          validators
        } = this.state;
        let validatorType;
        switch (type) {
          case DOMAIN_COND_FORMAT:
            validatorType = DOMAIN_COND_FORMATS;
            break;
          case DOMAIN_REGEX_VALIDATOR:
            validatorType = DOMAIN_REGEX_VALIDATORS;
            break;
          default:
            validatorType = DOMAIN_RANGE_VALIDATORS;
            break;
        }
        onApply(validators, validatorType);
        onHide();
      });
      ValidatorModal_defineProperty(this, "onChange", (validator, index) => {
        this.setState(() => ({
          validators: this.state.validators.set(index, validator)
        }));
      });
      ValidatorModal_defineProperty(this, "isValid", validators => {
        if (!validators || validators.size < 1) return true;
        return !validators.find(val => WrappedComponent.isValid(val) === false);
      });
      ValidatorModal_defineProperty(this, "addEmpty", validators => {
        const {
          type
        } = this.props;
        let updatedValidators;
        switch (type) {
          case DOMAIN_COND_FORMAT:
            updatedValidators = validators.push(new ConditionalFormat());
            break;
          case DOMAIN_REGEX_VALIDATOR:
            updatedValidators = validators.push(new PropertyValidator({
              type: 'RegEx'
            }));
            break;
          default:
            updatedValidators = validators.push(new PropertyValidator({
              type: 'Range'
            }));
            break;
        }
        return updatedValidators;
      });
      ValidatorModal_defineProperty(this, "onAdd", () => {
        const {
          validators
        } = this.state;
        this.setState(() => ({
          validators: this.addEmpty(validators),
          expanded: validators.size
        }));
      });
      ValidatorModal_defineProperty(this, "onDelete", index => {
        const {
          validators
        } = this.state;
        const updatedValidators = validators.delete(index);
        this.setState(() => ({
          validators: updatedValidators,
          expanded: updatedValidators.size - 1
        }));
      });
      ValidatorModal_defineProperty(this, "onExpand", expanded => {
        this.setState(() => ({
          expanded
        }));
      });
      this.state = {
        expanded: 0,
        validators: this.initValidators(props.validators)
      };
    }
    render() {
      const {
        title,
        onHide,
        addName,
        index,
        dataType,
        mvEnabled
      } = this.props;
      const {
        expanded,
        validators
      } = this.state;
      const footer = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-field-float-left"
      }, /*#__PURE__*/external_react_default().createElement(AddEntityButton, {
        entity: addName,
        buttonClass: "domain-validation-add-btn",
        onClick: this.onAdd
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-validation-btn-row"
      }, /*#__PURE__*/external_react_default().createElement("button", {
        className: "domain-adv-footer domain-adv-cancel-btn btn btn-default",
        onClick: onHide,
        type: "button"
      }, "Cancel"), /*#__PURE__*/external_react_default().createElement("button", {
        className: `domain-adv-footer domain-adv-apply-btn btn btn-${getSubmitButtonClass()}`,
        disabled: !this.isValid(validators),
        onClick: this.handleApply,
        type: "button"
      }, "Apply")));
      return /*#__PURE__*/external_react_default().createElement(Modal, {
        footer: footer,
        onCancel: onHide,
        title: title
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-modal"
      }, validators.map((validator, i) => /*#__PURE__*/external_react_default().createElement("div", {
        key: i
      }, /*#__PURE__*/external_react_default().createElement(WrappedComponent, {
        validatorIndex: i,
        validator: validator,
        index: index,
        expanded: i === expanded,
        dataType: dataType,
        mvEnabled: mvEnabled,
        onExpand: this.onExpand,
        onChange: this.onChange,
        onDelete: this.onDelete
      })))));
    }
  };
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/validation/RegexValidationOptions.tsx
function RegexValidationOptions_defineProperty(e, r, t) { return (r = RegexValidationOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function RegexValidationOptions_toPropertyKey(t) { var i = RegexValidationOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function RegexValidationOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







class RegexValidationOptions extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    RegexValidationOptions_defineProperty(this, "fieldWidth", 8);
    RegexValidationOptions_defineProperty(this, "renderRowTextbox", (label, name, value, tooltipTitle, tooltipBody, required) => {
      const {
        validatorIndex,
        domainIndex
      } = this.props;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "row domain-validator-filter-row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/external_react_default().createElement("div", null, label, tooltipTitle && tooltipBody && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: tooltipTitle,
        required: required
      }, tooltipBody))), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-8"
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("textarea", {
        className: "form-control textarea-fullwidth",
        rows: 3,
        id: createFormInputId(name, domainIndex, validatorIndex),
        name: createFormInputName(name),
        value: value,
        onChange: this.onChange
      }))));
    });
    RegexValidationOptions_defineProperty(this, "onDelete", () => {
      const {
        onDelete,
        validatorIndex
      } = this.props;
      onDelete(validatorIndex);
    });
    RegexValidationOptions_defineProperty(this, "onChange", evt => {
      const {
        onChange,
        validator,
        validatorIndex
      } = this.props;
      const value = evt.target.value;
      const name = getNameFromId(evt.target.id);
      let newValidator;
      if (name === DOMAIN_VALIDATOR_FAILONMATCH) {
        const newProperties = validator.properties.set(name, evt.target.checked);
        newValidator = validator.set('properties', newProperties);
      } else {
        newValidator = validator.set(name, value);
      }
      onChange(newValidator, validatorIndex);
    });
    RegexValidationOptions_defineProperty(this, "expandValidator", () => {
      const {
        onExpand,
        validatorIndex
      } = this.props;
      onExpand(validatorIndex);
    });
  }
  render() {
    const {
      validatorIndex,
      expanded,
      validator,
      domainIndex
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-validator-panel",
      id: 'domain-regex-validator-' + validatorIndex
    }, expanded && /*#__PURE__*/external_react_default().createElement("div", null, this.renderRowTextbox('Regular Expression *', DOMAIN_VALIDATOR_EXPRESSION, validator.expression, 'Regular Expression', /*#__PURE__*/external_react_default().createElement("p", null, "The regular expression that this field's value will be evaluated against. All regular expressions must be compatible with Java regular expressions as implemented in the", ' ', /*#__PURE__*/external_react_default().createElement(JavaDocsLink, {
      urlSuffix: "java/util/regex/Pattern.html"
    }, "Pattern"), " class."), true), this.renderRowTextbox('Description', DOMAIN_VALIDATOR_DESCRIPTION, validator.description), this.renderRowTextbox('Error Message', DOMAIN_VALIDATOR_ERRORMESSAGE, validator.errorMessage, 'Error Message', 'The message that will be displayed to the user in the event that validation fails for this field.'), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8 domain-validation-failOnMatch-row"
    }, /*#__PURE__*/external_react_default().createElement(DomainDesignerCheckbox, {
      id: createFormInputId(DOMAIN_VALIDATOR_FAILONMATCH, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_VALIDATOR_FAILONMATCH),
      checked: validator.properties.failOnMatch,
      onChange: this.onChange
    }, "Fail validation when pattern matches field value", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      title: "Fail when pattern matches?"
    }, "By default, validation will fail if the field value does not match the specified regular expression. Check this box if you want validation to fail when the pattern matches the field value.")))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement("div", null, "Name *")), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: "text",
      id: createFormInputId(DOMAIN_VALIDATOR_NAME, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_VALIDATOR_NAME),
      value: validator.name,
      onChange: this.onChange
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "domain-validation-delete btn btn-default",
      id: createFormInputId(DOMAIN_VALIDATOR_REMOVE, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_VALIDATOR_REMOVE),
      onClick: this.onDelete,
      type: "button"
    }, "Remove Validator")))), !expanded && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", null, (validator.name ? validator.name : 'Regex Validator') + ': ' + (validator.expression ? validator.expression : 'Missing expression'), /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-validator-collapse-icon",
      onClick: this.expandValidator
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-pencil"
    })))));
  }
}
RegexValidationOptions_defineProperty(RegexValidationOptions, "isValid", validator => {
  return !!validator.get('expression') && !!validator.get('name');
});
const RegexValidationOptionsModal = ValidatorModal(RegexValidationOptions);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/validation/Filters.tsx
var _Filters;
function Filters_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Filters_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Filters_ownKeys(Object(t), !0).forEach(function (r) { Filters_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Filters_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Filters_defineProperty(e, r, t) { return (r = Filters_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Filters_toPropertyKey(t) { var i = Filters_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function Filters_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




const NO_FILTER_TYPE = 'None';
class Filters extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    Filters_defineProperty(this, "fieldWidth", 8);
    // TODO: put these in our Filter API
    Filters_defineProperty(this, "getRangeFilters", () => {
      const {
        type
      } = this.props;
      const filterTypes = Array();
      if (type === 'date') {
        filterTypes.push(api_.Filter.Types.DATE_EQUAL);
        filterTypes.push(api_.Filter.Types.DATE_NOT_EQUAL);
        filterTypes.push(api_.Filter.Types.DATE_GREATER_THAN);
        filterTypes.push(api_.Filter.Types.DATE_GREATER_THAN_OR_EQUAL);
        filterTypes.push(api_.Filter.Types.DATE_LESS_THAN);
        filterTypes.push(api_.Filter.Types.DATE_LESS_THAN_OR_EQUAL);
      } else {
        filterTypes.push(api_.Filter.Types.EQUAL);
        filterTypes.push(api_.Filter.Types.NOT_EQUAL);
        filterTypes.push(api_.Filter.Types.GREATER_THAN);
        filterTypes.push(api_.Filter.Types.GREATER_THAN_OR_EQUAL);
        filterTypes.push(api_.Filter.Types.LESS_THAN);
        filterTypes.push(api_.Filter.Types.LESS_THAN_OR_EQUAL);
      }
      return filterTypes;
    });
    Filters_defineProperty(this, "getFilterTypes", first => {
      const {
        type,
        range,
        mvEnabled
      } = this.props;
      let filterTypes = Array();
      if (!first) {
        filterTypes.push({
          name: 'No other filter',
          value: NO_FILTER_TYPE
        });
      }
      let filters;
      if (!range) {
        filters = api_.Filter.getFilterTypesForType(type, mvEnabled);
      } else {
        filters = this.getRangeFilters();
      }
      filterTypes = filterTypes.concat(filters.map(type => {
        const suffix = type.getURLSuffix();
        return {
          name: type.getLongDisplayText(),
          value: suffix ? suffix : DOMAIN_FILTER_HASANYVALUE
        };
      }));
      return filterTypes;
    });
    Filters_defineProperty(this, "getFilterString", filters => {
      const {
        prefix
      } = this.props;
      const encodedPrefix = encodeURIComponent(prefix ? prefix : '') + '~';
      let filterString = encodedPrefix + filters.firstFilterType + '=' + encodeURIComponent(filters.firstFilterValue);
      if (Filters.hasFilterType(filters.secondFilterType)) {
        filterString = filterString.concat('&' + encodedPrefix + filters.secondFilterType + '=' + encodeURIComponent(filters.secondFilterValue));
      }
      return filterString;
    });
    Filters_defineProperty(this, "isDataValueRequired", second => {
      const {
        filterSet
      } = this.state;
      const type = filterSet[second ? 'secondFilterType' : 'firstFilterType'];
      return Filters.isDataValueRequiredForType(type);
    });
    Filters_defineProperty(this, "onChange", evt => {
      const {
        onChange
      } = this.props;
      const value = evt.target.value;
      const name = getNameFromId(evt.target.id);
      let updatedFilters = Filters_objectSpread(Filters_objectSpread({}, this.state['filterSet']), {}, {
        [name]: value
      });

      // Clear filter value for value not required types
      if (name === DOMAIN_FIRST_FILTER_TYPE || name === DOMAIN_SECOND_FILTER_TYPE) {
        if (!Filters.isDataValueRequiredForType(value)) {
          updatedFilters = Filters_objectSpread(Filters_objectSpread({}, updatedFilters), {}, {
            [name === DOMAIN_FIRST_FILTER_TYPE ? DOMAIN_FIRST_FILTER_VALUE : DOMAIN_SECOND_FILTER_VALUE]: ''
          });
        }
      }
      this.setState(() => ({
        filterSet: updatedFilters
      }));
      onChange(this.getFilterString(updatedFilters));
    });
    Filters_defineProperty(this, "getFormControlType", () => {
      const {
        type
      } = this.props;
      if (type === 'date') {
        return 'date';
      }
      if (type === 'int' || type === 'float') {
        return 'number';
      }
      return 'text';
    });
    this.state = {
      filterSet: Filters.parseFilterString(props.expression, props.prefix),
      firstFilterTypes: this.getFilterTypes(true),
      secondFilterTypes: this.getFilterTypes(false)
    };
  }
  render() {
    const {
      validatorIndex,
      type,
      firstFilterTypeLabel,
      firstFilterValueLabel,
      secondFilterTypeLabel,
      secondFilterValueLabel,
      firstFilterTooltip,
      secondFilterTooltip,
      domainIndex
    } = this.props;
    const {
      firstFilterTypes,
      secondFilterTypes,
      filterSet
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row domain-validator-filter-type-row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      id: "domain-filter-type-label-1"
    }, firstFilterTypeLabel, firstFilterTooltip ? firstFilterTooltip : '')), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8"
    }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("select", {
      className: "form-control",
      id: createFormInputId(DOMAIN_FIRST_FILTER_TYPE, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_FIRST_FILTER_TYPE),
      value: filterSet.firstFilterType !== undefined ? filterSet.firstFilterType : type === 'date' ? 'dateeq' : 'eq',
      onChange: this.onChange,
      required: true
    }, firstFilterTypes.map(type => /*#__PURE__*/external_react_default().createElement("option", {
      key: type.value,
      value: type.value
    }, type.name)))))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row domain-validator-filter-row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      id: "domain-filter-value-label-1"
    }, firstFilterValueLabel !== undefined ? firstFilterValueLabel : 'Filter Value')), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8"
    }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: this.getFormControlType(),
      id: createFormInputId(DOMAIN_FIRST_FILTER_VALUE, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_FIRST_FILTER_VALUE),
      value: filterSet.firstFilterValue !== undefined ? filterSet.firstFilterValue : '',
      disabled: !this.isDataValueRequired(false),
      required: true,
      onChange: this.onChange
    })))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row domain-validator-filter-type-row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      id: "domain-filter-type-label-2"
    }, secondFilterTypeLabel, secondFilterTooltip ? secondFilterTooltip : '')), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8"
    }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("select", {
      className: "form-control",
      id: createFormInputId(DOMAIN_SECOND_FILTER_TYPE, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_SECOND_FILTER_TYPE),
      value: filterSet.secondFilterType ? filterSet.secondFilterType : NO_FILTER_TYPE,
      onChange: this.onChange
    }, secondFilterTypes.map(type => /*#__PURE__*/external_react_default().createElement("option", {
      key: type.value,
      value: type.value
    }, type.name)))))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row domain-validator-filter-bottom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      id: "domain-filter-value-label-2"
    }, secondFilterValueLabel !== undefined ? secondFilterValueLabel : 'Filter Value')), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8"
    }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: this.getFormControlType(),
      id: createFormInputId(DOMAIN_SECOND_FILTER_VALUE, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_SECOND_FILTER_VALUE),
      value: filterSet.secondFilterValue !== undefined ? filterSet.secondFilterValue : '',
      disabled: !this.isDataValueRequired(true),
      onChange: this.onChange
    })))));
  }
}
_Filters = Filters;
Filters_defineProperty(Filters, "defaultProps", {
  firstFilterTypeLabel: 'First Condition *',
  firstFilterValueLabel: '',
  secondFilterTypeLabel: 'Second Condition',
  secondFilterValueLabel: ''
});
Filters_defineProperty(Filters, "isValid", (expression, prefix) => {
  const filterSet = _Filters.parseFilterString(expression, prefix);
  let valid = false;
  if (_Filters.hasFilterType(filterSet.firstFilterType)) {
    valid = !!_Filters.validFilter(filterSet.firstFilterType, filterSet.firstFilterValue);
  }
  if (valid && _Filters.hasFilterType(filterSet.secondFilterType)) {
    valid = !!_Filters.validFilter(filterSet.secondFilterType, filterSet.secondFilterValue);
  }
  return valid;
});
Filters_defineProperty(Filters, "hasFilterType", type => {
  return type && api_.Utils.isString(type) && type.length > 0 && type !== NO_FILTER_TYPE;
});
Filters_defineProperty(Filters, "validFilter", (type, value) => {
  return type && (value || !_Filters.isDataValueRequiredForType(type));
});
Filters_defineProperty(Filters, "describeExpression", (expression, prefix) => {
  const filterSet = _Filters.parseFilterString(expression, prefix);
  let expressionString = 'Invalid expression';
  if (_Filters.validFilter(filterSet.firstFilterType, filterSet.firstFilterValue)) {
    const firstType = _Filters.getFilterFromPrefix(filterSet.firstFilterType);
    expressionString = firstType.getDisplayText();
    if (filterSet.firstFilterValue) {
      expressionString += ' ' + filterSet.firstFilterValue;
    }
  }
  if (_Filters.hasFilterType(filterSet.secondFilterType) && _Filters.validFilter(filterSet.secondFilterType, filterSet.secondFilterValue)) {
    const secondType = _Filters.getFilterFromPrefix(filterSet.secondFilterType);
    expressionString += ' and ' + secondType.getDisplayText();
    if (filterSet.secondFilterValue) {
      expressionString += ' ' + filterSet.secondFilterValue;
    }
  }
  return expressionString;
});
Filters_defineProperty(Filters, "parseSingleFilter", (filterString, prefix) => {
  const parts = filterString.split('=');
  const returnVal = {
    type: undefined,
    value: undefined
  };
  if (parts.length > 0 && parts[0].length > 0) {
    returnVal.type = decodeURIComponent(parts[0]).substring(1 + (prefix ? prefix.length : 0)); // remove ~
  }
  if (parts.length > 1) {
    returnVal.value = decodeURIComponent(parts[1]);
  }
  return returnVal;
});
Filters_defineProperty(Filters, "parseFilterString", (expression, prefix) => {
  let parts;
  if (expression) {
    parts = expression.split('&');
  }
  if (!parts || parts.length < 1) {
    return {
      firstFilterType: 'eq',
      firstFilterValue: '',
      secondFilterType: NO_FILTER_TYPE,
      secondFilterValue: ''
    };
  }
  const firstFilter = _Filters.parseSingleFilter(parts[0], prefix);
  let secondFilter;
  if (parts.length > 1) {
    secondFilter = _Filters.parseSingleFilter(parts[1], prefix);
  }
  return {
    firstFilterType: firstFilter.type,
    firstFilterValue: firstFilter.value,
    secondFilterType: secondFilter ? secondFilter.type : undefined,
    secondFilterValue: secondFilter ? secondFilter.value : undefined
  };
});
Filters_defineProperty(Filters, "getFilterFromPrefix", type => {
  let filter;

  // Has Any Value has a value of "", which doesn't seem to resolve well in the api
  if (type === DOMAIN_FILTER_HASANYVALUE) {
    filter = api_.Filter.Types.HAS_ANY_VALUE;
  } else if (type) {
    filter = api_.Filter.getFilterTypeForURLSuffix(type);
  }
  return filter;
});
Filters_defineProperty(Filters, "isDataValueRequiredForType", type => {
  const filter = _Filters.getFilterFromPrefix(type);
  if (filter) {
    return filter.isDataValueRequired();
  }
  return false;
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/validation/RangeValidationOptions.tsx
function RangeValidationOptions_defineProperty(e, r, t) { return (r = RangeValidationOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function RangeValidationOptions_toPropertyKey(t) { var i = RangeValidationOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function RangeValidationOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






class RangeValidationOptions extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    RangeValidationOptions_defineProperty(this, "fieldWidth", 8);
    RangeValidationOptions_defineProperty(this, "renderRowTextbox", (label, name, value) => {
      const {
        validatorIndex,
        domainIndex
      } = this.props;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "row domain-validator-filter-row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/external_react_default().createElement("div", null, label)), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-8"
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("textarea", {
        className: "form-control textarea-fullwidth",
        rows: 3,
        id: createFormInputId(name, domainIndex, validatorIndex),
        name: createFormInputName(name),
        value: value,
        onChange: this.onChange
      }))));
    });
    RangeValidationOptions_defineProperty(this, "onDelete", () => {
      const {
        onDelete,
        validatorIndex
      } = this.props;
      onDelete(validatorIndex);
    });
    RangeValidationOptions_defineProperty(this, "onChange", evt => {
      const {
        onChange,
        validator,
        validatorIndex
      } = this.props;
      const value = evt.target.value;
      const name = getNameFromId(evt.target.id);
      const newValidator = validator.set(name, value);
      onChange(newValidator, validatorIndex);
    });
    RangeValidationOptions_defineProperty(this, "onFilterChange", expression => {
      const {
        validator,
        validatorIndex,
        onChange
      } = this.props;
      onChange(validator.set('expression', expression), validatorIndex);
    });
    RangeValidationOptions_defineProperty(this, "expandValidator", () => {
      const {
        onExpand,
        validatorIndex
      } = this.props;
      onExpand(validatorIndex);
    });
    RangeValidationOptions_defineProperty(this, "firstFilterTooltip", () => {
      return /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: "First Condition",
        required: true
      }, "Add a condition to this validation rule that will be tested against the value for this field.");
    });
    RangeValidationOptions_defineProperty(this, "secondFilterTooltip", () => {
      return /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: "Second Condition"
      }, "Add a condition to this validation rule that will be tested against the value for this field. Both the first and second conditions will be tested for this field.");
    });
  }
  render() {
    const {
      validatorIndex,
      expanded,
      dataType,
      validator,
      mvEnabled,
      domainIndex
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-validator-panel",
      id: 'domain-range-validator-' + validatorIndex
    }, expanded && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(Filters, {
      validatorIndex: validatorIndex,
      domainIndex: domainIndex,
      range: true,
      mvEnabled: mvEnabled,
      onChange: this.onFilterChange,
      type: dataType.getJsonType(),
      expression: validator.expression,
      firstFilterTooltip: this.firstFilterTooltip(),
      secondFilterTooltip: this.secondFilterTooltip()
    }), this.renderRowTextbox('Description', DOMAIN_VALIDATOR_DESCRIPTION, validator.description), this.renderRowTextbox('Error Message', DOMAIN_VALIDATOR_ERRORMESSAGE, validator.errorMessage), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement("div", null, "Name *")), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: "text",
      id: createFormInputId(DOMAIN_VALIDATOR_NAME, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_VALIDATOR_NAME),
      value: validator.name,
      onChange: this.onChange
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "domain-validation-delete btn btn-default",
      id: createFormInputId(DOMAIN_VALIDATOR_REMOVE, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_VALIDATOR_REMOVE),
      onClick: this.onDelete,
      type: "button"
    }, "Remove Validator")))), !expanded && /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-validator-collapse"
    }, `${validator.name ?? 'Range Validator'}: ${validator.expression ? Filters.describeExpression(validator.expression) : 'Missing condition'}`, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-validator-collapse-icon",
      onClick: this.expandValidator
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-pencil"
    }))));
  }
}
RangeValidationOptions_defineProperty(RangeValidationOptions, "isValid", validator => {
  return Filters.isValid(validator.get('expression')) && !!validator.get('name');
});
const RangeValidationOptionsModal = ValidatorModal(RangeValidationOptions);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/validation/ConditionalFormatOptions.tsx
function ConditionalFormatOptions_defineProperty(e, r, t) { return (r = ConditionalFormatOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ConditionalFormatOptions_toPropertyKey(t) { var i = ConditionalFormatOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ConditionalFormatOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









class ConditionalFormatOptions extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    ConditionalFormatOptions_defineProperty(this, "onDelete", () => {
      const {
        onDelete,
        validatorIndex
      } = this.props;
      onDelete(validatorIndex);
    });
    ConditionalFormatOptions_defineProperty(this, "onFieldChange", evt => {
      const {
        onChange,
        validator,
        validatorIndex
      } = this.props;
      let value = evt.target.value;
      const name = getNameFromId(evt.target.id);
      if (name === DOMAIN_VALIDATOR_BOLD || name === DOMAIN_VALIDATOR_STRIKETHROUGH || name === DOMAIN_VALIDATOR_ITALIC) {
        value = evt.target.checked;
      }
      onChange(validator.set(name, value), validatorIndex);
    });
    ConditionalFormatOptions_defineProperty(this, "onFilterChange", expression => {
      const {
        validator,
        validatorIndex,
        onChange
      } = this.props;
      onChange(validator.set('formatFilter', expression), validatorIndex);
    });
    ConditionalFormatOptions_defineProperty(this, "expandValidator", () => {
      const {
        onExpand,
        validatorIndex
      } = this.props;
      onExpand(validatorIndex);
    });
    ConditionalFormatOptions_defineProperty(this, "firstFilterTooltip", () => {
      return /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: "First Condition",
        required: true
      }, "Add a condition to this format rule that will be tested against the value for this field.");
    });
    ConditionalFormatOptions_defineProperty(this, "renderDisplayCheckbox", (name, label, value) => {
      const {
        validatorIndex,
        domainIndex
      } = this.props;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-12 domain-validation-display-checkbox-row"
      }, /*#__PURE__*/external_react_default().createElement(DomainDesignerCheckbox, {
        id: createFormInputId(name, domainIndex, validatorIndex),
        name: createFormInputName(name),
        checked: value,
        onChange: this.onFieldChange
      }, label)));
    });
    ConditionalFormatOptions_defineProperty(this, "onColorShow", evt => {
      const {
        showTextColor,
        showFillColor
      } = this.state;
      let name = getNameFromId(evt.target.id);

      // If click on caret icon
      if (!name) {
        name = getNameFromId(evt.target.parentElement.parentElement.id);
      }

      // Strange little border between icon and button
      if (!name) {
        name = getNameFromId(evt.target.parentElement.id);
      }
      if (name === DOMAIN_CONDITION_FORMAT_TEXT_COLOR) {
        this.setState(() => ({
          showTextColor: !showTextColor,
          showFillColor: false
        }));
      }
      if (name === DOMAIN_CONDITION_FORMAT_BACKGROUND_COLOR) {
        this.setState(() => ({
          showFillColor: !showFillColor,
          showTextColor: false
        }));
      }
    });
    ConditionalFormatOptions_defineProperty(this, "onColorChange", color => {
      const {
        onChange,
        validator,
        validatorIndex
      } = this.props;
      const {
        showTextColor
      } = this.state;
      const name = showTextColor ? DOMAIN_CONDITION_FORMAT_TEXT_COLOR : DOMAIN_CONDITION_FORMAT_BACKGROUND_COLOR;
      onChange(validator.set(name, color.hex.substring(1)), validatorIndex);
    });
    ConditionalFormatOptions_defineProperty(this, "renderColorPickers", () => {
      const {
        validator,
        validatorIndex
      } = this.props;
      const {
        showTextColor,
        showFillColor
      } = this.state;
      const textColor = validator.textColor ? '#' + validator.textColor : 'black';
      const fillColor = validator.backgroundColor ? '#' + validator.backgroundColor : 'white';
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "row domain-validator-color-row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-4"
      }, this.getColorPickerButton(DOMAIN_CONDITION_FORMAT_TEXT_COLOR, 'Text Color', textColor, showTextColor)), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-4"
      }, this.getColorPickerButton(DOMAIN_CONDITION_FORMAT_BACKGROUND_COLOR, 'Fill Color', fillColor, showFillColor)), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-1"
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/external_react_default().createElement("input", {
        className: "form-control",
        type: "text",
        id: 'domain-validator-preview-' + validatorIndex,
        defaultValue: "Preview Text",
        style: {
          fontSize: '12px',
          width: '100px',
          color: textColor,
          backgroundColor: fillColor,
          fontWeight: validator.bold ? 'bold' : 'normal',
          fontStyle: validator.italic ? 'italic' : 'normal',
          textDecoration: validator.strikethrough ? 'line-through' : ''
        }
      })));
    });
    ConditionalFormatOptions_defineProperty(this, "getColorPickerButton", (name, label, color, showColorPicker) => {
      const {
        validatorIndex,
        domainIndex
      } = this.props;
      const iconClassName = external_classnames_default()('domain-color-caret', 'fa', 'fa-lg', {
        'fa-caret-up': showColorPicker,
        'fa-caret-down': !showColorPicker
      });
      return /*#__PURE__*/external_react_default().createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/external_react_default().createElement("button", {
        className: "domain-color-picker-btn btn btn-default",
        id: createFormInputId(name, domainIndex, validatorIndex),
        key: createFormInputId(name, domainIndex, validatorIndex),
        name: createFormInputName(name),
        onClick: this.onColorShow,
        type: "button"
      }, label, /*#__PURE__*/external_react_default().createElement("span", {
        className: iconClassName
      })), showColorPicker && /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-validator-color-popover"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-validator-color-cover",
        id: createFormInputId(name, domainIndex, validatorIndex),
        onClick: this.onColorShow
      }), /*#__PURE__*/external_react_default().createElement(external_react_color_.CompactPicker, {
        onChangeComplete: this.onColorChange,
        color: color
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-color-preview",
        style: {
          backgroundColor: color
        }
      }));
    });
    this.state = {
      showTextColor: false,
      showFillColor: false
    };
  }
  render() {
    const {
      validatorIndex,
      expanded,
      dataType,
      validator,
      mvEnabled,
      domainIndex
    } = this.props;

    // Needs to be able to take string values for between syntax, but keep as date if that is the selected type (issue 39193)
    const type = dataType.getJsonType() === 'date' ? dataType.getJsonType() : 'string';
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-validator-panel",
      id: 'domain-condition-format-' + validatorIndex
    }, expanded && /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(Filters, {
      validatorIndex: validatorIndex,
      domainIndex: domainIndex,
      onChange: this.onFilterChange,
      type: type,
      mvEnabled: mvEnabled,
      expression: validator.formatFilter,
      prefix: DOMAIN_CONDITIONAL_FORMAT_PREFIX,
      firstFilterTooltip: this.firstFilterTooltip()
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-validation-subtitle"
    }, "Display Options"), this.renderDisplayCheckbox(DOMAIN_VALIDATOR_BOLD, 'Bold', validator.bold), this.renderDisplayCheckbox(DOMAIN_VALIDATOR_ITALIC, 'Italics', validator.italic), this.renderDisplayCheckbox(DOMAIN_VALIDATOR_STRIKETHROUGH, 'Strikethrough', validator.strikethrough), this.renderColorPickers(), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row domain-validator-color-row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "domain-validation-delete btn btn-default",
      id: createFormInputId(DOMAIN_VALIDATOR_REMOVE, domainIndex, validatorIndex),
      name: createFormInputName(DOMAIN_VALIDATOR_REMOVE),
      onClick: this.onDelete,
      type: "button"
    }, "Remove Formatting")))), !expanded && /*#__PURE__*/external_react_default().createElement("div", null, validator.formatFilter ? Filters.describeExpression(validator.formatFilter, DOMAIN_CONDITIONAL_FORMAT_PREFIX) : 'Missing condition', /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-validator-collapse-icon",
      onClick: this.expandValidator
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-pencil"
    }))));
  }
}
ConditionalFormatOptions_defineProperty(ConditionalFormatOptions, "isValid", validator => {
  return Filters.isValid(validator.get('formatFilter'), DOMAIN_CONDITIONAL_FORMAT_PREFIX);
});
const ConditionalFormatOptionsModal = ValidatorModal(ConditionalFormatOptions);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/ConditionalFormattingAndValidation.tsx
function ConditionalFormattingAndValidation_defineProperty(e, r, t) { return (r = ConditionalFormattingAndValidation_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ConditionalFormattingAndValidation_toPropertyKey(t) { var i = ConditionalFormattingAndValidation_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ConditionalFormattingAndValidation_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











const RANGE_VALIDATION_TOPIC = FIELD_EDITOR_TOPIC + '#range';
const REGEX_TOPIC = FIELD_EDITOR_TOPIC + '#regex';
const CONDITIONAL_FORMAT_TOPIC = FIELD_EDITOR_TOPIC + '#conditional';
const RangeValidatorHelpText = () => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Range validators allow you to specify numeric comparisons that must be satisfied."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
  topic: RANGE_VALIDATION_TOPIC
}, "Range Validation"), "."));
const RegexValidatorHelpText = () => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "RegEx validators allow you to specify a regular expression that defines what string values are valid."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
  topic: REGEX_TOPIC
}, "Regular Expression Validation"), "."));
const ConditionalFormatHelpText = () => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Conditional formats allow targeted display formatting for values that meet defined conditions."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
  topic: CONDITIONAL_FORMAT_TOPIC
}, "Conditional Formats"), "."));
class ConditionalFormattingAndValidation extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    ConditionalFormattingAndValidation_defineProperty(this, "handleChange", evt => {
      const {
        onChange
      } = this.props;
      onChange(evt.target.id, evt.target.value);
    });
    ConditionalFormattingAndValidation_defineProperty(this, "onApply", (validator, type) => {
      const {
        onChange,
        index,
        domainIndex
      } = this.props;
      onChange(createFormInputId(type, domainIndex, index), validator);
    });
    ConditionalFormattingAndValidation_defineProperty(this, "showHideConditionalFormat", () => {
      const {
        showingModal
      } = this.props;
      this.setState(state => ({
        showCondFormat: !state.showCondFormat
      }), () => showingModal(this.state.showCondFormat));
    });
    ConditionalFormattingAndValidation_defineProperty(this, "showHideRegexValidator", () => {
      const {
        showingModal
      } = this.props;
      this.setState(state => ({
        showRegex: !state.showRegex
      }), () => showingModal(this.state.showRegex));
    });
    ConditionalFormattingAndValidation_defineProperty(this, "showHideRangeValidator", () => {
      const {
        showingModal
      } = this.props;
      this.setState(state => ({
        showRange: !state.showRange
      }), () => showingModal(this.state.showRange));
    });
    ConditionalFormattingAndValidation_defineProperty(this, "renderValidator", range => {
      const {
        field,
        index,
        domainIndex
      } = this.props;
      const validators = range ? field.rangeValidators : field.regexValidators;
      const count = validators ? validators.size : 0;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: range ? '' : 'domain-validation-group'
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-field-label domain-no-wrap"
      }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
        label: 'Create ' + (range ? 'Range' : 'Regular Expression') + ' Validator',
        helpTipBody: range ? /*#__PURE__*/external_react_default().createElement(RangeValidatorHelpText, null) : /*#__PURE__*/external_react_default().createElement(RegexValidatorHelpText, null)
      })), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("button", {
        className: "domain-validation-button btn btn-default",
        disabled: isFieldFullyLocked(field.lockType),
        id: createFormInputId(range ? DOMAIN_RANGE_VALIDATOR : DOMAIN_REGEX_VALIDATOR, domainIndex, index),
        name: createFormInputName(range ? DOMAIN_RANGE_VALIDATOR : DOMAIN_REGEX_VALIDATOR),
        onClick: range ? this.showHideRangeValidator : this.showHideRegexValidator,
        type: "button"
      }, count > 0 ? range ? 'Edit Ranges' : 'Edit Regex' : range ? 'Add Range' : 'Add Regex'), count === 0 ? /*#__PURE__*/external_react_default().createElement("span", {
        className: "domain-text-label"
      }, "None Set") : /*#__PURE__*/external_react_default().createElement("a", {
        className: "domain-validator-link",
        onClick: isFieldFullyLocked(field.lockType) ? () => {} : range ? this.showHideRangeValidator : this.showHideRegexValidator
      }, '' + count + ' Active validator' + (count > 1 ? 's' : ''))));
    });
    ConditionalFormattingAndValidation_defineProperty(this, "renderConditionalFormats", () => {
      const {
        field,
        index,
        domainFormDisplayOptions,
        domainIndex
      } = this.props;
      if (domainFormDisplayOptions.hideConditionalFormatting) return null;
      const count = field.conditionalFormats ? field.conditionalFormats.size : 0;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-validation-group"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-field-label domain-no-wrap"
      }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
        label: "Create Conditional Format Criteria",
        helpTipBody: /*#__PURE__*/external_react_default().createElement(ConditionalFormatHelpText, null)
      })), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("button", {
        className: "domain-validation-button btn btn-default",
        disabled: isFieldFullyLocked(field.lockType),
        id: createFormInputId(DOMAIN_COND_FORMAT, domainIndex, index),
        name: createFormInputName(DOMAIN_COND_FORMAT),
        onClick: this.showHideConditionalFormat,
        type: "button"
      }, count > 0 ? 'Edit Formats' : 'Add Format'), count === 0 ? /*#__PURE__*/external_react_default().createElement("span", {
        className: "domain-text-label"
      }, "None Set") : /*#__PURE__*/external_react_default().createElement("a", {
        className: "domain-validator-link",
        onClick: isFieldFullyLocked(field.lockType) ? () => {} : this.showHideConditionalFormat
      }, '' + count + ' Active format' + (count > 1 ? 's' : ''))));
    });
    this.state = {
      showCondFormat: false,
      showRegex: false,
      showRange: false
    };
  }
  render() {
    const {
      index,
      field,
      domainFormDisplayOptions
    } = this.props;
    const {
      showCondFormat,
      showRegex,
      showRange
    } = this.state;
    const showCondFormatSection = !domainFormDisplayOptions.hideConditionalFormatting;
    const showRegexSection = !domainFormDisplayOptions.hideValidators && DomainField.hasRegExValidation(field);
    const showRangeSection = !domainFormDisplayOptions.hideValidators && DomainField.hasRangeValidation(field);
    const showValidation = showRegexSection || showRangeSection;
    const title = (showCondFormatSection ? 'Conditional Formatting' : '') + (showCondFormatSection && showValidation ? ' and ' : '') + (showValidation ? 'Validation' : '') + ' Options';

    // don't render anything for this component if none of the sections apply
    if (!showCondFormatSection && !showRegexSection && !showRangeSection) {
      return null;
    }
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: title,
      cls: "domain-field-section-hdr"
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, showCondFormatSection && this.renderConditionalFormats(), showRegexSection && this.renderValidator(false), showRangeSection && this.renderValidator(true), showCondFormat && /*#__PURE__*/external_react_default().createElement(ConditionalFormatOptionsModal, {
      title: 'Conditional Formatting ' + (field.name ? 'for ' + field.name : ''),
      addName: "Formatting",
      index: index,
      type: DOMAIN_COND_FORMAT,
      mvEnabled: field.mvEnabled,
      validators: field.conditionalFormats,
      dataType: field.dataType,
      onHide: this.showHideConditionalFormat,
      onApply: this.onApply
    }), showRegex && /*#__PURE__*/external_react_default().createElement(RegexValidationOptionsModal, {
      title: 'Regular Expression Validator(s) ' + (field.name ? 'for ' + field.name : ''),
      addName: "Validator",
      index: index,
      type: DOMAIN_REGEX_VALIDATOR,
      mvEnabled: field.mvEnabled,
      validators: field.regexValidators,
      dataType: field.dataType,
      onHide: this.showHideRegexValidator,
      onApply: this.onApply
    }), showRange && /*#__PURE__*/external_react_default().createElement(RangeValidationOptionsModal, {
      title: 'Range Validator(s) ' + (field.name ? 'for ' + field.name : ''),
      addName: "Validator",
      index: index,
      type: DOMAIN_RANGE_VALIDATOR,
      mvEnabled: field.mvEnabled,
      validators: field.rangeValidators,
      dataType: field.dataType,
      onHide: this.showHideRangeValidator,
      onApply: this.onApply
    }))));
  }
}
ConditionalFormattingAndValidation_defineProperty(ConditionalFormattingAndValidation, "defaultProps", {
  domainFormDisplayOptions: DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/SampleFieldOptions.tsx
function SampleFieldOptions_defineProperty(e, r, t) { return (r = SampleFieldOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SampleFieldOptions_toPropertyKey(t) { var i = SampleFieldOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SampleFieldOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











class SampleFieldOptions extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    SampleFieldOptions_defineProperty(this, "state", {
      loadingState: LoadingState.INITIALIZED,
      sampleTypes: (0,external_immutable_.List)()
    });
    SampleFieldOptions_defineProperty(this, "onFieldChange", evt => {
      this.props.onChange?.(evt.target.id, evt.target.value);
    });
    SampleFieldOptions_defineProperty(this, "componentDidMount", async () => {
      const {
        original
      } = this.props;
      this.setState({
        loadingState: LoadingState.LOADING
      });
      try {
        const queries = await fetchQueries(undefined, 'samples');
        const sampleTypes = queries.reduce((list, q) => list.concat(q.getLookupInfo(original.rangeURI)).toList(), (0,external_immutable_.List)()).filter(st => st.type.isInteger()) // Remove rowId duplicates
        .toList();
        this.setState({
          loadingState: LoadingState.LOADED,
          sampleTypes
        });
      } catch (e) {
        console.error('Failed to load sample field information', e);
        this.setState({
          loadingState: LoadingState.LOADED
        });
      }
    });
  }
  render() {
    const {
      index,
      label,
      lockType,
      value,
      domainIndex
    } = this.props;
    const {
      loadingState,
      sampleTypes
    } = this.state;
    const isLoaded = !isLoading(loadingState);
    const id = createFormInputId(DOMAIN_FIELD_SAMPLE_TYPE, domainIndex, index);
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: label
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-label"
    }, "Sample lookup to", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      title: "Sample Reference"
    }, /*#__PURE__*/external_react_default().createElement("p", null, "Select the sample reference for this field. You can choose to reference all available samples or select a specific sample type to filter by."), /*#__PURE__*/external_react_default().createElement("p", null, "This selection will be used to validate and link incoming data, populate lists for data entry, etc."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using", ' ', helpLinkNode(FIELD_EDITOR_SAMPLE_TYPES_TOPIC, 'sample fields'), " in LabKey."), ' ')))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/external_react_default().createElement("select", {
      className: "form-control",
      id: id,
      key: id,
      disabled: isFieldFullyLocked(lockType),
      name: createFormInputName(DOMAIN_FIELD_SAMPLE_TYPE),
      onChange: this.onFieldChange,
      value: value || ALL_SAMPLES_DISPLAY_TEXT
    }, !isLoaded && /*#__PURE__*/external_react_default().createElement("option", {
      disabled: true,
      key: "_loading",
      value: value
    }, "Loading..."), isLoaded && /*#__PURE__*/external_react_default().createElement("option", {
      key: createFormInputId(DOMAIN_FIELD_SAMPLE_TYPE + '-option-' + index, domainIndex, index),
      value: SAMPLE_TYPE_OPTION_VALUE
    }, "All Samples"), isLoaded && sampleTypes.map(st => {
      const encoded = encodeLookup(st.name, st.type);
      return /*#__PURE__*/external_react_default().createElement("option", {
        key: encoded,
        value: encoded
      }, st.name);
    }).toArray()))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainDesignerRadio.tsx

// Note: This component is specifically for the Domain Designer, if you need to render a radio input you should
// probably be using RadioGroupInput instead.
const DomainDesignerRadio = (0,external_react_.memo)(({
  checked,
  children,
  disabled,
  name,
  onChange,
  value
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "radio"
}, /*#__PURE__*/external_react_default().createElement("label", null, /*#__PURE__*/external_react_default().createElement("input", {
  checked: checked,
  disabled: disabled,
  name: name,
  onChange: onChange,
  type: "radio",
  value: value
}), children)));
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DerivationDataScopeFieldOptions.tsx







const DerivationDataScopeFieldOptions = (0,external_react_.memo)(props => {
  const {
    domainIndex,
    index,
    onChange,
    config,
    lockType,
    value,
    label,
    isExistingField,
    isRequiredField,
    fieldDataType
  } = props;
  const [isExistingParentOnly, setIsExistingParentOnly] = (0,external_react_.useState)(false);
  const [isChildOnlyValidOption, setIsChildOnlyValidOption] = (0,external_react_.useState)(false);
  const [isParentOnlyValidOption, setIsParentOnlyValidOption] = (0,external_react_.useState)(false);
  const [hasScopeChange, setHasScopeChange] = (0,external_react_.useState)(false);
  const [isExistingNonScopedField, setIsExistingNonScopedField] = (0,external_react_.useState)(false);
  (0,external_react_.useEffect)(() => {
    setIsExistingParentOnly(isExistingField && (!value || value === DERIVATION_DATA_SCOPES.PARENT_ONLY));
    setIsChildOnlyValidOption(!isExistingField || value === DERIVATION_DATA_SCOPES.CHILD_ONLY);
    setIsParentOnlyValidOption(!isExistingField || !value || value === DERIVATION_DATA_SCOPES.PARENT_ONLY);
    if (isExistingField && config.dataTypeFilter && fieldDataType && !config.dataTypeFilter(fieldDataType)) setIsExistingNonScopedField(true); // scenario: modify from Unique Id column to other colum types
  }, [domainIndex, index, isExistingField]); // don't use config or value in dependency, only evaluate once per index

  const inputId = (0,external_react_.useMemo)(() => {
    return createFormInputId(DOMAIN_FIELD_DERIVATION_DATA_SCOPE, domainIndex, index);
  }, [domainIndex, index]);
  const isFullyLocked = (0,external_react_.useMemo)(() => {
    return isFieldFullyLocked(lockType);
  }, [lockType]);
  const onRadioChange = (0,external_react_.useCallback)(event => {
    if (isExistingParentOnly && event.target.value === DERIVATION_DATA_SCOPES.ALL) setHasScopeChange(true);else setHasScopeChange(false);
    onChange(inputId, event.target.value);
  }, [inputId, onChange, isExistingParentOnly]);
  if (!config.show) return null;
  if (config.dataTypeFilter && fieldDataType && !config.dataTypeFilter(fieldDataType)) return null;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "margin-bottom"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
    title: label ?? config.sectionTitle,
    cls: "domain-field-section-hdr",
    helpTipBody: config.helpLinkNode
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "derivation_scope_options_container"
  }, /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
    name: inputId,
    value: DERIVATION_DATA_SCOPES.PARENT_ONLY,
    checked: !value && !isExistingNonScopedField || value === DERIVATION_DATA_SCOPES.PARENT_ONLY,
    onChange: onRadioChange,
    disabled: isFullyLocked || !isParentOnlyValidOption
  }, config.labelParent), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
    name: inputId,
    value: DERIVATION_DATA_SCOPES.CHILD_ONLY,
    checked: value === DERIVATION_DATA_SCOPES.CHILD_ONLY,
    onChange: onRadioChange,
    disabled: isFullyLocked || !isChildOnlyValidOption || isRequiredField
  }, config.labelChild), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
    name: inputId,
    value: DERIVATION_DATA_SCOPES.ALL,
    checked: value === DERIVATION_DATA_SCOPES.ALL || !value && isExistingNonScopedField,
    onChange: onRadioChange,
    disabled: isFullyLocked
  }, config.labelAll)))), hasScopeChange && config.scopeChangeWarning && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning",
    className: "aliquot-alert-warning"
  }, config.scopeChangeWarning)));
});
DerivationDataScopeFieldOptions.defaultProps = {
  config: {
    show: true,
    sectionTitle: 'Derivation Data Scope',
    labelAll: 'Editable for parent and child data independently',
    labelChild: 'Editable for child data only',
    labelParent: 'Editable for parent data only (default)'
  }
};
;// CONCATENATED MODULE: ./src/internal/components/forms/DisableableInput.tsx
const DisableableInput_excluded = ["disabledMsg", "title"];
function DisableableInput_extends() { return DisableableInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DisableableInput_extends.apply(null, arguments); }
function DisableableInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = DisableableInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function DisableableInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }




const DisableableInput_DisableableInput = (0,external_react_.memo)(props => {
  const {
      disabledMsg,
      title
    } = props,
    inputProps = DisableableInput_objectWithoutProperties(props, DisableableInput_excluded);
  const id = (0,external_react_.useMemo)(() => generateId(), []);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, disabledMsg ? /*#__PURE__*/external_react_default().createElement(OverlayTrigger, {
    style: {
      display: 'inline'
    },
    overlay: /*#__PURE__*/external_react_default().createElement(Popover, {
      id: id,
      title: title,
      placement: "bottom"
    }, disabledMsg)
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "disabled-button-with-tooltip full-width"
  }, /*#__PURE__*/external_react_default().createElement("input", DisableableInput_extends({}, inputProps, {
    type: "text",
    disabled: true
  })))) : /*#__PURE__*/external_react_default().createElement("input", DisableableInput_extends({}, inputProps, {
    type: "text"
  })));
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/TextChoiceAddValuesModal.tsx






const TextChoiceAddValuesModal = (0,external_react_.memo)(props => {
  const {
    onCancel,
    onApply,
    fieldName,
    initialValueCount = 0,
    maxValueCount = MAX_VALID_TEXT_CHOICES
  } = props;
  const [valueStr, setValueStr] = (0,external_react_.useState)('');
  const parsedValues = (0,external_react_.useMemo)(() => {
    return valueStr?.trim().length > 0 ? getValidValuesFromArray(valueStr.split('\n').map(v => v.trim())) : [];
  }, [valueStr]);
  const maxValuesToAdd = (0,external_react_.useMemo)(() => maxValueCount - initialValueCount, [initialValueCount]);
  const hasFieldName = (0,external_react_.useMemo)(() => fieldName?.length > 0, [fieldName]);
  const onChange = (0,external_react_.useCallback)(evt => {
    setValueStr(evt.target.value);
  }, []);
  const onConfirm = (0,external_react_.useCallback)(() => {
    if (parsedValues.length <= maxValuesToAdd) {
      onApply(parsedValues);
    }
  }, [parsedValues, maxValuesToAdd, onApply]);
  const canConfirm = parsedValues.length > 0 && parsedValues.length <= maxValuesToAdd;
  const title = `Add Text Choice Values${hasFieldName ? ' for ' + fieldName : ''}`;
  const valueNoun = api_.Utils.pluralize(maxValuesToAdd, 'value', 'values');
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    canConfirm: canConfirm,
    confirmText: "Apply",
    onCancel: onCancel,
    onConfirm: onConfirm,
    title: title
  }, /*#__PURE__*/external_react_default().createElement("p", null, "Enter each value on a new line. ", valueNoun, " can be added."), /*#__PURE__*/external_react_default().createElement("textarea", {
    rows: 8,
    cols: 50,
    className: "form-control textarea-fullwidth",
    placeholder: "Enter new values...",
    onChange: onChange,
    value: valueStr
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('text-choice-value-count', {
      'domain-text-choices-error': parsedValues.length > maxValuesToAdd
    })
  }, parsedValues.length === 1 ? '1 new value provided.' : `${parsedValues.length} new values provided.`));
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/TextChoiceOptions.tsx
function TextChoiceOptions_extends() { return TextChoiceOptions_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, TextChoiceOptions_extends.apply(null, arguments); }
function TextChoiceOptions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TextChoiceOptions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TextChoiceOptions_ownKeys(Object(t), !0).forEach(function (r) { TextChoiceOptions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TextChoiceOptions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextChoiceOptions_defineProperty(e, r, t) { return (r = TextChoiceOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function TextChoiceOptions_toPropertyKey(t) { var i = TextChoiceOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function TextChoiceOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

















const MIN_VALUES_FOR_SEARCH_COUNT = 2;
const HELP_TIP_BODY = /*#__PURE__*/external_react_default().createElement("p", null, "The set of values to be used as drop-down options to restrict data entry into this field.");
const IN_USE_TITLE = 'Text Choice In Use';
const IN_USE_TIP = 'This text choice value cannot be deleted because it is in use.';
const VALUE_IN_USE = /*#__PURE__*/external_react_default().createElement(LockIcon, {
  className: "pull-right",
  iconCls: "choices-list__locked",
  body: IN_USE_TIP,
  id: "text-choice-value-lock-icon",
  title: IN_USE_TITLE
});
const LOCKED_TITLE = 'Text Choice In Use and Locked';
const LOCKED_TIP = 'This text choice value cannot be deleted because it is in use and cannot be edited because one or more usages are for read-only items.';
const VALUE_LOCKED = /*#__PURE__*/external_react_default().createElement(LockIcon, {
  className: "pull-right",
  iconCls: "choices-list__locked",
  body: LOCKED_TIP,
  id: "text-choice-value-lock-icon",
  title: LOCKED_TITLE
});
// exported for jest testing
const TextChoiceOptionsImpl = (0,external_react_.memo)(props => {
  const {
    label,
    field,
    loading,
    fieldValues,
    validValues,
    replaceValues,
    maxValueCount = MAX_VALID_TEXT_CHOICES,
    lockedForDomain
  } = props;
  const [selectedIndex, setSelectedIndex] = (0,external_react_.useState)();
  const [currentValue, setCurrentValue] = (0,external_react_.useState)();
  const [currentError, setCurrentError] = (0,external_react_.useState)();
  const [showAddValuesModal, setShowAddValuesModal] = (0,external_react_.useState)();
  const [search, setSearch] = (0,external_react_.useState)('');

  // keep a map from the updated values for the in-use field values to their original values
  const [fieldValueUpdates, setFieldValueUpdates] = (0,external_react_.useState)({});
  (0,external_react_.useEffect)(() => {
    setFieldValueUpdates(Object.keys(fieldValues).reduce((prev, current) => {
      prev[current] = current;
      return prev;
    }, {}));
  }, [fieldValues]);
  const selectedValue = (0,external_react_.useMemo)(() => validValues[selectedIndex], [validValues, selectedIndex]);
  const currentInUse = fieldValueUpdates.hasOwnProperty(selectedValue);
  const currentLocked = currentInUse && (lockedForDomain || (fieldValues[fieldValueUpdates[selectedValue]]?.locked ?? false));
  const isValueDuplicate = (0,external_react_.useCallback)(val => {
    return validValues.indexOf(val) !== -1;
  }, [validValues]);
  const onSelect = (0,external_react_.useCallback)(ind => {
    setSelectedIndex(ind);
    setCurrentValue(validValues?.[ind]);
    setCurrentError(undefined);
  }, [validValues]);
  const onValueChange = (0,external_react_.useCallback)(evt => {
    const updatedVal = evt.target.value;
    setCurrentValue(updatedVal);
    setCurrentError(updatedVal.trim() !== selectedValue && isValueDuplicate(updatedVal.trim()) ? `"${updatedVal.trim()}" already exists in the list of values.` : undefined);
  }, [validValues, selectedIndex]);
  const updateValue = (0,external_react_.useCallback)(updatedValue => {
    const newValues = [...validValues];
    const newFieldValueUpdates = TextChoiceOptions_objectSpread({}, fieldValueUpdates);
    if (updatedValue !== undefined) {
      newValues.splice(selectedIndex, 1, updatedValue);

      // if one of the "in use" field values was updated, we need to update the fieldValueUpdates mapping object
      if (fieldValueUpdates[selectedValue]) {
        newFieldValueUpdates[updatedValue] = fieldValueUpdates[selectedValue];
        delete newFieldValueUpdates[selectedValue];
        setFieldValueUpdates(newFieldValueUpdates);
      }
    } else {
      newValues.splice(selectedIndex, 1);
      onSelect(undefined); // clear selected index and value
    }
    replaceValues(newValues, newFieldValueUpdates);
    setSearch('');
  }, [validValues, selectedValue, replaceValues, selectedIndex, onSelect, fieldValueUpdates]);
  const onApply = (0,external_react_.useCallback)(() => {
    const val = currentValue.trim();
    if (!isValueDuplicate(val)) {
      updateValue(val);
      setCurrentValue(val);
      setCurrentError(undefined);
    }
  }, [updateValue, currentValue]);
  const onDelete = (0,external_react_.useCallback)(() => {
    updateValue(); // calling without updatedValue will remove instead of replace
  }, [updateValue]);
  const toggleAddValues = (0,external_react_.useCallback)(() => {
    setShowAddValuesModal(!showAddValuesModal);
  }, [showAddValuesModal]);
  const onApplyAddValues = (0,external_react_.useCallback)(values => {
    // filter out any duplicates from the already included values
    const filteredVals = values.filter(v => !isValueDuplicate(v));
    replaceValues(validValues.concat(filteredVals), fieldValueUpdates);
    toggleAddValues();
    setSearch('');
  }, [replaceValues, validValues, toggleAddValues, fieldValueUpdates]);
  const searchStr = (0,external_react_.useMemo)(() => search.trim().toLowerCase(), [search]);
  const onSearchChange = (0,external_react_.useCallback)(event => {
    setSearch(event.target.value);
  }, []);
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
    title: label
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-label"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Drop-down Values",
    helpTipBody: HELP_TIP_BODY
  })))), loading && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null))), !loading && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('col-xs-6', 'col-lg-4', {
      'domain-text-choices-left-panel': validValues.length > 0
    })
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "list-group domain-text-choices-list"
  }, validValues.length > MIN_VALUES_FOR_SEARCH_COUNT && /*#__PURE__*/external_react_default().createElement("input", {
    autoFocus: true,
    className: "form-control domain-text-choices-search",
    onChange: onSearchChange,
    placeholder: "Find a value",
    value: search
  }), validValues.map((value, ind) => {
    const matchSearch = searchStr === '' || value.toLowerCase().indexOf(searchStr) > -1;
    if (!matchSearch) return null;
    const inUse = fieldValueUpdates.hasOwnProperty(value);
    const locked = inUse && (lockedForDomain || (fieldValues[fieldValueUpdates[value]]?.locked ?? false));
    return /*#__PURE__*/external_react_default().createElement(ChoicesListItem, {
      active: ind === selectedIndex,
      index: ind,
      key: ind,
      label: value,
      subLabel: value === '' ? 'Empty Value' : undefined,
      onSelect: onSelect,
      componentRight: locked ? VALUE_LOCKED : inUse ? VALUE_IN_USE : null
    });
  })), /*#__PURE__*/external_react_default().createElement(AddEntityButton, {
    disabled: validValues.length >= maxValueCount,
    entity: "Values",
    onClick: toggleAddValues,
    title: `Add Values (max ${maxValueCount})`
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6 col-lg-4"
  }, validValues.length > 0 && selectedIndex === undefined && /*#__PURE__*/external_react_default().createElement("p", {
    className: "choices-detail__empty-message"
  }, "Select a value from the list on the left to view details."), selectedIndex !== undefined && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-label"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Value"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-padding-bottom"
  }, /*#__PURE__*/external_react_default().createElement(DisableableInput_DisableableInput, {
    className: "form-control full-width",
    disabledMsg: currentLocked ? LOCKED_TIP : undefined,
    name: "value",
    onChange: onValueChange,
    placeholder: "Enter a text choice value",
    title: LOCKED_TITLE,
    value: currentValue ?? ''
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-padding-bottom"
  }, /*#__PURE__*/external_react_default().createElement(DisableableButton, {
    disabledMsg: currentLocked ? LOCKED_TIP : currentInUse ? IN_USE_TIP : undefined,
    onClick: onDelete,
    title: currentLocked ? LOCKED_TITLE : IN_USE_TITLE
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-trash"
  }), /*#__PURE__*/external_react_default().createElement("span", null, "\xA0Delete")), /*#__PURE__*/external_react_default().createElement("button", {
    className: "pull-right btn btn-success",
    disabled: currentError !== undefined || currentValue === selectedValue || currentValue.trim() === '',
    onClick: onApply,
    type: "button"
  }, "Apply")), fieldValueUpdates[selectedValue] !== undefined && selectedValue !== fieldValueUpdates[selectedValue] && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "info",
    className: "domain-text-choices-info"
  }, api_.Utils.pluralize(fieldValues[fieldValueUpdates[selectedValue]].count, 'row', 'rows'), ' ', "with value ", /*#__PURE__*/external_react_default().createElement("b", null, fieldValueUpdates[selectedValue]), " will be updated to", ' ', /*#__PURE__*/external_react_default().createElement("b", null, selectedValue), " on save."), currentError && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "danger"
  }, currentError)))), showAddValuesModal && /*#__PURE__*/external_react_default().createElement(TextChoiceAddValuesModal, {
    fieldName: field.name,
    onCancel: toggleAddValues,
    onApply: onApplyAddValues,
    initialValueCount: validValues.length
  }));
});
const TextChoiceOptions = (0,external_react_.memo)(props => {
  const {
    field,
    onChange,
    domainIndex,
    index,
    schemaName,
    queryName,
    lockedSqlFragment = 'FALSE'
  } = props;
  const [loading, setLoading] = (0,external_react_.useState)(true);
  const [fieldValues, setFieldValues] = (0,external_react_.useState)({});
  const [validValues, setValidValues] = (0,external_react_.useState)(field.textChoiceValidator?.properties.validValues ?? []);
  const fieldId = createFormInputId(DOMAIN_VALIDATOR_TEXTCHOICE, domainIndex, index);
  const replaceValues = (0,external_react_.useCallback)((newValues, newValueUpdates) => {
    setValidValues(newValues);
    const valueUpdates = Object.keys(newValueUpdates ?? {}).reduce((prev, curr) => {
      if (curr !== newValueUpdates[curr]) {
        prev[newValueUpdates[curr]] = curr;
      }
      return prev;
    }, {});
    onChange(fieldId, new PropertyValidator(TextChoiceOptions_objectSpread(TextChoiceOptions_objectSpread(TextChoiceOptions_objectSpread({}, field.textChoiceValidator), DEFAULT_TEXT_CHOICE_VALIDATOR.toJS()), {}, {
      shouldShowWarning: true,
      expression: newValues.join('|'),
      properties: {
        validValues: newValues
      },
      extraProperties: {
        valueUpdates
      }
    })));
  }, [field.textChoiceValidator, fieldId, onChange]);
  (0,external_react_.useEffect)(() => {
    // for an existing field, we query for the distinct set of values in the Text column to be used for
    // the initial set of values and/or setting fields as locked (i.e. in use)
    if (!field.isNew() && schemaName && queryName) {
      getTextChoiceInUseValues(field, schemaName, queryName, lockedSqlFragment).then(values => {
        setFieldValues(values);

        // if this is new text choice validator (i.e. does not have a rowId) for an existing field
        // that is being changed to data type = Text Choice (that "is new field" check is above),
        // then we will use the existing distinct values for that field as the initial options
        if (!field.textChoiceValidator?.rowId) {
          replaceValues(Object.keys(values).sort());
        }
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [
    /* none, only call once on mount*/
  ]);
  return /*#__PURE__*/external_react_default().createElement(TextChoiceOptionsImpl, TextChoiceOptions_extends({}, props, {
    fieldValues: fieldValues,
    loading: loading,
    replaceValues: replaceValues,
    validValues: validValues
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/FileAttachmentOptions.tsx





const FileAttachmentOptions = (0,external_react_.memo)(props => {
  const {
    onChange,
    label,
    index,
    domainIndex,
    displayOption,
    lockType
  } = props;
  const onFieldChange = (0,external_react_.useCallback)(evt => {
    const value = evt.target.value;
    if (onChange) {
      onChange(evt.target.id, value);
    }
  }, [onChange]);
  const helpText = (0,external_react_.useMemo)(() => {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, `Set the default behavior of ${label.toLowerCase()} links when clicked in grids and elsewhere in LabKey.`));
  }, [label]);
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
    title: `${label} Behavior`,
    helpTipBody: helpText
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row domain-field-label"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-2"
  }, /*#__PURE__*/external_react_default().createElement("select", {
    className: "form-control",
    id: createFormInputId(DOMAIN_FIELD_FILE_DISPLAY, domainIndex, index),
    disabled: isFieldFullyLocked(lockType),
    name: createFormInputName(DOMAIN_FIELD_FILE_DISPLAY),
    onChange: onFieldChange,
    value: displayOption
  }, /*#__PURE__*/external_react_default().createElement("option", {
    key: createFormInputId(DOMAIN_FIELD_FILE_DISPLAY + 'option-' + FILE_DISPLAY_INLINE, domainIndex, index),
    value: FILE_DISPLAY_INLINE
  }, `Show ${label} in Browser`), /*#__PURE__*/external_react_default().createElement("option", {
    key: createFormInputId(DOMAIN_FIELD_FILE_DISPLAY + 'option-' + FILE_DISPLAY_ATTACHMENT, domainIndex, index),
    value: FILE_DISPLAY_ATTACHMENT
  }, `Download ${label}`)))));
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/CalculatedFieldOptions.tsx








const CalculatedFieldOptions_HELP_TIP_BODY = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Define the SQL expression to use for this calculated field. This definition can perform some type of calculation for the given data row."), /*#__PURE__*/external_react_default().createElement("p", null, "The expression must be valid LabKey SQL and can use the default system fields, custom fields, and SQL functions as defined in the ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
  topic: LABKEY_SQL_TOPIC
}, "LabKey SQL Reference"), ' ', "documentation."), /*#__PURE__*/external_react_default().createElement("p", null, "Examples:", /*#__PURE__*/external_react_default().createElement("ul", null, /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("code", null, "numericField1 / numericField2 * 100")), /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("code", null, "CURDATE()")), /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("code", null, "TIMESTAMPDIFF( 'SQL_TSI_DAY', CURDATE(), TIMESTAMPADD( 'SQL_TSI_MONTH', 6, dateField))")), /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("code", null, "CASE WHEN age_in_months(dateField, CURDATE()) <= 6 AND FreezeThawCount < 2 THEN 'Viable' ELSE 'Questionable' END")))));
const CalculatedFieldOptions = (0,external_react_.memo)(props => {
  const {
    index,
    field,
    domainIndex,
    onChange
  } = props;
  const handleChange = (0,external_react_.useCallback)(evt => {
    onChange(evt.target.id, evt.target.value);
  }, [onChange]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()({
      'margin-bottom': !!field?.rangeURI && !PropDescType.isString(field.rangeURI)
    })
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
    title: "Expression",
    cls: "bottom-spacing",
    helpTipBody: CalculatedFieldOptions_HELP_TIP_BODY
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/external_react_default().createElement("textarea", {
    className: "form-control",
    rows: 4,
    value: field.valueExpression || '',
    id: createFormInputId(DOMAIN_FIELD_VALUE_EXPRESSION, domainIndex, index),
    name: createFormInputName(DOMAIN_FIELD_VALUE_EXPRESSION),
    onChange: handleChange,
    disabled: isFieldPartiallyLocked(field.lockType) || isFieldFullyLocked(field.lockType)
  }))));
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainRowExpandedOptions.tsx
function DomainRowExpandedOptions_defineProperty(e, r, t) { return (r = DomainRowExpandedOptions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DomainRowExpandedOptions_toPropertyKey(t) { var i = DomainRowExpandedOptions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DomainRowExpandedOptions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
















class DomainRowExpandedOptions extends (external_react_default()).Component {
  constructor(...args) {
    super(...args);
    DomainRowExpandedOptions_defineProperty(this, "typeDependentOptions", () => {
      const {
        field,
        index,
        onChange,
        onMultiChange,
        domainIndex,
        domainFormDisplayOptions,
        getDomainFields,
        appPropertiesOnly,
        domainContainerPath,
        schemaName,
        queryName
      } = this.props;

      // In most cases we will use the selected data type to determine which field options to show,
      // however in the calculated field data type case, we need to use the rangeURI.
      let dataTypeName = field.dataType.name;
      if (dataTypeName === 'calculation' && field?.rangeURI) {
        dataTypeName = field?.rangeURI.substring(field?.rangeURI.lastIndexOf('#') + 1);
      }
      switch (dataTypeName) {
        case 'string':
          if (domainFormDisplayOptions && !domainFormDisplayOptions.hideTextOptions) {
            // Issue 39877: Max text length options should not be visible for text key field of list
            // Also, don't show max text length options for calculated fields
            if (field.isPrimaryKey || field.isCalculatedField()) {
              return;
            }
            return /*#__PURE__*/external_react_default().createElement(TextFieldOptions, {
              index: index,
              domainIndex: domainIndex,
              label: "Text Options",
              scale: field.scale,
              onChange: onChange,
              lockType: field.lockType,
              scannable: field.scannable,
              appPropertiesOnly: appPropertiesOnly,
              showScannableOption: domainFormDisplayOptions?.showScannableOption
            });
          } else {
            return null;
          }
        case 'flag':
          return /*#__PURE__*/external_react_default().createElement(TextFieldOptions, {
            index: index,
            domainIndex: domainIndex,
            label: "Flag Options",
            scale: field.scale,
            onChange: onChange,
            lockType: field.lockType
          });
        case 'multiLine':
          return /*#__PURE__*/external_react_default().createElement(TextFieldOptions, {
            index: index,
            domainIndex: domainIndex,
            label: "Multi-line Text Field Options",
            scale: field.scale,
            onChange: onChange,
            lockType: field.lockType
          });
        case 'boolean':
          return /*#__PURE__*/external_react_default().createElement(BooleanFieldOptions, {
            index: index,
            domainIndex: domainIndex,
            label: "Boolean Field Options",
            format: field.format,
            onChange: onChange,
            lockType: field.lockType
          });
        case 'dateTime':
        case 'date':
        case 'time':
          return /*#__PURE__*/external_react_default().createElement(DateTimeFieldOptions, {
            index: index,
            domainIndex: domainIndex,
            label: "Date and Time Options",
            format: field.format,
            excludeFromShifting: field.excludeFromShifting,
            onChange: onChange,
            lockType: field.lockType,
            type: dataTypeName
          });
        case 'int':
          return /*#__PURE__*/external_react_default().createElement(NumericFieldOptions, {
            index: index,
            domainIndex: domainIndex,
            label: "Integer Options",
            format: field.format,
            defaultScale: field.defaultScale,
            onChange: onChange,
            lockType: field.lockType,
            scannable: field.scannable,
            appPropertiesOnly: appPropertiesOnly,
            showScannableOption: domainFormDisplayOptions?.showScannableOption && !field.isCalculatedField()
          });
        case 'double':
        case 'decimal':
          return /*#__PURE__*/external_react_default().createElement(NumericFieldOptions, {
            index: index,
            domainIndex: domainIndex,
            label: "Decimal Options",
            format: field.format,
            defaultScale: field.defaultScale,
            onChange: onChange,
            lockType: field.lockType
            // Issue #44567: Hide scannable option due to matching issues with floating point representation.
            ,
            showScannableOption: false
          });
        case 'lookup':
        case 'users':
          return /*#__PURE__*/external_react_default().createElement(LookupFieldOptions, {
            index: index,
            domainIndex: domainIndex,
            field: field,
            label: "Lookup Definition Options",
            lookupContainer: field.lookupContainer ?? domainContainerPath,
            onChange: onChange,
            onMultiChange: onMultiChange,
            lockType: field.lockType
          });
        case 'sample':
          return /*#__PURE__*/external_react_default().createElement(SampleFieldOptions, {
            index: index,
            domainIndex: domainIndex,
            label: "Sample Options",
            value: field.lookupQueryValue,
            original: field.original,
            container: field.lookupContainer,
            onChange: onChange,
            lockType: field.lockType
          });
        case 'ontologyLookup':
          const domainFields = getDomainFields ? getDomainFields() : (0,external_immutable_.List)();
          return /*#__PURE__*/external_react_default().createElement(OntologyLookupOptions, {
            domainContainerPath: domainContainerPath,
            index: index,
            domainIndex: domainIndex,
            label: "Ontology Lookup Options",
            domainFields: domainFields,
            field: field,
            onChange: onChange,
            onMultiChange: onMultiChange,
            lockType: field.lockType
          });
        case 'textChoice':
          // don't show Text Choice options for query metadata editor
          if (domainFormDisplayOptions?.hideValidators) return null;
          return /*#__PURE__*/external_react_default().createElement(TextChoiceOptions, {
            domainIndex: domainIndex,
            index: index,
            field: field,
            label: "Text Choice Options",
            lockType: field.lockType,
            onChange: onChange,
            queryName: queryName,
            schemaName: schemaName,
            lockedForDomain: domainFormDisplayOptions.textChoiceLockedForDomain,
            lockedSqlFragment: domainFormDisplayOptions.textChoiceLockedSqlFragment
          });
        case 'fileLink':
        case 'attachment':
          // Remove when this is supported in apps. Issue 46476
          if (appPropertiesOnly) return null;
          return /*#__PURE__*/external_react_default().createElement(FileAttachmentOptions, {
            index: index,
            domainIndex: domainIndex,
            label: dataTypeName === 'fileLink' ? 'File' : 'Attachment',
            displayOption: field.format,
            onChange: onChange,
            lockType: field.lockType
          });
      }
      return null;
    });
  }
  render() {
    const {
      field,
      index,
      onChange,
      showingModal,
      appPropertiesOnly,
      domainIndex,
      domainFormDisplayOptions
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-row-container"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-row-container-expand-spacer"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-row-container-expanded"
    }, domainFormDisplayOptions?.derivationDataScopeConfig?.show && !field.isCalculatedField() && /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(DerivationDataScopeFieldOptions, {
      index: index,
      domainIndex: domainIndex,
      config: domainFormDisplayOptions?.derivationDataScopeConfig,
      value: field.derivationDataScope,
      label: domainFormDisplayOptions?.derivationDataScopeConfig?.sectionTitle,
      onChange: onChange,
      lockType: field.lockType,
      isExistingField: !field.isNew(),
      isRequiredField: field.required,
      fieldDataType: field.dataType
    })), field.isCalculatedField() && /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(CalculatedFieldOptions, {
      domainIndex: domainIndex,
      field: field,
      index: index,
      onChange: onChange
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, this.typeDependentOptions()), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(NameAndLinkingOptions, {
      index: index,
      domainIndex: domainIndex,
      field: field,
      onChange: onChange,
      appPropertiesOnly: appPropertiesOnly,
      domainFormDisplayOptions: domainFormDisplayOptions
    })), !isFieldFullyLocked(field.lockType) && /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(ConditionalFormattingAndValidation, {
      index: index,
      domainIndex: domainIndex,
      field: field,
      onChange: onChange,
      showingModal: showingModal,
      domainFormDisplayOptions: domainFormDisplayOptions
    }))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/AdvancedSettings.tsx
function AdvancedSettings_defineProperty(e, r, t) { return (r = AdvancedSettings_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function AdvancedSettings_toPropertyKey(t) { var i = AdvancedSettings_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function AdvancedSettings_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }













class AdvancedSettings extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    AdvancedSettings_defineProperty(this, "initializeState", () => {
      this.setState(this.getInitialState(this.props.field, this.props.domainId, this.props.defaultDefaultValueType));
    });
    AdvancedSettings_defineProperty(this, "getInitialState", (field, domainId, defaultDefaultValueType) => {
      const {
        maxPhiLevel
      } = this.props;

      // Filter phi levels available
      const phiIndex = this.getPhiLevelIndex(maxPhiLevel);
      const phiLevels = DOMAIN_PHI_LEVELS.filter((value, index) => {
        return index <= phiIndex;
      });
      return {
        hidden: field.hidden,
        shownInDetailsView: field.shownInDetailsView,
        shownInInsertView: field.shownInInsertView,
        shownInUpdateView: field.shownInUpdateView,
        defaultValueType: field.defaultValueType ? field.defaultValueType : defaultDefaultValueType ? defaultDefaultValueType : DOMAIN_EDITABLE_DEFAULT,
        defaultDisplayValue: field.defaultDisplayValue || '[none]',
        dimension: field.dimension,
        measure: field.measure,
        mvEnabled: field.mvEnabled,
        recommendedVariable: field.recommendedVariable,
        excludeFromShifting: field.excludeFromShifting,
        uniqueConstraint: field.uniqueConstraint,
        PHI: field.PHI,
        phiLevels
      };
    });
    AdvancedSettings_defineProperty(this, "handleClose", () => {
      const {
        onHide
      } = this.props;
      onHide();
    });
    AdvancedSettings_defineProperty(this, "handleApply", () => {
      const {
        index,
        onApply,
        onHide,
        domainIndex
      } = this.props;
      if (onApply) {
        const changes = (0,external_immutable_.List)().asMutable();

        // Iterate over state values and put into list of changes
        Object.keys(this.state).forEach(function (key, i) {
          if (key !== 'phiLevels') {
            changes.push({
              id: createFormInputId(key, domainIndex, index),
              value: this.state[key]
            });
          }
        }, this);
        onApply(changes.asImmutable());
      }
      if (onHide) {
        onHide();
      }
    });
    AdvancedSettings_defineProperty(this, "handleCheckbox", evt => {
      let value = getCheckedValue(evt);
      const fieldName = getNameFromId(evt.target.id);

      // Show in default view
      if (fieldName === DOMAIN_FIELD_HIDDEN) {
        value = !value;
      }
      this.setState({
        [fieldName]: value
      });
    });
    AdvancedSettings_defineProperty(this, "handleChange", evt => {
      const fieldName = getNameFromId(evt.target.id);
      this.setState({
        [fieldName]: evt.target.value
      });
    });
    AdvancedSettings_defineProperty(this, "handleSetDefaultValues", evt => {
      const {
        domainId,
        helpNoun
      } = this.props;
      if (!this.hasValidDomainId()) {
        alert('Must save ' + helpNoun + ' before you can set default values.');
      } else {
        const params = {
          domainId,
          returnUrl: window.location
        };
        let controller = 'list';
        let action = 'setDefaultValuesList';
        if (api_.ActionURL.getController() === 'assay') {
          controller = 'assay';
          action = 'setDefaultValuesAssay';
          params['providerName'] = api_.ActionURL.getParameter('providerName');
        }
        window.location.href = api_.ActionURL.buildURL(controller, action, undefined, params);
      }
    });
    AdvancedSettings_defineProperty(this, "getPhiHelpText", () => {
      return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, "Sets Protected Health Information (PHI) level for this field."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: PROPERTY_FIELDS_PHI_TOPIC
      }, "protecting PHI"), " in LabKey."));
    });
    AdvancedSettings_defineProperty(this, "getDefaultTypeHelpText", () => {
      return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, "Editable default: Provides the same default value for every user, which allows editing."), /*#__PURE__*/external_react_default().createElement("p", null, "Fixed value: Provides fixed data with each inserted data row that cannot be edited."), /*#__PURE__*/external_react_default().createElement("p", null, "Last entered: An editable default value is provided on first use. The last value entered will be provided on later imports."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: ADVANCED_FIELD_EDITOR_TOPIC
      }, "Default Type"), ' ', "settings."));
    });
    AdvancedSettings_defineProperty(this, "getPhiLevelIndex", phi => {
      return DOMAIN_PHI_LEVELS.findIndex(level => {
        return level.value === phi;
      });
    });
    AdvancedSettings_defineProperty(this, "showDefaultValues", () => {
      const {
        field,
        showDefaultValueSettings
      } = this.props;

      // some domains just don't support default values
      if (!showDefaultValueSettings) return false;

      // Not shown for file types or calculated fields
      if (field.dataType.isFileType() || field.isCalculatedField()) return false;
      return !this.props.defaultValueOptions.isEmpty();
    });
    AdvancedSettings_defineProperty(this, "renderDisplayOptions", () => {
      const {
        hidden,
        shownInDetailsView,
        shownInInsertView,
        shownInUpdateView
      } = this.state;
      const {
        index,
        domainIndex,
        field
      } = this.props;
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-adv-display-options"
      }, "Display Options"), /*#__PURE__*/external_react_default().createElement("div", null, "These options configure how and in which views this field will be visible."), /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: hidden === false,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_HIDDEN),
        id: createFormInputId(DOMAIN_FIELD_HIDDEN, domainIndex, index)
      }, "Show field on default view of the grid"), !field.isCalculatedField() && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: shownInUpdateView === true,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_SHOWNINUPDATESVIEW),
        id: createFormInputId(DOMAIN_FIELD_SHOWNINUPDATESVIEW, domainIndex, index)
      }, "Show on update form when updating a single row of data"), /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: shownInInsertView === true,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_SHOWNININSERTVIEW),
        id: createFormInputId(DOMAIN_FIELD_SHOWNININSERTVIEW, domainIndex, index)
      }, "Show on insert form when updating a single row of data")), /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: shownInDetailsView === true,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_SHOWNINDETAILSVIEW),
        id: createFormInputId(DOMAIN_FIELD_SHOWNINDETAILSVIEW, domainIndex, index)
      }, "Show on details page for a single row"));
    });
    AdvancedSettings_defineProperty(this, "renderDefaultValues", () => {
      const {
        index,
        defaultValueOptions,
        domainIndex
      } = this.props;
      const {
        defaultValueType,
        defaultDisplayValue
      } = this.state;
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-adv-misc-options"
      }, "Default Value Options"), /*#__PURE__*/external_react_default().createElement("div", {
        className: "row domain-adv-thick-row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
        label: "Default Type",
        helpTipBody: this.getDefaultTypeHelpText()
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/external_react_default().createElement("select", {
        className: "form-control",
        name: createFormInputName(DOMAIN_FIELD_DEFAULT_VALUE_TYPE),
        id: createFormInputId(DOMAIN_FIELD_DEFAULT_VALUE_TYPE, domainIndex, index),
        onChange: this.handleChange,
        value: defaultValueType
      }, defaultValueOptions.map(level => /*#__PURE__*/external_react_default().createElement("option", {
        key: level,
        value: level
      }, DOMAIN_DEFAULT_TYPES[level])))), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-3"
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/external_react_default().createElement("span", null, "Default Value")), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-9"
      }, /*#__PURE__*/external_react_default().createElement("span", null, defaultDisplayValue !== undefined && defaultDisplayValue !== null ? defaultDisplayValue : ''), /*#__PURE__*/external_react_default().createElement("a", {
        style: {
          marginLeft: '20px'
        },
        onClick: this.handleSetDefaultValues,
        className: "domain-adv-link"
      }, "Set Default Values"))));
    });
    AdvancedSettings_defineProperty(this, "renderMiscOptions", () => {
      const {
        index,
        field,
        domainIndex,
        domainFormDisplayOptions,
        allowUniqueConstraintProperties
      } = this.props;
      const {
        measure,
        dimension,
        mvEnabled,
        recommendedVariable,
        uniqueConstraint,
        PHI,
        excludeFromShifting,
        phiLevels
      } = this.state;
      const currentValueExists = phiLevels?.find(level => level.value === PHI) !== undefined;
      const disablePhiSelect = domainFormDisplayOptions.phiLevelDisabled || field.disablePhiLevel || PHI !== undefined && !currentValueExists;
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-adv-misc-options"
      }, "Miscellaneous Options"), !field.isCalculatedField() && /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
        label: "PHI Level",
        helpTipBody: this.getPhiHelpText()
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/external_react_default().createElement("select", {
        className: "form-control",
        name: createFormInputName(DOMAIN_FIELD_PHI),
        id: createFormInputId(DOMAIN_FIELD_PHI, domainIndex, index),
        onChange: this.handleChange,
        value: PHI,
        disabled: disablePhiSelect
      }, !currentValueExists && /*#__PURE__*/external_react_default().createElement("option", {
        key: PHI,
        value: PHI
      }, DOMAIN_PHI_LEVELS.find(level => level.value === PHI)?.label ?? PHI), phiLevels.map(level => /*#__PURE__*/external_react_default().createElement("option", {
        key: level.value,
        value: level.value
      }, level.label)))), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-3"
      })), field.dataType === DATETIME_TYPE && /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: excludeFromShifting,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_EXCLUDE_FROM_SHIFTING),
        id: createFormInputId(DOMAIN_FIELD_EXCLUDE_FROM_SHIFTING, domainIndex, index)
      }, "Exclude from \"Participant Date Shifting\" on export/publication", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: "Exclude from Date Shifting"
      }, "Participant date fields with this property checked will not be shifted on export/publication when the \"Shift Participant Dates\" option is selected.")), PropDescType.isMeasure(field.dataType.rangeURI) && /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: measure,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_MEASURE),
        id: createFormInputId(DOMAIN_FIELD_MEASURE, domainIndex, index)
      }, "Make this field available as a measure", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: "Measure"
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, "Indicates fields that contain data subject to charting and other analysis. These are typically numeric results."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: CHART_MEASURES_AND_DIMENSIONS_TOPIC
      }, "Measures and Dimensions"), ' ', "for analysis.")))), PropDescType.isDimension(field.dataType.rangeURI) && /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: dimension,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_DIMENSION),
        id: createFormInputId(DOMAIN_FIELD_DIMENSION, domainIndex, index)
      }, "Make this field available as a dimension", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: "Data Dimension"
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, "Indicates a field of non-numerical categories that can be included in a chart. Dimensions define logical groupings of measures."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: CHART_MEASURES_AND_DIMENSIONS_TOPIC
      }, "Measures and Dimensions"), ' ', "for analysis.")))), /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: recommendedVariable,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_RECOMMENDEDVARIABLE),
        id: createFormInputId(DOMAIN_FIELD_RECOMMENDEDVARIABLE, domainIndex, index)
      }, "Make this field a recommended variable", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: "Recommended Variable"
      }, /*#__PURE__*/external_react_default().createElement("div", null, "Indicates that this is an important variable. These variables will be displayed as recommended when creating new charts or reports."))), PropDescType.isMvEnableable(field.dataType.rangeURI) && !field.isCalculatedField() && /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: mvEnabled,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_MVENABLED),
        id: createFormInputId(DOMAIN_FIELD_MVENABLED, domainIndex, index),
        disabled: domainFormDisplayOptions.disableMvEnabled
      }, "Track reason for missing data values", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: "Missing Value Indicators"
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, "Fields using this can hold special values to indicate data that has failed review or was originally missing. Administrators can set custom Missing Value indicators at the site and folder levels."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: MISSING_VALUES_TOPIC
      }, "Missing Value Indicators"))))), allowUniqueConstraintProperties && !field.isCalculatedField() && /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        checked: uniqueConstraint || field.isPrimaryKey,
        disabled: field.isPrimaryKey,
        onChange: this.handleCheckbox,
        name: createFormInputName(DOMAIN_FIELD_UNIQUECONSTRAINT),
        id: createFormInputId(DOMAIN_FIELD_UNIQUECONSTRAINT, domainIndex, index)
      }, "Require all values to be unique", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
        title: "Unique Constraint"
      }, /*#__PURE__*/external_react_default().createElement("div", null, "Add a unique constraint via a database-level index for this field."))));
    });
    this.state = this.getInitialState(this.props.field, this.props.domainId, this.props.defaultDefaultValueType);
  }
  componentDidMount() {
    this.initializeState();
  }
  hasValidDomainId() {
    const {
      domainId
    } = this.props;
    return !(domainId === undefined || domainId === null || domainId === 0);
  }
  render() {
    const {
      label
    } = this.props;
    const title = 'Advanced Settings and Properties' + (label ? ' for ' + label : '');
    const footer = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("button", {
      className: "domain-adv-footer domain-adv-cancel-btn btn btn-default",
      onClick: this.handleClose,
      type: "button"
    }, "Cancel"), /*#__PURE__*/external_react_default().createElement(HelpLink, {
      topic: ADVANCED_FIELD_EDITOR_TOPIC,
      className: "domain-adv-footer domain-adv-link"
    }, "Get help with field designer settings"), /*#__PURE__*/external_react_default().createElement("button", {
      className: `domain-adv-footer domain-adv-apply-btn btn btn-${getSubmitButtonClass()}`,
      onClick: this.handleApply,
      type: "button"
    }, "Apply"));
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      footer: footer,
      onCancel: this.handleClose,
      title: title
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-modal"
    }, this.renderDisplayOptions(), this.showDefaultValues() && this.renderDefaultValues(), this.renderMiscOptions()));
  }
}
AdvancedSettings_defineProperty(AdvancedSettings, "defaultProps", {
  domainFormDisplayOptions: DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/ConfirmDataTypeChangeModal.tsx




const ConfirmDataTypeChangeModal = (0,external_react_.memo)(props => {
  const {
    originalRangeURI,
    newDataType,
    onConfirm,
    onCancel
  } = props;
  const origTypeLabel = getDataTypeConfirmDisplayText(originalRangeURI);
  const newTypeLabel = getDataTypeConfirmDisplayText(newDataType.rangeURI);
  const reversible = PropDescType.isDate(originalRangeURI) && PropDescType.isDateTime(newDataType.rangeURI) || PropDescType.isDateTime(originalRangeURI) && PropDescType.isDate(newDataType.rangeURI);
  let dataLossWarning = null;
  if (originalRangeURI === DATETIME_RANGE_URI && (newDataType.rangeURI === DATE_RANGE_URI || newDataType.rangeURI === TIME_RANGE_URI)) {
    dataLossWarning = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "This will cause the ", newDataType.rangeURI === DATE_RANGE_URI ? 'Time' : 'Date', " portion of the value to be ", /*#__PURE__*/external_react_default().createElement("span", {
      className: "bold-text"
    }, "removed"), ".", ' ');
  }
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    title: "Confirm Data Type Change",
    onConfirm: onConfirm,
    onCancel: onCancel,
    confirmClass: "btn-danger",
    confirmText: "Yes, Change Data Type"
  }, /*#__PURE__*/external_react_default().createElement("div", null, "This change will convert the values in the field from", ' ', /*#__PURE__*/external_react_default().createElement("span", {
    className: "domain-field-confirm-datatype"
  }, origTypeLabel), " to", ' ', /*#__PURE__*/external_react_default().createElement("span", {
    className: "domain-field-confirm-datatype"
  }, newTypeLabel), ". ", dataLossWarning, !reversible && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "Once you save your changes, you will not be able to change it back to", ' ', /*#__PURE__*/external_react_default().createElement("span", {
    className: "domain-field-confirm-datatype"
  }, origTypeLabel), ".", ' '), "Would you like to continue?"));
});

// exported for jest testing
const getDataTypeConfirmDisplayText = rangeURI => {
  if (rangeURI === INT_RANGE_URI) return 'integer';
  if (rangeURI === MULTILINE_RANGE_URI) return 'string';
  if (rangeURI === FILELINK_RANGE_URI) return 'file';
  return rangeURI.substring(rangeURI.indexOf('#') + 1);
};
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/Collapsible.tsx


const Collapsible = (0,external_react_.memo)(({
  children,
  className,
  expanded
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: external_classnames_default()('collapse', className, {
    in: expanded
  })
}, children));
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainRow.tsx
function DomainRow_extends() { return DomainRow_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DomainRow_extends.apply(null, arguments); }
function DomainRow_defineProperty(e, r, t) { return (r = DomainRow_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DomainRow_toPropertyKey(t) { var i = DomainRow_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DomainRow_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




















/**
 * React component for one property in a domain
 */
class DomainRow extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    DomainRow_defineProperty(this, "ref", void 0);
    // Used in DomainPropertiesGrid
    DomainRow_defineProperty(this, "scrollIntoView", () => {
      this.ref.current.scrollIntoView({
        behavior: 'smooth'
      });
    });
    DomainRow_defineProperty(this, "getDetails", () => {
      const {
        field,
        fieldDetailsInfo,
        fieldError,
        index,
        expanded,
        domainIndex
      } = this.props;
      const details = field.getDetailsArray(index, fieldDetailsInfo);
      if (fieldError) {
        details.push(details.length > 0 ? '. ' : '');
        details.push( /*#__PURE__*/external_react_default().createElement(DomainRowWarning, {
          fieldError: fieldError
        }));
      }
      return /*#__PURE__*/external_react_default().createElement("div", {
        id: createFormInputId(DOMAIN_FIELD_DETAILS, domainIndex, index),
        className: expanded ? 'domain-field-details-expanded' : 'domain-field-details'
      }, details);
    });
    DomainRow_defineProperty(this, "getFieldBorderClass", (fieldError, selected) => {
      if (!fieldError) {
        return selected ? 'domain-row-border-selected' : 'domain-row-border-default';
      } else if (fieldError.severity === constants_SEVERITY_LEVEL_ERROR) {
        return 'domain-row-border-error';
      } else {
        return 'domain-row-border-warning';
      }
    });
    DomainRow_defineProperty(this, "getRowCssClasses", (expanded, dragging, selected, fieldError) => {
      const classes = [];
      classes.push('domain-field-row');
      if (selected) {
        classes.push('selected');
      }
      if (!dragging) {
        classes.push(this.getFieldBorderClass(fieldError, selected));
      } else {
        classes.push('domain-row-border-dragging');
      }
      if (expanded) {
        classes.push('domain-row-expanded');
      }
      return classes.join(' ');
    });
    DomainRow_defineProperty(this, "onFieldChange", (evt, expand) => {
      const {
        index
      } = this.props;
      let value = getCheckedValue(evt);
      if (value === undefined) {
        value = evt.target.value;
      }
      this.onSingleFieldChange(evt.target.id, value, index, expand);
    });
    DomainRow_defineProperty(this, "onSingleFieldChange", (id, value, index, expand) => {
      const changes = (0,external_immutable_.List)([{
        id,
        value
      }]);
      this.props.onChange(changes, index, expand === true);
    });
    DomainRow_defineProperty(this, "onMultiFieldChange", changes => {
      this.props.onChange(changes, this.props.index, true);
    });
    DomainRow_defineProperty(this, "onNameChange", evt => {
      const {
        index,
        domainIndex
      } = this.props;
      const value = evt.target.value;
      let nameAndErrorList = (0,external_immutable_.List)();

      // set value for the field
      nameAndErrorList = nameAndErrorList.push({
        id: createFormInputId(DOMAIN_FIELD_NAME, domainIndex, index),
        value
      });
      if (isLegalName(value) && !value.includes(' ')) {
        // set value to undefined for field error
        nameAndErrorList = nameAndErrorList.push({
          id: createFormInputId(DOMAIN_FIELD_CLIENT_SIDE_ERROR, domainIndex, index),
          value: undefined
        });
      } else {
        const fieldName = value;
        const severity = constants_SEVERITY_LEVEL_WARN;
        const indexes = (0,external_immutable_.List)([index]);
        const domainFieldError = new DomainFieldError({
          message: FIELD_NAME_CHAR_WARNING_MSG,
          extraInfo: FIELD_NAME_CHAR_WARNING_INFO,
          fieldName,
          propertyId: undefined,
          severity,
          rowIndexes: indexes
        });

        // set value for field error
        nameAndErrorList = nameAndErrorList.push({
          id: createFormInputId(DOMAIN_FIELD_CLIENT_SIDE_ERROR, domainIndex, index),
          value: domainFieldError
        });
      }
      this.props.onChange(nameAndErrorList, index, false);
    });
    DomainRow_defineProperty(this, "onDataTypeChange", evt => {
      const {
        field
      } = this.props;
      const {
        value
      } = evt.target;

      // warn for a saved field changing from any non-string -> string OR int/long -> double/float/decimal
      if (field.isSaved()) {
        const typeConvertingTo = PropDescType.fromName(value);
        if (shouldShowConfirmDataTypeChange(field.original.rangeURI, typeConvertingTo.rangeURI)) {
          this.onShowConfirmTypeChange(value);
          return;
        }
      }
      this.onFieldChange(evt, PropDescType.isLookup(value) || PropDescType.isTextChoice(value) || PropDescType.isUser(value) || PropDescType.isCalculation(value));
    });
    DomainRow_defineProperty(this, "onShowConfirmTypeChange", dataTypeChangeToConfirm => {
      this.setState({
        dataTypeChangeToConfirm
      });
      this.setDragDisabled(this.props.isDragDisabled, true);
    });
    DomainRow_defineProperty(this, "onConfirmTypeChange", () => {
      const {
        domainIndex,
        index
      } = this.props;
      const {
        dataTypeChangeToConfirm
      } = this.state;
      const evt = {
        target: {
          id: createFormInputId(DOMAIN_FIELD_TYPE, domainIndex, index),
          value: dataTypeChangeToConfirm
        }
      };
      this.onFieldChange(evt, PropDescType.isLookup(dataTypeChangeToConfirm) || PropDescType.isTextChoice(dataTypeChangeToConfirm));
      this.onHideConfirmTypeChange();
    });
    DomainRow_defineProperty(this, "onHideConfirmTypeChange", () => {
      this.setState({
        dataTypeChangeToConfirm: undefined
      });
      this.setDragDisabled(this.props.isDragDisabled, false);
    });
    DomainRow_defineProperty(this, "onShowAdvanced", () => {
      this.setState({
        showAdv: true
      });
      this.setDragDisabled(this.props.isDragDisabled, true);
    });
    DomainRow_defineProperty(this, "onHideAdvanced", () => {
      this.setState({
        showAdv: false
      });
      this.setDragDisabled(this.props.isDragDisabled, false);
    });
    DomainRow_defineProperty(this, "onDelete", () => {
      this.props.onDelete(this.props.index);
    });
    DomainRow_defineProperty(this, "onExpand", () => {
      this.props.onExpand(this.props.index);
    });
    DomainRow_defineProperty(this, "setDragDisabled", (propDragDisabled, disabled) => {
      this.setState({
        isDragDisabled: disabled || propDragDisabled
      });
    });
    DomainRow_defineProperty(this, "showingModal", showingModal => {
      this.setState({
        showingModal
      });
    });
    DomainRow_defineProperty(this, "disableNameInput", field => {
      const lockNameForPK = !field.isNew() && isPrimaryKeyFieldLocked(field.lockType);
      return isFieldPartiallyLocked(field.lockType) || isFieldFullyLocked(field.lockType) || lockNameForPK || field.lockExistingField // existingField defaults to false. used for query metadata editor
      ;
    });
    DomainRow_defineProperty(this, "disableTypeInput", field => {
      return !field.isNew() && (field.isPrimaryKey || field.isCalculatedField()) || isFieldPartiallyLocked(field.lockType) || isFieldFullyLocked(field.lockType) || isPrimaryKeyFieldLocked(field.lockType);
    });
    DomainRow_defineProperty(this, "renderBaseFields", () => {
      const {
        index,
        field,
        availableTypes,
        appPropertiesOnly,
        domainIndex,
        domainFormDisplayOptions
      } = this.props;
      return /*#__PURE__*/external_react_default().createElement("div", {
        id: createFormInputId(DOMAIN_FIELD_ROW, domainIndex, index),
        ref: this.ref
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/external_react_default().createElement("input", {
        className: "form-control",
        type: "text",
        value: field.name || '',
        name: createFormInputName(DOMAIN_FIELD_NAME),
        id: createFormInputId(DOMAIN_FIELD_NAME, domainIndex, index),
        onChange: this.onNameChange,
        disabled: this.disableNameInput(field)
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/external_react_default().createElement("select", {
        className: "form-control",
        name: createFormInputName(DOMAIN_FIELD_TYPE),
        disabled: this.disableTypeInput(field),
        id: createFormInputId(DOMAIN_FIELD_TYPE, domainIndex, index),
        onChange: this.onDataTypeChange,
        value: field.dataType.name
      }, isPrimaryKeyFieldLocked(field.lockType) ? /*#__PURE__*/external_react_default().createElement("option", {
        value: field.dataType.name
      }, field.dataType.display) : resolveAvailableTypes(field, availableTypes, appPropertiesOnly, !domainFormDisplayOptions.hideStudyPropertyTypes, !domainFormDisplayOptions.hideFilePropertyType).sort(naturalSortByProperty('display')).map(type => /*#__PURE__*/external_react_default().createElement("option", {
        key: type.name,
        value: type.name
      }, type.display)))), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-2"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-field-checkbox-container"
      }, !domainFormDisplayOptions.hideRequired && !field.isCalculatedField() && /*#__PURE__*/external_react_default().createElement(DomainDesignerCheckbox, {
        className: "domain-field-checkbox",
        name: createFormInputName(DOMAIN_FIELD_REQUIRED),
        id: createFormInputId(DOMAIN_FIELD_REQUIRED, domainIndex, index),
        checked: field.required,
        onChange: this.onFieldChange,
        disabled: isFieldFullyLocked(field.lockType) || isPrimaryKeyFieldLocked(field.lockType)
      }))));
    });
    DomainRow_defineProperty(this, "renderButtons", () => {
      const {
        expanded,
        index,
        field,
        appPropertiesOnly,
        domainIndex
      } = this.props;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: expanded ? 'domain-field-buttons-expanded' : 'domain-field-buttons'
      }, expanded && !isFieldFullyLocked(field.lockType) && !appPropertiesOnly && /*#__PURE__*/external_react_default().createElement("button", {
        className: "domain-row-button btn btn-default",
        disabled: isFieldFullyLocked(field.lockType),
        id: createFormInputId(DOMAIN_FIELD_ADV, domainIndex, index),
        name: createFormInputName(DOMAIN_FIELD_ADV),
        onClick: this.onShowAdvanced,
        type: "button"
      }, "Advanced Settings"), isFieldDeletable(field) && /*#__PURE__*/external_react_default().createElement(DeleteIcon, {
        id: createFormInputId(DOMAIN_FIELD_DELETE, domainIndex, index),
        title: "Remove field",
        iconCls: "domain-field-delete-icon",
        onDelete: this.onDelete
      }));
    });
    this.state = {
      showAdv: false,
      showingModal: false,
      dataTypeChangeToConfirm: undefined,
      isDragDisabled: props.isDragDisabled
    };
    this.ref = external_react_default().createRef();
  }
  componentDidUpdate(prevProps) {
    // if there was a prop change to isDragDisabled, need to call setDragDisabled
    if (prevProps.isDragDisabled !== this.props.isDragDisabled) {
      this.setDragDisabled(this.props.isDragDisabled, false);
    }
  }
  render() {
    const {
      isDragDisabled,
      showAdv,
      showingModal,
      dataTypeChangeToConfirm
    } = this.state;
    const {
      index,
      field,
      expanded,
      fieldError,
      maxPhiLevel,
      dragging,
      domainId,
      domainIndex,
      helpNoun,
      showDefaultValueSettings,
      allowUniqueConstraintProperties,
      defaultDefaultValueType,
      defaultValueOptions,
      appPropertiesOnly,
      domainFormDisplayOptions,
      getDomainFields,
      domainContainerPath,
      schemaName,
      queryName
    } = this.props;
    const selected = field.selected;
    return /*#__PURE__*/external_react_default().createElement(external_react_beautiful_dnd_.Draggable, {
      draggableId: createFormInputId('domaindrag', domainIndex, index),
      index: index,
      isDragDisabled: showingModal || isDragDisabled,
      key: index
    }, provided => /*#__PURE__*/external_react_default().createElement("div", DomainRow_extends({
      className: this.getRowCssClasses(expanded, dragging, selected, fieldError)
    }, provided.draggableProps, {
      ref: provided.innerRef,
      tabIndex: index
    }), /*#__PURE__*/external_react_default().createElement("div", {
      key: createFormInputId('domainrow', domainIndex, index),
      className: "row domain-row-container"
    }, showAdv && /*#__PURE__*/external_react_default().createElement(AdvancedSettings, {
      domainIndex: domainIndex,
      domainId: domainId,
      helpNoun: helpNoun,
      index: index,
      maxPhiLevel: maxPhiLevel,
      field: field,
      onApply: this.onMultiFieldChange,
      onHide: this.onHideAdvanced,
      label: field.name,
      showDefaultValueSettings: showDefaultValueSettings,
      allowUniqueConstraintProperties: allowUniqueConstraintProperties,
      defaultDefaultValueType: defaultDefaultValueType,
      defaultValueOptions: defaultValueOptions,
      domainFormDisplayOptions: domainFormDisplayOptions
    }), /*#__PURE__*/external_react_default().createElement("div", DomainRow_extends({
      className: external_classnames_default()('domain-row-handle', {
        disabled: isDragDisabled
      })
    }, provided.dragHandleProps), /*#__PURE__*/external_react_default().createElement(DragDropHandle, {
      highlighted: dragging ? true : isDragDisabled ? false : undefined /* use undefined instead of false to allow for css to handle the highlight color for hover*/
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-row-action-section"
    }, /*#__PURE__*/external_react_default().createElement(DomainDesignerCheckbox, {
      className: "domain-field-check-icon",
      name: createFormInputName(DOMAIN_FIELD_SELECTED),
      id: createFormInputId(DOMAIN_FIELD_SELECTED, domainIndex, index),
      checked: selected,
      onChange: this.onFieldChange,
      disabled: false
    }), /*#__PURE__*/external_react_default().createElement(FieldExpansionToggle, {
      cls: "domain-field-expand-icon",
      expanded: expanded,
      expandedTitle: "Hide additional field properties",
      collapsedTitle: "Show additional field properties",
      id: createFormInputId(DOMAIN_FIELD_EXPAND, domainIndex, index),
      onClick: this.onExpand
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-row-main"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-6 domain-row-base-fields domain-row-base-fields-position"
    }, this.renderBaseFields()), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-6 domain-row-details-container"
    }, this.getDetails(), this.renderButtons()))), /*#__PURE__*/external_react_default().createElement(Collapsible, {
      expanded: expanded
    }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(DomainRowExpandedOptions, {
      field: field,
      index: index,
      domainIndex: domainIndex,
      getDomainFields: getDomainFields,
      onMultiChange: this.onMultiFieldChange,
      onChange: this.onSingleFieldChange,
      showingModal: this.showingModal,
      appPropertiesOnly: appPropertiesOnly,
      domainFormDisplayOptions: domainFormDisplayOptions,
      domainContainerPath: domainContainerPath,
      schemaName: schemaName,
      queryName: queryName
    }))), dataTypeChangeToConfirm && /*#__PURE__*/external_react_default().createElement(ConfirmDataTypeChangeModal, {
      originalRangeURI: field.original.rangeURI,
      newDataType: PropDescType.fromName(dataTypeChangeToConfirm),
      onConfirm: this.onConfirmTypeChange,
      onCancel: this.onHideConfirmTypeChange
    })));
  }
}
DomainRow_defineProperty(DomainRow, "defaultProps", {
  domainFormDisplayOptions: DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS
});
const shouldShowConfirmDataTypeChange = (originalRangeURI, newRangeURI) => {
  if (newRangeURI && originalRangeURI !== newRangeURI) {
    const wasString = STRING_CONVERT_URIS.indexOf(originalRangeURI) > -1;
    const toString = STRING_CONVERT_URIS.indexOf(newRangeURI) > -1;
    const toNumber = NUMBER_CONVERT_URIS.indexOf(newRangeURI) > -1;
    const toDate = DATETIME_CONVERT_URIS.indexOf(newRangeURI) > -1;
    return toNumber || toString && !wasString || toDate;
  }
  return false;
};
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/CollapsiblePanelHeader.tsx
function CollapsiblePanelHeader_defineProperty(e, r, t) { return (r = CollapsiblePanelHeader_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function CollapsiblePanelHeader_toPropertyKey(t) { var i = CollapsiblePanelHeader_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function CollapsiblePanelHeader_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class CollapsiblePanelHeader extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    CollapsiblePanelHeader_defineProperty(this, "getHeaderIconHelpMsg", () => {
      const {
        isValid,
        panelStatus,
        iconHelpMsg,
        todoIconHelpMsg
      } = this.props;
      if (!isValid) {
        return iconHelpMsg;
      }
      if (panelStatus === 'TODO') {
        return todoIconHelpMsg || 'This section does not contain any user-defined fields. You may want to review.';
      }
      return undefined;
    });
    CollapsiblePanelHeader_defineProperty(this, "getHeaderIconComponent", () => {
      const {
        collapsed,
        isValid,
        panelStatus
      } = this.props;
      const validComplete = isValid && panelStatus === 'COMPLETE';
      const wrapperClassName = external_classnames_default()('domain-panel-status-icon', {
        'domain-panel-status-icon-green': collapsed && validComplete,
        'domain-panel-status-icon-blue': collapsed && !validComplete
      });
      const iconClassName = !isValid || panelStatus === 'TODO' ? 'fa fa-exclamation-circle' : 'fa fa-check-circle';
      return /*#__PURE__*/external_react_default().createElement("span", {
        className: wrapperClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: iconClassName
      }));
    });
    CollapsiblePanelHeader_defineProperty(this, "getTitlePrefix", () => {
      let prefix = this.props.titlePrefix;

      // ellipsis after certain length
      if (prefix && prefix.length > 70) {
        prefix = prefix.substr(0, 70) + '...';
      }
      return prefix ? prefix + ' - ' : '';
    });
  }
  render() {
    const {
      children,
      collapsed,
      collapsible,
      controlledCollapse,
      headerDetails,
      id,
      panelStatus,
      title,
      togglePanel
    } = this.props;
    const isApp_ = isApp();
    const iconHelpMsg = panelStatus && panelStatus !== 'NONE' ? this.getHeaderIconHelpMsg() : undefined;
    const collapsedIconClass = external_classnames_default()('fa', 'fa-lg', {
      'fa-chevron-right': collapsed,
      'fa-chevron-down': !collapsed,
      'domain-form-expand-btn': collapsed,
      'domain-form-collapse-btn': !collapsed
    });
    const panelHeaderClass = external_classnames_default()('domain-panel-header', {
      'panel-heading': isApp_,
      'domain-heading-collapsible': collapsible || controlledCollapse,
      'domain-panel-header-expanded': !collapsed,
      'domain-panel-header-collapsed': collapsed,
      'labkey-page-nav': !collapsed && !isApp_,
      'domain-panel-header-no-theme': !collapsed && isApp_
    });
    return /*#__PURE__*/external_react_default().createElement("div", {
      id: id,
      onClick: togglePanel,
      className: panelHeaderClass
    }, iconHelpMsg && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      iconComponent: this.getHeaderIconComponent(),
      title: title
    }, iconHelpMsg), panelStatus && panelStatus !== 'NONE' && !iconHelpMsg && this.getHeaderIconComponent(), /*#__PURE__*/external_react_default().createElement("span", {
      className: "domain-panel-title"
    }, this.getTitlePrefix() + title), (controlledCollapse || collapsible) && /*#__PURE__*/external_react_default().createElement("span", {
      className: "pull-right"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: collapsedIconClass
    })), children && /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      title: title
    }, children), controlledCollapse && headerDetails && /*#__PURE__*/external_react_default().createElement("span", {
      className: "domain-panel-header-fields-defined"
    }, headerDetails));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/ImportDataFilePreview.tsx
function ImportDataFilePreview_defineProperty(e, r, t) { return (r = ImportDataFilePreview_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ImportDataFilePreview_toPropertyKey(t) { var i = ImportDataFilePreview_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ImportDataFilePreview_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class ImportDataFilePreview extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    ImportDataFilePreview_defineProperty(this, "onToggleClick", () => {
      const {
        setFileImportData,
        file
      } = this.props;
      this.setState(state => ({
        shouldImportData: !state.shouldImportData
      }), () => {
        setFileImportData(file, this.state.shouldImportData);
      });
    });
    this.state = {
      shouldImportData: true
    };
  }
  render() {
    const {
      filePreviewData,
      noun,
      file
    } = this.props;
    const {
      shouldImportData
    } = this.state;
    if (filePreviewData == null) {
      return;
    }
    const data = convertRowDataIntoPreviewData(filePreviewData.get('data'), 4);
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-form__file-preview"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-form__file-preview__text"
    }, "Import data from this file upon ", noun, " creation? "), /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-form__file-preview__toggle"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      type: "checkbox",
      id: "domain__import-data__file-enabled",
      checked: shouldImportData,
      onChange: this.onToggleClick
    }), file && /*#__PURE__*/external_react_default().createElement("span", {
      className: "domain__import-data__file-title"
    }, " ", file.name, " ")), shouldImportData && this.props.children, shouldImportData && /*#__PURE__*/external_react_default().createElement(FilePreviewGrid, {
      previewCount: 4,
      data: data,
      header: null
    }));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainPropertiesGrid.tsx
function DomainPropertiesGrid_defineProperty(e, r, t) { return (r = DomainPropertiesGrid_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DomainPropertiesGrid_toPropertyKey(t) { var i = DomainPropertiesGrid_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DomainPropertiesGrid_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







class DomainPropertiesGrid extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    DomainPropertiesGrid_defineProperty(this, "getVisibleGridData", gridData => {
      return gridData.filter(row => row.get('visible'));
    });
    DomainPropertiesGrid_defineProperty(this, "uponRowAdd", newGridData => {
      const {
        gridData,
        visibleGridData
      } = this.state;
      const updatedGridData = gridData.push(newGridData.get(-1));
      const updatedVisibleGridData = visibleGridData.push(newGridData.get(-1));
      this.setState({
        gridData: updatedGridData,
        visibleGridData: updatedVisibleGridData
      });
    });
    DomainPropertiesGrid_defineProperty(this, "uponRowDelete", () => {
      const {
        appPropertiesOnly,
        domain,
        hasOntologyModule
      } = this.props;
      const {
        gridData
      } = this.state;
      const initGridData = domain.getGridData(appPropertiesOnly, hasOntologyModule);

      // Handle bug that occurs if multiple fields have the same name
      const replaceGridData = new Set(gridData.map(row => row.get('name')).toJS()).size !== gridData.size;
      if (replaceGridData) {
        this.setState({
          gridData: initGridData,
          visibleGridData: this.getVisibleGridData(initGridData)
        });
        return;
      }
      const updatedGridData = gridData.reduce((updatedGridData, row) => {
        const newRowIndex = initGridData.findIndex(newRow => newRow.get('name') === row.get('name'));
        return newRowIndex !== -1 ? updatedGridData.set(updatedGridData.size, row.set('fieldIndex', newRowIndex)) : updatedGridData;
      }, (0,external_immutable_.List)());
      const visibleGridData = this.getVisibleGridData(updatedGridData);
      this.setState({
        gridData: updatedGridData,
        visibleGridData
      });
    });
    DomainPropertiesGrid_defineProperty(this, "uponFilter", () => {
      const {
        appPropertiesOnly,
        domain,
        hasOntologyModule
      } = this.props;
      const {
        gridData
      } = this.state;
      const initGridData = domain.getGridData(appPropertiesOnly, hasOntologyModule);
      const updatedGridData = gridData.map(row => {
        const nextRowIndex = initGridData.findIndex(nextRow => nextRow.get('fieldIndex') === row.get('fieldIndex'));
        return row.set('visible', initGridData.get(nextRowIndex).get('visible'));
      });
      const visibleGridData = this.getVisibleGridData(updatedGridData);
      this.setState({
        gridData: updatedGridData,
        visibleGridData
      });
    });
    DomainPropertiesGrid_defineProperty(this, "uponRowSelection", () => {
      const {
        appPropertiesOnly,
        domain,
        hasOntologyModule
      } = this.props;
      const {
        gridData
      } = this.state;
      const initGridData = domain.getGridData(appPropertiesOnly, hasOntologyModule);
      for (let i = 0; i < gridData.size; i++) {
        const row = gridData.get(i);
        const rowSelection = row.get('selected');
        const newRowIndex = initGridData.findIndex(newRow => newRow.get('fieldIndex') === row.get('fieldIndex'));
        const newRow = initGridData.get(newRowIndex);
        const newRowSelection = newRow.get('selected');
        if (rowSelection !== newRowSelection) {
          const updatedGridData = gridData.update(i, field => field.set('selected', newRowSelection));
          const visibleGridData = this.getVisibleGridData(updatedGridData);
          this.setState({
            gridData: updatedGridData,
            visibleGridData
          });
          break;
        }
      }
    });
    DomainPropertiesGrid_defineProperty(this, "sortColumn", (column, direction) => {
      const {
        gridData
      } = this.state;
      const sortedFields = gridData.sort((field1, field2) => {
        const col = column.index;
        return compareStringsAlphabetically(field1.get(col), field2.get(col), direction);
      });
      const updatedVisibleGridData = this.getVisibleGridData(sortedFields);
      this.setState({
        gridData: sortedFields,
        visibleGridData: updatedVisibleGridData
      });
    });
    DomainPropertiesGrid_defineProperty(this, "headerCell", (column, index, columnCount) => {
      const {
        selectAll,
        actions
      } = this.props;
      if (column.index === GRID_SELECTION_INDEX) {
        return /*#__PURE__*/external_react_default().createElement(DomainDesignerCheckbox, {
          className: "domain-summary-selectAll",
          checked: selectAll,
          onChange: actions.toggleSelectAll
        });
      }
      return headerCell(index, column, false, columnCount, this.sortColumn);
    });
    const {
      domain: _domain,
      actions: _actions,
      appPropertiesOnly: _appPropertiesOnly,
      hasOntologyModule: _hasOntologyModule
    } = this.props;
    const {
      onFieldsChange,
      scrollFunction
    } = _actions;
    const {
      domainKindName
    } = _domain;
    const _gridData = _domain.getGridData(_appPropertiesOnly, _hasOntologyModule);

    // TODO: Maintain hash of fieldIndex : gridIndex on state in order to make delete and filter run in N rather than N^2 time.
    this.state = {
      gridData: _gridData,
      gridColumns: _domain.getGridColumns(onFieldsChange, scrollFunction, domainKindName, _appPropertiesOnly, _hasOntologyModule),
      visibleGridData: this.getVisibleGridData(_gridData),
      search: this.props.search
    };
  }
  componentDidUpdate(prevProps) {
    const {
      appPropertiesOnly,
      domain,
      hasOntologyModule
    } = this.props;
    const prevSearch = prevProps.search;
    const newSearch = this.props.search;
    const prevGridData = prevProps.domain.getGridData(appPropertiesOnly, hasOntologyModule);
    const newGridData = domain.getGridData(appPropertiesOnly, hasOntologyModule);

    // When new field added
    if (prevGridData.size < newGridData.size) {
      this.uponRowAdd(newGridData);
      // When fields are deleted
    } else if (prevGridData.size > newGridData.size) {
      this.uponRowDelete();
      // When search is updated
    } else if (prevSearch !== newSearch) {
      this.uponFilter();
      // If selection updated
    } else {
      this.uponRowSelection();
    }
  }
  render() {
    const {
      visibleGridData,
      gridColumns
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement(Grid, {
      data: visibleGridData,
      columns: gridColumns,
      headerCell: this.headerCell,
      condensed: true,
      calcWidths: true
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/SystemFields.tsx
function SystemFields_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SystemFields_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SystemFields_ownKeys(Object(t), !0).forEach(function (r) { SystemFields_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SystemFields_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SystemFields_defineProperty(e, r, t) { return (r = SystemFields_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SystemFields_toPropertyKey(t) { var i = SystemFields_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SystemFields_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






const SYSTEM_FIELD_GRID_COLS = [new GridColumn({
  index: 'Name',
  title: 'Name'
}), new GridColumn({
  index: 'Label',
  title: 'Label'
}), new GridColumn({
  index: 'DataType',
  title: 'Data Type'
}), new GridColumn({
  index: 'Required',
  title: 'Required',
  cell: selected => {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-no-bind
      external_react_default().createElement("input", {
        className: "grid-panel__row-checkbox",
        type: "checkbox",
        disabled: true,
        checked: selected === true
      })
    );
  }
}), new GridColumn({
  index: 'Description',
  title: 'Description'
})];
const SystemFields = (0,external_react_.memo)(({
  fields,
  disabledSystemFields,
  onSystemFieldEnable
}) => {
  const [collapsed, setCollapsed] = (0,external_react_.useState)(false);
  const onToggle = (0,external_react_.useCallback)(() => {
    setCollapsed(!collapsed);
  }, [collapsed]);
  const gridData = (0,external_react_.useMemo)(() => {
    const data = [];
    const disabledFieldsLc = [];
    disabledSystemFields?.forEach(field => {
      disabledFieldsLc.push(field.toLowerCase());
    });
    fields.forEach(field => {
      const dataRow = SystemFields_objectSpread({}, field);
      const fieldName = field.Name;
      dataRow.Enabled = disabledFieldsLc.indexOf(fieldName?.toLowerCase()) === -1;
      data.push(dataRow);
    });
    return data;
  }, [fields, disabledSystemFields]);
  const systemFieldColumns = (0,external_react_.useMemo)(() => {
    const enabledColumn = new GridColumn({
      index: 'Enabled',
      title: 'Enabled',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cell: (selected, row) => {
        const onChange = event => {
          const checked = event.target.checked === true;
          onSystemFieldEnable(row.get('Name'), checked);
        };
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/jsx-no-bind
          external_react_default().createElement("input", {
            className: "grid-panel__row-checkbox",
            type: "checkbox",
            disabled: !row.get('Disableble'),
            checked: selected === true,
            onChange: onChange // eslint-disable-line
          })
        );
      }
    });
    return (0,external_immutable_.List)([enabledColumn, ...SYSTEM_FIELD_GRID_COLS]);
  }, [onSystemFieldEnable]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-system-fields"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-system-fields-header"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-system-fields-header__text",
    onClick: onToggle
  }, "Default System Fields"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-system-fields-header__icon",
    onClick: onToggle
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: external_classnames_default()('fa fa-lg', collapsed ? 'fa-chevron-right' : 'fa-chevron-down')
  })))), /*#__PURE__*/external_react_default().createElement(Collapsible, {
    expanded: !collapsed
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-system-fields__grid"
  }, /*#__PURE__*/external_react_default().createElement(Grid, {
    data: gridData,
    condensed: true,
    columns: systemFieldColumns
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-custom-fields-header__text"
  }, " Custom Fields "));
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainForm.tsx
function DomainForm_extends() { return DomainForm_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DomainForm_extends.apply(null, arguments); }
function DomainForm_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DomainForm_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DomainForm_ownKeys(Object(t), !0).forEach(function (r) { DomainForm_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DomainForm_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function DomainForm_defineProperty(e, r, t) { return (r = DomainForm_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DomainForm_toPropertyKey(t) { var i = DomainForm_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DomainForm_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






























/**
 * Form containing all properties of a domain
 */
class DomainFormImpl extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    DomainForm_defineProperty(this, "refsArray", void 0);
    DomainForm_defineProperty(this, "componentDidMount", async () => {
      const {
        domain,
        maxPhiLevel,
        onChange,
        api
      } = this.props;
      this.setState({
        isLoading: true
      });
      if (!maxPhiLevel) {
        try {
          const nextMaxPhiLevel = await api.getMaxPhiLevel(domain.container);
          this.setState({
            maxPhiLevel: nextMaxPhiLevel
          });
        } catch (error) {
          console.error('Unable to retrieve max PHI level.', error);
        }
      }

      // if the Ontology module is available, get the updated set of available data types
      if (hasModule(ONTOLOGY_MODULE_NAME)) {
        try {
          const availableTypes = await getAvailableTypesForOntology(api, domain);
          this.setState({
            availableTypes
          });
        } catch (error) {
          console.error('Failed to retrieve available types for Ontology.', error);
        }
      }
      onChange?.(this.validateDomain(domain), false);
      this.setState({
        isLoading: false
      });
    });
    DomainForm_defineProperty(this, "validateDomain", domain => {
      const invalidFields = domain.getInvalidFields();
      let newDomain;
      if (invalidFields.size > 0) {
        const exception = DomainException.clientValidationExceptions('Missing required field properties.', invalidFields);
        const exceptionWithAllErrors = DomainException.mergeWarnings(domain, exception);
        newDomain = domain.set('domainException', exceptionWithAllErrors ? exceptionWithAllErrors : exception);
      } else {
        newDomain = clearAllClientValidationErrors(domain);
      }
      return newDomain;
    });
    DomainForm_defineProperty(this, "toggleLocalPanel", collapsed => {
      const {
        domain,
        onChange
      } = this.props;
      this.setState(state => ({
        expandedRowIndex: undefined,
        collapsed: collapsed !== undefined ? collapsed : !state.collapsed
      }), () => {
        let newDomain = this.validateDomain(domain);
        newDomain = this.getFilteredFields(newDomain);
        onChange?.(newDomain, false);
      });
    });
    DomainForm_defineProperty(this, "togglePanel", () => {
      const {
        onToggle,
        collapsible,
        controlledCollapse
      } = this.props;
      if (collapsible || controlledCollapse) {
        if (onToggle) {
          onToggle(!this.state.collapsed, this.toggleLocalPanel);
        } else {
          this.toggleLocalPanel();
        }
      }
    });
    DomainForm_defineProperty(this, "setExpandedState", expandedRowIndex => {
      this.setState({
        expandedRowIndex
      });
    });
    DomainForm_defineProperty(this, "collapseRow", () => {
      if (this.isExpanded()) {
        this.setExpandedState(undefined);
      }
    });
    DomainForm_defineProperty(this, "expandRow", index => {
      const {
        domain
      } = this.props;
      const {
        expandedRowIndex
      } = this.state;
      if (expandedRowIndex !== index && index < domain.fields.size) {
        this.setExpandedState(index);
      }
    });
    DomainForm_defineProperty(this, "fastExpand", index => {
      const {
        domain
      } = this.props;
      const {
        expandedRowIndex
      } = this.state;
      if (expandedRowIndex !== index && index < domain.fields.size) {
        this.setExpandedState(index);
      }
    });
    DomainForm_defineProperty(this, "isExpanded", () => {
      return this.state.expandedRowIndex !== undefined;
    });
    DomainForm_defineProperty(this, "onFieldExpandToggle", index => {
      const {
        expandedRowIndex
      } = this.state;
      expandedRowIndex === index ? this.collapseRow() : this.expandRow(index);
    });
    DomainForm_defineProperty(this, "clearFilePreviewData", () => {
      this.setState(state => {
        const fieldCount = this.props.domain.fields.size;
        return {
          filePreviewData: fieldCount === 0 ? undefined : state.filePreviewData,
          file: fieldCount === 0 ? undefined : state.file,
          filePreviewMsg: undefined
        };
      });
    });
    DomainForm_defineProperty(this, "initNewDesign", () => {
      const {
        domain
      } = this.props;
      const {
        newDesignFields
      } = domain;
      if (newDesignFields) {
        newDesignFields.forEach(this.applyAddField);
        this.setState({
          expandedRowIndex: 0
        });
      } else {
        this.applyAddField();
      }
    });
    DomainForm_defineProperty(this, "toggleSelectAll", () => {
      const {
        domain
      } = this.props;
      const {
        selectAll,
        visibleSelection
      } = this.state;
      let newVisibleSelection = new Set([...visibleSelection]);
      const toggledFields = domain.fields.map((field, index) => {
        if (field.visible) {
          newVisibleSelection = applySetOperation(newVisibleSelection, index, !selectAll);
          return field.set('selected', !selectAll);
        }
        return field;
      });
      const updatedDomain = domain.merge({
        fields: toggledFields
      });
      this.onDomainChange(updatedDomain, false);
      this.setState(state => ({
        selectAll: !state.selectAll,
        visibleSelection: newVisibleSelection
      }));
    });
    DomainForm_defineProperty(this, "clearAllSelection", () => {
      const {
        domain
      } = this.props;
      const fields = domain.fields.map(field => field.set('selected', false));
      const updatedDomain = domain.merge({
        fields
      });
      this.onDomainChange(updatedDomain, false);
      this.setState({
        selectAll: false,
        visibleSelection: new Set()
      });
    });
    DomainForm_defineProperty(this, "onExportFields", () => {
      const {
        domain
      } = this.props;
      const {
        visibleSelection
      } = this.state;
      let filteredFields = domain.fields.filter(f => f.visible);
      // Respect selection, if any selection exists
      filteredFields = visibleSelection.size > 0 ? filteredFields.filter(field => field.selected) : filteredFields;
      const fieldData = filteredFields.map(field => DomainField.serialize(field, false)).toArray();
      const fieldsJson = JSON.stringify(fieldData, null, 4);
      downloadJsonFile(fieldsJson, generateNameWithTimestamp('Fields') + '.fields.json');
    });
    DomainForm_defineProperty(this, "renderBulkFieldDeleteConfirm", () => {
      const {
        domain
      } = this.props;
      const {
        bulkDeleteConfirmInfo
      } = this.state;
      const deletableSelectedFieldsCount = bulkDeleteConfirmInfo.deletableSelectedFields.length;
      if (deletableSelectedFieldsCount === 0) {
        return /*#__PURE__*/external_react_default().createElement(Modal, {
          title: "Cannot Delete Required Fields",
          onCancel: this.onConfirmBulkCancel,
          cancelText: "Close",
          confirmClass: "btn-danger"
        }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, " None of the selected fields can be deleted. ")));
      }
      const {
        howManyDeleted,
        undeletableWarning
      } = generateBulkDeleteWarning(bulkDeleteConfirmInfo, bulkDeleteConfirmInfo.undeletableFields.map(i => domain.fields.get(i).name));
      return /*#__PURE__*/external_react_default().createElement(Modal, {
        title: "Confirm Delete Selected Fields",
        onConfirm: this.onBulkDeleteConfirm,
        onCancel: this.onConfirmBulkCancel,
        confirmClass: "btn-danger",
        confirmText: "Yes, Delete Fields"
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, howManyDeleted, " will be deleted."), /*#__PURE__*/external_react_default().createElement("p", null, undeletableWarning), /*#__PURE__*/external_react_default().createElement("p", null, "Are you sure you want to delete", ' ', deletableSelectedFieldsCount > 1 ? 'these fields' : 'this field', "? All of the related field data will also be deleted.")));
    });
    DomainForm_defineProperty(this, "onBulkDeleteClick", () => {
      this.setState(state => {
        const {
          fields
        } = this.props.domain;
        const {
          visibleSelection
        } = state;
        const undeletableFields = [];
        const deletableSelectedFields = [];
        visibleSelection.forEach(val => {
          const field = fields.get(val);
          if (field.isSaved() && !isFieldDeletable(field)) {
            undeletableFields.push(val);
          } else {
            deletableSelectedFields.push(val);
          }
        });
        return {
          bulkDeleteConfirmInfo: {
            deletableSelectedFields,
            undeletableFields
          }
        };
      });
    });
    DomainForm_defineProperty(this, "onBulkDeleteConfirm", () => {
      const {
        domain
      } = this.props;
      const {
        deletableSelectedFields
      } = this.state.bulkDeleteConfirmInfo;
      const updatedDomain = removeFields(domain, deletableSelectedFields);
      const visibleFieldsCount = getVisibleFieldCount(updatedDomain);
      const visibleSelection = getVisibleSelectedFieldIndexes(updatedDomain.fields);
      const rowIndexChanges = deletableSelectedFields.map(i => ({
        newIndex: undefined,
        originalIndex: i
      }));
      this.onDomainChange(updatedDomain, true, rowIndexChanges);
      this.setState({
        visibleSelection,
        visibleFieldsCount,
        expandedRowIndex: undefined,
        selectAll: visibleFieldsCount !== 0 && visibleSelection.size === visibleFieldsCount,
        bulkDeleteConfirmInfo: undefined
      }, this.clearFilePreviewData);
    });
    DomainForm_defineProperty(this, "onAddField", () => {
      this.applyAddField();
    });
    DomainForm_defineProperty(this, "onFileRemoval", () => {
      this.setState({
        filePreviewMsg: undefined
      });
    });
    DomainForm_defineProperty(this, "applyAddField", config => {
      const {
        newFieldConfig
      } = this.props;
      const newConfig = config ? DomainForm_objectSpread({}, config) : newFieldConfig;
      const newDomain = addDomainField(this.props.domain, newConfig);
      this.onDomainChange(newDomain, true);
      this.setState({
        selectAll: false,
        visibleFieldsCount: getVisibleFieldCount(newDomain)
      }, this.collapseRow);
    });
    DomainForm_defineProperty(this, "onSystemFieldEnable", (field, enable) => {
      const {
        domain
      } = this.props;
      this.onDomainChange(handleSystemFieldUpdates(domain, field, enable));
    });
    DomainForm_defineProperty(this, "onFieldsChange", (changes, index, expand) => {
      const {
        domain
      } = this.props;
      const firstChange = changes.get(0);
      const rowSelectedChange = getNameFromId(firstChange?.id) === 'selected';
      this.onDomainChange(handleDomainUpdates(domain, changes), !rowSelectedChange);
      if (rowSelectedChange) {
        this.setState(state => {
          const {
            visibleFieldsCount
          } = state;
          const visibleSelection = applySetOperation(state.visibleSelection, index, firstChange.value);
          return {
            visibleSelection,
            selectAll: visibleFieldsCount !== 0 && visibleSelection.size === visibleFieldsCount
          };
        }, () => {
          if (expand) {
            this.expandRow(index);
          }
        });
      } else if (expand) {
        this.expandRow(index);
      }
    });
    DomainForm_defineProperty(this, "onDeleteField", index => {
      const {
        domain
      } = this.props;
      const field = domain.fields.get(index);
      if (field) {
        // only show the confirm dialog for saved fields
        if (field.isSaved()) {
          this.setState({
            confirmDeleteRowIndex: index
          });
        } else {
          this.onDeleteConfirm(index);
        }
      }
    });
    DomainForm_defineProperty(this, "onConfirmCancel", () => {
      this.setState({
        confirmDeleteRowIndex: undefined
      });
    });
    DomainForm_defineProperty(this, "onConfirmBulkCancel", () => {
      this.setState({
        bulkDeleteConfirmInfo: undefined
      });
    });
    DomainForm_defineProperty(this, "onBeforeDragStart", initial => {
      const {
        domain
      } = this.props;
      const id = initial.draggableId;
      const idIndex = id ? getIndexFromId(id) : undefined;
      this.setState({
        dragId: idIndex
      });
      this.onDomainChange(domain, false);

      // remove focus for any current element so that it doesn't "jump" after drag end
      blurActiveElement();
    });
    DomainForm_defineProperty(this, "onDragEnd", result => {
      const {
        domain
      } = this.props;
      let destIndex = result.source.index; // default behavior go back to original spot if out of bounds
      const srcIndex = result.source.index;
      const id = result.draggableId;
      const idIndex = id ? getIndexFromId(id) : undefined;
      this.setState({
        dragId: undefined
      });
      if (result.destination) {
        destIndex = result.destination.index;
      }
      if (srcIndex === destIndex) {
        return;
      }
      const movedField = domain.fields.find((field, i) => i === idIndex);
      const newFields = (0,external_immutable_.List)().asMutable();
      let fieldsWithNewIndexesOnErrors = domain.hasException() ? domain.domainException.errors : (0,external_immutable_.List)();
      let expanded = this.state.expandedRowIndex;
      domain.fields.forEach((field, i) => {
        // move down
        if (i !== idIndex && srcIndex < destIndex) {
          newFields.push(field);
          fieldsWithNewIndexesOnErrors = this.setNewIndexOnError(i, newFields.size - 1, fieldsWithNewIndexesOnErrors);
          if (i === this.state.expandedRowIndex) {
            expanded = newFields.size - 1;
          }
        }
        if (i === destIndex) {
          newFields.push(movedField);
          fieldsWithNewIndexesOnErrors = this.setNewIndexOnError(idIndex, destIndex, fieldsWithNewIndexesOnErrors);
          if (idIndex === this.state.expandedRowIndex) {
            expanded = destIndex;
          }
        }

        // move up
        if (i !== idIndex && srcIndex > destIndex) {
          newFields.push(field);
          fieldsWithNewIndexesOnErrors = this.setNewIndexOnError(i, newFields.size - 1, fieldsWithNewIndexesOnErrors);
          if (i === this.state.expandedRowIndex) {
            expanded = newFields.size - 1;
          }
        }
      });
      let domainExceptionWithMovedErrors;
      if (domain.hasException()) {
        // set existing error row indexes with new row indexes
        const fieldsWithMovedErrorsUpdated = fieldsWithNewIndexesOnErrors.map(error => error.merge({
          rowIndexes: error.newRowIndexes ? error.newRowIndexes : error.rowIndexes,
          newRowIndexes: undefined // reset newRowIndexes
        })).toList();
        domainExceptionWithMovedErrors = domain.domainException.set('errors', fieldsWithMovedErrorsUpdated);
      }
      const newDomain = domain.merge({
        fields: newFields.asImmutable(),
        domainException: domainExceptionWithMovedErrors
      });
      if (movedField.selected) {
        this.setState(state => {
          const oldVisibleSelection = applySetOperation(state.visibleSelection, srcIndex, false);
          return {
            visibleSelection: applySetOperation(oldVisibleSelection, destIndex, true)
          };
        });
      }
      this.onDomainChange(newDomain, true, [{
        originalIndex: srcIndex,
        newIndex: destIndex
      }]);
      this.fastExpand(expanded);
    });
    DomainForm_defineProperty(this, "setNewIndexOnError", (oldIndex, newIndex, fieldErrors) => {
      return fieldErrors.map(fieldError => {
        let newRowIndexes;
        if (fieldError.newRowIndexes === undefined) {
          newRowIndexes = (0,external_immutable_.List)();
        } else {
          newRowIndexes = fieldError.get('newRowIndexes');
        }
        fieldError.rowIndexes.forEach(val => {
          if (val === oldIndex) {
            newRowIndexes = newRowIndexes.push(newIndex);
          }
        });
        return fieldError.set('newRowIndexes', newRowIndexes);
      }).toList();
    });
    DomainForm_defineProperty(this, "handleFilePreviewLoad", (response, file) => {
      const {
        domain,
        setFileImportData,
        domainFormDisplayOptions
      } = this.props;
      const retainReservedFields = domainFormDisplayOptions?.retainReservedFields;
      let fields = (0,external_immutable_.List)();
      let reservedFields = response?.reservedFields || (0,external_immutable_.List)();
      if (retainReservedFields) {
        fields = fields.merge(reservedFields);
      }
      if (response?.fields?.size) {
        response.fields.forEach(field => {
          if (domain.reservedFieldNames?.indexOf(field.name.toLowerCase()) < 0) {
            fields = fields.push(field);
          } else {
            reservedFields = reservedFields.push(field);
          }
        });
      }
      if (fields.size === 0) {
        this.setState({
          filePreviewMsg: 'The selected file contains only fields that will be created by default. Please remove the file and try uploading a new one.'
        });
      } else {
        // if the DomainForm usage wants to show the file preview and import data options, then set these state values
        if (setFileImportData) {
          this.setState({
            filePreviewData: response,
            file,
            filePreviewMsg: undefined
          });
          setFileImportData(file, true);
        }
        this.onDomainChange(setDomainFields(domain, fields));
      }
      if (reservedFields.size && !retainReservedFields) {
        this.setState({
          reservedFieldsMsg: 'Fields with reserved names or prefixes found in your file are not shown below. ' + 'These fields are already used by LabKey' + (domainFormDisplayOptions?.domainKindDisplayName ? ' to support this ' + domainFormDisplayOptions.domainKindDisplayName : '') + ': ' + reservedFields.map(field => field.name).join(', ') + '.'
        });
      }
    });
    DomainForm_defineProperty(this, "importFieldsFromJson", file => {
      const {
        domain,
        onChange
      } = this.props;
      return new Promise((resolve, reject) => {
        let content = '';
        const reader = new FileReader();

        // Waits until file is loaded
        reader.onloadend = async e => {
          // Catches malformed JSON
          try {
            content = e.target.result;
            const response = processJsonImport(content, domain);
            if (!response.success) {
              return resolve(response);
            } else {
              const tsFields = response.fields;
              const mergedFields = await mergeDomainFields(domain, tsFields);
              onChange?.(mergedFields, true);
              resolve({
                success: true
              });
            }
          } catch (e) {
            reject({
              success: false,
              msg: e.toString()
            });
          }
        };
        reader.onerror = function (error) {
          reject({
            success: false,
            msg: error.toString()
          });
        };
        reader.readAsText(file);
      });
    });
    DomainForm_defineProperty(this, "onToggleSummaryView", () => {
      this.setState(state => ({
        summaryViewMode: !state.summaryViewMode
      }));
    });
    DomainForm_defineProperty(this, "onSearch", evt => {
      const {
        value
      } = evt.target;
      this.updateFilteredFields(value);
    });
    DomainForm_defineProperty(this, "getFilteredFields", (domain, value) => {
      const filteredFields = domain.fields.map(field => {
        const fieldSearchMatch = !value || field.name && field.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        if (fieldSearchMatch) {
          return field.set('visible', true);
        }
        return field.set('visible', false);
      });
      return domain.set('fields', filteredFields);
    });
    DomainForm_defineProperty(this, "updateFilteredFields", value => {
      const {
        domain
      } = this.props;
      const filteredDomain = this.getFilteredFields(domain, value);
      const visibleFieldsCount = getVisibleFieldCount(filteredDomain);
      const visibleSelection = getVisibleSelectedFieldIndexes(filteredDomain.fields);
      this.setState({
        visibleSelection,
        visibleFieldsCount,
        search: value,
        selectAll: visibleFieldsCount !== 0 && visibleSelection.size === visibleFieldsCount
      }, () => {
        this.onDomainChange(filteredDomain, false);
      });
    });
    DomainForm_defineProperty(this, "isPanelExpanded", () => {
      const {
        collapsible,
        controlledCollapse
      } = this.props;
      const {
        collapsed
      } = this.state;
      if (!collapsible && !controlledCollapse) return true;
      return !collapsed;
    });
    DomainForm_defineProperty(this, "getDomainFields", () => {
      return this.props.domain.fields;
    });
    DomainForm_defineProperty(this, "scrollFunction", i => {
      this.setState({
        summaryViewMode: false,
        expandedRowIndex: i
      }, () => {
        this.refsArray[i].scrollIntoView();
      });
    });
    DomainForm_defineProperty(this, "renderDetailedFieldView", () => {
      const {
        domain,
        helpNoun,
        appPropertiesOnly,
        domainIndex,
        domainFormDisplayOptions,
        schemaName,
        queryName
      } = this.props;
      const {
        expandedRowIndex,
        fieldDetails,
        maxPhiLevel,
        dragId,
        availableTypes,
        reservedFieldsMsg,
        search,
        selectAll,
        visibleFieldsCount,
        visibleSelection
      } = this.state;
      const fieldPlural = visibleSelection.size !== 1 ? 'fields' : 'field';
      const clearText = visibleFieldsCount !== 0 && visibleSelection.size === visibleFieldsCount ? 'Clear All' : 'Clear';
      return /*#__PURE__*/external_react_default().createElement(external_react_beautiful_dnd_.DragDropContext, {
        onDragEnd: this.onDragEnd,
        onBeforeDragStart: this.onBeforeDragStart
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-field-row domain-row-border-default domain-floating-hdr"
      }, /*#__PURE__*/external_react_default().createElement(Alert, {
        bsStyle: "info"
      }, reservedFieldsMsg), /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-field-header"
      }, visibleSelection.size, " ", fieldPlural, " selected", /*#__PURE__*/external_react_default().createElement("button", {
        className: "domain-panel-header-clear-all btn btn-default",
        disabled: visibleSelection.size === 0,
        onClick: this.clearAllSelection,
        type: "button"
      }, clearText))), /*#__PURE__*/external_react_default().createElement("div", {
        className: "row domain-row-container"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-row-handle"
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "domain-row-action-section"
      }, /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
        className: "domain-field-check-icon",
        name: "domain-select-all-checkbox",
        id: "domain-select-all-checkbox",
        checked: selectAll,
        onChange: this.toggleSelectAll
      })), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/external_react_default().createElement("b", null, "Name *")), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-2"
      }, /*#__PURE__*/external_react_default().createElement("b", null, "Data Type *")), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-1"
      }, !domainFormDisplayOptions?.hideRequired && /*#__PURE__*/external_react_default().createElement("b", null, "Required")), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/external_react_default().createElement("b", null, "Details"))))), /*#__PURE__*/external_react_default().createElement(external_react_beautiful_dnd_.Droppable, {
        droppableId: "domain-form-droppable"
      }, provided => /*#__PURE__*/external_react_default().createElement("div", DomainForm_extends({
        ref: provided.innerRef
      }, provided.droppableProps), /*#__PURE__*/external_react_default().createElement("form", {
        className: "domain-form"
      }, domain.fields.map((field, i) => {
        // use the propertyId in the row key for saved fields (helps with issues 49481 and 50076)
        let key = 'domain-row-key-new' + i;
        if (!field.isNew() && !field.isCalculatedField()) {
          key = 'domain-row-key-prop' + field.propertyId;
        }

        // Need to preserve index so don't filter, instead just use empty div
        if (!field.visible) return /*#__PURE__*/external_react_default().createElement("div", {
          key: key
        });
        return /*#__PURE__*/external_react_default().createElement(DomainRow, {
          ref: ref => {
            this.refsArray[i] = ref;
          },
          domainId: domain.domainId,
          helpNoun: helpNoun,
          key: key,
          field: field,
          fieldError: this.getFieldError(domain, i),
          getDomainFields: this.getDomainFields,
          fieldDetailsInfo: fieldDetails.detailsInfo,
          domainIndex: domainIndex,
          index: i,
          expanded: expandedRowIndex === i,
          onChange: this.onFieldsChange,
          onExpand: this.onFieldExpandToggle,
          onDelete: this.onDeleteField,
          maxPhiLevel: maxPhiLevel,
          dragging: dragId === i,
          availableTypes: availableTypes,
          allowUniqueConstraintProperties: domain.allowUniqueConstraintProperties,
          showDefaultValueSettings: domain.showDefaultValueSettings,
          defaultDefaultValueType: domain.defaultDefaultValueType,
          defaultValueOptions: domain.defaultValueOptions,
          appPropertiesOnly: appPropertiesOnly,
          isDragDisabled: !valueIsEmpty(search) || domainFormDisplayOptions.isDragDisabled,
          domainFormDisplayOptions: domainFormDisplayOptions,
          domainContainerPath: domain.container,
          schemaName: schemaName ?? domain.schemaName,
          queryName: queryName ?? domain.queryName
        });
      }), provided.placeholder))));
    });
    this.state = {
      expandedRowIndex: undefined,
      confirmDeleteRowIndex: undefined,
      dragId: undefined,
      maxPhiLevel: props.maxPhiLevel || PHILEVEL_NOT_PHI,
      availableTypes: getAvailableTypes(props.domain),
      collapsed: props.initCollapsed,
      fieldDetails: props.domain?.getFieldDetails(),
      filePreviewData: undefined,
      file: undefined,
      filePreviewMsg: undefined,
      selectAll: false,
      bulkDeleteConfirmInfo: undefined,
      visibleSelection: new Set(),
      visibleFieldsCount: props.domain?.fields.size,
      summaryViewMode: false,
      search: undefined,
      reservedFieldsMsg: undefined
    };
    this.refsArray = [];
  }
  componentDidUpdate(prevProps) {
    const {
      controlledCollapse,
      domain,
      initCollapsed,
      validate,
      onChange
    } = this.props;

    // if controlled collapsible, allow the prop change to update the collapsed state
    if (controlledCollapse && prevProps.initCollapsed !== initCollapsed) {
      this.toggleLocalPanel(initCollapsed);
    }
    if (validate && validate !== prevProps.validate) {
      onChange?.(this.validateDomain(domain), false);
    }
  }
  onDomainChange(updatedDomain, dirty, rowIndexChanges) {
    const {
      controlledCollapse,
      domain,
      domainIndex
    } = this.props;
    const {
      ontologyLookupIndices
    } = this.state.fieldDetails;

    // Check for cleared errors
    if (controlledCollapse && updatedDomain.hasErrors()) {
      const invalidFields = updatedDomain.getInvalidFields();
      const markedInvalid = updatedDomain.get('domainException').get('errors');
      if (markedInvalid.size > invalidFields.size) {
        updatedDomain = this.validateDomain(updatedDomain);
      }
    }

    // if this domain has any Ontology Lookup field(s), check if we need to update the related field properties
    // based on the updated domain (i.e. check for any name changes to selected fields)
    if (rowIndexChanges === undefined && ontologyLookupIndices.length > 0) {
      ontologyLookupIndices.forEach(index => {
        updatedDomain = updateOntologyFieldProperties(index, domainIndex, updatedDomain, domain, rowIndexChanges);
      });
    }
    // and check for index shifts as a result of bulk deletes
    if (rowIndexChanges) {
      ontologyLookupIndices.forEach(index => {
        for (let i = 0; i < rowIndexChanges.length; i++) {
          const currentIndex = rowIndexChanges[i]?.originalIndex;

          // we skip any rowIndexChange which has a newIndex as those are just reorder changes
          if (rowIndexChanges[i]?.newIndex !== undefined) {
            return;
            // skip any ontology lookup fields if they were removed
          } else if (currentIndex === index) {
            continue;
          } else if (i + 1 < rowIndexChanges.length && rowIndexChanges[i + 1].originalIndex < index) {
            continue;
          } else if (index > currentIndex) {
            updatedDomain = updateOntologyFieldProperties(index - (i + 1), domainIndex, updatedDomain, domain, rowIndexChanges);
            return;
          }
        }
      });
    }
    this.setState({
      reservedFieldsMsg: undefined,
      fieldDetails: updatedDomain.getFieldDetails()
    });

    // Issue 49199: onChange call to be made separate from setState callback, Field Editor name input fix for jumping cursor to end of input
    this.props.onChange?.(updatedDomain, dirty !== undefined ? dirty : true, rowIndexChanges);
  }
  onDeleteConfirm(index) {
    const rowIndexChange = {
      newIndex: undefined,
      originalIndex: index
    };
    const updatedDomain = removeFields(this.props.domain, [index]);
    const visibleFieldsCount = getVisibleFieldCount(updatedDomain);
    const visibleSelection = getVisibleSelectedFieldIndexes(updatedDomain.fields);
    const selectAll = visibleFieldsCount !== 0 && visibleSelection.size === visibleFieldsCount;
    this.onDomainChange(updatedDomain, true, [rowIndexChange]);
    this.setState({
      visibleSelection,
      visibleFieldsCount,
      selectAll,
      expandedRowIndex: undefined,
      confirmDeleteRowIndex: undefined
    }, this.clearFilePreviewData);
  }
  renderAddFieldOption() {
    const {
      domain,
      domainFormDisplayOptions
    } = this.props;
    const hasFields = domain.fields.size > 0;
    if (!domainFormDisplayOptions?.hideAddFieldsButton) {
      if (!hasFields && (this.shouldShowInferFromFile() || this.shouldShowImportExport())) {
        return /*#__PURE__*/external_react_default().createElement("div", {
          className: "margin-top domain-form-manual-section"
        }, /*#__PURE__*/external_react_default().createElement("p", null, "Or"), /*#__PURE__*/external_react_default().createElement(ActionButton, {
          buttonClass: "domain-form-manual-btn",
          onClick: this.initNewDesign
        }, "Manually Define Fields"));
      }
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "row domain-add-field-row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/external_react_default().createElement(AddEntityButton, {
        entity: "Field",
        buttonClass: "domain-form-add-btn",
        containerClass: "pull-right",
        onClick: this.onAddField
      })));
    }
    return null;
  }
  getFieldError(domain, index) {
    if (domain.hasException()) {
      const fieldErrors = domain.domainException.errors;
      if (!fieldErrors.isEmpty()) {
        const errorsWithIndex = fieldErrors.filter(error => {
          return error.rowIndexes.findIndex(idx => idx === index) >= 0;
        });
        return errorsWithIndex.get(0);
      }
    }
    return undefined;
  }
  renderFieldRemoveConfirm() {
    const {
      confirmDeleteRowIndex
    } = this.state;
    const field = this.props.domain.fields.get(confirmDeleteRowIndex);
    const fieldName = field && field.name && field.name.trim().length > 0 ? /*#__PURE__*/external_react_default().createElement("b", null, field.name) : 'this field';
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: "Confirm Remove Field",
      onConfirm: () => this.onDeleteConfirm(confirmDeleteRowIndex),
      onCancel: this.onConfirmCancel,
      confirmClass: "btn-danger",
      confirmText: "Yes, Remove Field"
    }, /*#__PURE__*/external_react_default().createElement("div", null, "Are you sure you want to remove ", fieldName, "? All of its data will be deleted as well."));
  }
  shouldShowInferFromFile() {
    const {
      domain,
      domainFormDisplayOptions
    } = this.props;
    return !domainFormDisplayOptions?.hideInferFromFile && domain.fields.size === 0;
  }
  shouldShowImportExport() {
    return !this.props.domainFormDisplayOptions?.hideImportExport;
  }
  renderEmptyDomain() {
    const {
      domain,
      index
    } = this.props;
    const shouldShowInferFromFile = this.shouldShowInferFromFile();
    const shouldShowImportExport = this.shouldShowImportExport();
    if (shouldShowInferFromFile || shouldShowImportExport) {
      let acceptedFormats = [];
      if (shouldShowInferFromFile) {
        acceptedFormats = acceptedFormats.concat(['.csv', '.tsv', '.txt', '.xls', '.xlsx']);
      }
      if (shouldShowImportExport) {
        acceptedFormats = acceptedFormats.concat(['.json']);
      }
      let label;
      if (shouldShowImportExport && shouldShowInferFromFile) {
        label = 'Import or infer fields from file';
      } else if (shouldShowImportExport) {
        label = 'Import fields from file';
      } else {
        label = 'Infer fields from file';
      }
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(FileAttachmentForm, {
        acceptedFormats: acceptedFormats.join(', '),
        showAcceptedFormats: true,
        allowDirectories: false,
        allowMultiple: false,
        label: label,
        index: index,
        onFileRemoval: this.onFileRemoval,
        previewGridProps: shouldShowInferFromFile && {
          previewCount: 3,
          skipPreviewGrid: true,
          onPreviewLoad: this.handleFilePreviewLoad,
          domainKindName: domain.domainKindName
        },
        fileSpecificCallback: (0,external_immutable_.Map)({
          '.json': this.importFieldsFromJson
        })
      }), shouldShowInferFromFile && this.state.filePreviewMsg && /*#__PURE__*/external_react_default().createElement(Alert, {
        bsStyle: "info"
      }, this.state.filePreviewMsg));
    }
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-form-no-field-panel"
    }, "No fields created yet. Click the 'Add Field' button to get started.");
  }
  render() {
    const {
      appDomainHeaderRenderer,
      appPropertiesOnly,
      children,
      domain,
      domainIndex,
      collapsible,
      controlledCollapse,
      domainFormDisplayOptions,
      fieldsAdditionalRenderer,
      headerTitle,
      headerPrefix,
      helpNoun,
      helpTopic,
      modelDomains,
      panelStatus,
      setFileImportData,
      showHeader,
      systemFields,
      todoIconHelpMsg
    } = this.props;
    const {
      bulkDeleteConfirmInfo,
      collapsed,
      confirmDeleteRowIndex,
      filePreviewData,
      file,
      isLoading,
      search,
      selectAll,
      summaryViewMode,
      visibleSelection
    } = this.state;
    const {
      fields
    } = domain;
    const fieldSize = fields.size;
    const headerDetails = fieldSize > 0 ? '' + fieldSize + ' Field' + (fieldSize > 1 ? 's' : '') + ' Defined' : undefined;
    const hasFields = fields.size > 0;
    const styleToolbar = !hasFields && !systemFields && (this.shouldShowInferFromFile() || this.shouldShowImportExport());
    const disableExport = !hasFields || fields.filter(f => f.visible).size < 1;
    const hasException = domain.hasException();
    const isApp_ = isApp();
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, confirmDeleteRowIndex !== undefined && this.renderFieldRemoveConfirm(), bulkDeleteConfirmInfo && this.renderBulkFieldDeleteConfirm(), /*#__PURE__*/external_react_default().createElement("div", {
      className: getDomainPanelClass(collapsed, controlledCollapse, isApp_)
    }, showHeader && /*#__PURE__*/external_react_default().createElement(CollapsiblePanelHeader, {
      id: getDomainPanelHeaderId(domain),
      title: getDomainHeaderName(domain.name, headerTitle, headerPrefix),
      collapsed: !(this.isPanelExpanded() && controlledCollapse),
      collapsible: collapsible,
      controlledCollapse: controlledCollapse,
      headerDetails: headerDetails,
      todoIconHelpMsg: todoIconHelpMsg,
      panelStatus: panelStatus,
      togglePanel: this.togglePanel,
      isValid: !hasException,
      iconHelpMsg: hasException ? domain.domainException.exception : undefined
    }, children), /*#__PURE__*/external_react_default().createElement(Collapsible, {
      className: "panel-collapse",
      expanded: this.isPanelExpanded()
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('panel-body', {
        'domain-field-top-noBuffer': !styleToolbar
      })
    }, isLoading && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), !isLoading && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, systemFields && /*#__PURE__*/external_react_default().createElement(SystemFields, {
      fields: systemFields,
      disabledSystemFields: domain.disabledSystemFields,
      onSystemFieldEnable: this.onSystemFieldEnable
    }), (hasFields || !(this.shouldShowInferFromFile() || this.shouldShowImportExport())) && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row domain-field-toolbar"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, !domainFormDisplayOptions?.hideAddFieldsButton && /*#__PURE__*/external_react_default().createElement(AddEntityButton, {
      entity: "Field",
      containerClass: "container--toolbar-button",
      buttonClass: "domain-toolbar-add-btn",
      onClick: this.onAddField
    }), /*#__PURE__*/external_react_default().createElement(ActionButton, {
      containerClass: "container--toolbar-button",
      buttonClass: "domain-toolbar-delete-btn",
      onClick: this.onBulkDeleteClick,
      disabled: visibleSelection.size === 0
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-trash domain-toolbar-export-btn-icon"
    }), " Delete"), this.shouldShowImportExport() && /*#__PURE__*/external_react_default().createElement(ActionButton, {
      containerClass: "container--toolbar-button",
      buttonClass: "domain-toolbar-export-btn",
      onClick: this.onExportFields,
      disabled: disableExport
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-download domain-toolbar-export-btn-icon"
    }), ' ', "Export")), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-8"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "pull-right domain-field-toolbar-right-aligned"
    }, !valueIsEmpty(search) && /*#__PURE__*/external_react_default().createElement("span", {
      className: "domain-search-text"
    }, "Showing ", fields.filter(f => f.visible).size, " of", ' ', fields.size, " field", fields.size > 1 ? 's' : '', "."), /*#__PURE__*/external_react_default().createElement("input", {
      id: 'domain-search-name-' + domainIndex,
      className: "form-control domain-search-input",
      type: "text",
      placeholder: "Search Fields",
      onChange: this.onSearch
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-toolbar-toggle-summary"
    }, /*#__PURE__*/external_react_default().createElement("span", null, "Mode: "), /*#__PURE__*/external_react_default().createElement(ToggleButtons, {
      className: "",
      first: "Summary",
      second: "Detail",
      active: summaryViewMode ? 'Summary' : 'Detail',
      onClick: this.onToggleSummaryView
    }))))), /*#__PURE__*/external_react_default().createElement("div", {
      className: helpTopic ? 'row domain-form-hdr-margins' : 'row'
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: `col-xs-${helpTopic ? 9 : 12}`
    }), helpTopic && /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement(HelpLink, {
      topic: helpTopic,
      className: "domain-field-float-right"
    }, "Learn more about this tool"))), !summaryViewMode && appDomainHeaderRenderer && appDomainHeaderRenderer({
      domain,
      domainIndex,
      modelDomains,
      onChange: this.onFieldsChange,
      onAddField: this.applyAddField
    }), hasFields && summaryViewMode && /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-form__summary-mode"
    }, /*#__PURE__*/external_react_default().createElement(DomainPropertiesGrid, {
      domain: domain,
      search: search,
      selectAll: selectAll,
      actions: {
        toggleSelectAll: this.toggleSelectAll,
        scrollFunction: this.scrollFunction,
        onFieldsChange: this.onFieldsChange
      },
      appPropertiesOnly: appPropertiesOnly,
      hasOntologyModule: hasModule(ONTOLOGY_MODULE_NAME)
    })), hasFields && !summaryViewMode && this.renderDetailedFieldView(), !hasFields && this.renderEmptyDomain(), this.renderAddFieldOption()), fieldsAdditionalRenderer?.(), filePreviewData && !domainFormDisplayOptions?.hideImportData && /*#__PURE__*/external_react_default().createElement(ImportDataFilePreview, {
      noun: helpNoun,
      filePreviewData: filePreviewData,
      setFileImportData: setFileImportData,
      file: file
    })))), hasException && domain.domainException.severity === constants_SEVERITY_LEVEL_ERROR && /*#__PURE__*/external_react_default().createElement("div", {
      onClick: this.togglePanel,
      className: getDomainAlertClasses(collapsed, controlledCollapse, isApp_)
    }, /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "danger"
    }, domain.domainException.exception)));
  }
}
DomainForm_defineProperty(DomainFormImpl, "defaultProps", {
  api: getDefaultAPIWrapper().domain,
  helpNoun: 'field designer',
  helpTopic: FIELD_EDITOR_TOPIC,
  showHeader: true,
  initCollapsed: false,
  isNew: false,
  appPropertiesOnly: false,
  domainIndex: 0,
  domainFormDisplayOptions: DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS // add configurations options to DomainForm through this object
});
const DomainForm = (0,external_react_.memo)(props => /*#__PURE__*/external_react_default().createElement(LookupProvider, null, /*#__PURE__*/external_react_default().createElement(DomainFormImpl, props)));
DomainForm.displayName = 'DomainForm';
/* harmony default export */ const domainproperties_DomainForm = (DomainForm);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/BasePropertiesPanel.tsx
function BasePropertiesPanel_defineProperty(e, r, t) { return (r = BasePropertiesPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function BasePropertiesPanel_toPropertyKey(t) { var i = BasePropertiesPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function BasePropertiesPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







class BasePropertiesPanel extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    BasePropertiesPanel_defineProperty(this, "toggleLocalPanel", () => {
      const {
        togglePanel,
        collapsed,
        updateValidStatus
      } = this.props;
      updateValidStatus();
      togglePanel(!collapsed);
    });
  }
  componentDidUpdate(prevProps) {
    const {
      validate,
      updateValidStatus
    } = this.props;
    if (validate && prevProps.validate !== validate) {
      updateValidStatus();
    }
  }
  render() {
    const {
      collapsed,
      collapsible,
      controlledCollapse,
      panelStatus,
      headerId,
      titlePrefix,
      title,
      isValid,
      children,
      warning,
      todoIconHelpMsg
    } = this.props;
    const isApp_ = isApp();
    let body = /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-body"
    }, children);
    if (collapsible || controlledCollapse) {
      body = /*#__PURE__*/external_react_default().createElement(Collapsible, {
        className: "panel-collapse",
        expanded: !collapsed
      }, body);
    }
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: getDomainPanelClass(collapsed, true, isApp_)
    }, /*#__PURE__*/external_react_default().createElement(CollapsiblePanelHeader, {
      id: headerId,
      title: title,
      titlePrefix: titlePrefix,
      togglePanel: this.toggleLocalPanel,
      collapsed: collapsed,
      collapsible: collapsible,
      controlledCollapse: controlledCollapse,
      panelStatus: panelStatus,
      isValid: isValid,
      iconHelpMsg: PROPERTIES_PANEL_ERROR_MSG,
      todoIconHelpMsg: todoIconHelpMsg
    }), body), !isValid && /*#__PURE__*/external_react_default().createElement("div", {
      onClick: this.toggleLocalPanel,
      className: getDomainAlertClasses(collapsed, true, isApp_)
    }, /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "danger"
    }, PROPERTIES_PANEL_ERROR_MSG)), isValid && warning && /*#__PURE__*/external_react_default().createElement("div", {
      onClick: this.toggleLocalPanel,
      className: getDomainAlertClasses(collapsed, true, isApp_)
    }, /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "warning"
    }, warning)));
  }
}
BasePropertiesPanel_defineProperty(BasePropertiesPanel, "defaultProps", {
  title: 'Properties',
  validate: false
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainFieldsDisplay.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




const DOMAIN_FIELD_COLS = (0,external_immutable_.List)([new GridColumn({
  index: 'name',
  title: 'Name'
}), new GridColumn({
  index: 'label',
  title: 'Label'
}), new GridColumn({
  index: 'rangeURI',
  title: 'Range URI'
}), new GridColumn({
  index: 'conceptURI',
  title: 'Concept URI'
}), new GridColumn({
  index: 'required',
  title: 'Required'
}), new GridColumn({
  index: 'scale',
  title: 'Scale'
})]);
const DomainFieldsDisplay = ({
  domain,
  title
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "panel panel-default"
}, /*#__PURE__*/external_react_default().createElement("div", {
  className: "panel-heading"
}, /*#__PURE__*/external_react_default().createElement("div", {
  className: "panel-title"
}, title || domain.name)), /*#__PURE__*/external_react_default().createElement("div", {
  className: "panel-body"
}, /*#__PURE__*/external_react_default().createElement("p", null, domain.description), /*#__PURE__*/external_react_default().createElement(Grid, {
  columns: DOMAIN_FIELD_COLS,
  data: domain.fields
})));
DomainFieldsDisplay.displayName = 'DomainFieldsDisplay';
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainPropertiesPanelCollapse.tsx
const DomainPropertiesPanelCollapse_excluded = ["initCollapsed", "onToggle", "controlledCollapse", "collapsible"];
function DomainPropertiesPanelCollapse_extends() { return DomainPropertiesPanelCollapse_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DomainPropertiesPanelCollapse_extends.apply(null, arguments); }
function DomainPropertiesPanelCollapse_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = DomainPropertiesPanelCollapse_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function DomainPropertiesPanelCollapse_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function DomainPropertiesPanelCollapse_defineProperty(e, r, t) { return (r = DomainPropertiesPanelCollapse_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DomainPropertiesPanelCollapse_toPropertyKey(t) { var i = DomainPropertiesPanelCollapse_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DomainPropertiesPanelCollapse_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function withDomainPropertiesPanelCollapse(ComponentToWrap) {
  class ComponentWithDomainPropertiesPanelCollapse extends external_react_.PureComponent {
    constructor(props) {
      super(props);
      DomainPropertiesPanelCollapse_defineProperty(this, "toggleLocalPanel", collapsed => {
        this.setState(state => ({
          collapsed: collapsed !== undefined ? collapsed : !state.collapsed
        }));
      });
      DomainPropertiesPanelCollapse_defineProperty(this, "togglePanel", (evt, collapsed) => {
        const {
          onToggle,
          collapsible,
          controlledCollapse
        } = this.props;
        if (collapsible || controlledCollapse) {
          if (onToggle) {
            onToggle(collapsed !== undefined ? collapsed : !this.state.collapsed, this.toggleLocalPanel);
          } else {
            this.toggleLocalPanel(collapsed);
          }
        }
      });
      this.state = {
        collapsed: props.initCollapsed
      };
    }
    componentDidUpdate(prevProps) {
      const {
        controlledCollapse,
        initCollapsed
      } = this.props;

      // if controlled collapse, allow the prop change to update the collapsed state
      if (controlledCollapse && prevProps.initCollapsed !== initCollapsed) {
        this.toggleLocalPanel(initCollapsed);
      }
    }
    render() {
      // pull out MakeDomainPropertiesPanelCollapseProps as we don't want to pass that to children
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _this$props = this.props,
        {
          initCollapsed,
          onToggle,
          controlledCollapse,
          collapsible
        } = _this$props,
        props = DomainPropertiesPanelCollapse_objectWithoutProperties(_this$props, DomainPropertiesPanelCollapse_excluded);
      const {
        collapsed
      } = this.state;
      return /*#__PURE__*/external_react_default().createElement(ComponentToWrap, DomainPropertiesPanelCollapse_extends({
        controlledCollapse: controlledCollapse,
        collapsible: collapsible,
        collapsed: collapsed,
        togglePanel: this.togglePanel
      }, props));
    }
  }
  return ComponentWithDomainPropertiesPanelCollapse;
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DataTypeProjectsPanel.tsx











// export for jest testing
const DataTypeProjectsPanelImpl = (0,external_react_.memo)(props => {
  const {
    collapsed,
    togglePanel,
    controlledCollapse,
    dataTypeRowId,
    dataTypeName,
    onUpdateExcludedProjects,
    entityDataType,
    relatedDataTypeLabel,
    relatedProjectConfigurableDataType
  } = props;
  const {
    moduleContext,
    container
  } = useServerContext();
  const {
    api
  } = useAppContext();
  const [isValid, setIsValid] = (0,external_react_.useState)(!collapsed || !!dataTypeRowId);
  const [error, setError] = (0,external_react_.useState)();
  const [loading, setLoading] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [allDataCounts, setAllDataCounts] = (0,external_react_.useState)({});
  const [childProjects, setChildProjects] = (0,external_react_.useState)();
  const [allProjects, setAllProjects] = (0,external_react_.useState)();
  const [excludedProjectIdsDB, setExcludedProjectIdsDB] = (0,external_react_.useState)();
  const [excludedProjectIds, setExcludedProjectIds] = (0,external_react_.useState)();
  const [relatedExcludedProjectIdsDB, setRelatedExcludedProjectIdsDB] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    (async () => {
      setLoading(LoadingState.LOADING);
      setError(undefined);
      try {
        const containers = await api.folder.getProjects(container, moduleContext, true, true, true);
        const allProjects_ = containers.map(project => {
          return {
            label: project.title,
            lsid: project.id,
            type: 'Project'
          };
        });
        setChildProjects(allProjects_.slice(1));
        setAllProjects(allProjects_);
        const excludedProjectIds_ = await api.folder.getDataTypeExcludedProjects(entityDataType.projectConfigurableDataType, dataTypeRowId);
        setExcludedProjectIdsDB(excludedProjectIds_);
        setExcludedProjectIds(excludedProjectIds_);
        const allDataCounts_ = await api.query.getDataTypeProjectDataCount(entityDataType, dataTypeRowId, dataTypeName);
        setAllDataCounts(allDataCounts_);
        if (relatedProjectConfigurableDataType) {
          const relatedExcludedProjectIds_ = await api.folder.getDataTypeExcludedProjects(relatedProjectConfigurableDataType, dataTypeRowId);
          setRelatedExcludedProjectIdsDB(relatedExcludedProjectIds_);
        }
      } catch (e) {
        setError(`Error: ${resolveErrorMessage(e)}`);
      } finally {
        setLoading(LoadingState.LOADED);
      }
    })();
  }, [
    /* on mount only */
  ]);
  (0,external_react_.useEffect)(() => {
    // consider the panel valid once the user has expanded/opened it at least once
    if (!collapsed && !isValid) setIsValid(true);
  }, [collapsed, isValid]);
  const updateValidStatus = (0,external_react_.useCallback)(() => {
    /* no-op */
  }, []);
  const updateExcludedProjects = (0,external_react_.useCallback)((dataType, exclusions) => {
    onUpdateExcludedProjects(dataType, exclusions);
    setExcludedProjectIds(exclusions);
  }, [onUpdateExcludedProjects]);
  const updateRelatedExcludedProjects = (0,external_react_.useCallback)((dataType, exclusions) => {
    onUpdateExcludedProjects(dataType, exclusions);
  }, [onUpdateExcludedProjects]);
  if (!hasProductProjects(moduleContext)) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement(BasePropertiesPanel, {
    headerId: "domain-projects-hdr",
    title: "Projects",
    collapsed: collapsed,
    controlledCollapse: controlledCollapse,
    isValid: true,
    panelStatus: collapsed && isValid ? 'COMPLETE' : isValid ? 'INPROGRESS' : 'TODO',
    updateValidStatus: updateValidStatus,
    todoIconHelpMsg: 'This section defines which projects use this ' + entityDataType.typeNounSingular.toLowerCase() + '. You may want to review.',
    togglePanel: togglePanel
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "bottom-spacing"
  }, "Select which projects will use this ", entityDataType.typeNounSingular.toLowerCase(), "."), !!allProjects && allProjects?.length === excludedProjectIds?.length && /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning"
  }, "Note that this ", entityDataType.typeNounSingular.toLowerCase(), " can be re-enabled in the Project Settings page for individual projects."), error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), isLoading(loading) ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null) : /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, !relatedProjectConfigurableDataType && /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12 bottom-spacing"
  }, /*#__PURE__*/external_react_default().createElement(DataTypeSelector, {
    api: api,
    entityDataType: entityDataType,
    allDataCounts: allDataCounts,
    allDataTypes: childProjects,
    updateUncheckedTypes: updateExcludedProjects,
    uncheckedEntitiesDB: excludedProjectIdsDB,
    dataTypeLabel: "projects",
    noHeader: true,
    columns: 2
  })), !!relatedProjectConfigurableDataType && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6 bottom-spacing"
  }, /*#__PURE__*/external_react_default().createElement(DataTypeSelector, {
    api: api,
    entityDataType: entityDataType,
    allDataCounts: allDataCounts,
    allDataTypes: childProjects,
    updateUncheckedTypes: updateExcludedProjects,
    uncheckedEntitiesDB: excludedProjectIdsDB,
    dataTypeLabel: "Include in Projects"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-6 bottom-spacing"
  }, /*#__PURE__*/external_react_default().createElement(DataTypeSelector, {
    api: api,
    dataTypePrefix: "Dashboard",
    entityDataType: entityDataType,
    allDataTypes: allProjects,
    updateUncheckedTypes: updateRelatedExcludedProjects,
    uncheckedEntitiesDB: relatedExcludedProjectIdsDB,
    hiddenEntities: excludedProjectIds,
    dataTypeLabel: relatedDataTypeLabel
  })))));
});
const DataTypeProjectsPanel = withDomainPropertiesPanelCollapse(DataTypeProjectsPanelImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/HelpTopicURL.tsx


function HelpTopicURL(props) {
  const text = props.nounPlural ? 'Learn more about designing ' + props.nounPlural.toLowerCase() : 'Learn more about this tool';
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, helpLinkNode(props.helpTopic, text, 'domain-field-float-right')));
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/AutoLinkToStudyDropdown.tsx


const AutoLinkToStudyDropdown = props => {
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, props.containers === undefined ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null) : /*#__PURE__*/external_react_default().createElement("select", {
    className: "form-control",
    id: props.autoLinkTarget,
    onChange: props.onChange,
    value: props.value || ''
  }, /*#__PURE__*/external_react_default().createElement("option", {
    key: "_empty",
    value: null
  }), props.containers.map(container => /*#__PURE__*/external_react_default().createElement("option", {
    key: container.id,
    value: container.id
  }, container.path))));
};
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/assay/constants.ts
const PROPERTIES_HEADER_ID = 'assay-properties-hdr';
const FORM_ID_PREFIX = 'assay-design-';
const SCRIPTS_DIR = '@scripts';
const FORM_IDS = {
  ASSAY_NAME: FORM_ID_PREFIX + 'name',
  ASSAY_DESCRIPTION: FORM_ID_PREFIX + 'description',
  AUTO_LINK_TARGET: FORM_ID_PREFIX + 'autoCopyTargetContainerId',
  AUTO_LINK_CATEGORY: FORM_ID_PREFIX + 'autoLinkCategory',
  BACKGROUND_UPLOAD: FORM_ID_PREFIX + 'backgroundUpload',
  DETECTION_METHOD: FORM_ID_PREFIX + 'selectedDetectionMethod',
  EDITABLE_RUNS: FORM_ID_PREFIX + 'editableRuns',
  EDITABLE_RESULTS: FORM_ID_PREFIX + 'editableResults',
  METADATA_INPUT_FORMAT: FORM_ID_PREFIX + 'selectedMetadataInputFormat',
  PLATE_TEMPLATE: FORM_ID_PREFIX + 'selectedPlateTemplate',
  PROTOCOL_TRANSFORM_SCRIPTS: FORM_ID_PREFIX + 'protocolTransformScripts',
  QC_ENABLED: FORM_ID_PREFIX + 'qcEnabled',
  SAVE_SCRIPT_FILES: FORM_ID_PREFIX + 'saveScriptFiles',
  PLATE_METADATA: FORM_ID_PREFIX + 'plateMetadata',
  STATUS: FORM_ID_PREFIX + 'status'
};
const BOOLEAN_FIELDS = [FORM_IDS.BACKGROUND_UPLOAD, FORM_IDS.EDITABLE_RUNS, FORM_IDS.EDITABLE_RESULTS, FORM_IDS.QC_ENABLED, FORM_IDS.SAVE_SCRIPT_FILES, FORM_IDS.PLATE_METADATA, FORM_IDS.STATUS];
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/assay/AssayPropertiesInput.tsx
const AssayPropertiesInput_excluded = ["hideAdvancedProperties", "children", "colSize"];
function AssayPropertiesInput_defineProperty(e, r, t) { return (r = AssayPropertiesInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function AssayPropertiesInput_toPropertyKey(t) { var i = AssayPropertiesInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function AssayPropertiesInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function AssayPropertiesInput_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = AssayPropertiesInput_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function AssayPropertiesInput_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }



















const AssayPropertiesInput = (0,external_react_.memo)(props => {
  const {
      hideAdvancedProperties,
      children,
      colSize
    } = props,
    domainFieldProps = AssayPropertiesInput_objectWithoutProperties(props, AssayPropertiesInput_excluded);
  const colXs = colSize ? 'col-xs-' + colSize : undefined;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "row margin-top"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('col col-xs-3', {
      'col-lg-2': hideAdvancedProperties,
      'col-lg-4': !hideAdvancedProperties
    })
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, domainFieldProps)), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('col', colXs, {
      'col-lg-10': hideAdvancedProperties,
      'col-lg-8': !hideAdvancedProperties
    })
  }, children));
});
AssayPropertiesInput.displayName = 'AssayPropertiesInput';
AssayPropertiesInput.defaultProps = {
  colSize: 9
};
function NameInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Name",
    required: true,
    hideAdvancedProperties: props.hideAdvancedProperties
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control",
    id: FORM_IDS.ASSAY_NAME,
    type: "text",
    placeholder: "Enter a name for this assay",
    value: props.model.name || '',
    onChange: props.onChange,
    disabled: !props.model.isNew() && !props.canRename
  }));
}
function DescriptionInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Description",
    hideAdvancedProperties: props.hideAdvancedProperties,
    helpTipBody: /*#__PURE__*/external_react_default().createElement("p", null, "A short description for this assay design.")
  }, /*#__PURE__*/external_react_default().createElement("textarea", {
    className: "form-control",
    id: FORM_IDS.ASSAY_DESCRIPTION,
    value: props.model.description || '',
    onChange: props.onChange
  }));
}
const QCStatesInput = props => {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "QC States",
    helpTipBody: /*#__PURE__*/external_react_default().createElement("p", null, "If enabled, QC states can be configured and assigned on a per run basis to control the visibility of imported run data. Users not in the QC Analyst role will not be able to view non-public data.")
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "checkbox",
    id: FORM_IDS.QC_ENABLED,
    checked: props.model.qcEnabled,
    onChange: props.onChange
  }));
};
function PlateTemplatesInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Plate Template",
    required: true,
    colSize: 6,
    hideAdvancedProperties: props.hideAdvancedProperties,
    helpTipBody: /*#__PURE__*/external_react_default().createElement("p", null, "Specify the plate template definition used to map spots or wells on the plate to data fields in this assay design. ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
      topic: ASSAY_EDIT_PLATE_TEMPLATE_TOPIC
    }, "More info"))
  }, /*#__PURE__*/external_react_default().createElement("select", {
    className: "form-control",
    id: FORM_IDS.PLATE_TEMPLATE,
    onChange: props.onChange,
    value: props.model.selectedPlateTemplate
  }, /*#__PURE__*/external_react_default().createElement("option", {
    key: "_empty",
    value: null
  }), props.model.availablePlateTemplates.map((type, i) => /*#__PURE__*/external_react_default().createElement("option", {
    key: i,
    value: type
  }, type))), /*#__PURE__*/external_react_default().createElement("a", {
    className: "labkey-text-link",
    href: buildURL('plate', 'plateTemplateList')
  }, "Configure Templates"));
}
function DetectionMethodsInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Detection Method",
    required: true,
    colSize: 6,
    hideAdvancedProperties: props.hideAdvancedProperties
  }, /*#__PURE__*/external_react_default().createElement("select", {
    className: "form-control",
    id: FORM_IDS.DETECTION_METHOD,
    onChange: props.onChange,
    value: props.model.selectedDetectionMethod
  }, /*#__PURE__*/external_react_default().createElement("option", {
    key: "_empty",
    value: null
  }), props.model.availableDetectionMethods.map((method, i) => /*#__PURE__*/external_react_default().createElement("option", {
    key: i,
    value: method
  }, method))));
}
function MetadataInputFormatsInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Metadata Input Format",
    required: true,
    colSize: 6,
    hideAdvancedProperties: props.hideAdvancedProperties,
    helpTipBody: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("strong", null, "Manual: "), " Metadata is provided as form based manual entry."), /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("strong", null, "File Upload (metadata only): "), " Metadata is provided from a file upload (separate from the run data file)."), /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("strong", null, "Combined File Upload (metadata & run data): "), " Metadata and run data are combined into a single file upload."))
  }, /*#__PURE__*/external_react_default().createElement("select", {
    className: "form-control",
    id: FORM_IDS.METADATA_INPUT_FORMAT,
    onChange: props.onChange,
    value: props.model.selectedMetadataInputFormat
  }, Object.keys(props.model.availableMetadataInputFormats).map((key, i) => /*#__PURE__*/external_react_default().createElement("option", {
    key: i,
    value: key
  }, props.model.availableMetadataInputFormats[key]))));
}
const AssayStatusInput = props => {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Active",
    hideAdvancedProperties: props.hideAdvancedProperties,
    helpTipBody: /*#__PURE__*/external_react_default().createElement("p", null, "If disabled, this assay design will be considered archived, and will be hidden in certain views.")
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "checkbox",
    id: FORM_IDS.STATUS,
    checked: props.model.isActive(),
    onChange: props.onChange
  }));
};
function EditableRunsInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Editable Runs",
    hideAdvancedProperties: props.hideAdvancedProperties,
    helpTipBody: /*#__PURE__*/external_react_default().createElement("p", null, "If enabled, users with sufficient permissions can edit values at the run level after the initial import is complete. These changes will be audited.")
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "checkbox",
    id: FORM_IDS.EDITABLE_RUNS,
    checked: props.model.editableRuns,
    onChange: props.onChange
  }));
}
function EditableResultsInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Editable Results",
    hideAdvancedProperties: props.hideAdvancedProperties,
    helpTipBody: /*#__PURE__*/external_react_default().createElement("p", null, "If enabled, users with sufficient permissions can edit and delete at the individual results row level after the initial import is complete. New result rows cannot be added to existing runs. These changes will be audited.")
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "checkbox",
    id: FORM_IDS.EDITABLE_RESULTS,
    checked: props.model.editableResults,
    onChange: props.onChange
  }));
}
function BackgroundUploadInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Import in Background",
    helpTipBody: /*#__PURE__*/external_react_default().createElement("p", null, "If enabled, assay imports will be processed as jobs in the data pipeline. If there are any errors during the import, they can be viewed from the log file for that job.")
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "checkbox",
    id: FORM_IDS.BACKGROUND_UPLOAD,
    checked: props.model.backgroundUpload,
    onChange: props.onChange
  }));
}
class AutoLinkDataInput extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      containers: undefined
    };
  }
  componentDidMount() {
    getValidPublishTargets(this.props.model.container).then(containers => {
      this.setState({
        containers: (0,external_immutable_.List)(containers)
      });
    }).catch(response => {
      this.setState({
        containers: (0,external_immutable_.List)()
      });
    });
  }
  render() {
    const {
      model,
      onChange
    } = this.props;
    const {
      containers
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
      label: "Auto-Link Data to Study",
      helpTipBody: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "When new runs are imported, automatically link their data rows to the specified target study. Only rows that include subject and visit/date information will be linked."), /*#__PURE__*/external_react_default().createElement("p", null, "The user performing the import must have insert permission in the target study and the corresponding dataset."))
    }, /*#__PURE__*/external_react_default().createElement(AutoLinkToStudyDropdown, {
      containers: containers,
      onChange: onChange,
      autoLinkTarget: FORM_IDS.AUTO_LINK_TARGET,
      value: model.autoCopyTargetContainerId
    }));
  }
}
const AutoLinkCategoryInput = (0,external_react_.memo)(props => {
  const {
    model,
    onChange
  } = props;
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Linked Dataset Category",
    helpTipBody: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Specify the desired category for the Assay Dataset that will be created (or appended to) in the target study when rows are linked. If the category you specify does not exist, it will be created."), /*#__PURE__*/external_react_default().createElement("p", null, "If the Assay Dataset already exists, this setting will not overwrite a previously assigned category. Leave blank to use the default category of \"Uncategorized\"."))
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control",
    id: FORM_IDS.AUTO_LINK_CATEGORY,
    type: "text",
    value: model.autoLinkCategory,
    onChange: onChange
  }));
});
function ModuleProvidedScriptsInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Module-Provided Scripts",
    helpTipBody: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "These scripts are part of the assay type and cannot be removed. They will run after any custom scripts configured above."), /*#__PURE__*/external_react_default().createElement("p", null, "The extension of the script file identifies the scripting engine that will be used to run the validation script. For example, a script named test.pl will be run with the Perl scripting engine. The scripting engine must be configured on the Views and Scripting page in the Admin Console. ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
      topic: CONFIGURE_SCRIPTING_TOPIC
    }, "More info")))
  }, props.model.moduleTransformScripts.map((script, i) => {
    return /*#__PURE__*/external_react_default().createElement("div", {
      key: i,
      className: "module-transform-script",
      style: {
        overflowWrap: 'break-word'
      }
    }, script);
  }));
}
var AddingScriptType = /*#__PURE__*/function (AddingScriptType) {
  AddingScriptType[AddingScriptType["file"] = 0] = "file";
  AddingScriptType[AddingScriptType["path"] = 1] = "path";
  return AddingScriptType;
}(AddingScriptType || {});
class TransformScriptsInput extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    AssayPropertiesInput_defineProperty(this, "state", {
      error: undefined,
      addingScript: undefined,
      addingScriptPath: ''
    });
    AssayPropertiesInput_defineProperty(this, "toggleAddingScript", () => {
      this.setState(state => ({
        addingScript: state.addingScript === undefined ? AddingScriptType.file : undefined,
        addingScriptPath: '',
        error: undefined
      }));
    });
    AssayPropertiesInput_defineProperty(this, "onChangeAddingScriptType", evt => {
      const value = evt.target.value ?? evt.target.getAttribute('data-value');
      this.setState({
        addingScript: value === 'file' ? AddingScriptType.file : AddingScriptType.path
      });
    });
    AssayPropertiesInput_defineProperty(this, "addScript", path => {
      const scripts = this.props.model.protocolTransformScripts ? this.props.model.protocolTransformScripts : (0,external_immutable_.List)();
      this.applyChanges(scripts.push(path ?? ''));
      this.toggleAddingScript();
    });
    AssayPropertiesInput_defineProperty(this, "removeScript", index => {
      this.applyChanges(this.props.model.protocolTransformScripts.filter((script, i) => i !== index));
    });
    AssayPropertiesInput_defineProperty(this, "onScriptPathChange", evt => {
      this.setState({
        addingScriptPath: evt.target.value
      });
    });
    AssayPropertiesInput_defineProperty(this, "onAddScriptPath", async () => {
      if (this.state.addingScript !== AddingScriptType.path) return;
      const {
        model
      } = this.props;
      this.setState({
        error: undefined
      });
      try {
        const value = this.state.addingScriptPath?.trim() ?? '';
        if (value.length > 0) {
          await getScriptEngineForExtension(getFileExtension(value), model.container);
          this.addScript(value);
        }
      } catch (e) {
        this.setState({
          error: resolveErrorMessage(e)
        });
      }
    });
    AssayPropertiesInput_defineProperty(this, "onAddScriptFile", async files => {
      if (this.state.addingScript !== AddingScriptType.file) return;
      const {
        model
      } = this.props;
      this.setState({
        error: undefined
      });
      try {
        await getScriptEngineForExtension(getFileExtension(files.first()?.name), model.container);
        const url = getWebDavUrl(model.container, SCRIPTS_DIR, false, true);
        const fileName = await uploadWebDavFileToUrl(files.first(), url, false);
        const scriptFiles = await getWebDavFiles(model.container, SCRIPTS_DIR, false, true);
        const filePath = scriptFiles.get('files')?.get(fileName)?.dataFileUrl;

        // dataFileUrl comes back encoded and with a "file://" prefix
        if (filePath) {
          this.addScript(decodeURIComponent(filePath.replace('file://', '')));
        }
      } catch (e) {
        this.setState({
          error: resolveErrorMessage(e)
        });
      }
    });
    AssayPropertiesInput_defineProperty(this, "onRemoveScript", attachment => {
      this.applyChanges(this.props.model.protocolTransformScripts.filter(script => script !== attachment.description));
    });
    AssayPropertiesInput_defineProperty(this, "onCopyScriptPath", attachment => {
      const handleCopy = event => {
        setCopyValue(event, attachment.description);
        event.preventDefault();
        document.removeEventListener('copy', handleCopy, true);
      };
      document.addEventListener('copy', handleCopy, true);
      document.execCommand('copy');
    });
  }
  applyChanges(updatedScripts) {
    this.props.onChange(FORM_IDS.PROTOCOL_TRANSFORM_SCRIPTS, updatedScripts);
  }
  renderLabel() {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "col col-xs-3 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Transform Scripts",
      helpTipBody: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Upload a transform script file or enter the full path to an existing file."), /*#__PURE__*/external_react_default().createElement("p", null, "Transform scripts run before the assay data is imported and can reshape the data file to match the expected import format.", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: PROGRAMMATIC_QC_TOPIC,
        useDefaultUrl: true
      }, "More info")), /*#__PURE__*/external_react_default().createElement("p", null, "The extension of the script file identifies the scripting engine that will be used. The scripting engine must be configured on the Views and Scripting page in the Admin Console.", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: CONFIGURE_SCRIPTING_TOPIC,
        useDefaultUrl: true
      }, "More info")))
    }));
  }
  render() {
    const {
      model
    } = this.props;
    const {
      error,
      addingScript,
      addingScriptPath
    } = this.state;
    const protocolTransformScripts = model.protocolTransformScripts || (0,external_immutable_.List)();
    const protocolTransformAttachments = protocolTransformScripts.map(script => {
      return {
        name: getAttachmentTitleFromName(script),
        description: script
      };
    });
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, protocolTransformAttachments.map((attachment, i) => {
      return /*#__PURE__*/external_react_default().createElement("div", {
        key: i,
        className: "row margin-top"
      }, i === 0 ? this.renderLabel() : /*#__PURE__*/external_react_default().createElement("div", {
        className: "col col-xs-3 col-lg-4"
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "col col-xs-9 col-lg-8"
      }, /*#__PURE__*/external_react_default().createElement(AttachmentCard, {
        outerCls: "transform-script-card",
        allowRemove: true,
        allowDownload: false,
        attachment: attachment,
        copyNoun: "path",
        noun: "path",
        onRemove: this.onRemoveScript,
        onCopyLink: this.onCopyScriptPath
      })));
    }), addingScript !== undefined && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row transform-script-add"
    }, protocolTransformScripts.size === 0 ? this.renderLabel() : /*#__PURE__*/external_react_default().createElement("div", {
      className: "col col-xs-3 col-lg-4"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col col-xs-8 col-lg-8"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "transform-script-add--radio",
      checked: addingScript === AddingScriptType.file,
      type: "radio",
      name: "transformScriptAddType",
      value: "file",
      onChange: this.onChangeAddingScriptType
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "transform-script-add--label",
      "data-value": "file",
      onClick: this.onChangeAddingScriptType
    }, "Upload file"), /*#__PURE__*/external_react_default().createElement("input", {
      className: "transform-script-add--radio",
      checked: addingScript === AddingScriptType.path,
      type: "radio",
      name: "transformScriptAddType",
      value: "path",
      onChange: this.onChangeAddingScriptType
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "transform-script-add--label",
      "data-value": "path",
      onClick: this.onChangeAddingScriptType
    }, "Enter file path"), /*#__PURE__*/external_react_default().createElement(RemoveEntityButton, {
      labelClass: "domain-remove-icon pull-right",
      onClick: this.toggleAddingScript
    }), addingScript === AddingScriptType.file && /*#__PURE__*/external_react_default().createElement(FileAttachmentForm, {
      allowDirectories: false,
      allowMultiple: false,
      compact: true,
      showLabel: false,
      onFileChange: this.onAddScriptFile
    }), addingScript === AddingScriptType.path && /*#__PURE__*/external_react_default().createElement("div", {
      className: "transform-script-add--path"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      type: "text",
      className: "form-control",
      value: addingScriptPath,
      onChange: this.onScriptPathChange
    }), /*#__PURE__*/external_react_default().createElement("button", {
      type: "button",
      className: "btn btn-primary",
      onClick: this.onAddScriptPath
    }, "Apply")), error && /*#__PURE__*/external_react_default().createElement(Alert, null, error))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, protocolTransformScripts.size === 0 && addingScript === undefined ? this.renderLabel() : /*#__PURE__*/external_react_default().createElement("div", {
      className: "col col-xs-3 col-lg-4"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col col-xs-9 col-lg-8"
    }, /*#__PURE__*/external_react_default().createElement(AddEntityButton, {
      entity: "Script",
      containerClass: "transform-script--add-button",
      onClick: this.toggleAddingScript,
      disabled: addingScript !== undefined
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "transform-script--manage-link"
    }, /*#__PURE__*/external_react_default().createElement("a", {
      href: getWebDavUrl(model.container, SCRIPTS_DIR, false, true),
      target: "_blank",
      className: "labkey-text-link",
      rel: "noopener noreferrer"
    }, "Manage script files")))));
  }
}
function SaveScriptDataInput(props) {
  const {
    model
  } = props;
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Save Script Data for Debugging",
    helpTipBody: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Typically transform and validation script data files are deleted on script completion. For debug purposes, it can be helpful to be able to view the files generated by the server that are passed to the script."), /*#__PURE__*/external_react_default().createElement("p", null, "If this checkbox is checked, files will be saved to a subfolder named: \"TransformAndValidationFiles\", located in the same folder that the original script is located."), !model.isNew() && /*#__PURE__*/external_react_default().createElement("p", null, "Use the \"Download template files\" link to get example files for your assay design.", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
      topic: RUN_PROPERTIES_TOPIC,
      useDefaultUrl: true
    }, "More info")))
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "checkbox",
    id: FORM_IDS.SAVE_SCRIPT_FILES,
    checked: props.model.saveScriptFiles,
    onChange: props.onChange
  }), !model.isNew() && /*#__PURE__*/external_react_default().createElement("div", {
    className: "transform-script--download-link"
  }, /*#__PURE__*/external_react_default().createElement("a", {
    href: buildURL('assay', 'downloadSampleQCData', {
      rowId: model.protocolId
    }),
    target: "_blank",
    className: "labkey-text-link",
    rel: "noopener noreferrer"
  }, "Download template files")));
}
function PlateMetadataInput(props) {
  return /*#__PURE__*/external_react_default().createElement(AssayPropertiesInput, {
    label: "Plate Metadata",
    helpTipBody: /*#__PURE__*/external_react_default().createElement("p", null, "If enabled, plate template metadata can be added on a per run basis to combine tabular data that has well location information with plate based data.")
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "checkbox",
    id: FORM_IDS.PLATE_METADATA,
    checked: props.model.plateMetadata,
    onChange: props.onChange
  }));
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/assay/AssayPropertiesPanel.tsx
function AssayPropertiesPanel_extends() { return AssayPropertiesPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, AssayPropertiesPanel_extends.apply(null, arguments); }












const AssayPropertiesForm = (0,external_react_.memo)(props => {
  const {
    appPropertiesOnly,
    hideAdvancedProperties,
    children,
    hideStudyProperties,
    model,
    onChange,
    canRename
  } = props;
  const {
    moduleContext
  } = useServerContext();
  const onValueChange = (0,external_react_.useCallback)((id, value) => {
    const newModel = model.merge({
      [id.replace(FORM_ID_PREFIX, '')]: api_.Utils.isString(value) ? value.trimStart() : value
    });
    onChange(newModel);
  }, [model, onChange]);
  const onInputChange = (0,external_react_.useCallback)(evt => {
    const id = evt.target.id;
    let value = evt.target.value;

    // special case for checkboxes to use "checked" property of target
    if (BOOLEAN_FIELDS.indexOf(id) > -1) {
      value = evt.target.checked;
    }

    // special case for empty string, set as null instead
    if (api_.Utils.isString(value) && value?.trimStart().length === 0) {
      value = null;
    }
    onValueChange(id, value);
  }, [onValueChange]);
  const onStatusChange = (0,external_react_.useCallback)(evt => {
    const id = evt.target.id;
    const value = evt.target.checked ? Status.Active : Status.Archived;
    const newModel = model.merge({
      [id.replace(FORM_ID_PREFIX, '')]: value
    });
    onChange(newModel);
  }, [model, onChange]);
  return /*#__PURE__*/external_react_default().createElement("form", null, children && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12"
  }, children)), /*#__PURE__*/external_react_default().createElement("div", {
    className: `col-xs-12 col-lg-${hideAdvancedProperties ? 12 : 6}`
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-padding-bottom"
  }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
    title: "Basic Properties"
  }), /*#__PURE__*/external_react_default().createElement(NameInput, {
    model: model,
    onChange: onInputChange,
    hideAdvancedProperties: hideAdvancedProperties,
    canRename: canRename
  }), /*#__PURE__*/external_react_default().createElement(DescriptionInput, {
    model: model,
    onChange: onInputChange,
    hideAdvancedProperties: hideAdvancedProperties
  }), model.allowPlateTemplateSelection() && /*#__PURE__*/external_react_default().createElement(PlateTemplatesInput, {
    model: model,
    onChange: onInputChange,
    hideAdvancedProperties: hideAdvancedProperties
  }), model.allowDetectionMethodSelection() && /*#__PURE__*/external_react_default().createElement(DetectionMethodsInput, {
    model: model,
    onChange: onInputChange,
    hideAdvancedProperties: hideAdvancedProperties
  }), model.allowMetadataInputFormatSelection() && /*#__PURE__*/external_react_default().createElement(MetadataInputFormatsInput, {
    model: model,
    onChange: onInputChange,
    hideAdvancedProperties: hideAdvancedProperties
  }), !hideAdvancedProperties && model.allowQCStates && isAssayQCEnabled(moduleContext) && /*#__PURE__*/external_react_default().createElement(QCStatesInput, {
    model: model,
    onChange: onInputChange
  }), (!appPropertiesOnly || isPlatesEnabled(moduleContext)) && model.allowPlateMetadata && /*#__PURE__*/external_react_default().createElement(PlateMetadataInput, {
    model: model,
    onChange: onInputChange
  }), isPremiumProductEnabled(moduleContext) && /*#__PURE__*/external_react_default().createElement(AssayStatusInput, {
    model: model,
    onChange: onStatusChange,
    hideAdvancedProperties: hideAdvancedProperties
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-padding-bottom"
  }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
    title: "Editing Settings"
  }), /*#__PURE__*/external_react_default().createElement(EditableRunsInput, {
    model: model,
    onChange: onInputChange,
    hideAdvancedProperties: hideAdvancedProperties
  }), model.allowEditableResults && /*#__PURE__*/external_react_default().createElement(EditableResultsInput, {
    model: model,
    onChange: onInputChange,
    hideAdvancedProperties: hideAdvancedProperties
  }))), !hideAdvancedProperties && /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12 col-lg-6"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-padding-bottom"
  }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
    title: "Import Settings"
  }), model.allowBackgroundUpload && /*#__PURE__*/external_react_default().createElement(BackgroundUploadInput, {
    model: model,
    onChange: onInputChange
  }), model.allowTransformationScript && /*#__PURE__*/external_react_default().createElement(TransformScriptsInput, {
    model: model,
    onChange: onValueChange
  }), model.allowTransformationScript && /*#__PURE__*/external_react_default().createElement(SaveScriptDataInput, {
    model: model,
    onChange: onInputChange
  }), model.moduleTransformScripts?.size > 0 && /*#__PURE__*/external_react_default().createElement(ModuleProvidedScriptsInput, {
    model: model
  }))), !hideAdvancedProperties && !hideStudyProperties && hasModule('study', moduleContext) && /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-12 col-lg-6"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "domain-field-padding-bottom"
  }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
    title: "Link to Study Settings"
  }), /*#__PURE__*/external_react_default().createElement(AutoLinkDataInput, {
    model: model,
    onChange: onInputChange
  }), /*#__PURE__*/external_react_default().createElement(AutoLinkCategoryInput, {
    model: model,
    onChange: onInputChange
  }))));
});
AssayPropertiesForm.displayName = 'AssayPropertiesForm';
const AssayPropertiesPanelImpl = (0,external_react_.memo)(props => {
  const {
    appPropertiesOnly,
    hideAdvancedProperties,
    canRename,
    asPanel,
    children,
    helpTopic,
    hideStudyProperties,
    model,
    onChange
  } = props;
  const [isValid, setIsValid] = (0,external_react_.useState)(true);
  const updateValidStatus = (0,external_react_.useCallback)(newModel => {
    const updatedModel = newModel || model;
    setIsValid(!!updatedModel?.hasValidProperties());

    // Issue 39918: only consider the model changed if there is a newModel param
    if (newModel) {
      onChange(updatedModel);
    }
  }, [model, onChange]);
  const form = /*#__PURE__*/external_react_default().createElement(AssayPropertiesForm, {
    appPropertiesOnly: appPropertiesOnly,
    hideAdvancedProperties: hideAdvancedProperties,
    hideStudyProperties: hideStudyProperties,
    model: model,
    onChange: updateValidStatus,
    canRename: canRename
  }, children);
  if (asPanel) {
    return /*#__PURE__*/external_react_default().createElement(BasePropertiesPanel, AssayPropertiesPanel_extends({}, props, {
      headerId: PROPERTIES_HEADER_ID,
      isValid: isValid,
      title: "Assay Properties",
      updateValidStatus: updateValidStatus
    }), helpTopic && /*#__PURE__*/external_react_default().createElement(HelpTopicURL, {
      nounPlural: "assays",
      helpTopic: helpTopic
    }), form);
  }
  return form;
});
AssayPropertiesPanelImpl.defaultProps = {
  appPropertiesOnly: false,
  hideAdvancedProperties: false,
  hideStudyProperties: false,
  asPanel: true,
  helpTopic: DEFINE_ASSAY_SCHEMA_TOPIC
};
AssayPropertiesPanelImpl.displayName = 'AssayPropertiesPanelImpl';
const AssayPropertiesPanel = withDomainPropertiesPanelCollapse(AssayPropertiesPanelImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/assay/AssayDesignerPanels.tsx
function AssayDesignerPanels_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AssayDesignerPanels_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AssayDesignerPanels_ownKeys(Object(t), !0).forEach(function (r) { AssayDesignerPanels_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AssayDesignerPanels_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function AssayDesignerPanels_defineProperty(e, r, t) { return (r = AssayDesignerPanels_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function AssayDesignerPanels_toPropertyKey(t) { var i = AssayDesignerPanels_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function AssayDesignerPanels_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











const PROPERTIES_PANEL_INDEX = 0;
const DOMAIN_PANEL_INDEX = 1;
// Exported for testing
class AssayDesignerPanelsImpl extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    AssayDesignerPanels_defineProperty(this, "panelCount", 1);
    AssayDesignerPanels_defineProperty(this, "onDomainChange", (index, updatedDomain, dirty) => {
      const {
        onChange
      } = this.props;
      this.setState(state => {
        const domains = state.protocolModel.domains.map((domain, i) => {
          return i === index ? updatedDomain : domain;
        });
        const updatedModel = state.protocolModel.merge({
          domains
        });
        return {
          protocolModel: updatedModel
        };
      }, () => {
        // Issue 39918: use the dirty property that DomainForm onChange passes
        if (dirty) {
          onChange?.(this.state.protocolModel);
        }
      });
    });
    AssayDesignerPanels_defineProperty(this, "onFinish", () => {
      const {
        setSubmitting
      } = this.props;
      const {
        protocolModel
      } = this.state;
      const appIsValidMsg = this.getAppIsValidMsg();
      const textChoiceValidMsg = this.getTextChoiceUpdatesValidMsg();
      const isValid = protocolModel.isValid() && textChoiceValidMsg === undefined && appIsValidMsg === undefined;
      this.props.onFinish(isValid, this.saveDomain);
      if (!isValid) {
        const exception = appIsValidMsg !== undefined ? appIsValidMsg : textChoiceValidMsg ?? protocolModel.getFirstDomainFieldError();
        const updatedModel = protocolModel.set('exception', exception);
        setSubmitting(false, () => {
          this.setState(() => ({
            protocolModel: updatedModel
          }), () => {
            scrollDomainErrorIntoView();
          });
        });
      }
    });
    AssayDesignerPanels_defineProperty(this, "saveDomain", () => {
      const {
        beforeFinish,
        setSubmitting
      } = this.props;
      const {
        protocolModel
      } = this.state;
      beforeFinish?.(protocolModel);
      saveAssayDesign(protocolModel).then(response => {
        this.setState(() => ({
          protocolModel
        }));
        setSubmitting(false, () => {
          this.props.onComplete(response);
        });
      }).catch(errorModel => {
        setSubmitting(false, () => {
          this.setState(() => ({
            protocolModel: errorModel
          }), () => {
            scrollDomainErrorIntoView();
          });
        });
      });
    });
    AssayDesignerPanels_defineProperty(this, "onAssayPropertiesChange", protocolModel => {
      this.setState({
        protocolModel
      }, () => {
        this.props.onChange?.(protocolModel);
      });
    });
    AssayDesignerPanels_defineProperty(this, "getAppDomainHeaderRenderer", domain => {
      const {
        appDomainHeaders
      } = this.props;
      if (!appDomainHeaders) return undefined;
      return appDomainHeaders.filter((v, k) => domain.isNameSuffixMatch(k)).first();
    });
    AssayDesignerPanels_defineProperty(this, "onUpdateExcludedProjects", (_, excludedContainerIds) => {
      const {
        protocolModel
      } = this.state;
      const newModel = protocolModel.merge({
        excludedContainerIds
      });
      this.onAssayPropertiesChange(newModel);
    });
    this.panelCount = this.panelCount + props.initModel.domains.size;
    this.state = {
      protocolModel: props.initModel
    };
  }
  shouldSkipBatchDomain(domain) {
    return this.props.hideEmptyBatchDomain && domain && domain.isNameSuffixMatch('Batch') && domain.fields.size === 0;
  }
  getAppIsValidMsg() {
    const {
      appIsValidMsg
    } = this.props;
    const {
      protocolModel
    } = this.state;
    return !appIsValidMsg ? undefined : appIsValidMsg(protocolModel);
  }
  getTextChoiceUpdatesValidMsg() {
    const {
      protocolModel
    } = this.state;
    const runDomain = protocolModel.getDomainByNameSuffix('Run');
    if (runDomain && !protocolModel.editableRuns && this.domainHasTextChoiceUpdates(runDomain)) {
      return 'Text choice value updates are not allowed when assay does not allow "Editable Runs".';
    }
    const dataDomain = protocolModel.getDomainByNameSuffix('Data');
    if (dataDomain && !protocolModel.editableResults && this.domainHasTextChoiceUpdates(dataDomain)) {
      return 'Text choice value updates are not allowed when assay does not allow "Editable Results".';
    }
    return undefined;
  }
  domainHasTextChoiceUpdates(domain) {
    return domain.fields.find(field => {
      const valueUpdates = field.textChoiceValidator?.extraProperties?.valueUpdates ?? {};
      return Object.keys(valueUpdates).length > 0;
    }) !== undefined;
  }
  render() {
    const {
      allowProjectExclusion,
      initModel,
      api,
      appPropertiesOnly,
      hideAdvancedProperties,
      domainFormDisplayOptions,
      currentPanelIndex,
      validatePanel,
      visitedPanels,
      firstState,
      onTogglePanel,
      submitting,
      onCancel,
      saveBtnText
    } = this.props;
    const {
      protocolModel
    } = this.state;
    const isGpat = protocolModel.providerName === GENERAL_ASSAY_PROVIDER_NAME;
    return /*#__PURE__*/external_react_default().createElement(BaseDomainDesigner, {
      name: protocolModel.name,
      exception: protocolModel.exception,
      domains: protocolModel.domains,
      hasValidProperties: protocolModel.hasValidProperties(),
      visitedPanels: visitedPanels,
      submitting: submitting,
      onCancel: onCancel,
      onFinish: this.onFinish,
      saveBtnText: saveBtnText
    }, /*#__PURE__*/external_react_default().createElement(AssayPropertiesPanel, {
      model: protocolModel,
      onChange: this.onAssayPropertiesChange,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== PROPERTIES_PANEL_INDEX,
      panelStatus: protocolModel.isNew() ? getDomainPanelStatus(PROPERTIES_PANEL_INDEX, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      validate: validatePanel === PROPERTIES_PANEL_INDEX,
      appPropertiesOnly: appPropertiesOnly,
      hideAdvancedProperties: hideAdvancedProperties,
      hideStudyProperties: !!domainFormDisplayOptions && domainFormDisplayOptions.hideStudyPropertyTypes,
      onToggle: (collapsed, callback) => {
        onTogglePanel(PROPERTIES_PANEL_INDEX, collapsed, callback);
      },
      canRename: isGpat
    }), protocolModel.domains.map((domain, i) => {
      // optionally hide the Batch Fields domain from the UI
      if (this.shouldSkipBatchDomain(domain)) {
        return;
      }

      // allow empty domain to be inferred from a file for Data Fields in General assay
      const hideInferFromFile = !isGpat || !domain.isNameSuffixMatch('Data');
      // The File property type should be hidden for Data domains if the display options indicate this.
      // We will always allow file property types for the Batch and Run domains.
      const hideFilePropertyType = domainFormDisplayOptions.hideFilePropertyType && !domain.isNameSuffixMatch('Batch') && !domain.isNameSuffixMatch('Run');
      const appDomainHeaderRenderer = this.getAppDomainHeaderRenderer(domain);
      const textChoiceLockedForDomain = !(domain.isNameSuffixMatch('Run') && protocolModel.editableRuns || domain.isNameSuffixMatch('Data') && protocolModel.editableResults);
      return /*#__PURE__*/external_react_default().createElement(domainproperties_DomainForm, {
        key: domain.domainId || i,
        api: api,
        index: domain.domainId || i,
        domainIndex: i,
        domain: domain,
        headerPrefix: initModel?.name,
        controlledCollapse: true,
        initCollapsed: currentPanelIndex !== i + DOMAIN_PANEL_INDEX,
        validate: validatePanel === i + DOMAIN_PANEL_INDEX,
        panelStatus: protocolModel.isNew() ? getDomainPanelStatus(i + DOMAIN_PANEL_INDEX, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
        helpTopic: null // null so that we don't show the "learn more about this tool" link for these domains
        ,
        onChange: (updatedDomain, dirty) => {
          this.onDomainChange(i, updatedDomain, dirty);
        },
        onToggle: (collapsed, callback) => {
          onTogglePanel(i + DOMAIN_PANEL_INDEX, collapsed, callback);
        },
        appDomainHeaderRenderer: appDomainHeaderRenderer,
        modelDomains: protocolModel.domains,
        appPropertiesOnly: hideAdvancedProperties,
        domainFormDisplayOptions: AssayDesignerPanels_objectSpread(AssayDesignerPanels_objectSpread({}, domainFormDisplayOptions), {}, {
          domainKindDisplayName: 'assay design',
          hideFilePropertyType,
          hideInferFromFile,
          textChoiceLockedForDomain
        })
      }, /*#__PURE__*/external_react_default().createElement("div", null, domain.description));
    }), appPropertiesOnly && allowProjectExclusion && /*#__PURE__*/external_react_default().createElement(DataTypeProjectsPanel, {
      controlledCollapse: true,
      dataTypeRowId: protocolModel?.protocolId,
      dataTypeName: protocolModel?.name,
      entityDataType: AssayRunDataType,
      initCollapsed: currentPanelIndex !== protocolModel.domains.size + 1,
      onToggle: (collapsed, callback) => {
        onTogglePanel(protocolModel.domains.size + 1, collapsed, callback);
      },
      onUpdateExcludedProjects: this.onUpdateExcludedProjects
    }));
  }
}
// start at 1 for the AssayPropertiesPanel, will updated count after domains are defined in constructor
AssayDesignerPanels_defineProperty(AssayDesignerPanelsImpl, "defaultProps", {
  api: getDefaultAPIWrapper().domain,
  domainFormDisplayOptions: DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS
});
const AssayDesignerPanels = withBaseDomainDesigner(AssayDesignerPanelsImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/issues/models.ts
function issues_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function issues_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? issues_models_ownKeys(Object(t), !0).forEach(function (r) { issues_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : issues_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function issues_models_defineProperty(e, r, t) { return (r = issues_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function issues_models_toPropertyKey(t) { var i = issues_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function issues_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



class IssuesListDefModel {
  constructor(values) {
    issues_models_defineProperty(this, external_immer_.immerable, true);
    issues_models_defineProperty(this, "exception", void 0);
    issues_models_defineProperty(this, "domain", void 0);
    issues_models_defineProperty(this, "entityId", void 0);
    issues_models_defineProperty(this, "domainId", void 0);
    issues_models_defineProperty(this, "issueDefName", void 0);
    issues_models_defineProperty(this, "singularItemName", 'Issue');
    issues_models_defineProperty(this, "pluralItemName", 'Issues');
    issues_models_defineProperty(this, "commentSortDirection", 'ASC');
    issues_models_defineProperty(this, "assignedToGroup", void 0);
    issues_models_defineProperty(this, "assignedToUser", void 0);
    issues_models_defineProperty(this, "domainKindName", void 0);
    issues_models_defineProperty(this, "relatedFolderName", void 0);
    issues_models_defineProperty(this, "restrictedIssueList", void 0);
    issues_models_defineProperty(this, "restrictedIssueListGroup", void 0);
    Object.assign(this, values);
  }
  static create(raw, defaultSettings = null) {
    if (defaultSettings) {
      const domain = DomainDesign.create(undefined);
      return new IssuesListDefModel(issues_models_objectSpread(issues_models_objectSpread({}, defaultSettings), {}, {
        domain
      }));
    } else {
      const domain = DomainDesign.create(raw.domainDesign);
      return new IssuesListDefModel(issues_models_objectSpread(issues_models_objectSpread({}, raw.options), {}, {
        domain
      }));
    }
  }
  isNew() {
    return !this.entityId;
  }
  isValid() {
    return this.hasValidProperties() && !this.domain.hasInvalidFields();
  }
  hasValidProperties() {
    return this.issueDefName !== undefined && this.issueDefName !== null && this.issueDefName.trim().length > 0;
  }
  getOptions() {
    return {
      entityId: this.entityId,
      issueDefName: this.issueDefName,
      singularItemName: this.singularItemName,
      pluralItemName: this.pluralItemName,
      commentSortDirection: this.commentSortDirection,
      assignedToGroup: this.assignedToGroup,
      assignedToUser: this.assignedToUser,
      relatedFolderName: this.relatedFolderName,
      restrictedIssueList: this.restrictedIssueList,
      restrictedIssueListGroup: this.restrictedIssueListGroup
    };
  }
}
class IssuesRelatedFolder extends (0,external_immutable_.Record)({
  issueDefName: undefined,
  displayName: undefined,
  containerPath: undefined,
  key: undefined
}) {
  static create(raw) {
    return new IssuesRelatedFolder(issues_models_objectSpread({}, raw));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/issues/constants.ts
const ISSUES_LIST_DEF_SINGULAR_PLURAL_TIP = 'The Singular item name and Plural item name fields control the display ' + 'name for an "issue" across the Issues module. For example, you might instead refer to issues as "Bugs", "Tickets", or "Opportunities" depending on the context.';
const ISSUES_LIST_DEF_SORT_DIRECTION_TIP = 'By default, comments on an issue are shown in the order they are added, oldest first. Change the Comment Sort Direction to newest first if you prefer.';
const ISSUES_LIST_GROUP_ASSIGN_TIP = "Select a specific group from the dropdown, both site and project level groups are available. If left blank, the 'Assigned To' field will display all users who are a) assigned the role of Editor or higher in the folder, and b) are members of at least one project-level security group.";
const ISSUES_LIST_USER_ASSIGN_TIP = 'In some workflows it is useful to have a default user to whom all issues are assigned, such as for initial triage and balancing assignments across a group. If left blank, no user will be assigned by default.';
const ISSUES_LIST_RELATED_FOLDER_TIP = 'A related issue can be created in any issue list that the user can insert into. This setting controls the default folder selection in the related issue dialog box.';
const ISSUES_LIST_RESTRICTED_TRACKER_TIP = 'A restricted issue list will limit viewing and updating of all issues in the list. When the checkbox is selected only users who are either assigned to the issue or on the notify list ' + 'will have access to an issue. An additional group can optionally be configured to provide access to any members of that group.';
const ISSUES_LIST_RESTRICTED_GROUP_TIP = 'An optional project or site group that can give members of the group access to the issues in a restricted issue list.';
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/issues/IssuesListDefPropertiesPanelFormElements.tsx
function IssuesListDefPropertiesPanelFormElements_defineProperty(e, r, t) { return (r = IssuesListDefPropertiesPanelFormElements_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function IssuesListDefPropertiesPanelFormElements_toPropertyKey(t) { var i = IssuesListDefPropertiesPanelFormElements_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function IssuesListDefPropertiesPanelFormElements_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







// For AssignedToGroupInput & DefaultUserAssignmentInput components

class BasicPropertiesFields extends external_react_.PureComponent {
  render() {
    const {
      model,
      onInputChange,
      onSelect
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "Basic Properties"
    }), /*#__PURE__*/external_react_default().createElement(CommentSortDirectionDropDown, {
      model: model,
      onSelect: onSelect
    }), /*#__PURE__*/external_react_default().createElement(SingularItemNameInput, {
      model: model,
      onInputChange: onInputChange
    }), /*#__PURE__*/external_react_default().createElement(PluralItemNameInput, {
      model: model,
      onInputChange: onInputChange
    }));
  }
}
class AssignmentOptions extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "state", {
      coreGroups: undefined,
      coreUsers: undefined,
      relatedFolders: undefined
    });
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "componentDidMount", async () => {
      const {
        api,
        model
      } = this.props;
      try {
        const coreGroups = await api.getProjectGroups();
        const relatedFolders = await api.getRelatedFolders(model.issueDefName);
        this.setState({
          coreGroups,
          relatedFolders
        });
      } catch (e) {
        console.error('AssignmentOptions: failed to load initialize project groups and related folders.', e);
      }
      await this.loadUsersForGroup(this.props.model.assignedToGroup);
    });
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "loadUsersForGroup", async groupId => {
      try {
        const coreUsers = await this.props.api.getUsersForGroup(groupId);
        this.setState({
          coreUsers
        });
      } catch (e) {
        console.error(`AssignmentOptions: failed to load users for group ${groupId}`, e);
      }
    });
  }
  render() {
    const {
      model,
      onSelect
    } = this.props;
    const {
      coreUsers,
      coreGroups,
      relatedFolders
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12 col-md-6"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "Assignment Options"
    }), /*#__PURE__*/external_react_default().createElement(AssignedToGroupInput, {
      model: model,
      coreGroups: coreGroups,
      onSelect: onSelect,
      onGroupChange: this.loadUsersForGroup
    }), /*#__PURE__*/external_react_default().createElement(DefaultUserAssignmentInput, {
      model: model,
      coreUsers: coreUsers,
      onSelect: onSelect
    }), /*#__PURE__*/external_react_default().createElement(DefaultRelatedFolderInput, {
      model: model,
      relatedFolders: relatedFolders,
      onSelect: onSelect
    }));
  }
}
class RestrictedOptions extends external_react_.PureComponent {
  render() {
    const {
      api,
      model,
      onCheckChange,
      onSelect
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "Restricted List Options"
    }), /*#__PURE__*/external_react_default().createElement(RestrictedIssueInput, {
      api: api,
      model: model,
      onCheckChange: onCheckChange,
      onSelect: onSelect
    }), /*#__PURE__*/external_react_default().createElement(RestrictedIssueGroupInput, {
      api: api,
      model: model,
      onSelect: onSelect
    }));
  }
}
class SingularItemNameInput extends external_react_.PureComponent {
  render() {
    const {
      model,
      onInputChange
    } = this.props;
    const value = model.singularItemName === null ? '' : model.singularItemName;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Singular Item Name",
      helpTipBody: ISSUES_LIST_DEF_SINGULAR_PLURAL_TIP,
      required: false
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9 col-lg-8"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      id: "singularItemName",
      type: "text",
      value: value,
      onChange: onInputChange
    })));
  }
}
class PluralItemNameInput extends external_react_.PureComponent {
  render() {
    const {
      model,
      onInputChange
    } = this.props;
    const value = model.pluralItemName === null ? '' : model.pluralItemName;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Plural Items Name",
      helpTipBody: ISSUES_LIST_DEF_SINGULAR_PLURAL_TIP,
      required: false
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9 col-lg-8"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      id: "pluralItemName",
      type: "text",
      value: value,
      onChange: onInputChange
    })));
  }
}
class CommentSortDirectionDropDown extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "onChange", (name, formValue, selected) => {
      if (selected) {
        this.props.onSelect?.(name, selected.id);
      }
    });
  }
  render() {
    const {
      model
    } = this.props;
    const sortDirectionOptions = [{
      label: 'Oldest first',
      id: 'ASC'
    }, {
      label: 'Newest first',
      id: 'DESC'
    }];
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Comment Sort Direction",
      helpTipBody: ISSUES_LIST_DEF_SORT_DIRECTION_TIP,
      required: false
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9 col-lg-8"
    }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      name: "commentSortDirection",
      options: sortDirectionOptions,
      inputClass: "col-xs-12",
      valueKey: "id",
      onChange: this.onChange,
      value: model.commentSortDirection ?? 'ASC',
      clearable: false
    })));
  }
}
class AssignedToGroupInput extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "onChange", (name, formValue, selected, ref) => {
      const groupId = selected ? selected.userId : undefined;
      this.props.onGroupChange(groupId);
      this.props.onSelect(name, groupId);
    });
  }
  render() {
    const {
      model,
      coreGroups
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Populate \u2018Assigned To\u2019 Field from",
      helpTipBody: ISSUES_LIST_GROUP_ASSIGN_TIP,
      required: false
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9 col-lg-8"
    }, !coreGroups ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null) : /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      name: "assignedToGroup",
      options: coreGroups.toArray(),
      placeholder: "All Project Users",
      inputClass: "col-xs-12",
      valueKey: "userId",
      labelKey: "displayName",
      onChange: this.onChange,
      value: model.assignedToGroup ? model.assignedToGroup : undefined
    })));
  }
}
class DefaultUserAssignmentInput extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "onChange", (name, formValue, selected, ref) => {
      this.props.onSelect(name, selected ? selected.userId : undefined);
    });
  }
  render() {
    const {
      model,
      coreUsers
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Default User Assignment",
      helpTipBody: ISSUES_LIST_USER_ASSIGN_TIP,
      required: false
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9 col-lg-8"
    }, !coreUsers ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null) : /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      name: "assignedToUser",
      options: coreUsers?.toArray(),
      placeholder: "Unassigned",
      inputClass: "col-xs-12",
      valueKey: "userId",
      labelKey: "displayName",
      onChange: this.onChange,
      value: model.assignedToUser
    })));
  }
}
class DefaultRelatedFolderInput extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "onChange", (name, formValue, selected, ref) => {
      this.props.onSelect(name, selected ? selected.key : undefined);
    });
  }
  render() {
    const {
      model,
      relatedFolders
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Default Related Issue Folder",
      helpTipBody: ISSUES_LIST_RELATED_FOLDER_TIP,
      required: false
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9 col-lg-8"
    }, !relatedFolders ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null) : /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      name: "relatedFolderName",
      options: relatedFolders?.toArray(),
      placeholder: "Unassigned",
      inputClass: "col-xs-12",
      valueKey: "key",
      labelKey: "displayName",
      onChange: this.onChange,
      value: model.relatedFolderName
    })));
  }
}
class RestrictedIssueInput extends external_react_.PureComponent {
  render() {
    const {
      model,
      onCheckChange
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Restrict Issue List",
      helpTipBody: ISSUES_LIST_RESTRICTED_TRACKER_TIP
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9 col-lg-8"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      type: "checkbox",
      name: "restrictedIssueList",
      checked: model.restrictedIssueList,
      onChange: onCheckChange
    })));
  }
}
class RestrictedIssueGroupInput extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "state", {
      coreGroups: undefined
    });
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "componentDidMount", async () => {
      try {
        const coreGroups = await this.props.api.getProjectGroups();
        this.setState({
          coreGroups
        });
      } catch (e) {
        console.error('RestrictedOptions: failed to load initialize project groups', e);
      }
    });
    IssuesListDefPropertiesPanelFormElements_defineProperty(this, "onChange", (name, formValue, selected, ref) => {
      const groupId = selected ? selected.userId : undefined;
      this.props.onSelect(name, groupId);
    });
  }
  render() {
    const {
      model
    } = this.props;
    const {
      coreGroups
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Additional Group with Access",
      helpTipBody: ISSUES_LIST_RESTRICTED_GROUP_TIP
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9 col-lg-8"
    }, !coreGroups ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null) : /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      name: "restrictedIssueListGroup",
      options: coreGroups?.toArray(),
      placeholder: "Unassigned",
      inputClass: "col-xs-12",
      valueKey: "userId",
      labelKey: "displayName",
      onChange: this.onChange,
      value: model.restrictedIssueListGroup,
      disabled: !model.restrictedIssueList
    })));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/issues/actions.ts
function issues_actions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function issues_actions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? issues_actions_ownKeys(Object(t), !0).forEach(function (r) { issues_actions_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : issues_actions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function issues_actions_defineProperty(e, r, t) { return (r = issues_actions_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function issues_actions_toPropertyKey(t) { var i = issues_actions_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function issues_actions_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






function fetchIssuesListDefDesign(issueDefName) {
  return new Promise((resolve, reject) => {
    api_.Domain.getDomainDetails({
      schemaName: 'issues',
      queryName: issueDefName,
      domainKind: issueDefName === undefined ? 'IssueDefinition' : undefined,
      success: data => {
        resolve(IssuesListDefModel.create(data));
      },
      failure: error => {
        reject(error);
      }
    });
  });
}
class IssuesServerAPIWrapper {
  getProjectGroups() {
    return new Promise((resolve, reject) => {
      api_.Ajax.request({
        url: api_.ActionURL.buildURL('issues', 'getProjectGroups.api'),
        success: api_.Utils.getCallbackWrapper(coreGroupsData => {
          let groups = (0,external_immutable_.List)();
          coreGroupsData.forEach(principal => {
            const grp = Principal.create(principal);
            groups = groups.push(grp);
          });
          resolve(groups);
        }),
        failure: handleRequestFailure(reject, 'Failed to fetch project groups')
      });
    });
  }
  getRelatedFolders(issueDefName) {
    return new Promise((resolve, reject) => {
      api_.Ajax.request({
        url: api_.ActionURL.buildURL('issues', 'getRelatedFolder.api'),
        params: {
          issueDefName
        },
        success: api_.Utils.getCallbackWrapper(res => {
          let folders = (0,external_immutable_.List)();
          res.containers.forEach(container => {
            const folder = IssuesRelatedFolder.create(container);
            folders = folders.push(folder);
          });
          resolve(folders);
        }),
        failure: handleRequestFailure(reject, 'Failed to fetch related folders')
      });
    });
  }
  getUsersForGroup(groupId) {
    return new Promise((resolve, reject) => {
      api_.Ajax.request({
        url: api_.ActionURL.buildURL('issues', 'getUsersForGroup.api'),
        params: {
          groupId
        },
        success: api_.Utils.getCallbackWrapper(coreUsersData => {
          let users = (0,external_immutable_.List)();
          coreUsersData.forEach(user => {
            const usr = Principal.create(user);
            users = users.push(usr);
          });
          resolve(users);
        }),
        failure: handleRequestFailure(reject, 'Failed to fetch users for group')
      });
    });
  }
  saveIssueListDefOptions(options) {
    return new Promise((resolve, reject) => {
      api_.Ajax.request({
        url: buildURL('issues', 'admin.api'),
        method: 'POST',
        params: options,
        success: api_.Utils.getCallbackWrapper(res => {
          resolve(res);
        }),
        failure: handleRequestFailure(reject, 'Failed to save issue list definition options')
      });
    });
  }
}
let actions_DEFAULT_WRAPPER;
function getDefaultIssuesAPIWrapper() {
  if (!actions_DEFAULT_WRAPPER) {
    actions_DEFAULT_WRAPPER = new IssuesServerAPIWrapper();
  }
  return actions_DEFAULT_WRAPPER;
}
function getIssuesTestAPIWrapper(mockFn = () => () => {}, overrides = {}) {
  return issues_actions_objectSpread({
    getProjectGroups: mockFn(),
    getRelatedFolders: mockFn(),
    getUsersForGroup: mockFn(),
    saveIssueListDefOptions: mockFn()
  }, overrides);
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/issues/IssuesListDefPropertiesPanel.tsx
function IssuesListDefPropertiesPanel_extends() { return IssuesListDefPropertiesPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, IssuesListDefPropertiesPanel_extends.apply(null, arguments); }
function IssuesListDefPropertiesPanel_defineProperty(e, r, t) { return (r = IssuesListDefPropertiesPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function IssuesListDefPropertiesPanel_toPropertyKey(t) { var i = IssuesListDefPropertiesPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function IssuesListDefPropertiesPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










const IssuesListDefPropertiesPanel_PROPERTIES_HEADER_ID = 'issues-properties-hdr';
class IssuesListDefPropertiesPanelImpl extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    IssuesListDefPropertiesPanel_defineProperty(this, "updateValidStatus", newModel => {
      const {
        model,
        onChange
      } = this.props;
      const updatedModel = newModel || model;
      const isValid = updatedModel && updatedModel.hasValidProperties();
      this.setState(() => ({
        isValid
      }), () => {
        if (newModel) {
          onChange(updatedModel);
        }
      });
    });
    IssuesListDefPropertiesPanel_defineProperty(this, "onInputChange", e => {
      const id = e.target.id;
      let value = e.target.value;

      // special case for empty string, set as null instead
      if (api_.Utils.isString(value) && value.length === 0) {
        value = null;
      }
      this.onChange(id, value);
    });
    IssuesListDefPropertiesPanel_defineProperty(this, "onChange", (identifier, value, clearingField) => {
      const {
        model
      } = this.props;
      const newModel = (0,external_immer_.produce)(model, draft => {
        draft[identifier] = value;
        if (clearingField) {
          draft[clearingField] = undefined;
        }
      });
      this.updateValidStatus(newModel);
    });
    IssuesListDefPropertiesPanel_defineProperty(this, "onSelectChange", (name, value) => {
      if (name === 'assignedToGroup') {
        this.onChange(name, value, 'assignedToUser');
      } else {
        this.onChange(name, value);
      }
    });
    IssuesListDefPropertiesPanel_defineProperty(this, "onRestrictedListCheckChange", e => {
      const name = e.target.name;
      const value = e.target.checked;
      if (!value) {
        // clear out the group dropdown
        this.onChange(name, value, 'restrictedIssueListGroup');
      } else {
        this.onChange(name, value);
      }
    });
    this.state = (0,external_immer_.produce)({
      isValid: true
    }, () => {});
  }
  render() {
    const {
      api,
      model
    } = this.props;
    const {
      isValid
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement(BasePropertiesPanel, IssuesListDefPropertiesPanel_extends({}, this.props, {
      headerId: IssuesListDefPropertiesPanel_PROPERTIES_HEADER_ID,
      title: "Issues List Properties",
      titlePrefix: model.issueDefName,
      updateValidStatus: this.updateValidStatus,
      isValid: isValid
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(HelpTopicURL, {
      helpTopic: DEFINE_ISSUES_LIST_TOPIC,
      nounPlural: "issues lists"
    }))), /*#__PURE__*/external_react_default().createElement("form", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12 col-md-6"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-padding-bottom"
    }, /*#__PURE__*/external_react_default().createElement(BasicPropertiesFields, {
      model: model,
      onInputChange: this.onInputChange,
      onSelect: this.onSelectChange
    })), isRestrictedIssueListSupported() && /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-field-padding-bottom"
    }, /*#__PURE__*/external_react_default().createElement(RestrictedOptions, {
      api: api,
      model: model,
      onCheckChange: this.onRestrictedListCheckChange,
      onSelect: this.onSelectChange
    }))), /*#__PURE__*/external_react_default().createElement(AssignmentOptions, {
      api: api,
      model: model,
      onSelect: this.onSelectChange
    })));
  }
}
IssuesListDefPropertiesPanel_defineProperty(IssuesListDefPropertiesPanelImpl, "defaultProps", {
  api: getDefaultIssuesAPIWrapper()
});
const IssuesListDefPropertiesPanel = withDomainPropertiesPanelCollapse(IssuesListDefPropertiesPanelImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/issues/IssuesListDefDesignerPanels.tsx
function IssuesListDefDesignerPanels_defineProperty(e, r, t) { return (r = IssuesListDefDesignerPanels_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function IssuesListDefDesignerPanels_toPropertyKey(t) { var i = IssuesListDefDesignerPanels_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function IssuesListDefDesignerPanels_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










// exported for testing
class IssuesDesignerPanelsImpl extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    IssuesListDefDesignerPanels_defineProperty(this, "onPropertiesChange", model => {
      const {
        onChange
      } = this.props;
      this.setState((0,external_immer_.produce)(draft => {
        draft.model = model;
      }), () => {
        if (onChange) {
          onChange(model);
        }
      });
    });
    IssuesListDefDesignerPanels_defineProperty(this, "onDomainChange", (domain, dirty) => {
      const {
        onChange
      } = this.props;
      this.setState((0,external_immer_.produce)(draft => {
        draft.model.domain = domain;
      }), () => {
        if (onChange && dirty) {
          onChange(this.state.model);
        }
      });
    });
    IssuesListDefDesignerPanels_defineProperty(this, "onFinish", () => {
      const {
        model
      } = this.state;
      this.props.onFinish(model.isValid(), model.domain.isSharedDomain() ? this.saveOptions : this.saveDomain);
    });
    IssuesListDefDesignerPanels_defineProperty(this, "saveOptions", () => {
      const {
        api,
        setSubmitting
      } = this.props;
      const {
        model
      } = this.state;
      api.saveIssueListDefOptions(model.getOptions()).then(() => this.onSaveComplete()).catch(response => {
        setSubmitting(false, () => {
          this.setState((0,external_immer_.produce)(draft => {
            draft.model.exception = response.exception;
          }));
        });
      });
    });
    IssuesListDefDesignerPanels_defineProperty(this, "saveDomain", () => {
      const {
        setSubmitting
      } = this.props;
      const {
        model
      } = this.state;
      saveDomain({
        domain: model.domain,
        kind: model.domainKindName,
        options: model.getOptions(),
        name: model.issueDefName
      }).then(response => this.onSaveComplete(response)).catch(response => {
        const exception = resolveErrorMessage(response);
        setSubmitting(false, () => {
          this.setState((0,external_immer_.produce)(draft => {
            if (exception) {
              draft.model.exception = exception;
            } else {
              draft.model.exception = undefined;
              draft.model.domain = response;
            }
          }));
        });
      });
    });
    IssuesListDefDesignerPanels_defineProperty(this, "onSaveComplete", response => {
      const {
        setSubmitting
      } = this.props;
      this.setState((0,external_immer_.produce)(draft => {
        draft.model.exception = undefined;
        if (response) {
          draft.model.domain = response;
        }
      }), () => {
        setSubmitting(false, () => {
          const {
            model
          } = this.state;
          this.props.onComplete(model);
        });
      });
    });
    this.state = (0,external_immer_.produce)({
      model: props.initModel || IssuesListDefModel.create({})
    }, () => {});
  }
  render() {
    const {
      api,
      onCancel,
      visitedPanels,
      currentPanelIndex,
      firstState,
      validatePanel,
      submitting,
      onTogglePanel,
      saveBtnText
    } = this.props;
    const {
      model
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement(BaseDomainDesigner, {
      name: model.issueDefName,
      exception: model.exception,
      domains: external_immutable_.List.of(model.domain),
      hasValidProperties: model.hasValidProperties(),
      visitedPanels: visitedPanels,
      submitting: submitting,
      onCancel: onCancel,
      onFinish: this.onFinish,
      saveBtnText: saveBtnText
    }, /*#__PURE__*/external_react_default().createElement(IssuesListDefPropertiesPanel, {
      api: api,
      model: model,
      onChange: this.onPropertiesChange,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== 0,
      panelStatus: model.isNew() ? getDomainPanelStatus(0, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      validate: validatePanel === 0,
      onToggle: (collapsed, callback) => {
        onTogglePanel(0, collapsed, callback);
      }
    }), /*#__PURE__*/external_react_default().createElement(domainproperties_DomainForm, {
      key: model.domain.domainId || 0,
      domainIndex: 0,
      domain: model.domain,
      headerTitle: "Fields",
      helpNoun: "issues list",
      helpTopic: null // null so that we don't show the "learn more about this tool" link for this domains
      ,
      onChange: this.onDomainChange,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== 1,
      validate: validatePanel === 1,
      panelStatus: model.isNew() ? getDomainPanelStatus(1, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      onToggle: (collapsed, callback) => {
        onTogglePanel(1, collapsed, callback);
      },
      domainFormDisplayOptions: {
        isDragDisabled: model.domain.isSharedDomain(),
        hideAddFieldsButton: model.domain.isSharedDomain(),
        hideImportExport: true,
        hideInferFromFile: true
      }
    }));
  }
}
IssuesListDefDesignerPanels_defineProperty(IssuesDesignerPanelsImpl, "defaultProps", {
  api: getDefaultIssuesAPIWrapper()
});
const IssuesListDefDesignerPanels = withBaseDomainDesigner(IssuesDesignerPanelsImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/ConfirmImportTypes.tsx


class ConfirmImportTypes extends external_react_.PureComponent {
  render() {
    const {
      error,
      onConfirm,
      onCancel,
      designerType
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: `Create ${designerType} without importing data?`,
      confirmClass: "btn-primary",
      onConfirm: onConfirm,
      onCancel: onCancel,
      confirmText: "Yes, Create Without Data",
      cancelText: "No, Go Back to Field Editor"
    }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, "There was an error importing this file. To import this data now, check your file for issues or resolve the error below:"), /*#__PURE__*/external_react_default().createElement("ul", null, error && error.errors.map((error, index) => /*#__PURE__*/external_react_default().createElement("li", {
      key: index
    }, error.exception))), /*#__PURE__*/external_react_default().createElement("p", null, "If you create this ", designerType, " without resolving the error, no file data will be imported at this time.", ' ', /*#__PURE__*/external_react_default().createElement("strong", null, "Are you sure you want to create the ", designerType, " without importing the file data?"))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataset/utils.ts

function allowAsManagedField(field) {
  return field && field.dataType && (field.dataType.isString() || field.dataType.isNumeric() || field.dataType.isLookup());
}
function getStudySubjectProp(prop) {
  return (0,api_.getServerContext)().moduleContext.study.subject[prop];
}
function getStudyTimepointLabel() {
  return (0,api_.getServerContext)().moduleContext.study.timepointType === 'VISIT' ? 'Visits' : 'Timepoints';
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataset/DatasetColumnMappingPanel.tsx
function DatasetColumnMappingPanel_defineProperty(e, r, t) { return (r = DatasetColumnMappingPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DatasetColumnMappingPanel_toPropertyKey(t) { var i = DatasetColumnMappingPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DatasetColumnMappingPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







class DatasetColumnMappingPanel extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    DatasetColumnMappingPanel_defineProperty(this, "onSelectChange", (name, formValue, selected) => {
      const value = selected ? selected.name : undefined;
      this.setState(() => ({
        [name]: value
      }), () => {
        this.props.onColumnMappingChange(this.state.closestParticipantIdField, this.state.closestTimepointField);
      });
    });
    this.state = {
      closestParticipantIdField: this.findClosestColumn(this.props.subjectColumnName),
      closestTimepointField: this.findClosestColumn(this.props.timepointType)
    };
    this.props.onColumnMappingChange(this.state.closestParticipantIdField, this.state.closestTimepointField);
  }
  compareNames(name1, name2) {
    return name1 === name2 || name1.indexOf(name2) >= 0 || name2.indexOf(name1) >= 0;
  }
  areColumnNamesAndTypesEquivalent(targetColumnName, inferredField) {
    const {
      subjectColumnName,
      timepointType
    } = this.props;
    const targetColumn = targetColumnName.toLowerCase().replace(' ', '');
    const inferredFieldName = inferredField.name.toLowerCase().replace(' ', '');
    if (targetColumnName === subjectColumnName) {
      return this.compareNames(targetColumn, inferredFieldName);
    } else if (targetColumnName === timepointType && timepointType === 'DATE') {
      return this.compareNames('visitdate', inferredFieldName) && (inferredField.rangeURI === 'xsd:datetime' || inferredField.rangeURI === 'xsd:dateTime');
    } else if (targetColumnName === timepointType && timepointType === 'VISIT') {
      return this.compareNames('sequencenum', inferredFieldName) && inferredField.rangeURI === 'xsd:double';
    } else if (targetColumnName === timepointType) {
      return this.compareNames('date', inferredFieldName) && (inferredField.rangeURI === 'xsd:datetime' || inferredField.rangeURI === 'xsd:dateTime');
    }
    return false;
  }
  findClosestColumn(targetColumn) {
    const inferredColumns = this.props.model.domain.fields;
    const matchedField = inferredColumns.find(field => field.name && field.rangeURI && this.areColumnNamesAndTypesEquivalent(targetColumn, field));
    return matchedField ? matchedField.name : undefined;
  }
  getTimepointFields() {
    const {
      model,
      timepointType
    } = this.props;
    if (timepointType === 'VISIT') {
      return model.domain.fields.filter(field => field.dataType.isNumeric() || field.dataType.isString()).toList();
    } else {
      // DATE or CONTINUOUS
      return model.domain.fields.filter(field => field.rangeURI?.toLowerCase() === 'xsd:datetime' || field.rangeURI === DATETIME_RANGE_URI).toList();
    }
  }
  render() {
    const {
      model
    } = this.props;
    const {
      closestParticipantIdField,
      closestTimepointField
    } = this.state;
    const participantIdTxt = getStudySubjectProp('nounPlural');
    const timepointTxt = getStudyTimepointLabel();
    const domain = model.domain;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "Column mapping"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "margin-top"
    }, "Columns already existing in the base dataset can be mapped with columns from your file. Choose a column to map your ", participantIdTxt, " and ", timepointTxt, "."), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2 col-lg-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: participantIdTxt
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      onChange: this.onSelectChange,
      value: closestParticipantIdField,
      options: domain.fields.toArray(),
      inputClass: "",
      containerClass: "",
      labelClass: "",
      name: "closestParticipantIdField",
      labelKey: "name",
      valueKey: "name"
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2 col-lg-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: timepointTxt
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5 col-lg-4"
    }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      onChange: this.onSelectChange,
      value: closestTimepointField,
      options: this.getTimepointFields().toArray(),
      inputClass: "",
      containerClass: "",
      labelClass: "",
      name: "closestTimepointField",
      labelKey: "name",
      valueKey: "name"
    }))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataset/constants.ts
const DATASET_NAME_TIP = 'The dataset name is used when identifying a dataset during data upload. This name must be unique.';
const DATASET_CATEGORY_TIP = 'Assigning a category to a dataset will group it with similar datasets in the navigator and data browser.';
const DATASET_LABEL_TIP = 'The label of the dataset shown to users. If no label is provided during dataset creation, the name will be used.';
const DATASET_ID_TIP = 'The unique, numerical identifier for your dataset. It is defined during dataset creation and cannot be modified.';
const VISIT_DATE_TIP = "If the official 'Visit Date' for a visit can come from this dataset, choose the date column to represent " + 'it. Note that since datasets can include data from many visits, each visit must also indicate the official ' + "'VisitDate' dataset.";
const COHORT_TIP = 'Datasets may be cohort specific, or associated with all cohorts (default).';
const TAG_TIP = 'Adding a tag provides an additional, flexible way to categorize this dataset.';
const SHOW_IN_OVERVIEW = 'When this item is checked, this dataset will show in the overview grid by default. It can be unhidden by ' + "clicking 'Show All Datasets.";
const TIME_KEY_FIELD_KEY = '_Special$Time_';
const TIME_KEY_FIELD_DISPLAY = 'Time (from Date/Time)';
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataset/models.ts
function dataset_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function dataset_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? dataset_models_ownKeys(Object(t), !0).forEach(function (r) { dataset_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : dataset_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function dataset_models_defineProperty(e, r, t) { return (r = dataset_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function dataset_models_toPropertyKey(t) { var i = dataset_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function dataset_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






class DatasetModel {
  constructor(datasetModel) {
    dataset_models_defineProperty(this, external_immer_.immerable, true);
    dataset_models_defineProperty(this, "domain", void 0);
    dataset_models_defineProperty(this, "domainId", void 0);
    dataset_models_defineProperty(this, "exception", void 0);
    dataset_models_defineProperty(this, "datasetId", void 0);
    dataset_models_defineProperty(this, "entityId", void 0);
    dataset_models_defineProperty(this, "name", void 0);
    dataset_models_defineProperty(this, "category", void 0);
    dataset_models_defineProperty(this, "visitDatePropertyName", void 0);
    dataset_models_defineProperty(this, "keyPropertyName", void 0);
    dataset_models_defineProperty(this, "keyPropertyManaged", void 0);
    dataset_models_defineProperty(this, "demographicData", void 0);
    dataset_models_defineProperty(this, "label", void 0);
    dataset_models_defineProperty(this, "cohortId", void 0);
    dataset_models_defineProperty(this, "tag", void 0);
    dataset_models_defineProperty(this, "showByDefault", void 0);
    dataset_models_defineProperty(this, "description", void 0);
    dataset_models_defineProperty(this, "dataSharing", void 0);
    dataset_models_defineProperty(this, "definitionIsShared", void 0);
    dataset_models_defineProperty(this, "sourceName", void 0);
    dataset_models_defineProperty(this, "sourceUrl", void 0);
    dataset_models_defineProperty(this, "sourceType", void 0);
    dataset_models_defineProperty(this, "useTimeKeyField", void 0);
    Object.assign(this, datasetModel);
  }
  static create(newDataset = null, raw) {
    if (newDataset) {
      const domain = DomainDesign.create(undefined);
      return new DatasetModel(dataset_models_objectSpread(dataset_models_objectSpread({}, newDataset), {}, {
        domain
      }));
    } else {
      const domain = DomainDesign.create(raw.domainDesign);
      let model = new DatasetModel(dataset_models_objectSpread(dataset_models_objectSpread({}, raw.options), {}, {
        domain
      }));

      // if the dataset is from a linked source, disable/lock the fields
      if (model.isFromLinkedSource()) {
        const newDomain = domain.merge({
          fields: domain.fields.map(field => {
            return field.set('lockType', DOMAIN_FIELD_FULLY_LOCKED);
          }).toList()
        });
        model = (0,external_immer_.produce)(model, draft => {
          draft.domain = newDomain;
        });
      }
      return model;
    }
  }
  hasValidProperties() {
    const isValidName = this.name !== undefined && this.name !== null && this.name.trim().length > 0;
    const isValidLabel = this.isNew() || this.label !== undefined && this.label !== null && this.label.trim().length > 0;
    return isValidName && isValidLabel && this.hasValidAdditionalKey();
  }
  hasValidAdditionalKey() {
    let isValidKeySetting = true;
    if (this.getDataRowSetting() === 2) {
      isValidKeySetting = this.keyPropertyName !== undefined && this.keyPropertyName !== '' || this.useTimeKeyField;
    }
    return isValidKeySetting;
  }
  isNew() {
    return !this.entityId;
  }
  getDataRowSetting() {
    const noKeyPropName = this.keyPropertyName === undefined || this.keyPropertyName === null;

    // participant id
    if (noKeyPropName && this.demographicData) {
      return 0;
    }
    // participant id and timepoint
    else if (noKeyPropName && !this.useTimeKeyField) {
      return 1;
    }

    // participant id, timepoint and additional key field
    return 2;
  }
  validManagedKeyField(editedName) {
    if (this.keyPropertyName || editedName) {
      const domainFields = this.domain.fields;
      const allowedFieldTypes = domainFields.filter(field => allowAsManagedField(field)).map(field => {
        return field.name;
      }).toList();
      return allowedFieldTypes.contains(this.keyPropertyName) || allowedFieldTypes.contains(editedName);
    } else {
      return false;
    }
  }
  getDomainKind() {
    return (0,api_.getServerContext)().moduleContext.study.timepointType === 'VISIT' ? 'StudyDatasetVisit' : 'StudyDatasetDate';
  }
  getOptions() {
    return (0,external_immer_.produce)(this, draft => {
      delete draft.exception;
      delete draft.domain;
    });
  }
  isValid() {
    return this.hasValidProperties() && !this.domain.hasInvalidFields();
  }
  isFromLinkedSource() {
    return this.sourceName !== undefined && this.sourceName !== null;
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataset/actions.ts
/*
 * Copyright (c) 2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







function fetchCategories() {
  return new Promise((resolve, reject) => {
    selectRowsDeprecated({
      saveInSession: true,
      schemaName: 'study',
      sql: 'SELECT DISTINCT CategoryId.Label, CategoryId.RowId FROM DataSets'
    }).then(data => {
      const models = (0,external_immutable_.fromJS)(data.models[data.key]);
      let categories = (0,external_immutable_.List)();
      data.orderedModels[data.key].forEach(modelKey => {
        const row = models.get(modelKey);
        const value = row.getIn(['Label', 'value']);
        const label = row.getIn(['Label', 'value']);
        categories = categories.push({
          value,
          label
        });
      });
      resolve(categories);
    }).catch(response => {
      reject(response.message);
    });
  });
}
function getVisitDateColumns(domain) {
  let visitDateColumns = (0,external_immutable_.List)();

  // date field is a built in field for a dataset for a date based study
  visitDateColumns = visitDateColumns.push({
    value: 'date',
    label: 'date'
  });
  domain.fields.map(field => {
    if (field && field.rangeURI && field.rangeURI.endsWith('dateTime')) {
      visitDateColumns = visitDateColumns.push({
        value: field.name,
        label: field.name
      });
    }
  });
  return visitDateColumns;
}
function getAdditionalKeyFields(domain) {
  let additionalKeyFields = (0,external_immutable_.List)();

  // In a date-based or continuous study, an additional third key option is to use the Time (from Date/Time) portion of a datestamp field
  // where multiple measurements happen on a given day or visit (tracking primate weight for example), the time portion of the date field can be used as an additional key
  if ((0,api_.getServerContext)().moduleContext.study.timepointType !== 'VISIT') {
    additionalKeyFields = additionalKeyFields.push({
      value: TIME_KEY_FIELD_KEY,
      label: TIME_KEY_FIELD_DISPLAY
    });
  }
  domain.fields.filter(field => !field.isCalculatedField()).map(field => {
    additionalKeyFields = additionalKeyFields.push({
      value: field.name,
      label: field.name
    });
  });
  return additionalKeyFields;
}
function fetchCohorts() {
  return new Promise((resolve, reject) => {
    selectRowsDeprecated({
      schemaName: 'study',
      queryName: 'Cohort'
    }).then(data => {
      const models = (0,external_immutable_.fromJS)(data.models[data.key]);
      let cohorts = (0,external_immutable_.List)();
      data.orderedModels[data.key].forEach(modelKey => {
        const row = models.get(modelKey);
        const value = row.getIn(['rowid', 'value']);
        const label = row.getIn(['label', 'value']);
        cohorts = cohorts.push({
          value,
          label
        });
      });
      resolve(cohorts);
    }).catch(response => {
      reject(response.message);
    });
  });
}
function getHelpTip(fieldName) {
  let helpTip = '';
  switch (fieldName) {
    case 'name':
      helpTip = DATASET_NAME_TIP;
      break;
    case 'label':
      helpTip = DATASET_LABEL_TIP;
      break;
    case 'category':
      helpTip = DATASET_CATEGORY_TIP;
      break;
    case 'datasetId':
      helpTip = DATASET_ID_TIP;
      break;
    case 'visitDateColumn':
      helpTip = VISIT_DATE_TIP;
      break;
    case 'cohort':
      helpTip = COHORT_TIP;
      break;
    case 'tag':
      helpTip = TAG_TIP;
      break;
    case 'dataspace':
      helpTip = 'For demographics datasets, this setting is used to enable data sharing across studies. ' + "When 'No' is selected (default), each study folder 'owns' its own data rows. If the study has shared " + "visits/timepoints, then 'Share by " + getStudySubjectProp('columnName') + "' means that data rows are shared across the project and " + 'studies will only see data rows for ' + getStudySubjectProp('nounPlural').toLowerCase() + ' that are part of that study.';
      break;
    case 'dataRowUniqueness':
      helpTip = 'Choose criteria for how ' + getStudySubjectProp('nounPlural').toLowerCase() + ' and visits/timepoints are paired with, or without, an additional data column.';
      break;
  }
  return helpTip;
}
function getDatasetProperties(datasetId) {
  return new Promise((resolve, reject) => {
    api_.Ajax.request({
      url: api_.ActionURL.buildURL('study', 'getDataset.api'),
      method: 'GET',
      params: {
        datasetId
      },
      success: api_.Utils.getCallbackWrapper(data => {
        resolve(DatasetModel.create(data, undefined));
      }),
      failure: api_.Utils.getCallbackWrapper(error => {
        reject(error);
      })
    });
  });
}
function fetchDatasetDesign(datasetId) {
  return new Promise((resolve, reject) => {
    getDatasetProperties(datasetId).then(model => {
      api_.Domain.getDomainDetails({
        domainId: model.domainId,
        domainKind: datasetId === undefined ? 'StudyDatasetDate' : undefined,
        // NOTE there is also a StudyDatasetVisit domain kind but for this purpose either will work
        success: data => {
          resolve(DatasetModel.create(undefined, data));
        },
        failure: error => {
          reject(error);
        }
      });
    }).catch(error => {
      reject(error);
    });
  });
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataset/DatasetPropertiesAdvancedSettings.tsx
function DatasetPropertiesAdvancedSettings_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DatasetPropertiesAdvancedSettings_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DatasetPropertiesAdvancedSettings_ownKeys(Object(t), !0).forEach(function (r) { DatasetPropertiesAdvancedSettings_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DatasetPropertiesAdvancedSettings_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function DatasetPropertiesAdvancedSettings_defineProperty(e, r, t) { return (r = DatasetPropertiesAdvancedSettings_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DatasetPropertiesAdvancedSettings_toPropertyKey(t) { var i = DatasetPropertiesAdvancedSettings_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DatasetPropertiesAdvancedSettings_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }














class DatasetSettingsSelect extends (external_react_default()).PureComponent {
  render() {
    const {
      name,
      label,
      helpTip,
      selectedValue,
      selectOptions,
      onSelectChange,
      labelKey,
      valueKey,
      disabled,
      clearable
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: label,
      helpTipBody: helpTip
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-7"
    }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      onChange: onSelectChange,
      value: selectedValue,
      options: selectOptions,
      inputClass: "",
      containerClass: "",
      labelClass: "",
      name: name,
      labelKey: labelKey,
      valueKey: valueKey,
      disabled: disabled,
      clearable: clearable
    })));
  }
}
class DatasetSettingsInput extends (external_react_default()).PureComponent {
  render() {
    const {
      name,
      label,
      helpTip,
      value,
      placeholder,
      onValueChange,
      disabled,
      showInAdvancedSettings,
      required
    } = this.props;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: label,
      required: required,
      helpTipBody: helpTip
    })), showInAdvancedSettings && /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-1"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-7"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      id: name,
      type: "text",
      placeholder: placeholder,
      value: value,
      onChange: onValueChange,
      disabled: disabled
    })), !showInAdvancedSettings && /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-1"
    }));
  }
}
class DatasetPropertiesAdvancedSettings_AdvancedSettings extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    DatasetPropertiesAdvancedSettings_defineProperty(this, "getInitialState", () => {
      const model = this.props.model;
      return {
        datasetId: model.datasetId,
        tag: model.tag,
        showByDefault: model.showByDefault,
        cohortId: model.cohortId,
        dataSharing: model.dataSharing,
        visitDatePropertyName: this.getVisitDatePropertyName()
      };
    });
    DatasetPropertiesAdvancedSettings_defineProperty(this, "toggleModal", isModalOpen => {
      this.setState({
        modalOpen: isModalOpen
      });

      // If modal is re-opened, reset unsaved values
      if (isModalOpen) {
        this.setState(this.getInitialState());
      }
    });
    DatasetPropertiesAdvancedSettings_defineProperty(this, "closeModal", () => {
      this.toggleModal(false);
    });
    DatasetPropertiesAdvancedSettings_defineProperty(this, "onInputChange", e => {
      const id = e.target.id;
      let value = e.target.value;
      if (e.target.type === 'checkbox') {
        value = e.target.checked;
      }
      this.setState({
        [id]: value
      });
    });
    DatasetPropertiesAdvancedSettings_defineProperty(this, "onSelectChange", (id, value) => {
      this.setState({
        [id]: value
      });
    });
    DatasetPropertiesAdvancedSettings_defineProperty(this, "applyChanges", () => {
      const {
        datasetId,
        cohortId,
        visitDatePropertyName,
        showByDefault,
        tag,
        dataSharing
      } = this.state;
      const datasetAdvancedSettingsForm = {
        showByDefault,
        datasetId,
        cohortId,
        visitDatePropertyName,
        tag,
        dataSharing
      };
      const {
        applyAdvancedProperties
      } = this.props;
      applyAdvancedProperties(datasetAdvancedSettingsForm);
      this.toggleModal(false);
    });
    const initialState = this.getInitialState();
    initQueryGridState(); // needed for selectRows usage

    this.state = DatasetPropertiesAdvancedSettings_objectSpread({
      modalOpen: false
    }, initialState);
  }
  componentDidMount() {
    fetchCohorts().then(data => {
      this.setState({
        availableCohorts: data.toArray()
      });
    }).catch(error => {
      console.error('Failed to retrieve available cohorts.', error);
    });
  }
  getVisitDatePropertyName() {
    const {
      model,
      visitDatePropertyIndex
    } = this.props;
    return visitDatePropertyIndex !== undefined ? model.domain.fields.get(visitDatePropertyIndex).name : model.visitDatePropertyName;
  }
  getHelpTipElement(field) {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, " ", getHelpTip(field), " ");
  }
  render() {
    const {
      modalOpen,
      datasetId,
      cohortId,
      tag,
      showByDefault,
      dataSharing,
      availableCohorts
    } = this.state;
    const {
      model,
      title
    } = this.props;
    const showDataspace = model.definitionIsShared && model.getDataRowSetting() === 0;
    const showDataspaceCls = showDataspace ? 'dataset_data_row_element_show' : 'dataset_data_row_element_hide';
    const showInOverviewLabel = 'Show dataset in overview';
    const visitDateColumns = getVisitDateColumns(model.domain).toArray();
    const visitDateProperty = this.getVisitDatePropertyName();
    const footer = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("button", {
      className: "domain-adv-footer domain-adv-cancel-btn btn btn-default",
      onClick: this.closeModal,
      type: "button"
    }, "Cancel"), /*#__PURE__*/external_react_default().createElement(HelpLink, {
      topic: DATASET_PROPERTIES_TOPIC,
      className: "domain-adv-footer domain-adv-link"
    }, "Get help with dataset settings"), /*#__PURE__*/external_react_default().createElement("button", {
      className: `domain-adv-footer domain-adv-apply-btn btn btn-${getSubmitButtonClass()}`,
      onClick: this.applyChanges,
      type: "button"
    }, "Apply"));
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("button", {
      className: "domain-field-float-right btn btn-default",
      onClick: () => this.toggleModal(true),
      type: "button"
    }, title), modalOpen && /*#__PURE__*/external_react_default().createElement(Modal, {
      footer: footer,
      onCancel: this.closeModal,
      title: "Advanced Dataset Settings"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "Miscellaneous Options"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, showInOverviewLabel, /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
      title: showInOverviewLabel
    }, SHOW_IN_OVERVIEW)), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-7"
    }, /*#__PURE__*/external_react_default().createElement(DomainDesignerCheckbox, {
      checked: showByDefault,
      onChange: this.onInputChange,
      id: "showByDefault",
      className: "domain-field-checkbox"
    }))), /*#__PURE__*/external_react_default().createElement(DatasetSettingsInput, {
      name: "datasetId",
      label: "Dataset ID",
      helpTip: this.getHelpTipElement('datasetId'),
      value: datasetId,
      placeholder: "Auto Assign",
      disabled: !model.isNew(),
      onValueChange: this.onInputChange,
      showInAdvancedSettings: true,
      required: true
    }), (0,api_.getServerContext)().moduleContext.study.timepointType === 'VISIT' && /*#__PURE__*/external_react_default().createElement(DatasetSettingsSelect, {
      name: "visitDatePropertyName",
      label: "Visit Date Column",
      helpTip: this.getHelpTipElement('visitDateColumn'),
      selectOptions: visitDateColumns,
      selectedValue: visitDateProperty,
      onSelectChange: this.onSelectChange
    }), /*#__PURE__*/external_react_default().createElement(DatasetSettingsSelect, {
      name: "cohortId",
      label: "Cohort Association",
      helpTip: this.getHelpTipElement('cohort'),
      selectOptions: availableCohorts,
      selectedValue: cohortId,
      onSelectChange: this.onSelectChange
    }), /*#__PURE__*/external_react_default().createElement(DatasetSettingsInput, {
      name: "tag",
      label: "Tag",
      helpTip: this.getHelpTipElement('tag'),
      value: tag,
      disabled: false,
      onValueChange: this.onInputChange,
      showInAdvancedSettings: true,
      required: false
    }), model.definitionIsShared && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: showDataspaceCls
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "margin-top"
    }, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "Dataspace Project Options"
    })), /*#__PURE__*/external_react_default().createElement(DatasetSettingsSelect, {
      name: "dataSharing",
      label: "Share demographic data",
      helpTip: this.getHelpTipElement('dataspace'),
      selectOptions: [{
        label: 'No',
        value: 'NONE'
      }, {
        label: 'Share by ' + getStudySubjectProp('columnName'),
        value: 'PTID'
      }],
      selectedValue: dataSharing,
      onSelectChange: this.onSelectChange,
      disabled: model.getDataRowSetting() !== 0
    })))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataset/DatasetPropertiesPanelFormElements.tsx
function DatasetPropertiesPanelFormElements_defineProperty(e, r, t) { return (r = DatasetPropertiesPanelFormElements_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DatasetPropertiesPanelFormElements_toPropertyKey(t) { var i = DatasetPropertiesPanelFormElements_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DatasetPropertiesPanelFormElements_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










class DatasetPropertiesPanelFormElements_DescriptionInput extends (external_react_default()).PureComponent {
  render() {
    const {
      model,
      onInputChange
    } = this.props;
    const value = model.description === null ? '' : model.description;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Description"
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-7"
    }, /*#__PURE__*/external_react_default().createElement("textarea", {
      className: "form-control",
      id: "description",
      value: value,
      onChange: onInputChange
    })));
  }
}
class DatasetPropertiesPanelFormElements_BasicPropertiesFields extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    DatasetPropertiesPanelFormElements_defineProperty(this, "getHelpTipElement", field => {
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, " ", getHelpTip(field), " ");
    });
    this.state = {
      availableCategories: []
    };
  }
  componentDidMount() {
    fetchCategories().then(data => {
      this.setState({
        availableCategories: data.toArray()
      });
    }).catch(error => {
      console.error('Failed to retrieve available categories.', error);
    });
  }
  render() {
    const {
      model,
      onInputChange,
      onCategoryChange
    } = this.props;
    const {
      availableCategories
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "Basic Properties"
    }), /*#__PURE__*/external_react_default().createElement(DatasetSettingsInput, {
      name: "name",
      label: "Name",
      helpTip: this.getHelpTipElement('name'),
      value: model.name,
      placeholder: "Enter a name for this dataset",
      disabled: model.isFromLinkedSource(),
      onValueChange: onInputChange,
      showInAdvancedSettings: false,
      required: true
    }), /*#__PURE__*/external_react_default().createElement(DatasetSettingsInput, {
      name: "label",
      label: "Label",
      helpTip: this.getHelpTipElement('label'),
      value: model.label,
      disabled: false,
      onValueChange: onInputChange,
      showInAdvancedSettings: false,
      required: !model.isNew()
    }), /*#__PURE__*/external_react_default().createElement(DatasetPropertiesPanelFormElements_DescriptionInput, {
      model: model,
      onInputChange: onInputChange
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-4"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Category",
      required: false,
      helpTipBody: this.getHelpTipElement('category')
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-7"
    }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      allowCreate: true,
      containerClass: "",
      inputClass: "",
      name: "category",
      noResultsText: "No categories exist yet",
      onChange: onCategoryChange,
      options: availableCategories,
      placeholder: "Select dataset category",
      value: model.category
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-1"
    })));
  }
}
class DataRowUniquenessElements extends (external_react_default()).PureComponent {
  render() {
    const {
      onRadioChange,
      dataRowSetting,
      isFromAssay
    } = this.props;
    const radioName = 'dataRowSetting';
    const participantIdTxt = getStudySubjectProp('nounPlural');
    const timepointTxt = getStudyTimepointLabel();
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "dataset_data_row_uniqueness_container"
    }, /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
      name: radioName,
      value: 0,
      checked: dataRowSetting === 0,
      onChange: onRadioChange,
      disabled: isFromAssay
    }, participantIdTxt, " only (demographic data)"), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
      name: radioName,
      value: 1,
      checked: dataRowSetting === 1,
      onChange: onRadioChange,
      disabled: isFromAssay
    }, participantIdTxt, " and ", timepointTxt.toLowerCase()), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
      name: radioName,
      value: 2,
      checked: dataRowSetting === 2,
      onChange: onRadioChange,
      disabled: isFromAssay
    }, participantIdTxt, ", ", timepointTxt.toLowerCase(), ", and additional key field"));
  }
}
class DataRowUniquenessContainer extends (external_react_default()).PureComponent {
  getHelpTipForAdditionalField() {
    const ptidSingularTxt = getStudySubjectProp('nounSingular');
    const timepointTxt = getStudyTimepointLabel();
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "If the dataset has more than one row per ", ptidSingularTxt.toLowerCase(), "/", timepointTxt.toLowerCase(), ", an additional key field must be provided."), /*#__PURE__*/external_react_default().createElement("p", null, "There can be at most one row in the dataset for each combination of ", ptidSingularTxt.toLowerCase(), ",", timepointTxt.toLowerCase(), " and key."), "The dataset additional key field can be one of the following two types:", /*#__PURE__*/external_react_default().createElement("ul", null, /*#__PURE__*/external_react_default().createElement("li", null, "Data Field: A user-managed key field."), /*#__PURE__*/external_react_default().createElement("li", null, "Managed Field: A numeric or string field that will be managed by the server to make each new entry unique. Numbers will be assigned auto-incrementing integer values, strings will be assigned globally unique identifiers (GUIDs).")));
  }
  getHelpTipElement(field) {
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, " ", getHelpTip(field), " ");
  }
  render() {
    const {
      model,
      onRadioChange,
      onCheckBoxChange,
      onSelectChange,
      keyPropertyIndex
    } = this.props;
    const domain = model.domain;
    const additionalKeyFields = getAdditionalKeyFields(domain);
    const dataRowSetting = model.getDataRowSetting();
    const showAdditionalKeyField = dataRowSetting === 2 || model.isFromLinkedSource();
    let keyPropertyName = model.keyPropertyName;
    if (model.useTimeKeyField) {
      keyPropertyName = TIME_KEY_FIELD_KEY;
    } else if (keyPropertyIndex !== undefined) {
      keyPropertyName = model.domain.fields.get(keyPropertyIndex).name;
    }
    const validKeyField = model.validManagedKeyField(keyPropertyName);
    const showAdditionalKeyFieldCls = showAdditionalKeyField ? 'dataset_data_row_element_show' : 'dataset_data_row_element_hide';
    const keyPropertyManagedCls = showAdditionalKeyField && validKeyField ? 'dataset_data_row_element_show' : 'dataset_data_row_element_hide';
    const managedKeyDisabled = !showAdditionalKeyField || !validKeyField || model.isFromLinkedSource();
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "Data Row Uniqueness",
      helpTipBody: this.getHelpTipElement('dataRowUniqueness')
    }), /*#__PURE__*/external_react_default().createElement(DataRowUniquenessElements, {
      onRadioChange: onRadioChange,
      dataRowSetting: dataRowSetting,
      isFromAssay: model.isFromLinkedSource()
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: showAdditionalKeyFieldCls
    }, /*#__PURE__*/external_react_default().createElement(DatasetSettingsSelect, {
      name: "keyPropertyName",
      label: "Additional Key Field",
      selectOptions: additionalKeyFields.toArray(),
      onSelectChange: onSelectChange,
      selectedValue: keyPropertyName,
      disabled: !showAdditionalKeyField || model.isFromLinkedSource(),
      helpTip: this.getHelpTipForAdditionalField(),
      clearable: false
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: keyPropertyManagedCls
    }, /*#__PURE__*/external_react_default().createElement(DomainDesignerCheckbox, {
      checked: model.keyPropertyManaged && !managedKeyDisabled,
      onChange: onCheckBoxChange,
      id: "keyPropertyManaged",
      disabled: managedKeyDisabled
    }, "Let server manage fields to make entries unique")));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataset/DatasetPropertiesPanel.tsx
const DatasetPropertiesPanel_excluded = ["keyPropertyIndex", "model", "onChange", "onIndexChange", "visitDatePropertyIndex"];
function DatasetPropertiesPanel_extends() { return DatasetPropertiesPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DatasetPropertiesPanel_extends.apply(null, arguments); }
function DatasetPropertiesPanel_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = DatasetPropertiesPanel_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function DatasetPropertiesPanel_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function DatasetPropertiesPanel_defineProperty(e, r, t) { return (r = DatasetPropertiesPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DatasetPropertiesPanel_toPropertyKey(t) { var i = DatasetPropertiesPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DatasetPropertiesPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











class DatasetPropertiesPanelImpl extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    DatasetPropertiesPanel_defineProperty(this, "state", {
      isValid: true
    });
    DatasetPropertiesPanel_defineProperty(this, "updateValidStatus", newModel => {
      const {
        model,
        onChange
      } = this.props;
      const updatedModel = newModel || model;
      const isValid = updatedModel && updatedModel.hasValidProperties();
      this.setState(() => ({
        isValid
      }), () => {
        // Issue 39918: only consider the model changed if there is a newModel param
        if (newModel) {
          onChange(updatedModel);
        }
      });
    });
    DatasetPropertiesPanel_defineProperty(this, "onChange", (identifier, value) => {
      const {
        model
      } = this.props;
      const newModel = (0,external_immer_.produce)(model, draft => {
        draft[identifier] = value;
      });
      this.updateValidStatus(newModel);
    });
    DatasetPropertiesPanel_defineProperty(this, "onInputChange", evt => {
      const id = evt.target.id;
      let value = evt.target.value;
      if (evt.target.type === 'checkbox') {
        value = evt.target.checked;
      }
      this.onChange(id, value);
    });
    DatasetPropertiesPanel_defineProperty(this, "onCategoryChange", (_, category) => {
      const {
        model
      } = this.props;
      const newModel = (0,external_immer_.produce)(model, draft => {
        draft.category = category ?? undefined;
      });
      this.updateValidStatus(newModel);
    });
    DatasetPropertiesPanel_defineProperty(this, "onDataRowRadioChange", e => {
      const {
        model,
        onIndexChange,
        visitDatePropertyIndex
      } = this.props;
      const value = e.target.value;

      // set all of the field's disablePhiLevel back to false, since there isn't a selected additional key anymore
      const updatedDomain = model.domain.merge({
        fields: this.getUpdatedFieldsWithoutDisablePhi()
      });
      const newModel = (0,external_immer_.produce)(model, draft => {
        draft.domain = updatedDomain;
        draft.useTimeKeyField = false;
        draft.keyPropertyManaged = false;
        draft.dataSharing = 'NONE';
        draft.demographicData = value == 0;
        draft.keyPropertyName = value != 2 ? undefined : ''; // resetting key property name
      });
      onIndexChange(undefined, visitDatePropertyIndex);
      this.updateValidStatus(newModel);
    });
    DatasetPropertiesPanel_defineProperty(this, "onAdditionalKeyFieldChange", (name, formValue, selected) => {
      const {
        model,
        onIndexChange,
        visitDatePropertyIndex
      } = this.props;

      // first set all of the field's disablePhiLevel back to false
      const updatedFields = this.getUpdatedFieldsWithoutDisablePhi();
      let keyPropIndex;
      const updatedDomain = model.domain.merge({
        fields: updatedFields.map((field, index) => {
          if (field.name === formValue) {
            keyPropIndex = index;

            // for the selected field, set its PHI level back to none and disable it
            return field.merge({
              disablePhiLevel: true,
              PHI: PHILEVEL_NOT_PHI
            });
          }
          return field;
        }).toList()
      });
      const newModel = (0,external_immer_.produce)(model, draft => {
        draft.domain = updatedDomain;
        draft.useTimeKeyField = formValue === TIME_KEY_FIELD_KEY;
        draft.keyPropertyName = formValue;

        // if we are switching to a field type that is not allowed to be managed, set keyPropertyManaged as false
        if (!allowAsManagedField(draft.domain.fields.get(keyPropIndex))) {
          draft.keyPropertyManaged = false;
        }
      });
      onIndexChange(keyPropIndex, visitDatePropertyIndex);
      this.updateValidStatus(newModel);
    });
    DatasetPropertiesPanel_defineProperty(this, "applyAdvancedProperties", advancedSettingsForm => {
      const {
        model,
        onIndexChange,
        keyPropertyIndex
      } = this.props;
      let visitDatePropIndex;
      const newModel = (0,external_immer_.produce)(model, draft => {
        Object.assign(draft, model, advancedSettingsForm);
      });
      newModel.domain.fields.map((field, index) => {
        if (field.name === newModel.visitDatePropertyName) {
          visitDatePropIndex = index;
        }
      });
      onIndexChange(keyPropertyIndex, visitDatePropIndex);
      this.updateValidStatus(newModel);
    });
  }
  getUpdatedFieldsWithoutDisablePhi() {
    return this.props.model.domain.fields.map(field => {
      return field.set('disablePhiLevel', false);
    }).toList();
  }
  render() {
    // Extract OwnProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _this$props = this.props,
      {
        keyPropertyIndex,
        model,
        onChange,
        onIndexChange,
        visitDatePropertyIndex
      } = _this$props,
      baseProps = DatasetPropertiesPanel_objectWithoutProperties(_this$props, DatasetPropertiesPanel_excluded);
    return /*#__PURE__*/external_react_default().createElement(BasePropertiesPanel, DatasetPropertiesPanel_extends({}, baseProps, {
      headerId: "dataset-header-id",
      isValid: this.state.isValid,
      title: "Dataset Properties",
      titlePrefix: model.name,
      updateValidStatus: this.updateValidStatus
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(HelpTopicURL, {
      helpTopic: DEFINE_DATASET_TOPIC,
      nounPlural: "datasets"
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12 col-md-5"
    }, /*#__PURE__*/external_react_default().createElement(DatasetPropertiesPanelFormElements_BasicPropertiesFields, {
      model: model,
      onInputChange: this.onInputChange,
      onCategoryChange: this.onCategoryChange
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12 col-md-5"
    }, /*#__PURE__*/external_react_default().createElement(DataRowUniquenessContainer, {
      model: model,
      onRadioChange: this.onDataRowRadioChange,
      onCheckBoxChange: this.onInputChange,
      onSelectChange: this.onAdditionalKeyFieldChange,
      keyPropertyIndex: keyPropertyIndex
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12 col-md-2"
    }, /*#__PURE__*/external_react_default().createElement(DatasetPropertiesAdvancedSettings_AdvancedSettings, {
      title: "Advanced Settings",
      model: model,
      applyAdvancedProperties: this.applyAdvancedProperties,
      visitDatePropertyIndex: visitDatePropertyIndex
    }))));
  }
}
const DatasetPropertiesPanel = withDomainPropertiesPanelCollapse(DatasetPropertiesPanelImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataset/DatasetDesignerPanels.tsx
function DatasetDesignerPanels_defineProperty(e, r, t) { return (r = DatasetDesignerPanels_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DatasetDesignerPanels_toPropertyKey(t) { var i = DatasetDesignerPanels_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DatasetDesignerPanels_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2020 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


















const KEY_FIELD_MAPPING_ERROR = 'Your Additional Key Field must not be one of the Column Mapping fields.';
const VISIT_DATE_MAPPING_ERROR = 'Your Visit Date Column must not be one of the Column Mapping fields.';
const ADDITIONAL_KEY_ERROR = 'You must select an Additional Key Field in the dataset properties panel.';
// Exported for testing
class DatasetDesignerPanelImpl extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    DatasetDesignerPanels_defineProperty(this, "_participantId", void 0);
    DatasetDesignerPanels_defineProperty(this, "_sequenceNum", void 0);
    DatasetDesignerPanels_defineProperty(this, "onPropertiesChange", model => {
      const {
        onChange
      } = this.props;
      const {
        file
      } = this.state;
      let updatedModel = model;
      if (file && (this._participantId || this._sequenceNum)) {
        const error = this.checkFieldsInColumnMapping(model);
        if (model.exception !== error) {
          updatedModel = (0,external_immer_.produce)(model, draft => {
            draft.exception = error;
          });
        }
      }
      if (!model.hasValidAdditionalKey() && model.exception !== ADDITIONAL_KEY_ERROR) {
        updatedModel = (0,external_immer_.produce)(model, draft => {
          draft.exception = ADDITIONAL_KEY_ERROR;
        });
      }
      this.setState(() => ({
        model: updatedModel
      }), () => {
        if (onChange) {
          onChange(model);
        }
      });
    });
    DatasetDesignerPanels_defineProperty(this, "onIndexChange", (keyPropertyIndex, visitDatePropertyIndex) => {
      this.setState(() => ({
        keyPropertyIndex,
        visitDatePropertyIndex
      }));
    });
    DatasetDesignerPanels_defineProperty(this, "onFinish", () => {
      const {
        setSubmitting
      } = this.props;
      const {
        model,
        shouldImportData
      } = this.state;
      const missingRequiredTimepointMapping = !model.demographicData && !this._sequenceNum;
      if (shouldImportData && (!this._participantId || missingRequiredTimepointMapping)) {
        this.setState((0,external_immer_.produce)(draft => {
          draft.model.exception = 'You must select a column mapping field for ' + getStudySubjectProp('nounPlural') + (missingRequiredTimepointMapping ? ' and ' + getStudyTimepointLabel() : '') + ' in the fields panel.';
        }), () => {
          setSubmitting(false);
        });
        return;
      }
      if (this.checkFieldsInColumnMapping(model) || !model.hasValidAdditionalKey()) {
        return;
      }
      this.props.onFinish(model.isValid(), this.saveDomain);
    });
    DatasetDesignerPanels_defineProperty(this, "onDomainChange", (domain, dirty, rowIndexChanges) => {
      const {
        onChange
      } = this.props;
      const {
        keyPropertyIndex,
        visitDatePropertyIndex
      } = this.state;
      this.setState((0,external_immer_.produce)(draft => {
        draft.model.domain = domain;

        // if we are back to the no fields state, reset the file related items
        if (domain.fields.size === 0) {
          draft.file = undefined;
          draft.shouldImportData = false;
          this._participantId = undefined;
          this._sequenceNum = undefined;
        }
        if (keyPropertyIndex !== undefined) {
          // if the row was removed or reordered, update the keyPropertyIndex
          // else if a different row was removed or reordered, refind out index by name
          if (rowIndexChanges) {
            rowIndexChanges.forEach(rowIndexChange => {
              if (rowIndexChange.originalIndex === keyPropertyIndex) {
                draft.keyPropertyIndex = rowIndexChange.newIndex;
              } else {
                draft.keyPropertyIndex = this.findFieldIndexByName(draft.model.domain, draft.model.keyPropertyName);
              }
            });
          }

          // if row was removed, reset key property name
          if (draft.keyPropertyIndex === undefined) {
            draft.model.keyPropertyName = '';
          } else {
            // pick up any name changes to the selected field
            draft.model.keyPropertyName = domain.fields.get(draft.keyPropertyIndex).name;
          }
        }
        if (visitDatePropertyIndex !== undefined) {
          // if the row was removed or reordered, update the visitDatePropertyIndex
          if (rowIndexChanges) {
            rowIndexChanges.forEach(rowIndexChange => {
              if (rowIndexChange && rowIndexChange.originalIndex === visitDatePropertyIndex) {
                draft.visitDatePropertyIndex = rowIndexChange.newIndex;
              } else {
                draft.visitDatePropertyIndex = this.findFieldIndexByName(draft.model.domain, draft.model.visitDatePropertyName);
              }
            });
          }

          // if row was removed, reset visit date property name
          if (draft.visitDatePropertyIndex === undefined) {
            draft.model.visitDatePropertyName = undefined;
          } else {
            // pick up any name changes to the selected field
            draft.model.visitDatePropertyName = domain.fields.get(draft.visitDatePropertyIndex).name;
          }
        }
      }), () => {
        // Issue 39918: use the dirty property that DomainForm onChange passes
        if (onChange && dirty) {
          onChange(this.state.model);
        }
      });
    });
    DatasetDesignerPanels_defineProperty(this, "setFileImportData", (file, shouldImportData) => {
      this.setState(state => ({
        file,
        shouldImportData: shouldImportData && !state.model.definitionIsShared
      }));
    });
    DatasetDesignerPanels_defineProperty(this, "onColumnMappingChange", (participantIdField, timePointField) => {
      const {
        model
      } = this.state;
      this._participantId = participantIdField;
      this._sequenceNum = timePointField;

      // lock down these fields from domain
      const updatedDomain = model.domain.merge({
        fields: model.domain.fields.map(field => {
          if (field.name === participantIdField || field.name === timePointField) {
            return field.set('lockType', DOMAIN_FIELD_FULLY_LOCKED);
          } else {
            return field.set('lockType', DOMAIN_FIELD_NOT_LOCKED);
          }
        }).toList()
      });
      this.setState((0,external_immer_.produce)(draft => {
        draft.model.domain = updatedDomain;
        draft.model.exception = this.checkFieldsInColumnMapping(draft.model);
      }));
    });
    DatasetDesignerPanels_defineProperty(this, "renderColumnMappingSection", () => {
      const {
        model,
        file
      } = this.state;

      // only show this column mapping section in the file infer fields case when there is at least one field
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, file && model && model.domain.fields && model.domain.fields.size > 0 && /*#__PURE__*/external_react_default().createElement(DatasetColumnMappingPanel, {
        model: model,
        onColumnMappingChange: this.onColumnMappingChange,
        subjectColumnName: getStudySubjectProp('columnName'),
        timepointType: (0,api_.getServerContext)().moduleContext.study.timepointType
      }));
    });
    DatasetDesignerPanels_defineProperty(this, "onImportErrorStayAndFix", () => {
      const {
        savedModel
      } = this.state;
      api_.Domain.drop({
        schemaName: 'study',
        queryName: savedModel.name,
        failure: error => {
          this.setState((0,external_immer_.produce)(draft => {
            draft.model.exception = error;
            draft.savedModel = undefined;
            draft.importError = undefined;
          }));
        },
        success: () => {
          this.setState((0,external_immer_.produce)(draft => {
            draft.savedModel = undefined;
            draft.importError = undefined;
          }));
        }
      });
    });
    DatasetDesignerPanels_defineProperty(this, "onImportErrorContinue", () => {
      this.props.onComplete(this.state.savedModel);
    });
    DatasetDesignerPanels_defineProperty(this, "saveDomain", () => {
      const {
        setSubmitting
      } = this.props;
      const {
        model,
        shouldImportData
      } = this.state;
      const participantIdMapCol = this._participantId;
      const sequenceNumMapCol = this._sequenceNum;

      // filter out the selected column mapping files as those will be created in the base domain fields
      const updatedDomain = model.domain.merge({
        fields: model.domain.fields.filter(field => !this._participantId || field.name !== this._participantId).filter(field => !this._sequenceNum || field.name !== this._sequenceNum).toList()
      });

      // need to track the updated field index values for property values after the filter
      let keyPropIndex;
      let visitPropIndex;
      updatedDomain.fields.map((field, index) => {
        if (model.keyPropertyName && field.name === model.keyPropertyName) {
          keyPropIndex = index;
        }
        if (model.visitDatePropertyName && field.name === model.visitDatePropertyName) {
          visitPropIndex = index;
        }
      });
      saveDomain({
        domain: updatedDomain,
        kind: model.getDomainKind(),
        options: model.getOptions(),
        name: model.name,
        includeWarnings: false,
        addRowIndexes: true,
        originalDomain: model.domain
      }).then(response => {
        this.setState((0,external_immer_.produce)(draftState => {
          draftState.keyPropertyIndex = keyPropIndex;
          draftState.visitDatePropertyIndex = visitPropIndex;
          draftState.model.exception = undefined;

          // the savedModel will be used for dropping the domain on file import failure or for onComplete
          draftState.savedModel = (0,external_immer_.produce)(draftState.model, draftModel => {
            draftModel.domain = response;
          });
        }), () => {
          // If we're importing Dataset file and not in a Dataspace study, import the file contents
          if (shouldImportData) {
            this.handleFileImport(participantIdMapCol, sequenceNumMapCol);
          } else {
            setSubmitting(false, () => {
              this.props.onComplete(this.state.savedModel);
            });
          }
        });
      }).catch(response => {
        const exception = resolveErrorMessage(response);
        setSubmitting(false, () => {
          this.setState((0,external_immer_.produce)(draft => {
            if (exception) {
              draft.model.exception = exception;
            } else {
              // since the create case filters out the mapped columns, we don't replace the full
              // model.domain with response but just update the domainException
              draft.model.domain = draft.model.domain.merge({
                domainException: response.domainException
              });
              draft.model.exception = undefined;
            }
          }));
        });
      });
    });
    this.state = {
      model: props.initModel || DatasetModel.create(null, {}),
      file: undefined,
      shouldImportData: false,
      savedModel: undefined,
      importError: undefined
    };
  }
  componentDidMount() {
    const {
      model
    } = this.state;

    // setting initial indexes if these properties are already present and there are changes to them in
    // the domain form
    const keyPropertyIndex = this.findFieldIndexByName(model.domain, model.keyPropertyName);
    const visitDatePropertyIndex = this.findFieldIndexByName(model.domain, model.visitDatePropertyName);

    // disabling the phi level for initially selected additional key field
    if (model.keyPropertyName) {
      const updatedDomain = model.domain.merge({
        fields: model.domain.fields.map((field, index) => {
          return field.set('disablePhiLevel', field.name === model.keyPropertyName);
        }).toList()
      });
      const updatedModel = (0,external_immer_.produce)(model, draft => {
        draft.domain = updatedDomain;
      });
      this.setState(() => ({
        keyPropertyIndex,
        visitDatePropertyIndex,
        model: updatedModel
      }));
    } else {
      this.setState(() => ({
        keyPropertyIndex,
        visitDatePropertyIndex
      }));
    }
  }
  findFieldIndexByName(domain, fieldName) {
    const index = domain.findFieldIndexByName(fieldName);
    return index > -1 ? index : undefined;
  }
  checkFieldsInColumnMapping(model) {
    let error;
    if (model.keyPropertyName && (model.keyPropertyName === this._participantId || model.keyPropertyName === this._sequenceNum)) {
      error = KEY_FIELD_MAPPING_ERROR;
    } else if (model.visitDatePropertyName && (model.visitDatePropertyName === this._participantId || model.visitDatePropertyName === this._sequenceNum)) {
      error = VISIT_DATE_MAPPING_ERROR;
    }
    return error;
  }
  handleFileImport(participantId, sequenceNum) {
    const {
      setSubmitting
    } = this.props;
    const {
      file,
      savedModel
    } = this.state;
    importData({
      schemaName: 'study',
      queryName: savedModel.name,
      file,
      importUrl: buildURL('study', 'import', {
        name: savedModel.name,
        participantId,
        sequenceNum
      })
    }).then(response => {
      setSubmitting(false, () => {
        this.props.onComplete(savedModel);
      });
    }).catch(error => {
      console.error(error);
      setSubmitting(false, () => {
        this.setState({
          importError: error
        });
      });
    });
  }
  render() {
    const {
      api,
      onTogglePanel,
      visitedPanels,
      submitting,
      onCancel,
      currentPanelIndex,
      firstState,
      validatePanel,
      saveBtnText
    } = this.props;
    const {
      model,
      file,
      keyPropertyIndex,
      visitDatePropertyIndex,
      importError
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement(BaseDomainDesigner, {
      name: model.name,
      exception: model.exception,
      domains: external_immutable_.List.of(model.domain),
      hasValidProperties: model.hasValidProperties(),
      visitedPanels: visitedPanels,
      submitting: submitting,
      onCancel: onCancel,
      onFinish: this.onFinish,
      saveBtnText: saveBtnText
    }, /*#__PURE__*/external_react_default().createElement(DatasetPropertiesPanel, {
      initCollapsed: currentPanelIndex !== 0,
      model: model,
      keyPropertyIndex: keyPropertyIndex,
      visitDatePropertyIndex: visitDatePropertyIndex,
      onIndexChange: this.onIndexChange,
      controlledCollapse: true,
      panelStatus: model.isNew() ? getDomainPanelStatus(0, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      validate: validatePanel === 0,
      onToggle: (collapsed, callback) => {
        onTogglePanel(0, collapsed, callback);
      },
      onChange: this.onPropertiesChange
    }), /*#__PURE__*/external_react_default().createElement(domainproperties_DomainForm, {
      api: api,
      key: model.domain.domainId || 0,
      domainIndex: 0,
      domain: model.domain,
      headerTitle: "Fields",
      helpNoun: "dataset",
      helpTopic: null // null so that we don't show the "learn more about this tool" link for this domains
      ,
      onChange: this.onDomainChange,
      setFileImportData: this.setFileImportData,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== 1,
      validate: validatePanel === 1,
      panelStatus: model.isNew() ? getDomainPanelStatus(1, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      onToggle: (collapsed, callback) => {
        onTogglePanel(1, collapsed, callback);
      },
      fieldsAdditionalRenderer: this.renderColumnMappingSection,
      domainFormDisplayOptions: {
        isDragDisabled: model.isFromLinkedSource(),
        hideAddFieldsButton: model.isFromLinkedSource(),
        hideImportData: model.definitionIsShared,
        // Shared (Dataspace) study does not have permission to import data. See study-importAction.validatePermission
        retainReservedFields: true // reserved fields are used for mapping the participant and visit columns.
      }
    }), /*#__PURE__*/external_react_default().createElement(Progress, {
      modal: true,
      delay: 1000,
      estimate: file ? file.size * 0.005 : undefined,
      title: "Importing data from selected file...",
      toggle: submitting && file !== undefined
    }), importError !== undefined && /*#__PURE__*/external_react_default().createElement(ConfirmImportTypes, {
      designerType: "dataset",
      error: importError,
      onConfirm: this.onImportErrorContinue,
      onCancel: this.onImportErrorStayAndFix
    }));
  }
}
DatasetDesignerPanels_defineProperty(DatasetDesignerPanelImpl, "defaultProps", {
  api: getDefaultAPIWrapper().domain
});
const DatasetDesignerPanels = withBaseDomainDesigner(DatasetDesignerPanelImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/validation/NameExpressionValidationModal.tsx
function NameExpressionValidationModal_defineProperty(e, r, t) { return (r = NameExpressionValidationModal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function NameExpressionValidationModal_toPropertyKey(t) { var i = NameExpressionValidationModal_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function NameExpressionValidationModal_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


const nameExpressionWarningPrefix = 'Name Pattern warning: ';
const aliquotNameExpressionWarningPrefix = 'Aliquot Name Pattern warning: ';
class NameExpressionValidationModal extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    NameExpressionValidationModal_defineProperty(this, "onConfirm", () => {
      const {
        onConfirm,
        onHide
      } = this.props;
      onConfirm();
      onHide();
    });
  }
  render() {
    const {
      title,
      onHide,
      onConfirm,
      warnings,
      show,
      previews
    } = this.props;
    if (!show || !warnings || warnings.length === 0) return null;
    const nameWarnings = [],
      aliquotNameWarnings = [];
    warnings?.forEach(warning => {
      if (warning.indexOf(nameExpressionWarningPrefix) === 0) nameWarnings.push(warning.substring(nameExpressionWarningPrefix.length));else if (warning.indexOf(aliquotNameExpressionWarningPrefix) === 0) aliquotNameWarnings.push(warning.substring(aliquotNameExpressionWarningPrefix.length));
    });
    let warnTitle = title,
      hasMultiGroup = false;
    if (!warnTitle) {
      if (nameWarnings.length > 0 && aliquotNameWarnings.length > 0) {
        hasMultiGroup = true;
        warnTitle = 'Sample and Aliquot Naming Pattern Warning(s)';
      } else if (nameWarnings.length > 0) warnTitle = 'Naming Pattern Warning(s)';else if (aliquotNameWarnings.length > 0) warnTitle = 'Aliquot Naming Pattern Warning(s)';
    }
    let nameWarnDisplay = null,
      aliquotNameWarnDisplay = null;
    if (nameWarnings.length > 0) {
      nameWarnDisplay = /*#__PURE__*/external_react_default().createElement("div", null, hasMultiGroup && /*#__PURE__*/external_react_default().createElement("p", null, "Naming Pattern Warning(s):"), /*#__PURE__*/external_react_default().createElement("p", null, "Example name generated: ", previews[0]), /*#__PURE__*/external_react_default().createElement("ul", {
        className: "name-expression-warning-list"
      }, nameWarnings.map((warning, ind) => /*#__PURE__*/external_react_default().createElement("li", {
        key: ind + ''
      }, warning))), /*#__PURE__*/external_react_default().createElement("br", null));
    }
    if (aliquotNameWarnings.length > 0) {
      aliquotNameWarnDisplay = /*#__PURE__*/external_react_default().createElement("div", null, hasMultiGroup && /*#__PURE__*/external_react_default().createElement("p", null, "Aliquot Naming Pattern Warning(s):"), /*#__PURE__*/external_react_default().createElement("p", null, "Example aliquot name generated: ", previews[1]), /*#__PURE__*/external_react_default().createElement("ul", {
        className: "aliquot-expression-warning-list"
      }, aliquotNameWarnings.map((warning, ind) => /*#__PURE__*/external_react_default().createElement("li", {
        key: ind + ''
      }, warning))));
    }
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      title: warnTitle,
      onCancel: onHide,
      onConfirm: onConfirm,
      confirmText: "Save anyways...",
      confirmClass: "btn-danger"
    }, nameWarnDisplay, aliquotNameWarnDisplay);
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/NameExpressionGenIdBanner.tsx







const GENID_SYNTAX_STRING = '${genId'; // skip closing tag to allow existence of formatter

const NameExpressionGenIdBanner = props => {
  const {
    api,
    containerPath,
    rowId,
    kindName,
    dataTypeName,
    dataTypeLSID
  } = props;
  const [currentGenId, setCurrentGenId] = (0,external_react_.useState)(undefined);
  const [newGenId, setNewGenId] = (0,external_react_.useState)(undefined);
  const [minNewGenId, setMinNewGenId] = (0,external_react_.useState)(undefined);
  const [error, setError] = (0,external_react_.useState)(undefined);
  const [canReset, setCanReset] = (0,external_react_.useState)(false);
  const [showResetDialog, setShowResetDialog] = (0,external_react_.useState)(false);
  const [showEditDialog, setShowEditDialog] = (0,external_react_.useState)(false);

  // useNotificationsContext will not always be available depending on if the app wraps the NotificationsContext.Provider
  let _createNotification;
  try {
    _createNotification = useNotificationsContext().createNotification;
  } catch (e) {
    // this is expected for LKS usages, so don't throw or console.error
  }
  const init = async () => {
    if (rowId && kindName) {
      try {
        const canResetGen = await api.entity.isDataTypeEmpty(kindName === 'DataClass' ? 'DataClass' : 'SampleType', dataTypeLSID, rowId, containerPath);
        setCanReset(canResetGen);
        try {
          const genId = (await api.domain.getGenId(rowId, kindName)) + 1; // when creating new data, seq.next() will be used, so display the next number to users instead of current
          setCurrentGenId(genId);
          const minNewGenId = canResetGen ? 1 : genId;
          setMinNewGenId(minNewGenId);
          setNewGenId(minNewGenId);
        } catch (reason) {
          console.error(reason);
        }
      } catch (reason) {
        console.error(reason);
      }
    }
  };
  (0,external_react_.useEffect)(() => {
    init();
  }, [rowId, kindName]);
  const onEditClick = (0,external_react_.useCallback)(() => {
    setShowEditDialog(true);
    setError(undefined);
  }, []);
  const onEditCancel = (0,external_react_.useCallback)(() => {
    setShowEditDialog(false);
  }, []);
  const onEditConfirm = (0,external_react_.useCallback)(async () => {
    const newGen = newGenId ?? minNewGenId;
    if (newGen === currentGenId) {
      setShowEditDialog(false);
      return;
    }
    try {
      await api.domain.setGenId(rowId, kindName, (newGenId ?? minNewGenId) - 1 /* Reset to N-1 so seq.next will be N. */);
      _createNotification?.('Successfully updated genId.');
      init();
      setShowEditDialog(false);
    } catch (reason) {
      console.error(reason);
      const error = reason?.error ?? reason;
      setError(resolveErrorMessage(error, 'genId', 'genId', 'edit'));
    }
  }, [rowId, kindName, newGenId, _createNotification]);
  const onResetClick = (0,external_react_.useCallback)(() => {
    setShowResetDialog(true);
    setError(undefined);
  }, []);
  const onResetCancel = (0,external_react_.useCallback)(() => {
    setShowResetDialog(false);
  }, []);
  const onResetConfirm = (0,external_react_.useCallback)(async () => {
    try {
      await api.domain.setGenId(rowId, kindName, 0 /* Reset to 0 so seq.next will be 1. */);
      _createNotification?.('Successfully reset genId.');
      init();
      setShowResetDialog(false);
    } catch (reason) {
      console.error(reason);
      setError(resolveErrorMessage(reason, 'genId', 'genId', 'reset'));
    }
  }, [api, rowId, kindName, _createNotification, init]);
  if (currentGenId === undefined) return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "info",
    className: "genid-alert"
  }, "Current genId: ", currentGenId, /*#__PURE__*/external_react_default().createElement("button", {
    className: "pull-right alert-button edit-genid-btn btn btn-info",
    onClick: onEditClick,
    type: "button"
  }, "Edit genId"), canReset && currentGenId > 1 && /*#__PURE__*/external_react_default().createElement("button", {
    className: "pull-right alert-button reset-genid-btn btn btn-info",
    onClick: onResetClick,
    type: "button"
  }, "Reset genId")), showResetDialog && /*#__PURE__*/external_react_default().createElement(Modal, {
    confirmText: "Reset",
    confirmClass: "btn-danger",
    onCancel: onResetCancel,
    onConfirm: onResetConfirm,
    title: `Are you sure you want to reset genId for ${dataTypeName}?`
  }, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("div", null, "The current genId is at ", currentGenId, ". Resetting will reset genId back to 1 and cannot be undone.")), showEditDialog && /*#__PURE__*/external_react_default().createElement(Modal, {
    confirmText: "Update",
    confirmClass: "btn-danger",
    onCancel: onEditCancel,
    onConfirm: onEditConfirm,
    title: `Are you sure you want to update genId for ${dataTypeName}?`
  }, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("div", null, "The current genId is at ", currentGenId, ". Updating genId will allow new", ' ', kindName === 'SampleSet' ? 'samples' : 'data', " to use a new start value (min ", minNewGenId, "). This action cannot be undone."), /*#__PURE__*/external_react_default().createElement("div", {
    className: "row margin-top"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-5"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control update-genId-input ",
    min: minNewGenId,
    step: 1,
    name: "newgenidval",
    onChange: event => setNewGenId(event?.target?.value),
    type: "number",
    value: newGenId ?? minNewGenId,
    placeholder: "Enter new genId..."
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-7"
  }))));
};
NameExpressionGenIdBanner.defaultProps = {
  api: getDefaultAPIWrapper()
};
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/samples/UniqueIdBanner.tsx



const DEFAULT_UNIQUE_ID_FIELD = {
  dataType: UNIQUE_ID_TYPE,
  conceptURI: UNIQUE_ID_TYPE.conceptURI,
  rangeURI: UNIQUE_ID_TYPE.rangeURI,
  name: 'Barcode',
  shownInInsertView: false
};

// exported for Jest tests
const NEW_TYPE_NO_BARCODE_FIELDS_MSG = 'Not currently enabled for this sample type';
const ADD_NEW_UNIQUE_ID_MSG = 'Do you want to add a unique ID field to create barcodes for this sample type?';
const UniqueIdBanner = (0,external_react_.memo)(({
  model,
  isFieldsPanel,
  onAddField
}) => {
  const onClick = (0,external_react_.useCallback)(() => {
    onAddField(DEFAULT_UNIQUE_ID_FIELD);
  }, [onAddField]);
  const uniqueIdFields = model.domain?.fields?.filter(field => field.isUniqueIdField()).toArray();
  if (model.isNew() && !isFieldsPanel && !uniqueIdFields?.length) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "uniqueid-msg"
    }, NEW_TYPE_NO_BARCODE_FIELDS_MSG);
  } else {
    if (!uniqueIdFields?.length) {
      return /*#__PURE__*/external_react_default().createElement(Alert, {
        bsStyle: "info",
        className: "uniqueid-alert"
      }, ADD_NEW_UNIQUE_ID_MSG, /*#__PURE__*/external_react_default().createElement("button", {
        className: "pull-right alert-button btn btn-info",
        onClick: onClick,
        type: "button"
      }, "Yes, Add Unique ID Field"));
    } else if (!isFieldsPanel) {
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "uniqueid-msg"
      }, /*#__PURE__*/external_react_default().createElement("i", {
        className: "fa fa-check-circle domain-panel-status-icon-green"
      }), /*#__PURE__*/external_react_default().createElement("span", {
        className: "left-spacing"
      }, uniqueIdFields?.length === 1 ? 'A Unique ID field for barcodes is defined: ' + uniqueIdFields[0].name : uniqueIdFields.length + ' Unique ID fields are defined: ' + uniqueIdFields.map(field => field.name).join(', ')));
    }
  }
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/entities/constants.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const ENTITY_FORM_ID_PREFIX = 'entity-';
const constants_ENTITY_FORM_IDS = {
  NAME: ENTITY_FORM_ID_PREFIX + 'name',
  NAME_EXPRESSION: ENTITY_FORM_ID_PREFIX + 'nameExpression',
  DESCRIPTION: ENTITY_FORM_ID_PREFIX + 'description',
  AUTO_LINK_TARGET: ENTITY_FORM_ID_PREFIX + 'autoLinkTargetContainerId',
  AUTO_LINK_CATEGORY: ENTITY_FORM_ID_PREFIX + 'autoLinkCategory'
};
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/entities/actions.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function getFormNameFromId(id) {
  const index = id.indexOf(ENTITY_FORM_ID_PREFIX);
  return index === 0 ? id.substring(index + ENTITY_FORM_ID_PREFIX.length) : id;
}
function getEntityFormDataValue(key, propName, defaultValue, formValues, data) {
  if (key && formValues && formValues[key] !== undefined) {
    return formValues[key] || defaultValue;
  } else if (data) {
    return data.get(propName) || defaultValue;
  }
  return defaultValue;
}
function isEntityFormValid(formValues, data) {
  const hasValidName = formValues !== undefined && formValues[ENTITY_FORM_IDS.NAME] !== undefined && formValues[ENTITY_FORM_IDS.NAME].length > 0;
  return isExistingEntity(formValues, data) || hasValidName;
}
function isExistingEntity(formValues, data) {
  return getEntityFormDataValue(null, 'rowId', undefined, formValues, data) !== undefined;
}
function getEntityNameValue(formValues, data) {
  return getEntityFormDataValue(constants_ENTITY_FORM_IDS.NAME, 'name', '', formValues, data);
}
function getEntityNameExpressionValue(formValues, data) {
  return getEntityFormDataValue(constants_ENTITY_FORM_IDS.NAME_EXPRESSION, 'nameExpression', '', formValues, data);
}
function getEntityDescriptionValue(formValues, data) {
  return getEntityFormDataValue(constants_ENTITY_FORM_IDS.DESCRIPTION, 'description', '', formValues, data);
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/NameExpressionPreview.tsx


const NameExpressionPreview = props => {
  const {
    isPreviewLoading,
    previewName
  } = props;
  const isValidExpression = isPreviewLoading || !!previewName;
  if (!isValidExpression) {
    return /*#__PURE__*/external_react_default().createElement("p", null, "Unable to generate example name from the current pattern. Check for syntax errors.");
  }
  return /*#__PURE__*/external_react_default().createElement("p", null, "Example of name that will be generated from the current pattern:\xA0", previewName ? previewName : /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null));
};
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/entities/EntityDetailsForm.tsx







class EntityDetailsForm extends (external_react_default()).PureComponent {
  render() {
    const {
      nameExpressionInfoUrl,
      nameExpressionPlaceholder,
      noun,
      onFormChange,
      formValues,
      data,
      nameReadOnly,
      warning,
      showPreviewName,
      previewName,
      onNameFieldHover,
      namePreviewsLoading,
      nameExpressionGenIdProps
    } = this.props;
    const moreInfoLink = nameExpressionInfoUrl ? /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("a", {
      target: "_blank",
      href: nameExpressionInfoUrl,
      rel: "noopener noreferrer"
    }, "More info")) : '';
    return /*#__PURE__*/external_react_default().createElement("form", null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Name",
      required: true
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-10"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      id: constants_ENTITY_FORM_IDS.NAME,
      type: "text",
      placeholder: `Enter a name for this ${noun.toLowerCase()}`,
      onChange: onFormChange,
      value: getEntityNameValue(formValues, data),
      disabled: nameReadOnly
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Description",
      helpTipBody: `A short description for this ${noun.toLowerCase()}.`
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-10"
    }, /*#__PURE__*/external_react_default().createElement("textarea", {
      className: "form-control",
      id: constants_ENTITY_FORM_IDS.DESCRIPTION,
      onChange: onFormChange,
      value: getEntityDescriptionValue(formValues, data)
    }))), nameExpressionGenIdProps && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-10"
    }, /*#__PURE__*/external_react_default().createElement(NameExpressionGenIdBanner, nameExpressionGenIdProps))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "name-expression-label-div",
      onMouseEnter: () => onNameFieldHover?.()
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Naming Pattern",
      helpTipBody: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Pattern used for generating unique IDs for this ", noun.toLowerCase(), "."), showPreviewName && /*#__PURE__*/external_react_default().createElement(NameExpressionPreview, {
        previewName: previewName,
        isPreviewLoading: namePreviewsLoading
      }), moreInfoLink)
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-10"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: external_classnames_default()('form-control', {
        'naming-pattern-border-warning': warning !== undefined && !warning.startsWith('Aliquot')
      }),
      id: constants_ENTITY_FORM_IDS.NAME_EXPRESSION,
      type: "text",
      placeholder: nameExpressionPlaceholder,
      onChange: onFormChange,
      value: getEntityNameExpressionValue(formValues, data)
    }))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/ParentAliasRow.tsx
function ParentAliasRow_defineProperty(e, r, t) { return (r = ParentAliasRow_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ParentAliasRow_toPropertyKey(t) { var i = ParentAliasRow_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ParentAliasRow_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







class ParentAliasRow extends (external_react_default()).Component {
  constructor(props) {
    super(props);
    ParentAliasRow_defineProperty(this, "nameInput", void 0);
    ParentAliasRow_defineProperty(this, "focusNameInput", () => {
      if (this.nameInput && this.nameInput.current) {
        const domEl = (0,external_react_dom_.findDOMNode)(this.nameInput.current);
        domEl.focus();
      }
    });
    ParentAliasRow_defineProperty(this, "onChange", e => {
      const {
        name,
        value
      } = e.target;
      this.props.onAliasChange(this.props.id, name, value);
    });
    ParentAliasRow_defineProperty(this, "onSelectChange", (name, selectedValue, selectedOption) => {
      // Issue 40149: on clear, need to retain the IParentOption with schema
      const {
        parentAlias
      } = this.props;
      let newValue = selectedOption;
      if (!selectedOption && parentAlias && parentAlias.parentValue) {
        newValue = {
          schema: parentAlias.parentValue.schema
        };
      }
      this.props.onAliasChange(this.props.id, name, newValue);
    });
    ParentAliasRow_defineProperty(this, "removeParentAlias", () => {
      const {
        id
      } = this.props;
      this.props.onRemove(id);
    });
    ParentAliasRow_defineProperty(this, "onAliasBlur", () => {
      this.props.updateDupeParentAliases(this.props.id);
    });
    // Issue 40149: update alias ignoreSelectError prop on both blur and focus
    ParentAliasRow_defineProperty(this, "onParentValueBlur", () => {
      this.props.onAliasChange(this.props.id, 'ignoreSelectError', false);
    });
    // Issue 40149: update alias ignoreSelectError prop on both blur and focus
    ParentAliasRow_defineProperty(this, "onParentValueFocus", () => {
      this.props.onAliasChange(this.props.id, 'ignoreSelectError', true);
    });
    this.nameInput = external_react_default().createRef();
  }
  componentDidMount() {
    const {
      parentAlias
    } = this.props;
    if (!(parentAlias && parentAlias.alias)) this.focusNameInput();
  }
  render() {
    const {
      id,
      parentAlias,
      parentOptions,
      aliasCaption,
      parentTypeCaption,
      helpMsg
    } = this.props;
    if (!parentOptions) return null;
    const {
      alias,
      parentValue,
      ignoreAliasError,
      ignoreSelectError,
      isDupe
    } = parentAlias;
    const aliasBlank = !alias || alias.trim().length === 0;
    const parentValueBlank = !parentValue || !parentValue.value;
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "row",
      key: id
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: aliasCaption,
      required: true,
      helpTipBody: helpMsg
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('col-xs-3', {
        'has-error': !ignoreAliasError && (aliasBlank || isDupe)
      })
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      ref: this.nameInput,
      name: "alias",
      type: "text",
      placeholder: `Enter a ${aliasCaption.toLowerCase()} for import`,
      defaultValue: alias // Issue 50140: use defaultValue instead of value
      ,
      onChange: this.onChange,
      onBlur: this.onAliasBlur
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: external_classnames_default()('col-xs-5', {
        'has-error': !ignoreSelectError && parentValueBlank
      })
    }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      inputClass: "import-alias--parent-select",
      name: "parentValue",
      onChange: this.onSelectChange,
      options: parentOptions,
      placeholder: `Select a ${parentTypeCaption.toLowerCase()}...`,
      value: parentValue?.value,
      onFocus: this.onParentValueFocus,
      onBlur: this.onParentValueBlur
    })), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(RemoveEntityButton, {
      labelClass: "entity-insert--remove-parent",
      onClick: this.removeParentAlias
    })));
  }
}
ParentAliasRow_defineProperty(ParentAliasRow, "defaultProps", {
  aliasCaption: 'Parent Alias',
  parentTypeCaption: 'parent type',
  helpMsg: PARENT_ALIAS_HELPER_TEXT
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DomainParentAliases.tsx






const sampleSetAliasFilterFn = alias => {
  return alias.parentValue?.schema === SCHEMAS.SAMPLE_SETS.SCHEMA;
};
const sampleSetOptionFilterFn = option => {
  return option?.schema === SCHEMAS.SAMPLE_SETS.SCHEMA;
};
const dataClassAliasFilterFn = alias => {
  return alias.parentValue?.schema === SCHEMAS.DATA_CLASSES.SCHEMA;
};
const dataClassOptionFilterFn = option => {
  return option?.schema === SCHEMAS.DATA_CLASSES.SCHEMA;
};
const DomainParentAliases = (0,external_react_.memo)(props => {
  const {
    parentAliases,
    parentOptions,
    updateDupeParentAliases,
    sampleAliasCaption,
    sampleTypeCaption,
    dataClassAliasCaption,
    dataClassTypeCaption,
    dataClassParentageLabel,
    onParentAliasChange,
    onRemoveParentAlias,
    includeSampleSet,
    includeDataClass,
    showAddBtn,
    idPrefix,
    onAddParentAlias,
    schema,
    addEntityHelp,
    parentAliasHelpText,
    useSeparateDataClassesAliasMenu
  } = props;
  const [aliasCaption, setAliasCaption] = (0,external_react_.useState)();
  const [helpMsg, setHelpMsg] = (0,external_react_.useState)();
  const [parentTypeCaption, setParentTypeCaption] = (0,external_react_.useState)();
  const [filteredParentOptions, setFilteredParentOptions] = (0,external_react_.useState)();
  const [filteredParentAliases, setFilteredParentAliases] = (0,external_react_.useState)();
  (0,external_react_.useEffect)(() => {
    if (!parentAliases || !parentOptions) return;
    let filteredParentAliases = (0,external_immutable_.OrderedMap)();
    let filteredParentOptions = [];
    let aliasCaption;
    let parentTypeCaption;
    let helpMsg;
    if (includeSampleSet && includeDataClass) {
      filteredParentAliases = parentAliases;
      filteredParentOptions = parentOptions;
    } else if (includeSampleSet) {
      filteredParentAliases = parentAliases.filter(sampleSetAliasFilterFn);
      filteredParentOptions = parentOptions.filter(sampleSetOptionFilterFn);
      aliasCaption = sampleAliasCaption;
      parentTypeCaption = sampleTypeCaption;
    } else if (includeDataClass) {
      filteredParentAliases = parentAliases.filter(dataClassAliasFilterFn);
      filteredParentOptions = parentOptions.filter(dataClassOptionFilterFn);
      aliasCaption = dataClassAliasCaption;
      parentTypeCaption = dataClassTypeCaption;
      helpMsg = parentAliasHelpText.replace('parentage', dataClassParentageLabel ? dataClassParentageLabel : 'parentage');
    }
    if (includeSampleSet && !(includeDataClass && useSeparateDataClassesAliasMenu)) {
      aliasCaption = 'Parent Alias';
    }
    setAliasCaption(aliasCaption);
    setParentTypeCaption(parentTypeCaption);
    setHelpMsg(helpMsg);
    setFilteredParentOptions(filteredParentOptions);
    setFilteredParentAliases(filteredParentAliases?.valueSeq()?.toArray());
  }, [parentAliases, parentOptions]);
  const addParentAlias = (0,external_react_.useCallback)(() => {
    // Generates a temporary id for add/delete of the import aliases
    const newId = generateId(idPrefix);
    const newParentAlias = {
      id: newId,
      alias: '',
      parentValue: {
        schema
      },
      ignoreAliasError: true,
      ignoreSelectError: true,
      isDupe: false
    };
    onAddParentAlias(newId, newParentAlias);
  }, [idPrefix, onAddParentAlias, schema]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, filteredParentAliases?.map(alias => /*#__PURE__*/external_react_default().createElement(ParentAliasRow, {
    key: alias.id,
    id: alias.id,
    parentAlias: alias,
    parentOptions: filteredParentOptions,
    onAliasChange: onParentAliasChange,
    onRemove: onRemoveParentAlias,
    updateDupeParentAliases: updateDupeParentAliases,
    aliasCaption: aliasCaption,
    parentTypeCaption: parentTypeCaption,
    helpMsg: helpMsg
  })), showAddBtn && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-2"
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-10"
  }, /*#__PURE__*/external_react_default().createElement("span", null, /*#__PURE__*/external_react_default().createElement(AddEntityButton, {
    entity: aliasCaption,
    onClick: addParentAlias,
    helperBody: addEntityHelp
  })))));
});
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/samples/SampleTypePropertiesPanel.tsx
function SampleTypePropertiesPanel_extends() { return SampleTypePropertiesPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, SampleTypePropertiesPanel_extends.apply(null, arguments); }
function SampleTypePropertiesPanel_defineProperty(e, r, t) { return (r = SampleTypePropertiesPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SampleTypePropertiesPanel_toPropertyKey(t) { var i = SampleTypePropertiesPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SampleTypePropertiesPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

























const SampleTypePropertiesPanel_PROPERTIES_HEADER_ID = 'sample-type-properties-hdr';
const ALIQUOT_HELP_LINK = getHelpLink('aliquotIDs');
const ALIQUOT_NAME_PLACEHOLDER = 'Enter a naming pattern for aliquots (e.g., ' + DEFAULT_ALIQUOT_NAMING_PATTERN + ')';
const AddEntityHelpTip = (0,external_react_.memo)(({
  parentageLabel
}) => {
  const msg = parentageLabel ? PARENT_ALIAS_HELPER_TEXT.replace(/parent(age)?/g, parentageLabel) : PARENT_ALIAS_HELPER_TEXT;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, msg), /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: DERIVE_SAMPLES_ALIAS_TOPIC
  }, "More info")));
});
const AutoLinkDataToStudyHelpTip = () => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Automatically link Sample Type data rows to the specified target study. Only rows that include subject and visit/date information will be linked."), /*#__PURE__*/external_react_default().createElement("p", null, "The user performing the import must have insert permission in the target study and the corresponding dataset."));
const LinkedDatasetCategoryHelpTip = () => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Specify the desired category for the Sample Type Dataset that will be created (or appended to) in the target study when rows are linked. If the category you specify does not exist, it will be created."), /*#__PURE__*/external_react_default().createElement("p", null, "If the Sample Type Dataset already exists, this setting will not overwrite a previously assigned category. Leave blank to use the default category of \"Uncategorized\"."));
const UniqueIdHelpTip = () => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Use a Unique ID field to represent barcodes or other ID fields in use in your lab."), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about using ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
  topic: UNIQUE_IDS_TOPIC
}, "barcodes and unique IDs"), " in", ' ', getCurrentProductName(), "."));

// Splitting these out to clarify where they end-up

// Splitting these out to clarify where they end-up

class SampleTypePropertiesPanelImpl extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    SampleTypePropertiesPanel_defineProperty(this, "state", {
      containers: undefined,
      isValid: true,
      loadingError: undefined,
      prefix: undefined,
      sampleTypeCategory: undefined
    });
    SampleTypePropertiesPanel_defineProperty(this, "componentDidMount", async () => {
      const {
        api,
        model
      } = this.props;
      try {
        const result = await api.query.selectRows({
          columns: ['Category'],
          containerFilter: api_.Query.ContainerFilter.currentPlusProjectAndShared,
          filterArray: [api_.Filter.create('RowId', model.rowId)],
          schemaQuery: SCHEMAS.EXP_TABLES.SAMPLE_SETS
        });
        this.setState({
          sampleTypeCategory: result.rows[0]?.Category.value
        });
      } catch (e) {
        this.setState({
          loadingError: 'There was a problem retrieving the Sample Type category.'
        });
      }
      try {
        const containers = await api.domain.getValidPublishTargets(model.containerPath);
        this.setState({
          containers: (0,external_immutable_.List)(containers)
        });
      } catch (e) {
        this.setState({
          containers: (0,external_immutable_.List)()
        });
      }
      if (isSampleManagerEnabled()) {
        try {
          const response = await api.entity.loadNameExpressionOptions(model.containerPath);
          this.setState({
            prefix: response.prefix ?? null
          });
        } catch (error) {
          this.setState({
            loadingError: 'There was a problem retrieving the Naming Pattern prefix.'
          });
        }
      }
    });
    SampleTypePropertiesPanel_defineProperty(this, "updateValidStatus", newModel => {
      const {
        model,
        updateModel,
        metricUnitProps
      } = this.props;
      const updatedModel = newModel || model;
      const isValid = updatedModel?.hasValidProperties() && updatedModel?.isMetricUnitValid(metricUnitProps?.metricUnitRequired);
      this.setState(() => ({
        isValid
      }), () => {
        // Issue 39918: only consider the model changed if there is a newModel param
        if (newModel) {
          updateModel(updatedModel);
        }
      });
    });
    SampleTypePropertiesPanel_defineProperty(this, "onFormChange", evt => {
      const id = evt.target.id;
      const value = evt.target.value;
      this.onFieldChange(getFormNameFromId(id), value?.trimStart());
    });
    SampleTypePropertiesPanel_defineProperty(this, "onFieldChange", (key, value) => {
      this.updateValidStatus(this.props.model.set(key, value));
    });
    SampleTypePropertiesPanel_defineProperty(this, "onNameFieldHover", () => {
      this.props.onNameFieldHover?.();
    });
  }
  containsDataClassOptions() {
    return this.props.parentOptions?.filter(dataClassOptionFilterFn).length > 0;
  }
  render() {
    const {
      model,
      onAddUniqueIdField,
      parentOptions,
      nameExpressionInfoUrl,
      nameExpressionPlaceholder,
      aliquotNamePatternProps,
      nounSingular,
      nounPlural,
      headerText,
      helpTopic,
      includeDataClasses,
      useSeparateDataClassesAliasMenu,
      dataClassParentageLabel,
      appPropertiesOnly,
      showLinkToStudy,
      metricUnitProps,
      namePreviews,
      namePreviewsLoading,
      nameExpressionGenIdProps
    } = this.props;
    const {
      isValid,
      containers,
      prefix,
      loadingError,
      sampleTypeCategory
    } = this.state;
    const showAliquotNameExpression = aliquotNamePatternProps?.showAliquotNameExpression;
    const aliquotNameExpressionInfoUrl = aliquotNamePatternProps?.aliquotNameExpressionInfoUrl;
    const aliquotNameExpressionPlaceholder = aliquotNamePatternProps?.aliquotNameExpressionPlaceholder;
    const includeMetricUnitProperty = metricUnitProps?.includeMetricUnitProperty;
    const metricUnitLabel = metricUnitProps?.metricUnitLabel || 'Metric Unit';
    const metricUnitHelpMsg = metricUnitProps?.metricUnitHelpMsg || 'The unit of measurement used for the sample type.';
    const metricUnitRequired = !!metricUnitProps?.metricUnitRequired;
    const allowTimepointProperties = model.domain.get('allowTimepointProperties');

    // Issue 48776: Suppress import parent aliasing for media Mixture Batches
    const showAddParentAlias = !!parentOptions && (model.name !== SCHEMAS.SAMPLE_SETS.MIXTURE_BATCHES.queryName || sampleTypeCategory !== 'media');
    const showDataClass = includeDataClasses && useSeparateDataClassesAliasMenu && this.containsDataClassOptions();
    let warning;
    if (prefix && !model.isNew() && model.nameExpression && !model.nameExpression.includes(PREFIX_SUBSTITUTION_EXPRESSION)) {
      warning = `${PROPERTIES_PANEL_NAMING_PATTERN_WARNING_MSG}: "${prefix}".`;
    } else if (prefix && showAliquotNameExpression && model.aliquotNameExpression && !model.aliquotNameExpression.includes(PREFIX_SUBSTITUTION_EXPRESSION)) {
      warning = `Aliquot ${PROPERTIES_PANEL_NAMING_PATTERN_WARNING_MSG}: "${prefix}".`;
    } else if (loadingError !== undefined) {
      warning = loadingError;
    }
    return /*#__PURE__*/external_react_default().createElement(BasePropertiesPanel, SampleTypePropertiesPanel_extends({}, this.props, {
      headerId: SampleTypePropertiesPanel_PROPERTIES_HEADER_ID,
      title: "Sample Type Properties",
      updateValidStatus: this.updateValidStatus,
      isValid: isValid,
      warning: warning
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom"
    }, headerText && /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "entity-form--headerhelp"
    }, headerText)), /*#__PURE__*/external_react_default().createElement("div", {
      className: `col-xs-${headerText ? 3 : 12}`
    }, /*#__PURE__*/external_react_default().createElement(HelpTopicURL, {
      helpTopic: helpTopic,
      nounPlural: nounPlural
    }))), appPropertiesOnly && /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      title: "General Properties"
    }), /*#__PURE__*/external_react_default().createElement(EntityDetailsForm, {
      noun: nounSingular,
      onFormChange: this.onFormChange,
      data: model,
      nameReadOnly: model.nameReadOnly,
      nameExpressionInfoUrl: nameExpressionInfoUrl,
      nameExpressionPlaceholder: nameExpressionPlaceholder,
      warning: warning,
      showPreviewName: !!model.nameExpression,
      onNameFieldHover: this.onNameFieldHover,
      namePreviewsLoading: namePreviewsLoading,
      previewName: namePreviews?.[0],
      nameExpressionGenIdProps: nameExpressionGenIdProps
    }), showAliquotNameExpression && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      onMouseEnter: this.onNameFieldHover
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Aliquot Naming Pattern",
      helpTipBody: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Pattern used for generating unique Ids for Aliquots."), /*#__PURE__*/external_react_default().createElement("p", null, "By default, the name of the aliquot will use the name of its parent followed by a dash and a counter for that parent\u2019s aliquots."), /*#__PURE__*/external_react_default().createElement("p", null, "For example, if the original sample is S1, aliquots of that sample will be named S1-1, S1-2, etc."), model.aliquotNameExpression && /*#__PURE__*/external_react_default().createElement(NameExpressionPreview, {
        previewName: namePreviews?.[1],
        isPreviewLoading: namePreviewsLoading
      }), /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("a", {
        target: "_blank",
        href: aliquotNameExpressionInfoUrl ?? ALIQUOT_HELP_LINK,
        rel: "noopener noreferrer"
      }, "More info")))
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-10"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: external_classnames_default()('form-control', {
        'naming-pattern-border-warning': warning?.startsWith('Aliquot')
      }),
      name: "aliquotNameExpression",
      type: "text",
      placeholder: aliquotNameExpressionPlaceholder ?? ALIQUOT_NAME_PLACEHOLDER,
      onChange: e => {
        this.onFieldChange(e.target.name, e.target.value);
      },
      value: model.aliquotNameExpression
    }))), /*#__PURE__*/external_react_default().createElement(DomainParentAliases, SampleTypePropertiesPanel_extends({}, this.props, {
      parentAliases: model.parentAliases,
      idPrefix: "sampletype-parent-import-alias-",
      schema: SCHEMAS.SAMPLE_SETS.SCHEMA,
      addEntityHelp: /*#__PURE__*/external_react_default().createElement(AddEntityHelpTip, null),
      includeSampleSet: true,
      includeDataClass: includeDataClasses && !useSeparateDataClassesAliasMenu,
      showAddBtn: showAddParentAlias
    })), showDataClass && /*#__PURE__*/external_react_default().createElement(DomainParentAliases, SampleTypePropertiesPanel_extends({}, this.props, {
      parentAliases: model.parentAliases,
      idPrefix: "sampletype-parent-import-alias-",
      schema: SCHEMAS.DATA_CLASSES.SCHEMA,
      addEntityHelp: /*#__PURE__*/external_react_default().createElement(AddEntityHelpTip, {
        parentageLabel: dataClassParentageLabel
      }),
      includeSampleSet: false,
      includeDataClass: true,
      showAddBtn: true
    })), allowTimepointProperties && showLinkToStudy && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Auto-Link Data to Study",
      helpTipBody: /*#__PURE__*/external_react_default().createElement(AutoLinkDataToStudyHelpTip, null)
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/external_react_default().createElement(AutoLinkToStudyDropdown, {
      containers: containers,
      onChange: this.onFormChange,
      autoLinkTarget: constants_ENTITY_FORM_IDS.AUTO_LINK_TARGET,
      value: model.autoLinkTargetContainerId
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Linked Dataset Category",
      helpTipBody: /*#__PURE__*/external_react_default().createElement(LinkedDatasetCategoryHelpTip, null)
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      type: "text",
      id: constants_ENTITY_FORM_IDS.AUTO_LINK_CATEGORY,
      onChange: this.onFormChange,
      value: model.autoLinkCategory || ''
    })))), (appPropertiesOnly || !isCommunityDistribution()) && /*#__PURE__*/external_react_default().createElement(SectionHeading, {
      cls: "top-spacing",
      title: "Storage Settings"
    }), appPropertiesOnly && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Label Color",
      helpTipBody: "The label color will be used to distinguish this sample type in various views in the application."
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-10"
    }, /*#__PURE__*/external_react_default().createElement(ColorPickerInput, {
      name: "labelColor",
      value: model.labelColor,
      onChange: this.onFieldChange,
      allowRemove: true
    }))), includeMetricUnitProperty && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: metricUnitLabel,
      required: metricUnitRequired,
      helpTipBody: metricUnitHelpMsg
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, metricUnitProps?.metricUnitOptions ? /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
      containerClass: "sampleset-metric-unit-select-container",
      inputClass: "sampleset-metric-unit-select",
      name: "metricUnit",
      options: metricUnitProps.metricUnitOptions,
      required: metricUnitRequired,
      clearable: !metricUnitRequired,
      onChange: (name, formValue, option) => {
        this.onFieldChange(name, formValue === undefined && option ? option.id : formValue);
      },
      placeholder: "Select a unit...",
      value: model.metricUnit
    }) : /*#__PURE__*/external_react_default().createElement("input", {
      className: "form-control",
      name: "metricUnit",
      type: "text",
      placeholder: "Enter a unit",
      required: metricUnitRequired,
      value: model.metricUnit,
      onChange: e => {
        this.onFieldChange(e.target.name, e.target.value);
      }
    })))), !isCommunityDistribution() && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-top"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Barcodes",
      helpTipBody: /*#__PURE__*/external_react_default().createElement(UniqueIdHelpTip, null)
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-10"
    }, /*#__PURE__*/external_react_default().createElement(UniqueIdBanner, {
      model: model,
      isFieldsPanel: false,
      onAddField: onAddUniqueIdField
    }))));
  }
}
SampleTypePropertiesPanel_defineProperty(SampleTypePropertiesPanelImpl, "defaultProps", {
  api: getDefaultAPIWrapper(),
  nounSingular: SAMPLE_SET_DISPLAY_TEXT,
  nounPlural: SAMPLE_SET_DISPLAY_TEXT + 's',
  nameExpressionInfoUrl: getHelpLink('sampleIDs'),
  // eslint-disable-next-line no-template-curly-in-string
  nameExpressionPlaceholder: 'Enter a naming pattern (e.g., S-${now:date}-${dailySampleCount})',
  appPropertiesOnly: false,
  showLinkToStudy: true,
  helpTopic: DEFINE_SAMPLE_TYPE_TOPIC,
  sampleAliasCaption: 'Sample Alias',
  sampleTypeCaption: 'Sample Type',
  dataClassAliasCaption: 'Data Class Alias',
  dataClassTypeCaption: 'Data Class',
  dataClassParentageLabel: 'data class',
  metricUnitProps: {
    metricUnitLabel: 'Metric Unit',
    metricUnitHelpMsg: 'The unit of measurement used for the sample type.'
  },
  parentAliasHelpText: PARENT_ALIAS_HELPER_TEXT
});
const SampleTypePropertiesPanel = withDomainPropertiesPanelCollapse(SampleTypePropertiesPanelImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/samples/SampleTypeDesigner.tsx
function SampleTypeDesigner_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SampleTypeDesigner_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SampleTypeDesigner_ownKeys(Object(t), !0).forEach(function (r) { SampleTypeDesigner_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SampleTypeDesigner_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SampleTypeDesigner_defineProperty(e, r, t) { return (r = SampleTypeDesigner_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SampleTypeDesigner_toPropertyKey(t) { var i = SampleTypeDesigner_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SampleTypeDesigner_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




























const NEW_SAMPLE_SET_OPTION = {
  label: `(Current ${SAMPLE_SET_DISPLAY_TEXT})`,
  value: '{{this_sample_set}}',
  schema: SCHEMAS.SAMPLE_SETS.SCHEMA
};
const SampleTypeDesigner_PROPERTIES_PANEL_INDEX = 0;
const SampleTypeDesigner_DOMAIN_PANEL_INDEX = 1;
const PROJECTS_PANEL_INDEX = 2;
const SAMPLE_TYPE_NAME_EXPRESSION_PLACEHOLDER = 'Enter a naming pattern (e.g., S-${now:date}-${dailySampleCount})';
const SAMPLE_TYPE_HELP_TOPIC = 'createSampleType';
const AliquotOptionsHelp = (0,external_react_.memo)(({
  helpTopic
}) => {
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("b", null, "Editable for samples only:"), " Field is editable for samples but not for aliquots. An aliquot will inherit the field value from its parent sample."), /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("b", null, "Editable for aliquots only:"), " Field is viewable and editable for aliquots but not for samples."), /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("b", null, "Separately editable for samples and aliquots:"), " Field is editable for samples and aliquots independently."), /*#__PURE__*/external_react_default().createElement("br", null), /*#__PURE__*/external_react_default().createElement("p", null, "Learn more about ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: helpTopic
  }, "Sample Aliquots"), "."));
});
// Exported for testing
class SampleTypeDesignerImpl extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    SampleTypeDesigner_defineProperty(this, "componentDidMount", async () => {
      const {
        api,
        includeDataClasses,
        setSubmitting,
        isValidParentOptionFn
      } = this.props;
      const {
        model
      } = this.state;
      try {
        const {
          parentOptions,
          parentAliases
        } = await api.entity.initParentOptionsSelects(true, includeDataClasses, model.containerPath, isValidParentOptionFn, model.isNew() ? NEW_SAMPLE_SET_OPTION : null, model.importAliases, 'sampleset-parent-import-alias-', this.formatLabel);
        this.setState({
          model: model.merge({
            parentAliases
          }),
          parentOptions
        });
      } catch (error) {
        setSubmitting(false, () => {
          this.setState({
            error: resolveErrorMessage(error)
          });
        });
      }
    });
    SampleTypeDesigner_defineProperty(this, "formatLabel", (name, prefix, isDataClass, containerPath) => {
      const {
        includeDataClasses,
        useSeparateDataClassesAliasMenu,
        showParentLabelPrefix
      } = this.props;
      const {
        model
      } = this.state;
      if (name === model?.name && !isDataClass) return NEW_SAMPLE_SET_OPTION.label;
      return includeDataClasses && !useSeparateDataClassesAliasMenu && showParentLabelPrefix ? `${prefix}: ${name} (${containerPath})` : name;
    });
    SampleTypeDesigner_defineProperty(this, "onFieldChange", model => {
      this.setState({
        model,
        uniqueIdsConfirmed: undefined
      }, () => {
        this.props.onChange?.(model);
      });
    });
    SampleTypeDesigner_defineProperty(this, "propertiesToggle", (collapsed, callback) => {
      this.props.onTogglePanel(SampleTypeDesigner_PROPERTIES_PANEL_INDEX, collapsed, callback);
    });
    SampleTypeDesigner_defineProperty(this, "formToggle", (collapsed, callback) => {
      this.props.onTogglePanel(SampleTypeDesigner_DOMAIN_PANEL_INDEX, collapsed, callback);
    });
    SampleTypeDesigner_defineProperty(this, "projectsToggle", (collapsed, callback) => {
      this.props.onTogglePanel(PROJECTS_PANEL_INDEX, collapsed, callback);
    });
    SampleTypeDesigner_defineProperty(this, "parentAliasChange", (id, field, newValue) => {
      const {
        model
      } = this.state;
      const newAliases = getParentAliasChangeResult(model.parentAliases, id, field, newValue);
      const newModel = model.merge({
        parentAliases: newAliases
      });
      this.onFieldChange(newModel);
    });
    SampleTypeDesigner_defineProperty(this, "updateDupes", id => {
      const {
        model
      } = this.state;
      if (!model) {
        return;
      }
      const newAliases = getParentAliasUpdateDupesResults(model.parentAliases, id);
      const newModel = model.merge({
        parentAliases: newAliases
      });
      this.onFieldChange(newModel);
    });
    SampleTypeDesigner_defineProperty(this, "addParentAlias", (id, newAlias) => {
      const {
        model
      } = this.state;
      const {
        parentAliases
      } = model;
      const newModel = model.merge({
        parentAliases: parentAliases.set(id, newAlias)
      });
      this.onFieldChange(newModel);
    });
    SampleTypeDesigner_defineProperty(this, "removeParentAlias", id => {
      const {
        model
      } = this.state;
      const {
        parentAliases
      } = model;
      const aliases = parentAliases.delete(id);
      const newModel = model.set('parentAliases', aliases);
      this.onFieldChange(newModel);
    });
    SampleTypeDesigner_defineProperty(this, "onUpdateExcludedProjects", (dataType, excludedContainerIds) => {
      const {
        model
      } = this.state;
      if (dataType === 'SampleType') {
        const newModel = model.set('excludedContainerIds', excludedContainerIds);
        this.onFieldChange(newModel);
      } else if (dataType === 'DashboardSampleType') {
        const newModel = model.set('excludedDashboardContainerIds', excludedContainerIds);
        this.onFieldChange(newModel);
      }
    });
    SampleTypeDesigner_defineProperty(this, "domainChangeHandler", (domain, dirty) => {
      this.setState(state => ({
        model: state.model.merge({
          domain
        })
      }), () => {
        // Issue 39918: use the dirty property that DomainForm onChange passes
        if (dirty) {
          this.props.onChange?.(this.state.model);
        }
      });
    });
    SampleTypeDesigner_defineProperty(this, "onUniqueIdCancel", () => {
      this.setState({
        showUniqueIdConfirmation: false,
        uniqueIdsConfirmed: false
      });
    });
    SampleTypeDesigner_defineProperty(this, "onUniqueIdConfirm", () => {
      this.setState({
        uniqueIdsConfirmed: true
      }, this.onFinish);
    });
    SampleTypeDesigner_defineProperty(this, "onNameExpressionWarningCancel", () => {
      const {
        setSubmitting
      } = this.props;
      setSubmitting(false, () => {
        this.setState({
          nameExpressionWarnings: undefined
        });
      });
    });
    SampleTypeDesigner_defineProperty(this, "onNameExpressionWarningConfirm", () => {
      this.setState({
        nameExpressionWarnings: undefined
      }, () => {
        this.saveDomain(true);
      });
    });
    SampleTypeDesigner_defineProperty(this, "onFinish", () => {
      const {
        defaultSampleFieldConfig,
        setSubmitting,
        metricUnitProps
      } = this.props;
      const {
        model,
        uniqueIdsConfirmed
      } = this.state;
      if (!model.isNew() && this.getNumNewUniqueIdFields() > 0 && !uniqueIdsConfirmed) {
        this.setState({
          showUniqueIdConfirmation: true
        });
        return;
      }
      const metricUnitRequired = metricUnitProps?.metricUnitRequired;
      const isValid = model.isValid(defaultSampleFieldConfig, metricUnitRequired);
      this.props.onFinish(isValid, this.saveDomain);
      if (isValid) return;
      let exception;
      if (model.hasInvalidNameField(defaultSampleFieldConfig)) {
        exception = 'The ' + defaultSampleFieldConfig.name + ' field name is reserved for imported or generated sample ids.';
      } else if (getDuplicateAlias(model.parentAliases, true).size > 0) {
        exception = 'Duplicate parent alias header found: ' + getDuplicateAlias(model.parentAliases, true).join(', ');
      } else if (!model.isMetricUnitValid(metricUnitRequired)) {
        exception = metricUnitProps?.metricUnitLabel + ' field is required.';
      } else {
        exception = model.domain.getFirstFieldError();
      }
      const updatedModel = model.set('exception', exception);
      setSubmitting(false, () => {
        this.setState({
          model: updatedModel
        }, () => {
          scrollDomainErrorIntoView();
        });
      });
    });
    SampleTypeDesigner_defineProperty(this, "saveDomain", async hasConfirmedNameExpression => {
      const {
        api,
        beforeFinish,
        setSubmitting
      } = this.props;
      const {
        model
      } = this.state;
      const {
        name,
        domain,
        description
      } = model;
      if (!hasConfirmedNameExpression) {
        beforeFinish?.(model);
      }
      let domainDesign = domain.merge({
        name,
        // This will be the Sample Type Name
        description
      });
      const details = this.getDomainDetails();
      if (model.isNew()) {
        // Initialize a sampleId column, this is not displayed as part of the designer.
        domainDesign = addDomainField(domainDesign, {
          name: 'Name'
        });
      }
      try {
        if (!hasConfirmedNameExpression && this.props.validateProperties) {
          const response = await this.props.validateProperties(details);
          if (response.error) {
            const updatedModel = model.set('exception', response.error);
            setSubmitting(false, () => {
              this.setState(() => ({
                model: updatedModel,
                showUniqueIdConfirmation: false
              }), () => {
                scrollDomainErrorIntoView();
              });
            });
            return;
          }
        }
      } catch (error) {
        const exception = resolveErrorMessage(error);
        setSubmitting(false, () => {
          this.setState(() => ({
            model: model.set('exception', exception),
            showUniqueIdConfirmation: false
          }), () => {
            scrollDomainErrorIntoView();
          });
        });
        return;
      }
      try {
        if (this.props.validateNameExpressions && !hasConfirmedNameExpression) {
          const response = await api.domain.validateDomainNameExpressions(domainDesign, api_.Domain.KINDS.SAMPLE_TYPE, details, true);
          if (response.errors?.length > 0 || response.warnings?.length > 0) {
            const updatedModel = model.set('exception', response.errors?.join('\n'));
            setSubmitting(false, () => {
              this.setState(() => ({
                model: updatedModel,
                nameExpressionWarnings: response.warnings,
                namePreviews: response.previews,
                showUniqueIdConfirmation: false
              }), () => {
                scrollDomainErrorIntoView();
              });
            });
            return;
          }
        }
      } catch (error) {
        console.error(error);
        const exception = resolveErrorMessage(error);
        setSubmitting(false, () => {
          this.setState(() => ({
            model: model.set('exception', exception),
            showUniqueIdConfirmation: false
          }), () => {
            scrollDomainErrorIntoView();
          });
        });
        return;
      }
      try {
        const response = await api.domain.saveDomain({
          containerPath: model.isNew() ? getAppHomeFolderPath(new Container((0,api_.getServerContext)().container)) : model.containerPath,
          domain: domainDesign,
          kind: api_.Domain.KINDS.SAMPLE_TYPE,
          name,
          options: details
        });
        setSubmitting(false, () => {
          this.props.onComplete(response);
        });
      } catch (response) {
        const exception = resolveErrorMessage(response);
        const updatedModel = exception ? model.set('exception', exception) : model.merge({
          // since the isNew case adds in the Name column, we need to go back to the state model's domain to merge in the error info
          domain: domain.merge({
            domainException: response.domainException
          }),
          exception: undefined
        });
        setSubmitting(false, () => {
          this.setState({
            model: updatedModel,
            showUniqueIdConfirmation: false
          }, () => {
            scrollDomainErrorIntoView();
          });
        });
      }
    });
    SampleTypeDesigner_defineProperty(this, "onAddUniqueIdField", fieldConfig => {
      this.setState(state => ({
        model: state.model.set('domain', addDomainField(state.model.domain, fieldConfig))
      }));
    });
    SampleTypeDesigner_defineProperty(this, "uniqueIdBannerRenderer", config => {
      const {
        model
      } = this.state;
      if (isCommunityDistribution() || !model.isNew() || model.domain?.fields?.isEmpty()) {
        return null;
      }
      return /*#__PURE__*/external_react_default().createElement(UniqueIdBanner, {
        model: this.state.model,
        isFieldsPanel: true,
        onAddField: config.onAddField
      });
    });
    SampleTypeDesigner_defineProperty(this, "getDomainDetails", () => {
      const {
        model
      } = this.state;
      const {
        name,
        nameExpression,
        aliquotNameExpression,
        labelColor,
        metricUnit,
        autoLinkTargetContainerId,
        autoLinkCategory,
        excludedContainerIds,
        excludedDashboardContainerIds
      } = model;
      return {
        name,
        nameExpression,
        aliquotNameExpression,
        labelColor,
        metricUnit,
        autoLinkTargetContainerId,
        autoLinkCategory,
        importAliases: this.getImportAliasesAsMap(model).toJS(),
        excludedContainerIds,
        excludedDashboardContainerIds
      };
    });
    SampleTypeDesigner_defineProperty(this, "onNameFieldHover", async () => {
      const {
        api
      } = this.props;
      const {
        model,
        namePreviewsLoading
      } = this.state;
      if (namePreviewsLoading) return;
      const {
        name,
        domain,
        description
      } = model;
      const domainDesign = domain.merge({
        name,
        description
      });
      try {
        if (this.props.validateNameExpressions) {
          const response = await api.domain.validateDomainNameExpressions(domainDesign, api_.Domain.KINDS.SAMPLE_TYPE, this.getDomainDetails(), true);
          this.setState({
            namePreviews: response?.previews,
            namePreviewsLoading: false
          });
        }
      } catch (error) {
        this.setState({
          namePreviewsLoading: false
        });
      }
    });
    initQueryGridState();
    let domainDetails = this.props.initModel || DomainDetails.create();
    if (props.defaultSampleFieldConfig) {
      const domainDesign = domainDetails.domainDesign.merge({
        reservedFieldNames: (0,external_immutable_.List)([props.defaultSampleFieldConfig?.name.toLowerCase()])
      });
      domainDetails = domainDetails.set('domainDesign', domainDesign);
    }
    this.state = {
      model: SampleTypeModel.create(domainDetails, domainDetails.domainDesign?.name),
      parentOptions: undefined,
      error: undefined,
      showUniqueIdConfirmation: false,
      uniqueIdsConfirmed: undefined,
      nameExpressionWarnings: undefined,
      namePreviewsLoading: false,
      namePreviews: undefined
    };
  }
  getImportAliasesAsMap(model) {
    const {
      name,
      parentAliases
    } = model;
    const aliases = {};
    parentAliases?.forEach(alias => {
      const {
        parentValue
      } = alias;
      let value = parentValue && parentValue.value ? parentValue.value : '';
      if (parentValue === NEW_SAMPLE_SET_OPTION) {
        value = SAMPLE_SET_IMPORT_PREFIX + name;
      }
      aliases[alias.alias] = value;
    });
    return (0,external_immutable_.Map)(aliases);
  }
  getNumNewUniqueIdFields() {
    const {
      model
    } = this.state;
    return model.domain.fields.filter(field => field.isNew() && field.isUniqueIdField()).count();
  }
  render() {
    const {
      allowProjectExclusion,
      api,
      appPropertiesOnly,
      currentPanelIndex,
      visitedPanels,
      firstState,
      validatePanel,
      submitting,
      onCancel,
      nameExpressionPlaceholder,
      nameExpressionInfoUrl,
      nounSingular,
      nounPlural,
      headerText,
      saveBtnText,
      helpTopic,
      includeDataClasses,
      useSeparateDataClassesAliasMenu,
      sampleAliasCaption,
      sampleTypeCaption,
      dataClassAliasCaption,
      dataClassTypeCaption,
      dataClassParentageLabel,
      metricUnitProps,
      domainFormDisplayOptions,
      showLinkToStudy,
      aliquotNamePatternProps,
      initModel,
      showAliquotOptions,
      showGenIdBanner
    } = this.props;
    const {
      error,
      model,
      parentOptions,
      showUniqueIdConfirmation,
      nameExpressionWarnings,
      namePreviews,
      namePreviewsLoading
    } = this.state;
    const numNewUniqueIdFields = this.getNumNewUniqueIdFields();
    // For non-premium LKSM the showLinkToStudy will be true, but the study module will not be present.
    // We also don't want to always show the link to study even if the study module is available (the LKB case).
    const _showLinkToStudy = showLinkToStudy && hasModule('study');
    const confirmModalMessage = 'You have added ' + numNewUniqueIdFields + ' ' + UNIQUE_ID_TYPE.display + ' field' + (numNewUniqueIdFields !== 1 ? 's' : '') + ' to this ' + SampleTypeDataType.typeNounSingular + '. ' + 'Values for ' + (numNewUniqueIdFields !== 1 ? 'these fields' : 'this field') + ' will be created for all existing samples.';
    const options = initModel?.get('options');
    const hasGenIdInExpression = model.nameExpression?.indexOf(GENID_SYNTAX_STRING) > -1 || model.aliquotNameExpression?.indexOf(GENID_SYNTAX_STRING) > -1;
    return /*#__PURE__*/external_react_default().createElement(BaseDomainDesigner, {
      name: model.name,
      exception: model.exception,
      domains: external_immutable_.List.of(model.domain),
      hasValidProperties: model.hasValidProperties(),
      visitedPanels: visitedPanels,
      submitting: submitting,
      onCancel: onCancel,
      onFinish: this.onFinish,
      saveBtnText: saveBtnText
    }, /*#__PURE__*/external_react_default().createElement(SampleTypePropertiesPanel, {
      api: api,
      nounSingular: nounSingular,
      nounPlural: nounPlural,
      nameExpressionInfoUrl: nameExpressionInfoUrl,
      nameExpressionPlaceholder: nameExpressionPlaceholder,
      headerText: headerText,
      helpTopic: helpTopic,
      model: model,
      parentOptions: parentOptions,
      includeDataClasses: includeDataClasses,
      useSeparateDataClassesAliasMenu: useSeparateDataClassesAliasMenu,
      sampleAliasCaption: sampleAliasCaption,
      sampleTypeCaption: sampleTypeCaption,
      dataClassAliasCaption: dataClassAliasCaption,
      dataClassTypeCaption: dataClassTypeCaption,
      dataClassParentageLabel: dataClassParentageLabel,
      onParentAliasChange: this.parentAliasChange,
      onAddParentAlias: this.addParentAlias,
      onRemoveParentAlias: this.removeParentAlias,
      updateDupeParentAliases: this.updateDupes,
      updateModel: this.onFieldChange,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== SampleTypeDesigner_PROPERTIES_PANEL_INDEX,
      panelStatus: model.isNew() ? getDomainPanelStatus(SampleTypeDesigner_PROPERTIES_PANEL_INDEX, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      validate: validatePanel === SampleTypeDesigner_PROPERTIES_PANEL_INDEX,
      onToggle: this.propertiesToggle,
      appPropertiesOnly: appPropertiesOnly,
      showLinkToStudy: _showLinkToStudy,
      metricUnitProps: metricUnitProps,
      onAddUniqueIdField: this.onAddUniqueIdField,
      aliquotNamePatternProps: aliquotNamePatternProps,
      namePreviewsLoading: namePreviewsLoading,
      namePreviews: namePreviews,
      onNameFieldHover: this.onNameFieldHover,
      nameExpressionGenIdProps: showGenIdBanner && options && hasGenIdInExpression ? {
        containerPath: model.containerPath,
        dataTypeName: options.get('name'),
        dataTypeLSID: options.get('lsid'),
        rowId: options.get('rowId'),
        kindName: 'SampleSet',
        api
      } : undefined
    }), /*#__PURE__*/external_react_default().createElement(domainproperties_DomainForm, {
      api: api.domain,
      key: model.domain.domainId || 0,
      appDomainHeaderRenderer: this.uniqueIdBannerRenderer,
      domainIndex: 0,
      domain: model.domain,
      headerTitle: "Fields",
      helpTopic: null // null so that we don't show the "learn more about this tool" link for this domains
      ,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== SampleTypeDesigner_DOMAIN_PANEL_INDEX,
      validate: validatePanel === SampleTypeDesigner_DOMAIN_PANEL_INDEX,
      panelStatus: model.isNew() ? getDomainPanelStatus(1, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      onChange: this.domainChangeHandler,
      onToggle: this.formToggle,
      appPropertiesOnly: appPropertiesOnly,
      domainFormDisplayOptions: SampleTypeDesigner_objectSpread(SampleTypeDesigner_objectSpread({}, domainFormDisplayOptions), {}, {
        hideStudyPropertyTypes: !_showLinkToStudy,
        showScannableOption: true,
        textChoiceLockedSqlFragment: "MAX(CASE WHEN SampleState.StatusType = 'Locked' THEN 1 ELSE 0 END)",
        derivationDataScopeConfig: {
          show: showAliquotOptions,
          dataTypeFilter: dataType => !dataType.isUniqueId(),
          sectionTitle: 'Sample/Aliquot Options',
          labelAll: 'Separately editable for samples and aliquots',
          labelChild: 'Editable for aliquots only',
          labelParent: 'Editable for samples only (default)',
          helpLinkNode: /*#__PURE__*/external_react_default().createElement(AliquotOptionsHelp, {
            helpTopic: biologicsIsPrimaryApp() ? LKS_SAMPLE_ALIQUOT_FIELDS_TOPIC : SAMPLE_ALIQUOT_FIELDS_TOPIC
          }),
          scopeChangeWarning: "Updating a 'Samples Only' field to be 'Samples and Aliquots' will blank out the field values for all aliquots. This action cannot be undone. "
        }
      }),
      newFieldConfig: {
        derivationDataScope: DERIVATION_DATA_SCOPES.PARENT_ONLY
      },
      systemFields: options?.get('systemFields')
    }), appPropertiesOnly && allowProjectExclusion &&
    /*#__PURE__*/
    // appPropertiesOnly check will prevent this panel from showing in LKS and in LKB media types
    external_react_default().createElement(DataTypeProjectsPanel, {
      controlledCollapse: true,
      dataTypeRowId: model?.rowId,
      dataTypeName: model?.name,
      entityDataType: SampleTypeDataType,
      relatedProjectConfigurableDataType: "DashboardSampleType",
      relatedDataTypeLabel: "Include in Dashboard Insights graphs",
      initCollapsed: currentPanelIndex !== PROJECTS_PANEL_INDEX,
      onToggle: this.projectsToggle,
      onUpdateExcludedProjects: this.onUpdateExcludedProjects
    }), error && /*#__PURE__*/external_react_default().createElement("div", {
      className: "domain-form-panel"
    }, error && /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "danger"
    }, error)), showUniqueIdConfirmation && /*#__PURE__*/external_react_default().createElement(Modal, {
      title: 'Updating ' + SampleTypeDataType.typeNounSingular + ' with Unique ID field' + (numNewUniqueIdFields !== 1 ? 's' : ''),
      onCancel: this.onUniqueIdCancel,
      onConfirm: this.onUniqueIdConfirm,
      confirmText: submitting ? 'Finishing ...' : 'Finish Updating ' + SampleTypeDataType.typeNounSingular,
      isConfirming: submitting
    }, confirmModalMessage), /*#__PURE__*/external_react_default().createElement(NameExpressionValidationModal, {
      onHide: this.onNameExpressionWarningCancel,
      onConfirm: this.onNameExpressionWarningConfirm,
      warnings: nameExpressionWarnings,
      previews: namePreviews,
      show: !!nameExpressionWarnings && !model.exception
    }));
  }
}
SampleTypeDesigner_defineProperty(SampleTypeDesignerImpl, "defaultProps", {
  api: getDefaultAPIWrapper(),
  defaultSampleFieldConfig: DEFAULT_SAMPLE_FIELD_CONFIG,
  includeDataClasses: false,
  useSeparateDataClassesAliasMenu: false,
  nameExpressionInfoUrl: getHelpLink(SAMPLE_TYPE_NAME_EXPRESSION_TOPIC),
  nameExpressionPlaceholder: SAMPLE_TYPE_NAME_EXPRESSION_PLACEHOLDER,
  helpTopic: SAMPLE_TYPE_HELP_TOPIC,
  showParentLabelPrefix: true,
  showLinkToStudy: false,
  domainFormDisplayOptions: SampleTypeDesigner_objectSpread(SampleTypeDesigner_objectSpread({}, DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS), {}, {
    domainKindDisplayName: SampleTypeDataType.typeNounSingular.toLowerCase()
  }),
  validateNameExpressions: true
});
const SampleTypeDesigner = withBaseDomainDesigner(SampleTypeDesignerImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/list/ListPropertiesAdvancedSettings.tsx
const ListPropertiesAdvancedSettings_excluded = ["modalOpen"];
function ListPropertiesAdvancedSettings_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ListPropertiesAdvancedSettings_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ListPropertiesAdvancedSettings_ownKeys(Object(t), !0).forEach(function (r) { ListPropertiesAdvancedSettings_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ListPropertiesAdvancedSettings_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ListPropertiesAdvancedSettings_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = ListPropertiesAdvancedSettings_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function ListPropertiesAdvancedSettings_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ListPropertiesAdvancedSettings_defineProperty(e, r, t) { return (r = ListPropertiesAdvancedSettings_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ListPropertiesAdvancedSettings_toPropertyKey(t) { var i = ListPropertiesAdvancedSettings_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ListPropertiesAdvancedSettings_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ListPropertiesAdvancedSettings_extends() { return ListPropertiesAdvancedSettings_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ListPropertiesAdvancedSettings_extends.apply(null, arguments); }









const DATA_INDEXING_TIP = 'Not recommend for large lists with frequent updates, since updating any item will cause re-indexing of the entire list.';
const DOCUMENT_TITLE_TIP = 'Any text you want displayed and indexed as the search result title. There are no substitution parameters available for this title. Leave the document title blank to use the default title.';
const CUSTOM_TEMPLATE_TIP = 'Example: ${Key} ${value}';
const DISPLAY_TITLE_TIP = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "Choose a field to identify this list when other lists or datasets have lookups into this list. When \u201CAuto\u201D is enabled, LabKey will select the title field for you by using:", /*#__PURE__*/external_react_default().createElement("ul", null, /*#__PURE__*/external_react_default().createElement("li", null, "The first non-lookup string column"), /*#__PURE__*/external_react_default().createElement("li", null, "The primary key, if there are no string fields")));
const DISCUSSION_LINKS_TIP = 'Optionally allow one or more discussion links to be shown on the details view of each list item.';
const SEARCH_INDEXING_TIP = 'Controls how this list is indexed for search within LabKey Server.';
const DisplayTitle = (0,external_react_.memo)(({
  model,
  onSelectChange,
  titleColumn
}) => {
  const fields = model.domain.fields.filter(field => !field.isCalculatedField());
  const disabled = fields.size === 0;
  const placeholder = disabled ? 'No fields have been defined yet' : 'Auto';
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__advanced-settings-modal__display-title"
  }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    name: "titleColumn",
    options: fields.toArray(),
    placeholder: placeholder,
    inputClass: "" // This attr is necessary for proper styling
    ,
    valueKey: "name",
    labelKey: "name",
    disabled: disabled,
    onChange: onSelectChange,
    value: titleColumn
  }));
});
// TODO: use RadioGroupInput instead
const DISCUSSION_RADIO_NAME = 'discussionSetting';
const DiscussionInputs = (0,external_react_.memo)(({
  onRadioChange,
  discussionSetting
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "form-group"
}, /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
  name: DISCUSSION_RADIO_NAME,
  value: 0,
  checked: discussionSetting === 0,
  onChange: onRadioChange
}, "Disable discussions"), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
  name: DISCUSSION_RADIO_NAME,
  value: 1,
  checked: discussionSetting === 1,
  onChange: onRadioChange
}, "Allow one discussion per item"), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
  name: DISCUSSION_RADIO_NAME,
  value: 2,
  checked: discussionSetting === 2,
  onChange: onRadioChange
}, "Allow multiple discussions per item")));
const TitleIndexField = (0,external_react_.memo)(({
  name,
  titleTemplate,
  onInputChange
}) => /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
  label: "Document title",
  helpTipBody: DOCUMENT_TITLE_TIP
}), /*#__PURE__*/external_react_default().createElement("span", null, /*#__PURE__*/external_react_default().createElement("input", {
  className: "form-control list__advanced-settings-modal__text-field",
  id: name,
  type: "text",
  placeholder: "Use default",
  value: titleTemplate == null ? '' : titleTemplate,
  onChange: onInputChange
}))));
// Note: Currently the radio values go from high to low in order to correspond with the previous
// designer's order of radio options. Once the old designer is deprecated, we could change these to
// count from low to high.
// TODO: use RadioGroupInput instead
const MetadataIndexField = (0,external_react_.memo)(({
  indexSetting,
  name,
  onRadioChange
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "form-group"
}, /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
  name: name,
  value: 2,
  checked: indexSetting === 2,
  onChange: onRadioChange
}, "Include both metadata and data", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
  title: "Warning"
}, DATA_INDEXING_TIP)), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
  name: name,
  value: 1,
  checked: indexSetting === 1,
  onChange: onRadioChange
}, "Include data only", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
  title: "Warning"
}, DATA_INDEXING_TIP)), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
  name: name,
  value: 0,
  checked: indexSetting === 0,
  onChange: onRadioChange
}, "Include metadata only (name and description of list and fields)")));
const IndexField = (0,external_react_.memo)(props => {
  const {
    name,
    onRadioChange,
    bodySetting,
    bodyTemplate,
    onInputChange
  } = props;
  const id = name === 'entireListBodySetting' ? 'entireListBodyTemplate' : 'eachItemBodyTemplate';

  // TODO: Use RadioGroupInput instead
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
    name: name,
    value: 0,
    checked: bodySetting === 0,
    onChange: onRadioChange
  }, "Index all non-PHI text fields"), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
    name: name,
    value: 1,
    checked: bodySetting === 1,
    onChange: onRadioChange
  }, "Index all non-PHI fields (text, number, date, and boolean)"), /*#__PURE__*/external_react_default().createElement(DomainDesignerRadio, {
    name: name,
    value: 2,
    checked: bodySetting === 2,
    onChange: onRadioChange
  }, "Index using custom template", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, null, CUSTOM_TEMPLATE_TIP))), bodySetting === 2 && /*#__PURE__*/external_react_default().createElement("input", {
    id: id,
    type: "text",
    value: bodyTemplate,
    onChange: onInputChange,
    className: "form-control list__advanced-settings-modal__custom-template-text-field"
  }));
});
const SingleDocumentIndexFields = (0,external_react_.memo)(props => {
  const {
    onRadioChange,
    onInputChange,
    entireListTitleTemplate,
    entireListIndexSetting,
    entireListBodySetting,
    entireListBodyTemplate
  } = props;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__advanced-settings-modal__single-doc-fields"
  }, /*#__PURE__*/external_react_default().createElement(TitleIndexField, {
    titleTemplate: entireListTitleTemplate,
    name: "entireListTitleTemplate",
    onInputChange: onInputChange
  }), /*#__PURE__*/external_react_default().createElement(MetadataIndexField, {
    name: "entireListIndexSetting",
    onRadioChange: onRadioChange,
    indexSetting: entireListIndexSetting
  }), /*#__PURE__*/external_react_default().createElement(IndexField, {
    name: "entireListBodySetting",
    onRadioChange: onRadioChange,
    onInputChange: onInputChange,
    bodySetting: entireListBodySetting,
    bodyTemplate: entireListBodyTemplate
  }));
});
const SeparateDocumentIndexFields = (0,external_react_.memo)(props => {
  const {
    onRadioChange,
    onInputChange,
    eachItemTitleTemplate,
    eachItemBodySetting,
    eachItemBodyTemplate
  } = props;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__advanced-settings-modal__single-doc-fields"
  }, /*#__PURE__*/external_react_default().createElement(TitleIndexField, {
    titleTemplate: eachItemTitleTemplate,
    name: "eachItemTitleTemplate",
    onInputChange: onInputChange
  }), /*#__PURE__*/external_react_default().createElement(IndexField, {
    name: "eachItemBodySetting",
    onRadioChange: onRadioChange,
    onInputChange: onInputChange,
    bodySetting: eachItemBodySetting,
    bodyTemplate: eachItemBodyTemplate
  }));
});
const CollapsibleFields = (0,external_react_.memo)(props => {
  const {
    checked,
    children,
    collapseFields,
    expandFields,
    expanded,
    identifier,
    onCheckboxChange,
    title
  } = props;
  const icon = external_classnames_default()('fa', 'fa-lg', {
    'fa-angle-down': expanded,
    'fa-angle-right': !expanded
  });
  const expand = (0,external_react_.useCallback)(() => {
    // The logic in here could be moved up to the parent component.
    expandFields(expanded ? '' : identifier);
  }, [expandFields, expanded, identifier]);
  const onChange = (0,external_react_.useCallback)(event => {
    const checked_ = event.target.checked;
    onCheckboxChange(identifier, checked_);
    if (checked_ && !expanded) {
      expand();
    } else if (!checked_ && expanded) {
      collapseFields();
    }
  }, [collapseFields, expand, expanded, identifier, onCheckboxChange]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__advanced-settings-modal__collapsible-field"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: icon,
    onClick: expand
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("label", null, /*#__PURE__*/external_react_default().createElement("input", {
    checked: checked,
    onChange: onChange,
    type: "checkbox"
  }), title)), expanded && children);
});
const SearchIndexing = (0,external_react_.memo)(props => {
  const {
    onRadioChange,
    onCheckboxChange,
    onInputChange,
    entireListIndex,
    entireListIndexSettings,
    eachItemIndex,
    eachItemIndexSettings,
    fileAttachmentIndex
  } = props;
  const [expanded, setExpanded] = (0,external_react_.useState)('');
  const collapseFields = (0,external_react_.useCallback)(() => setExpanded(''), []);
  const onIndexFileAttachmentsChange = (0,external_react_.useCallback)(event => {
    onCheckboxChange('fileAttachmentIndex', event.target.checked);
  }, [onCheckboxChange]);
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(CollapsibleFields, {
    expanded: expanded === 'entireListIndex',
    title: "Index entire list as a single document",
    identifier: "entireListIndex",
    expandFields: setExpanded,
    collapseFields: collapseFields,
    checked: entireListIndex,
    onCheckboxChange: onCheckboxChange
  }, /*#__PURE__*/external_react_default().createElement(SingleDocumentIndexFields, ListPropertiesAdvancedSettings_extends({
    onRadioChange: onRadioChange,
    onInputChange: onInputChange
  }, entireListIndexSettings))), /*#__PURE__*/external_react_default().createElement(CollapsibleFields, {
    expanded: expanded === 'eachItemIndex',
    title: "Index each item as a separate document",
    identifier: "eachItemIndex",
    expandFields: setExpanded,
    collapseFields: collapseFields,
    checked: eachItemIndex,
    onCheckboxChange: onCheckboxChange
  }, /*#__PURE__*/external_react_default().createElement(SeparateDocumentIndexFields, ListPropertiesAdvancedSettings_extends({
    onRadioChange: onRadioChange,
    onInputChange: onInputChange
  }, eachItemIndexSettings))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__advanced-settings-modal__index-checkbox form-group"
  }, /*#__PURE__*/external_react_default().createElement("label", null, /*#__PURE__*/external_react_default().createElement("input", {
    checked: fileAttachmentIndex,
    onChange: onIndexFileAttachmentsChange,
    type: "checkbox"
  }), "Index file attachments")));
});
const SettingsContainer = (0,external_react_.memo)(({
  children,
  title,
  tipBody,
  tipTitle
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "list__advanced-settings-modal__section-container"
}, /*#__PURE__*/external_react_default().createElement("div", {
  className: "list__advanced-settings-modal__heading"
}, /*#__PURE__*/external_react_default().createElement("span", {
  className: "list__bold-text"
}, " ", title, " "), /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
  title: tipTitle || title
}, tipBody)), children));
class ListPropertiesAdvancedSettings_AdvancedSettings extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    ListPropertiesAdvancedSettings_defineProperty(this, "getInitialState", () => {
      const model = this.props.model;
      return {
        titleColumn: model.titleColumn,
        discussionSetting: model.discussionSetting,
        fileAttachmentIndex: model.fileAttachmentIndex,
        // entire list
        entireListIndex: model.entireListIndex,
        // document title
        entireListTitleTemplate: model.entireListTitleTemplate,
        // metadata/data
        entireListIndexSetting: model.entireListIndexSetting,
        // index
        entireListBodySetting: model.entireListBodySetting,
        entireListBodyTemplate: model.entireListBodyTemplate,
        // each item
        eachItemIndex: model.eachItemIndex,
        // document title
        eachItemTitleTemplate: model.eachItemTitleTemplate,
        // index
        eachItemBodySetting: model.eachItemBodySetting,
        eachItemBodyTemplate: model.eachItemBodyTemplate
      };
    });
    ListPropertiesAdvancedSettings_defineProperty(this, "toggleModal", isModalOpen => {
      this.setState({
        modalOpen: isModalOpen
      });

      // If modal is re-opened, reset unsaved values
      if (isModalOpen) {
        this.setState(this.getInitialState());
      }
    });
    ListPropertiesAdvancedSettings_defineProperty(this, "openModal", () => this.toggleModal(true));
    ListPropertiesAdvancedSettings_defineProperty(this, "closeModal", () => this.toggleModal(false));
    ListPropertiesAdvancedSettings_defineProperty(this, "onRadioChange", e => {
      const name = e.currentTarget.name;
      const value = e.target.value;
      this.setState({
        [name]: parseInt(value, 10)
      });
    });
    ListPropertiesAdvancedSettings_defineProperty(this, "onCheckboxChange", (name, checked) => {
      this.setState({
        [name]: checked
      });
    });
    ListPropertiesAdvancedSettings_defineProperty(this, "onInputChange", e => {
      const id = e.target.id;
      const value = e.target.value;
      this.setState({
        [id]: value
      });
    });
    ListPropertiesAdvancedSettings_defineProperty(this, "onSelectChange", (name, formValue, selected) => {
      const value = selected ? selected.name : '<AUTO>';
      this.setState({
        [name]: value
      });
    });
    ListPropertiesAdvancedSettings_defineProperty(this, "applyChanges", () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _this$state = this.state,
        {
          modalOpen
        } = _this$state,
        advancedSettingsForm = ListPropertiesAdvancedSettings_objectWithoutProperties(_this$state, ListPropertiesAdvancedSettings_excluded);
      this.props.applyAdvancedProperties(advancedSettingsForm);
      this.toggleModal(false);
    });
    const initialState = this.getInitialState();
    this.state = ListPropertiesAdvancedSettings_objectSpread({
      modalOpen: false
    }, initialState);
  }
  render() {
    const {
      modalOpen,
      discussionSetting,
      fileAttachmentIndex,
      entireListIndex,
      entireListTitleTemplate,
      entireListIndexSetting,
      entireListBodySetting,
      eachItemIndex,
      eachItemTitleTemplate,
      eachItemBodySetting,
      titleColumn,
      entireListBodyTemplate,
      eachItemBodyTemplate
    } = this.state;
    const {
      title,
      model
    } = this.props;
    const entireListIndexSettings = {
      entireListTitleTemplate,
      entireListIndexSetting,
      entireListBodySetting,
      entireListBodyTemplate
    };
    const eachItemIndexSettings = {
      eachItemTitleTemplate,
      eachItemBodySetting,
      eachItemBodyTemplate
    };
    const footer = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("button", {
      className: "domain-adv-footer domain-adv-cancel-btn btn btn-default",
      onClick: this.closeModal,
      type: "button"
    }, "Cancel"), /*#__PURE__*/external_react_default().createElement(HelpLink, {
      className: "domain-adv-footer domain-adv-link",
      topic: "createListOptions#advanced"
    }, "Get help with list settings"), /*#__PURE__*/external_react_default().createElement("button", {
      className: `domain-adv-footer domain-adv-apply-btn btn btn-${getSubmitButtonClass()}`,
      onClick: this.applyChanges,
      type: "button"
    }, "Apply"));
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("button", {
      className: "domain-field-float-right btn btn-default",
      onClick: this.openModal,
      type: "button"
    }, title), modalOpen && /*#__PURE__*/external_react_default().createElement(Modal, {
      footer: footer,
      onCancel: this.closeModal,
      title: "Advanced List Settings"
    }, /*#__PURE__*/external_react_default().createElement(SettingsContainer, {
      title: "Default Display Field",
      tipBody: DISPLAY_TITLE_TIP
    }, /*#__PURE__*/external_react_default().createElement(DisplayTitle, {
      model: model,
      onSelectChange: this.onSelectChange,
      titleColumn: titleColumn
    })), /*#__PURE__*/external_react_default().createElement(SettingsContainer, {
      title: "Discussion Threads",
      tipBody: DISCUSSION_LINKS_TIP
    }, /*#__PURE__*/external_react_default().createElement(DiscussionInputs, {
      onRadioChange: this.onRadioChange,
      discussionSetting: discussionSetting
    })), /*#__PURE__*/external_react_default().createElement(SettingsContainer, {
      title: "Search Indexing Options",
      tipBody: SEARCH_INDEXING_TIP
    }, /*#__PURE__*/external_react_default().createElement(SearchIndexing, {
      onRadioChange: this.onRadioChange,
      onCheckboxChange: this.onCheckboxChange,
      onInputChange: this.onInputChange,
      entireListIndex: entireListIndex,
      entireListIndexSettings: entireListIndexSettings,
      eachItemIndex: eachItemIndex,
      eachItemIndexSettings: eachItemIndexSettings,
      fileAttachmentIndex: fileAttachmentIndex
    }))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/list/ListPropertiesPanelFormElements.tsx



const ListPropertiesPanelFormElements_NameInput = (0,external_react_.memo)(({
  model,
  onInputChange
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "row margin-top"
}, /*#__PURE__*/external_react_default().createElement("div", {
  className: "col-xs-3 col-lg-2"
}, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
  label: "Name",
  required: true,
  helpTipBody: "The name for this list. Note that this can be changed after list creation."
})), /*#__PURE__*/external_react_default().createElement("div", {
  className: "col-xs-9 col-lg-8"
}, /*#__PURE__*/external_react_default().createElement("input", {
  className: "form-control",
  id: "name",
  type: "text",
  placeholder: "Enter a name for this list",
  value: model.name === null ? '' : model.name,
  onChange: onInputChange
}))));
const ListPropertiesPanelFormElements_DescriptionInput = (0,external_react_.memo)(({
  model,
  onInputChange
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "row margin-top"
}, /*#__PURE__*/external_react_default().createElement("div", {
  className: "col-xs-3 col-lg-2"
}, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
  label: "Description"
})), /*#__PURE__*/external_react_default().createElement("div", {
  className: "col-xs-9 col-lg-8"
}, /*#__PURE__*/external_react_default().createElement("textarea", {
  className: "form-control",
  id: "description",
  value: model.description === null ? '' : model.description,
  onChange: onInputChange
}))));
const ListPropertiesPanelFormElements_BasicPropertiesFields = (0,external_react_.memo)(({
  model,
  onInputChange
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "col-xs-12 col-md-7"
}, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
  title: "Basic Properties"
}), /*#__PURE__*/external_react_default().createElement(ListPropertiesPanelFormElements_NameInput, {
  model: model,
  onInputChange: onInputChange
}), /*#__PURE__*/external_react_default().createElement(ListPropertiesPanelFormElements_DescriptionInput, {
  model: model,
  onInputChange: onInputChange
})));
const CheckBoxRow = (0,external_react_.memo)(({
  checked,
  onChange,
  name,
  text
}) => {
  const onChange_ = (0,external_react_.useCallback)(event => {
    onChange(name, event.target.checked);
  }, [name, onChange]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "list__properties__checkbox-row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("label", null, /*#__PURE__*/external_react_default().createElement("input", {
    checked: checked,
    onChange: onChange_,
    type: "checkbox"
  }), text)));
});
CheckBoxRow.displayName = 'CheckBoxRow';
const AllowableActionContainer = (0,external_react_.memo)(({
  model,
  onChange
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "list__properties__allowable-actions"
}, /*#__PURE__*/external_react_default().createElement(CheckBoxRow, {
  text: "Delete",
  checked: model.allowDelete,
  onChange: onChange,
  name: "allowDelete"
}), /*#__PURE__*/external_react_default().createElement(CheckBoxRow, {
  text: "Upload",
  checked: model.allowUpload,
  onChange: onChange,
  name: "allowUpload"
}), /*#__PURE__*/external_react_default().createElement(CheckBoxRow, {
  text: "Export & Print",
  checked: model.allowExport,
  onChange: onChange,
  name: "allowExport"
})));
const AllowableActions = (0,external_react_.memo)(({
  model,
  onChange
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "col-xs-12 col-md-3"
}, /*#__PURE__*/external_react_default().createElement(SectionHeading, {
  title: "Allow these Actions"
}), /*#__PURE__*/external_react_default().createElement(AllowableActionContainer, {
  model: model,
  onChange: onChange
})));
AllowableActions.displayName = 'AllowableActions';
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/list/ListPropertiesPanel.tsx
function ListPropertiesPanel_extends() { return ListPropertiesPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ListPropertiesPanel_extends.apply(null, arguments); }
function ListPropertiesPanel_defineProperty(e, r, t) { return (r = ListPropertiesPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ListPropertiesPanel_toPropertyKey(t) { var i = ListPropertiesPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ListPropertiesPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








const ListPropertiesPanel_PROPERTIES_HEADER_ID = 'list-properties-hdr';
// Note: exporting this class for jest test case
class ListPropertiesPanelImpl extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    ListPropertiesPanel_defineProperty(this, "updateValidStatus", newModel => {
      const {
        model,
        onChange
      } = this.props;
      const updatedModel = newModel || model;
      const isValid = updatedModel && updatedModel.hasValidProperties();
      this.setState(() => ({
        isValid
      }), () => {
        // Issue 39918: only consider the model changed if there is a newModel param
        if (newModel) {
          onChange(updatedModel);
        }
      });
    });
    ListPropertiesPanel_defineProperty(this, "onChange", (name, value) => {
      const {
        model
      } = this.props;

      // Name must be set on Domain as well
      let newDomain = model.domain;
      if (name === 'name') {
        newDomain = model.domain.merge({
          name: value
        });
      }
      const newModel = model.merge({
        [name]: value,
        domain: newDomain
      });
      this.updateValidStatus(newModel);
    });
    ListPropertiesPanel_defineProperty(this, "onInputChange", e => {
      const id = e.target.id;
      let value = e.target.value;

      // special case for empty string, set as null instead
      if (api_.Utils.isString(value) && value.length === 0) {
        value = null;
      }
      this.onChange(id, value);
    });
    ListPropertiesPanel_defineProperty(this, "applyAdvancedProperties", advancedSettingsForm => {
      const {
        model
      } = this.props;
      const newModel = model.merge(advancedSettingsForm);
      this.updateValidStatus(newModel);
    });
    this.state = {
      isValid: true
    };
  }
  render() {
    const {
      model
    } = this.props;
    const {
      isValid
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement(BasePropertiesPanel, ListPropertiesPanel_extends({}, this.props, {
      headerId: ListPropertiesPanel_PROPERTIES_HEADER_ID,
      title: "List Properties",
      titlePrefix: model.name,
      updateValidStatus: this.updateValidStatus,
      isValid: isValid
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/external_react_default().createElement(HelpTopicURL, {
      helpTopic: DEFINE_LIST_TOPIC,
      nounPlural: "lists"
    }))), /*#__PURE__*/external_react_default().createElement("form", null, /*#__PURE__*/external_react_default().createElement(ListPropertiesPanelFormElements_BasicPropertiesFields, {
      model: model,
      onInputChange: this.onInputChange
    }), /*#__PURE__*/external_react_default().createElement(AllowableActions, {
      model: model,
      onChange: this.onChange
    }), /*#__PURE__*/external_react_default().createElement(ListPropertiesAdvancedSettings_AdvancedSettings, {
      title: "Advanced Settings",
      model: model,
      applyAdvancedProperties: this.applyAdvancedProperties
    })));
  }
}
const ListPropertiesPanel = withDomainPropertiesPanelCollapse(ListPropertiesPanelImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/list/SetKeyFieldNamePanel.tsx
function SetKeyFieldNamePanel_defineProperty(e, r, t) { return (r = SetKeyFieldNamePanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SetKeyFieldNamePanel_toPropertyKey(t) { var i = SetKeyFieldNamePanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SetKeyFieldNamePanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







const AUTO_INC_KEY_OPTION_TEXT = 'Auto integer key';
const AUTO_INC_KEY_OPTION_VALUE = -1;
const AUTO_INC_FIELD_CONFIG = {
  required: true,
  name: 'Key',
  dataType: AUTOINT_TYPE,
  rangeURI: AUTOINT_TYPE.rangeURI,
  isPrimaryKey: true,
  lockType: DOMAIN_FIELD_PRIMARY_KEY_LOCKED,
  conceptURI: AUTO_INT_CONCEPT_URI
};
class SetKeyFieldNamePanel extends (external_react_default()).PureComponent {
  constructor(...args) {
    super(...args);
    SetKeyFieldNamePanel_defineProperty(this, "onSelectionChange", e => {
      const {
        model,
        onModelChange
      } = this.props;
      const {
        value
      } = e.target;
      const selectedRowIndex = api_.Utils.isNumber(parseInt(value)) ? parseInt(value) : undefined;
      if (selectedRowIndex === undefined) {
        return;
      }

      // start by removing the previous primary key field setting
      let updatedFields = model.domain.fields.map(field => {
        return field.isPrimaryKey ? field.merge({
          isPrimaryKey: false,
          required: false,
          lockType: 'NotLocked'
        }) : field;
      }).toList();

      // now set the selected fields as the new primary key, and if that pk is an auto increment field add it as a new field
      let newKeyField;
      let keyType;
      if (selectedRowIndex === AUTO_INC_KEY_OPTION_VALUE) {
        newKeyField = createNewDomainField(model.domain, AUTO_INC_FIELD_CONFIG);
        updatedFields = updatedFields.insert(0, newKeyField);
        keyType = 'AutoIncrementInteger';
      } else {
        newKeyField = updatedFields.get(selectedRowIndex).merge({
          isPrimaryKey: true,
          required: true,
          lockType: DOMAIN_FIELD_PRIMARY_KEY_LOCKED
        });
        updatedFields = updatedFields.set(selectedRowIndex, newKeyField);
        keyType = newKeyField.dataType.name === 'int' ? 'Integer' : 'Varchar';

        // filter out any previously added Auto Inc key fields since we aren't using that anymore
        updatedFields = updatedFields.filter(field => !PropDescType.isAutoIncrement(field.dataType)).toList();
      }
      const updatedModel = model.merge({
        domain: model.domain.set('fields', updatedFields),
        keyName: newKeyField.name,
        keyType
      });
      onModelChange(updatedModel);
    });
  }
  isValidKeyField(field) {
    const dataType = field.dataType.name;
    const hasName = typeof field.name !== 'undefined' && field.name.trim().length > 0;
    return (dataType == 'string' || dataType == 'int') && hasName;
  }
  render() {
    const {
      domain
    } = this.props;
    const pkRowIndex = domain && domain.fields.findIndex(i => i.isPrimaryKey);
    const pkField = pkRowIndex > -1 ?
    // check for edge case on JSON file import, for an invalid PK field type
    this.isValidKeyField(domain.fields.get(pkRowIndex)) ? domain.fields.get(pkRowIndex) : undefined : undefined;
    const isAutoIncPk = pkField !== undefined && PropDescType.isAutoIncrement(pkField.dataType);
    return /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "info",
      className: "list__set-key-alert"
    }, /*#__PURE__*/external_react_default().createElement("div", null, "Select a key value for this list which uniquely identifies the item. You can use \"", AUTO_INC_KEY_OPTION_TEXT, "\" to define your own below."), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row list__set-key-panel"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-3"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Key Field Name",
      required: true,
      helpTipBody: "Only integer or text fields can be made the primary key."
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-5"
    }, /*#__PURE__*/external_react_default().createElement("select", {
      className: "form-control",
      name: "keyField",
      onChange: this.onSelectionChange,
      value: pkRowIndex > -1 ? pkRowIndex : undefined
    }, !pkField && /*#__PURE__*/external_react_default().createElement("option", {
      key: "_default",
      value: undefined
    }, "Select a field from the list"), !isAutoIncPk && /*#__PURE__*/external_react_default().createElement("option", {
      key: "_autoInc",
      value: AUTO_INC_KEY_OPTION_VALUE
    }, AUTO_INC_KEY_OPTION_TEXT), domain && domain.fields.map((field, index) => {
      const display = isAutoIncPk && index === pkRowIndex ? AUTO_INC_KEY_OPTION_TEXT : field.name;
      return this.isValidKeyField(field) ? /*#__PURE__*/external_react_default().createElement("option", {
        value: index,
        key: index
      }, display) : undefined;
    })))));
  }
}
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/list/ListDesignerPanels.tsx
function ListDesignerPanels_extends() { return ListDesignerPanels_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ListDesignerPanels_extends.apply(null, arguments); }
function ListDesignerPanels_defineProperty(e, r, t) { return (r = ListDesignerPanels_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ListDesignerPanels_toPropertyKey(t) { var i = ListDesignerPanels_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ListDesignerPanels_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
















// export for testing
class ListDesignerPanelsImpl extends (external_react_default()).PureComponent {
  constructor(props) {
    super(props);
    ListDesignerPanels_defineProperty(this, "onPropertiesChange", model => {
      const {
        onChange
      } = this.props;
      this.setState(() => ({
        model
      }), () => onChange(model));
    });
    ListDesignerPanels_defineProperty(this, "onDomainChange", (domain, dirty, rowIndexChanges) => {
      const {
        model
      } = this.state;

      // Issue 40262: If we have a titleColumn selected and the name changes (not the row index), update the titleColumn
      let titleColumn = model.titleColumn;
      if (titleColumn && !rowIndexChanges) {
        const index = model.domain.findFieldIndexByName(titleColumn);
        titleColumn = index > -1 ? domain.fields.get(index).name : undefined;
      }
      this.setState(state => ({
        model: state.model.merge({
          domain,
          titleColumn
        })
      }), () => {
        // Issue 39918: use the dirty property that DomainForm onChange passes
        if (dirty) {
          this.props.onChange(this.state.model);
        }
        this.setKeyTypeForModel();
      });
    });
    ListDesignerPanels_defineProperty(this, "setFileImportData", (file, shouldImportData) => {
      this.setState({
        file,
        shouldImportData
      });
    });
    ListDesignerPanels_defineProperty(this, "onImportErrorStayAndFix", () => {
      const {
        model,
        savedModel
      } = this.state;
      api_.Domain.drop({
        schemaName: 'lists',
        queryName: savedModel.name,
        failure: error => {
          this.setState({
            model: model.set('exception', error),
            savedModel: undefined,
            importError: undefined
          });
        },
        success: () => {
          this.setState(() => ({
            model: model.set('exception', undefined),
            savedModel: undefined,
            importError: undefined
          }));
        }
      });
    });
    ListDesignerPanels_defineProperty(this, "onImportErrorContinue", () => {
      this.props.onComplete(this.state.savedModel);
    });
    ListDesignerPanels_defineProperty(this, "onFinish", () => {
      const {
        setSubmitting
      } = this.props;
      const {
        model
      } = this.state;
      const isValid = model.isValid();
      this.props.onFinish(isValid, this.saveDomain);
      if (!isValid) {
        const exception = !model.hasValidKeyType() ? 'You must specify a key field for your list in the fields panel to continue.' : model.domain.getFirstFieldError();
        const updatedModel = model.set('exception', exception);
        setSubmitting(false, () => {
          this.setState(() => ({
            model: updatedModel
          }));
        });
      }
    });
    ListDesignerPanels_defineProperty(this, "saveDomain", () => {
      const {
        setSubmitting
      } = this.props;
      const {
        model,
        shouldImportData
      } = this.state;
      saveDomain({
        domain: model.domain,
        kind: model.getDomainKind(),
        options: model.getOptions(),
        name: model.name
      }).then(response => {
        const updatedModel = model.set('exception', undefined);
        this.setState(() => ({
          model: updatedModel,
          // the savedModel will be used for dropping the domain on file import failure or for onComplete
          savedModel: updatedModel.merge({
            domain: response
          })
        }), () => {
          // If we're importing List file data, import file contents
          if (shouldImportData) {
            this.handleFileImport();
          } else {
            setSubmitting(false, () => {
              this.props.onComplete(this.state.savedModel);
            });
          }
        });
      }).catch(response => {
        const exception = resolveErrorMessage(response);

        // Issue 49113: Better handling for case where the only error is a form error
        if (!exception && response.domainException) {
          response = response.setIn(['domainException', 'exception'], resolveErrorMessage(response.domainException.exception));
        }
        const updatedModel = exception ? model.set('exception', exception) : model.merge({
          domain: response,
          exception: undefined
        });
        setSubmitting(false, () => {
          this.setState(() => ({
            model: updatedModel
          }));
        });
      });
    });
    ListDesignerPanels_defineProperty(this, "headerRenderer", config => {
      return /*#__PURE__*/external_react_default().createElement(SetKeyFieldNamePanel, ListDesignerPanels_extends({
        model: this.state.model,
        onModelChange: this.onPropertiesChange
      }, config));
    });
    ListDesignerPanels_defineProperty(this, "toggleListPropertiesPanel", (collapsed, callback) => {
      this.props.onTogglePanel(0, collapsed, callback);
    });
    ListDesignerPanels_defineProperty(this, "toggleDomainForm", (collapsed, callback) => {
      this.props.onTogglePanel(1, collapsed, callback);
    });
    this.state = {
      model: props.initModel || ListModel.create({}),
      file: undefined,
      shouldImportData: false,
      savedModel: undefined,
      importError: undefined
    };
  }
  handleFileImport() {
    const {
      setSubmitting
    } = this.props;
    const {
      file,
      savedModel
    } = this.state;
    importData({
      schemaName: 'lists',
      queryName: savedModel.name,
      file,
      importUrl: buildURL('list', 'UploadListItems', {
        name: savedModel.name
      })
    }).then(() => {
      setSubmitting(false, () => {
        this.props.onComplete(savedModel);
      });
    }).catch(error => {
      console.error(error);
      setSubmitting(false, () => {
        this.setState({
          importError: error
        });
      });
    });
  }
  setKeyTypeForModel() {
    const {
      model
    } = this.state;
    if (!model.keyType) {
      const fields = model.domain.fields;
      const pkField = fields.find(i => i.isPrimaryKey);
      if (pkField) {
        const keyName = pkField.get('name');
        let keyType;
        let domain = model.domain;
        // Issue 41718: Domain Designer Field Imports should observe auto-increment fields
        if (pkField.conceptURI === AUTO_INT_CONCEPT_URI) {
          keyType = 'AutoIncrementInteger';
          const updatedFields = fields.map(f => f.isPrimaryKey ? f.merge({
            dataType: AUTOINT_TYPE
          }) : f);
          domain = model.domain.set('fields', updatedFields);
        } else if (PropDescType.isAutoIncrement(pkField.dataType)) {
          keyType = 'AutoIncrementInteger';
        } else if (PropDescType.isInteger(pkField.dataType.rangeURI)) {
          keyType = 'Integer';
        } else if (PropDescType.isString(pkField.dataType.rangeURI)) {
          keyType = 'Varchar';
        }
        this.onPropertiesChange(model.merge({
          keyName,
          keyType,
          domain
        }));
      }
    }
  }
  render() {
    const {
      api,
      onCancel,
      visitedPanels,
      currentPanelIndex,
      firstState,
      validatePanel,
      submitting,
      saveBtnText
    } = this.props;
    const {
      model,
      file,
      importError
    } = this.state;
    return /*#__PURE__*/external_react_default().createElement(BaseDomainDesigner, {
      name: model.name,
      exception: model.exception,
      domains: external_immutable_.List.of(model.domain),
      hasValidProperties: model.hasValidProperties(),
      visitedPanels: visitedPanels,
      submitting: submitting,
      onCancel: onCancel,
      onFinish: this.onFinish,
      saveBtnText: saveBtnText
    }, /*#__PURE__*/external_react_default().createElement(ListPropertiesPanel, {
      model: model,
      onChange: this.onPropertiesChange,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== 0,
      panelStatus: model.isNew() ? getDomainPanelStatus(0, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      validate: validatePanel === 0,
      onToggle: this.toggleListPropertiesPanel
    }), /*#__PURE__*/external_react_default().createElement(domainproperties_DomainForm, {
      api: api?.domain,
      key: model.domain.domainId || 0,
      domainIndex: 0,
      domain: model.domain,
      headerTitle: "Fields",
      todoIconHelpMsg: "This section does not contain any user-defined fields and requires a selection for the Key Field Name property.",
      helpNoun: "list",
      helpTopic: null // null so that we don't show the "learn more about this tool" link for this domains
      ,
      onChange: this.onDomainChange,
      setFileImportData: this.setFileImportData,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== 1,
      validate: validatePanel === 1,
      panelStatus: model.isNew() ? getDomainPanelStatus(1, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      onToggle: this.toggleDomainForm,
      appDomainHeaderRenderer: model.isNew() && model.domain.fields.size > 0 && this.headerRenderer
    }), /*#__PURE__*/external_react_default().createElement(Progress, {
      modal: true,
      delay: 1000,
      estimate: file ? file.size * 0.005 : undefined,
      title: "Importing data from selected file...",
      toggle: submitting && file !== undefined
    }), importError !== undefined && /*#__PURE__*/external_react_default().createElement(ConfirmImportTypes, {
      designerType: "list",
      error: importError,
      onConfirm: this.onImportErrorContinue,
      onCancel: this.onImportErrorStayAndFix
    }));
  }
}
const ListDesignerPanels = withBaseDomainDesigner(ListDesignerPanelsImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataclasses/DataClassPropertiesPanel.tsx
function DataClassPropertiesPanel_extends() { return DataClassPropertiesPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DataClassPropertiesPanel_extends.apply(null, arguments); }
function DataClassPropertiesPanel_defineProperty(e, r, t) { return (r = DataClassPropertiesPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DataClassPropertiesPanel_toPropertyKey(t) { var i = DataClassPropertiesPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DataClassPropertiesPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }















const DataClassPropertiesPanel_PROPERTIES_HEADER_ID = 'dataclass-properties-hdr';
const DataClassPropertiesPanel_FORM_IDS = {
  CATEGORY: ENTITY_FORM_ID_PREFIX + 'category',
  SAMPLE_TYPE_ID: ENTITY_FORM_ID_PREFIX + 'sampleSet'
};
// Note: exporting this class for jest test case
class DataClassPropertiesPanelImpl extends external_react_.PureComponent {
  constructor(...args) {
    super(...args);
    DataClassPropertiesPanel_defineProperty(this, "state", {
      isValid: true,
      prefix: undefined,
      loadingError: undefined
    });
    DataClassPropertiesPanel_defineProperty(this, "componentDidMount", async () => {
      const {
        model
      } = this.props;
      if (isSampleManagerEnabled()) {
        try {
          const response = await loadNameExpressionOptions(model.containerPath);
          this.setState({
            prefix: response.prefix ?? null
          });
        } catch (error) {
          this.setState({
            loadingError: 'There was a problem retrieving the Naming Pattern prefix.'
          });
        }
      }
    });
    DataClassPropertiesPanel_defineProperty(this, "updateValidStatus", newModel => {
      const {
        model,
        onChange
      } = this.props;
      const updatedModel = newModel || model;
      this.setState(() => ({
        isValid: !!updatedModel?.hasValidProperties
      }), () => {
        // Issue 39918: only consider the model changed if there is a newModel param
        if (newModel) {
          onChange(updatedModel);
        }
      });
    });
    DataClassPropertiesPanel_defineProperty(this, "onFormChange", evt => {
      const {
        id,
        value
      } = evt.target;
      this.onChange(id, value?.trimStart());
    });
    DataClassPropertiesPanel_defineProperty(this, "onChange", (id, value) => {
      this.updateValidStatus(this.props.model.mutate({
        [getFormNameFromId(id)]: value
      }));
    });
    DataClassPropertiesPanel_defineProperty(this, "renderAddEntityHelper", noun => {
      return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Column headings used during import to set a ", noun.toLowerCase(), "'s parentage."), /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: DATACLASS_ALIAS_TOPIC
      }, "More info")));
    });
  }
  render() {
    const {
      model,
      headerText,
      appPropertiesOnly,
      nounSingular,
      nounPlural,
      nameExpressionInfoUrl,
      nameExpressionPlaceholder,
      helpTopic,
      namePreviewsLoading,
      previewName,
      onNameFieldHover,
      nameExpressionGenIdProps,
      allowParentAlias
    } = this.props;
    const {
      isValid,
      prefix,
      loadingError
    } = this.state;
    let warning;
    if (prefix && !model.isNew && model.nameExpression && !model.nameExpression.includes(PREFIX_SUBSTITUTION_EXPRESSION)) {
      warning = `${PROPERTIES_PANEL_NAMING_PATTERN_WARNING_MSG}: "${prefix}".`;
    } else if (loadingError !== undefined) {
      warning = loadingError;
    }
    return /*#__PURE__*/external_react_default().createElement(BasePropertiesPanel, DataClassPropertiesPanel_extends({}, this.props, {
      headerId: DataClassPropertiesPanel_PROPERTIES_HEADER_ID,
      title: nounSingular + ' Properties',
      updateValidStatus: this.updateValidStatus,
      isValid: isValid,
      warning: warning
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row margin-bottom"
    }, headerText && /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-9"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "entity-form--headerhelp"
    }, headerText)), /*#__PURE__*/external_react_default().createElement("div", {
      className: `col-xs-${headerText ? 3 : 12}`
    }, /*#__PURE__*/external_react_default().createElement(HelpTopicURL, {
      helpTopic: helpTopic,
      nounPlural: nounPlural
    }))), /*#__PURE__*/external_react_default().createElement(EntityDetailsForm, {
      noun: nounSingular,
      onFormChange: this.onFormChange,
      data: model.entityDataMap,
      nameExpressionInfoUrl: nameExpressionInfoUrl,
      nameExpressionPlaceholder: nameExpressionPlaceholder,
      warning: warning,
      showPreviewName: !!model.nameExpression,
      namePreviewsLoading: namePreviewsLoading,
      previewName: previewName,
      onNameFieldHover: onNameFieldHover,
      nameExpressionGenIdProps: nameExpressionGenIdProps,
      nameReadOnly: model.isBuiltIn
    }), allowParentAlias && /*#__PURE__*/external_react_default().createElement(DomainParentAliases, DataClassPropertiesPanel_extends({}, this.props, {
      parentAliases: model.parentAliases,
      idPrefix: "dataclass-parent-import-alias-",
      schema: SCHEMAS.DATA_CLASSES.SCHEMA,
      addEntityHelp: this.renderAddEntityHelper(nounSingular),
      includeSampleSet: false,
      includeDataClass: true,
      showAddBtn: true
    })), !appPropertiesOnly && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Category"
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-10"
    }, /*#__PURE__*/external_react_default().createElement(QuerySelect, {
      key: DataClassPropertiesPanel_FORM_IDS.CATEGORY,
      name: DataClassPropertiesPanel_FORM_IDS.CATEGORY,
      schemaQuery: SCHEMAS.EXP_TABLES.DATA_CLASS_CATEGORY_TYPE,
      displayColumn: "Value",
      valueColumn: "Value",
      onQSChange: this.onChange,
      value: model.category,
      showLabel: false
    }))), !appPropertiesOnly && /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-2"
    }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
      label: "Sample Type",
      helpTipBody: `The default Sample Type where new samples will be created for this ${nounSingular.toLowerCase()}.`
    })), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-xs-10"
    }, /*#__PURE__*/external_react_default().createElement(QuerySelect, {
      key: DataClassPropertiesPanel_FORM_IDS.SAMPLE_TYPE_ID,
      name: DataClassPropertiesPanel_FORM_IDS.SAMPLE_TYPE_ID,
      schemaQuery: SCHEMAS.EXP_TABLES.SAMPLE_SETS,
      onQSChange: this.onChange,
      value: model.sampleSet,
      showLabel: false
    }))));
  }
}
DataClassPropertiesPanel_defineProperty(DataClassPropertiesPanelImpl, "defaultProps", {
  nounSingular: 'Data Class',
  nounPlural: 'Data Classes',
  helpTopic: DEFINE_DATA_CLASS_TOPIC,
  nameExpressionInfoUrl: getHelpLink(DATA_CLASS_NAME_EXPRESSION_TOPIC),
  nameExpressionPlaceholder: 'Enter a naming pattern (e.g., DC-${now:date}-${genId})',
  appPropertiesOnly: false,
  dataClassAliasCaption: 'Parent Alias',
  parentAliasHelpText: "Column headings used during import to set a data's parentage."
});
const DataClassPropertiesPanel = withDomainPropertiesPanelCollapse(DataClassPropertiesPanelImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/dataclasses/DataClassDesigner.tsx
const DataClassDesigner_excluded = ["systemFields"];
function DataClassDesigner_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DataClassDesigner_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DataClassDesigner_ownKeys(Object(t), !0).forEach(function (r) { DataClassDesigner_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DataClassDesigner_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function DataClassDesigner_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = DataClassDesigner_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function DataClassDesigner_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function DataClassDesigner_defineProperty(e, r, t) { return (r = DataClassDesigner_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DataClassDesigner_toPropertyKey(t) { var i = DataClassDesigner_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DataClassDesigner_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






















const NEW_DATA_CLASS_OPTION = {
  label: '(Current Data Class)',
  value: '{{this_data_class}}',
  schema: SCHEMAS.DATA_CLASSES.SCHEMA
};
const DataClassDesigner_PROPERTIES_PANEL_INDEX = 0;
const DataClassDesigner_DOMAIN_PANEL_INDEX = 1;
const DataClassDesigner_PROJECTS_PANEL_INDEX = 2;
// Exported for testing
class DataClassDesignerImpl extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    DataClassDesigner_defineProperty(this, "componentDidMount", async () => {
      const {
        model
      } = this.state;
      const {
        isValidParentOptionsFn
      } = this.props;
      if (this.props.allowParentAlias) {
        const {
          parentOptions,
          parentAliases
        } = await initParentOptionsSelects(false, true, model.containerPath, isValidParentOptionsFn, !model.rowId ? NEW_DATA_CLASS_OPTION : null, model.importAliases, 'dataclass-parent-import-alias-', this.formatLabel);
        this.setState((0,external_immer_.produce)(draft => {
          draft.model.parentAliases = parentAliases;
          draft.parentOptions = parentOptions;
        }));
      }
      if (this.state.model.isNew && isSampleManagerEnabled()) {
        const response = await this.props.loadNameExpressionOptions(this.state.model.containerPath);
        if (response.prefix) {
          this.setState((0,external_immer_.produce)(draft => {
            draft.model.nameExpression = response.prefix + (draft.model.nameExpression ? draft.model.nameExpression : '');
          }));
        }
      }
    });
    DataClassDesigner_defineProperty(this, "formatLabel", name => {
      const {
        model
      } = this.state;
      if (name === model?.name) return NEW_DATA_CLASS_OPTION.label;
      return name;
    });
    DataClassDesigner_defineProperty(this, "onFinish", () => {
      const {
        defaultNameFieldConfig,
        setSubmitting,
        nounSingular
      } = this.props;
      const {
        model
      } = this.state;
      const isValid = model.isValid(defaultNameFieldConfig);
      this.props.onFinish(isValid, this.saveDomain);
      if (!isValid) {
        let exception;
        if (model.hasInvalidNameField(defaultNameFieldConfig)) {
          exception = 'The ' + defaultNameFieldConfig.name + ' field name is reserved for imported or generated ' + nounSingular + ' ids.';
        } else if (getDuplicateAlias(model.parentAliases, true).size > 0) {
          exception = 'Duplicate parent alias header found: ' + getDuplicateAlias(model.parentAliases, true).join(', ');
        }
        setSubmitting(false, () => {
          this.saveModelForError({
            exception
          });
        });
      }
    });
    DataClassDesigner_defineProperty(this, "saveDomain", async hasConfirmedNameExpression => {
      const {
        api,
        beforeFinish,
        onComplete,
        setSubmitting,
        validateNameExpressions
      } = this.props;
      const {
        model
      } = this.state;
      const {
        name,
        domain
      } = model;
      beforeFinish?.(model);
      const domainDesign = domain.merge({
        name // This will be the Data Class Name
      });

      // Remove display-only option field
      const _model$options = model.options,
        {
          systemFields
        } = _model$options,
        otherOptions = DataClassDesigner_objectWithoutProperties(_model$options, DataClassDesigner_excluded);
      const options = DataClassDesigner_objectSpread({}, otherOptions);
      options.importAliases = this.getImportAliasesAsMap(model);
      if (validateNameExpressions && !hasConfirmedNameExpression) {
        try {
          const response = await api.domain.validateDomainNameExpressions(domainDesign, api_.Domain.KINDS.DATA_CLASS, options, true);
          if (response.errors?.length > 0 || response.warnings?.length > 0) {
            setSubmitting(false, () => {
              if (response.errors?.length > 0) this.saveModelForError({
                exception: response.errors?.join('\n')
              });
              this.setState({
                nameExpressionWarnings: response.warnings,
                namePreviews: response.previews
              });
            });
            return;
          }
        } catch (e) {
          const exception = resolveErrorMessage(e);
          setSubmitting(false, () => {
            this.saveModelForError({
              exception
            });
          });
          return;
        }
      }
      try {
        const savedDomain = await saveDomain({
          containerPath: model.isNew ? getAppHomeFolderPath(new Container((0,api_.getServerContext)().container)) : model.containerPath,
          domain: domainDesign,
          kind: api_.Domain.KINDS.DATA_CLASS,
          name: model.name,
          options
        });
        setSubmitting(false, () => {
          this.saveModel({
            domain: savedDomain,
            exception: undefined
          }, () => {
            onComplete(this.state.model);
          });
        });
      } catch (error) {
        const exception = resolveErrorMessage(error);
        setSubmitting(false, () => {
          if (exception) {
            this.saveModelForError({
              exception
            });
          } else {
            this.saveModelForError({
              domain: error,
              exception: undefined
            });
          }
        });
      }
    });
    DataClassDesigner_defineProperty(this, "saveModelForError", modelOrProps => {
      this.saveModel(modelOrProps, () => {
        scrollDomainErrorIntoView();
      });
    });
    DataClassDesigner_defineProperty(this, "saveModel", (modelOrProps, callback) => {
      this.setState((0,external_immer_.produce)(draft => {
        if (modelOrProps instanceof DataClassModel) {
          draft.model = modelOrProps;
        } else {
          Object.assign(draft.model, modelOrProps);
        }
      }), callback);
    });
    DataClassDesigner_defineProperty(this, "onDomainChange", (domain, dirty) => {
      const {
        onChange
      } = this.props;
      this.saveModel({
        domain
      }, () => {
        // Issue 39918: use the dirty property that DomainForm onChange passes
        if (dirty) {
          onChange?.(this.state.model);
        }
      });
    });
    DataClassDesigner_defineProperty(this, "onPropertiesChange", model => {
      const {
        onChange
      } = this.props;
      this.saveModel(model, () => {
        onChange?.(this.state.model);
      });
    });
    DataClassDesigner_defineProperty(this, "onNameExpressionWarningCancel", () => {
      const {
        setSubmitting
      } = this.props;
      setSubmitting(false, () => {
        this.setState({
          nameExpressionWarnings: undefined
        });
      });
    });
    DataClassDesigner_defineProperty(this, "onNameExpressionWarningConfirm", () => {
      this.setState(() => ({
        nameExpressionWarnings: undefined
      }), () => this.saveDomain(true));
    });
    DataClassDesigner_defineProperty(this, "onNameFieldHover", () => {
      const {
        api
      } = this.props;
      const {
        model,
        namePreviewsLoading
      } = this.state;
      if (namePreviewsLoading) return;
      if (this.props.validateNameExpressions) {
        api.domain.validateDomainNameExpressions(model.domain, api_.Domain.KINDS.DATA_CLASS, model.options, true).then(response => {
          this.setState(() => ({
            namePreviewsLoading: false,
            namePreviews: response?.previews
          }));
        }).catch(response => {
          console.error(response);
          this.setState(() => ({
            namePreviewsLoading: false
          }));
        });
      }
    });
    DataClassDesigner_defineProperty(this, "parentAliasChange", (id, field, newValue) => {
      const {
        model
      } = this.state;
      const newAliases = getParentAliasChangeResult(model.parentAliases, id, field, newValue);
      const newModel = DataClassDesigner_objectSpread(DataClassDesigner_objectSpread({}, model), {}, {
        parentAliases: newAliases
      });
      this.saveModel(newModel);
    });
    DataClassDesigner_defineProperty(this, "updateDupes", id => {
      const {
        model
      } = this.state;
      if (!model) {
        return;
      }
      const newModel = DataClassDesigner_objectSpread(DataClassDesigner_objectSpread({}, model), {}, {
        parentAliases: getParentAliasUpdateDupesResults(model.parentAliases, id)
      });
      this.saveModel(newModel);
    });
    DataClassDesigner_defineProperty(this, "addParentAlias", (id, newAlias) => {
      const {
        model
      } = this.state;
      const {
        parentAliases
      } = model;
      const newModel = DataClassDesigner_objectSpread(DataClassDesigner_objectSpread({}, model), {}, {
        parentAliases: parentAliases.set(id, newAlias)
      });
      this.saveModel(newModel);
    });
    DataClassDesigner_defineProperty(this, "removeParentAlias", id => {
      const {
        model
      } = this.state;
      const {
        parentAliases
      } = model;
      const aliases = parentAliases.delete(id);
      const newModel = DataClassDesigner_objectSpread(DataClassDesigner_objectSpread({}, model), {}, {
        parentAliases: aliases
      });
      this.saveModel(newModel);
    });
    DataClassDesigner_defineProperty(this, "onUpdateExcludedProjects", (_, excludedContainerIds) => {
      const {
        model
      } = this.state;
      const newModel = DataClassDesigner_objectSpread(DataClassDesigner_objectSpread({}, model), {}, {
        excludedContainerIds
      });
      this.onPropertiesChange(newModel);
    });
    DataClassDesigner_defineProperty(this, "propertiesToggle", (collapsed, callback) => {
      this.props.onTogglePanel(DataClassDesigner_PROPERTIES_PANEL_INDEX, collapsed, callback);
    });
    DataClassDesigner_defineProperty(this, "formToggle", (collapsed, callback) => {
      this.props.onTogglePanel(DataClassDesigner_DOMAIN_PANEL_INDEX, collapsed, callback);
    });
    DataClassDesigner_defineProperty(this, "projectsToggle", (collapsed, callback) => {
      this.props.onTogglePanel(DataClassDesigner_PROJECTS_PANEL_INDEX, collapsed, callback);
    });
    this.state = (0,external_immer_.produce)({
      model: props.initModel || DataClassModel.create({}),
      nameExpressionWarnings: undefined,
      namePreviews: undefined,
      namePreviewsLoading: false,
      parentOptions: undefined
    }, () => {});
  }
  getImportAliasesAsMap(model) {
    const {
      name,
      parentAliases
    } = model;
    const aliases = {};
    if (parentAliases) {
      parentAliases.forEach(alias => {
        const {
          parentValue
        } = alias;
        let value = parentValue && parentValue.value ? parentValue.value : '';
        if (parentValue === NEW_DATA_CLASS_OPTION) {
          value = DATA_CLASS_IMPORT_PREFIX + name;
        }
        aliases[alias.alias] = value;
      });
    }
    return (0,external_immutable_.Map)(aliases);
  }
  render() {
    const {
      api,
      onCancel,
      appPropertiesOnly,
      dataClassAliasCaption,
      nounSingular,
      nounPlural,
      nameExpressionInfoUrl,
      nameExpressionPlaceholder,
      headerText,
      submitting,
      saveBtnText,
      currentPanelIndex,
      visitedPanels,
      validatePanel,
      firstState,
      helpTopic,
      domainFormDisplayOptions,
      showGenIdBanner,
      allowParentAlias,
      allowProjectExclusion
    } = this.props;
    const {
      model,
      nameExpressionWarnings,
      namePreviews,
      namePreviewsLoading,
      parentOptions
    } = this.state;
    const hasGenIdInExpression = model.nameExpression?.indexOf(GENID_SYNTAX_STRING) > -1;
    return /*#__PURE__*/external_react_default().createElement(BaseDomainDesigner, {
      name: model.name,
      exception: model.exception,
      domains: external_immutable_.List.of(model.domain),
      hasValidProperties: model.hasValidProperties,
      visitedPanels: visitedPanels,
      submitting: submitting,
      onCancel: onCancel,
      onFinish: this.onFinish,
      saveBtnText: saveBtnText
    }, /*#__PURE__*/external_react_default().createElement(DataClassPropertiesPanel, {
      nounSingular: nounSingular,
      nounPlural: nounPlural,
      nameExpressionInfoUrl: nameExpressionInfoUrl,
      nameExpressionPlaceholder: nameExpressionPlaceholder,
      headerText: headerText,
      helpTopic: helpTopic,
      model: model,
      onChange: this.onPropertiesChange,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== DataClassDesigner_PROPERTIES_PANEL_INDEX,
      panelStatus: model.isNew ? getDomainPanelStatus(DataClassDesigner_PROPERTIES_PANEL_INDEX, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      validate: validatePanel === DataClassDesigner_PROPERTIES_PANEL_INDEX,
      appPropertiesOnly: appPropertiesOnly,
      onToggle: this.propertiesToggle,
      namePreviewsLoading: namePreviewsLoading,
      previewName: namePreviews?.[0],
      onNameFieldHover: this.onNameFieldHover,
      nameExpressionGenIdProps: showGenIdBanner && hasGenIdInExpression ? {
        containerPath: model.containerPath,
        dataTypeName: model.name,
        rowId: model.rowId,
        kindName: 'DataClass'
      } : undefined,
      allowParentAlias: allowParentAlias,
      parentOptions: parentOptions,
      onParentAliasChange: this.parentAliasChange,
      dataClassAliasCaption: dataClassAliasCaption,
      onAddParentAlias: this.addParentAlias,
      onRemoveParentAlias: this.removeParentAlias,
      updateDupeParentAliases: this.updateDupes,
      parentAliasHelpText: `Column headings used during import to set a ${nounSingular.toLowerCase()}'s parentage. The referenced type will also be added as a parent type by default when adding ${nounPlural.toLowerCase()} manually.`
    }), /*#__PURE__*/external_react_default().createElement(domainproperties_DomainForm, {
      key: model.domain.domainId || 0,
      api: api.domain,
      domainIndex: 0,
      domain: model.domain,
      headerTitle: "Fields",
      helpTopic: null // null so that we don't show the "learn more about this tool" link for this domains
      ,
      controlledCollapse: true,
      initCollapsed: currentPanelIndex !== DataClassDesigner_DOMAIN_PANEL_INDEX,
      validate: validatePanel === DataClassDesigner_DOMAIN_PANEL_INDEX,
      panelStatus: model.isNew ? getDomainPanelStatus(DataClassDesigner_DOMAIN_PANEL_INDEX, currentPanelIndex, visitedPanels, firstState) : 'COMPLETE',
      onChange: this.onDomainChange,
      onToggle: this.formToggle,
      appPropertiesOnly: appPropertiesOnly,
      domainFormDisplayOptions: domainFormDisplayOptions,
      systemFields: model.options.systemFields
    }), appPropertiesOnly && !model.isBuiltIn && allowProjectExclusion && /*#__PURE__*/external_react_default().createElement(DataTypeProjectsPanel, {
      controlledCollapse: true,
      dataTypeRowId: model?.rowId,
      dataTypeName: model?.name,
      entityDataType: DataClassDataType,
      initCollapsed: currentPanelIndex !== DataClassDesigner_PROJECTS_PANEL_INDEX,
      onToggle: this.projectsToggle,
      onUpdateExcludedProjects: this.onUpdateExcludedProjects
    }), /*#__PURE__*/external_react_default().createElement(NameExpressionValidationModal, {
      onHide: this.onNameExpressionWarningCancel,
      onConfirm: this.onNameExpressionWarningConfirm,
      warnings: nameExpressionWarnings,
      previews: namePreviews,
      show: !!nameExpressionWarnings && !model.exception
    }));
  }
}
DataClassDesigner_defineProperty(DataClassDesignerImpl, "defaultProps", {
  api: getDefaultAPIWrapper(),
  nounSingular: 'Data Class',
  nounPlural: 'Data Classes',
  domainFormDisplayOptions: DataClassDesigner_objectSpread(DataClassDesigner_objectSpread({}, DEFAULT_DOMAIN_FORM_DISPLAY_OPTIONS), {}, {
    domainKindDisplayName: 'data class'
  }),
  loadNameExpressionOptions: loadNameExpressionOptions,
  validateNameExpressions: true
});
const DataClassDesigner = withBaseDomainDesigner(DataClassDesignerImpl);
;// CONCATENATED MODULE: ./src/internal/components/domainproperties/DesignerDetailPanel.tsx
const DesignerDetailPanel_excluded = ["schemaQuery"];
function DesignerDetailPanel_extends() { return DesignerDetailPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DesignerDetailPanel_extends.apply(null, arguments); }
function DesignerDetailPanel_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = DesignerDetailPanel_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function DesignerDetailPanel_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }





const DesignerDetailPanel = (0,external_react_.memo)(props => {
  const {
      schemaQuery
    } = props,
    detailDisplayProps = DesignerDetailPanel_objectWithoutProperties(props, DesignerDetailPanel_excluded);
  const {
    api
  } = useAppContext();
  const [previews, setPreviews] = (0,external_react_.useState)();

  // don't show description in the panel since it is shown elsewhere in the app header
  const queryColumns = props.queryColumns ?? props.model?.detailColumns?.filter(col => col.fieldKey.toLowerCase() !== 'description');
  (0,external_react_.useEffect)(() => {
    (async () => {
      if (schemaQuery) {
        setPreviews(undefined);
        try {
          const previews_ = {};
          const results = await api.domain.getDomainNamePreviews(schemaQuery);
          if (results?.length > 0) {
            if (results[0]) previews_.nameexpression = 'Example name that will be generated from the current pattern: ' + results[0];
            if (results?.length > 1 && !!results[1]) previews_.aliquotnameexpression = 'Example aliquot name that will be generated from the current pattern: ' + results[1];
          }
          setPreviews(previews_);
        } catch (reason) {
          console.error(reason);
        }
      }
    })();
  }, [api, schemaQuery]);
  return /*#__PURE__*/external_react_default().createElement(DetailPanel, DesignerDetailPanel_extends({
    fieldHelpTexts: previews,
    queryColumns: queryColumns
  }, detailDisplayProps));
});
const DesignerDetailTooltip = (0,external_react_.memo)(props => {
  const {
    model
  } = props;
  const description = caseInsensitive(model?.getRow(), 'Description')?.value;
  return /*#__PURE__*/external_react_default().createElement("div", null, !!description && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("span", {
    className: "header-details-description"
  }, description), /*#__PURE__*/external_react_default().createElement("span", null, "\xA0")), /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    popoverClassName: "header-details-hover",
    iconComponent: /*#__PURE__*/external_react_default().createElement("span", {
      className: "header-details-link"
    }, "Details")
  }, /*#__PURE__*/external_react_default().createElement(DesignerDetailPanel, props)));
});
;// CONCATENATED MODULE: ./src/internal/components/pipeline/constants.ts

const DATA_IMPORT_FILE_SIZE_LIMITS = (0,external_immutable_.Map)({
  all: {
    maxPreviewSize: {
      value: 5242880,
      displayValue: '5MB'
    }
  }
});
const BACKGROUND_IMPORT_MIN_FILE_SIZE = 1024 * 100; // 100kb
const BACKGROUND_IMPORT_MIN_ROW_SIZE = 1000;
;// CONCATENATED MODULE: ./src/internal/components/assay/AssayReimportHeader.tsx



const AssayReimportHeader = (0,external_react_.memo)(({
  assay,
  hasBatchProperties,
  replacedRunProperties
}) => {
  const rowId = caseInsensitive(replacedRunProperties, 'RowId').value;
  const name = caseInsensitive(replacedRunProperties, 'Name').value;
  const assayRunUrl = AppURL.create('assays', assay.type, assay.name, 'runs', rowId);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Re-Import Run"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("strong", null, "Replacing Run: ", /*#__PURE__*/external_react_default().createElement("a", {
    href: assayRunUrl.toHref()
  }, name))), /*#__PURE__*/external_react_default().createElement("p", null, "Edit the ", hasBatchProperties ? 'batch and ' : '', " run properties below or provide updated data for this assay run. Changes will be reflected in the audit history for this run.")));
});
;// CONCATENATED MODULE: ./src/internal/components/assay/AssayWizardModel.ts





class AssayWizardModel extends (0,external_immutable_.Record)({
  assayDef: undefined,
  isWarning: false,
  isInit: false,
  isLoading: false,
  batchId: undefined,
  // batchId is null for first run
  lastRunId: undefined,
  returnUrl: undefined,
  isSubmitted: undefined,
  isSubmitting: undefined,
  attachedFiles: (0,external_immutable_.Map)(),
  resultsFiles: (0,external_immutable_.Map)(),
  batchColumns: (0,external_immutable_.OrderedMap)(),
  batchProperties: (0,external_immutable_.Map)(),
  comment: undefined,
  dataText: undefined,
  plateColumns: (0,external_immutable_.OrderedMap)(),
  plateProperties: (0,external_immutable_.Map)(),
  runColumns: (0,external_immutable_.OrderedMap)(),
  runId: undefined,
  runProperties: (0,external_immutable_.Map)(),
  runName: undefined,
  queryInfo: undefined,
  selectedSamples: undefined,
  toDelete: undefined,
  usePreviousRunFile: false,
  jobDescription: undefined,
  jobNotificationProvider: undefined,
  forceAsync: false,
  workflowTask: undefined
}) {
  isFilesTab(currentStep) {
    return currentStep === AssayUploadTabs.Files;
  }
  isGridTab(currentStep) {
    return currentStep === AssayUploadTabs.Grid;
  }
  getAttachedFiles() {
    return this.attachedFiles.valueSeq().toArray();
  }
  getTotalAttachedFilesSize() {
    return this.attachedFiles.reduce((totalSize, file) => totalSize + file.size, 0);
  }
  getResultsFiles() {
    return this.resultsFiles.valueSeq().toArray();
  }
  getTotalResultsFilesSize() {
    return this.resultsFiles.reduce((totalSize, file) => totalSize + file.size, 0);
  }
  getRunName(currentStep) {
    if (this.runName) {
      return this.runName;
    }
    if (this.isFilesTab(currentStep)) {
      // Issue 39328: set assay run to 'undefined' so that the server will fill it in based on the file name
      // note that in the "file already exists so it will be renamed" case, that renamed file name will be used.
      const file = this.getAttachedFiles()[0];
      if (file || this.usePreviousRunFile) {
        return undefined;
      }
    }
    return generateNameWithTimestamp(this.assayDef.name);
  }
  hasData(currentStep, editorModel) {
    if (this.isFilesTab(currentStep)) {
      if (!this.attachedFiles.isEmpty()) {
        return true;
      }
      if (this.runId && this.usePreviousRunFile) {
        return true;
      }
    } else if (this.isGridTab(currentStep)) {
      return editorModel.hasData;
    }
    return false;
  }
  prepareFormData(currentStep, editorModel, queryModel) {
    const {
      batchId,
      batchProperties,
      comment,
      assayDef,
      runProperties,
      runId,
      usePreviousRunFile,
      jobDescription,
      jobNotificationProvider,
      forceAsync,
      workflowTask
    } = this;
    const assayData = {
      assayId: assayDef.id,
      batchId,
      batchProperties: batchProperties.toObject(),
      comment,
      name: this.getRunName(currentStep),
      properties: runProperties.toObject(),
      reRunId: runId,
      saveDataAsFile: true,
      jobDescription,
      jobNotificationProvider,
      forceAsync,
      workflowTask
    };
    Object.keys(assayData).forEach(k => {
      if (assayData[k] === undefined) {
        delete assayData[k];
      }
    });
    if (this.isFilesTab(currentStep)) {
      assayData.files = this.getAttachedFiles();
      assayData.resultsFiles = this.getResultsFiles();
      if (runId !== undefined && usePreviousRunFile && assayData.files.length === 0) {
        const url = runProperties.get('DataOutputs/DataFileUrl');
        if (url) {
          const filesIndex = url.indexOf('@files');
          // get past the @files and the trailing slash
          assayData.runFilePath = url.substring(filesIndex + 7);
          if (assayData.runFilePath.toLowerCase().endsWith('.tmp')) {
            // Issue 47509: if the original run was imported via the editable grid,
            // the sample Ids will be rowIds so set allowLookupByAlternateKey to false
            assayData.allowLookupByAlternateKey = false;
          }
        }
      }
    } else if (this.isGridTab(currentStep)) {
      // need to get the EditorModel for the data to use in the import
      assayData.dataRows = editorModel.getRawDataFromModel(queryModel, false, false).valueSeq().map(row => row.filter(v => v !== undefined && v !== null && ('' + v).trim() !== '')).toList().toJS();

      // Issue 47509: the editable grid will always use key values (i.e. RowIds) for lookups, so set allowLookupByAlternateKey to false
      assayData.allowLookupByAlternateKey = false;
    } else {
      throw new Error('Unsupported upload step! Current step: "' + currentStep + '"');
    }

    // remove the "DataOutputs/DataFileUrl" from properties as it causes failures in AssayRunUploadContextImpl.addVocabularyProperties()
    if (assayData.properties['DataOutputs/DataFileUrl']) {
      delete assayData.properties['DataOutputs/DataFileUrl'];
    }
    return assayData;
  }
  getInitialQueryModelData() {
    const {
      assayDef,
      selectedSamples
    } = this;
    const sampleColumnData = assayDef.getSampleColumn();
    const sampleColInResults = sampleColumnData && sampleColumnData.domain === AssayDomainTypes.RESULT;
    const hasSamples = sampleColInResults && selectedSamples;
    // We only care about passing samples to the data grid if there is a sample column in the results domain.
    const rows = hasSamples ? selectedSamples.toJS() : {};
    return {
      rows,
      orderedRows: Object.keys(rows),
      queryInfo: this.queryInfo
    };
  }

  /**
   * This method instantiates the initial data used in the editable grid during assay upload, it includes data for
   * an EditorModel and QueryModel.
   */
  async getInitialGridData() {
    const queryModelData = this.getInitialQueryModelData();
    const editorModelData = await loadEditorModelData(queryModelData);
    return {
      editorModel: editorModelData,
      queryModel: queryModelData
    };
  }
}
;// CONCATENATED MODULE: ./src/internal/components/assay/BatchPropertiesPanel.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





const BatchPropertiesPanel = (0,external_react_.memo)(({
  model,
  onChange,
  operation
}) => {
  if (model.batchColumns.size === 0) {
    return null;
  }

  // FIXME: Update the AssayWizardModel to use ExtendedMap for batchColumns so we don't need to do this conversion.
  const queryColumns = (0,external_react_.useMemo)(() => new ExtendedMap(model.batchColumns.toJS()), [model.batchColumns]);
  const disabled = model.batchId !== undefined;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Batch Details"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/external_react_default().createElement((external_formsy_react_default()), {
    className: "form-horizontal",
    onChange: onChange,
    disabled: disabled
  }, /*#__PURE__*/external_react_default().createElement(QueryFormInputs, {
    containerFilter: getContainerFilterForLookups(),
    fieldValues: model.batchProperties.toObject(),
    operation: operation,
    queryColumns: queryColumns,
    renderFileInputs: true
  }))));
});
BatchPropertiesPanel.displayName = 'BatchPropertiesPanel';
;// CONCATENATED MODULE: ./src/internal/components/assay/ImportWithRenameConfirmModal.tsx


const ImportWithRenameConfirmModal = (0,external_react_.memo)(props => {
  const {
    folderType,
    newName,
    onConfirm,
    onCancel,
    originalName
  } = props;
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    title: "Rename duplicate file?",
    onConfirm: onConfirm,
    onCancel: onCancel,
    confirmText: "Import and Rename"
  }, /*#__PURE__*/external_react_default().createElement("p", null, "A file named ", /*#__PURE__*/external_react_default().createElement("span", {
    className: "import-rename-filename"
  }, originalName), " already exists in this", ' ', folderType, " folder."), /*#__PURE__*/external_react_default().createElement("p", null, "To import this file, either give it a new name or it will be renamed to the following on import:"), /*#__PURE__*/external_react_default().createElement("p", null, /*#__PURE__*/external_react_default().createElement("span", {
    className: "import-rename-filename"
  }, newName)));
});
;// CONCATENATED MODULE: ./src/internal/components/assay/PlatePropertiesPanel.tsx








const PlatePropertiesPanel = (0,external_react_.memo)(({
  model,
  onChange,
  operation
}) => {
  // FIXME: Update the AssayWizardModel to use ExtendedMap for plateColumns so we don't need to do this conversion.
  const queryColumns = (0,external_react_.useMemo)(() => new ExtendedMap(model.plateColumns.toJS()), [model.plateColumns]);
  const queryFilters = (0,external_react_.useMemo)(() => ({
    [PLATE_SET_COLUMN]: external_immutable_.List.of(api_.Filter.create('Archived', false), api_.Filter.create('Type', 'assay'))
  }), []);
  if (queryColumns.size === 0) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Plate Details"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/external_react_default().createElement((external_formsy_react_default()), {
    className: "form-horizontal",
    onChange: onChange
  }, /*#__PURE__*/external_react_default().createElement(QueryFormInputs, {
    containerFilter: getContainerFilterForLookups(),
    fieldValues: model.plateProperties.toObject(),
    operation: operation,
    queryColumns: queryColumns,
    queryFilters: queryFilters,
    renderFileInputs: true
  }))));
});
PlatePropertiesPanel.displayName = 'PlatePropertiesPanel';
;// CONCATENATED MODULE: ./src/internal/components/assay/RunDataPanel.tsx
function RunDataPanel_defineProperty(e, r, t) { return (r = RunDataPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function RunDataPanel_toPropertyKey(t) { var i = RunDataPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function RunDataPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

















const TABS = ['Enter Data into Grid', 'Import Data from File'];
const PREVIEW_ROW_COUNT = 3;
const ASSAY_RESULTS_DATA_TOOLTIP = /*#__PURE__*/external_react_default().createElement("p", null, "Click to select your assay data file or drag and drop it directly onto the upload area.", /*#__PURE__*/external_react_default().createElement("br", null), "This is the data file that contains one row per assay result.");
const RESULTS_FILE_SIZE_LIMIT_DISPLAY = '200MB';
const RESULTS_FILE_SIZE_LIMITS = (0,external_immutable_.Map)({
  all: {
    totalSize: {
      value: 209715200,
      // initial total file size limit set to 200MB (ex. 384 well plate of ab1 sequence files that are 300KB each = 115.2MB)
      displayValue: RESULTS_FILE_SIZE_LIMIT_DISPLAY
    }
  }
});
class RunDataPanel extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    RunDataPanel_defineProperty(this, "isRerun", () => {
      return this.props.wizardModel.runId !== undefined;
    });
    RunDataPanel_defineProperty(this, "initPreviewData", () => {
      const {
        previousRunData
      } = this.state;
      const {
        wizardModel,
        runPropertiesRow
      } = this.props;
      if (!this.isRerun() || !previousRunData || previousRunData.isLoaded || previousRunData.isLoading) {
        return;
      }
      if (wizardModel.isInit && wizardModel.usePreviousRunFile) {
        if (runPropertiesRow && runPropertiesRow['DataOutputs']) {
          const outputFiles = runPropertiesRow['DataOutputs/DataFileUrl'];
          if (outputFiles?.length === 1) {
            const outputs = runPropertiesRow['DataOutputs'];
            this.setState(() => ({
              previousRunData: {
                isLoading: true,
                isLoaded: false
              }
            }));
            getServerFilePreview(outputs[0].value, outputs[0].displayValue, PREVIEW_ROW_COUNT).then(response => {
              this.setState(() => ({
                previousRunData: {
                  isLoaded: true,
                  data: response,
                  fileName: getRunPropertiesFileName(runPropertiesRow)
                }
              }));
            }).catch(reason => {
              this.setState(() => ({
                message: getActionErrorMessage("There was a problem retrieving the current run's data for previewing. ", 'assay run'),
                messageStyle: 'danger',
                previousRunData: {
                  isLoaded: true
                }
              }));
            });
          } else {
            let message = 'No preview data available for the current run.';
            if (outputFiles.size > 1) {
              message += '  There are ' + outputFiles.size + ' output files for this run. Preview is not currently supported for multiple files.';
            }
            this.setState(() => ({
              message,
              messageStyle: 'info',
              previousRunData: {
                isLoaded: true
              }
            }));
          }
        }
      }
    });
    RunDataPanel_defineProperty(this, "resetMessage", () => {
      this.setState(() => ({
        message: undefined
      }));
    });
    RunDataPanel_defineProperty(this, "onDataFileChange", attachments => {
      this.setState(() => ({
        message: undefined
      }), () => this.props.onDataFileChange(attachments));
    });
    RunDataPanel_defineProperty(this, "onDataFileRemove", attachmentName => {
      this.setState(() => ({
        message: undefined,
        previousRunData: undefined
      }), () => this.props.onDataFileRemoval(attachmentName));
    });
    RunDataPanel_defineProperty(this, "onTabChange", () => {
      this.resetMessage();
    });
    RunDataPanel_defineProperty(this, "getEditableGridColumnMetadata", () => {
      const {
        wizardModel,
        plateSupportEnabled
      } = this.props;
      const selectedPlateSet = wizardModel.runProperties?.get('PlateSet');
      if (!plateSupportEnabled || !selectedPlateSet) return undefined;
      return (0,external_immutable_.Map)({
        Plate: {
          lookupValueFilters: [api_.Filter.create('PlateSet', selectedPlateSet)]
        }
      });
    });
    this.state = {
      previousRunData: props.wizardModel.usePreviousRunFile ? {
        isLoaded: false
      } : undefined
    };
  }
  componentDidMount() {
    this.initPreviewData();
  }
  componentDidUpdate(prevProps) {
    const {
      wizardModel
    } = this.props;
    if (prevProps.wizardModel.runId !== wizardModel.runId) {
      this.setState(() => ({
        previousRunData: wizardModel.usePreviousRunFile ? {
          isLoaded: false
        } : undefined
      }));
    } else {
      this.initPreviewData();
    }
  }
  render() {
    const {
      acceptedPreviewFileFormats,
      allowBulkInsert,
      allowBulkRemove,
      allowBulkUpdate,
      currentStep,
      editorModel,
      maxEditableGridRowMsg,
      queryModel,
      showTabs,
      wizardModel,
      getIsDirty,
      setIsDirty,
      onResultsFileChange,
      onResultsFileRemoval
    } = this.props;
    const {
      message,
      messageStyle,
      previousRunData
    } = this.state;
    const isLoading = !wizardModel.isInit || queryModel.isLoading;
    const isLoadingPreview = previousRunData && !previousRunData.isLoaded;
    const columnMetadata = this.getEditableGridColumnMetadata();
    const fileColumnNames = isLIMSEnabled() ? wizardModel.assayDef.getDomainFileColumns(AssayDomainTypes.RESULT)?.map(col => col.name) : undefined;
    const assayFileFieldTooltip = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("p", null, "Click to select your assay results file field(s) data files or drag and drop them directly onto the upload area. The total file size limit is ", RESULTS_FILE_SIZE_LIMIT_DISPLAY, ".", /*#__PURE__*/external_react_default().createElement("br", null), "These are the files that contain additional data for each assay result. The results data above should include columns that references these files by file name."), /*#__PURE__*/external_react_default().createElement("p", null, "The current assay design has the following result file fields: ", /*#__PURE__*/external_react_default().createElement("b", null, fileColumnNames?.join(', ')), "."));
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel panel-default"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-heading"
    }, "Results"), /*#__PURE__*/external_react_default().createElement("div", {
      className: "panel-body"
    }, isLoading ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null) : /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, showTabs && /*#__PURE__*/external_react_default().createElement(FormTabs, {
      tabs: TABS,
      onTabChange: this.onTabChange
    }), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-sm-12"
    }, /*#__PURE__*/external_react_default().createElement(FormStep, {
      stepIndex: AssayUploadTabs.Grid
    }, /*#__PURE__*/external_react_default().createElement(EditableGridPanel, {
      addControlProps: {
        placement: 'top',
        nounPlural: 'rows',
        nounSingular: 'row',
        invalidCountMsg: maxEditableGridRowMsg
      },
      allowBulkAdd: allowBulkInsert,
      allowBulkRemove: allowBulkRemove,
      allowBulkUpdate: allowBulkUpdate,
      bordered: true,
      bulkAddText: "Bulk Insert",
      bulkAddProps: {
        title: 'Bulk Insert Assay Rows',
        header: 'Add a batch of assay data rows that will share the properties set below.'
      },
      columnMetadata: columnMetadata,
      containerFilter: getContainerFilterForLookups(),
      disabled: currentStep !== AssayUploadTabs.Grid,
      editorModel: editorModel,
      emptyGridMsg: "Start by adding the quantity of assay data rows you want to create.",
      isSubmitting: wizardModel.isSubmitting,
      lockLeftOnScroll: false,
      maxRows: this.props.maxRows,
      metricFeatureArea: "assayResultsEditableGrid",
      model: queryModel,
      onChange: this.props.onGridChange,
      striped: true,
      getIsDirty: getIsDirty,
      setIsDirty: setIsDirty
    })), /*#__PURE__*/external_react_default().createElement(FormStep, {
      stepIndex: AssayUploadTabs.Files
    }, isLoadingPreview ? /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null) : /*#__PURE__*/external_react_default().createElement(FileAttachmentForm, {
      key: wizardModel.lastRunId + '-dataFile' // required for rerender in the "save and import another" case
      ,
      allowDirectories: false,
      allowMultiple: false,
      showLabel: fileColumnNames?.length > 0,
      label: /*#__PURE__*/external_react_default().createElement("div", {
        className: "assay-data-file-label"
      }, /*#__PURE__*/external_react_default().createElement(LabelOverlay, {
        label: "Results Data"
      }, ASSAY_RESULTS_DATA_TOOLTIP)),
      initialFileNames: previousRunData && previousRunData.fileName ? [previousRunData.fileName] : [],
      onFileChange: this.onDataFileChange,
      onFileRemoval: this.onDataFileRemove,
      templateUrl: wizardModel.assayDef.templateLink,
      previewGridProps: acceptedPreviewFileFormats && {
        header: 'Data Preview:',
        previewCount: PREVIEW_ROW_COUNT,
        acceptedFormats: acceptedPreviewFileFormats,
        initialData: previousRunData ? previousRunData.data : undefined
      },
      sizeLimits: this.props.fileSizeLimits,
      sizeLimitsHelpText: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "We recommend dividing your data into smaller files that meet this limit. See our", ' ', /*#__PURE__*/external_react_default().createElement(HelpLink, {
        topic: DATA_IMPORT_TOPIC
      }, "help document"), " for best practices on data import.")
    }), fileColumnNames?.length > 0 && /*#__PURE__*/external_react_default().createElement("div", {
      className: "top-spacing"
    }, /*#__PURE__*/external_react_default().createElement(FileAttachmentForm, {
      key: wizardModel.lastRunId + '-resultsFiles',
      index: 1 // this is so that the file input doesn't interfere with the data file FileAttachmentForm
      ,
      allowDirectories: true,
      includeDirectoryFiles: true,
      fileCountSuffix: "will be uploaded",
      allowMultiple: true,
      sizeLimits: RESULTS_FILE_SIZE_LIMITS,
      label: /*#__PURE__*/external_react_default().createElement("div", {
        className: "assay-data-file-label"
      }, /*#__PURE__*/external_react_default().createElement(LabelOverlay, {
        label: "File Fields Data"
      }, assayFileFieldTooltip)),
      labelLong: "Select file(s) or drag and drop here",
      onFileChange: onResultsFileChange,
      onFileRemoval: onResultsFileRemoval
    }))))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "top-spacing"
    }, /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: messageStyle
    }, message)))));
  }
}
RunDataPanel_defineProperty(RunDataPanel, "defaultProps", {
  allowBulkRemove: false,
  allowBulkInsert: false,
  allowBulkUpdate: false,
  showTabs: true
});
;// CONCATENATED MODULE: ./src/internal/components/assay/RunPropertiesPanel.tsx
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










const NAME_LABEL = /*#__PURE__*/external_react_default().createElement(LabelOverlay, {
  description: "The assay/experiment ID that uniquely identifies this assay run.",
  label: "Assay ID",
  type: "Text (String)"
});
const COMMENT_LABEL = /*#__PURE__*/external_react_default().createElement(LabelOverlay, {
  description: "Contains comments about this run",
  label: "Comments",
  type: "Text (String)"
});
const RunPropertiesPanel = (0,external_react_.memo)(({
  model,
  onChange,
  onWorkflowTaskChange,
  operation
}) => {
  const {
    moduleContext
  } = useServerContext();
  // FIXME: Update the AssayWizardModel to use ExtendedMap for runColumns so we don't need to do this conversion.
  const queryColumns = (0,external_react_.useMemo)(() => new ExtendedMap(model.runColumns.toJS()), [model.runColumns]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Run Details"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/external_react_default().createElement((external_formsy_react_default()), {
    className: "form-horizontal",
    onChange: onChange
  }, /*#__PURE__*/external_react_default().createElement(FormsyInput, {
    id: "runname",
    label: NAME_LABEL,
    labelClassName: "text-left",
    name: "runname",
    value: model.runName
  }), /*#__PURE__*/external_react_default().createElement(FormsyTextArea, {
    cols: 60,
    id: "comment",
    label: COMMENT_LABEL,
    labelClassName: "text-left",
    name: "comment",
    rows: 2,
    value: model.comment
  }), isWorkflowEnabled(moduleContext) && /*#__PURE__*/external_react_default().createElement(AssayTaskInput, {
    assayId: model.assayDef.id,
    containerFilter: getContainerFilterForLookups(),
    formsy: true,
    name: "workflowtask",
    value: model.workflowTask,
    onChange: onWorkflowTaskChange
  }), model.runColumns.size !== 0 && /*#__PURE__*/external_react_default().createElement(QueryFormInputs, {
    containerFilter: getContainerFilterForLookups(),
    fieldValues: model.runProperties.toObject(),
    operation: operation,
    queryColumns: queryColumns,
    renderFileInputs: true
  }))));
});
RunPropertiesPanel.displayName = 'RunPropertiesPanel';
;// CONCATENATED MODULE: ./src/internal/components/assay/AssayImportPanels.tsx
function AssayImportPanels_extends() { return AssayImportPanels_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, AssayImportPanels_extends.apply(null, arguments); }
function AssayImportPanels_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AssayImportPanels_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AssayImportPanels_ownKeys(Object(t), !0).forEach(function (r) { AssayImportPanels_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AssayImportPanels_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function AssayImportPanels_defineProperty(e, r, t) { return (r = AssayImportPanels_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function AssayImportPanels_toPropertyKey(t) { var i = AssayImportPanels_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function AssayImportPanels_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








































const BASE_FILE_TYPES = ['.csv', '.tsv', '.txt', '.xlsx', '.xls'];
const BATCH_PROPERTIES_GRID_ID = 'assay-batch-details';
const DATA_GRID_ID = 'assay-grid-data';
const IMPORT_ERROR_ID = 'assay-import-error';
class AssayImportPanelsBody extends external_react_.Component {
  constructor(props) {
    super(props);
    AssayImportPanels_defineProperty(this, "assayUploadTimer", void 0);
    AssayImportPanels_defineProperty(this, "isReimport", () => {
      return this.props.runId !== undefined;
    });
    AssayImportPanels_defineProperty(this, "getRunPropsQueryModel", () => {
      return this.props.queryModels.model;
    });
    AssayImportPanels_defineProperty(this, "getRunPropertiesMap", () => {
      const {
        searchParams
      } = this.props;
      let runProperties = flattenQueryModelRow(this.getRunPropsQueryModel().getRow());

      // Issue 38711: Need to pre-populate the run properties form with assayRequest if it is present on the URL
      if (searchParams.get('assayRequest')) {
        runProperties = runProperties.set('assayRequest', searchParams.get('assayRequest'));
      }
      if (searchParams.get('plateSet')) {
        runProperties = runProperties.set(PLATE_SET_COLUMN, searchParams.get('plateSet'));
      }
      return runProperties;
    });
    AssayImportPanels_defineProperty(this, "getBatchId", () => {
      return this.getRunPropsQueryModel().getRowValue('Batch');
    });
    AssayImportPanels_defineProperty(this, "getBatchPropsQueryModel", () => {
      return this.props.queryModels[BATCH_PROPERTIES_GRID_ID];
    });
    AssayImportPanels_defineProperty(this, "getBatchPropertiesMap", () => {
      const model = this.getBatchPropsQueryModel();
      return flattenQueryModelRow(model?.getRow());
    });
    AssayImportPanels_defineProperty(this, "runAndBatchPropsLoaded", () => {
      // if not reimporting, we don't need batch/run properties to display in the form
      const runQueryModel = this.getRunPropsQueryModel();
      const batchQueryModel = this.getBatchPropsQueryModel();
      return !this.isReimport() || runQueryModel && !runQueryModel.isLoading && batchQueryModel && !batchQueryModel.isLoading;
    });
    AssayImportPanels_defineProperty(this, "initModel", async () => {
      const {
        assayDefinition,
        searchParams,
        runId
      } = this.props;
      const {
        schemaQuery
      } = this.state;
      let plateProperties = (0,external_immutable_.Map)();
      let workflowTask;
      if (searchParams.get('workflowTaskId')) {
        const _workflowTask = parseInt(searchParams.get('workflowTaskId'), 10);
        workflowTask = isNaN(_workflowTask) ? undefined : _workflowTask;
      }
      const batchQueryInfo = await getQueryDetails(new SchemaQuery(assayDefinition.protocolSchemaName, 'Batches'));
      const runQueryInfo = await getQueryDetails(new SchemaQuery(assayDefinition.protocolSchemaName, 'Runs'));
      const dataQueryInfo = await getQueryDetails(schemaQuery);
      const {
        plateColumns,
        runColumns
      } = this.getRunColumns(runQueryInfo);
      const runProperties = this.getRunPropertiesMap();
      if (this.plateSupportEnabled && runProperties.get(PLATE_SET_COLUMN)) {
        plateProperties = plateProperties.set(PLATE_SET_COLUMN, runProperties.get(PLATE_SET_COLUMN));
      }
      this.setState({
        model: new AssayWizardModel({
          // Initialization is done if the assay does not have a sample column and we aren't getting the
          // run properties to show for reimport
          isInit: assayDefinition.getSampleColumn() === undefined && this.runAndBatchPropsLoaded(),
          assayDef: assayDefinition,
          batchColumns: this.getDomainColumns(AssayDomainTypes.BATCH, batchQueryInfo),
          plateColumns,
          plateProperties,
          runColumns,
          runId,
          usePreviousRunFile: this.isReimport(),
          batchProperties: this.getBatchPropertiesMap(),
          runProperties,
          queryInfo: dataQueryInfo,
          workflowTask
        })
      }, this.onGetQueryDetailsComplete);
    });
    AssayImportPanels_defineProperty(this, "getDomainColumns", (domainType, queryInfo) => {
      // Issue 47576: if there are wrapped columns that are marked as userEditable and shownInInsertView, include them in the form / UI
      const {
        assayDefinition
      } = this.props;
      let columns = assayDefinition.getDomainColumns(domainType);
      queryInfo?.columns.forEach(c => {
        const shouldInclude = c.wrappedColumnName && c.userEditable && c.shownInInsertView;
        if (shouldInclude) columns = columns.set(c.fieldKey.toLowerCase(), c);
      });
      return columns;
    });
    AssayImportPanels_defineProperty(this, "getRunColumns", runQueryInfo => {
      let runColumns = this.getDomainColumns(AssayDomainTypes.RUN, runQueryInfo);
      let plateColumns = (0,external_immutable_.OrderedMap)();
      if (this.plateSupportEnabled) {
        const plateTemplateFieldKey = PLATE_TEMPLATE_COLUMN.toLowerCase();
        if (runColumns.has(plateTemplateFieldKey)) {
          runColumns = runColumns.remove(plateTemplateFieldKey);
        }
        const plateSetFieldKey = PLATE_SET_COLUMN.toLowerCase();
        if (runColumns.has(plateSetFieldKey)) {
          plateColumns = plateColumns.set(plateSetFieldKey, runColumns.get(plateSetFieldKey));
          runColumns = runColumns.remove(plateSetFieldKey);
        }
      }
      return {
        plateColumns,
        runColumns
      };
    });
    AssayImportPanels_defineProperty(this, "ensureRunAndBatchProperties", () => {
      const {
        isInit,
        queryInfo
      } = this.state.model;
      if (!isInit && queryInfo && this.isReimport() && this.runAndBatchPropsLoaded()) {
        // if this is a re-import and the batch/run props are now loaded, put them into the state model
        this.setState(state => ({
          model: state.model.merge({
            isInit: true,
            batchProperties: this.getBatchPropertiesMap(),
            runProperties: this.getRunPropertiesMap()
          })
        }), this.onInitModelComplete);
      }
    });
    AssayImportPanels_defineProperty(this, "onGetQueryDetailsComplete", async () => {
      const {
        assayDefinition,
        searchParams
      } = this.props;
      const sampleColumnData = assayDefinition.getSampleColumn();
      let sampleStatusWarning;
      const modelUpdates = {
        batchProperties: this.getBatchPropertiesMap(),
        isInit: this.runAndBatchPropsLoaded(),
        runProperties: this.getRunPropertiesMap()
      };
      let hasValidSamples = false;
      if (sampleColumnData) {
        try {
          // If the assay has a sample column look up at Batch, Run, or Result level then we want to retrieve
          // the currently selected samples so we can pre-populate the fields in the wizard with the selected
          // samples.
          // Additionally, we want to pre-populate the fields in the wizard with samples if the job has samples
          // associated with it, and the assay has a sample column.
          const {
            column,
            domain
          } = sampleColumnData;
          const samples = await this.props.loadSelectedSamples(searchParams, column);
          const statusConfirmationData = await getSampleOperationConfirmationData(SampleOperation.AddAssayData, samples.keySeq().toArray());

          // Only one sample can be added at batch or run level, so ignore selected samples if multiple are selected.
          const validSamples = samples.filter((_, key) => statusConfirmationData.isIdActionable(key)).toOrderedMap();
          if (validSamples.size === 1) {
            const sampleValue = validSamples.first().getIn([column.fieldKey, 0]).value;
            if (domain === AssayDomainTypes.RUN) {
              modelUpdates.runProperties = modelUpdates.runProperties.set(column.fieldKey, sampleValue);
            } else if (domain === AssayDomainTypes.BATCH) {
              modelUpdates.batchProperties = modelUpdates.batchProperties.set(column.fieldKey, sampleValue);
            }

            // Note: we do not do anything with the results domain here if samples are selected because that has to
            // be addressed by the AssayGridLoader, which grabs the sample data from the selectedSamples property.
          }
          modelUpdates.selectedSamples = validSamples;
          hasValidSamples = validSamples.size > 0;
          if (samples.size > 0) {
            sampleStatusWarning = getOperationNotAllowedMessage(SampleOperation.AddAssayData, statusConfirmationData);
          }
        } catch (e) {
          this.setState({
            error: STATUS_DATA_RETRIEVAL_ERROR
          });
          return;
        }
      }
      this.setState(state => ({
        model: state.model.merge(modelUpdates),
        sampleStatusWarning
      }), () => this.onInitModelComplete(hasValidSamples));
    });
    AssayImportPanels_defineProperty(this, "onInitModelComplete", async hasSamples => {
      const {
        setIsDirty
      } = this.props;
      const runPropsModel = this.getRunPropsQueryModel();
      const runName = runPropsModel.getRowValue('Name');
      const fileName = getRunPropertiesFileName(runPropsModel.getRow());
      const gridData = await this.state.model.getInitialGridData();
      if (hasSamples) setIsDirty(true);

      // Issue 38237: set the runName and comments for the re-import case
      this.setState(state => {
        const model = state.model.merge({
          runName: this.isReimport() && runName === fileName ? undefined : runName,
          // Issue 39328
          comment: runPropsModel.getRowValue('Comments') ?? ''
        });
        return {
          model,
          dataModel: state.dataModel.mutate(AssayImportPanels_objectSpread(AssayImportPanels_objectSpread({}, gridData.queryModel), {}, {
            queryInfo: model.queryInfo,
            rowsLoadingState: LoadingState.LOADED,
            queryInfoLoadingState: LoadingState.LOADED
          })),
          editorModel: state.editorModel.merge(gridData.editorModel)
        };
      });
    });
    AssayImportPanels_defineProperty(this, "handleDataFileChange", attachments => {
      this.props.setIsDirty?.(attachments.size > 0);
      this.setState(state => ({
        error: undefined,
        model: state.model.merge({
          attachedFiles: attachments,
          usePreviousRunFile: false
        })
      }));
    });
    AssayImportPanels_defineProperty(this, "handleDataFileRemove", () => {
      this.props.setIsDirty?.(false);
      this.setState(state => ({
        error: undefined,
        model: state.model.merge({
          attachedFiles: (0,external_immutable_.Map)(),
          usePreviousRunFile: false
        })
      }));
    });
    AssayImportPanels_defineProperty(this, "handleResultsFileChange", attachments => {
      this.setResultsFiles(attachments);
    });
    AssayImportPanels_defineProperty(this, "handleResultsFileRemove", (_, updatedFiles) => {
      this.setResultsFiles(updatedFiles);
    });
    AssayImportPanels_defineProperty(this, "setResultsFiles", attachments => {
      this.props.setIsDirty?.(true);
      this.setState(state => ({
        model: state.model.merge({
          resultsFiles: attachments
        })
      }));
    });
    AssayImportPanels_defineProperty(this, "handleBatchChange", fieldValues => {
      const values = AssayImportPanels_objectSpread(AssayImportPanels_objectSpread({}, this.state.model.batchProperties.toObject()), fieldValues);
      this.props.setIsDirty?.(true);
      const cleanedValues = Object.keys(values).reduce((result, key) => {
        const value = values[key];
        if (value !== undefined) {
          result[key] = value;
        }
        return result;
      }, {});
      this.handleChange('batchProperties', (0,external_immutable_.OrderedMap)(cleanedValues));
    });
    AssayImportPanels_defineProperty(this, "handleWorkflowTaskChange", (name, value) => {
      this.setState(state => ({
        model: state.model.merge({
          workflowTask: value
        })
      }));
    });
    AssayImportPanels_defineProperty(this, "handleRunChange", (fieldValues, isChanged) => {
      const values = AssayImportPanels_objectSpread(AssayImportPanels_objectSpread({}, this.state.model.runProperties.toObject()), fieldValues);
      let {
        comment,
        runName
      } = this.state.model;
      const cleanedValues = Object.keys(values).reduce((result, key) => {
        const value = values[key];
        if (key === 'runname') {
          runName = value;
        } else if (key === 'comment') {
          comment = value;
        } else if (key !== 'workflowtask' && value !== undefined) {
          result[key] = value;
        }
        return result;
      }, {});
      if (isChanged) this.props.setIsDirty?.(true);
      this.handleChange('runProperties', (0,external_immutable_.OrderedMap)(cleanedValues), () => {
        this.setState(state => ({
          model: state.model.merge({
            runName,
            comment
          })
        }));
      });
    });
    AssayImportPanels_defineProperty(this, "handleDataTextChange", fieldValues => {
      this.props.setIsDirty?.(fieldValues !== undefined && fieldValues !== '');
      // use '' to clear out text area
      this.handleChange('dataText', fieldValues !== undefined ? fieldValues : '');
    });
    AssayImportPanels_defineProperty(this, "handleChange", (prop, value, onComplete) => {
      clearTimeout(this.assayUploadTimer);
      this.assayUploadTimer = window.setTimeout(() => {
        this.assayUploadTimer = null;
        this.setState(state => ({
          model: state.model.set(prop, value)
        }));
        onComplete?.();
      }, 250);
    });
    AssayImportPanels_defineProperty(this, "checkForDuplicateFiles", importAgain => {
      checkForDuplicateAssayFiles(this.state.model.attachedFiles.keySeq().toArray()).then(response => {
        if (response.duplicate) {
          this.setState({
            duplicateFileResponse: response,
            importAgain,
            showRenameModal: true
          });
        } else {
          this.onFinish(importAgain);
        }
      }).catch(() => {
        this.setState({
          error: getActionErrorMessage('There was a problem checking for duplicate file names.', 'assay run')
        });
      });
    });
    AssayImportPanels_defineProperty(this, "save", importAgain => {
      if (this.state.model.isFilesTab(this.props.currentStep)) {
        this.checkForDuplicateFiles(importAgain);
      } else {
        this.onFinish(importAgain);
      }
    });
    AssayImportPanels_defineProperty(this, "onImport", () => this.save(false));
    AssayImportPanels_defineProperty(this, "onSaveAndImportAgain", () => this.save(true));
    AssayImportPanels_defineProperty(this, "getBackgroundJobDescription", options => {
      const {
        assayDefinition
      } = this.props;
      return assayDefinition.name + (options.name ? ' - ' + options.name : '');
    });
    AssayImportPanels_defineProperty(this, "onFinish", async importAgain => {
      const {
        currentStep,
        onSave,
        jobNotificationProvider,
        assayProtocol,
        searchParams,
        dismissNotifications
      } = this.props;
      const {
        model,
        comment
      } = this.state;
      const data = model.prepareFormData(currentStep, this.state.editorModel, this.state.dataModel);
      this.setModelState(true, undefined);
      dismissNotifications();
      try {
        const processedData = await uploadAssayRunFiles(data);
        const backgroundUpload = assayProtocol?.backgroundUpload;
        let forceAsync = false;
        if (!backgroundUpload && assayProtocol?.allowBackgroundUpload) {
          const useAsync = searchParams.get('useAsync') === 'true';
          const asyncFileSize = useAsync ? 1 : BACKGROUND_IMPORT_MIN_FILE_SIZE;
          const asyncRowSize = useAsync ? 1 : BACKGROUND_IMPORT_MIN_ROW_SIZE;
          if (processedData.maxFileSize && processedData.maxFileSize >= asyncFileSize || processedData.maxRowCount && processedData.maxRowCount >= asyncRowSize) {
            forceAsync = true;
          }
        }
        const response = await importAssayRun(AssayImportPanels_objectSpread(AssayImportPanels_objectSpread({}, processedData), {}, {
          forceAsync,
          jobDescription: this.getBackgroundJobDescription(data),
          jobNotificationProvider,
          auditUserComment: comment
        }));
        this.props.setIsDirty?.(false);
        if (importAgain && onSave) {
          this.onSuccessContinue(response, backgroundUpload || forceAsync);
        } else {
          this.onSuccessComplete(response, data, backgroundUpload || forceAsync);
        }
      } catch (e) {
        let error;
        const errorPrefix = 'There was a problem importing the assay results.';
        const message = resolveErrorMessage(e);
        if (message) {
          error = `${errorPrefix} ${message}`;
        } else {
          error = getActionErrorMessage(errorPrefix, 'referenced samples or assay design', false);
        }
        this.setModelState(false, error);
      }
    });
    AssayImportPanels_defineProperty(this, "onSuccessContinue", async (response, isAsync) => {
      this.props.onSave?.(response, isAsync);
      const initialGridData = await this.state.model.getInitialGridData();

      // Reset the data for the AssayWizardModel and dataModel
      this.setState(state => {
        const model = state.model.merge({
          batchId: response.batchId,
          lastRunId: response.runId,
          isSubmitting: false,
          comment: '',
          // textarea doesn't clear for undefined
          dataText: '',
          runName: undefined,
          attachedFiles: (0,external_immutable_.Map)(),
          runProperties: (0,external_immutable_.Map)()
          // Note: leave batchProperties alone since those are preserved in this case
        });
        const dataModel = state.dataModel.mutate(initialGridData.queryModel);
        const editorModel = state.editorModel.merge(initialGridData.editorModel);
        return {
          dataModel,
          editorModel,
          model
        };
      });
    });
    AssayImportPanels_defineProperty(this, "onSuccessComplete", (response, data, isAsync) => {
      this.setModelState(false, undefined);
      this.props.onComplete(response, isAsync, data.properties[PLATE_SET_COLUMN]);
    });
    AssayImportPanels_defineProperty(this, "setModelState", (isSubmitting, errorMsg) => {
      this.setState(state => ({
        error: errorMsg,
        model: state.model.merge({
          isSubmitting
        })
      }), () => {
        if (errorMsg) {
          document.querySelector('#' + IMPORT_ERROR_ID)?.scrollIntoView();
        }
      });
    });
    AssayImportPanels_defineProperty(this, "getProgressSizeEstimate", () => {
      const {
        model
      } = this.state;
      if (!model.isSubmitting) {
        return;
      }
      const data = model.prepareFormData(this.props.currentStep, this.state.editorModel, this.state.dataModel);
      if (data.files?.length > 0) {
        // the data file (i.e. attachedFiles) will be processed so the size of the file gets much greater weight
        // than the results files that just need to be sent to the server and saved to the file system
        return model.getTotalAttachedFilesSize() / 5 + model.getTotalResultsFilesSize() / 100_000;
      } else if (data.dataRows) {
        if (api_.Utils.isArray(data.dataRows)) {
          return data.dataRows.length * 10;
        } else if (data.dataRows.size) {
          return data.dataRows.size * 10;
        }
      }
    });
    AssayImportPanels_defineProperty(this, "onCancelRename", () => {
      this.setState({
        showRenameModal: false,
        duplicateFileResponse: undefined,
        importAgain: undefined
      });
    });
    AssayImportPanels_defineProperty(this, "onRenameConfirm", () => {
      const {
        importAgain
      } = this.state;
      this.setState({
        showRenameModal: false,
        duplicateFileResponse: undefined,
        importAgain: undefined
      }, () => this.onFinish(importAgain));
    });
    AssayImportPanels_defineProperty(this, "onCommentChange", comment => {
      this.setState({
        comment
      });
    });
    AssayImportPanels_defineProperty(this, "onGridChange", (event, editorModelChanges, dataKeys, data) => {
      this.setState(state => {
        const {
          dataModel,
          editorModel
        } = state;
        const updatedModels = applyEditableGridChangesToModels([dataModel], [editorModel], editorModelChanges, undefined, dataKeys, data);
        this.props.setIsDirty?.(true);
        return {
          dataModel: updatedModels.dataModels[0],
          editorModel: updatedModels.editorModels[0]
        };
      });
    });
    const _schemaQuery = new SchemaQuery(props.assayDefinition.protocolSchemaName, 'Data');
    this.state = {
      comment: undefined,
      dataModel: new QueryModel({
        id: DATA_GRID_ID,
        schemaQuery: _schemaQuery
      }),
      editorModel: new EditorModel({
        id: DATA_GRID_ID
      }),
      error: undefined,
      model: new AssayWizardModel({
        isInit: false,
        runId: props.runId
      }),
      schemaQuery: _schemaQuery,
      showRenameModal: false,
      sampleStatusWarning: undefined
    };
  }
  componentDidMount() {
    const {
      searchParams,
      selectStep
    } = this.props;
    if (searchParams.get('dataTab')) {
      selectStep(parseInt(searchParams.get('dataTab'), 10));
    }
    this.initModel();
  }
  componentDidUpdate() {
    const {
      queryModels,
      actions,
      assayDefinition
    } = this.props;
    const batchId = this.getBatchId();
    if (!queryModels[BATCH_PROPERTIES_GRID_ID] && batchId) {
      actions.addModel({
        id: BATCH_PROPERTIES_GRID_ID,
        keyValue: batchId,
        schemaQuery: new SchemaQuery(assayDefinition.protocolSchemaName, 'Batches'),
        requiredColumns: SCHEMAS.CBMB.concat('Name', 'RowId').toArray()
      }, true);
    }
    this.ensureRunAndBatchProperties();
  }
  get plateSupportEnabled() {
    return isPlatesEnabled() && this.props.assayProtocol.plateMetadata === true;
  }
  render() {
    const {
      container,
      currentStep,
      onCancel,
      requiresUserComment,
      acceptedPreviewFileFormats,
      allowBulkRemove,
      allowBulkInsert,
      allowBulkUpdate,
      maxRows,
      onSave,
      showUploadTabs,
      fileSizeLimits,
      user,
      getIsDirty,
      setIsDirty
    } = this.props;
    const {
      comment,
      dataModel,
      duplicateFileResponse,
      editorModel,
      model,
      showRenameModal,
      sampleStatusWarning
    } = this.state;
    const runPropsModel = this.getRunPropsQueryModel();
    const resultsFilesCount = model.getResultsFiles().length;
    if (!model.isInit || runPropsModel.isLoading) {
      return /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
    } else if (runPropsModel.hasLoadErrors) {
      return /*#__PURE__*/external_react_default().createElement(Alert, null, /*#__PURE__*/external_react_default().createElement("ul", null, runPropsModel.loadErrors.map((error, i) => /*#__PURE__*/external_react_default().createElement("li", {
        key: i
      }, error))));
    }
    const isReimport = this.isReimport();
    const operation = isReimport ? Operation.update : Operation.insert;
    const runContainerId = runPropsModel.getRowValue('Folder');
    const folderNoun = isPremiumProductEnabled() ? 'project' : 'folder';
    const plateSupportEnabled = this.plateSupportEnabled;
    if (isReimport && !allowReimportAssayRun(user, runContainerId, container.id)) {
      const runName = runPropsModel.getRowValue('Name');
      return /*#__PURE__*/external_react_default().createElement(Alert, null, "The run \"", runName, "\" cannot be re-imported into this $", folderNoun, ". This run is declared in a different $", folderNoun, " and re-import of runs is only supported within the same $", folderNoun, ".");
    }
    const showSaveAgainBtn = !isReimport && onSave !== undefined;
    const disabledSave = model.isSubmitting || !model.hasData(currentStep, editorModel) || !isReimport && !!getIsDirty && !getIsDirty?.() || isReimport && requiresUserComment && !comment?.trim()?.length;
    const runProps = runPropsModel.getRow();
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, isReimport && /*#__PURE__*/external_react_default().createElement(AssayReimportHeader, {
      assay: model.assayDef,
      replacedRunProperties: runProps,
      hasBatchProperties: model.batchColumns.size > 0
    }), /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "warning"
    }, sampleStatusWarning), /*#__PURE__*/external_react_default().createElement(BatchPropertiesPanel, {
      model: model,
      operation: operation,
      onChange: this.handleBatchChange
    }), /*#__PURE__*/external_react_default().createElement(RunPropertiesPanel, {
      model: model,
      operation: operation,
      onChange: this.handleRunChange,
      onWorkflowTaskChange: this.handleWorkflowTaskChange
    }), this.plateSupportEnabled && /*#__PURE__*/external_react_default().createElement(PlatePropertiesPanel, {
      model: model,
      operation: operation,
      onChange: this.handleRunChange
    }), /*#__PURE__*/external_react_default().createElement(RunDataPanel, {
      acceptedPreviewFileFormats: acceptedPreviewFileFormats,
      allowBulkRemove: allowBulkRemove,
      allowBulkInsert: allowBulkInsert,
      allowBulkUpdate: allowBulkUpdate,
      currentStep: currentStep,
      editorModel: editorModel,
      fileSizeLimits: fileSizeLimits,
      maxEditableGridRowMsg: `A max of ${maxRows?.toLocaleString()} rows are allowed. Please use the 'Import Data from File' tab if you need to import more than ${maxRows?.toLocaleString()} rows.`,
      maxRows: maxRows,
      onDataFileChange: this.handleDataFileChange,
      onDataFileRemoval: this.handleDataFileRemove,
      onResultsFileChange: this.handleResultsFileChange,
      onResultsFileRemoval: this.handleResultsFileRemove,
      onGridChange: this.onGridChange,
      operation: operation,
      onTextChange: this.handleDataTextChange,
      plateSupportEnabled: plateSupportEnabled,
      queryModel: dataModel,
      runPropertiesRow: runProps,
      showTabs: showUploadTabs,
      wizardModel: model,
      getIsDirty: getIsDirty,
      setIsDirty: setIsDirty
    }), /*#__PURE__*/external_react_default().createElement(Alert, {
      id: IMPORT_ERROR_ID
    }, this.state.error), /*#__PURE__*/external_react_default().createElement(FormButtons, null, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: onCancel,
      type: "button"
    }, "Cancel"), isReimport && /*#__PURE__*/external_react_default().createElement(CommentTextArea, {
      actionName: "Update",
      containerClassName: "inline-comment",
      onChange: this.onCommentChange,
      requiresUserComment: requiresUserComment,
      inline: true
    }), showSaveAgainBtn && /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      type: "submit",
      onClick: this.onSaveAndImportAgain,
      disabled: disabledSave
    }, model.isSubmitting ? 'Saving...' : 'Save and Import Another Run'), /*#__PURE__*/external_react_default().createElement("button", {
      type: "submit",
      className: "btn btn-success",
      onClick: this.onImport,
      disabled: disabledSave
    }, model.isSubmitting ? 'Importing...' : isReimport ? 'Re-Import' : 'Import')), /*#__PURE__*/external_react_default().createElement(Progress, {
      estimate: this.getProgressSizeEstimate(),
      modal: true,
      title: isReimport ? 'Re-importing assay run' : 'Importing assay run',
      toggle: model.isSubmitting
    }, resultsFilesCount > 0 && /*#__PURE__*/external_react_default().createElement("p", null, "Upload includes ", api_.Utils.pluralBasic(resultsFilesCount, 'additional file'), ". Please stay on this page until upload finishes.")), showRenameModal && /*#__PURE__*/external_react_default().createElement(ImportWithRenameConfirmModal, {
      onConfirm: this.onRenameConfirm,
      onCancel: this.onCancelRename,
      originalName: model.attachedFiles.keySeq().get(0),
      newName: duplicateFileResponse.newFileNames[0]
    }));
  }
}
AssayImportPanels_defineProperty(AssayImportPanelsBody, "defaultProps", {
  acceptedPreviewFileFormats: BASE_FILE_TYPES.join(', '),
  fileSizeLimits: DATA_IMPORT_FILE_SIZE_LIMITS,
  loadSelectedSamples: loadSelectedSamples,
  showUploadTabs: true,
  maxRows: MAX_EDITABLE_GRID_ROWS
});
const AssayImportPanelWithQueryModels = withQueryModels(AssayImportPanelsBody);
const AssayImportPanelsBodyImpl = props => {
  const {
    assayDefinition,
    runId
  } = props;
  const [searchParams] = (0,external_react_router_dom_.useSearchParams)();
  const {
    createNotification,
    dismissNotifications
  } = useNotificationsContext();
  const {
    container,
    user
  } = useServerContext();
  const {
    requiresUserComment
  } = useDataChangeCommentsRequired();
  const key = [runId, assayDefinition.protocolSchemaName].join('|');
  const schemaQuery = (0,external_react_.useMemo)(() => new SchemaQuery(assayDefinition.protocolSchemaName, 'Runs'), [assayDefinition.protocolSchemaName]);
  const queryConfigs = (0,external_react_.useMemo)(() => ({
    model: {
      keyValue: runId,
      schemaQuery,
      requiredColumns: RUN_PROPERTIES_REQUIRED_COLUMNS.toArray(),
      baseFilters: [api_.Filter.create('RowId', runId || -1),
      // allow for the possibility of viewing runs that have been replaced.
      api_.Filter.create('Replaced', undefined, api_.Filter.Types.NONBLANK)]
    }
  }), [runId, schemaQuery]);
  return /*#__PURE__*/external_react_default().createElement(AssayImportPanelWithQueryModels, AssayImportPanels_extends({}, props, {
    autoLoad: true,
    container: container,
    createNotification: createNotification,
    dismissNotifications: dismissNotifications,
    key: key,
    queryConfigs: queryConfigs,
    requiresUserComment: requiresUserComment,
    searchParams: searchParams,
    user: user
  }));
};
const AssayImportPanels = withFormSteps(AssayImportPanelsBodyImpl, {
  currentStep: AssayUploadTabs.Files,
  furthestStep: AssayUploadTabs.Files,
  hasDependentSteps: false
});
// EXTERNAL MODULE: external "@testing-library/react"
var react_ = __webpack_require__(722);
;// CONCATENATED MODULE: ./src/internal/test/reactTestLibraryHelpers.tsx
function reactTestLibraryHelpers_extends() { return reactTestLibraryHelpers_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, reactTestLibraryHelpers_extends.apply(null, arguments); }
function reactTestLibraryHelpers_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function reactTestLibraryHelpers_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? reactTestLibraryHelpers_ownKeys(Object(t), !0).forEach(function (r) { reactTestLibraryHelpers_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : reactTestLibraryHelpers_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function reactTestLibraryHelpers_defineProperty(e, r, t) { return (r = reactTestLibraryHelpers_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function reactTestLibraryHelpers_toPropertyKey(t) { var i = reactTestLibraryHelpers_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function reactTestLibraryHelpers_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




/**
 * Use this if you're testing a component that requires a wrapping <AppContextProvider/> to provide context.
 * This test method wraps React Testing Library's `render()` method utilizing the `wrapper` option to specify
 * the React Context provider components.
 * @param node The component under test.
 * @param contexts The contexts to be provided to the underlying React Context providers.
 * @param options Additional `RenderOptions` to supply to the `render()` method.
 */
const renderWithAppContext = (node, contexts, options) => {
  // https://github.com/testing-library/react-testing-library/issues/780
  return (0,react_.render)(node, reactTestLibraryHelpers_objectSpread({
    wrapper: _props => /*#__PURE__*/external_react_default().createElement(AppContextTestProvider, reactTestLibraryHelpers_extends({}, _props, contexts))
  }, options));
};
;// CONCATENATED MODULE: ./src/internal/components/gridbar/ExportModal.tsx



const DEFAULT_TITLE = 'Select the Tabs to Export';
const ExportModal = (0,external_react_.memo)(props => {
  const {
    queryModels,
    tabOrder,
    onClose,
    onExport,
    canExport,
    tabRowCounts,
    title = DEFAULT_TITLE
  } = props;
  const [selected, setSelected] = (0,external_react_.useState)(() => {
    let selected = new Set();
    tabOrder.forEach(modelId => {
      if (tabRowCounts?.[modelId] > 0) selected = selected.add(modelId);
      if (queryModels[modelId].rowCount > 0) selected = selected.add(modelId);
    });
    return selected;
  });
  const closeHandler = (0,external_react_.useCallback)(() => {
    onClose();
  }, [onClose]);
  const exportHandler = (0,external_react_.useCallback)(() => {
    onExport(selected);
  }, [onExport, selected]);
  const onChecked = (0,external_react_.useCallback)(evt => {
    const modelId = evt.target.name;
    const draftSelected = new Set(selected);
    if (evt.target.checked) {
      setSelected(draftSelected.add(modelId));
    } else {
      draftSelected.delete(modelId);
      setSelected(draftSelected);
    }
  }, [selected]);
  if (queryModels == null) return null;
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    canConfirm: canExport && selected.size > 0,
    confirmText: "Export",
    onCancel: closeHandler,
    onConfirm: exportHandler,
    title: title
  }, /*#__PURE__*/external_react_default().createElement("table", {
    className: "export-modal-body"
  }, /*#__PURE__*/external_react_default().createElement("tbody", null, /*#__PURE__*/external_react_default().createElement("tr", null, /*#__PURE__*/external_react_default().createElement("th", null), /*#__PURE__*/external_react_default().createElement("th", {
    className: "pull-right"
  }, "Count"), /*#__PURE__*/external_react_default().createElement("th", {
    className: "view-name"
  }, "View")), tabOrder.map(modelId => {
    const model = queryModels[modelId];
    let rowCountDisplay = model.rowCount;
    if (rowCountDisplay === undefined && !model.isActivelyLoadingTotalCount) {
      rowCountDisplay = tabRowCounts?.[modelId];
    }
    return /*#__PURE__*/external_react_default().createElement("tr", {
      key: modelId
    }, /*#__PURE__*/external_react_default().createElement("td", null, /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
      checked: selected.has(modelId),
      name: modelId,
      onChange: onChecked
    }, model.title)), /*#__PURE__*/external_react_default().createElement("td", {
      className: "pull-right"
    }, rowCountDisplay), /*#__PURE__*/external_react_default().createElement("td", {
      className: "view-name"
    }, !model.viewName || model.viewName.startsWith('~~') ? 'Default' : model.viewName, ' ', model.currentView?.session && /*#__PURE__*/external_react_default().createElement("span", {
      className: "text-muted"
    }, "(edited)")));
  }))));
});
;// CONCATENATED MODULE: ./src/public/QueryModel/TabbedGridPanel.tsx
const TabbedGridPanel_excluded = ["activeModelId", "actions", "allowViewCustomization", "allowViewCustomizationForGridIds", "alwaysShowTabs", "asPanel", "onTabSelect", "queryModels", "rightTabs", "showRowCountOnTabs", "tabOrder", "onExport", "exportFilename", "advancedExportOptions", "getAdvancedExportOptions", "getGridPanelDisplay", "showViewMenu", "getShowViewMenu", "tabRowCounts"];
function TabbedGridPanel_extends() { return TabbedGridPanel_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, TabbedGridPanel_extends.apply(null, arguments); }
function TabbedGridPanel_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TabbedGridPanel_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TabbedGridPanel_ownKeys(Object(t), !0).forEach(function (r) { TabbedGridPanel_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TabbedGridPanel_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TabbedGridPanel_defineProperty(e, r, t) { return (r = TabbedGridPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function TabbedGridPanel_toPropertyKey(t) { var i = TabbedGridPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function TabbedGridPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function TabbedGridPanel_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = TabbedGridPanel_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function TabbedGridPanel_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








const GridTab = (0,external_react_.memo)(({
  isActive,
  model,
  onSelect,
  pullRight,
  showRowCount,
  tabRowCount
}) => {
  const {
    id,
    queryInfo,
    rowCount,
    title
  } = model;
  const className = external_classnames_default()({
    active: isActive,
    'pull-right': pullRight
  });
  const onClick = (0,external_react_.useCallback)(() => onSelect(id), [id, onSelect]);
  const rowCountDisplay = (0,external_react_.useMemo)(() => {
    if (rowCount === undefined && !model.isActivelyLoadingTotalCount) return tabRowCount?.toLocaleString();
    return rowCount?.toLocaleString();
  }, [rowCount, tabRowCount, model]);
  return /*#__PURE__*/external_react_default().createElement("li", {
    className: className
  }, /*#__PURE__*/external_react_default().createElement("a", {
    onClick: onClick
  }, title || queryInfo?.queryLabel || queryInfo?.name, showRowCount && rowCountDisplay !== undefined && /*#__PURE__*/external_react_default().createElement("span", null, " (", rowCountDisplay, ")")));
});
const TabbedGridPanel = (0,external_react_.memo)(props => {
  const {
      activeModelId,
      actions,
      allowViewCustomization = true,
      allowViewCustomizationForGridIds,
      alwaysShowTabs,
      asPanel = true,
      onTabSelect,
      queryModels,
      rightTabs = [],
      showRowCountOnTabs,
      tabOrder,
      onExport,
      exportFilename,
      advancedExportOptions,
      getAdvancedExportOptions,
      getGridPanelDisplay,
      showViewMenu,
      getShowViewMenu,
      tabRowCounts
    } = props,
    rest = TabbedGridPanel_objectWithoutProperties(props, TabbedGridPanel_excluded);
  const [internalActiveId, setInternalActiveId] = (0,external_react_.useState)(activeModelId ?? tabOrder[0]);
  const [showExportModal, setShowExportModal] = (0,external_react_.useState)(false);
  const [canExport, setCanExport] = (0,external_react_.useState)(true);
  const onSelect = (0,external_react_.useCallback)(modelId => {
    if (onTabSelect !== undefined) {
      onTabSelect(modelId);
    } else {
      setInternalActiveId(modelId);
    }
  }, [onTabSelect]);

  // useNotificationsContext is only available if the app uses NotificationsContext, LKS does not
  let _createNotification;
  try {
    _createNotification = useNotificationsContext().createNotification;
  } catch (e) {
    // this is expected for LKS usages, so don't throw or console.error
  }
  const exportTabs = (0,external_react_.useCallback)(async selectedTabs => {
    try {
      // set exporting blocker
      setCanExport(false);
      const models = [];
      selectedTabs.forEach(selected => {
        const selectedModel = queryModels[selected];
        let exportOptions = TabbedGridPanel_objectSpread({}, advancedExportOptions);
        if (getAdvancedExportOptions) exportOptions = TabbedGridPanel_objectSpread({}, getAdvancedExportOptions(selected));
        const tabForm = getQueryModelExportParams(selectedModel, EXPORT_TYPES.EXCEL, TabbedGridPanel_objectSpread(TabbedGridPanel_objectSpread({}, exportOptions), {}, {
          sheetName: selectedModel.title
        }));
        models.push(tabForm);
      });
      const filename = exportFilename ?? 'Data';
      await exportTabsXlsx(filename, models);
      onExport?.[EXPORT_TYPES.EXCEL]?.();
    } catch (e) {
      console.error(e);
      // Set export error
      _createNotification?.({
        message: 'Export failed: ' + e,
        alertClass: 'danger'
      });
    } finally {
      // unset exporting blocker
      setCanExport(true);
      setShowExportModal(false);
    }
  }, [exportFilename, canExport, _createNotification, queryModels, advancedExportOptions, getAdvancedExportOptions]);
  const excelExportHandler = (0,external_react_.useCallback)(async () => {
    if (Object.keys(tabOrder).length > 1) {
      setShowExportModal(true);
      return;
    }
    try {
      await exportTabs([internalActiveId]);
    } catch (e) {
      console.error(e);
    }
  }, [tabOrder, exportTabs, internalActiveId]);
  const exportHandlers = TabbedGridPanel_objectSpread(TabbedGridPanel_objectSpread({}, onExport), {}, {
    [EXPORT_TYPES.EXCEL]: excelExportHandler
  });
  const closeExportModal = (0,external_react_.useCallback)(() => {
    setShowExportModal(false);
  }, []);

  // If the component is passed onTabSelect we will only honor the activeModelId passed to this component.
  let activeId = onTabSelect === undefined ? internalActiveId : activeModelId;

  // Default activeId if current activeId not in tabOrder
  activeId = tabOrder.indexOf(activeId) === -1 ? tabOrder[0] : activeId;
  const activeModel = queryModels[activeId];
  const hasTabs = tabOrder.length > 1 || alwaysShowTabs;
  const showViewConfig = {}; // showViewMenu default to true in GridPanel
  if (getShowViewMenu || showViewMenu !== undefined) {
    showViewConfig['showViewMenu'] = getShowViewMenu ? getShowViewMenu(activeId) : showViewMenu;
  }
  const panelTitle = rest.title;
  if (asPanel && hasTabs) delete rest.title;
  const gridDisplay = getGridPanelDisplay?.(activeId, exportHandlers) ?? /*#__PURE__*/external_react_default().createElement(GridPanel, TabbedGridPanel_extends({
    allowViewCustomization: allowViewCustomizationForGridIds ? allowViewCustomizationForGridIds.indexOf(activeId) > -1 : allowViewCustomization,
    key: activeId,
    actions: actions,
    hasHeader: !hasTabs,
    asPanel: !hasTabs,
    model: activeModel,
    onExport: exportHandlers,
    advancedExportOptions: getAdvancedExportOptions ? getAdvancedExportOptions(activeId) : advancedExportOptions
  }, showViewConfig, rest));
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, hasTabs && /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('tabbed-grid-panel', {
      panel: asPanel,
      'panel-default': asPanel
    })
  }, asPanel && panelTitle && /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, panelTitle), /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('tabbed-grid-panel__body', {
      'panel-body': asPanel
    })
  }, /*#__PURE__*/external_react_default().createElement("ul", {
    className: "nav nav-tabs"
  }, tabOrder.map(modelId => {
    if (queryModels[modelId]) {
      return /*#__PURE__*/external_react_default().createElement(GridTab, {
        key: modelId,
        model: queryModels[modelId],
        isActive: activeId === modelId,
        onSelect: onSelect,
        pullRight: rightTabs.indexOf(modelId) > -1,
        showRowCount: showRowCountOnTabs,
        tabRowCount: tabRowCounts?.[modelId]
      });
    } else {
      return null;
    }
  })), gridDisplay)), !hasTabs && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, gridDisplay), showExportModal && !!queryModels && /*#__PURE__*/external_react_default().createElement(ExportModal, {
    queryModels: queryModels,
    tabOrder: tabOrder,
    onClose: closeExportModal,
    onExport: exportTabs,
    canExport: canExport,
    tabRowCounts: tabRowCounts
  }));
});
;// CONCATENATED MODULE: ./src/public/QueryModel/testUtils.ts


/**
 * @ignore
 * Helper to instantiate a QueryModel for use with tests.
 * @param schemaQuery
 * @param queryInfo: The queryInfo you want to apply to a model. See makeQueryInfo above.
 * @param rows
 * @param orderedRows
 * @param rowCount
 * @param id
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const makeTestQueryModel = (schemaQuery, queryInfo, rows, orderedRows, rowCount, id) => {
  let model = new QueryModel({
    id: id ? id : 'model',
    schemaQuery
  });
  if (queryInfo) {
    model = model.mutate({
      queryInfo,
      queryInfoLoadingState: LoadingState.LOADED
    });
  }
  if (rows) {
    model = model.mutate({
      orderedRows,
      rowCount,
      rows,
      rowsLoadingState: LoadingState.LOADED
    });
  }
  return model;
};

/**
 * @ignore
 * Creates an Actions object with a mock function for every action. For most use cases you'll want to pass `jest.fn`
 * to the `mockFn` parameter. You can use this in beforeEach so your actions get refreshed
 * between every test, jest.fn() objects track all calls overtime, so you'll want a fresh one for every test.
 *
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
const makeTestActions = (mockFn = () => () => {}, overrides = {}) => {
  const defaultActions = {
    addModel: mockFn(),
    clearSelections: mockFn(),
    loadModel: mockFn(),
    loadAllModels: mockFn(),
    loadRows: mockFn(),
    loadNextPage: mockFn(),
    loadPreviousPage: mockFn(),
    loadFirstPage: mockFn(),
    loadLastPage: mockFn(),
    loadCharts: mockFn(),
    selectAllRows: mockFn(),
    selectRow: mockFn(),
    selectPage: mockFn(),
    selectReport: mockFn(),
    setFilters: mockFn(),
    setMaxRows: mockFn(),
    setOffset: mockFn(),
    setSchemaQuery: mockFn(),
    setSorts: mockFn(),
    setView: mockFn(),
    setSelections: mockFn(),
    replaceSelections: mockFn(),
    resetTotalCountState: mockFn()
  };
  return Object.assign(defaultActions, overrides);
};
;// CONCATENATED MODULE: ./src/internal/components/samples/ManageSampleStatusesPanel.tsx
function ManageSampleStatusesPanel_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageSampleStatusesPanel_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageSampleStatusesPanel_ownKeys(Object(t), !0).forEach(function (r) { ManageSampleStatusesPanel_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageSampleStatusesPanel_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ManageSampleStatusesPanel_defineProperty(e, r, t) { return (r = ManageSampleStatusesPanel_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ManageSampleStatusesPanel_toPropertyKey(t) { var i = ManageSampleStatusesPanel_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ManageSampleStatusesPanel_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }























const ManageSampleStatusesPanel_TITLE = 'Manage Sample Statuses';
const STATE_TYPE_SQ = new SchemaQuery('exp', 'SampleStateType');
const DEFAULT_TYPE_OPTIONS = [{
  value: 'Available'
}, {
  value: 'Consumed'
}, {
  value: 'Locked'
}];
const NEW_STATUS_INDEX = -1;
const SAMPLE_STATUS_LOCKED_TITLE = 'Sample Status Locked';
function resolveDuplicateStatusLabel(errorMsg, noun, nounPlural, verb) {
  const keyMatch = errorMsg.match(/Key \(([^)]+)\)=\(([^)]+)\) already exists./);
  let name;
  if (keyMatch) {
    // the uniqueness key has only two parts: (label, container)
    const index = keyMatch[2].lastIndexOf(', ');
    name = keyMatch[2].substring(0, index);
  }
  let retMsg = `There was a problem ${verb || 'creating'} your ${nounPlural || noun || 'data'}.`;
  if (name) {
    retMsg += ` Duplicate name '${name}' found.`;
  } else {
    retMsg += ` Check the existing ${nounPlural || noun} for possible duplicates and make sure any referenced ${nounPlural || noun} are still valid.`;
  }
  return retMsg;
}

// exported for jest testing
const SampleStatusDetail = (0,external_react_.memo)(props => {
  const {
    state,
    addNew,
    onActionComplete,
    onChange,
    container
  } = props;
  const [typeOptions, setTypeOptions] = (0,external_react_.useState)();
  const [updatedState, setUpdatedState] = (0,external_react_.useState)();
  const [dirty, setDirty] = (0,external_react_.useState)();
  const [saving, setSaving] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  const [showDeleteConfirm, setShowDeleteConfirm] = (0,external_react_.useState)();
  const {
    api
  } = useAppContext();
  (0,external_react_.useEffect)(() => {
    (async () => {
      try {
        const response = await api.query.selectRows({
          columns: 'RowId,Value',
          schemaQuery: STATE_TYPE_SQ,
          containerPath: container?.path
        });
        const options = response.rows.reduce((options_, row) => {
          options_.push({
            value: caseInsensitive(row, 'Value').value
          });
          return options_;
        }, []);
        setTypeOptions(options);
      } catch (e) {
        setTypeOptions(DEFAULT_TYPE_OPTIONS);
      }
    })();
  }, [api, container?.path]);
  const resetState = (0,external_react_.useCallback)(() => {
    setSaving(false);
    setShowDeleteConfirm(false);
    setError(undefined);
  }, []);
  (0,external_react_.useEffect)(() => {
    if (addNew) {
      setUpdatedState(new SampleState({
        stateType: typeOptions?.[0]?.value,
        isLocal: true
      }));
    } else {
      if (state && !state.color) {
        setUpdatedState(new SampleState(ManageSampleStatusesPanel_objectSpread(ManageSampleStatusesPanel_objectSpread({}, state), {}, {
          color: getSampleStatusColor(state.color, state.stateType)
        })));
      } else {
        setUpdatedState(state);
      }
    }
    setDirty(addNew);
    if (addNew) onChange();
    resetState();
  }, [state, addNew, typeOptions, resetState, onChange]);
  const onFormChange = (0,external_react_.useCallback)(evt => {
    const {
      name,
      value
    } = evt.target;
    setUpdatedState(updatedState.set(name, value));
    setDirty(true);
    onChange();
  }, [updatedState, onChange]);
  const onSelectChange = (0,external_react_.useCallback)((name, value) => {
    setUpdatedState(updatedState.set(name, value));
    setDirty(true);
    onChange();
  }, [updatedState, onChange]);
  const onCancel = (0,external_react_.useCallback)(() => {
    onActionComplete(undefined, true);
  }, [onActionComplete]);
  const onSave = (0,external_react_.useCallback)(() => {
    setError(undefined);
    setSaving(true);

    // trim the label string before saving
    const stateToSave = updatedState.set('label', updatedState.label?.trim());
    if (stateToSave.rowId) {
      api.query.updateRows({
        schemaQuery: SCHEMAS.CORE_TABLES.DATA_STATES,
        rows: [stateToSave],
        containerPath: container?.path
      }).then(() => {
        onActionComplete(stateToSave.label);
      }).catch(reason => {
        setError(resolveErrorMessage(reason, 'status', 'statuses', 'updating', resolveDuplicateStatusLabel));
        setSaving(false);
      });
    } else {
      api.query.insertRows({
        schemaQuery: SCHEMAS.CORE_TABLES.DATA_STATES,
        rows: (0,external_immutable_.List)([stateToSave]),
        containerPath: container?.path
      }).then(() => {
        onActionComplete(stateToSave.label);
      }).catch(response => {
        setError(resolveErrorMessage(response.error, 'status', 'status', 'inserting', resolveDuplicateStatusLabel));
        setSaving(false);
      });
    }
  }, [api, updatedState, onActionComplete, container?.path]);
  const onToggleDeleteConfirm = (0,external_react_.useCallback)(() => setShowDeleteConfirm(!showDeleteConfirm), [showDeleteConfirm]);
  const onDeleteConfirm = (0,external_react_.useCallback)(() => {
    if (updatedState.rowId) {
      api.query.deleteRows({
        schemaQuery: SCHEMAS.CORE_TABLES.DATA_STATES,
        containerPath: container?.path,
        rows: [updatedState]
      }).then(() => {
        onActionComplete(undefined, true);
      }).catch(reason => {
        setError(resolveErrorMessage(reason?.error, 'status', 'statuses', 'deleting'));
        setShowDeleteConfirm(false);
      });
    } else {
      setShowDeleteConfirm(false);
    }
  }, [api, updatedState, onActionComplete, container?.path]);
  const disabledMsg = (0,external_react_.useMemo)(() => {
    return getSampleStatusLockedMessage(updatedState, saving);
  }, [updatedState, saving]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !updatedState && state !== null && /*#__PURE__*/external_react_default().createElement("p", {
    className: "choices-detail__empty-message"
  }, "Select a sample status to view details."), updatedState && /*#__PURE__*/external_react_default().createElement("form", {
    className: "form-horizontal content-form"
  }, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Label",
    required: true
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    className: "form-control",
    name: "label",
    onChange: onFormChange,
    disabled: saving || !updatedState.isLocal,
    placeholder: "Enter status label",
    type: "text",
    value: updatedState.label ?? ''
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Color",
    required: true
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/external_react_default().createElement(ColorPickerInput, {
    name: "color",
    value: updatedState.color,
    onChange: onSelectChange,
    allowRemove: true,
    disabled: saving || !updatedState.isLocal,
    colors: Object.keys(SAMPLE_STATUS_COLORS)
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Description"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/external_react_default().createElement("textarea", {
    className: "form-control",
    name: "description",
    onChange: onFormChange,
    disabled: saving || !updatedState.isLocal,
    value: updatedState.description ?? ''
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/external_react_default().createElement(DomainFieldLabel, {
    label: "Status Type",
    required: true
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/external_react_default().createElement(SelectInput_SelectInput, {
    name: "stateType",
    inputClass: "col-sm-12",
    labelKey: "value",
    clearable: false,
    onChange: onSelectChange,
    disabled: updatedState.inUse || !updatedState.isLocal || saving,
    options: typeOptions,
    value: updatedState.stateType
  }))), /*#__PURE__*/external_react_default().createElement("div", null, !addNew && updatedState.isLocal && /*#__PURE__*/external_react_default().createElement(DisableableButton, {
    disabledMsg: disabledMsg,
    onClick: onToggleDeleteConfirm,
    title: SAMPLE_STATUS_LOCKED_TITLE
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-trash"
  }), /*#__PURE__*/external_react_default().createElement("span", null, "\xA0Delete")), addNew && /*#__PURE__*/external_react_default().createElement("button", {
    className: "btn btn-default",
    disabled: saving,
    onClick: onCancel,
    type: "button"
  }, "Cancel"), updatedState.isLocal && /*#__PURE__*/external_react_default().createElement("button", {
    className: "pull-right btn btn-success",
    disabled: !dirty || saving || !updatedState.color || !updatedState.label?.trim(),
    onClick: onSave,
    type: "button"
  }, saving ? 'Saving...' : 'Save'))), showDeleteConfirm && /*#__PURE__*/external_react_default().createElement(Modal, {
    confirmClass: "btn-danger",
    confirmText: "Yes, Delete",
    onCancel: onToggleDeleteConfirm,
    onConfirm: onDeleteConfirm,
    title: "Permanently Delete Status?"
  }, /*#__PURE__*/external_react_default().createElement("span", null, "The ", /*#__PURE__*/external_react_default().createElement("b", null, updatedState.label), " status will be permanently deleted.", /*#__PURE__*/external_react_default().createElement("p", {
    className: "top-spacing"
  }, /*#__PURE__*/external_react_default().createElement("strong", null, "Deletion cannot be undone."), " Do you want to proceed?"))));
});
SampleStatusDetail.displayName = 'SampleStatusDetail';
const HELP_TEXT = {
  [SampleStateType.Available]: 'Allows any action. Included in the calculation of available amount.',
  [SampleStateType.Consumed]: 'Prevents updates to storage such as adding to storage or changing F/T count.',
  [SampleStateType.Locked]: 'All updates to the sample are prevented. Locked samples may be added to picklists.'
};

// exported for jest testing
const SampleStatusesList = (0,external_react_.memo)(props => {
  const {
    statesByType,
    onSelect,
    selected,
    selectedGroup
  } = props;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, Object.keys(statesByType).sort().map(stateType => /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, {
    key: stateType
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "choice-section-header"
  }, stateType, /*#__PURE__*/external_react_default().createElement(LabelHelpTip, {
    placement: "right"
  }, HELP_TEXT[SampleStateType[stateType]])), /*#__PURE__*/external_react_default().createElement("div", {
    className: "list-group"
  }, statesByType[stateType].map((state, index) => /*#__PURE__*/external_react_default().createElement(ChoicesListItem, {
    active: index === selected && stateType === selectedGroup,
    group: stateType,
    index: index,
    key: state.rowId,
    label: /*#__PURE__*/external_react_default().createElement(SampleStatusTag, {
      status: state.toSampleStatus(),
      hideDescription: true
    }),
    onSelect: onSelect,
    componentRight: (state.inUse || !state.isLocal) && /*#__PURE__*/external_react_default().createElement(LockIcon, {
      className: "pull-right",
      iconCls: "choices-list__locked",
      body: getSampleStatusLockedMessage(state, false),
      id: "sample-state-lock-icon",
      title: SAMPLE_STATUS_LOCKED_TITLE
    })
  }))))), Object.keys(statesByType).length === 0 && /*#__PURE__*/external_react_default().createElement("div", {
    className: "list-group"
  }, /*#__PURE__*/external_react_default().createElement("p", {
    className: "choices-list__empty-message"
  }, "No sample statuses defined.")));
});
SampleStatusesList.displayName = 'SampleStatusesList';
const ManageSampleStatusesPanel = (0,external_react_.memo)(props => {
  const {
    api,
    setIsDirty,
    container
  } = props;
  const [states, setStates] = (0,external_react_.useState)();
  const [error, setError] = (0,external_react_.useState)();
  const [selected, setSelected] = (0,external_react_.useState)();
  const [selectedGroup, setSelectedGroup] = (0,external_react_.useState)();
  const addNew = (0,external_react_.useMemo)(() => selected === NEW_STATUS_INDEX, [selected]);
  const querySampleStatuses = (0,external_react_.useCallback)(newStatusLabel => {
    setError(undefined);
    api.samples.getSampleStatuses(true, container?.path).then(statuses => {
      const statesByType = {};
      statuses.sort((a, b) => {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
      }).forEach(state => {
        if (!statesByType[state.stateType]) {
          statesByType[state.stateType] = [];
        }
        statesByType[state.stateType].push(state);
        if (newStatusLabel && state.label === newStatusLabel) {
          setSelectedGroup(state.stateType);
          setSelected(statesByType[state.stateType].length - 1);
        }
      });
      setStates(statesByType);
    }).catch(() => {
      setStates({});
      setError('Error: Unable to load sample statuses.');
    });
  }, [api, container]);
  (0,external_react_.useEffect)(() => {
    querySampleStatuses();
  }, [querySampleStatuses]);
  const onSetSelected = (0,external_react_.useCallback)((index, group) => {
    setSelected(index);
    setSelectedGroup(group);
  }, []);
  const onAddState = (0,external_react_.useCallback)(() => {
    setSelected(NEW_STATUS_INDEX);
  }, []);
  const onChange = (0,external_react_.useCallback)(() => {
    setIsDirty(true);
  }, [setIsDirty]);
  const onActionComplete = (0,external_react_.useCallback)((newStatusLabel, isDelete = false) => {
    querySampleStatuses(newStatusLabel);
    if (isDelete) setSelected(undefined);
    setIsDirty(false);
  }, [querySampleStatuses, setIsDirty]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, ManageSampleStatusesPanel_TITLE), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, error && /*#__PURE__*/external_react_default().createElement(Alert, null, error), !states && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), states && !error && /*#__PURE__*/external_react_default().createElement("div", {
    className: "row choices-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-lg-4 col-md-6 choices-container-left-panel"
  }, /*#__PURE__*/external_react_default().createElement(SampleStatusesList, {
    statesByType: states,
    selected: selected,
    selectedGroup: selectedGroup,
    onSelect: onSetSelected
  }), /*#__PURE__*/external_react_default().createElement(AddEntityButton, {
    onClick: onAddState,
    entity: "New Status",
    disabled: addNew
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-lg-8 col-md-6"
  }, /*#__PURE__*/external_react_default().createElement(SampleStatusDetail
  // use null to indicate that no statuses exist to be selected, so don't show the empty message
  , {
    state: Object.keys(states).length === 0 ? null : states[selectedGroup]?.[selected],
    addNew: addNew,
    onActionComplete: onActionComplete,
    onChange: onChange,
    container: container
  })))));
});
ManageSampleStatusesPanel.defaultProps = {
  api: getDefaultAPIWrapper()
};
ManageSampleStatusesPanel.displayName = 'ManageSampleStatusesPanel';
;// CONCATENATED MODULE: ./src/internal/mockUtils.ts
function mockUtils_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function mockUtils_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? mockUtils_ownKeys(Object(t), !0).forEach(function (r) { mockUtils_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : mockUtils_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mockUtils_defineProperty(e, r, t) { return (r = mockUtils_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function mockUtils_toPropertyKey(t) { var i = mockUtils_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function mockUtils_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Util function for creating an InjectedRouteLeaveProps object, useful for testing components
 * that expect to be wrapped by withRouteLeave.
 *
 * Note: Intentionally does not use jest.fn() to avoid jest becoming an implicit external package dependency.
 */
const createMockWithRouteLeave = (mockFn = () => () => {}, overrides = {}) => {
  return mockUtils_objectSpread({
    getIsDirty: () => false,
    setIsDirty: mockFn()
  }, overrides);
};
;// CONCATENATED MODULE: ./src/internal/components/ontology/OntologyConceptPicker.tsx




const OntologyConceptPicker = (0,external_react_.memo)(props => {
  const {
    ontologyId,
    conceptSubtree,
    fieldLabel,
    onConceptSelection,
    fieldValue = ''
  } = props;
  const [concept, setConcept] = (0,external_react_.useState)();
  const [subtreePath, setSubtreePath] = (0,external_react_.useState)();
  const [isLoadingSubtreePath, setIsLoadingSubtreePath] = (0,external_react_.useState)(!!conceptSubtree);
  const [showPicker, setShowPicker] = (0,external_react_.useState)(false);
  (0,external_react_.useEffect)(() => {
    if (fieldValue) {
      fetchConceptForCode(fieldValue).then(setConcept).catch(() => {
        // If concept not found clear existing concept, unfound values are allowed if not recommended
        setConcept(undefined);
      });
    } else {
      setConcept(undefined);
    }
  }, [fieldValue]);
  (0,external_react_.useEffect)(() => {
    if (conceptSubtree) {
      fetchPathModel(conceptSubtree).then(pathModel => {
        setSubtreePath(pathModel);
        setIsLoadingSubtreePath(false);
      }).catch(() => {
        setIsLoadingSubtreePath(false);
      });
    }
  }, [conceptSubtree]);
  const togglePicker = (0,external_react_.useCallback)(() => {
    setShowPicker(!showPicker);
  }, [showPicker]);
  const onApplyConcept = (0,external_react_.useCallback)((selectedPath, selectedConcept) => {
    setConcept(selectedConcept);
    setShowPicker(false);
    onConceptSelection(selectedConcept);
  }, [onConceptSelection]);
  const label = concept?.label ?? null;
  const title = `Find ${fieldLabel} By Tree`;
  if (isLoadingSubtreePath) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !!label && /*#__PURE__*/external_react_default().createElement("div", {
    className: "concept-label-text"
  }, label, "\xA0", /*#__PURE__*/external_react_default().createElement(ConceptOverviewTooltip, {
    concept: concept
  })), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("a", {
    className: "show-toggle",
    onClick: togglePicker
  }, title), showPicker && /*#__PURE__*/external_react_default().createElement(OntologyBrowserModal, {
    initOntologyId: ontologyId,
    initConcept: concept,
    initPath: subtreePath,
    onApply: onApplyConcept,
    onCancel: togglePicker,
    title: title
  })));
});
;// CONCATENATED MODULE: ./src/internal/app/models.ts
function app_models_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function app_models_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? app_models_ownKeys(Object(t), !0).forEach(function (r) { app_models_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : app_models_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function app_models_defineProperty(e, r, t) { return (r = app_models_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function app_models_toPropertyKey(t) { var i = app_models_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function app_models_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */




const user = new User(app_models_objectSpread(app_models_objectSpread({}, (0,api_.getServerContext)().user), {}, {
  permissionsList: (0,api_.getServerContext)().container?.effectivePermissions ?? []
}));
class AppModel extends (0,external_immutable_.Record)({
  container: new Container((0,api_.getServerContext)().container),
  contextPath: api_.ActionURL.getContextPath(),
  initialUserId: user.id,
  user
}) {
  hasUserChanged() {
    return this.initialUserId !== this.user.id;
  }
  shouldReload() {
    return this.hasUserChanged();
  }
}

// Note: this should stay in sync with the eln/src/ReferencingNotebooks.tsx props
;// CONCATENATED MODULE: ./src/internal/components/picklist/PicklistEditModal.tsx
function PicklistEditModal_extends() { return PicklistEditModal_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, PicklistEditModal_extends.apply(null, arguments); }












const PicklistEditModal = (0,external_react_.memo)(props => {
  const {
    api,
    queryModel,
    sampleFieldKey,
    sampleIds
  } = props;
  const [ids, setIds] = (0,external_react_.useState)(sampleIds);
  (0,external_react_.useEffect)(() => {
    (async () => {
      // Look up SampleIds from the selected row ids.
      // Using sampleFieldKey as proxy flag to determine if lookup is needed
      if (sampleFieldKey && queryModel && !queryModel.isLoadingSelections) {
        try {
          const ids_ = await api.samples.getFieldLookupFromSelection(queryModel.schemaQuery.schemaName, queryModel.schemaQuery.queryName, [...queryModel.selections], sampleFieldKey);
          setIds(ids_);
          await setSnapshotSelections(queryModel.selectionKey, [...queryModel.selections]);
        } catch (error) {
          console.error(error);
        }
      }
    })();
  }, [api, sampleFieldKey, queryModel]);
  return /*#__PURE__*/external_react_default().createElement(PicklistEditModalDisplay, PicklistEditModal_extends({}, props, {
    sampleIds: ids
  }));
});
const PicklistEditModalDisplay = (0,external_react_.memo)(props => {
  const {
    api,
    onCancel,
    onFinish,
    sampleFieldKey,
    sampleIds,
    picklist,
    showNotification,
    currentProductId,
    picklistProductId,
    metricFeatureArea,
    queryModel
  } = props;
  const useSnapshotSelection = queryModel?.filterArray.length > 0;
  const {
    createNotification
  } = useNotificationsContext();
  const [name, setName] = (0,external_react_.useState)(picklist?.name ?? '');
  const onNameChange = (0,external_react_.useCallback)(evt => setName(evt.target.value), []);
  const validCount = (0,external_react_.useMemo)(() => sampleIds?.length || queryModel?.selections.size, [sampleIds, queryModel?.selections]);
  const selectionKey = (0,external_react_.useMemo)(() => sampleFieldKey ? undefined : queryModel?.selectionKey, [sampleFieldKey, queryModel?.selectionKey]);
  const [description, setDescription] = (0,external_react_.useState)(picklist?.Description ?? '');
  const onDescriptionChange = (0,external_react_.useCallback)(evt => setDescription(evt.target.value), []);
  const [shared, setShared] = (0,external_react_.useState)(picklist?.isPublic() ?? false);
  const onSharedChanged = (0,external_react_.useCallback)(evt => setShared(evt.currentTarget.checked), []);
  const [isSubmitting, setIsSubmitting] = (0,external_react_.useState)(false);
  const [picklistError, setPicklistError] = (0,external_react_.useState)(undefined);
  (0,external_react_.useEffect)(() => {
    (async () => {
      if (useSnapshotSelection) await setSnapshotSelections(selectionKey, [...queryModel.selections]);
    })();
  }, [useSnapshotSelection, selectionKey, queryModel?.selections]);
  const isUpdate = picklist !== undefined;
  let finishVerb, finishingVerb;
  if (isUpdate) {
    finishVerb = 'Update';
    finishingVerb = 'Updating';
  } else {
    finishVerb = 'Create';
    finishingVerb = 'Creating';
  }
  const reset = () => {
    setPicklistError(undefined);
    setIsSubmitting(false);
    setName(undefined);
    setDescription(undefined);
    setShared(false);
  };
  const onHide = (0,external_react_.useCallback)(() => {
    reset();
    onCancel();
  }, [onCancel]);
  const onSavePicklist = (0,external_react_.useCallback)(async () => {
    setIsSubmitting(true);
    try {
      let updatedList;
      const trimmedName = name.trim();
      if (isUpdate) {
        updatedList = await updatePicklist(new Picklist({
          Container: picklist.Container,
          name: trimmedName,
          listId: picklist.listId,
          Description: description,
          Category: shared ? PUBLIC_PICKLIST_CATEGORY : PRIVATE_PICKLIST_CATEGORY
        }));
      } else {
        updatedList = await createPicklist(trimmedName, description, shared, selectionKey, useSnapshotSelection, sampleIds);
        api.query.incrementClientSideMetricCount(metricFeatureArea, 'createPicklist');
      }
      reset();
      if (showNotification) {
        const href = getPicklistUrl(updatedList.listId, picklistProductId, currentProductId);
        const noun = validCount ? api_.Utils.pluralize(validCount, 'sample', 'samples') : ' no samples';
        createNotification({
          message: /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "Successfully created \"", updatedList.name, "\" with ", noun, ". ", /*#__PURE__*/external_react_default().createElement("a", {
            href: href
          }, "View picklist"), "."),
          alertClass: 'success'
        });
      }
      onFinish(updatedList);
    } catch (e) {
      setPicklistError(resolveErrorMessage(e));
      setIsSubmitting(false);
    }
  }, [api.query, createNotification, currentProductId, description, isUpdate, metricFeatureArea, name, onFinish, picklist?.Container, picklist?.listId, picklistProductId, sampleIds, selectionKey, shared, showNotification, useSnapshotSelection, validCount]);
  let title;
  if (isUpdate) {
    title = 'Update Picklist Data';
  } else {
    if (!validCount) {
      title = 'Create an Empty Picklist';
    } else if (selectionKey && validCount) {
      const pluralizedNoun = api_.Utils.pluralize(validCount, 'Selected Sample', 'Selected Samples');
      title = `Create a New Picklist with the ${pluralizedNoun}`;
    } else if (validCount === 1) {
      title = 'Create a New Picklist with This Sample';
    } else {
      title = 'Create a New Picklist with These Samples';
    }
  }
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    canConfirm: !!name,
    confirmText: finishVerb + ' Picklist',
    confirmingText: finishingVerb + ' Picklist...',
    isConfirming: isSubmitting,
    onCancel: onHide,
    onConfirm: onSavePicklist,
    title: title
  }, /*#__PURE__*/external_react_default().createElement(Alert, null, picklistError), /*#__PURE__*/external_react_default().createElement("form", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: "control-label"
  }, "Name *"), /*#__PURE__*/external_react_default().createElement("input", {
    placeholder: "Give this list a name",
    className: "form-control",
    value: name,
    onChange: onNameChange,
    type: "text"
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: "control-label"
  }, "Description"), /*#__PURE__*/external_react_default().createElement("textarea", {
    placeholder: "Add a description",
    className: "form-control",
    value: description,
    onChange: onDescriptionChange
  }), /*#__PURE__*/external_react_default().createElement(CheckboxLK, {
    checked: shared,
    name: "shared",
    onChange: onSharedChanged
  }, "Share this picklist"))));
});
PicklistEditModal.defaultProps = {
  api: getDefaultAPIWrapper()
};
;// CONCATENATED MODULE: ./src/internal/components/picklist/PicklistCreationMenuItem.tsx
const PicklistCreationMenuItem_excluded = ["asMenuItem", "itemText", "user", "onCreatePicklist", "queryModel", "sampleIds"];
function PicklistCreationMenuItem_extends() { return PicklistCreationMenuItem_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, PicklistCreationMenuItem_extends.apply(null, arguments); }
function PicklistCreationMenuItem_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = PicklistCreationMenuItem_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function PicklistCreationMenuItem_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }






const PicklistCreationMenuItem = props => {
  const {
      asMenuItem,
      itemText,
      user,
      onCreatePicklist,
      queryModel,
      sampleIds
    } = props,
    editModalProps = PicklistCreationMenuItem_objectWithoutProperties(props, PicklistCreationMenuItem_excluded);
  const [showModal, setShowModal] = (0,external_react_.useState)(false);
  const onFinish = (0,external_react_.useCallback)(() => {
    setShowModal(false);
    onCreatePicklist?.();
  }, [onCreatePicklist]);
  const onCancel = (0,external_react_.useCallback)(() => {
    setShowModal(false);
  }, []);
  const onClick = (0,external_react_.useCallback)(() => {
    setShowModal(true);
  }, []);
  if (!userCanManagePicklists(user)) {
    return null;
  }
  const numSamples = sampleIds?.length ?? queryModel?.selections?.size ?? 0;
  const excessSamples = numSamples > MAX_SELECTIONS_PER_ADD;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, queryModel && /*#__PURE__*/external_react_default().createElement(SelectionMenuItem, {
    text: itemText,
    onClick: onClick,
    queryModel: queryModel,
    nounPlural: "samples",
    maxSelection: MAX_SELECTIONS_PER_ADD
  }), !queryModel && asMenuItem && /*#__PURE__*/external_react_default().createElement(DisableableMenuItem, {
    onClick: onClick,
    disabled: excessSamples,
    disabledMessage: MAX_SELECTIONS_MESSAGE
  }, itemText), !queryModel && !asMenuItem && /*#__PURE__*/external_react_default().createElement("button", {
    disabled: excessSamples,
    title: excessSamples ? MAX_SELECTIONS_MESSAGE : undefined,
    className: "btn btn-success",
    onClick: onClick,
    type: "button"
  }, itemText), showModal && /*#__PURE__*/external_react_default().createElement(PicklistEditModal, PicklistCreationMenuItem_extends({
    queryModel: queryModel,
    sampleIds: sampleIds
  }, editModalProps, {
    showNotification: true,
    onFinish: onFinish,
    onCancel: onCancel
  })));
};
PicklistCreationMenuItem.defaultProps = {
  itemText: 'Create a New Picklist'
};
PicklistCreationMenuItem.displayName = 'PicklistCreationMenuItem';
;// CONCATENATED MODULE: ./src/internal/components/picklist/ChoosePicklistModal.tsx
function ChoosePicklistModal_extends() { return ChoosePicklistModal_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ChoosePicklistModal_extends.apply(null, arguments); }















// export for jest testing
const PicklistList = (0,external_react_.memo)(props => {
  const {
    activeItem,
    emptyMessage,
    onSelect,
    showSharedIcon = false,
    items
  } = props;
  const onClick = (0,external_react_.useCallback)(index => {
    onSelect(items[index]);
  }, [items, onSelect]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "list-group choices-list"
  }, items.map((item, index) => /*#__PURE__*/external_react_default().createElement(ChoicesListItem, {
    active: activeItem?.listId === item.listId,
    index: index,
    key: item.listId,
    label: item.name,
    onSelect: onClick,
    componentRight: showSharedIcon && item.isPublic() && /*#__PURE__*/external_react_default().createElement("span", {
      className: "fa fa-users pull-right",
      title: "Team Picklist"
    })
  })), items.length === 0 && /*#__PURE__*/external_react_default().createElement("p", {
    className: "choices-list__empty-message"
  }, emptyMessage));
});
// export for jest testing
const PicklistItemsSummary = (0,external_react_.memo)(({
  picklist
}) => {
  const {
    name
  } = picklist;
  const [countsByType, setCountsByType] = (0,external_react_.useState)([]);
  const [loadingState, setLoadingState] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const {
    api
  } = useAppContext();
  (0,external_react_.useEffect)(() => {
    (async () => {
      setLoadingState(LoadingState.LOADING);
      try {
        const counts = await api.picklist.getPicklistCountsBySampleType(name);
        setCountsByType(counts);
      } catch (e) {
        setCountsByType([]);
      }
      setLoadingState(LoadingState.LOADED);
    })();
  }, [api.picklist, name]);
  const isLoaded = !isLoading(loadingState);
  const hasCounts = countsByType.length > 0;
  const hasItems = picklist.ItemCount > 0;
  return /*#__PURE__*/external_react_default().createElement("div", {
    key: "picklist-items-summary"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    key: "header",
    className: "picklist-items__header"
  }, "Sample Counts"), !isLoaded && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), isLoaded && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, hasCounts && countsByType.map(countData => /*#__PURE__*/external_react_default().createElement("div", {
    key: countData.SampleType,
    className: "row picklist-items__row"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "col-md-1"
  }, /*#__PURE__*/external_react_default().createElement(ColorIcon, {
    useSmall: true,
    value: countData.LabelColor
  })), /*#__PURE__*/external_react_default().createElement("span", {
    className: "col-md-5 picklist-items__sample-type choice-metadata-item__name"
  }, countData.SampleType), /*#__PURE__*/external_react_default().createElement("span", {
    className: "col-md-4 picklist-items__item-count"
  }, countData.ItemCount))), hasItems && !hasCounts && /*#__PURE__*/external_react_default().createElement("div", {
    key: "summary"
  }, api_.Utils.pluralize(picklist.ItemCount, 'sample', 'samples')), !hasItems && !hasCounts && /*#__PURE__*/external_react_default().createElement("div", {
    key: "summary",
    className: "choices-detail__empty-message"
  }, "This list is empty.")));
});
// export for jest testing
const PicklistDetails = (0,external_react_.memo)(props => {
  const {
    picklist
  } = props;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "choice-details"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "choice-details__name"
  }, picklist.name), /*#__PURE__*/external_react_default().createElement("div", {
    className: "choice-details-section choice-details__metadata"
  }, picklist.isPublic() && /*#__PURE__*/external_react_default().createElement("div", {
    className: "choice-metadata-item"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "choice-metadata-item__name"
  }, "Created by:"), /*#__PURE__*/external_react_default().createElement("span", {
    className: "choice-metadata-item__value"
  }, picklist.CreatedByDisplay)), /*#__PURE__*/external_react_default().createElement("div", {
    className: "choice-details-section choice-metadata-item"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "choice-metadata-item__name"
  }, "Created:"), /*#__PURE__*/external_react_default().createElement("span", {
    className: "choice-metadata-item__value"
  }, formatDate(parseDate(picklist.Created))))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "choice-details-section choice-details__description"
  }, picklist.Description), /*#__PURE__*/external_react_default().createElement("div", {
    className: "choice-details-section top-spacing choice-details__summary"
  }, /*#__PURE__*/external_react_default().createElement(PicklistItemsSummary, {
    picklist: picklist
  })));
});
// export for jest testing
const AddedToPicklistNotification = props => {
  const {
    picklist,
    numAdded,
    numSelected,
    currentProductId,
    picklistProductId
  } = props;
  let numAddedNotification;
  if (numAdded === 0) {
    numAddedNotification = 'No samples added';
  } else {
    numAddedNotification = 'Successfully added ' + api_.Utils.pluralize(numAdded, 'sample', 'samples');
  }
  let numNotAddedNotification = null;
  if (numAdded < numSelected) {
    const notAdded = numSelected - numAdded;
    numNotAddedNotification = ' ' + api_.Utils.pluralize(notAdded, 'sample', 'samples');
    numNotAddedNotification += notAdded === 1 ? ' was ' : ' were ';
    numNotAddedNotification += 'already in the list.';
  }
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, numAddedNotification, " to picklist \"", /*#__PURE__*/external_react_default().createElement("a", {
    href: getPicklistUrl(picklist.listId, picklistProductId, currentProductId)
  }, picklist.name), "\".", numNotAddedNotification);
};
// export for jest testing
const ChoosePicklistModalDisplay = (0,external_react_.memo)(props => {
  const {
    picklists,
    loading,
    picklistLoadError,
    onCancel,
    afterAddToPicklist,
    user,
    selectionKey,
    sampleIds,
    currentProductId,
    picklistProductId,
    metricFeatureArea,
    validCount
  } = props;
  const [search, setSearch] = (0,external_react_.useState)('');
  const [error, setError] = (0,external_react_.useState)(undefined);
  const [submitting, setSubmitting] = (0,external_react_.useState)(false);
  const [activeItem, setActiveItem] = (0,external_react_.useState)(undefined);
  const {
    api
  } = useAppContext();
  const {
    createNotification
  } = useNotificationsContext();
  const onSearchChange = (0,external_react_.useCallback)(event => {
    setSearch(event.target.value.trim().toLowerCase());
  }, []);
  const filteredItems = (0,external_react_.useMemo)(() => {
    if (search !== '') {
      return picklists.filter(item => item.name.toLowerCase().indexOf(search) > -1);
    }
    return picklists;
  }, [search, picklists]);
  const [myItems, teamItems] = (0,external_react_.useMemo)(() => {
    const mine = [];
    const team = [];
    filteredItems.forEach(item => {
      if (item.isUserList(user)) {
        mine.push(item);
      }
      if (item.isPublic()) {
        team.push(item);
      }
    });
    return [mine, team];
  }, [filteredItems, user]);
  const onAddClicked = (0,external_react_.useCallback)(async () => {
    setSubmitting(true);
    setError(undefined);
    let numAdded = 0;
    try {
      const response = await addSamplesToPicklist(activeItem.name, false, selectionKey, sampleIds);
      api.query.incrementClientSideMetricCount(metricFeatureArea, 'addSamplesToPicklist');
      numAdded = response.rows.length;
      setSubmitting(false);
    } catch (e) {
      setSubmitting(false);
      setError(resolveErrorMessage(e) ?? 'Failed to add samples to picklist.');
      return;
    }
    createNotification({
      message: /*#__PURE__*/external_react_default().createElement(AddedToPicklistNotification, {
        picklist: activeItem,
        numAdded: numAdded,
        numSelected: validCount,
        currentProductId: currentProductId,
        picklistProductId: picklistProductId
      }),
      alertClass: numAdded === 0 ? 'info' : 'success'
    });
    afterAddToPicklist();
  }, [createNotification, activeItem, validCount, currentProductId, picklistProductId, afterAddToPicklist, selectionKey, sampleIds, api.query, metricFeatureArea]);
  const closeModal = (0,external_react_.useCallback)(() => {
    setError(undefined);
    onCancel(false);
  }, [onCancel]);
  const goToCreateNewList = (0,external_react_.useCallback)(() => {
    setError(undefined);
    onCancel(true);
  }, [onCancel]);
  const createNewListMessage = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, "Do you want to ", /*#__PURE__*/external_react_default().createElement("a", {
    onClick: goToCreateNewList
  }, "create a new one"), "?");
  let body = /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
  if (!loading) {
    const isSearching = !!search;
    let myEmptyMessage = 'You do not have any picklists ';
    let teamEmptyMessage = 'There are no shared picklists  ';
    let suffix = '';
    if (isSearching) {
      suffix = ' matching your search';
    }
    suffix += ' to add ' + (validCount === 1 ? 'this sample to.' : 'these samples to.');
    myEmptyMessage += suffix;
    teamEmptyMessage += suffix;
    if (!isSearching) {
      myEmptyMessage = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, myEmptyMessage, " ", createNewListMessage);
      teamEmptyMessage = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, teamEmptyMessage, " ", createNewListMessage);
    }
    body = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/external_react_default().createElement(Alert, {
      bsStyle: "info"
    }, "Adding ", api_.Utils.pluralize(validCount, 'sample', 'samples'), " to selected picklist.", ' '))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-6"
    }, /*#__PURE__*/external_react_default().createElement("input", {
      autoFocus: true,
      className: "form-control",
      onChange: onSearchChange,
      placeholder: "Find a picklist"
    }))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "row choices-container"
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-6"
    }, /*#__PURE__*/external_react_default().createElement(Tabs, {
      className: "choose-items-tabs"
    }, /*#__PURE__*/external_react_default().createElement(Tab, {
      eventKey: "yours",
      title: "Your Picklists"
    }, /*#__PURE__*/external_react_default().createElement(PicklistList, {
      activeItem: activeItem,
      emptyMessage: myEmptyMessage,
      onSelect: setActiveItem,
      showSharedIcon: true,
      items: myItems
    })), /*#__PURE__*/external_react_default().createElement(Tab, {
      eventKey: "shared",
      title: "Shared Picklists"
    }, /*#__PURE__*/external_react_default().createElement(PicklistList, {
      activeItem: activeItem,
      emptyMessage: teamEmptyMessage,
      onSelect: setActiveItem,
      items: teamItems
    })))), /*#__PURE__*/external_react_default().createElement("div", {
      className: "col-md-6"
    }, activeItem === undefined && /*#__PURE__*/external_react_default().createElement("div", {
      className: "choices-list__empty-message"
    }, "Choose a picklist"), activeItem !== undefined && /*#__PURE__*/external_react_default().createElement(PicklistDetails, {
      picklist: activeItem
    }))));
  }
  return /*#__PURE__*/external_react_default().createElement(Modal, {
    bsSize: "lg",
    canConfirm: activeItem !== undefined && !loading,
    confirmText: "Add to Picklist",
    confirmingText: "Adding to Picklist...",
    isConfirming: submitting,
    onCancel: closeModal,
    onConfirm: onAddClicked,
    title: "Choose a Picklist"
  }, /*#__PURE__*/external_react_default().createElement(Alert, null, picklistLoadError ?? error), body);
});
const ChoosePicklistModal = (0,external_react_.memo)(props => {
  const {
    numSelected,
    selectionKey,
    queryModel,
    sampleFieldKey,
    sampleIds
  } = props;
  const [error, setError] = (0,external_react_.useState)();
  const [items, setItems] = (0,external_react_.useState)([]);
  const [idsLoading, setIdsLoading] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [itemsLoading, setItemsLoading] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [ids, setIds] = (0,external_react_.useState)(sampleIds);
  const [validCount, setValidCount] = (0,external_react_.useState)(numSelected);
  const [selectionsLoading, setSelectionsLoading] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const useSnapshotSelection = queryModel?.filterArray.length > 0;
  const schemaQuery = queryModel?.schemaQuery;
  const selections = queryModel?.selections;
  const {
    api
  } = useAppContext();
  (0,external_react_.useEffect)(() => {
    (async () => {
      if (selectionsLoading === LoadingState.INITIALIZED) {
        setItemsLoading(LoadingState.LOADING);
        try {
          const picklists = await getPicklistsForInsert();
          setItems(picklists);
        } catch (e) {
          console.error(e);
          setError(resolveErrorMessage(e) ?? 'Failed to retrieve picklists.');
        }
        setItemsLoading(LoadingState.LOADED);
      }
      if (useSnapshotSelection) {
        if (!queryModel?.isLoadingSelections) {
          try {
            await setSnapshotSelections(queryModel.selectionKey, [...selections]);
          } catch (reason) {
            console.error('There was a problem loading the filtered selection data. Your actions will not obey these filters.', reason);
          }
          setSelectionsLoading(LoadingState.LOADED);
        }
      } else {
        setSelectionsLoading(LoadingState.LOADED);
      }
    })();
  }, [selectionsLoading, queryModel?.selectionKey, selections, queryModel?.isLoadingSelections, useSnapshotSelection]);
  (0,external_react_.useEffect)(() => {
    setIdsLoading(LoadingState.LOADING);
    if (selectionsLoading === LoadingState.LOADED) {
      (async () => {
        // This method is responsible for:
        // 1. Determining the sample IDs for the set of samples to be added to the picklist.
        // 2. Verifying what operations are allowed for those samples.
        let ids_;
        if (sampleIds) {
          ids_ = sampleIds;
        } else if (sampleFieldKey && schemaQuery) {
          // Look up SampleIds from the selected row ids.
          // Using sampleFieldKey as proxy flag to determine if lookup is needed.
          try {
            ids_ = await api.samples.getFieldLookupFromSelection(schemaQuery.schemaName, schemaQuery.queryName, [...selections], sampleFieldKey);
          } catch (e) {
            setError(resolveErrorMessage(e) ?? 'Failed to retrieve picklist selection.');
          }
        } else if (selections) {
          ids_ = [...selections];
        }
        setIds(ids_);
        setValidCount(ids_?.length ?? 0);
        setIdsLoading(LoadingState.LOADED);
      })();
    }
  }, [api.samples, selectionsLoading, sampleFieldKey, sampleIds, schemaQuery, selectionKey, selections, useSnapshotSelection]);
  return /*#__PURE__*/external_react_default().createElement(ChoosePicklistModalDisplay, ChoosePicklistModal_extends({}, props, {
    loading: isLoading(itemsLoading) || isLoading(idsLoading) || isLoading(selectionsLoading),
    picklists: items,
    picklistLoadError: error,
    sampleIds: ids,
    selectionKey: selectionKey,
    validCount: validCount
  }));
});
ChoosePicklistModal.displayName = 'ChoosePicklistModal';
;// CONCATENATED MODULE: ./src/internal/components/picklist/AddToPicklistMenuItem.tsx









const AddToPicklistMenuItem = (0,external_react_.memo)(props => {
  const {
    sampleIds,
    user,
    queryModel,
    currentProductId,
    picklistProductId,
    metricFeatureArea,
    sampleFieldKey
  } = props;
  const [showChoosePicklist, setShowChoosePicklist] = (0,external_react_.useState)(false);
  const [showCreatePicklist, setShowCreatePicklist] = (0,external_react_.useState)(false);
  const closeAddToPicklist = (0,external_react_.useCallback)(closeToCreate => {
    setShowChoosePicklist(false);
    if (closeToCreate) {
      setShowCreatePicklist(true);
    }
  }, []);
  const afterAddToPicklist = (0,external_react_.useCallback)(() => {
    setShowChoosePicklist(false);
  }, []);
  const closeCreatePicklist = (0,external_react_.useCallback)(() => {
    setShowCreatePicklist(false);
  }, []);
  const afterCreatePicklist = (0,external_react_.useCallback)(() => {
    setShowCreatePicklist(false);
  }, []);
  const onClick = (0,external_react_.useCallback)(() => {
    if (queryModel?.hasSelections || sampleIds?.length) {
      setShowChoosePicklist(true);
    }
  }, [queryModel, sampleIds]);
  if (!userCanManagePicklists(user)) {
    return null;
  }
  const useSelection = sampleIds === undefined;
  const selectionKey = sampleIds ? undefined : queryModel?.selectionKey;
  const numSelected = sampleIds ? sampleIds.length : queryModel.selections?.size;
  const operationPermitted = isSampleOperationPermitted(getSampleStatusType(queryModel.getRow()), SampleOperation.AddToPicklist);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, useSelection ? /*#__PURE__*/external_react_default().createElement(SelectionMenuItem, {
    text: "Add to Picklist",
    onClick: onClick,
    queryModel: queryModel,
    maxSelection: MAX_SELECTIONS_PER_ADD,
    nounPlural: "samples"
  }) : /*#__PURE__*/external_react_default().createElement(DisableableMenuItem, {
    onClick: onClick,
    disabled: !operationPermitted || numSelected > MAX_SELECTIONS_PER_ADD,
    disabledMessage: numSelected > MAX_SELECTIONS_PER_ADD ? MAX_SELECTIONS_MESSAGE : undefined
  }, "Add to Picklist"), showChoosePicklist && /*#__PURE__*/external_react_default().createElement(ChoosePicklistModal, {
    onCancel: closeAddToPicklist,
    afterAddToPicklist: afterAddToPicklist,
    user: user,
    selectionKey: selectionKey,
    numSelected: numSelected,
    sampleIds: sampleIds,
    currentProductId: currentProductId,
    picklistProductId: picklistProductId,
    metricFeatureArea: metricFeatureArea,
    queryModel: queryModel,
    sampleFieldKey: sampleFieldKey
  }), showCreatePicklist && /*#__PURE__*/external_react_default().createElement(PicklistEditModal, {
    sampleIds: sampleIds,
    onFinish: afterCreatePicklist,
    onCancel: closeCreatePicklist,
    showNotification: true,
    metricFeatureArea: metricFeatureArea,
    queryModel: queryModel,
    sampleFieldKey: sampleFieldKey
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/picklist/PicklistButton.tsx






const PicklistButton = (0,external_react_.memo)(props => {
  const {
    model,
    user,
    metricFeatureArea,
    asSubMenu,
    currentProductId,
    picklistProductId,
    sampleIds
  } = props;
  const items = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(AddToPicklistMenuItem, {
    queryModel: model,
    user: user,
    sampleIds: sampleIds,
    metricFeatureArea: metricFeatureArea,
    currentProductId: currentProductId,
    picklistProductId: picklistProductId
  }), /*#__PURE__*/external_react_default().createElement(PicklistCreationMenuItem, {
    queryModel: sampleIds ? undefined : model,
    sampleIds: sampleIds,
    key: "picklist",
    user: user,
    asMenuItem: true,
    metricFeatureArea: metricFeatureArea,
    currentProductId: currentProductId,
    picklistProductId: picklistProductId
  }));
  return /*#__PURE__*/external_react_default().createElement(RequiresPermission, {
    permissionCheck: "any",
    perms: api_.PermissionTypes.ManagePicklists
  }, /*#__PURE__*/external_react_default().createElement(ResponsiveMenuButton, {
    className: "samples-picklist-menu",
    items: items,
    text: "Picklists",
    asSubMenu: asSubMenu
  }));
});
;// CONCATENATED MODULE: ./src/internal/components/labelPrinting/PrintLabelsModal.tsx
function PrintLabelsModal_defineProperty(e, r, t) { return (r = PrintLabelsModal_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function PrintLabelsModal_toPropertyKey(t) { var i = PrintLabelsModal_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function PrintLabelsModal_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











const PRINT_ERROR_MESSAGE = 'There was a problem printing the labels for the selected samples. Verify the label template chosen is still valid and the connection to BarTender has been configured properly.';
class PrintLabelsModalImpl extends external_react_.PureComponent {
  constructor(props) {
    super(props);

    // because of a timing issue with the clearSelections on componentWillUnmount, use distinct model ids for single sample vs grid selection case
    PrintLabelsModal_defineProperty(this, "_modelId", 'sampleModel');
    PrintLabelsModal_defineProperty(this, "onCopyCountChange", event => {
      let numCopies = parseInt(event.target.value);
      if (isNaN(numCopies)) {
        numCopies = undefined;
      }
      this.setState(() => ({
        numCopies
      }));
    });
    PrintLabelsModal_defineProperty(this, "onConfirmPrint", () => {
      this.setState(() => ({
        error: undefined,
        submitting: true
      }));
      const {
        labelTemplate
      } = this.state;
      this.props.api.labelprinting.printGridLabels(this.getModel(), '' + labelTemplate, this.state.numCopies, this.props.printServiceUrl).then(btResponse => {
        if (btResponse.ranToCompletion()) {
          this.onLabelPrintSuccess();
        } else if (btResponse.faulted() && btResponse.isLabelUnavailableError()) {
          this.onLabelPrintError(btResponse.getFaultMessage(), LABEL_NOT_FOUND_ERROR);
        } else {
          this.onLabelPrintError(btResponse.getFaultMessage());
        }
      }).catch(reason => {
        this.onLabelPrintError(reason);
      });
    });
    PrintLabelsModal_defineProperty(this, "onLabelPrintSuccess", () => {
      const {
        afterPrint
      } = this.props;
      const {
        sampleCount
      } = this.state;
      this.setState(() => ({
        submitting: false
      }));
      if (afterPrint) {
        afterPrint(sampleCount, sampleCount > 0 ? this.state.numCopies * sampleCount : this.state.numCopies);
      }
    });
    PrintLabelsModal_defineProperty(this, "onLabelPrintError", (reason, errorMessage) => {
      console.error(reason);
      this.setState(() => ({
        submitting: false,
        error: errorMessage || PRINT_ERROR_MESSAGE
      }));
    });
    PrintLabelsModal_defineProperty(this, "changeSampleSelection", (name, value) => {
      const sampleIds = value ? value.split(',') : [];
      this.setState(() => ({
        sampleCount: sampleIds.length
      }));
      this.props.actions.replaceSelections(this._modelId, sampleIds);
    });
    PrintLabelsModal_defineProperty(this, "changeTemplateSelection", (name, value) => {
      this.setState(() => ({
        labelTemplate: value
      }));
    });
    if (!props.showSelection) {
      this._modelId = 'singleSampleModel';
    }
    this.state = {
      error: undefined,
      labelTemplate: props.defaultLabel,
      loadingSelections: true,
      numCopies: 1,
      sampleCount: props.sampleIds.length,
      submitting: false
    };
  }
  componentDidMount() {
    const {
      model
    } = this.props;
    this.props.actions.addModel({
      id: this._modelId,
      schemaQuery: model?.schemaQuery,
      baseFilters: model?.filters,
      sorts: model?.sorts
    }, true, true);
  }
  componentDidUpdate(prevProps, prevState) {
    // only set initial model selections once after the loadingSelections state changes to LOADED
    if (this.state.loadingSelections && !this.getModel().isLoadingSelections) {
      this.setState(() => ({
        loadingSelections: false
      }));
      this.props.actions.setSelections(this._modelId, true, this.props.sampleIds);
    }
  }
  componentWillUnmount() {
    this.props.actions.clearSelections(this._modelId);
  }
  getModel() {
    return this.props.queryModels[this._modelId];
  }
  getSampleCount() {
    return this.state.sampleCount;
  }
  getTitle() {
    const numSamples = this.getSampleCount();
    if (numSamples === 0) {
      return 'Print Labels with BarTender';
    } else {
      return 'Print Labels for ' + numSamples + (numSamples === 1 ? ' Sample' : ' Samples') + ' with BarTender';
    }
  }
  isReadyForPrint() {
    const {
      labelTemplate,
      numCopies
    } = this.state;
    return labelTemplate !== undefined && labelTemplate >= 0 && numCopies !== undefined && numCopies > 0 && this.getSampleCount() > 0;
  }
  render() {
    const {
      onCancel,
      showSelection
    } = this.props;
    const {
      error,
      labelTemplate,
      numCopies,
      submitting
    } = this.state;
    const model = this.getModel();
    const isLoading = model === undefined || model.isLoading;
    let body;
    if (isLoading) {
      body = /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null);
    } else if (submitting) {
      body = /*#__PURE__*/external_react_default().createElement(LoadingSpinner, {
        msg: "Printing ..."
      });
    } else {
      const sampleCount = this.getSampleCount();
      let displayColumn = 'Name';
      let valueColumn = 'RowId';
      if (model?.queryInfo.pkCols?.[0] === 'rowId') {
        displayColumn = 'name';
        valueColumn = 'rowId';
      }
      let message;
      if (sampleCount === 0) {
        message = 'Select samples to print labels for.';
      } else if (showSelection) {
        message = "Confirm you've selected the samples you want and the proper label template.";
      } else {
        message = 'Choose the number of copies of the label for this sample to print and confirm the label template.';
      }
      body = /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
        className: "bottom-spacing"
      }, message), /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("strong", null, "Number of copies"), /*#__PURE__*/external_react_default().createElement("input", {
        className: "form-control label-printing--copies",
        min: 1,
        name: "numCopies",
        onChange: this.onCopyCountChange,
        type: "number",
        value: numCopies ? numCopies.toString() : undefined
      }), showSelection && /*#__PURE__*/external_react_default().createElement("div", {
        className: "top-spacing"
      }, /*#__PURE__*/external_react_default().createElement("strong", null, "Selected samples to print"), /*#__PURE__*/external_react_default().createElement(QuerySelect, {
        formsy: false,
        fireQSChangeOnInit: true,
        showLabel: false,
        loadOnFocus: true,
        maxRows: 10,
        multiple: true,
        name: "label-samples",
        onQSChange: this.changeSampleSelection,
        placeholder: "Select or type to search...",
        required: false,
        schemaQuery: model.schemaQuery,
        queryFilters: (0,external_immutable_.List)(model.filters),
        displayColumn: displayColumn,
        valueColumn: valueColumn,
        value: this.props.sampleIds.join(',')
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "top-spacing"
      }, /*#__PURE__*/external_react_default().createElement("strong", null, "Label template"), /*#__PURE__*/external_react_default().createElement(QuerySelect, {
        formsy: false,
        fireQSChangeOnInit: true,
        showLabel: false,
        loadOnFocus: true,
        maxRows: 10,
        name: "label-template",
        onQSChange: this.changeTemplateSelection,
        placeholder: "Select or type to search...",
        required: true,
        schemaQuery: LABEL_TEMPLATE_SQ,
        displayColumn: "name",
        valueColumn: "rowId",
        value: labelTemplate
      }))));
    }
    const footer = /*#__PURE__*/external_react_default().createElement(FormButtons, {
      sticky: false
    }, /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-default",
      onClick: onCancel,
      type: "button"
    }, "Cancel"), /*#__PURE__*/external_react_default().createElement(HelpLink, {
      topic: BAR_TENDER_TOPIC,
      className: "label-printing--help-link"
    }, "BarTender help"), /*#__PURE__*/external_react_default().createElement("button", {
      className: "btn btn-success",
      disabled: submitting || !this.isReadyForPrint(),
      onClick: this.onConfirmPrint,
      type: "button"
    }, "Yes, Print"));
    return /*#__PURE__*/external_react_default().createElement(Modal, {
      onCancel: onCancel,
      title: this.getTitle(),
      footer: footer
    }, /*#__PURE__*/external_react_default().createElement(Alert, null, error), body);
  }
}
PrintLabelsModal_defineProperty(PrintLabelsModalImpl, "defaultProps", {
  api: getDefaultAPIWrapper()
});
const PrintLabelsModal = withQueryModels(PrintLabelsModalImpl);
;// CONCATENATED MODULE: ./src/internal/app/reducers.ts
function reducers_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function reducers_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? reducers_ownKeys(Object(t), !0).forEach(function (r) { reducers_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : reducers_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function reducers_defineProperty(e, r, t) { return (r = reducers_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function reducers_toPropertyKey(t) { var i = reducers_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function reducers_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright (c) 2019 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */





function AppReducers(state = new AppModel(), action) {
  switch (action.type) {
    case UPDATE_USER:
      return state.merge({
        user: new User(reducers_objectSpread(reducers_objectSpread({}, state.user), action.userProps))
      });
    case UPDATE_USER_DISPLAY_NAME:
      return state.merge({
        user: new User(reducers_objectSpread(reducers_objectSpread({}, state.user), {}, {
          displayName: action.displayName
        }))
      });
    default:
      return state;
  }
}
function ProductMenuReducers(state = new ProductMenuModel(), action) {
  switch (action.type) {
    case MENU_INVALIDATE:
      return new ProductMenuModel();
    case MENU_RELOAD:
      return state.setNeedsReload();
    case MENU_LOADING_START:
      return state.merge({
        currentProductId: action.currentProductId,
        isLoading: true,
        productIds: action.productIds
      });
    case MENU_LOADING_ERROR:
      return state.setError(action.message);
    case MENU_LOADING_END:
      return state.setLoadedSections(action.sections);
    default:
      return state;
  }
}
function ServerNotificationReducers(state = new ServerNotificationModel(), action) {
  switch (action.type) {
    case SERVER_NOTIFICATIONS_INVALIDATE:
      return new ServerNotificationModel();
    case SERVER_NOTIFICATIONS_LOADING_START:
      return state.setLoadingStart();
    case SERVER_NOTIFICATIONS_LOADING_END:
      return state.setLoadingComplete(action.serverActivity);
    case SERVER_NOTIFICATIONS_LOADING_ERROR:
      return state.setError(action.message);
    default:
      return state;
  }
}
;// CONCATENATED MODULE: ./src/internal/app/actions.ts
/*
 * Copyright (c) 2016-2018 LabKey Corporation. All rights reserved. No portion of this work may be reproduced in
 * any form or by any electronic or mechanical means without written permission from LabKey Corporation.
 */




const updateUser = userProps => ({
  type: UPDATE_USER,
  userProps
});
const updateUserDisplayName = displayName => ({
  type: UPDATE_USER_DISPLAY_NAME,
  displayName
});
function menuInit(currentProductId, appProductId) {
  return (dispatch, getState) => {
    let menu = getState().routing.menu;
    if (!menu.isLoaded && !menu.isLoading || menu.needsReload) {
      if (!menu.needsReload) {
        dispatch({
          type: MENU_LOADING_START,
          currentProductId,
          productIds: getAppProductIds(appProductId)
        });
      }
      menu = getState().routing.menu;
      menu.getMenuSections().then(sections => {
        dispatch({
          type: MENU_LOADING_END,
          sections
        });
      }).catch(reason => {
        console.error('Problem retrieving product menu data.', reason);
        dispatch({
          type: MENU_LOADING_ERROR,
          message: 'Error in retrieving product menu data. Please contact your site administrator.'
        });
      });
    }
  };
}
const menuInvalidate = () => ({
  type: MENU_INVALIDATE
});

// an alternative to menuInvalidate, which doesn't erase current menu during reload
function menuReload() {
  return (dispatch, getState) => {
    dispatch({
      type: MENU_RELOAD
    });
    const menu = getState().routing.menu;
    menu.getMenuSections().then(sections => {
      dispatch({
        type: MENU_LOADING_END,
        sections
      });
    }).catch(reason => {
      console.error('Problem retrieving product menu data.', reason);
      dispatch({
        type: MENU_LOADING_ERROR,
        message: 'Error in retrieving product menu data. Please contact your site administrator.'
      });
    });
  };
}
function serverNotificationInit(serverActivitiesLoaderFn) {
  return (dispatch, getState) => {
    const serverNotificationModel = getState().serverNotifications;
    if (serverNotificationModel && !serverNotificationModel.isLoaded && !serverNotificationModel.isLoading) {
      dispatch({
        type: SERVER_NOTIFICATIONS_LOADING_START,
        serverActivitiesLoaderFn
      });
      serverActivitiesLoaderFn().then(serverActivity => {
        dispatch({
          type: SERVER_NOTIFICATIONS_LOADING_END,
          serverActivity
        });
      }).catch(reason => {
        console.error('Unable to retrieve notifications.', reason);
        dispatch({
          type: SERVER_NOTIFICATIONS_LOADING_ERROR,
          message: 'Unable to retrieve notifications.'
        });
      });
    }
  };
}
const serverNotificationInvalidate = () => ({
  type: SERVER_NOTIFICATIONS_INVALIDATE
});

// This isn't really an action, but it needs to be here to prevent circular dependencies
function registerWebSocketListeners(store, notificationListeners, menuReloadListeners) {
  if (notificationListeners) {
    notificationListeners.forEach(listener => {
      LABKEY_WEBSOCKET.addServerEventListener(listener, function (evt) {
        // not checking evt.wasClean since we want this event for all user sessions
        window.setTimeout(() => store.dispatch({
          type: SERVER_NOTIFICATIONS_INVALIDATE
        }), 1000);
      });
    });
  }
  if (menuReloadListeners) {
    menuReloadListeners.forEach(listener => {
      LABKEY_WEBSOCKET.addServerEventListener(listener, function (evt) {
        // not checking evt.wasClean since we want this event for all user sessions
        window.setTimeout(() => {
          store.dispatch(menuReload());
        }, 1000);
      });
    });
  }
}
;// CONCATENATED MODULE: ./src/internal/userFixtures.ts


const TEST_USER_GUEST = new User({
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: true,
  isRootAdmin: false,
  isSignedIn: false,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read]
});
const TEST_USER_READER = new User({
  id: 1200,
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  displayName: 'ReaderDisplayName',
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read, api_.PermissionTypes.ReadDataClass, api_.PermissionTypes.ReadAssay, api_.PermissionTypes.ReadMedia, api_.PermissionTypes.ReadNotebooks]
});
const TEST_USER_AUTHOR = new User({
  id: 1300,
  canDelete: false,
  canDeleteOwn: false,
  canInsert: true,
  canUpdate: false,
  canUpdateOwn: false,
  displayName: 'AuthorDisplayName',
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read, api_.PermissionTypes.Insert]
});
const TEST_USER_EDITOR = new User({
  id: 1100,
  canDelete: true,
  canDeleteOwn: true,
  canInsert: true,
  canUpdate: true,
  canUpdateOwn: true,
  displayName: 'EditorDisplayName',
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Delete, api_.PermissionTypes.Read, api_.PermissionTypes.Insert, api_.PermissionTypes.Update, api_.PermissionTypes.ManagePicklists, api_.PermissionTypes.ManageSampleWorkflows, api_.PermissionTypes.SampleWorkflowDelete, api_.PermissionTypes.ReadNotebooks, api_.PermissionTypes.ReadDataClass, api_.PermissionTypes.ReadAssay, api_.PermissionTypes.ReadMedia, api_.PermissionTypes.EditSharedView, api_.PermissionTypes.ShareReportPermission]
});
const TEST_USER_EDITOR_WITHOUT_DELETE = new User({
  id: 1100,
  canDelete: false,
  canDeleteOwn: false,
  canInsert: true,
  canUpdate: true,
  canUpdateOwn: true,
  displayName: 'EditorDisplayName',
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read, api_.PermissionTypes.Insert, api_.PermissionTypes.Update, api_.PermissionTypes.ManagePicklists, api_.PermissionTypes.ManageSampleWorkflows, api_.PermissionTypes.ReadNotebooks, api_.PermissionTypes.ReadDataClass, api_.PermissionTypes.ReadAssay, api_.PermissionTypes.ReadMedia, api_.PermissionTypes.EditSharedView, api_.PermissionTypes.ShareReportPermission]
});
const TEST_USER_ASSAY_DESIGNER = new User({
  id: 1400,
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  displayName: 'AssayDesignerDisplayName',
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read, api_.PermissionTypes.DesignAssay]
});
const TEST_USER_SOURCE_TYPE_DESIGNER = new User({
  id: 1400,
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  displayName: 'SourceTypeDesignerDisplayName',
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read, api_.PermissionTypes.DesignDataClass]
});
const TEST_USER_SAMPLE_TYPE_DESIGNER = new User({
  id: 1400,
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  displayName: 'SampleTypeDesignerDisplayName',
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read, api_.PermissionTypes.DesignSampleSet]
});
const TEST_USER_FOLDER_ADMIN = new User({
  id: 1005,
  canDelete: true,
  canDeleteOwn: true,
  canInsert: true,
  canUpdate: true,
  canUpdateOwn: true,
  displayName: 'FolderAdminDisplayName',
  isAdmin: true,
  isAnalyst: true,
  isDeveloper: true,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: true,
  permissionsList: [api_.PermissionTypes.Delete, api_.PermissionTypes.Read, api_.PermissionTypes.DesignDataClass, api_.PermissionTypes.DesignSampleSet, api_.PermissionTypes.DesignStorage, api_.PermissionTypes.DesignAssay, api_.PermissionTypes.Insert, api_.PermissionTypes.Update, api_.PermissionTypes.ManagePicklists, api_.PermissionTypes.ManageSampleWorkflows, api_.PermissionTypes.SampleWorkflowDelete, api_.PermissionTypes.Admin, api_.PermissionTypes.ReadNotebooks, api_.PermissionTypes.ReadDataClass, api_.PermissionTypes.ReadAssay, api_.PermissionTypes.ReadMedia, api_.PermissionTypes.EditSharedView, api_.PermissionTypes.ShareReportPermission, api_.PermissionTypes.CanSeeGroupDetails, api_.PermissionTypes.CanSeeUserDetails]
});
const TEST_USER_PROJECT_ADMIN = new User({
  id: 1005,
  canDelete: true,
  canDeleteOwn: true,
  canInsert: true,
  canUpdate: true,
  canUpdateOwn: true,
  displayName: 'FolderAdminDisplayName',
  isAdmin: true,
  isAnalyst: true,
  isDeveloper: true,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: true,
  permissionsList: [api_.PermissionTypes.Delete, api_.PermissionTypes.Read, api_.PermissionTypes.DesignDataClass, api_.PermissionTypes.DesignSampleSet, api_.PermissionTypes.DesignStorage, api_.PermissionTypes.DesignAssay, api_.PermissionTypes.Insert, api_.PermissionTypes.Update, api_.PermissionTypes.ManagePicklists, api_.PermissionTypes.ManageSampleWorkflows, api_.PermissionTypes.SampleWorkflowDelete, api_.PermissionTypes.Admin, api_.PermissionTypes.AddUser, api_.PermissionTypes.ReadNotebooks, api_.PermissionTypes.ReadDataClass, api_.PermissionTypes.ReadAssay, api_.PermissionTypes.ReadMedia, api_.PermissionTypes.EditSharedView, api_.PermissionTypes.ShareReportPermission, api_.PermissionTypes.CanSeeGroupDetails, api_.PermissionTypes.CanSeeUserDetails]
});
const TEST_USER_SITE_ADMIN = new User({
  id: 1005,
  canDelete: true,
  canDeleteOwn: true,
  canInsert: true,
  canUpdate: true,
  canUpdateOwn: true,
  displayName: 'AppAdminDisplayName',
  isAdmin: true,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: true,
  isSignedIn: true,
  isSystemAdmin: true,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Delete, api_.PermissionTypes.Read, api_.PermissionTypes.DesignDataClass, api_.PermissionTypes.DesignSampleSet, api_.PermissionTypes.DesignAssay, api_.PermissionTypes.DesignStorage, api_.PermissionTypes.Insert, api_.PermissionTypes.Update, api_.PermissionTypes.ManagePicklists, api_.PermissionTypes.ManageSampleWorkflows, api_.PermissionTypes.SampleWorkflowDelete, api_.PermissionTypes.Admin, api_.PermissionTypes.UserManagement, api_.PermissionTypes.ApplicationAdmin, api_.PermissionTypes.AddUser, api_.PermissionTypes.ReadNotebooks, api_.PermissionTypes.ReadDataClass, api_.PermissionTypes.ReadAssay, api_.PermissionTypes.ReadMedia, api_.PermissionTypes.EditSharedView, api_.PermissionTypes.ShareReportPermission, api_.PermissionTypes.CanSeeGroupDetails, api_.PermissionTypes.CanSeeUserDetails]
});
const TEST_USER_APP_ADMIN = new User({
  id: 1005,
  canDelete: true,
  canDeleteOwn: true,
  canInsert: true,
  canUpdate: true,
  canUpdateOwn: true,
  displayName: 'AppAdminDisplayName',
  isAdmin: true,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: true,
  isSignedIn: true,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Delete, api_.PermissionTypes.Read, api_.PermissionTypes.DesignDataClass, api_.PermissionTypes.DesignSampleSet, api_.PermissionTypes.DesignAssay, api_.PermissionTypes.DesignStorage, api_.PermissionTypes.Insert, api_.PermissionTypes.Update, api_.PermissionTypes.ManagePicklists, api_.PermissionTypes.ManageSampleWorkflows, api_.PermissionTypes.SampleWorkflowDelete, api_.PermissionTypes.Admin, api_.PermissionTypes.UserManagement, api_.PermissionTypes.ApplicationAdmin, api_.PermissionTypes.AddUser, api_.PermissionTypes.ReadNotebooks, api_.PermissionTypes.ReadDataClass, api_.PermissionTypes.ReadAssay, api_.PermissionTypes.ReadMedia, api_.PermissionTypes.EditSharedView, api_.PermissionTypes.ShareReportPermission, api_.PermissionTypes.CanSeeGroupDetails, api_.PermissionTypes.CanSeeUserDetails]
});
const TEST_USER_STORAGE_DESIGNER = new User({
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: true,
  isRootAdmin: false,
  isSignedIn: false,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read, api_.PermissionTypes.DesignStorage]
});
const TEST_USER_STORAGE_EDITOR = new User({
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: true,
  isRootAdmin: false,
  isSignedIn: false,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read, api_.PermissionTypes.EditStorageData, api_.PermissionTypes.ManageSampleWorkflows, api_.PermissionTypes.ManagePicklists]
});
const TEST_USER_WORKFLOW_EDITOR = new User({
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: true,
  isRootAdmin: false,
  isSignedIn: false,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.Read, api_.PermissionTypes.ManageSampleWorkflows, api_.PermissionTypes.SampleWorkflowDelete, api_.PermissionTypes.ManagePicklists]
});
const TEST_USER_QC_ANALYST = new User({
  canDelete: false,
  canDeleteOwn: false,
  canInsert: false,
  canUpdate: false,
  canUpdateOwn: false,
  isAdmin: false,
  isAnalyst: false,
  isDeveloper: false,
  isGuest: false,
  isRootAdmin: false,
  isSignedIn: false,
  isSystemAdmin: false,
  isTrusted: false,
  permissionsList: [api_.PermissionTypes.QCAnalyst]
});
;// CONCATENATED MODULE: ./src/internal/containerFixtures.ts
function containerFixtures_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function containerFixtures_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? containerFixtures_ownKeys(Object(t), !0).forEach(function (r) { containerFixtures_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : containerFixtures_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function containerFixtures_defineProperty(e, r, t) { return (r = containerFixtures_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function containerFixtures_toPropertyKey(t) { var i = containerFixtures_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function containerFixtures_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



const TEST_DATE_FORMATS = {
  dateFormat: 'yyyy-MM-dd',
  dateTimeFormat: 'yyyy-MM-dd HH:mm',
  numberFormat: null,
  timeFormat: 'HH:mm'
};
const TEST_PROJECT_CONTAINER_CONFIG = {
  activeModules: ['a', 'b', 'c'],
  formats: TEST_DATE_FORMATS,
  id: 'a685712e-0900-103a-9486-0131958dce60',
  isContainerTab: false,
  isWorkbook: false,
  name: 'TestProjectContainer',
  parentId: '785eb92a-95aa-1039-9db0-ffabf47c5c38',
  parentPath: '/',
  path: '/TestProjectContainer',
  title: 'Test Project Container',
  type: 'project'
};
const TEST_PROJECT_CONTAINER = new Container(TEST_PROJECT_CONTAINER_CONFIG);
const TEST_PROJECT_CONTAINER_ADMIN = new Container(containerFixtures_objectSpread(containerFixtures_objectSpread({}, TEST_PROJECT_CONTAINER_CONFIG), {}, {
  effectivePermissions: ['org.labkey.api.security.permissions.AdminPermission', 'org.labkey.api.security.permissions.AddUserPermission']
}));
const TEST_PROJECT = {
  id: TEST_PROJECT_CONTAINER.id,
  name: TEST_PROJECT_CONTAINER.name,
  path: TEST_PROJECT_CONTAINER.path,
  rootId: TEST_PROJECT_CONTAINER.parentId,
  title: TEST_PROJECT_CONTAINER.title
};
const TEST_FOLDER_CONTAINER_CONFIG = {
  activeModules: ['a', 'b', 'c'],
  formats: TEST_DATE_FORMATS,
  id: 'b685712f-0800-103a-9286-0131958dcf60',
  isContainerTab: false,
  isWorkbook: false,
  name: 'TestFolderContainer',
  parentId: TEST_PROJECT_CONTAINER.id,
  parentPath: TEST_PROJECT_CONTAINER.path,
  path: `${TEST_PROJECT_CONTAINER.path}/TestFolderContainer`,
  title: 'Test Folder Container',
  type: 'folder'
};
const TEST_FOLDER_CONTAINER = new Container(TEST_FOLDER_CONTAINER_CONFIG);
const TEST_FOLDER_CONTAINER_ADMIN = new Container(containerFixtures_objectSpread(containerFixtures_objectSpread({}, TEST_FOLDER_CONTAINER_CONFIG), {}, {
  effectivePermissions: ['org.labkey.api.security.permissions.AdminPermission']
}));
const TEST_FOLDER_OTHER_CONTAINER_CONFIG = {
  activeModules: ['a', 'b', 'c'],
  formats: TEST_DATE_FORMATS,
  id: 'b685712f-0800-103a-9286-0131958dcf69',
  isContainerTab: false,
  isWorkbook: false,
  name: 'OtherTestFolderContainer',
  parentId: TEST_PROJECT_CONTAINER.id,
  parentPath: TEST_PROJECT_CONTAINER.path,
  path: `${TEST_PROJECT_CONTAINER.path}/OtherTestFolderContainer`,
  title: 'Other Test Folder Container',
  type: 'folder'
};
const TEST_FOLDER_OTHER_CONTAINER = new Container(TEST_FOLDER_OTHER_CONTAINER_CONFIG);
const TEST_FOLDER_OTHER_CONTAINER_ADMIN = new Container(containerFixtures_objectSpread(containerFixtures_objectSpread({}, TEST_FOLDER_OTHER_CONTAINER_CONFIG), {}, {
  effectivePermissions: ['org.labkey.api.security.permissions.AdminPermission']
}));
const createTestProjectAppContextAdmin = (mockFn = () => () => {}) => {
  return {
    api: getTestAPIWrapper(mockFn, {
      security: getSecurityTestAPIWrapper(mockFn, {
        fetchContainers: mockFn().mockResolvedValue([TEST_PROJECT_CONTAINER_ADMIN, TEST_FOLDER_CONTAINER_ADMIN])
      })
    })
  };
};
const createTestProjectAppContextNonAdmin = (mockFn = () => () => {}) => {
  return {
    api: getTestAPIWrapper(mockFn, {
      security: getSecurityTestAPIWrapper(mockFn, {
        fetchContainers: mockFn().mockResolvedValue([TEST_PROJECT_CONTAINER, TEST_FOLDER_CONTAINER])
      })
    })
  };
};
;// CONCATENATED MODULE: ./src/internal/components/DateInput.tsx
function DateInput_extends() { return DateInput_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DateInput_extends.apply(null, arguments); }
function DateInput_defineProperty(e, r, t) { return (r = DateInput_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function DateInput_toPropertyKey(t) { var i = DateInput_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function DateInput_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class DateInput extends external_react_.PureComponent {
  constructor(props) {
    super(props);
    DateInput_defineProperty(this, "input", void 0);
    DateInput_defineProperty(this, "onIconClick", () => {
      this.input.current?.setFocus();
    });
    DateInput_defineProperty(this, "onSelect", (date, event) => {
      // focus the input so an onBlur action gets triggered after selection has been made
      this.input.current?.setFocus();
      this.props.onSelect?.(date, event);
    });
    this.input = external_react_default().createRef();
  }
  render() {
    return /*#__PURE__*/external_react_default().createElement("span", {
      className: "input-group date-input"
    }, /*#__PURE__*/external_react_default().createElement((external_react_datepicker_default()), DateInput_extends({}, this.props, {
      ref: this.input,
      onSelect: this.onSelect
    })), /*#__PURE__*/external_react_default().createElement("span", {
      className: "input-group-addon",
      onClick: this.onIconClick
    }, /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-calendar"
    })));
  }
}
// DatePicker is not a react-bootstrap component, form-control class is needed on className and wrapperClassName,
// we also need to re-apply border radius via date-input class in fields.scss.
DateInput_defineProperty(DateInput, "defaultProps", {
  autoComplete: 'off',
  className: 'form-control',
  // TODO: Support server-specified date formats.
  // DatePicker utilizes `date-fns` (https://date-fns.org/) for handling date formatting. Currently, LabKey
  // utilizes `moment` for handling date formats on the client and Java date formatting on the server. This
  // mix of different formats is problematic for providing consistent date formatting to users in all cases.
  dateFormat: 'MM/dd/yyyy',
  // different format than Moment.
  wrapperClassName: 'form-control',
  showTimeSelect: false
});
;// CONCATENATED MODULE: ./src/internal/components/EditInlineField.tsx
function EditInlineField_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EditInlineField_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EditInlineField_ownKeys(Object(t), !0).forEach(function (r) { EditInlineField_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EditInlineField_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function EditInlineField_defineProperty(e, r, t) { return (r = EditInlineField_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function EditInlineField_toPropertyKey(t) { var i = EditInlineField_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function EditInlineField_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











const EditInlineField = (0,external_react_.memo)(props => {
  const {
    allowBlank,
    allowEdit,
    className,
    emptyText,
    label,
    name,
    onChange,
    placeholder,
    type,
    value,
    column,
    useJsonDateFormat,
    timezone,
    tooltip
  } = props;
  const {
    container
  } = useServerContext();
  const dateFormat = column?.format ?? getMomentDateFormat(container);
  const isDate = type === 'date' || column?.jsonType === 'date';
  const isDateOnly = column?.isDateOnlyColumn;
  const isTime = type === 'time' || column?.jsonType === 'time';
  const isDateOrTime = isDate || isTime;
  const isTextArea = type === 'textarea';
  const isText = !isDate && !isTextArea;
  const isUser = QueryColumn.isUserLookup(column?.lookup);
  const inputType = type === 'int' || type === 'float' ? 'number' : 'text';
  const inputRef = (0,external_react_.useRef)(null);
  const _value = typeof value === 'object' ? value?.value : value;
  const [dateValue, setDateValue] = (0,external_react_.useState)(() => isDate && _value ? new Date(_value) : undefined);
  const [timeJsonValue, setTimeJsonValue] = (0,external_react_.useState)(undefined);
  const [columnBasedValue, setColumnBasedValue] = (0,external_react_.useState)();

  // Utilizing useReducer here so multiple state attributes can be updated at once
  const [state, setState] = (0,external_react_.useReducer)((currentState, newState) => EditInlineField_objectSpread(EditInlineField_objectSpread({}, currentState), newState), {
    editing: false,
    ignoreBlur: false
  });
  const displayValue = (0,external_react_.useMemo)(() => {
    let value_;
    if (value?.formattedValue) {
      value_ = value.formattedValue;
    } else if (value?.displayValue) {
      value_ = value.displayValue;
    } else if (_value !== undefined && _value !== null && _value !== '') {
      // value is of type "any" so it could be a number, boolean, etc. Use explicit value checks.
      if (isDate) {
        value_ = formatDate(_value, timezone, dateFormat);
      } else {
        value_ = _value?.toString();
      }
    }

    // Issue 48196: if the domain column has been setup with a "url" prop, use it in the EditInlineField value display
    if (value_ !== undefined && value?.url) {
      value_ = /*#__PURE__*/external_react_default().createElement("a", {
        href: value.url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, value_);
    }
    if (value_) return value_;
    return /*#__PURE__*/external_react_default().createElement("span", {
      className: "edit-inline-field__placeholder"
    }, emptyText);
  }, [dateFormat, emptyText, isDate, timezone, value, _value]);
  const getInputValue = (0,external_react_.useCallback)(() => {
    if (isTime) return timeJsonValue;
    if (isDate) {
      if (useJsonDateFormat) {
        return isDateOnly ? getJsonDateFormatString(dateValue) : getJsonDateTimeFormatString(dateValue);
      }
      return dateValue?.valueOf();
    }
    if (column) return columnBasedValue;
    return inputRef.current?.value;
  }, [dateValue, timeJsonValue, isDate, isTime, columnBasedValue, column, useJsonDateFormat, isDateOnly]);
  const onCancel = (0,external_react_.useCallback)(() => {
    setState({
      editing: false,
      ignoreBlur: true
    });
  }, []);
  const saveEdit = (0,external_react_.useCallback)(() => {
    const inputValue = getInputValue();
    if (allowBlank === false && !isDate && inputValue.trim() === '') {
      return;
    }
    if (inputValue !== _value) {
      onChange?.(name, inputValue);
    }
    setState({
      editing: false
    });
  }, [allowBlank, getInputValue, isDate, name, onChange, _value]);
  const onBlur = (0,external_react_.useCallback)(() => {
    if (!state.ignoreBlur) {
      if (allowBlank === false && !isDate && getInputValue().trim() === '') {
        onCancel();
      } else {
        saveEdit();
      }
    }
    setState({
      ignoreBlur: false
    });
  }, [allowBlank, getInputValue, isDate, onCancel, saveEdit, state.ignoreBlur]);
  const onDateChange = (0,external_react_.useCallback)(date => {
    if (date instanceof Array) throw new Error('Unsupported date/time type');
    if (typeof date === 'string') setTimeJsonValue(date);else setDateValue(date);
  }, []);
  const onFormsyColumnChange = (0,external_react_.useCallback)(data => {
    setColumnBasedValue(data[column.fieldKey]);
  }, [column]);
  const onKeyDown = useEnterEscape(saveEdit, onCancel);

  // This is used in conjunction with the input-resizer class  to get the input field to resize based on the size of the value.
  const onInputChange = (0,external_react_.useCallback)(event => {
    event.currentTarget.parentElement.dataset.value = event.currentTarget.value + '';
  }, []);
  const toggleEdit = (0,external_react_.useCallback)(() => {
    if (allowEdit) {
      setState({
        editing: !state.editing
      });
    }
  }, [allowEdit, state.editing]);
  const toggleKeyDown = (0,external_react_.useCallback)(evt => {
    if (evt.key === Key.ENTER) toggleEdit();
  }, [toggleEdit]);

  // When focusing on a <textarea /> the default browser behavior is to set the cursor
  // to the beginning of the text. For <input type="text" /> the default browser behavior
  // is to set the cursor to the end of the text. This makes the <textarea /> utilized by
  // this component behave like an <input /> and sets the cursor to the end.
  const onTextAreaFocus = (0,external_react_.useCallback)(evt => {
    const valueLength = evt.target.value.length;
    if (valueLength > 0) {
      evt.target.setSelectionRange(valueLength, valueLength);
    }
  }, []);
  const dateInputDateFormat = (0,external_react_.useMemo)(() => isDate ? getColDateFormat(column, column ? undefined : getMomentDateFormat()) : undefined, [column, isDate]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className
  }, state.editing && isDateOrTime && !!column && /*#__PURE__*/external_react_default().createElement(DatePickerInput, {
    autoFocus: true,
    name: name,
    formsy: false,
    queryColumn: column,
    showLabel: false,
    value: isDate ? dateValue : _value,
    inputWrapperClassName: "form-control",
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    onChange: onDateChange,
    placeholderText: placeholder,
    inlineEdit: true
  }), state.editing && isDateOrTime && !column && /*#__PURE__*/external_react_default().createElement(DateInput, {
    autoFocus: true,
    name: name,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    onChange: onDateChange,
    onMonthChange: onDateChange,
    placeholderText: placeholder,
    selected: dateValue,
    showTimeSelect: !!column,
    dateFormat: dateInputDateFormat,
    timeFormat: parseDateFNSTimeFormat(dateInputDateFormat)
  }), state.editing && isTextArea && /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group"
  }, /*#__PURE__*/external_react_default().createElement("textarea", {
    autoFocus: true,
    className: "form-control",
    cols: 100,
    defaultValue: _value,
    onBlur: onBlur,
    onFocus: onTextAreaFocus,
    onKeyDown: onKeyDown,
    name: name,
    placeholder: placeholder,
    ref: inputRef,
    rows: 5
  })), state.editing && column && !isDateOrTime && /*#__PURE__*/external_react_default().createElement((external_formsy_react_default()), {
    className: "form-horizontal",
    onChange: onFormsyColumnChange
  }, resolveDetailEditRenderer(column, {
    hideLabel: true,
    autoFocus: true,
    onBlur,
    placeholder
  })(value)), state.editing && !column && isText && /*#__PURE__*/external_react_default().createElement("span", {
    className: "input-group input-sizer"
  }, /*#__PURE__*/external_react_default().createElement("input", {
    autoFocus: true,
    className: "form-control",
    defaultValue: _value,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    name: name,
    placeholder: placeholder,
    ref: inputRef,
    type: inputType,
    size: Math.max(_value?.length ?? 0, 20),
    onInput: onInputChange
  })), !state.editing && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, label && /*#__PURE__*/external_react_default().createElement("span", {
    className: "edit-inline-field__label",
    unselectable: "on",
    title: allowEdit ? tooltip : undefined
  }, label), isUser && /*#__PURE__*/external_react_default().createElement(UserLink, {
    userId: value?.value,
    userDisplayValue: value?.displayValue
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: external_classnames_default()({
      'edit-inline-field__toggle': allowEdit,
      'ws-pre-wrap': isTextArea
    }),
    onClick: toggleEdit,
    onKeyDown: toggleKeyDown,
    tabIndex: 1
  }, !isUser && displayValue, allowEdit && /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-pencil"
  }))));
});
EditInlineField.defaultProps = {
  className: 'edit-inline-field'
};
;// CONCATENATED MODULE: ./src/internal/components/files/FileAttachmentArea.tsx



/**
 * This component looks like the FileAttachmentContainer, but does significantly less. It only renders the file drop
 * area/input, it does not render attached files. This is useful if you render attached files separately from your
 * attachment area, such as in cases where files are automatically uploaded.
 */
const FileAttachmentArea = (0,external_react_.memo)(({
  onAttach,
  compact
}) => {
  const [highlight, setHighlight] = (0,external_react_.useState)(false);
  const onChange = (0,external_react_.useCallback)(evt => {
    cancelEvent(evt);
    onAttach(Array.from(evt.target.files));
  }, [onAttach]);
  const onDrag = (0,external_react_.useCallback)(evt => {
    cancelEvent(evt);
    setHighlight(true);
  }, []);
  const onDragLeave = (0,external_react_.useCallback)(evt => {
    cancelEvent(evt);
    setHighlight(false);
  }, []);
  const onDrop = (0,external_react_.useCallback)(evt => {
    cancelEvent(evt);
    setHighlight(false);
    if (evt.dataTransfer?.files) {
      onAttach(Array.from(evt.dataTransfer.files));
    }
  }, [onAttach]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "file-attachment-area",
    onDrop: onDrop
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "file-upload--container"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: external_classnames_default()({
      'file-upload--label': !compact,
      'file-upload--label--compact': compact,
      'file-upload__is-hover': highlight
    }),
    htmlFor: "simple-file-attachment-container",
    onDragEnter: onDrag,
    onDragLeave: onDragLeave,
    onDragOver: onDrag,
    onDrop: onDrop
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: external_classnames_default()('fa fa-cloud-upload', {
      'fa-2x': !compact
    }),
    "aria-hidden": "true"
  }), ' ', "Select file or drag and drop here"), /*#__PURE__*/external_react_default().createElement("input", {
    className: "file-upload--input",
    id: "simple-file-attachment-container",
    multiple: true,
    onChange: onChange,
    type: "file"
  })));
});
;// CONCATENATED MODULE: ./src/internal/announcements/model.ts


// Expected to match WikiRendererType.java
let AnnouncementRenderType = /*#__PURE__*/function (AnnouncementRenderType) {
  AnnouncementRenderType["HTML"] = "HTML";
  AnnouncementRenderType["MARKDOWN"] = "MARKDOWN";
  AnnouncementRenderType["RADEOX"] = "RADEOX";
  AnnouncementRenderType["TEXT_WITH_LINKS"] = "TEXT_WITH_LINKS";
  return AnnouncementRenderType;
}({});
const getAttachmentURL = (attachment, containerPath) => {
  return api_.ActionURL.buildURL('announcements', 'download', containerPath, {
    name: attachment.name,
    entityId: attachment.parent
  });
};
// See copyEditableProps from AnnouncementsController
const EDITABLE_FIELDS = ['approved', 'body', 'discussionSrcIdentifier', 'discussionSrcEntityType', 'expires', 'parent', 'rendererType', 'rowId', 'status', 'title'];
;// CONCATENATED MODULE: ./src/internal/announcements/APIWrapper.ts
function announcements_APIWrapper_defineProperty(e, r, t) { return (r = announcements_APIWrapper_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function announcements_APIWrapper_toPropertyKey(t) { var i = announcements_APIWrapper_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function announcements_APIWrapper_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


const createThreadForm = (thread, files) => {
  const form = new FormData();
  EDITABLE_FIELDS.forEach(field => {
    const value = thread[field];
    if (value !== undefined) {
      form.append(`thread.${field}`, value.toString());
    }
  });
  files.forEach((file, i) => {
    form.append(`file${i === 0 ? '' : i}`, file);
  });
  return form;
};
class ServerAnnouncementsAPIWrapper {
  constructor() {
    announcements_APIWrapper_defineProperty(this, "createThread", (thread, files, reply, containerPath) => {
      const form = createThreadForm(thread, files);
      form.append('reply', (!!reply).toString());
      return new Promise((resolve, reject) => {
        return api_.Ajax.request({
          url: api_.ActionURL.buildURL('announcements', 'createThread.api', containerPath),
          method: 'POST',
          form,
          success: api_.Utils.getCallbackWrapper(({
            data
          }) => {
            resolve(data);
          }),
          failure: api_.Utils.getCallbackWrapper(error => {
            reject(error);
          }, undefined, true)
        });
      });
    });
    announcements_APIWrapper_defineProperty(this, "deleteAttachment", (entityId, name, containerPath) => {
      return new Promise((resolve, reject) => {
        return api_.Ajax.request({
          url: api_.ActionURL.buildURL('announcements', 'deleteAttachment.api', containerPath),
          method: 'POST',
          jsonData: {
            entityId,
            name
          },
          success: api_.Utils.getCallbackWrapper(({
            success
          }) => resolve(success)),
          failure: api_.Utils.getCallbackWrapper(error => {
            reject(error);
          }, undefined, true)
        });
      });
    });
    announcements_APIWrapper_defineProperty(this, "deleteThread", (threadRowId, containerPath) => {
      return new Promise((resolve, reject) => {
        return api_.Ajax.request({
          url: api_.ActionURL.buildURL('announcements', 'deleteThread.api', containerPath),
          method: 'POST',
          jsonData: {
            rowId: threadRowId
          },
          success: api_.Utils.getCallbackWrapper(({
            success
          }) => resolve(success)),
          failure: api_.Utils.getCallbackWrapper(error => {
            reject(error);
          }, undefined, true)
        });
      });
    });
    announcements_APIWrapper_defineProperty(this, "getDiscussions", (discussionSrcIdentifier, containerPath) => {
      return new Promise((resolve, reject) => {
        return api_.Ajax.request({
          url: api_.ActionURL.buildURL('announcements', 'getDiscussions.api', containerPath),
          method: 'POST',
          jsonData: {
            discussionSrcIdentifier
          },
          success: api_.Utils.getCallbackWrapper(({
            data
          }) => {
            resolve(data);
          }),
          failure: api_.Utils.getCallbackWrapper(error => {
            reject(error);
          }, undefined, true)
        });
      });
    });
    announcements_APIWrapper_defineProperty(this, "getThread", (threadRowId, containerPath) => {
      return new Promise((resolve, reject) => {
        return api_.Ajax.request({
          url: api_.ActionURL.buildURL('announcements', 'getThread.api', containerPath),
          method: 'POST',
          jsonData: {
            rowId: threadRowId
          },
          success: api_.Utils.getCallbackWrapper(({
            data
          }) => {
            resolve(data);
          }),
          failure: api_.Utils.getCallbackWrapper(error => {
            reject(error);
          }, undefined, true)
        });
      });
    });
    announcements_APIWrapper_defineProperty(this, "renderContent", (content, containerPath) => {
      return new Promise((resolve, reject) => {
        return api_.Ajax.request({
          url: api_.ActionURL.buildURL('core', 'transformWiki.api', containerPath),
          method: 'POST',
          jsonData: {
            body: content,
            fromFormat: 'MARKDOWN',
            toFormat: 'HTML'
          },
          success: api_.Utils.getCallbackWrapper(({
            body
          }) => {
            resolve(body);
          }),
          failure: api_.Utils.getCallbackWrapper(error => {
            reject(error);
          }, undefined, true)
        });
      });
    });
    announcements_APIWrapper_defineProperty(this, "updateThread", (thread, files, containerPath) => {
      const form = createThreadForm(thread, files);
      return new Promise((resolve, reject) => {
        return api_.Ajax.request({
          url: api_.ActionURL.buildURL('announcements', 'updateThread.api', containerPath),
          method: 'POST',
          form,
          success: api_.Utils.getCallbackWrapper(({
            data
          }) => {
            resolve(data);
          }),
          failure: api_.Utils.getCallbackWrapper(error => {
            reject(error);
          }, undefined, true)
        });
      });
    });
  }
}
const getDefaultAnnouncementsAPIWrapper = () => new ServerAnnouncementsAPIWrapper();
;// CONCATENATED MODULE: ./src/internal/announcements/ThreadAttachments.tsx




const ThreadAttachment = (0,external_react_.memo)(({
  attachment,
  containerPath,
  onRemove
}) => {
  const _onRemove = (0,external_react_.useCallback)(() => onRemove(attachment.name), [attachment, onRemove]);
  // Only generate a URL if the file has been uploaded.
  const url = attachment.created !== undefined ? getAttachmentURL(attachment, containerPath) : undefined;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-attachment"
  }, onRemove !== undefined && /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-times-circle thread-attachment-icon thread-attachment-icon--remove",
    onClick: _onRemove
  }), /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-file-text thread-attachment-icon thread-attachment-icon--file"
  }), url === undefined && /*#__PURE__*/external_react_default().createElement("span", null, attachment.name), url !== undefined && /*#__PURE__*/external_react_default().createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, attachment.name));
});
const ThreadAttachments = (0,external_react_.memo)(({
  attachments,
  containerPath,
  error,
  onRemove
}) => /*#__PURE__*/external_react_default().createElement("div", {
  className: "thread-editor-attachments"
}, /*#__PURE__*/external_react_default().createElement("div", {
  className: "thread-editor-attachments__error help-block"
}, error), /*#__PURE__*/external_react_default().createElement("div", {
  className: "thread-editor-attachments__body"
}, /*#__PURE__*/external_react_default().createElement("div", {
  className: "thread-editor-attachments__list"
}, attachments.map(attachment => /*#__PURE__*/external_react_default().createElement(ThreadAttachment, {
  key: attachment.name,
  attachment: attachment,
  onRemove: onRemove,
  containerPath: containerPath
}))))));
const RemoveAttachmentModal = (0,external_react_.memo)(props => /*#__PURE__*/external_react_default().createElement(Modal, {
  canConfirm: !props.isRemoving,
  confirmClass: "btn-danger",
  confirmText: "Yes, Delete Attachment",
  onCancel: props.cancel,
  onConfirm: props.remove,
  title: "Delete Attachment?"
}, /*#__PURE__*/external_react_default().createElement(Alert, null, props.error), "Are you sure you want to delete the attachment \"", props.name, "\"?"));
;// CONCATENATED MODULE: ./src/internal/announcements/ThreadEditor.tsx
function ThreadEditor_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ThreadEditor_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ThreadEditor_ownKeys(Object(t), !0).forEach(function (r) { ThreadEditor_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ThreadEditor_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ThreadEditor_defineProperty(e, r, t) { return (r = ThreadEditor_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ThreadEditor_toPropertyKey(t) { var i = ThreadEditor_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ThreadEditor_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









// Check if a line starts with any spaces, a number, followed by a period and a space.
const orderedBulletRe = /^\s*\d+. /;
// Checks if the entire line consists of any spaces, followed by a number, followed by a period and a space.
const orderedBulletLine = /^\s*\d+. $/;
const handleBulletedListEnter = (selectionStart, selectionEnd, value) => {
  if (selectionStart !== selectionEnd) {
    return [undefined, undefined];
  }

  // Subtract 1 because if the cursor is at the end of the line it will be on a "\n" character and the loop below will
  // exit prematurely.
  let index = selectionStart - 1;
  // The position of the first character of the line the cursor was on when the user hit enter.
  let startOfLine;

  // Travel backwards until we fine the start of the line the cursor is on.
  while (index >= 0) {
    if (value[index] === '\n') {
      startOfLine = index + 1;
      break;
    }
    if (index === 0) {
      startOfLine = index;
      break;
    }
    index = index - 1;
  }
  const line = value.slice(startOfLine, selectionStart);
  const trimmedLine = line.trimLeft();
  const padding = line.length - trimmedLine.length;
  const isUnordered = trimmedLine.startsWith('- ');
  const isOrdered = orderedBulletRe.test(line);
  const isList = isUnordered || orderedBulletRe.test(line);
  const entireLineIsBullet = trimmedLine === '- ' || orderedBulletLine.test(trimmedLine);
  if (isList) {
    let before;
    let after;
    let body;
    let cursorPos;
    if (entireLineIsBullet) {
      // If the user hit enter an the entire contents of the line is '- ' or a number then we
      // want to escape out of the list.
      before = value.slice(0, startOfLine);
      after = value.slice(selectionStart);
      body = before + after;
      cursorPos = startOfLine;
    } else {
      before = value.slice(0, selectionStart);
      after = value.slice(selectionStart);
      let bullet;
      if (isOrdered) {
        const periodIndex = trimmedLine.indexOf('.');
        bullet = `${parseInt(trimmedLine.slice(0, periodIndex), 10) + 1}. `;
      } else {
        bullet = '- ';
      }
      bullet = bullet.padStart(padding + bullet.length);
      body = `${before}\n${bullet}${after}`;
      cursorPos = selectionStart + bullet.length + 1;
    }
    return [body, cursorPos];
  }
  return [undefined, undefined];
};
var EditorView = /*#__PURE__*/function (EditorView) {
  EditorView["edit"] = "Markdown mode";
  EditorView["preview"] = "Preview";
  return EditorView;
}(EditorView || {});
const ToolBarButton = (0,external_react_.memo)(({
  disabled,
  iconName,
  onClick
}) => {
  const iconClass = `fa fa-${iconName}`;
  const _onClick = (0,external_react_.useCallback)(() => onClick(), [onClick]);
  return /*#__PURE__*/external_react_default().createElement("button", {
    className: "editor-toolbar__button",
    disabled: disabled,
    onClick: _onClick
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: iconClass
  }));
});
const extractTemplateParts = element => {
  const {
    selectionStart,
    selectionEnd,
    value
  } = element;
  const before = value.slice(0, selectionStart);
  const selected = value.slice(selectionStart, selectionEnd);
  const after = value.slice(selectionEnd);
  return [before, selected, after];
};
const applyTemplate = (element, prefix, postfix) => {
  const [before, selected, after] = extractTemplateParts(element);
  const newText = `${prefix}${selected}${postfix}`;
  const selectionStart = element.selectionStart + prefix.length;
  const selectionEnd = element.selectionEnd + prefix.length;
  return [`${before}${newText}${after}`, selectionStart, selectionEnd];
};
const applyList = (element, mapper) => {
  const [before, selected, after] = extractTemplateParts(element);
  const items = selected.split('\n').map(mapper).join('\n');
  return `${before}${items}${after}`;
};
const olMapper = (item, index) => `${index + 1}. ${item}`;
const ulMapper = item => `- ${item}`;
const ThreadEditorToolbar = (0,external_react_.memo)(({
  inputRef,
  setBody,
  setView,
  view
}) => {
  const bold = (0,external_react_.useCallback)(() => {
    const [body, selectionStart, selectionEnd] = applyTemplate(inputRef.current, '**', '**');
    setBody(body, selectionStart, selectionEnd);
  }, [inputRef]);
  const italic = (0,external_react_.useCallback)(() => {
    const [body, selectionStart, selectionEnd] = applyTemplate(inputRef.current, '*', '*');
    setBody(body, selectionStart, selectionEnd);
  }, [inputRef]);
  const link = (0,external_react_.useCallback)(() => {
    const [body, selectionStart, selectionEnd] = applyTemplate(inputRef.current, '[', '](url)');
    // Highlight url area instead of previously selected text
    const selectionLength = selectionEnd - selectionStart;
    setBody(body, selectionStart + selectionLength + 2, selectionEnd + 5);
  }, [inputRef]);
  const unorderedList = (0,external_react_.useCallback)(() => {
    setBody(applyList(inputRef.current, ulMapper));
  }, [inputRef]);
  const orderedList = (0,external_react_.useCallback)(() => {
    setBody(applyList(inputRef.current, olMapper));
  }, [inputRef]);
  const setEditMode = (0,external_react_.useCallback)(() => setView(EditorView.edit), [setView]);
  const setPreviewMode = (0,external_react_.useCallback)(() => setView(EditorView.preview), [setView]);
  const buttonsDisabled = view === EditorView.preview;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-editor-toolbar editor-toolbar"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "editor-toolbar__section insert-menu"
  }, /*#__PURE__*/external_react_default().createElement(DropdownAnchor, {
    title: view
  }, /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: setEditMode
  }, EditorView.edit), /*#__PURE__*/external_react_default().createElement(MenuItem, {
    onClick: setPreviewMode
  }, EditorView.preview))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "editor-toolbar__section"
  }, /*#__PURE__*/external_react_default().createElement(ToolBarButton, {
    disabled: buttonsDisabled,
    iconName: "bold",
    onClick: bold
  }), /*#__PURE__*/external_react_default().createElement(ToolBarButton, {
    disabled: buttonsDisabled,
    iconName: "italic",
    onClick: italic
  }), /*#__PURE__*/external_react_default().createElement(ToolBarButton, {
    disabled: buttonsDisabled,
    iconName: "link",
    onClick: link
  }), /*#__PURE__*/external_react_default().createElement(ToolBarButton, {
    disabled: buttonsDisabled,
    iconName: "list-ul",
    onClick: unorderedList
  }), /*#__PURE__*/external_react_default().createElement(ToolBarButton, {
    disabled: buttonsDisabled,
    iconName: "list-ol",
    onClick: orderedList
  })));
});
const Preview = (0,external_react_.memo)(({
  containerPath,
  content,
  renderContent
}) => {
  const [renderedContent, setRenderedContent] = (0,external_react_.useState)(undefined);
  const [loadingState, setLoadingState] = (0,external_react_.useState)(LoadingState.INITIALIZED);
  const [error, setError] = (0,external_react_.useState)(undefined);
  const _isLoading = isLoading(loadingState);
  (0,external_react_.useEffect)(() => {
    (async () => {
      setLoadingState(LoadingState.LOADING);
      try {
        const _renderedContent = await renderContent(content, containerPath);
        setError(undefined);
        setRenderedContent(_renderedContent);
      } catch (e) {
        setError(resolveErrorMessage(e));
      } finally {
        setLoadingState(LoadingState.LOADED);
      }
    })();
  }, [containerPath, content]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-editor-preview"
  }, _isLoading && /*#__PURE__*/external_react_default().createElement(LoadingSpinner, null), !_isLoading && error === undefined && /*#__PURE__*/external_react_default().createElement("div", {
    dangerouslySetInnerHTML: {
      __html: renderedContent
    }
  }), !_isLoading && error !== undefined && /*#__PURE__*/external_react_default().createElement("div", {
    className: "help-block"
  }, "Error loading preview: ", error));
});
const ThreadEditor = props => {
  const {
    api,
    containerPath,
    discussionSrcIdentifier,
    discussionSrcEntityType,
    nounSingular,
    onCancel,
    onCreate,
    onUpdate,
    parent,
    thread,
    setPendingChange
  } = props;
  const bodyInputRef = (0,external_react_.useRef)(null);
  const [error, setError] = (0,external_react_.useState)(undefined);
  const [model, setModel] = (0,external_react_.useState)(ThreadEditor_objectSpread({}, thread));
  const [submitting, setSubmitting] = (0,external_react_.useState)(false);
  const hasError = error !== undefined;
  const isCreate = model.rowId === undefined;
  const submitDisabled = submitting || !model.body;
  const [attachmentError, setAttachmentError] = (0,external_react_.useState)(undefined);
  const [files, setFiles] = (0,external_react_.useState)([]);
  const attachments = (0,external_react_.useMemo)(() => {
    return (model.attachments ?? []).concat(files.map(f => ({
      name: f.name,
      documentSize: f.size
    })));
  }, [model.attachments, files]);
  const onAttach = (0,external_react_.useCallback)(newFiles => {
    const duplicates = [];
    const filesToAdd = newFiles.filter(file => {
      const existingAttachment = attachments.find(attachment => attachment.name === file.name);
      if (existingAttachment !== undefined) {
        duplicates.push(file.name);
        return false;
      }
      return true;
    });
    if (duplicates.length > 0) {
      setAttachmentError(`Duplicate files can not be attached: ${duplicates.join(', ')}`);
    } else {
      setAttachmentError(undefined);
    }
    setFiles(files.concat(filesToAdd));
  }, [files, attachments]);
  const onFileInputChange = (0,external_react_.useMemo)(() => handleFileInputChange(onAttach), [onAttach]);
  const [attachmentToRemove, setAttachmentToRemove] = (0,external_react_.useState)(undefined);
  const openRemoveModal = (0,external_react_.useCallback)(name => setAttachmentToRemove(name), []);
  const closeRemoveModal = (0,external_react_.useCallback)(() => setAttachmentToRemove(undefined), []);
  const [isRemoving, setIsRemoving] = (0,external_react_.useState)(false);
  const [removeAttachmentError, setRemoveAttachmentError] = (0,external_react_.useState)(undefined);
  const removeAttachment = (0,external_react_.useCallback)(async () => {
    const attachment = attachments.find(attachment => attachment.name === attachmentToRemove);
    if (attachment.created !== undefined) {
      // pre-existing attachment, delete from server
      setIsRemoving(true);
      try {
        await api.deleteAttachment(attachment.parent, attachment.name, containerPath);
        const updatedAttachments = model.attachments.filter(att => att.name !== attachmentToRemove);
        setModel(ThreadEditor_objectSpread(ThreadEditor_objectSpread({}, model), {}, {
          attachments: updatedAttachments
        }));
        setAttachmentToRemove(undefined);
      } catch (err) {
        const message = resolveErrorMessage(err, 'attachment', 'delete');
        setRemoveAttachmentError(`Error deleting attachment: ${message}`);
      } finally {
        setIsRemoving(false);
      }
    } else {
      // new attachment, remove from files
      setFiles(files.filter(file => file.name !== attachmentToRemove));
      setAttachmentToRemove(undefined);
    }
  }, [containerPath, model, attachments, attachmentToRemove, files]);
  const createThread = (0,external_react_.useCallback)(async () => {
    const modelToCreate = ThreadEditor_objectSpread({}, model);

    // Ensure title
    // This is required for announcements, however, it is not
    // exposed or utilized by this commenting UI at this time.
    if (!modelToCreate.title) {
      modelToCreate.title = `${nounSingular} thread`;
    }

    // apply "discussionSrcIdentifier"
    if (discussionSrcIdentifier) {
      modelToCreate.discussionSrcIdentifier = discussionSrcIdentifier;
    }
    if (discussionSrcEntityType) {
      modelToCreate.discussionSrcEntityType = discussionSrcEntityType;
    }

    // apply "parent"
    if (parent) {
      modelToCreate.parent = parent;
    }
    let createdThread;
    try {
      createdThread = await api.createThread(modelToCreate, files, parent !== undefined, containerPath);
    } catch (err) {
      setError(resolveErrorMessage(err, 'thread', 'create'));
    }
    setSubmitting(false);
    if (createdThread) {
      onCreate?.(createdThread);
    }
  }, [containerPath, model, discussionSrcIdentifier, discussionSrcEntityType, parent, nounSingular, api, files, onCreate]);
  const updateThread = (0,external_react_.useCallback)(async () => {
    let updatedThread;
    try {
      updatedThread = await api.updateThread(model, files, containerPath);
    } catch (err) {
      setError(resolveErrorMessage(err, 'thread', 'update'));
    }
    setSubmitting(false);
    if (updatedThread) {
      onUpdate?.(updatedThread);
    }
  }, [api, containerPath, files, model, onUpdate]);
  const setBody = (0,external_react_.useCallback)((body, selectionStart, selectionEnd) => {
    // selectionStart / selectionEnd allow us to change the selected text and move the cursor.
    if (selectionStart !== undefined && selectionEnd !== undefined) {
      bodyInputRef.current.value = body;
      bodyInputRef.current.selectionStart = selectionStart;
      bodyInputRef.current.selectionEnd = selectionEnd;
      bodyInputRef.current.focus();
    }
    setModel(ThreadEditor_objectSpread(ThreadEditor_objectSpread({}, model), {}, {
      body
    }));
  }, [model]);
  const handlePendingChange = (0,external_react_.useCallback)((hasPendingChange = false) => {
    setPendingChange?.(thread?.rowId ?? -1, hasPendingChange);
  }, [setPendingChange, thread?.rowId]);
  const onBodyChange = (0,external_react_.useCallback)(event => {
    setError(undefined);
    setBody(event.target.value);
    handlePendingChange(!!event.target.value);
  }, [setBody, handlePendingChange]);
  const handleCancel = (0,external_react_.useCallback)(() => {
    onCancel?.();
    handlePendingChange();
  }, [thread?.rowId, onCancel, handlePendingChange]);
  const onSubmit = (0,external_react_.useCallback)(() => {
    if (submitting) return;
    setSubmitting(true);
    if (isCreate) {
      createThread();
    } else {
      updateThread();
    }
    handlePendingChange();
  }, [createThread, isCreate, setSubmitting, submitting, updateThread, handlePendingChange]);
  const onKeyDown = (0,external_react_.useCallback)(evt => {
    if (evt.key === Key.ENTER) {
      if (evt.metaKey) {
        onSubmit();
      } else {
        const {
          selectionEnd,
          selectionStart,
          value
        } = bodyInputRef.current;
        const [body, cursorPos] = handleBulletedListEnter(selectionStart, selectionEnd, value);
        if (body !== undefined) {
          // We're taking over the behavior now, so we cancel the conflicting default browser behavior.
          evt.preventDefault();
          setBody(body, cursorPos, cursorPos);
        }
      }
    }
  }, [onSubmit, setBody]);
  const [view, setView] = (0,external_react_.useState)(EditorView.edit);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-editor"
  }, /*#__PURE__*/external_react_default().createElement(ThreadEditorToolbar, {
    inputRef: bodyInputRef,
    setBody: setBody,
    setView: setView,
    view: view
  }), view === EditorView.edit && /*#__PURE__*/external_react_default().createElement("div", {
    className: external_classnames_default()('form-group', {
      'has-error': hasError
    })
  }, /*#__PURE__*/external_react_default().createElement("textarea", {
    autoFocus: true,
    className: "thread-editor__input form-control",
    name: "body",
    onChange: onBodyChange,
    onKeyDown: onKeyDown,
    placeholder: "Type your comment",
    ref: bodyInputRef,
    value: model.body
  }), hasError && /*#__PURE__*/external_react_default().createElement("span", {
    className: "help-block"
  }, error)), view === EditorView.preview && /*#__PURE__*/external_react_default().createElement(Preview, {
    containerPath: containerPath,
    content: model.body,
    renderContent: api.renderContent
  }), /*#__PURE__*/external_react_default().createElement(ThreadAttachments, {
    attachments: attachments,
    error: attachmentError,
    onRemove: openRemoveModal,
    containerPath: containerPath
  }), /*#__PURE__*/external_react_default().createElement("button", {
    type: "button",
    className: "btn btn-default thread-editor__create-btn",
    disabled: submitDisabled,
    onClick: onSubmit
  }, isCreate ? `Add ${nounSingular}` : 'Save Changes'), /*#__PURE__*/external_react_default().createElement("label", {
    className: "thread-editor__attachment-input btn btn-default"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "fa fa-paperclip"
  }), /*#__PURE__*/external_react_default().createElement("input", {
    multiple: true,
    onChange: onFileInputChange,
    type: "file"
  })), /*#__PURE__*/external_react_default().createElement("span", {
    className: "clickable-text thread-editor__cancel-btn",
    onClick: handleCancel
  }, "Cancel"), attachmentToRemove !== undefined && /*#__PURE__*/external_react_default().createElement(RemoveAttachmentModal, {
    cancel: closeRemoveModal,
    error: removeAttachmentError,
    isRemoving: isRemoving,
    name: attachmentToRemove,
    remove: removeAttachment
  }));
};
;// CONCATENATED MODULE: ./src/internal/announcements/ThreadBlock.tsx
function ThreadBlock_extends() { return ThreadBlock_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ThreadBlock_extends.apply(null, arguments); }









const DeleteThreadModal = ({
  cancel,
  onDelete
}) => /*#__PURE__*/external_react_default().createElement(Modal, {
  confirmText: "Yes, Delete Thread",
  confirmClass: "btn-danger",
  onCancel: cancel,
  onConfirm: onDelete,
  title: "Delete this comment thread?"
}, "Deleting this comment will also delete any replies to the original comment. Are you sure you want to delete this thread?");
const DeleteReplyModal = ({
  cancel,
  onDelete
}) => /*#__PURE__*/external_react_default().createElement(Modal, {
  confirmText: "Yes, Delete Reply",
  confirmClass: "btn-danger",
  onCancel: cancel,
  onConfirm: onDelete,
  title: "Delete this reply?"
}, "Are you sure you want to delete this reply?");
const ThreadBlockHeader = props => {
  const {
    created,
    modified,
    onDelete,
    onEdit,
    author,
    isThread
  } = props;
  const [showDeleteBSModal, setShowDeleteBSModal] = (0,external_react_.useState)(false);
  const formattedCreate = (0,external_react_.useMemo)(() => external_moment_default()(created).fromNow(), [created]);
  const isEdited = (0,external_react_.useMemo)(() => {
    return external_moment_default()(modified).diff(external_moment_default()(created), 'seconds') > 1;
  }, [created, modified]);
  const onCancelDelete = (0,external_react_.useCallback)(() => {
    setShowDeleteBSModal(false);
  }, []);
  const onShowDelete = (0,external_react_.useCallback)(() => {
    setShowDeleteBSModal(true);
  }, []);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-block-header"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "thread-block-header__user"
  }, /*#__PURE__*/external_react_default().createElement(UserLink, {
    userId: author.id,
    userDisplayValue: author.displayName
  })), /*#__PURE__*/external_react_default().createElement("div", {
    className: "pull-right"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "thread-block-header__date"
  }, formattedCreate, isEdited ? ' (Edited)' : ''), (onDelete || onEdit) && /*#__PURE__*/external_react_default().createElement(DropdownAnchor, {
    className: "thread-block-header__menu",
    title: /*#__PURE__*/external_react_default().createElement("i", {
      className: "fa fa-ellipsis-v"
    }),
    pullRight: true
  }, onEdit !== undefined && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    className: "thread-block-header__menu-edit",
    onClick: onEdit
  }, "Edit Comment"), onDelete !== undefined && /*#__PURE__*/external_react_default().createElement(MenuItem, {
    className: "thread-block-header__menu-delete",
    onClick: onShowDelete
  }, "Delete ", isThread ? 'Thread' : 'Reply'))), showDeleteBSModal && isThread && /*#__PURE__*/external_react_default().createElement(DeleteThreadModal, {
    cancel: onCancelDelete,
    onDelete: onDelete
  }), showDeleteBSModal && !isThread && /*#__PURE__*/external_react_default().createElement(DeleteReplyModal, {
    cancel: onCancelDelete,
    onDelete: onDelete
  }));
};
const ThreadBlock = props => {
  const {
    api,
    canReply,
    containerPath,
    onCreate,
    onDelete,
    onToggleResponses,
    onUpdate,
    readOnly,
    showResponses,
    thread,
    user,
    setPendingChange
  } = props;
  const [editing, setEditing] = (0,external_react_.useState)(false);
  const [error, setError] = (0,external_react_.useState)(undefined);
  const [recentTimeout, setRecentTimeout] = (0,external_react_.useState)(undefined);
  const [replying, setReplying] = (0,external_react_.useState)(false);
  const [showRecent, setShowRecent] = (0,external_react_.useState)(false);
  const threadBody = (0,external_react_.useMemo)(() => ({
    __html: thread.formattedHtml
  }), [thread.formattedHtml]);
  const allowDelete = !readOnly && user.canDelete;
  const allowReply = canReply && !readOnly && user.canInsert;
  const allowUpdate = !readOnly && user.canUpdate;
  const showReplyToggle = onToggleResponses !== undefined && thread.responses.length > 0;
  const onDeleteThread = (0,external_react_.useCallback)(async () => {
    let deleted = false;
    try {
      deleted = await api.deleteThread(thread.rowId, containerPath);
    } catch (err) {
      setError(resolveErrorMessage(err, 'thread', 'thread', 'delete'));
    }
    if (deleted) {
      onDelete?.(thread);
    }
  }, [api, containerPath, onDelete, thread]);
  const onCancel = (0,external_react_.useCallback)(() => {
    setEditing(false);
    setReplying(false);
  }, []);
  const onEdit = (0,external_react_.useCallback)(() => {
    setEditing(true);
  }, []);
  const onEdited = (0,external_react_.useCallback)(thread => {
    setEditing(false);
    onUpdate?.(thread);
  }, []);
  const onReply = (0,external_react_.useCallback)(() => {
    setReplying(true);
  }, []);
  const onReplied = (0,external_react_.useCallback)(thread => {
    clearTimeout(recentTimeout);
    setReplying(false);
    onCreate?.(thread);
    setShowRecent(true);
    setRecentTimeout(setTimeout(() => {
      setShowRecent(false);
    }, 10000));
  }, []);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-block"
  }, editing && /*#__PURE__*/external_react_default().createElement(ThreadEditor, ThreadBlock_extends({}, props, {
    onCancel: onCancel,
    onUpdate: onEdited
  })), !editing && /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-block-body"
  }, /*#__PURE__*/external_react_default().createElement(ThreadBlockHeader, {
    created: thread.created,
    modified: thread.modified,
    onDelete: allowDelete ? onDeleteThread : undefined,
    onEdit: allowUpdate ? onEdit : undefined,
    author: thread.author,
    isThread: !thread.parent
  }), error !== undefined && /*#__PURE__*/external_react_default().createElement(Alert, null, error), /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-block-body__content",
    dangerouslySetInnerHTML: threadBody
  }), /*#__PURE__*/external_react_default().createElement(ThreadAttachments, {
    attachments: thread.attachments ?? [],
    containerPath: containerPath
  }), allowReply && /*#__PURE__*/external_react_default().createElement("span", {
    className: "clickable-text thread-block__reply",
    onClick: onReply
  }, "Reply"), showReplyToggle && /*#__PURE__*/external_react_default().createElement("span", {
    className: "clickable-text thread-block__toggle-reply",
    onClick: onToggleResponses
  }, showResponses ? 'Hide all replies' : `Show all replies (${thread.responses.length.toLocaleString()})`), showRecent && /*#__PURE__*/external_react_default().createElement("span", {
    className: "thread-block__toggle-reply-msg"
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-check-circle"
  }), " Your reply was posted"))), replying && /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-responses-container"
  }, /*#__PURE__*/external_react_default().createElement(ThreadEditor, ThreadBlock_extends({}, props, {
    onCancel: onCancel,
    onCreate: onReplied,
    parent: thread.parent ?? thread.entityId,
    thread: undefined,
    setPendingChange: setPendingChange
  }))));
};
ThreadBlock.defaultProps = {
  canReply: true
};
;// CONCATENATED MODULE: ./src/internal/announcements/Thread.tsx
function Thread_extends() { return Thread_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, Thread_extends.apply(null, arguments); }


const Thread = props => {
  const {
    thread
  } = props;
  const {
    responses
  } = thread;
  const [responseToggle, setResponseToggle] = (0,external_react_.useState)(false);
  const showResponses = responseToggle && responses.length > 0;
  const toggleResponses = (0,external_react_.useCallback)(() => {
    setResponseToggle(!responseToggle);
  }, [setResponseToggle, responseToggle]);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-container"
  }, /*#__PURE__*/external_react_default().createElement(ThreadBlock, Thread_extends({}, props, {
    onToggleResponses: toggleResponses,
    showResponses: responseToggle
  })), showResponses && /*#__PURE__*/external_react_default().createElement("div", {
    className: "thread-responses-container"
  }, responses.map(response => /*#__PURE__*/external_react_default().createElement(Thread, Thread_extends({}, props, {
    canReply: false,
    key: response.rowId,
    parent: thread.entityId,
    thread: response
  })))));
};
;// CONCATENATED MODULE: ./src/internal/announcements/Discussions.tsx





const Discussions = (0,external_react_.memo)(props => {
  const {
    api,
    autoLoad,
    containerPath,
    discussionSrcIdentifier,
    discussionSrcEntityType,
    nounPlural,
    nounSingular,
    readOnly,
    user,
    setHasPendingChanges
  } = props;
  const {
    canInsert
  } = user;
  const [error, setError] = (0,external_react_.useState)(undefined);
  const [discussions, setDiscussions] = (0,external_react_.useState)([]);
  const [showEditor, setShowEditor] = (0,external_react_.useState)(false);
  const [pendingChanges, setPendingChanges] = (0,external_react_.useState)(new Set());
  const allowCreateThread = !readOnly && canInsert;
  const hasError = error !== undefined;
  const hasDiscussions = discussions.length > 0;
  const loadDiscussions = (0,external_react_.useCallback)(async () => {
    try {
      setDiscussions(await api.getDiscussions(discussionSrcIdentifier, containerPath));
    } catch (err) {
      setError(resolveErrorMessage(err, 'discussion', 'discussions', 'load'));
    }
  }, [api, containerPath, discussionSrcIdentifier]);
  const onCancel = (0,external_react_.useCallback)(() => {
    setShowEditor(false);
  }, []);
  const onCreate = (0,external_react_.useCallback)(() => {
    setShowEditor(false);
    loadDiscussions();
  }, [loadDiscussions]);
  const onShow = (0,external_react_.useCallback)(() => {
    setShowEditor(true);
  }, []);
  const updatePendingThread = (0,external_react_.useCallback)((threadId, hasPendingChange) => {
    const updatedPendingChanges = new Set(pendingChanges);
    if (hasPendingChange) updatedPendingChanges.add(threadId);else updatedPendingChanges.delete(threadId);
    setPendingChanges(updatedPendingChanges);
    setHasPendingChanges?.(updatedPendingChanges.size > 0);
  }, [pendingChanges]);
  (0,external_react_.useEffect)(() => {
    if (autoLoad) loadDiscussions();
  }, [autoLoad, loadDiscussions]);

  // Empty read only state
  if (readOnly && !hasDiscussions) {
    // Returning non-null element as the tests do not like returning null
    return /*#__PURE__*/external_react_default().createElement("div", null);
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "discussions-container"
  }, /*#__PURE__*/external_react_default().createElement("hr", null), /*#__PURE__*/external_react_default().createElement("div", {
    className: "discussions-container__title"
  }, nounPlural), hasError && /*#__PURE__*/external_react_default().createElement("div", {
    className: "alert alert-danger"
  }, error), discussions.map(thread => /*#__PURE__*/external_react_default().createElement(Thread, {
    api: api,
    containerPath: containerPath,
    discussionSrcIdentifier: discussionSrcIdentifier,
    discussionSrcEntityType: discussionSrcEntityType,
    key: thread.rowId,
    nounPlural: nounPlural,
    nounSingular: nounSingular,
    onCreate: loadDiscussions,
    onDelete: loadDiscussions,
    onUpdate: loadDiscussions,
    readOnly: readOnly,
    thread: thread,
    user: user,
    setPendingChange: updatePendingThread
  })), allowCreateThread && !showEditor && /*#__PURE__*/external_react_default().createElement("span", {
    className: "clickable-text",
    onClick: onShow
  }, /*#__PURE__*/external_react_default().createElement("i", {
    className: "fa fa-comments"
  }), "Start a thread"), allowCreateThread && showEditor && /*#__PURE__*/external_react_default().createElement(ThreadEditor, {
    api: api,
    containerPath: containerPath,
    discussionSrcIdentifier: discussionSrcIdentifier,
    discussionSrcEntityType: discussionSrcEntityType,
    nounPlural: nounPlural,
    nounSingular: nounSingular,
    onCancel: onCancel,
    onCreate: onCreate,
    setPendingChange: updatePendingThread
  }));
});
Discussions.defaultProps = {
  api: getDefaultAnnouncementsAPIWrapper(),
  // Prevent auto-load in test environments in lieu of mocking APIWrapper in all test locations
  autoLoad: "production" !== 'test',
  nounPlural: 'comments',
  nounSingular: 'comment'
};
;// CONCATENATED MODULE: ./src/internal/productFixtures.ts

const TEST_LKSM_PROFESSIONAL_MODULE_CONTEXT = {
  api: {
    moduleNames: ['samplemanagement', 'inventory', 'assay', 'labbook']
  },
  samplemanagement: {
    productId: SAMPLE_MANAGER_APP_PROPERTIES.productId
  },
  inventory: {
    productId: FREEZER_MANAGER_APP_PROPERTIES.productId
  },
  core: {
    productFeatures: [ProductFeature.Workflow, ProductFeature.ELN, ProductFeature.Assay, ProductFeature.ApiKeys, ProductFeature.CalculatedFields, ProductFeature.DataChangeCommentRequirement]
  }
};
const TEST_LKSM_STARTER_MODULE_CONTEXT = {
  api: {
    moduleNames: ['samplemanagement', 'inventory']
  },
  samplemanagement: {
    productId: SAMPLE_MANAGER_APP_PROPERTIES.productId
  },
  inventory: {
    productId: FREEZER_MANAGER_APP_PROPERTIES.productId
  },
  core: {
    productFeatures: []
  }
};
const TEST_LKSM_STARTER_AND_WORKFLOW_MODULE_CONTEXT = {
  api: {
    moduleNames: ['samplemanagement', 'inventory']
  },
  samplemanagement: {
    productId: SAMPLE_MANAGER_APP_PROPERTIES.productId
  },
  inventory: {
    productId: FREEZER_MANAGER_APP_PROPERTIES.productId
  },
  core: {
    productFeatures: [ProductFeature.Workflow]
  }
};
const TEST_LKS_STARTER_MODULE_CONTEXT = {
  api: {
    moduleNames: ['samplemanagement', 'inventory', 'assay', 'premium']
  },
  samplemanagement: {
    productId: SAMPLE_MANAGER_APP_PROPERTIES.productId
  },
  inventory: {
    productId: FREEZER_MANAGER_APP_PROPERTIES.productId
  },
  core: {
    productFeatures: [ProductFeature.ApiKeys, ProductFeature.Assay]
  }
};
const TEST_LIMS_STARTER_MODULE_CONTEXT = {
  biologics: {
    productId: BIOLOGICS_APP_PROPERTIES.productId
  },
  core: {
    productFeatures: [ProductFeature.Assay, ProductFeature.ELN, ProductFeature.FreezerManagement, ProductFeature.Projects, ProductFeature.SampleManagement, ProductFeature.Workflow, ProductFeature.ApiKeys, ProductFeature.CalculatedFields, ProductFeature.DataChangeCommentRequirement]
  },
  inventory: {
    productId: FREEZER_MANAGER_APP_PROPERTIES.productId
  },
  samplemanagement: {
    productId: SAMPLE_MANAGER_APP_PROPERTIES.productId
  }
};
;// CONCATENATED MODULE: ./src/internal/DropdownSection.tsx
const DropdownSection_excluded = ["label"];
function DropdownSection_extends() { return DropdownSection_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, DropdownSection_extends.apply(null, arguments); }
function DropdownSection_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = DropdownSection_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function DropdownSection_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }





const SHOW_FILTER_CUTOFF = 10;
/**
 * Use this component when you want to render a section of a dropdown menu that can be expanded. Useful when you have
 * many items in a menu that would make it overwhelmingly long.
 */
const DropdownSection = ({
  items,
  showDivider = false,
  toggleText
}) => {
  // We default expanded when there is no toggle text, which also means there is no way to expand or collapse the
  // children when there is no toggleText; this is by design. We want to always render the children when toggleText
  // is undefined because that means we're rendering the items as the only menu items; this is typically when we're
  // rendering a DropdownButton that gets condensed into a "More" menu on smaller screens.
  const [expanded, setExpanded] = (0,external_react_.useState)(!toggleText);
  const onHeaderClick = (0,external_react_.useCallback)(event => {
    preventDocumentHandler(event);
    event.preventDefault();
    setExpanded(e => !e);
  }, []);
  const [filterValue, setFilterValue] = (0,external_react_.useState)('');
  const onFilterChange = (0,external_react_.useCallback)(event => setFilterValue(event.target.value), []);
  const onFilterClick = (0,external_react_.useCallback)(event => {
    preventDocumentHandler(event);
  }, []);
  const menuItems = (0,external_react_.useMemo)(() => {
    if (filterValue.trim()) {
      const filterValueLC = filterValue.toLowerCase();
      return items.filter(item => api_.Utils.isString(item.label) && item.label.toLowerCase().indexOf(filterValueLC) > -1);
    }
    return items;
  }, [filterValue, items]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, toggleText && /*#__PURE__*/external_react_default().createElement("li", {
    className: "dropdown-section-toggle",
    role: "presentation"
  }, /*#__PURE__*/external_react_default().createElement("a", {
    href: "#",
    onClick: onHeaderClick,
    role: "menuitem"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "dropdown-section-toggle__text"
  }, toggleText), /*#__PURE__*/external_react_default().createElement("span", {
    className: `fa fa-chevron-${expanded ? 'up' : 'down'}`
  }))), expanded && items.length > SHOW_FILTER_CUTOFF && /*#__PURE__*/external_react_default().createElement(MenuItem, null, /*#__PURE__*/external_react_default().createElement("input", {
    onChange: onFilterChange,
    onClick: onFilterClick,
    placeholder: "Filter...",
    value: filterValue
  })), expanded && menuItems.map((_ref, index) => {
    let {
        label: menuItemLabel
      } = _ref,
      props = DropdownSection_objectWithoutProperties(_ref, DropdownSection_excluded);
    return /*#__PURE__*/external_react_default().createElement(DisableableMenuItem, DropdownSection_extends({
      key: index
    }, props, {
      className: external_classnames_default()('dropdown-section__menu-item', props.className)
    }), menuItemLabel);
  }), showDivider && expanded && /*#__PURE__*/external_react_default().createElement(MenuDivider, null));
};
;// CONCATENATED MODULE: ./src/internal/components/settings/ActiveUserLimit.tsx





const ActiveUserLimitMessage = (0,external_react_.memo)(({
  settings
}) => {
  if (!settings?.messageHtml) return null;
  return /*#__PURE__*/external_react_default().createElement(Alert, {
    bsStyle: "warning"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    dangerouslySetInnerHTML: {
      __html: settings.messageHtml
    }
  }));
});
const ActiveUserLimit = (0,external_react_.memo)(props => {
  const {
    user,
    container
  } = props;
  const [error, setError] = (0,external_react_.useState)();
  const [settings, setSettings] = (0,external_react_.useState)();
  const {
    api
  } = useAppContext();
  (0,external_react_.useEffect)(() => {
    if (!user.hasAddUsersPermission()) return;
    setError(undefined);
    (async () => {
      try {
        const limitSettings = await api.security.getUserLimitSettings(container.path);
        setSettings(limitSettings);
      } catch (e) {
        setError(`Error: ${resolveErrorMessage(e)}`);
      }
    })();
  }, [api, user, container.path]);
  if (!user.hasAddUsersPermission()) return null;
  if (!error && !settings?.userLimit) return null;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "active-user-limit-panel panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Active Users"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/external_react_default().createElement(Alert, null, error), settings && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(ActiveUserLimitMessage, {
    settings: settings
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "active-user-limit-message"
  }, "Active user limit is ", settings.userLimitLevel, ". You can add or reactivate", ' ', api_.Utils.pluralBasic(settings.remainingUsers, 'more user'), "."), /*#__PURE__*/external_react_default().createElement("br", null), /*#__PURE__*/external_react_default().createElement("div", null, "Contact your LabKey Account Manager to upgrade the number of allowed users."))));
});
;// CONCATENATED MODULE: ./src/internal/components/settings/AuditSettings.tsx








const AuditSettings = () => {
  const {
    api
  } = useAppContext();
  const {
    container,
    moduleContext
  } = useServerContext();
  const [isRequired, setIsRequired] = (0,external_react_.useState)(false);
  const appFolderPath = getAppHomeFolderPath(container, moduleContext);
  (0,external_react_.useEffect)(() => {
    (async () => {
      const settings = await api.folder.getAuditSettings(appFolderPath);
      setIsRequired(settings.requireUserComments);
    })();
  }, [appFolderPath]);
  const onDisableRequirement = (0,external_react_.useCallback)(() => {
    setIsRequired(false);
    api.folder.setAuditCommentsRequired(false, appFolderPath);
  }, [appFolderPath, api]);
  const onEnableRequired = (0,external_react_.useCallback)(() => {
    setIsRequired(true);
    api.folder.setAuditCommentsRequired(true, appFolderPath);
  }, [appFolderPath, api]);
  if (!isDataChangeCommentRequirementFeatureEnabled(moduleContext)) {
    return null;
  }
  return /*#__PURE__*/external_react_default().createElement(RequiresPermission, {
    perms: api_.PermissionTypes.Admin
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-heading"
  }, "Audit Logging"), /*#__PURE__*/external_react_default().createElement("div", {
    className: "panel-body"
  }, "Would you like to require that users provide a reason before completing certain actions?", /*#__PURE__*/external_react_default().createElement(LabelHelpTip, null, "Many update and delete actions allow users to enter a reason for the action, which will be recorded in the audit log. ", /*#__PURE__*/external_react_default().createElement(HelpLink, {
    topic: "audits#require"
  }, "Click to see which actions support a user-entered reason"), ". By default, reasons are optional but if you would ike to require them, select \"Yes\"."), /*#__PURE__*/external_react_default().createElement("div", {
    className: "framed-input__container top-spacing"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: 'framed-input ' + (!isRequired ? 'active' : ''),
    onClick: onDisableRequirement
  }, /*#__PURE__*/external_react_default().createElement("label", null, /*#__PURE__*/external_react_default().createElement("input", {
    name: "requireComments",
    type: "radio",
    onChange: onDisableRequirement,
    value: "false",
    checked: !isRequired
  }), ' ', /*#__PURE__*/external_react_default().createElement("span", {
    className: "label-text"
  }, "No, reasons are optional.")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "description"
  }, "Users will see the reasons field but can leave it blank.")), /*#__PURE__*/external_react_default().createElement("div", {
    className: 'framed-input margin-left ' + (isRequired ? 'active' : ''),
    onClick: onEnableRequired
  }, /*#__PURE__*/external_react_default().createElement("label", null, /*#__PURE__*/external_react_default().createElement("input", {
    name: "requireComments",
    type: "radio",
    onChange: onEnableRequired,
    value: "true",
    checked: isRequired
  }), ' ', /*#__PURE__*/external_react_default().createElement("span", {
    className: "label-text"
  }, "Yes, reasons are required.")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "description"
  }, "Users must enter a reason for any of these actions."))))));
};
;// CONCATENATED MODULE: ./src/index.ts
/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */













































































































































































































































































































































// See Immer docs for why we do this: https://immerjs.github.io/immer/docs/installation#pick-your-immer-version
(0,external_immer_.enableMapSet)();
(0,external_immer_.enablePatches)();
const App = {
  AppReducers: AppReducers,
  ProductMenuReducers: ProductMenuReducers,
  ServerNotificationReducers: ServerNotificationReducers,
  CloseEventCode: CloseEventCode,
  EntityCreationMode: EntityCreationMode,
  biologicsIsPrimaryApp: biologicsIsPrimaryApp,
  createTestProjectAppContextAdmin: createTestProjectAppContextAdmin,
  createTestProjectAppContextNonAdmin: createTestProjectAppContextNonAdmin,
  getCurrentAppProperties: getCurrentAppProperties,
  registerWebSocketListeners: registerWebSocketListeners,
  getAppHomeFolderPath: getAppHomeFolderPath,
  getAppHomeFolderId: getAppHomeFolderId,
  isApp: isApp,
  isAppHomeFolder: isAppHomeFolder,
  isAssayDesignExportEnabled: isAssayDesignExportEnabled,
  isAssayEnabled: isAssayEnabled,
  isAssayQCEnabled: isAssayQCEnabled,
  isAssayRequestsEnabled: isAssayRequestsEnabled,
  isMediaEnabled: isMediaEnabled,
  isWorkflowEnabled: isWorkflowEnabled,
  isELNEnabled: isELNEnabled,
  isFreezerManagementEnabled: isFreezerManagementEnabled,
  isPlatesEnabled: isPlatesEnabled,
  isSampleManagerEnabled: isSampleManagerEnabled,
  isBiologicsEnabled: isBiologicsEnabled,
  isPremiumProductEnabled: isPremiumProductEnabled,
  isSampleAliquotSelectorEnabled: isSampleAliquotSelectorEnabled,
  isProjectContainer: isProjectContainer,
  isProtectedDataEnabled: isProtectedDataEnabled,
  isSharedDefinition: isSharedDefinition,
  sampleManagerIsPrimaryApp: sampleManagerIsPrimaryApp,
  freezerManagerIsCurrentApp: freezerManagerIsCurrentApp,
  isSampleStatusEnabled: isSampleStatusEnabled,
  isProductProjectsEnabled: isProductProjectsEnabled,
  isAllProductFoldersFilteringEnabled: isAllProductFoldersFilteringEnabled,
  isSampleEntity: isSampleEntity,
  isDataClassEntity: isDataClassEntity,
  getPrimaryAppProperties: getPrimaryAppProperties,
  getProjectDataExclusion: getProjectDataExclusion,
  getProjectAssayDesignExclusion: getProjectAssayDesignExclusion,
  getProjectDataClassExclusion: getProjectDataClassExclusion,
  getProjectSampleTypeExclusion: getProjectSampleTypeExclusion,
  getProjectPath: getProjectPath,
  getFolderTestAPIWrapper: getFolderTestAPIWrapper,
  getLabelsTestAPIWrapper: getLabelsTestAPIWrapper,
  getSecurityTestAPIWrapper: getSecurityTestAPIWrapper,
  hasPremiumModule: hasPremiumModule,
  hasProductProjects: hasProductProjects,
  hasModule: hasModule,
  getDateFormat: getDateFormat,
  getDateTimeFormat: getDateTimeFormat,
  getTimeFormat: getTimeFormat,
  useMenuSectionConfigs: useMenuSectionConfigs,
  menuInit: menuInit,
  menuInvalidate: menuInvalidate,
  menuReload: menuReload,
  registerInputRenderers: registerInputRenderers,
  serverNotificationInit: serverNotificationInit,
  serverNotificationInvalidate: serverNotificationInvalidate,
  updateUser: updateUser,
  updateUserDisplayName: updateUserDisplayName,
  userCanDesignLocations: userCanDesignLocations,
  userCanEditStorageData: userCanEditStorageData,
  userCanDesignSourceTypes: userCanDesignSourceTypes,
  userCanManagePicklists: userCanManagePicklists,
  userCanManageSampleWorkflow: userCanManageSampleWorkflow,
  userCanReadAssays: userCanReadAssays,
  userCanReadNotebooks: userCanReadNotebooks,
  userCanReadMedia: userCanReadMedia,
  userCanReadDataClasses: userCanReadDataClasses,
  userCanReadGroupDetails: userCanReadGroupDetails,
  userCanReadRegistry: userCanReadRegistry,
  userCanReadSources: userCanReadSources,
  userCanEditSharedViews: userCanEditSharedViews,
  userCanDeletePublicPicklists: userCanDeletePublicPicklists,
  getCurrentProductName: getCurrentProductName,
  setProductProjects: setProductProjects,
  UPDATE_USER: UPDATE_USER,
  UPDATE_USER_DISPLAY_NAME: UPDATE_USER_DISPLAY_NAME,
  BIOLOGICS: BIOLOGICS_APP_PROPERTIES,
  SAMPLE_MANAGER: SAMPLE_MANAGER_APP_PROPERTIES,
  FREEZER_MANAGER: FREEZER_MANAGER_APP_PROPERTIES,
  ASSAYS_KEY: ASSAYS_KEY,
  ASSAY_DESIGN_KEY: ASSAY_DESIGN_KEY,
  AUDIT_KEY: AUDIT_KEY,
  EXPERIMENTAL_REQUESTS_MENU: EXPERIMENTAL_REQUESTS_MENU,
  FIND_SAMPLES_BY_ID_KEY: FIND_SAMPLES_BY_ID_KEY,
  FIND_SAMPLES_BY_FILTER_KEY: FIND_SAMPLES_BY_FILTER_KEY,
  PICKLIST_KEY: PICKLIST_KEY,
  MINE_KEY: MINE_KEY,
  TEAM_KEY: TEAM_KEY,
  SAMPLES_KEY: SAMPLES_KEY,
  SAMPLE_TYPE_KEY: SAMPLE_TYPE_KEY,
  SEARCH_KEY: SEARCH_KEY,
  DATA_CLASS_KEY: DATA_CLASS_KEY,
  SOURCES_KEY: SOURCES_KEY,
  SOURCE_TYPE_KEY: SOURCE_TYPE_KEY,
  WORKFLOW_KEY: WORKFLOW_KEY,
  FREEZERS_KEY: FREEZERS_KEY,
  BOXES_KEY: BOXES_KEY,
  HOME_KEY: HOME_KEY,
  USER_KEY: USER_KEY,
  GRID_INSERT_SAMPLES_HREF: GRID_INSERT_SAMPLES_HREF,
  FILE_IMPORT_SAMPLES_HREF: FILE_IMPORT_SAMPLES_HREF,
  FILE_UPDATE_SAMPLES_HREF: FILE_UPDATE_SAMPLES_HREF,
  NEW_SOURCE_TYPE_HREF: NEW_SOURCE_TYPE_HREF,
  NEW_SAMPLE_TYPE_HREF: NEW_SAMPLE_TYPE_HREF,
  NEW_ASSAY_DESIGN_HREF: NEW_ASSAY_DESIGN_HREF,
  NEW_STANDARD_ASSAY_DESIGN_HREF: NEW_STANDARD_ASSAY_DESIGN_HREF,
  FIND_SAMPLES_BY_FILTER_HREF: FIND_SAMPLES_BY_FILTER_HREF,
  FIND_SAMPLES_BY_ID_HREF: FIND_SAMPLES_BY_ID_HREF,
  PICKLIST_HOME_HREF: PICKLIST_HOME_HREF,
  MY_PICKLISTS_HREF: MY_PICKLISTS_HREF,
  TEAM_PICKLISTS_HREF: TEAM_PICKLISTS_HREF,
  WORKFLOW_HOME_HREF: WORKFLOW_HOME_HREF,
  NOTIFICATION_TIMEOUT: NOTIFICATION_TIMEOUT,
  SERVER_NOTIFICATION_MAX_ROWS: SERVER_NOTIFICATION_MAX_ROWS,
  TEST_USER_GUEST: TEST_USER_GUEST,
  TEST_USER_READER: TEST_USER_READER,
  TEST_USER_AUTHOR: TEST_USER_AUTHOR,
  TEST_USER_EDITOR: TEST_USER_EDITOR,
  TEST_USER_EDITOR_WITHOUT_DELETE: TEST_USER_EDITOR_WITHOUT_DELETE,
  TEST_USER_ASSAY_DESIGNER: TEST_USER_ASSAY_DESIGNER,
  TEST_USER_FOLDER_ADMIN: TEST_USER_FOLDER_ADMIN,
  TEST_USER_PROJECT_ADMIN: TEST_USER_PROJECT_ADMIN,
  TEST_USER_APP_ADMIN: TEST_USER_APP_ADMIN,
  TEST_USER_STORAGE_DESIGNER: TEST_USER_STORAGE_DESIGNER,
  TEST_USER_STORAGE_EDITOR: TEST_USER_STORAGE_EDITOR,
  TEST_USER_QC_ANALYST: TEST_USER_QC_ANALYST,
  TEST_USER_WORKFLOW_EDITOR: TEST_USER_WORKFLOW_EDITOR,
  TEST_LIMS_STARTER_MODULE_CONTEXT: TEST_LIMS_STARTER_MODULE_CONTEXT,
  TEST_LKS_STARTER_MODULE_CONTEXT: TEST_LKS_STARTER_MODULE_CONTEXT,
  TEST_LKSM_STARTER_MODULE_CONTEXT: TEST_LKSM_STARTER_MODULE_CONTEXT,
  TEST_LKSM_STARTER_AND_WORKFLOW_MODULE_CONTEXT: TEST_LKSM_STARTER_AND_WORKFLOW_MODULE_CONTEXT,
  TEST_LKSM_PROFESSIONAL_MODULE_CONTEXT: TEST_LKSM_PROFESSIONAL_MODULE_CONTEXT,
  TEST_PROJECT: TEST_PROJECT,
  TEST_PROJECT_CONTAINER: TEST_PROJECT_CONTAINER,
  TEST_PROJECT_CONTAINER_ADMIN: TEST_PROJECT_CONTAINER_ADMIN,
  TEST_FOLDER_CONTAINER: TEST_FOLDER_CONTAINER,
  TEST_FOLDER_CONTAINER_ADMIN: TEST_FOLDER_CONTAINER_ADMIN,
  TEST_FOLDER_OTHER_CONTAINER: TEST_FOLDER_OTHER_CONTAINER,
  TEST_FOLDER_OTHER_CONTAINER_ADMIN: TEST_FOLDER_OTHER_CONTAINER_ADMIN,
  MEDIA_KEY: MEDIA_KEY,
  REGISTRY_KEY: REGISTRY_KEY,
  CROSS_TYPE_KEY: CROSS_TYPE_KEY,
  ELN_KEY: ELN_KEY,
  DATA_CLASS_IMPORT_PREFIX: DATA_CLASS_IMPORT_PREFIX,
  SAMPLE_SET_IMPORT_PREFIX: SAMPLE_SET_IMPORT_PREFIX,
  SAMPLE_PROPERTY_ALL_SAMPLE_TYPE: SAMPLE_PROPERTY_ALL_SAMPLE_TYPE,
  SEARCH_PAGE_DEFAULT_SIZE: SEARCH_PAGE_DEFAULT_SIZE,
  DELIMITER: DELIMITER,
  DETAIL_TABLE_CLASSES: DETAIL_TABLE_CLASSES,
  DISCARD_CONSUMED_CHECKBOX_FIELD: DISCARD_CONSUMED_CHECKBOX_FIELD,
  SAMPLE_FILTER_METRIC_AREA: SAMPLE_FILTER_METRIC_AREA,
  ALIQUOTED_FROM_COL: ALIQUOTED_FROM_COL,
  PRIVATE_PICKLIST_CATEGORY: PRIVATE_PICKLIST_CATEGORY,
  PUBLIC_PICKLIST_CATEGORY: PUBLIC_PICKLIST_CATEGORY,
  DATA_IMPORT_TOPIC: DATA_IMPORT_TOPIC,
  SAMPLE_IMPORT_TOPIC: SAMPLE_IMPORT_TOPIC,
  PLATES_KEY: PLATES_KEY,
  COMMENT_FIELD_ID: COMMENT_FIELD_ID
};
const Hooks = {
  useAppContext: useAppContext,
  useContainerUser: useContainerUser,
  useEnterEscape: useEnterEscape,
  useLabelPrintingContext: useLabelPrintingContext,
  useNotificationsContext: useNotificationsContext,
  useRouteLeave: useRouteLeave,
  useServerContext: useServerContext,
  useUserProperties: useUserProperties,
  useUsersWithPermissions: useUsersWithPermissions
};


//  Due to babel-loader & typescript babel plugins we need to export/import types separately. The babel plugins require
//  the typescript compiler option "isolatedModules", which do not export types from modules, so types must be exported
//  separately.
//  https://github.com/babel/babel-loader/issues/603
/******/ 	return __webpack_exports__;
/******/ })()
;
});